/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 311);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(319);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(360)();
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return flush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return hydrate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cx", function() { return cx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRegisteredStyles", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sheet", function() { return sheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cache", function() { return cache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_emotion__ = __webpack_require__(362);


var _createEmotion = Object(__WEBPACK_IMPORTED_MODULE_0_create_emotion__["a" /* default */])(),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    cache = _createEmotion.cache;




/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return refreshInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EMPTY_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ERROR_METRIC_SUFFFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return HYPHEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MISSING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return TOTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PACKAGE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return STATION_PAIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FLOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FLOOR_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GROUP_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CYCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CYCLE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FALSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return True; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TRUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TIMEOUT_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return NOT_AVAILABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DATE_TIME_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DARK_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONSTANT_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return OPTIONS_TAG_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return OPTIONS_TAG_REQUIRED_STOW_BUFFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return HEADERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DEFAULT_JACKPOT_BAY_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FEATURES; });
var refreshInterval=60*1000;var EMPTY_STRING="";var ERROR_METRIC_SUFFFIX="Error";var HYPHEN="-";var MISSING="MISSING";var TOTAL="Total";var PACKAGE_STATUS="PACKAGE_STATUS";var STATION_PAIR="STATION_PAIR";var FLOOR="FLOOR";var FLOOR_LOCATION="FLOOR_LOCATION";var GROUP_BY="GROUP_BY";var CYCLE="CYCLE";var CYCLE_ID="CYCLE_ID";var FALSE="FALSE";var True="true";var TRUE="TRUE";var TIMEOUT_STRING="timeout";var NOT_AVAILABLE="NA";var DATE_TIME_FORMAT={year:'numeric',month:'long',day:'numeric',hour:'2-digit',minute:'2-digit',second:'2-digit',timeZoneName:'short',hourCycle:'h24'};var DARK_MODE={DARK:"dark",LIGHT:"light"};var CONSTANT_FILTERS=["cycle","cycleId","CPT","CPTId"];var OPTIONS_TAG_REQUIRED=["cycle","clusters","associateStatuses","aisle","CPT"];var OPTIONS_TAG_REQUIRED_STOW_BUFFER=["cycle","machineStatuses"];var HEADERS={ASSOCIATE:{tab:"associate.tabHeading",tabAlt:"Associate",head:"associate.heading",headAlt:"Associates",desc:"associate.description",descAlt:"This table shows stow associates’ performance data and current working location."},HEATMAP:{tab:"heatMap.tabHeading",tabAlt:"Inbound",head:"heatMap.heading",headAlt:"Stow",desc:"heatMap.description",descAlt:"This table shows the clusters and statuses of containers and packages in the stow process."},STOW_BUFFER:{tab:"stowBuffer.tabHeading",tabAlt:"Associate",head:"stowBuffer.heading",headAlt:"Stow Buffer",desc:"stowBuffer.description",descAlt:"This table shows ADTA Finger level metrics"}};var DEFAULT_JACKPOT_BAY_NAME="Jackpot Bay";var FEATURES={ADTA_VISIBILITY:"isADTAVisibilityEnabled",IS_CPT_FILTER_ENABLED:"isCPTFilterEnabled",DRS_STOW_VISIBILITY:"isDRSStowVisibilityEnabled",GRID_ALLOCATION_VIEW_ENABLED:"isGridAllocationViewEnabled",SIDELINE_STOW_VISIBILITY:"isSidelineStowVisibilityEnabled",SIDELINE_STOW_V2:"isSidelineStowVisibilityV2Enabled",STOW_BREAKDOWN_V2:"isAllStowLocationsVisibilityEnabled",REINDUCT_DATE_PLUS_ONE_FIX:"isReInductDatePlusOneFixEnabled",CART_VISIBILITY:"isCartVisibilityEnabled",ROUTE_CODE_VISIBILITY:"isRouteCodeVisibleForSSDStations",DOWNLOAD_SORT_PLAN_BUTTON_VISIBILITY:"isDownloadSortPlanButtonEnabled",IS_EMPTY_CYCLE_ALLOWED_ENABLED:"isEmptyCycleAllowedEnabled",IS_ASSOCIATE_SCAN_METRIC_ENABLED:"isAssociateScanMetricEnabled"};

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BrowserRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HashRouter; });
/* unused harmony export Link */
/* unused harmony export NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(189);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(128);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Link, _React$Component);

  function Link() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Link.prototype;

  _proto.handleClick = function handleClick(event, history) {
    try {
      if (this.props.onClick) this.props.onClick(event);
    } catch (ex) {
      event.preventDefault();
      throw ex;
    }

    if (!event.defaultPrevented && // onClick prevented default
    event.button === 0 && ( // ignore everything but left clicks
    !this.props.target || this.props.target === "_self") && // let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        var method = this.props.replace ? history.replace : history.push;
        method(this.props.to);
      }
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        innerRef = _this$props.innerRef,
        replace = _this$props.replace,
        to = _this$props.to,
        rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["innerRef", "replace", "to"]); // eslint-disable-line no-unused-vars


    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, context.location) : to;
      var href = location ? context.history.createHref(location) : "";
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        onClick: function onClick(event) {
          return _this.handleClick(event, context.history);
        },
        href: href,
        ref: innerRef
      }));
    });
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object]);
  var innerRefType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.propTypes = {
    innerRef: innerRefType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


function NavLink(_ref) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "strict", "style", "to"]);

  var path = typeof to === "object" ? to.pathname : to; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var pathToMatch = locationProp ? locationProp.pathname : context.location.pathname;
    var match = escapedPath ? Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["f" /* matchPath */])(pathToMatch, {
      path: escapedPath,
      exact: exact,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, context.location) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styleProp, activeStyle) : styleProp;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Link, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: to
    }, rest));
  });
}

if (false) {
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    strict: PropTypes.bool,
    style: PropTypes.object
  });
}




/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PackageStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return metricType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Capability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return Resource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AtRiskAislesMetric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return StowPackageMetric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssociateMetric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return InductPackageMetric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FloorMetric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FloorData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CartData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BinMetric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BagMetric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CartMetric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return HeatMapView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ViewType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CartType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FileType; });
/* unused harmony export RangeFilter */
/* unused harmony export NodeResourceData */
var PackageStatus={CURRENT_INDUCTED:"CURRENT_INDUCTED",CURRENT_STOWED:"CURRENT_STOWED",STOWED:"STOWED",CURRENT_RECEIVED:"CURRENT_RECEIVED",PROBLEM_SOLVE:"PROBLEM_SOLVE",PICKED:"PICKED",CURRENT_STOW_BUFFERED:"CURRENT_STOW_BUFFERED",CURRENT_MFR_JACKPOT_BUFFERED:"CURRENT_MFR_JACKPOT_BUFFERED"};var metricType={COUNT:"count",TIME:"time"};var Capability={AMZL:"AMZL_CORE",SSD:"SSD",AR_NEXT_GEN:"AR_NEXT_GEN",AR:"AR"};var Resource={CLUSTER:"CLUSTER",AISLE:"AISLE",BIN:"BIN",ZONE:"ZONE",CART:"CART",CART_LOCATION:"CART_LOCATION",FLOOR:"FLOOR",FLOOR_LOCATION:"FLOOR_LOCATION",STATION_PAIR:"STATION_PAIR",FLOOR_AND_SIDELINE_UNTIL_TIME:"FLOOR_AND_SIDELINE_UNTIL_TIME"};var AtRiskAislesMetric={MINUTES_OF_WORK:"MINUTES_OF_WORK",ADJACENCY_SCORE:"ADJACENCY_SCORE"};var StowPackageMetric={STOW_RATE:"STOW_RATE",LAST_FIFTEEN_MINUTE_STOW_RATE:"LAST_FIFTEEN_MINUTE_STOW_RATE",MINUTES_OF_WORK:"MINUTES_OF_WORK",SCAN_COMPLIANCE:"SCAN_COMPLIANCE",PROBLEM_SOLVE_COUNT:"PROBLEM_SOLVE_COUNT",STOWED_COUNT:"STOWED_COUNT",CURRENT_STOWED_COUNT:"CURRENT_STOWED_COUNT",CURRENT_INDUCTED_COUNT:"CURRENT_INDUCTED_COUNT",CURRENT_STOW_BUFFERED_COUNT:"CURRENT_STOW_BUFFERED_COUNT",CURRENT_MFR_JACKPOT_BUFFERED_COUNT:"CURRENT_MFR_JACKPOT_BUFFERED_COUNT",PLANNED_COUNT:"PLANNED_COUNT",STOW_VS_PLAN:"STOW_VS_PLAN",FSAF:"FSAF",CURRENT_SCAN_COMPLIANCE:"CURRENT_SCAN_COMPLIANCE"};var AssociateMetric={ACTIVE_ASSOCIATE_COUNT:"ACTIVE_ASSOCIATE_COUNT",INACTIVE_ASSOCIATE_COUNT:"INACTIVE_ASSOCIATE_COUNT"};var InductPackageMetric={CUMULATIVE_INDUCTED:"CUMULATIVE_INDUCTED",INDUCTED_AT_STATION:"INDUCTED_AT_STATION",PENDING_INDUCT:"PENDING_INDUCT",RECEIVED:"RECEIVED",INDUCTED:"INDUCTED"};var FloorMetric={FLOORS_COUNT_MISSING_CART:"FLOORS_COUNT_MISSING_CART",ATTACHED_CART_COUNT:"ATTACHED_CART_COUNT"};var FloorData={FLOOR_LABEL:"FLOOR_LABEL",ROUTE_CODE:"ROUTE_CODE",ROUTE_ID:"ROUTE_ID",CART_DATA:"CART_DATA"};var CartData={CART_LABEL:"CART_LABEL",BIN_DATA:"BIN_DATA"};var BinMetric={BINS_COUNT_MISSING_OPEN_BAG:"BINS_COUNT_MISSING_OPEN_BAG"};var BagMetric={USED_BAG_COUNT:"USED_BAG_COUNT",PLANNED_BAG_COUNT:"PLANNED_BAG_COUNT",OPEN_BAG_COUNT:"OPEN_BAG_COUNT",CLOSED_BAG_COUNT:"CLOSED_BAG_COUNT"};var CartMetric={USED_CART_COUNT:"USED_CART_COUNT",PLANNED_CART_COUNT:"PLANNED_CART_COUNT",OPEN_CART_COUNT:"OPEN_CART_COUNT",CLOSED_CART_COUNT:"CLOSED_CART_COUNT",MISSING_CART_COUNT:"MISSING_CART_COUNT"};var HeatMapView={CLUSTER_VIEW:"clusterView",AISLE_VIEW:"aisleView",SORT_ZONE_VIEW:"sortZoneView",STATION_PAIR_VIEW:"stationPairView",FLOOR_VIEW:"floorView",ROUTE_VIEW:"routeView",ZONE_VIEW:"zoneView",CART_LOCATION_VIEW:"cartLocationView",FLOOR_LOCATION_VIEW:"floorLocationView",CART_VIEW:"cartView"};var ViewType={DEFAULT_VIEW:"defaultView",ROUTE_VIEW:"routeView",SIDELINE_VIEW:"sidelineView"};var CartType={NORMAL:"NORMAL",HYBRID:"HYBRID",OV:"OV"};var FileType={CSV:"CSV",JSON:"JSON"};var RangeFilter={DIMENSION:"dimension",LESS_THAN_EQUAL:"lessThanEqual",LESS_THAN:"lessThan",GREATER_THAN:"greaterThan",GREATER_THAN_EQUAL:"greaterThanEqual"};var NodeResourceData={NODE_RESOURCE_TYPE:"nodeResourceType",NODE_RESOURCE_LIST:"nodeResourceList"};

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Context__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__connect_connect__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks_useDispatch__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_useSelector__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_useStore__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_batch__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_shallowEqual__ = __webpack_require__(197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport connectAdvanced */
/* unused harmony reexport ReactReduxContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__connect_connect__["a"]; });
/* unused harmony reexport batch */
/* unused harmony reexport useDispatch */
/* unused harmony reexport createDispatchHook */
/* unused harmony reexport useSelector */
/* unused harmony reexport createSelectorHook */
/* unused harmony reexport useStore */
/* unused harmony reexport createStoreHook */
/* unused harmony reexport shallowEqual */










Object(__WEBPACK_IMPORTED_MODULE_7__utils_batch__["b" /* setBatch */])(__WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__["a" /* unstable_batchedUpdates */]);


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addLocaleData; });
/* unused harmony export intlShape */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return injectIntl; });
/* unused harmony export defineMessages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IntlProvider; });
/* unused harmony export FormattedDate */
/* unused harmony export FormattedTime */
/* unused harmony export FormattedRelative */
/* unused harmony export FormattedNumber */
/* unused harmony export FormattedPlural */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormattedMessage; });
/* unused harmony export FormattedHTMLMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_format_cache__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__);
/*
 * Copyright 2019, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */










// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

function createError(message, exception) {
  var eMsg = exception ? '\n' + exception : '';
  return '[React Intl] ' + message + eMsg;
}

function defaultErrorHandler(error) {
  if (false) {
    console.error(error);
  }
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_6_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this._wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? /* istanbul ignore next */function (ref) {
            return _this2._wrappedInstance = ref;
          } : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(InjectIntl, WrappedComponent);
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
  thresholds['second-short'] = newThresholds['second-short'];
  thresholds['minute-short'] = newThresholds['minute-short'];
  thresholds['hour-short'] = newThresholds['hour-short'];
  thresholds['day-short'] = newThresholds['day-short'];
  thresholds['month-short'] = newThresholds['month-short'];
}

function getNamedFormat(formats, type, name, onError) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  onError(createError('No ' + type + ' format named: ' + name));
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting date.', e));
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting time.', e));
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    onError(createError('Error formatting relative time.', e));
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting number.', e));
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  var onError = config.onError || defaultErrorHandler;

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting plural.', e));
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // Produce a better error if the user calls `intl.formatMessage(element)`

  if (false) {
    invariant(!isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
  }

  // `id` is a required field of a Message Descriptor.
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;
  var onError = config.onError || defaultErrorHandler;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
    }
  } else {
    // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting the default message for: "' + id + '"', e));
    }
  }

  if (!formattedMessage) {
    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  timeZone: null,
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {},

  onError: defaultErrorHandler
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_6_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(Intl.DateTimeFormat),
      getNumberFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(Intl.NumberFormat),
      getMessageFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats,
            onError = _config.onError;


        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (false) {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }
  return formatMessage({}, { getMessageFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a) }, descriptor, values);
};

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    if (!props.defaultMessage) {
      invariantIntlContext(context);
    }
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.context.intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;

      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getOrDefaultValueForCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getTotalUnopenedBags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return missingBagforStowV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getNodeResourceDataMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return chainWalk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getClusterForAisle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getZoneForCartLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getNodeId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return extractRouteCodePrefixesFromParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getFormattedTimeFromEpoch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getRelativeTimeFromEpoch; });
/* unused harmony export getMonthName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAliasFromLoginId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return makeNumberTwoDigit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convertToString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getFilteredLocations; });
/* unused harmony export getFilteredLocationsForDRS */
/* harmony export (immutable) */ __webpack_exports__["g"] = getBaseUrl;
/* harmony export (immutable) */ __webpack_exports__["j"] = getDateInMMDDYYYYWithOffset;
/* unused harmony export getStowVsPlan */
/* unused harmony export isAMPLStation */
/* unused harmony export isAMXLStation */
/* harmony export (immutable) */ __webpack_exports__["t"] = isCapabilityARorSSD;
/* unused harmony export isARStation */
/* harmony export (immutable) */ __webpack_exports__["u"] = isOnlyRouteViewApplicable;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCurrentFormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getSidelineRangeFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return onRouteClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return downloadCsvFromUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__ = __webpack_require__(24);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/**
 * Gets value from the map. If the resolved value is undefined, the defaultValue is returned in its place.
 */var getOrDefaultValueForCell=function getOrDefaultValueForCell(map,key1,key2){if(map===undefined||map[key1]===undefined||map[key1][key2]===undefined&&key2){return"-";}return key2?map[key1][key2]:map[key1];};var getTotalUnopenedBags=function getTotalUnopenedBags(nodeResourceDataMap,stowBinMetricsMap){var totalVal=0;// eslint-disable-next-line no-unused-vars
var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=nodeResourceDataMap[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _ref=_step.value;var _ref2=_slicedToArray(_ref,2);var key=_ref2[0];var value=_ref2[1];totalVal=totalVal+missingBagforStowV2(nodeResourceDataMap,stowBinMetricsMap,key);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return totalVal;};var missingBagforStowV2=function missingBagforStowV2(nodeResourceDataMap,stowBinMetricsMap,key1){var key2="binsMissingBag";var totalVal=nodeResourceDataMap.get(key1.toString());if(totalVal===undefined){return 0;}else{if(stowBinMetricsMap!==undefined){if(stowBinMetricsMap[key1]===undefined||stowBinMetricsMap[key1][key2]===undefined&&key2){return totalVal;}else{return Math.max(totalVal-stowBinMetricsMap[key1][key2],0);}}}};var getNodeResourceDataMap=function getNodeResourceDataMap(nodeResourceData){var nodeResourceDataMap=new Map(Object.entries(nodeResourceData));var nodeResourceMap={};var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=nodeResourceDataMap[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _ref3=_step2.value;var _ref4=_slicedToArray(_ref3,2);var label=_ref4[0];var nodeResource=_ref4[1];nodeResourceMap[label]=nodeResource["numberOfSortZones"];}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}return new Map(Object.entries(nodeResourceMap));};var chainWalk=function chainWalk(func,defaultValue){try{var value=func();return value===null||value===undefined?defaultValue:value;}catch(e){return defaultValue;}};var getClusterForAisle=function getClusterForAisle(aisle){return aisle.split("-")[0].replace(/\d/g,"");};var getZoneForCartLocation=function getZoneForCartLocation(cartLocation){return cartLocation.split('.')[0];};var getNodeId=function getNodeId(){var queryParams=new URLSearchParams(window.location.search);return queryParams.get('stationCode');};var extractRouteCodePrefixesFromParam=function extractRouteCodePrefixesFromParam(props){if(props.match&&props.match.params&&props.match.params.routeCodePrefixes)return props.match.params.routeCodePrefixes;return"";};var getFormattedTimeFromEpoch=function getFormattedTimeFromEpoch(millis){var dateTime=new Date(millis);var date=dateTime.getUTCDate();var month=getMonthName(dateTime.getUTCMonth());var year=dateTime.getUTCFullYear();var hours=makeNumberTwoDigit(dateTime.getUTCHours());var minutes=makeNumberTwoDigit(dateTime.getUTCMinutes());var seconds=makeNumberTwoDigit(dateTime.getUTCSeconds());return date+" "+month+" "+year+" "+hours+":"+minutes+":"+seconds;};var getRelativeTimeFromEpoch=function getRelativeTimeFromEpoch(time){var date=new Date();var currentTimeSeconds=Math.floor(date.getTime()/1000);var delta=currentTimeSeconds-time/1000;if(delta>2*24*3600){return getFormattedTimeFromEpoch(delta*1000);}else if(delta>24*3600){return"yesterday";}else if(delta>3600){return"a few hours ago";}else if(delta>1800){return"half an hour ago";}else if(delta>60){return Math.floor(delta/60)+" minutes ago";}};var getMonthName=function getMonthName(monthNumber){var monthNames=["Jan","Feb","Mar","Apr","May","June","July","Aug","Sept","Oct","Nov","Dec"];return monthNames[monthNumber];};var formQueryParams=function formQueryParams(params){var queryParams="";for(var key in params){queryParams+=key+"="+params[key]+"&";}return queryParams;};var getAliasFromLoginId=function getAliasFromLoginId(loginId){if(loginId.indexOf('@')!==-1){return loginId.substr(0,loginId.indexOf('@'));}return loginId;};var makeNumberTwoDigit=function makeNumberTwoDigit(number){return number<10?'0'+number:number;};var convertToString=function convertToString(param){return param&&param!==null?param.toString():"";};var getFilteredLocations=function getFilteredLocations(locations,packageMetricsMap,isDRSStowVisibilityEnabled){if(isDRSStowVisibilityEnabled){return getFilteredLocationsForDRS(locations,packageMetricsMap);}return locations.filter(function(locationEle){return getOrDefaultValueForCell(packageMetricsMap,locationEle,"plannedPackages")!=='-'&&getOrDefaultValueForCell(packageMetricsMap,locationEle,"plannedPackages")!==0||locationEle.startsWith("OV");});// Because OV locations will always have 0 planned volume
};var getFilteredLocationsForDRS=function getFilteredLocationsForDRS(locations,packageMetricsMap){return locations.filter(function(locationEle){return getOrDefaultValueForCell(packageMetricsMap,locationEle,"plannedPackages")!=='-'&&getOrDefaultValueForCell(packageMetricsMap,locationEle,"plannedPackages")!==0||locationEle.startsWith("OV")||getOrDefaultValueForCell(packageMetricsMap,locationEle,"stowedPackages")!=='-'&&getOrDefaultValueForCell(packageMetricsMap,locationEle,"stowedPackages")!==0||getOrDefaultValueForCell(packageMetricsMap,locationEle,"receivedPackages")!=='-'&&getOrDefaultValueForCell(packageMetricsMap,locationEle,"receivedPackages")!==0||getOrDefaultValueForCell(packageMetricsMap,locationEle,"currentInductedPackages")!=='-'&&getOrDefaultValueForCell(packageMetricsMap,locationEle,"currentInductedPackages")!==0;});};function getBaseUrl(endpoint){var url=new URL(endpoint);return url.origin;}function getDateInMMDDYYYYWithOffset(offset){var presentDate=new Date();presentDate.setDate(presentDate.getDate()+offset);return presentDate.getMonth()+1+"/"+presentDate.getDate()+"/"+presentDate.getFullYear();}function getStowVsPlan(planned,stowed){if(planned===0){return 0;}return(stowed*100.00/planned).toFixed(2);}function isAMPLStation(nodeId){var nodeList=["DQA5","DQA6","DGQ1","DQL1","DQV3","DQV7","DQV8","DCT5","DCT6","DQB5","DQB6","DZG1","DRQ1","DAO9","DAR9","DAC8","DAC9","DLP9","DWP3","DFQ2","DFQ3","DFQ4","DCQ2","DCQ4","DSQ3"];return nodeList.includes(nodeId);}function isAMXLStation(nodeId){return nodeId.startsWith("H")&&nodeId!=="HMB1";}function isCapabilityARorSSD(capability){return __WEBPACK_IMPORTED_MODULE_1__enums__["e" /* Capability */].SSD===capability||__WEBPACK_IMPORTED_MODULE_1__enums__["e" /* Capability */].AR===capability;}function isARStation(capability){return __WEBPACK_IMPORTED_MODULE_1__enums__["e" /* Capability */].AR===capability;}function isOnlyRouteViewApplicable(nodeId,capability){return isAMPLStation(nodeId)||isAMXLStation(nodeId)||isARStation(capability);}/**
 * Returns the current time in format [ MonthName dd, YYYY, HH:MM:SS GMT+__:__ ]
 * This pattern may slightly change according to current locale.
 * @param locale
 * @return string
 */var getCurrentFormattedTime=function getCurrentFormattedTime(locale){var currentDate=new Date();return new Intl.DateTimeFormat(locale,__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* DATE_TIME_FORMAT */]).format(currentDate);};var getSidelineRangeFilter=function getSidelineRangeFilter(reInductDay){var date=reInductDay.split("T")[0];var lessThanEqualDate=date+"T23:59:59";return{dimension:"SIDELINE_UNTIL_TIME",greaterThanEqual:reInductDay,lessThanEqual:lessThanEqualDate};};var onRouteClick=function onRouteClick(routeId,routeCode){var nodeId=getNodeId();Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["d" /* getDocumentURL */])().then(function(result){var params=["Stow",routeId,__WEBPACK_IMPORTED_MODULE_2__constants__["q" /* NOT_AVAILABLE */],__WEBPACK_IMPORTED_MODULE_2__constants__["q" /* NOT_AVAILABLE */],__WEBPACK_IMPORTED_MODULE_2__constants__["q" /* NOT_AVAILABLE */],__WEBPACK_IMPORTED_MODULE_2__constants__["q" /* NOT_AVAILABLE */],routeCode,nodeId];var url=new URL(result.replace("stow","pick"));var shareableLink="/routeDetail/"+params.join("/");url.searchParams.set("shareableLink",shareableLink);window.open(url.href,"_parent");});};var downloadCsvFromUrl=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(presignedUrl){var filename=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"sort_plan.csv";var fetchResponse,blob,blobUrl,a;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return fetch(presignedUrl,{method:'GET',mode:'cors',headers:{'Accept':'text/csv,application/octet-stream'}});case 3:fetchResponse=_context.sent;_context.next=6;return fetchResponse.blob();case 6:blob=_context.sent;blobUrl=window.URL.createObjectURL(new Blob([blob],{type:'text/csv;charset=utf-8;'}));a=document.createElement("a");a.style.display='none';a.href=blobUrl;a.download=filename;document.body.appendChild(a);a.click();document.body.removeChild(a);// Release memory after download
window.URL.revokeObjectURL(blobUrl);_context.next=21;break;case 18:_context.prev=18;_context.t0=_context["catch"](0);throw _context.t0;case 21:case"end":return _context.stop();}}},_callee,_this,[[0,18]]);}));return function downloadCsvFromUrl(_x2){return _ref5.apply(this,arguments);};}();

/***/ }),
/* 11 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeTokenPrefixes = exports.memoizeTokenStyles = exports.getUnthemedTokens = exports.getTokenHelper = exports.getToken = exports.getIconFromTokens = void 0;

var _pascalCase = _interopRequireDefault(__webpack_require__(374));

var _upperFirst = _interopRequireDefault(__webpack_require__(203));

var _lowerFirst = _interopRequireDefault(__webpack_require__(375));

var _functional = __webpack_require__(26);

/**
 * Select a single token from a token object given a key (and optionally a
 * "suffix" key or list of suffix keys). If the token doesn't exist then an
 * attempt is made to replace the last suffix key with "default" and get the
 * value for that token. If that token also doesn't exist then `undefined` is
 * returned.
 *
 * @example
 * const tokens = {
 *   backgroundColorDefault: "#fff",
 *   backgroundColorHover: "#ccc",
 *   backgroundColorPressed: "#f00",
 * }
 * getToken(tokens, "backgroundColor", "active") // #fff
 * getTokens(tokens, "background", ["color", "pressed"]) // #f00
 * getToken(tokens, "myBackgroundColor") // undefined
 */
var getToken = function getToken(tokens, key, suffixKeys) {
  // If we got an array of suffix keys, turn them into a PascalCaseString and
  // look up the token
  if (suffixKeys && Array.isArray(suffixKeys)) {
    var value = tokens["".concat(key).concat((0, _pascalCase["default"])(suffixKeys))];
    return value !== undefined ? value : tokens["".concat(key).concat((0, _pascalCase["default"])(suffixKeys.slice(0, -1)), "Default")]; // If we got a single suffix key then upper case the first character and look
    // up the token
  } else if (suffixKeys) {
    var _value = tokens["".concat(key).concat((0, _upperFirst["default"])(suffixKeys))];
    return _value !== undefined ? _value : tokens["".concat(key, "Default")]; // If we didn't get any suffix keys then do a simple lookup
  } else {
    return tokens[key];
  }
};
/**
 * This will, given a root key and token object, return a special helper that
 * includes token utilities with those inputs already applied. Calling the
 * helper as a function is equivalent to calling `getToken`, but the helper also
 * includes several properties that make it easier to construct CSS from tokens.
 * This helper is useful when working with an object of tokens that all have the
 * same prefix.
 *
 * @example
 * const tokens = {
 *   buttonBorderWidth: 1,
 *   buttonBorderStyle: "dotted",
 *   buttonBorderColor: "#f00",
 * }
 * const t = getTokenHelper("button")(tokens)
 * t("borderWidth") // 1
 * t.borderCss("border") // "1px dotted #f00"
 * t.tokens === tokens // true
 *
 */


exports.getToken = getToken;
var getTokenHelper = (0, _functional.memoizeCurry)(function (prefixKey, tokens) {
  var helper = function helper(key, suffixKeys) {
    return getToken(tokens, prefixKey ? "".concat(prefixKey).concat((0, _upperFirst["default"])(key)) : key, suffixKeys);
  };

  helper.tokens = tokens; // Pass in "myBorder" and shorthand border css will be generated based on
  // "myBorderWidth" and "myBorderColor" tokens.

  helper.borderCss = function (key) {
    var width = helper(key, "width");
    var color = helper(key, "color");
    return width && color ? "".concat(width, "px solid ").concat(color) : undefined;
  }; // Pass in "myShadow" and shorthand box shadow css will be generated based on
  // "myShadowOffsetX", "myShadowOffsetY", "myShadowBlur", "myShadowSpread",
  // and "myShadowColor" tokens


  helper.boxShadowCss = function (key) {
    var color = helper(key, "color");
    return color ? "".concat(helper(key, "offsetX"), "px ").concat(helper(key, "offsetY"), "px ").concat(helper(key, "blur"), "px ").concat(helper(key, "spread"), "px ").concat(color) : undefined;
  }; // Pass in "myMotion" and a single css property or array of properties and
  // shorthand transition css will be generated that animates those properties
  // based on "myMotionFunction" and "myMotionDuration" tokens


  helper.transitionCss = function (key, properties) {
    var transition = "".concat(helper(key, "duration"), " ").concat(helper(key, "function"));
    return Array.isArray(properties) ? properties.map(function (property) {
      return "".concat(property, " ").concat(transition);
    }).join(", ") : "".concat(properties, " ").concat(transition);
  };

  return helper;
}, 1);
/**
 * Gets icon data from a set of icon tokens
 *
 * ```
 * const tokens = {
 *   iconCheckmarkData: "<svg />",
 *.  iconCheckmarkWidth: 12,
 *   iconCheckmarkHeight: 10,
 * }
 * // Returns { data: "<svg />", width: 12, height: 10 }
 * getIconFromTokens(tokens)
 * ```
 */

exports.getTokenHelper = getTokenHelper;

var getIconFromTokens = function getIconFromTokens(tokens) {
  return Object.keys(tokens).reduce(function (result, key) {
    if (key.indexOf("Data") > 0) {
      result.data = tokens[key];
    } else if (key.indexOf("Rtl") > 0) {
      result.dataRtl = tokens[key];
    } else if (key.indexOf("Width") > 0) {
      result.width = tokens[key];
    } else if (key.indexOf("Height") > 0) {
      result.height = tokens[key];
    }

    return result;
  }, {});
};
/**
 * If you pass in a function that returns themed tokens when given a theme
 * object (e.g. any of our "component" tokens), this will call that function
 * with an empty theme object and filter out any tokens that are undefined. This
 * is useful for quickly accessing unthemed component tokens. Use this sparingly
 * as what is and is not themed may change in the future and require a refactor
 * of any code using this function.
 */


exports.getIconFromTokens = getIconFromTokens;

var getUnthemedTokens = function getUnthemedTokens(tokens) {
  var unthemedTokens = tokens({});
  return Object.keys(unthemedTokens).reduce(function (result, key) {
    if (unthemedTokens[key] !== undefined) {
      result[key] = unthemedTokens[key];
    }

    return result;
  }, {});
};
/**
 * Takes an object of tokens and removes the prefix from each token name (object
 * key). The result is returned with the first character of the new keys
 * lowercased.
 *
 * ```
 * const tokens = {
 *   iconCheckmarkData: "<svg />",
 *.  iconCheckmarkWidth: 12,
 *   iconCheckmarkHeight: 10,
 * }
 * // Returns { data: "<svg />", width: 12, height: 10 }
 * removetokenPrefixes(tokens, "iconCheckmark")
 * ```
 */


exports.getUnthemedTokens = getUnthemedTokens;

var removeTokenPrefixes = function removeTokenPrefixes(tokens, prefix) {
  var match = new RegExp("^".concat(prefix));
  return Object.keys(tokens).reduce(function (result, key) {
    if (match.test(key)) {
      result[(0, _lowerFirst["default"])(key.replace(match, ""))] = tokens[key];
    }

    return result;
  }, {});
};
/**
 * Memoize f(tokens, props) that is used extensively throughout meridian components,
 * specify the keys in the object to compare when determining whether to re-use
 * a previous calculation.
 *
 * @example
 * const style = memoizeTokenStyles((t, {a, b}) => css({a, b}), ["a", "b"])
 * style(tokens, {a, b})
 */


exports.removeTokenPrefixes = removeTokenPrefixes;

var memoizeTokenStyles = function memoizeTokenStyles(f, keys) {
  /* eslint-disable-next-line rulesdir/no-partial-memoization */
  var fn = (0, _functional.memoize)(function (t) {
    return (0, _functional.memoizeByKeys)(function (props) {
      return f(t, props);
    }, keys);
  });
  return function (t, props) {
    return fn(t)(props);
  };
};

exports.memoizeTokenStyles = memoizeTokenStyles;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Takes an object of props and filters them down to only the props with names
 * that start with one of a given set of prefixes.
 */
var filterPropsByPrefix = function filterPropsByPrefix(props, prefixes) {
  return Object.keys(props).filter(function (name) {
    return prefixes.some(function (prefix) {
      return name.indexOf(prefix) === 0;
    });
  }).reduce(function (result, name) {
    result[name] = props[name];
    return result;
  }, {});
};

var _default = filterPropsByPrefix;
exports["default"] = _default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Style", {
  enumerable: true,
  get: function get() {
    return _theme.Style;
  }
});
exports["default"] = void 0;
Object.defineProperty(exports, "useTheme", {
  enumerable: true,
  get: function get() {
    return _theme.useTheme;
  }
});

__webpack_require__(377);

var _theme = _interopRequireWildcard(__webpack_require__(378));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = _theme["default"];
exports["default"] = _default;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _column = _interopRequireDefault(__webpack_require__(556));

var _default = _column["default"];
exports["default"] = _default;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(543);


/***/ }),
/* 17 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(359);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(17)["default"];

var assertThisInitialized = __webpack_require__(28);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _checkbox = _interopRequireDefault(__webpack_require__(210));

var _token = __webpack_require__(12);

var _functional = __webpack_require__(26);

var _isElementOfAny = _interopRequireDefault(__webpack_require__(98));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

var _rtl = __webpack_require__(52);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var unthemedCheckboxTokens = (0, _token.getUnthemedTokens)(_checkbox["default"]);
/**
 * Helpers
 */

var getCheckbox = function getCheckbox(checkboxComponents, elements) {
  if (checkboxComponents && typeof elements !== "string") {
    var isCheckbox = (0, _isElementOfAny["default"])(checkboxComponents);

    var child = _react["default"].Children.toArray(elements)[0];

    return isCheckbox(child) ? child : null;
  } else {
    return null;
  }
};

var getCheckboxWidth = (0, _functional.memoize)(function (size) {
  return (0, _token.getToken)(unthemedCheckboxTokens, "checkboxWidth", size);
});

var stretchCheckbox = function stretchCheckbox(checkbox) {
  return /*#__PURE__*/_react["default"].cloneElement(checkbox, {
    fillParent: true
  });
};
/**
 * Styles
 */


var styles = (0, _functional.memoize)(function (checkboxWidth) {
  return (0, _functional.memoizeByKeys)(function (_ref) {
    var _css;

    var alignmentHorizontal = _ref.alignmentHorizontal,
        alignmentVertical = _ref.alignmentVertical,
        width = _ref.width,
        height = _ref.height,
        backgroundColor = _ref.backgroundColor;
    return (0, _emotion.css)((_css = {
      textAlign: (0, _rtl.getHorizontalDirection)(alignmentHorizontal)
    }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
      textAlign: (0, _rtl.getRtl)(alignmentHorizontal)
    }), (0, _defineProperty2["default"])(_css, "verticalAlign", alignmentVertical === "center" ? "middle" : alignmentVertical), (0, _defineProperty2["default"])(_css, "width", width || checkboxWidth), (0, _defineProperty2["default"])(_css, "minWidth", width || checkboxWidth), (0, _defineProperty2["default"])(_css, "height", height || "inherit"), (0, _defineProperty2["default"])(_css, "boxSizing", width || height ? "border-box" : "content-box"), (0, _defineProperty2["default"])(_css, "&[mdn-cell-background-color-custom]", {
      backgroundColor: "".concat(backgroundColor, " !important")
    }), (0, _defineProperty2["default"])(_css, "&[mdn-hidden-cell]", {
      display: "none"
    }), (0, _defineProperty2["default"])(_css, "& > span", checkboxWidth ? {
      display: "block",
      height: "100%",
      position: "static"
    } : undefined), _css));
  }, ["alignmentHorizontal", "alignmentVertical", "width", "height", "backgroundColor"]);
});
/**
 * Component
 */

/**
 * Used to render a table cell. Can take any children. Place this as a child of
 * the TableRow component.
 *
 * Note that the Table component will automatically set some props on this
 * component (e.g. `header={true}` if the cell is in a header row). This means
 * that if you wrap this component in your own custom table cell component, you
 * should still pass all props through to this component. For example:
 *
 * // Correct
 * const MyCustomCell = ({ myCustomProp, ...extraProps }) =>
 *   <TableCell {...extraProps} />
 *
 * // Incorrect
 * const MyCustomCell = ({ myCustomProp, children }) =>
 *   <TableCell>{children}</TableCell>
 */

var TableCell = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TableCell, _React$Component);

  var _super = _createSuper(TableCell);

  function TableCell() {
    (0, _classCallCheck2["default"])(this, TableCell);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(TableCell, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var hexBgColor = props.backgroundColor && props.backgroundColor !== "primary" && props.backgroundColor !== "secondary" ? props.backgroundColor : undefined; // If the only child of the cell is a checkbox then stretch the checkbox to
      // fill the cell, making the entire cell clickable

      var checkbox = getCheckbox(props.checkboxComponents, props.children);
      var children = checkbox ? stretchCheckbox(checkbox) : props.children;
      var checkboxWidth = checkbox ? getCheckboxWidth(checkbox.props.size) : undefined;
      var tag = props.header ? "th" : "td";
      var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
      return /*#__PURE__*/_react["default"].createElement(tag, _objectSpread(_objectSpread({}, passThroughProps), {}, {
        className: styles(checkboxWidth)(props),
        colSpan: props.columnSpan,
        rowSpan: props.rowSpan,
        id: props.id,
        headers: props.headers,
        "aria-sort": props.sortDirection,
        "mdn-cell-background-color-primary": props.backgroundColor === "primary" ? "" : undefined,
        "mdn-cell-background-color-secondary": props.backgroundColor === "secondary" ? "" : undefined,
        "mdn-cell-background-color-custom": hexBgColor ? "" : undefined,
        "mdn-cell-highlight": props.highlight ? "" : undefined,
        "mdn-cell-selectable": checkbox ? "" : undefined,

        /* eslint-disable-next-line react/prop-types */
        "mdn-section-header": props.sectionHeader ? "" : undefined,
        "mdn-hidden-cell": !props.showCell ? "" : undefined,
        // HACK: Don't include `scope` in prop-types since we already take
        // care of setting scope in `table.js` and don't want users overwriting.
        // We could use context, but that would require potentially hundreds of
        // contexts for a single table so this is more performant.

        /* eslint-disable-next-line react/prop-types */
        scope: props.scope
      }),
      /*#__PURE__*/
      // An extra span is needed for the fancy nested headers style and for
      // the chevron icon placed on the left side of parent rows.
      _react["default"].createElement("span", null, children));
    }
  }]);
  return TableCell;
}(_react["default"].Component);

(0, _defineProperty2["default"])(TableCell, "defaultProps", {
  alignmentHorizontal: "start",
  alignmentVertical: "center",
  defaultSortDirection: "ascending",
  showCell: true
});
TableCell.propTypes =  false ? {
  /**
   * The horizontal alignment of content inside the cell.
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["left", "start", "center", "right", "end"]),

  /**
   * The vertical alignment of content inside the cell.
   */
  alignmentVertical: _propTypes["default"].oneOf(["top", "center", "bottom"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set the cell's background color using a preset, or using a string
   * containing any valid CSS color. WARNING: AA accessibility requires
   * a color contrast ratio of 4.5:1 or higher. Please keep this in mind
   * when providing custom background colors, and be sure to check your
   * contrast ratios with a tool like https://contrastchecker.com/
   *
   * @since 5.x
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary"]), _propTypes["default"].string]),

  /**
   * The component or components that will be used to render checkboxes for
   * selectable tables. This can be set on the `Table` component itself, in
   * which case it is not necessary to set it here for each individual cell.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  checkboxComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * The contents of the cell. Any elements are allowed except for nested
   * Meridian tables.
   */
  children: _propTypes["default"].node,

  /**
   * Set this to force the cell to span more than one column.
   */
  columnSpan: _propTypes["default"].number,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Apply this to a header cell to specify the sort direction that should be
   * applied first when the user turns on sorting for the column.
   */
  defaultSortDirection: _propTypes["default"].oneOf(["ascending", "descending"]),

  /**
   * Set this to true if the cell is a header cell (either in a headerRow or
   * header column). Note that this is automatically set if the TableCell is
   * placed in a Table component, so in most cases you should not have to
   * touch this.
   */
  header: _propTypes["default"].bool,

  /**
   * A string of Table header id's with which to associate.
   *
   * See [Mozilla's documentation](https://developer.mozilla.org/en-US/docs/Learn/HTML/Tables/Advanced#using_column_and_row_headers)
   * to learn more (Note: the `scope` attribute is taken care of in Meridian.)
   *
   * @since 5.17.0
   */
  headers: _propTypes["default"].string,

  /**
   * The height of the cell. If left blank the browser will dynamically choose
   * a height based on the cell's contents and the other cells in the table.
   */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Highlight this cell.
   * @deprecated 5.x
   */
  highlight: _propTypes["default"].bool,

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.17.0
   */
  id: _propTypes["default"].string,

  /**
   * Set this to force the cell to span more than one row.
   *
   * Use this in conjunction with `showCell={false}` to hide empty cells
   * covered by the spanned rows.
   *
   * @since 5.29.0
   */
  rowSpan: _propTypes["default"].number,

  /**
   * Set this to false to hide the cell completely, including from screen readers.
   *
   * This is useful in combination with the `rowSpan` prop, when you need to
   * hide empty cells that are covered by the spanned rows.
   *
   * @since 5.29.0
   */
  showCell: _propTypes["default"].bool,

  /**
   * Specify a key that the Table component can use to identify the cell when
   * determining which column should be sorted. If this prop is provided the
   * cell will be made clickable and a sort icon will be added to it.
   */
  sortColumn: _propTypes["default"].string,

  /**
   * Apply this to a header cell if the data in the cell's column is sorted.
   *
   * This is automatically set by the Table component, so in most cases you
   * should not have to touch this. See the docs for the corresponding
   * "sortDirection" column on the Table component.
   */
  sortDirection: _propTypes["default"].oneOf(["ascending", "descending"]),

  /**
   * The width of the cell. If left blank the browser will dynamically choose
   * a width based on the cell's contents and the other cells in the table.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
var _default = TableCell;
exports["default"] = _default;

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = setDarkModeStateListener;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDarkModeStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getNodeCapabilityFromParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFeaturesFromParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCycleDataFromParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAPIGatewayDataFromParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDocumentURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getSmartStowEnablementFromParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getLocaleFromParent; });
/* harmony export (immutable) */ __webpack_exports__["k"] = setSelectedCycle;
/* harmony export (immutable) */ __webpack_exports__["i"] = publishClientSideMetrics;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility__ = __webpack_require__(10);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var postMessagePromises={};function generateGuid(){/**
     * @return {string}
     */function S4(){return((1+Math.random())*0x10000|0).toString(16).substring(1);}return(S4()+S4()+"-"+S4()+"-4"+S4().substr(0,3)+"-"+S4()+"-"+S4()+S4()+S4()).toLowerCase();}function postMessagePromised(targetWindow,message,targetOrigin,timeout){var newGuid=generateGuid();message.guid=newGuid;postMessagePromises[newGuid]={};postMessagePromises[newGuid]['promise']=new Promise(function(resolve,reject){postMessagePromises[newGuid]['resolve']=resolve;postMessagePromises[newGuid]['reject']=reject;targetWindow.postMessage(message,targetOrigin);if(timeout){setTimeout(function(){postMessagePromises[newGuid].resolve(__WEBPACK_IMPORTED_MODULE_1__constants__["v" /* TIMEOUT_STRING */]);console.log("TimeOut: "+message.method);},timeout);}});return postMessagePromises[newGuid].promise;}var setCurrentDarkMode=function setCurrentDarkMode(){};function setDarkModeStateListener(darkModeStateListener){setCurrentDarkMode=darkModeStateListener;}var getDarkModeStatus=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return postMessagePromised(window.parent,{method:"getDarkModeStatus",args:{}},"*");case 2:return _context.abrupt("return",_context.sent);case 3:case"end":return _context.stop();}}},_callee,this);}));return function getDarkModeStatus(){return _ref.apply(this,arguments);};}();var getNodeCapabilityFromParent=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return postMessagePromised(window.parent,{method:'getNodeCapability',args:{}},'*');case 2:return _context2.abrupt("return",_context2.sent);case 3:case"end":return _context2.stop();}}},_callee2,this);}));return function getNodeCapabilityFromParent(){return _ref2.apply(this,arguments);};}();var getFeaturesFromParent=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(features){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return postMessagePromised(window.parent,{method:'getFeatureStatus',args:{features:features,stationCode:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["m" /* getNodeId */])()}},'*');case 2:return _context3.abrupt("return",_context3.sent);case 3:case"end":return _context3.stop();}}},_callee3,this);}));return function getFeaturesFromParent(_x){return _ref3.apply(this,arguments);};}();var getCycleDataFromParent=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return postMessagePromised(window.parent,{method:'getCycleDataFromParent',args:{}},'*');case 2:return _context4.abrupt("return",_context4.sent);case 3:case"end":return _context4.stop();}}},_callee4,this);}));return function getCycleDataFromParent(){return _ref4.apply(this,arguments);};}();var getAPIGatewayDataFromParent=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(args){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return postMessagePromised(window.parent,{method:'getAPIGatewayDataFromParent',args:args},'*');case 2:return _context5.abrupt("return",_context5.sent);case 3:case"end":return _context5.stop();}}},_callee5,this);}));return function getAPIGatewayDataFromParent(_x2){return _ref5.apply(this,arguments);};}();var getDocumentURL=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return postMessagePromised(window.parent,{method:'getDocumentURL',args:{}},'*');case 2:return _context6.abrupt("return",_context6.sent);case 3:case"end":return _context6.stop();}}},_callee6,this);}));return function getDocumentURL(){return _ref6.apply(this,arguments);};}();var getSmartStowEnablementFromParent=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return postMessagePromised(window.parent,{method:'getSmartStowEnabled',args:{}},'*');case 2:return _context7.abrupt("return",_context7.sent);case 3:case"end":return _context7.stop();}}},_callee7,this);}));return function getSmartStowEnablementFromParent(){return _ref7.apply(this,arguments);};}();var getLocaleFromParent=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return postMessagePromised(window.parent,{method:'getLocale',args:{}},'*',200);case 2:return _context8.abrupt("return",_context8.sent);case 3:case"end":return _context8.stop();}}},_callee8,this);}));return function getLocaleFromParent(){return _ref8.apply(this,arguments);};}();function setSelectedCycle(selectedCycle){window.parent.postMessage({method:'setSelectedCycle',args:{selectedCycle:selectedCycle}},"*");}function publishClientSideMetrics(args){window.parent.postMessage({method:'publishClientSideMetrics',args:args},"*");}window.addEventListener("message",onNewPostMessageFromParent,false);function onNewPostMessageFromParent(event){if(event.data.method&&subscribeAbleEvents.hasOwnProperty(event.data.method)){subscribeAbleEvents[event.data.method](event.data);}}var subscribeAbleEvents={"sendCycleDataToChild":sendCycleDataToChild,"sendApiGatewayResponse":sendApiGatewayResponse,"sendDocumentURL":sendDocumentURL,"sendCapabilityResponse":sendCapabilityResponse,"sendLocaleResponse":sendChildData,"sendFeatureStatus":sendResponseData,"sendSmartStowEnabled":sendSmartStowEnabled,"sendDarkModeStatus":sendDarkModeStatus};function sendDarkModeStatus(data){setCurrentDarkMode(data.childData.capability);}function sendCycleDataToChild(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.childData);}}function sendSmartStowEnabled(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.childData);}}function sendApiGatewayResponse(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.responseData);}}function sendDocumentURL(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.responseData);}}function sendCapabilityResponse(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.childData);}}function sendChildData(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.childData);}}function sendResponseData(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.responseData);}}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _keycode = _interopRequireDefault(__webpack_require__(47));

var _emotion = __webpack_require__(4);

var _focus = _interopRequireDefault(__webpack_require__(135));

var _isElementOfAny = _interopRequireDefault(__webpack_require__(98));

var _functional = __webpack_require__(26);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = (0, _functional.memoizeByKeys)(function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return (0, _emotion.css)({
    "&[mdn-row-background-color-custom] > *": {
      backgroundColor: "".concat(backgroundColor, " !important")
    }
  });
}, ["backgroundColor"]);
/**
 * Used to render a table row. Children must be TableCell components. Place this
 * as a child of the Table component.
 */

var TableRow = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TableRow, _React$Component);

  var _super = _createSuper(TableRow);

  function TableRow() {
    var _this;

    (0, _classCallCheck2["default"])(this, TableRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isRow", (0, _isElementOfAny["default"])(_this.props.rowComponents));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDown", function (event) {
      var key = (0, _keycode["default"])(event);

      if (key === "space" || key === "enter") {
        _this.props.onClick(); // Prevent default space and enter behavior (scroll or submit,
        // respectively)


        event.preventDefault();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderRow", function (_ref2) {
      var parent = _ref2.parent,
          cells = _ref2.cells,
          focus = _ref2.focus,
          focusTrigger = _ref2.focusTrigger,
          _ref2$focusProps = _ref2.focusProps,
          focusProps = _ref2$focusProps === void 0 ? {} : _ref2$focusProps;
      var props = _this.props;
      var clickable = Boolean(props.onClick);
      var hexBgColor = props.backgroundColor && props.backgroundColor !== "primary" && props.backgroundColor !== "secondary" ? props.backgroundColor : undefined;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
      return /*#__PURE__*/_react["default"].createElement("tr", (0, _extends2["default"])({}, passThroughProps, {
        className: styles({
          backgroundColor: hexBgColor
        }),
        onClick: props.onClick,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onKeyDown: clickable ? _this.onKeyDown : undefined,
        tabIndex: clickable ? "0" : undefined,
        "mdn-row-focus": focus && focusTrigger === "keyboard" ? "" : undefined,
        "mdn-row-parent": parent ? "" : undefined,
        "mdn-row-highlight": props.highlight ? "" : undefined,
        "mdn-row-background-color-primary": props.backgroundColor === "primary" ? "" : undefined,
        "mdn-row-background-color-secondary": props.backgroundColor === "secondary" ? "" : undefined,
        "mdn-row-background-color-custom": hexBgColor ? "" : undefined,
        "mdn-row-highlight-on-hover": props.highlightOnHover ? "" : undefined,
        "mdn-row-highlight-on-press": props.onClick && props.highlightOnHover ? "" : undefined,
        "mdn-row-open": parent && props.open ? "" : undefined,
        "mdn-row-child": props.child ? "" : undefined,
        "mdn-row-last-child": props.lastChild ? "" : undefined
      }, focusProps), cells);
    });
    return _this;
  }

  (0, _createClass2["default"])(TableRow, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onClick = _this$props.onClick,
          open = _this$props.open,
          children = _this$props.children;
      var childRows = [];
      var cells = []; // Separate cells from nested rows

      _react["default"].Children.forEach(children, function (child) {
        if (_this2.isRow(child)) {
          childRows.push(child);
        } else {
          cells.push(child);
        }
      });

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, onClick ? /*#__PURE__*/_react["default"].createElement(_focus["default"], null, function (focus) {
        return _this2.renderRow(_objectSpread({
          parent: childRows.length > 0,
          cells: cells
        }, focus));
      }) : this.renderRow({
        parent: childRows.length > 0,
        cells: cells
      }), open ? childRows.map(function (row, index) {
        return /*#__PURE__*/_react["default"].cloneElement(row, {
          child: true,
          lastChild: index === childRows.length - 1
        });
      }) : null);
    }
  }]);
  return TableRow;
}(_react["default"].Component);

TableRow.propTypes =  false ? {
  /**
   * A list of `TableCell` elements, as well as any nested `TableRow` elements
   * for expandable tables.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set the cell's background color using a preset, or using a string
   * containing any valid CSS color. WARNING: AA accessibility requires
   * a color contrast ratio of 4.5:1 or higher. Please keep this in mind
   * when providing custom background colors, and be sure to check your
   * contrast ratios with a tool like https://contrastchecker.com/
   *
   * @since 5.x
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary"]), _propTypes["default"].string]),

  /**
   * Indicates that this row is a child of another row. This prop is set
   * automatically when one TableRow is nested inside another, so in most
   * cases you should not have to touch this.
   */
  child: _propTypes["default"].bool,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * This determines if the row is highlighted.
   *
   * @deprecated 5.x
   */
  highlight: _propTypes["default"].bool,

  /**
   * This determines if the row should highlight when the user hovers over it.
   * If the row is clickable (i.e. a click handler is passed to the `onClick`
   * prop) then it will also take on a pressed when the user activates it.
   */
  highlightOnHover: _propTypes["default"].bool,

  /**
   * Indicates that this row is the last child of another row. This prop is
   * set automatically when one TableRow is nested inside another, so in most
   * cases you should not have to touch this.
   */
  lastChild: _propTypes["default"].bool,

  /**
   * Determines if rows that are children of this row are visible or hidden.
   */
  open: _propTypes["default"].bool,

  /**
   * The component that will render any nested table rows (for expandable
   * tables). Inherits the value passed to the "rowComponents" prop of Table by
   * default.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  rowComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * Bind a click handler to the row. This will make the row focuseable via
   * keyboard. Avoid using this if the row contains clickable children (e.g.
   * a link or a button).
   */
  onClick: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves over the component. The [mouseenter event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseenter_event)
   * is passed as the first argument to the function.
   *
   * This is helpful for tracking the row's hovered state.
   */
  onMouseEnter: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves off of the component. The [mouseleave event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseleave_event)
   * is passed as the first argument to the function.
   *
   * This is helpful for tracking the row's hovered state.
   */
  onMouseLeave: _propTypes["default"].func
} : {};
var _default = TableRow;
exports["default"] = _default;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memoize = memoize;
exports.memoizeArray = memoizeArray;
exports.memoizeByKeys = memoizeByKeys;
exports.memoizeCurry = memoizeCurry;

/**
 * Author: shekwong@
 */
var END = new Object();
/**
 * Memoize a function with one argument.
 *
 * @example
 * const square = a => a * a
 * const memoizedSquare = memoize(square)
 * memoizedSquare(2) // 4
 */

function memoize(f) {
  var memo = new Map();
  return function (i) {
    if (memo.has(i)) {
      return memo.get(i);
    }

    var result = f(i);
    memo.set(i, result);
    return result;
  };
}
/**
 * Memoize a function with N args by currying it
 *
 * @example
 * const multiply = (a, b) => a * b
 * const memoizedMultiply = memoize(multiply, 1)
 * memoizedMultiply(2)(3) // 6
 */


function memoizeCurry(f, depth) {
  var a = f;

  if (depth == 0) {
    return memoize(a);
  }

  return memoize(function (x) {
    return memoizeCurry(a.bind(null, x), depth - 1);
  });
}
/**
 * A helper function used by memoizeByKeys.
 */


function memoizeByKeysCurry(f, resolver, depth) {
  var a = f;

  if (depth == 0) {
    return memoize(resolver);
  }

  return memoize(function (x) {
    return memoizeByKeysCurry(a.bind(null, x), resolver, depth - 1);
  });
}
/**
 * Memoize a function that accepts an object as its only argument. You must
 * specify the keys in the object to compare when determining whether to re-use
 * a previous calculation.
 *
 * NOTE: This can only support properties in the object that are simple (e.g.
 * strings, numbers, booleans, not nested objects or arrays).
 *
 * @example
 * const multiply = ({ a, b }) => a * b
 * cont memoizedMultiply = memoizeByKeys(multiply, ["a", "b"])
 * memoizedMultiply({ a: 2, b: 3 }) // 6
 */


function memoizeByKeys(f, keys) {
  var args = undefined;
  var g = memoizeByKeysCurry(f, function () {
    return f(args);
  }, keys.length - 1);
  return function (a) {
    if (!a) {
      var _c = g;
      keys.forEach(function () {
        _c = _c(undefined);
      });
      return _c;
    }

    args = a;
    var c = g;
    keys.forEach(function (k) {
      c = c(args[k]);
    });
    return c;
  };
}
/**
 * A helper function used by memoizeArray.
 */


function memoizeByVarArgsCurry(f) {
  var a = f;
  return memoize(function (x) {
    return x === END ? a() : memoizeByVarArgsCurry(a.bind(null, x));
  });
}
/**
 * Memoize a function that accepts an array as its only argument.
 *
 * @example
 * const multiply = numbers => numbers.reduce((result, num) => result * num)
 * cont memoizedMultiply = memoizeArray(multiply)
 * memoizedMultiply([2, 3, 4]) // 24
 */


function memoizeArray(f) {
  var memoized = memoizeByVarArgsCurry(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return f(args);
  });
  return function (vals) {
    var g = memoized;
    vals.forEach(function (v) {
      g = g(v);
    });
    return g(END);
  };
}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _text = _interopRequireDefault(__webpack_require__(134));

var text = function text(t) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var tokens = (0, _text["default"])(t.tokens);
  return {
    color: t("foregroundColor", keys.color) || t.tokens.themeForegroundPrimaryDefault,
    fontFamily: t("fontFamily", keys.fontFamily) || tokens.textFontFamilyAmazonEmber,
    fontSize: t("fontSize", keys.fontSize) || tokens.textFontSizeB300,
    fontWeight: t("fontWeight", keys.fontWeight) || tokens.textFontWeightB300,
    lineHeight: t("lineHeight", keys.lineHeight) || tokens.textLineHeightB300
  };
};

var _default = text;
exports["default"] = _default;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TableActionBar", {
  enumerable: true,
  get: function get() {
    return _tableActionBar["default"];
  }
});
Object.defineProperty(exports, "TableActionBarOverlay", {
  enumerable: true,
  get: function get() {
    return _tableActionBar.TableActionBarOverlay;
  }
});
Object.defineProperty(exports, "TableCell", {
  enumerable: true,
  get: function get() {
    return _tableCell["default"];
  }
});
Object.defineProperty(exports, "TableRow", {
  enumerable: true,
  get: function get() {
    return _tableRow["default"];
  }
});
Object.defineProperty(exports, "TableSectionHeader", {
  enumerable: true,
  get: function get() {
    return _tableSectionHeader["default"];
  }
});
exports["default"] = void 0;

var _table = _interopRequireDefault(__webpack_require__(380));

var _tableRow = _interopRequireDefault(__webpack_require__(25));

var _tableCell = _interopRequireDefault(__webpack_require__(23));

var _tableSectionHeader = _interopRequireDefault(__webpack_require__(209));

var _tableActionBar = _interopRequireWildcard(__webpack_require__(414));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = _table["default"];
exports["default"] = _default;

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return OPTIONS_ADDED_OR_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return VIEW_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return OPTION_REMOVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return OPTION_REMOVE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return OPTIONS_BUTTON_CLICKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_OPTIONS_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_CAPABILITY_CALL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_CYCLES_CALL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_FILTERS_CALL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_OPTIONS_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NAVIGATION_ADDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NAVIGATION_REMOVED; });
/* unused harmony export fetchOptionsCallBegin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return fetchCapabilityCallSuccess; });
/* unused harmony export fetchCyclesCallSuccess */
/* unused harmony export fetchFiltersCallSuccess */
/* unused harmony export fetchOptionsCallFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fetchCapability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return fetchCycles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return fetchFilters; });
/* unused harmony export optionsButtonClicked */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return optionsAddedOrChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return viewChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return optionRemoved; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return optionRemoveAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return navigationAdded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return navigationRemoved; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_StowResource__ = __webpack_require__(31);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var OPTIONS_ADDED_OR_CHANGED="OPTIONS_ADDED_OR_CHANGED";var VIEW_CHANGED="VIEW_CHANGED";var OPTION_REMOVED="OPTION_REMOVED";var OPTION_REMOVE_ALL="OPTION_REMOVE_ALL";var OPTIONS_BUTTON_CLICKED="OPTIONS_BUTTON_CLICKED";var FETCH_OPTIONS_CALL_BEGIN="FETCH_OPTIONS_CALL_BEGIN";var FETCH_CAPABILITY_CALL_SUCCESS="FETCH_CAPABILITY_CALL_SUCCESS";var FETCH_CYCLES_CALL_SUCCESS="FETCH_CYCLES_CALL_SUCCESS";var FETCH_FILTERS_CALL_SUCCESS="FETCH_FILTERS_CALL_SUCCESS";var FETCH_OPTIONS_CALL_FAILURE="FETCH_OPTIONS_CALL_FAILURE";var NAVIGATION_ADDED="NAVIGATION_ADDED";var NAVIGATION_REMOVED="NAVIGATION_REMOVED";/**
 * Fetch Options call begin.
 */var fetchOptionsCallBegin=function fetchOptionsCallBegin(){return{type:FETCH_OPTIONS_CALL_BEGIN};};/**
 * Fetch Capability call success.
 */var fetchCapabilityCallSuccess=function fetchCapabilityCallSuccess(capabilityResponse){return{type:FETCH_CAPABILITY_CALL_SUCCESS,capabilityResponse:capabilityResponse};};/**
 * Fetch Cycles call success.
 */var fetchCyclesCallSuccess=function fetchCyclesCallSuccess(cyclesResponse){return{type:FETCH_CYCLES_CALL_SUCCESS,cyclesResponse:cyclesResponse};};/**
 * Fetch Filters call success.
 */var fetchFiltersCallSuccess=function fetchFiltersCallSuccess(filters){return{type:FETCH_FILTERS_CALL_SUCCESS,filters:filters};};/**
 * Fetch Options call failure
 */var fetchOptionsCallFailure=function fetchOptionsCallFailure(error){return{type:FETCH_OPTIONS_CALL_FAILURE,error:error};};var fetchCapability=function fetchCapability(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var capabilityResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(fetchOptionsCallBegin());_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["g" /* getNodeCapabilityFromParent */])();case 4:capabilityResponse=_context.sent;dispatch(fetchCapabilityCallSuccess(capabilityResponse));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context["catch"](1);return _context.abrupt("return",dispatch(fetchOptionsCallFailure(_context.t0.response)));case 11:case"end":return _context.stop();}}},_callee,_this,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var fetchCycles=function fetchCycles(){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var cyclesResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;dispatch(fetchOptionsCallBegin());_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["b" /* getCycleDataFromParent */])();case 4:cyclesResponse=_context2.sent;dispatch(fetchCyclesCallSuccess(cyclesResponse));_context2.next=11;break;case 8:_context2.prev=8;_context2.t0=_context2["catch"](0);return _context2.abrupt("return",dispatch(fetchOptionsCallFailure(_context2.t0.response)));case 11:case"end":return _context2.stop();}}},_callee2,_this,[[0,8]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var fetchFilters=function fetchFilters(nodeId){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var filters;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;dispatch(fetchOptionsCallBegin());_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_StowResource__["n" /* getStowFilters */])(nodeId);case 4:filters=_context3.sent;dispatch(fetchFiltersCallSuccess(filters));_context3.next=11;break;case 8:_context3.prev=8;_context3.t0=_context3["catch"](0);return _context3.abrupt("return",dispatch(fetchOptionsCallFailure(_context3.t0.response)));case 11:case"end":return _context3.stop();}}},_callee3,_this,[[0,8]]);}));return function(_x3){return _ref3.apply(this,arguments);};}();};var optionsButtonClicked=function optionsButtonClicked(){return{type:OPTIONS_BUTTON_CLICKED};};var optionsAddedOrChanged=function optionsAddedOrChanged(options){return{type:OPTIONS_ADDED_OR_CHANGED,options:options};};var viewChanged=function viewChanged(view){return{type:VIEW_CHANGED,view:view};};var optionRemoved=function optionRemoved(removedOption,removedOptionValue){return{type:OPTION_REMOVED,removedOption:removedOption,removedOptionValue:removedOptionValue};};var optionRemoveAll=function optionRemoveAll(){return{type:OPTION_REMOVE_ALL};};var navigationAdded=function navigationAdded(navigationOption){return{type:NAVIGATION_ADDED,navigationOption:navigationOption};};var navigationRemoved=function navigationRemoved(navigationIndex){return{type:NAVIGATION_REMOVED,navigationIndex:navigationIndex};};

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAtRiskAislesMetrics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getNodeResourceData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getStowPackageMetrics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getStowRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getStowBinMetrics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getStowBinMetricsForStowV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getStowBagMetrics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getStowCartMetrics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getStowAssociateMetrics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getStowFloorMetrics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getStowBins; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getStowCarts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getStowFloors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getStowAssociates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getStowAssociateScanMetrics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getStowFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCPTList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPackages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MetricUtility__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(7);
var _this=this;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="SCC_STOW";var getAtRiskAislesMetrics=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(request){var metricName,args,startTime,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:metricName="getStowOverviewMetrics";args=getAPIGatewayPostRequest(request,"svs/aislesHeatMap/metrics");startTime=Date.now();_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context.sent;if(!(response.status===200)){_context.next=9;break;}Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context.abrupt("return",transformAtRiskAislesMetrics(response.data.groupedAisleMetrics));case 9:Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 10:case"end":return _context.stop();}}},_callee,this);}));return function getAtRiskAislesMetrics(_x){return _ref.apply(this,arguments);};}();var getNodeResourceData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(request){var metricName,args,startTime,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:metricName="getNodeResourceData";args=getAPIGatewayPostRequest(request,"svs/nodeResource/data");startTime=Date.now();_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context2.sent;if(!(response.status===200)){_context2.next=9;break;}Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context2.abrupt("return",transformNodeResourceMetrics(response.data.nodeResourceList,response.data.nodeResourceType));case 9:Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 10:case"end":return _context2.stop();}}},_callee2,this);}));return function getNodeResourceData(_x2){return _ref2.apply(this,arguments);};}();var getStowPackageMetrics=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(request){var metricName,args,startTime,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:metricName="getStowPackageMetrics";args=getAPIGatewayPostRequest(request,"svs/packages/metrics");startTime=Date.now();_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context3.sent;if(!(response.status===200)){_context3.next=9;break;}Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context3.abrupt("return",transformStowPackageMetrics(response.data.packageMetricsGroupList,response.data.aggregatePackageMetrics));case 9:Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 10:case"end":return _context3.stop();}}},_callee3,this);}));return function getStowPackageMetrics(_x3){return _ref3.apply(this,arguments);};}();var getStowRoutes=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(request){var metricName,args,startTime,response,transformStowRoutes;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:transformStowRoutes=function transformStowRoutes(routes){var routesMap={};routes.forEach(function(route){return routesMap[route.id]={routeCode:route.code,plannedPackages:route.plannedCount};});return routesMap;};metricName="getStowRoutes";args=getAPIGatewayPostRequest(request,"svs/routes/data");startTime=Date.now();_context4.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 6:response=_context4.sent;if(!(response.status===200)){_context4.next=10;break;}Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context4.abrupt("return",transformStowRoutes(response.data.routes));case 10:Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 11:case"end":return _context4.stop();}}},_callee4,this);}));return function getStowRoutes(_x4){return _ref4.apply(this,arguments);};}();var getStowBinMetrics=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(request){var metricName,args,startTime,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:metricName="getStowBinMetrics";args=getAPIGatewayPostRequest(request,"svs/bins/metrics");startTime=Date.now();_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context5.sent;if(!(response.status===200)){_context5.next=9;break;}Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context5.abrupt("return",transformStowBinMetrics(response.data.groupedBinMetrics));case 9:Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 10:case"end":return _context5.stop();}}},_callee5,this);}));return function getStowBinMetrics(_x5){return _ref5.apply(this,arguments);};}();var getStowBinMetricsForStowV2=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(request){var metricName,args,startTime,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:metricName="getStowBinMetrics";args=getAPIGatewayPostRequest(request,"svs/bins/metrics");startTime=Date.now();_context6.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context6.sent;if(!(response.status===200)){_context6.next=9;break;}Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context6.abrupt("return",transformStowBinMetricsForStowV2(response.data.groupedBinMetrics));case 9:Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 10:case"end":return _context6.stop();}}},_callee6,this);}));return function getStowBinMetricsForStowV2(_x6){return _ref6.apply(this,arguments);};}();var getStowBagMetrics=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(request){var metricName,args,startTime,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:metricName="getStowBagMetrics";args=getAPIGatewayPostRequest(request,"svs/bags/metrics");startTime=Date.now();_context7.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context7.sent;if(!(response.status===200)){_context7.next=9;break;}Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context7.abrupt("return",transformStowBagMetrics(response.data.groupedBagMetrics));case 9:Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 10:case"end":return _context7.stop();}}},_callee7,this);}));return function getStowBagMetrics(_x7){return _ref7.apply(this,arguments);};}();var getStowCartMetrics=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(request){var metricName,args,startTime,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:metricName="getStowCartMetrics";args=getAPIGatewayPostRequest(request,"svs/carts/metrics");startTime=Date.now();_context8.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context8.sent;if(!(response.status===200)){_context8.next=9;break;}Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context8.abrupt("return",transformStowCartMetrics(response.data.groupedCartMetrics));case 9:Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 10:case"end":return _context8.stop();}}},_callee8,this);}));return function getStowCartMetrics(_x8){return _ref8.apply(this,arguments);};}();var getStowAssociateMetrics=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(request){var metricName,args,startTime,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:metricName="getStowAssociateMetrics";args=getAPIGatewayPostRequest(request,"svs/associates/metrics");startTime=Date.now();_context9.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context9.sent;if(!(response.status===200)){_context9.next=9;break;}Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context9.abrupt("return",transformStowAssociateMetrics(response.data.associateMetricsGroupList));case 9:Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 10:case"end":return _context9.stop();}}},_callee9,this);}));return function getStowAssociateMetrics(_x9){return _ref9.apply(this,arguments);};}();var getStowFloorMetrics=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(request){var args,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:args=getAPIGatewayPostRequest(request,"svs/floors/metrics");_context10.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 3:response=_context10.sent;if(!(response.status===200)){_context10.next=6;break;}return _context10.abrupt("return",transformStowFloorMetricsGroupMap(response.data.floorMetricsGroupList));case 6:case"end":return _context10.stop();}}},_callee10,this);}));return function getStowFloorMetrics(_x10){return _ref10.apply(this,arguments);};}();var getStowBins=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(request){var metricName,args,startTime,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:metricName="getStowBins";args=getAPIGatewayPostRequest(request,"svs/bins/data");startTime=Date.now();_context11.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context11.sent;if(!(response.status===200)){_context11.next=9;break;}Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context11.abrupt("return",transformBins(response.data.bins));case 9:Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 10:case"end":return _context11.stop();}}},_callee11,this);}));return function getStowBins(_x11){return _ref11.apply(this,arguments);};}();var getStowCarts=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(request){var args,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:args=getAPIGatewayPostRequest(request,"svs/carts/data");_context12.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 3:response=_context12.sent;if(!(response.status===200)){_context12.next=6;break;}return _context12.abrupt("return",transformCarts(response.data.carts));case 6:case"end":return _context12.stop();}}},_callee12,this);}));return function getStowCarts(_x12){return _ref12.apply(this,arguments);};}();var getStowFloors=function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(request){var args,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:args=getAPIGatewayPostRequest(request,"svs/floors/data");_context13.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 3:response=_context13.sent;if(!(response.status===200)){_context13.next=6;break;}return _context13.abrupt("return",transformFloors(response.data.floors));case 6:case"end":return _context13.stop();}}},_callee13,this);}));return function getStowFloors(_x13){return _ref13.apply(this,arguments);};}();var getStowAssociates=function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(request){var metricName,args,capability,startTime,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:metricName="getStowAssociates";args=getAPIGatewayPostRequest(request,"svs/associates/data");_context14.next=4;return getNodeCapability();case 4:capability=_context14.sent;startTime=Date.now();_context14.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 8:response=_context14.sent;if(!(response.status===200)){_context14.next=12;break;}Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context14.abrupt("return",transformAssociatesList(response.data.associates,capability));case 12:Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context14.stop();}}},_callee14,this);}));return function getStowAssociates(_x14){return _ref14.apply(this,arguments);};}();var getStowAssociateScanMetrics=function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(request){var metricName,args,startTime,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:metricName="getStowAssociateScanMetrics";args=getAPIGatewayPostRequest(request,"svs/associates/scanMetrics");startTime=Date.now();_context15.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context15.sent;if(!(response.status===200)){_context15.next=9;break;}Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context15.abrupt("return",response.data);case 9:Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 10:case"end":return _context15.stop();}}},_callee15,this);}));return function getStowAssociateScanMetrics(_x15){return _ref15.apply(this,arguments);};}();var getNodeCapability=function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(){var capabilityResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["g" /* getNodeCapabilityFromParent */])();case 2:capabilityResponse=_context16.sent;return _context16.abrupt("return",JSON.parse(capabilityResponse.capability));case 4:case"end":return _context16.stop();}}},_callee16,_this);}));return function getNodeCapability(){return _ref16.apply(this,arguments);};}();var getStowFilters=function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(nodeId){var metricName,args,startTime,response,capability;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:metricName="getStowFilters";args=getAPIGatewayGetRequest({nodeId:[nodeId]},"svs/getFiltersForStow");startTime=Date.now();_context17.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context17.sent;_context17.next=8;return getNodeCapability();case 8:capability=_context17.sent;if(!(response.status===200)){_context17.next=12;break;}Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context17.abrupt("return",transformStowFilters(response.data.filterMap,capability));case 12:Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context17.stop();}}},_callee17,this);}));return function getStowFilters(_x16){return _ref17.apply(this,arguments);};}();function getCPTDataAPIGatewayRequest(request){return{resourcePath:"/svs/getStationCPTs",httpMethod:"post",processName:"stow",requestBody:request};}var getCPTList=function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(nodeId){var request,metricName,args,startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:request={nodeId:[nodeId]};metricName="getCPTList";args=getCPTDataAPIGatewayRequest(request);startTime=Date.now();Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args).then(function(result){if(result.status===200){Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);var output=result.data;var data=JSON.parse(output.CPTList);return{CPTList:data,CPTLabel:output.CPTTypeLabelKey,filterIdentifier:output.filterIdentifier};}});case 5:case"end":return _context18.stop();}}},_callee18,this);}));return function getCPTList(_x17){return _ref18.apply(this,arguments);};}();var getPackages=function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(request){var metricName,args,startTime,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:metricName="getStowPackages";args=getAPIGatewayPostRequest(request,"svs/packages/data");startTime=Date.now();_context19.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context19.sent;if(!(response.status===200)){_context19.next=9;break;}Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context19.abrupt("return",transformPackages(response.data.packages));case 9:Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 10:case"end":return _context19.stop();}}},_callee19,this);}));return function getPackages(_x18){return _ref19.apply(this,arguments);};}();function getAPIGatewayPostRequest(request,resourcePath){return{resourcePath:resourcePath,httpMethod:"post",processName:"stow",requestBody:request};}function getAPIGatewayGetRequest(request,resourcePath){return{resourcePath:resourcePath,httpMethod:"get",processName:"stow",requestParams:request};}function transformAssociatesList(associates,capability){return associates.map(function(associate){return{alias:associate.alias,name:associate.name,active:isAssociateActive(associate.status),location:associate.location,cluster:getCluster(associate.location,capability),pph:associate.performance.pph===-1?'-':associate.performance.pph,fsaf:associate.performance.fsaf,fsafDpmo:associate.performance.fsafDpmo,stowedPackages:associate.performance.stowedCount,stowedBufferedPackages:associate.performance.stowBufferedCount,minutesWorked:associate.performance.minutesWorked};});}function getCluster(location,capability){if(__WEBPACK_IMPORTED_MODULE_5__enums__["e" /* Capability */].AMZL===capability){return Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["h" /* getClusterForAisle */])(location);}else if(__WEBPACK_IMPORTED_MODULE_5__enums__["e" /* Capability */].SSD===capability){return Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["s" /* getZoneForCartLocation */])(location);}}function transformBags(bags){return bags.map(function(bag){return{bagLabel:bag.label,state:bag.open?"Open":"Closed",childCount:bag.childCount};});}function transformBins(bins){return bins.map(function(bin){return{binLabel:bin.binLabel,bags:transformBags(bin.bags),ovUsage:bin.ovUsage.toFixed(2)};});}function transformCart(cart){return{readiness:(cart.readiness*100).toFixed(2),status:cart.status,childCount:cart.childCount,label:cart.label,type:cart.type,packageCount:cart.packageCount,bins:cart.bins&&transformBins(cart.bins)};}function transformCarts(carts){return carts.map(function(cart){return transformCart(cart);});}function transformFloors(floors){var floorEntries=floors.map(function(floor){return _defineProperty({},floor.label,{routeCode:floor.routeCode,routeId:floor.routeId,cart:floor.cart&&transformCart(floor.cart)});});return Object.assign.apply(Object,[{}].concat(_toConsumableArray(floorEntries)));}function transformPackages(packages){return packages.map(function(packageObject){return{trackingId:packageObject.trackingId,lastScan:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["l" /* getFormattedTimeFromEpoch */])(packageObject.localLastScanTime*1000),minutesInState:packageObject.minutesInState,state:packageObject.state,reason:packageObject.reason,location:packageObject.sortLocation.location,associateId:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["f" /* getAliasFromLoginId */])(packageObject.lastScanAssociateId),cycle:packageObject.cycleId,sortZone:packageObject.sortLocation.bin,cluster:packageObject.sortLocation.cluster,ead:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["l" /* getFormattedTimeFromEpoch */])(packageObject.localEstimatedArrivalDate*1000),size:packageObject.size,routeCode:packageObject.routeCode,floor:packageObject.sortLocation.floor,conveyance:packageObject.sortLocation.conveyance};});}function isAssociateActive(status){return status==="ACTIVE"?"Yes":"No";}function transformAtRiskAislesMetrics(groupedAisleMetrics){var metricsMapOutput={};for(var key in groupedAisleMetrics){if(key){metricsMapOutput[key]={associateAlias:groupedAisleMetrics[key]["activeAssociateAliases"],activeStowers:groupedAisleMetrics[key]["activeAssociateCount"],currentStowedPackages:groupedAisleMetrics[key]["currentStowedCount"],isAtRisk:groupedAisleMetrics[key]["isAtRisk"],minutesOfWork:groupedAisleMetrics[key]["minutesOfWork"],adjacencyScore:groupedAisleMetrics[key]["adjacencyScore"],baselineAdjacencyScore:groupedAisleMetrics[key]["baselineAdjacencyScore"]};}}return metricsMapOutput;}function transformNodeResourceMetrics(nodeResourceDataList,nodeResourceDataType){var nodeResourceMapOutput={};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=nodeResourceDataList[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var nodeResource=_step.value;var resource=nodeResource.nodeResourceLabel;nodeResourceMapOutput[resource]={displayLabel:resource,numberOfSortZones:nodeResource.numberOfSortZones};}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return nodeResourceMapOutput;}function transformStowPackageMetrics(packageMetricsGroupList,aggregatePackageMetrics){var metricsMapOutput={};var _loop=function _loop(packageMetricsGroup){metricsMapOutput[packageMetricsGroup.id]={displayLabel:packageMetricsGroup.displayLabel,plannedPackages:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return packageMetricsGroup.packageMetrics.plannedCount;},null),stowedPackages:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return packageMetricsGroup.packageMetrics.stowedCount;},null),currentInductedPackages:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return packageMetricsGroup.packageMetrics.currentInductedCount;},null),currentStowedPackages:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return packageMetricsGroup.packageMetrics.currentStowedCount;},null),currentStowBufferedPackages:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return packageMetricsGroup.packageMetrics.currentStowBufferedCount;},undefined),currentMFRJackpotBufferedPackages:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return packageMetricsGroup.packageMetrics.currentMFRJackpotBufferedCount;},undefined),problemSolvePackages:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return packageMetricsGroup.packageMetrics.problemSolveCount;},null),minutesOfWork:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return packageMetricsGroup.packageMetrics.minutesOfWork===0&&packageMetricsGroup.packageMetrics.currentInductedCount!==0?'-':packageMetricsGroup.packageMetrics.minutesOfWork;},null),stowRate:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return packageMetricsGroup.packageMetrics.stowRate;},null),lastFifteenMinuteStowRate:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return packageMetricsGroup.packageMetrics.lastFifteenMinuteStowRate;},null),stowVsPlan:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return packageMetricsGroup.packageMetrics.stowVsPlan.toFixed(2);},null),scanCompliance:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return packageMetricsGroup.packageMetrics.scanCompliance.toFixed(2);},null),currentScanCompliance:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return packageMetricsGroup.packageMetrics.currentScanCompliance.toFixed(2);},null),fsaf:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return packageMetricsGroup.packageMetrics.fsaf;},null)};};var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=packageMetricsGroupList[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var packageMetricsGroup=_step2.value;_loop(packageMetricsGroup);}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}metricsMapOutput['Total']={displayLabel:'Total',plannedPackages:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return aggregatePackageMetrics.plannedCount;},null),stowedPackages:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return aggregatePackageMetrics.stowedCount;},null),currentInductedPackages:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return aggregatePackageMetrics.currentInductedCount;},null),currentStowBufferedPackages:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return aggregatePackageMetrics.currentStowBufferedCount;},undefined),currentMFRJackpotBufferedPackages:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return aggregatePackageMetrics.currentMFRJackpotBufferedCount;},undefined),currentStowedPackages:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return aggregatePackageMetrics.currentStowedCount;},null),problemSolvePackages:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return aggregatePackageMetrics.problemSolveCount;},null),minutesOfWork:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return aggregatePackageMetrics.minutesOfWork===0&&aggregatePackageMetrics.currentInductedCount!==0?'-':aggregatePackageMetrics.minutesOfWork;},null),stowRate:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return aggregatePackageMetrics.stowRate;},null),lastFifteenMinuteStowRate:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return aggregatePackageMetrics.lastFifteenMinuteStowRate;},null),stowVsPlan:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return aggregatePackageMetrics.stowVsPlan.toFixed(2);},null),scanCompliance:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return aggregatePackageMetrics.scanCompliance.toFixed(2);},null),currentScanCompliance:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return aggregatePackageMetrics.currentScanCompliance.toFixed(2);},null),fsaf:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return aggregatePackageMetrics.fsaf;},null)};return metricsMapOutput;}function transformStowBinMetrics(metricsMapInput){var metricsMapOutput={};for(var key in metricsMapInput){metricsMapOutput[key]={binsMissingBag:metricsMapInput[key].binsCountMissingOpenBag};}return metricsMapOutput;}function transformStowBinMetricsForStowV2(metricsMapInput){var metricsMapOutput={};for(var key in metricsMapInput){metricsMapOutput[key]={binsMissingBag:metricsMapInput[key].activeBinsCount};}return metricsMapOutput;}function transformStowBagMetrics(metricsMapInput){var metricsMapOutput={};for(var key in metricsMapInput){metricsMapOutput[key]={plannedBags:metricsMapInput[key].plannedBagCount,closedBags:metricsMapInput[key].closedBagCount,openBags:metricsMapInput[key].openBagCount,usedBags:metricsMapInput[key].usedBagCount};}return metricsMapOutput;}function transformStowCartMetrics(metricsMapInput){var metricsMapOutput={};for(var key in metricsMapInput){metricsMapOutput[key]={plannedCarts:metricsMapInput[key].plannedCartCount,usedCarts:metricsMapInput[key].openCartCount,missingCarts:metricsMapInput[key].missingCartCount};}return metricsMapOutput;}function transformStowAssociateMetrics(associateMetricsGroupList){var metricsMapOutput={};var _loop2=function _loop2(associateMetricsGroup){metricsMapOutput[associateMetricsGroup.id]={displayLabel:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return associateMetricsGroup.displayLabel;},null),activeStowers:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return associateMetricsGroup.associateMetrics.activeCount;},null),inactiveStowers:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return associateMetricsGroup.associateMetrics.inactiveCount;},null)};};var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=associateMetricsGroupList[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var associateMetricsGroup=_step3.value;_loop2(associateMetricsGroup);}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}return metricsMapOutput;}function transformStowFilters(filterMap,capability){var resourceMap={};var resource=void 0;if(__WEBPACK_IMPORTED_MODULE_5__enums__["e" /* Capability */].SSD===capability){resource=__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].CART_LOCATION;resourceMap=getZoneToCartLocationMap(filterMap);}else{resource=__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].AISLE;resourceMap=getClusterToAisleMap(filterMap);}return{clusterAislesMap:resourceMap,allAisles:filterMap[resource],allClusters:Object.keys(resourceMap)};}var getClusterToAisleMap=function getClusterToAisleMap(filterMap){var clusterAislesMap={};filterMap[__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].AISLE].forEach(function(aisle){var cluster=Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["h" /* getClusterForAisle */])(aisle);if(!cluster||cluster==="Total"){filterMap[__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].AISLE]=filterMap[__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].AISLE].filter(function(ele){return ele!==aisle;});return;}if(!clusterAislesMap[cluster]){clusterAislesMap[cluster]=[];}clusterAislesMap[cluster].push(aisle);});return clusterAislesMap;};var getZoneToCartLocationMap=function getZoneToCartLocationMap(filterMap){var zoneToCartLocationMap={};filterMap[__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].CART_LOCATION].forEach(function(cartLocation){var zoneLabel=Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["s" /* getZoneForCartLocation */])(cartLocation);if(filterMap[__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].ZONE].includes(zoneLabel)){if(!zoneToCartLocationMap[zoneLabel]){zoneToCartLocationMap[zoneLabel]=[];}zoneToCartLocationMap[zoneLabel].push(cartLocation);}});return zoneToCartLocationMap;};function transformStowFloorMetricsGroupMap(floorMetricsGroupList){var floorMetricsGroupEntries=floorMetricsGroupList.map(function(floorMetricsGroup){return _defineProperty({},floorMetricsGroup.id,transformStowFloorMetricsGroup(floorMetricsGroup));});return Object.assign.apply(Object,[{}].concat(_toConsumableArray(floorMetricsGroupEntries)));}function transformStowFloorMetricsGroup(floorMetricsGroup){return{displayLabel:floorMetricsGroup.displayLabel,floorMetrics:transformStowFloorMetrics(floorMetricsGroup.floorMetrics)};}function transformStowFloorMetrics(floorMetrics){return{floorsCountMissingCart:floorMetrics.floorsCountMissingCart,attachedCartCount:floorMetrics.attachedCartCount};}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _link = _interopRequireDefault(__webpack_require__(570));

var _default = _link["default"];
exports["default"] = _default;

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_context_DeviceLayoutContext__ = __webpack_require__(41);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/**
 * React component for getting the last refresh time in a page
 * @param deps
 * @param locale
 * @return JSX.Element
 */var RefreshTimer=function RefreshTimer(_ref){var deps=_ref.deps,intl=_ref.intl;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),latestRefreshTime=_useState2[0],setRefreshTime=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setRefreshTime(Object(__WEBPACK_IMPORTED_MODULE_4__Utility__["i" /* getCurrentFormattedTime */])(intl.locale));},deps);var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_5__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),isMobile=_useDeviceLayout.isMobile;var headerType=isMobile?"b100":"b200";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a,{type:headerType},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:"common.data_last_updated",defaultMessage:"Data last updated"}),": ",latestRefreshTime);};RefreshTimer.propTypes={deps:__WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].array,locale:__WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(RefreshTimer));

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _loader = _interopRequireDefault(__webpack_require__(358));

var _default = _loader["default"];
exports["default"] = _default;

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_alert__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ErrorPage=function(_Component){_inherits(ErrorPage,_Component);function ErrorPage(){_classCallCheck(this,ErrorPage);return _possibleConstructorReturn(this,(ErrorPage.__proto__||Object.getPrototypeOf(ErrorPage)).apply(this,arguments));}_createClass(ErrorPage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_alert___default.a,{type:"error",size:"takeover"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:this.props.errorId,defaultMessage:this.props.errorMessage}));}}]);return ErrorPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (ErrorPage);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return publishCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return publishTime; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility__ = __webpack_require__(10);
var publishCount=function publishCount(processName,metricName){var request=getMetricPublishRequest(processName,metricName,1,__WEBPACK_IMPORTED_MODULE_0__enums__["r" /* metricType */].COUNT);Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["i" /* publishClientSideMetrics */])(request);publishNodeLevelMetrics(request);};var publishTime=function publishTime(processName,metricName,startTime){var metricValue=Date.now()-startTime;var request=getMetricPublishRequest(processName,metricName,metricValue,__WEBPACK_IMPORTED_MODULE_0__enums__["r" /* metricType */].TIME);Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["i" /* publishClientSideMetrics */])(request);publishNodeLevelMetrics(request);};var getMetricPublishRequest=function getMetricPublishRequest(processName,metricName,metricValue,metricType){return{processName:processName,metricName:metricName,metricValue:metricValue,metricType:metricType};};var publishNodeLevelMetrics=function publishNodeLevelMetrics(request){var nodeId=Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["m" /* getNodeId */])();var nodeRequest=Object.assign({},request,{processName:request.processName+'_'+nodeId});Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["i" /* publishClientSideMetrics */])(nodeRequest);};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _icon = _interopRequireDefault(__webpack_require__(406));

var _default = _icon["default"];
exports["default"] = _default;

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLocale; });
/* harmony export (immutable) */ __webpack_exports__["a"] = getDirection;
/* harmony export (immutable) */ __webpack_exports__["c"] = getMessages;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__il8n_locales_en_json__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__il8n_locales_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__il8n_locales_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__il8n_locales_es_json__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__il8n_locales_es_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__il8n_locales_es_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__il8n_locales_fr_json__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__il8n_locales_fr_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__il8n_locales_fr_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__il8n_locales_it_json__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__il8n_locales_it_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__il8n_locales_it_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__il8n_locales_ja_json__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__il8n_locales_ja_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__il8n_locales_ja_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__il8n_locales_de_json__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__il8n_locales_de_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__il8n_locales_de_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__il8n_locales_ar_json__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__il8n_locales_ar_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__il8n_locales_ar_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__il8n_locales_tr_json__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__il8n_locales_tr_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__il8n_locales_tr_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ParentDataHandler__ = __webpack_require__(24);
var fetchLocale=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var localeResponse,locale;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10__ParentDataHandler__["f" /* getLocaleFromParent */])();case 2:localeResponse=_context2.sent;if(!(__WEBPACK_IMPORTED_MODULE_9__constants__["v" /* TIMEOUT_STRING */]===localeResponse)){_context2.next=5;break;}return _context2.abrupt('return',navigator.language);case 5:locale=JSON.parse(localeResponse.locale);if(!(__WEBPACK_IMPORTED_MODULE_9__constants__["g" /* EMPTY_STRING */]===locale)){_context2.next=8;break;}return _context2.abrupt('return',navigator.language);case 8:return _context2.abrupt('return',locale);case 9:case'end':return _context2.stop();}}},_callee2,this);}));return function fetchLocale(){return _ref2.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getLocale=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var locale;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return fetchLocale();case 2:locale=_context.sent;_context.t0=locale;_context.next=_context.t0==="de"?6:_context.t0==="de-DE"?6:_context.t0==="de-CH"?6:_context.t0==="de-AT"?6:_context.t0==="de-LU"?6:_context.t0==="de-LI"?6:_context.t0==="es"?7:_context.t0==="es-ES"?7:_context.t0==="es-AR"?7:_context.t0==="es-GT"?7:_context.t0==="es-CR"?7:_context.t0==="es-PA"?7:_context.t0==="es-DO"?7:_context.t0==="es-MX"?7:_context.t0==="es-VE"?7:_context.t0==="es-CO"?7:_context.t0==="es-PE"?7:_context.t0==="es-EC"?7:_context.t0==="es-CL"?7:_context.t0==="es-UY"?7:_context.t0==="es-PY"?7:_context.t0==="es-BO"?7:_context.t0==="es-SV"?7:_context.t0==="es-HN"?7:_context.t0==="es-NI"?7:_context.t0==="es-PR"?7:_context.t0==="ja"?8:_context.t0==="ja-JP"?8:_context.t0==="it"?9:_context.t0==="it-IT"?9:_context.t0==="it-CH"?9:_context.t0==="fr"?10:_context.t0==="fr-FR"?10:_context.t0==="fr-BE"?10:_context.t0==="fr-CA"?10:_context.t0==="fr-CH"?10:_context.t0==="fr-LU"?10:_context.t0==="ar"?11:_context.t0==="ar-SA"?11:_context.t0==="ar-IQ"?11:_context.t0==="ar-EG"?11:_context.t0==="ar-LY"?11:_context.t0==="ar-DZ"?11:_context.t0==="ar-MA"?11:_context.t0==="ar-TN"?11:_context.t0==="ar-OM"?11:_context.t0==="ar-YE"?11:_context.t0==="ar-SY"?11:_context.t0==="ar-JO"?11:_context.t0==="ar-LB"?11:_context.t0==="ar-KW"?11:_context.t0==="ar-AE"?11:_context.t0==="ar-BH"?11:_context.t0==="ar-QA"?11:_context.t0==="tr"?12:_context.t0==="tr-TR"?12:13;break;case 6:return _context.abrupt('return',"de");case 7:return _context.abrupt('return',"es");case 8:return _context.abrupt('return',"ja");case 9:return _context.abrupt('return',"it");case 10:return _context.abrupt('return',"fr");case 11:return _context.abrupt('return',"ar");case 12:return _context.abrupt('return',"tr");case 13:return _context.abrupt('return',"en");case 14:case'end':return _context.stop();}}},_callee,this);}));return function getLocale(){return _ref.apply(this,arguments);};}();function getDirection(locale){return locale==="ar"?"rtl":"ltr";}function getMessages(locale){switch(locale){case"en":return __WEBPACK_IMPORTED_MODULE_1__il8n_locales_en_json___default.a;case"es":return __WEBPACK_IMPORTED_MODULE_2__il8n_locales_es_json___default.a;case"fr":return __WEBPACK_IMPORTED_MODULE_3__il8n_locales_fr_json___default.a;case"it":return __WEBPACK_IMPORTED_MODULE_4__il8n_locales_it_json___default.a;case"ja":return __WEBPACK_IMPORTED_MODULE_5__il8n_locales_ja_json___default.a;case"de":return __WEBPACK_IMPORTED_MODULE_6__il8n_locales_de_json___default.a;case"ar":return __WEBPACK_IMPORTED_MODULE_7__il8n_locales_ar_json___default.a;case"tr":return __WEBPACK_IMPORTED_MODULE_8__il8n_locales_tr_json___default.a;default:return __WEBPACK_IMPORTED_MODULE_1__il8n_locales_en_json___default.a;}}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _useFocus = _interopRequireDefault(__webpack_require__(382));

var _default = _useFocus["default"];
exports["default"] = _default;

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useDeviceLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeviceLayoutProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_ResponsiveProps_js__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_responsive__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_responsive__);
/*
This acts as common context, and it will provide context related to device info and layout
Currently It is using Responsive Component from Meridian library to decide the applicable properties.
*/var DeviceLayoutContext=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();var useDeviceLayout=function useDeviceLayout(){return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(DeviceLayoutContext);};var DeviceLayoutProvider=function DeviceLayoutProvider(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_responsive___default.a,{query:"max-width",props:__WEBPACK_IMPORTED_MODULE_1__constant_ResponsiveProps_js__["a" /* responsiveProps */]},function(_ref2){var isMobile=_ref2.isMobile,spacingInset_shorthand2=_ref2.spacingInset_shorthand2,spacingInset_shorthand3=_ref2.spacingInset_shorthand3,spacingInset_shorthand4=_ref2.spacingInset_shorthand4,spacingInset_shorthand5=_ref2.spacingInset_shorthand5,spacingInset_shorthand6=_ref2.spacingInset_shorthand6;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DeviceLayoutContext.Provider,{value:{isMobile:isMobile,spacingInset_shorthand2:spacingInset_shorthand2,spacingInset_shorthand3:spacingInset_shorthand3,spacingInset_shorthand4:spacingInset_shorthand4,spacingInset_shorthand5:spacingInset_shorthand5,spacingInset_shorthand6:spacingInset_shorthand6}},children);});};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _focusRing = _interopRequireDefault(__webpack_require__(219));

var _elevation = __webpack_require__(59);

var _token = __webpack_require__(12);

var _borderRadius = _interopRequireDefault(__webpack_require__(100));

var _rtl = __webpack_require__(52);

/**
 * Styles for our focus ring. Apply these to the focuseable element.
 *
 * NOTE: This applies "position: relative" to the focuseable element in order to
 * position the ring absolutely. This method will not work on elements without
 * a box (e.g. a link that wraps across lines, or an element with display set to
 * "content").
 */
var focusRing = function focusRing(themeTokens, _ref) {
  var _ref2, _ref3;

  var focus = _ref.focus,
      error = _ref.error,
      dropShadow = _ref.dropShadow,
      gapColor = _ref.gapColor,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset,
      _ref$borderWidth = _ref.borderWidth,
      borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 0 : _ref$borderRadius,
      _ref$hoverSelector = _ref.hoverSelector,
      hoverSelector = _ref$hoverSelector === void 0 ? "&:hover" : _ref$hoverSelector,
      _ref$borderSides = _ref.borderSides,
      borderSides = _ref$borderSides === void 0 ? [] : _ref$borderSides;
  var tokens = (0, _focusRing["default"])(themeTokens);
  var state = focus ? "focus" : error ? "error" : undefined;
  var width = (0, _token.getToken)(tokens, "focusRingWidth");
  var color = (0, _token.getToken)(tokens, "focusRingColor", state);
  var dropShadowCss = dropShadow === true ? "".concat((0, _token.getToken)(tokens, "focusRingDropShadowOffsetX"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowOffsetY"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowBlur"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowSpread"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowColor")) : dropShadow; // If we're supposed to fill in the gap between the focus ring and the
  // element then use an inset box shadow.

  var gapShadowCss = color && gapColor ? "inset 0 0 0 ".concat(offset - width, "px ").concat(gapColor) : undefined;
  var dropShadowAndGapShadowCss = dropShadowCss && gapShadowCss ? "".concat(dropShadowCss, ", ").concat(gapShadowCss) : dropShadowCss || gapShadowCss;
  return _ref3 = {
    // The focuseable element needs to be relatively positioned so that we can
    // absolutely position the focus ring
    position: "relative",
    // If the ring entirely overlaps the focused element's border, turn the
    // element's border off to avoid artifacts near the rounded corners
    borderColor: color && offset >= 0 && width - offset >= borderWidth ? "transparent" : undefined
  }, (0, _defineProperty2["default"])(_ref3, hoverSelector, dropShadowCss && !color ? {
    boxShadow: dropShadowCss
  } : undefined), (0, _defineProperty2["default"])(_ref3, hoverSelector.split(",").map(function (selector) {
    return "".concat(selector.trim(), ":after");
  }).join(", "), dropShadowCss && state === "error" ? {
    boxShadow: dropShadowAndGapShadowCss
  } : undefined), (0, _defineProperty2["default"])(_ref3, "zIndex", focus ? _elevation.elevationForeground : error ? _elevation.elevationMidground : _elevation.elevationBackground), (0, _defineProperty2["default"])(_ref3, "&:after", color ? (_ref2 = {
    content: "''",
    pointerEvents: "none",
    position: "absolute",
    top: -offset - borderWidth,
    right: -offset - borderWidth,
    bottom: -offset - borderWidth,
    left: -offset - borderWidth,
    border: "".concat(width, "px solid ").concat(color),
    borderRadius: borderSides.length > 0 ? (0, _borderRadius["default"])(borderRadius, borderSides) : typeof borderRadius === "string" ? borderRadius.split(" ").map(function (radius) {
      var r = parseInt(radius);
      return r > 0 ? "".concat(parseInt(radius) + offset, "px") : "0";
    }).join(" ") : borderRadius > 0 ? borderRadius + offset : 0
  }, (0, _defineProperty2["default"])(_ref2, "[dir=\"rtl\"] &", {
    borderRadius: borderSides.length > 0 ? (0, _borderRadius["default"])(borderRadius, borderSides.map(function (borderSide) {
      return (0, _rtl.getRtl)(borderSide);
    })) : borderRadius
  }), (0, _defineProperty2["default"])(_ref2, "boxShadow", state === "focus" ? dropShadowAndGapShadowCss : gapShadowCss), _ref2) : undefined), _ref3;
};

var _default = focusRing;
exports["default"] = _default;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _row = _interopRequireDefault(__webpack_require__(484));

var _default = _row["default"];
exports["default"] = _default;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _text = _interopRequireDefault(__webpack_require__(555));

var _default = _text["default"];
exports["default"] = _default;

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return OPTIONS_ADDED_OR_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return VIEW_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return OPTION_REMOVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return OPTION_REMOVE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return OPTIONS_BUTTON_CLICKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_OPTIONS_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_CAPABILITY_CALL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_CYCLES_CALL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CPT_ADDED_OR_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_CPT_CALL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_FILTERS_CALL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_OPTIONS_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NAVIGATION_ADDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NAVIGATION_REMOVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ASSIGN_CPT_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ASSIGN_FILTER_IDENTIFIER; });
/* unused harmony export fetchOptionsCallBegin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return fetchCapabilityCallSuccess; });
/* unused harmony export fetchCyclesCallSuccess */
/* unused harmony export fetchCPTCallSuccess */
/* unused harmony export assignCPTLabel */
/* unused harmony export assignFilterIdentifier */
/* unused harmony export fetchFiltersCallSuccess */
/* unused harmony export fetchOptionsCallFailure */
/* unused harmony export fetchCapability */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return fetchCycles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return fetchCPTList; });
/* unused harmony export fetchFilters */
/* unused harmony export optionsButtonClicked */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return optionsAddedOrChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CPTAddedOrChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return viewChanged; });
/* unused harmony export optionRemoved */
/* unused harmony export optionRemoveAll */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return navigationAdded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return navigationRemoved; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_StowResource__ = __webpack_require__(31);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var OPTIONS_ADDED_OR_CHANGED="OPTIONS_ADDED_OR_CHANGED";var VIEW_CHANGED="VIEW_CHANGED";var OPTION_REMOVED="OPTION_REMOVED";var OPTION_REMOVE_ALL="OPTION_REMOVE_ALL";var OPTIONS_BUTTON_CLICKED="OPTIONS_BUTTON_CLICKED";var FETCH_OPTIONS_CALL_BEGIN="FETCH_OPTIONS_CALL_BEGIN";var FETCH_CAPABILITY_CALL_SUCCESS="FETCH_CAPABILITY_CALL_SUCCESS";var FETCH_CYCLES_CALL_SUCCESS="FETCH_CYCLES_CALL_SUCCESS";var CPT_ADDED_OR_CHANGED="CPT_ADDED_OR_CHANGED";var FETCH_CPT_CALL_SUCCESS="FETCH_CPT_CALL_SUCCESS";var FETCH_FILTERS_CALL_SUCCESS="FETCH_FILTERS_CALL_SUCCESS";var FETCH_OPTIONS_CALL_FAILURE="FETCH_OPTIONS_CALL_FAILURE";var NAVIGATION_ADDED="NAVIGATION_ADDED";var NAVIGATION_REMOVED="NAVIGATION_REMOVED";var ASSIGN_CPT_LABEL="ASSIGN_CPT_LABEL";var ASSIGN_FILTER_IDENTIFIER="ASSIGN_FILTER_IDENTIFIER";/**
 * Fetch Options call begin.
 */var fetchOptionsCallBegin=function fetchOptionsCallBegin(){return{type:FETCH_OPTIONS_CALL_BEGIN};};/**
 * Fetch Capability call success.
 */var fetchCapabilityCallSuccess=function fetchCapabilityCallSuccess(capabilityResponse){return{type:FETCH_CAPABILITY_CALL_SUCCESS,capabilityResponse:capabilityResponse};};/**
 * Fetch Cycles call success.
 */var fetchCyclesCallSuccess=function fetchCyclesCallSuccess(cyclesResponse){return{type:FETCH_CYCLES_CALL_SUCCESS,cyclesResponse:cyclesResponse};};/**
 * Fetch CPT call success.
 */var fetchCPTCallSuccess=function fetchCPTCallSuccess(CPTResponse){return{type:FETCH_CPT_CALL_SUCCESS,CPTList:CPTResponse};};var assignCPTLabel=function assignCPTLabel(CPTResponse){return{type:ASSIGN_CPT_LABEL,CPTLabel:CPTResponse};};var assignFilterIdentifier=function assignFilterIdentifier(CPTResponse){return{type:ASSIGN_FILTER_IDENTIFIER,filterIdentifier:CPTResponse};};/**
 * Fetch Filters call success.
 */var fetchFiltersCallSuccess=function fetchFiltersCallSuccess(filters){return{type:FETCH_FILTERS_CALL_SUCCESS,filters:filters};};/**
 * Fetch Options call failure
 */var fetchOptionsCallFailure=function fetchOptionsCallFailure(error){return{type:FETCH_OPTIONS_CALL_FAILURE,error:error};};var fetchCapability=function fetchCapability(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var capabilityResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(fetchOptionsCallBegin());_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["g" /* getNodeCapabilityFromParent */])();case 4:capabilityResponse=_context.sent;dispatch(fetchCapabilityCallSuccess(capabilityResponse));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context["catch"](1);return _context.abrupt("return",dispatch(fetchOptionsCallFailure(_context.t0.response)));case 11:case"end":return _context.stop();}}},_callee,_this,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var fetchCycles=function fetchCycles(){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var cyclesResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;dispatch(fetchOptionsCallBegin());_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["b" /* getCycleDataFromParent */])();case 4:cyclesResponse=_context2.sent;dispatch(fetchCyclesCallSuccess(cyclesResponse));_context2.next=11;break;case 8:_context2.prev=8;_context2.t0=_context2["catch"](0);return _context2.abrupt("return",dispatch(fetchOptionsCallFailure(_context2.t0.response)));case 11:case"end":return _context2.stop();}}},_callee2,_this,[[0,8]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var fetchCPTList=function fetchCPTList(nodeId){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var CPTResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;dispatch(fetchOptionsCallBegin());_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_StowResource__["b" /* getCPTList */])(nodeId);case 4:CPTResponse=_context3.sent;dispatch(fetchCPTCallSuccess(CPTResponse.CPTList));dispatch(assignCPTLabel(CPTResponse.CPTTypeLabelKey));dispatch(assignFilterIdentifier(CPTResponse.filterIdentifier));_context3.next=13;break;case 10:_context3.prev=10;_context3.t0=_context3["catch"](0);return _context3.abrupt("return",dispatch(fetchOptionsCallFailure(_context3.t0.response)));case 13:case"end":return _context3.stop();}}},_callee3,_this,[[0,10]]);}));return function(_x3){return _ref3.apply(this,arguments);};}();};var fetchFilters=function fetchFilters(nodeId){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var filters;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;dispatch(fetchOptionsCallBegin());_context4.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_StowResource__["n" /* getStowFilters */])(nodeId);case 4:filters=_context4.sent;dispatch(fetchFiltersCallSuccess(filters));_context4.next=11;break;case 8:_context4.prev=8;_context4.t0=_context4["catch"](0);return _context4.abrupt("return",dispatch(fetchOptionsCallFailure(_context4.t0.response)));case 11:case"end":return _context4.stop();}}},_callee4,_this,[[0,8]]);}));return function(_x4){return _ref4.apply(this,arguments);};}();};var optionsButtonClicked=function optionsButtonClicked(){return{type:OPTIONS_BUTTON_CLICKED};};var optionsAddedOrChanged=function optionsAddedOrChanged(options){return{type:OPTIONS_ADDED_OR_CHANGED,options:options};};var CPTAddedOrChanged=function CPTAddedOrChanged(options){return{type:CPT_ADDED_OR_CHANGED,options:options};};var viewChanged=function viewChanged(view){return{type:VIEW_CHANGED,view:view};};var optionRemoved=function optionRemoved(removedOption,removedOptionValue){return{type:OPTION_REMOVED,removedOption:removedOption,removedOptionValue:removedOptionValue};};var optionRemoveAll=function optionRemoveAll(){return{type:OPTION_REMOVE_ALL};};var navigationAdded=function navigationAdded(navigationOption){return{type:NAVIGATION_ADDED,navigationOption:navigationOption};};var navigationRemoved=function navigationRemoved(navigationIndex){return{type:NAVIGATION_REMOVED,navigationIndex:navigationIndex};};

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(383);

var iterableToArrayLimit = __webpack_require__(384);

var unsupportedIterableToArray = __webpack_require__(207);

var nonIterableRest = __webpack_require__(385);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _box = _interopRequireDefault(__webpack_require__(485));

var _default = _box["default"];
exports["default"] = _default;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _button = _interopRequireDefault(__webpack_require__(490));

var _default = _button["default"];
exports["default"] = _default;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(88);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRtl = exports.getHorizontalDirection = exports.getDOMDirection = void 0;

var _functional = __webpack_require__(26);

var _canUseDom = _interopRequireDefault(__webpack_require__(136));

var rtlMap = {
  left: "right",
  right: "left",
  borderLeft: "borderRight",
  borderRight: "borderLeft",
  start: "right",
  end: "left",
  topLeft: "topRight",
  topRight: "topLeft",
  bottomLeft: "bottomRight",
  bottomRight: "bottomLeft"
};
var horizontalDirectionMap = {
  start: "left",
  end: "right"
};
/**
 * This method returns the RTL equivalent for an LTR direction.
 * Eg:
 *  getRtl("borderLeft") returns "borderRight"
 *  getRtl("start") returns "right"
 */

var getRtl = (0, _functional.memoize)(function (str) {
  return Object.prototype.hasOwnProperty.call(rtlMap, str) ? rtlMap[str] : str;
});
/**
 * This method returns left/right for start/end. This allows us to accept the
 * start/end prop for our components that have directional props (eg: alignmentHorizontal)
 * while still supporting IE11 which doesn't accept start/end.
 */

exports.getRtl = getRtl;
var getHorizontalDirection = (0, _functional.memoize)(function (str) {
  return Object.prototype.hasOwnProperty.call(horizontalDirectionMap, str) ? horizontalDirectionMap[str] : str;
});
/**
 * Returns the dir of the DOM from an anchor passed into it
 *
 * @param anchor
 */

exports.getHorizontalDirection = getHorizontalDirection;

var getDOMDirection = function getDOMDirection(anchor) {
  try {
    var dir = _canUseDom["default"] && anchor !== null && typeof anchor !== "undefined" ? window.getComputedStyle(anchor).direction : "ltr";
    return dir;
  } catch (_) {
    return "ltr";
  }
};

exports.getDOMDirection = getDOMDirection;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(214);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return toString.call(val) === '[object FormData]';
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  typeof document.createElement -> undefined
 */
function isStandardBrowserEnv() {
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    typeof document.createElement === 'function'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  trim: trim
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(290);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(321);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// These styles are helpful for visually hiding an element while still allowing
// the user to interact with it (e.g. hide an input but allow the user to focus
// on it by clicking on an associated label). Simply applying "display: none" to
// an input will tell the browser to ignore it completely and the user will not
// be able to interact with it at all. Having an invisible yet interactive
// element is useful for creating custom styled inputs that are backed by their
// native html counterparts under the hood or for presenting information to
// screen-readers only.
var visuallyHidden = {
  clip: "rect(0 0 0 0)",
  overflow: "hidden",
  position: "absolute",
  top: 0,
  left: 0,
  border: 0,
  width: 1,
  height: 1,
  opacity: 0
};
var _default = visuallyHidden;
exports["default"] = _default;

/***/ }),
/* 59 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports = {
  elevationBackground: 0,
  elevationMidground: 10,
  elevationForeground: 20,
  elevationMasthead: 30,
  elevationFixture: 40,
  elevationSideMenu: 50,
  elevationModal: 60,
  elevationPopover: 70,
  elevationTooltip: 80
};

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getInductPackageMetrics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MetricUtility__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(5);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="SCC_STOW";var getInductPackageMetrics=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(request){var metricName,args,startTime,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:metricName="getInductPackageMetrics";args=getAPIGatewayRequest(request);startTime=Date.now();_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context.sent;if(!(response.status===200)){_context.next=9;break;}Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context.abrupt("return",transformInductPackageMetrics(response.data.groupedPackageMetrics));case 9:Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 10:case"end":return _context.stop();}}},_callee,this);}));return function getInductPackageMetrics(_x){return _ref.apply(this,arguments);};}();function getAPIGatewayRequest(request){return{resourcePath:"/ivs/getPackageMetric",httpMethod:"post",processName:"induct",requestBody:request};}function transformInductPackageMetrics(metricsMapInput){var metricsMapOutput={};for(var key in metricsMapInput["INDUCTED"]){if(key){metricsMapOutput[key]=Object.assign({},metricsMapOutput[key],{"inductedPackages":metricsMapInput["INDUCTED"][key]});}}for(var _key in metricsMapInput["INDUCTED_AT_STATION"]){if(_key){metricsMapOutput[_key]=Object.assign({},metricsMapOutput[_key],{"inductedPackages":metricsMapInput["INDUCTED_AT_STATION"][_key]});}}for(var _key2 in metricsMapInput["CUMULATIVE_INDUCTED"]){if(_key2){metricsMapOutput[_key2]=Object.assign({},metricsMapOutput[_key2],{"cumulativeInducted":metricsMapInput["CUMULATIVE_INDUCTED"][_key2]});}}for(var _key3 in metricsMapInput["RECEIVED"]){if(_key3){metricsMapOutput[_key3]=Object.assign({},metricsMapOutput[_key3],{"receivedPackages":metricsMapInput["RECEIVED"][_key3]});}}for(var _key4 in metricsMapInput["PENDING_INDUCT"]){if(_key4){metricsMapOutput[_key4]=Object.assign({},metricsMapOutput[_key4],{"receivedPackages":metricsMapInput["PENDING_INDUCT"][_key4]});}}for(var _key5 in metricsMapInput["PLANNED_CURRENT_CYCLE_INDUCTED"]){if(_key5){metricsMapOutput[_key5]=Object.assign({},metricsMapOutput[_key5],{"plannedInducted":metricsMapInput["PLANNED_CURRENT_CYCLE_INDUCTED"][_key5]});}}for(var _key6 in metricsMapInput["UNPLANNED_CURRENT_CYCLE_INDUCTED"]){if(_key6){metricsMapOutput[_key6]=Object.assign({},metricsMapOutput[_key6],{"unplannedInducted":metricsMapInput["UNPLANNED_CURRENT_CYCLE_INDUCTED"][_key6]});}}return metricsMapOutput;}

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReactReduxContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ReactReduxContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);
/* unused harmony default export */ var _unused_webpack_default_export = (ReactReduxContext);

/***/ }),
/* 62 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(400);

var iterableToArray = __webpack_require__(401);

var unsupportedIterableToArray = __webpack_require__(207);

var nonIterableSpread = __webpack_require__(402);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _clickable = _interopRequireDefault(__webpack_require__(412));

var _default = _clickable["default"];
exports["default"] = _default;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(428),
    getValue = __webpack_require__(431);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSpacing = exports.parseAlignment = void 0;

var _spacing = _interopRequireDefault(__webpack_require__(489));

var _token = __webpack_require__(12);

// Parses the value for a spacing prop. This turns a string of spacing names
// like "medium" or "small medium" into an array of spacing values like ["16px"]
// or ["8px", "16px"].
var parseSpacing = function parseSpacing(spacing) {
  return spacing ? spacing.split(" ").map(function (spacing) {
    return (0, _token.getToken)(_spacing["default"], "spacing", spacing) || 0;
  }) : [];
}; // Parses the value for a alignment prop. Given a valid alignment prop value
// this will return an array of two values representing x and y alignment
// respectively.


exports.parseSpacing = parseSpacing;

var parseAlignment = function parseAlignment(alignment) {
  var values = alignment.split(" ");
  return {
    x: values[1],
    y: values[0]
  };
};

exports.parseAlignment = parseAlignment;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tooltip = _interopRequireDefault(__webpack_require__(528));

var _default = _tooltip["default"];
exports["default"] = _default;

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_FEATURE_STATUS_CALL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchFeatureStatusCallSuccess; });
var FETCH_FEATURE_STATUS_CALL_SUCCESS="FETCH_FEATURE_STATUS_CALL_SUCCESS";/**
 * Fetch feature status call success.
 */var fetchFeatureStatusCallSuccess=function fetchFeatureStatusCallSuccess(featureStatus){return{type:FETCH_FEATURE_STATUS_CALL_SUCCESS,featureStatus:featureStatus};};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _controlGroup = _interopRequireDefault(__webpack_require__(654));

var _default = _controlGroup["default"];
exports["default"] = _default;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(683),
    getValue = __webpack_require__(688);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Determines if two components are the same. Uses some tricks to smooth out
 * wrinkles with react-hot-loader in development mode
 *
 * @example
 * import Checkbox from "@amzn/meridian/checkbox"
 * import Radio from "@amzn/meridian/radio"
 *
 * console.log(isSameComponent(Checkbox, Checkbox)) // true
 * console.log(isSameComponent(Checkbox, Radio)) // false
 */
var isSameComponent = function isSameComponent(a, b) {
  if (!a || !b) {
    // Bail if either component wasn't provided
    return false;
  } else if (false) {
    // If a name is set then rely on that in development mode. The component
    // name is more reliable than the type in development mode becaues of a
    // limitation of react-hot-loader (see:
    // https://github.com/gaearon/react-hot-loader/issues/304). Don't use this
    // in production though because minification will change the name and break
    // the comparison.
    var aName = a.displayName || a.name;
    var bName = b.displayName || b.name;
    return aName === bName;
  } else {
    // Just check if the components reference the same class/function.
    return a === b;
  }
};
/**
 * Determines if an element is an instance of a particular component.
 *
 * @example
 * import Checkbox from "@amzn/meridian/checkbox"
 *
 * const isCheckbox = isElementOf(Checkbox)
 * console.log(isCheckbox(<Checkbox />)) // true
 */


var isElementOf = function isElementOf(component) {
  return function (element) {
    if (!component || !element) {
      // Bail if either the component or element wasn't provided
      return false;
    } else if (element.type && element.type.WrappedComponent) {
      // If the element's component has a static WrappedComponent property, assume
      // we're working with a HoC and compare the wrapped component instead of the
      // HoC component. The connect HoC from redux uses this pattern, so this
      // check ensures that isElementOf works correctly on redux-connected
      // components.
      return isSameComponent(element.type.WrappedComponent, component) || isSameComponent(element.type.WrappedComponent, component.WrappedComponent);
    } else {
      // If WrappedComonent isn't set do a normal comparison of element.type
      // (the component that element was instantiated from) and component.
      return isSameComponent(element.type, component);
    }
  };
};

var _default = isElementOf;
exports["default"] = _default;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(213),
    isLength = __webpack_require__(139);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(84),
    getRawTag = __webpack_require__(393),
    objectToString = __webpack_require__(394);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _checkbox = _interopRequireDefault(__webpack_require__(405));

var _default = _checkbox["default"];
exports["default"] = _default;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _emotion = __webpack_require__(4);

var _functional = __webpack_require__(26);

var cxMemoizedCurried = (0, _functional.memoizeCurry)(_emotion.cx, 1);
/**
 * A memoized version of cx. Only supports two classes.
 */

var cxMemoized = function cxMemoized(a, b) {
  return cxMemoizedCurried(a)(b);
};

var _default = cxMemoized;
exports["default"] = _default;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(487);
} else {
  module.exports = require("./prop-types");
}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(521)();
}


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_METRICS_FOR_SORT_ZONE_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOAD_STOW_PACKAGE_METRICS_FOR_SORT_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOAD_STOW_BAG_METRICS_FOR_SORT_ZONE; });
/* unused harmony export LOAD_STOW_CART_METRICS_FOR_SORT_ZONE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOAD_STOW_OV_USAGE_FOR_SORT_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOAD_STOW_BAG_DATA_FOR_SORT_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_INDUCT_PACKAGE_METRICS_FOR_SORT_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_METRICS_FOR_SORT_ZONE_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_NODE_RESOURCE_DATA_FOR_SORT_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOAD_TOTAL_SORT_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getStowPackageMetricsForSortZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchOvUsageForSortZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getNodeResourceDataForSortZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchBagsDataForSortZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getStowBagMetricsForSortZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getInductPackageMetricsForSortZone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_StowResource__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_InductResource__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MetricUtility__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(7);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var LOAD_METRICS_FOR_SORT_ZONE_CALL_BEGIN="LOAD_METRICS_FOR_SORT_ZONE_CALL_BEGIN";var LOAD_STOW_PACKAGE_METRICS_FOR_SORT_ZONE="LOAD_STOW_PACKAGE_METRICS_FOR_SORT_ZONE";var LOAD_STOW_BAG_METRICS_FOR_SORT_ZONE="LOAD_STOW_BAG_METRICS_FOR_SORT_ZONE";var LOAD_STOW_CART_METRICS_FOR_SORT_ZONE="LOAD_STOW_CART_METRICS_FOR_SORT_ZONE";var LOAD_STOW_OV_USAGE_FOR_SORT_ZONE="LOAD_STOW_OV_USAGE_FOR_SORT_ZONE";var LOAD_STOW_BAG_DATA_FOR_SORT_ZONE="LOAD_STOW_BAG_DATA_FOR_SORT_ZONE";var LOAD_INDUCT_PACKAGE_METRICS_FOR_SORT_ZONE="LOAD_INDUCT_PACKAGE_METRICS_FOR_SORT_ZONE";var LOAD_METRICS_FOR_SORT_ZONE_CALL_FAILURE="LOAD_METRICS_FOR_SORT_ZONE_CALL_FAILURE";var LOAD_NODE_RESOURCE_DATA_FOR_SORT_ZONE="LOAD_NODE_RESOURCE_DATA_FOR_SORT_ZONE";var LOAD_TOTAL_SORT_ZONE="LOAD_TOTAL_SORT_ZONE";var metricProcessName="SCC_STOW_SORTZONE";var loadMetricsForSortZoneCallBegin=function loadMetricsForSortZoneCallBegin(){return{type:LOAD_METRICS_FOR_SORT_ZONE_CALL_BEGIN};};var loadInductPackageMetricsForSortZone=function loadInductPackageMetricsForSortZone(inductPackageMetricsMap){return{type:LOAD_INDUCT_PACKAGE_METRICS_FOR_SORT_ZONE,inductPackageMetricsMap:inductPackageMetricsMap};};var loadNodeResourceDataForSortZone=function loadNodeResourceDataForSortZone(nodeResourceData){return{type:LOAD_NODE_RESOURCE_DATA_FOR_SORT_ZONE,nodeResourceData:nodeResourceData};};var loadStowPackageMetricsForSortZone=function loadStowPackageMetricsForSortZone(stowPackageMetricsMap){return{type:LOAD_STOW_PACKAGE_METRICS_FOR_SORT_ZONE,stowPackageMetricsMap:stowPackageMetricsMap};};var loadStowBagMetricsForSortZone=function loadStowBagMetricsForSortZone(stowBagMetricsMap){return{type:LOAD_STOW_BAG_METRICS_FOR_SORT_ZONE,stowBagMetricsMap:stowBagMetricsMap};};var loadStowOvUsageForSortZone=function loadStowOvUsageForSortZone(stowOvUsageMap){return{type:LOAD_STOW_OV_USAGE_FOR_SORT_ZONE,stowOvUsageMap:stowOvUsageMap};};var loadStowBagDataForSortZone=function loadStowBagDataForSortZone(stowBagsData){return{type:LOAD_STOW_BAG_DATA_FOR_SORT_ZONE,stowBagsData:stowBagsData};};var loadMetricsForSortZoneCallFailure=function loadMetricsForSortZoneCallFailure(){return{type:LOAD_METRICS_FOR_SORT_ZONE_CALL_FAILURE};};var getStowPackageMetricsForSortZone=function getStowPackageMetricsForSortZone(isDRSStowVisibilityEnabled,nodeId,cycles,aisles,cycleIds){var metricName="getStowPackageMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].BIN,filters:{NODE:[nodeId],AISLE:aisles},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].STOWED_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].PLANNED_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].CURRENT_INDUCTED_COUNT]};if(!isDRSStowVisibilityEnabled){request.filters["DRS"]=[__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* FALSE */]];}cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* CYCLE_ID */]]=cycleIds;}return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var startTime,stowPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;dispatch(loadMetricsForSortZoneCallBegin());startTime=Date.now();_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["q" /* getStowPackageMetrics */])(request);case 5:stowPackageMetricsMap=_context.sent;if(stowPackageMetricsMap){dispatch(loadStowPackageMetricsForSortZone(stowPackageMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForSortZoneCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context.next=13;break;case 9:_context.prev=9;_context.t0=_context["catch"](0);dispatch(loadMetricsForSortZoneCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context.stop();}}},_callee,_this,[[0,9]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var fetchOvUsageForSortZone=function fetchOvUsageForSortZone(nodeId,cycles,aisles){var metricName="getStowOvUsage";var request={filters:{NODE:[nodeId],AISLE:aisles},fieldsRequired:["OV_USAGE"]};cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var startTime,stowBinsWithOvUsage;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;dispatch(loadMetricsForSortZoneCallBegin());startTime=Date.now();_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["k" /* getStowBins */])(request);case 5:stowBinsWithOvUsage=_context2.sent;if(stowBinsWithOvUsage){dispatch(loadStowOvUsageForSortZone(transformOvUsageResponse(stowBinsWithOvUsage)));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForSortZoneCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context2.next=13;break;case 9:_context2.prev=9;_context2.t0=_context2["catch"](0);dispatch(loadMetricsForSortZoneCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context2.stop();}}},_callee2,_this,[[0,9]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();function transformOvUsageResponse(stowBinsWithOvUsage){var metricsMapOutput={};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=stowBinsWithOvUsage[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var bin=_step.value;metricsMapOutput[bin.binLabel]={ovUsage:bin.ovUsage};}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return metricsMapOutput;}};var getNodeResourceDataForSortZone=function getNodeResourceDataForSortZone(nodeId,nodeResourceType,aisle){var metricName="getNodeResourceData";var request={nodeId:nodeId,filters:{AISLE:aisle},nodeResourceType:nodeResourceType};return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var startTime,nodeResources;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;dispatch(loadMetricsForSortZoneCallBegin());startTime=Date.now();_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["c" /* getNodeResourceData */])(request);case 5:nodeResources=_context3.sent;if(nodeResources){dispatch(loadNodeResourceDataForSortZone(nodeResources));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}_context3.next=13;break;case 9:_context3.prev=9;_context3.t0=_context3["catch"](0);dispatch(loadMetricsForSortZoneCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context3.stop();}}},_callee3,_this,[[0,9]]);}));return function(_x3){return _ref3.apply(this,arguments);};}();};var fetchBagsDataForSortZone=function fetchBagsDataForSortZone(nodeId,cycles,sortZone){var metricName="getStowBags";var request={filters:{NODE:[nodeId],BIN:[sortZone]}};cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var startTime,stowBagsData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;dispatch(loadMetricsForSortZoneCallBegin());startTime=Date.now();_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["k" /* getStowBins */])(request);case 5:stowBagsData=_context4.sent;if(stowBagsData&&stowBagsData.length&&stowBagsData[0].bags){dispatch(loadStowBagDataForSortZone({sortZone:sortZone,bagsData:stowBagsData[0].bags}));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForSortZoneCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context4.next=13;break;case 9:_context4.prev=9;_context4.t0=_context4["catch"](0);dispatch(loadMetricsForSortZoneCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context4.stop();}}},_callee4,_this,[[0,9]]);}));return function(_x4){return _ref4.apply(this,arguments);};}();};var getStowBagMetricsForSortZone=function getStowBagMetricsForSortZone(nodeId,cycles,aisles,cycleIds,isStowBreakdownV2Enabled){var metricName="getStowBagMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].BIN,filters:{NODE:[nodeId],AISLE:aisles},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["c" /* BagMetric */].CLOSED_BAG_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["c" /* BagMetric */].OPEN_BAG_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["c" /* BagMetric */].PLANNED_BAG_COUNT]};if(isStowBreakdownV2Enabled){request.filters["STOW_BREAKDOWN_V2"]=[__WEBPACK_IMPORTED_MODULE_4__constants__["y" /* True */]];}cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* CYCLE_ID */]]=cycleIds;}return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var startTime,stowBagMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;dispatch(loadMetricsForSortZoneCallBegin());startTime=Date.now();_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["h" /* getStowBagMetrics */])(request);case 5:stowBagMetricsMap=_context5.sent;if(stowBagMetricsMap){dispatch(loadStowBagMetricsForSortZone(stowBagMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForSortZoneCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context5.next=13;break;case 9:_context5.prev=9;_context5.t0=_context5["catch"](0);dispatch(loadMetricsForSortZoneCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context5.stop();}}},_callee5,_this,[[0,9]]);}));return function(_x5){return _ref5.apply(this,arguments);};}();};var getInductPackageMetricsForSortZone=function getInductPackageMetricsForSortZone(nodeId,cycles,aisles){var metricName="getInductPackageMetrics";var request={groupBy:"SortZone",filters:{Aisle:aisles},metricList:[__WEBPACK_IMPORTED_MODULE_5__enums__["m" /* InductPackageMetric */].RECEIVED],nodeId:nodeId};cycles=cycles.filter(Boolean);if(cycles.length){request.filters["Cycle"]=cycles;}return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch){var startTime,inductPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.prev=0;dispatch(loadMetricsForSortZoneCallBegin());startTime=Date.now();_context6.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_InductResource__["a" /* getInductPackageMetrics */])(request);case 5:inductPackageMetricsMap=_context6.sent;if(inductPackageMetricsMap){dispatch(loadInductPackageMetricsForSortZone(inductPackageMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForSortZoneCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context6.next=13;break;case 9:_context6.prev=9;_context6.t0=_context6["catch"](0);dispatch(loadMetricsForSortZoneCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context6.stop();}}},_callee6,_this,[[0,9]]);}));return function(_x6){return _ref6.apply(this,arguments);};}();};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BreadcrumbGroup", {
  enumerable: true,
  get: function get() {
    return _breadcrumbGroup["default"];
  }
});
exports["default"] = void 0;

var _breadcrumbGroup = _interopRequireDefault(__webpack_require__(81));

var _breadcrumb = _interopRequireDefault(__webpack_require__(595));

var _default = _breadcrumb["default"];
exports["default"] = _default;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _breadcrumb = _interopRequireDefault(__webpack_require__(593));

var _context = _interopRequireDefault(__webpack_require__(255));

var _theme = __webpack_require__(14);

var _listReset = _interopRequireDefault(__webpack_require__(594));

var _functional = __webpack_require__(26);

var styles = (0, _emotion.css)(_listReset["default"], {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
});
var getContextValue = (0, _functional.memoizeCurry)(function (t, selected) {
  return {
    t: t,
    selected: selected
  };
}, 1);
/**
 * Used to group a set of breadcrumbs.
 */

function BreadcrumbGroup(props) {
  var t = (0, _theme.useTheme)(_breadcrumb["default"], "breadcrumb");

  var breadcrumbs = _react["default"].Children.toArray(props.children);

  var lastIndex = breadcrumbs.length - 1;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: styles
  }, breadcrumbs.map(function (breadcrumb, index) {
    return /*#__PURE__*/_react["default"].createElement(_context["default"].Provider, {
      key: index,
      value: getContextValue(t)(index === lastIndex)
    }, breadcrumb);
  }));
}

BreadcrumbGroup.propTypes =  false ? {
  /**
   * The list of breadcrumbs to display. These must be elements of the
   * `Breadcrumb` component.
   */
  children: _propTypes["default"].node.isRequired
} : {};
var _default = BreadcrumbGroup;
exports["default"] = _default;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    tableActionBarOverlayBackgroundColor: tokens.themeForegroundPrimaryFocus,
    tableForegroundColor: tokens.themeForegroundPrimaryDefault,
    tableBackgroundColorPrimary: tokens.themeBackgroundPrimaryDefault,
    tableBackgroundColorDefault: tokens.themeBackgroundPrimaryDefault,
    tableBackgroundColorHover: tokens.themeBackgroundSecondaryDefault,
    tableBackgroundColorPressed: tokens.themeBackgroundTertiaryDefault,
    tableBackgroundColorHighlight: tokens.themeBackgroundSecondaryDefault,
    tableBackgroundColorStripe: tokens.themeBackgroundSecondaryDefault,
    tableFontSizeNestedHeader: 14,
    tableFontSizeSectionHeader: 14,
    tableFontSizeBody: 12,
    tableFontWeightHeader: 600,
    tableFontWeightBody: 400,
    tableBorderWidthHeader: 2,
    tableBorderWidthBody: 1,
    tableBorderRadius: 0,
    tableBorderColor: tokens.themeBorderSecondaryDefault,
    tableActionBarOverlayBackgroundColorHover: tokens.themeForegroundAccentHover,
    tableActionBarOverlayBackgroundColorPressed: tokens.themeForegroundAccentPressed,
    tableActionBarOverlayForegroundColor: tokens.themeForegroundInvertedDefault,
    tableSortIndicatorColorDefault: tokens.themeForegroundSecondaryDefault,
    tableSortIndicatorColorHover: tokens.themeForegroundAccentHover,
    tableSortIndicatorColorFocus: tokens.themeForegroundAccentHover,
    tableSortIndicatorColorPressed: tokens.themeForegroundAccentPressed,
    tableSortIndicatorColorSorted: tokens.themeForegroundPrimaryDefault,
    tableSortIndicatorColorPreselected: tokens.themeBorderAccentPreselected,
    tableSortIndicatorWidth: 24,
    tableSortIndicatorHeight: 24,
    tableSortIndicatorSpacing: 4,
    tableSpacingHorizontal: 16,
    tableSpacingVerticalSmall: 8,
    tableSpacingVerticalMedium: 16,
    tableMotionDuration: "100ms",
    tableMotionFunction: "ease",
    tableOverflowShadowOffsetX: 0,
    tableOverflowShadowOffsetY: 8,
    tableOverflowShadowBlur: 8,
    tableOverflowShadowSpread: -4,
    tableOverflowShadowColor: "rgba(11, 12, 12, 0.16)",
    tableOverflowStickyRowShadowOffsetX: 0,
    tableOverflowStickyRowShadowOffsetY: 8,
    tableOverflowStickyRowShadowBlur: 8,
    tableOverflowStickyRowShadowSpread: 0,
    tableOverflowStickyRowShadowColor: "rgba(11, 12, 12, 0.16)",
    tableOverflowStickyColumnShadowOffsetY: 0,
    tableOverflowStickyColumnShadowOffsetX: 8,
    tableOverflowStickyColumnShadowBlur: 8,
    tableOverflowStickyColumnShadowSpread: 0,
    tableOverflowStickyColumnShadowColor: "rgba(11, 12, 12, 0.16)"
  }
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Generate a CSS value for an encoded svg icon. This essentially just sets the
 * color and wraps the data in a "url()".
 *
 * @example
 * getIconCss(data, "#000")
 */
var getIconCss = function getIconCss(data, color) {
  return data && color ? "url(\"".concat(data.replace(new RegExp("currentColor", "g"), // NOTE: Encode any "#" chars in the color value to future proof against
  // this change: https://www.chromestatus.com/feature/5656049583390720
  color.replace(new RegExp("#", "g"), "%23")), "\")") : "none";
};

var _default = getIconCss;
exports["default"] = _default;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(53);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(457),
    baseKeys = __webpack_require__(463),
    isArrayLike = __webpack_require__(73);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(477);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _heading = _interopRequireDefault(__webpack_require__(554));

var _default = _heading["default"];
exports["default"] = _default;

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTableCellHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTableCellCount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table_table_cell__);
var SORT_COL_TO_FORMATTED_ID_MAP={currentStowBufferedPackages:"common.stow_buffered",currentMFRJackpotBufferedPackages:"common.jackpot_buffered_mfr"};var SORT_COL_TO_FORMATTED_DEFAULT_MSG_MAP={currentStowBufferedPackages:"Stow buffered",currentMFRJackpotBufferedPackages:"Jackpot buffered (MFR)"};var getTableCellHeader=function getTableCellHeader(sortColumn){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table_table_cell___default.a,{sortColumn:sortColumn,alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:SORT_COL_TO_FORMATTED_ID_MAP[sortColumn],defaultMessage:SORT_COL_TO_FORMATTED_DEFAULT_MSG_MAP[sortColumn]}));};var getTableCellCount=function getTableCellCount(count){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},count);};

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_INDUCT_PACKAGE_METRICS_FOR_FLOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_METRICS_FOR_FLOOR_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_METRICS_FOR_FLOOR_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_PICK_PACKAGE_METRICS_FOR_FLOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOAD_STOW_CART_DATA_FOR_FLOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOAD_STOW_FLOOR_DATA_FOR_FLOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOAD_STOW_PACKAGE_METRICS_FOR_FLOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getInductPackageMetricsForFloor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getPickPackageMetricsForFloor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getStowCartDataForFloor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getStowFloorDataForFloor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getStowPackageMetricsForFloor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_InductResource__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_StowResource__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resources_PickResource__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(7);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var LOAD_INDUCT_PACKAGE_METRICS_FOR_FLOOR="LOAD_INDUCT_PACKAGE_METRICS_FOR_FLOOR";var LOAD_METRICS_FOR_FLOOR_CALL_BEGIN="LOAD_METRICS_FOR_FLOOR_CALL_BEGIN";var LOAD_METRICS_FOR_FLOOR_CALL_FAILURE="LOAD_METRICS_FOR_FLOOR_CALL_FAILURE";var LOAD_PICK_PACKAGE_METRICS_FOR_FLOOR="LOAD_PICK_PACKAGE_METRICS_FOR_FLOOR";var LOAD_STOW_CART_DATA_FOR_FLOOR="LOAD_STOW_CART_DATA_FOR_FLOOR";var LOAD_STOW_FLOOR_DATA_FOR_FLOOR="LOAD_STOW_FLOOR_DATA_FOR_FLOOR";var LOAD_STOW_PACKAGE_METRICS_FOR_FLOOR="LOAD_STOW_PACKAGE_METRICS_FOR_FLOOR";var loadInductPackageMetricsForFloor=function loadInductPackageMetricsForFloor(inductPackageMetricsMap){return{type:LOAD_INDUCT_PACKAGE_METRICS_FOR_FLOOR,inductPackageMetricsMap:inductPackageMetricsMap};};var loadMetricsForFloorCallBegin=function loadMetricsForFloorCallBegin(){return{type:LOAD_METRICS_FOR_FLOOR_CALL_BEGIN};};var loadMetricsForFloorCallFailure=function loadMetricsForFloorCallFailure(){return{type:LOAD_METRICS_FOR_FLOOR_CALL_FAILURE};};var loadPickPackageMetricsForFloor=function loadPickPackageMetricsForFloor(pickPackageMetricsMap){return{type:LOAD_PICK_PACKAGE_METRICS_FOR_FLOOR,pickPackageMetricsMap:pickPackageMetricsMap};};var loadStowCartDataForFloor=function loadStowCartDataForFloor(stowCartData){return{type:LOAD_STOW_CART_DATA_FOR_FLOOR,stowCartData:stowCartData};};var loadStowFloorDataForFloor=function loadStowFloorDataForFloor(stowFloorsData){return{type:LOAD_STOW_FLOOR_DATA_FOR_FLOOR,stowFloorsData:stowFloorsData};};var loadStowPackageMetricsForFloor=function loadStowPackageMetricsForFloor(stowPackageMetricsMap){return{type:LOAD_STOW_PACKAGE_METRICS_FOR_FLOOR,stowPackageMetricsMap:stowPackageMetricsMap};};var getInductPackageMetricsForFloor=function getInductPackageMetricsForFloor(nodeId,stationPairs){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var request,inductPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(loadMetricsForFloorCallBegin());_context.prev=1;request=constructInductPackageMetricsRequest(nodeId,stationPairs);_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_InductResource__["a" /* getInductPackageMetrics */])(request);case 5:inductPackageMetricsMap=_context.sent;if(inductPackageMetricsMap){dispatch(loadInductPackageMetricsForFloor(inductPackageMetricsMap));}else{dispatch(loadMetricsForFloorCallFailure());}_context.next=12;break;case 9:_context.prev=9;_context.t0=_context["catch"](1);dispatch(loadMetricsForFloorCallFailure());case 12:case"end":return _context.stop();}}},_callee,_this,[[1,9]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var getPickPackageMetricsForFloor=function getPickPackageMetricsForFloor(nodeId,stationPairs){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var request,pickPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(loadMetricsForFloorCallBegin());_context2.prev=1;request=constructPickPackageMetricsRequest(nodeId,stationPairs);_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4__resources_PickResource__["a" /* getPickPackageMetrics */])(request);case 5:pickPackageMetricsMap=_context2.sent;if(pickPackageMetricsMap){dispatch(loadPickPackageMetricsForFloor(pickPackageMetricsMap));}else{dispatch(loadMetricsForFloorCallFailure());}_context2.next=12;break;case 9:_context2.prev=9;_context2.t0=_context2["catch"](1);dispatch(loadMetricsForFloorCallFailure());case 12:case"end":return _context2.stop();}}},_callee2,_this,[[1,9]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var getStowCartDataForFloor=function getStowCartDataForFloor(nodeId,floor){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var request,stowCartData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(loadMetricsForFloorCallBegin());_context3.prev=1;request=constructStowCartDataRequest(nodeId,floor);_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_StowResource__["m" /* getStowCarts */])(request);case 5:stowCartData=_context3.sent;if(stowCartData){dispatch(loadStowCartDataForFloor({floor:floor,cartData:stowCartData[0]}));}else{dispatch(loadMetricsForFloorCallFailure());}_context3.next=12;break;case 9:_context3.prev=9;_context3.t0=_context3["catch"](1);dispatch(loadMetricsForFloorCallFailure());case 12:case"end":return _context3.stop();}}},_callee3,_this,[[1,9]]);}));return function(_x3){return _ref3.apply(this,arguments);};}();};var getStowFloorDataForFloor=function getStowFloorDataForFloor(nodeId,stationPairs){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var request,stowFloorsDataMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch(loadMetricsForFloorCallBegin());_context4.prev=1;request=constructStowFloorDataRequest(nodeId,stationPairs);_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_StowResource__["p" /* getStowFloors */])(request);case 5:stowFloorsDataMap=_context4.sent;if(stowFloorsDataMap){dispatch(loadStowFloorDataForFloor(stowFloorsDataMap));}else{dispatch(loadMetricsForFloorCallFailure());}_context4.next=12;break;case 9:_context4.prev=9;_context4.t0=_context4["catch"](1);dispatch(loadMetricsForFloorCallFailure());case 12:case"end":return _context4.stop();}}},_callee4,_this,[[1,9]]);}));return function(_x4){return _ref4.apply(this,arguments);};}();};var getStowPackageMetricsForFloor=function getStowPackageMetricsForFloor(nodeId,stationPairs){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var request,stowPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch(loadMetricsForFloorCallBegin());_context5.prev=1;request=constructStowPackageMetricsRequest(nodeId,stationPairs);_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_StowResource__["q" /* getStowPackageMetrics */])(request);case 5:stowPackageMetricsMap=_context5.sent;if(stowPackageMetricsMap){delete stowPackageMetricsMap['Total'];dispatch(loadStowPackageMetricsForFloor(stowPackageMetricsMap));}else{dispatch(loadMetricsForFloorCallFailure());}_context5.next=12;break;case 9:_context5.prev=9;_context5.t0=_context5["catch"](1);dispatch(loadMetricsForFloorCallFailure());case 12:case"end":return _context5.stop();}}},_callee5,_this,[[1,9]]);}));return function(_x5){return _ref5.apply(this,arguments);};}();};var constructInductPackageMetricsRequest=function constructInductPackageMetricsRequest(nodeId,stationPairs){return{groupBy:"Floor",nodeId:nodeId,metricList:[__WEBPACK_IMPORTED_MODULE_5__enums__["m" /* InductPackageMetric */].INDUCTED],filters:{StationPair:stationPairs}};};var constructPickPackageMetricsRequest=function constructPickPackageMetricsRequest(nodeId,stationPairs){return{groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].FLOOR_LOCATION,stationCode:nodeId,metricList:["PICKED"],date:Object(__WEBPACK_IMPORTED_MODULE_3__Utility__["j" /* getDateInMMDDYYYYWithOffset */])(0),filters:{stationPair:stationPairs}};};var constructStowCartDataRequest=function constructStowCartDataRequest(nodeId,floor){return{filters:{NODE:[nodeId],FLOOR:[floor]},fieldsRequired:[__WEBPACK_IMPORTED_MODULE_5__enums__["f" /* CartData */].CART_LABEL,__WEBPACK_IMPORTED_MODULE_5__enums__["f" /* CartData */].BIN_DATA]};};var constructStowFloorDataRequest=function constructStowFloorDataRequest(nodeId,stationPairs){return{filters:{NODE:[nodeId],STATION_PAIR:stationPairs},fieldsRequired:[__WEBPACK_IMPORTED_MODULE_5__enums__["j" /* FloorData */].FLOOR_LABEL,__WEBPACK_IMPORTED_MODULE_5__enums__["j" /* FloorData */].ROUTE_CODE,__WEBPACK_IMPORTED_MODULE_5__enums__["j" /* FloorData */].CART_DATA]};};var constructStowPackageMetricsRequest=function constructStowPackageMetricsRequest(nodeId,stationPairs){return{groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].FLOOR,filters:{NODE:[nodeId],STATION_PAIR:stationPairs},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].STOWED_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].PROBLEM_SOLVE_COUNT]};};

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_loader__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_loader__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Loading=function(_Component){_inherits(Loading,_Component);function Loading(){_classCallCheck(this,Loading);return _possibleConstructorReturn(this,(Loading.__proto__||Object.getPrototypeOf(Loading)).apply(this,arguments));}_createClass(Loading,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,{height:this.props.height,alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_loader___default.a,null));}}]);return Loading;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Loading);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_METRICS_FOR_CART_LOCATION_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_METRICS_FOR_CART_LOCATION_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_STOW_CART_DATA_FOR_CART_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_STOW_FLOOR_DATA_FOR_CART_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOAD_STOW_PACKAGE_METRICS_FOR_CART_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getStowCartDataForCartLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getStowFloorDataForCartLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getStowPackageMetricsForCartLocation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_StowResource__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(5);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var LOAD_METRICS_FOR_CART_LOCATION_CALL_BEGIN="LOAD_METRICS_FOR_CART_LOCATION_CALL_BEGIN";var LOAD_METRICS_FOR_CART_LOCATION_CALL_FAILURE="LOAD_METRICS_FOR_CART_LOCATION_CALL_FAILURE";var LOAD_STOW_CART_DATA_FOR_CART_LOCATION="LOAD_STOW_CART_DATA_FOR_CART_LOCATION";var LOAD_STOW_FLOOR_DATA_FOR_CART_LOCATION="LOAD_STOW_FLOOR_DATA_FOR_CART_LOCATION";var LOAD_STOW_PACKAGE_METRICS_FOR_CART_LOCATION="LOAD_STOW_PACKAGE_METRICS_FOR_CART_LOCATION";var loadMetricsForCartLocationCallBegin=function loadMetricsForCartLocationCallBegin(){return{type:LOAD_METRICS_FOR_CART_LOCATION_CALL_BEGIN};};var loadMetricsForCartLocationCallFailure=function loadMetricsForCartLocationCallFailure(){return{type:LOAD_METRICS_FOR_CART_LOCATION_CALL_FAILURE};};var loadStowCartDataForCartLocation=function loadStowCartDataForCartLocation(stowCartData){return{type:LOAD_STOW_CART_DATA_FOR_CART_LOCATION,stowCartData:stowCartData};};var loadStowFloorDataForCartLocation=function loadStowFloorDataForCartLocation(stowFloorsData){return{type:LOAD_STOW_FLOOR_DATA_FOR_CART_LOCATION,stowFloorsData:stowFloorsData};};var loadStowPackageMetricsForCartLocation=function loadStowPackageMetricsForCartLocation(stowPackageMetricsMap){return{type:LOAD_STOW_PACKAGE_METRICS_FOR_CART_LOCATION,stowPackageMetricsMap:stowPackageMetricsMap};};var getStowCartDataForCartLocation=function getStowCartDataForCartLocation(nodeId,cartLocation){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var request,stowCartData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(loadMetricsForCartLocationCallBegin());_context.prev=1;request=constructStowCartDataRequest(nodeId,cartLocation);_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["m" /* getStowCarts */])(request);case 5:stowCartData=_context.sent;if(stowCartData){dispatch(loadStowCartDataForCartLocation({floor:cartLocation,cartData:stowCartData[0]}));}else{dispatch(loadMetricsForCartLocationCallFailure());}_context.next=12;break;case 9:_context.prev=9;_context.t0=_context["catch"](1);dispatch(loadMetricsForCartLocationCallFailure());case 12:case"end":return _context.stop();}}},_callee,_this,[[1,9]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var getStowFloorDataForCartLocation=function getStowFloorDataForCartLocation(nodeId,zone){var fetchRouteData=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var request,stowFloorsDataMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(loadMetricsForCartLocationCallBegin());_context2.prev=1;request=fetchRouteData?constructStowFloorDataRequestWithRouteDetails(nodeId,zone):constructStowFloorDataRequest(nodeId,zone);_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["p" /* getStowFloors */])(request);case 5:stowFloorsDataMap=_context2.sent;if(stowFloorsDataMap){dispatch(loadStowFloorDataForCartLocation(stowFloorsDataMap));}else{dispatch(loadMetricsForCartLocationCallFailure());}_context2.next=12;break;case 9:_context2.prev=9;_context2.t0=_context2["catch"](1);dispatch(loadMetricsForCartLocationCallFailure());case 12:case"end":return _context2.stop();}}},_callee2,_this,[[1,9]]);}));return function(_x3){return _ref2.apply(this,arguments);};}();};var getStowPackageMetricsForCartLocation=function getStowPackageMetricsForCartLocation(nodeId,zone){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var request,stowPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(loadMetricsForCartLocationCallBegin());_context3.prev=1;request=constructStowPackageMetricsRequest(nodeId,zone);_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["q" /* getStowPackageMetrics */])(request);case 5:stowPackageMetricsMap=_context3.sent;if(stowPackageMetricsMap){delete stowPackageMetricsMap[__WEBPACK_IMPORTED_MODULE_3__constants__["w" /* TOTAL */]];dispatch(loadStowPackageMetricsForCartLocation(stowPackageMetricsMap));}else{dispatch(loadMetricsForCartLocationCallFailure());}_context3.next=12;break;case 9:_context3.prev=9;_context3.t0=_context3["catch"](1);dispatch(loadMetricsForCartLocationCallFailure());case 12:case"end":return _context3.stop();}}},_callee3,_this,[[1,9]]);}));return function(_x4){return _ref3.apply(this,arguments);};}();};var constructStowCartDataRequest=function constructStowCartDataRequest(nodeId,floor){return{filters:{NODE:[nodeId],FLOOR:[floor]},fieldsRequired:[__WEBPACK_IMPORTED_MODULE_2__enums__["f" /* CartData */].CART_LABEL]};};var constructStowFloorDataRequest=function constructStowFloorDataRequest(nodeId,zone){return{filters:{NODE:[nodeId],ZONE:zone},fieldsRequired:[__WEBPACK_IMPORTED_MODULE_2__enums__["j" /* FloorData */].FLOOR_LABEL,__WEBPACK_IMPORTED_MODULE_2__enums__["j" /* FloorData */].CART_DATA]};};var constructStowFloorDataRequestWithRouteDetails=function constructStowFloorDataRequestWithRouteDetails(nodeId,zone){return{filters:{NODE:[nodeId],ZONE:zone},fieldsRequired:[__WEBPACK_IMPORTED_MODULE_2__enums__["j" /* FloorData */].FLOOR_LABEL,__WEBPACK_IMPORTED_MODULE_2__enums__["j" /* FloorData */].CART_DATA,__WEBPACK_IMPORTED_MODULE_2__enums__["j" /* FloorData */].ROUTE_CODE,__WEBPACK_IMPORTED_MODULE_2__enums__["j" /* FloorData */].ROUTE_ID]};};var constructStowPackageMetricsRequest=function constructStowPackageMetricsRequest(nodeId,zone){return{groupBy:__WEBPACK_IMPORTED_MODULE_2__enums__["o" /* Resource */].CART_LOCATION,filters:{NODE:[nodeId],CLUSTER:zone},metrics:[__WEBPACK_IMPORTED_MODULE_2__enums__["p" /* StowPackageMetric */].CURRENT_INDUCTED_COUNT,__WEBPACK_IMPORTED_MODULE_2__enums__["p" /* StowPackageMetric */].STOWED_COUNT,__WEBPACK_IMPORTED_MODULE_2__enums__["p" /* StowPackageMetric */].CURRENT_STOWED_COUNT,__WEBPACK_IMPORTED_MODULE_2__enums__["p" /* StowPackageMetric */].PROBLEM_SOLVE_COUNT,__WEBPACK_IMPORTED_MODULE_2__enums__["p" /* StowPackageMetric */].STOW_RATE,__WEBPACK_IMPORTED_MODULE_2__enums__["p" /* StowPackageMetric */].SCAN_COMPLIANCE]};};

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOAD_STOW_BIN_METRICS_FOR_CLUSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOAD_STOW_CART_METRICS_FOR_CLUSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOAD_STOW_BIN_METRICS_FOR_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LOAD_STOW_PACKAGE_METRICS_FOR_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOAD_STOW_CART_METRICS_FOR_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getStowPackageMetricsForCluster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getStowBinMetricsForCluster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getStowCartMetricsForCluster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getInductPackageMetricsForCluster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getStowAssociateMetricsForCluster; });
/* unused harmony export getInductPackageMetricsForNode */
/* unused harmony export getStowAssociateMetricsForNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_StowResource__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_InductResource__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MetricUtility__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(7);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN="LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN";var LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER="LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER";var LOAD_STOW_BIN_METRICS_FOR_CLUSTER="LOAD_STOW_BIN_METRICS_FOR_CLUSTER";var LOAD_STOW_CART_METRICS_FOR_CLUSTER="LOAD_STOW_CART_METRICS_FOR_CLUSTER";var LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER="LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER";var LOAD_STOW_BIN_METRICS_FOR_NODE="LOAD_STOW_BIN_METRICS_FOR_NODE";var LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER="LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER";var LOAD_STOW_PACKAGE_METRICS_FOR_NODE="LOAD_STOW_PACKAGE_METRICS_FOR_NODE";var LOAD_STOW_CART_METRICS_FOR_NODE="LOAD_STOW_CART_METRICS_FOR_NODE";var LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE="LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE";var LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE="LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE";var LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE="LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE";var metricProcessName="SCC_STOW_CLUSTER";var loadMetricsForClusterCallBegin=function loadMetricsForClusterCallBegin(){return{type:LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN};};var loadStowPackageMetricsForCluster=function loadStowPackageMetricsForCluster(stowPackageMetricsMap){return{type:LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER,stowPackageMetricsMap:stowPackageMetricsMap};};var loadStowCartMetricsForCluster=function loadStowCartMetricsForCluster(stowCartMetricsMap){return{type:LOAD_STOW_CART_METRICS_FOR_CLUSTER,stowCartMetricsMap:stowCartMetricsMap};};var loadStowCartMetricsForNode=function loadStowCartMetricsForNode(totalStowCartMetricsMap){return{type:LOAD_STOW_CART_METRICS_FOR_NODE,totalStowCartMetricsMap:totalStowCartMetricsMap};};var loadStowBinMetricsForCluster=function loadStowBinMetricsForCluster(stowBinMetricsMap){return{type:LOAD_STOW_BIN_METRICS_FOR_CLUSTER,stowBinMetricsMap:stowBinMetricsMap};};var loadStowBinMetricsForNode=function loadStowBinMetricsForNode(totalStowBinMetrics){return{type:LOAD_STOW_BIN_METRICS_FOR_NODE,totalStowBinMetrics:totalStowBinMetrics};};var loadInductPackageMetricsForCluster=function loadInductPackageMetricsForCluster(inductPackageMetricsMap){return{type:LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER,inductPackageMetricsMap:inductPackageMetricsMap};};var loadStowAssociateMetricsForCluster=function loadStowAssociateMetricsForCluster(stowAssociateMetricsMap){return{type:LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER,stowAssociateMetricsMap:stowAssociateMetricsMap};};var loadStowPackageMetricsForNode=function loadStowPackageMetricsForNode(totalStowPackageMetrics){return{type:LOAD_STOW_PACKAGE_METRICS_FOR_NODE,totalStowPackageMetrics:totalStowPackageMetrics};};var loadInductPackageMetricsForNode=function loadInductPackageMetricsForNode(totalInductPackageMetrics){return{type:LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE,totalInductPackageMetrics:totalInductPackageMetrics};};var loadStowAssociateMetricsForNode=function loadStowAssociateMetricsForNode(totalStowAssociateMetrics){return{type:LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE,totalStowAssociateMetrics:totalStowAssociateMetrics};};var loadMetricsForClusterCallFailure=function loadMetricsForClusterCallFailure(){return{type:LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE};};var getStowPackageMetricsForCluster=function getStowPackageMetricsForCluster(isADTAVisibilityEnabled,isDRSStowVisibilityEnabled,nodeId,cycles,cycleIds){var metricName="getStowPackageMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].CLUSTER,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].STOW_RATE,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].SCAN_COMPLIANCE,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].PROBLEM_SOLVE_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].PLANNED_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].STOW_VS_PLAN,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].STOWED_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].CURRENT_INDUCTED_COUNT],isAggregationRequired:true};if(!isDRSStowVisibilityEnabled){request.filters["DRS"]=[__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* FALSE */]];}if(isADTAVisibilityEnabled){request.metrics.push(__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].CURRENT_STOW_BUFFERED_COUNT);request.metrics.push(__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].CURRENT_MFR_JACKPOT_BUFFERED_COUNT);}cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* CYCLE_ID */]]=cycleIds;}function getStowPackageMetricsForNode(stowPackageMetricsMap){return{Total:stowPackageMetricsMap[__WEBPACK_IMPORTED_MODULE_4__constants__["w" /* TOTAL */]]};}return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var startTime,stowPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;dispatch(loadMetricsForClusterCallBegin());startTime=Date.now();_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["q" /* getStowPackageMetrics */])(request);case 5:stowPackageMetricsMap=_context.sent;if(stowPackageMetricsMap){dispatch(loadStowPackageMetricsForNode(getStowPackageMetricsForNode(stowPackageMetricsMap)));removeUnwantedClusters(stowPackageMetricsMap);dispatch(loadStowPackageMetricsForCluster(stowPackageMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context.next=13;break;case 9:_context.prev=9;_context.t0=_context["catch"](0);dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context.stop();}}},_callee,_this,[[0,9]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var getStowBinMetricsForCluster=function getStowBinMetricsForCluster(nodeId,cycles,cycleIds){var metricName="getStowBinMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].CLUSTER,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["d" /* BinMetric */].BINS_COUNT_MISSING_OPEN_BAG]};cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* CYCLE_ID */]]=cycleIds;}return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var startTime,stowBinMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;dispatch(loadMetricsForClusterCallBegin());startTime=Date.now();_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["i" /* getStowBinMetrics */])(request);case 5:stowBinMetricsMap=_context2.sent;if(stowBinMetricsMap){removeUnwantedClusters(stowBinMetricsMap);dispatch(loadStowBinMetricsForNode(getTotalMetrics(stowBinMetricsMap)));dispatch(loadStowBinMetricsForCluster(stowBinMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context2.next=13;break;case 9:_context2.prev=9;_context2.t0=_context2["catch"](0);dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context2.stop();}}},_callee2,_this,[[0,9]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var getStowCartMetricsForCluster=function getStowCartMetricsForCluster(nodeId,cycles,cycleIds,isStowBreakdownV2Enabled){var metricName="getStowCartMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].CLUSTER,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["g" /* CartMetric */].PLANNED_CART_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["g" /* CartMetric */].OPEN_CART_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["g" /* CartMetric */].MISSING_CART_COUNT]};if(isStowBreakdownV2Enabled){request.filters["STOW_BREAKDOWN_V2"]=[__WEBPACK_IMPORTED_MODULE_4__constants__["y" /* True */]];}cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* CYCLE_ID */]]=cycleIds;}function getStowCartMetricsForNode(stowCartMetricsMap){return{Total:stowCartMetricsMap[__WEBPACK_IMPORTED_MODULE_4__constants__["w" /* TOTAL */]]};}return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var startTime,stowCartMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;dispatch(loadMetricsForClusterCallBegin());startTime=Date.now();_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["l" /* getStowCartMetrics */])(request);case 5:stowCartMetricsMap=_context3.sent;if(stowCartMetricsMap){dispatch(loadStowCartMetricsForNode(getStowCartMetricsForNode(stowCartMetricsMap)));removeUnwantedClusters(stowCartMetricsMap);dispatch(loadStowCartMetricsForCluster(stowCartMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context3.next=13;break;case 9:_context3.prev=9;_context3.t0=_context3["catch"](0);dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context3.stop();}}},_callee3,_this,[[0,9]]);}));return function(_x3){return _ref3.apply(this,arguments);};}();};var getInductPackageMetricsForCluster=function getInductPackageMetricsForCluster(nodeId,cycles){var metricName="getInductPackageMetrics";var request={nodeId:nodeId,groupBy:"Cluster",metricList:[__WEBPACK_IMPORTED_MODULE_5__enums__["m" /* InductPackageMetric */].RECEIVED]};cycles=cycles.filter(Boolean);if(cycles.length){request.filters={Cycle:cycles};}return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var startTime,inductPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;dispatch(loadMetricsForClusterCallBegin());startTime=Date.now();_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_InductResource__["a" /* getInductPackageMetrics */])(request);case 5:inductPackageMetricsMap=_context4.sent;if(inductPackageMetricsMap){removeUnwantedClusters(inductPackageMetricsMap);dispatch(loadInductPackageMetricsForNode(getTotalMetrics(inductPackageMetricsMap)));dispatch(loadInductPackageMetricsForCluster(inductPackageMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context4.next=13;break;case 9:_context4.prev=9;_context4.t0=_context4["catch"](0);dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context4.stop();}}},_callee4,_this,[[0,9]]);}));return function(_x4){return _ref4.apply(this,arguments);};}();};var getStowAssociateMetricsForCluster=function getStowAssociateMetricsForCluster(nodeId,cycles){var metricName="getStowAssociateMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].CLUSTER,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["a" /* AssociateMetric */].ACTIVE_ASSOCIATE_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["a" /* AssociateMetric */].INACTIVE_ASSOCIATE_COUNT]};cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var startTime,stowAssociateMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;dispatch(loadMetricsForClusterCallBegin());startTime=Date.now();_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["e" /* getStowAssociateMetrics */])(request);case 5:stowAssociateMetricsMap=_context5.sent;if(stowAssociateMetricsMap){removeUnwantedClusters(stowAssociateMetricsMap);dispatch(loadStowAssociateMetricsForNode(getTotalMetrics(stowAssociateMetricsMap)));dispatch(loadStowAssociateMetricsForCluster(stowAssociateMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context5.next=13;break;case 9:_context5.prev=9;_context5.t0=_context5["catch"](0);dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context5.stop();}}},_callee5,_this,[[0,9]]);}));return function(_x5){return _ref5.apply(this,arguments);};}();};var getInductPackageMetricsForNode=function getInductPackageMetricsForNode(nodeId,cycles){var request={nodeId:nodeId,groupBy:"Node",metricList:["INDUCTED_AT_STATION","PENDING_INDUCT"]};cycles=cycles.filter(Boolean);if(cycles.length){request.filters={"Cycle":cycles};}return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch){var inductPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.prev=0;dispatch(loadMetricsForClusterCallBegin());_context6.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_InductResource__["a" /* getInductPackageMetrics */])(request);case 4:inductPackageMetricsMap=_context6.sent;replaceNodeByTotal(inductPackageMetricsMap,nodeId);if(inductPackageMetricsMap){dispatch(loadInductPackageMetricsForNode(inductPackageMetricsMap));}else{dispatch(loadMetricsForClusterCallFailure());}_context6.next=12;break;case 9:_context6.prev=9;_context6.t0=_context6["catch"](0);dispatch(loadMetricsForClusterCallFailure());case 12:case"end":return _context6.stop();}}},_callee6,_this,[[0,9]]);}));return function(_x6){return _ref6.apply(this,arguments);};}();};var getStowAssociateMetricsForNode=function getStowAssociateMetricsForNode(nodeId,cycles){var request={groupBy:"NODE",filters:{'NODE':[nodeId]},metrics:["ACTIVE_ASSOCIATE_COUNT","INACTIVE_ASSOCIATE_COUNT"]};cycles=cycles.filter(Boolean);if(cycles.length){request.filters["CYCLE"]=cycles;}return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch){var stowAssociateMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.prev=0;dispatch(loadMetricsForClusterCallBegin());_context7.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["e" /* getStowAssociateMetrics */])(request);case 4:stowAssociateMetricsMap=_context7.sent;replaceNodeByTotal(stowAssociateMetricsMap,nodeId);if(stowAssociateMetricsMap){dispatch(loadStowAssociateMetricsForNode(stowAssociateMetricsMap));}else{dispatch(loadMetricsForClusterCallFailure());}_context7.next=12;break;case 9:_context7.prev=9;_context7.t0=_context7["catch"](0);dispatch(loadMetricsForClusterCallFailure());case 12:case"end":return _context7.stop();}}},_callee7,_this,[[0,9]]);}));return function(_x7){return _ref7.apply(this,arguments);};}();};function replaceNodeByTotal(metricsMap,nodeId){metricsMap["Total"]=metricsMap[nodeId];delete metricsMap[nodeId];}function getTotalMetrics(groupedMetricsMap){var totalCluster={};for(var cluster in groupedMetricsMap){var metricsMap=groupedMetricsMap[cluster];for(var metric in metricsMap){if(!totalCluster[metric]){totalCluster[metric]=metricsMap[metric];}else{totalCluster[metric]=+totalCluster[metric]+ +metricsMap[metric];}}}return{Total:totalCluster};}function removeUnwantedClusters(metricsMap){delete metricsMap[__WEBPACK_IMPORTED_MODULE_4__constants__["w" /* TOTAL */]];}

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(122),
    getRawTag = __webpack_require__(684),
    objectToString = __webpack_require__(685);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isElementOf = _interopRequireDefault(__webpack_require__(72));

/**
 * Determines if an element is an instance of any one component from a list of
 * components.
 */
var isElementOfAny = function isElementOfAny(components) {
  return function (element) {
    return [].concat(components).some(function (component) {
      return (0, _isElementOf["default"])(component)(element);
    });
  };
};

var _default = isElementOfAny;
exports["default"] = _default;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(74),
    isObjectLike = __webpack_require__(62);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/** Returns a string value for a border radius style.
 *
 * eg: `0px 4px 4px 0px`
 *
 * @returns {string}
 */
var getBorderRadius = function getBorderRadius(borderRadius) {
  var sides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var topLeft = sides.includes("topLeft") ? borderRadius : 0;
  var topRight = sides.includes("topRight") ? borderRadius : 0;
  var bottomLeft = sides.includes("bottomLeft") ? borderRadius : 0;
  var bottomRight = sides.includes("bottomRight") ? borderRadius : 0;
  return "".concat(topLeft, "px ").concat(topRight, "px ").concat(bottomRight, "px ").concat(bottomLeft, "px");
};

var _default = getBorderRadius;
exports["default"] = _default;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(222),
    findIndex = __webpack_require__(151);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(416),
    baseMatchesProperty = __webpack_require__(472),
    identity = __webpack_require__(150),
    isArray = __webpack_require__(42),
    property = __webpack_require__(481);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(418),
    listCacheDelete = __webpack_require__(419),
    listCacheGet = __webpack_require__(420),
    listCacheHas = __webpack_require__(421),
    listCacheSet = __webpack_require__(422);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(138);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(440);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(99);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(540);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Executes code after waiting at least one whole animation frame. This is
// helpful when you want to allow DOM updates to settle before triggering
// something like a css transition. This returns a function that can be used to
// cancel the callback.
var waitAnimationFrame = function waitAnimationFrame(callback) {
  var frame = requestAnimationFrame(function () {
    frame = requestAnimationFrame(callback);
  });
  return function () {
    return cancelAnimationFrame(frame);
  };
};

var _default = waitAnimationFrame;
exports["default"] = _default;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var noTextWrap = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};
var _default = noTextWrap;
exports["default"] = _default;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _responsive = _interopRequireDefault(__webpack_require__(568));

var _default = _responsive["default"];
exports["default"] = _default;

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_METRICS_FOR_AISLE_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOAD_STOW_PACKAGE_METRICS_FOR_AISLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOAD_STOW_BIN_METRICS_FOR_AISLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOAD_STOW_BAG_METRICS_FOR_AISLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOAD_STOW_CART_METRICS_FOR_AISLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_INDUCT_PACKAGE_METRICS_FOR_AISLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOAD_STOW_ASSOCIATE_METRICS_FOR_AISLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_METRICS_FOR_AISLE_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_NODE_RESOURCE_DATA_FOR_AISLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOAD_STOW_BIN_METRICS_FOR_AISLE_FOR_STOW_V2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getStowPackageMetricsForAisle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getNodeResourceDataForAisle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getStowBinMetricsForAisle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getStowBinMetricsForAisleForStowV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getStowBagMetricsForAisle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getStowCartMetricsForAisle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getInductPackageMetricsForAisle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getStowAssociateMetricsForAisle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_StowResource__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_InductResource__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MetricUtility__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(7);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var LOAD_METRICS_FOR_AISLE_CALL_BEGIN="LOAD_METRICS_FOR_AISLE_CALL_BEGIN";var LOAD_STOW_PACKAGE_METRICS_FOR_AISLE="LOAD_STOW_PACKAGE_METRICS_FOR_AISLE";var LOAD_STOW_BIN_METRICS_FOR_AISLE="LOAD_STOW_BIN_METRICS_FOR_AISLE";var LOAD_STOW_BAG_METRICS_FOR_AISLE="LOAD_STOW_BAG_METRICS_FOR_AISLE";var LOAD_STOW_CART_METRICS_FOR_AISLE="LOAD_STOW_CART_METRICS_FOR_AISLE";var LOAD_INDUCT_PACKAGE_METRICS_FOR_AISLE="LOAD_INDUCT_PACKAGE_METRICS_FOR_AISLE";var LOAD_STOW_ASSOCIATE_METRICS_FOR_AISLE="LOAD_STOW_ASSOCIATE_METRICS_FOR_AISLE";var LOAD_METRICS_FOR_AISLE_CALL_FAILURE="LOAD_METRICS_FOR_AISLE_CALL_FAILURE";var LOAD_NODE_RESOURCE_DATA_FOR_AISLE="LOAD_NODE_RESOURCE_DATA_FOR_AISLE";var LOAD_STOW_BIN_METRICS_FOR_AISLE_FOR_STOW_V2="LOAD_STOW_BIN_METRICS_FOR_AISLE_FOR_STOW_V2";var metricProcessName="SCC_STOW_AISLE";var loadMetricsForAisleCallBegin=function loadMetricsForAisleCallBegin(){return{type:LOAD_METRICS_FOR_AISLE_CALL_BEGIN};};var loadNodeResourceDataForAisle=function loadNodeResourceDataForAisle(nodeResourceData){return{type:LOAD_NODE_RESOURCE_DATA_FOR_AISLE,nodeResourceData:nodeResourceData};};var loadStowBinMetricsForAisleForStowV2=function loadStowBinMetricsForAisleForStowV2(stowBinMetricsMapForStowV2){return{type:LOAD_STOW_BIN_METRICS_FOR_AISLE_FOR_STOW_V2,stowBinMetricsMapForStowV2:stowBinMetricsMapForStowV2};};var loadStowPackageMetricsForAisle=function loadStowPackageMetricsForAisle(stowPackageMetricsMap){return{type:LOAD_STOW_PACKAGE_METRICS_FOR_AISLE,stowPackageMetricsMap:stowPackageMetricsMap};};var loadStowBinMetricsForAisle=function loadStowBinMetricsForAisle(stowBinMetricsMap){return{type:LOAD_STOW_BIN_METRICS_FOR_AISLE,stowBinMetricsMap:stowBinMetricsMap};};var loadStowBagMetricsForAisle=function loadStowBagMetricsForAisle(stowBagMetricsMap){return{type:LOAD_STOW_BAG_METRICS_FOR_AISLE,stowBagMetricsMap:stowBagMetricsMap};};var loadStowCartMetricsForAisle=function loadStowCartMetricsForAisle(stowCartMetricsMap){return{type:LOAD_STOW_CART_METRICS_FOR_AISLE,stowCartMetricsMap:stowCartMetricsMap};};var loadInductPackageMetricsForAisle=function loadInductPackageMetricsForAisle(inductPackageMetricsMap){return{type:LOAD_INDUCT_PACKAGE_METRICS_FOR_AISLE,inductPackageMetricsMap:inductPackageMetricsMap};};var loadStowAssociateMetricsForAisle=function loadStowAssociateMetricsForAisle(stowAssociateMetricsMap){return{type:LOAD_STOW_ASSOCIATE_METRICS_FOR_AISLE,stowAssociateMetricsMap:stowAssociateMetricsMap};};var loadMetricsForAisleCallFailure=function loadMetricsForAisleCallFailure(){return{type:LOAD_METRICS_FOR_AISLE_CALL_FAILURE};};var getStowPackageMetricsForAisle=function getStowPackageMetricsForAisle(isADTAVisibilityEnabled,isDRSStowVisibilityEnabled,nodeId,cycles,clusters,cycleIds){var metricName="getStowPackageMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].AISLE,filters:{NODE:[nodeId],CLUSTER:clusters},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].STOWED_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].STOW_RATE,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].SCAN_COMPLIANCE,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].PLANNED_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].FSAF,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].CURRENT_INDUCTED_COUNT]};if(!isDRSStowVisibilityEnabled){request.filters["DRS"]=[__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* FALSE */]];}if(isADTAVisibilityEnabled){request.metrics.push(__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].CURRENT_STOW_BUFFERED_COUNT);}cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* CYCLE_ID */]]=cycleIds;}return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var startTime,stowPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;dispatch(loadMetricsForAisleCallBegin());startTime=Date.now();_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["q" /* getStowPackageMetrics */])(request);case 5:stowPackageMetricsMap=_context.sent;if(stowPackageMetricsMap){dispatch(loadStowPackageMetricsForAisle(stowPackageMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForAisleCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context.next=13;break;case 9:_context.prev=9;_context.t0=_context["catch"](0);dispatch(loadMetricsForAisleCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context.stop();}}},_callee,_this,[[0,9]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var getNodeResourceDataForAisle=function getNodeResourceDataForAisle(nodeId,nodeResourceType,cluster){var metricName="getNodeResourceData";var request={nodeId:nodeId,filters:{CLUSTER:cluster},nodeResourceType:nodeResourceType};return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var startTime,nodeResources;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;dispatch(loadMetricsForAisleCallBegin());startTime=Date.now();_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["c" /* getNodeResourceData */])(request);case 5:nodeResources=_context2.sent;if(nodeResources){dispatch(loadNodeResourceDataForAisle(nodeResources));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}_context2.next=13;break;case 9:_context2.prev=9;_context2.t0=_context2["catch"](0);dispatch(loadMetricsForAisleCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context2.stop();}}},_callee2,_this,[[0,9]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var getStowBinMetricsForAisle=function getStowBinMetricsForAisle(nodeId,cycles,clusters,cycleIds){var metricName="getStowBinMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].AISLE,filters:{NODE:[nodeId],CLUSTER:clusters},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["d" /* BinMetric */].BINS_COUNT_MISSING_OPEN_BAG]};cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* CYCLE_ID */]]=cycleIds;}return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var startTime,stowBinMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;dispatch(loadMetricsForAisleCallBegin());startTime=Date.now();_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["i" /* getStowBinMetrics */])(request);case 5:stowBinMetricsMap=_context3.sent;if(stowBinMetricsMap){dispatch(loadStowBinMetricsForAisle(stowBinMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForAisleCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context3.next=13;break;case 9:_context3.prev=9;_context3.t0=_context3["catch"](0);dispatch(loadMetricsForAisleCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context3.stop();}}},_callee3,_this,[[0,9]]);}));return function(_x3){return _ref3.apply(this,arguments);};}();};var getStowBinMetricsForAisleForStowV2=function getStowBinMetricsForAisleForStowV2(nodeId,cycles,clusters,cycleIds){var metricName="getStowBinMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].AISLE,filters:{NODE:[nodeId],CLUSTER:clusters},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["d" /* BinMetric */].BINS_COUNT_MISSING_OPEN_BAG]};cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* CYCLE_ID */]]=cycleIds;}return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var startTime,stowBinMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;dispatch(loadMetricsForAisleCallBegin());startTime=Date.now();_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["j" /* getStowBinMetricsForStowV2 */])(request);case 5:stowBinMetricsMap=_context4.sent;if(stowBinMetricsMap){dispatch(loadStowBinMetricsForAisleForStowV2(stowBinMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForAisleCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context4.next=13;break;case 9:_context4.prev=9;_context4.t0=_context4["catch"](0);dispatch(loadMetricsForAisleCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context4.stop();}}},_callee4,_this,[[0,9]]);}));return function(_x4){return _ref4.apply(this,arguments);};}();};var getStowBagMetricsForAisle=function getStowBagMetricsForAisle(nodeId,cycles,clusters,cycleIds,isStowBreakdownV2Enabled){var metricName="getStowBagMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].AISLE,filters:{NODE:[nodeId],CLUSTER:clusters},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["c" /* BagMetric */].USED_BAG_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["c" /* BagMetric */].PLANNED_BAG_COUNT]};if(isStowBreakdownV2Enabled){request.filters["STOW_BREAKDOWN_V2"]=[__WEBPACK_IMPORTED_MODULE_4__constants__["y" /* True */]];}cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* CYCLE_ID */]]=cycleIds;}return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var startTime,stowBagMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;dispatch(loadMetricsForAisleCallBegin());startTime=Date.now();_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["h" /* getStowBagMetrics */])(request);case 5:stowBagMetricsMap=_context5.sent;if(stowBagMetricsMap){dispatch(loadStowBagMetricsForAisle(stowBagMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForAisleCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context5.next=13;break;case 9:_context5.prev=9;_context5.t0=_context5["catch"](0);dispatch(loadMetricsForAisleCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context5.stop();}}},_callee5,_this,[[0,9]]);}));return function(_x5){return _ref5.apply(this,arguments);};}();};var getStowCartMetricsForAisle=function getStowCartMetricsForAisle(nodeId,cycles,clusters,cycleIds,isStowBreakdownV2Enabled){var metricName="getStowCartMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].AISLE,filters:{NODE:[nodeId],CLUSTER:clusters},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["g" /* CartMetric */].PLANNED_CART_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["g" /* CartMetric */].OPEN_CART_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["g" /* CartMetric */].MISSING_CART_COUNT]};if(isStowBreakdownV2Enabled){request.filters["STOW_BREAKDOWN_V2"]=[__WEBPACK_IMPORTED_MODULE_4__constants__["y" /* True */]];}cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* CYCLE_ID */]]=cycleIds;}return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch){var startTime,stowCartMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.prev=0;dispatch(loadMetricsForAisleCallBegin());startTime=Date.now();_context6.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["l" /* getStowCartMetrics */])(request);case 5:stowCartMetricsMap=_context6.sent;if(stowCartMetricsMap){dispatch(loadStowCartMetricsForAisle(stowCartMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForAisleCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context6.next=13;break;case 9:_context6.prev=9;_context6.t0=_context6["catch"](0);dispatch(loadMetricsForAisleCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context6.stop();}}},_callee6,_this,[[0,9]]);}));return function(_x6){return _ref6.apply(this,arguments);};}();};var getInductPackageMetricsForAisle=function getInductPackageMetricsForAisle(nodeId,cycles,clusters){var metricName="getInductPackageMetrics";var request={nodeId:nodeId,groupBy:"Aisle",metricList:[__WEBPACK_IMPORTED_MODULE_5__enums__["m" /* InductPackageMetric */].RECEIVED],filters:{Cluster:clusters}};cycles=cycles.filter(Boolean);if(cycles.length){request.filters["Cycle"]=cycles;}return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch){var startTime,inductPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.prev=0;dispatch(loadMetricsForAisleCallBegin());startTime=Date.now();_context7.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_InductResource__["a" /* getInductPackageMetrics */])(request);case 5:inductPackageMetricsMap=_context7.sent;if(inductPackageMetricsMap){dispatch(loadInductPackageMetricsForAisle(inductPackageMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForAisleCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context7.next=13;break;case 9:_context7.prev=9;_context7.t0=_context7["catch"](0);dispatch(loadMetricsForAisleCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context7.stop();}}},_callee7,_this,[[0,9]]);}));return function(_x7){return _ref7.apply(this,arguments);};}();};var getStowAssociateMetricsForAisle=function getStowAssociateMetricsForAisle(nodeId,cycles,clusters){var metricName="getStowAssociateMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].AISLE,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["a" /* AssociateMetric */].ACTIVE_ASSOCIATE_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["a" /* AssociateMetric */].INACTIVE_ASSOCIATE_COUNT]};cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatch){var startTime,stowAssociateMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.prev=0;dispatch(loadMetricsForAisleCallBegin());startTime=Date.now();_context8.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["e" /* getStowAssociateMetrics */])(request);case 5:stowAssociateMetricsMap=_context8.sent;if(stowAssociateMetricsMap){dispatch(loadStowAssociateMetricsForAisle(stowAssociateMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForAisleCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context8.next=13;break;case 9:_context8.prev=9;_context8.t0=_context8["catch"](0);dispatch(loadMetricsForAisleCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context8.stop();}}},_callee8,_this,[[0,9]]);}));return function(_x8){return _ref8.apply(this,arguments);};}();};

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_INDUCT_PACKAGE_METRICS_FOR_STATION_PAIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_METRICS_FOR_STATION_PAIR_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_METRICS_FOR_STATION_PAIR_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOAD_PICK_PACKAGE_METRICS_FOR_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOAD_PICK_PACKAGE_METRICS_FOR_STATION_PAIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOAD_STOW_ASSOCIATE_METRICS_FOR_STATION_PAIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOAD_STOW_FLOOR_METRICS_FOR_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOAD_STOW_FLOOR_METRICS_FOR_STATION_PAIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LOAD_STOW_PACKAGE_METRICS_FOR_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LOAD_STOW_PACKAGE_METRICS_FOR_STATION_PAIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getInductPackageMetricsForStationPair; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getPickPackageMetricsForStationPair; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getStowAssociateMetricsForStationPair; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getStowFloorMetricsForStationPair; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getStowPackageMetricsForStationPair; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_InductResource__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_StowResource__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resources_PickResource__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(5);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE="LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE";var LOAD_INDUCT_PACKAGE_METRICS_FOR_STATION_PAIR="LOAD_INDUCT_PACKAGE_METRICS_FOR_STATION_PAIR";var LOAD_METRICS_FOR_STATION_PAIR_CALL_BEGIN="LOAD_METRICS_FOR_STATION_PAIR_CALL_BEGIN";var LOAD_METRICS_FOR_STATION_PAIR_CALL_FAILURE="LOAD_METRICS_FOR_STATION_PAIR_CALL_FAILURE";var LOAD_PICK_PACKAGE_METRICS_FOR_NODE="LOAD_PICK_PACKAGE_METRICS_FOR_NODE";var LOAD_PICK_PACKAGE_METRICS_FOR_STATION_PAIR="LOAD_PICK_PACKAGE_METRICS_FOR_STATION_PAIR";var LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE="LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE";var LOAD_STOW_ASSOCIATE_METRICS_FOR_STATION_PAIR="LOAD_STOW_ASSOCIATE_METRICS_FOR_STATION_PAIR";var LOAD_STOW_FLOOR_METRICS_FOR_NODE="LOAD_STOW_FLOOR_METRICS_FOR_NODE";var LOAD_STOW_FLOOR_METRICS_FOR_STATION_PAIR="LOAD_STOW_FLOOR_METRICS_FOR_STATION_PAIR";var LOAD_STOW_PACKAGE_METRICS_FOR_NODE="LOAD_STOW_PACKAGE_METRICS_FOR_NODE";var LOAD_STOW_PACKAGE_METRICS_FOR_STATION_PAIR="LOAD_STOW_PACKAGE_METRICS_FOR_STATION_PAIR";var loadInductPackageMetricsForNode=function loadInductPackageMetricsForNode(totalInductPackageMetrics){return{type:LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE,totalInductPackageMetrics:totalInductPackageMetrics};};var loadInductPackageMetricsForStationPair=function loadInductPackageMetricsForStationPair(inductPackageMetricsMap){return{type:LOAD_INDUCT_PACKAGE_METRICS_FOR_STATION_PAIR,inductPackageMetricsMap:inductPackageMetricsMap};};var loadMetricsForStationPairCallBegin=function loadMetricsForStationPairCallBegin(){return{type:LOAD_METRICS_FOR_STATION_PAIR_CALL_BEGIN};};var loadMetricsForStationPairCallFailure=function loadMetricsForStationPairCallFailure(){return{type:LOAD_METRICS_FOR_STATION_PAIR_CALL_FAILURE};};var loadPickPackageMetricsForNode=function loadPickPackageMetricsForNode(totalPickPackageMetricsMap){return{type:LOAD_PICK_PACKAGE_METRICS_FOR_NODE,totalPickPackageMetricsMap:totalPickPackageMetricsMap};};var loadPickPackageMetricsForStationPair=function loadPickPackageMetricsForStationPair(pickPackageMetricsMap){return{type:LOAD_PICK_PACKAGE_METRICS_FOR_STATION_PAIR,pickPackageMetricsMap:pickPackageMetricsMap};};var loadStowAssociateMetricsForNode=function loadStowAssociateMetricsForNode(totalStowAssociateMetrics){return{type:LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE,totalStowAssociateMetrics:totalStowAssociateMetrics};};var loadStowAssociateMetricsForStationPair=function loadStowAssociateMetricsForStationPair(stowAssociateMetricsMap){return{type:LOAD_STOW_ASSOCIATE_METRICS_FOR_STATION_PAIR,stowAssociateMetricsMap:stowAssociateMetricsMap};};var loadStowFloorMetricsForNode=function loadStowFloorMetricsForNode(totalStowFloorMetricsMap){return{type:LOAD_STOW_FLOOR_METRICS_FOR_NODE,totalStowFloorMetricsMap:totalStowFloorMetricsMap};};var loadStowFloorMetricsForStationPair=function loadStowFloorMetricsForStationPair(stowFloorMetricsGroupMap){return{type:LOAD_STOW_FLOOR_METRICS_FOR_STATION_PAIR,stowFloorMetricsGroupMap:stowFloorMetricsGroupMap};};var loadStowPackageMetricsForNode=function loadStowPackageMetricsForNode(totalStowPackageMetrics){return{type:LOAD_STOW_PACKAGE_METRICS_FOR_NODE,totalStowPackageMetrics:totalStowPackageMetrics};};var loadStowPackageMetricsForStationPair=function loadStowPackageMetricsForStationPair(stowPackageMetricsMap){return{type:LOAD_STOW_PACKAGE_METRICS_FOR_STATION_PAIR,stowPackageMetricsMap:stowPackageMetricsMap};};var getInductPackageMetricsForStationPair=function getInductPackageMetricsForStationPair(nodeId){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var request,inductPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;dispatch(loadMetricsForStationPairCallBegin());request=constructInductPackageMetricsForStationPairRequest(nodeId);_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_InductResource__["a" /* getInductPackageMetrics */])(request);case 5:inductPackageMetricsMap=_context.sent;if(inductPackageMetricsMap){dispatch(loadInductPackageMetricsForNode(getTotalMetrics(inductPackageMetricsMap)));dispatch(loadInductPackageMetricsForStationPair(inductPackageMetricsMap));}else{dispatch(loadMetricsForStationPairCallFailure());}_context.next=12;break;case 9:_context.prev=9;_context.t0=_context["catch"](0);dispatch(loadMetricsForStationPairCallFailure());case 12:case"end":return _context.stop();}}},_callee,_this,[[0,9]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var getPickPackageMetricsForStationPair=function getPickPackageMetricsForStationPair(nodeId){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var request,pickPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(loadMetricsForStationPairCallBegin());_context2.prev=1;request=constructPickPackageMetricsRequest(nodeId);_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4__resources_PickResource__["a" /* getPickPackageMetrics */])(request);case 5:pickPackageMetricsMap=_context2.sent;if(pickPackageMetricsMap){dispatch(loadPickPackageMetricsForNode(getTotalMetrics(pickPackageMetricsMap)));dispatch(loadPickPackageMetricsForStationPair(pickPackageMetricsMap));}else{dispatch(loadMetricsForStationPairCallBegin());}_context2.next=12;break;case 9:_context2.prev=9;_context2.t0=_context2["catch"](1);dispatch(loadMetricsForStationPairCallBegin());case 12:case"end":return _context2.stop();}}},_callee2,_this,[[1,9]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var getStowAssociateMetricsForStationPair=function getStowAssociateMetricsForStationPair(nodeId){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var request,stowAssociateMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;dispatch(loadMetricsForStationPairCallBegin());request=constructStowAssociateMetricsForStationPairRequest(nodeId);_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_StowResource__["e" /* getStowAssociateMetrics */])(request);case 5:stowAssociateMetricsMap=_context3.sent;if(stowAssociateMetricsMap){dispatch(loadStowAssociateMetricsForNode(getTotalMetrics(stowAssociateMetricsMap)));dispatch(loadStowAssociateMetricsForStationPair(stowAssociateMetricsMap));}else{dispatch(loadMetricsForStationPairCallBegin());}_context3.next=12;break;case 9:_context3.prev=9;_context3.t0=_context3["catch"](0);dispatch(loadMetricsForStationPairCallBegin());case 12:case"end":return _context3.stop();}}},_callee3,_this,[[0,9]]);}));return function(_x3){return _ref3.apply(this,arguments);};}();};var getStowFloorMetricsForStationPair=function getStowFloorMetricsForStationPair(nodeId){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var request,stowFloorMetricsGroupMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;request=constructStowFloorMetricsForStationPairRequest(nodeId);dispatch(loadMetricsForStationPairCallBegin());_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_StowResource__["o" /* getStowFloorMetrics */])(request);case 5:stowFloorMetricsGroupMap=_context4.sent;if(stowFloorMetricsGroupMap){dispatch(loadStowFloorMetricsForNode(getTotalFloorMetrics(stowFloorMetricsGroupMap)));dispatch(loadStowFloorMetricsForStationPair(stowFloorMetricsGroupMap));}else{dispatch(loadMetricsForStationPairCallBegin());}_context4.next=12;break;case 9:_context4.prev=9;_context4.t0=_context4["catch"](0);dispatch(loadMetricsForStationPairCallBegin());case 12:case"end":return _context4.stop();}}},_callee4,_this,[[0,9]]);}));return function(_x4){return _ref4.apply(this,arguments);};}();};var getStowPackageMetricsForStationPair=function getStowPackageMetricsForStationPair(nodeId){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var request,stowPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;dispatch(loadMetricsForStationPairCallBegin());request=constructStowPackageMetricsForStationPairRequest(nodeId);_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_StowResource__["q" /* getStowPackageMetrics */])(request);case 5:stowPackageMetricsMap=_context5.sent;if(stowPackageMetricsMap){delete stowPackageMetricsMap[__WEBPACK_IMPORTED_MODULE_6__constants__["w" /* TOTAL */]];dispatch(loadStowPackageMetricsForNode(getTotalMetrics(stowPackageMetricsMap)));dispatch(loadStowPackageMetricsForStationPair(stowPackageMetricsMap));}else{dispatch(loadMetricsForStationPairCallFailure());}_context5.next=12;break;case 9:_context5.prev=9;_context5.t0=_context5["catch"](0);dispatch(loadMetricsForStationPairCallFailure());case 12:case"end":return _context5.stop();}}},_callee5,_this,[[0,9]]);}));return function(_x5){return _ref5.apply(this,arguments);};}();};function getTotalMetrics(groupedMetricsMap){var totalMetricsMap={};for(var stationPair in groupedMetricsMap){var metricsMap=groupedMetricsMap[stationPair];for(var metric in metricsMap){if(!totalMetricsMap[metric]){totalMetricsMap[metric]=metricsMap[metric];}else{totalMetricsMap[metric]=+totalMetricsMap[metric]+ +metricsMap[metric];}}}return{Total:totalMetricsMap};}function getTotalFloorMetrics(floorMetricsGroupMap){var totalFloorMetrics={};var _loop=function _loop(stationPair){var floorMetrics=Object(__WEBPACK_IMPORTED_MODULE_1__Utility__["a" /* chainWalk */])(function(){return floorMetricsGroupMap[stationPair].floorMetrics;},null);if(floorMetrics){for(var metric in floorMetrics){if(!totalFloorMetrics[metric]){totalFloorMetrics[metric]=floorMetrics[metric];}else{totalFloorMetrics[metric]=+totalFloorMetrics[metric]+ +floorMetrics[metric];}}}};for(var stationPair in floorMetricsGroupMap){_loop(stationPair);}return{Total:totalFloorMetrics};}var constructInductPackageMetricsForStationPairRequest=function constructInductPackageMetricsForStationPairRequest(nodeId){return{groupBy:"StationPair",nodeId:nodeId,metricList:[__WEBPACK_IMPORTED_MODULE_5__enums__["m" /* InductPackageMetric */].INDUCTED,__WEBPACK_IMPORTED_MODULE_5__enums__["m" /* InductPackageMetric */].CUMULATIVE_INDUCTED]};};var constructPickPackageMetricsRequest=function constructPickPackageMetricsRequest(nodeId){return{groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].STATION_PAIR,stationCode:nodeId,metricList:["PICKED"],date:Object(__WEBPACK_IMPORTED_MODULE_1__Utility__["j" /* getDateInMMDDYYYYWithOffset */])(0)};};var constructStowAssociateMetricsForStationPairRequest=function constructStowAssociateMetricsForStationPairRequest(nodeId){return{groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].STATION_PAIR,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["a" /* AssociateMetric */].ACTIVE_ASSOCIATE_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["a" /* AssociateMetric */].INACTIVE_ASSOCIATE_COUNT]};};var constructStowFloorMetricsForStationPairRequest=function constructStowFloorMetricsForStationPairRequest(nodeId){return{groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].STATION_PAIR,filters:{NODE:[nodeId]},metrics:["FLOORS_COUNT_MISSING_CART"]};};var constructStowPackageMetricsForStationPairRequest=function constructStowPackageMetricsForStationPairRequest(nodeId){return{groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].STATION_PAIR,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].STOW_RATE,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].PROBLEM_SOLVE_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].STOWED_COUNT]};};

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_METRICS_FOR_ROUTE_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOAD_STOW_PACKAGE_METRICS_FOR_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_PLANNED_PACKAGE_METRICS_FOR_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_INDUCT_PACKAGE_METRICS_FOR_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOAD_STOW_ASSOCIATE_METRICS_FOR_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_METRICS_FOR_ROUTE_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getMetricsForRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_StowResource__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MetricUtility__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handler_LocaleHandler__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utility__ = __webpack_require__(10);
var _this=this;var fetchPlannedPackageMetrics=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(nodeId){var metricName,request,startTime,routesMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:metricName="getPlannedPackageMetrics";request={fieldsRequired:["ID","CODE"],filters:{NODE:[nodeId]}};startTime=Date.now();_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["r" /* getStowRoutes */])(request);case 5:routesMap=_context2.sent;if(!routesMap){_context2.next=11;break;}Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context2.abrupt("return",routesMap);case 11:Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 12:case"end":return _context2.stop();}}},_callee2,this);}));return function fetchPlannedPackageMetrics(_x2){return _ref2.apply(this,arguments);};}();var fetchStowPackageMetricsByRoute=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(nodeId,routeIds){var metricName,request,startTime,stowPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:metricName="fetchStowPackageMetricsByRoute";request={groupBy:"ROUTE_ID",filters:{NODE:[nodeId],ROUTE_ID:routeIds},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].STOW_RATE,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].SCAN_COMPLIANCE,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].PROBLEM_SOLVE_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].FSAF,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].STOWED_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].CURRENT_INDUCTED_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].PLANNED_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].STOW_VS_PLAN]};startTime=Date.now();_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["q" /* getStowPackageMetrics */])(request);case 5:stowPackageMetricsMap=_context3.sent;if(!stowPackageMetricsMap){_context3.next=11;break;}Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context3.abrupt("return",stowPackageMetricsMap);case 11:Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 12:case"end":return _context3.stop();}}},_callee3,this);}));return function fetchStowPackageMetricsByRoute(_x3,_x4){return _ref3.apply(this,arguments);};}();var fetchStowAssociateMetricsByRoute=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(nodeId){var metricName,request,startTime,stowAssociateMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:metricName="fetchStowAssociateMetricsByRoute";request={groupBy:"ROUTE_ID",filters:{NODE:[nodeId],DRS:[__WEBPACK_IMPORTED_MODULE_3__constants__["x" /* TRUE */]]},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["a" /* AssociateMetric */].ACTIVE_ASSOCIATE_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["a" /* AssociateMetric */].INACTIVE_ASSOCIATE_COUNT]};startTime=Date.now();_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["e" /* getStowAssociateMetrics */])(request);case 5:stowAssociateMetricsMap=_context4.sent;if(!stowAssociateMetricsMap){_context4.next=11;break;}Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context4.abrupt("return",stowAssociateMetricsMap);case 11:Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 12:case"end":return _context4.stop();}}},_callee4,this);}));return function fetchStowAssociateMetricsByRoute(_x5){return _ref4.apply(this,arguments);};}();/*async function fetchInductPackageMetricsByRoute(nodeId, routeIds) {

    const metricName = "fetchInductPackageMetricsByRoute";

    const request = {
        nodeId: nodeId,
        groupBy: "Cluster",
        metricList: ["RECEIVED"],
        filters: {
            'RouteId': routeIds
        }
    }

    const startTime = Date.now();
    const inductPackageMetricsMap = await getInductPackageMetrics(request);

    if (inductPackageMetricsMap) {
        publishTime(metricProcessName, metricName, startTime);
        return inductPackageMetricsMap;
    } else {
        publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
    }
}*/function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// import {getInductPackageMetrics} from "../resources/InductResource";
var LOAD_METRICS_FOR_ROUTE_CALL_BEGIN="LOAD_METRICS_FOR_ROUTE_CALL_BEGIN";var LOAD_STOW_PACKAGE_METRICS_FOR_ROUTE="LOAD_STOW_PACKAGE_METRICS_FOR_ROUTE";var LOAD_PLANNED_PACKAGE_METRICS_FOR_ROUTE="LOAD_PLANNED_PACKAGE_METRICS_FOR_ROUTE";var LOAD_INDUCT_PACKAGE_METRICS_FOR_ROUTE="LOAD_INDUCT_PACKAGE_METRICS_FOR_ROUTE";var LOAD_STOW_ASSOCIATE_METRICS_FOR_ROUTE="LOAD_STOW_ASSOCIATE_METRICS_FOR_ROUTE";var LOAD_METRICS_FOR_ROUTE_CALL_FAILURE="LOAD_METRICS_FOR_ROUTE_CALL_FAILURE";var metricProcessName="SCC_STOW_ROUTE";var loadMetricsForRouteCallBegin=function loadMetricsForRouteCallBegin(){return{type:LOAD_METRICS_FOR_ROUTE_CALL_BEGIN};};var loadStowPackageMetricsForRoute=function loadStowPackageMetricsForRoute(stowPackageMetricsMap){return{type:LOAD_STOW_PACKAGE_METRICS_FOR_ROUTE,stowPackageMetricsMap:stowPackageMetricsMap};};var loadPlannedPackageMetricsForRoute=function loadPlannedPackageMetricsForRoute(plannedPackageMetricsMap){return{type:LOAD_PLANNED_PACKAGE_METRICS_FOR_ROUTE,plannedPackageMetricsMap:plannedPackageMetricsMap};};/*const loadInductPackageMetricsForRoute = (inductPackageMetricsMap) => ({
    type: LOAD_INDUCT_PACKAGE_METRICS_FOR_ROUTE,
    inductPackageMetricsMap
});*/var loadStowAssociateMetricsForRoute=function loadStowAssociateMetricsForRoute(stowAssociateMetricsMap){return{type:LOAD_STOW_ASSOCIATE_METRICS_FOR_ROUTE,stowAssociateMetricsMap:stowAssociateMetricsMap};};var loadMetricsForRouteCallFailure=function loadMetricsForRouteCallFailure(){return{type:LOAD_METRICS_FOR_ROUTE_CALL_FAILURE};};function dedupeRouteIds(routesMap){var routeCodeToId={};for(var routeId in routesMap){var route=routesMap[routeId];var oldRouteId=routeCodeToId[route.routeCode];//If two routeIds have same routeCode, we are keeping only the newer one
if(!oldRouteId||oldRouteId.localeCompare(routeId,Object(__WEBPACK_IMPORTED_MODULE_4__handler_LocaleHandler__["b" /* getLocale */])(),{numeric:true})<0){routeCodeToId[route.routeCode]=routeId;if(oldRouteId){delete routesMap[oldRouteId];}}}}var getMetricsForRoute=function getMetricsForRoute(nodeId,capability){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var routesMap,routeIds,stowPackageMetrics,stowAssociateMetrics;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;dispatch(loadMetricsForRouteCallBegin());//fetch route-ids and planned package count
_context.next=4;return fetchPlannedPackageMetrics(nodeId);case 4:routesMap=_context.sent;if(!Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["t" /* isCapabilityARorSSD */])(capability)){dedupeRouteIds(routesMap);}if(routesMap){_context.next=10;break;}dispatch(loadMetricsForRouteCallFailure());_context.next=21;break;case 10:dispatch(loadPlannedPackageMetricsForRoute(routesMap));routeIds=Object.keys(routesMap);if(!routeIds.length){_context.next=21;break;}_context.next=15;return fetchStowPackageMetricsByRoute(nodeId,routeIds);case 15:stowPackageMetrics=_context.sent;dispatch(loadStowPackageMetricsForRoute(stowPackageMetrics));/* Dev pending

                    //fetch induct package metrics
                    const inductPackageMetrics = await fetchInductPackageMetricsByRoute(nodeId, routeIds);
                    dispatch(loadInductPackageMetricsForRoute(inductPackageMetrics));

                    *///fetch stow associate metrics
_context.next=19;return fetchStowAssociateMetricsByRoute(nodeId);case 19:stowAssociateMetrics=_context.sent;dispatch(loadStowAssociateMetricsForRoute(stowAssociateMetrics));case 21:_context.next=26;break;case 23:_context.prev=23;_context.t0=_context["catch"](0);dispatch(loadMetricsForRouteCallFailure());case 26:case"end":return _context.stop();}}},_callee,_this,[[0,23]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_METRICS_FOR_ZONE_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_METRICS_FOR_ZONE_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_STOW_ASSOCIATE_METRICS_FOR_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOAD_STOW_PACKAGE_METRICS_FOR_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOAD_STOW_PACKAGE_METRICS_FOR_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getStowPackageMetricsForZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getStowAssociateMetricsForZone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_StowResource__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(5);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var LOAD_METRICS_FOR_ZONE_CALL_BEGIN="LOAD_METRICS_FOR_ZONE_CALL_BEGIN";var LOAD_METRICS_FOR_ZONE_CALL_FAILURE="LOAD_METRICS_FOR_ZONE_CALL_FAILURE";var LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE="LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE";var LOAD_STOW_ASSOCIATE_METRICS_FOR_ZONE="LOAD_STOW_ASSOCIATE_METRICS_FOR_ZONE";var LOAD_STOW_PACKAGE_METRICS_FOR_NODE="LOAD_STOW_PACKAGE_METRICS_FOR_NODE";var LOAD_STOW_PACKAGE_METRICS_FOR_ZONE="LOAD_STOW_PACKAGE_METRICS_FOR_ZONE";var loadMetricsForZoneCallBegin=function loadMetricsForZoneCallBegin(){return{type:LOAD_METRICS_FOR_ZONE_CALL_BEGIN};};var loadMetricsForZoneCallFailure=function loadMetricsForZoneCallFailure(){return{type:LOAD_METRICS_FOR_ZONE_CALL_FAILURE};};var loadStowAssociateMetricsForNode=function loadStowAssociateMetricsForNode(totalStowAssociateMetrics){return{type:LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE,totalStowAssociateMetrics:totalStowAssociateMetrics};};var loadStowAssociateMetricsForZone=function loadStowAssociateMetricsForZone(stowAssociateMetricsMap){return{type:LOAD_STOW_ASSOCIATE_METRICS_FOR_ZONE,stowAssociateMetricsMap:stowAssociateMetricsMap};};var loadStowPackageMetricsForNode=function loadStowPackageMetricsForNode(totalStowPackageMetrics){return{type:LOAD_STOW_PACKAGE_METRICS_FOR_NODE,totalStowPackageMetrics:totalStowPackageMetrics};};var loadStowPackageMetricsForZone=function loadStowPackageMetricsForZone(stowPackageMetricsMap){return{type:LOAD_STOW_PACKAGE_METRICS_FOR_ZONE,stowPackageMetricsMap:stowPackageMetricsMap};};var getStowPackageMetricsForZone=function getStowPackageMetricsForZone(nodeId,cycles,cycleIds){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var request,stowPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;dispatch(loadMetricsForZoneCallBegin());request=constructStowPackageMetricsForZoneRequest(nodeId,cycles,cycleIds);_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["q" /* getStowPackageMetrics */])(request);case 5:stowPackageMetricsMap=_context.sent;if(stowPackageMetricsMap){dispatch(loadStowPackageMetricsForNode(getStowPackageMetricsForNode(stowPackageMetricsMap)));removeUnwantedZones(stowPackageMetricsMap);dispatch(loadStowPackageMetricsForZone(stowPackageMetricsMap));}else{dispatch(loadMetricsForZoneCallFailure());}_context.next=12;break;case 9:_context.prev=9;_context.t0=_context["catch"](0);dispatch(loadMetricsForZoneCallFailure());case 12:case"end":return _context.stop();}}},_callee,_this,[[0,9]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var getStowAssociateMetricsForZone=function getStowAssociateMetricsForZone(nodeId,cycles){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var request,stowAssociateMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;dispatch(loadMetricsForZoneCallBegin());request=constructStowAssociateMetricsForZoneRequest(nodeId,cycles);_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["e" /* getStowAssociateMetrics */])(request);case 5:stowAssociateMetricsMap=_context2.sent;if(stowAssociateMetricsMap){removeUnwantedZones(stowAssociateMetricsMap);dispatch(loadStowAssociateMetricsForNode(getTotalMetrics(stowAssociateMetricsMap)));dispatch(loadStowAssociateMetricsForZone(stowAssociateMetricsMap));}else{dispatch(loadMetricsForZoneCallFailure());}_context2.next=12;break;case 9:_context2.prev=9;_context2.t0=_context2["catch"](0);dispatch(loadMetricsForZoneCallFailure());case 12:case"end":return _context2.stop();}}},_callee2,_this,[[0,9]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var constructStowAssociateMetricsForZoneRequest=function constructStowAssociateMetricsForZoneRequest(nodeId,cycles){var request={groupBy:__WEBPACK_IMPORTED_MODULE_2__enums__["o" /* Resource */].ZONE,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_2__enums__["a" /* AssociateMetric */].ACTIVE_ASSOCIATE_COUNT,__WEBPACK_IMPORTED_MODULE_2__enums__["a" /* AssociateMetric */].INACTIVE_ASSOCIATE_COUNT]};cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CYCLE */]]=cycles;}return request;};var constructStowPackageMetricsForZoneRequest=function constructStowPackageMetricsForZoneRequest(nodeId,cycles,cycleIds){var request={groupBy:__WEBPACK_IMPORTED_MODULE_2__enums__["o" /* Resource */].ZONE,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_2__enums__["p" /* StowPackageMetric */].STOW_RATE,__WEBPACK_IMPORTED_MODULE_2__enums__["p" /* StowPackageMetric */].SCAN_COMPLIANCE,__WEBPACK_IMPORTED_MODULE_2__enums__["p" /* StowPackageMetric */].PROBLEM_SOLVE_COUNT,__WEBPACK_IMPORTED_MODULE_2__enums__["p" /* StowPackageMetric */].STOWED_COUNT,__WEBPACK_IMPORTED_MODULE_2__enums__["p" /* StowPackageMetric */].CURRENT_INDUCTED_COUNT,__WEBPACK_IMPORTED_MODULE_2__enums__["p" /* StowPackageMetric */].CURRENT_STOWED_COUNT],isAggregationRequired:true};cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* CYCLE_ID */]]=cycleIds;}return request;};var getTotalMetrics=function getTotalMetrics(groupedMetricsMap){var totalZone={};for(var Zone in groupedMetricsMap){var metricsMap=groupedMetricsMap[Zone];for(var metric in metricsMap){if(!totalZone[metric]){totalZone[metric]=metricsMap[metric];}else{totalZone[metric]=+totalZone[metric]+ +metricsMap[metric];}}}return{Total:totalZone};};var getStowPackageMetricsForNode=function getStowPackageMetricsForNode(stowPackageMetricsMap){return{Total:stowPackageMetricsMap[__WEBPACK_IMPORTED_MODULE_3__constants__["w" /* TOTAL */]]};};var removeUnwantedZones=function removeUnwantedZones(metricsMap){delete metricsMap[__WEBPACK_IMPORTED_MODULE_3__constants__["w" /* TOTAL */]];};

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_FLOOR_LOCATION_METRICS_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOAD_STOW_PACKAGE_METRICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOAD_TOTAL_STOW_PACKAGE_METRICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_STOW_FLOOR_METRICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_STOW_ASSOCIATE_METRICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_FLOOR_LOCATION_METRICS_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getStowPackageMetricsForFloorLocation; });
/* unused harmony export getStowAssociateMetricsForFloorLocation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getStowFloorMetricsForFloorLocation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_StowResource__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MetricUtility__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums__ = __webpack_require__(7);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var LOAD_FLOOR_LOCATION_METRICS_CALL_BEGIN="LOAD_FLOOR_LOCATION_METRICS_CALL_BEGIN";var LOAD_STOW_PACKAGE_METRICS="LOAD_STOW_PACKAGE_METRICS";var LOAD_TOTAL_STOW_PACKAGE_METRICS="LOAD_TOTAL_STOW_PACKAGE_METRICS";var LOAD_STOW_FLOOR_METRICS="LOAD_STOW_FLOOR_METRICS";var LOAD_STOW_ASSOCIATE_METRICS="LOAD_STOW_ASSOCIATE_METRICS";var LOAD_FLOOR_LOCATION_METRICS_CALL_FAILURE="LOAD_FLOOR_LOCATION_METRICS_CALL_FAILURE";var metricProcessName="SCC_STOW_FLOOR_LOCATION";var loadMetricsForFloorLocationCallBegin=function loadMetricsForFloorLocationCallBegin(){return{type:LOAD_FLOOR_LOCATION_METRICS_CALL_BEGIN};};var loadStowPackageMetricsForFloorLocation=function loadStowPackageMetricsForFloorLocation(stowPackageMetricsMap){return{type:LOAD_STOW_PACKAGE_METRICS,stowPackageMetricsMap:stowPackageMetricsMap};};var loadStowPackageTotalMetricsForFloorLocation=function loadStowPackageTotalMetricsForFloorLocation(totalStowPackageMetrics){return{type:LOAD_TOTAL_STOW_PACKAGE_METRICS,totalStowPackageMetrics:totalStowPackageMetrics};};var loadStowFloorMetrics=function loadStowFloorMetrics(stowFloorMetricsMap){return{type:LOAD_STOW_FLOOR_METRICS,stowFloorMetricsMap:stowFloorMetricsMap};};var loadStowAssociateMetricsForFloorLocation=function loadStowAssociateMetricsForFloorLocation(stowAssociateMetricsMap){return{type:LOAD_STOW_ASSOCIATE_METRICS,stowAssociateMetricsMap:stowAssociateMetricsMap};};var loadMetricsForFloorLocationCallFailure=function loadMetricsForFloorLocationCallFailure(){return{type:LOAD_FLOOR_LOCATION_METRICS_CALL_FAILURE};};var getStowPackageMetricsForFloorLocation=function getStowPackageMetricsForFloorLocation(nodeId,featureStatus){var metricName="getStowPackageMetrics";var request={filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_4__enums__["p" /* StowPackageMetric */].CURRENT_INDUCTED_COUNT,__WEBPACK_IMPORTED_MODULE_4__enums__["p" /* StowPackageMetric */].CURRENT_STOWED_COUNT]};//To be made SIDELINE_V2 by default once stable
if(featureStatus&&featureStatus[__WEBPACK_IMPORTED_MODULE_3__constants__["j" /* FEATURES */].SIDELINE_STOW_V2]){request.groupBy=__WEBPACK_IMPORTED_MODULE_4__enums__["o" /* Resource */].FLOOR;request.filters.SIDELINE_V2=[__WEBPACK_IMPORTED_MODULE_3__constants__["x" /* TRUE */]];}else{request.groupBy=__WEBPACK_IMPORTED_MODULE_4__enums__["o" /* Resource */].FLOOR_AND_SIDELINE_UNTIL_TIME;request.filters.SIDELINE=[__WEBPACK_IMPORTED_MODULE_3__constants__["x" /* TRUE */]];}//Stow metrics
request.metrics.push(__WEBPACK_IMPORTED_MODULE_4__enums__["p" /* StowPackageMetric */].CURRENT_SCAN_COMPLIANCE);request.metrics.push(__WEBPACK_IMPORTED_MODULE_4__enums__["p" /* StowPackageMetric */].STOW_RATE);request.isAggregationRequired=true;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var startTime,stowPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;dispatch(loadMetricsForFloorLocationCallBegin());startTime=Date.now();_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["q" /* getStowPackageMetrics */])(request);case 5:stowPackageMetricsMap=_context.sent;if(stowPackageMetricsMap){dispatch(loadStowPackageTotalMetricsForFloorLocation(stowPackageMetricsMap[__WEBPACK_IMPORTED_MODULE_3__constants__["w" /* TOTAL */]]));removeUnwantedMetrics(stowPackageMetricsMap);dispatch(loadStowPackageMetricsForFloorLocation(stowPackageMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForFloorLocationCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context.next=13;break;case 9:_context.prev=9;_context.t0=_context["catch"](0);dispatch(loadMetricsForFloorLocationCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context.stop();}}},_callee,_this,[[0,9]]);}));return function(_x){return _ref.apply(this,arguments);};}();};/**
 * TODO: Unused for now, associate metrics will be added later.
 */var getStowAssociateMetricsForFloorLocation=function getStowAssociateMetricsForFloorLocation(nodeId){var metricName="getStowAssociateMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_4__enums__["o" /* Resource */].FLOOR_AND_SIDELINE_UNTIL_TIME,filters:{NODE:[nodeId],SIDELINE:[__WEBPACK_IMPORTED_MODULE_3__constants__["x" /* TRUE */]]},metrics:[__WEBPACK_IMPORTED_MODULE_4__enums__["a" /* AssociateMetric */].ACTIVE_ASSOCIATE_COUNT,__WEBPACK_IMPORTED_MODULE_4__enums__["a" /* AssociateMetric */].INACTIVE_ASSOCIATE_COUNT]};return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var startTime,stowAssociateMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;dispatch(loadMetricsForFloorLocationCallBegin());startTime=Date.now();_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["e" /* getStowAssociateMetrics */])(request);case 5:stowAssociateMetricsMap=_context2.sent;if(stowAssociateMetricsMap){removeUnwantedMetrics(stowAssociateMetricsMap);dispatch(loadStowAssociateMetricsForFloorLocation(stowAssociateMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForFloorLocationCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context2.next=13;break;case 9:_context2.prev=9;_context2.t0=_context2["catch"](0);dispatch(loadMetricsForFloorLocationCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context2.stop();}}},_callee2,_this,[[0,9]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var getStowFloorMetricsForFloorLocation=function getStowFloorMetricsForFloorLocation(nodeId,featureStatus){var metricName="getStowFloorMetrics";var request={filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_4__enums__["k" /* FloorMetric */].ATTACHED_CART_COUNT]};if(featureStatus&&featureStatus[__WEBPACK_IMPORTED_MODULE_3__constants__["j" /* FEATURES */].SIDELINE_STOW_V2]){request.groupBy=__WEBPACK_IMPORTED_MODULE_4__enums__["o" /* Resource */].FLOOR;request.filters.SIDELINE_V2=[__WEBPACK_IMPORTED_MODULE_3__constants__["x" /* TRUE */]];}else{request.groupBy=__WEBPACK_IMPORTED_MODULE_4__enums__["o" /* Resource */].FLOOR_AND_SIDELINE_UNTIL_TIME;request.filters.SIDELINE=[__WEBPACK_IMPORTED_MODULE_3__constants__["x" /* TRUE */]];}return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var startTime,stowFloorMetricsGroupMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;dispatch(loadMetricsForFloorLocationCallBegin());startTime=Date.now();_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["o" /* getStowFloorMetrics */])(request);case 5:stowFloorMetricsGroupMap=_context3.sent;if(stowFloorMetricsGroupMap){removeUnwantedMetrics(stowFloorMetricsGroupMap);dispatch(loadStowFloorMetrics(stowFloorMetricsGroupMap));Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForFloorLocationCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context3.next=13;break;case 9:_context3.prev=9;_context3.t0=_context3["catch"](0);dispatch(loadMetricsForFloorLocationCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context3.stop();}}},_callee3,_this,[[0,9]]);}));return function(_x3){return _ref3.apply(this,arguments);};}();};function removeUnwantedMetrics(metricsMap){// aggregation not required
delete metricsMap[__WEBPACK_IMPORTED_MODULE_3__constants__["w" /* TOTAL */]];}

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_METRICS_FOR_CART_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_METRICS_FOR_CART_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_STOW_PACKAGE_METRICS_FOR_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getStowPackageMetricsForCart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_StowResource__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utility__ = __webpack_require__(10);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var LOAD_METRICS_FOR_CART_CALL_BEGIN="LOAD_METRICS_FOR_CART_CALL_BEGIN";var LOAD_METRICS_FOR_CART_CALL_FAILURE="LOAD_METRICS_FOR_CART_CALL_FAILURE";var LOAD_STOW_PACKAGE_METRICS_FOR_CART="LOAD_STOW_PACKAGE_METRICS_FOR_CART";var loadMetricsForCartCallBegin=function loadMetricsForCartCallBegin(){return{type:LOAD_METRICS_FOR_CART_CALL_BEGIN};};var loadMetricsForCartCallFailure=function loadMetricsForCartCallFailure(){return{type:LOAD_METRICS_FOR_CART_CALL_FAILURE};};var loadStowPackageMetricsForCart=function loadStowPackageMetricsForCart(stowPackageMetricsMap){return{type:LOAD_STOW_PACKAGE_METRICS_FOR_CART,stowPackageMetricsMap:stowPackageMetricsMap};};var getStowPackageMetricsForCart=function getStowPackageMetricsForCart(nodeId,featureStatus,floorLocation,reInductDate){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var request,stowPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(loadMetricsForCartCallBegin());_context.prev=1;request=constructStowPackageMetricsRequest(nodeId,featureStatus,floorLocation,reInductDate);_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["q" /* getStowPackageMetrics */])(request);case 5:stowPackageMetricsMap=_context.sent;if(stowPackageMetricsMap){// aggregation not required
delete stowPackageMetricsMap[__WEBPACK_IMPORTED_MODULE_3__constants__["w" /* TOTAL */]];dispatch(loadStowPackageMetricsForCart(stowPackageMetricsMap));}else{dispatch(loadMetricsForCartCallFailure());}_context.next=12;break;case 9:_context.prev=9;_context.t0=_context["catch"](1);dispatch(loadMetricsForCartCallFailure());case 12:case"end":return _context.stop();}}},_callee,_this,[[1,9]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var constructStowPackageMetricsRequest=function constructStowPackageMetricsRequest(nodeId,featureStatus,floorLocation,reInductDate){if(featureStatus&&featureStatus[__WEBPACK_IMPORTED_MODULE_3__constants__["j" /* FEATURES */].SIDELINE_STOW_V2]){return{groupBy:__WEBPACK_IMPORTED_MODULE_2__enums__["o" /* Resource */].CART,filters:{NODE:[nodeId],SIDELINE_V2:[__WEBPACK_IMPORTED_MODULE_3__constants__["x" /* TRUE */]],FLOOR_LOCATION:[floorLocation]},rangeFilters:[Object(__WEBPACK_IMPORTED_MODULE_4__Utility__["q" /* getSidelineRangeFilter */])(reInductDate)],metrics:[__WEBPACK_IMPORTED_MODULE_2__enums__["p" /* StowPackageMetric */].CURRENT_STOWED_COUNT]};}return{groupBy:__WEBPACK_IMPORTED_MODULE_2__enums__["o" /* Resource */].CART,filters:{NODE:[nodeId],SIDELINE:[__WEBPACK_IMPORTED_MODULE_3__constants__["x" /* TRUE */]],FLOOR_LOCATION:[floorLocation],SIDELINE_UNTIL_TIME:[reInductDate]},metrics:[__WEBPACK_IMPORTED_MODULE_2__enums__["p" /* StowPackageMetric */].CURRENT_STOWED_COUNT]};};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SelectOption", {
  enumerable: true,
  get: function get() {
    return _selectOption["default"];
  }
});
Object.defineProperty(exports, "SelectOptionGroup", {
  enumerable: true,
  get: function get() {
    return _selectOptionGroup["default"];
  }
});
exports["default"] = void 0;

var _select = _interopRequireDefault(__webpack_require__(634));

var _selectOption = _interopRequireDefault(__webpack_require__(174));

var _selectOptionGroup = _interopRequireDefault(__webpack_require__(275));

var _default = _select["default"];
exports["default"] = _default;

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_heading__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_MobileDisplay__ = __webpack_require__(651);
/**
 * Returns the page heading and description
 * @param head
 * @param headAlt
 * @param desc
 * @param descAlt
 * @param tab
 * @param tabAlt
 * @return JSX.Element
 */var PageHeader=function PageHeader(_ref){var head=_ref.head,headAlt=_ref.headAlt,desc=_ref.desc,descAlt=_ref.descAlt,tab=_ref.tab,tabAlt=_ref.tabAlt;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,{spacing:"none"},tab&&tabAlt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_MobileDisplay__["a" /* MobileDisplay */],{visibility:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a,{type:"h100",spacingTop:"medium",color:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:tab,defaultMessage:tabAlt}))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_heading___default.a,{level:2,type:"h400",alignment:"left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:head,defaultMessage:headAlt})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_MobileDisplay__["a" /* MobileDisplay */],{visibility:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a,{color:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:desc,defaultMessage:descAlt}))));};PageHeader.propTypes={head:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,headAlt:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,desc:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,descAlt:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(673),
    listCacheDelete = __webpack_require__(674),
    listCacheGet = __webpack_require__(675),
    listCacheHas = __webpack_require__(676),
    listCacheSet = __webpack_require__(677);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(288);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(55);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(70);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(697);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(184);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(328)();
}


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__batch__ = __webpack_require__(194);
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var batch = Object(__WEBPACK_IMPORTED_MODULE_0__batch__["a" /* getBatch */])(); // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?

  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      batch(function () {
        for (var i = 0; i < listeners.length; i++) {
          listeners[i]();
        }
      });
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub) {
    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.handleChangeWrapper = function handleChangeWrapper() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* unused harmony export compose */
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(347);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;

  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.REPLACE });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';

  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var store = createStore.apply(undefined, args);
      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(undefined, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */
function isCrushed() {}

if (false) {
  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 134 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    textFontFamilyAmazonEmber: "\"Amazon Ember\", \"Amazon Ember Arabic\", Arial, sans-serif",
    textFontFamilyAmazonEmberArabic: "\"Amazon Ember Arabic\", \"Amazon Ember\", Arial, sans-serif",
    textFontFamilyAmazonEmberDisplay: "\"Amazon Ember Display\", \"Amazon Ember\", Arial, sans-serif",
    textFontFamilyAmazonEmberMonospace: "\"Amazon Ember Monospace\", \"Courier New\", Courier, monospace",
    textFontFamilyBookerly: "Bookerly, Georgia, serif",
    textFontFamilyBookerlyDisplay: "\"Bookerly Display\", Georgia, serif",
    textFontSizeD300: 76,
    textFontSizeD200: 54,
    textFontSizeD100: 48,
    textFontSizeD50: 36,
    textFontSizeH600: 36,
    textFontSizeH500: 28,
    textFontSizeH400: 24,
    textFontSizeH300: 20,
    textFontSizeH200: 18,
    textFontSizeH100: 16,
    textFontSizeB500: 20,
    textFontSizeB400: 18,
    textFontSizeB300: 16,
    textFontSizeB200: 14,
    textFontSizeB100: 12,
    textFontWeightD300: 200,
    textFontWeightD200: 200,
    textFontWeightD100: 200,
    textFontWeightD50: 200,
    textFontWeightH600: 600,
    textFontWeightH500: 600,
    textFontWeightH400: 600,
    textFontWeightH300: 600,
    textFontWeightH200: 600,
    textFontWeightH100: 600,
    textFontWeightB500: 400,
    textFontWeightB400: 400,
    textFontWeightB300: 400,
    textFontWeightB200: 400,
    textFontWeightB100: 400,
    textLineHeightD300: "96px",
    textLineHeightD200: "64px",
    textLineHeightD100: "60px",
    textLineHeightD50: "48px",
    textLineHeightH600: "48px",
    textLineHeightH500: "36px",
    textLineHeightH400: "32px",
    textLineHeightH300: "24px",
    textLineHeightH200: "24px",
    textLineHeightH100: "20px",
    textLineHeightB500: "28px",
    textLineHeightB400: "28px",
    textLineHeightB300: "24px",
    textLineHeightB200: "20px",
    textLineHeightB100: "16px",
    textColorPrimary: tokens.themeForegroundPrimaryDefault,
    textColorSecondary: tokens.themeForegroundSecondaryDefault,
    textColorError: tokens.themeForegroundPrimaryError,
    textColorInverted: tokens.themeForegroundInvertedDefault,
    textListSpacingHorizontal: 20,
    textListSpacingVertical: 8
  }
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _focus = _interopRequireDefault(__webpack_require__(381));

var _default = _focus["default"];
exports["default"] = _default;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var _default = canUseDOM;
exports["default"] = _default;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronRightSmallData: "data:image/svg+xml,%3csvg width='6' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 9l4-4-4-4' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconChevronRightSmallRtlSvg: "data:image/svg+xml,%3csvg width='6' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5 1L1 5l4 4' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconChevronRightSmallWidth: 6,
  iconChevronRightSmallHeight: 10
};

/***/ }),
/* 138 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 139 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 140 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var addDebouncedEventListener = function addDebouncedEventListener(node, event, listener, options) {
  var timeout = null;

  var debouncedListener = function debouncedListener(event) {
    window.cancelAnimationFrame(timeout);

    if (window && window.requestAnimationFrame) {
      timeout = window.requestAnimationFrame(function () {
        return listener(event);
      });
    }
  };

  if (node && node.addEventListener) {
    node.addEventListener(event, debouncedListener, options);
  }

  return function () {
    window.cancelAnimationFrame(timeout);

    if (node && node.removeEventListener) {
      node.removeEventListener(event, debouncedListener, options);
    }
  };
};

var _default = addDebouncedEventListener;
exports["default"] = _default;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65),
    root = __webpack_require__(53);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(432),
    mapCacheDelete = __webpack_require__(439),
    mapCacheGet = __webpack_require__(441),
    mapCacheHas = __webpack_require__(442),
    mapCacheSet = __webpack_require__(443);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(143),
    setCacheAdd = __webpack_require__(445),
    setCacheHas = __webpack_require__(446);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 145 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 146 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(459),
    isObjectLike = __webpack_require__(62);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(42),
    isSymbol = __webpack_require__(99);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 149 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(152),
    baseIteratee = __webpack_require__(102),
    toInteger = __webpack_require__(153);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 152 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(215);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 154 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCloseData: "data:image/svg+xml,%3csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1.76 1.76l8.48 8.48M10.24 1.76l-8.48 8.48'/%3e%3c/g%3e%3c/svg%3e",
  iconCloseWidth: 12,
  iconCloseHeight: 12
};

/***/ }),
/* 155 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    buttonMotionDuration: "100ms",
    buttonMotionFunction: "ease",
    buttonBackgroundColorPrimaryDefault: tokens.themeForegroundAccentDefault,
    buttonBackgroundColorPrimaryHover: tokens.themeForegroundAccentHover,
    buttonBackgroundColorPrimaryPressed: tokens.themeForegroundAccentPressed,
    buttonBackgroundColorPrimaryDisabled: tokens.themeForegroundAccentDisabled,
    buttonBackgroundColorSecondaryDefault: tokens.themeBackgroundTertiaryDefault,
    buttonBackgroundColorSecondaryHover: tokens.themeBackgroundTertiaryHover,
    buttonBackgroundColorSecondaryPressed: tokens.themeBackgroundTertiaryPressed,
    buttonBackgroundColorSecondaryDisabled: tokens.themeBackgroundTertiaryDisabled,
    buttonBackgroundColorTertiaryDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorTertiaryHover: tokens.themeForegroundAccentHover,
    buttonBackgroundColorTertiaryPressed: tokens.themeForegroundAccentPressed,
    buttonBackgroundColorLinkDarkBackdropDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorLinkDarkBackdropHover: "rgba(255, 255, 255, 0.22)",
    buttonBackgroundColorLinkDarkBackdropPressed: "rgba(255, 255, 255, 0.36)",
    buttonBackgroundColorLinkLightBackdropDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorLinkLightBackdropHover: "rgba(11, 12, 12, 0.1)",
    buttonBackgroundColorLinkLightBackdropPressed: "rgba(11, 12, 12, 0.26)",
    buttonBackgroundColorIconDarkBackdropDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorIconDarkBackdropHover: "rgba(255, 255, 255, 0.22)",
    buttonBackgroundColorIconDarkBackdropPressed: "rgba(255, 255, 255, 0.36)",
    buttonBackgroundColorIconLightBackdropDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorIconLightBackdropHover: "rgba(11, 12, 12, 0.1)",
    buttonBackgroundColorIconLightBackdropPressed: "rgba(11, 12, 12, 0.26)",
    buttonForegroundColorPrimaryDefault: tokens.themeForegroundInvertedDefault,
    buttonForegroundColorPrimaryDisabled: tokens.themeBackgroundAccentDisabled,
    buttonForegroundColorSecondaryDefault: tokens.themeForegroundPrimaryDefault,
    buttonForegroundColorSecondaryDisabled: tokens.themeForegroundTertiaryDisabled,
    buttonForegroundColorTertiaryDefault: tokens.themeForegroundAccentDefault,
    buttonForegroundColorTertiaryHover: tokens.themeForegroundInvertedDefault,
    buttonForegroundColorTertiaryFocus: tokens.themeForegroundInvertedDefault,
    buttonForegroundColorTertiaryPressed: tokens.themeForegroundInvertedDefault,
    buttonForegroundColorTertiaryDisabled: tokens.themeBorderAccentDisabled,
    buttonForegroundColorLinkDarkBackdropDefault: tokens.themePalette300,
    buttonForegroundColorLinkDarkBackdropHover: tokens.themePalette200,
    buttonForegroundColorLinkDarkBackdropPressed: tokens.themePalette100,
    buttonForegroundColorLinkDarkBackdropDisabled: tokens.themePaletteMuted500,
    buttonForegroundColorLinkLightBackdropDefault: tokens.themePalette500,
    buttonForegroundColorLinkLightBackdropHover: tokens.themePalette600,
    buttonForegroundColorLinkLightBackdropPressed: tokens.themePalette700,
    buttonForegroundColorLinkLightBackdropDisabled: tokens.themePaletteMuted200,
    buttonForegroundColorIconDarkBackdropDefault: "#FFFFFF",
    buttonForegroundColorIconDarkBackdropDisabled: "#697576",
    buttonForegroundColorIconLightBackdropDefault: "#232F3E",
    buttonForegroundColorIconLightBackdropDisabled: "#BBC0C1",
    buttonFontSizeSmall: 14,
    buttonFontSizeMedium: 16,
    buttonFontSizeLarge: 18,
    buttonFontSizeXlarge: 28,
    buttonBorderWidth: 2,
    buttonBorderRadius: 4,
    buttonBorderColorTertiaryDefault: tokens.themeForegroundAccentDefault,
    buttonBorderColorTertiaryHover: tokens.themeForegroundAccentHover,
    buttonBorderColorTertiaryPressed: tokens.themeForegroundAccentPressed,
    buttonBorderColorTertiaryDisabled: tokens.themeBorderAccentDisabled,
    buttonSpacingInsetHorizontalSmall: 10,
    buttonSpacingInsetHorizontalMedium: 16,
    buttonSpacingInsetHorizontalLarge: 16,
    buttonSpacingInsetHorizontalXlarge: 24,
    buttonHeightSmall: 32,
    buttonHeightMedium: 40,
    buttonHeightLarge: 48,
    buttonHeightXlarge: 64,
    buttonFocusOutlineOffset: 4
  }
};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _alert = _interopRequireDefault(__webpack_require__(492));

var _default = _alert["default"];
exports["default"] = _default;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKeyboardFocusNodes = exports.getFocusNodes = exports.getBoundingFocusNodes = exports.canKeyboardFocusNode = exports.canFocusNode = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(63));

var _findIndex = _interopRequireDefault(__webpack_require__(151));

var _findLastIndex = _interopRequireDefault(__webpack_require__(238));

var focusNodeQuery = "button, input, select, textarea, [tabindex], [href]";
/**
 * Returns true if a node can be focused
 */

var canFocusNode = function canFocusNode(node) {
  return node && node.matches ? node.matches(focusNodeQuery) : node && node.msMatchesSelector ? node.msMatchesSelector(focusNodeQuery) : false;
};

exports.canFocusNode = canFocusNode;

var canKeyboardFocusNode = function canKeyboardFocusNode(node) {
  return canFocusNode(node) && node.getAttribute("tabindex") !== "-1";
};

exports.canKeyboardFocusNode = canKeyboardFocusNode;

var getFocusNodes = function getFocusNodes(node) {
  return node ? [].slice.call(node.querySelectorAll(focusNodeQuery)) : [];
};

exports.getFocusNodes = getFocusNodes;

var getKeyboardFocusNodes = function getKeyboardFocusNodes(node) {
  return getFocusNodes(node).filter(canKeyboardFocusNode);
};
/**
 * Returns an object containing two arrays of focuseable nodes keyed under
 * "startNodes" and "endNodes". The startNodes array contains every node that,
 * when focused, will cause the parent node to lose focus if the user presses
 * shift + tab (moving back in the tab order). The endNodes array contains every
 * node that, when focused, will cause the parent node to lose focus if the user
 * presses tab (moving forward in the tab order).
 */


exports.getKeyboardFocusNodes = getKeyboardFocusNodes;

var getBoundingFocusNodes = function getBoundingFocusNodes(node) {
  var nodes = [canFocusNode(node) ? node : undefined].concat((0, _toConsumableArray2["default"])(getFocusNodes(node))).filter(Boolean);
  var startFocusIndex = (0, _findIndex["default"])(nodes, canKeyboardFocusNode);
  var endFocusIndex = (0, _findLastIndex["default"])(nodes, canKeyboardFocusNode);
  var startNodes = startFocusIndex !== -1 ? nodes.slice(0, startFocusIndex + 1) : nodes;
  var endNodes = endFocusIndex !== -1 ? nodes.slice(endFocusIndex) : nodes;
  return {
    startNodes: startNodes,
    endNodes: endNodes
  };
};

exports.getBoundingFocusNodes = getBoundingFocusNodes;

/***/ }),
/* 158 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    popoverForegroundColorOutline: tokens.themeForegroundPrimaryDefault,
    popoverForegroundColorFill: "#FFFFFF",
    popoverBackgroundColorOutline: tokens.themeBackgroundPrimaryDefault,
    popoverBackgroundColorFill: "#252829",
    popoverBorderWidth: 1,
    popoverBorderRadius: 4,
    popoverBorderColorOutline: tokens.themeBorderSecondaryDefault,
    popoverBorderColorFill: tokens.themeBorderAlternateDefault,
    popoverSpacingInsetVerticalSmall: 8,
    popoverSpacingInsetVerticalMedium: 12,
    popoverSpacingInsetHorizontalSmall: 8,
    popoverSpacingInsetHorizontalMedium: 12,
    popoverArrowWidth: 16,
    popoverArrowHeight: 8,
    popoverHeaderSpacingHorizontal: 8,
    popoverHeaderFontWeight: 600,
    popoverDropShadowOffsetX: 0,
    popoverDropShadowOffsetY: 1,
    popoverDropShadowBlur: 2,
    popoverDropShadowSpread: 0,
    popoverDropShadowColor: "rgba(11, 12, 12, 0.16)",
    popoverMotionDuration: "150ms",
    popoverMotionFunction: "ease",
    popoverClosedScale: 90,
    popoverOffsetWithArrow: 16,
    popoverOffsetWithoutArrow: 8
  }
};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBestOrigin = exports.getAvailableSpace = exports.flipOrigin = exports.flipAlignment = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Flip an alignment string (e.g. from "top" to "bottom" etc)
 */
var flipAlignment = function flipAlignment(alignment) {
  return {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left",
    center: "center"
  }[alignment];
};
/**
 * Flip an origin (in the form of { x: "left", y: "bottom"}) across either one
 * or both axis.
 */


exports.flipAlignment = flipAlignment;

var flipOrigin = function flipOrigin(origin, flipX, flipY) {
  return {
    x: flipX ? flipAlignment(origin.x) : origin.x,
    y: flipY ? flipAlignment(origin.y) : origin.y
  };
};
/**
 * Given an anchor origin, popover origin, anchor rectangle, viewport rectangle,
 * any arbitrary extra space, and an axis, determine how much space is available
 * in the viewport along the provided axis to render a popover.
 */


exports.flipOrigin = flipOrigin;

var getAvailableSpaceOnAxis = function getAvailableSpaceOnAxis(axis, _ref) {
  var anchorOrigin = _ref.anchorOrigin,
      popoverOrigin = _ref.popoverOrigin,
      anchorRect = _ref.anchorRect,
      viewportRect = _ref.viewportRect,
      extraSpace = _ref.extraSpace;
  var edge = axis === "x" ? "left" : "top";
  var dimension = axis === "x" ? "width" : "height";
  var oppositeEdge = flipAlignment(edge); // Determine the position along the requested axis in the viewport that
  // represents the edge of the available space for the popover

  var popoverEdge = anchorOrigin[axis] === edge ? anchorRect[edge] : anchorOrigin[axis] === oppositeEdge ? anchorRect[edge] + anchorRect[dimension] : anchorOrigin[axis] === "center" ? anchorRect[edge] + anchorRect[dimension] / 2 : undefined; // Calculate the available space along the requested axis that the popover can
  // use to render

  var availableSpace = popoverOrigin[axis] === edge ? viewportRect[dimension] - popoverEdge - extraSpace[axis] : popoverOrigin[axis] === oppositeEdge ? popoverEdge - extraSpace[axis] : popoverOrigin[axis] === "center" ? 2 * (Math.min(viewportRect[dimension] - popoverEdge, popoverEdge) - extraSpace[axis]) : undefined;
  return Math.max(0, availableSpace);
}; // Given an anchor origin, popover origin, anchor rectangle, viewport rectangle,
// and any arbitrary extra space, determine how much space is available in the
// viewport to render a popover.


var getAvailableSpace = function getAvailableSpace(args) {
  return {
    x: getAvailableSpaceOnAxis("x", args),
    y: getAvailableSpaceOnAxis("y", args)
  };
};
/**
 * Given an axis and a bunch of other information, this determines the
 * transform that, when applied to the popover and anchor origins, will result
 * in the best origins to display the popover. The transform will either be a
 * shift left or right (or up or down) along the axis (e.g. center -> left or
 * center -> right) or a flip across the axis entirely (to the other side of the
 * anchor).
 *
 * Required args:
 *  - anchorOrigin
 *  - popoverOrigin
 *  - anchorRect
 *  - viewportRect
 *  - popoverRect
 *  - extraSpace
 */


exports.getAvailableSpace = getAvailableSpace;

var getBestOriginTransformOnAxis = function getBestOriginTransformOnAxis(axis, args) {
  var getSpace = function getSpace(anchorOrigin, popoverOrigin) {
    return getAvailableSpaceOnAxis(axis, _objectSpread(_objectSpread({}, args), {}, {
      anchorOrigin: anchorOrigin,
      popoverOrigin: popoverOrigin
    }));
  };

  var edge = axis === "x" ? "left" : "top";
  var dimension = axis === "x" ? "width" : "height";
  var oppositeEdge = flipAlignment(edge);
  var spaceWithPreferredOrigin = getSpace(args.anchorOrigin, args.popoverOrigin);
  var preferredOriginIsGood = spaceWithPreferredOrigin >= args.popoverRect[dimension]; // If the popover is center-aligned on the anchor then try shifting it
  // left/right or up/down (depending on the axis)

  var tryShift = args.popoverOrigin[axis] === "center" && args.anchorOrigin[axis] === "center" && !preferredOriginIsGood;
  var spaceShiftedStart = tryShift ? getSpace(_objectSpread(_objectSpread({}, args.anchorOrigin), {}, (0, _defineProperty2["default"])({}, axis, edge)), _objectSpread(_objectSpread({}, args.popoverOrigin), {}, (0, _defineProperty2["default"])({}, axis, edge))) : 0;
  var spaceShiftedEnd = tryShift ? getSpace(_objectSpread(_objectSpread({}, args.anchorOrigin), {}, (0, _defineProperty2["default"])({}, axis, oppositeEdge)), _objectSpread(_objectSpread({}, args.popoverOrigin), {}, (0, _defineProperty2["default"])({}, axis, oppositeEdge))) : 0;
  var shift = spaceShiftedStart > spaceWithPreferredOrigin && spaceShiftedStart > spaceShiftedEnd ? edge : spaceShiftedEnd > spaceWithPreferredOrigin ? oppositeEdge : undefined; // If shifting didn't work then try flipping the popover over the axis
  // entirely (to the other side of the anchor).

  var tryFlip = !preferredOriginIsGood && !shift;
  var flip = tryFlip && getSpace(flipOrigin(args.anchorOrigin, axis === "x", axis === "y"), flipOrigin(args.popoverOrigin, axis === "x", axis === "y")) > spaceWithPreferredOrigin;
  return shift ? {
    type: "shift",
    axis: axis,
    alignment: shift
  } : flip ? {
    type: "flip",
    axis: axis
  } : {
    type: "none"
  };
};
/**
 * This is used to apply a transform from `getBestOriginTransformOnAxis` to an
 * origin object.
 */


var transformOrigin = function transformOrigin(transform, origin) {
  switch (transform.type) {
    case "shift":
      return _objectSpread(_objectSpread({}, origin), {}, (0, _defineProperty2["default"])({}, transform.axis, transform.alignment));

    case "flip":
      return flipOrigin(origin, transform.axis === "x", transform.axis === "y");

    default:
      return origin;
  }
};
/**
 * Determine the anchor and popover origins that will work best for displaying
 * the popover. If there is enough space to show the popover at the origins
 * requested by the user then that will always be treated as the best option.
 * If there is not enough space at those origins *and* there are alternate
 * origins that will buy us more space, the origins that will give us the most
 * space are treated as the best option.
 *
 * Required args:
 *  - anchorOrigin
 *  - popoverOrigin
 *  - anchorRect
 *  - viewportRect
 *  - popoverRect
 *  - extraSpace
 *
 * Note that a popover may be shifted side to side or flipped over it's anchor
 * entirely, but it will never moved to an adjacent side (e.g. from the left to
 * the top). Designers/developers should be able to choose good enough defaults
 * for their popovers that this kind of transform won't be necessary to render
 * the popovers within the viewport.
 */


var getBestOrigin = function getBestOrigin(args) {
  // Determine the transforms along the x and y axis that will result in the
  // best display of the popover (not running off any edges of the viewport).
  var transformX = getBestOriginTransformOnAxis("x", args);
  var transformY = getBestOriginTransformOnAxis("y", args); // Apply the transforms to both the anchor origin and the popover origin

  var bestAnchorOrigin = transformOrigin(transformY, transformOrigin(transformX, args.anchorOrigin));
  var bestPopoverOrigin = transformOrigin(transformY, transformOrigin(transformX, args.popoverOrigin)); // Return the new origins along with the available space that they obtained
  // for the popover

  return {
    anchorOrigin: bestAnchorOrigin,
    popoverOrigin: bestPopoverOrigin,
    availableSpace: getAvailableSpace(_objectSpread(_objectSpread({}, args), {}, {
      anchorOrigin: bestAnchorOrigin,
      popoverOrigin: bestPopoverOrigin
    }))
  };
};

exports.getBestOrigin = getBestOrigin;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _portal = _interopRequireDefault(__webpack_require__(541));

var _default = _portal["default"];
exports["default"] = _default;

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_FloorActions__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CartStatus__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_Loading__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__BinTableCell__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OvCartTableCell__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__OVBinTableCell__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_ErrorPage__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Floor=function(_Component){_inherits(Floor,_Component);function Floor(props){_classCallCheck(this,Floor);var _this=_possibleConstructorReturn(this,(Floor.__proto__||Object.getPrototypeOf(Floor)).call(this,props));_this.getDistinctFloors=function(){var allFloors=[].concat(_toConsumableArray(Object.keys(_this.props.inductPackageMetricsMap)),_toConsumableArray(Object.keys(_this.props.pickPackageMetricsMap)),_toConsumableArray(Object.keys(_this.props.stowFloorsData)),_toConsumableArray(Object.keys(_this.props.stowPackageMetricsMap)));return[].concat(_toConsumableArray(new Set(allFloors)));};_this.renderHeadings=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"floor.location",defaultMessage:"Location"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"floor.route",defaultMessage:"Route"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"floor.inducted",defaultMessage:"Inducted"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"floor.picked",defaultMessage:"Picked"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"floor.stowed",defaultMessage:"Stowed"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"floor.problem_solve",defaultMessage:"PS"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"floor.stow_readiness",defaultMessage:"Stow Readiness"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"floor.cart_status",defaultMessage:"Cart status"})));};_this.renderFloorRow=function(floor){var combinedMetricsMap=_this.getCombinedMetricsMap(floor);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,key:floor,open:_this.isFloorExpanded(floor),onClick:function onClick(){return _this.floorRowClicked(floor);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,_this.getDisplayLabel(floor)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,combinedMetricsMap.routeCode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this.renderPackageCount(combinedMetricsMap.inductedPackages,floor,__WEBPACK_IMPORTED_MODULE_16__enums__["n" /* PackageStatus */].CURRENT_INDUCTED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this.renderPackageCount(combinedMetricsMap.pickedPackages,floor,__WEBPACK_IMPORTED_MODULE_16__enums__["n" /* PackageStatus */].PICKED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this.renderPackageCount(combinedMetricsMap.stowedPackages,floor,__WEBPACK_IMPORTED_MODULE_16__enums__["n" /* PackageStatus */].STOWED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this.renderPackageCount(combinedMetricsMap.problemSolvePackages,floor,__WEBPACK_IMPORTED_MODULE_16__enums__["n" /* PackageStatus */].PROBLEM_SOLVE)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.cartReadiness),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CartStatus__["a" /* default */],{status:combinedMetricsMap.cartStatus})),_this.renderCart(floor));};_this.getCombinedMetricsMap=function(floor){var _this$props=_this.props,inductPackageMetricsMap=_this$props.inductPackageMetricsMap,pickPackageMetricsMap=_this$props.pickPackageMetricsMap,stowFloorsData=_this$props.stowFloorsData,stowPackageMetricsMap=_this$props.stowPackageMetricsMap;var defaultMetricValue="-";var cartType=Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowFloorsData[floor].cart.type;},null);var cartReadiness=cartType==="OV"?"OV":Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowFloorsData[floor].cart.readiness;},defaultMetricValue)+"%";return{routeCode:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowFloorsData[floor].routeCode;},defaultMetricValue),inductedPackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return inductPackageMetricsMap[floor].inductedPackages;},defaultMetricValue),pickedPackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return pickPackageMetricsMap[floor].pickedPackages;},defaultMetricValue),stowedPackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[floor].stowedPackages;},defaultMetricValue),problemSolvePackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[floor].problemSolvePackages;},defaultMetricValue),cartReadiness:cartReadiness,cartStatus:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowFloorsData[floor].cart.status;},"MISSING")};};_this.getDisplayLabel=function(floor){return Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return floor.split(".")[1];},floor);};_this.isFloorExpanded=function(floor){return _this.state.expandedFloors.indexOf(floor)!==-1;};_this.renderCart=function(floor){var cart=_this.getCart(floor);if(cart){switch(cart.type){case __WEBPACK_IMPORTED_MODULE_16__enums__["h" /* CartType */].OV:return _this.renderOvCart(cart);case __WEBPACK_IMPORTED_MODULE_16__enums__["h" /* CartType */].HYBRID:return _this.renderHybridCart(cart);case __WEBPACK_IMPORTED_MODULE_16__enums__["h" /* CartType */].NORMAL:return _this.renderNormalCartBins(cart);default:return _this.renderNormalCartBins(cart);}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default.a,null);};_this.getCart=function(floor){var cartData=_this.props.stowCartData;if(cartData&&cartData[floor]){return cartData[floor];}};_this.renderOvCart=function(cart){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__OvCartTableCell__["a" /* default */],{cart:cart}));};_this.renderOvPackages=function(cart){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__OVBinTableCell__["a" /* default */],{cart:cart}));};_this.renderHybridCart=function(cart){var bins=cart.bins;if(bins){var binArray=bins.map(function(bin){return _this.renderBin(bin);});binArray.push(_this.renderOvPackages(cart));return binArray;}};_this.renderNormalCartBins=function(cart){var bins=cart.bins;if(bins){return bins.map(function(bin){return _this.renderBin(bin);});}};_this.renderBin=function(bin){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__BinTableCell__["a" /* default */],{bin:bin}));};_this.renderPackageCount=function(value,floor,state){return value!==0&&value!=='-'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_link___default.a,{href:_this.getPackageListURL(state,floor),type:"secondary"}," ",value," "):value;};_this.getPackageListURL=function(state,floor){var params={PACKAGE_STATUS:state,FLOOR:floor};if(__WEBPACK_IMPORTED_MODULE_16__enums__["n" /* PackageStatus */].PICKED===state){params[__WEBPACK_IMPORTED_MODULE_17__constants__["m" /* GROUP_BY */]]=__WEBPACK_IMPORTED_MODULE_17__constants__["l" /* FLOOR_LOCATION */];params[__WEBPACK_IMPORTED_MODULE_17__constants__["u" /* STATION_PAIR */]]=floor.split(".")[0];}return"#packageList/?"+Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["e" /* formQueryParams */])(params);};_this.floorRowClicked=function(floor){_this.setState(function(oldState){if(oldState.expandedFloors.indexOf(floor)!==-1){return{expandedFloors:oldState.expandedFloors.filter(function(expandedFloor){return expandedFloor!==floor;})};}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_FloorActions__["j" /* getStowCartDataForFloor */])(_this.props.nodeId,floor));return{expandedFloors:oldState.expandedFloors.concat(floor)};}});};_this.state={expandedFloors:[]};return _this;}_createClass(Floor,[{key:"render",value:function render(){var _this2=this;var error=this.props.error;if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__utils_ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});}var floors=this.getDistinctFloors().sort();if(this.props.loading&&!floors.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__utils_Loading__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default.a,{headerRows:1,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true},this.renderHeadings(),floors.map(function(floor){return _this2.renderFloorRow(floor);}));}}]);return Floor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{loading:state.floorReducer.loading,error:state.floorReducer.error,inductPackageMetricsMap:state.floorReducer.inductPackageMetricsMap,pickPackageMetricsMap:state.floorReducer.pickPackageMetricsMap,stowCartData:state.floorReducer.stowCartData,stowFloorsData:state.floorReducer.stowFloorsData,stowPackageMetricsMap:state.floorReducer.stowPackageMetricsMap};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Floor)));

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPickPackageMetrics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPickPackages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(5);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getPickPackageMetrics=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(request){var documentUrl,baseURL,api,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["d" /* getDocumentURL */])();case 2:documentUrl=_context.sent;baseURL=Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["g" /* getBaseUrl */])(documentUrl);api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseURL});_context.next=7;return api.post("/rsws/package/metric",request);case 7:response=_context.sent;if(!(response.status===200)){_context.next=10;break;}return _context.abrupt("return",transformPackageMetrics(response.data.values));case 10:case"end":return _context.stop();}}},_callee,this);}));return function getPickPackageMetrics(_x){return _ref.apply(this,arguments);};}();var getPickPackages=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(request,baseURL){var api,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseURL});_context2.next=3;return api.post("/rsws/package/list",request);case 3:response=_context2.sent;if(!(response.status===200)){_context2.next=6;break;}return _context2.abrupt("return",transformPackages(response.data.packageList));case 6:case"end":return _context2.stop();}}},_callee2,this);}));return function getPickPackages(_x2,_x3){return _ref2.apply(this,arguments);};}();function transformPackageMetrics(groupedPackageMetrics){var metricsMapOutput={};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=groupedPackageMetrics[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var value=_step.value;if(value){var metricList=value.metricList;var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=metricList[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var metricObj=_step2.value;if(metricObj&&"PICKED"===metricObj.metric){metricsMapOutput[value.id]={"pickedPackages":metricObj.metricValue};break;}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return metricsMapOutput;}function transformPackages(packageList){return packageList.map(function(packageObject){return{associateId:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["f" /* getAliasFromLoginId */])(packageObject.lastScanAssociateId),bin:packageObject.bin,cluster:packageObject.cluster,cycle:packageObject.cycleId,ead:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["l" /* getFormattedTimeFromEpoch */])(packageObject.localEstimatedArrivalDate*1000),lastScan:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["l" /* getFormattedTimeFromEpoch */])(packageObject.localLastScanTime*1000),location:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return packageObject.packageLocation.scannedLocation;},__WEBPACK_IMPORTED_MODULE_4__constants__["o" /* HYPHEN */]),minutesInState:packageObject.minutesInState,reason:packageObject.reason,routeCode:packageObject.routeCode,size:packageObject.size,sortZone:packageObject.sortZone,state:packageObject.state,trackingId:packageObject.trackingId,conveyance:Object(__WEBPACK_IMPORTED_MODULE_2__Utility__["a" /* chainWalk */])(function(){return packageObject.packageLocation.stationPairLabel;},__WEBPACK_IMPORTED_MODULE_4__constants__["o" /* HYPHEN */])};});}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tag = _interopRequireDefault(__webpack_require__(586));

var _default = _tag["default"];
exports["default"] = _default;

/***/ }),
/* 164 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    tagFontSize: 14,
    tagHeight: 20,
    tagIndicatorDiameter: 12,
    tagCloseIconMotionDuration: "100ms",
    tagCloseIconMotionFunction: "ease",
    tagCloseIconSize: 16,
    tagCloseIconColorDismissibleThemeDefault: tokens.themeForegroundAccentDefault,
    tagCloseIconColorDismissibleThemeHover: tokens.themeForegroundAccentHover,
    tagCloseIconColorDismissibleThemePressed: tokens.themeForegroundAccentPressed,
    tagCloseIconColorDismissibleThemeFocus: tokens.themeForegroundAccentHover,
    tagCloseIconColorDismissibleNeutralDefault: tokens.themeForegroundTertiaryDefault,
    tagCloseIconColorDismissibleNeutralHover: tokens.themeForegroundTertiaryHover,
    tagCloseIconColorDismissibleNeutralPressed: tokens.themeForegroundTertiaryPressed,
    tagCloseIconColorDismissibleNeutralFocus: tokens.themeForegroundSecondaryDefault,
    tagSpacingInsetStatusRight: 12,
    tagSpacingInsetStatusLeft: 4,
    tagSpacingInsetDismissibleRight: 2,
    tagSpacingInsetDismissibleLeft: 8,
    tagSpacingHorizontal: 8,
    tagBackgroundColorDismissibleTheme: tokens.themeBackgroundAccentDefault,
    tagBackgroundColorDismissibleNeutral: tokens.themeBackgroundTertiaryDefault,
    tagBorderWidth: 1,
    tagBorderRadius: 13,
    tagBorderCompactWidth: 2,
    tagBorderCompactRadius: 999,
    tagBorderColorStatusSuccess: "#ADE422",
    tagBorderColorStatusWarning: "#FAD000",
    tagBorderColorStatusError: "#DE1B1B",
    tagBorderColorStatusNeutral: tokens.themeForegroundPrimaryDisabled,
    tagBorderColorStatusTheme: tokens.themeBorderAccentDefault,
    tagBorderColorDismissibleTheme: tokens.themeBorderAccentDefault,
    tagBorderColorDismissibleNeutral: tokens.themeForegroundPrimaryDisabled,
    tagBorderColorCompact: "#232F3E",
    tagFocusOutlineOffset: 4
  }
};

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LOAD_STOW_MIN_OF_WORK_METRICS_FOR_CLUSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOAD_STOW_BIN_METRICS_FOR_CLUSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOAD_STOW_BIN_METRICS_FOR_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return LOAD_STOW_PACKAGE_METRICS_FOR_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOAD_NODE_RESOURCE_DATA_FOR_CLUSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOAD_STOW_BIN_METRICS_FOR_CLUSTER_FOR_STOW_V2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getStowPackageMetricsForCluster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getNodeResourceDataForCluster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getMinOfWorkMetricsForCluster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getStowBinMetricsForClusterforStowV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getStowBinMetricsForCluster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getInductPackageMetricsForCluster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getStowAssociateMetricsForCluster; });
/* unused harmony export getInductPackageMetricsForNode */
/* unused harmony export getStowAssociateMetricsForNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_StowResource__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_InductResource__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MetricUtility__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(7);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN="LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN";var LOAD_STOW_MIN_OF_WORK_METRICS_FOR_CLUSTER="LOAD_STOW_MIN_OF_WORK_METRICS_FOR_CLUSTER";var LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER="LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER";var LOAD_STOW_BIN_METRICS_FOR_CLUSTER="LOAD_STOW_BIN_METRICS_FOR_CLUSTER";var LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER="LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER";var LOAD_STOW_BIN_METRICS_FOR_NODE="LOAD_STOW_BIN_METRICS_FOR_NODE";var LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER="LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER";var LOAD_STOW_PACKAGE_METRICS_FOR_NODE="LOAD_STOW_PACKAGE_METRICS_FOR_NODE";var LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE="LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE";var LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE="LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE";var LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE="LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE";var LOAD_NODE_RESOURCE_DATA_FOR_CLUSTER="LOAD_NODE_RESOURCE_DATA_FOR_CLUSTER";var LOAD_STOW_BIN_METRICS_FOR_CLUSTER_FOR_STOW_V2="LOAD_STOW_BIN_METRICS_FOR_CLUSTER_FOR_STOW_V2";var metricProcessName="SCC_STOW_CLUSTER";var loadMetricsForClusterCallBegin=function loadMetricsForClusterCallBegin(){return{type:LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN};};var loadStowBinMetricsForClusterForStowV2=function loadStowBinMetricsForClusterForStowV2(stowBinMetricsMapForStowV2){return{type:LOAD_STOW_BIN_METRICS_FOR_CLUSTER_FOR_STOW_V2,stowBinMetricsMapForStowV2:stowBinMetricsMapForStowV2};};var loadMinOfWorkMetricsForCluster=function loadMinOfWorkMetricsForCluster(minOfWorkMetricsMap){return{type:LOAD_STOW_MIN_OF_WORK_METRICS_FOR_CLUSTER,minOfWorkMetricsMap:minOfWorkMetricsMap};};var loadStowPackageMetricsForCluster=function loadStowPackageMetricsForCluster(stowPackageMetricsMap){return{type:LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER,stowPackageMetricsMap:stowPackageMetricsMap};};var loadNodeResourcesDataForCluster=function loadNodeResourcesDataForCluster(nodeResourceData){return{type:LOAD_NODE_RESOURCE_DATA_FOR_CLUSTER,nodeResourceData:nodeResourceData};};var loadStowBinMetricsForCluster=function loadStowBinMetricsForCluster(stowBinMetricsMap){return{type:LOAD_STOW_BIN_METRICS_FOR_CLUSTER,stowBinMetricsMap:stowBinMetricsMap};};var loadStowBinMetricsForNode=function loadStowBinMetricsForNode(totalStowBinMetrics){return{type:LOAD_STOW_BIN_METRICS_FOR_NODE,totalStowBinMetrics:totalStowBinMetrics};};var loadInductPackageMetricsForCluster=function loadInductPackageMetricsForCluster(inductPackageMetricsMap){return{type:LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER,inductPackageMetricsMap:inductPackageMetricsMap};};var loadStowAssociateMetricsForCluster=function loadStowAssociateMetricsForCluster(stowAssociateMetricsMap){return{type:LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER,stowAssociateMetricsMap:stowAssociateMetricsMap};};var loadStowPackageMetricsForNode=function loadStowPackageMetricsForNode(totalStowPackageMetrics){return{type:LOAD_STOW_PACKAGE_METRICS_FOR_NODE,totalStowPackageMetrics:totalStowPackageMetrics};};var loadInductPackageMetricsForNode=function loadInductPackageMetricsForNode(totalInductPackageMetrics){return{type:LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE,totalInductPackageMetrics:totalInductPackageMetrics};};var loadStowAssociateMetricsForNode=function loadStowAssociateMetricsForNode(totalStowAssociateMetrics){return{type:LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE,totalStowAssociateMetrics:totalStowAssociateMetrics};};var loadMetricsForClusterCallFailure=function loadMetricsForClusterCallFailure(){return{type:LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE};};var getStowPackageMetricsForCluster=function getStowPackageMetricsForCluster(isADTAVisibilityEnabled,isDRSStowVisibilityEnabled,nodeId,cycles,cycleIds,CPTIds,filterIdentifier,isCPTFilterEnabled){var metricName="getStowPackageMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].CLUSTER,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].STOW_RATE,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].SCAN_COMPLIANCE,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].PROBLEM_SOLVE_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].PLANNED_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].STOW_VS_PLAN,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].STOWED_COUNT,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].CURRENT_INDUCTED_COUNT],isAggregationRequired:true};if(!isDRSStowVisibilityEnabled){request.filters["DRS"]=[__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* FALSE */]];}if(isADTAVisibilityEnabled){request.metrics.push(__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].CURRENT_STOW_BUFFERED_COUNT);request.metrics.push(__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].CURRENT_MFR_JACKPOT_BUFFERED_COUNT);}cycles=cycles.filter(Boolean);if(cycles.length&&!isCPTFilterEnabled){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length&&!isCPTFilterEnabled){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* CYCLE_ID */]]=cycleIds;}if(CPTIds.length&&isCPTFilterEnabled){request.filters[[filterIdentifier]]=CPTIds;}function getStowPackageMetricsForNode(stowPackageMetricsMap){return{Total:stowPackageMetricsMap[__WEBPACK_IMPORTED_MODULE_4__constants__["w" /* TOTAL */]]};}return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var startTime,stowPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;dispatch(loadMetricsForClusterCallBegin());startTime=Date.now();_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["q" /* getStowPackageMetrics */])(request);case 5:stowPackageMetricsMap=_context.sent;if(stowPackageMetricsMap){dispatch(loadStowPackageMetricsForNode(getStowPackageMetricsForNode(stowPackageMetricsMap)));removeUnwantedClusters(stowPackageMetricsMap);dispatch(loadStowPackageMetricsForCluster(stowPackageMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context.next=13;break;case 9:_context.prev=9;_context.t0=_context["catch"](0);dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context.stop();}}},_callee,_this,[[0,9]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var getNodeResourceDataForCluster=function getNodeResourceDataForCluster(nodeId,nodeResourceType){var metricName="getNodeResourceData";var request={nodeId:nodeId,nodeResourceType:nodeResourceType};return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var startTime,nodeResources;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;dispatch(loadMetricsForClusterCallBegin());startTime=Date.now();_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["c" /* getNodeResourceData */])(request);case 5:nodeResources=_context2.sent;if(nodeResources){dispatch(loadNodeResourcesDataForCluster(nodeResources));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}_context2.next=13;break;case 9:_context2.prev=9;_context2.t0=_context2["catch"](0);dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context2.stop();}}},_callee2,_this,[[0,9]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var getMinOfWorkMetricsForCluster=function getMinOfWorkMetricsForCluster(nodeId,isDRSStowVisibilityEnabled,cycles,cycleIds){var metricName="getMinOfWorkMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].CLUSTER,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].MINUTES_OF_WORK,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].LAST_FIFTEEN_MINUTE_STOW_RATE,__WEBPACK_IMPORTED_MODULE_5__enums__["p" /* StowPackageMetric */].CURRENT_INDUCTED_COUNT],isAggregationRequired:true};if(!isDRSStowVisibilityEnabled){request.filters["DRS"]=[__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* FALSE */]];}cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* CYCLE_ID */]]=cycleIds;}return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var startTime,minOfWorkMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;dispatch(loadMetricsForClusterCallBegin());startTime=Date.now();_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["q" /* getStowPackageMetrics */])(request);case 5:minOfWorkMetricsMap=_context3.sent;if(minOfWorkMetricsMap){minOfWorkMetricsMap["totalMinOfWork"]=minOfWorkMetricsMap["Total"]["minutesOfWork"];removeUnwantedClusters(minOfWorkMetricsMap);dispatch(loadMinOfWorkMetricsForCluster(minOfWorkMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context3.next=13;break;case 9:_context3.prev=9;_context3.t0=_context3["catch"](0);dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context3.stop();}}},_callee3,_this,[[0,9]]);}));return function(_x3){return _ref3.apply(this,arguments);};}();};var getStowBinMetricsForClusterforStowV2=function getStowBinMetricsForClusterforStowV2(nodeId,cycles,cycleIds,CPTIds,filterIdentifier,isCPTFilterEnabled,isStowBreakdownV2Enabled){var metricName="getStowBinMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].CLUSTER,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["d" /* BinMetric */].BINS_COUNT_MISSING_OPEN_BAG]};cycles=cycles.filter(Boolean);if(cycles.length&&!isCPTFilterEnabled){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length&&!isCPTFilterEnabled){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* CYCLE_ID */]]=cycleIds;}if(CPTIds.length&&isCPTFilterEnabled){request.filters[[filterIdentifier]]=CPTIds;}return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var startTime,stowBinMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;dispatch(loadMetricsForClusterCallBegin());startTime=Date.now();_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["j" /* getStowBinMetricsForStowV2 */])(request);case 5:stowBinMetricsMap=_context4.sent;if(stowBinMetricsMap){removeUnwantedClusters(stowBinMetricsMap);dispatch(loadStowBinMetricsForNode(getTotalMetrics(stowBinMetricsMap)));dispatch(loadStowBinMetricsForClusterForStowV2(stowBinMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context4.next=13;break;case 9:_context4.prev=9;_context4.t0=_context4["catch"](0);dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context4.stop();}}},_callee4,_this,[[0,9]]);}));return function(_x4){return _ref4.apply(this,arguments);};}();};var getStowBinMetricsForCluster=function getStowBinMetricsForCluster(nodeId,cycles,cycleIds,CPTIds,filterIdentifier,isCPTFilterEnabled){var metricName="getStowBinMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].CLUSTER,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["d" /* BinMetric */].BINS_COUNT_MISSING_OPEN_BAG]};cycles=cycles.filter(Boolean);if(cycles.length&&!isCPTFilterEnabled){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length&&!isCPTFilterEnabled){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* CYCLE_ID */]]=cycleIds;}if(CPTIds.length&&isCPTFilterEnabled){request.filters[[filterIdentifier]]=CPTIds;}return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var startTime,stowBinMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;dispatch(loadMetricsForClusterCallBegin());startTime=Date.now();_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["i" /* getStowBinMetrics */])(request);case 5:stowBinMetricsMap=_context5.sent;if(stowBinMetricsMap){removeUnwantedClusters(stowBinMetricsMap);dispatch(loadStowBinMetricsForNode(getTotalMetrics(stowBinMetricsMap)));dispatch(loadStowBinMetricsForCluster(stowBinMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context5.next=13;break;case 9:_context5.prev=9;_context5.t0=_context5["catch"](0);dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context5.stop();}}},_callee5,_this,[[0,9]]);}));return function(_x5){return _ref5.apply(this,arguments);};}();};var getInductPackageMetricsForCluster=function getInductPackageMetricsForCluster(nodeId,cycles,CPTIds,filterIdentifier,isCPTFilterEnabled){var metricName="getInductPackageMetrics";var request={nodeId:nodeId,filters:{},groupBy:"Cluster",metricList:[__WEBPACK_IMPORTED_MODULE_5__enums__["m" /* InductPackageMetric */].RECEIVED]};cycles=cycles.filter(Boolean);if(cycles.length&&!isCPTFilterEnabled){request.filters["Cycle"]=cycles;}if(CPTIds.length&&isCPTFilterEnabled){request.filters[[filterIdentifier]]=CPTIds;}return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch){var startTime,inductPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.prev=0;dispatch(loadMetricsForClusterCallBegin());startTime=Date.now();_context6.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_InductResource__["a" /* getInductPackageMetrics */])(request);case 5:inductPackageMetricsMap=_context6.sent;if(inductPackageMetricsMap){removeUnwantedClusters(inductPackageMetricsMap);dispatch(loadInductPackageMetricsForNode(getTotalMetrics(inductPackageMetricsMap)));dispatch(loadInductPackageMetricsForCluster(inductPackageMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context6.next=13;break;case 9:_context6.prev=9;_context6.t0=_context6["catch"](0);dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context6.stop();}}},_callee6,_this,[[0,9]]);}));return function(_x6){return _ref6.apply(this,arguments);};}();};var getStowAssociateMetricsForCluster=function getStowAssociateMetricsForCluster(nodeId,cycles,CPTIds,filterIdentifier,isCPTFilterEnabled){var metricName="getStowAssociateMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_5__enums__["o" /* Resource */].CLUSTER,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_5__enums__["a" /* AssociateMetric */].ACTIVE_ASSOCIATE_COUNT]};cycles=cycles.filter(Boolean);if(cycles.length&&!isCPTFilterEnabled){request.filters[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* CYCLE */]]=cycles;}if(CPTIds.length&&isCPTFilterEnabled){request.filters[[filterIdentifier]]=CPTIds;}return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch){var startTime,stowAssociateMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.prev=0;dispatch(loadMetricsForClusterCallBegin());startTime=Date.now();_context7.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["e" /* getStowAssociateMetrics */])(request);case 5:stowAssociateMetricsMap=_context7.sent;if(stowAssociateMetricsMap){removeUnwantedClusters(stowAssociateMetricsMap);dispatch(loadStowAssociateMetricsForNode(getTotalMetrics(stowAssociateMetricsMap)));dispatch(loadStowAssociateMetricsForCluster(stowAssociateMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context7.next=13;break;case 9:_context7.prev=9;_context7.t0=_context7["catch"](0);dispatch(loadMetricsForClusterCallFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context7.stop();}}},_callee7,_this,[[0,9]]);}));return function(_x7){return _ref7.apply(this,arguments);};}();};var getInductPackageMetricsForNode=function getInductPackageMetricsForNode(nodeId,cycles,CPTIds,filterIdentifier,isCPTFilterEnabled){var request={nodeId:nodeId,groupBy:"Node",metricList:["INDUCTED_AT_STATION","PENDING_INDUCT"]};cycles=cycles.filter(Boolean);if(cycles.length&&!isCPTFilterEnabled){request.filters={"Cycle":cycles};}if(CPTIds.length&&isCPTFilterEnabled){request.filters[[filterIdentifier]]=CPTIds;}return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatch){var inductPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.prev=0;dispatch(loadMetricsForClusterCallBegin());_context8.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_InductResource__["a" /* getInductPackageMetrics */])(request);case 4:inductPackageMetricsMap=_context8.sent;replaceNodeByTotal(inductPackageMetricsMap,nodeId);if(inductPackageMetricsMap){dispatch(loadInductPackageMetricsForNode(inductPackageMetricsMap));}else{dispatch(loadMetricsForClusterCallFailure());}_context8.next=12;break;case 9:_context8.prev=9;_context8.t0=_context8["catch"](0);dispatch(loadMetricsForClusterCallFailure());case 12:case"end":return _context8.stop();}}},_callee8,_this,[[0,9]]);}));return function(_x8){return _ref8.apply(this,arguments);};}();};var getStowAssociateMetricsForNode=function getStowAssociateMetricsForNode(nodeId,cycles,CPTIds,filterIdentifier,isCPTFilterEnabled){var request={groupBy:"NODE",filters:{'NODE':[nodeId]},metrics:["ACTIVE_ASSOCIATE_COUNT","INACTIVE_ASSOCIATE_COUNT"]};cycles=cycles.filter(Boolean);if(cycles.length&&!isCPTFilterEnabled){request.filters["CYCLE"]=cycles;}if(CPTIds.length&&isCPTFilterEnabled){request.filters[[filterIdentifier]]=CPTIds;}return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatch){var stowAssociateMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.prev=0;dispatch(loadMetricsForClusterCallBegin());_context9.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["e" /* getStowAssociateMetrics */])(request);case 4:stowAssociateMetricsMap=_context9.sent;replaceNodeByTotal(stowAssociateMetricsMap,nodeId);if(stowAssociateMetricsMap){dispatch(loadStowAssociateMetricsForNode(stowAssociateMetricsMap));}else{dispatch(loadMetricsForClusterCallFailure());}_context9.next=12;break;case 9:_context9.prev=9;_context9.t0=_context9["catch"](0);dispatch(loadMetricsForClusterCallFailure());case 12:case"end":return _context9.stop();}}},_callee9,_this,[[0,9]]);}));return function(_x9){return _ref9.apply(this,arguments);};}();};function replaceNodeByTotal(metricsMap,nodeId){metricsMap["Total"]=metricsMap[nodeId];delete metricsMap[nodeId];}function getTotalMetrics(groupedMetricsMap){var totalCluster={};for(var cluster in groupedMetricsMap){var metricsMap=groupedMetricsMap[cluster];for(var metric in metricsMap){if(!totalCluster[metric]){totalCluster[metric]=metricsMap[metric];}else{totalCluster[metric]=+totalCluster[metric]+ +metricsMap[metric];}}}return{Total:totalCluster};}function removeUnwantedClusters(metricsMap){delete metricsMap[__WEBPACK_IMPORTED_MODULE_4__constants__["w" /* TOTAL */]];}

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_Loading__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ErrorPage__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StationPair=function(_Component){_inherits(StationPair,_Component);function StationPair(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StationPair);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StationPair.__proto__||Object.getPrototypeOf(StationPair)).call.apply(_ref,[this].concat(args))),_this),_this.getDistinctStationPairs=function(){var allStationPairs=[].concat(_toConsumableArray(Object.keys(_this.props.inductPackageMetricsMap)),_toConsumableArray(Object.keys(_this.props.pickPackageMetricsMap)),_toConsumableArray(Object.keys(_this.props.stowAssociateMetricsMap)),_toConsumableArray(Object.keys(_this.props.stowFloorMetricsGroupMap)),_toConsumableArray(Object.keys(_this.props.stowPackageMetricsMap)));var filteredStationPairs=allStationPairs.filter(function(stationPair){return stationPair!=="";});return[].concat(_toConsumableArray(new Set(filteredStationPairs)));},_this.renderHeadings=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"stationPair.packages",defaultMessage:"Packages"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"stationPair.readiness",defaultMessage:"Readiness"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"stationPair.performance",defaultMessage:"Performance"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"stationPair.stowers",defaultMessage:"Stowers"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null));},_this.renderSubHeadings=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"stationPair.station_pair",defaultMessage:"Station"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"stationPair.inducted",defaultMessage:"Inducted"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"stationPair.picked",defaultMessage:"Picked"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"stationPair.stowed",defaultMessage:"Stowed"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"stationPair.stow_plan",defaultMessage:"Stow/Plan"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"stationPair.ps",defaultMessage:"PS"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"stationPair.missing_carts",defaultMessage:"Missing carts"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"stationPair.stow_rate",defaultMessage:"Stow rate"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"stationPair.active",defaultMessage:"Active"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"stationPair.inactive",defaultMessage:"Inactive"})));},_this.renderPackageMetrics=function(stationPair){var combinedMetricsMap=_this.getCombinedMetricsMap(stationPair);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,key:stationPair,onClick:function onClick(){return _this.stationPairRowClicked(stationPair,combinedMetricsMap.displayLabel);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null,combinedMetricsMap.displayLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this.renderPackageCount(combinedMetricsMap.inductedPackages,stationPair,__WEBPACK_IMPORTED_MODULE_12__enums__["n" /* PackageStatus */].CURRENT_INDUCTED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this.renderPackageCount(combinedMetricsMap.pickedPackages,stationPair,__WEBPACK_IMPORTED_MODULE_12__enums__["n" /* PackageStatus */].PICKED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this.renderPackageCount(combinedMetricsMap.stowedPackages,stationPair,__WEBPACK_IMPORTED_MODULE_12__enums__["n" /* PackageStatus */].STOWED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.stowVsPlan,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this.renderPackageCount(combinedMetricsMap.problemSolvePackages,stationPair,__WEBPACK_IMPORTED_MODULE_12__enums__["n" /* PackageStatus */].PROBLEM_SOLVE)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.floorsCountMissingCart),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.stowRate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.activeStowers),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.inactiveStowers));},_this.renderTotalPackageMetrics=function(){var combinedTotalMetricsMap=_this.getCombinedTotalMetricsMap();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null,"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedTotalMetricsMap.inductedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedTotalMetricsMap.pickedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedTotalMetricsMap.stowedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedTotalMetricsMap.stowVsPlan,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedTotalMetricsMap.problemSolvePackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedTotalMetricsMap.floorsCountMissingCart),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedTotalMetricsMap.stowRate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedTotalMetricsMap.activeStowers),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedTotalMetricsMap.inactiveStowers));},_this.getCombinedMetricsMap=function(stationPair){var _this$props=_this.props,inductPackageMetricsMap=_this$props.inductPackageMetricsMap,pickPackageMetricsMap=_this$props.pickPackageMetricsMap,stowAssociateMetricsMap=_this$props.stowAssociateMetricsMap,stowFloorMetricsGroupMap=_this$props.stowFloorMetricsGroupMap,stowPackageMetricsMap=_this$props.stowPackageMetricsMap;var defaultMetricValue="-";var displayLabel=Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowFloorMetricsGroupMap[stationPair].displayLabel;},Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[stationPair].displayLabel;},__WEBPACK_IMPORTED_MODULE_13__constants__["o" /* HYPHEN */]));return{inductedPackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return inductPackageMetricsMap[stationPair].inductedPackages;},defaultMetricValue),pickedPackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return pickPackageMetricsMap[stationPair].pickedPackages;},defaultMetricValue),stowedPackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[stationPair].stowedPackages;},defaultMetricValue),stowVsPlan:_this.getStowVsPlan(stowPackageMetricsMap,inductPackageMetricsMap,stationPair),problemSolvePackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[stationPair].problemSolvePackages;},defaultMetricValue),displayLabel:displayLabel,floorsCountMissingCart:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowFloorMetricsGroupMap[stationPair].floorMetrics.floorsCountMissingCart;},defaultMetricValue),stowRate:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[stationPair].stowRate;},defaultMetricValue),activeStowers:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowAssociateMetricsMap[stationPair].activeStowers;},defaultMetricValue),inactiveStowers:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowAssociateMetricsMap[stationPair].inactiveStowers;},defaultMetricValue)};},_this.getCombinedTotalMetricsMap=function(){var _this$props2=_this.props,totalInductPackageMetrics=_this$props2.totalInductPackageMetrics,totalPickPackageMetricsMap=_this$props2.totalPickPackageMetricsMap,totalStowAssociateMetrics=_this$props2.totalStowAssociateMetrics,totalStowFloorMetricsMap=_this$props2.totalStowFloorMetricsMap,totalStowPackageMetrics=_this$props2.totalStowPackageMetrics;var defaultMetricValue="-";var total="Total";return{inductedPackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return totalInductPackageMetrics[total].inductedPackages;},defaultMetricValue),pickedPackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return totalPickPackageMetricsMap[total].pickedPackages;},defaultMetricValue),stowedPackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return totalStowPackageMetrics[total].stowedPackages;},defaultMetricValue),stowVsPlan:_this.getStowVsPlan(totalStowPackageMetrics,totalInductPackageMetrics,__WEBPACK_IMPORTED_MODULE_13__constants__["w" /* TOTAL */]),problemSolvePackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return totalStowPackageMetrics[total].problemSolvePackages;},defaultMetricValue),floorsCountMissingCart:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return totalStowFloorMetricsMap[total].floorsCountMissingCart;},defaultMetricValue),stowRate:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return totalStowPackageMetrics[total].stowRate;},defaultMetricValue),activeStowers:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return totalStowAssociateMetrics[total].activeStowers;},defaultMetricValue),inactiveStowers:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return totalStowAssociateMetrics[total].inactiveStowers;},defaultMetricValue)};},_this.getStowVsPlan=function(stowPackageMetricsMap,inductPackageMetricsMap,stationPair){var stowedPackages=Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[stationPair].stowedPackages;},0);var inductedPackages=Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return inductPackageMetricsMap[stationPair].cumulativeInducted;},0);var stowVsPlan=inductedPackages===0?0:stowedPackages/inductedPackages;return(stowVsPlan*100).toFixed(2);},_this.stationPairRowClicked=function(stationPair,displayLabel){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_OptionsActions__["q" /* navigationAdded */])({key:'Station',value:stationPair,displayValue:displayLabel}));},_this.renderPackageCount=function(value,stationPair,state){return value!==0&&value!=='-'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_link___default.a,{href:_this.getPackageListURL(state,stationPair),type:"secondary"}," ",value," "):value;},_this.getPackageListURL=function(state,stationPair){var params={PACKAGE_STATUS:state,STATION_PAIR:stationPair};if(__WEBPACK_IMPORTED_MODULE_12__enums__["n" /* PackageStatus */].PICKED===state){params[__WEBPACK_IMPORTED_MODULE_13__constants__["m" /* GROUP_BY */]]=__WEBPACK_IMPORTED_MODULE_13__constants__["u" /* STATION_PAIR */];}return"#packageList/?"+Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["e" /* formQueryParams */])(params);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StationPair,[{key:"render",value:function render(){var _this2=this;var error=this.props.error;if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__utils_ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});}var stationPairs=this.getDistinctStationPairs().sort();if(this.props.loading&&!stationPairs.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__utils_Loading__["a" /* default */],{height:"400px"});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default.a,{headerRows:2,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true},this.renderHeadings(),this.renderSubHeadings(),stationPairs.map(function(stationPair){return _this2.renderPackageMetrics(stationPair);}),stationPairs.length?this.renderTotalPackageMetrics():null);}}]);return StationPair;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{loading:state.stationPairReducer.loading,error:state.stationPairReducer.error,inductPackageMetricsMap:state.stationPairReducer.inductPackageMetricsMap,pickPackageMetricsMap:state.stationPairReducer.pickPackageMetricsMap,stowAssociateMetricsMap:state.stationPairReducer.stowAssociateMetricsMap,stowFloorMetricsGroupMap:state.stationPairReducer.stowFloorMetricsGroupMap,stowPackageMetricsMap:state.stationPairReducer.stowPackageMetricsMap,totalInductPackageMetrics:state.stationPairReducer.totalInductPackageMetrics,totalPickPackageMetricsMap:state.stationPairReducer.totalPickPackageMetricsMap,totalStowAssociateMetrics:state.stationPairReducer.totalStowAssociateMetrics,totalStowFloorMetricsMap:state.stationPairReducer.totalStowFloorMetricsMap,totalStowPackageMetrics:state.stationPairReducer.totalStowPackageMetrics};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(StationPair)));

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_input__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__handler_LocaleHandler__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RefreshTimer__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Route=function(_Component){_inherits(Route,_Component);function Route(props){_classCallCheck(this,Route);var _this=_possibleConstructorReturn(this,(Route.__proto__||Object.getPrototypeOf(Route)).call(this,props));_this.getCombinedMetricsMap=function(routeId){var _this$props=_this.props,stowPackageMetricsMap=_this$props.stowPackageMetricsMap,inductPackageMetricsMap=_this$props.inductPackageMetricsMap,stowAssociateMetricsMap=_this$props.stowAssociateMetricsMap,plannedPackageMetricsMap=_this$props.plannedPackageMetricsMap;var defaultMetricValue="-";var routeCode=plannedPackageMetricsMap[routeId].routeCode;return{routeCode:routeCode,plannedPackages:Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[routeId].plannedPackages;},defaultMetricValue),receivedPackages:Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["a" /* chainWalk */])(function(){return inductPackageMetricsMap[routeId].receivedPackages;},defaultMetricValue),currentInductedPackages:Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[routeId].currentInductedPackages;},defaultMetricValue),stowedPackages:Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[routeId].stowedPackages;},defaultMetricValue),stowVsPlan:Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[routeId].stowVsPlan;},defaultMetricValue),problemSolvePackages:Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[routeId].problemSolvePackages;},defaultMetricValue),fsaf:Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[routeId].fsaf;},defaultMetricValue),stowRate:Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[routeId].stowRate;},defaultMetricValue),scanCompliance:Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[routeId].scanCompliance;},defaultMetricValue),activeStowers:Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["a" /* chainWalk */])(function(){return stowAssociateMetricsMap[routeCode].activeStowers;},0),inactiveStowers:Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["a" /* chainWalk */])(function(){return stowAssociateMetricsMap[routeCode].inactiveStowers;},0)};};_this.renderClickableCount=function(value,state){var routeId=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var params=_this.createParams(state,routeId);return value!==0&&value!=='-'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link___default.a,{href:_this.getPackageListURL(params),type:"secondary"}," ",value," "):value;};_this.createParams=function(state,routeId){var params={PACKAGE_STATUS:state};if(!routeId){params["DRS"]="TRUE";}else{params["ROUTE_ID"]=routeId;}return params;};_this.getPackageListURL=function(params){return"#packageList/?"+Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["e" /* formQueryParams */])(params);};_this.state={routeCodePrefixes:props.routeCodePrefixesFromUrl,sortColumn:"routeCode",sortDirection:"ascending"};return _this;}_createClass(Route,[{key:"getFilteredRoutes",value:function getFilteredRoutes(routes,plannedPackageMetricsMap,stowPackageMetricsMap,routeCodePrefixList){var prefixFiltered=routes.filter(function(routeId){var routeCode=plannedPackageMetricsMap[routeId].routeCode.toUpperCase();if(routeCode&&routeCodePrefixList.length===0){return true;}return routeCodePrefixList.find(function(routeCodePrefix){return routeCode.startsWith(routeCodePrefix.toUpperCase());});});return Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["k" /* getFilteredLocations */])(prefixFiltered,stowPackageMetricsMap,false);}},{key:"render",value:function render(){var _this2=this;var _props=this.props,loading=_props.loading,plannedPackageMetricsMap=_props.plannedPackageMetricsMap,stowPackageMetricsMap=_props.stowPackageMetricsMap,capability=_props.capability;var routes=Object.keys(plannedPackageMetricsMap);var isAssociateMetricViewEnabled=!Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["t" /* isCapabilityARorSSD */])(capability);var isRouteDetailsEnabled=Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["t" /* isCapabilityARorSSD */])(capability);var routeCodePrefixList=this.state.routeCodePrefixes.split(",").map(function(routeCode){return routeCode.trim();}).filter(function(routeCode){return routeCode!=="";});var filteredRoutes=this.getFilteredRoutes(routes,plannedPackageMetricsMap,stowPackageMetricsMap,routeCodePrefixList);var onSort=function onSort(sortDetails){_this2.setState({sortColumn:sortDetails.sortColumn,sortDirection:sortDetails.sortDirection});};function customCompare(a,b){return Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["b" /* convertToString */])(a).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["b" /* convertToString */])(b),Object(__WEBPACK_IMPORTED_MODULE_13__handler_LocaleHandler__["b" /* getLocale */])(),{numeric:true});}var sortColumn=this.state.sortColumn;var direction=this.state.sortDirection;filteredRoutes.sort(function(r1,r2){var r1CombinedMetricsMap=_this2.getCombinedMetricsMap(r1);var r2CombinedMetricsMap=_this2.getCombinedMetricsMap(r2);if(direction==="ascending"){return customCompare(r1CombinedMetricsMap[sortColumn],r2CombinedMetricsMap[sortColumn]);}else{return customCompare(r2CombinedMetricsMap[sortColumn],r1CombinedMetricsMap[sortColumn]);}});if(loading&&!routes.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{height:"400px",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader___default.a,null));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{width:"30%",minWidth:"300px"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_input___default.a,{type:"text",size:"small",autoFocus:true,placeholder:"Filter by prefix ...",prefix:"Route Code",value:this.state.routeCodePrefixes,onChange:function onChange(routeCodePrefixes){return _this2.routeCodePrefixChanged(routeCodePrefixes);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__RefreshTimer__["a" /* default */],{deps:[stowPackageMetricsMap]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default.a,{headerRows:2,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true,sortColumn:this.state.sortColumn,sortDirection:this.state.sortDirection,onSort:onSort},this.renderHeadings(isAssociateMetricViewEnabled),this.renderSubHeadings(isAssociateMetricViewEnabled),filteredRoutes.map(function(route){return _this2.renderRouteRow(route,isAssociateMetricViewEnabled,isRouteDetailsEnabled);})));}},{key:"routeCodePrefixChanged",value:function routeCodePrefixChanged(routeCodePrefixes){this.setState(function(){return{routeCodePrefixes:routeCodePrefixes};});}},{key:"renderHeadings",value:function renderHeadings(isAssociateMetricViewEnabled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"cluster.packages",defaultMessage:"Packages"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"cluster.performance",defaultMessage:"Performance"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,null),isAssociateMetricViewEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"cluster.stowers",defaultMessage:"Stowers"})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,null));}},{key:"renderSubHeadings",value:function renderSubHeadings(isAssociateMetricViewEnabled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{sortColumn:"routeCode"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"route.route",defaultMessage:"Route"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{sortColumn:"plannedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"route.route_planned",defaultMessage:"R. Planned"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{sortColumn:"currentInductedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"cluster.inducted",defaultMessage:"Inducted"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"cluster.stowed",defaultMessage:"Stowed"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowVsPlan",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"cluster.stow_plan",defaultMessage:"Stow/Plan"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{sortColumn:"problemSolvePackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"cluster.ps",defaultMessage:"PS"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{sortColumn:"fsaf",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"aisle.fsaf",defaultMessage:"FSAF"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowRate",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"cluster.stow_rate",defaultMessage:"Stow rate"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{sortColumn:"scanCompliance",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"cluster.scan_complaince",defaultMessage:"Scan comp."})),isAssociateMetricViewEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{sortColumn:"activeStowers",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"cluster.active",defaultMessage:"Active"})):null,isAssociateMetricViewEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{sortColumn:"inactiveStowers",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"cluster.inactive",defaultMessage:"Inactive"})):null);}},{key:"renderRouteRow",value:function renderRouteRow(routeId,isAssociateMetricViewEnabled,isRouteDetailsEnabled){var combinedMetricsMap=this.getCombinedMetricsMap(routeId);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,{key:routeId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,null,isRouteDetailsEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link___default.a,{onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["x" /* onRouteClick */])(routeId,combinedMetricsMap.routeCode);},type:"secondary"},combinedMetricsMap.routeCode):combinedMetricsMap.routeCode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.plannedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderClickableCount(combinedMetricsMap.currentInductedPackages,__WEBPACK_IMPORTED_MODULE_11__enums__["n" /* PackageStatus */].CURRENT_INDUCTED,routeId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderClickableCount(combinedMetricsMap.stowedPackages,__WEBPACK_IMPORTED_MODULE_11__enums__["n" /* PackageStatus */].STOWED,routeId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.stowVsPlan,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderClickableCount(combinedMetricsMap.problemSolvePackages,__WEBPACK_IMPORTED_MODULE_11__enums__["n" /* PackageStatus */].PROBLEM_SOLVE,routeId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.fsaf),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.stowRate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.scanCompliance,"%"),isAssociateMetricViewEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.activeStowers):null,isAssociateMetricViewEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.inactiveStowers):null);}}]);return Route;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{loading:state.routeReducer.loading,stowPackageMetricsMap:state.routeReducer.stowPackageMetricsMap,plannedPackageMetricsMap:state.routeReducer.plannedPackageMetricsMap,inductPackageMetricsMap:state.routeReducer.inductPackageMetricsMap,stowAssociateMetricsMap:state.routeReducer.stowAssociateMetricsMap,capability:state.optionsReducer.capability};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Route)));

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_Loading__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ErrorPage__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RefreshTimer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_column__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Zone=function(_Component){_inherits(Zone,_Component);function Zone(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Zone);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Zone.__proto__||Object.getPrototypeOf(Zone)).call.apply(_ref,[this].concat(args))),_this),_this.getDistinctZones=function(){var allZones=[].concat(_toConsumableArray(Object.keys(_this.props.stowPackageMetricsMap)));var filteredZones=allZones.filter(function(zone){return zone!=="";});return[].concat(_toConsumableArray(new Set(filteredZones)));},_this.filteredZones=function(){var zones=_this.getDistinctZones().sort();var stowPackageMetricsMap=_this.props.stowPackageMetricsMap;return zones.filter(function(zone){return Boolean(stowPackageMetricsMap[zone].currentInductedPackages+stowPackageMetricsMap[zone].stowedPackages+stowPackageMetricsMap[zone].problemSolvePackages);});},_this.renderHeadings=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"zone.packages",defaultMessage:"Packages"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"zone.performance",defaultMessage:"Performance"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"zone.stowers",defaultMessage:"Stowers"})));},_this.renderSubHeadings=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"zone.zone",defaultMessage:"Zone"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"zone.inducted",defaultMessage:"Inducted"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"zone.stowed",defaultMessage:"Stowed"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"zone.ps",defaultMessage:"Problem Solve"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"zone.stow_rate",defaultMessage:"Stow rate"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{sortColumn:"scanCompliance",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"zone.scan_complaince",defaultMessage:"Scan comp."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"zone.active",defaultMessage:"Active"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"zone.inactive",defaultMessage:"Inactive"})));},_this.renderPackageMetrics=function(zone){var combinedMetricsMap=_this.getCombinedMetricsMap(zone);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,key:zone,onClick:function onClick(){return _this.zoneRowClicked(zone,combinedMetricsMap.displayLabel);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null,combinedMetricsMap.displayLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this.renderPackageCount(combinedMetricsMap.inductedPackages,zone,__WEBPACK_IMPORTED_MODULE_12__enums__["n" /* PackageStatus */].CURRENT_INDUCTED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this.renderPackageCount(combinedMetricsMap.stowedPackages,zone,__WEBPACK_IMPORTED_MODULE_12__enums__["n" /* PackageStatus */].STOWED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this.renderPackageCount(combinedMetricsMap.problemSolvePackages,zone,__WEBPACK_IMPORTED_MODULE_12__enums__["n" /* PackageStatus */].PROBLEM_SOLVE)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.stowRate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.scanCompliance,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.activeStowers),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.inactiveStowers));},_this.renderTotalPackageMetrics=function(){var combinedTotalMetricsMap=_this.getCombinedTotalMetricsMap();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null,"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedTotalMetricsMap.inductedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedTotalMetricsMap.stowedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedTotalMetricsMap.problemSolvePackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedTotalMetricsMap.stowRate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedTotalMetricsMap.scanCompliance,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedTotalMetricsMap.activeStowers),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedTotalMetricsMap.inactiveStowers));},_this.getCombinedMetricsMap=function(zone){var _this$props=_this.props,stowAssociateMetricsMap=_this$props.stowAssociateMetricsMap,stowPackageMetricsMap=_this$props.stowPackageMetricsMap;var defaultMetricValue=__WEBPACK_IMPORTED_MODULE_13__constants__["o" /* HYPHEN */];var displayLabel=Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[zone].displayLabel;},__WEBPACK_IMPORTED_MODULE_13__constants__["o" /* HYPHEN */]);return{inductedPackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[zone].currentInductedPackages;},defaultMetricValue),stowedPackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[zone].stowedPackages;},defaultMetricValue),problemSolvePackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[zone].problemSolvePackages;},defaultMetricValue),displayLabel:displayLabel,stowRate:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[zone].stowRate;},defaultMetricValue),scanCompliance:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[zone].scanCompliance;},defaultMetricValue),activeStowers:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowAssociateMetricsMap[zone].activeStowers;},defaultMetricValue),inactiveStowers:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return stowAssociateMetricsMap[zone].inactiveStowers;},defaultMetricValue)};},_this.getCombinedTotalMetricsMap=function(){var _this$props2=_this.props,totalStowAssociateMetrics=_this$props2.totalStowAssociateMetrics,totalStowPackageMetrics=_this$props2.totalStowPackageMetrics;var defaultMetricValue=__WEBPACK_IMPORTED_MODULE_13__constants__["o" /* HYPHEN */];var zone=__WEBPACK_IMPORTED_MODULE_13__constants__["w" /* TOTAL */];return{inductedPackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return totalStowPackageMetrics[zone].currentInductedPackages;},defaultMetricValue),stowedPackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return totalStowPackageMetrics[zone].stowedPackages;},defaultMetricValue),problemSolvePackages:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return totalStowPackageMetrics[zone].problemSolvePackages;},defaultMetricValue),stowRate:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return totalStowPackageMetrics[zone].stowRate;},defaultMetricValue),scanCompliance:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return totalStowPackageMetrics[zone].scanCompliance;},defaultMetricValue),activeStowers:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return totalStowAssociateMetrics[zone].activeStowers;},defaultMetricValue),inactiveStowers:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["a" /* chainWalk */])(function(){return totalStowAssociateMetrics[zone].inactiveStowers;},defaultMetricValue)};},_this.zoneRowClicked=function(zone,displayLabel){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_OptionsActions__["q" /* navigationAdded */])({key:'Zone',value:zone,displayValue:displayLabel}));},_this.renderPackageCount=function(value,zone,state){return value!==0&&value!=='-'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_link___default.a,{href:_this.getPackageListURL(state,zone),type:"secondary"}," ",value," "):value;},_this.getPackageListURL=function(state,zone){var params={PACKAGE_STATUS:state,CLUSTER:zone};var options=_this.props.options;if(options.cycle){params[__WEBPACK_IMPORTED_MODULE_13__constants__["b" /* CYCLE */]]=options.cycle;}return"#packageList/?"+Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["e" /* formQueryParams */])(params);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Zone,[{key:"render",value:function render(){var _this2=this;var error=this.props.error;var stowPackageMetricsMap=this.props.stowPackageMetricsMap;if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__utils_ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});}var zones=this.filteredZones();if(this.props.loading&&!zones.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__utils_Loading__["a" /* default */],{height:"400px"});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__RefreshTimer__["a" /* default */],{deps:[stowPackageMetricsMap]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default.a,{headerRows:2,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true},this.renderHeadings(),this.renderSubHeadings(),zones.map(function(zone){return _this2.renderPackageMetrics(zone);}),zones.length?this.renderTotalPackageMetrics():null));}/**
     * This function will return the distinct zones which have packages planned.
     * @returns list of zones
     */}]);return Zone;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{loading:state.zoneReducer.loading,error:state.zoneReducer.error,options:state.optionsReducer.options,stowAssociateMetricsMap:state.zoneReducer.stowAssociateMetricsMap,stowPackageMetricsMap:state.zoneReducer.stowPackageMetricsMap,totalStowAssociateMetrics:state.zoneReducer.totalStowAssociateMetrics,totalStowPackageMetrics:state.zoneReducer.totalStowPackageMetrics};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Zone)));

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_Loading__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ErrorPage__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__floor_CartStatus__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__floor_OvCartTableCell__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_CartLocationActions__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__RefreshTimer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_column__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CartLocation=function(_Component){_inherits(CartLocation,_Component);function CartLocation(props){_classCallCheck(this,CartLocation);var _this=_possibleConstructorReturn(this,(CartLocation.__proto__||Object.getPrototypeOf(CartLocation)).call(this,props));_this.getDistinctCartLocations=function(){var allCartLocations=[].concat(_toConsumableArray(Object.keys(_this.props.stowCartLocationsData)),_toConsumableArray(Object.keys(_this.props.stowPackageMetricsMap)));return[].concat(_toConsumableArray(new Set(allCartLocations)));};_this.renderHeadings=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"floor.location",defaultMessage:"Location"})),_this.isRouteCodeVisibleForSSDStations()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"floor.routeCode",defaultMessage:"Route code"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"floor.inducted",defaultMessage:"Inducted"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"floor.stowed",defaultMessage:"Stowed"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"floor.problem_solve",defaultMessage:"PS"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"floor.stow_rate",defaultMessage:"Stow rate"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"floor.scan_compliance",defaultMessage:"Scan comp."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"floor.cart_status",defaultMessage:"Cart status"})));};_this.renderCartLocationRow=function(floor){var combinedMetricsMap=_this.getCombinedMetricsMap(floor);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,key:floor,open:_this.isCartLocationExpanded(floor),onClick:function onClick(){return _this.floorRowClicked(floor);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,_this.getDisplayLabel(floor)),_this.isRouteCodeVisibleForSSDStations()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this.getRouteDetailsURL(combinedMetricsMap.routeId,combinedMetricsMap.routeCode)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this.renderPackageCount(combinedMetricsMap.inductedPackages,floor,__WEBPACK_IMPORTED_MODULE_11__enums__["n" /* PackageStatus */].CURRENT_INDUCTED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this.renderPackageCount(combinedMetricsMap.stowedPackages,floor,__WEBPACK_IMPORTED_MODULE_11__enums__["n" /* PackageStatus */].STOWED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this.renderPackageCount(combinedMetricsMap.problemSolvePackages,floor,__WEBPACK_IMPORTED_MODULE_11__enums__["n" /* PackageStatus */].PROBLEM_SOLVE)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.stowRate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.scanCompliance),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__floor_CartStatus__["a" /* default */],{status:combinedMetricsMap.cartStatus})),_this.renderCart(floor));};_this.getCombinedMetricsMap=function(floor){var _this$props=_this.props,stowCartLocationsData=_this$props.stowCartLocationsData,stowPackageMetricsMap=_this$props.stowPackageMetricsMap;var defaultMetricValue=__WEBPACK_IMPORTED_MODULE_8__constants__["o" /* HYPHEN */];return{inductedPackages:Object(__WEBPACK_IMPORTED_MODULE_13__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[floor].currentInductedPackages;},defaultMetricValue),routeCode:Object(__WEBPACK_IMPORTED_MODULE_13__Utility__["a" /* chainWalk */])(function(){return stowCartLocationsData[floor].routeCode;},defaultMetricValue),routeId:Object(__WEBPACK_IMPORTED_MODULE_13__Utility__["a" /* chainWalk */])(function(){return stowCartLocationsData[floor].routeId;},defaultMetricValue),stowedPackages:Object(__WEBPACK_IMPORTED_MODULE_13__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[floor].stowedPackages;},defaultMetricValue),problemSolvePackages:Object(__WEBPACK_IMPORTED_MODULE_13__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[floor].problemSolvePackages;},defaultMetricValue),scanCompliance:Object(__WEBPACK_IMPORTED_MODULE_13__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[floor].scanCompliance;},defaultMetricValue),stowRate:Object(__WEBPACK_IMPORTED_MODULE_13__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[floor].stowRate;},defaultMetricValue),cartStatus:Object(__WEBPACK_IMPORTED_MODULE_13__Utility__["a" /* chainWalk */])(function(){return stowCartLocationsData[floor].cart.status;},__WEBPACK_IMPORTED_MODULE_8__constants__["p" /* MISSING */])};};_this.isRouteCodeVisibleForSSDStations=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_8__constants__["j" /* FEATURES */].ROUTE_CODE_VISIBILITY];};_this.getDisplayLabel=function(floor){return Object(__WEBPACK_IMPORTED_MODULE_13__Utility__["a" /* chainWalk */])(function(){return floor.split(".")[1];},floor);};_this.isCartLocationExpanded=function(floor){return _this.state.expandedCartLocations.indexOf(floor)!==-1;};_this.renderCart=function(floor){var cart=_this.getCart(floor);if(cart){return _this.renderOvCart(cart);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default.a,null);};_this.getCart=function(floor){var cartData=_this.props.stowCartData;if(cartData&&cartData[floor]){return cartData[floor];}};_this.renderOvCart=function(cart){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__floor_OvCartTableCell__["a" /* default */],{cart:cart}));};_this.renderPackageCount=function(value,floor,state){return value!==0&&value!=='-'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link___default.a,{href:_this.getPackageListURL(state,floor),type:"secondary"}," ",value," "):value;};_this.getPackageListURL=function(state,floor){var params={PACKAGE_STATUS:state,AISLE:floor};return"#packageList/?"+Object(__WEBPACK_IMPORTED_MODULE_13__Utility__["e" /* formQueryParams */])(params);};_this.getRouteDetailsURL=function(routeId,routeCode){if(routeCode===__WEBPACK_IMPORTED_MODULE_8__constants__["o" /* HYPHEN */]){return routeCode;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link___default.a,{onClick:function onClick(){_this.isExpandEnabled.current=false;Object(__WEBPACK_IMPORTED_MODULE_13__Utility__["x" /* onRouteClick */])(routeId,routeCode);},type:"secondary"},routeCode);};_this.floorRowClicked=function(floor){if(_this.isExpandEnabled.current){_this.setState(function(oldState){if(oldState.expandedCartLocations.indexOf(floor)!==-1){return{expandedCartLocations:oldState.expandedCartLocations.filter(function(expandedCartLocation){return expandedCartLocation!==floor;})};}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_CartLocationActions__["f" /* getStowCartDataForCartLocation */])(_this.props.nodeId,floor));return{expandedCartLocations:oldState.expandedCartLocations.concat(floor)};}});}};_this.state={expandedCartLocations:[]};_this.isExpandEnabled=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.isExpandEnabled.current=true;return _this;}_createClass(CartLocation,[{key:"render",value:function render(){var _this2=this;var error=this.props.error;var stowPackageMetricsMap=this.props.stowPackageMetricsMap;if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__utils_ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});}var floors=this.getDistinctCartLocations().sort();if(this.props.loading&&!floors.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__utils_Loading__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__RefreshTimer__["a" /* default */],{deps:[stowPackageMetricsMap]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default.a,{headerRows:1,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true},this.renderHeadings(),floors.map(function(floor){return _this2.renderCartLocationRow(floor);})));}}]);return CartLocation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{loading:state.cartLocationReducer.loading,error:state.cartLocationReducer.error,stowCartData:state.cartLocationReducer.stowCartData,stowCartLocationsData:state.cartLocationReducer.stowCartLocationsData,stowPackageMetricsMap:state.cartLocationReducer.stowPackageMetricsMap};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(CartLocation)));

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ErrorPage__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RefreshTimer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_DateTimeUtils__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_OptionsActions__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Floor Location View with floor location as the primary column.
 * Currently, used for showing sidelined packages.
 */var FloorLocation=function(_Component){_inherits(FloorLocation,_Component);function FloorLocation(props){_classCallCheck(this,FloorLocation);var _this=_possibleConstructorReturn(this,(FloorLocation.__proto__||Object.getPrototypeOf(FloorLocation)).call(this,props));_this.getCombinedMetricsMap=function(compositeKey){var _this$props=_this.props,stowFloorMetricsMap=_this$props.stowFloorMetricsMap,stowPackageMetricsMap=_this$props.stowPackageMetricsMap;var defaultMetricValue="-";var _this$parseCompositeK=_this.parseCompositeKey(compositeKey),floorLocation=_this$parseCompositeK.floorLocation,reInductDay=_this$parseCompositeK.reInductDay;return{floorLocation:floorLocation,reInductDay:reInductDay,currentInductedPackages:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[compositeKey].currentInductedPackages;},defaultMetricValue),currentStowedPackages:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[compositeKey].currentStowedPackages;},defaultMetricValue),attachedCartCount:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return stowFloorMetricsMap[compositeKey].floorMetrics.attachedCartCount;},defaultMetricValue),stowRate:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[compositeKey].stowRate;},defaultMetricValue),scanCompliance:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[compositeKey].currentScanCompliance;},defaultMetricValue),activeStowers:defaultMetricValue,//chainWalk(() => stowAssociateMetricsMap[compositeKey].activeStowers, defaultMetricValue),
inactiveStowers:defaultMetricValue//chainWalk(() => stowAssociateMetricsMap[compositeKey].inactiveStowers, defaultMetricValue)
};};_this.parseCompositeKey=function(key){var splitKey=key.split("|");return{floorLocation:splitKey[0],reInductDay:splitKey[1]};};_this.isSidelineViewV2Enabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_15__constants__["j" /* FEATURES */].SIDELINE_STOW_V2];};_this.isReInductDatePlusOneFixEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_15__constants__["j" /* FEATURES */].REINDUCT_DATE_PLUS_ONE_FIX];};_this.renderPackageCount=function(value,compositeKey,state){var _this$parseCompositeK2=_this.parseCompositeKey(compositeKey),floorLocation=_this$parseCompositeK2.floorLocation,reInductDay=_this$parseCompositeK2.reInductDay;var params={PACKAGE_STATUS:state,FLOOR_LOCATION:floorLocation,SIDELINE_UNTIL_TIME:reInductDay};if(_this.isSidelineViewV2Enabled()){params.SIDELINE_V2=__WEBPACK_IMPORTED_MODULE_15__constants__["x" /* TRUE */];}else{params.SIDELINE=__WEBPACK_IMPORTED_MODULE_15__constants__["x" /* TRUE */];}return value!==0&&value!=='-'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_link___default.a,{href:_this.getPackageListURL(params),type:"secondary"}," ",value," "):value;};_this.getPackageListURL=function(params){return"#packageList/?"+Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["e" /* formQueryParams */])(params);};_this.rowClicked=function(floorLocationAndReInductDay){var _this$parseCompositeK3=_this.parseCompositeKey(floorLocationAndReInductDay),floorLocation=_this$parseCompositeK3.floorLocation,reInductDay=_this$parseCompositeK3.reInductDay;_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_OptionsActions__["q" /* navigationAdded */])({key:'Floor Location, Re-Induct Day',value:[floorLocation,reInductDay],displayValue:floorLocation+", "+Object(__WEBPACK_IMPORTED_MODULE_12__utils_DateTimeUtils__["a" /* getFormattedDate */])(reInductDay,_this.isReInductDatePlusOneFixEnabled())}));};_this.state={sortColumn:"floorLocation",sortDirection:"ascending"};return _this;}_createClass(FloorLocation,[{key:"render",value:function render(){var _this2=this;var _props=this.props,loading=_props.loading,error=_props.error,stowPackageMetricsMap=_props.stowPackageMetricsMap,stowFloorMetricsMap=_props.stowFloorMetricsMap,stowAssociateMetricsMap=_props.stowAssociateMetricsMap;if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utils_ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});var allFloorLocationsAndSidelineUntilTime=[].concat(_toConsumableArray(Object.keys(stowFloorMetricsMap)),_toConsumableArray(Object.keys(stowPackageMetricsMap)),_toConsumableArray(Object.keys(stowAssociateMetricsMap)));var distinctFloorLocationsAndSidelineUntilTime=[].concat(_toConsumableArray(new Set(allFloorLocationsAndSidelineUntilTime)));if(loading&&!distinctFloorLocationsAndSidelineUntilTime.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default.a,{height:"400px",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader___default.a,null));}var onSort=function onSort(sortDetails){_this2.setState({sortColumn:sortDetails.sortColumn,sortDirection:sortDetails.sortDirection});};var sortColumn=this.state.sortColumn;var direction=this.state.sortDirection;distinctFloorLocationsAndSidelineUntilTime.sort(function(c1,c2){var c1CombinedMetricsMap=_this2.getCombinedMetricsMap(c1);var c2CombinedMetricsMap=_this2.getCombinedMetricsMap(c2);if(c1CombinedMetricsMap[sortColumn]<c2CombinedMetricsMap[sortColumn]){return direction==="ascending"?-1:1;}if(c1CombinedMetricsMap[sortColumn]>c2CombinedMetricsMap[sortColumn]){return direction==="ascending"?1:-1;}return 0;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__RefreshTimer__["a" /* default */],{deps:[stowPackageMetricsMap]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table___default.a,{headerRows:2,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true,sortColumn:this.state.sortColumn,sortDirection:this.state.sortDirection,onSort:onSort,"data-cy":"floorLocationTable"},this.renderHeadings(),this.renderSubHeadings(),distinctFloorLocationsAndSidelineUntilTime.map(function(compositeKey){return _this2.renderFloorLocationRow(compositeKey);}),distinctFloorLocationsAndSidelineUntilTime.length?this.renderTotalFloorLocationRow():null));}},{key:"renderHeadings",value:function renderHeadings(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"floorLocation.packages",defaultMessage:"Packages"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"floorLocation.carts",defaultMessage:"Carts"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"floorLocation.performance",defaultMessage:"Performance"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"floorLocation.stowers",defaultMessage:"Stowers"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null));}},{key:"renderSubHeadings",value:function renderSubHeadings(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"floorLocation"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"floorLocation.floor_location",defaultMessage:"Floor Location"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"reInductDay"},this.isReInductDatePlusOneFixEnabled()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"floorLocation.ofd",defaultMessage:"OFD"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"floorLocation.re_induct_day",defaultMessage:"Re-induct Day"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"currentInductedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"floorLocation.inducted",defaultMessage:"Inducted"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"currentStowedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"floorLocation.stowed",defaultMessage:"Stowed"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"attachedCartCount",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"floorLocation.no_of_carts",defaultMessage:"# of Carts"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowRate",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"floorLocation.stow_rate",defaultMessage:"Stow rate"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"scanCompliance",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"floorLocation.scan_compliance",defaultMessage:"Scan comp."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"activeStowers",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"floorLocation.active",defaultMessage:"Active"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"inactiveStowers",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"floorLocation.inactive",defaultMessage:"Inactive"})));}},{key:"renderFloorLocationRow",value:function renderFloorLocationRow(compositeKey){var _this3=this;var combinedMetricsMap=this.getCombinedMetricsMap(compositeKey);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,key:combinedMetricsMap.floorLocation+combinedMetricsMap.reInductDay,onClick:function onClick(){return _this3.rowClicked(compositeKey);},"data-cy":"floorLocationDataRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,combinedMetricsMap.floorLocation),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_12__utils_DateTimeUtils__["a" /* getFormattedDate */])(combinedMetricsMap.reInductDay,this.isReInductDatePlusOneFixEnabled())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.currentInductedPackages,compositeKey,__WEBPACK_IMPORTED_MODULE_14__enums__["n" /* PackageStatus */].CURRENT_INDUCTED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.currentStowedPackages,compositeKey,__WEBPACK_IMPORTED_MODULE_14__enums__["n" /* PackageStatus */].CURRENT_STOWED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.attachedCartCount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.stowRate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.scanCompliance,'-'!==combinedMetricsMap.scanCompliance&&'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.activeStowers),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.inactiveStowers));}},{key:"renderTotalFloorLocationRow",value:function renderTotalFloorLocationRow(){var totalMetricsMap=this.getTotalStowMetricsMap();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,{"data-cy":"floorLocationTotalRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,totalMetricsMap.floorLocation),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,totalMetricsMap.reInductDay),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},totalMetricsMap.currentInductedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},totalMetricsMap.currentStowedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},totalMetricsMap.attachedCartCount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},totalMetricsMap.stowRate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},totalMetricsMap.scanCompliance,'-'!==totalMetricsMap.scanCompliance&&'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},totalMetricsMap.activeStowers),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},totalMetricsMap.inactiveStowers));}},{key:"getTotalStowMetricsMap",value:function getTotalStowMetricsMap(){var totalStowPackageMetrics=this.props.totalStowPackageMetrics;var defaultMetricValue="-";return{floorLocation:__WEBPACK_IMPORTED_MODULE_15__constants__["w" /* TOTAL */],reInductDay:defaultMetricValue,currentInductedPackages:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return totalStowPackageMetrics.currentInductedPackages;},defaultMetricValue),currentStowedPackages:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return totalStowPackageMetrics.currentStowedPackages;},defaultMetricValue),attachedCartCount:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return totalStowPackageMetrics.floorMetrics.attachedCartCount;},defaultMetricValue),stowRate:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return totalStowPackageMetrics.stowRate;},defaultMetricValue),scanCompliance:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return totalStowPackageMetrics.currentScanCompliance;},defaultMetricValue),activeStowers:defaultMetricValue,//chainWalk(() => stowAssociateMetricsMap[compositeKey].activeStowers, defaultMetricValue),
inactiveStowers:defaultMetricValue//chainWalk(() => stowAssociateMetricsMap[compositeKey].inactiveStowers, defaultMetricValue)
};}}]);return FloorLocation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{loading:state.floorLocationReducer.loading,error:state.floorLocationReducer.error,options:state.floorLocationReducer.options,stowFloorMetricsMap:state.floorLocationReducer.stowFloorMetricsMap,stowPackageMetricsMap:state.floorLocationReducer.stowPackageMetricsMap,stowAssociateMetricsMap:state.floorLocationReducer.stowAssociateMetricsMap,totalStowPackageMetrics:state.floorLocationReducer.totalStowPackageMetrics,featureStatus:state.configReducer.featureStatus};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(FloorLocation)));

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_Loading__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ErrorPage__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RefreshTimer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_DateTimeUtils__ = __webpack_require__(261);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Cart View containing package information at cart level.
 */var Cart=function(_Component){_inherits(Cart,_Component);function Cart(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Cart);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Cart.__proto__||Object.getPrototypeOf(Cart)).call.apply(_ref,[this].concat(args))),_this),_this.renderHeadings=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"cart.floor_location",defaultMessage:"Floor Location"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,_this.isReInductDatePlusOneFixEnabled()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"cart.ofd",defaultMessage:"OFD"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"cart.reInductDay",defaultMessage:"Re-Induct Day"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"cart.cart_id",defaultMessage:"Cart ID"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"cart.no_of_packages",defaultMessage:"# of Packages"})));},_this.renderCartRow=function(cart){var combinedMetricsMap=_this.getCombinedMetricsMap(cart);var _this$getViewSubjects=_this.getViewSubjects('Floor Location, Re-Induct Day'),_this$getViewSubjects2=_slicedToArray(_this$getViewSubjects,2),floorLocation=_this$getViewSubjects2[0],reInductDay=_this$getViewSubjects2[1];var cartFromCompositeKey=cart.split("|")[0];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,key:cart},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,floorLocation),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_15__utils_DateTimeUtils__["a" /* getFormattedDate */])(reInductDay,_this.isReInductDatePlusOneFixEnabled())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},cartFromCompositeKey),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this.renderPackageCount(combinedMetricsMap.currentStowedPackages,cartFromCompositeKey,__WEBPACK_IMPORTED_MODULE_11__enums__["n" /* PackageStatus */].CURRENT_STOWED,floorLocation,reInductDay)));},_this.getCombinedMetricsMap=function(cart){return{currentStowedPackages:Object(__WEBPACK_IMPORTED_MODULE_12__Utility__["a" /* chainWalk */])(function(){return _this.props.stowPackageMetricsMap[cart].currentStowedPackages;},__WEBPACK_IMPORTED_MODULE_8__constants__["o" /* HYPHEN */])};},_this.renderPackageCount=function(value,cart,state,floorLocation,reInductDay){return value!==0&&value!==__WEBPACK_IMPORTED_MODULE_8__constants__["o" /* HYPHEN */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link___default.a,{href:_this.getPackageListURL(state,cart,floorLocation,reInductDay),type:"secondary"},value):value;},_this.isSidelineViewV2Enabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_8__constants__["j" /* FEATURES */].SIDELINE_STOW_V2];},_this.isReInductDatePlusOneFixEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_8__constants__["j" /* FEATURES */].REINDUCT_DATE_PLUS_ONE_FIX];},_this.getPackageListURL=function(state,cart,floorLocation,reInductDay){var params={PACKAGE_STATUS:state,FLOOR_LOCATION:floorLocation,SIDELINE_UNTIL_TIME:reInductDay,CART:cart};if(_this.isSidelineViewV2Enabled()){params.SIDELINE_V2=__WEBPACK_IMPORTED_MODULE_8__constants__["x" /* TRUE */];}else{params.SIDELINE=__WEBPACK_IMPORTED_MODULE_8__constants__["x" /* TRUE */];}return"#packageList/?"+Object(__WEBPACK_IMPORTED_MODULE_12__Utility__["e" /* formQueryParams */])(params);},_this.getViewSubjects=function(key){return Object(__WEBPACK_IMPORTED_MODULE_12__Utility__["a" /* chainWalk */])(function(){return _this.props.navigationOptions.find(function(navigationOption){return navigationOption.key===key;}).value;},[]);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Cart,[{key:"render",value:function render(){var _this2=this;var _props=this.props,loading=_props.loading,error=_props.error,stowPackageMetricsMap=_props.stowPackageMetricsMap;if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__utils_ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});var allCarts=[].concat(_toConsumableArray(Object.keys(stowPackageMetricsMap)));var carts=[].concat(_toConsumableArray(new Set(allCarts.filter(function(cart){return stowPackageMetricsMap[cart].currentStowedPackages>0;})))).sort();if(loading&&!carts.length)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__utils_Loading__["a" /* default */],null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__RefreshTimer__["a" /* default */],{deps:[stowPackageMetricsMap]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default.a,{headerRows:1,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true},this.renderHeadings(),carts.map(function(cart){return _this2.renderCartRow(cart);})));}}]);return Cart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{loading:state.cartReducer.loading,error:state.cartReducer.error,navigationOptions:state.optionsReducerV2.navigationOptions,stowPackageMetricsMap:state.cartReducer.stowPackageMetricsMap,featureStatus:state.configReducer.featureStatus};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Cart)));

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getTableStyle;
/* harmony export (immutable) */ __webpack_exports__["a"] = compareAisleInfoForSorting;
/* harmony export (immutable) */ __webpack_exports__["c"] = unFlattenSortLocationsModel;
var reservedColorList=["#ddebf7","#fff2cc","#fce4d6","#C5C5C5"];var unreservedColor="#e2efda";var availableText="Available";/**
 * The inline style definition for sort grid allocation table
 * @param color
 * @returns {{border: string, borderCollapse: string, backgroundColor, textAlign: string}}
 */function getTableStyle(color){return{'border':'1px solid grey','borderCollapse':'collapse','textAlign':'center','backgroundColor':color};}/**
 * Comparison logic for sorting two aisles based on sortIndex
 * @param aisle1
 * @param aisle2
 * @returns {number}
 */function compareAisleInfoForSorting(aisle1,aisle2){var aisle1Index=aisle1.sortIndex;var aisle2Index=aisle2.sortIndex;return aisle1Index>aisle2Index?1:-1;}/**
 * From a list of sort locations, create a top-down model for rendering
 * @param sortLocations
 * @returns {*}
 */function unFlattenSortLocationsModel(sortLocations){var clusterInfoMap={};var colorMapping={};var lastUsedColorIndex=-1;function getColorForReservingEntity(reservedFor){if(!(reservedFor in colorMapping)){// get new color
var newColorIndex=getRotatingIndex(lastUsedColorIndex,reservedColorList.length);colorMapping[reservedFor]=reservedColorList[newColorIndex];lastUsedColorIndex=newColorIndex;}return colorMapping[reservedFor];}if(sortLocations){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=sortLocations[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var sortLocationInfo=_step.value;var sortLocationLabel=sortLocationInfo.label;var aisleLabel=sortLocationInfo.aisle;var clusterLabel=getClusterLabelFromAisle(aisleLabel);var columnLabel=getColumnLabelFromSortLocation(sortLocationLabel);if(!(clusterLabel in clusterInfoMap)){clusterInfoMap[clusterLabel]=getSkeletonClusterInfo(clusterLabel);}var aisleInfoMap=clusterInfoMap[clusterLabel].aisleInfoMap;var aisleInfo=!(aisleLabel in aisleInfoMap)?getSkeletonAisleInfo(aisleLabel):aisleInfoMap[aisleLabel];// push the sort location info in aisle object
if(!(columnLabel in aisleInfo.sortLocations)){aisleInfo.sortLocations[columnLabel]=[];}// mark the aisle as reserved if the sort location is reserved.
if(sortLocationInfo.status==="RES"){var color=getColorForReservingEntity(sortLocationInfo.reservedFor);aisleInfo.sortLocations[columnLabel].push(getReservedSortLocationInfo(sortLocationInfo,color));aisleInfo.reservedFor=sortLocationInfo.reservedFor;aisleInfo.color=color;}else{aisleInfo.sortLocations[columnLabel].push(getAvailableSortLocationInfo(sortLocationInfo));}clusterInfoMap[clusterLabel].aisleInfoMap[aisleLabel]=aisleInfo;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}return clusterInfoMap;}function getSkeletonClusterInfo(clusterLabel){return{"label":clusterLabel,"aisleInfoMap":{}};}function getSkeletonAisleInfo(aisleLabel){return{"sortIndex":getAisleSortIndex(aisleLabel),"label":aisleLabel,"color":unreservedColor,"reservedFor":availableText,"sortLocations":{}};}function getAvailableSortLocationInfo(sortLocationInfo){return{"label":sortLocationInfo.label,"reservedFor":availableText,"color":unreservedColor};}function getReservedSortLocationInfo(sortLocationInfo,color){return{"label":sortLocationInfo.label,"reservedFor":sortLocationInfo.reservedFor,"color":color};}function getRotatingIndex(lastUsedIndex,boundLength){var newIndex=lastUsedIndex+1;if(newIndex>boundLength-1){newIndex=0;}return newIndex;}/**
 * get cluster label from aisle.
 * @param aisleLabel
 * @returns {*|string}
 */function getClusterLabelFromAisle(aisleLabel){return aisleLabel?aisleLabel[0]:"Unknown";}/**
 * get column label from sort location
 * @param sortLocationLabel
 * @returns {*|string}
 */function getColumnLabelFromSortLocation(sortLocationLabel){return sortLocationLabel.charAt(sortLocationLabel.length-1);}/**
 * Get sort index for an aisle for sorting while displaying
 * @param aisleLabel
 * @returns {number|number}
 */function getAisleSortIndex(aisleLabel){var matches=aisleLabel.match(/(\d+)/);return matches.length>0?parseInt(matches[0],10):0;}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    scrimBackgroundColor: tokens.themeBackgroundOverlayDefault,
    scrimMotionTiming: "150ms",
    scrimMotionFunction: "ease",
    scrimElevation: 60
  }
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Pass this as a child to the `Select` component to render it as an option of
 * the select.
 */
var SelectOption = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SelectOption, _React$Component);

  var _super = _createSuper(SelectOption);

  function SelectOption() {
    (0, _classCallCheck2["default"])(this, SelectOption);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SelectOption, [{
    key: "render",
    value: function render() {
      // The top-level OptionListItem component is used to render this. See
      // ./select-option-list for the implementation.
      return null;
    }
  }]);
  return SelectOption;
}(_react["default"].Component);

SelectOption.propTypes =  false ? {
  /**
   * The option's label.
   *
   * This is shown in the `Select` component's field when the option is
   * selected, and as the text for the option if no `children` prop is provided.
   */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,

  /**
   * The value of the option. This will be passed to the `Select` component's
   * `onChange` handler when this option is selected.
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Use this to render custom (non-plain-text) children in the option.
   *
   * This should be a function that returns the elements to render. It will
   * receive as its only argument an object containing the following keys:
   *   - `preselected` - a boolean that will be true if the user has
   *     focused on the option with their mouse or keyboard
   *   - `selected` - a boolean that will be true if the user has selected the
   *     option.
   * This data can be used to tailor the display of the custom option children
   * based on the state of the option.
   */
  children: _propTypes["default"].func,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool
} : {};
var _default = SelectOption;
exports["default"] = _default;

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_box__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_tag__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_loader__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_context_DeviceLayoutContext__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_FilterExpander__ = __webpack_require__(271);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Options=function(_Component){_inherits(Options,_Component);function Options(){_classCallCheck(this,Options);return _possibleConstructorReturn(this,(Options.__proto__||Object.getPrototypeOf(Options)).apply(this,arguments));}_createClass(Options,[{key:"render",value:function render(){var _this2=this;var _props=this.props,loading=_props.loading,options=_props.options,optionsTagsRequired=_props.optionsTagsRequired,selectedOptions=_props.selectedOptions,isMobile=_props.isMobile;var isFilterSet=function isFilterSet(){var isFilterSet=false;Object.keys(selectedOptions).filter(function(key){return!__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CONSTANT_FILTERS */].includes(key);}).forEach(function(key){isFilterSet=isFilterSet||selectedOptions[key]!==undefined&&selectedOptions[key].length!==0;});return isFilterSet;};function showOptions(){if(loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{height:"100px",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_loader___default.a,null));}if(isMobile){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__common_FilterExpander__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{alignmentHorizontal:"left",alignmentVertical:"top",spacingInset:"medium small",backgroundColor:"secondary"},options.map(function(option){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{heights:"fill",alignmentHorizontal:"center",spacingInset:"none medium none",key:option.name},option.component);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentVertical:"top",alignmenHorizontal:"left"},renderFilterTags()))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"left",alignmentVertical:"top",spacingInset:"medium large",backgroundColor:"secondary"},options.map(function(option){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{heights:"fill",alignmentHorizontal:"center",spacingInset:"none medium none",key:option.name},option.component);}));}var renderSelectedOptions=function renderSelectedOptions(){return Object.keys(selectedOptions).filter(function(key){return optionsTagsRequired.includes(key);}).map(function(optionKey){var optionValues=selectedOptions[optionKey];if(Array.isArray(optionValues)){return optionValues.filter(Boolean).map(function(optionValue){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_tag___default.a,{type:"theme",key:optionValue,onClose:function onClose(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_OptionsActions__["t" /* optionRemoved */])(optionKey,optionValue));}},optionValue);});}else if(optionValues){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_tag___default.a,{key:optionValues,type:"theme"},optionValues);}else{return null;}});};var renderFilterTags=function renderFilterTags(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"options-tag"},renderSelectedOptions(),isFilterSet()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link___default.a,{onClick:function onClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_OptionsActions__["s" /* optionRemoveAll */])());},type:"secondary",style:{whiteSpace:'nowrap'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */],{id:"clear_all",defaultMessage:"Clear all"})):null);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{width:"100%",className:"Options",spacingInset:"none"},showOptions(),!isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{widths:["grid-11"],alignmentVertical:"top",alignmenHorizontal:"left"},renderFilterTags()));}}]);return Options;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// Adapter to convert class component to functional component.
function classToFunctionAdapter(CustomComponent){return function WrappedComponent(props){var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_12__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),isMobile=_useDeviceLayout.isMobile;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomComponent,Object.assign({},props,{isMobile:isMobile}));};}var mapStateToProps=function mapStateToProps(state){return{loading:state.optionsReducer.loading,selectedOptions:state.optionsReducer.options,showingOptionsMenu:state.optionsReducer.showingOptionsMenu};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps)(classToFunctionAdapter(Options))));

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _radioButton = _interopRequireDefault(__webpack_require__(658));

var _default = _radioButton["default"];
exports["default"] = _default;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(672),
    isObjectLike = __webpack_require__(96);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(70),
    root = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 179 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(689),
    mapCacheDelete = __webpack_require__(696),
    mapCacheGet = __webpack_require__(698),
    mapCacheHas = __webpack_require__(699),
    mapCacheSet = __webpack_require__(700);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(717),
    baseKeys = __webpack_require__(724),
    isArrayLike = __webpack_require__(297);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 182 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(56),
    isSymbol = __webpack_require__(184);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(95),
    isObjectLike = __webpack_require__(96);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssociateScanContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_AssociateScanReducer__ = __webpack_require__(763);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AssociateScanContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var AssociateScanContextProvider=function AssociateScanContextProvider(props){var associateScanData={chartData:{granularity:"15m",selectedAssociates:[]},scanMetrics:{},associateList:[]};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducers_AssociateScanReducer__["a" /* AssociateScanReducer */],associateScanData),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AssociateScanContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (AssociateScanContextProvider);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return INDUCT_CALL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return INDUCT_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INDUCT_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MACHINE_STATUS_CALL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MACHINE_STATUS_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MACHINE_STATUS_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BAY_TABLE_DATA_CALL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BAY_TABLE_DATA_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BAY_TABLE_DATA_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BAY_TABLE_DATA_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MACHINE_TABLE_DATA_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MACHINE_TABLE_DATA_CALL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MACHINE_TABLE_DATA_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PLANNED_COUNT_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PLANNED_COUNT_CALL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PLANNED_COUNT_CALL_FAILURE; });
/* unused harmony export machineTableDataCallSuccess */
/* unused harmony export bayTableDataCallSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return bayTableDataClear; });
/* harmony export (immutable) */ __webpack_exports__["s"] = getInductCount;
/* harmony export (immutable) */ __webpack_exports__["u"] = getMachineTableData;
/* harmony export (immutable) */ __webpack_exports__["r"] = getBayTableData;
/* harmony export (immutable) */ __webpack_exports__["t"] = getMachineStatus;
/* harmony export (immutable) */ __webpack_exports__["v"] = getPlannedCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_InductResource__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resources_StowResource__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resources_StowBufferResource__ = __webpack_require__(788);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var INDUCT_CALL_SUCCESS="INDUCT_CALL_SUCCESS";var INDUCT_CALL_FAILURE="INDUCT_CALL_FAILURE";var INDUCT_CALL_BEGIN='INDUCT_CALL_BEGIN';var MACHINE_STATUS_CALL_SUCCESS="MACHINE_STATUS_CALL_SUCCESS";var MACHINE_STATUS_CALL_FAILURE="MACHINE_STATUS_CALL_FAILURE";var MACHINE_STATUS_CALL_BEGIN='MACHINE_STATUS_CALL_BEGIN';var BAY_TABLE_DATA_CALL_SUCCESS="BAY_TABLE_DATA_CALL_SUCCESS";var BAY_TABLE_DATA_CALL_FAILURE="BAY_TABLE_DATA_CALL_FAILURE";var BAY_TABLE_DATA_CALL_BEGIN='BAY_TABLE_DATA_CALL_BEGIN';var BAY_TABLE_DATA_CLEAR='BAY_TABLE_DATA_CLEAR';var MACHINE_TABLE_DATA_CALL_BEGIN="MACHINE_TABLE_DATA_CALL_BEGIN";var MACHINE_TABLE_DATA_CALL_SUCCESS="MACHINE_TABLE_DATA_CALL_SUCCESS";var MACHINE_TABLE_DATA_CALL_FAILURE="MACHINE_TABLE_DATA_CALL_FAILURE";var PLANNED_COUNT_CALL_BEGIN="PLANNED_COUNT_CALL_BEGIN";var PLANNED_COUNT_CALL_SUCCESS="PLANNED_COUNT_CALL_SUCCESS";var PLANNED_COUNT_CALL_FAILURE="PLANNED_COUNT_CALL_FAILURE";var plannedCountDataCallBegin=function plannedCountDataCallBegin(){return{type:PLANNED_COUNT_CALL_BEGIN};};var plannedCountDataCallSuccess=function plannedCountDataCallSuccess(stowPackageMetricsMap){return{type:PLANNED_COUNT_CALL_SUCCESS,stowPackageMetricsMap:stowPackageMetricsMap};};var plannedCountDataCallFailure=function plannedCountDataCallFailure(){return{type:PLANNED_COUNT_CALL_FAILURE};};var machineTableDataCallBegin=function machineTableDataCallBegin(){return{type:MACHINE_TABLE_DATA_CALL_BEGIN};};var machineTableDataCallSuccess=function machineTableDataCallSuccess(machineList){return{type:MACHINE_TABLE_DATA_CALL_SUCCESS,machineList:machineList};};var machineTableDataCallFailure=function machineTableDataCallFailure(){return{type:MACHINE_TABLE_DATA_CALL_FAILURE};};var inductCallSuccess=function inductCallSuccess(inductCount){return{type:INDUCT_CALL_SUCCESS,inductCount:inductCount};};var inductCallBegin=function inductCallBegin(){return{type:INDUCT_CALL_BEGIN};};var inductCallFailure=function inductCallFailure(){return{type:INDUCT_CALL_FAILURE};};var machineStatusCallSuccess=function machineStatusCallSuccess(machineStatusList){return{type:MACHINE_STATUS_CALL_SUCCESS,machineStatusList:machineStatusList};};var machineStatusCallBegin=function machineStatusCallBegin(){return{type:MACHINE_STATUS_CALL_BEGIN};};var machineStatusCallFailure=function machineStatusCallFailure(){return{type:MACHINE_STATUS_CALL_FAILURE};};var bayTableDataCallSuccess=function bayTableDataCallSuccess(bayList){return{type:BAY_TABLE_DATA_CALL_SUCCESS,bayList:bayList};};var bayTableDataCallBegin=function bayTableDataCallBegin(){return{type:BAY_TABLE_DATA_CALL_BEGIN};};var bayTableDataClear=function bayTableDataClear(){return{type:BAY_TABLE_DATA_CLEAR};};var bayTableDataCallFailure=function bayTableDataCallFailure(){return{type:BAY_TABLE_DATA_CALL_FAILURE};};function addStatusToMachineList(machineList,machineStatusList){var machineStatusMap={};machineStatusList&&machineStatusList.data.adtaStatusList.forEach(function(machine){machineStatusMap[machine.mac]=machine.status;});return machineList.map(function(machine){return Object.assign({},machine,{status:machineStatusMap[machine.macAddress]});});}function addPlannedVolumeToBayTable(bayList,plannedVolumeList){var plannedVolumeMap={};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.entries(plannedVolumeList)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _ref=_step.value;var _ref2=_slicedToArray(_ref,2);var key=_ref2[0];var value=_ref2[1];plannedVolumeMap[key]=value.plannedPackages;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return bayList.map(function(bayListItem){var plannedVolumeSum=0;bayListItem.name.split(" ").forEach(function(bay){var bayName=bay[0]+bay.slice(2);plannedVolumeSum+=parseInt(plannedVolumeMap[bayName],10);});if(!plannedVolumeSum&&plannedVolumeSum!==0){plannedVolumeSum="-";}return Object.assign({},bayListItem,{plannedVolumeSum:plannedVolumeSum});});}function getInductCount(cycles,nodeId){var _this=this;var filterMap={'Cycle':[cycles]};var request={nodeId:nodeId,groupBy:'Node',filters:filterMap,metricList:["PLANNED_CURRENT_CYCLE_INDUCTED","UNPLANNED_CURRENT_CYCLE_INDUCTED"]};return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var inductPackageMetricsMap,inductValue;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(inductCallBegin());_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_InductResource__["a" /* getInductPackageMetrics */])(request);case 4:inductPackageMetricsMap=_context.sent;inductValue=inductPackageMetricsMap[nodeId].plannedInducted+inductPackageMetricsMap[nodeId].unplannedInducted;dispatch(inductCallSuccess(inductValue));_context.next=12;break;case 9:_context.prev=9;_context.t0=_context["catch"](1);dispatch(inductCallFailure());case 12:case"end":return _context.stop();}}},_callee,_this,[[1,9]]);}));return function(_x){return _ref3.apply(this,arguments);};}();}function getMachineTableData(nodeId,cycles,groupBy){var _this2=this;var request={filters:{NODE:[nodeId]},fieldsRequired:["NAME","STATUS","PERFORMANCE","LOCATION"],tabView:"STOW_BUFFERED"};if(groupBy){request['groupBy']=groupBy;}if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CYCLE */]]=[cycles];}return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var machineList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;dispatch(machineTableDataCallBegin());_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_6__resources_StowBufferResource__["b" /* getStowBufferTableData */])(request);case 4:machineList=_context2.sent;if(machineList){dispatch(machineTableDataCallSuccess(machineList));}else{dispatch(machineTableDataCallFailure());}_context2.next=11;break;case 8:_context2.prev=8;_context2.t0=_context2["catch"](0);dispatch(machineTableDataCallFailure());case 11:case"end":return _context2.stop();}}},_callee2,_this2,[[0,8]]);}));return function(_x2){return _ref4.apply(this,arguments);};}();}function getBayTableData(nodeId,cycles,groupBy,machineName,plannedVolumeList){var _this3=this;var request={filters:{NODE:[nodeId]},fieldsRequired:["NAME","STATUS","PERFORMANCE","LOCATION"],tabView:"STOW_BUFFERED"};if(groupBy){request['groupBy']=groupBy;}if(machineName){request.filters['ASSOCIATE']=[machineName];}if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CYCLE */]]=[cycles];}return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var bayList,mappedBayList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;dispatch(bayTableDataCallBegin());_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_6__resources_StowBufferResource__["b" /* getStowBufferTableData */])(request);case 4:bayList=_context3.sent;mappedBayList=addPlannedVolumeToBayTable(bayList,plannedVolumeList);if(mappedBayList){dispatch(bayTableDataCallSuccess(mappedBayList));}else{dispatch(bayTableDataCallFailure());}_context3.next=12;break;case 9:_context3.prev=9;_context3.t0=_context3["catch"](0);dispatch(bayTableDataCallFailure());case 12:case"end":return _context3.stop();}}},_callee3,_this3,[[0,9]]);}));return function(_x3){return _ref5.apply(this,arguments);};}();}function getMachineStatus(nodeId,machineList){var _this4=this;var macAddressList=machineList.map(function(machine){return machine.macAddress;});var request={nodeId:nodeId,macAddressList:macAddressList};return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var args,machineStatusList,mappedMachineList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;dispatch(machineStatusCallBegin());args=Object(__WEBPACK_IMPORTED_MODULE_6__resources_StowBufferResource__["a" /* getAPIGatewayPostRequest */])(request,"ndms/getADTAStatus","deviceManagement");_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_5__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:machineStatusList=_context4.sent;mappedMachineList=addStatusToMachineList(machineList,machineStatusList);if(machineStatusList){dispatch(machineTableDataCallSuccess(mappedMachineList));dispatch(machineStatusCallSuccess(machineStatusList));}else{dispatch(machineStatusCallFailure());}_context4.next=13;break;case 10:_context4.prev=10;_context4.t0=_context4["catch"](0);dispatch(machineStatusCallFailure());case 13:case"end":return _context4.stop();}}},_callee4,_this4,[[0,10]]);}));return function(_x4){return _ref6.apply(this,arguments);};}();}function getPlannedCount(nodeId,cycles,cycleIds){var _this5=this;var request={groupBy:'AISLE',filters:{NODE:[nodeId],DRS:['FALSE']},metrics:[__WEBPACK_IMPORTED_MODULE_2__enums__["p" /* StowPackageMetric */].PLANNED_COUNT]};if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CYCLE */]]=[cycles];}if(cycleIds.length){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* CYCLE_ID */]]=[cycleIds];}return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var stowPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;dispatch(plannedCountDataCallBegin());_context5.next=4;return Object(__WEBPACK_IMPORTED_MODULE_4__resources_StowResource__["q" /* getStowPackageMetrics */])(request);case 4:stowPackageMetricsMap=_context5.sent;if(stowPackageMetricsMap){dispatch(plannedCountDataCallSuccess(stowPackageMetricsMap));}else{dispatch(plannedCountDataCallFailure());}_context5.next=11;break;case 8:_context5.prev=8;_context5.t0=_context5["catch"](0);dispatch(plannedCountDataCallFailure());case 11:case"end":return _context5.stop();}}},_callee5,_this5,[[0,8]]);}));return function(_x5){return _ref7.apply(this,arguments);};}();}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(314);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemoryRouter */
/* unused harmony export Prompt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Redirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Router; });
/* unused harmony export StaticRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Switch; });
/* unused harmony export generatePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return matchPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return withRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return context; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mini_create_react_context__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_path_to_regexp__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_0_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var context =
/*#__PURE__*/
createNamedContext("Router");

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Provider, {
      children: this.props.children || null,
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    });
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_5_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
    !context$$1 ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    if (!when || context$$1.staticContext) return null;
    var method = context$$1.history.block;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
    !context$$1 ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context$$1.history,
        staticContext = context$$1.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(prevProps.to);

        if (!Object(__WEBPACK_IMPORTED_MODULE_5_history__["f" /* locationsAreEqual */])(prevLocation, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string") options = {
    path: options
  };
  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path) return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      if (typeof children === "function") {
        children = children(props);

        if (children === undefined) {
          if (false) {
            var path = _this.props.path;
            process.env.NODE_ENV !== "production" ? warning(false, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
          }

          children = null;
        }
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Provider, {
        value: props
      }, children && !isEmptyChildren(children) ? children : props.match ? component ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : render ? render(props) : null : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_5_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
     false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false);
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$$1.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context$$1.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, context$$1, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}




/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(128);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(335);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_ROUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STOW_ROUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STOW_BREAKDOWN_V2_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GRID_ALLOCATION_ROUTE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StowOverview__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StowBreakdown__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GridAllocation__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StowBreakdownV3__ = __webpack_require__(619);
var DEFAULT_ROUTES={"/heatMapv2":"/heatMapv2/StowOverview"};var STOW_ROUTES=[{name:"Stow-Overview",path:"/heatMapv2/StowOverview",id:"Overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StowOverview__["a" /* default */],null);}},{name:"Stow-Breakdown",path:"/heatMapv2/StowBreakdown",id:"Stow Breakdown",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StowBreakdown__["a" /* default */],null);}}];var STOW_BREAKDOWN_V2_ROUTE={name:"Stow-Breakdown-V2",path:"/heatMapv2/StowBreakdownV2",id:"Stow Breakdown V2",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StowBreakdownV3__["a" /* default */],null);}};var GRID_ALLOCATION_ROUTE={name:"Grid-Allocation",path:"/heatMapv2/GridAllocation",id:"Grid Allocation",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GridAllocation__["a" /* default */],null);}};

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBatch; });
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Subscription__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Context__ = __webpack_require__(61);







 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
}; // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect because we want
// `connect` to perform sync updates to a ref to save the latest props after
// a render is actually committed to the DOM.


var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_4_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_4_react__["useEffect"];
function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? __WEBPACK_IMPORTED_MODULE_7__Context__["a" /* ReactReduxContext */] : _ref2$context,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
  var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {
      invariant(isValidElementType(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? __WEBPACK_IMPORTED_MODULE_4_react__["useMemo"] : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var forwardedRef = props.forwardedRef,
            wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["forwardedRef"]);

        return [props.context, forwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          forwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && Object(__WEBPACK_IMPORTED_MODULE_5_react_is__["isContextConsumer"])(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(ContextToUse); // The store _must_ exist as either a prop or in context

      var didStoreComeFromProps = Boolean(props.store);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
      __WEBPACK_IMPORTED_MODULE_3_invariant___default()(didStoreComeFromProps || didStoreComeFromContext, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      var store = props.store || contextValue.store;
      var childPropsSelector = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var subscription = new __WEBPACK_IMPORTED_MODULE_6__utils_Subscription__["a" /* default */](store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useReducer"])(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();
      var lastWrapperProps = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(wrapperProps);
      var childPropsFromStoreUpdate = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();
      var renderIsScheduled = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffect(function () {
        // We want to capture the wrapper props and child props we used for later comparisons
        lastWrapperProps.current = wrapperProps;
        lastChildProps.current = actualChildProps;
        renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

        if (childPropsFromStoreUpdate.current) {
          childPropsFromStoreUpdate.current = null;
          notifyNestedSubs();
        }
      }); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffect(function () {
        // If we're not subscribed to the store, nothing to do here
        if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

        var didUnsubscribe = false;
        var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

        var checkForUpdates = function checkForUpdates() {
          if (didUnsubscribe) {
            // Don't run stale listeners.
            // Redux doesn't guarantee unsubscriptions happen until next dispatch.
            return;
          }

          var latestStoreState = store.getState();
          var newChildProps, error;

          try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
          } catch (e) {
            error = e;
            lastThrownError = e;
          }

          if (!error) {
            lastThrownError = null;
          } // If the child props haven't changed, nothing to do here - cascade the subscription update


          if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) {
              notifyNestedSubs();
            }
          } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

            forceComponentUpdateDispatch({
              type: 'STORE_UPDATED',
              payload: {
                latestStoreState: latestStoreState,
                error: error
              }
            });
          }
        }; // Actually subscribe to the nearest connected ancestor (or store)


        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe(); // Pull data from the store after first render in case the store has
        // changed since we began.

        checkForUpdates();

        var unsubscribeWrapper = function unsubscribeWrapper() {
          didUnsubscribe = true;
          subscription.tryUnsubscribe();
          subscription.onStateChange = null;

          if (lastThrownError) {
            // It's possible that we caught an error due to a bad mapState function, but the
            // parent re-rendered without this component and we're about to unmount.
            // This shouldn't happen as long as we do top-down subscriptions correctly, but
            // if we ever do those wrong, this throw will surface the error in our tests.
            // In that case, throw the error from here so it doesn't get lost.
            throw lastThrownError;
          }
        };

        return unsubscribeWrapper;
      }, [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, actualChildProps, {
          ref: forwardedRef
        }));
      }, [forwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = __WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function forwardConnectRef(props, ref) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Connect, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          forwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(forwarded, WrappedComponent);
    }

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(344);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(199);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(200);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStoreHook;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Context__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useReduxContext__ = __webpack_require__(202);



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {Function} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */];
  }

  var useReduxContext = context === __WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_2__useReduxContext__["a" /* useReduxContext */] : function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore = createStoreHook();

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useReduxContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Context__ = __webpack_require__(61);



/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__components_Context__["a" /* ReactReduxContext */]);
  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(contextValue, 'could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
  return contextValue;
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var upperFirst = function upperFirst(str) {
  return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
};

var _default = upperFirst;
exports["default"] = _default;

/***/ }),
/* 204 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  themeForegroundPrimaryDefault: "#232F3E",
  themeForegroundPrimaryFocus: "#077398",
  themeForegroundPrimaryError: "#AD0A30",
  themeForegroundPrimaryDisabled: "#BBC0C1",
  themeForegroundSecondaryDefault: "#697576",
  themeForegroundSecondaryDisabled: "#E7E9E9",
  themeForegroundTertiaryDefault: "#697576",
  themeForegroundTertiaryHover: "#485050",
  themeForegroundTertiaryPressed: "#252829",
  themeForegroundTertiaryDisabled: "#ABB0B5",
  themeForegroundInvertedDefault: "#FFFFFF",
  themeForegroundAccentDefault: "#077398",
  themeForegroundAccentHover: "#055D7B",
  themeForegroundAccentPressed: "#03384B",
  themeForegroundAccentDisabled: "#C1DEE8",
  themeBorderPrimaryDefault: "#697576",
  themeBorderPrimaryDisabled: "#BBC0C1",
  themeBorderPrimaryFocus: "#077398",
  themeBorderPrimaryError: "#CC0C39",
  themeBorderPrimaryWarning: "#DCB700",
  themeBorderSecondaryDefault: "#BBC0C1",
  themeBorderSecondaryFocus: "#00A8E1",
  themeBorderTertiaryDefault: "#E7E9E9",
  themeBorderAlternateDefault: "rgba(0, 0, 0, 0)",
  themeBorderAccentDefault: "#00A8E1",
  themeBorderAccentHover: "#077398",
  themeBorderAccentPressed: "#055D7B",
  themeBorderAccentDisabled: "#90C5D7",
  themeBorderAccentPreselected: "#7CCEE9",
  themeBorderAlternateAccentDefault: "#055D7B",
  themeBackgroundPrimaryDefault: "#FFFFFF",
  themeBackgroundPrimaryDisabled: "#F0F1F2",
  themeBackgroundSecondaryDefault: "#F0F1F2",
  themeBackgroundSecondaryError: "#FF7494",
  themeBackgroundSecondaryWarning: "#FCDE4D",
  themeBackgroundTertiaryDefault: "#E7E9E9",
  themeBackgroundTertiaryHover: "#BBC0C1",
  themeBackgroundTertiaryPressed: "#949C9C",
  themeBackgroundTertiaryDisabled: "#ECEDED",
  themeBackgroundAlternatePrimaryDefault: "#FFFFFF",
  themeBackgroundAlternatePrimarySelected: "#F0F1F2",
  themeBackgroundAlternatePrimaryHover: "#E7E9E9",
  themeBackgroundAlternatePrimaryPressed: "#BBC0C1",
  themeBackgroundAlternateSecondaryDefault: "#F9FAFA",
  themeBackgroundAlternateTertiaryDefault: "#FFFFFF",
  themeBackgroundAlternateTertiaryFocus: "#F9FAFA",
  themeBackgroundAccentDefault: "#B9E8F7",
  themeBackgroundAccentDisabled: "#86A4AF",
  themeBackgroundInvertedDefault: "#0B0C0C",
  themeBackgroundOverlayDefault: "rgba(11, 12, 12, 0.5)",
  themeBackgroundOverlayPressed: "rgba(11, 12, 12, 0.04)",
  themePalette50: "#E5F6FB",
  themePalette100: "#B9E8F7",
  themePalette200: "#7CCEE9",
  themePalette300: "#47C2EC",
  themePalette400: "#00A8E1",
  themePalette500: "#077398",
  themePalette600: "#055D7B",
  themePalette700: "#03384B",
  themePalette800: "#01222D",
  themePaletteMuted100: "#C1DEE8",
  themePaletteMuted200: "#90C5D7",
  themePaletteMuted300: "#86A4AF",
  themePaletteMuted400: "#204B5A",
  themePaletteMuted500: "#24586A",
  themePaletteMuted600: "#14181D",
  _themeColorScaleCategorical: ["#36C2B4","#EB64D7","#FF8F00","#8169F8","#FCC201","#FF5A94","#708090"],
  _themeColorScaleComparison: ["#348118","#DE1B1B"],
  _themeColorScaleViolet: ["#DDC8FF","#C9A8FF","#A588FF","#8169F8","#614FD9","#3E36BB"],
  _themeColorScalePurple: ["#E9C6E4","#ECA8E0","#EC88DC","#EB64D7","#C54FB4","#8C297D"],
  _themeColorScalePink: ["#FFDBE5","#FFB5CA","#FF8CAF","#FF5A94","#DC3C71","#BA1750"],
  _themeColorScaleTangerine: ["#FFE5CB","#FFCB96","#FFAE5D","#FF8F00","#D4780C","#A45C0A"],
  _themeColorScaleGold: ["#FFF4D9","#FFE8B1","#FFDB86","#FCC201","#DAA500","#BF8E00"],
  _themeColorScaleTurquoise: ["#C3E9E7","#78D9CF","#36C2B4","#2C9F93","#227D74","#1B5F5B"],
  _themeColorScaleForest: ["#D6ECC9","#ABD994","#7EC55E","#47B120","#348118","#005C00"],
  _themeColorScaleCrimson: ["#FFD9CF","#FFB09F","#F98771","#EE5A46","#DE1B1B","#AF1F18"],
  _themeColorScaleSlate: ["#DADEE2","#B6BDC6","#929EAB","#708090","#596571","#434C54"],
  _themeColorScaleDiverging: ["#2C9F93","#36C2B4","#78D9CF","#C3E9E7","#FFF4D9","#FFE8B1","#FFDB86","#FCC201"],
  _themeColorScaleDivergingWithMiddle: ["#C54FB4","#EB64D7","#EC88DC","#ECA8E0","#FFF4D9","#78D9CF","#36C2B4","#2C9F93","#227D74"]
};

/***/ }),
/* 205 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  themeForegroundPrimaryDefault: "#FFFFFF",
  themeForegroundPrimaryFocus: "#7CCEE9",
  themeForegroundPrimaryError: "#FF7494",
  themeForegroundPrimaryDisabled: "#697576",
  themeForegroundSecondaryDefault: "#BBC0C1",
  themeForegroundSecondaryDisabled: "#485050",
  themeForegroundTertiaryDefault: "#BBC0C1",
  themeForegroundTertiaryHover: "#E7E9E9",
  themeForegroundTertiaryPressed: "#F0F1F2",
  themeForegroundTertiaryDisabled: "#5B5F5F",
  themeForegroundInvertedDefault: "#232F3E",
  themeForegroundAccentDefault: "#47C2EC",
  themeForegroundAccentHover: "#7CCEE9",
  themeForegroundAccentPressed: "#B9E8F7",
  themeForegroundAccentDisabled: "#204B5A",
  themeBorderPrimaryDefault: "#E7E9E9",
  themeBorderPrimaryDisabled: "#485050",
  themeBorderPrimaryFocus: "#077398",
  themeBorderPrimaryError: "#FF7494",
  themeBorderPrimaryWarning: "#FEF2B8",
  themeBorderSecondaryDefault: "#697576",
  themeBorderSecondaryFocus: "#00A8E1",
  themeBorderTertiaryDefault: "#485050",
  themeBorderAlternateDefault: "#697576",
  themeBorderAccentDefault: "#00A8E1",
  themeBorderAccentHover: "#47C2EC",
  themeBorderAccentPressed: "#7CCEE9",
  themeBorderAccentDisabled: "#24586A",
  themeBorderAccentPreselected: "#055D7B",
  themeBorderAlternateAccentDefault: "#00A8E1",
  themeBackgroundPrimaryDefault: "#0B0C0C",
  themeBackgroundPrimaryDisabled: "#252829",
  themeBackgroundSecondaryDefault: "#252829",
  themeBackgroundSecondaryError: "#AD0A30",
  themeBackgroundSecondaryWarning: "#FAD000",
  themeBackgroundTertiaryDefault: "#485050",
  themeBackgroundTertiaryHover: "#697576",
  themeBackgroundTertiaryPressed: "#949C9C",
  themeBackgroundTertiaryDisabled: "#323838",
  themeBackgroundAlternatePrimaryDefault: "#252829",
  themeBackgroundAlternatePrimarySelected: "#485050",
  themeBackgroundAlternatePrimaryHover: "#697576",
  themeBackgroundAlternatePrimaryPressed: "#949C9C",
  themeBackgroundAlternateSecondaryDefault: "#0B0C0C",
  themeBackgroundAlternateTertiaryDefault: "#485050",
  themeBackgroundAlternateTertiaryFocus: "#252829",
  themeBackgroundAccentDefault: "#055D7B",
  themeBackgroundAccentDisabled: "#14181D",
  themeBackgroundInvertedDefault: "#FFFFFF",
  themeBackgroundOverlayDefault: "rgba(108, 119, 120, 0.5)",
  themeBackgroundOverlayPressed: "rgba(255, 255, 255, 0.16)",
  themePalette50: "#E5F6FB",
  themePalette100: "#B9E8F7",
  themePalette200: "#7CCEE9",
  themePalette300: "#47C2EC",
  themePalette400: "#00A8E1",
  themePalette500: "#077398",
  themePalette600: "#055D7B",
  themePalette700: "#03384B",
  themePalette800: "#01222D",
  themePaletteMuted100: "#C1DEE8",
  themePaletteMuted200: "#90C5D7",
  themePaletteMuted300: "#86A4AF",
  themePaletteMuted400: "#204B5A",
  themePaletteMuted500: "#24586A",
  themePaletteMuted600: "#14181D",
  _themeColorScaleCategorical: ["#36C2B4","#EB64D7","#FF8F00","#8169F8","#FCC201","#FF5A94","#708090"],
  _themeColorScaleComparison: ["#47B120","#EE5A46"],
  _themeColorScaleViolet: ["#3E36BB","#614FD9","#8169F8","#A588FF","#C9A8FF","#DDC8FF"],
  _themeColorScalePurple: ["#8C297D","#C54FB4","#EB64D7","#EC88DC","#ECA8E0","#E9C6E4"],
  _themeColorScalePink: ["#BA1750","#DC3C71","#FF5A94","#FF8CAF","#FFB5CA","#FFDBE5"],
  _themeColorScaleTangerine: ["#A45C0A","#D4780C","#FF8F00","#FFAE5D","#FFCB96","#FFE5CB"],
  _themeColorScaleGold: ["#BF8E00","#DAA500","#FCC201","#FFDB86","#FFE8B1","#FFF4D9"],
  _themeColorScaleTurquoise: ["#1B5F5B","#227D74","#2C9F93","#36C2B4","#78D9CF","#C3E9E7"],
  _themeColorScaleForest: ["#005C00","#348118","#47B120","#7EC55E","#ABD994","#D6ECC9"],
  _themeColorScaleCrimson: ["#AF1F18","#DE1B1B","#EE5A46","#F98771","#FFB09F","#FFD9CF"],
  _themeColorScaleSlate: ["#434C54","#596571","#708090","#929EAB","#B6BDC6","#DADEE2"],
  _themeColorScaleDiverging: ["#2C9F93","#36C2B4","#78D9CF","#C3E9E7","#FFF4D9","#FFE8B1","#FFDB86","#FCC201"],
  _themeColorScaleDivergingWithMiddle: ["#C54FB4","#EB64D7","#EC88DC","#ECA8E0","#FFF4D9","#78D9CF","#36C2B4","#2C9F93","#227D74"]
};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ColorSchemeContext = void 0;

var _react = __webpack_require__(0);

/**
 * Context for passing the theme's color scheme down the tree.
 */
var ColorSchemeContext = /*#__PURE__*/(0, _react.createContext)("light");
exports.ColorSchemeContext = ColorSchemeContext;

var useColorScheme = function useColorScheme() {
  return (0, _react.useContext)(ColorSchemeContext);
};

var _default = useColorScheme;
exports["default"] = _default;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(208);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 208 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toRow = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _tableRow = _interopRequireDefault(__webpack_require__(25));

var _tableCell = _interopRequireDefault(__webpack_require__(23));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This can be used to create a header for a group of Row components. Use it
 * exactly like you would a normal Row. The only difference is that this takes
 * normal content children instead of Cell components.
 */
var TableSectionHeader = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TableSectionHeader, _React$Component);

  var _super = _createSuper(TableSectionHeader);

  function TableSectionHeader() {
    (0, _classCallCheck2["default"])(this, TableSectionHeader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(TableSectionHeader, [{
    key: "render",
    value: function render() {
      // This component is API sugar only, at render time it's replaced with `Row`
      // and `Cell` components
      return null;
    }
  }]);
  return TableSectionHeader;
}(_react["default"].Component);

TableSectionHeader.propTypes =  false ? {
  /**
   * The contents of the section header.
   *
   * Note that this does *not* support table cells as children, this is a
   * generic content area that spans the width of the table.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set this to force the cell to span more than one column.
   *
   * NOTE: This helps build an accessible TableSectionHeader. However,
   * any provided columnSpan will be overwritten to 1 when a Table has a
   * [stickyHeaderColumn](https://meridian.a2z.com/components/table/?platform=react-web&detailsTab=api#api-Table-stickyHeaderColumn).
   *
   * @since 5.24.0
   */
  columnSpan: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Determines if rows that are children of this row are visible or hidden.
   */
  open: _propTypes["default"].bool,

  /**
   * Bind a click handler to the row. This will make the row focuseable via
   * keyboard. Avoid using this if the row contains clickable children (e.g.
   * a link or a button).
   */
  onClick: _propTypes["default"].func
} : {};

var toRow = function toRow(isRow, element, stickyHeaderColumn) {
  var children = _react["default"].Children.toArray(element.props.children); // The number of columns the header cell spans. Use the defined `columnSpan` if
  // defined else if the table has a sticky header column, fallback to 1, else 100.


  var columnSpan = stickyHeaderColumn ? 1 : element.props.columnSpan || 100;
  return /*#__PURE__*/_react["default"].createElement(_tableRow["default"], (0, _extends2["default"])({}, element.props, {
    id: undefined
  }), /*#__PURE__*/_react["default"].createElement(_tableCell["default"], {
    header: true,
    highlight: true,
    sectionHeader: true,
    id: element.props.id,
    columnSpan: columnSpan,
    scope: "colgroup"
  }, children.filter(function (child) {
    return !isRow(child);
  })), (!element.props.columnSpan || stickyHeaderColumn) && columnSpan < 100 && /*#__PURE__*/_react["default"].createElement(_tableCell["default"], {
    highlight: true,
    columnSpan: 100,
    sectionHeader: true,
    headers: element.props.id,
    scope: "colgroup"
  }), children.filter(isRow));
};

exports.toRow = toRow;
var _default = TableSectionHeader;
exports["default"] = _default;

/***/ }),
/* 210 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    checkboxMotionDuration: "100ms",
    checkboxMotionFunction: "ease",
    checkboxForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    checkboxForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    checkboxBackgroundColorSelectedDefault: tokens.themeForegroundAccentDefault,
    checkboxBackgroundColorSelectedHover: tokens.themeForegroundAccentHover,
    checkboxBackgroundColorSelectedPressed: tokens.themeForegroundAccentPressed,
    checkboxBackgroundColorSelectedDisabled: tokens.themeForegroundAccentDisabled,
    checkboxBackgroundColorUnselectedDefault: tokens.themeBackgroundPrimaryDefault,
    checkboxBackgroundColorUnselectedHover: tokens.themeForegroundAccentHover,
    checkboxBackgroundColorUnselectedPressed: tokens.themeForegroundAccentPressed,
    checkboxBackgroundColorUnselectedDisabled: tokens.themeBackgroundPrimaryDisabled,
    checkboxBorderWidth: 1,
    checkboxBorderRadius: 4,
    checkboxBorderColorSelectedDefault: "rgba(0, 0, 0, 0)",
    checkboxBorderColorSelectedDisabled: tokens.themeBorderPrimaryDisabled,
    checkboxBorderColorUnselectedDefault: tokens.themeBorderPrimaryDefault,
    checkboxBorderColorUnselectedHover: "rgba(0, 0, 0, 0)",
    checkboxBorderColorUnselectedPressed: "rgba(0, 0, 0, 0)",
    checkboxBorderColorUnselectedDisabled: tokens.themeBorderPrimaryDisabled,
    checkboxIndicatorColorSelectedDefault: tokens.themeForegroundInvertedDefault,
    checkboxIndicatorColorUnselectedDefault: "rgba(0, 0, 0, 0)",
    checkboxIndicatorColorUnselectedHover: tokens.themeForegroundAccentDefault,
    checkboxIndicatorColorUnselectedPressed: tokens.themeForegroundInvertedDefault,
    checkboxWidthMedium: 20,
    checkboxWidthLarge: 24,
    checkboxHeightMedium: 20,
    checkboxHeightLarge: 24,
    checkboxSpacingHorizontal: 12
  }
};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(48));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _table = _interopRequireDefault(__webpack_require__(82));

var _chevronDownSmall = _interopRequireDefault(__webpack_require__(386));

var _chevronRightSmall = _interopRequireDefault(__webpack_require__(137));

var _stickyScrollTracker = _interopRequireDefault(__webpack_require__(387));

var _theme = __webpack_require__(14);

var _token = __webpack_require__(12);

var _functional = __webpack_require__(26);

var _getIconCss = _interopRequireDefault(__webpack_require__(83));

var _text = _interopRequireDefault(__webpack_require__(27));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var positionStickyElevation = {
  rowHeader: 1,
  columnHeader: 2,
  tableHeaderCell: 3
};
var chevronDownIcon = (0, _token.getIconFromTokens)(_chevronDownSmall["default"]);
var chevronRightIcon = (0, _token.getIconFromTokens)(_chevronRightSmall["default"]);
var styles = (0, _functional.memoizeByKeys)(function (_ref) {
  var spacing = _ref.spacing,
      showDividers = _ref.showDividers,
      showExpandedDividers = _ref.showExpandedDividers,
      showStripes = _ref.showStripes,
      nestedRows = _ref.nestedRows,
      layout = _ref.layout;
  return (0, _functional.memoize)(function (t) {
    var _trFirstChild;

    var borderColor = t("borderColor");
    var borderWidthHeader = t("borderWidthHeader");
    var borderWidthBody = t("borderWidthBody");
    var spacingHorizontal = t("spacingHorizontal");
    var spacingVerticalSmall = t("spacingVerticalSmall");
    var backgroundColorDefault = t("backgroundColorDefault");
    var backgroundColorHover = t("backgroundColorHover");
    var backgroundColorPressed = t("backgroundColorPressed");
    var backgroundColorHighlight = t("backgroundColorHighlight");
    var backgroundColorStripe = t("backgroundColorStripe");
    return (0, _emotion.css)(
    /**
     * Layout
     */
    {
      width: "100%",
      tableLayout: layout,
      "& tr": {
        // HACK: This, in combination with "height: inherit" on table cells, allows
        // cell contents to stretch to fill the cell height if necessary (e.g. a
        // checkbox with `fillParent={true}`). See:
        // https://stackoverflow.com/questions/3215553/make-a-div-fill-an-entire-table-cell
        height: 1
      },
      "& td, & th": {
        position: "relative"
      }
    },
    /**
     * Typography
     */
    (0, _text["default"])(t), {
      "& td": {
        fontWeight: t("fontWeightBody")
      },
      "& th": {
        fontWeight: t("fontWeightHeader")
      },
      // Highlighted header cells should use the normal font weight
      "& th[mdn-cell-highlight]": {
        fontWeight: t("fontWeightBody")
      },
      // Section headers have their own font size
      "& th[mdn-section-header]": (0, _defineProperty2["default"])({
        fontSize: t("fontSizeSectionHeader")
      }, "[dir=\"rtl\"] &", {
        // HACK: need the fix the section header right padding
        // in RTL layouts.
        paddingRight: "".concat(spacingHorizontal, "px !important")
      })
    },
    /**
     * Background colors
     */
    {
      "& td, & th": {
        backgroundColor: backgroundColorDefault,
        "&[mdn-cell-highlight]": {
          backgroundColor: backgroundColorHighlight
        },
        "&[mdn-cell-background-color-primary]": {
          backgroundColor: backgroundColorDefault
        },
        "&[mdn-cell-background-color-secondary]": {
          backgroundColor: backgroundColorHover
        }
      },
      "& tbody > tr[mdn-row-highlight] > *": {
        backgroundColor: backgroundColorHighlight
      },
      "& tbody > tr[mdn-row-background-color-primary] > *": {
        backgroundColor: backgroundColorDefault
      },
      "& tbody > tr[mdn-row-background-color-secondary] > *": {
        backgroundColor: backgroundColorHover
      },
      "& tbody > tr[mdn-row-highlight-on-hover]:hover > *": {
        backgroundColor: backgroundColorHover
      },
      "& tbody > tr[mdn-row-highlight-on-press]:active > *": {
        backgroundColor: backgroundColorPressed
      },
      "& tbody > tr:nth-child(even) > *": showStripes ? {
        backgroundColor: backgroundColorStripe
      } : undefined,
      transition: t.transitionCss("motion", "background-color")
    },
    /**
     * Borders
     */
    {
      borderCollapse: "separate",
      borderSpacing: 0,
      // Always add a border between the header and the body (if a header
      // exists)
      "& thead > tr:last-child > *": {
        borderBottomColor: borderColor,
        borderBottomStyle: "solid",
        borderBottomWidth: borderWidthHeader
      },
      // Add a thick border after the last row in a set of open child rows
      "& tbody > tr[mdn-row-last-child] + tr > *": {
        borderTopColor: borderColor,
        borderTopStyle: "solid",
        borderTopWidth: borderWidthHeader
      },
      "& tbody > tr[mdn-row-last-child]:last-child > *": {
        borderBottomColor: borderColor,
        borderBottomStyle: "solid",
        borderBottomWidth: borderWidthHeader
      },
      // Remove the borders between open child rows
      "& tbody > tr[mdn-row-child] > *": {
        borderTopColor: showExpandedDividers ? undefined : "transparent"
      }
    }, showDividers ? {
      // Add top borders to rows
      "& tbody > tr > *": {
        borderTopColor: borderColor,
        borderTopStyle: "solid",
        borderTopWidth: borderWidthBody
      },
      // Add a bottom border to the last row
      "& tbody > tr:last-child > *": {
        borderBottomColor: borderColor,
        borderBottomStyle: "solid",
        borderBottomWidth: borderWidthBody
      },
      // Remove the top border from the first row if a header exists (the
      // header will apply a special border to separate the header from the
      // body)
      "& thead + tbody > tr:first-child > *": {
        borderTop: "none"
      }
    } : undefined,
    /**
     * Padding
     */
    {
      "& td, & th": {
        // Add padding for half the horizontal spacing to each cell so that when
        // the cells are lined up in a row the space between the cell contents
        // adds up to the original horizontal spacing.
        padding: "".concat(t("spacingVertical", spacing), "px ").concat(spacingHorizontal / 2, "px"),
        // Show the full horizontal spacing on the left and right hand sides of
        // each row.
        "&:first-child": (0, _defineProperty2["default"])({
          // For tables with nested rows add extra padding for the chevron icon
          paddingLeft: nestedRows ? spacingHorizontal * 2 + chevronRightIcon.width : spacingHorizontal
        }, "[dir=\"rtl\"] &", {
          paddingRight: nestedRows ? "".concat(spacingHorizontal * 2 + chevronRightIcon.width, "px !important") : spacingHorizontal,
          // HACK: the above paddingLeft still gets applied, so
          // we need to override it and make it half the width for RTL layouts
          paddingLeft: spacingHorizontal / 2
        }),
        "&:last-child": (0, _defineProperty2["default"])({
          // HACK: IE11 does not support padding-inline-* so we have
          // to use directional padding-left/right. If/when we drop IE11 we can simplify
          // these styles to be:
          // {
          //   paddingInlineStart: spacingHorizontal,
          // }
          paddingRight: spacingHorizontal
        }, "[dir=\"rtl\"] &", {
          paddingLeft: spacingHorizontal,
          // HACK: the above `paddingRight: spacingHorizontal` still gets applied, so
          // we need to override it and make it half the width for RTL layouts
          paddingRight: spacingHorizontal / 2
        })
      },
      // Cells in the table header or header cells in the table body that span
      // the entire row (section header cells) use "small" vertical spacing,
      // regardless of the user's spacing setting.
      "& thead > tr > *, & tbody > tr > th:only-child": {
        paddingTop: spacingVerticalSmall,
        paddingBottom: spacingVerticalSmall
      }
    },
    /**
     * Nested header rows
     */
    {
      "& thead > tr:not(:last-child) > *": {
        fontSize: t("fontSizeNestedHeader"),
        paddingBottom: 0,
        // Shrink the span down to fit the cell contents so that it obscures the
        // horizontal stripe behind the contents but not across the entire cell.
        // Add pseudo elements to add a little padding between the contents and
        // the stripe
        "& > span": {
          display: "inline-block",
          position: "relative",
          backgroundColor: "inherit",
          "&:before, &:after": {
            content: "''",
            backgroundColor: "inherit",
            display: "block",
            height: "100%",
            width: spacingHorizontal,
            position: "absolute",
            top: 0
          },
          "&:before": {
            right: "100%"
          },
          "&:after": {
            left: "100%"
          }
        },
        // Add a horizontal stripe along the center of the cell
        "&:before": {
          content: "''",
          display: "block",
          height: t("borderWidthHeader"),
          left: 0,
          right: 0,
          backgroundColor: borderColor,
          position: "absolute",
          top: "calc(50% + ".concat(spacingVerticalSmall / 2, "px)"),
          transform: "translateY(-50%)"
        }
      }
    },
    /**
     * Expandable rows
     */
    {
      // Add a chevron icon as a pseudo-element to the first cell in the row
      "& tbody > tr[mdn-row-parent] > *:first-child": (0, _defineProperty2["default"])({
        backgroundImage: (0, _getIconCss["default"])(chevronRightIcon.data, t("foregroundColor")),
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center left ".concat(spacingHorizontal, "px")
      }, "[dir=\"rtl\"] &", {
        backgroundImage: (0, _getIconCss["default"])(chevronRightIcon.dataRtl, t("foregroundColor")),
        backgroundPosition: "center right ".concat(spacingHorizontal, "px")
      }),
      // Point the chevron icon down if the row is open
      "& tbody > tr[mdn-row-parent][mdn-row-open] > *:first-child": (0, _defineProperty2["default"])({
        backgroundImage: (0, _getIconCss["default"])(chevronDownIcon.data, t("foregroundColor")),
        // Scoot the down chevron, which is a tad wider than the right
        // chevron, to the left a bit so it is horizontally centered on the
        // same point that the right chevron was.
        backgroundPosition: "center left ".concat(spacingHorizontal - 0.5 * (chevronDownIcon.width - chevronRightIcon.width), "px")
      }, "[dir=\"rtl\"] &", {
        backgroundPosition: "center right ".concat(spacingHorizontal - 0.5 * (chevronDownIcon.width - chevronRightIcon.width), "px")
      })
    },
    /**
     * Clickable rows
     */
    {
      "& tr[tabindex]": {
        cursor: "pointer"
      },
      // TODO: We need an actual focus style for clickable rows. Right now we
      // just fall back to the default outline. See https://sim.amazon.com/issues/MRDN-127
      "& tr[tabindex]:not([mdn-row-focus])": {
        outline: "none"
      }
    },
    /**
     * Selectable cells
     */
    {
      // If we're dealing with a selectable table cell (a cell containing a
      // single checkbox that has been stretched to fill the entire cell) then
      // expand the cell padding (by taking padding from the cell to the right)
      // to maximize the clickable area.
      "& tr > *:first-child[mdn-cell-selectable]": (_trFirstChild = {
        // HACK: IE11 does not support padding-inline-* so we have
        // to use directional padding-left/right. If/when we drop IE11 we can simplify
        // these styles to be:
        // {
        //   paddingInlineEnd: spacingHorizontal,
        //   "& + *": {
        //     paddingInlineStart: 0,
        //   },
        // }
        paddingRight: spacingHorizontal
      }, (0, _defineProperty2["default"])(_trFirstChild, "[dir=\"rtl\"] &", {
        paddingLeft: spacingHorizontal
      }), (0, _defineProperty2["default"])(_trFirstChild, "& + *", (0, _defineProperty2["default"])({
        paddingLeft: 0
      }, "[dir=\"rtl\"] &", {
        // HACK: the above `paddingRight: spacingHorizontal` still gets applied, so
        // we need to reapply the half horizontal spacing to paddingLeft
        paddingLeft: spacingHorizontal / 2,
        paddingRight: 0
      })), _trFirstChild)
    });
  });
}, ["spacing", "showDividers", "showExpandedDividers", "showStripes", "nestedRows", "layout"]);
var stickyStyles = (0, _functional.memoizeByKeys)(function (_ref2) {
  var stickyHeaderColumn = _ref2.stickyHeaderColumn,
      stickyHeaderColumnOffset = _ref2.stickyHeaderColumnOffset,
      headerColumnStuck = _ref2.headerColumnStuck,
      stickyHeaderRow = _ref2.stickyHeaderRow,
      stickyHeaderRowOffset = _ref2.stickyHeaderRowOffset,
      headerRowStuck = _ref2.headerRowStuck;
  return (0, _functional.memoize)(function (t) {
    var _stickyHeaderCellStyl, _theadTrLastOfTyp;

    var stickyHeaderCellStyles = (_stickyHeaderCellStyl = {
      position: "sticky",
      left: stickyHeaderColumnOffset,
      zIndex: positionStickyElevation.columnHeader
    }, (0, _defineProperty2["default"])(_stickyHeaderCellStyl, "[dir=\"rtl\"] &", {
      left: "unset",
      right: stickyHeaderColumnOffset
    }), (0, _defineProperty2["default"])(_stickyHeaderCellStyl, "::after", {
      position: "absolute",
      content: "''",
      top: 0,
      right: 0,
      bottom: 0,
      width: 8,
      boxShadow: headerColumnStuck ? t.boxShadowCss("overflowStickyColumnShadow") : undefined
    }), _stickyHeaderCellStyl);
    return (0, _emotion.css)(
    /**
     * Sticky column header
     */
    stickyHeaderColumn ? {
      "tbody th": stickyHeaderCellStyles,
      "[mdn-row-child] > td:first-child": stickyHeaderCellStyles
    } : undefined,
    /**
     * Sticky row header
     */
    stickyHeaderRow ? {
      "thead tr:last-of-type th": {
        position: "sticky",
        top: stickyHeaderRowOffset,
        zIndex: positionStickyElevation.rowHeader,
        "::after": {
          position: "absolute",
          content: "''",
          bottom: 0,
          right: 0,
          left: 0,
          height: 8,
          boxShadow: headerRowStuck ? t.boxShadowCss("overflowStickyRowShadow") : undefined
        }
      }
    } : undefined,
    /**
     * Sticky row and column header (in LTR it's the top-left-most cell)
     */
    stickyHeaderRow && stickyHeaderColumn ? {
      "thead tr:last-of-type th:first-child": (_theadTrLastOfTyp = {
        left: stickyHeaderColumnOffset,
        top: stickyHeaderRowOffset,
        zIndex: positionStickyElevation.tableHeaderCell
      }, (0, _defineProperty2["default"])(_theadTrLastOfTyp, "[dir=\"rtl\"] &", {
        left: "unset",
        right: stickyHeaderColumnOffset
      }), (0, _defineProperty2["default"])(_theadTrLastOfTyp, "filter", headerColumnStuck ? "drop-shadow(".concat(t("overflowStickyColumnShadowOffsetX"), "px ").concat(t("overflowStickyColumnShadowOffsetY"), "px ").concat(t("overflowStickyColumnShadowBlur"), "px ").concat(t("overflowStickyColumnShadowColor"), ")") : undefined), _theadTrLastOfTyp)
    } : undefined);
  });
}, ["stickyHeaderColumn", "stickyHeaderColumnOffset", "headerColumnStuck", "stickyHeaderRow", "stickyHeaderRowOffset", "headerRowStuck"]);
/**
 * This component renders a `<table />` tag along with all the styles necessary to
 * property display rows and cells placed inside the tag. This is used under the
 * hood by the Table component which adds some nice APIs on top of it, so in
 * most cases you should not have to touch this.
 */

var TableContainer = function TableContainer(props) {
  var t = (0, _theme.useTheme)(_table["default"], "table");

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      headerColumnStuck = _useState2[0],
      setHeaderColumnStuck = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      headerRowStuck = _useState4[0],
      setHeaderRowStuck = _useState4[1];

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("table", (0, _extends2["default"])({}, passThroughProps, {
    className: (0, _emotion.cx)(props.className, styles(props)(t), stickyStyles(_objectSpread(_objectSpread({}, props), {}, {
      headerColumnStuck: headerColumnStuck,
      headerRowStuck: headerRowStuck
    }))(t)),
    "mdn-table-fixed": props.fixed ? "" : undefined
  }), props.children), props.stickyHeaderColumn || props.stickyHeaderRow ? /*#__PURE__*/_react["default"].createElement(_stickyScrollTracker["default"], {
    trackX: props.stickyHeaderColumn,
    trackY: props.stickyHeaderRow,
    onChangeX: setHeaderColumnStuck,
    onChangeY: setHeaderRowStuck
  }) : null);
};

TableContainer.displayName = "TableContainer";
TableContainer.propTypes =  false ? {
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Set this to true if the table is being used to contain fixed content.
   */
  fixed: _propTypes["default"].bool,

  /**
   * Set this to true if the table contain nested rows (child rows that can be
   * expanded/collapsed by clicking on their parent row).
   */
  nestedRows: _propTypes["default"].bool,

  /**
   * This determines if horizontal dividers are shown between table rows.
   */
  showDividers: _propTypes["default"].bool,

  /**
   * This determines if horizontal dividers are shown between expanded rows.
   */
  showExpandedDividers: _propTypes["default"].bool,

  /**
   * This determines if table is striped using alternately highlighted rows.
   */
  showStripes: _propTypes["default"].bool,

  /**
   * This can be used to adjust the vertical spacing of the table.
   */
  spacing: _propTypes["default"].oneOf(["small", "medium"]),

  /**
   * Stick table header column to the beginning of the scroll container when the
   * user scrolls horizontally.
   *
   * NOTE: This feature is unsupported on IE11 because it uses `position: sticky`.
   *
   * @since 5.21.0
   */
  stickyHeaderColumn: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the "stickyHeaderColumn" prop if you don't want
   * to stick table header column to the very beginning of the scroll container.
   * Use this to specify the pixel offset at which the column should stick.
   *
   * @since 5.21.0
   */
  stickyHeaderColumnOffset: _propTypes["default"].number,

  /**
   * Stick table header column to the beginning of the scroll container when the
   * user scrolls vertically.
   *
   * NOTE: This feature is unsupported on IE11 because it uses `position: sticky`.
   *
   * @since 5.21.0
   */
  stickyHeaderRow: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the "stickyHeaderRow" prop if you don't want
   * to stick table header rows to the very beginning of the scroll container.
   * Use this to specify the pixel offset at which the rows should stick.
   *
   * @since 5.21.0
   */
  stickyHeaderRowOffset: _propTypes["default"].number
} : {};
var _default = TableContainer;
exports["default"] = _default;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(390);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(74),
    isObject = __webpack_require__(85);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(395);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNodeBounds = exports.emptyNodeBounds = exports.compareNodeBounds = void 0;
var emptyNodeBounds = {
  top: 0,
  left: 0,
  width: 0,
  height: 0
};
exports.emptyNodeBounds = emptyNodeBounds;
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
/**
 * Check to see if two rectangles, defined by top/left origin and width/height,
 * are equal.
 */

var compareNodeBounds = function compareNodeBounds(a, b) {
  return a === b || a.top === b.top && a.left === b.left && a.width === b.width && a.height === b.height;
};
/**
 * This returns a rectangle from a DOM node that represents the size and
 * position of the node relative to the viewport. If the node does not exist
 * then an empty rectangle is returned. Note that the width and height do not
 * take any CSS scale transforms into account.
 */


exports.compareNodeBounds = compareNodeBounds;

var getNodeBounds = function getNodeBounds(node) {
  if (!canUseDOM) {
    return emptyNodeBounds;
  } else if (node === window) {
    var width = window.innerWidth;
    var height = window.innerHeight;
    return {
      top: 0,
      left: 0,
      width: width,
      height: height
    };
  } else if (node === document.documentElement) {
    // For the document element, getBoundingClientRect() will return scroll
    // offset instead of actual position for top/left values (in all browsers
    // except edge). This is inconsistent with the function's behavior for other
    // nodes (in all browsers except edge). Resolve this by just assuming the
    // top/left of the document element is 0/0 (true in all cases except for
    // when the "html" tag has been repositioned with CSS, which is rare).
    var _node$getBoundingClie = node.getBoundingClientRect(),
        _width = _node$getBoundingClie.width,
        _height = _node$getBoundingClie.height;

    return {
      top: 0,
      left: 0,
      width: _width,
      height: _height
    };
  } else if (node && node.getBoundingClientRect) {
    // For normal nodes, get the width and height from offsetWidth and
    // offsetHeight instead of getBoundingClientRect. This will ignore any CSS
    // scale transforms that are applied.
    var _width2 = node.offsetWidth;
    var _height2 = node.offsetHeight;

    var _node$getBoundingClie2 = node.getBoundingClientRect(),
        top = _node$getBoundingClie2.top,
        left = _node$getBoundingClie2.left;

    return {
      top: top,
      left: left,
      width: _width2,
      height: _height2
    };
  } else {
    return emptyNodeBounds;
  }
};

exports.getNodeBounds = getNodeBounds;

/***/ }),
/* 217 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCheckLargeData: "data:image/svg+xml,%3csvg width='13' height='9' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 4.017l3.996 3.998L12.006 1' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconCheckLargeWidth: 13,
  iconCheckLargeHeight: 9
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(74),
    isArray = __webpack_require__(42),
    isObjectLike = __webpack_require__(62);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 219 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    focusRingWidth: 2,
    focusRingColorFocus: tokens.themeBorderPrimaryFocus,
    focusRingColorError: tokens.themeBorderPrimaryError,
    focusRingDropShadowOffsetX: 0,
    focusRingDropShadowOffsetY: 1,
    focusRingDropShadowBlur: 2,
    focusRingDropShadowSpread: 0,
    focusRingDropShadowColor: "rgba(11, 12, 12, 0.16)"
  }
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _default = /*#__PURE__*/_react["default"].createContext({});

exports["default"] = _default;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var buttonReset = {
  display: "inline-block",
  padding: 0,
  border: 0,
  outline: "none",
  backgroundColor: "transparent",
  textAlign: "inherit",
  color: "inherit",
  fontFamily: "inherit",
  fontSize: "inherit",
  fontWeight: "inherit",
  lineHeight: "inherit",
  WebkitAppearance: "none",
  WebkitMarginBefore: 0,
  WebkitMarginAfter: 0,
  WebkitMarginStart: 0,
  WebkitMarginEnd: 0,
  "::-moz-focus-inner": {
    border: 0
  }
};
var _default = buttonReset;
exports["default"] = _default;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(102),
    isArrayLike = __webpack_require__(73),
    keys = __webpack_require__(86);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(103),
    stackClear = __webpack_require__(423),
    stackDelete = __webpack_require__(424),
    stackGet = __webpack_require__(425),
    stackHas = __webpack_require__(426),
    stackSet = __webpack_require__(427);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 224 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(444),
    isObjectLike = __webpack_require__(62);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(144),
    arraySome = __webpack_require__(447),
    cacheHas = __webpack_require__(145);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(53),
    stubFalse = __webpack_require__(460);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)(module)))

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(461),
    baseUnary = __webpack_require__(230),
    nodeUtil = __webpack_require__(462);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 230 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65),
    root = __webpack_require__(53);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(85);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 233 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(235),
    toKey = __webpack_require__(107);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(42),
    isKey = __webpack_require__(148),
    stringToPath = __webpack_require__(474),
    toString = __webpack_require__(88);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _table = _interopRequireDefault(__webpack_require__(82));

var _close = _interopRequireDefault(__webpack_require__(154));

var _elevation = __webpack_require__(59);

var _row = _interopRequireDefault(__webpack_require__(44));

var _button = _interopRequireDefault(__webpack_require__(50));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _theme = _interopRequireWildcard(__webpack_require__(14));

var _isElementOfAny = _interopRequireDefault(__webpack_require__(98));

var _visuallyHidden = _interopRequireDefault(__webpack_require__(58));

var _functional = __webpack_require__(26);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = function styles(t) {
  return (0, _emotion.css)({
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: _elevation.elevationForeground,
    color: t("foregroundColor"),
    backgroundColor: t("backgroundColor"),
    "& > [mdn-table-action-bar-overlay-label] > [mdn-table-action-bar-overlay-label-hidden]": _visuallyHidden["default"]
  });
};

var getOverrideTokens = (0, _functional.memoize)(function (t) {
  return {
    themeBorderPrimaryFocus: t("foregroundColor"),
    // Overlays in light mode
    buttonForegroundColorLinkDarkBackdropDefault: t("foregroundColor"),
    buttonForegroundColorLinkDarkBackdropHover: t("foregroundColor"),
    buttonForegroundColorLinkDarkBackdropPressed: t("foregroundColor"),
    buttonBackgroundColorLinkDarkBackdropHover: t("backgroundColorHover"),
    buttonBackgroundColorLinkDarkBackdropPressed: t("backgroundColorPressed"),
    buttonBackgroundColorIconDarkBackdropHover: t("backgroundColorHover"),
    buttonBackgroundColorIconDarkBackdropPressed: t("backgroundColorPressed"),
    // Overlays in dark mode
    buttonForegroundColorLinkLightBackdropDefault: t("foregroundColor"),
    buttonForegroundColorLinkLightBackdropHover: t("foregroundColor"),
    buttonForegroundColorLinkLightBackdropPressed: t("foregroundColor")
  };
});
/**
 * Used to render an overlay containing bulk actions over an action bar. Place
 * this as a child of the TableActionBar component.
 */

var TableActionBarOverlay = function TableActionBarOverlay(props) {
  var buttonComponents = props.buttonComponents;
  var isButton = (0, _react.useMemo)(function () {
    return (0, _isElementOfAny["default"])(buttonComponents);
  }, [buttonComponents]);

  var buttons = _react["default"].Children.toArray(props.children).filter(isButton);

  var t = (0, _theme.useTheme)(_table["default"], "tableActionBarOverlay");
  return /*#__PURE__*/_react["default"].createElement(_theme["default"], {
    tokens: getOverrideTokens(t)
  }, /*#__PURE__*/_react["default"].createElement(_row["default"], {
    className: styles(t),
    type: "fill",
    spacingInset: "medium",
    spacing: "small",
    widths: ["fill"]
  }, /*#__PURE__*/_react["default"].createElement("span", {
    "aria-live": "polite",
    "aria-atomic": "true",
    "mdn-table-action-bar-overlay-label": ""
  }, props.label, /*#__PURE__*/_react["default"].createElement("span", {
    "mdn-table-action-bar-overlay-label-hidden": ""
  }, props.openLabel)), buttons.map(function (button) {
    return /*#__PURE__*/_react["default"].cloneElement(button, {
      backdropColor: t("backgroundColor")
    });
  }), props.onClose ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: props.onClose,
    backdropColor: t("backgroundColor"),
    label: props.closeLabel
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _close["default"]
  })) : null));
};

TableActionBarOverlay.propTypes =  false ? {
  /**
   * The contents of the action bar overlay.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The component or components that will render as buttons. Defaults
   * to Meridian's Button.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  buttonComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * An accessible label for the overlay's close button.
   */
  closeLabel: _propTypes["default"].string,

  /**
   * A label that is shown on the left hand side of the overlay. This label
   * should indicate the number of rows selected in the table (e.g. something
   * like "3 shipments selected" or "4 of 10 regions selected").
   */
  label: _propTypes["default"].node,

  /**
   * An accessible label read by screen readers after label when the overlay appears.
   * This label should indicate what new content is available within the overlay
   * (e.g. "new actions available").
   */
  openLabel: _propTypes["default"].string,

  /**
   * This is called when the user attempts to close the overlay.
   */
  onClose: _propTypes["default"].func
} : {};
TableActionBarOverlay.defaultProps = {
  label: null,
  closeLabel: "Close",
  openLabel: "new actions available",
  buttonComponents: [_button["default"]]
};
var _default = TableActionBarOverlay;
exports["default"] = _default;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hoverStyles = exports.focusStyles = exports.disabledStyles = exports.defaultStyles = exports.activeStyles = void 0;

var _focusRing = _interopRequireDefault(__webpack_require__(43));

var getStyles = function getStyles(t, _ref) {
  var type = _ref.type,
      backdrop = _ref.backdrop,
      state = _ref.state;
  return {
    color: t("foregroundColor", [type, backdrop, state]),
    backgroundColor: t("backgroundColor", [type, backdrop, state]),
    borderColor: t("borderColor", [type, state])
  };
};

var activeStyles = function activeStyles(t, _ref2) {
  var type = _ref2.type,
      backdrop = _ref2.backdrop;
  return getStyles(t, {
    type: type,
    backdrop: backdrop,
    state: "pressed"
  });
};

exports.activeStyles = activeStyles;

var hoverStyles = function hoverStyles(t, _ref3) {
  var type = _ref3.type,
      backdrop = _ref3.backdrop;
  return getStyles(t, {
    type: type,
    backdrop: backdrop,
    state: "hover"
  });
};

exports.hoverStyles = hoverStyles;

var defaultStyles = function defaultStyles(t, _ref4) {
  var type = _ref4.type,
      backdrop = _ref4.backdrop;
  return getStyles(t, {
    type: type,
    backdrop: backdrop,
    state: "default"
  });
};

exports.defaultStyles = defaultStyles;

var disabledStyles = function disabledStyles(t, _ref5) {
  var type = _ref5.type,
      backdrop = _ref5.backdrop;
  return getStyles(t, {
    type: type,
    backdrop: backdrop,
    state: "disabled"
  });
};

exports.disabledStyles = disabledStyles;

var focusStyles = function focusStyles(t, _ref6) {
  var focus = _ref6.focus,
      borderWidth = _ref6.borderWidth,
      borderRadius = _ref6.borderRadius,
      backdropColor = _ref6.backdropColor,
      linkOrIcon = _ref6.linkOrIcon,
      outlineOffset = _ref6.outlineOffset;
  return (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    borderWidth: borderWidth,
    borderRadius: borderRadius,
    gapColor: backdropColor,
    dropShadow: !linkOrIcon,
    offset: outlineOffset !== undefined ? outlineOffset : t("focusOutlineOffset")
  });
};

exports.focusStyles = focusStyles;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(152),
    baseIteratee = __webpack_require__(102),
    toInteger = __webpack_require__(153);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = fromIndex < 0
      ? nativeMax(length + index, 0)
      : nativeMin(index, length - 1);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
}

module.exports = findLastIndex;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(506)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(513);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 241 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _popoverController = _interopRequireDefault(__webpack_require__(539));

var _default = _popoverController["default"];
exports["default"] = _default;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _transitionController = _interopRequireDefault(__webpack_require__(542));

var _default = _transitionController["default"];
exports["default"] = _default;

/***/ }),
/* 244 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertKnockoutData: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3e%3cpath d='M15.89 14.55l-7-14a1 1 0 00-1.78 0l-7 14a1 1 0 000 1A1 1 0 001 16h14a1 1 0 00.89-1.45zM7 6a1 1 0 012 0v3a1 1 0 01-2 0zm1 8a1 1 0 111-1 1 1 0 01-1 1z' fill='currentColor'/%3e%3c/svg%3e",
  iconAlertKnockoutWidth: 16,
  iconAlertKnockoutHeight: 16
};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _emotion = __webpack_require__(4);

var _token = __webpack_require__(12);

var _noTextWrap = _interopRequireDefault(__webpack_require__(110));

/**
 * Pass in a token helper for text tokens
 * (e.g. getTokenHelper("text")(themedTextTokens)) and any text props.
 */
var getTextStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _ul, _ref2, _ol, _ref3, _css;

  var fontFamily = _ref.fontFamily,
      color = _ref.color,
      type = _ref.type,
      transform = _ref.transform,
      alignment = _ref.alignment,
      tag = _ref.tag,
      truncate = _ref.truncate,
      breakWord = _ref.breakWord,
      listStyle = _ref.listStyle;
  return (0, _emotion.css)( // DEFAULT: These are the default text styles - drop in a <Text /> tag in
  // with no parent and no props and this is what you'll get.
  {
    fontFamily: t("fontFamilyAmazonEmber"),
    fontWeight: t("fontWeightB300"),
    fontSize: t("fontSizeB300"),
    lineHeight: t("lineHeightB300"),
    color: t("colorPrimary")
  }, // INHERIT: These styles enable you to cascade <Text /> components - place a
  // <Text /> component inside another <Text /> component and the descendant
  // component will inherit from the ancestor instead of falling back to the
  // default styles.
  {
    "[mdn-text] &": {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      color: "inherit"
    }
  }, // OVERRIDE: These styles enable you to override any default or inherited
  // styles using the component's props. The :not() selector is added to
  // increase the specificity of the styles so they override everything else
  // without resorting to !important.
  {
    "&:not(#mdn-specificity-hack)": {
      fontFamily: fontFamily ? t("fontFamily", fontFamily) : undefined,
      fontWeight: type ? t("fontWeight", type) : undefined,
      fontSize: type ? t("fontSize", type) : undefined,
      lineHeight: type ? t("lineHeight", type) : undefined,
      color: color ? t("color", color) : undefined
    }
  }, (_css = {
    textTransform: transform,
    textAlign: alignment ? alignment : undefined,
    // Clear the default margin on tags like "p"
    margin: 0,
    // If a single word is too wide for the element then allow the browser
    // to break it up at an arbitrary location. A hyphen will not be
    // added. This won't look great, but is better than the word flowing
    // off the edge of the element and potentially getting
    // clipped/obscured.
    overflowWrap: breakWord ? "break-word" : undefined,
    // HACK: Overflow wrap for IE11
    wordWrap: breakWord ? "break-word" : undefined
  }, (0, _defineProperty2["default"])(_css, tag === "ul" ? "&" : "& ul", (_ref2 = {
    // HACK: IE11 does not support padding-inline-* so we have
    // to use directional padding-left/right. If/when we drop IE11
    // and we update the token names, we can simplify these styles to be:
    // {
    //   paddingInlineStart: t("listSpacingHorizontal")
    // }
    paddingLeft: t("listSpacingHorizontal")
  }, (0, _defineProperty2["default"])(_ref2, "[dir=\"rtl\"] &", {
    paddingLeft: 0,
    paddingRight: t("listSpacingHorizontal")
  }), (0, _defineProperty2["default"])(_ref2, "listStyleType", "disc"), (0, _defineProperty2["default"])(_ref2, "& ul", (_ul = {
    // HACK: IE11 does not support padding-inline-* so we have
    // to use directional padding-left/right. If/when we drop IE11
    // and we update the token names, we can simplify these styles to be:
    // {
    //   paddingInlineStart: t("listSpacingHorizontal")
    // }
    paddingLeft: t("listSpacingHorizontal")
  }, (0, _defineProperty2["default"])(_ul, "[dir=\"rtl\"] &", {
    paddingLeft: 0,
    paddingRight: t("listSpacingHorizontal")
  }), (0, _defineProperty2["default"])(_ul, "listStyleType", "circle"), (0, _defineProperty2["default"])(_ul, "& ul", {
    listStyleType: "square"
  }), _ul)), _ref2)), (0, _defineProperty2["default"])(_css, tag === "ol" ? "&" : "& ol", (_ref3 = {
    // HACK: IE11 does not support padding-inline-* so we have
    // to use directional padding-left/right. If/when we drop IE11
    // and we update the token names, we can simplify these styles to be:
    // {
    //   paddingInlineStart: t("listSpacingHorizontal")
    // }
    paddingLeft: t("listSpacingHorizontal")
  }, (0, _defineProperty2["default"])(_ref3, "[dir=\"rtl\"] &", {
    paddingLeft: 0,
    paddingRight: t("listSpacingHorizontal")
  }), (0, _defineProperty2["default"])(_ref3, "listStyleType", listStyle ? listStyle : "decimal"), (0, _defineProperty2["default"])(_ref3, "& ol", (_ol = {
    // HACK: IE11 does not support padding-inline-* so we have
    // to use directional padding-left/right. If/when we drop IE11
    // and we update the token names, we can simplify these styles to be:
    // {
    //   paddingInlineStart: t("listSpacingHorizontal")
    // }
    paddingLeft: t("listSpacingHorizontal")
  }, (0, _defineProperty2["default"])(_ol, "[dir=\"rtl\"] &", {
    paddingLeft: 0,
    paddingRight: t("listSpacingHorizontal")
  }), (0, _defineProperty2["default"])(_ol, "listStyleType", listStyle ? listStyle : "lower-alpha"), (0, _defineProperty2["default"])(_ol, "& ol", {
    listStyleType: listStyle ? listStyle : "lower-roman"
  }), _ol)), _ref3)), (0, _defineProperty2["default"])(_css, "".concat(tag === "ul" || tag === "ol" ? "& > * + *, " : "", "& ul > * + *, & ol > * + *"), {
    paddingTop: t("listSpacingVertical")
  }), _css), truncate ? _noTextWrap["default"] : undefined);
}, ["fontFamily", "color", "type", "transform", "alignment", "tag", "truncate", "breakWord", "listStyle"]);
var _default = getTextStyles;
exports["default"] = _default;

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOAD_METRICS_FOR_OVERVIEW_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOAD_METRICS_FOR_OVERVIEW_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_AISLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_AISLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOAD_STOW_MIN_OF_WORK_METRICS_FOR_OVERVIEW_CLUSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOAD_STOW_ASSOCIATE_METRICS_FOR_OVERVIEW_CLUSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_AT_RISK_AISLES_METRICS_FOR_OVERVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_SMART_STOW_ENABLEMENT_CALL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchSmartStowEnablementCallSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getAtRiskAislesForOverview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getMinOfWorkMetricsForOverviewCluster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getStowPackageMetricsForOverviewCluster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getStowAssociateMetricsForOverviewCluster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getStowPackageMetricsForOverviewAisle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getInductPackageMetricsForOverviewAisle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getInductPackageMetricsForOverviewCluster; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_StowResource__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MetricUtility__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources_InductResource__ = __webpack_require__(60);
var _this=this;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var LOAD_METRICS_FOR_OVERVIEW_CALL_BEGIN="LOAD_METRICS_FOR_OVERVIEW_CALL_BEGIN";var LOAD_METRICS_FOR_OVERVIEW_CALL_FAILURE="LOAD_METRICS_FOR_OVERVIEW_CALL_FAILURE";var LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_AISLE="LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_AISLE";var LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_AISLE="LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_AISLE";var LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER="LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER";var LOAD_STOW_MIN_OF_WORK_METRICS_FOR_OVERVIEW_CLUSTER="LOAD_STOW_MIN_OF_WORK_METRICS_FOR_OVERVIEW_CLUSTER";var LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER="LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER";var LOAD_STOW_ASSOCIATE_METRICS_FOR_OVERVIEW_CLUSTER="LOAD_STOW_ASSOCIATE_METRICS_FOR_OVERVIEW_CLUSTER";var LOAD_AT_RISK_AISLES_METRICS_FOR_OVERVIEW="LOAD_AT_RISK_AISLES_METRICS_FOR_OVERVIEW";var FETCH_SMART_STOW_ENABLEMENT_CALL_SUCCESS="FETCH_SMART_STOW_ENABLEMENT_CALL_SUCCESS";var metricProcessName="SCC_STOW_OVERVIEW";var loadMetricsForOverviewCallBegin=function loadMetricsForOverviewCallBegin(){return{type:LOAD_METRICS_FOR_OVERVIEW_CALL_BEGIN};};var loadAtRiskAislesMetricsForOverview=function loadAtRiskAislesMetricsForOverview(atRiskAislesMetricsMap){return{type:LOAD_AT_RISK_AISLES_METRICS_FOR_OVERVIEW,atRiskAislesMetricsMap:atRiskAislesMetricsMap};};var loadInductPackageMetricsForOverviewAisle=function loadInductPackageMetricsForOverviewAisle(inductPackageMetricsMapAisle){return{type:LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_AISLE,inductPackageMetricsMapAisle:inductPackageMetricsMapAisle};};var loadStowPackageMetricsForOverviewAisle=function loadStowPackageMetricsForOverviewAisle(stowPackageMetricsMapAisle){return{type:LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_AISLE,stowPackageMetricsMapAisle:stowPackageMetricsMapAisle};};var loadInductPackageMetricsForOverviewCluster=function loadInductPackageMetricsForOverviewCluster(inductPackageMetricsMapCluster){return{type:LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER,inductPackageMetricsMapCluster:inductPackageMetricsMapCluster};};var loadStowAssociateMetricsForOverviewCluster=function loadStowAssociateMetricsForOverviewCluster(stowAssociateMetricsMapCluster){return{type:LOAD_STOW_ASSOCIATE_METRICS_FOR_OVERVIEW_CLUSTER,stowAssociateMetricsMapCluster:stowAssociateMetricsMapCluster};};var loadStowMinOfWorkMetricsForOverviewCluster=function loadStowMinOfWorkMetricsForOverviewCluster(minOfWorkMetricsMapCluster){return{type:LOAD_STOW_MIN_OF_WORK_METRICS_FOR_OVERVIEW_CLUSTER,minOfWorkMetricsMapCluster:minOfWorkMetricsMapCluster};};var loadStowPackageMetricsForOverviewCluster=function loadStowPackageMetricsForOverviewCluster(stowPackageMetricsMapCluster){return{type:LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER,stowPackageMetricsMapCluster:stowPackageMetricsMapCluster};};var fetchSmartStowEnablementCallSuccess=function fetchSmartStowEnablementCallSuccess(isSmartStowEnabled){return{type:FETCH_SMART_STOW_ENABLEMENT_CALL_SUCCESS,isSmartStowEnabled:isSmartStowEnabled};};var loadMetricsForOverviewCallFailure=function loadMetricsForOverviewCallFailure(){return{type:LOAD_METRICS_FOR_OVERVIEW_CALL_FAILURE};};var getAtRiskAislesForOverview=function getAtRiskAislesForOverview(nodeId,isDRSStowVisibilityEnabled,cycles,cycleIds,CPTIds,filterIdentifier,isCPTFilterEnabled,isSmartStowEnabled){var metricName="getAtRiskAislesMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_4__enums__["o" /* Resource */].AISLE,filters:{NODE:[nodeId]},isAggregationRequired:true};if(!isDRSStowVisibilityEnabled){request.filters["DRS"]=[__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* FALSE */]];}cycles=cycles.filter(Boolean);if(cycles.length&&!isCPTFilterEnabled){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length&&!isCPTFilterEnabled){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* CYCLE_ID */]]=cycleIds;}if(CPTIds.length&&isCPTFilterEnabled){request.filters[[filterIdentifier]]=CPTIds;}if(isSmartStowEnabled){request.metrics=[__WEBPACK_IMPORTED_MODULE_4__enums__["b" /* AtRiskAislesMetric */].MINUTES_OF_WORK,__WEBPACK_IMPORTED_MODULE_4__enums__["b" /* AtRiskAislesMetric */].ADJACENCY_SCORE];}else{request.metrics=[__WEBPACK_IMPORTED_MODULE_4__enums__["b" /* AtRiskAislesMetric */].MINUTES_OF_WORK];}return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var startTime,atRiskAislesMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;dispatch(loadMetricsForOverviewCallBegin());startTime=Date.now();_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["a" /* getAtRiskAislesMetrics */])(request);case 5:atRiskAislesMetricsMap=_context.sent;if(atRiskAislesMetricsMap){dispatch(loadAtRiskAislesMetricsForOverview(atRiskAislesMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForOverviewCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context.next=13;break;case 9:_context.prev=9;_context.t0=_context["catch"](0);dispatch(loadMetricsForOverviewCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context.stop();}}},_callee,_this,[[0,9]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var getMinOfWorkMetricsForOverviewCluster=function getMinOfWorkMetricsForOverviewCluster(nodeId,isDRSStowVisibilityEnabled,cycles,cycleIds){var metricName="getMinOfWorkMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_4__enums__["o" /* Resource */].CLUSTER,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_4__enums__["p" /* StowPackageMetric */].MINUTES_OF_WORK,__WEBPACK_IMPORTED_MODULE_4__enums__["p" /* StowPackageMetric */].LAST_FIFTEEN_MINUTE_STOW_RATE,__WEBPACK_IMPORTED_MODULE_4__enums__["p" /* StowPackageMetric */].CURRENT_INDUCTED_COUNT],isAggregationRequired:true};if(!isDRSStowVisibilityEnabled){request.filters["DRS"]=[__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* FALSE */]];}cycles=cycles.filter(Boolean);if(cycles.length){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* CYCLE_ID */]]=cycleIds;}return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var startTime,minOfWorkMetricsMapCluster;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;dispatch(loadMetricsForOverviewCallBegin());startTime=Date.now();_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["q" /* getStowPackageMetrics */])(request);case 5:minOfWorkMetricsMapCluster=_context2.sent;if(minOfWorkMetricsMapCluster){removeUnwantedClusters(minOfWorkMetricsMapCluster);dispatch(loadStowMinOfWorkMetricsForOverviewCluster(minOfWorkMetricsMapCluster));Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForOverviewCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context2.next=13;break;case 9:_context2.prev=9;_context2.t0=_context2["catch"](0);dispatch(loadMetricsForOverviewCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context2.stop();}}},_callee2,_this,[[0,9]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var getStowPackageMetricsForOverviewCluster=function getStowPackageMetricsForOverviewCluster(nodeId,isDRSStowVisibilityEnabled,cycles,cycleIds,CPTIds,filterIdentifier,isCPTFilterEnabled){var metricName="getStowPackageMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_4__enums__["o" /* Resource */].CLUSTER,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_4__enums__["p" /* StowPackageMetric */].STOW_RATE,__WEBPACK_IMPORTED_MODULE_4__enums__["p" /* StowPackageMetric */].SCAN_COMPLIANCE,__WEBPACK_IMPORTED_MODULE_4__enums__["p" /* StowPackageMetric */].PLANNED_COUNT,__WEBPACK_IMPORTED_MODULE_4__enums__["p" /* StowPackageMetric */].CURRENT_INDUCTED_COUNT],isAggregationRequired:true};if(!isDRSStowVisibilityEnabled){request.filters["DRS"]=[__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* FALSE */]];}cycles=cycles.filter(Boolean);if(cycles.length&&!isCPTFilterEnabled){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length&&!isCPTFilterEnabled){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* CYCLE_ID */]]=cycleIds;}if(CPTIds.length&&isCPTFilterEnabled){request.filters[[filterIdentifier]]=CPTIds;}return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var startTime,stowPackageMetricsMapCluster;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;dispatch(loadMetricsForOverviewCallBegin());startTime=Date.now();_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["q" /* getStowPackageMetrics */])(request);case 5:stowPackageMetricsMapCluster=_context3.sent;if(stowPackageMetricsMapCluster){removeUnwantedClusters(stowPackageMetricsMapCluster);dispatch(loadStowPackageMetricsForOverviewCluster(stowPackageMetricsMapCluster));Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForOverviewCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context3.next=13;break;case 9:_context3.prev=9;_context3.t0=_context3["catch"](0);dispatch(loadMetricsForOverviewCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context3.stop();}}},_callee3,_this,[[0,9]]);}));return function(_x3){return _ref3.apply(this,arguments);};}();};var getStowAssociateMetricsForOverviewCluster=function getStowAssociateMetricsForOverviewCluster(nodeId,cycles,CPTIds,filterIdentifier,isCPTFilterEnabled){var metricName="getStowAssociateMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_4__enums__["o" /* Resource */].CLUSTER,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_4__enums__["a" /* AssociateMetric */].ACTIVE_ASSOCIATE_COUNT]};cycles=cycles.filter(Boolean);if(cycles.length&&!isCPTFilterEnabled){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CYCLE */]]=cycles;}if(CPTIds.length&&isCPTFilterEnabled){request.filters[[filterIdentifier]]=CPTIds;}return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var startTime,stowAssociateMetricsMapCluster;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;dispatch(loadMetricsForOverviewCallBegin());startTime=Date.now();_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["e" /* getStowAssociateMetrics */])(request);case 5:stowAssociateMetricsMapCluster=_context4.sent;if(stowAssociateMetricsMapCluster){removeUnwantedClusters(stowAssociateMetricsMapCluster);dispatch(loadStowAssociateMetricsForOverviewCluster(stowAssociateMetricsMapCluster));Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForOverviewCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context4.next=13;break;case 9:_context4.prev=9;_context4.t0=_context4["catch"](0);dispatch(loadMetricsForOverviewCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context4.stop();}}},_callee4,_this,[[0,9]]);}));return function(_x4){return _ref4.apply(this,arguments);};}();};var getStowPackageMetricsForOverviewAisle=function getStowPackageMetricsForOverviewAisle(nodeId,isDRSStowVisibilityEnabled,cycles,cycleIds,CPTIds,filterIdentifier,isCPTFilterEnabled){var metricName="getStowPackageMetrics";var request={groupBy:__WEBPACK_IMPORTED_MODULE_4__enums__["o" /* Resource */].AISLE,filters:{NODE:[nodeId]},metrics:[__WEBPACK_IMPORTED_MODULE_4__enums__["p" /* StowPackageMetric */].PLANNED_COUNT,__WEBPACK_IMPORTED_MODULE_4__enums__["p" /* StowPackageMetric */].CURRENT_INDUCTED_COUNT]};if(!isDRSStowVisibilityEnabled){request.filters["DRS"]=[__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* FALSE */]];}cycles=cycles.filter(Boolean);if(cycles.length&&!isCPTFilterEnabled){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CYCLE */]]=cycles;}cycleIds=cycleIds.filter(Boolean);if(cycleIds.length&&!isCPTFilterEnabled){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* CYCLE_ID */]]=cycleIds;}if(CPTIds.length&&isCPTFilterEnabled){request.filters[[filterIdentifier]]=CPTIds;}return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var startTime,stowPackageMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;dispatch(loadMetricsForOverviewCallBegin());startTime=Date.now();_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["q" /* getStowPackageMetrics */])(request);case 5:stowPackageMetricsMap=_context5.sent;if(stowPackageMetricsMap){dispatch(loadStowPackageMetricsForOverviewAisle(stowPackageMetricsMap));Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForOverviewCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context5.next=13;break;case 9:_context5.prev=9;_context5.t0=_context5["catch"](0);dispatch(loadMetricsForOverviewCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context5.stop();}}},_callee5,_this,[[0,9]]);}));return function(_x5){return _ref5.apply(this,arguments);};}();};var getInductPackageMetricsForOverviewAisle=function getInductPackageMetricsForOverviewAisle(nodeId,cycles,CPTIds,filterIdentifier,isCPTFilterEnabled){var metricName="getInductPackageMetrics";var request={nodeId:nodeId,groupBy:"Aisle",metricList:[__WEBPACK_IMPORTED_MODULE_4__enums__["m" /* InductPackageMetric */].RECEIVED]};cycles=cycles.filter(Boolean);if(cycles.length&&!isCPTFilterEnabled){request.filters={Cycle:cycles};}if(CPTIds.length&&isCPTFilterEnabled){request.filters=_defineProperty({},filterIdentifier,CPTIds);}return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch){var startTime,inductPackageMetricsMapAisle;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.prev=0;dispatch(loadMetricsForOverviewCallBegin());startTime=Date.now();_context6.next=5;return Object(__WEBPACK_IMPORTED_MODULE_5__resources_InductResource__["a" /* getInductPackageMetrics */])(request);case 5:inductPackageMetricsMapAisle=_context6.sent;if(inductPackageMetricsMapAisle){dispatch(loadInductPackageMetricsForOverviewAisle(inductPackageMetricsMapAisle));Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForOverviewCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context6.next=13;break;case 9:_context6.prev=9;_context6.t0=_context6["catch"](0);dispatch(loadMetricsForOverviewCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context6.stop();}}},_callee6,_this,[[0,9]]);}));return function(_x6){return _ref6.apply(this,arguments);};}();};var getInductPackageMetricsForOverviewCluster=function getInductPackageMetricsForOverviewCluster(nodeId,cycles,CPTIds,filterIdentifier,isCPTFilterEnabled){var metricName="getInductPackageMetrics";var request={nodeId:nodeId,groupBy:"Cluster",metricList:[__WEBPACK_IMPORTED_MODULE_4__enums__["m" /* InductPackageMetric */].RECEIVED]};cycles=cycles.filter(Boolean);if(cycles.length&&!isCPTFilterEnabled){request.filters={Cycle:cycles};}if(CPTIds.length&&isCPTFilterEnabled){request.filters=_defineProperty({},filterIdentifier,CPTIds);}return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch){var startTime,inductPackageMetricsMapCluster;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.prev=0;dispatch(loadMetricsForOverviewCallBegin());startTime=Date.now();_context7.next=5;return Object(__WEBPACK_IMPORTED_MODULE_5__resources_InductResource__["a" /* getInductPackageMetrics */])(request);case 5:inductPackageMetricsMapCluster=_context7.sent;if(inductPackageMetricsMapCluster){removeUnwantedClusters(inductPackageMetricsMapCluster);dispatch(loadInductPackageMetricsForOverviewCluster(inductPackageMetricsMapCluster));Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadMetricsForOverviewCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context7.next=13;break;case 9:_context7.prev=9;_context7.t0=_context7["catch"](0);dispatch(loadMetricsForOverviewCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context7.stop();}}},_callee7,_this,[[0,9]]);}));return function(_x7){return _ref7.apply(this,arguments);};}();};function removeUnwantedClusters(metricsMap){delete metricsMap[__WEBPACK_IMPORTED_MODULE_3__constants__["w" /* TOTAL */]];}

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ClusterV2__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Aisle__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__floor_Floor__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SortZone__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_breadcrumb__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_breadcrumb_breadcrumb_group__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_breadcrumb_breadcrumb_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_breadcrumb_breadcrumb_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_ClusterActionsV2__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_AisleActions__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_SortZoneActions__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__station_pair_StationPair__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_StationPairActions__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions_FloorActions__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Route__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions_RouteActions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions_ZoneActions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Zone__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__CartLocation__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__actions_CartLocationActions__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__actions_ConfigActions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__sideline_FloorLocation__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__actions_FloorLocationActions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__sideline_Cart__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__actions_CartActions__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__common_context_DeviceLayoutContext__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__actions_ClusterActions__ = __webpack_require__(94);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StowBreakdown=function(_Component){_inherits(StowBreakdown,_Component);function StowBreakdown(props){_classCallCheck(this,StowBreakdown);var _this=_possibleConstructorReturn(this,(StowBreakdown.__proto__||Object.getPrototypeOf(StowBreakdown)).call(this,props));_this.getViewSubjects=function(key){return _this.props.navigationOptions.filter(function(navigationOption){return navigationOption.key===key;}).map(function(navigationOption){return navigationOption.value;});};_this.isCPTFilterEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].IS_CPT_FILTER_ENABLED];};_this.findViewByOptionValues=function(navigationOptions,selectedView){switch(_this.props.capability){case __WEBPACK_IMPORTED_MODULE_20__enums__["e" /* Capability */].SSD:return _this.findViewForSSD(navigationOptions,selectedView);case __WEBPACK_IMPORTED_MODULE_20__enums__["e" /* Capability */].AMZL:default:return _this.findViewForAmzlCore(navigationOptions,selectedView);case __WEBPACK_IMPORTED_MODULE_20__enums__["e" /* Capability */].AR_NEXT_GEN:return _this.findViewForArNextGen(navigationOptions,selectedView);}};_this.findViewForAmzlCore=function(navigationOptions,selectedView){if(__WEBPACK_IMPORTED_MODULE_20__enums__["q" /* ViewType */].SIDELINE_VIEW===selectedView){if(navigationOptions.length===1)return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].CART_VIEW;return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].FLOOR_LOCATION_VIEW;}if(Object(__WEBPACK_IMPORTED_MODULE_15__Utility__["u" /* isOnlyRouteViewApplicable */])(_this.state.nodeId,_this.props.capability)||__WEBPACK_IMPORTED_MODULE_20__enums__["q" /* ViewType */].ROUTE_VIEW===selectedView){return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].ROUTE_VIEW;}else if(navigationOptions.length===2)return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].SORT_ZONE_VIEW;else if(navigationOptions.length===1)return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].AISLE_VIEW;else return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].CLUSTER;};_this.findViewForSSD=function(navigationOptions,selectedView){if(__WEBPACK_IMPORTED_MODULE_20__enums__["q" /* ViewType */].ROUTE_VIEW===selectedView){return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].ROUTE_VIEW;}if(navigationOptions.length===1)return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].CART_LOCATION_VIEW;return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].ZONE_VIEW;};_this.findViewForArNextGen=function(navigationOptions,selectedView){if(__WEBPACK_IMPORTED_MODULE_20__enums__["q" /* ViewType */].ROUTE_VIEW===selectedView){return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].ROUTE_VIEW;}if(navigationOptions.length===1)return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].FLOOR_VIEW;else return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].STATION_PAIR_VIEW;};_this.state={nodeId:Object(__WEBPACK_IMPORTED_MODULE_15__Utility__["m" /* getNodeId */])(),routeCodePrefixes:Object(__WEBPACK_IMPORTED_MODULE_15__Utility__["d" /* extractRouteCodePrefixesFromParam */])(props)};return _this;}_createClass(StowBreakdown,[{key:"render",value:function render(){var _this2=this;var _props=this.props,navigationOptions=_props.navigationOptions,selectedCycle=_props.selectedCycle,selectedCycleId=_props.selectedCycleId,selectedView=_props.selectedView,isInitialView=_props.isInitialView,selectedCPT=_props.selectedCPT,filterIdentifier=_props.filterIdentifier,spacingInset_shorthand4=_props.spacingInset_shorthand4;//For initial view open route view when route code prefix list exists in params
if(this.state.routeCodePrefixes&&this.state.routeCodePrefixes!==""&&isInitialView){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["x" /* viewChanged */])(__WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].ROUTE_VIEW));}var view=this.findViewByOptionValues(navigationOptions,selectedView);var renderSubComponent=function renderSubComponent(){clearInterval(_this2.timer);switch(view){case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].AISLE_VIEW:return _this2.renderAisleView(selectedCycle,selectedCycleId);case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].SORT_ZONE_VIEW:return _this2.renderSortZoneView(selectedCycle,selectedCycleId);case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].STATION_PAIR_VIEW:return _this2.renderStationPairView();case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].FLOOR_VIEW:return _this2.renderFloorView();case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].ROUTE_VIEW:return _this2.renderRouteView(_this2.state.routeCodePrefixes);case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].ZONE_VIEW:return _this2.renderZoneView(selectedCycle,selectedCycleId);case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].CART_LOCATION_VIEW:return _this2.renderCartLocationView();case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].FLOOR_LOCATION_VIEW:return _this2.renderFloorLocationView();case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].CART_VIEW:return _this2.renderCartView();case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].CLUSTER_VIEW:default:return _this2.renderClusterView(selectedCycle,selectedCycleId,selectedCPT,filterIdentifier,_this2.isCPTFilterEnabled());}};var navigationChanged=function navigationChanged(navigationIndex){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["v" /* navigationRemoved */])(navigationIndex));};function renderBreadCrumb(navigationOptions){if(navigationOptions.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box___default.a,{spacingInset:"small none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_breadcrumb_breadcrumb_group___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_breadcrumb___default.a,{onClick:function onClick(){return navigationChanged(0);}},"Stow"),navigationOptions.map(function(navigationOption,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_breadcrumb___default.a,{onClick:function onClick(){return navigationChanged(index+1);},key:navigationOption.key},navigationOption.key," ",getNavigationOptionValue(navigationOption));})));}}var getNavigationOptionValue=function getNavigationOptionValue(navigationOption){switch(_this2.props.capability){case __WEBPACK_IMPORTED_MODULE_20__enums__["e" /* Capability */].SSD:case __WEBPACK_IMPORTED_MODULE_20__enums__["e" /* Capability */].AR_NEXT_GEN:return navigationOption.displayValue;case __WEBPACK_IMPORTED_MODULE_20__enums__["e" /* Capability */].AMZL:return navigationOption.displayValue?navigationOption.displayValue:navigationOption.value;default:return navigationOption.value;}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default.a,{spacingInset:spacingInset_shorthand4},renderBreadCrumb(navigationOptions),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box___default.a,null,renderSubComponent()));}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps){return JSON.stringify(nextProps.navigationOptions)!==JSON.stringify(this.props.navigationOptions)||nextProps.selectedCycle!==this.props.selectedCycle||nextProps.selectedView!==this.props.selectedView;}},{key:"renderAisleView",value:function renderAisleView(selectedCycle,selectedCycleId){var _this3=this;this.fetchAisleData(this.state.nodeId,selectedCycle,this.getViewSubjects('Cluster'),selectedCycleId);this.timer=setInterval(function(){if(!document.hidden){_this3.fetchAisleData(_this3.state.nodeId,selectedCycle,_this3.getViewSubjects('Cluster'),selectedCycleId);}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Aisle__["a" /* default */],null);}},{key:"renderSortZoneView",value:function renderSortZoneView(selectedCycle,selectedCycleId){var _this4=this;this.fetchSortZoneData(this.state.nodeId,selectedCycle,this.getViewSubjects('Aisle'),selectedCycleId);this.timer=setInterval(function(){if(!document.hidden){_this4.fetchSortZoneData(_this4.state.nodeId,selectedCycle,_this4.getViewSubjects('Aisle'),selectedCycleId);}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SortZone__["a" /* default */],null);}},{key:"renderClusterView",value:function renderClusterView(selectedCycle,selectedCycleId,selectedCPT,filterIdentifier,isCPTFilterEnabled){var _this5=this;this.fetchClusterData(this.state.nodeId,selectedCycle,selectedCycleId,selectedCPT,filterIdentifier,isCPTFilterEnabled);this.timer=setInterval(function(){if(!document.hidden){_this5.fetchClusterData(_this5.state.nodeId,selectedCycle,selectedCycleId,selectedCPT,filterIdentifier,isCPTFilterEnabled);}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ClusterV2__["a" /* default */],null);}},{key:"renderFloorLocationView",value:function renderFloorLocationView(){var _this6=this;this.fetchFloorLocationData(this.state.nodeId);this.timer=setInterval(function(){if(!document.hidden){_this6.fetchFloorLocationData(_this6.state.nodeId);}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__sideline_FloorLocation__["a" /* default */],null);}},{key:"renderCartView",value:function renderCartView(){var _this7=this;this.fetchCartData.apply(this,[this.state.nodeId].concat(_toConsumableArray(this.getViewSubjects('Floor Location, Re-Induct Day'))));this.timer=setInterval(function(){if(!document.hidden){_this7.fetchCartData.apply(_this7,[_this7.state.nodeId].concat(_toConsumableArray(_this7.getViewSubjects('Floor Location, Re-Induct Day'))));}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__sideline_Cart__["a" /* default */],null);}},{key:"renderZoneView",value:function renderZoneView(selectedCycle,selectedCycleId){var _this8=this;this.fetchZoneData(this.state.nodeId,selectedCycle,selectedCycleId);this.timer=setInterval(function(){if(!document.hidden){_this8.fetchZoneData(_this8.state.nodeId,selectedCycle,selectedCycleId);}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__Zone__["a" /* default */],null);}},{key:"renderRouteView",value:function renderRouteView(routeCodePrefixes){var _this9=this;this.fetchRouteData(this.state.nodeId,this.props.capability);this.timer=setInterval(function(){if(!document.hidden){_this9.fetchRouteData(_this9.state.nodeId,_this9.props.capability);}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Route__["a" /* default */],{routeCodePrefixesFromUrl:routeCodePrefixes});}},{key:"renderFloorView",value:function renderFloorView(){var _this10=this;this.fetchFloorData();this.timer=setInterval(function(){if(!document.hidden){_this10.fetchFloorData();}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__floor_Floor__["a" /* default */],{nodeId:this.state.nodeId});}},{key:"renderCartLocationView",value:function renderCartLocationView(){var _this11=this;this.fetchCartLocationData();this.timer=setInterval(function(){if(!document.hidden){_this11.fetchCartLocationData();}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__CartLocation__["a" /* default */],{nodeId:this.state.nodeId});}},{key:"renderStationPairView",value:function renderStationPairView(){var _this12=this;this.fetchStationPairData();this.timer=setInterval(function(){if(!document.hidden){_this12.fetchStationPairData();}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__station_pair_StationPair__["a" /* default */],null);}},{key:"fetchClusterData",value:function fetchClusterData(nodeId,cycle,cycleId,selectedCPT,filterIdentifier,isCPTFilterEnabled){if(cycle&&cycleId&&this.props.featureStatus||selectedCPT&&this.props.featureStatus){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_ClusterActionsV2__["o" /* getMinOfWorkMetricsForCluster */])(nodeId,this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY],[cycle],[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_ClusterActionsV2__["t" /* getStowPackageMetricsForCluster */])(this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].ADTA_VISIBILITY],this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY],nodeId,[cycle],[cycleId],[selectedCPT],filterIdentifier,isCPTFilterEnabled));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_ClusterActionsV2__["r" /* getStowBinMetricsForCluster */])(nodeId,[cycle],[cycleId],[selectedCPT],filterIdentifier,isCPTFilterEnabled));this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].CART_VISIBILITY]&&this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_34__actions_ClusterActions__["p" /* getStowCartMetricsForCluster */])(nodeId,[cycle],[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_ClusterActionsV2__["n" /* getInductPackageMetricsForCluster */])(nodeId,[cycle],[selectedCPT],filterIdentifier,isCPTFilterEnabled));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_ClusterActionsV2__["q" /* getStowAssociateMetricsForCluster */])(nodeId,[cycle],[selectedCPT],filterIdentifier,isCPTFilterEnabled));}}},{key:"fetchFloorLocationData",value:function fetchFloorLocationData(nodeId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_30__actions_FloorLocationActions__["h" /* getStowPackageMetricsForFloorLocation */])(nodeId,this.props.featureStatus));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_30__actions_FloorLocationActions__["g" /* getStowFloorMetricsForFloorLocation */])(nodeId,this.props.featureStatus));}},{key:"fetchCartData",value:function fetchCartData(nodeId,floorLocationAndReInductDay){this.props.dispatch(__WEBPACK_IMPORTED_MODULE_32__actions_CartActions__["d" /* getStowPackageMetricsForCart */].apply(undefined,[nodeId,this.props.featureStatus].concat(_toConsumableArray(floorLocationAndReInductDay))));}},{key:"fetchRouteData",value:function fetchRouteData(nodeId,capability){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_RouteActions__["g" /* getMetricsForRoute */])(nodeId,capability));}},{key:"fetchAisleData",value:function fetchAisleData(nodeId,cycle,clusters,cycleId){if(cycle&&cycleId&&this.props.featureStatus){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_AisleActions__["r" /* getStowPackageMetricsForAisle */])(this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].ADTA_VISIBILITY],this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY],nodeId,[cycle],clusters,[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_AisleActions__["o" /* getStowBinMetricsForAisle */])(nodeId,[cycle],clusters,[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_AisleActions__["n" /* getStowBagMetricsForAisle */])(nodeId,[cycle],clusters,[cycleId]));this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].CART_VISIBILITY]&&this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_AisleActions__["q" /* getStowCartMetricsForAisle */])(nodeId,[cycle],clusters,[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_AisleActions__["k" /* getInductPackageMetricsForAisle */])(nodeId,[cycle],clusters));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_AisleActions__["m" /* getStowAssociateMetricsForAisle */])(nodeId,[cycle],clusters));}}},{key:"fetchSortZoneData",value:function fetchSortZoneData(nodeId,cycle,aisles,cycleId){if(cycle&&cycleId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_SortZoneActions__["o" /* getStowPackageMetricsForSortZone */])(this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY],nodeId,[cycle],aisles,[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_SortZoneActions__["n" /* getStowBagMetricsForSortZone */])(nodeId,[cycle],aisles,[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_SortZoneActions__["l" /* getInductPackageMetricsForSortZone */])(nodeId,[cycle],aisles));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_SortZoneActions__["k" /* fetchOvUsageForSortZone */])(nodeId,[cycle],aisles));}}},{key:"fetchStationPairData",value:function fetchStationPairData(){var nodeId=this.state.nodeId;this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_StationPairActions__["m" /* getInductPackageMetricsForStationPair */])(nodeId));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_StationPairActions__["n" /* getPickPackageMetricsForStationPair */])(nodeId));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_StationPairActions__["o" /* getStowAssociateMetricsForStationPair */])(nodeId));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_StationPairActions__["p" /* getStowFloorMetricsForStationPair */])(nodeId));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_StationPairActions__["q" /* getStowPackageMetricsForStationPair */])(nodeId));}},{key:"fetchFloorData",value:function fetchFloorData(){var nodeId=this.state.nodeId;var stationPairs=this.getViewSubjects('Station');this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_FloorActions__["h" /* getInductPackageMetricsForFloor */])(nodeId,stationPairs));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_FloorActions__["i" /* getPickPackageMetricsForFloor */])(nodeId,stationPairs));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_FloorActions__["l" /* getStowPackageMetricsForFloor */])(nodeId,stationPairs));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_FloorActions__["k" /* getStowFloorDataForFloor */])(nodeId,stationPairs));}},{key:"fetchCartLocationData",value:function fetchCartLocationData(){var nodeId=this.state.nodeId;var zone=this.getViewSubjects('Zone');this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__actions_CartLocationActions__["h" /* getStowPackageMetricsForCartLocation */])(nodeId,zone));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__actions_CartLocationActions__["g" /* getStowFloorDataForCartLocation */])(nodeId,zone));}},{key:"fetchZoneData",value:function fetchZoneData(nodeId,cycle,cycleId){if(cycle&&cycleId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_ZoneActions__["h" /* getStowPackageMetricsForZone */])(nodeId,[cycle],[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_ZoneActions__["g" /* getStowAssociateMetricsForZone */])(nodeId,[cycle]));}}},{key:"componentDidMount",value:function componentDidMount(){var _this13=this;Object(__WEBPACK_IMPORTED_MODULE_23__handler_ParentDataHandler__["e" /* getFeaturesFromParent */])([__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].ADTA_VISIBILITY,__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY,__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].CART_VISIBILITY]).then(function(featureStatusResponse){_this13.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__actions_ConfigActions__["b" /* fetchFeatureStatusCallSuccess */])(featureStatusResponse.data));});Object(__WEBPACK_IMPORTED_MODULE_23__handler_ParentDataHandler__["g" /* getNodeCapabilityFromParent */])().then(function(capabilityResponse){var capability=JSON.parse(capabilityResponse.capability);Object(__WEBPACK_IMPORTED_MODULE_23__handler_ParentDataHandler__["e" /* getFeaturesFromParent */])([__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].IS_CPT_FILTER_ENABLED]).then(function(featureStatusResponse){_this13.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__actions_ConfigActions__["b" /* fetchFeatureStatusCallSuccess */])(featureStatusResponse.data));});if(_this13.props.featureStatus&&_this13.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].IS_CPT_FILTER_ENABLED]&&__WEBPACK_IMPORTED_MODULE_20__enums__["e" /* Capability */].AR_NEXT_GEN!==capability){_this13.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["r" /* fetchCPTList */])());}else if(__WEBPACK_IMPORTED_MODULE_20__enums__["e" /* Capability */].AR_NEXT_GEN!==capability){_this13.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["t" /* fetchCycles */])());}_this13.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["s" /* fetchCapabilityCallSuccess */])(capabilityResponse));});}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.timer);this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["v" /* navigationRemoved */])(0));}}]);return StowBreakdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// Adapter to convert class component to functional component.
function classToFunctionAdapter(CustomComponent){return function WrappedComponent(props){var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_33__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),spacingInset_shorthand4=_useDeviceLayout.spacingInset_shorthand4;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomComponent,Object.assign({},props,{spacingInset_shorthand4:spacingInset_shorthand4}));};}var mapStateToProps=function mapStateToProps(state){return{capability:state.optionsReducerV2.capability,navigationOptions:state.optionsReducerV2.navigationOptions,selectedCycle:state.optionsReducerV2.options.cycle,selectedCPT:state.optionsReducerV2.options.CPTId,filterIdentifier:state.optionsReducerV2.filterIdentifier,selectedView:state.optionsReducerV2.heatMapView,selectedCycleId:state.optionsReducerV2.options.cycleId,featureStatus:state.configReducer.featureStatus,isInitialView:state.optionsReducerV2.isInitialView};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(classToFunctionAdapter(StowBreakdown))));

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ErrorPage__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__handler_LocaleHandler__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_TableCellUtil__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__RefreshTimer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Aisle=function(_Component){_inherits(Aisle,_Component);function Aisle(props){_classCallCheck(this,Aisle);var _this=_possibleConstructorReturn(this,(Aisle.__proto__||Object.getPrototypeOf(Aisle)).call(this,props));_this.getCombinedMetricsMap=function(aisle){var _this$props=_this.props,stowPackageMetricsMap=_this$props.stowPackageMetricsMap,inductPackageMetricsMap=_this$props.inductPackageMetricsMap,stowAssociateMetricsMap=_this$props.stowAssociateMetricsMap,stowBinMetricsMap=_this$props.stowBinMetricsMap,stowBagMetricsMap=_this$props.stowBagMetricsMap,stowCartMetricsMap=_this$props.stowCartMetricsMap;var defaultMetricValue="-";return{aisle:aisle,plannedBags:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(stowBagMetricsMap,aisle,"plannedBags"),usedBags:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(stowBagMetricsMap,aisle,"usedBags"),binsMissingBag:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(stowBinMetricsMap,aisle,"binsMissingBag"),plannedCarts:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(stowCartMetricsMap,aisle,"plannedCarts"),usedCarts:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(stowCartMetricsMap,aisle,"usedCarts"),missingCarts:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(stowCartMetricsMap,aisle,"missingCarts"),plannedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[aisle].plannedPackages;},defaultMetricValue),receivedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return inductPackageMetricsMap[aisle].receivedPackages;},defaultMetricValue),currentInductedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[aisle].currentInductedPackages;},defaultMetricValue),stowedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[aisle].stowedPackages;},defaultMetricValue),stowRate:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[aisle].stowRate;},defaultMetricValue),scanCompliance:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[aisle].scanCompliance;},defaultMetricValue),currentStowBufferedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[aisle].currentStowBufferedPackages;},defaultMetricValue),fsaf:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[aisle].fsaf;},defaultMetricValue),activeStowers:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowAssociateMetricsMap[aisle].activeStowers;},defaultMetricValue)};};_this.aisleRowClicked=function(aisle){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_OptionsActions__["q" /* navigationAdded */])({key:'Aisle',value:aisle}));};_this.getADTATableCell=function(value,aisle,state){return _this.isADTAVisibilityEnabled()&&Object(__WEBPACK_IMPORTED_MODULE_15__utils_TableCellUtil__["a" /* getTableCellCount */])(_this.renderPackageCount(value,aisle,state));};_this.renderPackageCount=function(value,aisle,state){return value!==0&&value!=='-'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_link___default.a,{href:_this.getPackageListURL(state,aisle),type:"secondary"}," ",value," "):value;};_this.getPackageListURL=function(state,aisle){var _this$props2=_this.props,navigationOptions=_this$props2.navigationOptions,options=_this$props2.options;var params={PACKAGE_STATUS:state,CLUSTER:navigationOptions[0].value,AISLE:aisle};if(options.cycle){params["CYCLE"]=options.cycle;}return"#packageList/?"+Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["e" /* formQueryParams */])(params);};_this.isADTAVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_17__constants__["j" /* FEATURES */].ADTA_VISIBILITY];};_this.isCartVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_17__constants__["j" /* FEATURES */].CART_VISIBILITY];};_this.isDRSStowVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_17__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY];};_this.state={sortColumn:"aisle",sortDirection:"ascending"};return _this;}_createClass(Aisle,[{key:"render",value:function render(){var _this2=this;var _props=this.props,loading=_props.loading,error=_props.error,stowPackageMetricsMap=_props.stowPackageMetricsMap,inductPackageMetricsMap=_props.inductPackageMetricsMap,stowAssociateMetricsMap=_props.stowAssociateMetricsMap,stowBinMetricsMap=_props.stowBinMetricsMap,stowBagMetricsMap=_props.stowBagMetricsMap,stowCartMetricsMap=_props.stowCartMetricsMap;if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__utils_ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});}var allAisles=[].concat(_toConsumableArray(Object.keys(stowPackageMetricsMap)),_toConsumableArray(Object.keys(inductPackageMetricsMap)),_toConsumableArray(Object.keys(stowAssociateMetricsMap)),_toConsumableArray(Object.keys(stowBinMetricsMap)),_toConsumableArray(Object.keys(stowBagMetricsMap)),_toConsumableArray(Object.keys(stowCartMetricsMap)));var distinctAisles=[].concat(_toConsumableArray(new Set(allAisles)));if(loading&&!distinctAisles.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,{height:"400px",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader___default.a,null));}var filteredAisles=Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["k" /* getFilteredLocations */])(distinctAisles,stowPackageMetricsMap,this.isDRSStowVisibilityEnabled());var onSort=function onSort(sortDetails){_this2.setState({sortColumn:sortDetails.sortColumn,sortDirection:sortDetails.sortDirection});};function customCompare(a,b){return Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["b" /* convertToString */])(a).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["b" /* convertToString */])(b),Object(__WEBPACK_IMPORTED_MODULE_14__handler_LocaleHandler__["b" /* getLocale */])(),{numeric:true});}var sortColumn=this.state.sortColumn;var direction=this.state.sortDirection;filteredAisles.sort(function(a1,a2){var a1CombinedMetricsMap=_this2.getCombinedMetricsMap(a1);var a2CombinedMetricsMap=_this2.getCombinedMetricsMap(a2);if(direction==="ascending"){return customCompare(a1CombinedMetricsMap[sortColumn],a2CombinedMetricsMap[sortColumn]);}else{return customCompare(a2CombinedMetricsMap[sortColumn],a1CombinedMetricsMap[sortColumn]);}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__RefreshTimer__["a" /* default */],{deps:[stowBinMetricsMap]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table___default.a,{headerRows:2,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true,sortColumn:this.state.sortColumn,sortDirection:this.state.sortDirection,onSort:onSort,"data-cy":"aisleTable"},this.renderHeadings(),this.renderSubHeadings(),filteredAisles.map(function(aisle){return _this2.renderAisleRow(aisle);})));}},{key:"renderHeadings",value:function renderHeadings(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.packages",defaultMessage:"Packages"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),this.isADTAVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.carts",defaultMessage:"Carts"})),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.bags",defaultMessage:"Bags"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.performance",defaultMessage:"Performance"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.stowers",defaultMessage:"Stowers"})));}},{key:"renderCartHeading",value:function renderCartHeading(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,null);}},{key:"renderSubHeadings",value:function renderSubHeadings(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"aisle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.aisle",defaultMessage:"Aisle"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"plannedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.containerPlanned",defaultMessage:"C. Planned"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"receivedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.arrived",defaultMessage:"Arrived"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"currentInductedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.inducted",defaultMessage:"Inducted"})),this.isADTAVisibilityEnabled()&&Object(__WEBPACK_IMPORTED_MODULE_15__utils_TableCellUtil__["b" /* getTableCellHeader */])("currentStowBufferedPackages"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.stowed",defaultMessage:"Stowed"})),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"plannedCarts",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.planned_carts",defaultMessage:"Planned"})),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"usedCarts",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.used_carts",defaultMessage:"Used"})),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"missingCarts",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.missing_carts",defaultMessage:"Missing"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"plannedBags",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.planned",defaultMessage:"Planned"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"usedBags",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.used",defaultMessage:"Used"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"binsMissingBag",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.missing",defaultMessage:"Missing"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowRate",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.stow_rate",defaultMessage:"Stow rate"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"scanCompliance",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.scan_complaince",defaultMessage:"Scan comp."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"fsaf",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.fsaf",defaultMessage:"FSAF"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"activeStowers",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.active",defaultMessage:"Active"})));}},{key:"renderAisleRow",value:function renderAisleRow(aisle){var _this3=this;var combinedMetricsMap=this.getCombinedMetricsMap(aisle);var stowBufferedCell=this.getADTATableCell(combinedMetricsMap.currentStowBufferedPackages,aisle,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_STOW_BUFFERED);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,key:aisle,onClick:function onClick(){return _this3.aisleRowClicked(aisle);},"data-cy":"aisleDataRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,aisle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.plannedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.receivedPackages,aisle,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_RECEIVED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.currentInductedPackages,aisle,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_INDUCTED)),stowBufferedCell,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.stowedPackages,aisle,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].STOWED)),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.plannedCarts),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.usedCarts),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.missingCarts)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.plannedBags),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.usedBags),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.binsMissingBag),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.stowRate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.scanCompliance,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.fsaf),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.activeStowers));}}]);return Aisle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{loading:state.aisleReducer.loading,error:state.aisleReducer.error,navigationOptions:state.optionsReducer.navigationOptions,options:state.optionsReducer.options,stowPackageMetricsMap:state.aisleReducer.stowPackageMetricsMap,stowBinMetricsMap:state.aisleReducer.stowBinMetricsMap,stowBagMetricsMap:state.aisleReducer.stowBagMetricsMap,stowCartMetricsMap:state.aisleReducer.stowCartMetricsMap,inductPackageMetricsMap:state.aisleReducer.inductPackageMetricsMap,stowAssociateMetricsMap:state.aisleReducer.stowAssociateMetricsMap,featureStatus:state.configReducer.featureStatus};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Aisle)));

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var buildURL = __webpack_require__(576);
var parseHeaders = __webpack_require__(577);
var transformData = __webpack_require__(251);
var isURLSameOrigin = __webpack_require__(578);
var btoa = window.btoa || __webpack_require__(579);

module.exports = function xhrAdapter(resolve, reject, config) {
  var requestData = config.data;
  var requestHeaders = config.headers;

  if (utils.isFormData(requestData)) {
    delete requestHeaders['Content-Type']; // Let the browser set it
  }

  var request = new XMLHttpRequest();

  // For IE 8/9 CORS support
  // Only supports POST and GET calls and doesn't returns the response headers.
  if (window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
    request = new window.XDomainRequest();
  }

  // HTTP basic authentication
  if (config.auth) {
    var username = config.auth.username || '';
    var password = config.auth.password || '';
    requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
  }

  request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

  // Set the request timeout in MS
  request.timeout = config.timeout;

  // Listen for ready state
  request.onload = function handleLoad() {
    if (!request) {
      return;
    }
    // Prepare the response
    var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
    var responseData = ['text', ''].indexOf(config.responseType || '') !== -1 ? request.responseText : request.response;
    var response = {
      data: transformData(
        responseData,
        responseHeaders,
        config.transformResponse
      ),
      // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
      status: request.status === 1223 ? 204 : request.status,
      statusText: request.status === 1223 ? 'No Content' : request.statusText,
      headers: responseHeaders,
      config: config
    };

    // Resolve or reject the Promise based on the status
    ((response.status >= 200 && response.status < 300) ||
     (!('status' in request) && response.responseText) ?
      resolve :
      reject)(response);

    // Clean up request
    request = null;
  };

  // Handle low level network errors
  request.onerror = function handleError() {
    // Real errors are hidden from us by the browser
    // onerror should only fire if it's a network error
    reject(new Error('Network Error'));

    // Clean up request
    request = null;
  };

  // Add xsrf header
  // This is only done if running in a standard browser environment.
  // Specifically not if we're in a web worker, or react-native.
  if (utils.isStandardBrowserEnv()) {
    var cookies = __webpack_require__(580);

    // Add xsrf header
    var xsrfValue = config.withCredentials || isURLSameOrigin(config.url) ?
        cookies.read(config.xsrfCookieName) :
        undefined;

    if (xsrfValue) {
      requestHeaders[config.xsrfHeaderName] = xsrfValue;
    }
  }

  // Add headers to the request
  if ('setRequestHeader' in request) {
    utils.forEach(requestHeaders, function setRequestHeader(val, key) {
      if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
        // Remove Content-Type if data is undefined
        delete requestHeaders[key];
      } else {
        // Otherwise add header to the request
        request.setRequestHeader(key, val);
      }
    });
  }

  // Add withCredentials to request if needed
  if (config.withCredentials) {
    request.withCredentials = true;
  }

  // Add responseType to request if needed
  if (config.responseType) {
    try {
      request.responseType = config.responseType;
    } catch (e) {
      if (request.responseType !== 'json') {
        throw e;
      }
    }
  }

  if (utils.isArrayBuffer(requestData)) {
    requestData = new DataView(requestData);
  }

  // Send the request
  request.send(requestData);
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_tag__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_tag__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CartStatus=function(_Component){_inherits(CartStatus,_Component);function CartStatus(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CartStatus);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CartStatus.__proto__||Object.getPrototypeOf(CartStatus)).call.apply(_ref,[this].concat(args))),_this),_this.CART_STATUS_TO_TAG_TYPE_MAP={STOW_COMPLETE:"warning",STOW_NOT_STARTED:"neutral",STOW_IN_PROGRESS:"neutral",MISSING:"error"},_this.CART_STATUS_TO_DISPLAY_NAME={STOW_COMPLETE:"Cart full",STOW_NOT_STARTED:"Available",STOW_IN_PROGRESS:"In progress",MISSING:"Cart missing"},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CartStatus,[{key:"render",value:function render(){var status=this.props.status;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_tag___default.a,{type:this.CART_STATUS_TO_TAG_TYPE_MAP[status]},this.CART_STATUS_TO_DISPLAY_NAME[status]);}}]);return CartStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CartStatus);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * This class is currently used by floor view to show the details for an OV cart
 */var OvCartTableCell=function(_Component){_inherits(OvCartTableCell,_Component);function OvCartTableCell(){_classCallCheck(this,OvCartTableCell);return _possibleConstructorReturn(this,(OvCartTableCell.__proto__||Object.getPrototypeOf(OvCartTableCell)).apply(this,arguments));}_createClass(OvCartTableCell,[{key:"render",value:function render(){var cart=this.props.cart;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table_table_cell___default.a,{columnSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"ovCart.ovCart",defaultMessage:"OV Cart"})," ",cart.label," (",cart.childCount,") packages");}}]);return OvCartTableCell;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (OvCartTableCell);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ErrorPage__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_SortZoneActions__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__handler_LocaleHandler__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RefreshTimer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SortZone=function(_Component){_inherits(SortZone,_Component);function SortZone(props){_classCallCheck(this,SortZone);var _this=_possibleConstructorReturn(this,(SortZone.__proto__||Object.getPrototypeOf(SortZone)).call(this,props));_this.getCombinedMetricsMap=function(sortZone){var _this$props=_this.props,stowPackageMetricsMap=_this$props.stowPackageMetricsMap,inductPackageMetricsMap=_this$props.inductPackageMetricsMap,ovUsageMap=_this$props.ovUsageMap,stowBagMetricsMap=_this$props.stowBagMetricsMap;var defaultMetricValue="-";return{sortZone:sortZone,plannedBags:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["o" /* getOrDefaultValueForCell */])(stowBagMetricsMap,sortZone,"plannedBags"),closedBags:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["o" /* getOrDefaultValueForCell */])(stowBagMetricsMap,sortZone,"closedBags"),openBags:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["o" /* getOrDefaultValueForCell */])(stowBagMetricsMap,sortZone,"openBags"),plannedPackages:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[sortZone].plannedPackages;},defaultMetricValue),receivedPackages:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return inductPackageMetricsMap[sortZone].receivedPackages;},defaultMetricValue),inductedPackages:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[sortZone].currentInductedPackages;},defaultMetricValue),stowedPackages:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[sortZone].stowedPackages;},defaultMetricValue),ovUsage:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return ovUsageMap[sortZone].ovUsage+'%';},defaultMetricValue)};};_this.clickSortZoneRow=function(sortZone){_this.setState(function(oldState){if(oldState.expandedSortZones.indexOf(sortZone)!==-1){return{expandedSortZones:oldState.expandedSortZones.filter(function(expandedSortZone){return expandedSortZone!==sortZone;})};}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_SortZoneActions__["j" /* fetchBagsDataForSortZone */])(Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["m" /* getNodeId */])(),[_this.props.options.cycle],sortZone));return{expandedSortZones:oldState.expandedSortZones.concat(sortZone)};}});};_this.isSortZoneExpanded=function(sortZone){return _this.state.expandedSortZones.indexOf(sortZone)!==-1;};_this.renderPackageCount=function(value,sortZone,state){return value!==0&&value!=='-'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_link___default.a,{href:_this.getPackageListURL(state,sortZone),type:"secondary"}," ",value," "):value;};_this.getPackageListURL=function(state,sortZone){var _this$props2=_this.props,navigationOptions=_this$props2.navigationOptions,options=_this$props2.options;var params={PACKAGE_STATUS:state,BIN:sortZone,AISLE:navigationOptions[1].value};if(options.cycle){params["CYCLE"]=options.cycle;}return"#packageList/?"+Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["e" /* formQueryParams */])(params);};_this.isDRSStowVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_16__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY];};_this.state={expandedSortZones:[],sortColumn:"sortZone",sortDirection:"ascending"};return _this;}_createClass(SortZone,[{key:"render",value:function render(){var _this2=this;var _props=this.props,loading=_props.loading,error=_props.error,stowPackageMetricsMap=_props.stowPackageMetricsMap,inductPackageMetricsMap=_props.inductPackageMetricsMap,stowBagMetricsMap=_props.stowBagMetricsMap,ovUsageMap=_props.ovUsageMap;if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utils_ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});}var sortZones=[].concat(_toConsumableArray(Object.keys(stowPackageMetricsMap)),_toConsumableArray(Object.keys(stowBagMetricsMap)),_toConsumableArray(Object.keys(inductPackageMetricsMap)),_toConsumableArray(Object.keys(ovUsageMap)));var distinctSortZones=[].concat(_toConsumableArray(new Set(sortZones)));if(loading&&!distinctSortZones.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default.a,{height:"400px",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader___default.a,null));}var filteredZones=Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["k" /* getFilteredLocations */])(distinctSortZones,stowPackageMetricsMap,this.isDRSStowVisibilityEnabled());var onSort=function onSort(sortDetails){_this2.setState({sortColumn:sortDetails.sortColumn,sortDirection:sortDetails.sortDirection});};function customCompare(a,b){return Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["b" /* convertToString */])(a).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["b" /* convertToString */])(b),Object(__WEBPACK_IMPORTED_MODULE_14__handler_LocaleHandler__["b" /* getLocale */])(),{numeric:true});}var sortColumn=this.state.sortColumn;var direction=this.state.sortDirection;filteredZones.sort(function(s1,s2){var s1CombinedMetricsMap=_this2.getCombinedMetricsMap(s1);var s2CombinedMetricsMap=_this2.getCombinedMetricsMap(s2);if(direction==="ascending"){return customCompare(s1CombinedMetricsMap[sortColumn],s2CombinedMetricsMap[sortColumn]);}else{return customCompare(s2CombinedMetricsMap[sortColumn],s1CombinedMetricsMap[sortColumn]);}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__RefreshTimer__["a" /* default */],{deps:[stowPackageMetricsMap]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table___default.a,{headerRows:2,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true,sortColumn:this.state.sortColumn,sortDirection:this.state.sortDirection,onSort:onSort,"data-cy":"zoneTable"},this.renderHeadings(),this.renderSubHeadings(),filteredZones.map(function(sortZone){return _this2.renderSortZoneRow(sortZone);})));}},{key:"renderHeadings",value:function renderHeadings(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.bags",defaultMessage:"Bags"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.ov_capacity",defaultMessage:"OV Capacity"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.packages",defaultMessage:"Packages"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null));}},{key:"renderSubHeadings",value:function renderSubHeadings(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"sortZone"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.zone",defaultMessage:"Zone"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"plannedBags",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.planned",defaultMessage:"Planned"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"closedBags",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.closed",defaultMessage:"Closed"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"openBags",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.open",defaultMessage:"Open"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"ovUsage",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.used",defaultMessage:"Used"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"plannedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.container_planned",defaultMessage:"C. Planned"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"receivedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.arrived",defaultMessage:"Arrived"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"inductedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.inducted",defaultMessage:"Inducted"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.stowed",defaultMessage:"Stowed"})));}},{key:"renderSortZoneRow",value:function renderSortZoneRow(sortZone){var _this3=this;var bagsData=this.props.bagsData;var combinedMetricsMap=this.getCombinedMetricsMap(sortZone);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,{key:sortZone,open:this.isSortZoneExpanded(sortZone),onClick:function onClick(){return _this3.clickSortZoneRow(sortZone);},"data-cy":"zoneDataRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,sortZone),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.plannedBags),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.closedBags),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.openBags),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.ovUsage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.plannedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.receivedPackages,sortZone,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_RECEIVED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.inductedPackages,sortZone,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_INDUCTED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.stowedPackages,sortZone,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].STOWED)),bagsData&&bagsData[sortZone]&&bagsData[sortZone].length?bagsData[sortZone].map(function(bag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{columnSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.bag",defaultMessage:"Bag"})," ",bag.bagLabel," (",bag.state,"): ",bag.childCount," packages"));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,null));}}]);return SortZone;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{loading:state.sortZoneReducer.loading,error:state.sortZoneReducer.error,navigationOptions:state.optionsReducer.navigationOptions,options:state.optionsReducer.options,stowPackageMetricsMap:state.sortZoneReducer.stowPackageMetricsMap,stowBagMetricsMap:state.sortZoneReducer.stowBagMetricsMap,inductPackageMetricsMap:state.sortZoneReducer.inductPackageMetricsMap,bagsData:state.sortZoneReducer.bagsData,ovUsageMap:state.sortZoneReducer.stowOvUsageMap,featureStatus:state.configReducer.featureStatus};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(SortZone)));

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = __webpack_require__(0);

var _default = /*#__PURE__*/(0, _react.createContext)({});

exports["default"] = _default;

/***/ }),
/* 256 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    inputSpacingVertical: 4,
    inputSpacingInsetVerticalDefault: 0,
    inputSpacingInsetVerticalAuto: 12,
    inputSpacingInsetHorizontal: 12,
    inputHeightSmall: 32,
    inputHeightMedium: 40,
    inputHeightLarge: 48,
    inputHeightXlarge: 60,
    inputLineHeightDefault: "20px",
    inputLineHeightAuto: "24px",
    inputForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    inputForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    inputPlaceholderColorDefault: tokens.themeForegroundSecondaryDefault,
    inputPlaceholderColorDisabled: tokens.themeForegroundPrimaryDisabled,
    inputBorderWidth: 1,
    inputBorderRadius: 4,
    inputBorderColorDefault: tokens.themeBorderPrimaryDefault,
    inputBorderColorDisabled: tokens.themeBorderPrimaryDisabled,
    inputFocusRingBorderWidth: 1,
    inputFocusRingBorderRadius: 4,
    inputBackgroundColorDefault: tokens.themeBackgroundPrimaryDefault,
    inputBackgroundColorDisabled: tokens.themeBackgroundPrimaryDisabled,
    inputFontSizeDefault: 16,
    inputFontSizeSmall: 14,
    inputEndcapBorderWidth: 1,
    inputEndcapBorderRadius: 4,
    inputEndcapBackgroundColor: tokens.themeBackgroundTertiaryDefault,
    inputLabelFontSizeDefault: 16,
    inputLabelFontSizeFloated: 14,
    inputLabelColorDefault: tokens.themeForegroundPrimaryDefault,
    inputLabelColorFocus: tokens.themeForegroundPrimaryFocus,
    inputLabelColorDisabled: tokens.themeForegroundPrimaryDisabled,
    inputLabelFloatDistanceXlarge: 12,
    inputLabelFloatDistanceAuto: 4,
    inputLabelMotionDuration: "150ms",
    inputLabelMotionFunction: "ease",
    inputSupportTextFontSize: 14,
    inputSupportTextColor: tokens.themeForegroundSecondaryDefault,
    inputSupportTextInset: 2
  }
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _inputBox = _interopRequireDefault(__webpack_require__(598));

var _default = _inputBox["default"];
exports["default"] = _default;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _supportTextWrapper = _interopRequireDefault(__webpack_require__(600));

var _default = _supportTextWrapper["default"];
exports["default"] = _default;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var inputReset = function inputReset(_ref) {
  var textColor = _ref.textColor,
      placeholderColor = _ref.placeholderColor,
      empty = _ref.empty;
  return {
    display: "block",
    backgroundColor: "transparent",
    border: "none",
    padding: 0,
    width: "100%",
    color: textColor,
    WebkitTextFillColor: empty ? placeholderColor : textColor,
    fontFamily: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
    lineHeight: "inherit",
    outline: "none",
    // Base built-in style resets
    WebkitAppearance: "none",
    MozAppearance: "textfield",
    // Remove the clear button from search inputs
    "::-ms-clear": {
      display: "none"
    },
    "::-ms-reveal": {
      display: "none"
    },
    "::-webkit-search-decoration": {
      display: "none"
    },
    "::-webkit-search-cancel-button": {
      display: "none"
    },
    "::-webkit-search-results-button": {
      display: "none"
    },
    "::-webkit-search-results-decoration ": {
      display: "none"
    },
    // Remove the built-in error outline
    ":invalid": {
      boxShadow: "none"
    },
    ":-moz-submit-invalid": {
      boxShadow: "none"
    },
    ":-moz-ui-invalid": {
      boxShadow: "none"
    },
    // Remove the numeric input up/down buttons in webkit
    "::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: "0"
    },
    "::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: "0"
    },
    // Set the placeholder colors
    "::-moz-placeholder": {
      opacity: "1",
      color: placeholderColor
    },
    ":-moz-placeholder": {
      opacity: "1",
      color: placeholderColor
    },
    "::-ms-input-placeholder": {
      opacity: "1",
      color: placeholderColor
    },
    ":-ms-input-placeholder": {
      opacity: "1",
      color: placeholderColor
    },
    "::-webkit-input-placeholder": {
      opacity: "1",
      color: placeholderColor
    },
    "::placeholder": {
      opacity: "1",
      color: placeholderColor
    }
  };
};

var _default = inputReset;
exports["default"] = _default;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/** Returns a string value of IDs for the support text used by
 * form field components with a SupportTextWrapper. To be used
 * in an aria-describedby prop to ensure that helper text,
 * constraint text, and error messages are read in the correct
 * order by screen readers.
 *
 * eg: `myinput-constraint-text myinput-helper-text myinput-error-message`
 *
 * @returns {string}
 */
var getSupportTextAriaDescribedby = function getSupportTextAriaDescribedby(_ref) {
  var id = _ref.id,
      hasHelperText = _ref.hasHelperText,
      hasConstraintText = _ref.hasConstraintText,
      hasErrorMessage = _ref.hasErrorMessage,
      errorMessageFirst = _ref.errorMessageFirst;
  var helperText = hasHelperText ? "".concat(id, "-helper-text") : null;
  var constraintText = hasConstraintText ? "".concat(id, "-constraint-text") : null;
  var errorMessage = hasErrorMessage ? "".concat(id, "-error-message") : null;
  return errorMessageFirst ? [errorMessage, helperText, constraintText].filter(Boolean).join(" ") : [helperText, errorMessage, constraintText].filter(Boolean).join(" ");
};

var _default = getSupportTextAriaDescribedby;
exports["default"] = _default;

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFormattedDate; });
/* unused harmony export dateOrdinal */
/**
 * Converts ISO date string to human-readable string.
 * @param dateString ISO Date Time string of the format 13-07-2022T01:00:00
 * @returns {string} date in the format '13th Jul' if parseable else '-'
 */var getFormattedDate=function getFormattedDate(dateString,isReInductDatePlusOneFixEnabled){var date=new Date(dateString);if(isReInductDatePlusOneFixEnabled)date.setDate(date.getDate()+1);if(!dateString||!(date instanceof Date)||isNaN(date))return'-';return''+date.getDate()+dateOrdinal(date.getDate())+' '+date.toLocaleString('default',{month:'short'});};/**
 * Provide ordinal for date
 * @see https://stackoverflow.com/a/15397495
 * @param date The date of month
 * @returns {string} The ordinal for the date like, st, nd, rd, th
 */var dateOrdinal=function dateOrdinal(date){var dString=String(date);var last=+dString.slice(-2);if(last>3&&last<21)return'th';switch(last%10){case 1:return"st";case 2:return"nd";case 3:return"rd";default:return"th";}};

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_ALLOCATION_DATA_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RENDER_ALLOCATION_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_ALLOCATION_DATA_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getGridAllocationDataForNode; });
/* unused harmony export fetchAllocationDataStart */
/* unused harmony export fetchAllocationDataFailure */
/* unused harmony export renderAllocationData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_GridAllocationResource__ = __webpack_require__(602);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var FETCH_ALLOCATION_DATA_START="FETCH_ALLOCATION_DATA_START";var RENDER_ALLOCATION_DATA="RENDER_ALLOCATION_DATA";var FETCH_ALLOCATION_DATA_FAILURE="FETCH_ALLOCATION_DATA_FAILURE";/**
 * Fetch the grid allocation data from backend
 *
 * @param nodeId identifier of the node
 * @returns {(function(*): Promise<void>)|*}
 */var getGridAllocationDataForNode=function getGridAllocationDataForNode(nodeId){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var allocationData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(fetchAllocationDataStart());_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_GridAllocationResource__["a" /* getSortGridAllocationForNode */])(nodeId);case 4:allocationData=_context.sent;if(allocationData){dispatch(renderAllocationData(allocationData));}else{dispatch(fetchAllocationDataFailure());}_context.next=11;break;case 8:_context.prev=8;_context.t0=_context["catch"](1);dispatch(fetchAllocationDataFailure());case 11:case"end":return _context.stop();}}},_callee,_this,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};/**
 * Fetch Allocation data start.
 */var fetchAllocationDataStart=function fetchAllocationDataStart(){return{type:FETCH_ALLOCATION_DATA_START};};/**
 * Fetch Allocation data failure.
 */var fetchAllocationDataFailure=function fetchAllocationDataFailure(){return{type:FETCH_ALLOCATION_DATA_FAILURE};};/**
 * Fetch Allocation success and render
 */var renderAllocationData=function renderAllocationData(data){return{type:RENDER_ALLOCATION_DATA,data:data};};

/***/ }),
/* 263 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    modalMobileCloseButtonSpacingTop: 4,
    modalMobileCloseButtonSpacingRight: 2,
    modalMotionDuration: "300ms",
    modalMotionFunction: "ease",
    modalBorderWidth: 1,
    modalBorderRadius: 4,
    modalHeaderForegroundColor: "#FFFFFF",
    modalHeaderBackgroundColor: "#252829",
    modalHeaderFontWeight: 600,
    modalHeaderMinHeight: 48,
    modalHeaderSpacingInsetTop: 8,
    modalHeaderSpacingInsetRight: 40,
    modalHeaderSpacingInsetBottom: 8,
    modalHeaderSpacingInsetLeft: 16,
    modalCloseButtonSpacingTop: 8,
    modalCloseButtonSpacingRight: 8,
    modalBodyBackgroundColor: tokens.themeBackgroundPrimaryDefault,
    modalFooterSpacingInset: 16,
    modalFooterBorderWidth: 1,
    modalFooterBorderRadius: 0,
    modalFooterBorderColor: tokens.themeBorderTertiaryDefault,
    modalDropShadowOffsetX: 0,
    modalDropShadowOffsetY: 2,
    modalDropShadowBlur: 4,
    modalDropShadowSpread: 0,
    modalDropShadowColor: "rgba(11, 12, 12, 0.16)",
    modalFloatingBreakpoint: 721
  }
};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

/**
 * This component is used to render a footer in your Modal. It is meant to
 * be used with Modals of type "scrollableRegion," and without it modals of
 * those type will not render correctly.
 */
var ModalFooter = function ModalFooter(props) {
  var children = props.children;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement("footer", passThroughProps, children);
};

ModalFooter.propTypes =  false ? {
  /**
   * The contents of the footer. Can be any components, but we suggest you
   * include action buttons here (e.g. "Close" and "Cancel") so that they are
   * easily reachable by your customers
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string
} : {};
var _default = ModalFooter;
exports["default"] = _default;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _focusTrap = _interopRequireDefault(__webpack_require__(607));

var _default = _focusTrap["default"];
exports["default"] = _default;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(267),
    isArrayLike = __webpack_require__(73),
    isString = __webpack_require__(218),
    toInteger = __webpack_require__(153),
    values = __webpack_require__(610);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(152),
    baseIsNaN = __webpack_require__(608),
    strictIndexOf = __webpack_require__(609);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _scrim = _interopRequireDefault(__webpack_require__(613));

var _default = _scrim["default"];
exports["default"] = _default;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AnimateFade", {
  enumerable: true,
  get: function get() {
    return _animateFade["default"];
  }
});
Object.defineProperty(exports, "AnimateFadeScale", {
  enumerable: true,
  get: function get() {
    return _animateFadeScale["default"];
  }
});
Object.defineProperty(exports, "AnimateSlideIn", {
  enumerable: true,
  get: function get() {
    return _animateSlideIn["default"];
  }
});
exports["default"] = void 0;

var _withAnimateMount = _interopRequireDefault(__webpack_require__(614));

var _animateFade = _interopRequireDefault(__webpack_require__(615));

var _animateSlideIn = _interopRequireDefault(__webpack_require__(616));

var _animateFadeScale = _interopRequireDefault(__webpack_require__(617));

var _default = _withAnimateMount["default"];
exports["default"] = _default;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * WHAT: This function makes it easy to detect a direct click on an element. It
 * will only trigger if both the mouse down and mouse up parts of the click
 * occurr directly on the element itself, and not the element's children.
 *
 * WHY: Listening for a direct click on an element, excluding its children, is
 * pretty tricky. You could try comparing event.target to event.currentTarget in
 * a click handler bound directly to the element, but that would still fire if
 * the click started on another element. For example if the user moused down on
 * a child element, moused over to the parent element, and released then a click
 * even would be fired on the parent where event.target was the same as
 * event.currentTarget. This same limitation applies to the method of trying to
 * call event.stopPropagation on click events from children to keep them from
 * bubbling up to parents. See https://sim.amazon.com/issues/MRDN-592 for why
 * triggering a click that started on another element can be problematic.

 * HOW: Usage of this utility is a little weird, but it's the only consistent
 * solution I could find to the problem. This function's only argument is the
 * onClick handler that should be called when a direct click is made. However
 * instead of returning some sort of more robust click handler it returns a
 * mouse down handler. This handler should be passed to the onMouseDown prop of
 * the element. For example:
 *
 * ```
 * const onClick = () => console.log("clicked directly on div!")
 *
 * // NOTE: onClick can't change after this point as onDirectClick stores it in
 * // memory. If onClick may change just inline this in your jsx (e.g.
 * // `onMouseDown={onDirectClick(onClick)}`).
 * const onMouseDown = onDirectClick(onClick)
 *
 * <div onMouseDown={onMouseDown}>
 *   <p>Clicking on this will not trigger a "direct" click on the parent</p>
 * </div>
 * ```
 *
 * Not super intuitive, but it works. This allows the utility to start listening
 * for clicks only when the user mouses down on the element, avoiding the
 * situation where a mousedown on another element, then a mouseover to our
 * element, then a mouse up would fire a click.
 */
var onDirectClick = function onDirectClick(callback) {
  // Listeners to add when the user mouses down on our element.
  var addListeners = function addListeners(node) {
    node.addEventListener("click", onClick);
    node.addEventListener("mouseout", onMouseOut);
  }; // Listeners to remove when the user finishes their click or mouses out of
  // the element.


  var removeListeners = function removeListeners(node) {
    node.removeEventListener("click", onClick);
    node.removeEventListener("mouseout", onMouseOut);
  }; // This is the final "direct" click handler.


  var onClick = function onClick(event) {
    removeListeners(event.target);
    callback(event);
  }; // If the user mouses out clear our listeners (and stop listening for a click
  // event, as it would no longer be directly on the element).


  var onMouseOut = function onMouseOut(event) {
    return removeListeners(event.target);
  }; // If the user mouses down directly on the element that this event is bound
  // to then start listening for a click event to finish things off.


  var onMouseDown = function onMouseDown(event) {
    if (event.target === event.currentTarget) {
      addListeners(event.target);
    }
  };

  return callback ? onMouseDown : undefined;
};

var _default = onDirectClick;
exports["default"] = _default;

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FilterExpander */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_icon__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_tokens_base_icon_filter__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_tokens_base_icon_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_tokens_base_icon_filter__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var FilterExpander=function FilterExpander(_ref){var children=_ref.children;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),open=_useState2[0],setOpen=_useState2[1];var onClick=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){setOpen(!open);},[open]);var FilterButton=function FilterButton(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{onClick:onClick,type:"link",size:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_tokens_base_icon_filter___default.a})," Filters");};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterButton,null),open?children:null);};/* harmony default export */ __webpack_exports__["a"] = (FilterExpander);

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = exports.Consumer = void 0;

var _react = __webpack_require__(0);

var _createContext = /*#__PURE__*/(0, _react.createContext)({}),
    Provider = _createContext.Provider,
    Consumer = _createContext.Consumer;

exports.Consumer = Consumer;
exports.Provider = Provider;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(88);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

module.exports = escapeRegExp;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOptionValueSelected = exports.isOption = exports.isGroup = exports.getOptionsFromChildren = exports.getNonOptionsFromChildren = exports.createOptionItemsAndGroups = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _selectOption = _interopRequireDefault(__webpack_require__(174));

var _selectOptionGroup = _interopRequireDefault(__webpack_require__(275));

var _optionList = __webpack_require__(276);

var _highlightSubstring = _interopRequireDefault(__webpack_require__(278));

var _isElementOf = _interopRequireDefault(__webpack_require__(72));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var isOption = (0, _isElementOf["default"])(_selectOption["default"]);
exports.isOption = isOption;
var isGroup = (0, _isElementOf["default"])(_selectOptionGroup["default"]);
exports.isGroup = isGroup;

var isOptionValueSelected = function isOptionValueSelected(selectedValue, optionValue) {
  return Array.isArray(selectedValue) ? selectedValue.indexOf(optionValue) !== -1 : selectedValue === optionValue;
};

exports.isOptionValueSelected = isOptionValueSelected;

var getOptionFromSelectOption = function getOptionFromSelectOption(_ref) {
  var selectOption = _ref.selectOption,
      index = _ref.index,
      groupDisabled = _ref.groupDisabled;
  return _objectSpread({
    index: index,
    label: selectOption.props.label.toString(),
    value: selectOption.props.value,
    children: selectOption.props.children,
    disabled: groupDisabled || selectOption.props.disabled
  }, (0, _filterPropsByPrefix["default"])(selectOption.props, ["data-"]));
};

var getOptionsFromChildren = function getOptionsFromChildren(children) {
  // The final list of options
  var options = []; // Rest option counter to 0

  var optionCounter = 0;

  _react["default"].Children.toArray(children).forEach(function (child) {
    // If we're parsing an option, push onto options
    if (isOption(child)) {
      var index = optionCounter;
      options.push(getOptionFromSelectOption({
        selectOption: child,
        index: index
      })); // Update option counter

      optionCounter += 1;
    } // If we're parsing a group, iterate over its children and add to options
    else if (isGroup(child)) {
      var groupDisabled = child.props.disabled;

      _react["default"].Children.toArray(child.props.children).forEach(function (child) {
        var index = optionCounter;

        if (isOption(child)) {
          options.push(getOptionFromSelectOption({
            selectOption: child,
            index: index,
            groupDisabled: groupDisabled
          })); // Update option counter

          optionCounter += 1;
        }
      });
    }
  });

  return options;
};

exports.getOptionsFromChildren = getOptionsFromChildren;

var createOptionItemFromSelectOption = function createOptionItemFromSelectOption(option, _ref2) {
  var selectValue = _ref2.selectValue,
      onClickOption = _ref2.onClickOption,
      searchQuery = _ref2.searchQuery,
      groupDisabled = _ref2.groupDisabled;
  var _option$props = option.props,
      label = _option$props.label,
      value = _option$props.value,
      disabled = _option$props.disabled;
  var key = option.key;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(option.props, ["data-", "aria-"]);
  var children = searchQuery && option.props.children === undefined ? function () {
    return /*#__PURE__*/_react["default"].createElement(_highlightSubstring["default"], {
      match: searchQuery
    }, label);
  } : option.props.children;
  return /*#__PURE__*/_react["default"].createElement(_optionList.OptionListItem, _objectSpread({
    key: key !== null && key !== void 0 ? key : value,
    selected: isOptionValueSelected(selectValue, value),
    onClick: function onClick() {
      return onClickOption(value);
    },
    label: label.toString(),
    disabled: disabled || groupDisabled
  }, passThroughProps), children);
};

var createOptionGroupFromSelectOptionGroup = function createOptionGroupFromSelectOptionGroup(group, _ref3) {
  var selectValue = _ref3.selectValue,
      onClickOption = _ref3.onClickOption,
      searchQuery = _ref3.searchQuery;
  var _group$props = group.props,
      label = _group$props.label,
      disabled = _group$props.disabled;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(group.props, ["aria-", "data-"]);

  var children = _react["default"].Children.toArray(group.props.children).map(function (child) {
    if (isOption(child)) {
      return createOptionItemFromSelectOption(child, {
        selectValue: selectValue,
        onClickOption: onClickOption,
        searchQuery: searchQuery,
        groupDisabled: disabled
      });
    }
  });

  return /*#__PURE__*/_react["default"].createElement(_optionList.OptionListGroup, _objectSpread({
    key: label,
    label: label.toString(),
    disabled: disabled
  }, passThroughProps), children);
};

var createOptionItemsAndGroups = function createOptionItemsAndGroups(_ref4) {
  var children = _ref4.children,
      selectValue = _ref4.value,
      onClickOption = _ref4.onClickOption,
      searchQuery = _ref4.searchQuery;
  var optionsAndGroups = [];

  _react["default"].Children.toArray(children).forEach(function (child) {
    if (isOption(child)) {
      optionsAndGroups.push(createOptionItemFromSelectOption(child, {
        selectValue: selectValue,
        onClickOption: onClickOption,
        searchQuery: searchQuery
      }));
    } else if (isGroup(child)) {
      optionsAndGroups.push(createOptionGroupFromSelectOptionGroup(child, {
        selectValue: selectValue,
        onClickOption: onClickOption,
        searchQuery: searchQuery
      }));
    }
  });

  return optionsAndGroups;
};

exports.createOptionItemsAndGroups = createOptionItemsAndGroups;

var getNonOptionsFromChildren = function getNonOptionsFromChildren(children) {
  return _react["default"].Children.toArray(children).filter(function (child) {
    return child && !isOption(child) && !isGroup(child);
  });
};

exports.getNonOptionsFromChildren = getNonOptionsFromChildren;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Pass this as a child to the `Select` component to render it as an option of
 * the select.
 *
 * @since 5.13.0
 */
var SelectOptionGroup = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SelectOptionGroup, _React$Component);

  var _super = _createSuper(SelectOptionGroup);

  function SelectOptionGroup() {
    (0, _classCallCheck2["default"])(this, SelectOptionGroup);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SelectOptionGroup, [{
    key: "render",
    value: function render() {
      // The top-level OptionListGroup component is used to render this. See
      // ./select-option-list for the implementation.
      return null;
    }
  }]);
  return SelectOptionGroup;
}(_react["default"].Component);

SelectOptionGroup.propTypes =  false ? {
  /**
   * A list of `SelectOption` elements. Nested groups are not supported.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The group's label.
   */
  label: _propTypes["default"].string.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive. Setting to `true` will also
   * disable all child options.
   */
  disabled: _propTypes["default"].bool
} : {};
var _default = SelectOptionGroup;
exports["default"] = _default;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "OptionListGroup", {
  enumerable: true,
  get: function get() {
    return _optionListGroup["default"];
  }
});
Object.defineProperty(exports, "OptionListItem", {
  enumerable: true,
  get: function get() {
    return _optionListItem["default"];
  }
});
exports["default"] = void 0;

var _optionList = _interopRequireDefault(__webpack_require__(638));

var _optionListItem = _interopRequireDefault(__webpack_require__(640));

var _optionListGroup = _interopRequireDefault(__webpack_require__(277));

var _default = _optionList["default"];
exports["default"] = _default;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _uniqueId = _interopRequireDefault(__webpack_require__(51));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

/**
 * This component groups option list items.
 *
 * @since 5.13.0
 */
var OptionListGroup = function OptionListGroup(props) {
  var label = props.label,
      children = props.children,
      disabled = props.disabled;
  var labelId = (0, _uniqueId["default"])("option-list-group-title-");
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]);
  var ariaLabel = passThroughProps["aria-label"];
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    role: "group",
    "aria-labelledby": labelId
  }, passThroughProps), /*#__PURE__*/_react["default"].createElement("span", {
    id: labelId,
    role: "presentation",
    disabled: disabled,
    "aria-label": ariaLabel
  }, label), children);
};

OptionListGroup.propTypes =  false ? {
  /**
   * A set of OptionListItem nodes. Nested groups not supported.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The label of the group.
   */
  label: _propTypes["default"].string.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive. Setting to `true` will also
   * disable all child options.
   */
  disabled: _propTypes["default"].bool
} : {};
var _default = OptionListGroup;
exports["default"] = _default;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _highlightSubstring = _interopRequireDefault(__webpack_require__(641));

var _default = _highlightSubstring["default"];
exports["default"] = _default;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _default = /*#__PURE__*/_react["default"].createContext({});

exports["default"] = _default;

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FilterOptionsV2=function(_Component){_inherits(FilterOptionsV2,_Component);function FilterOptionsV2(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FilterOptionsV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FilterOptionsV2.__proto__||Object.getPrototypeOf(FilterOptionsV2)).call.apply(_ref,[this].concat(args))),_this),_this.isCPTFilterEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_7__constants__["j" /* FEATURES */].IS_CPT_FILTER_ENABLED];},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FilterOptionsV2,[{key:"render",value:function render(){var _this2=this;var _props=this.props,allCycles=_props.allCycles,selectedCycle=_props.selectedCycle,allCPT=_props.allCPT,selectedCPT=_props.selectedCPT,CPTLabel=_props.CPTLabel;if(!this.isCPTFilterEnabled()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"cycleOptions.cycle",defaultMessage:"Cycle"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select___default.a,{onChange:function onChange(updatedCycle){return _this2.handleCycleChange(updatedCycle,allCycles);},value:selectedCycle,placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"cycleOptions.cycle",defaultMessage:"Cycle"})},allCycles.map(function(cycle){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__["SelectOption"],{key:cycle.cycleName,value:cycle.cycleName,"data-cy":"cycleFieldsetOption",label:cycle.displayableName});})));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"CPT."+CPTLabel,defaultMessage:"CPT"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select___default.a,{onChange:function onChange(updatedCPT){return _this2.handleCPTChange(updatedCPT,allCPT);},value:selectedCPT},allCPT.map(function(CPT){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__["SelectOption"],{key:CPT.id,value:CPT.id,"data-cy":"CPTFieldsetOption",label:CPT.label});})));}}},{key:"handleCycleChange",value:function handleCycleChange(updatedCycle,allCycles){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["w" /* optionsAddedOrChanged */])({'cycle':updatedCycle}));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["w" /* optionsAddedOrChanged */])({'cycleId':allCycles.filter(function(cycle){return cycle.cycleId===updatedCycle;}).map(function(cycle){return cycle.casCycleId;})[0]}));}},{key:"handleCPTChange",value:function handleCPTChange(updatedCPT,allCPT){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["c" /* CPTAddedOrChanged */])({'CPT':updatedCPT}));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["c" /* CPTAddedOrChanged */])({'CPTId':allCPT.filter(function(CPT){return CPT.id===updatedCPT;}).map(function(CPT){return CPT.id;})[0]}));}}]);return FilterOptionsV2;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{selectedCycle:state.optionsReducerV2.options.cycle,allCycles:state.optionsReducerV2.allCycles,selectedCPT:state.optionsReducerV2.options.CPT,allCPT:state.optionsReducerV2.allCPT,featureStatus:state.configReducer.featureStatus,CPTLabel:state.optionsReducerV2.CPTLabel};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(FilterOptionsV2)));

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_control_group__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_control_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_control_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_radio_button__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_radio_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_radio_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CycleOptions=function(_Component){_inherits(CycleOptions,_Component);function CycleOptions(){_classCallCheck(this,CycleOptions);return _possibleConstructorReturn(this,(CycleOptions.__proto__||Object.getPrototypeOf(CycleOptions)).apply(this,arguments));}_createClass(CycleOptions,[{key:"componentDidMount",value:function componentDidMount(){if(this.props.allCycles.length!==0&&this.props.selectedCycle.length===0){this.handleCycleChange(this.props.allCycles[0].cycleId,this.props.allCycles);}}},{key:"render",value:function render(){var _this2=this;var _props=this.props,allCycles=_props.allCycles,selectedCycle=_props.selectedCycle;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_control_group___default.a,{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"cycleOptions.cycle",defaultMessage:"Cycle"}),onChange:function onChange(updatedCycle){return _this2.handleCycleChange(updatedCycle,allCycles);},value:selectedCycle},allCycles.map(function(cycle){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_radio_button___default.a,{key:cycle.cycleName,value:cycle.cycleName,"data-cy":"cycleFieldsetOption"},cycle.displayableName);}));}},{key:"handleCycleChange",value:function handleCycleChange(updatedCycle,allCycles){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_OptionsActions__["u" /* optionsAddedOrChanged */])({'cycle':updatedCycle}));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_OptionsActions__["u" /* optionsAddedOrChanged */])({'cycleId':allCycles.filter(function(cycle){return cycle.cycleId===updatedCycle;}).map(function(cycle){return cycle.casCycleId;})[0]}));}}]);return CycleOptions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{selectedCycle:state.optionsReducer.options.cycle,allCycles:state.optionsReducer.allCycles};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(CycleOptions)));

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(144),
    arrayIncludes = __webpack_require__(283),
    arrayIncludesWith = __webpack_require__(284),
    cacheHas = __webpack_require__(145),
    createSet = __webpack_require__(656),
    setToArray = __webpack_require__(146);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(267);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 284 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var fieldsetReset = {
  border: 0,
  padding: 0,
  margin: 0,
  "& legend": {
    padding: 0
  }
};
var _default = fieldsetReset;
exports["default"] = _default;

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_STOW_ASSOCIATES_CALL_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_STOW_ASSOCIATES_CALL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_STOW_ASSOCIATES_CALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getStowAssociatesForAssociateView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_StowResource__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MetricUtility__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(5);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var LOAD_STOW_ASSOCIATES_CALL_BEGIN="LOAD_STOW_ASSOCIATES_CALL_BEGIN";var LOAD_STOW_ASSOCIATES_CALL_SUCCESS="LOAD_STOW_ASSOCIATES_CALL_SUCCESS";var LOAD_STOW_ASSOCIATES_CALL_FAILURE="LOAD_STOW_ASSOCIATES_CALL_FAILURE";var metricProcessName="SCC_STOW_ASSOCIATE";var loadStowAssociatesCallBegin=function loadStowAssociatesCallBegin(){return{type:LOAD_STOW_ASSOCIATES_CALL_BEGIN};};var loadStowAssociatesCallSuccess=function loadStowAssociatesCallSuccess(associatesList){return{type:LOAD_STOW_ASSOCIATES_CALL_SUCCESS,associatesList:associatesList};};var loadStowAssociatesCallFailure=function loadStowAssociatesCallFailure(){return{type:LOAD_STOW_ASSOCIATES_CALL_FAILURE};};var getStowAssociatesForAssociateView=function getStowAssociatesForAssociateView(nodeId,cycles,CPTId,filterIdentifier,isCPTFilterEnabled){var metricName="getStowAssociates";var request={filters:{NODE:[nodeId]},fieldsRequired:["NAME","STATUS","PERFORMANCE","LOCATION"]};cycles=cycles.filter(Boolean);if(cycles.length&&!isCPTFilterEnabled){request.filters[__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CYCLE */]]=cycles;}if(CPTId.length&&isCPTFilterEnabled){request.filters[[filterIdentifier]]=CPTId;}return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var startTime,associatesList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;dispatch(loadStowAssociatesCallBegin());startTime=Date.now();_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["g" /* getStowAssociates */])(request);case 5:associatesList=_context.sent;if(associatesList){dispatch(loadStowAssociatesCallSuccess(associatesList));Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadStowAssociatesCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context.next=13;break;case 9:_context.prev=9;_context.t0=_context["catch"](0);dispatch(loadStowAssociatesCallFailure());Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context.stop();}}},_callee,_this,[[0,9]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(120),
    stackClear = __webpack_require__(678),
    stackDelete = __webpack_require__(679),
    stackGet = __webpack_require__(680),
    stackHas = __webpack_require__(681),
    stackSet = __webpack_require__(682);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 288 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(95),
    isObject = __webpack_require__(179);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 291 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(701),
    arraySome = __webpack_require__(704),
    cacheHas = __webpack_require__(705);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(719),
    isObjectLike = __webpack_require__(96);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(55),
    stubFalse = __webpack_require__(720);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)(module)))

/***/ }),
/* 295 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(721),
    baseUnary = __webpack_require__(722),
    nodeUtil = __webpack_require__(723);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(289),
    isLength = __webpack_require__(182);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(179);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 299 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(301),
    toKey = __webpack_require__(125);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(56),
    isKey = __webpack_require__(183),
    stringToPath = __webpack_require__(750),
    toString = __webpack_require__(753);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_PACKAGE_LIST_BEGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_PACKAGE_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_PACKAGE_LIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchPackageListForFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchPickedPackageList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_StowResource__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MetricUtility__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources_PickResource__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utility__ = __webpack_require__(10);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var LOAD_PACKAGE_LIST_BEGIN="LOAD_PACKAGE_LIST_BEGIN";var LOAD_PACKAGE_LIST_SUCCESS="LOAD_PACKAGE_LIST_SUCCESS";var LOAD_PACKAGE_LIST_FAILURE="LOAD_PACKAGE_LIST_FAILURE";var metricProcessName="SCC_STOW_PACKAGES";var loadPackageListBegin=function loadPackageListBegin(){return{type:LOAD_PACKAGE_LIST_BEGIN};};var loadPackageListSuccess=function loadPackageListSuccess(packageList){return{type:LOAD_PACKAGE_LIST_SUCCESS,packageList:packageList};};var loadPackageListFailure=function loadPackageListFailure(){return{type:LOAD_PACKAGE_LIST_FAILURE};};var fetchPackageListForFilters=function fetchPackageListForFilters(nodeId,params,capability){var metricName="getPackages";var request={filters:{'NODE':[nodeId]}};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=params.entries()[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var pair=_step.value;request.filters[pair[0]]=[pair[1]];}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(__WEBPACK_IMPORTED_MODULE_2__enums__["e" /* Capability */].AR_NEXT_GEN!==capability&&!request.filters['ROUTE_ID']&&!request.filters['DRS']&&!request.filters['SIDELINE']&&!request.filters['SIDELINE_V2']&&(request.filters['PACKAGE_STATUS'][0]===__WEBPACK_IMPORTED_MODULE_2__enums__["n" /* PackageStatus */].CURRENT_STOWED||request.filters['PACKAGE_STATUS'][0]===__WEBPACK_IMPORTED_MODULE_2__enums__["n" /* PackageStatus */].PROBLEM_SOLVE||request.filters['PACKAGE_STATUS'][0]===__WEBPACK_IMPORTED_MODULE_2__enums__["n" /* PackageStatus */].CURRENT_INDUCTED)){request.filters['DRS']=["FALSE"];}if(request.filters['SIDELINE_V2']){var reInductDate=request.filters['SIDELINE_UNTIL_TIME'][0];delete request.filters['SIDELINE_UNTIL_TIME'];request.rangeFilters=[Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["q" /* getSidelineRangeFilter */])(reInductDate)];}return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var startTime,packageList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;dispatch(loadPackageListBegin());startTime=Date.now();_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StowResource__["d" /* getPackages */])(request);case 5:packageList=_context.sent;if(packageList){dispatch(loadPackageListSuccess(packageList));Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);}else{dispatch(loadPackageListFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);}_context.next=13;break;case 9:_context.prev=9;_context.t0=_context["catch"](0);dispatch(loadPackageListFailure());Object(__WEBPACK_IMPORTED_MODULE_3__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 13:case"end":return _context.stop();}}},_callee,_this,[[0,9]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var fetchPickedPackageList=function fetchPickedPackageList(baseURL,nodeId,params){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var request,packageList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(loadPackageListBegin());_context2.prev=1;request=constructPickedPackagesRequest(nodeId,params);_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_5__resources_PickResource__["b" /* getPickPackages */])(request,baseURL);case 5:packageList=_context2.sent;if(packageList){dispatch(loadPackageListSuccess(packageList));}else{dispatch(loadPackageListFailure());}_context2.next=12;break;case 9:_context2.prev=9;_context2.t0=_context2["catch"](1);dispatch(loadPackageListFailure());case 12:case"end":return _context2.stop();}}},_callee2,_this,[[1,9]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var constructPickedPackagesRequest=function constructPickedPackagesRequest(nodeId,queryParams){return{stationCode:nodeId,date:Object(__WEBPACK_IMPORTED_MODULE_6__Utility__["j" /* getDateInMMDDYYYYWithOffset */])(0),metric:queryParams.get(__WEBPACK_IMPORTED_MODULE_4__constants__["t" /* PACKAGE_STATUS */]),groupBy:queryParams.get(__WEBPACK_IMPORTED_MODULE_4__constants__["m" /* GROUP_BY */]),filters:constructFiltersForPicked(queryParams)};};var constructFiltersForPicked=function constructFiltersForPicked(queryParams){var filters={stationPair:[queryParams.get(__WEBPACK_IMPORTED_MODULE_4__constants__["u" /* STATION_PAIR */])]};if(__WEBPACK_IMPORTED_MODULE_4__constants__["l" /* FLOOR_LOCATION */]===queryParams.get(__WEBPACK_IMPORTED_MODULE_4__constants__["m" /* GROUP_BY */])){return Object.assign({},filters,{floorLocation:[queryParams.get(__WEBPACK_IMPORTED_MODULE_4__constants__["k" /* FLOOR */])]});}return filters;};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _pagination = _interopRequireDefault(__webpack_require__(766));

var _default = _pagination["default"];
exports["default"] = _default;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(227),
    isFlattenable = __webpack_require__(769);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(150),
    overRest = __webpack_require__(770),
    setToString = __webpack_require__(772);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(73),
    isObjectLike = __webpack_require__(62);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PendingStowList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ReverseTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_box__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_control_group__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_control_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_control_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_responsive__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button_group__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_heading__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tooltip__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_info_knockout__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_info_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_info_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_full_screen__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_full_screen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_full_screen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_check_small__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_check_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_check_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tokens_base_icon_alert_knockout__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tokens_base_icon_alert_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tokens_base_icon_alert_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_close_small__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_close_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_close_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_clock__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_clock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_clock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_emotion__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__amzn_meridian_pagination__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__amzn_meridian_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__amzn_meridian_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_button__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_csv__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_react_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__amzn_meridian_select__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__amzn_meridian_tag__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__amzn_meridian_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__amzn_meridian_breadcrumb_breadcrumb_group__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__amzn_meridian_breadcrumb_breadcrumb_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__amzn_meridian_breadcrumb_breadcrumb_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__amzn_meridian_breadcrumb__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__amzn_meridian_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__amzn_meridian_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__amzn_meridian_table_table_row__);
































function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var ShipmentTypeFilterReducer = function ShipmentTypeFilterReducer(state, action) {
  switch (action.type) {
    case "SET_SHIPMENTTYPE_FILTERS":
      {
        var newState = _extends({}, state, {
          shipmentTypeFilters: action.shipmentTypeFilters
        });
        return newState;
      }
    default:
      return state;
  }
};

var ShipmentTypeFilterContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();
var ShipmentTypeFilterContextProvider = function ShipmentTypeFilterContextProvider(props) {
  var state = {
    shipmentTypeFilters: []
  };
  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(ShipmentTypeFilterReducer, state),
    ViewModelG = _useReducer[0],
    dispatchG = _useReducer[1];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShipmentTypeFilterContext.Provider, {
    value: {
      ViewModelG: ViewModelG,
      dispatchG: dispatchG
    }
  }, props.children);
};

var ShipmentTypeFilter = function ShipmentTypeFilter() {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
    checkBoxValues = _useState[0],
    setCheckBoxValues = _useState[1];
  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ShipmentTypeFilterContext),
    ViewModelG = _useContext.ViewModelG,
    dispatchG = _useContext.dispatchG;
  var updateShipmentTypeFilters = function updateShipmentTypeFilters(checkBoxValues) {
    setCheckBoxValues(checkBoxValues);
    dispatchG({
      type: "SET_SHIPMENTTYPE_FILTERS",
      shipmentTypeFilters: checkBoxValues
    });
  };
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    setCheckBoxValues(ViewModelG.shipmentTypeFilters);
    sessionStorage.setItem("filter", JSON.stringify(ViewModelG.shipmentTypeFilters));
  }, []);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a, {
    spacing: "200"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_control_group___default.a, {
    name: "shipmentTypeFilters[]",
    onChange: updateShipmentTypeFilters,
    value: checkBoxValues
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_checkbox___default.a, {
    value: "MFNPickup"
  }, "Ship With Amazon"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_checkbox___default.a, {
    value: "Undeliverables"
  }, "Undeliverables"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_checkbox___default.a, {
    value: "CReturns"
  }, "Customer Returns")));
};

var SMALL = "840px";
var LARGE = "1260px";

var _spacingInset_shortha, _spacingInset_shortha2, _isMobile;
var responsiveProps = {
  spacingInset_shorthand2: (_spacingInset_shortha = {
    default: "small large"
  }, _spacingInset_shortha[SMALL] = "small medium", _spacingInset_shortha),
  spacingInset_shorthand4: (_spacingInset_shortha2 = {
    default: "medium large none large"
  }, _spacingInset_shortha2[SMALL] = "medium medium none medium", _spacingInset_shortha2),
  isMobile: (_isMobile = {
    default: false
  }, _isMobile[SMALL] = true, _isMobile)
};

var DeviceLayoutContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();
var useDeviceLayout = function useDeviceLayout() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(DeviceLayoutContext);
};
var DeviceLayoutProvider = function DeviceLayoutProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_responsive___default.a, {
    query: "max-width",
    props: responsiveProps
  }, function (_ref2) {
    var spacingInset_shorthand2 = _ref2.spacingInset_shorthand2,
      spacingInset_shorthand4 = _ref2.spacingInset_shorthand4,
      isMobile = _ref2.isMobile;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DeviceLayoutContext.Provider, {
      value: {
        spacingInset_shorthand2: spacingInset_shorthand2,
        spacingInset_shorthand4: spacingInset_shorthand4,
        isMobile: isMobile
      }
    }, children);
  });
};

var ShipmentTypeField = function ShipmentTypeField() {
  var _useDeviceLayout = useDeviceLayout(),
    spacingInset_shorthand2 = _useDeviceLayout.spacingInset_shorthand2;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
    widths: ["grid-12"],
    spacingInset: spacingInset_shorthand2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_box___default.a, {
    type: "fill",
    spacingInset: "300"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
    type: "h100"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.ShipmentType",
    defaultMessage: "Shipment Type"
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShipmentTypeFilter, null)))));
};

var ReverseFilterReducer = function ReverseFilterReducer(state, action) {
  switch (action.type) {
    case "SELECT_WAVE_VIEW":
      {
        var newState = _extends({}, state, {
          waveViewType: action.waveViewType
        });
        return newState;
      }
    default:
      return state;
  }
};

var REVERSE_PAGE_HEADERS = {
  REVERSE: {
    tab: "reverse.tabHeading",
    tabAlt: "Reverse",
    head: "reverse.heading",
    headAlt: "Reverse",
    desc: "reverse.description",
    descAlt: "An overview of packages and containers being processed to depart from the station in reverse"
  }
};
var VISUAL_GRID_VIEW = "VISUAL_GRID_VIEW";
var TABULAR_GRID_VIEW = "TABULAR_GRID_VIEW";
var HOVER_DESCRIPTION = {
  AT_RISK: {
    desc: "reverse.hoverDescriptionAtRisk",
    descAlt: "Number of containers not loaded with 30 minutes or less to CPT."
  }
};

var ReverseFilterContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();
var ReverseFilterContextProvider = function ReverseFilterContextProvider(props) {
  var state = {
    waveViewType: VISUAL_GRID_VIEW
  };
  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(ReverseFilterReducer, state),
    viewModelF = _useReducer[0],
    dispatchF = _useReducer[1];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReverseFilterContext.Provider, {
    value: {
      viewModelF: viewModelF,
      dispatchF: dispatchF
    }
  }, props.children);
};

var ReverseViewSelector = function ReverseViewSelector() {
  var _useDeviceLayout = useDeviceLayout(),
    spacingInset_shorthand4 = _useDeviceLayout.spacingInset_shorthand4;
  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ReverseFilterContext),
    viewModelF = _useContext.viewModelF,
    dispatchF = _useContext.dispatchF;
  var toggleView = function toggleView(newValue) {
    dispatchF({
      type: 'SELECT_WAVE_VIEW',
      waveViewType: newValue
    });
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
    spacingInset: spacingInset_shorthand4
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button_group___default.a, {
    value: viewModelF.waveViewType,
    onChange: toggleView
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button_group__["ButtonOption"], {
    value: VISUAL_GRID_VIEW
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.visualView",
    defaultMessage: "Visual view"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button_group__["ButtonOption"], {
    value: TABULAR_GRID_VIEW
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.tableView",
    defaultMessage: "Table view"
  }))));
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (false) {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (true) {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function() {};

if (false) {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var ReverseHeader = function ReverseHeader(_ref) {
  var head = _ref.head,
    headAlt = _ref.headAlt,
    desc = _ref.desc,
    descAlt = _ref.descAlt;
  var _useDeviceLayout = useDeviceLayout(),
    spacingInset_shorthand2 = _useDeviceLayout.spacingInset_shorthand2;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a, {
    spacingInset: spacingInset_shorthand2,
    spacing: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_heading___default.a, {
    level: 2,
    type: "h400",
    alignment: "left"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: head,
    defaultMessage: headAlt
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
    color: "secondary"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: desc,
    defaultMessage: descAlt
  }))));
};
ReverseHeader.propTypes = {
  head: propTypes.string,
  headAlt: propTypes.string,
  desc: propTypes.string,
  descAlt: propTypes.string
};

var PENDING_DEPART = "Pending Depart";
var PENDING_LOADING = "Pending Loading";
var PENDING_STAGE = "Pending Stage";
var DEPARTED = "Departed";
var AT_RISK = "At Risk";
var CLOSED_FAILED = "Closed Failed";
var PENDING_CLOSE = "Pending Close";
var PackageTypeMapForFetchingPackageMetrics = {
  MFNPickup: "MFNPickup",
  Undeliverables: "Delivery",
  CReturns: ["CReturns", "Abandoned"]
};
var PackageTypeMapForFetchingContainerMetrics = {
  MFNPickup: "SWA",
  Undeliverables: "UNDELIVERED",
  CReturns: "C_RETURN"
};

var ScrollableElementWrapper = function ScrollableElementWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      overflow: "auto"
    }
  }, children);
};

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

var TIMEOUT_STRING = "timeout";
var TRACKING_ID = "Tracking ID";
var ROUTE_CODE = "Route Code";
var STATE = "State";
var REASON = "Reason";
var SORT_ZONE = "Sort Zone";
var CONTAINER_ID = "Container ID";
var STATUS = "Status";
var RESOURCE_LABEL = "Resource Label";
var VOLUME = "Volume";
var DESTINATION = "Destination";
var STACKING_FILTER = "Stacking Filter";
var OPENED_TIME = "Opened Time";
var CLOSED_TIME = "Closed Time";
var STAGED_TIME = "Staged Time";
var LOADED_TIME = "Loaded Time";
var DEPARTED_TIME = "Departed Time";
var CPT = "CPT";
var VRID = "VRID";
var ContainerState = {
  OPENED: "OPENED",
  CLOSE_FAILED: "CLOSE_FAILED",
  CLOSED: "CLOSED",
  STAGED: "STAGED",
  LOADED: "LOADED",
  DEPARTED: "DEPARTED"
};
var ContainerMetric = {
  PENDING_CLOSE: "Pending Close",
  PENDING_STAGE: "Pending Stage",
  PENDING_DEPART: "Pending Depart",
  CLOSE_FAILED: "Close Failed",
  AT_RISK: "At Risk"
};
var PENDING_STOW_TABLE_COLUMNS = [TRACKING_ID, ROUTE_CODE, STATE, REASON, SORT_ZONE];
var CONTAINER_TABLE_COLUMNS = [CONTAINER_ID, STATUS, RESOURCE_LABEL, VOLUME, DESTINATION, STACKING_FILTER, OPENED_TIME, CLOSED_TIME, STAGED_TIME, LOADED_TIME, DEPARTED_TIME, CPT, VRID];

var getNodeId = function getNodeId() {
  var queryParams = new URLSearchParams(window.location.search);
  return queryParams.get('stationCode');
};
function convertSecondsToDDMM(milliseconds) {
  var time = new Date(parseInt(milliseconds, 10));
  var date = time.getDate();
  var month = time.getMonth() + 1;
  if (date < 10) date = '0' + date;
  if (month < 10) month = '0' + month;
  return month + ':' + date;
}
function convertSecondsToHHMM(milliseconds) {
  var time = new Date(parseInt(milliseconds, 10));
  return ('0' + time.getHours()).slice(-2) + ':' + ('0' + time.getMinutes()).slice(-2);
}
function convertSecondsToHHMMSS(milliseconds) {
  var time = new Date(parseInt(milliseconds, 10));
  return ('0' + time.getHours()).slice(-2) + ':' + ('0' + time.getMinutes()).slice(-2) + ':' + time.getSeconds();
}
function getRegion() {
  var url = window.location.href;
  return url.includes("eu.") ? "eu" : url.includes("jp.") ? "jp" : "na";
}
function convertLocaleTime(epochMills) {
  if (epochMills === 0 || epochMills === 2147483647) {
    return '-';
  }
  var date = new Date(epochMills);
  var systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var formatter = new Intl.DateTimeFormat("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: systemTimeZone
  });
  return formatter.format(date).replace(',', '');
}
function getIcon(container, index) {
  var val = container.containerState[index];
  if (val > 0) {
    return __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_check_small___default.a;
  } else if (val < 0) {
    return __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tokens_base_icon_alert_knockout___default.a;
  } else if (shouldActivateTimer(container, index)) {
    return __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_clock___default.a;
  } else {
    return __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_close_small___default.a;
  }
}
function shouldActivateTimer(container, index) {
  if (index === 0 || container.containerState[index] === 1) {
    return false;
  }
  return container.status === "CLOSED" && Date.now() - container.closedTime >= 5 * 60 * 1000 && container.containerState[index - 1] === 1;
}
function withRefreshTime(callback, refreshTime) {
  var repeat = setInterval(callback, refreshTime);
  callback();
  return repeat;
}

var getDocumentURL = function getDocumentURL() {
  try {
    return Promise.resolve(postMessagePromised(window.parent, {
      method: 'getDocumentURL',
      args: {}
    }, '*'));
  } catch (e) {
    return Promise.reject(e);
  }
};
var getAPIGatewayDataFromParent = function getAPIGatewayDataFromParent(args) {
  try {
    return Promise.resolve(postMessagePromised(window.parent, {
      method: 'getAPIGatewayDataFromParent',
      args: args
    }, '*'));
  } catch (e) {
    return Promise.reject(e);
  }
};
var postMessagePromises = {};
function generateGuid() {
  function S4() {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
  }
  return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
}
function postMessagePromised(targetWindow, message, targetOrigin, timeout) {
  var newGuid = generateGuid();
  message.guid = newGuid;
  postMessagePromises[newGuid] = {};
  postMessagePromises[newGuid]['promise'] = new Promise(function (resolve, reject) {
    postMessagePromises[newGuid]['resolve'] = resolve;
    postMessagePromises[newGuid]['reject'] = reject;
    targetWindow.postMessage(message, targetOrigin);
    if (timeout) {
      setTimeout(function () {
        postMessagePromises[newGuid].resolve(TIMEOUT_STRING);
        console.log("TimeOut: " + message.method);
      }, timeout);
    }
  });
  return postMessagePromises[newGuid].promise;
}
window.addEventListener("message", onNewPostMessageFromParent, false);
function onNewPostMessageFromParent(event) {
  if (event.data.method && subscribeAbleEvents.hasOwnProperty(event.data.method)) {
    subscribeAbleEvents[event.data.method](event.data);
  }
}
var subscribeAbleEvents = {
  "sendCycleDataToChild": sendCycleDataToChild,
  "sendApiGatewayResponse": sendApiGatewayResponse,
  "sendDocumentURL": sendDocumentURL,
  "sendCapabilityResponse": sendCapabilityResponse,
  "sendLocaleResponse": sendChildData,
  "sendFeatureStatus": sendResponseData
};
function sendCycleDataToChild(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.childData);
  }
}
function sendApiGatewayResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}
function sendDocumentURL(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}
function sendCapabilityResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.childData);
  }
}
function sendChildData(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.childData);
  }
}
function sendResponseData(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

var getPackageMetrics = function getPackageMetrics(dispatch, shipmentTypeFilters) {
  try {
    var nodeId = getNodeId();
    var mappedFilters = getMappingForPackageFilters(shipmentTypeFilters);
    var request = {
      nodeId: nodeId,
      metrics: ["PENDING_STOW_COUNT", "REVERSE_STOWED"],
      filters: mappedFilters
    };
    var _temp3 = _catch(function () {
      var args = getAPIGatewayRequestForPackageMetricsData(request);
      return Promise.resolve(getAPIGatewayDataFromParent(args)).then(function (response) {
        var output = response.data;
        if (output.packageMetricsData) {
          dispatch({
            type: "GET_PACKAGE_METRICS_RESPONSE",
            packageMetricsData: getPackageMetricsData(output.packageMetricsData)
          });
        }
      });
    }, function () {
      console.log("Error");
    });
    return Promise.resolve(_temp3 && _temp3.then ? _temp3.then(function () {}) : void 0);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getContainerFromApi = function getContainerFromApi(dispatch, shipmentTypeFilters) {
  try {
    var nodeId = getNodeId();
    var updatedShipmentTypeFilters = [];
    shipmentTypeFilters.forEach(function (selectedValue) {
      if (Object.keys(PackageTypeMapForFetchingContainerMetrics).includes(selectedValue)) {
        var val = PackageTypeMapForFetchingContainerMetrics[selectedValue];
        if (Array.isArray(val)) {
          updatedShipmentTypeFilters = [].concat(updatedShipmentTypeFilters, val);
        } else {
          updatedShipmentTypeFilters.push(val);
        }
      }
    });
    var request = {
      nodeId: nodeId,
      shipmentTypeFilters: updatedShipmentTypeFilters
    };
    var _temp2 = _catch(function () {
      var args = getAPIGatewayRequestForContainerData(request);
      return Promise.resolve(getAPIGatewayDataFromParent(args)).then(function (response) {
        var output = response.data;
        if (output.containerMetrics) {
          dispatch({
            type: "GET_CONTAINER_METRICS_RESPONSE",
            containerMetrics: getContainerMetrics(output.containerMetrics)
          });
        }
        if (output.containers) {
          dispatch({
            type: "GET_CONTAINER_DATA_RESPONSE",
            containers: getContainerList(output.containers, dispatch),
            containersForVisualView: getContainersForVisualView(output.containers)
          });
        }
      });
    }, function () {
      console.log("Error");
    });
    return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getPackageDetailsFromApi = function getPackageDetailsFromApi(dispatch, shipmentTypeFilters) {
  try {
    var nodeId = getNodeId();
    var mappedFilters = getMappingForPackageFilters(shipmentTypeFilters);
    var request = {
      nodeId: nodeId,
      packageStatusMap: {
        PendingStow: []
      },
      filters: mappedFilters
    };
    var _temp = _catch(function () {
      var args = getAPIGatewayRequestForPackageDetails(request);
      return Promise.resolve(getAPIGatewayDataFromParent(args)).then(function (response) {
        var output = response.data;
        if (output.packageResultList) {
          dispatch({
            type: "GET_PACKAGE_DETAILS_RESPONSE",
            packageResultList: getPackageResultList(output.packageResultList)
          });
        }
      });
    }, function () {
      console.log("Error");
    });
    return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
  } catch (e) {
    return Promise.reject(e);
  }
};
function getContainerInfo(dispatch, shipmentTypeFilters) {
  getContainerFromApi(dispatch, shipmentTypeFilters);
}
function getPackageMetricsInfo(dispatch, shipmentTypeFilters) {
  getPackageMetrics(dispatch, shipmentTypeFilters);
}
function getPackageDetailsInfo(dispatch, shipmentTypeFilters) {
  getPackageDetailsFromApi(dispatch, shipmentTypeFilters);
}
function getMappingForPackageFilters(shipmentTypeFilters) {
  var updatedShipmentTypeFilters = [];
  shipmentTypeFilters.forEach(function (selectedValue) {
    if (Object.keys(PackageTypeMapForFetchingPackageMetrics).includes(selectedValue)) {
      var val = PackageTypeMapForFetchingPackageMetrics[selectedValue];
      if (Array.isArray(val)) {
        updatedShipmentTypeFilters = [].concat(updatedShipmentTypeFilters, val);
      } else {
        updatedShipmentTypeFilters.push(val);
      }
    }
  });
  var filters = [];
  if (updatedShipmentTypeFilters.length != 0) {
    filters = [{
      __type: "TermFilter:http://internal.amazon.com/coral/com.amazon.containervisibilityservice.model.filter/",
      filterMap: {
        SHIPMENT_TYPE: updatedShipmentTypeFilters
      }
    }];
  }
  return filters;
}
function getAPIGatewayRequestForContainerData(request) {
  return {
    resourcePath: "/cvs/container/data",
    httpMethod: "post",
    processName: "stow",
    requestBody: request
  };
}
function getAPIGatewayRequestForPackageMetricsData(request) {
  return {
    resourcePath: "/cvs/package/metrics",
    httpMethod: "post",
    processName: "stow",
    requestBody: request
  };
}
function getAPIGatewayRequestForPackageDetails(request) {
  return {
    resourcePath: "/cvs/package/details",
    httpMethod: "post",
    processName: "stow",
    requestBody: request
  };
}
function getPackageMetricsData(packageMetricsData) {
  return {
    pendingStowCount: packageMetricsData.pendingStowCount,
    stowCompliance: packageMetricsData.stowCompliance
  };
}
function getContainerMetrics(containerMetrics) {
  return {
    closeSuccessRate: containerMetrics.closeSuccessRate,
    stageCompliance: containerMetrics.stageCompliance,
    loadingCompliance: containerMetrics.loadingCompliance,
    departCompliance: containerMetrics.departCompliance,
    pendingCloseCount: containerMetrics.pendingCloseCount,
    pendingStageCount: containerMetrics.pendingStageCount,
    pendingDepartCount: containerMetrics.pendingDepartCount,
    closeFailedCount: containerMetrics.closeFailedCount
  };
}
function getContainerList(containers, dispatch) {
  var containersWithNoRisk = [];
  var containerWithRisk = [];
  var atRiskContainersCount = 0;
  containers.forEach(function (container) {
    if (!container.isAtRisk) {
      var containerWithNoRiskModel = {
        openedTime: container.openedTime,
        closedTime: container.closedTime,
        stagedTime: container.stagedTime,
        loadedTime: container.loadedTime,
        departedTime: container.departedTime,
        criticalPullTime: container.criticalPullTime,
        containerId: container.containerId,
        resourceLabel: container.resourceLabel,
        containerState: convertStatus(container.containerState),
        status: container.containerState,
        volume: container.volume,
        vrID: container.vrID,
        destination: container.destination,
        stackingFilter: container.stackingFilter,
        cptDDMM: convertSecondsToDDMM(container.criticalPullTime),
        cptHHMM: convertSecondsToHHMM(container.criticalPullTime),
        openedTimeDDMM: convertSecondsToDDMM(container.openedTime),
        openedTimeHHMMSS: convertSecondsToHHMMSS(container.openedTime),
        isAtRisk: container.isAtRisk
      };
      containersWithNoRisk.push(containerWithNoRiskModel);
    } else {
      var containerWithRiskModel = {
        openedTime: container.openedTime,
        closedTime: container.closedTime,
        criticalPullTime: container.criticalPullTime,
        containerId: container.containerId,
        resourceLabel: container.resourceLabel,
        containerState: convertStatus(container.containerState),
        status: container.containerState,
        volume: container.volume,
        vrID: container.vrID,
        destination: container.destination,
        stackingFilter: container.stackingFilter,
        cptDDMM: convertSecondsToDDMM(container.criticalPullTime),
        cptHHMM: convertSecondsToHHMM(container.criticalPullTime),
        openedTimeDDMM: convertSecondsToDDMM(container.openedTime),
        openedTimeHHMMSS: convertSecondsToHHMMSS(container.openedTime),
        isAtRisk: container.isAtRisk
      };
      atRiskContainersCount = atRiskContainersCount + 1;
      containerWithRisk.push(containerWithRiskModel);
    }
  });
  dispatch({
    type: "GET_AT_RISK_CONTAINERS_COUNT",
    atRiskContainerCount: atRiskContainersCount
  });
  var sortedContainerWithRisk = sortContainers(containerWithRisk);
  var sortedContainerWithNoRisk = sortContainers(containersWithNoRisk);
  return sortedContainerWithRisk.concat(sortedContainerWithNoRisk);
}
function sortContainers(containers) {
  containers.sort(function (a, b) {
    return a.criticalPullTime < b.criticalPullTime ? -1 : a.criticalPullTime > b.criticalPullTime ? 1 : 0;
  });
  return containers;
}
function getContainersForVisualView(containers) {
  var group_to_values = containers.reduce(function (obj, item) {
    obj[item.criticalPullTime] = obj[item.criticalPullTime] || [];
    var container = {
      openedTime: item.openedTime,
      containerId: item.containerId,
      resourceLabel: item.resourceLabel,
      status: item.status,
      volume: item.volume,
      VrID: item.vrID,
      destination: item.destination,
      stackingFilter: item.stackingFilter,
      isAtRisk: item.isAtRisk,
      sortOrder: getSortOrderForContainers(item.status)
    };
    obj[item.criticalPullTime].push(container);
    return obj;
  }, {});
  var groups = Object.keys(group_to_values).map(function (key) {
    return {
      criticalPullTime: key,
      containers: group_to_values[key]
    };
  });
  groups.sort(function (a, b) {
    return a.criticalPullTime < b.criticalPullTime ? -1 : a.criticalPullTime > b.criticalPullTime ? 1 : 0;
  });
  var result = [];
  result = customModel(groups);
  return result;
}
function customModel(groups) {
  var result = [];
  groups.forEach(function (container) {
    var containerModel = {
      criticalPullTime: convertLocaleTime(parseInt(container.criticalPullTime, 10)),
      containers: getModeledContainer(container)
    };
    result.push(containerModel);
  });
  return result;
}
function getModeledContainer(container) {
  container.containers.sort(function (a, b) {
    return a.sortOrder < b.sortOrder ? -1 : a.sortOrder > b.sortOrder ? 1 : 0;
  });
  var AtRiskContainers = [];
  var NoRiskContainers = [];
  container.containers.forEach(function (entity) {
    if (entity.isAtRisk === true) {
      AtRiskContainers.push(entity);
    } else {
      NoRiskContainers.push(entity);
    }
  });
  return NoRiskContainers.concat(AtRiskContainers);
}
function convertStatus(status) {
  if (status === "OPENED") return [1, 0, 0, 0, 0];else if (status === "CLOSED") return [1, 1, 0, 0, 0];else if (status === "STAGED") return [1, 1, 1, 0, 0];else if (status === "LOADED") return [1, 1, 1, 1, 0];else if (status === "CLOSE_FAILED") return [1, -1, 0, 0, 0];
  return [1, 1, 1, 1, 1];
}
function getPackageResultList(packageResultList) {
  var result = [];
  packageResultList.forEach(function (packageResultList) {
    var packageResultModel = {
      minutesInState: packageResultList.minutesInState,
      reason: packageResultList.reason,
      routeCode: packageResultList.routeCode,
      sortZone: packageResultList.sortZone,
      state: packageResultList.state,
      trackingId: packageResultList.trackingId
    };
    result.push(packageResultModel);
  });
  return result;
}
function getSortOrderForContainers(containerState) {
  if (containerState === "OPENED") return 1;else if (containerState === "CLOSED") return 2;else if (containerState === "STAGED") return 3;else if (containerState === "LOADED") return 4;else if (containerState === "DEPARTED") return 5;else if (containerState === "CLOSE_FAILED") return 6;
}

var ContainerDataReducer = function ContainerDataReducer(state, action) {
  switch (action.type) {
    case "LOAD_CONTAINER_DATA":
      getContainerInfo(action.data.dispatch, action.data.shipmentTypeFilters);
      return state;
    case "GET_CONTAINER_METRICS_RESPONSE":
      return _extends({}, state, {
        containerMetrics: action.containerMetrics
      });
    case "GET_CONTAINER_DATA_RESPONSE":
      return _extends({}, state, {
        containers: action.containers,
        containersForVisualView: action.containersForVisualView
      });
    case "GET_AT_RISK_CONTAINERS_COUNT":
      return _extends({}, state, {
        atRiskContainerCount: action.atRiskContainerCount
      });
    default:
      return state;
  }
};

var ContainerDataContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();
var ContainerDataContextProvider = function ContainerDataContextProvider(props) {
  var state = {
    containers: [],
    containerMetrics: {
      closeSuccessRate: 0,
      stageCompliance: 0,
      loadingCompliance: 0,
      departCompliance: 0,
      pendingCloseCount: 0,
      pendingStageCount: 0,
      pendingDepartCount: 0,
      closeFailedCount: 0
    },
    containersForVisualView: [],
    atRiskContainerCount: 0,
    shipmentTypeFilters: []
  };
  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(ContainerDataReducer, state),
    ViewModelA = _useReducer[0],
    DispatchA = _useReducer[1];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContainerDataContext.Provider, {
    value: {
      ViewModelA: ViewModelA,
      DispatchA: DispatchA
    }
  }, props.children);
};

var filterOption = function filterOption(container, filter, key, viewModel) {
  if (!viewModel[filter] || viewModel[filter].length === 0) {
    return true;
  }
  var result = false;
  viewModel[filter].forEach(function (filterValue) {
    if (container[key] === filterValue) {
      result = true;
    }
  });
  return result;
};
var atRiskFilter = function atRiskFilter(container, viewModel) {
  if (viewModel["status"] && viewModel["status"].length !== 0 && viewModel["status"][0] === ContainerMetric.AT_RISK) {
    return container.isAtRisk;
  }
  return true;
};

var ContainerFilterReducer = function ContainerFilterReducer(state, action) {
  switch (action.type) {
    case "SELECT_STATUS":
      return _extends({}, state, {
        status: action.status,
        containerState: action.containerState
      });
    case "REMOVE_ALL_FILTER":
      {
        var newState = _extends({}, state);
        Object.entries(state).forEach(function (entry) {
          var key = entry[0];
          var values = entry[1];
          if (Array.isArray(values) && values.length && key !== 'data') {
            newState[key] = [];
          }
        });
        return newState;
      }
    case "REMOVE_FILTER":
      {
        var _extends2;
        var _action$data = action.data,
          key = _action$data.key,
          value = _action$data.value;
        state[key] = state[key].filter(function (item) {
          return item !== value;
        });
        var newItem = state[key].filter(function (item) {
          return item !== value;
        });
        return _extends({}, state, (_extends2 = {}, _extends2[key] = newItem, _extends2));
      }
    default:
      return state;
  }
};

var ContainerFilterContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();
var ContainerFilterContextProvider = function ContainerFilterContextProvider(props) {
  var initialState = {
    viewType: TABULAR_GRID_VIEW,
    status: [],
    containerState: []
  };
  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(ContainerFilterReducer, initialState),
    ViewModelF = _useReducer[0],
    DispatchF = _useReducer[1];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContainerFilterContext.Provider, {
    value: {
      ViewModelF: ViewModelF,
      DispatchF: DispatchF
    }
  }, props.children);
};

var ReverseVisualGridView = function ReverseVisualGridView() {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    screenState = _useState[0],
    setScreenState = _useState[1];
  var _useDeviceLayout = useDeviceLayout(),
    spacingInset_shorthand2 = _useDeviceLayout.spacingInset_shorthand2;
  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ContainerDataContext),
    ViewModelA = _useContext.ViewModelA;
  var _useContext2 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ContainerFilterContext),
    ViewModelF = _useContext2.ViewModelF;
  var ContainersForVisualView = ViewModelA.containers;
  ContainersForVisualView = ContainersForVisualView.filter(function (container) {
    return filterOption(container, "containerState", "status", ViewModelF);
  }).filter(function (container) {
    return atRiskFilter(container, ViewModelF);
  });
  ContainersForVisualView = getContainersForVisualView(ContainersForVisualView);
  var close_failed_icon = Object(__WEBPACK_IMPORTED_MODULE_21_emotion__["css"])({
    color: '#cc0c39',
    position: 'relative',
    marginTop: '-7px',
    marginRight: '-7px',
    float: 'right'
  });
  var getToolTipBody = function getToolTipBody(container) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a, {
      className: "tooltip-text",
      spacing: "none"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
      alignmentHorizontal: "center"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, container.containerId), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a, {
      spacing: "none",
      alignmentHorizontal: "left"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      style: {
        textAlign: 'left'
      }
    }, "ContainerState: ", container.status), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      style: {
        textAlign: 'left'
      }
    }, "ResourceLabel: ", container.resourceLabel), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      style: {
        textAlign: 'left'
      }
    }, "StackingFilter: ", container.stackingFilter)));
  };
  var toggleScreen = function toggleScreen() {
    setScreenState(!screenState);
  };
  var getRouteColor = function getRouteColor(status) {
    switch (status) {
      case PENDING_CLOSE:
        return "#F39C12";
      case PENDING_STAGE:
        return "#CB2FBF";
      case PENDING_LOADING:
        return "#FAD000";
      case PENDING_DEPART:
        return "#47C2EC";
      case DEPARTED:
        return "#98C91E";
      case AT_RISK:
        return "#FFFFFF";
      case CLOSED_FAILED:
        return "#F39C12";
      default:
        return "#BBC0C1";
    }
  };
  var getContainerState = function getContainerState(containerState) {
    switch (containerState) {
      case "OPENED":
        return PENDING_CLOSE;
      case "CLOSED":
        return PENDING_STAGE;
      case "STAGED":
        return PENDING_LOADING;
      case "LOADED":
        return PENDING_DEPART;
      case "DEPARTED":
        return DEPARTED;
      case "CLOSE_FAILED":
        return CLOSED_FAILED;
      case "AT_RISK":
        return AT_RISK;
      default:
        return "#BBC0C1";
    }
  };
  var boxWidth = 16;
  var boxHeight = 16;
  var closedFailedIconSrc = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjIgMjIiPjxjaXJjbGUgY3g9IjExIiBjeT0iLTEwNDEuMzYiIHI9IjgiIHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwLTEgMC0xMDMwLjM2KSIgb3BhY2l0eT0iLjk4IiBmaWxsPSIjZGE0NDUzIi8+PHBhdGggZD0ibS0yNi4zMDkgMTguMDdjLTEuMTggMC0yLjEzNS45NjgtMi4xMzUgMi4xMjl2MTIuODJjMCAxLjE3Ni45NDggMi4xMjkgMi4xMzUgMi4xMjkgMS4xODMgMCAyLjEzNS0uOTY4IDIuMTM1LTIuMTI5di0xMi44MmMwLTEuMTc2LS45NDYtMi4xMjktMi4xMzUtMi4xMjl6bTAgMjEuMzQ4Yy0xLjE4IDAtMi4xMzUuOTU0LTIuMTM1IDIuMTM1IDAgMS4xOC45NTQgMi4xMzUgMi4xMzUgMi4xMzUgMS4xODEgMCAyLjEzNS0uOTU0IDIuMTM1LTIuMTM1IDAtMS4xOC0uOTUyLTIuMTM1LTIuMTM1LTIuMTM1eiIgdHJhbnNmb3JtPSJtYXRyaXgoLjMwMDU2IDAgMCAuMzAwNTYgMTguOTAyIDEuNzI4KSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIi8+PC9zdmc+";
  var getSquareBox = function getSquareBox(color, height, width) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_box___default.a, {
      minHeight: height,
      minWidth: width,
      maxHeight: height,
      maxWidth: width,
      backgroundColor: color
    });
  };
  var getDefaultLegend = function getDefaultLegend(color, labelId, defaultLabel) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
      wrap: "none",
      spacing: "small"
    }, renderBox(color, defaultLabel), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
      id: labelId,
      defaultMessage: defaultLabel
    })));
  };
  var getBoxColor = function getBoxColor(isAtRisk, status) {
    if (isAtRisk === true) status = "AT_RISK";
    var convert = getContainerState(status);
    return getRouteColor(convert);
  };
  var getSquareBoxWithBoundary = function getSquareBoxWithBoundary(color) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_box___default.a, {
      minHeight: boxHeight,
      minWidth: boxWidth,
      maxHeight: boxHeight,
      maxWidth: boxWidth,
      backgroundColor: "#FF0000",
      spacingInset: "xxsmall"
    }, getSquareBox(color, boxHeight - 4, boxWidth - 4));
  };
  var renderContainerBox = function renderContainerBox(color, isAtRisk, containerState) {
    return isAtRisk ? getSquareBoxWithBoundary(color) : getSquareBox2(color, boxWidth, boxHeight, containerState);
  };
  var getSquareBox2 = function getSquareBox2(color, height, width, containerState) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_box___default.a, {
      minHeight: height,
      minWidth: width,
      maxHeight: height,
      maxWidth: width,
      backgroundColor: color
    }, containerState === 'CLOSE_FAILED' && getCloseFailedIcon());
  };
  var getCloseFailedIcon = function getCloseFailedIcon() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
      className: close_failed_icon,
      alt: "closeFailed",
      src: closedFailedIconSrc,
      width: "16px",
      height: "16px"
    });
  };
  var renderBox = function renderBox(color, defaultLabel) {
    return defaultLabel === AT_RISK ? getSquareBoxWithBoundary(color) : getSquareBox(color, boxWidth, boxHeight);
  };
  var renderVisualGridBoxes = function renderVisualGridBoxes(index) {
    return index.map(function (container) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        style: {
          textDecoration: "none",
          cursor: "pointer"
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
        className: "html-tooltip",
        spacing: "none",
        spacingInset: "none"
      }, getToolTipBody(container), renderContainerBox(getBoxColor(container.isAtRisk, container.status), container.isAtRisk, container.status)));
    });
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
    widths: ["grid-12"],
    alignmentVertical: "top",
    spacingInset: spacingInset_shorthand2,
    wrap: "down"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_full_screen___default.a, {
    enabled: screenState,
    onChange: function onChange(enabled) {
      return setScreenState(enabled);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollableElementWrapper, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table___default.a, {
    showStripes: false,
    headerColumns: 1,
    stickyHeaderColumn: true,
    headerRows: 1,
    spacing: "small",
    fixHeaderRows: true,
    showDividers: false
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableRow"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
    alignmentHorizontal: "left",
    width: "10%"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.CPT",
    defaultMessage: "CPT"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tooltip___default.a, {
    position: "right",
    title: "The CPT presented on this page is based on the distribution of packages (most frequent CPT among all containerized packages) and may differ from FMC's CPT",
    id: "tooltip.cpt"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon___default.a, {
    className: "custom-tool-tip",
    tokens: __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_info_knockout___default.a
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
    alignmentHorizontal: "center",
    width: "15%"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.Containers",
    defaultMessage: "Containers"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
    alignmentHorizontal: "right",
    width: "75%"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
    widths: ["grid-10", "grid-2"],
    spacing: "xlarge",
    alignmentHorizontal: "left"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
    spacing: "large"
  }, getDefaultLegend(getRouteColor(PENDING_CLOSE), "reverse.pendingClose", PENDING_CLOSE), getDefaultLegend(getRouteColor(PENDING_STAGE), "reverse.pendingStage", PENDING_STAGE), getDefaultLegend(getRouteColor(PENDING_LOADING), "reverse.pendingLoading", PENDING_LOADING), getDefaultLegend(getRouteColor(PENDING_DEPART), "reverse.pendingDepart", PENDING_DEPART), getDefaultLegend(getRouteColor(DEPARTED), "reverse.departed", DEPARTED), getDefaultLegend(getRouteColor(AT_RISK), "reverse.isAtRisk", AT_RISK), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
    wrap: "none",
    spacing: "small"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    className: close_failed_icon,
    alt: "closeFailed",
    src: closedFailedIconSrc,
    width: "16px",
    height: "16px"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.closeFailed",
    defaultMessage: "Closed Failed"
  }))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
    alignmentHorizontal: "right",
    spacing: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_link___default.a, {
    onClick: toggleScreen,
    type: "secondary"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.toggleFullscreen",
    defaultMessage: "Toggle fullscreen"
  }))))), ContainersForVisualView.map(function (index) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableRow"], {
      key: index
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
      alignmentHorizontal: "center"
    }, index.criticalPullTime), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
      alignmentHorizontal: "center"
    }, index.containers.length), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
      width: "100%",
      spacing: "small",
      wrap: "down"
    }, renderVisualGridBoxes(index.containers))));
  })))))));
};

var ExportCSV = function ExportCSV(props) {
  var csvLink = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef();
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
    csvData = _useState[0],
    setCSVData = _useState[1];
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (csvData.length > 0) {
      csvLink.current.link.click();
    }
  }, [csvData]);
  var exportCSVFile = function exportCSVFile() {
    if (props.csvDataProvider) {
      var result = props.csvDataProvider();
      if (Array.isArray(result)) {
        setCSVData(result);
      }
    }
  };
  var fileName = props.filePrefix + "_" + new Date().toISOString().slice(0, 10) + ".csv";
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
    width: "100%",
    alignmentHorizontal: "right",
    spacingInset: "none",
    spacing: "none"
  }, props.isLink ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_link___default.a, {
    type: "secondary",
    onClick: exportCSVFile
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.exportCSV",
    defaultMessage: "Export To CSV"
  })) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_button___default.a, {
    type: "tertiary",
    size: "small",
    onClick: exportCSVFile
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.exportCSV",
    defaultMessage: "Export To CSV"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_react_csv__["CSVLink"], {
    data: csvData,
    ref: csvLink,
    filename: fileName,
    target: "_blank",
    fileencoding: "UTF-8"
  })));
};

function getPendingStowDataInCSVFormat(pendingStowList) {
  var csvData = [];
  csvData.push(PENDING_STOW_TABLE_COLUMNS);
  pendingStowList.forEach(function (pendingStowObject) {
    var rowData = [];
    rowData.push(pendingStowObject.trackingId);
    rowData.push(pendingStowObject.routeCode);
    rowData.push(pendingStowObject.state);
    rowData.push(pendingStowObject.reason);
    rowData.push(pendingStowObject.sortZone);
    csvData.push(rowData);
  });
  return csvData;
}
function getContainerDataInCSVFormat(containerDataList) {
  var csvData = [];
  csvData.push(CONTAINER_TABLE_COLUMNS);
  containerDataList.forEach(function (container) {
    var rowData = [];
    rowData.push(container.containerId);
    rowData.push(container.status);
    rowData.push(container.resourceLabel);
    rowData.push(container.volume);
    rowData.push(container.destination);
    rowData.push(container.stackingFilter);
    rowData.push(convertLocaleTime(container.openedTime));
    rowData.push(convertLocaleTime(container.closedTime));
    rowData.push(convertLocaleTime(container.stagedTime));
    rowData.push(convertLocaleTime(container.loadedTime));
    rowData.push(convertLocaleTime(container.departedTime));
    rowData.push(convertLocaleTime(container.criticalPullTime));
    rowData.push(container.vrID);
    csvData.push(rowData);
  });
  return csvData;
}

var Timer = function Timer(_ref) {
  var startTime = _ref.startTime;
  var initialSeconds = Math.floor(startTime);
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(initialSeconds),
    seconds = _useState[0],
    setSeconds = _useState[1];
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var intervalId = setInterval(function () {
      setSeconds(function (prevSeconds) {
        return prevSeconds + 1;
      });
    }, 1000);
    return function () {
      return clearInterval(intervalId);
    };
  }, []);
  var days = Math.floor(seconds / 86400);
  var hours = Math.floor(seconds % 86400 / 3600);
  var minutes = Math.floor(seconds % 3600 / 60);
  var formattedTime = "" + (days > 0 ? days + "d " : '') + (hours > 0 || days > 0 ? hours + "h " : '') + minutes + "m";
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", {
    style: {
      fontSize: '12px',
      color: 'red'
    }
  }, formattedTime));
};

var ReverseTableGridView = function ReverseTableGridView() {
  var _useDeviceLayout = useDeviceLayout(),
    spacingInset_shorthand2 = _useDeviceLayout.spacingInset_shorthand2;
  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ContainerDataContext),
    ViewModelA = _useContext.ViewModelA;
  var _useContext2 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ContainerFilterContext),
    ViewModelF = _useContext2.ViewModelF;
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
    currentPage = _useState[0],
    setCurrentPage = _useState[1];
  var changePage = function changePage(pageNumber) {
    setCurrentPage(pageNumber);
  };
  var _useState2 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(100),
    pageCount = _useState2[0],
    setPageCount = _useState2[1];
  var customColorForCheck = Object(__WEBPACK_IMPORTED_MODULE_21_emotion__["css"])({
    color: "mediumseagreen"
  });
  var customColorForClose = Object(__WEBPACK_IMPORTED_MODULE_21_emotion__["css"])({
    color: "#00A8E1"
  });
  var customColorForCloseFailed = Object(__WEBPACK_IMPORTED_MODULE_21_emotion__["css"])({
    color: "#FF0000"
  });
  var getRedirectLink = function getRedirectLink(containerId) {
    var nodeId = getNodeId();
    var baseUrl = "";
    baseUrl = getRegion() === "jp" ? "https://trans-logistics-fe.amazon.com/sortcenter/tantei?nodeId=" : getRegion() === "eu" ? "https://trans-logistics-eu.amazon.com/sortcenter/tantei?nodeId=" : "https://trans-logistics.amazon.com/sortcenter/tantei?nodeId=";
    var parsedContainerId = JSON.parse(containerId);
    return baseUrl + nodeId + "&searchType=Container&searchId=" + parsedContainerId;
  };
  var redirectToTroubleshootingToolPage = function redirectToTroubleshootingToolPage(containerId) {
    var url = getRedirectLink(containerId);
    window.open(url, "_blank");
  };
  var containerDataConversionHandler = function containerDataConversionHandler() {
    return getContainerDataInCSVFormat(ViewModelA.containers);
  };
  var Containers = ViewModelA.containers;
  Containers = Containers.filter(function (container) {
    return filterOption(container, "containerState", "status", ViewModelF);
  }).filter(function (container) {
    return atRiskFilter(container, ViewModelF);
  });
  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])("departed"),
    sortColumn = _useState3[0],
    setSortColumn = _useState3[1];
  var _useState4 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])("ascending"),
    sortDirection = _useState4[0],
    setSortDirection = _useState4[1];
  var onSort = function onSort(_ref) {
    var sortColumn = _ref.sortColumn,
      sortDirection = _ref.sortDirection;
    setSortDirection(sortDirection);
    setSortColumn(sortColumn);
    setCurrentPage(1);
  };
  var customSort = function customSort(a, b, sortColumn, direction) {
    if (sortColumn === "departed") {
      var onesInA = a.containerState.reduce(function (first, second) {
        return first + second;
      }, 0);
      var onesInB = b.containerState.reduce(function (first, second) {
        return first + second;
      }, 0);
      if (onesInA < onesInB) {
        return direction === "ascending" ? -1 : 1;
      } else if (onesInA > onesInB) {
        return direction === "ascending" ? 1 : -1;
      } else {
        return a.criticalPullTime < b.criticalPullTime ? -1 : a.criticalPullTime > b.criticalPullTime ? 1 : 0;
      }
    } else {
      console.log("Other than departed column has been selected ");
      if (a[sortColumn] < b[sortColumn]) {
        return direction === "ascending" ? -1 : 1;
      }
      if (a[sortColumn] > b[sortColumn]) {
        return direction === "ascending" ? 1 : -1;
      }
      return 0;
    }
  };
  Containers.sort(function (a, b) {
    return customSort(a, b, sortColumn, sortDirection);
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
    widths: ["grid-12"],
    alignmentVertical: "top",
    spacingInset: spacingInset_shorthand2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollableElementWrapper, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table___default.a, {
    showDividers: true,
    showStripes: true,
    headerRows: 1,
    spacing: "small",
    headerColumns: 1,
    stickyHeaderColumn: true,
    fixHeaderRows: true,
    sortColumn: sortColumn,
    sortDirection: sortDirection,
    onSort: onSort
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableActionBar"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
    width: "100%",
    spacingInset: spacingInset_shorthand2,
    alignmentHorizontal: "right"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__amzn_meridian_select___default.a, {
    label: "Container Count",
    value: pageCount,
    onChange: setPageCount,
    placeholder: "100",
    size: "small",
    width: 180
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__amzn_meridian_select__["SelectOption"], {
    value: "10",
    label: "10"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__amzn_meridian_select__["SelectOption"], {
    value: "20",
    label: "20"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__amzn_meridian_select__["SelectOption"], {
    value: "50",
    label: "50"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__amzn_meridian_select__["SelectOption"], {
    value: "100",
    label: "100"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__amzn_meridian_select__["SelectOption"], {
    value: "200",
    label: "200"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExportCSV, {
    isLink: true,
    csvDataProvider: containerDataConversionHandler,
    filePrefix: "Container"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableRow"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
    alignmentHorizontal: "left",
    sortColumn: "criticalPullTime"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.CPT",
    defaultMessage: "CPT"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tooltip___default.a, {
    position: "right",
    title: "The CPT presented on this page is based on the distribution of packages (most frequent CPT among all containerized packages) and may differ from FMC's CPT",
    id: "tooltip.cpt"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon___default.a, {
    className: "custom-tool-tip",
    tokens: __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_info_knockout___default.a
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
    alignmentHorizontal: "left",
    sortColumn: "openedTime"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.OpenedAt",
    defaultMessage: "Opened At"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
    alignmentHorizontal: "left",
    sortColumn: "containerId"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.ContainerID",
    defaultMessage: "Container ID"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
    alignmentHorizontal: "left",
    sortColumn: "resourceLabel"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.ResourceLabel",
    defaultMessage: "Resource Label"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
    alignmentHorizontal: "left"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.Opened",
    defaultMessage: "Opened"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
    alignmentHorizontal: "left"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.Closed",
    defaultMessage: "Closed"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
    alignmentHorizontal: "left"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.Staged",
    defaultMessage: "Staged"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
    alignmentHorizontal: "left"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.Loaded",
    defaultMessage: "Loaded"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
    alignmentHorizontal: "left",
    sortColumn: "departed"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.Departed",
    defaultMessage: "Departed"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
    alignmentHorizontal: "left"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.Volume",
    defaultMessage: "Volume"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
    alignmentHorizontal: "left",
    sortColumn: "destination"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "reverse.Destination",
    defaultMessage: "Destination"
  }))), Containers && Containers.slice((currentPage - 1) * pageCount, currentPage * pageCount).map(function (container, index) {
    var color = container.isAtRisk ? '#FEF2B8' : '#FFFFFF';
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableRow"], {
      key: index,
      backgroundColor: color
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, convertLocaleTime(container.criticalPullTime))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, convertLocaleTime(container.openedTime))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], {
      alignmentHorizontal: "left"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_link___default.a, {
      type: "secondary",
      onClick: function onClick() {
        return redirectToTroubleshootingToolPage(JSON.stringify(container.containerId));
      }
    }, container.containerId)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], null, container.resourceLabel), container.containerState.map(function (val, index) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        style: {
          marginRight: '8px'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon___default.a, {
        tokens: getIcon(container, index),
        className: val > 0 ? customColorForCheck : val < 0 || shouldActivateTimer(container, index) ? customColorForCloseFailed : customColorForClose
      })), shouldActivateTimer(container, index) ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Timer, {
        startTime: (Date.now() - container.closedTime) / 1000
      }) : null));
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], null, container.volume), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"], null, container.destination));
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
    alignmentVertical: "top",
    alignmentHorizontal: "center"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__amzn_meridian_pagination___default.a, {
    numberOfPages: Math.ceil(Containers.length / pageCount),
    onChange: function onChange(pageNumber) {
      return changePage(pageNumber);
    },
    currentPage: currentPage
  })))));
};

var ReverseRouteGridView = function ReverseRouteGridView() {
  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ReverseFilterContext),
    viewModelF = _useContext.viewModelF;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, viewModelF.waveViewType === VISUAL_GRID_VIEW ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReverseVisualGridView, null) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReverseTableGridView, null));
};

var PackageDataReducer = function PackageDataReducer(state, action) {
  switch (action.type) {
    case "LOAD_PACKAGE_DATA":
      getPackageMetricsInfo(action.data.dispatch, action.data.shipmentTypeFilters);
      return _extends({}, state, {
        shipmentTypeFilters: action.data.shipmentTypeFilters
      });
    case "LOAD_FILTERED_PACKAGE_DATA":
      getPackageDetailsInfo(action.data.dispatch, action.data.shipmentTypeFilters);
      return _extends({}, state, {
        shipmentTypeFilters: action.data.shipmentTypeFilters
      });
    case "GET_PACKAGE_DETAILS_RESPONSE":
      {
        return _extends({}, state, {
          packageResultList: action.packageResultList
        });
      }
    case "GET_PACKAGE_METRICS_RESPONSE":
      return _extends({}, state, {
        packageMetricsData: action.packageMetricsData
      });
    default:
      return state;
  }
};

var PackageDataContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();
var PackageMetricDataContextProvider = function PackageMetricDataContextProvider(props) {
  var state = {
    packageMetricsData: {
      pendingStowCount: 0,
      stowCompliance: 0
    },
    shipmentTypeFilters: [],
    packageResultList: []
  };
  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(PackageDataReducer, state),
    ViewModelB = _useReducer[0],
    DispatchB = _useReducer[1];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PackageDataContext.Provider, {
    value: {
      ViewModelB: ViewModelB,
      DispatchB: DispatchB
    }
  }, props.children);
};

var ActionableMetricView = function ActionableMetricView(data) {
  var onMetricCountClick = function onMetricCountClick() {
    if (data.onMetricCountClick) {
      data.onMetricCountClick();
    }
  };
  var _useDeviceLayout = useDeviceLayout(),
    isMobile = _useDeviceLayout.isMobile;
  var headerFont = isMobile ? "b100" : "b200";
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
    type: headerFont,
    alignment: "start"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: data.containerStatus.title,
    defaultMessage: data.containerStatus.message
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
    type: "d50",
    alignment: "start"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_link___default.a, {
    type: "secondary",
    onClick: onMetricCountClick
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    style: {
      color: data.containerStatus.color
    }
  }, data.containerStatus.value)))));
};

var ReverseMetricView = function ReverseMetricView(_ref) {
  var _items, _widths, _spacing;
  var descAlt = _ref.descAlt;
  var _useDeviceLayout = useDeviceLayout(),
    spacingInset_shorthand4 = _useDeviceLayout.spacingInset_shorthand4;
  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ContainerDataContext),
    ViewModelA = _useContext.ViewModelA,
    DispatchA = _useContext.DispatchA;
  var _useContext2 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(PackageDataContext),
    ViewModelB = _useContext2.ViewModelB,
    DispatchB = _useContext2.DispatchB;
  var _useContext3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ContainerFilterContext),
    DispatchF = _useContext3.DispatchF;
  var _useContext4 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ShipmentTypeFilterContext),
    ViewModelG = _useContext4.ViewModelG;
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var repeat = withRefreshTime(function () {
      DispatchA({
        type: "LOAD_CONTAINER_DATA",
        data: {
          dispatch: DispatchA,
          shipmentTypeFilters: ViewModelG.shipmentTypeFilters
        }
      });
    }, 30000);
    return function () {
      if (repeat) {
        clearInterval(repeat);
      }
    };
  }, [ViewModelG.shipmentTypeFilters]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var repeat = withRefreshTime(function () {
      DispatchB({
        type: "LOAD_PACKAGE_DATA",
        data: {
          dispatch: DispatchB,
          shipmentTypeFilters: ViewModelG.shipmentTypeFilters
        }
      });
    }, 30000);
    return function () {
      if (repeat) {
        clearInterval(repeat);
      }
    };
  }, [ViewModelG.shipmentTypeFilters]);
  var getPendingStowListURL = function getPendingStowListURL() {
    return "#pendingStowList";
  };
  var ReversePackages = function ReversePackages() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_box___default.a, {
      type: "outline",
      spacingInset: "400"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
      type: "H200"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
      id: "reverse.reversePackages",
      defaultMessage: "Reverse Packages"
    }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
      type: "b200",
      alignment: "start"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
      type: "b200",
      id: "reverse.pendingStow",
      defaultMessage: "Pending Stow"
    }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
      type: "d50",
      alignment: "start"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_link___default.a, {
      href: getPendingStowListURL(),
      type: "secondary"
    }, ViewModelB.packageMetricsData.pendingStowCount, " ")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tooltip___default.a, {
      position: "right",
      title: "% of eligible packages stowed to a reverse container in the past 24 hours.",
      id: "tooltip.stowCompliance"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
      type: "b200",
      alignment: "start"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
      id: "reverse.stowCompliance",
      defaultMessage: "Stow Compliance"
    })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
      type: "d50",
      alignment: "start"
    }, (ViewModelB.packageMetricsData.stowCompliance * 100.00).toFixed(2) === "100.00" ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      style: {
        color: "#00688D"
      }
    }, ViewModelB.packageMetricsData.stowCompliance * 100.00 + "%") : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      style: {
        color: "#CB330B"
      }
    }, (ViewModelB.packageMetricsData.stowCompliance * 100.00).toFixed(1) + "%"))))));
  };
  var ReverseContainers = function ReverseContainers() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_box___default.a, {
      type: "outline",
      spacingInset: "400"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
      type: "H200"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
      id: "reverse.reverseContainers",
      defaultMessage: "Reverse Containers"
    }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionableMetricView, {
      onMetricCountClick: function onMetricCountClick() {
        return DispatchF({
          type: 'SELECT_STATUS',
          status: [ContainerMetric.PENDING_CLOSE],
          containerState: [ContainerState.OPENED, ContainerState.CLOSE_FAILED]
        });
      },
      containerStatus: {
        title: "reverse.pendingClose",
        message: "Pending Close",
        value: ViewModelA.containerMetrics.pendingCloseCount,
        color: "#00688D"
      }
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionableMetricView, {
      onMetricCountClick: function onMetricCountClick() {
        return DispatchF({
          type: 'SELECT_STATUS',
          status: [ContainerMetric.PENDING_STAGE],
          containerState: [ContainerState.CLOSED]
        });
      },
      containerStatus: {
        title: "reverse.pendingStage",
        message: "Pending Stage",
        value: ViewModelA.containerMetrics.pendingStageCount,
        color: "#00688D"
      }
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionableMetricView, {
      onMetricCountClick: function onMetricCountClick() {
        return DispatchF({
          type: 'SELECT_STATUS',
          status: [ContainerMetric.PENDING_DEPART],
          containerState: [ContainerState.STAGED, ContainerState.LOADED]
        });
      },
      containerStatus: {
        title: "reverse.pendingDepart",
        message: "Pending Depart",
        value: ViewModelA.containerMetrics.pendingDepartCount,
        color: "#00688D"
      }
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionableMetricView, {
      onMetricCountClick: function onMetricCountClick() {
        return DispatchF({
          type: 'SELECT_STATUS',
          status: [ContainerMetric.CLOSE_FAILED],
          containerState: [ContainerState.CLOSE_FAILED]
        });
      },
      containerStatus: {
        title: "reverse.closeFailed",
        message: "Close Failed",
        value: ViewModelA.containerMetrics.closeFailedCount,
        color: "#00688D"
      }
    })));
  };
  var ContainerScanCompliance = function ContainerScanCompliance() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_box___default.a, {
      type: "outline",
      spacingInset: "400"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
      type: "H200"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
      id: "reverse.containerScanCompliance",
      defaultMessage: "Container Scan Compliance"
    }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tooltip___default.a, {
      position: "right",
      title: "% of containers which are successfully closed in the past 7 days.",
      id: "tooltip.closeSuccess"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
      type: "b200",
      alignment: "start"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
      id: "reverse.closeSuccess",
      defaultMessage: "Close Success"
    })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
      type: "d50",
      alignment: "start"
    }, formatMetricsPercentage(ViewModelA.containerMetrics.closeSuccessRate)))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tooltip___default.a, {
      position: "right",
      title: "% of containers staged or loaded within 24 hours of container close.",
      id: "tooltip.stageCompliance"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
      type: "b200",
      alignment: "start"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
      id: "reverse.stageCompliance",
      defaultMessage: "Stage Compliance"
    })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
      type: "d50",
      alignment: "start"
    }, formatMetricsPercentage(ViewModelA.containerMetrics.stageCompliance)))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tooltip___default.a, {
      position: "right",
      title: "% of containers loaded on D-1 out of all containers with D-1 CPT.",
      id: "tooltip.loadingCompliance"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
      type: "b200",
      alignment: "start"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
      id: "reverse.loadingCompliance",
      defaultMessage: "Loading Compliance"
    })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
      type: "d50",
      alignment: "start"
    }, formatMetricsPercentage(ViewModelA.containerMetrics.loadingCompliance)))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tooltip___default.a, {
      position: "right",
      title: "% of containers departed on D-1 out of all containers with D-1 CPT.",
      id: "tooltip.departCompliance"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
      type: "b200",
      alignment: "start"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
      id: "reverse.departCompliance",
      defaultMessage: "Depart Compliance"
    })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
      type: "d50",
      alignment: "start"
    }, formatMetricsPercentage(ViewModelA.containerMetrics.departCompliance))))));
  };
  var AtRisk = function AtRisk() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_box___default.a, {
      type: "outline",
      spacingInset: "400"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tooltip___default.a, {
      position: "right",
      title: descAlt
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a, {
      type: "H200",
      alignment: "start"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
      id: "reverse.atRisk",
      defaultMessage: "At risk"
    }))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionableMetricView, {
      onMetricCountClick: function onMetricCountClick() {
        return DispatchF({
          type: 'SELECT_STATUS',
          status: [ContainerMetric.AT_RISK],
          containerState: []
        });
      },
      containerStatus: {
        title: "reverse.containerCount",
        message: "Container Count",
        value: ViewModelA.atRiskContainerCount,
        color: ViewModelA.atRiskContainerCount === 0 ? "#00688D" : "#CB330B"
      }
    })));
  };
  var ShipmentTypeFilterBox = function ShipmentTypeFilterBox() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShipmentTypeField, null);
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a, {
    spacingInset: spacingInset_shorthand4,
    spacing: "small"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_responsive___default.a, {
    query: "max-width",
    props: {
      items: (_items = {
        default: [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReversePackages, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReverseContainers, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContainerScanCompliance, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AtRisk, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShipmentTypeFilterBox, null)]
      }, _items[LARGE] = [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReversePackages, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReverseContainers, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContainerScanCompliance, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AtRisk, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShipmentTypeFilterBox, null)], _items),
      widths: (_widths = {
        default: []
      }, _widths[LARGE] = ["35%", "35%", "30%", "100%"], _widths),
      spacing: (_spacing = {
        default: "large"
      }, _spacing[LARGE] = "large", _spacing)
    }
  }, function (_ref2) {
    var items = _ref2.items,
      widths = _ref2.widths,
      spacing = _ref2.spacing;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
      spacing: spacing,
      maxWidth: "100%",
      widths: widths,
      wrap: "down",
      alignmentVertical: "stretch"
    }, items);
  }));
};
var formatMetricsPercentage = function formatMetricsPercentage(value) {
  var percentage = value * 100;
  if (percentage === 100) {
    return "100%";
  }
  var rounded = Math.round(percentage * 10) / 10;
  return rounded.toFixed(1).replace(/\.0$/, '') + "%";
};
ReverseMetricView.propTypes = {
  desc: propTypes.string,
  descAlt: propTypes.string
};

var ContainerFilter = function ContainerFilter() {
  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ContainerFilterContext),
    ViewModelF = _useContext.ViewModelF,
    DispatchF = _useContext.DispatchF;
  var isFilterSet = function isFilterSet() {
    var result = false;
    Object.entries(ViewModelF).forEach(function (entry) {
      var values = entry[1];
      result = result || Array.isArray(values) && values.length;
    });
    return result;
  };
  var clearAllFilters = function clearAllFilters() {
    DispatchF({
      type: 'REMOVE_ALL_FILTER'
    });
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a, {
    spacingInset: "none large",
    spacing: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
    width: "100%",
    spacingInset: "small none none none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
    spacing: "small"
  }, Object.entries(ViewModelF).map(function (entry) {
    var key = entry[0];
    var values = entry[1];
    return Array.isArray(values) && key !== 'containerState' ? values.map(function (value) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_tag___default.a, {
        key: value,
        type: "theme",
        onClose: function onClose() {
          return DispatchF({
            type: 'REMOVE_FILTER',
            data: {
              key: key,
              value: value
            }
          });
        }
      }, value);
    }) : null;
  }), isFilterSet() ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_link___default.a, {
    onClick: clearAllFilters,
    type: "secondary"
  }, "Clear all") : null)));
};

var ReverseTab = function ReverseTab() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DeviceLayoutProvider, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContainerFilterContextProvider, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReverseFilterContextProvider, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShipmentTypeFilterContextProvider, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContainerDataContextProvider, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PackageMetricDataContextProvider, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReverseHeader, REVERSE_PAGE_HEADERS.REVERSE), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContainerFilter, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReverseMetricView, HOVER_DESCRIPTION.AT_RISK), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReverseViewSelector, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReverseRouteGridView, null))))))));
};

var PendingStowDetails = function PendingStowDetails(props) {
  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(PackageDataContext),
    ViewModelB = _useContext.ViewModelB,
    DispatchB = _useContext.DispatchB;
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),
    baseURL = _useState[0],
    setBaseURL = _useState[1];
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    try {
      var filter = JSON.parse(props.value);
      DispatchB({
        type: "LOAD_FILTERED_PACKAGE_DATA",
        data: {
          dispatch: DispatchB,
          shipmentTypeFilters: filter
        }
      });
      getDocumentURL().then(function (value) {
        setBaseURL(value);
      });
    } catch (error) {
      console.log("Error while loading filtered data ", error);
    }
  }, []);
  var PendingStowList = ViewModelB.packageResultList;
  var _useState2 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  var changePage = function changePage(pageNumber) {
    setCurrentPage(pageNumber);
  };
  var getPackageShareableLink = function getPackageShareableLink(trackingId) {
    var shareablePath = "detailPage/";
    var redirectPath = new URL(baseURL.replace("containerSummary", "search"));
    redirectPath.searchParams.set("shareableLink", shareablePath.concat(trackingId));
    return redirectPath;
  };
  var pendingStowDataConversionHandler = function pendingStowDataConversionHandler() {
    return getPendingStowDataInCSVFormat(ViewModelB.packageResultList);
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a, {
    spacingInset: "large medium none large"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
    width: "100%",
    spacingInset: "none",
    alignmentHorizontal: "right"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExportCSV, {
    isLink: true,
    csvDataProvider: pendingStowDataConversionHandler,
    filePrefix: "PendingStow"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__amzn_meridian_breadcrumb_breadcrumb_group___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__amzn_meridian_breadcrumb___default.a, {
    href: "#containerSummary"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "pendingStowList.reverse",
    defaultMessage: "Reverse"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__amzn_meridian_breadcrumb___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "pendingStowList.pendingStowList",
    defaultMessage: "Pending Stow List"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_heading___default.a, {
    level: 1
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "pendingStowList.packageStowList",
    defaultMessage: "Pending Stow List"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollableElementWrapper, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table___default.a, {
    headerRows: 1,
    spacing: "small"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__amzn_meridian_table_table_row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_table_table_cell___default.a, {
    sortColumn: "trackingId"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "pendingStowList.trackingId",
    defaultMessage: "Tracking Id"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_table_table_cell___default.a, {
    sortColumn: "state"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "pendingStowList.state",
    defaultMessage: "State"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_table_table_cell___default.a, {
    sortColumn: "reason"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "pendingStowList.reason",
    defaultMessage: "Reason"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_table_table_cell___default.a, {
    sortColumn: "sortZone"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], {
    id: "pendingStowList.location",
    defaultMessage: "Sort Zone"
  }))), PendingStowList && PendingStowList.slice((currentPage - 1) * 15, currentPage * 15).map(function (pendingObject) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__amzn_meridian_table_table_row___default.a, {
      key: pendingObject.trackingId
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_link___default.a, {
      target: "_blank",
      rel: "noreferrer noopener",
      href: getPackageShareableLink(pendingObject.trackingId)
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_table_table_cell___default.a, null, pendingObject.trackingId)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_table_table_cell___default.a, null, pendingObject.state), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_table_table_cell___default.a, null, pendingObject.reason), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_table_table_cell___default.a, null, pendingObject.sortZone));
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a, {
    alignmentVertical: "top",
    alignmentHorizontal: "center"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__amzn_meridian_pagination___default.a, {
    numberOfPages: Math.ceil(PendingStowList.length / 15),
    onChange: function onChange(pageNumber) {
      return changePage(pageNumber);
    },
    currentPage: currentPage
  }))));
};

var getSessionData = function getSessionData() {
  return sessionStorage.getItem("filter");
};
var PendingStowList = function PendingStowList() {
  var filter = getSessionData();
  console.log("Value of filter in session storage :", filter);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PackageMetricDataContextProvider, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PendingStowDetails, {
    value: filter
  })));
};


//# sourceMappingURL=index.modern.js.map


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _default = /*#__PURE__*/_react["default"].createContext({});

exports["default"] = _default;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var isSafari = exports.isSafari = function isSafari() {
  return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  );
};

var isJsons = exports.isJsons = function isJsons(array) {
  return Array.isArray(array) && array.every(function (row) {
    return (typeof row === "undefined" ? "undefined" : _typeof(row)) === 'object' && !(row instanceof Array);
  });
};

var isArrays = exports.isArrays = function isArrays(array) {
  return Array.isArray(array) && array.every(function (row) {
    return Array.isArray(row);
  });
};

var jsonsHeaders = exports.jsonsHeaders = function jsonsHeaders(array) {
  return Array.from(array.map(function (json) {
    return Object.keys(json);
  }).reduce(function (a, b) {
    return new Set([].concat(_toConsumableArray(a), _toConsumableArray(b)));
  }, []));
};

var jsons2arrays = exports.jsons2arrays = function jsons2arrays(jsons, headers) {
  headers = headers || jsonsHeaders(jsons);

  var headerLabels = headers;
  var headerKeys = headers;
  if (isJsons(headers)) {
    headerLabels = headers.map(function (header) {
      return header.label;
    });
    headerKeys = headers.map(function (header) {
      return header.key;
    });
  }

  var data = jsons.map(function (object) {
    return headerKeys.map(function (header) {
      return getHeaderValue(header, object);
    });
  });
  return [headerLabels].concat(_toConsumableArray(data));
};

var getHeaderValue = exports.getHeaderValue = function getHeaderValue(property, obj) {
  var foundValue = property.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function (o, p, i, arr) {
    var value = o[p];
    if (value === undefined || value === null) {
      arr.splice(1);
    } else {
      return value;
    }
  }, obj);

  return foundValue === undefined ? property in obj ? obj[property] : '' : foundValue;
};

var elementOrEmpty = exports.elementOrEmpty = function elementOrEmpty(element) {
  return typeof element === 'undefined' || element === null ? '' : element;
};

var joiner = exports.joiner = function joiner(data) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
  var enclosingCharacter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '"';

  return data.filter(function (e) {
    return e;
  }).map(function (row) {
    return row.map(function (element) {
      return elementOrEmpty(element);
    }).map(function (column) {
      return "" + enclosingCharacter + column + enclosingCharacter;
    }).join(separator);
  }).join("\n");
};

var arrays2csv = exports.arrays2csv = function arrays2csv(data, headers, separator, enclosingCharacter) {
  return joiner(headers ? [headers].concat(_toConsumableArray(data)) : data, separator, enclosingCharacter);
};

var jsons2csv = exports.jsons2csv = function jsons2csv(data, headers, separator, enclosingCharacter) {
  return joiner(jsons2arrays(data, headers), separator, enclosingCharacter);
};

var string2csv = exports.string2csv = function string2csv(data, headers, separator, enclosingCharacter) {
  return headers ? headers.join(separator) + "\n" + data : data.replace(/"/g, '""');
};

var toCSV = exports.toCSV = function toCSV(data, headers, separator, enclosingCharacter) {
  if (isJsons(data)) return jsons2csv(data, headers, separator, enclosingCharacter);
  if (isArrays(data)) return arrays2csv(data, headers, separator, enclosingCharacter);
  if (typeof data === 'string') return string2csv(data, headers, separator);
  throw new TypeError("Data should be a \"String\", \"Array of arrays\" OR \"Array of objects\" ");
};

var buildURI = exports.buildURI = function buildURI(data, uFEFF, headers, separator, enclosingCharacter) {
  var csv = toCSV(data, headers, separator, enclosingCharacter);
  var type = isSafari() ? 'application/csv' : 'text/csv';
  var blob = new Blob([uFEFF ? "\uFEFF" : '', csv], { type: type });
  var dataURI = "data:" + type + ";charset=utf-8," + (uFEFF ? "\uFEFF" : '') + csv;

  var URL = window.URL || window.webkitURL;

  return typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob);
};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropsNotForwarded = exports.defaultProps = exports.propTypes = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
  data: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.array, _propTypes.func]).isRequired,
  headers: _propTypes.array,
  target: _propTypes.string,
  separator: _propTypes.string,
  filename: _propTypes.string,
  uFEFF: _propTypes.bool,
  onClick: _propTypes.func,
  asyncOnClick: _propTypes.bool,
  enclosingCharacter: _propTypes.string
};

var defaultProps = exports.defaultProps = {
  separator: ',',
  filename: 'generatedBy_react-csv.csv',
  uFEFF: true,
  asyncOnClick: false,
  enclosingCharacter: '"'
};

var PropsNotForwarded = exports.PropsNotForwarded = ['data', 'headers'];

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(312);
module.exports = __webpack_require__(318);


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(313).enable();
  window.Promise = __webpack_require__(315);
}

// fetch() polyfill for making API calls.
__webpack_require__(316);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(317);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(187);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(187);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 316 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App_js__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_tokens_base_font_amazon_ember_css__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_tokens_base_font_amazon_ember_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_tokens_base_font_amazon_ember_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_thunk__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_rootReducer__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__handler_LocaleHandler__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl_locale_data_en__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl_locale_data_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_intl_locale_data_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl_locale_data_ja__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl_locale_data_ja___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_intl_locale_data_ja__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl_locale_data_it__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl_locale_data_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_intl_locale_data_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl_locale_data_fr__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl_locale_data_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_intl_locale_data_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_intl_locale_data_es__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_intl_locale_data_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_intl_locale_data_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl_locale_data_de__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl_locale_data_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_intl_locale_data_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_intl_locale_data_ar__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_intl_locale_data_ar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_intl_locale_data_ar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_intl_locale_data_tr__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_intl_locale_data_tr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_intl_locale_data_tr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_utils_ErrorBoundary__ = __webpack_require__(836);
Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_12_react_intl_locale_data_en___default.a);Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_13_react_intl_locale_data_ja___default.a);Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_14_react_intl_locale_data_it___default.a);Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_17_react_intl_locale_data_de___default.a);Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_15_react_intl_locale_data_fr___default.a);Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_16_react_intl_locale_data_es___default.a);Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_18_react_intl_locale_data_ar___default.a);Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_19_react_intl_locale_data_tr___default.a);var store=Object(__WEBPACK_IMPORTED_MODULE_4_redux__["d" /* createStore */])(__WEBPACK_IMPORTED_MODULE_8__reducers_rootReducer__["a" /* default */],//Thunk is a middleware that looks at every action that passes through the system, and if itâ€™s a function,
// it calls that function. Thatâ€™s all it does.
Object(__WEBPACK_IMPORTED_MODULE_4_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_7_redux_thunk__["a" /* default */]));//Routes
Object(__WEBPACK_IMPORTED_MODULE_11__handler_LocaleHandler__["b" /* getLocale */])().then(function(locale){document.getElementsByTagName('html')[0].setAttribute("dir",Object(__WEBPACK_IMPORTED_MODULE_11__handler_LocaleHandler__["a" /* getDirection */])(locale));__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["b" /* IntlProvider */],{locale:locale,messages:Object(__WEBPACK_IMPORTED_MODULE_11__handler_LocaleHandler__["c" /* getMessages */])(locale)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* HashRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_utils_ErrorBoundary__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_App_js__["a" /* default */],null))))),document.getElementById('root'));});

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(320),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(322),r=__webpack_require__(323);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
b>c?b:c;0===b&&(Fh=null);$h(a,b)}
function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(324);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_SVRoute__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_RouteConstants__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HeatMapV2__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HeatMap__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__associate_Associate__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PackageList__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MetricUtility__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stowBuffer_StowBuffer__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__stowBuffer_Bay__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_context_DeviceLayoutContext__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_container_visibility_website__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_theme_blue_dark__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_theme_blue_dark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_theme_blue_dark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_theme_blue_light__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_theme_blue_light___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_theme_blue_light__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_theme__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_theme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_theme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__handler_ParentDataHandler__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AppComponent=function AppComponent(){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* DARK_MODE */].LIGHT),_useState2=_slicedToArray(_useState,2),currentDarkMode=_useState2[0],setCurrentDarkMode=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){Object(__WEBPACK_IMPORTED_MODULE_17__handler_ParentDataHandler__["j" /* setDarkModeStateListener */])(setCurrentDarkMode);Object(__WEBPACK_IMPORTED_MODULE_17__handler_ParentDataHandler__["c" /* getDarkModeStatus */])();},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_theme___default.a,{tokens:currentDarkMode===__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* DARK_MODE */].DARK?__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_theme_blue_dark___default.a:__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_theme_blue_light___default.a},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_context_DeviceLayoutContext__["a" /* DeviceLayoutProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* HashRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,Object.keys(__WEBPACK_IMPORTED_MODULE_3__utils_RouteConstants__["a" /* DEFAULT_ROUTES */]).map(function(path,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:path,key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */],{to:__WEBPACK_IMPORTED_MODULE_3__utils_RouteConstants__["a" /* DEFAULT_ROUTES */][path]}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utils_SVRoute__["a" /* SVRoute */],{path:'/heatMapv2/:routeCodePrefixes',component:__WEBPACK_IMPORTED_MODULE_5__HeatMapV2__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utils_SVRoute__["a" /* SVRoute */],{path:'/heatMapv2',component:__WEBPACK_IMPORTED_MODULE_5__HeatMapV2__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utils_SVRoute__["a" /* SVRoute */],{path:'/heatMap/:routeCodePrefixes',component:__WEBPACK_IMPORTED_MODULE_6__HeatMap__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utils_SVRoute__["a" /* SVRoute */],{path:'/heatMap',component:__WEBPACK_IMPORTED_MODULE_6__HeatMap__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utils_SVRoute__["a" /* SVRoute */],{path:'/associate',component:__WEBPACK_IMPORTED_MODULE_7__associate_Associate__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utils_SVRoute__["a" /* SVRoute */],{path:'/packageList',component:__WEBPACK_IMPORTED_MODULE_8__PackageList__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utils_SVRoute__["a" /* SVRoute */],{path:'/stowBuffer',component:__WEBPACK_IMPORTED_MODULE_10__stowBuffer_StowBuffer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utils_SVRoute__["a" /* SVRoute */],{path:'/bay/:machine',component:__WEBPACK_IMPORTED_MODULE_11__stowBuffer_Bay__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utils_SVRoute__["a" /* SVRoute */],{path:'/containerSummary',component:__WEBPACK_IMPORTED_MODULE_13__amzn_container_visibility_website__["b" /* ReverseTab */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utils_SVRoute__["a" /* SVRoute */],{path:'/pendingStowList',component:__WEBPACK_IMPORTED_MODULE_13__amzn_container_visibility_website__["a" /* PendingStowList */]})))));};var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;publishRoutePath(this.props.location);this.onRouteSwitch=this.props.history.listen(function(){publishRoutePath(_this2.props.location);});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.onRouteSwitch();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AppComponent,null);}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function publishRoutePath(location){var metricProcessName="SCC_STOW";var metricName=location.pathname;Object(__WEBPACK_IMPORTED_MODULE_9__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(App));

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(97);






var MAX_SIGNED_31_BIT_INT = 1073741823;

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + __WEBPACK_IMPORTED_MODULE_3_gud___default()() + '__';

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer =
  /*#__PURE__*/
  function (_Component2) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext || createReactContext;

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 327 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(329);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(334)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(191);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SVRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(6);
var SVRoute=function SVRoute(_ref){var exact=_ref.exact,path=_ref.path,Component=_ref.component;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:exact,path:path,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props));}});};

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_ErrorPage__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__handler_LocaleHandler__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_alert_knockout__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_alert_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_alert_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_help_knockout__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_help_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_help_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_row__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_heading__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__actions_OverviewActions__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions_OptionsActionsV2__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__StowBreakdown__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__actions_ConfigActions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__RefreshTimer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__common_context_DeviceLayoutContext__ = __webpack_require__(41);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StowOverview=function(_Component){_inherits(StowOverview,_Component);function StowOverview(props){_classCallCheck(this,StowOverview);var _this=_possibleConstructorReturn(this,(StowOverview.__proto__||Object.getPrototypeOf(StowOverview)).call(this,props));_this.aisleRowClicked=function(clickedCluster){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_OptionsActionsV2__["u" /* navigationAdded */])({key:'Cluster',value:clickedCluster}));return;};_this.getCombinedMetricsMapCluster=function(cluster){var _this$props=_this.props,stowPackageMetricsMapCluster=_this$props.stowPackageMetricsMapCluster,minOfWorkMetricsMapCluster=_this$props.minOfWorkMetricsMapCluster,inductPackageMetricsMapCluster=_this$props.inductPackageMetricsMapCluster,stowAssociateMetricsMapCluster=_this$props.stowAssociateMetricsMapCluster;var defaultMetricValue="-";return{cluster:cluster,plannedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMapCluster[cluster].plannedPackages;},defaultMetricValue),receivedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return inductPackageMetricsMapCluster[cluster].receivedPackages;},defaultMetricValue),currentInductedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMapCluster[cluster].currentInductedPackages;},defaultMetricValue),stowRate:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMapCluster[cluster].stowRate;},defaultMetricValue),minutesOfWork:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return isNaN(parseFloat(minOfWorkMetricsMapCluster[cluster].minutesOfWork).toFixed(1))?defaultMetricValue:parseFloat(minOfWorkMetricsMapCluster[cluster].minutesOfWork).toFixed(1);},defaultMetricValue),activeStowers:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowAssociateMetricsMapCluster[cluster].activeStowers;},defaultMetricValue)};};_this.getCombinedMetricsMapAisle=function(aisle){var _this$props2=_this.props,atRiskAislesMetricsMap=_this$props2.atRiskAislesMetricsMap,inductPackageMetricsMapAisle=_this$props2.inductPackageMetricsMapAisle,stowPackageMetricsMapAisle=_this$props2.stowPackageMetricsMapAisle;var defaultMetricValue="-";return{aisle:aisle,isAtRisk:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return atRiskAislesMetricsMap[aisle].isAtRisk;},defaultMetricValue),minutesOfWork:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return _this.getMinutesOfWorkForGivenAisle(aisle);},defaultMetricValue),adjacencyScore:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return atRiskAislesMetricsMap[aisle].adjacencyScore;},defaultMetricValue),baselineAdjacencyScore:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return atRiskAislesMetricsMap[aisle].baselineAdjacencyScore;},defaultMetricValue),associateAlias:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return atRiskAislesMetricsMap[aisle].associateAlias.toString().substring(0,atRiskAislesMetricsMap[aisle].associateAlias.toString().lastIndexOf('@'));},defaultMetricValue),//.tostring().substring(0,4), defaultMetricValue),
activeStowers:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return atRiskAislesMetricsMap[aisle].activeStowers;},defaultMetricValue),receivedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return inductPackageMetricsMapAisle[aisle].receivedPackages;},defaultMetricValue),currentInductedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMapAisle[aisle].currentInductedPackages;},defaultMetricValue)};};_this.renderAisleCount=function(value1,value2){return value1==="-"?value2==="-"?"-":value2:value2==="-"?value1:value1+value2;};_this.renderAdjacencyScoreValue=function(value1){return value1==="-"?"-":parseFloat(value1).toFixed(2);};_this.renderAlias=function(value1,value2){return value1==="-"?value2==="-"?"-":value2:value2==="-"?value1:value1===value2?value1:value1+","+value2;};_this.isADTAVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_20__constants__["j" /* FEATURES */].ADTA_VISIBILITY];};_this.isDRSStowVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_20__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY];};_this.isCPTFilterEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_20__constants__["j" /* FEATURES */].IS_CPT_FILTER_ENABLED];};_this.renderAdjacencyScoreAlert=function(baselineAdjacencyScore,aisleAdjacencyScore){return aisleAdjacencyScore>1.2*baselineAdjacencyScore?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_alert_knockout___default.a}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",null);};_this.renderAdjacencyScoreInfo=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:_this.props.intl.formatMessage({id:"tooltip.overview.adjacency_score"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_help_knockout___default.a}));};_this.renderAdjacencyScoreColumnHeading=function(backgroundColor){return _this.props.isSmartStowEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right",backgroundColor:backgroundColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"overview.adjacency_score",defaultMessage:"Stow Adherence"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",null," ",_this.renderAdjacencyScoreInfo())):null;};_this.renderAdjacencyScoreColumnValue=function(backgroundColor,a1combinedMetricsMap){return _this.props.isSmartStowEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{backgroundColor:backgroundColor,alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",null,_this.renderAdjacencyScoreAlert(a1combinedMetricsMap.baselineAdjacencyScore,a1combinedMetricsMap.adjacencyScore)," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",null,_this.renderAdjacencyScoreValue(a1combinedMetricsMap.adjacencyScore))):null;};_this.findViewByOptionValues=function(navigationOptions,selectedView){switch(_this.props.capability){case __WEBPACK_IMPORTED_MODULE_12__enums__["e" /* Capability */].SSD:return _this.findViewForSSD(navigationOptions,selectedView);case __WEBPACK_IMPORTED_MODULE_12__enums__["e" /* Capability */].AMZL:default:return _this.findViewForAmzlCore(navigationOptions,selectedView);case __WEBPACK_IMPORTED_MODULE_12__enums__["e" /* Capability */].AR_NEXT_GEN:return _this.findViewForArNextGen(navigationOptions,selectedView);}};_this.findViewForAmzlCore=function(navigationOptions,selectedView){if(__WEBPACK_IMPORTED_MODULE_12__enums__["q" /* ViewType */].SIDELINE_VIEW===selectedView)return __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].FLOOR_LOCATION_VIEW;if(Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["u" /* isOnlyRouteViewApplicable */])(_this.state.nodeId,_this.props.capability)||__WEBPACK_IMPORTED_MODULE_12__enums__["q" /* ViewType */].ROUTE_VIEW===selectedView){return __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].ROUTE_VIEW;}else if(navigationOptions.length===2)return __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].SORT_ZONE_VIEW;else if(navigationOptions.length===1)return __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].AISLE_VIEW;else return __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].CLUSTER;};_this.findViewForSSD=function(navigationOptions,selectedView){if(__WEBPACK_IMPORTED_MODULE_12__enums__["q" /* ViewType */].ROUTE_VIEW===selectedView){return __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].ROUTE_VIEW;}if(navigationOptions.length===1)return __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].CART_LOCATION_VIEW;return __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].ZONE_VIEW;};_this.findViewForArNextGen=function(navigationOptions,selectedView){if(__WEBPACK_IMPORTED_MODULE_12__enums__["q" /* ViewType */].ROUTE_VIEW===selectedView){return __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].ROUTE_VIEW;}if(navigationOptions.length===1)return __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].FLOOR_VIEW;else return __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].STATION_PAIR_VIEW;};_this.state={nodeId:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["m" /* getNodeId */])(),routeCodePrefixes:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["d" /* extractRouteCodePrefixesFromParam */])(props),sortColumn:"aisle",sortDirection:"ascending",flag:false,locale:"en"};return _this;}_createClass(StowOverview,[{key:"render",value:function render(){var _this2=this;var _props=this.props,navigationOptions=_props.navigationOptions,selectedCycle=_props.selectedCycle,selectedCycleId=_props.selectedCycleId,selectedView=_props.selectedView,isInitialView=_props.isInitialView,selectedCPTId=_props.selectedCPTId,filterIdentifier=_props.filterIdentifier;//For initial view open route view when route code prefix list exists in params
if(this.state.routeCodePrefixes&&this.state.routeCodePrefixes!==""&&isInitialView){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_OptionsActionsV2__["x" /* viewChanged */])(__WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].ROUTE_VIEW));}var view=this.findViewByOptionValues(navigationOptions,selectedView);var renderSubComponent=function renderSubComponent(){clearInterval(_this2.timer);switch(view){case __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].AISLE_VIEW:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__StowBreakdown__["a" /* default */],null);case __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].SORT_ZONE_VIEW:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__StowBreakdown__["a" /* default */],null);case __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].STATION_PAIR_VIEW:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__StowBreakdown__["a" /* default */],null);case __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].FLOOR_VIEW:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__StowBreakdown__["a" /* default */],null);case __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].ROUTE_VIEW:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__StowBreakdown__["a" /* default */],null);case __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].ZONE_VIEW:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__StowBreakdown__["a" /* default */],null);case __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].CART_LOCATION_VIEW:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__StowBreakdown__["a" /* default */],null);case __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].FLOOR_LOCATION_VIEW:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__StowBreakdown__["a" /* default */],null);case __WEBPACK_IMPORTED_MODULE_12__enums__["l" /* HeatMapView */].CLUSTER_VIEW:default:return _this2.renderStowOverview(selectedCycle,selectedCycleId,selectedCPTId,filterIdentifier,_this2.isCPTFilterEnabled());}};return renderSubComponent();}},{key:"renderStowOverview",value:function renderStowOverview(selectedCycle,selectedCycleId,selectedCPTId,filterIdentifier,isCPTFilterEnabled){var _this3=this;if(this.state.flag===false&&selectedCycle&&selectedCycleId){this.fetchOverviewData(this.state.nodeId,selectedCycle,selectedCycleId,selectedCPTId,filterIdentifier,isCPTFilterEnabled);this.setState({flag:true});}this.timer=setInterval(function(){if(!document.hidden){_this3.fetchOverviewData(_this3.state.nodeId,selectedCycle,selectedCycleId,selectedCPTId,filterIdentifier,isCPTFilterEnabled);}},__WEBPACK_IMPORTED_MODULE_20__constants__["z" /* refreshInterval */]);return this.renderAtRiskAisle(selectedCycle,selectedCycleId,selectedCPTId,filterIdentifier,isCPTFilterEnabled);}},{key:"fetchOverviewData",value:function fetchOverviewData(nodeId,cycle,cycleId,CPTId,filterIdentifier,isCPTFilterEnabled){if(cycle&&cycleId||CPTId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_OverviewActions__["o" /* getMinOfWorkMetricsForOverviewCluster */])(nodeId,this.isDRSStowVisibilityEnabled(),[cycle],[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_OverviewActions__["l" /* getAtRiskAislesForOverview */])(nodeId,this.isDRSStowVisibilityEnabled(),[cycle],[cycleId],[CPTId],filterIdentifier,isCPTFilterEnabled,this.props.isSmartStowEnabled));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_OverviewActions__["m" /* getInductPackageMetricsForOverviewAisle */])(nodeId,[cycle],[CPTId],filterIdentifier,isCPTFilterEnabled));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_OverviewActions__["n" /* getInductPackageMetricsForOverviewCluster */])(nodeId,[cycle],[CPTId],filterIdentifier,isCPTFilterEnabled));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_OverviewActions__["r" /* getStowPackageMetricsForOverviewCluster */])(nodeId,this.isDRSStowVisibilityEnabled(),[cycle],[cycleId],[CPTId],filterIdentifier,isCPTFilterEnabled));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_OverviewActions__["q" /* getStowPackageMetricsForOverviewAisle */])(nodeId,this.isDRSStowVisibilityEnabled(),[cycle],[cycleId],[CPTId],filterIdentifier,isCPTFilterEnabled));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_OverviewActions__["p" /* getStowAssociateMetricsForOverviewCluster */])(nodeId,[cycle],[CPTId],filterIdentifier,isCPTFilterEnabled));}}},{key:"renderAtRiskAisle",value:function renderAtRiskAisle(){var _this4=this;var _props2=this.props,loading=_props2.loading,error=_props2.error,stowPackageMetricsMapAisle=_props2.stowPackageMetricsMapAisle,stowPackageMetricsMapCluster=_props2.stowPackageMetricsMapCluster,inductPackageMetricsMapCluster=_props2.inductPackageMetricsMapCluster,stowAssociateMetricsMapCluster=_props2.stowAssociateMetricsMapCluster,atRiskAislesMetricsMap=_props2.atRiskAislesMetricsMap,inductPackageMetricsMapAisle=_props2.inductPackageMetricsMapAisle;if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__utils_ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});}var allAisles=[].concat(_toConsumableArray(Object.keys(stowPackageMetricsMapAisle)),_toConsumableArray(Object.keys(atRiskAislesMetricsMap)),_toConsumableArray(Object.keys(inductPackageMetricsMapAisle)));var allClusters=[].concat(_toConsumableArray(Object.keys(stowPackageMetricsMapCluster)),_toConsumableArray(Object.keys(inductPackageMetricsMapCluster)),_toConsumableArray(Object.keys(stowAssociateMetricsMapCluster)));var distinctAisles=[].concat(_toConsumableArray(new Set(allAisles)));var distinctClusters=[].concat(_toConsumableArray(new Set(allClusters)));var filteredClusters=Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["k" /* getFilteredLocations */])(distinctClusters,stowPackageMetricsMapCluster,this.isDRSStowVisibilityEnabled());var filteredAisles=Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["k" /* getFilteredLocations */])(distinctAisles,stowPackageMetricsMapAisle,this.isDRSStowVisibilityEnabled());if(loading&&!distinctAisles.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_column___default.a,{height:"400px",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader___default.a,null));}var onSort=function onSort(sortDetails){_this4.setState({sortDirection:sortDetails.sortDirection});};var that=this;function customCompare(a,b){return Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["b" /* convertToString */])(a).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["b" /* convertToString */])(b),that.state.locale,{numeric:true});}var direction=this.state.sortDirection;filteredAisles.sort(function(a1,a2){return customCompare(a1,a2);});var clusterAislesPair={};var filteredAtRiskAislesPair=[];var _loop=function _loop(cluster){clusterAislesPair[cluster]=filteredAisles.filter(function(Aisle){return Aisle.startsWith(cluster);});filteredAtRiskAislesPair.push.apply(filteredAtRiskAislesPair,_toConsumableArray(_this4.atRiskPairMap(clusterAislesPair[cluster],clusterAislesPair[cluster].length)));};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=filteredClusters[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var cluster=_step.value;_loop(cluster);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}filteredAtRiskAislesPair.sort(function(a1,a2){if(direction==="ascending"){return customCompare(a1[0],a2[0]);}else{return customCompare(a2[0],a1[0]);}});if(!filteredAtRiskAislesPair.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__RefreshTimer__["a" /* default */],{deps:[atRiskAislesMetricsMap]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_column___default.a,{type:"fill",spacingInset:"small medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_heading___default.a,{level:2,type:"h200",alignment:"left",color:"primary",spacing:"large"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"aisle.No Aisles at Risk",defaultMessage:"No Aisles at Risk"}))),this.renderClusters());}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__RefreshTimer__["a" /* default */],{deps:[atRiskAislesMetricsMap]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_column___default.a,{type:"fill",spacingInset:"small medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_heading___default.a,{level:2,type:"h200",alignment:"left",color:"error",spacing:"large"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_alert_knockout___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_heading___default.a,{color:"primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.overview.aisles_at_risk"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"overview.aisles_at_risk",defaultMessage:" Aisles at Risk"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default.a,{headerRows:1,showDividers:true,showStripes:true,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true,sortColumn:this.state.sortColumn,sortDirection:this.state.sortDirection,onSort:onSort,"data-cy":"atRiskAisleTable"},this.renderAtRiskAisleHeading(),filteredAtRiskAislesPair.map(function(aisles){return _this4.renderAtRiskAisleRow(aisles);}))),this.renderClusters());}},{key:"renderAtRiskAisleHeading",value:function renderAtRiskAisleHeading(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{sortColumn:"aisle",backgroundColor:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"aisle.aisle",defaultMessage:"Aisle"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right",backgroundColor:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"aisle.arrived",defaultMessage:"Arrived"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right",backgroundColor:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"aisle.inducted",defaultMessage:"Inducted"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right",backgroundColor:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"aisle.minutes_of_work",defaultMessage:"Minutes of Work"})),this.renderAdjacencyScoreColumnHeading("secondary"));}},{key:"renderAtRiskAisleRow",value:function renderAtRiskAisleRow(aisles){var _this5=this;var a1combinedMetricsMap=this.getCombinedMetricsMapAisle(aisles[0]);var a2combinedMetricsMap=this.getCombinedMetricsMapAisle(aisles[1]);var aisle;if(a2combinedMetricsMap.aisle===undefined){aisle=a1combinedMetricsMap.aisle.replace("-","");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,key:aisles[0],onClick:function onClick(){return _this5.aisleRowClicked(aisles[0][0]);},"data-cy":"atRiskAisleDataRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{backgroundColor:"secondary"},aisle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right",backgroundColor:"secondary"},a1combinedMetricsMap.receivedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right",backgroundColor:"secondary"},a1combinedMetricsMap.currentInductedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right",backgroundColor:"secondary"},a1combinedMetricsMap.minutesOfWork),this.renderAdjacencyScoreColumnValue("secondary",a1combinedMetricsMap));}else{var combinedMinOfWork=parseFloat(a1combinedMetricsMap.minutesOfWork+a2combinedMetricsMap.minutesOfWork).toFixed(1);aisle=a1combinedMetricsMap.aisle.replace("-","")+"-"+a2combinedMetricsMap.aisle.replace("-","");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,key:aisles[0],onClick:function onClick(){return _this5.aisleRowClicked(aisles[0][0]);},"data-cy":"atRiskAisleDataRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{backgroundColor:"secondary"},aisle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right",backgroundColor:"secondary"},this.renderAisleCount(a1combinedMetricsMap.receivedPackages,a2combinedMetricsMap.receivedPackages)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right",backgroundColor:"secondary"},this.renderAisleCount(a1combinedMetricsMap.currentInductedPackages,a2combinedMetricsMap.currentInductedPackages)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right",backgroundColor:"secondary"},isNaN(combinedMinOfWork)?"-":combinedMinOfWork),this.renderAdjacencyScoreColumnValue("secondary",a1combinedMetricsMap));}}},{key:"renderClusters",value:function renderClusters(){var _this6=this;var _props3=this.props,loading=_props3.loading,error=_props3.error,stowPackageMetricsMapCluster=_props3.stowPackageMetricsMapCluster,inductPackageMetricsMapCluster=_props3.inductPackageMetricsMapCluster,stowAssociateMetricsMapCluster=_props3.stowAssociateMetricsMapCluster;if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__utils_ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});}var allClusters=[].concat(_toConsumableArray(Object.keys(stowPackageMetricsMapCluster)),_toConsumableArray(Object.keys(inductPackageMetricsMapCluster)),_toConsumableArray(Object.keys(stowAssociateMetricsMapCluster)));var distinctClusters=[].concat(_toConsumableArray(new Set(allClusters)));if(loading&&!distinctClusters.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_column___default.a,{height:"400px",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader___default.a,null));}var filteredClusters=Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["k" /* getFilteredLocations */])(distinctClusters,stowPackageMetricsMapCluster,this.isDRSStowVisibilityEnabled());filteredClusters.sort(function(c1,c2){if(c1<c2){return-1;}if(c1>c2){return 1;}return 0;});var filteredClustersPair=this.clusterPairMap(filteredClusters,filteredClusters.length);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_row___default.a,{spacing:"Xsmall",wrap:"down",alignmentVertical:"stretch"},filteredClustersPair.map(function(clusters){return _this6.renderClusterGrid(clusters);}));}},{key:"renderClusterGrid",value:function renderClusterGrid(clusters){var _props4=this.props,isMobile=_props4.isMobile,spacingInset_shorthand3=_props4.spacingInset_shorthand3;var c1=clusters[0];var c2=clusters[1];var rowWidth=isMobile?"100%":"";var boxWidth=isMobile?"":"550px";var maxBoxWidth=isMobile?"":"50%";if(c2===undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_row___default.a,{wrap:"down",width:"100%",alignmentVertical:"stretch",spacingInset:spacingInset_shorthand3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box___default.a,{width:boxWidth,maxWidth:maxBoxWidth,type:"outline",spacingInset:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_heading___default.a,{level:2,type:"h200",alignment:"left",spacingInset:"Xsmall"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"cluster.cluster",defaultMessage:"Cluster"})," "+c1),this.renderClusterContent(c1),this.renderClusterAisles(c1)));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_row___default.a,{wrap:"down",width:rowWidth,alignmentVertical:"stretch",spacingInset:spacingInset_shorthand3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box___default.a,{width:boxWidth,maxWidth:maxBoxWidth,type:"outline",spacingInset:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_heading___default.a,{level:2,type:"h200",alignment:"left",spacingInset:"Xsmall"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"cluster.cluster",defaultMessage:"Cluster"})," "+c1),this.renderClusterContent(c1),this.renderClusterAisles(c1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box___default.a,{width:boxWidth,maxWidth:maxBoxWidth,type:"outline",spacingInset:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_heading___default.a,{level:2,type:"h200",alignment:"left",spacingInset:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"cluster.cluster",defaultMessage:"Cluster"})," "+c2),this.renderClusterContent(c2),this.renderClusterAisles(c2)));}}},{key:"renderClusterContent",value:function renderClusterContent(cluster){var isMobile=this.props.isMobile;var combinedMetricsMap=this.getCombinedMetricsMapCluster(cluster);if(isMobile){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default.a,{headerRows:1,showDividers:true,showStripes:true,spacing:"small",fixHeaderRowsFullWidth:true,"data-cy":"clusterTable"},this.renderMobileClusterHeading1(),this.renderMobileClusterRow1(combinedMetricsMap)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default.a,{headerRows:1,showDividers:true,showStripes:true,spacing:"small",fixHeaderRowsFullWidth:true,"data-cy":"clusterTable"},this.renderMobileClusterHeading2(),this.renderMobileClusterRow2(combinedMetricsMap)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default.a,{headerRows:1,showDividers:true,showStripes:true,spacing:"small",fixHeaderRowsFullWidth:true,"data-cy":"clusterTable"},this.renderClusterHeading(),this.renderClusterRow(combinedMetricsMap));}},{key:"renderMobileClusterHeading1",value:function renderMobileClusterHeading1(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.overview.container_planned"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"overview.container_planned",defaultMessage:"C. Planned"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.overview.arrived"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"overview.arrived",defaultMessage:"Arrived"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.overview.inducted"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"overview.inducted",defaultMessage:"Inducted"}))));}},{key:"renderMobileClusterHeading2",value:function renderMobileClusterHeading2(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.overview.stow_rate"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"overview.stow_rate",defaultMessage:"Stow rate"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.overview.stowers"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"overview.stowers",defaultMessage:"Stowers"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.overview.minutes_of_work"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"overview.Minutes_of_Work",defaultMessage:"MoW"}))));}},{key:"renderClusterHeading",value:function renderClusterHeading(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.overview.container_planned"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"overview.container_planned",defaultMessage:"C. Planned"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.overview.arrived"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"overview.arrived",defaultMessage:"Arrived"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.overview.inducted"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"overview.inducted",defaultMessage:"Inducted"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.overview.stow_rate"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"overview.stow_rate",defaultMessage:"Stow rate"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.overview.stowers"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"overview.stowers",defaultMessage:"Stowers"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.overview.minutes_of_work"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"overview.Minutes_of_Work",defaultMessage:"MoW"}))));}},{key:"renderMobileClusterRow1",value:function renderMobileClusterRow1(combinedMetricsMap){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,"data-cy":"clusterDataRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"left"},combinedMetricsMap.plannedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.receivedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.currentInductedPackages));}},{key:"renderMobileClusterRow2",value:function renderMobileClusterRow2(combinedMetricsMap){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,"data-cy":"clusterDataRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},isFinite(parseFloat(combinedMetricsMap.stowRate/combinedMetricsMap.activeStowers).toFixed(2))?parseFloat(combinedMetricsMap.stowRate/combinedMetricsMap.activeStowers).toFixed(2):"-"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.activeStowers),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.minutesOfWork));}},{key:"renderClusterRow",value:function renderClusterRow(combinedMetricsMap){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,"data-cy":"clusterDataRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"left"},combinedMetricsMap.plannedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.receivedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.currentInductedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},isFinite(parseFloat(combinedMetricsMap.stowRate/combinedMetricsMap.activeStowers).toFixed(2))?parseFloat(combinedMetricsMap.stowRate/combinedMetricsMap.activeStowers).toFixed(2):"-"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.activeStowers),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.minutesOfWork));}},{key:"renderClusterAisles",value:function renderClusterAisles(cluster){var _this7=this;var _props5=this.props,loading=_props5.loading,error=_props5.error,stowPackageMetricsMapAisle=_props5.stowPackageMetricsMapAisle,atRiskAislesMetricsMap=_props5.atRiskAislesMetricsMap,inductPackageMetricsMapAisle=_props5.inductPackageMetricsMapAisle;if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__utils_ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});}var allAisles=[].concat(_toConsumableArray(Object.keys(stowPackageMetricsMapAisle)),_toConsumableArray(Object.keys(atRiskAislesMetricsMap)),_toConsumableArray(Object.keys(inductPackageMetricsMapAisle)));var distinctAisles=[].concat(_toConsumableArray(new Set(allAisles)));var filteredAisles=Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["k" /* getFilteredLocations */])(distinctAisles.filter(function(aisle){return aisle.startsWith(cluster);}),stowPackageMetricsMapAisle,this.isDRSStowVisibilityEnabled());if(loading&&!distinctAisles.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_column___default.a,{height:"400px",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader___default.a,null));}var that=this;function customCompare(a,b){return Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["b" /* convertToString */])(a).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["b" /* convertToString */])(b),that.state.locale,{numeric:true});}filteredAisles.sort(function(a1,a2){return customCompare(a1,a2);});var filteredAislePair=this.aislePairMap(filteredAisles,filteredAisles.length);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box___default.a,{spacing:"none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default.a,{headerRows:1,showDividers:true,showStripes:false,spacing:"small","data-cy":"clusterAislesTable"},this.renderClusterAisleHeading(),filteredAislePair.map(function(aisles){return _this7.renderClusterAisleRow(aisles);})));}},{key:"renderClusterAisleHeading",value:function renderClusterAisleHeading(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,{spacingInset:"Xsmall"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{sortColumn:"aisle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"aisle.aisle",defaultMessage:"Aisle"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"aisle.arrived",defaultMessage:"Arrived"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"aisle.inducted",defaultMessage:"Inducted"})),this.renderAdjacencyScoreColumnHeading("default"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"aisle.active",defaultMessage:"Active"})));}},{key:"renderClusterAisleRow",value:function renderClusterAisleRow(aisles){var _this8=this;var a1combinedMetricsMap=this.getCombinedMetricsMapAisle(aisles[0]);var a2combinedMetricsMap=this.getCombinedMetricsMapAisle(aisles[1]);var aisle;var setcolor="default";if(a2combinedMetricsMap.aisle===undefined){aisle=a1combinedMetricsMap.aisle.replace("-","");if(a1combinedMetricsMap.minutesOfWork>15&&a1combinedMetricsMap.minutesOfWork<=30){setcolor="#DCB700";}if(a1combinedMetricsMap.minutesOfWork>30){setcolor="#DD9DAB";}}else{var combinedMinOfWork=parseFloat(a1combinedMetricsMap.minutesOfWork+a2combinedMetricsMap.minutesOfWork).toFixed(1);aisle=a1combinedMetricsMap.aisle.replace("-","")+"-"+a2combinedMetricsMap.aisle.replace("-","");if(combinedMinOfWork>15&&combinedMinOfWork<=30){setcolor="#DCB700";}if(combinedMinOfWork>30){setcolor="#DD9DAB";}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,key:aisles[0],onClick:function onClick(){return _this8.aisleRowClicked(aisles[0][0]);},spacingInset:"Xsmall","data-cy":"clusterAislesDataRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{backgroundColor:setcolor,alignmentHorizontal:"left"},aisle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{backgroundColor:setcolor,alignmentHorizontal:"right"},this.renderAisleCount(a1combinedMetricsMap.receivedPackages,a2combinedMetricsMap.receivedPackages)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{backgroundColor:setcolor,alignmentHorizontal:"right"},this.renderAisleCount(a1combinedMetricsMap.currentInductedPackages,a2combinedMetricsMap.currentInductedPackages)),this.renderAdjacencyScoreColumnValue(setcolor,a1combinedMetricsMap),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_cell___default.a,{backgroundColor:setcolor,alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:this.renderAlias(a1combinedMetricsMap.associateAlias,a2combinedMetricsMap.associateAlias)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",null,this.renderAisleCount(a1combinedMetricsMap.activeStowers,a2combinedMetricsMap.activeStowers)))));}},{key:"componentDidMount",value:function componentDidMount(){var _this9=this;var that=this;Object(__WEBPACK_IMPORTED_MODULE_13__handler_LocaleHandler__["b" /* getLocale */])().then(function(locale){that.setState({locale:locale});});Object(__WEBPACK_IMPORTED_MODULE_24__handler_ParentDataHandler__["e" /* getFeaturesFromParent */])([__WEBPACK_IMPORTED_MODULE_20__constants__["j" /* FEATURES */].ADTA_VISIBILITY,__WEBPACK_IMPORTED_MODULE_20__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY]).then(function(featureStatusResponse){_this9.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__actions_ConfigActions__["b" /* fetchFeatureStatusCallSuccess */])(featureStatusResponse.data));});Object(__WEBPACK_IMPORTED_MODULE_24__handler_ParentDataHandler__["h" /* getSmartStowEnablementFromParent */])().then(function(response){_this9.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_OverviewActions__["k" /* fetchSmartStowEnablementCallSuccess */])(/true/.test(response.isSmartStowEnabled)));});Object(__WEBPACK_IMPORTED_MODULE_24__handler_ParentDataHandler__["g" /* getNodeCapabilityFromParent */])().then(function(capabilityResponse){var capability=JSON.parse(capabilityResponse.capability);Object(__WEBPACK_IMPORTED_MODULE_24__handler_ParentDataHandler__["e" /* getFeaturesFromParent */])([__WEBPACK_IMPORTED_MODULE_20__constants__["j" /* FEATURES */].IS_CPT_FILTER_ENABLED]).then(function(featureStatusResponse){_this9.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__actions_ConfigActions__["b" /* fetchFeatureStatusCallSuccess */])(featureStatusResponse.data));});if(_this9.props.featureStatus&&_this9.props.featureStatus[__WEBPACK_IMPORTED_MODULE_20__constants__["j" /* FEATURES */].IS_CPT_FILTER_ENABLED]&&__WEBPACK_IMPORTED_MODULE_12__enums__["e" /* Capability */].AR_NEXT_GEN!==capability){_this9.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_OptionsActionsV2__["r" /* fetchCPTList */])());}else if(__WEBPACK_IMPORTED_MODULE_12__enums__["e" /* Capability */].AR_NEXT_GEN!==capability){_this9.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_OptionsActionsV2__["t" /* fetchCycles */])());}_this9.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_OptionsActionsV2__["s" /* fetchCapabilityCallSuccess */])(capabilityResponse));});}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){var _props6=this.props,selectedCycle=_props6.selectedCycle,selectedCycleId=_props6.selectedCycleId;if(prevProps.selectedCycle!==selectedCycle&&prevProps.selectedCycleId!==selectedCycleId){this.fetchOverviewData(prevState.nodeId,selectedCycle,selectedCycleId);}}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.timer);this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_OptionsActionsV2__["v" /* navigationRemoved */])(0));}},{key:"atRiskPairMap",/*
     * PairMap function implements pairng of aisle as per odd|even standard
     *      if (last single aisle || first even aisle)
     *          add aisle
     *      else
     *          if (firstEvenInPair)  // handle even|odd and even|even case
     *              add aisle
     *          else if (secondOddInPair) // handle odd|odd case
     *              add aisle
     *          add aisle pair
     *
     */value:function atRiskPairMap(filteredAisles,totalAisles){var filteredAislePair=[];for(var index=0;index<totalAisles;index+=1){if(index+1===totalAisles||parseInt(filteredAisles[index].substring(1,filteredAisles[index].length),10)%2===0&&index===0){var a1combinedMetricsMap=this.getCombinedMetricsMapAisle(filteredAisles[index]);if(a1combinedMetricsMap.minutesOfWork>30){filteredAislePair.push([filteredAisles[index]]);}}else{var _a1combinedMetricsMap=this.getCombinedMetricsMapAisle(filteredAisles[index]);var a2combinedMetricsMap=this.getCombinedMetricsMapAisle(filteredAisles[index+1]);if(parseInt(filteredAisles[index].substring(1,filteredAisles[index].length),10)%2===0){if(_a1combinedMetricsMap.minutesOfWork>30){filteredAislePair.push([filteredAisles[index]]);}continue;}else if(parseInt(filteredAisles[index+1].substring(1,filteredAisles[index+1].length),10)%2!==0){if(_a1combinedMetricsMap.minutesOfWork>30){filteredAislePair.push([filteredAisles[index]]);}continue;}var combinedMinOfWork=parseFloat(_a1combinedMetricsMap.minutesOfWork+a2combinedMetricsMap.minutesOfWork).toFixed(1);if(combinedMinOfWork>30){filteredAislePair.push([filteredAisles[index],filteredAisles[index+1]]);}index+=1;}}return filteredAislePair;}},{key:"aislePairMap",value:function aislePairMap(filteredAisles,totalAisles){var filteredAislePair=[];for(var index=0;index<totalAisles;index+=1){if(index+1===totalAisles||parseInt(filteredAisles[index].substring(1,filteredAisles[index].length),10)%2===0&&index===0){filteredAislePair.push([filteredAisles[index]]);}else{if(parseInt(filteredAisles[index].substring(1,filteredAisles[index].length),10)%2===0){filteredAislePair.push([filteredAisles[index]]);continue;}else if(parseInt(filteredAisles[index+1].substring(1,filteredAisles[index+1].length),10)%2!==0){filteredAislePair.push([filteredAisles[index]]);continue;}filteredAislePair.push([filteredAisles[index],filteredAisles[index+1]]);index+=1;}}return filteredAislePair;}},{key:"clusterPairMap",value:function clusterPairMap(filteredClusters,totalClusters){var filteredClusterPair=[];for(var index=0;index<totalClusters;index+=1){if(index+1===totalClusters){filteredClusterPair.push([filteredClusters[index]]);}else{filteredClusterPair.push([filteredClusters[index],filteredClusters[index+1]]);index+=1;}}return filteredClusterPair;}},{key:"getMinutesOfWorkForGivenAisle",value:function getMinutesOfWorkForGivenAisle(aisle){var defaultMetricValue="-";var _props7=this.props,minOfWorkMetricsMapCluster=_props7.minOfWorkMetricsMapCluster,stowAssociateMetricsMapCluster=_props7.stowAssociateMetricsMapCluster,stowPackageMetricsMapAisle=_props7.stowPackageMetricsMapAisle;var cluster=aisle.charAt(0).toUpperCase();var lastFifteenMinuteStowRate=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return minOfWorkMetricsMapCluster[cluster].lastFifteenMinuteStowRate;},defaultMetricValue)).toFixed(1);var activeStowers=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowAssociateMetricsMapCluster[cluster].activeStowers;},defaultMetricValue)).toFixed(1);var stowRatePerStower=(lastFifteenMinuteStowRate/activeStowers).toFixed(1);if(!isFinite(stowRatePerStower)){return"-";}var currentInductedPackage=parseFloat(stowPackageMetricsMapAisle[aisle].currentInductedPackages).toFixed(1);var minutesOfWork=parseFloat(currentInductedPackage*60.0/stowRatePerStower).toFixed(1);if(!isFinite(minutesOfWork)){return"-";}return parseFloat(minutesOfWork);}/* Show the alert icon if the aisle adjacency score is higher than the baseline adjacency score *//* Show the info icon with tooltip in the table heading *//* Add the table cell in aisle heading only if smart stow is enabled *//* Add the table cell in row only if smart stow is enabled based on value of first aisle in pairing */}]);return StowOverview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// Adapter to convert class component to functional component.
function classToFunctionAdapter(CustomComponent){return function WrappedComponent(props){var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_27__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),isMobile=_useDeviceLayout.isMobile,spacingInset_shorthand3=_useDeviceLayout.spacingInset_shorthand3;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomComponent,Object.assign({},props,{isMobile:isMobile,spacingInset_shorthand3:spacingInset_shorthand3}));};}var mapStateToProps=function mapStateToProps(state){return{loading:state.overviewReducer.loading,error:state.overviewReducer.error,capability:state.optionsReducerV2.capability,filterIdentifier:state.optionsReducerV2.filterIdentifier,selectedCycle:state.optionsReducerV2.options.cycle,selectedView:state.optionsReducerV2.heatMapView,selectedCycleId:state.optionsReducerV2.options.cycleId,selectedCPTId:state.optionsReducerV2.options.CPTId,isInitialView:state.optionsReducerV2.isInitialView,featureStatus:state.configReducer.featureStatus,options:state.optionsReducerV2.options,navigationOptions:state.optionsReducerV2.navigationOptions,atRiskAislesMetricsMap:state.overviewReducer.atRiskAislesMetricsMap,minOfWorkMetricsMapCluster:state.overviewReducer.minOfWorkMetricsMapCluster,stowPackageMetricsMapCluster:state.overviewReducer.stowPackageMetricsMapCluster,inductPackageMetricsMapCluster:state.overviewReducer.inductPackageMetricsMapCluster,stowAssociateMetricsMapCluster:state.overviewReducer.stowAssociateMetricsMapCluster,inductPackageMetricsMapAisle:state.overviewReducer.inductPackageMetricsMapAisle,stowPackageMetricsMapAisle:state.overviewReducer.stowPackageMetricsMapAisle,isSmartStowEnabled:state.overviewReducer.isSmartStowEnabled};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_intl__["d" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(classToFunctionAdapter(StowOverview)))));

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Context__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(129);





function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return store.getState();
  }, [store]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || __WEBPACK_IMPORTED_MODULE_2__Context__["a" /* ReactReduxContext */];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

Provider.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    subscribe: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    getState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  }),
  context: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Provider);

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(341)();
}


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(342);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(196);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(353);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(198);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(349);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71), __webpack_require__(348)(module)))

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(198);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(199);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, {}, stateProps, {}, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(354);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(200);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createDispatchHook */
/* unused harmony export useDispatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Context__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useStore__ = __webpack_require__(201);


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {Function} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_0__components_Context__["a" /* ReactReduxContext */];
  }

  var useStore = context === __WEBPACK_IMPORTED_MODULE_0__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_1__useStore__["b" /* useStore */] : Object(__WEBPACK_IMPORTED_MODULE_1__useStore__["a" /* createStoreHook */])(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = createDispatchHook();

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createSelectorHook */
/* unused harmony export useSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useReduxContext__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Context__ = __webpack_require__(61);




 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelector = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelectedState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var selectedState;

  try {
    if (selector !== latestSelector.current || latestSubscriptionCallbackError.current) {
      selectedState = selector(store.getState());
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    var errorMessage = "An error occured while selecting the store state: " + err.message + ".";

    if (latestSubscriptionCallbackError.current) {
      errorMessage += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\nOriginal stack trace:";
    }

    throw new Error(errorMessage);
  }

  useIsomorphicLayoutEffect(function () {
    latestSelector.current = selector;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect(function () {
    function checkForUpdates() {
      try {
        var newSelectedState = latestSelector.current(store.getState());

        if (equalityFn(newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = newSelectedState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender({});
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {Function} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_4__components_Context__["a" /* ReactReduxContext */];
  }

  var useReduxContext = context === __WEBPACK_IMPORTED_MODULE_4__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_2__useReduxContext__["a" /* useReduxContext */] : function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(selector, "You must pass a selector to useSelectors");

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    return useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = createSelectorHook();

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_react_dom__, "unstable_batchedUpdates")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_dom__["unstable_batchedUpdates"]; });
/* eslint-disable import/no-unresolved */


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _loader = _interopRequireDefault(__webpack_require__(372));

var _linear = _interopRequireDefault(__webpack_require__(373));

var _circular = _interopRequireDefault(__webpack_require__(376));

var _theme = __webpack_require__(14);

var _token = __webpack_require__(12);

var _text = _interopRequireDefault(__webpack_require__(27));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var wrapperStyles = function wrapperStyles(t, _ref) {
  var type = _ref.type,
      size = _ref.size;
  return (0, _emotion.css)((0, _text["default"])(t, {
    fontSize: type === "linear" ? type : size,
    lineHeight: type === "linear" ? type : size,
    fontWeight: "body"
  }));
};

var Loader = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Loader, _React$PureComponent);

  var _super = _createSuper(Loader);

  function Loader() {
    (0, _classCallCheck2["default"])(this, Loader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Loader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          type = _this$props.type,
          showPercentageText = _this$props.showPercentageText,
          label = _this$props.label;
      var percentage = this.props.percentage;
      percentage = percentage > 100 ? 100 : percentage < 0 ? 0 : percentage;
      var determinate = percentage !== undefined;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, ["data-", "aria-"]);
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _loader["default"],
        map: (0, _token.getTokenHelper)("loader")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, passThroughProps, {
          className: wrapperStyles(t, {
            size: size,
            type: type
          })
        }), type === "linear" ? /*#__PURE__*/_react["default"].createElement(_linear["default"], {
          label: label,
          percentage: percentage,
          showPercentageText: showPercentageText,
          size: size,
          determinate: determinate,
          t: t
        }) : /*#__PURE__*/_react["default"].createElement(_circular["default"], {
          label: label,
          percentage: percentage,
          showPercentageText: showPercentageText,
          size: size,
          determinate: determinate,
          t: t
        }));
      });
    }
  }]);
  return Loader;
}(_react["default"].PureComponent);

(0, _defineProperty2["default"])(Loader, "defaultProps", {
  size: "large",
  type: "circular",
  showPercentageText: true
});
Loader.propTypes =  false ? {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * An accessible label. This is not shown in the UI, but will be read by
   * screen-readers.
   *
   * @since 5.x
   */
  label: _propTypes["default"].string,

  /**
   * Set this to a number between `0` and `100` (inclusive) to show the loader
   * at a particular stage of completion.
   *
   * If this prop is not set the loader will indicate an "indefinite" loading
   * state using a cyclical animation.
   */
  percentage: _propTypes["default"].number,

  /**
   * This determines whether the value of the `percentage` prop is shown in
   * text-form in the UI.
   */
  showPercentageText: _propTypes["default"].bool,

  /**
   * Sets the size of the component using a preset.
   *
   * The `"medium"` sizes is only available if `type` is set to `"circular"`.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large"]),

  /**
   * Determines the shape of the loader.
   */
  type: _propTypes["default"].oneOf(["circular", "linear"])
} : {};
var _default = Loader;
exports["default"] = _default;

/***/ }),
/* 359 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(361);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_cache__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_serialize__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_utils__ = __webpack_require__(371);




function insertWithoutScoping(cache, serialized) {
  if (cache.inserted[serialized.name] === undefined) {
    return cache.insert('', serialized, cache.sheet, true);
  }
}

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_utils__["a" /* getRegisteredStyles */])(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var createEmotion = function createEmotion(options) {
  var cache = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_cache__["a" /* default */])(options); // $FlowFixMe

  cache.sheet.speedy = function (value) {
    if (false) {
      throw new Error('speedy must be changed before any rules are inserted');
    }

    this.isSpeedy = value;
  };

  cache.compat = true;

  var css = function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered, this !== undefined ? this.mergedProps : undefined);
    Object(__WEBPACK_IMPORTED_MODULE_2__emotion_utils__["b" /* insertStyles */])(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var keyframes = function keyframes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered);
    insertWithoutScoping(cache, serialized);
  };

  var cx = function cx() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return merge(cache.registered, css, classnames(args));
  };

  return {
    css: css,
    cx: cx,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function (key) {
        cache.inserted[key] = true;
      });
    },
    flush: function flush() {
      cache.registered = {};
      cache.inserted = {};
      cache.sheet.flush();
    },
    // $FlowFixMe
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: __WEBPACK_IMPORTED_MODULE_2__emotion_utils__["a" /* getRegisteredStyles */].bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
};

var classnames = function classnames(args) {
  var cls = '';

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

/* harmony default export */ __webpack_exports__["a"] = (createEmotion);


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_weak_memoize__ = __webpack_require__(366);




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__["a" /* default */](stylisOptions);

  if (false) {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__["a" /* StyleSheet */]({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ __webpack_exports__["a"] = (createCache);


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleSheet; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();




/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (weakMemoize);


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serializeStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_hash__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_memoize__ = __webpack_require__(370);




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_memoize__["a" /* default */])(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles;

          if (false) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }
      }
    // eslint-disable-next-line no-fallthrough

    default:
      {
        if (registered == null) {
          return interpolation;
        }

        var cached = registered[interpolation];

        if (false) {
          console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
          shouldWarnAboutInterpolatingClassNameFromCss = false;
        }

        return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
      }
  }
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (false) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (false) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_hash__["a" /* default */])(styles) + identifierName;

  if (false) {
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertStyles; });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),
/* 372 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    loaderIndicatorBackgroundColor: tokens.themeBorderAccentDefault,
    loaderIndicatorMotionIndeterminateDuration: "700ms",
    loaderIndicatorMotionIndeterminateFunction: "linear",
    loaderIndicatorMotionDeterminateDuration: "150ms",
    loaderIndicatorMotionDeterminateFunction: "linear",
    loaderTrackBackgroundColor: tokens.themeBackgroundTertiaryDefault,
    loaderTrackLinearLargeHeight: 8,
    loaderTrackLinearSmallHeight: 4,
    loaderTrackCircularLargeSize: 64,
    loaderTrackCircularLargeStrokeWidth: 4,
    loaderTrackCircularMediumSize: 32,
    loaderTrackCircularMediumStrokeWidth: 4,
    loaderTrackCircularSmallSize: 16,
    loaderTrackCircularSmallStrokeWidth: 2,
    loaderPercentageSpacing: 8,
    loaderBorderRadius: 999,
    loaderFontSizeLinear: 14,
    loaderFontSizeSmall: 12,
    loaderFontSizeMedium: 12,
    loaderFontSizeLarge: 14,
    loaderLineHeightLinear: "20px",
    loaderLineHeightSmall: "16px",
    loaderLineHeightMedium: "16px",
    loaderLineHeightLarge: "20px"
  }
};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(4);

var _visuallyHidden = _interopRequireDefault(__webpack_require__(58));

var _token = __webpack_require__(12);

var indeterminateLinearAnimation = (0, _emotion.keyframes)({
  from: {
    transform: "scaleX(0.25) translateX(-100%)"
  },
  to: {
    transform: "scaleX(1) translateX(150%)"
  }
});
var indeterminateLinearAnimationRtl = (0, _emotion.keyframes)({
  from: {
    transform: "scaleX(1) translateX(150%)"
  },
  to: {
    transform: "scaleX(0.25) translateX(-100%)"
  }
});
var linearWrapperStyle = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var size = _ref.size;
  return (0, _emotion.css)({
    display: "flex",
    borderRadius: t("borderRadius"),
    width: "100%",
    minWidth: 100,
    height: t("trackLinear", [size, "height"]),
    backgroundColor: t("trackBackgroundColor"),
    position: "relative",
    overflow: "hidden",
    // HACK: This allows `overflow: hidden` + `position: relative` to work
    // as intended in Safari desktop
    zIndex: 0
  });
}, ["size"]);
var linearIndicatorStyle = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var determinate = _ref2.determinate,
      _ref2$percentage = _ref2.percentage,
      percentage = _ref2$percentage === void 0 ? 0 : _ref2$percentage;
  return (0, _emotion.css)({
    width: "".concat(percentage, "%"),
    height: "100%",
    backgroundColor: t("indicatorBackgroundColor"),
    transition: t.transitionCss("indicatorMotionDeterminate", "width")
  }, !determinate ? linearIndeterminateStyle(t) : undefined);
}, ["determinate", "percentage"]);

var linearIndeterminateStyle = function linearIndeterminateStyle(t) {
  return (0, _defineProperty2["default"])({
    width: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    borderRadius: t("borderRadius"),
    transformOrigin: "top left",
    animation: "".concat(indeterminateLinearAnimation, " ").concat(t("indicatorMotionIndeterminateDuration"), " ").concat(t("indicatorMotionIndeterminateFunction"), " infinite")
  }, "[dir=\"rtl\"] &", {
    animation: "".concat(indeterminateLinearAnimationRtl, " ").concat(t("indicatorMotionIndeterminateDuration"), " ").concat(t("indicatorMotionIndeterminateFunction"), " infinite")
  });
};

var linearPercentageStyle = (0, _token.memoizeTokenStyles)(function (t, _ref4) {
  var _css;

  var percentage = _ref4.percentage;
  return (0, _emotion.css)((_css = {
    width: "".concat(percentage, "%"),
    // HACK: IE11 does not support text-align "end" or "start" so we have
    // to use directional left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    //   textAlign: "end"
    textAlign: "right"
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    textAlign: "left"
  }), (0, _defineProperty2["default"])(_css, "marginTop", t("percentageSpacing")), (0, _defineProperty2["default"])(_css, "transition", t.transitionCss("indicatorMotionDeterminate", "width")), _css));
}, ["percentage"]);
var labelStyles = (0, _emotion.css)(_visuallyHidden["default"]);
/* eslint-disable react/prop-types */

var LinearLoader = function LinearLoader(_ref5) {
  var t = _ref5.t,
      percentage = _ref5.percentage,
      showPercentageText = _ref5.showPercentageText,
      size = _ref5.size,
      label = _ref5.label,
      determinate = _ref5.determinate;
  var useAriaLabel = !(determinate && showPercentageText);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "aria-label": useAriaLabel ? label : undefined
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: linearWrapperStyle(t, {
      size: size
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: linearIndicatorStyle(t, {
      determinate: determinate,
      percentage: percentage
    })
  })), !useAriaLabel ? /*#__PURE__*/_react["default"].createElement("div", {
    "aria-live": "polite",
    "aria-atomic": "true",
    className: linearPercentageStyle(t, {
      percentage: percentage
    })
  }, "".concat(percentage, "%"), /*#__PURE__*/_react["default"].createElement("span", {
    className: labelStyles
  }, label)) : null);
};
/* eslint-enable react/prop-types */


var _default = LinearLoader;
exports["default"] = _default;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _upperFirst = _interopRequireDefault(__webpack_require__(203));

var pascalCase = function pascalCase(strings) {
  return strings.map(_upperFirst["default"]).join("");
};

var _default = pascalCase;
exports["default"] = _default;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var lowerFirst = function lowerFirst(str) {
  return str ? str.charAt(0).toLowerCase() + str.slice(1) : "";
};

var _default = lowerFirst;
exports["default"] = _default;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(4);

var _token = __webpack_require__(12);

var _functional = __webpack_require__(26);

var _visuallyHidden = _interopRequireDefault(__webpack_require__(58));

var indeterminateCircularAnimation = (0, _emotion.keyframes)({
  "0%": {
    strokeDasharray: "100% 200%",
    transform: "rotate(100deg)"
  },
  "50%": {
    strokeDasharray: "30% 400%"
  },
  "100%": {
    strokeDasharray: "100% 200%",
    transform: "rotate(460deg)"
  }
});
var wrapperStyle = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var size = _ref.size;
  return (0, _emotion.css)({
    position: "relative"
  }, size === "small" ? {
    display: "flex",
    alignItems: "center"
  } : undefined);
}, ["size"]);

var svgStyle = function svgStyle(size) {
  return (0, _emotion.css)({
    width: size,
    height: size
  });
};

var pathStyle = (0, _functional.memoize)(function (t) {
  return (0, _emotion.css)({
    transition: t.transitionCss("indicatorMotionDeterminate", "stroke-dasharray")
  });
});
var indeterminatePathStyle = (0, _functional.memoize)(function (t) {
  return (0, _emotion.css)({
    transformOrigin: "center",
    animation: "".concat(indeterminateCircularAnimation, " ").concat(t("indicatorMotionIndeterminateDuration"), " ").concat(t("indicatorMotionDeterminateFunction"), " infinite")
  });
});
var percentageStyle = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var size = _ref2.size;
  return (0, _emotion.css)(size === "small" ? smallPercentageStyle : size === "medium" ? mediumPercentageStyle(t) : largePercentageStyle(t));
}, ["size"]);
var smallPercentageStyle = (0, _defineProperty2["default"])({
  // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
  // to use directional margin-left/right. If/when we drop IE11 we can simplify
  // these styles to be:
  // {
  //   marginInlineStart: 8,
  // }
  marginLeft: 8
}, "[dir=\"rtl\"] &", {
  marginLeft: 0,
  marginRight: 8
});

var mediumPercentageStyle = function mediumPercentageStyle(t) {
  return {
    width: t("trackCircularMediumSize"),
    textAlign: "center",
    marginTop: t("percentageSpacing")
  };
};

var largePercentageStyle = function largePercentageStyle(t) {
  return {
    position: "absolute",
    top: t("trackCircularLargeSize") / 2,
    width: t("trackCircularLargeSize"),
    lineHeight: 0,
    textAlign: "center"
  };
};

var labelStyles = (0, _emotion.css)(_visuallyHidden["default"]);
/**
 * To draw the right amount of stroke we need to know
 * the total length of the path. These path lengths were
 * derived once in Chrome console in order that they not
 * be calculated every time
 */

var pathLengths = {
  large: 188.5220947265625,
  medium: 87.97695922851562,
  small: 43.98847961425781
};
/* eslint-disable react/prop-types */

var CircularLoader = function CircularLoader(props) {
  var t = props.t,
      size = props.size,
      percentage = props.percentage,
      showPercentageText = props.showPercentageText,
      determinate = props.determinate,
      label = props.label;
  var box = t("trackCircular", [size, "size"]);
  var startX = box / 2;
  var startY = t("trackCircular", [size, "strokeWidth"]) / 2;
  var endX = 0;
  var endY = box - t("trackCircular", [size, "strokeWidth"]);
  var useAriaLabel = !(determinate && showPercentageText);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperStyle(t, {
      size: size
    })
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    role: "img",
    viewBox: "0 0 ".concat(box, " ").concat(box),
    className: svgStyle(box),
    "aria-hidden": label ? false : true,
    focusable: label ? true : false,
    "aria-label": useAriaLabel ? label : undefined
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: box / 2,
    cy: box / 2,
    r: endY / 2,
    stroke: t("track", "backgroundColor"),
    strokeWidth: t("trackCircular", [size, "strokeWidth"]),
    fill: "none"
  }), !determinate ? /*#__PURE__*/_react["default"].createElement("circle", {
    className: indeterminatePathStyle(t),
    cx: box / 2,
    cy: box / 2,
    r: endY / 2,
    stroke: t("indicatorBackgroundColor"),
    strokeWidth: t("trackCircular", [size, "strokeWidth"]),
    strokeLinecap: "round",
    strokeDasharray: "10% 100%",
    fill: "none"
  }) : /*#__PURE__*/_react["default"].createElement("path", {
    className: pathStyle(t),
    d: "M".concat(startX, ",").concat(startY, "\n              a 1 1 0 0 1 ").concat(endX, " ").concat(endY, "\n              a 1 1 0 0 1 ").concat(endX, " -").concat(endY),
    fill: "none",
    stroke: t("indicatorBackgroundColor"),
    strokeWidth: t("trackCircular", [size, "strokeWidth"]),
    strokeLinecap: "round",
    strokeDasharray: "".concat(pathLengths[size] * percentage / 100, ", ").concat(pathLengths[size])
  })), !useAriaLabel ? /*#__PURE__*/_react["default"].createElement("div", {
    "aria-live": "polite",
    "aria-atomic": "true",
    className: percentageStyle(t, {
      size: size
    })
  }, "".concat(percentage, "%"), /*#__PURE__*/_react["default"].createElement("span", {
    className: labelStyles
  }, label)) : null);
};
/* eslint-enable react/prop-types */


var _default = CircularLoader;
exports["default"] = _default;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _emotion = __webpack_require__(4);

/**
 * Global styles
 */
(0, _emotion.injectGlobal)({
  /**
   * Set font smoothing technique
   *
   * On macOS the default font smoothing technique (subpixel antialiasing) is
   * optimized for dark text on light backgrounds. Unfortunately when applied to
   * light text on dark backgrounds this results in extra heavy, fuzzy text. The
   * following two properties turn off subpixel antialiasing in webkit browsers
   * and Firefox on macOS when the display's pixel density is high enough to
   * support full-pixel aliasing without decreasing text legibility.
   */
  "@media screen and (-webkit-min-device-pixel-ratio: 2), screen and (min-resolution: 2dppx)": {
    body: {
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale"
    }
  },

  /**
   * HACK: Fix html5 tags in IE11
   *
   * IE11 won't apply styles correctly to newer html5 tags that it doesn't
   * recognize unless they have a "display" property set.
   */
  "main, nav, header, footer": {
    display: "block"
  }
});

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Style = Style;
exports.useTheme = exports["default"] = exports.ThemeContext = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _blueLight = _interopRequireDefault(__webpack_require__(204));

var _getColorSchemeFromTokens = _interopRequireDefault(__webpack_require__(379));

var _useColorScheme = __webpack_require__(206);

var _token = __webpack_require__(12);

var _functional = __webpack_require__(26);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Context for passing theme tokens down the tree.
 */
var ThemeContext = /*#__PURE__*/(0, _react.createContext)(_blueLight["default"]);
/**
 * Merge two token objects together.
 */

exports.ThemeContext = ThemeContext;
var mergeTokens = (0, _functional.memoizeCurry)(function (a, b) {
  return _objectSpread(_objectSpread({}, a), b);
}, 1);
/**
 * Takes in an object of theme tokens and a function or object of tokens to
 * theme.
 */

var applyTheme = (0, _functional.memoizeCurry)(function (themeTokens, tokens) {
  return typeof tokens === "function" ? mergeTokens(tokens(themeTokens))(themeTokens) : tokens ? mergeTokens(tokens)(themeTokens) : themeTokens;
}, 1);
/**
 * A hook that grants access to theme tokens. Optionally pass in themeable
 * tokens as a function or non-themeable tokens as an object to mix with the
 * theme tokens. If tokens are provided, a prefixKey can be passed to allow easier
 * selection of tokens with a common prefix. For example:
 *   const t = useTheme(buttonTokens, "button")
 *   const buttonBgColor = t("backgroundColor")
 */

var useTheme = function useTheme(tokens) {
  var prefixKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  var _legacyHelperForBackwardsCompatibilityDoNotUse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var themeTokens = (0, _react.useContext)(ThemeContext);
  var currentTokens = applyTheme(themeTokens)(tokens);
  return typeof _legacyHelperForBackwardsCompatibilityDoNotUse === "function" ? _legacyHelperForBackwardsCompatibilityDoNotUse(currentTokens) : _legacyHelperForBackwardsCompatibilityDoNotUse ? currentTokens : (0, _token.getTokenHelper)(prefixKey)(currentTokens);
};
/**
 * Set the theme. Changes are applied to all the component's descendants.
 */


exports.useTheme = useTheme;

function Theme(_ref) {
  var tokens = _ref.tokens,
      children = _ref.children;
  var contextTokens = (0, _react.useContext)(ThemeContext);
  var currentTokens = mergeTokens(contextTokens)(tokens);
  var colorScheme = (0, _getColorSchemeFromTokens["default"])(currentTokens);
  return /*#__PURE__*/_react["default"].createElement(ThemeContext.Provider, {
    value: currentTokens
  }, /*#__PURE__*/_react["default"].createElement(_useColorScheme.ColorSchemeContext.Provider, {
    value: colorScheme
  }, children));
}

Theme.propTypes =  false ? {
  /**
   * The components to apply the theme to.
   */
  children: _propTypes["default"].element.isRequired,

  /**
   * An object of theme tokens imported from the Meridian token library.
   */
  tokens: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].string)])).isRequired
} : {};
/**
 * IMPORTANT: For backwards-compatibility only! Use the "useTheme" hook instead.
 */

function Style(_ref2) {
  var tokens = _ref2.tokens,
      map = _ref2.map,
      children = _ref2.children;
  return children(useTheme(tokens, "", map || true));
}

Style.propTypes = {
  children: _propTypes["default"].func.isRequired,
  map: _propTypes["default"].func,
  tokens: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])
};
var _default = Theme;
exports["default"] = _default;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _blueDark = _interopRequireDefault(__webpack_require__(205));

// The pivotal token used to determine if a set of tokens are "dark" or "light"
var themeBackgroundPrimaryDefault = _blueDark["default"].themeBackgroundPrimaryDefault;
/**
 * Returns if a tokens object represents a "light" or "dark" color scheme
 */

var getColorSchemeFromTokens = function getColorSchemeFromTokens(tokens) {
  return tokens.themeBackgroundPrimaryDefault === themeBackgroundPrimaryDefault ? "dark" : "light";
};

var _default = getColorSchemeFromTokens;
exports["default"] = _default;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _tableRow = _interopRequireDefault(__webpack_require__(25));

var _tableSectionHeader = _interopRequireWildcard(__webpack_require__(209));

var _tableContainer = _interopRequireDefault(__webpack_require__(211));

var _tableFixedHeaders = _interopRequireDefault(__webpack_require__(389));

var _checkbox = _interopRequireDefault(__webpack_require__(75));

var _tableSortToggle = _interopRequireDefault(__webpack_require__(407));

var _isElementOfAny = _interopRequireDefault(__webpack_require__(98));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var fullWidthStyles = (0, _emotion.css)({
  width: "100%",
  position: "relative"
});
/**
 * HACK that checks an element to see if it should have an explicit key set by
 * the user.
 *
 * This is dangerous because it delves into private React APIs. It is written in
 * such a way that if the private API is changed/removed then it will default to
 * `true` (indicating that a key is required) since adding explicit unique keys
 * can never hurt (other than being annoying) but omitting them can result in
 * tricky bugs.
 */

var dangerouslyCheckIfExplicitKeyIsRequired = function dangerouslyCheckIfExplicitKeyIsRequired(element) {
  return element && (!element._store || element._store.validated === undefined || element._store.validated === false);
};
/**
 * HACK that returns the key we should use for a row based on the row element
 * and its index in the table.
 *
 * ## Background
 *
 * Because we take the table rows provided by the user and then turn them into a
 * dynamic array, React thinks that explicit keys are always required (even for
 * static tables where row order will never change). We originally got around
 * this by setting each row key to the row index. This stopped the unnecessary
 * "key required" warnings for static tables, but also suppressed the necessary
 * "key required" warnings for dynamic tables (and made custom keys impossible).
 * In retrospect this was a poor choice and caused issues for tables with
 * dynamic rows that had internal state.
 *
 * ## Solution
 *
 * To address this problem we now a) always use the user's explicit keys if they
 * provide them and b) only use the row's index as a key for static tables (as
 * identified by elements where `dangerouslyCheckIfExplicitKeyIsRequired`
 * returns false). This is hacky, but makes our table behave just like any other
 * React component in terms of the key API (custom keys respected, warnings for
 * missing keys on dynamic elements, no warnings for missing keys on static
 * elements). Ultimately it was a poor choice to process all table rows as
 * arrays, but here we are.
 */


var getRowKey = function getRowKey(element, index) {
  return element.key || (dangerouslyCheckIfExplicitKeyIsRequired(element) ? undefined : index);
};
/**
 * Render a table - anything from advanced data tables with sorting and
 * filtering to simple static tables with basic content.
 */


var Table = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Table, _React$Component);

  var _super = _createSuper(Table);

  function Table() {
    var _this;

    (0, _classCallCheck2["default"])(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "rootRef", undefined);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateRootRef", function (rootRef) {
      _this.rootRef = rootRef; // If we're fixing table headers, re-render when the rootRef comes through

      if (_this.props.fixHeaderRows) {
        _this.forceUpdate();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isRow", (0, _isElementOfAny["default"])(_this.props.rowComponents));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isSectionHeader", (0, _isElementOfAny["default"])(_this.props.sectionHeaderComponents));
    return _this;
  }

  (0, _createClass2["default"])(Table, [{
    key: "getChildren",
    value:
    /**
     * This function takes the table children passed by the user, splits them into
     * non-rows, header rows, and body rows, and then transforms them based on the
     * props passed to this component (e.g. this component will set the `header`
     * prop on individual table cells based on the `headerRows` and
     * `headerColumns` props passed by the user).
     *
     * This function looks a bit messy because it prioritizes code performance
     * over code readability, accomplishing everything in a single pass over the
     * table cells.
     */
    function getChildren() {
      var _this2 = this;

      var props = this.props;
      var rowIndex = -1;
      var nestedRows = false;
      var nonRows = [];
      var headerRows = [];
      var bodyRows = []; // Walk through every child of the Table (mostly rows, but other children
      // such as a TableActionBar might be included).

      _react["default"].Children.forEach(props.children, function (child) {
        if (!_this2.isRow(child) && !_this2.isSectionHeader(child)) {
          // Gather all the elements that aren't rows together
          nonRows.push(child);
        } else {
          // Transform TableSectionHeader elements (syntactic sugar for users)
          // into actual TableRow elements (that we can render)
          var row = _this2.isSectionHeader(child) ? (0, _tableSectionHeader.toRow)(_this2.isRow, child, props.stickyHeaderColumn) : child;
          rowIndex += 1;
          var key = getRowKey(child, rowIndex); // Handle header rows

          if (rowIndex < props.headerRows) {
            // Add header={true} to every cell in every header row. Transform the
            // cell children into a TableSortToggle if the cell has a `sortColumn`
            // prop set.
            var headerRow = /*#__PURE__*/_react["default"].cloneElement(row, {
              key: key,
              children: _react["default"].Children.map(row.props.children, function (child, columnIndex) {
                return child && /*#__PURE__*/_react["default"].cloneElement(child, {
                  header: true,
                  scope: "col",
                  sortDirection: child.props.sortColumn !== undefined && child.props.sortColumn === props.sortColumn ? props.sortDirection || child.props.defaultSortDirection : undefined,
                  checkboxComponents: columnIndex === 0 ? props.checkboxComponents : undefined,
                  children: props.onSort && child.props.sortColumn ? _this2.renderSortButton(child) : child.props.children
                });
              })
            });

            headerRows.push(headerRow);
          } // Handle body rows. Add header={true} to body cells that are part of
          // a header column. Also keep track of nested rows for styling
          // purposes.
          else {
            var prevColumnIndex = -1;

            var bodyRow = /*#__PURE__*/_react["default"].cloneElement(row, {
              key: key,
              rowComponents: row.props.rowComponents || props.rowComponents,
              children: _react["default"].Children.map(row.props.children, function (child) {
                if (_this2.isRow(child)) {
                  nestedRows = true;
                  return child;
                } else if (child) {
                  // Clone header cells or cells that may contain a checkbox for
                  // selectable tables (we need to pass table-level data down to
                  // these cells).
                  var columnIndex = prevColumnIndex + 1;
                  var header = columnIndex < props.headerColumns;
                  var checkboxComponents = columnIndex === 0 ? props.checkboxComponents : undefined;
                  prevColumnIndex += 1;
                  return header || checkboxComponents ? /*#__PURE__*/_react["default"].cloneElement(child, {
                    header: child.props.header || header,
                    scope: child.props.sectionHeader ? "colgroup" : child.props.header || header ? "row" : undefined,
                    checkboxComponents: child.props.checkboxComponents || checkboxComponents
                  }) : child;
                } else {
                  return null;
                }
              })
            });

            bodyRows.push(bodyRow);
          }
        }
      });

      return {
        nonRows: nonRows,
        headerRows: headerRows,
        bodyRows: bodyRows,
        nestedRows: nestedRows
      };
    }
  }, {
    key: "renderSortButton",
    value: function renderSortButton(cell) {
      var _this$props = this.props,
          sortColumn = _this$props.sortColumn,
          sortDirection = _this$props.sortDirection,
          onSort = _this$props.onSort;
      return /*#__PURE__*/_react["default"].createElement(_tableSortToggle["default"], {
        sortColumn: cell.props.sortColumn,
        value: {
          sortColumn: sortColumn,
          sortDirection: sortDirection
        },
        defaultSortDirection: cell.props.defaultSortDirection,
        columnTextAlignment: cell.props.alignmentHorizontal,
        onChange: onSort
      }, cell.props.children);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;

      var _this$getChildren = this.getChildren(),
          nestedRows = _this$getChildren.nestedRows,
          nonRows = _this$getChildren.nonRows,
          headerRows = _this$getChildren.headerRows,
          bodyRows = _this$getChildren.bodyRows;

      var tableContainerProps = _objectSpread({
        nestedRows: nestedRows
      }, props);

      var renderHead = headerRows.length > 0;
      var renderBody = bodyRows.length > 0;
      var useFixedHeaders = props.fixHeaderRows && this.rootRef && renderHead;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: fullWidthStyles,
        ref: this.updateRootRef
      }, !useFixedHeaders ? nonRows : /*#__PURE__*/_react["default"].createElement(_tableFixedHeaders["default"], {
        rootRef: this.rootRef,
        tableContainerProps: tableContainerProps,
        nonRows: nonRows,
        headerRows: headerRows,
        headerRowsOffset: props.fixHeaderRowsOffset,
        fullWidth: props.fixHeaderRowsFullWidth
      }), /*#__PURE__*/_react["default"].createElement(_tableContainer["default"], tableContainerProps, renderHead ? /*#__PURE__*/_react["default"].createElement("thead", {
        ref: this.updateHeadRef
      }, headerRows) : null, renderBody ? /*#__PURE__*/_react["default"].createElement("tbody", {
        ref: this.updateBodyRef
      }, bodyRows) : null));
    }
  }]);
  return Table;
}(_react["default"].Component);

(0, _defineProperty2["default"])(Table, "defaultProps", {
  spacing: "medium",
  headerRows: 0,
  headerColumns: 0,
  rowComponents: [_tableRow["default"]],
  sectionHeaderComponents: [_tableSectionHeader["default"]],
  checkboxComponents: [_checkbox["default"]],
  layout: "auto",
  stickyHeaderColumnOffset: 0,
  stickyHeaderRowOffset: 0
});
Table.propTypes =  false ? {
  /**
   * Place `TableActionBar`, `TableRow`, and `TableSectionHeader`, components
   * as children of this component.
   *
   * Any unrecognized children will be extracted and rendered as previous
   * siblings to the table.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * The component or components that will be used to render checkboxes for
   * selectable tables. Defaults to Checkbox.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  checkboxComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Fix table header rows to the top of the scroll container when the user
   * scrolls down. This will also fix the TableActionBar if present.
   *
   * NOTE: We recommend turning on the `fixHeaderRowsFullWidth` property as
   * well, which is not enabled by default for backwards-compatibility
   * reasons.
   *
   * If you are not "fixing" an action bar, have a single header row, and are
   * not supporting IE11 we recommend using `stickyHeaderRow` which uses the
   * native CSS property `position: sticky`.
   */
  fixHeaderRows: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the `fixHeaderRows` prop if you want the
   * table header to expand to fill the full width of the scroll container
   * when fixed.
   */
  fixHeaderRowsFullWidth: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the "fixHeaderRows" prop if you don't want
   * to fix table header rows to the very top of the scroll container. Use
   * this to specify the pixel offset at which the rows should stick.
   */
  fixHeaderRowsOffset: _propTypes["default"].number,

  /**
   * This determines how many columns, starting on the left hand side of the
   * table, should be considered headers.
   */
  headerColumns: _propTypes["default"].number,

  /**
   * This determines how many rows, starting at the top of the table, should
   * be considered headers.
   *
   * NOTE: Expandable header rows are not supported.
   */
  headerRows: _propTypes["default"].number,

  /**
   * This determines how the browser will calculate the column widths of the
   * table. See the [table-layout CSS property](https://developer.mozilla.org/en-US/docs/Web/CSS/table-layout)
   * for details.
   */
  layout: _propTypes["default"].oneOf(["auto", "fixed"]),

  /**
   * Set this to true if the table contain nested rows (child rows that can be
   * expanded/collapsed by clicking on their parent row).
   *
   * NOTE: This prop is only necessary when creating nested rows whose children
   * are _not_ defined in the Table JSX. For instance, the following example
   * _does not_ require `nestedRows` to be defined since the `SelfContainedExpandableRow`'s
   * children are defined in the JSX defining `Table`.
   *
   * ```
   * const MyTable = () => (
   *   <Table rowComponents={[SelfContainedExpandableRow, TableRow]}>
   *     <SelfContainedExpandableRow>
   *       <TableCell>Data 1</TableCell>
   *       <TableCell>Data 2</TableCell>
   *       <TableRow>
   *         <TableCell>Nested 1</TableCell>
   *       </TableRow>
   *     </SelfContainedExpandableRow>
   *   </Table>
   * )
   *
   * const SelfContainedExpandableRow = ({ children, rowComponents }) => {
   *   const [open, setOpen] = useState(false)
   *   return (
   *     <TableRow
   *       open={open}
   *       onClick={() => setOpen(!open)}
   *       rowComponents={rowComponents}
   *     >
   *       {children}
   *     </TableRow>
   *   )
   * }
   * ```
   *
   * The following example, however, _does_ require `nestedRows` to be `true`
   * since `SelfContainedExpandableRow`'s children are defined outside the JSX
   * defining `Table`.
   *
   * ```
   * const SelfContainedExpandableRow = ({ rowComponents }) => {
   *   const [open, setOpen] = useState(false)
   *   return (
   *     <TableRow
   *       open={open}
   *       onClick={() => setOpen(!open)}
   *       rowComponents={rowComponents}
   *     >
   *       <TableCell>Data 1</TableCell>
   *       <TableCell>Data 2</TableCell>
   *       <TableRow>
   *         <TableCell>Nested 1</TableCell>
   *       </TableRow>
   *     </TableRow>
   *   )
   * }
   *
   * const MyTable = () => (
   *   <Table
   *     rowComponents={[SelfContainedExpandableRow, TableRow]}
   *     nestedRows={true}
   *   >
   *     <SelfContainedExpandableRow />
   *   </Table>
   * )
   * ```
   *
   * @since  5.x
   */
  nestedRows: _propTypes["default"].bool,

  /**
   * The component or components that will be used to render each table row.
   * Defaults to TableRow.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  rowComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * The component or components that will be used to render each table
   * section header. Defaults to TableSectionHeader.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  sectionHeaderComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * This determines if horizontal dividers are shown between table rows.
   */
  showDividers: _propTypes["default"].bool,

  /**
   * This determines if horizontal dividers are shown between expanded rows.
   */
  showExpandedDividers: _propTypes["default"].bool,

  /**
   * This determines if table is striped using alternately highlighted rows.
   */
  showStripes: _propTypes["default"].bool,

  /**
   * This identifies which column is currently sorted. It is matched against
   * any "sortId" props set on TableCell elements in the table's header rows.
   */
  sortColumn: _propTypes["default"].string,

  /**
   * This identifies which direction the data column identified by
   * "sortColumn" is sorted.
   */
  sortDirection: _propTypes["default"].oneOf(["ascending", "descending"]),

  /**
   * This can be used to adjust the vertical spacing of the table.
   */
  spacing: _propTypes["default"].oneOf(["small", "medium"]),

  /**
   * Stick table header column to the beginning of the scroll container when the
   * user scrolls horizontally.
   *
   * NOTE: This feature is unsupported on IE11 because it uses `position: sticky`.
   *
   * NOTE: Currently stickyHeaderColumn only supports sticking one header column.
   *
   * NOTE: Enabling a stickyHeaderColumn will ignore any user-defined [colummSpan](https://meridian.a2z.com/components/table/?platform=react-web&detailsTab=api#api-TableSectionHeader-columnSpan)
   * prop on a TableSectionHeader.
   *
   * @since 5.21.0
   */
  stickyHeaderColumn: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the 'stickyHeaderColumn' prop if you don't want
   * to stick the table header column to the very beginning of the scroll container.
   * Use this to specify the pixel offset at which the column should stick.
   *
   * @since 5.21.0
   */
  stickyHeaderColumnOffset: _propTypes["default"].number,

  /**
   * Stick table header row to the beginning of the scroll container when the
   * user scrolls vertically. Only the last table header row will become stuck.
   *
   * NOTE: This feature is unsupported on IE11 because it uses `position: sticky`.
   * There is also a known issue with using this prop with multiple header rows
   * (`headerColumns > 1`) on Safari desktop.
   *
   * NOTE: Currently stickyHeaderRow only supports sticking one header row. If there
   * are multiple header rows it will stick the header row closest to the table body.
   *
   * @since 5.21.0
   */
  stickyHeaderRow: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the 'stickyHeaderRow' prop if you don't want
   * to stick the table header rows to the very beginning of the scroll container.
   * Use this to specify the pixel offset at which the rows should stick.
   *
   * @since 5.21.0
   */
  stickyHeaderRowOffset: _propTypes["default"].number,

  /**
   * When the user clicks on the header of a sortable column this is called
   * with an object containing two keys: "sortColumn" and "sortDirection".
   */
  onSort: _propTypes["default"].func
} : {};
var _default = Table;
exports["default"] = _default;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _useFocus = _interopRequireDefault(__webpack_require__(40));

/**
 * NOTE: This component is deprecated. Use the useFocus hook instead.
 */
var Focus = function Focus(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      multipleTargets = _ref.multipleTargets,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus;
  var focus = (0, _useFocus["default"])({
    disabled: disabled,
    multipleNodes: multipleTargets,
    onBlur: onBlur,
    onFocus: onFocus
  });
  return children(focus);
};

Focus.displayName = "Focus";
Focus.propTypes = {
  children: _propTypes["default"].func.isRequired,

  /**
   * A bug in React means that onBlur is not called when an element with focus
   * is disabled. This prop allows you to manually inform the Focus component
   * when the element(s) that it manages are disabled so that it can turn off
   * its internal focus state. See: https://github.com/facebook/react/issues/9142
   */
  disabled: _propTypes["default"].bool,

  /**
   * Turn this on if you are using this component to track the focus of
   * multiple elements.
   */
  multipleTargets: _propTypes["default"].bool,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func
};
var _default = Focus;
exports["default"] = _default;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(48));

var _react = __webpack_require__(0);

var _noop = _interopRequireDefault(__webpack_require__(37));

/**
 * @callback focusEventCallback
 * @param {*} focusEvent
 * @returns *
 */

/**
 * Options for the useFocus hook
 *
 * @typedef focusOptions
 * @type {object}
 * @property {boolean} [disabled=false] - A bug in React means that onBlur is not called
 *   when an element with focus is disabled. This prop allows you to manually
 *   inform the Focus component when the element(s) that it manages are disabled
 *   so that it can turn off its internal focus state. See:
 *   https://github.com/facebook/react/issues/9142
 * @property {boolean} [multipleNodes=false] - Turn this on if you are tracking the focus
 *   of multiple DOM nodes (i.e. if you are applying the `focusProps` returned
 *   from this hook to multiple elements).
 * @property {focusEventCallback} [onBlur] - This is called when the component loses
 *   focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
 *   is passed as the first argument to the function.
 * @property {focusEventCallback} [onFocus] - This is called when the component gains
 *   focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
 *   is passed as the first argument to the function.
 */

/**
 * Focus state returned by the useFocus hook
 *
 * @typedef focusReturn
 * @type {object}
 * @property {boolean} focus - Are the tracked node(s) focused?
 * @property {('keyboard'|'mouse')} focusTrigger - The type of device that
 *   triggered the focus.
 * @property {Object} focusProps - An object containing onFocus and onBlur
 *   event handlers that can be bound to any node you want to track focus for.
 */

/**
 * This hook helps track the focus state of a DOM node or set of DOM nodes.
 *
 * When to use this component: if you need to make a distinction between mouse
 * focus and keyboard focus, or if you need to treat multiple focuseable dom
 * nodes as a single focuseable unit. If you don't need these features you
 * should probably just track focus using local state or style using the CSS
 * :focus selector.
 *
 * This component tracks focus state for its children, including the type of
 * device that triggered the focus (keyboard or pointer). This component
 * essentially takes the place of the CSS pseudo-selectors `:focus-within` and
 * `:focus-visible`, which are not well supported. It also allows you to
 * simulate something like `:focus-visible-within`, which doesn't exist in CSS
 * at all. See:
 *   - https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
 *   - https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo
 *
 * ```
 * // The button wrapper will be outlined in blue if the button or the div is
 * // focused with the keyboard, and will not be outlined if the elements are
 * // focused with the mouse (or if they are not focused at all).
 * const MyFocuseableButton = () => {
 *   const { focus, focusTrigger, focusProps } = useFocus()
 *   return (
 *     <div style={{
 *       outline: focus && focusTrigger === "keyboard" ? "1px solid blue" : "none"
 *     }}>
 *       <button {...focusProps}>Click me!</button>
 *       <div tabIndex={0}>Also click me!</div>
 *     </div>
 *   )
 * }
 * ```
 *
 * NOTE: Components that use this hook will re-render when the nodes that are
 * are being tracked by the hook are focused or blurred. To avoid re-rendering
 * an unnecessary amount of components on focus & blur, call this hook at the
 * lowest level possible. In other words, don't call this hook in a high-level
 * component that holds a ton of children just to track the focus on a single
 * child. Instead wrap the child in its own component and call the hook there,
 * limiting focus-related renders to just that child.
 *
 * @param {focusOptions} options - Options that determine how focus is tracked.
 * @returns {focusReturn}
 */
var useFocus = function useFocus() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      disabled = _ref.disabled,
      multipleNodes = _ref.multipleNodes,
      _ref$onBlur = _ref.onBlur,
      onBlurCallback = _ref$onBlur === void 0 ? _noop["default"] : _ref$onBlur,
      _ref$onFocus = _ref.onFocus,
      onFocusCallback = _ref$onFocus === void 0 ? _noop["default"] : _ref$onFocus;

  var _useState = (0, _react.useState)([false, null]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      _useState2$ = (0, _slicedToArray2["default"])(_useState2[0], 2),
      focus = _useState2$[0],
      focusDescendent = _useState2$[1],
      setFocus = _useState2[1];

  var focusedNode = (0, _react.useRef)();
  var blurTimeout = (0, _react.useRef)();
  var onFocus = (0, _react.useCallback)(function (event) {
    clearTimeout(blurTimeout.current);
    focusedNode.current = event ? event.target : undefined;
    var nextFocusDescendent = Boolean(event) && event.currentTarget !== focusedNode.current;

    if (!focus || focusDescendent !== nextFocusDescendent) {
      setFocus([true, nextFocusDescendent]);
    }

    if (!focus) {
      onFocusCallback(event, getInteractionDevice());
    }
  }, [onFocusCallback, focus, focusDescendent]);
  var onBlurComplete = (0, _react.useCallback)(function (event) {
    setFocus([false, false]);
    onBlurCallback(event, getInteractionDevice());
  }, [onBlurCallback]);
  var onBlur = (0, _react.useCallback)(function (event) {
    if (event && multipleNodes) {
      clearTimeout(blurTimeout.current); // Don't trigger `onBlurComplete` right away if we're managing focus for
      // multiple elements. Instead, wait briefly using setTimeout to see if
      // onFocus is called for another element we're tracking. If it is then
      // we consider the state to still be focused, otherwise we can move ahead
      // and call `onBlurComplete`.

      event.persist();
      blurTimeout.current = setTimeout(function () {
        if (event.target === focusedNode.current) {
          onBlurComplete(event);
        }
      }, 0);
    } else {
      onBlurComplete(event);
    }
  }, [onBlurComplete, multipleNodes]);
  var focusProps = (0, _react.useMemo)(function () {
    return {
      onFocus: onFocus,
      onBlur: onBlur
    };
  }, [onFocus, onBlur]);
  (0, _react.useEffect)(function () {
    // When the node(s) are focused and we flip from enabled to disabled, clear
    // the focus (see the docs for the disabled param re: why this is
    // necessary).
    if (focus && disabled) {
      setFocus([false, false]);
    } // Clear the timeout when unmounting


    return function () {
      return clearTimeout(blurTimeout.current);
    };
  }, [focus, disabled]);
  return {
    focus: focus,
    focusProps: focusProps,
    focusDescendent: focusDescendent,
    focusTrigger: getInteractionDevice()
  };
};
/**
 * This tracks whether the user is using their mouse or keyboard to interact
 * with the application. This state is tracked outside of React because it
 * updates on every mousedown or keydown in the window. Tracking this inside of
 * React using component state would trigger a re-render of every component
 * with useFocus for every one of these events, which would result in a ton of
 * unnecessary re-rendering. The value of this state is only relevant when a new
 * element is focused anyway, so `onFocus` can fetch the new value when that
 * happens.
 */


var getInteractionDevice = function () {
  var device = "keyboard";

  if (typeof window !== "undefined" && window.addEventListener) {
    window.addEventListener("mousedown", function () {
      return device = "mouse";
    }, true);
    window.addEventListener("keydown", function () {
      return device = "keyboard";
    }, true);
  }

  return function () {
    return device;
  };
}();

var _default = useFocus;
exports["default"] = _default;

/***/ }),
/* 383 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 384 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 385 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 386 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronDownSmallData: "data:image/svg+xml,%3csvg width='10' height='6' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 1l4 4 4-4' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconChevronDownSmallWidth: 10,
  iconChevronDownSmallHeight: 6
};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _stickyScrollTracker = _interopRequireDefault(__webpack_require__(388));

var _default = _stickyScrollTracker["default"];
exports["default"] = _default;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _noop = _interopRequireDefault(__webpack_require__(37));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _canUseDom = _interopRequireDefault(__webpack_require__(136));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = (0, _emotion.css)({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  pointerEvents: "none",
  "& > [mdn-tracker-x]": {
    width: 0,
    height: 0,
    position: "sticky",
    top: 0
  },
  "& > [mdn-tracker-y]": (0, _defineProperty2["default"])({
    width: 0,
    height: 0,
    position: "sticky",
    left: 0
  }, "[dir=\"rtl\"] &", {
    left: "unset",
    right: 0
  })
});
var canUseIntersectionObserver = _canUseDom["default"] && "IntersectionObserver" in window;
/**
 * Tracks when a user has scrolled a "relative" container in either direction.
 */

var StickyScrollTracker = function StickyScrollTracker(_ref) {
  var trackX = _ref.trackX,
      trackY = _ref.trackY,
      onChangeX = _ref.onChangeX,
      onChangeY = _ref.onChangeY;
  var xTrackerRef = (0, _react.useRef)();
  var yTrackerRef = (0, _react.useRef)(); // Set up the x-axis tracker. When it becomes partially hidden, the tracker
  // fires `onChangeX` with `true`. Once it becomes entirely uncovered, it calls
  // `onChangeX` with `false`.

  (0, _react.useEffect)(function () {
    if ( // We can use IntersectionObserver
    canUseIntersectionObserver && // We are tracking scrolling in the x direction
    trackX && // Tracker is in DOM
    xTrackerRef.current) {
      var observer = new IntersectionObserver(function (entries) {
        return onChangeX(!entries[0].isIntersecting);
      }, {
        threshold: 1
      });
      observer.observe(xTrackerRef.current);
      return function () {
        return observer.disconnect();
      };
    }
  }, [trackX, onChangeX]); // Set up the y-axis tracker. When it becomes partially hidden, the tracker
  // fires `onChangeY` with `true`. Once it becomes entirely uncovered, it calls
  // `onChangeY` with `false`.

  (0, _react.useEffect)(function () {
    if ( // We can use IntersectionObserver
    canUseIntersectionObserver && // We are tracking scrolling in the x direction
    trackY && // Tracker is in DOM
    yTrackerRef.current) {
      var observer = new IntersectionObserver(function (entries) {
        return onChangeY(!entries[0].isIntersecting);
      }, {
        threshold: 1
      });
      observer.observe(yTrackerRef.current);
      return function () {
        return observer.disconnect();
      };
    }
  }, [trackY, onChangeY]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "aria-hidden": "true",
    className: styles
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-tracker-y": "",
    ref: yTrackerRef
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-tracker-x": "",
    ref: xTrackerRef
  }));
};

StickyScrollTracker.displayName = "StickyScrollTracker";
StickyScrollTracker.propTypes =  false ? {
  /**
   * If we should track scrolling in the x direction
   */
  trackX: _propTypes["default"].bool,

  /**
   * If we should track scrolling in the y direction
   */
  trackY: _propTypes["default"].bool,

  /**
   * Called when the x scroll state changes. Passes `true` if the container has
   * scrolled past the threshold in the x direction and `false` otherwise.
   */
  onChangeX: _propTypes["default"].func,

  /**
   * Called when the x scroll state changes. Passes `true` if the container has
   * scrolled past the threshold in the y direction and `false` otherwise.
   */
  onChangeY: _propTypes["default"].func
} : {};
StickyScrollTracker.defaultProps = {
  trackX: false,
  trackY: false,
  onChangeX: _noop["default"],
  onChangeY: _noop["default"]
};
var _default = StickyScrollTracker;
exports["default"] = _default;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(48));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _range = _interopRequireDefault(__webpack_require__(212));

var _table = _interopRequireDefault(__webpack_require__(82));

var _elevation = __webpack_require__(59);

var _tableContainer = _interopRequireDefault(__webpack_require__(211));

var _stickyContainer = _interopRequireDefault(__webpack_require__(398));

var _theme = __webpack_require__(14);

var _querySelectorArray = _interopRequireDefault(__webpack_require__(404));

var _token = __webpack_require__(12);

var _addDebouncedEventListener = _interopRequireDefault(__webpack_require__(141));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var fixedHeaderRowStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var stuckY = _ref.stuckY,
      fullWidth = _ref.fullWidth,
      containerWidth = _ref.containerWidth,
      columnWidths = _ref.columnWidths;
  return (0, _emotion.css)(_objectSpread({
    // Apply the primary background color to the fixed header so non-fixed
    // elements don't show through the cracks (e.g. the space between an action
    // bar and the table header)
    backgroundColor: t("backgroundColorPrimary"),
    // Set the box shadow here if we're not including the fullWidth prop
    boxShadow: !fullWidth && t.boxShadowCss("overflowShadow"),
    // If the table overflows its container's width (e.g. for a horizontally
    // scrolling table) then we want the table header to do the same. The only
    // way to make sure the header does this is to set its width explicitly
    // (setting individual column widths is not enough - the browser will just
    // squish them down to fit the table's container).
    width: columnWidths.length > 0 ? columnWidths[0].reduce(function (result, width) {
      return result + width;
    }, 0) : undefined,
    // Unset the max width set by StickyContainer
    maxWidth: "unset !important",
    // Constrain the action bar to the width of the table's container (instead
    // of matching the table width) so that actions floated to the right hand
    // side of the bar don't disappear out of view for horizontally scrollable
    // tables.
    "& [mdn-action-bar]": {
      maxWidth: containerWidth
    },
    // Make sure the stuck non-rows paints correctly on the z-axis
    "& > [mdn-table-stuck-non-rows]": {
      transform: "translateZ(0)"
    },
    // Display a backdrop that makes the header appear to expand the full
    // width of the scroll parent
    "&:before": fullWidth && {
      content: "''",
      position: "absolute",
      top: "0",
      left: "50%",
      transform: "translateX(-50%)",
      height: "100%",
      // Just go super super wide. We can't use something like 100% of the
      // viewport width in case we're in a horizontal scroller that is wider
      // than the viewport
      width: "10000px",
      boxSizing: "border-box",
      backgroundColor: t("backgroundColorPrimary"),
      borderBottomStyle: "solid",
      borderBottomWidth: t("borderWidthHeader"),
      borderBottomColor: t("borderColor"),
      boxShadow: t.boxShadowCss("overflowShadow"),
      opacity: stuckY ? 1 : 0,
      transition: t.transitionCss("motion", "opacity")
    },
    // When we override the width of the table cells (see below) we want to
    // make sure that the cell's padding doesn't affect the width that we set.
    "& th": {
      boxSizing: "border-box"
    }
  }, columnWidths.reduce(function (result, cellWidths, rowIndex) {
    result["& thead tr:nth-child(".concat(rowIndex + 1, ")")] = cellWidths.reduce(function (result, width, columnIndex) {
      result["& th:nth-child(".concat(columnIndex + 1, ")")] = {
        width: "".concat(width, "px !important")
      };
      return result;
    }, {});
    return result;
  }, {})));
}, ["stuckY", "fullWidth", "containerWidth", "columnWidths"]);
var initialState = {
  stuck: false,
  columnWidths: [],
  bodyHeight: 0
};

function reducer(state, action) {
  var type = action.type,
      columnWidths = action.columnWidths,
      bodyHeight = action.bodyHeight;

  switch (type) {
    case "WINDOW_RESIZED":
      return _objectSpread(_objectSpread({}, state), {}, {
        columnWidths: columnWidths,
        bodyHeight: bodyHeight
      });

    case "DOM_MUTATED":
      return _objectSpread(_objectSpread({}, state), {}, {
        columnWidths: columnWidths,
        bodyHeight: bodyHeight
      });

    case "STUCK":
      return _objectSpread(_objectSpread({}, state), {}, {
        stuck: true,
        columnWidths: columnWidths,
        bodyHeight: bodyHeight
      });

    case "UNSTUCK":
      return _objectSpread(_objectSpread({}, state), {}, {
        stuck: false
      });
  }
}
/**
 * This can be used to fix the table headers so that they don't scroll out of
 * view.
 */


var TableFixedHeaders = function TableFixedHeaders(_ref2) {
  var rootRef = _ref2.rootRef,
      headerRows = _ref2.headerRows,
      headerRowsOffset = _ref2.headerRowsOffset,
      tableContainerProps = _ref2.tableContainerProps,
      fullWidth = _ref2.fullWidth,
      nonRows = _ref2.nonRows;
  var t = (0, _theme.useTheme)(_table["default"], "table");

  var _useReducer = (0, _react.useReducer)(reducer, initialState),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      _useReducer2$ = _useReducer2[0],
      stuck = _useReducer2$.stuck,
      columnWidths = _useReducer2$.columnWidths,
      bodyHeight = _useReducer2$.bodyHeight,
      dispatch = _useReducer2[1]; // Measure the column widths (to fix the width of the header row cells) and the
  // table body height (to keep the fixed content from remaining stuck if the
  // user scrolls past the entire table).


  var headerRowCount = headerRows.length;
  var measureTable = (0, _react.useCallback)(function () {
    var bodyNode = rootRef.querySelector("tbody"); // Be sure to only query the columns that are in the "real" table

    var tableNode = rootRef.querySelector("table:not([mdn-table-fixed])");
    return {
      columnWidths: (0, _range["default"])(headerRowCount).map(function (_, rowIndex) {
        return (0, _querySelectorArray["default"])(tableNode, "thead tr:nth-child(".concat(rowIndex + 1, ") > *")).map(function (cell) {
          return cell.getBoundingClientRect().width;
        });
      }),
      bodyHeight: bodyNode ? bodyNode.getBoundingClientRect().height : 0
    };
  }, [headerRowCount, rootRef]); // When the header sticks update our internal "stuck" state and re-measure
  // the table to make sure we've got the latest dimensions

  var onStick = (0, _react.useCallback)(function () {
    return dispatch(_objectSpread({
      type: "STUCK"
    }, measureTable()));
  }, [measureTable]); // When the header unsticks update our internal "stuck" state.

  var onUnstick = (0, _react.useCallback)(function () {
    return dispatch({
      type: "UNSTUCK"
    });
  }, []); // When our internal "stuck" state flips to true, add a resize listener to the
  // window and a mutation observer to the table so we can re-measure the table
  // dimensions when it's likely that they've changed.

  (0, _react.useEffect)(function () {
    if (stuck) {
      var removeOnResizeListener = (0, _addDebouncedEventListener["default"])(window, "resize", function () {
        return dispatch(_objectSpread({
          type: "WINDOW_RESIZED"
        }, measureTable()));
      });
      var mutationObserver = new MutationObserver(function () {
        return dispatch(_objectSpread({
          type: "DOM_MUTATED"
        }, measureTable()));
      });
      mutationObserver.observe(rootRef.querySelector("table"), {
        childList: true,
        subtree: true
      });
      return function () {
        removeOnResizeListener();

        if (mutationObserver) {
          mutationObserver.disconnect();
        }
      };
    }
  }, [measureTable, rootRef, stuck]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    "aria-hidden": stuck ? "true" : undefined,
    style: {
      visibility: stuck ? "hidden" : undefined
    },
    key: stuck ? "stuck" : "unstuck"
  }, nonRows), /*#__PURE__*/_react["default"].createElement(_stickyContainer["default"], {
    offsetY: headerRowsOffset,
    maxOffsetY: bodyHeight,
    anchorNode: rootRef,
    onStick: onStick,
    onUnstick: onUnstick,
    zIndex: _elevation.elevationFixture
  }, function (_ref3) {
    var style = _ref3.style,
        stuckY = _ref3.stuckY;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: style,
      className: fixedHeaderRowStyles(t, {
        stuckY: stuckY,
        fullWidth: fullWidth,
        columnWidths: columnWidths,
        containerWidth: style.maxWidth
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      key: stuck ? "stuck" : "not-stuck",
      "mdn-table-stuck-non-rows": ""
    }, nonRows), /*#__PURE__*/_react["default"].createElement(_tableContainer["default"], (0, _extends2["default"])({}, tableContainerProps, {
      fixed: true
    }), /*#__PURE__*/_react["default"].createElement("thead", null, headerRows)));
  }));
};

TableFixedHeaders.displayName = "TableFixedHeaders";
TableFixedHeaders.propTypes =  false ? {
  /**
   * A ref pointing to the container around the table. This cannot be changed
   * once it's set.
   */
  rootRef: _propTypes["default"].object.isRequired,

  /**
   * The props set on the TableContainer element.
   */
  tableContainerProps: _propTypes["default"].object.isRequired,

  /*
   * Should the sticky header expand to fill the width of the scroll container
   * when it's displayed?
   */
  fullWidth: _propTypes["default"].bool,

  /**
   * Any header rows to fix.
   */
  headerRows: _propTypes["default"].arrayOf(_propTypes["default"].node),

  /**
   * The pixel offset from the top of the scroll container at which to fix the
   * header rows.
   */
  headerRowsOffset: _propTypes["default"].number,

  /**
   * Any non-row elements to fix along with the header rows.
   */
  nonRows: _propTypes["default"].arrayOf(_propTypes["default"].node)
} : {};
TableFixedHeaders.defaultProps = {
  headerRowsOffset: 0
};
var _default = TableFixedHeaders;
exports["default"] = _default;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(391),
    isIterateeCall = __webpack_require__(392),
    toFinite = __webpack_require__(215);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 391 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(138),
    isArrayLike = __webpack_require__(73),
    isIndex = __webpack_require__(140),
    isObject = __webpack_require__(85);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(84);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 394 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(396),
    isObject = __webpack_require__(85),
    isSymbol = __webpack_require__(99);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(397);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 397 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _stickyContainer = _interopRequireDefault(__webpack_require__(399));

var _default = _stickyContainer["default"];
exports["default"] = _default;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(63));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(57));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _noop = _interopRequireDefault(__webpack_require__(37));

var _addDebouncedEventListener = _interopRequireDefault(__webpack_require__(141));

var _getScrollParent = _interopRequireDefault(__webpack_require__(403));

var _nodeBounds = __webpack_require__(216);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// NOTE: This component does not use emotion because its styles are *highly*
// dynamic (updated on scroll). The emotion docs say that emotion is performant
// enough for highly dynamic styles, but using inline styles still seems to
// perform marginally better in this situation. Plus, using inline styles here
// isn't any worse from a dev perspective since we don't need any of the fancy
// css features enabled by emotion.

/**
 * The bounding box ensures that the sticky container is clipped as if it was a
 * sibling of the anchor node. Otherwise, because the sticky container is
 * position: fixed, it would flow outside of the anchor node's scroll parent.
 */
var boundingBoxStyle = function boundingBoxStyle(_ref) {
  var show = _ref.show,
      zIndex = _ref.zIndex,
      boundingBox = _ref.boundingBox;
  return {
    position: "fixed",
    top: 0,
    left: 0,
    overflow: "hidden",
    zIndex: zIndex,
    // This'll cover the same screen space as the scroll container, but we don't
    // want it to block interaction with elements underneath it.
    pointerEvents: "none",
    display: show ? undefined : "none",
    width: boundingBox.width,
    height: boundingBox.height,
    // NOTE: We could use "willChange: 'transform'" to optimize this a bit, but we
    // have chosen not to because that results in fuzzy text on non-retina
    // displays (at least in Chrome). The fuzzy text is the result of an
    // intentional optimization by the browser: https://googlechrome.github.io/samples/css-will-change-transform-rasterization/.
    transform: "translateY(".concat(boundingBox.top, "px) translateX(").concat(boundingBox.left, "px)")
  };
};
/**
 * The scroll box ensures that the sticky container scrolls normally when it's
 * not fixed.
 */


var scrollBoxStyle = function scrollBoxStyle(_ref2) {
  var top = _ref2.top,
      left = _ref2.left,
      width = _ref2.width,
      height = _ref2.height;
  return {
    position: "absolute",
    top: 0,
    left: 0,
    // Re-enable all the pointer events that we disabled for the parent bounding
    // box (see `boundingBoxStyle`).
    pointerEvents: "all",
    transform: "translateY(".concat(top, "px) translateX(").concat(left, "px)"),
    maxWidth: width,
    maxHeight: height
  };
};
/**
 * Nifty wrapper around Math.max to ignore undefined values
 */


var max = function max() {
  for (var _len = arguments.length, numbers = new Array(_len), _key = 0; _key < _len; _key++) {
    numbers[_key] = arguments[_key];
  }

  return Math.max.apply(Math, (0, _toConsumableArray2["default"])(numbers.filter(function (n) {
    return !isNaN(n);
  })));
};
/**
 * Nifty wrapper around Math.min to ignore undefined values
 */


var min = function min() {
  for (var _len2 = arguments.length, numbers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    numbers[_key2] = arguments[_key2];
  }

  return Math.min.apply(Math, (0, _toConsumableArray2["default"])(numbers.filter(function (n) {
    return !isNaN(n);
  })));
};
/**
 * Walk up the DOM tree from an element and find all the containers that are
 * scrollable along the given axis (or along either axis if no axis is
 * provided). This list may include the element itself if the element is
 * scrollable.
 *
 * Note that this doesn't check whether the scroll parent is currently
 * overflowing and has scrollbars, it just checks if it *would* have scrollbars
 * if its contents did overflow.
 */


var getAllScrollParents = function getAllScrollParents(element, axis) {
  var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var scrollParent = (0, _getScrollParent["default"])(element, axis);

  if (scrollParent === document.documentElement) {
    return result.concat(scrollParent);
  } else {
    return getAllScrollParents(scrollParent.parentNode, axis, result.concat(scrollParent));
  }
};
/**
 * Returns the pixel width of a node's border on one side. If no border is
 * present or the border is not defined in terms of pixels this will return 0.
 *
 * HACK: Requiring border widths as pixels feels a bit hacky, but all the sticky
 * container math assumes pixels so we can't really deal with other units. I
 * can't think of a last time I saw a border width specified as a non-pixel unit
 * anyway. This should be a pretty safe assumption, and worse-case scenario
 * non-pixel borders will result in the same behavior we had prior to this
 * addition (the sticky element overlapping the border).
 */


var getBorderPixelWidth = function getBorderPixelWidth(node, side) {
  var rawValue = window.getComputedStyle(node).getPropertyValue("border-".concat(side, "-width"));
  return rawValue && rawValue.indexOf("px") !== -1 ? parseFloat(rawValue) : 0;
};
/**
 * Use this to "stick" scrollable content to the screen when it's about to
 * scroll out of view (a la position: sticky). This component works by watching
 * an "anchor" node and displaying itself when the anchor node starts to scroll
 * out of view. This component will automatically pick up the position and
 * dimensions of the anchor node, but the actual content must be provided via
 * the children prop. Use something like React.cloneElement if you want to clone
 * the anchor node to make it appear as if it's transitioning from a scrollable
 * to a fixed state. This cloning requires a little extra work, but it makes the
 * component's internals less complicated and its usage more flexible (e.g. you
 * can use it for a fixed table header, which you can't really rip out of its
 * parent element and display on its own).
 */


var StickyContainer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(StickyContainer, _React$Component);

  var _super = _createSuper(StickyContainer);

  function StickyContainer() {
    var _this;

    (0, _classCallCheck2["default"])(this, StickyContainer);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      stuckX: false,
      stuckY: false,
      boundingBox: _nodeBounds.emptyNodeBounds,
      scrollBox: _nodeBounds.emptyNodeBounds
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "eventListeners", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "anchorNode", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollParentNodesX", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollParentNodesY", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "refresh", function () {
      var _this$props = _this.props,
          onStick = _this$props.onStick,
          onUnstick = _this$props.onUnstick;
      var state = _this.state;

      var boundingBox = _this.getBoundingBox();

      var _this$getScrollBox = _this.getScrollBox({
        boundingBox: boundingBox
      }),
          stuckX = _this$getScrollBox.stuckX,
          stuckY = _this$getScrollBox.stuckY,
          scrollBox = _this$getScrollBox.scrollBox;

      var stickyChange = state.stuckX !== stuckX || state.stuckY !== stuckY;

      var show = _this.show({
        stuckX: stuckX,
        stuckY: stuckY
      }); // Notify the user when the container sticks


      if (stuckX && !state.stuckX || stuckY && !state.stuckY) {
        onStick({
          stuckX: stuckX,
          stuckY: stuckY
        });
      } // Update the state if the container should be shown and anything has
      // changed


      if (show && (stickyChange || !(0, _nodeBounds.compareNodeBounds)(scrollBox, state.scrollBox) || !(0, _nodeBounds.compareNodeBounds)(boundingBox, state.boundingBox))) {
        _this.setState({
          stuckX: stuckX,
          stuckY: stuckY,
          scrollBox: scrollBox,
          boundingBox: boundingBox
        });
      } // Update the state if the container is unsticking


      if (!stuckX && !stuckY && stickyChange) {
        onUnstick();

        _this.setState({
          stuckX: false,
          stuckY: false
        });
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(StickyContainer, [{
    key: "setup",
    value: function setup() {
      /* eslint-disable-next-line react/no-find-dom-node */
      this.anchorNode = _reactDom["default"].findDOMNode(this.props.anchorNode);

      if (this.anchorNode) {
        this.scrollParentNodesX = getAllScrollParents(this.anchorNode, "x");
        this.scrollParentNodesY = getAllScrollParents(this.anchorNode, "y");
        this.addEventListeners();
        this.refresh();
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      // Remove any existing event listeners to ensure we don't accidentally stack
      // multiple listeners
      this.removeEventListeners(); // Listen for *any* scroll event in the document

      this.eventListeners.push((0, _addDebouncedEventListener["default"])(document, "scroll", this.refresh, true)); // Update on window resizes as well, since that will affect the size and
      // position of the elements we're tracking

      this.eventListeners.push((0, _addDebouncedEventListener["default"])(window, "resize", this.refresh, true));
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      this.eventListeners.forEach(function (removeListener) {
        return removeListener();
      });
      this.eventListeners = [];
    }
  }, {
    key: "show",
    value: function show(_ref3) {
      var stuckX = _ref3.stuckX,
          stuckY = _ref3.stuckY;
      return stuckX || stuckY || this.props.showAlways;
    }
    /**
     * This function refreshes the bounding box, scroll box, and "stuck" state
     * in response to the user's scrolling.
     */

  }, {
    key: "getBoundingBox",
    value:
    /**
     * This function returns the bounds of the visible area where we can show
     * sticky elements. These bounds represent the intersection of all scrollable
     * elements up the DOM tree from our anchor element. This rectangle can be
     * used to position a sticky element relative to the scroll parent(s) and to
     * clip the sticky element to make it appear as if it was a child of the
     * scroll parent(s).
     */
    function getBoundingBox() {
      var scrollParentNodesX = this.scrollParentNodesX,
          scrollParentNodesY = this.scrollParentNodesY; // Get the left and right edges of the intersection of all the scroll
      // containers (representing the horizontal space that is actually visible).

      var _scrollParentNodesX$r = scrollParentNodesX.reduce(function (result, node) {
        var _getNodeBounds = (0, _nodeBounds.getNodeBounds)(node),
            left = _getNodeBounds.left; // Add the container's left border width so the sticky element doesn't
        // overlap the left border


        // Add the container's left border width so the sticky element doesn't
        // overlap the left border
        result.left = max(left + getBorderPixelWidth(node, "left"), result.left); // Use the container's clientWidth which excludes borders and scrollbars

        // Use the container's clientWidth which excludes borders and scrollbars
        result.right = min(left + node.clientWidth, result.right);
        return result;
      }, {}),
          left = _scrollParentNodesX$r.left,
          right = _scrollParentNodesX$r.right; // Get the top and bottom edges of the intersection of all the scroll
      // containers (representing the vertical space that is actually visible).


      var _scrollParentNodesY$r = scrollParentNodesY.reduce(function (result, node) {
        var _getNodeBounds2 = (0, _nodeBounds.getNodeBounds)(node),
            top = _getNodeBounds2.top; // Add the container's top border height so the sticky element doesn't
        // overlap the top border


        // Add the container's top border height so the sticky element doesn't
        // overlap the top border
        result.top = max(top + getBorderPixelWidth(node, "top"), result.top); // Use the container's clientHeight which excludes borders and scrollbars

        // Use the container's clientHeight which excludes borders and scrollbars
        result.bottom = min(top + node.clientHeight, result.bottom);
        return result;
      }, {}),
          top = _scrollParentNodesY$r.top,
          bottom = _scrollParentNodesY$r.bottom;

      return {
        top: top,
        left: left,
        width: Math.max(right - left, 0),
        height: Math.max(bottom - top, 0)
      };
    }
    /**
     * This function returns a rectangle that can be used to position a sticky
     * element relative to the bounding box returned by `getBoundingBox`. It also
     * returns the "stuck" state of the element (whether it's fixed along the x or
     * y axis).
     */

  }, {
    key: "getScrollBox",
    value: function getScrollBox(_ref4) {
      var boundingBox = _ref4.boundingBox;
      var _this$props2 = this.props,
          offsetX = _this$props2.offsetX,
          maxOffsetX = _this$props2.maxOffsetX,
          offsetY = _this$props2.offsetY,
          maxOffsetY = _this$props2.maxOffsetY;
      var anchorBox = (0, _nodeBounds.getNodeBounds)(this.anchorNode);
      var anchorLeft = anchorBox.left - boundingBox.left;
      var anchorTop = anchorBox.top - boundingBox.top;
      var maxY = maxOffsetY !== undefined ? anchorTop + maxOffsetY : offsetY;
      var maxX = maxOffsetX !== undefined ? anchorLeft + maxOffsetX : offsetX;
      var stuckX = offsetX !== undefined && anchorLeft < offsetX;
      var stuckY = offsetY !== undefined && anchorTop < offsetY;
      var scrollBox = {
        top: stuckY ? Math.min(maxY, offsetY) : anchorTop,
        left: stuckX ? Math.min(maxX, offsetX) : anchorLeft,
        width: anchorBox.width,
        height: anchorBox.height
      };
      return {
        stuckX: stuckX,
        stuckY: stuckY,
        scrollBox: scrollBox
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setup();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // If the anchor node changed then setup everything from scratch
      if (this.props.anchorNode !== prevProps.anchorNode) {
        this.setup();
      } // If a constraint changed then refresh


      if (this.props.offsetX !== prevProps.offsetX || this.props.offsetY !== prevProps.offsetY || this.props.maxOffsetX !== prevProps.maxOffsetX || this.props.maxOffsetY !== prevProps.maxOffsetY) {
        this.refresh();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEventListeners();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          zIndex = _this$props3.zIndex,
          children = _this$props3.children;
      var _this$state = this.state,
          stuckY = _this$state.stuckY,
          stuckX = _this$state.stuckX,
          scrollBox = _this$state.scrollBox,
          boundingBox = _this$state.boundingBox;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: boundingBoxStyle({
          show: this.show({
            stuckX: stuckX,
            stuckY: stuckY
          }),
          zIndex: zIndex,
          boundingBox: boundingBox
        })
      }, children({
        stuckY: stuckY,
        stuckX: stuckX,
        style: scrollBoxStyle(scrollBox)
      }));
    }
  }]);
  return StickyContainer;
}(_react["default"].Component);

(0, _defineProperty2["default"])(StickyContainer, "defaultProps", {
  onStick: _noop["default"],
  onUnstick: _noop["default"]
});
StickyContainer.propTypes =  false ? {
  /**
   * Specify children as a function. StickyContainer will pass an object
   * containing three keys that can be used to render the children: "style"
   * which contains an object of styles that must be set on a wrapper around
   * the children, "stuckX" which indicates whether or not the container is
   * stuck along the X axis, and "stuckY" which indicates whether or not the
   * container is stuck along the Y axis.
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * The node to track when showing, hiding, and positioning the sticky
   * container.
   */
  anchorNode: _propTypes["default"].object,

  /**
   * The offset from the left edge of the scroll viewport at which the
   * container should cease to stick. When the container reaches this offset
   * it will remain visible but will start to scroll left again with the rest
   * of the content.
   */
  maxOffsetX: _propTypes["default"].number,

  /**
   * The offset from the top edge of the scroll viewport at which the
   * container should cease to stick. When the container reaches this offset
   * it will remain visible but will start to scroll up again with the rest of
   * the content.
   */
  maxOffsetY: _propTypes["default"].number,

  /**
   * The offset from the top edge of the scroll viewport at which the
   * container will stick. An offset of 0 will cause the container to stick at
   * the top edge of the scroll viewport, an offset of 100 will cause it to
   * stick 100px down from the top, etc. If this is not provided the container
   * will not stick on the x axis.
   */
  offsetX: _propTypes["default"].number,

  /**
   * The offset from the left edge of the scroll viewport at which the
   * container will stick. An offset of 0 will cause the container to stick at
   * the left edge of the scroll viewport, an offset of 100 will cause it to
   * stick 100px right from the edge, etc. If this is not provided the
   * container will not stick on the y axis.
   */
  offsetY: _propTypes["default"].number,

  /**
   * Normally the sticky container is only rendered when it's stuck. Turn this
   * on to force it to render when unstuck as well.
   */
  showAlways: _propTypes["default"].bool,

  /**
   * Use this to determine how the sticky container is layered with other
   * elements.
   */
  zIndex: _propTypes["default"].number,

  /**
   * This is called when the container transitions from unstuck to stuck
   */
  onStick: _propTypes["default"].func,

  /**
   * This is called when the container transitions from stuck to unstuck
   */
  onUnstick: _propTypes["default"].func
} : {};
var _default = StickyContainer;
exports["default"] = _default;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(208);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 401 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 402 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isScrollable = function isScrollable(element, axis) {
  var style = window.getComputedStyle(element);
  return axis === "x" ? /(auto|scroll)/.test(style.overflowX) : axis === "y" ? /(auto|scroll)/.test(style.overflowY) : /(auto|scroll)/.test(style.overflow + style.overflowY + style.overflowX);
};
/**
 * Walk up the DOM tree from an element and find the closest container that is
 * scrollable along the given axis (or along either axis if no axis is
 * provided). This may return the element itself if the element is scrollable.
 *
 * Note that this doesn't check whether the scroll parent is currently
 * overflowing and has scrollbars, it just checks if it *would* have scrollbars
 * if its contents did overflow.
 */


var getScrollParent = function getScrollParent(element, axis) {
  return element && isScrollable(element, axis) ? element : element && element.parentElement ? getScrollParent(element.parentElement, axis) : document.documentElement;
};

var _default = getScrollParent;
exports["default"] = _default;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Identical to querySelectorAll, except the results are returned as an array
 */
var querySelectorArray = function querySelectorArray(element, query) {
  return Array.prototype.slice.call(element.querySelectorAll(query));
};

var _default = querySelectorArray;
exports["default"] = _default;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(48));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _checkbox = _interopRequireDefault(__webpack_require__(210));

var _checkLarge = _interopRequireDefault(__webpack_require__(217));

var _theme = __webpack_require__(14);

var _useFocus2 = _interopRequireDefault(__webpack_require__(40));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _token = __webpack_require__(12);

var _focusRing = _interopRequireDefault(__webpack_require__(43));

var _text = _interopRequireDefault(__webpack_require__(27));

var _visuallyHidden = _interopRequireDefault(__webpack_require__(58));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

var _cardContext = _interopRequireDefault(__webpack_require__(220));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _labelSpan;

  var fillParent = _ref.fillParent,
      disabled = _ref.disabled,
      labelled = _ref.labelled,
      checked = _ref.checked,
      hover = _ref.hover,
      focus = _ref.focus,
      size = _ref.size,
      hoverDisabled = _ref.hoverDisabled;
  var textStyleObject = (0, _text["default"])(t);
  var modifier = checked ? "selected" : "unselected";
  var state = disabled ? "disabled" : "default";
  var borderWidth = t("borderWidth");
  var borderRadius = t("borderRadius");
  return (0, _emotion.css)({
    /**
     * Outer wrapper
     *
     * This outer wrapper makes the checkbox a block-level component without
     * stretching the clickable-area beyond the visible label.
     */
    // NOTE: Use "flex" instead of "block" to achieve block-level display while
    // fixing the min-height issue in IE11:
    // https://stackoverflow.com/questions/44700068/flexbox-min-height-and-ie11
    display: "flex",
    fontSize: 0,
    // Positioned this wrapper element statically if the checkbox is supposed
    // to fill its parent. The static positioning makes this wrapper disappear
    // when it comes to positioning so that the label (see "labelStyles" below)
    // is positioned relative to the parent of the checkbox, not this wrapper.
    position: fillParent ? "static" : undefined,
    // For IE11
    width: fillParent ? "100%" : undefined,
    height: fillParent ? "100%" : undefined,

    /**
     * Inner wrapper (the label element)
     */
    "& > label": _objectSpread(_objectSpread({}, textStyleObject), {}, {
      display: "inline-flex",
      flexDirection: "row",
      justifyContent: labelled ? "flex-start" : "center",
      alignItems: "center",
      position: fillParent ? "absolute" : "relative",
      top: fillParent ? 0 : undefined,
      right: fillParent ? 0 : undefined,
      bottom: fillParent ? 0 : undefined,
      left: fillParent ? 0 : undefined,
      color: t("foregroundColor", disabled ? "disabled" : "default"),
      cursor: disabled ? "not-allowed" : "pointer",
      userSelect: "none",
      minHeight: textStyleObject.lineHeight
    }),

    /**
     * Icon wrapper
     */
    "& > label > span": (_labelSpan = {
      // Vertically center icon
      display: "flex",
      alignItems: "center",
      // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
      // to use directional margin-left/right. If/when we drop IE11 we can simplify
      // these styles to be:
      // marginInlineEnd: labelled ? t("spacingHorizontal") : undefined,
      marginRight: labelled ? t("spacingHorizontal") : undefined,
      marginLeft: 0
    }, (0, _defineProperty2["default"])(_labelSpan, "[dir=\"rtl\"] &", {
      marginLeft: labelled ? t("spacingHorizontal") : undefined,
      marginRight: 0
    }), (0, _defineProperty2["default"])(_labelSpan, "width", t("width", size)), (0, _defineProperty2["default"])(_labelSpan, "height", t("height", size)), _labelSpan),

    /**
     * Visible checkbox (the Icon element)
     */
    "& > label > span > *[role=img]": (0, _emotion.css)({
      boxSizing: "border-box",
      flexShrink: 0,
      borderWidth: borderWidth,
      borderRadius: borderRadius,
      borderColor: t("borderColor", [modifier, state]),
      borderStyle: "solid",
      transition: t.transitionCss("motion", ["color", "background-color"]),
      color: t("indicatorColor", [modifier, state]),
      backgroundColor: t("backgroundColor", [modifier, state]),
      width: t("width", size),
      height: t("height", size)
    }, !disabled ? (0, _focusRing["default"])(t.tokens, {
      focus: focus,
      borderWidth: borderWidth,
      borderRadius: borderRadius,
      dropShadow: true,
      offset: 4,
      gapColor: t.themeBackgroundPrimaryDefault,
      hoverSelector: "*:hover > &"
    }) : undefined),
    "& > label:hover > span > *[role=img]": !disabled && !hoverDisabled ? {
      color: t("indicatorColor", [modifier, "hover"]),
      backgroundColor: t("backgroundColor", [modifier, "hover"]),
      borderColor: t("borderColor", [modifier, "hover"])
    } : undefined,
    "& > label:active > span > *[role=img]": !disabled ? {
      color: t("indicatorColor", [modifier, "pressed"]),
      backgroundColor: t("backgroundColor", [modifier, "pressed"]),
      borderColor: t("borderColor", [modifier, "pressed"])
    } : undefined
  }, hover && !hoverDisabled && !disabled ? {
    "& > label > span > *[role=img]": {
      color: t("indicatorColor", [modifier, "hover"]),
      backgroundColor: t("backgroundColor", [modifier, "hover"]),
      borderColor: t("borderColor", [modifier, "hover"])
    }
  } : undefined);
}, ["fillParent", "disabled", "labelled", "hover", "checked", "focus", "size", "hoverDisabled"]); // Styles for the actual HTML checkbox element that is hidden from the user

var hiddenCheckboxStyles = (0, _emotion.css)(_visuallyHidden["default"]);
/**
 * Render a form control that can be toggled on or off by the user. Usually
 * rendered in groups to allow one or more choices to be selected.
 */

var Checkbox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onChange = props.onChange;
  var t = (0, _theme.useTheme)(_checkbox["default"], "checkbox");
  var context = (0, _react.useContext)(_cardContext["default"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      hoverDisabled = _useState2[0],
      setHoverDisabled = _useState2[1];

  var onMouseEnter = (0, _react.useCallback)(function () {
    return setHoverDisabled(false);
  }, [setHoverDisabled]);
  var handleChange = (0, _react.useCallback)(function (event) {
    if (onChange) onChange(event.target.checked);
    setHoverDisabled(true);
  }, [onChange, setHoverDisabled]);
  var labelled = Boolean(props.children);

  var _useFocus = (0, _useFocus2["default"])({
    onFocus: function onFocus(event) {
      if (props.onFocus) props.onFocus(event);
    },
    onBlur: function onBlur(event) {
      if (props.onBlur) props.onBlur(event);
    }
  }),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, {
      labelled: labelled,
      hover: context.hover,
      hoverDisabled: hoverDisabled,
      checked: props.checked,
      disabled: props.disabled,
      focus: focus && focusTrigger === "keyboard",
      size: props.size,
      fillParent: props.fillParent
    })
  }, /*#__PURE__*/_react["default"].createElement("label", {
    onMouseEnter: onMouseEnter
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, passThroughProps, focusProps, {
    id: props.id,
    className: hiddenCheckboxStyles,
    type: "checkbox",
    name: props.name,
    value: props.value,
    "aria-checked": props.checked !== "mixed" ? Boolean(props.checked) : "mixed",
    checked: // Cast `checked` to a boolean so that a value of `undefined`
    // doesn't flip the input into React's "uncontrolled" mode.
    Boolean(props.checked),
    disabled: props.disabled,
    tabIndex: props.tabIndex,
    onChange: handleChange,
    ref: ref
  })), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: props.iconTokens
  }), labelled ? /*#__PURE__*/_react["default"].createElement("div", null, props.children) : null));
});

Checkbox.displayName = "Checkbox";
Checkbox.propTypes =  false ? {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Checkbox component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-checked
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * The checked state of the component. Use this in conjunction with the
   * `onChange` prop to make the component interactive.
   */
  checked: _propTypes["default"].oneOf([true, false, "mixed"]),

  /**
   * The component's label. Plain text is recommended. This will be displayed
   * next to the form control, and will trigger a state change when clicked. If
   * you're using a Checkbox without a visible label, be sure to assign a
   * label using `aria-label`.
   */
  children: _propTypes["default"].node,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * If set to true the checkbox's clickable area will stretch to fill its
   * layout parent (the nearest ancestor with non-static positioning). The
   * checkbox's form control will be centered in the available space.
   *
   * This is currently used when checkboxes are rendered in table cells to make
   * table rows selectable.
   */
  fillParent: _propTypes["default"].bool,

  /**
   * Use this to customize the icon rendered in the checkbox. The value of this
   * prop should be an object of icon tokens imported directly from the Meridian
   * token library (e.g. `import checkTokens from "@amzn/meridian-tokens/base/icon/check-large`).
   *
   * The `"check-large"` icon is recommended for almost all checkboxes. The
   * `"minus"` icon is recommended for a checkbox that represents a partially
   * checked state (e.g. a "Select all" checkbox when only some items are
   * selected).
   *
   * See the [Iconography page](https://meridian.a2z.com/fundamentals/iconography/?platform=reactjs)
   * for a full list of the available icons.
   *
   * NOTE: This is deprecated and will be removed in 6.x.
   *
   * @deprecated 5.x
   */
  iconTokens: _propTypes["default"].object,

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["medium", "large"]),

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The value of the underlying input element. This is used to populate the
   * form data when submitting a form. To change the on/off status of the
   * component use the `checked` prop.
   */
  value: _propTypes["default"].any,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * A function that will be called when the user attempts to change the checked
   * state of the component (e.g. by clicking on it). The new checked state will
   * be passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the checked state provided to this function somewhere in
   * your state and pass it back via the `checked` prop in order to make this
   * component interactive.
   */
  onChange: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func
} : {};
Checkbox.defaultProps = {
  size: "medium",
  iconTokens: _checkLarge["default"]
};
var _default = Checkbox;
exports["default"] = _default;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _isString = _interopRequireDefault(__webpack_require__(218));

var _token = __webpack_require__(12);

var _functional = __webpack_require__(26);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

var _css;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var spanStyles = (0, _functional.memoize)(function (size) {
  return (0, _emotion.css)({
    position: "relative",
    flexShrink: 0,
    display: "inline-block",
    width: size,
    height: size,
    verticalAlign: "middle"
  });
});
var imgSpanStyles = (0, _emotion.css)({
  // Don't show the icon's label
  fontSize: 0,
  // Center the icon image
  "& svg": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translateY(-50%) translateX(-50%)"
  }
}); // These RTL styles are applied to a parent span only when an icon contains an LTR and RTL version.

var rtlStyles = (0, _emotion.css)((_css = {}, (0, _defineProperty2["default"])(_css, "span[role=img]:nth-child(1)", (0, _defineProperty2["default"])({}, "[dir=\"rtl\"] &", {
  display: "none"
})), (0, _defineProperty2["default"])(_css, "span[role=img]:nth-child(2)", (0, _defineProperty2["default"])({
  display: "none"
}, "[dir=\"rtl\"] &", {
  display: "inline-block"
})), _css));

var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
  return nextProps.tokens === prevProps.tokens && nextProps.className === prevProps.className && nextProps.children === prevProps.children;
};

var decodeSvgString = function decodeSvgString(svgData) {
  return decodeURIComponent(svgData.replace(/^data:image\/svg\+xml,/, "") // Add aria-hidden="true" so that screen readers ignore the underlying svg
  // (we label the parent span) and focusable="false" because IE11 defaults
  // to adding SVGs to the tab order
  ).replace(/<svg/, "<svg aria-hidden=\"true\" focusable=\"false\"");
};

var Icon = /*#__PURE__*/_react["default"].memo( /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _getIconFromTokens = (0, _token.getIconFromTokens)(props.tokens),
      data = _getIconFromTokens.data,
      dataRtl = _getIconFromTokens.dataRtl,
      width = _getIconFromTokens.width,
      height = _getIconFromTokens.height;

  var svg = decodeSvgString(data); // Create an RTL version of the SVG to be used for the RTL icon if it exists, else null

  var svgRtl = dataRtl ? decodeSvgString(dataRtl) : null;
  var html = (0, _react.useMemo)(function () {
    return {
      __html: svg
    };
  }, [svg]); // Generate RTL html for the RTL version of an SVG

  var htmlRtl = (0, _react.useMemo)(function () {
    return {
      __html: svgRtl
    };
  }, [svgRtl]);
  var size = width > Icon.sizes.small || height > Icon.sizes.small ? Icon.sizes.large : Icon.sizes.small;
  var simpleChildren = props.children === undefined || typeof props.children === "string";

  var stringChild = _react["default"].Children.toArray(props.children).filter(_isString["default"]).join(" ");

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: dataRtl ? (0, _emotion.cx)(rtlStyles, spanStyles(size), props.className) : (0, _emotion.cx)(spanStyles(size), props.className)
  }, /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({
    "aria-label": stringChild
  }, passThroughProps, {
    role: "img",
    "aria-hidden": !props.children ? true : undefined,
    className: imgSpanStyles,
    tabIndex: props.tabIndex,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    ref: ref,
    dangerouslySetInnerHTML: simpleChildren ? html : undefined
  }), simpleChildren ? null : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    dangerouslySetInnerHTML: html
  }), props.children)), dataRtl && /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({}, passThroughProps, {
    role: "img",
    "aria-hidden": !props.children ? true : undefined,
    "aria-label": simpleChildren ? props.children : undefined,
    className: imgSpanStyles,
    tabIndex: props.tabIndex,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    ref: ref,
    dangerouslySetInnerHTML: simpleChildren ? htmlRtl : undefined
  }), simpleChildren ? null : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    dangerouslySetInnerHTML: htmlRtl
  }), props.children)));
}), shouldNotUpdate);

Icon.sizes = {
  small: 16,
  large: 24
};
Icon.displayName = "Icon";
Icon.propTypes =  false ? {
  /**
   * An object of icon tokens imported from the Meridian token library.
   */
  tokens: _propTypes["default"].object.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Icon component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-hidden | aria-label
   *
   * If you are looking to set an accessible `aria-label` for the screen reader, please see the `children` prop details.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * An accessible label for the icon (not visible in the UI). A Badge component
   * can be passed in along with the label in order to render a badge on the
   * icon (visible in the UI).
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   * This can be used for positioning the icon or setting the icon's color
   *
   * This should *not* be used to override other styles on the component.
   * Meridian's internal CSS and HTML are private APIs and may change at any
   * time, potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * If this is not specified the component will not be focuseable.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].number,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   *
   * Note that `tabIndex` must be specified in order for the component to be
   * focuseable.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   *
   * Note that `tabIndex` must be specified in order for the component to be
   * focuseable.
   */
  onFocus: _propTypes["default"].func
} : {};
Icon.sizes = {
  small: 16,
  large: 24
};
var _default = Icon;
exports["default"] = _default;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tableSortToggle = _interopRequireDefault(__webpack_require__(408));

var _default = _tableSortToggle["default"];
exports["default"] = _default;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _table = _interopRequireDefault(__webpack_require__(82));

var _arrowsUpAndDown = _interopRequireDefault(__webpack_require__(409));

var _arrowUpLarge = _interopRequireDefault(__webpack_require__(410));

var _arrowDownLarge = _interopRequireDefault(__webpack_require__(411));

var _clickable = _interopRequireDefault(__webpack_require__(64));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _theme = __webpack_require__(14);

var _useFocus2 = _interopRequireDefault(__webpack_require__(40));

var _focusRing = _interopRequireDefault(__webpack_require__(43));

var _text = _interopRequireDefault(__webpack_require__(27));

var _token = __webpack_require__(12);

var _rtl = __webpack_require__(52);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var sortDirection = _ref.sortDirection,
      focus = _ref.focus,
      columnTextAlignment = _ref.columnTextAlignment;
  return (0, _emotion.css)((0, _text["default"])(t), {
    fontWeight: t("fontWeightHeader"),
    // Add padding to the sort button to increase its clickable area, but add
    // the same amount of negative margin to ensure that the sort button
    // padding doesn't double up with the table cell padding. This assumes
    // that the toggle will be placed in a container with at least the same
    // amount of padding as "sortIndicatorSpacing" (e.g. a table cell).
    padding: t("sortIndicatorSpacing"),
    margin: -t("sortIndicatorSpacing"),
    // Inline flex so that the sort button moves left/right according to the
    // table cell's text alignment
    display: "inline-flex",
    alignItems: "center",
    flexDirection: (0, _rtl.getHorizontalDirection)(columnTextAlignment) === "right" ? "row-reverse" : "row",
    justifyContent: (0, _rtl.getHorizontalDirection)(columnTextAlignment) === "right" ? "flex-end" : "flex-start",
    "& > * + *": (0, _defineProperty2["default"])({}, (0, _rtl.getHorizontalDirection)(columnTextAlignment) === "right" ? "marginRight" : "marginLeft", t("sortIndicatorSpacing")),
    // Icon wrapper styles
    "& > span:nth-child(2)": {
      width: t("sortIndicatorWidth"),
      height: t("sortIndicatorHeight")
    },
    // Icon styles
    "& > span > *[role=img]": {
      color: focus ? t("sortIndicatorColorFocus") : sortDirection !== null ? t("sortIndicatorColorSorted") : t("sortIndicatorColorDefault"),
      // The focus ring doesn't have a transition (for performance reasons) so
      // don't transition the icon when showing the focus state (otherwise the
      // icon fades in after the focus ring appears and it looks a bit wonky).
      transition: !focus ? t.transitionCss("motion", "color") : undefined
    },
    "&:hover > span > *[role=img]": {
      color: t("sortIndicatorColorHover")
    },
    "&:active > span > *[role=img]": {
      color: t("sortIndicatorColorPressed")
    }
  }, (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: 2
  }));
}, ["sortDirection", "focus", "columnTextAlignment"]);
/**
 * Drop this in a table column's header cell to render a control that can be
 * used to change the sort direction of the column.
 */

var TableSortToggle = function TableSortToggle(_ref2) {
  var onChange = _ref2.onChange,
      sortColumn = _ref2.sortColumn,
      value = _ref2.value,
      defaultSortDirection = _ref2.defaultSortDirection,
      columnTextAlignment = _ref2.columnTextAlignment,
      children = _ref2.children;
  var t = (0, _theme.useTheme)(_table["default"], "table");
  var sortDirection = value && value.sortColumn === sortColumn ? value.sortDirection : null;
  var onClick = (0, _react.useCallback)(function () {
    return onChange({
      sortColumn: sortColumn,
      sortDirection: sortDirection === "ascending" ? "descending" : sortDirection === "descending" ? "ascending" : defaultSortDirection
    });
  }, [sortColumn, sortDirection, defaultSortDirection, onChange]);
  var iconDirection = sortDirection || defaultSortDirection;

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, focusProps, {
    onClick: onClick,
    className: styles(t, {
      focus: focus && focusTrigger === "keyboard",
      sortDirection: sortDirection,
      columnTextAlignment: columnTextAlignment
    })
  }), /*#__PURE__*/_react["default"].createElement("span", null, children), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: sortDirection === null ? _arrowsUpAndDown["default"] : iconDirection === "descending" ? _arrowDownLarge["default"] : _arrowUpLarge["default"]
  }));
};

TableSortToggle.displayName = "TableSortToggle";
TableSortToggle.propTypes =  false ? {
  /**
   * The table cell's text.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The column that this toggle sorts.
   */
  sortColumn: _propTypes["default"].string.isRequired,

  /**
   * This is called when the user attempts to sort the column. The toggle's new
   * value, either "ascending" or "descending", will be passed to the function.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * This should match the text alignment of the table column that
   * contains the sort button.
   */
  columnTextAlignment: _propTypes["default"].oneOf(["left", "start", "right", "end"]),

  /**
   * This is the value that the toggle will default to when first clicked by the
   * user.
   */
  defaultSortDirection: _propTypes["default"].oneOf(["ascending", "descending"]),

  /**
   * The column that is currently sorted and the direction that it's sorted.
   */
  value: _propTypes["default"].shape({
    sortColumn: _propTypes["default"].string,
    sortDirection: _propTypes["default"].PropTypes.oneOf(["ascending", "descending"])
  })
} : {};
TableSortToggle.defaultProps = {
  defaultSortDirection: "ascending"
};
var _default = TableSortToggle;
exports["default"] = _default;

/***/ }),
/* 409 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconArrowsUpAndDownData: "data:image/svg+xml,%3csvg width='18' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='currentColor' fill-rule='nonzero'%3e%3cpath d='M4 0a1 1 0 011 1v9.585l1.293-1.292a1 1 0 011.32-.083l.094.083a1 1 0 010 1.414l-3 3A1.003 1.003 0 014 14l.085-.004a1.003 1.003 0 01-.052.003L4 14a1.223 1.223 0 01-.149-.011 1.12 1.12 0 01-.222-.06 1.005 1.005 0 01-.336-.222l.09.08a1.003 1.003 0 01-.09-.08l-3-3a1 1 0 111.414-1.414L3 10.585V1a1 1 0 01.883-.993L4 0zM14 14a1 1 0 001-1V3.415l1.293 1.292a1 1 0 001.32.083l.094-.083a1 1 0 000-1.414l-3-3A1 1 0 0014 0l.085.004A1 1 0 0014.033 0L14 0a1.016 1.016 0 00-.52.146 1.045 1.045 0 00-.187.147l.09-.08a1 1 0 00-.09.08l-3 3a1 1 0 001.414 1.414L13 3.415V13a1 1 0 00.883.993L14 14z'/%3e%3c/g%3e%3c/svg%3e",
  iconArrowsUpAndDownWidth: 18,
  iconArrowsUpAndDownHeight: 14
};

/***/ }),
/* 410 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconArrowUpLargeData: "data:image/svg+xml,%3csvg width='10' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M9 5L5 1 1 5M5 1v12'/%3e%3c/g%3e%3c/svg%3e",
  iconArrowUpLargeWidth: 10,
  iconArrowUpLargeHeight: 14
};

/***/ }),
/* 411 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconArrowDownLargeData: "data:image/svg+xml,%3csvg width='10' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1 9l4 4 4-4M5 13V1'/%3e%3c/g%3e%3c/svg%3e",
  iconArrowDownLargeWidth: 10,
  iconArrowDownLargeHeight: 14
};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _keycode = _interopRequireDefault(__webpack_require__(47));

var _noop = _interopRequireDefault(__webpack_require__(37));

var _buttonReset = _interopRequireDefault(__webpack_require__(221));

var _linkReset = _interopRequireDefault(__webpack_require__(413));

var _functional = __webpack_require__(26);

var _cxMemoized = _interopRequireDefault(__webpack_require__(76));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = (0, _functional.memoizeByKeys)(function (_ref) {
  var tag = _ref.tag,
      disabled = _ref.disabled;
  return (0, _emotion.css)({
    button: _objectSpread(_objectSpread({}, _buttonReset["default"]), {}, {
      // HACK: IE offsets the contents of buttons on mouse down (in the active
      // state) to create a faux 3D effect. These styles are applied to every
      // child of  the button in order to counter this effect so that we are
      // the masters of our own button-content-position-destiny.
      "& > *": {
        position: "relative"
      }
    }),
    a: _linkReset["default"]
  }[tag], {
    cursor: disabled ? "not-allowed" : "pointer",
    outline: "none"
  });
}, ["tag", "disabled"]);

var getPropsForNativeLink = function getPropsForNativeLink(props) {
  return {
    href: props.disabled ? undefined : props.href,
    target: props.target,
    rel: props.rel,
    "aria-disabled": props.disabled || undefined,
    role: props.role !== "link" ? props.role : undefined,
    tabIndex: props.disabled ? "-1" : props.tabIndex,
    onClick: props.onClick
  };
};

var getPropsForNativeButton = function getPropsForNativeButton(props) {
  return {
    disabled: props.disabled || undefined,
    type: props.submit ? "submit" : "button",
    role: props.role !== "button" ? props.role : undefined,
    tabIndex: props.tabIndex,
    onClick: props.onClick,
    form: props.form
  };
};

var getPropsForCustomClickable = function getPropsForCustomClickable(props) {
  return {
    href: props.disabled ? undefined : props.href,
    target: props.target,
    rel: props.rel,
    "aria-disabled": props.disabled || undefined,
    tabIndex: props.disabled ? "-1" : props.tabIndex || "0",
    role: props.role,
    onKeyDown: function onKeyDown(event) {
      var key = (0, _keycode["default"])(event);
      var focus = document.activeElement === event.currentTarget; // Trigger a click on enter-key-down for buttons and links

      if (focus && key === "enter") {
        props.onClick(event);
      } // Disable scrolling on space-key-down for buttons


      if (focus && key === "space" && props.role === "button") {
        event.preventDefault();
      }
    },
    onKeyUp: props.role === "button" ? function (event) {
      var key = (0, _keycode["default"])(event);
      var focus = document.activeElement === event.currentTarget; // Trigger a click on space-key-up for buttons

      if (focus && key === "space") {
        // NOTE: event.preventDefault() will have already been called at
        // this point to keep the space key from triggering a scroll
        // (see `onKeyDown` above), so instead of passing the original
        // event this will pass a mock event that looks like it hasn't
        // had preventDefault() called.
        props.onClick({
          defaultPrevented: false,
          preventDefault: _noop["default"]
        });
      }
    } : undefined,
    onClick: props.onClick
  };
};
/**
 * Simulate a link click by creating an anchor tag and clicking on it. This
 * allows features like the "rel" attribute to be used on Clickable that have
 * an href but aren't rendered as an "a" tag (e.g. a Card that might be rendered
 * as a div so it can contain action buttons/links).
 */


var simulateLinkClick = function simulateLinkClick(linkAttributes) {
  // Create a link element that we can click
  var link = document.createElement("a"); // Assign attributes to the link (e.g. href). Filter out undefined attributes.
  // React normally does this for us, but the DOM doesn't so we have to do it
  // manually to avoid things like `download="undefined"` in the DOM.

  Object.assign(link, Object.keys(linkAttributes).reduce(function (result, key) {
    if (linkAttributes[key] !== undefined) {
      result[key] = linkAttributes[key];
    }

    return result;
  }, {})); // Add the link to the DOM (necessary for this to work in some browsers like
  // FF)

  document.body.appendChild(link); // Trigger a click on the link

  link.click(); // Remove the link from the dom.

  document.body.removeChild(link);
};
/**
 * This component determines whether an `a` or `button` tag is most appropriate
 * given the props passed to it. It will render the element to the dom with its
 * styles completely reset. It also handles link disabling (not a native feature
 * of the web) and default event prevention for links with click handlers.
 *
 * The goal of this component is to provide a uniform API for clickable elements
 * while ensuring that we are always using the correct html element under the
 * hood. This allows us to can take advantage of default browser behavior and
 * maintain good accessibility.
 *
 * This component also allows nesting so that clickable parents can have
 * clickable children and the streams won't get crossed. For these use cases the
 * `tag` prop can be used to manually choose the html tag rendered by the
 * component, since clickable elements should not be nested inside native
 * buttons or links.
 */


var Clickable = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onClick = props.onClick,
      href = props.href,
      target = props.target,
      submit = props.submit,
      disabled = props.disabled,
      rel = props.rel,
      download = props.download,
      tabIndex = props.tabIndex,
      propagateClickEvent = props.propagateClickEvent; // Figure out the role of the clickable element and the tag to render to the
  // DOM

  var nativeRole = href && !submit ? "link" : "button";
  var role = props.role !== undefined ? props.role : nativeRole;
  var tag = props.tag ? props.tag : nativeRole === "link" ? "a" : "button";
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "mdn-", "aria-"]); // What happens when the Clickable is clicked. Pretty key.

  var onClickTag = (0, _react.useCallback)(function (event) {
    // If the default event behavior was already prevented (e.g. by a nested
    // Clickable inside this one) then don't do anything
    if (!event.defaultPrevented) {
      var nativeBehavior = tag === "a" && href || tag === "button" && submit; // Call `preventDefault` for elements that are either disabled, have a
      // custom onClick handler, or do not have any native browser behavior.
      // This keeps any parent Clickable elements higher up in the DOM tree from
      // also handling the event. This doesn't stop propagation though - other
      // elements may want to react to the event even if its default behavior
      // was cancelled.

      if (disabled || onClick || !nativeBehavior) {
        event.preventDefault();
      } // If we were explicitly told to stop propagation on the event then
      // do so now


      if (!propagateClickEvent) {
        event.stopPropagation();
      } // If we're not disabled then handle the click


      if (!disabled) {
        // If the element has native behavior and we don't have a custom
        // onClick handler, then fall back to the native behavior (and stop
        // propagation to keep anyone else from handling the click).
        if (nativeBehavior && !onClick) {
          event.stopPropagation();
        } // If we've got an element with an href and the user has attempted to
        // open it in a new tab (via control-click, command-click, or
        // middle-mouse-button click) then do that
        else if (href && (event.ctrlKey || event.metaKey || event.button === 1)) {
          simulateLinkClick({
            href: href,
            target: "_blank",
            rel: "noopener noreferrer",
            download: download
          });
        } // If we were given a custom onClick handle then call it and pass the
        // href (if we have one). This makes it easy to do html5-history-style
        // links like this:
        //   <Clickable href="/path" onClick={push}>
        //     my accessible html5 link
        //   </Clickable>
        else if (onClick) {
          onClick(href);
        } // For non-link elements with an href and no onClick handler we have
        // to manually navigate to the href
        else if (href) {
          simulateLinkClick({
            href: href,
            target: target,
            rel: rel,
            download: download
          });
        }
      }
    }
  }, [onClick, href, target, submit, disabled, tag, rel, download, propagateClickEvent]); // Generate props that are specific to the tag we're rendering (e.g. a link,
  // a button, and a div will all require different props in order to acheive
  // a particular behavior). Memoize these to reduce the number of large objects
  // created on each render.

  var clickableProps = (0, _react.useMemo)(function () {
    var props = {
      onClick: onClickTag,
      role: role,
      disabled: disabled,
      href: href,
      rel: rel,
      target: target,
      tabIndex: tabIndex,
      submit: submit
    };
    return tag === "a" && href ? getPropsForNativeLink(props) : tag === "button" ? getPropsForNativeButton(props) : getPropsForCustomClickable(props);
  }, [tag, onClickTag, role, disabled, href, rel, target, tabIndex, submit]); // HACK: Wrap string children in a span so that the IE positioning
  // hack (see the button styles above) can take effect

  var applyIE11StyleHack = tag === "button" && _react["default"].Children.toArray(props.children).filter(function (child) {
    return typeof child !== "string";
  }).length === 0;
  return /*#__PURE__*/_react["default"].createElement(tag, _objectSpread(_objectSpread(_objectSpread({}, passThroughProps), clickableProps), {}, {
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    onMouseMove: props.onMouseMove,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    onMouseDown: props.onMouseDown,
    onMouseUp: props.onMouseUp,
    id: props.id,
    download: props.download,
    title: props.title,
    className: (0, _cxMemoized["default"])(styles({
      tag: tag,
      disabled: props.disabled
    }), props.className),
    form: props.form,
    ref: ref
  }), applyIE11StyleHack ? /*#__PURE__*/_react["default"].createElement("span", null, props.children) : props.children);
});

Clickable.displayName = "Clickable";
Clickable.propTypes =  false ? {
  /**
   * All props prefixed with `aria-` are accepted. See the [W3C aria docs](https://w3c.github.io/using-aria/) for
   * relevant props.
   */
  "aria-*": _propTypes["default"].string,

  /**
   * The contents of the component.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * See docs for the [a tag's download attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-download).
   */
  download: _propTypes["default"].string,

  /**
   * The form attribute specifies the form the button belongs to. The value of this
   * attribute must be equal to the id attribute of a <form> element in the same
   * document. Please refer to this [guide](https://www.w3schools.com/tags/att_button_form.asp) for details.
   */
  form: _propTypes["default"].string,

  /**
   * If a URL is provided here, the component will behave like a link.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * Determines whether or not the clickable propagates the click event.
   * Setting to false will run `event.stopPropagation()`.
   */
  propagateClickEvent: _propTypes["default"].bool,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,

  /**
   * See docs for the [aria role attribute](https://www.w3.org/TR/wai-aria/#host_general_role).
   */
  role: _propTypes["default"].string,

  /**
   * See docs for the "submit" value of the [button tag's type attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attr-type).
   */
  submit: _propTypes["default"].bool,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The tag used to render the component in the DOM. This defaults to either
   * `a` or `button`, whichever is the more appropriate choice given the other
   * props provided (e.g. `href` or `onClick`).
   */
  tag: _propTypes["default"].string,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * Add a title to the element. Read [the MDN docs on title](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/title)
   * for details.
   */
  title: _propTypes["default"].string,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the mouse is pressed down on the component. The [mousedown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mousedown_event)
   * is passed as the first argument to the function.
   */
  onMouseDown: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves over the component. The [mouseenter event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseenter_event)
   * is passed as the first argument to the function.
   */
  onMouseEnter: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves off of the component. The [mouseleave event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseleave_event)
   * is passed as the first argument to the function.
   */
  onMouseLeave: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves within the component. The [mousemove event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mousemove_event)
   * is passed as the first argument to the function.
   */
  onMouseMove: _propTypes["default"].func,

  /**
   * This is called when a mouse press is released on the component. The [mouseup event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseup_event)
   * is passed as the first argument to the function.
   */
  onMouseUp: _propTypes["default"].func
} : {};
Clickable.defaultProps = {
  propagateClickEvent: true
};
var _default = Clickable;
exports["default"] = _default;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var linkReset = {
  display: "inline-block",
  outline: "none",
  textDecoration: "none",
  color: "inherit",
  cursor: "default"
};
var _default = linkReset;
exports["default"] = _default;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TableActionBarOverlay", {
  enumerable: true,
  get: function get() {
    return _tableActionBarOverlay["default"];
  }
});
exports["default"] = void 0;

var _tableActionBar = _interopRequireDefault(__webpack_require__(415));

var _tableActionBarOverlay = _interopRequireDefault(__webpack_require__(236));

var _default = _tableActionBar["default"];
exports["default"] = _default;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _find = _interopRequireDefault(__webpack_require__(101));

var _table = _interopRequireDefault(__webpack_require__(82));

var _elevation = __webpack_require__(59);

var _tableActionBarOverlay = _interopRequireDefault(__webpack_require__(236));

var _row = _interopRequireDefault(__webpack_require__(44));

var _button = _interopRequireDefault(__webpack_require__(50));

var _theme = __webpack_require__(14);

var _text = _interopRequireDefault(__webpack_require__(27));

var _isElementOf = _interopRequireDefault(__webpack_require__(72));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var isButton = (0, _isElementOf["default"])(_button["default"]);

var styles = function styles(t, _ref) {
  var stickyOffset = _ref.stickyOffset,
      withOverlay = _ref.withOverlay;
  return (0, _emotion.css)((0, _text["default"])(t), {
    // The action bar container adds whitespace between the action bar and the
    // table. It also ensures that the empty space is opaque (using the table's
    // background color) so that elements don't peak through between the action
    // bar and the table when the action bar is sticky.
    backgroundColor: t("backgroundColorDefault"),
    paddingBottom: t("spacingVerticalSmall"),
    "& > [mdn-action-bar]": {
      position: "relative"
    },
    // Hide the action bar's children when an overlay is shown (ensures that the
    // action bar's interactive children aren't focuseable when obscured by
    // an overlay).
    "& > [mdn-action-bar] > *:last-child": withOverlay && {
      visibility: "hidden"
    }
  }, stickyOffset !== undefined && {
    position: "sticky",
    top: stickyOffset,
    // Stack one higher than other fixtures to ensure that if the action bar
    // and table header conflict then the action bar is shown on top (this
    // happens when the user scrolls to the very bottom of an HTML table with
    // headers that are stuck using `position: sticky`).
    zIndex: _elevation.elevationFixture + 1
  });
};
/**
 * Used to render an action bar for a table. Usually placed as a child of the Table
 * component, but can be placed outside of the Table when necessary.
 */


var TableActionBar = function TableActionBar(props) {
  var children = props.children,
      alignmentHorizontal = props.alignmentHorizontal,
      widths = props.widths,
      stickyOffset = props.stickyOffset,
      overlayComponent = props.overlayComponent;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);

  var childrenArray = _react["default"].Children.toArray(children);

  var isOverlay = (0, _react.useMemo)(function () {
    return (0, _isElementOf["default"])(overlayComponent);
  }, [overlayComponent]);
  var isNotActionBarOverlay = (0, _react.useCallback)(function (child) {
    return !isOverlay(child);
  }, [isOverlay]);
  var overlay = (0, _find["default"])(children, isOverlay);
  var nonOverlayChildren = childrenArray.filter(isNotActionBarOverlay);
  var t = (0, _theme.useTheme)(_table["default"], "table");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, {
      stickyOffset: stickyOffset,
      withOverlay: Boolean(overlay)
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-action-bar": ""
  }, overlay, /*#__PURE__*/_react["default"].createElement(_row["default"], (0, _extends2["default"])({}, passThroughProps, {
    widths: widths,
    type: "fill",
    spacingInset: "small medium",
    spacing: "small",
    alignmentHorizontal: alignmentHorizontal
  }), nonOverlayChildren.map(function (element) {
    return isButton(element) ? /*#__PURE__*/_react["default"].cloneElement(element, {
      backdropColor: t.tokens.themeBackgroundSecondaryDefault
    }) : element;
  }))));
};

TableActionBar.displayName = "TableActionBar";
TableActionBar.propTypes =  false ? {
  /**
   * The contents of the action bar.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Use this to determine how the children in the action bar are aligned
   * horizontally.
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["left", "start", "center", "right", "end", "justify"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * The component that will render as an overlay. Defaults to Meridian's TableActionBarOverlay.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   *
   * @since  5.x
   */
  overlayComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),

  /**
   * This applies sticky positioning to the action bar so that it sticks to the
   * top of the viewport when the user scrolls. This is an experimental feature
   * that is not compatible with IE11. If you are using the TableActionBar with
   * Meridian's Table component, use the `fixHeaderRows` prop on the Table
   * component instead of this prop.
   */
  stickyOffset: _propTypes["default"].number,

  /**
   * Use this to determine the widths of the action bar's children. The action
   * bar uses the Row component under the hood - see the usage documentation of
   * the Row component for details on how to use this prop.
   */
  widths: _propTypes["default"].oneOfType([_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]), _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))])
} : {};
TableActionBar.defaultProps = {
  alignmentHorizontal: "start",
  overlayComponent: _tableActionBarOverlay["default"]
};
var _default = TableActionBar;
exports["default"] = _default;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(417),
    getMatchData = __webpack_require__(471),
    matchesStrictComparable = __webpack_require__(233);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(223),
    baseIsEqual = __webpack_require__(225);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 418 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(104);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(104);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(104);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(104);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(103);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 424 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 425 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 426 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(103),
    Map = __webpack_require__(142),
    MapCache = __webpack_require__(143);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(213),
    isMasked = __webpack_require__(429),
    isObject = __webpack_require__(85),
    toSource = __webpack_require__(224);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(430);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(53);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 431 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(433),
    ListCache = __webpack_require__(103),
    Map = __webpack_require__(142);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(434),
    hashDelete = __webpack_require__(435),
    hashGet = __webpack_require__(436),
    hashHas = __webpack_require__(437),
    hashSet = __webpack_require__(438);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(105);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 435 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(105);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(105);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(105);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(106);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 440 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(106);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(106);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(106);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(223),
    equalArrays = __webpack_require__(226),
    equalByTag = __webpack_require__(448),
    equalObjects = __webpack_require__(451),
    getTag = __webpack_require__(467),
    isArray = __webpack_require__(42),
    isBuffer = __webpack_require__(228),
    isTypedArray = __webpack_require__(229);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 445 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 446 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 447 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(84),
    Uint8Array = __webpack_require__(449),
    eq = __webpack_require__(138),
    equalArrays = __webpack_require__(226),
    mapToArray = __webpack_require__(450),
    setToArray = __webpack_require__(146);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(53);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 450 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(452);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(453),
    getSymbols = __webpack_require__(454),
    keys = __webpack_require__(86);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(227),
    isArray = __webpack_require__(42);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(455),
    stubArray = __webpack_require__(456);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 455 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 456 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(458),
    isArguments = __webpack_require__(147),
    isArray = __webpack_require__(42),
    isBuffer = __webpack_require__(228),
    isIndex = __webpack_require__(140),
    isTypedArray = __webpack_require__(229);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 458 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(74),
    isObjectLike = __webpack_require__(62);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 460 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(74),
    isLength = __webpack_require__(139),
    isObjectLike = __webpack_require__(62);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(214);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)(module)))

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(464),
    nativeKeys = __webpack_require__(465);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 464 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(466);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 466 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(468),
    Map = __webpack_require__(142),
    Promise = __webpack_require__(469),
    Set = __webpack_require__(231),
    WeakMap = __webpack_require__(470),
    baseGetTag = __webpack_require__(74),
    toSource = __webpack_require__(224);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65),
    root = __webpack_require__(53);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65),
    root = __webpack_require__(53);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65),
    root = __webpack_require__(53);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(232),
    keys = __webpack_require__(86);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(225),
    get = __webpack_require__(473),
    hasIn = __webpack_require__(478),
    isKey = __webpack_require__(148),
    isStrictComparable = __webpack_require__(232),
    matchesStrictComparable = __webpack_require__(233),
    toKey = __webpack_require__(107);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(234);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(475);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(476);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(143);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(84),
    arrayMap = __webpack_require__(149),
    isArray = __webpack_require__(42),
    isSymbol = __webpack_require__(99);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(479),
    hasPath = __webpack_require__(480);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 479 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(235),
    isArguments = __webpack_require__(147),
    isArray = __webpack_require__(42),
    isIndex = __webpack_require__(140),
    isLength = __webpack_require__(139),
    toKey = __webpack_require__(107);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(482),
    basePropertyDeep = __webpack_require__(483),
    isKey = __webpack_require__(148),
    toKey = __webpack_require__(107);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 482 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(234);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridColumns = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _box = _interopRequireDefault(__webpack_require__(49));

var _propTypes2 = _interopRequireDefault(__webpack_require__(77));

var _parsers = __webpack_require__(66);

var _functional = __webpack_require__(26);

var _cxMemoized = _interopRequireDefault(__webpack_require__(76));

var _rtl = __webpack_require__(52);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var gridColumns = 12; // Turns a raw width value (a string or number) into an object with fields
// containing the type of width and the parsed width values

exports.gridColumns = gridColumns;

var parseWidth = function parseWidth(width) {
  return typeof width === "string" && /^grid-/.test(width) ? {
    type: "grid",
    // Turns "grid-X" into a numeric percentage w/ four significant digits (e.g.
    // "grid-4" to 0.3333)
    value: Math.floor(10000 * parseInt(width.substr(5)) / gridColumns) / 10000
  } : typeof width === "string" && /^[0-9.]+%\s*$/.test(width) ? {
    type: "percentage",
    // Turns "X%" into a numeric percentage w/ four significant digis (e.g. "33.33%"
    // to 0.3333)
    value: Math.floor(100 * parseFloat(width)) / 10000
  } : width === "fit" || width === "fill" ? {
    type: "flex",
    value: width
  } : width !== undefined && width !== null && width !== "" ? {
    type: "css",
    value: width
  } : {
    type: "empty",
    value: null
  };
}; // These styles stretch the inner div to fill the entire box so that a width or
// height applied to the box will also apply to the inner div. This is only
// necessary for rows that wrap (which have two containing divs in order to make
// the gutter spacing work correctly - see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Mastering_Wrapping_of_Flex_Items#Creating_gutters_between_items)


var wrapContainerStyles = (0, _emotion.css)({
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch"
});

var rowStyles = function rowStyles(widths) {
  return (0, _functional.memoizeByKeys)(function (_ref) {
    var _css;

    var wrap = _ref.wrap,
        spacing = _ref.spacing,
        alignmentHorizontal = _ref.alignmentHorizontal,
        alignmentVertical = _ref.alignmentVertical,
        reverse = _ref.reverse;
    var spacingValues = (0, _parsers.parseSpacing)(spacing);
    var verticalSpacing = spacingValues[0];
    var horizontalSpacing = spacingValues[1] || verticalSpacing;
    return (0, _emotion.css)((_css = {
      width: wrap === "none" ? undefined : "calc(100% + ".concat(horizontalSpacing, "px)"),
      display: "flex",
      flexDirection: reverse ? "row-reverse" : "row",
      flexWrap: wrap === "down" ? "wrap" : wrap === "up" ? "wrap-reverse" : undefined,
      alignItems: {
        top: "flex-start",
        bottom: "flex-end"
      }[alignmentVertical] || alignmentVertical,
      justifyContent: {
        left: "flex-start",
        right: "flex-end",
        justify: "space-between"
      }[(0, _rtl.getHorizontalDirection)(alignmentHorizontal)] || (0, _rtl.getHorizontalDirection)(alignmentHorizontal),
      // Reset the extra margins caused by the children on the right/bottom
      // edges. We can't do a simple reset on the first/last child because
      // there may be any number of children on the right/bottom edges if the
      // row wraps.
      margin: wrap === "none" ? undefined : "0 -".concat(horizontalSpacing, "px ").concat(wrap === "none" ? 0 : "-".concat(verticalSpacing, "px"), " 0")
    }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
      margin: wrap === "none" ? undefined : "0 0 ".concat(wrap === "none" ? 0 : "-".concat(verticalSpacing, "px"), " -").concat(horizontalSpacing, "px")
    }), (0, _defineProperty2["default"])(_css, "& > *", (0, _defineProperty2["default"])({
      // Make sure that any borders or padding applied to the child don't throw
      // of the widths that we apply
      boxSizing: "border-box !important",
      // Set margins for horizontal spacing and vertical spacing if the row is
      // allowed to wrap (and clear other margins)
      margin: "0 ".concat(horizontalSpacing, "px ").concat(wrap === "none" ? 0 : verticalSpacing, "px 0 !important")
    }, "[dir=\"rtl\"] &", {
      margin: "0 0 ".concat(wrap === "none" ? 0 : verticalSpacing, "px ").concat(horizontalSpacing, "px !important")
    })), (0, _defineProperty2["default"])(_css, "& > *:".concat(reverse ? "first" : "last", "-child"), wrap === "none" ? {
      marginRight: "0 !important"
    } : undefined), (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] & > *:".concat(reverse ? "first" : "last", "-child"), wrap === "none" ? {
      marginLeft: "0px !important"
    } : undefined), _css), // If we've got an array of widths, apply each width to the child whose
    // index in the dom matches the widths's index in the array. If we've
    // got a single height, apply that to all children.
    Array.isArray(widths) ? widths.reduce(function (result, width, index) {
      result["& > *:nth-child(".concat(parseInt(index) + 1, ")")] = childStyles({
        width: width,
        wrap: wrap,
        horizontalSpacing: horizontalSpacing
      });
      return result;
    }, {}) : {
      "& > *": childStyles({
        width: widths,
        wrap: wrap,
        horizontalSpacing: horizontalSpacing
      })
    });
  }, ["wrap", "spacing", "alignmentHorizontal", "alignmentVertical", "reverse"]);
};

var rowStylesWithUniqueWidths = (0, _functional.memoizeArray)(rowStyles);
var rowStylesWithUniformWidths = (0, _functional.memoize)(rowStyles);

var childStyles = function childStyles(_ref2) {
  var rawWidth = _ref2.width,
      wrap = _ref2.wrap,
      horizontalSpacing = _ref2.horizontalSpacing;
  var width = parseWidth(rawWidth);
  return {
    // Stretch the child to fill remaining space if the width is "fill"
    flex: width.type === "flex" && width.value === "fill" ? "1 !important" : undefined,
    // Ensure that the child isn't smashed by flexbox if it has an explicit
    // width set.
    flexShrink: width.type === "grid" || width.type === "percentage" || width.type === "flex" && width.value === "fit" || width.type === "css" && width.value !== "auto" ? "0 !important" : undefined,
    width: width.type === "grid" || width.type === "percentage" ? // For percentage widths (or grid widths), set the element to the
    // specified percentage of the row's width (e.g. 50%) but subtract the
    // gutter spacing from the width to ensure there's enough room for the
    // element and its gutter (e.g. 50% - 16px). For rows that wrap we can
    // subtract the full gutter width since each element has a full gutter
    // to its right (the extra gutter on the right edge of the row is
    // removed with a negative margin on the parent element). For rows
    // that don't wrap the last element doesn't have a gutter to its
    // right, so things are a bit more complicated. In this case there's
    // one less gutter than there are elements in the row (e.g. 3 elements
    // have 2 gutters between them) so subtracting a full gutter from each
    // element's width would be too much. We have to spread out this saved
    // saved gutter space proportional to the percentage of the row that
    // the element takes up. For example if a row has two elements that
    // each take up 50% of the row with a single 16px gutter between them,
    // then we'd subtract 50% of the 16px gutter from each element giving
    // us a final width of 50% - 8px for each element.
    "calc(".concat(width.value * 100, "% - ").concat(horizontalSpacing - (wrap === "none" ? width.value * horizontalSpacing : 0), "px) !important") : width.type === "css" ? // If the size is a plain CSS value then just use that directly
    "".concat(width.value).concat(typeof width.value === "number" ? "px" : "", " !important") : // And lastly for fit, fill, or empty values leave it up to flexbox
    undefined
  };
};
/**
 * The Row component lines children up horizontally in a row with even spacing
 * in-between them. If a value is provided for the `wrap` property then the Row
 * component can also be used to stack elements with even vertical spacing
 * between them.
 */


var Row = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  // A row with an explicit height cannot wrap
  var wrap = props.height === undefined ? props.wrap : "none"; // We need to memoize differently based on whether we got an array or scalar
  // for the "widths" property

  var rowStylesFunc = Array.isArray(props.widths) ? rowStylesWithUniqueWidths : rowStylesWithUniformWidths;
  var rowStyles = rowStylesFunc(props.widths)(_objectSpread(_objectSpread({}, props), {}, {
    wrap: wrap
  })); // Apply the row styles to an extra div inside the box so margins that are
  // applied to the box (e.g. if the row is nested in another row) don't
  // conflict with the margins that are applied by `rowStyles`.

  return /*#__PURE__*/_react["default"].createElement(_box["default"], _objectSpread(_objectSpread({}, props), {}, {
    className: wrap === "none" ? (0, _cxMemoized["default"])(rowStyles, props.className) : (0, _cxMemoized["default"])(wrapContainerStyles, props.className),
    ref: ref
  }), wrap === "none" ? props.children : /*#__PURE__*/_react["default"].createElement("div", {
    className: rowStyles
  }, props.children));
});

Row.displayName = "Row";
Row.propTypes =  false ? {
  /**
   * Specify the horizontal alignment of the elements inside the row.
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["left", "start", "center", "right", "end", "justify"]),

  /**
   * Specify the vertical alignment of the elements inside the row.
   *
   * @since 5.x
   */
  alignmentVertical: _propTypes["default"].oneOf(["top", "center", "bottom", "stretch", "baseline"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.18.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set the column's background color using a preset, or using a string
   * containing any valid CSS color.
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary"]), _propTypes["default"].string]),

  /**
   * The elements to line up in a row. Any elements can be supplied here, although if
   * only one child is supplied the row will not add much value (it's meant
   * for aligning multiple elements). If you only have one child, consider using
   * the `Box` component instead.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Set the height of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum height of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum width of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum height of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum width of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Controls the horizontal overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowX` can cause the `overflow-y` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   *
   * @since 5.21.0
   */
  overflowX: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * Controls the vertical overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowY` can cause the `overflow-x` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   */
  overflowY: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * If set to true this will reverse the order in which the elements in the row
   * are rendered (the first element will be rendered where the last normally
   * would, and vice-versa).
   */
  reverse: _propTypes["default"].bool,

  /**
   * Set the spacing between elements in the row using a preset.
   *
   * Two spacing values are allowed (separated by a space) if the `wrap` prop is
   * set. In this case the first value will be used as the vertical spacing
   * between elements and the second value will be used as the horizontal
   * spacing.
   */
  spacing: _propTypes2["default"].spacing(2),

  /**
   * Apply padding to the component.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"small medium"` for small padding on the top/bottom and
   * medium padding on the left/right).
   */
  spacingInset: _propTypes2["default"].spacing(4),

  /**
   * The HTML tag to use when rendering the component to the DOM.
   */
  tag: _propTypes["default"].string,

  /**
   * Set the style of the row using one of Meridian's Box component styles.
   * If omitted the row will not have any decorative visual style applied to
   * it.
   */
  type: _propTypes["default"].oneOf(["outline", "fill"]),

  /**
   * Set the width of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the width of each element in the row.
   *
   * If a single width is provided then it will be applied to every element in
   * the row. If an array of widths is provided then each width will be
   * applied to the element in the row that exists at the same index as the
   * width in the array (e.g. `[<element 0 width>, <element 1 width>, null, <element 3 width>]`).
   *
   * The possible values for each width are:
   *   - `number` - A fixed pixel width.
   *   - `string` - Any valid CSS width.
   *   - `"fit"` - The element's width will shrink to fit its contents.
   *   - `"fill"` - The element's width will fill all remaining space in the row.
   *     If this value is set on multiple elements, they will share the remaining
   *     space in the row equally.
   *   - `"grid-<x>"` - The element will take up "x" grid units on a 12-column grid
   *     ("x" can be 1-12).
   */
  widths: _propTypes["default"].oneOfType([_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]), _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),

  /**
   * Set this to allow elements that overflow the width of the row to wrap. If
   * this is set to `"down"` then elements that overflow to the right will wrap
   * down below the other elements. If set to `"up"` then the overflowing
   * elements will wrap up above the other elements.
   *
   * NOTE: Negative margins are used internally in order to maintain the correct
   * gutter spacing between elements that wrap ([this technique is recommended by MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Mastering_Wrapping_of_Flex_Items#Creating_gutters_between_items)).
   * This can cause unwanted horizontal scrolling if the inset spacing of the
   * row is less than the gutter spacing *and* the row is placed in a parent that
   * allows overflow. To resolve this you can either increase the padding/margin
   * around the row (using the `insetSpacing` prop of the row or by applying
   * padding/margin to an element that wraps the row) or turn off the
   * overflow on the row's parent element (by applying an `overflow: hidden`
   * style). You can also turn off wrapping on the row or consider using custom
   * styles to build a layout with something like [CSS grid](https://css-tricks.com/snippets/css/complete-guide-grid/).
   */
  wrap: _propTypes["default"].oneOf(["up", "down", "none"])
} : {};
Row.defaultProps = {
  wrap: "none",
  spacing: "medium",
  alignmentVertical: "center",
  alignmentHorizontal: "start"
};
var _default = Row;
exports["default"] = _default;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _box = _interopRequireDefault(__webpack_require__(486));

var _propTypes2 = _interopRequireDefault(__webpack_require__(77));

var _theme = __webpack_require__(14);

var _cxMemoized = _interopRequireDefault(__webpack_require__(76));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

var _box2 = __webpack_require__(488);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * The Box component can also be used to visually separate part of the layout by
 * applying an outline or fill.
 *
 * It can also be used as a layout component (similar to the Row and Column
 * components) to apply width and inset padding to any part of the layout (with
 * or without an outline or fill).
 */
var Box = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return (// Only pull in theme tokens if we're styling the box
    props.backgroundColor || props.type ? /*#__PURE__*/_react["default"].createElement(ThemedBox, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }), props.children) : /*#__PURE__*/_react["default"].createElement(props.tag, _objectSpread(_objectSpread({}, (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"])), {}, {
      className: (0, _cxMemoized["default"])((0, _box2.styles)(props), props.className),
      id: props.id,
      tabIndex: props.tabIndex,
      ref: ref
    }), props.children)
  );
});

Box.displayName = "Box";
Box.propTypes = {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.18.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set the box's background color using a preset, or using a string
   * containing any valid CSS color.
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary", "alternatePrimary", "alternateSecondary"]), _propTypes["default"].string]),

  /**
   * The elements to render inside the box.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Set the height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Adds an [id](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id) to the component.
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  id: _propTypes["default"].string,

  /**
   * Set the maximum height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Controls the horizontal overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowX` can cause the `overflow-y` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   *
   * @since 5.20.0
   */
  overflowX: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * Controls the vertical overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowY` can cause the `overflow-x` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   */
  overflowY: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * Apply padding to the component.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"small medium"` for small padding on the top/bottom and
   * medium padding on the left/right).
   */
  spacingInset: _propTypes2["default"].spacing(4),

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The HTML tag to use when rendering the component to the DOM.
   */
  tag: _propTypes["default"].string,

  /**
   * The type of visuals to apply to the box. If this is omitted the box will
   * not have any decorative styles and can be used purely for layout purposes.
   */
  type: _propTypes["default"].oneOf(["outline", "fill"]),

  /**
   * Set the width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Box.defaultProps = {
  tag: "div",
  spacingInset: "none"
};
/* eslint-disable react/prop-types */

/**
 * This component renders a themed box. This is only used if themed styles are
 * actually applied to the box. Otherwise we can skip all the extra work that
 * goes into theming.
 */

var ThemedBox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_box["default"], "box");
  return /*#__PURE__*/_react["default"].createElement(props.tag, _objectSpread(_objectSpread({}, (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"])), {}, {
    className: (0, _cxMemoized["default"])((0, _box2.themedStyles)(t)(props), props.className),
    id: props.id,
    tabIndex: props.tabIndex,
    ref: ref
  }), props.children);
});

ThemedBox.displayName = "ThemedBox";
/* eslint-enable react/prop-types */

var _default = Box;
exports["default"] = _default;

/***/ }),
/* 486 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    boxBackgroundColorOutline: tokens.themeBackgroundPrimaryDefault,
    boxBackgroundColorFill: tokens.themeBackgroundSecondaryDefault,
    boxBorderWidth: 1,
    boxBorderRadiusOutline: 4,
    boxBorderRadiusFill: 4,
    boxBorderColorOutline: tokens.themeBorderSecondaryDefault
  }
};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var shim = function shim() {};

shim.isRequired = shim;

var getShim = function getShim() {
  return shim;
}; // Important!
// Keep this list in sync with production version in `./_prop-types.js`.


var size = shim;
var flexAlignment = getShim;
var spacing = getShim;
var alignment = shim;
var _default = {
  size: size,
  flexAlignment: flexAlignment,
  spacing: spacing,
  alignment: alignment
};
exports["default"] = _default;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themedStyles = exports.styles = exports.cardStyles = void 0;

var _emotion = __webpack_require__(4);

var _text = _interopRequireDefault(__webpack_require__(27));

var _functional = __webpack_require__(26);

var _borderRadius = _interopRequireDefault(__webpack_require__(100));

var _token = __webpack_require__(12);

var _parsers = __webpack_require__(66);

var cardStyles = (0, _functional.memoize)(function (c) {
  var borderRadius = c("borderRadius");
  var imageBorderRadius = borderRadius - c("borderWidth");
  return (0, _emotion.css)((0, _text["default"])(c), {
    border: c.borderCss("border"),
    borderRadius: borderRadius,
    boxShadow: c.boxShadowCss("dropShadowDefault"),
    position: "relative",
    "& > *[role=img]": {
      borderRadius: (0, _borderRadius["default"])(imageBorderRadius, ["topLeft", "topRight"])
    }
  });
});
exports.cardStyles = cardStyles;
var styles = (0, _functional.memoizeByKeys)(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
      borderColor = _ref.borderColor,
      borderWidth = _ref.borderWidth,
      borderRadius = _ref.borderRadius,
      width = _ref.width,
      height = _ref.height,
      minWidth = _ref.minWidth,
      minHeight = _ref.minHeight,
      maxWidth = _ref.maxWidth,
      maxHeight = _ref.maxHeight,
      overflowX = _ref.overflowX,
      overflowY = _ref.overflowY,
      spacingInset = _ref.spacingInset;
  return (0, _emotion.css)({
    boxSizing: "border-box",
    // If we have a border radius defined then clip content so that it doesn't
    // bleed out the corners
    overflow: borderRadius ? "hidden" : undefined,
    overflowX: overflowX ? overflowX : undefined,
    overflowY: overflowY ? overflowY : undefined,
    padding: (0, _parsers.parseSpacing)(spacingInset).map(function (value) {
      return "".concat(value, "px");
    }).join(" "),
    borderStyle: borderWidth && borderColor ? "solid" : undefined,
    borderWidth: borderWidth,
    borderColor: borderColor,
    borderRadius: borderRadius,
    backgroundColor: backgroundColor,
    width: width,
    height: height,
    minWidth: minWidth,
    maxWidth: maxWidth,
    minHeight: minHeight,
    maxHeight: maxHeight
  });
}, ["backgroundColor", "borderColor", "borderWidth", "borderRadius", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "overflowX", "overflowY", "spacingInset"]);
exports.styles = styles;
var themedStyles = (0, _functional.memoize)(function (t) {
  return (0, _functional.memoizeByKeys)(function (_ref2) {
    var type = _ref2.type,
        backgroundColor = _ref2.backgroundColor,
        width = _ref2.width,
        height = _ref2.height,
        minWidth = _ref2.minWidth,
        minHeight = _ref2.minHeight,
        maxWidth = _ref2.maxWidth,
        maxHeight = _ref2.maxHeight,
        overflowX = _ref2.overflowX,
        overflowY = _ref2.overflowY,
        spacingInset = _ref2.spacingInset;
    return styles({
      backgroundColor: backgroundColor ? (0, _token.getToken)(t.tokens, "themeBackground", [backgroundColor, "default"]) || backgroundColor : t("backgroundColor", type),
      borderColor: t("borderColor", type),
      borderWidth: t("borderWidth"),
      borderRadius: t("borderRadius", type),
      width: width,
      height: height,
      minWidth: minWidth,
      minHeight: minHeight,
      maxWidth: maxWidth,
      maxHeight: maxHeight,
      overflowX: overflowX,
      overflowY: overflowY,
      spacingInset: spacingInset
    });
  }, ["type", "backgroundColor", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "overflowX", "overflowY", "spacingInset"]);
});
exports.themedStyles = themedStyles;

/***/ }),
/* 489 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports = {
  spacing100: 2,
  spacing200: 4,
  spacing300: 8,
  spacing400: 16,
  spacing450: 24,
  spacing500: 32,
  spacing600: 64,
  spacingNone: 0,
  spacingXxsmall: 2,
  spacingXsmall: 4,
  spacingSmall: 8,
  spacingMedium: 16,
  spacingLarge: 32,
  spacingXlarge: 64
};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _button = _interopRequireDefault(__webpack_require__(155));

var _theme = __webpack_require__(14);

var _clickable = _interopRequireDefault(__webpack_require__(64));

var _useFocus2 = _interopRequireDefault(__webpack_require__(40));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _buttonStyles = __webpack_require__(237);

var _text = _interopRequireDefault(__webpack_require__(27));

var _token = __webpack_require__(12);

var _isColorDark = _interopRequireDefault(__webpack_require__(491));

var _isElementOf = _interopRequireDefault(__webpack_require__(72));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

var isIcon = (0, _isElementOf["default"])(_icon["default"]);
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _css;

  var size = _ref.size,
      type = _ref.type,
      focus = _ref.focus,
      disabled = _ref.disabled,
      minWidth = _ref.minWidth,
      _ref$backdropColor = _ref.backdropColor,
      backdropColor = _ref$backdropColor === void 0 ? t.tokens.themeBackgroundPrimaryDefault : _ref$backdropColor,
      iconOnly = _ref.iconOnly,
      circular = _ref.circular;
  var state = disabled ? "disabled" : "default";
  var linkOrIcon = type === "link" || type === "icon";
  var backdrop = linkOrIcon && (0, _isColorDark["default"])(backdropColor) ? "darkBackdrop" : linkOrIcon ? "lightBackdrop" : undefined;
  var borderColor = t("borderColor", [type, state]);
  var borderWidth = borderColor ? t("borderWidth") : 0;
  var borderStyle = borderColor ? "solid" : undefined;
  var borderRadius = circular && iconOnly ? 999 : t("borderRadius");
  return (0, _emotion.css)((0, _text["default"])(t, {
    fontSize: size
  }), disabled ? (0, _buttonStyles.disabledStyles)(t, {
    type: type,
    backdrop: backdrop
  }) : (0, _buttonStyles.defaultStyles)(t, {
    type: type,
    backdrop: backdrop
  }), (_css = {
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    outline: "none",
    position: "relative",
    minWidth: minWidth,
    height: t("height", size),
    // Make icon-only buttons square w/ no padding and all other buttons
    // flexible with padding.
    width: iconOnly ? t("height", size) : undefined,
    flexShrink: iconOnly ? 0 : undefined,
    padding: iconOnly ? undefined : "0 ".concat(t("spacingInsetHorizontal", size), "px"),
    transition: t.transitionCss("motion", ["color", "background-color", "border-color"]),
    borderRadius: borderRadius,
    borderStyle: borderStyle,
    borderWidth: borderWidth,
    whiteSpace: "nowrap",
    // HACK: IE11 will only show a pseudo element on a button if
    // overflow is set to visible, and our focus ring is displayed with a
    // pseudo element.
    overflow: "visible",
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // "& > * + *": {
    //   marginInlineStart: t("spacingInsetHorizontal", size),
    // },
    "& > * + *": {
      marginLeft: t("spacingInsetHorizontal", size),
      marginRight: 0
    }
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] & > * + *", {
    marginLeft: 0,
    marginRight: t("spacingInsetHorizontal", size)
  }), (0, _defineProperty2["default"])(_css, ":hover", !disabled ? (0, _buttonStyles.hoverStyles)(t, {
    type: type,
    backdrop: backdrop
  }) : undefined), (0, _defineProperty2["default"])(_css, ":active", !disabled ? (0, _buttonStyles.activeStyles)(t, {
    type: type,
    backdrop: backdrop
  }) : undefined), _css), !disabled ? (0, _buttonStyles.focusStyles)(t, {
    focus: focus,
    borderWidth: borderWidth,
    borderRadius: borderRadius,
    backdropColor: backdropColor,
    linkOrIcon: linkOrIcon
  }) : undefined);
}, ["size", "type", "focus", "disabled", "backdropColor", "minWidth", "iconOnly", "circular"]); // Used to wrap button text in spans. This allows the margins applied by the
// button to take effect, since you can't apply a margin to a text node. This
// was implemented with the <Button><Icon /> text</Button> use case in mind
// where spacing needs to be applied between the icon and the text. Note that
// this is not applied if the button only has one child.

var wrapStringSiblingsInSpans = function wrapStringSiblingsInSpans(children) {
  var arr = _react["default"].Children.toArray(children);

  return arr.length > 1 ? arr.map(function (child, index) {
    return typeof child === "string" ? /*#__PURE__*/_react["default"].createElement("span", {
      key: index
    }, child) : child;
  }) : children;
};
/**
 * Render a button. Note that won't necessarily result in a "button" tag in the
 * DOM - if you provide an href attribute then an "a" tag will be used for
 * accessibility purposes.
 */


var Button = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_button["default"], "button"); // Does the button contain only an icon (no text)?

  var iconOnly = _react["default"].Children.count(props.children) === 1 && isIcon(props.children); // Pull popovers closer to icon/link buttons so that they're offset from the
  // edge of the icon/text (which is visible), not the edge of the button
  // element (which is not visible). The magic "24" for the icon variant is the
  // size of a standard icon. By subtracting that from the height of the button
  // and dividing by 2 we get the distance between the invisible edge of the
  // button and the visible edge of the icon.

  var popoverOffset = props.type === "icon" ? -(t("height", props.size) - 24) / 2 : props.type === "link" ? -(t("height", props.size) - t("fontSize", props.size)) / 2 : undefined;

  var _useFocus = (0, _useFocus2["default"])(props),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]);
  return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, {
    ref: ref,
    className: (0, _emotion.cx)(styles(t, {
      type: props.type,
      size: props.size,
      disabled: props.disabled,
      circular: props.circular,
      backdropColor: props.backdropColor,
      minWidth: props.minWidth,
      focus: focus && focusTrigger === "keyboard",
      iconOnly: iconOnly
    }), props.className),
    disabled: props.disabled,
    id: props.id,
    href: props.href,
    rel: props.rel,
    target: props.target,
    onClick: props.onClick,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    propagateClickEvent: props.propagateClickEvent,
    tabIndex: props.tabIndex,
    download: props.download,
    submit: props.submit // eslint-disable-next-line react/prop-types
    ,
    "aria-label": props["aria-label"] || props.label || undefined,
    form: props.form || undefined,
    "mdn-popover-offset": popoverOffset
  }, focusProps), wrapStringSiblingsInSpans(props.children));
});

Button.displayName = "Button";
Button.propTypes =  false ? {
  /**
   * The button's contents. This can be a string label, an Icon, or a
   * combination of a string label and an Icon.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.27.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * This optimizes the button for display when placed over a particular
   * background color. This is only helpful if the button is placed over a
   * background color other than the current theme's primary background color.
   */
  backdropColor: _propTypes["default"].string,

  /**
   * Render a circular button. This is only applicable to icon-only buttons.
   * Buttons with text labels cannot be circular.
   */
  circular: _propTypes["default"].bool,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the `href` prop to render a button that
   * triggers the download of a file. See docs for the [HTML download attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-download).
   */
  download: _propTypes["default"].string,

  /**
   * The form attribute specifies the form the button belongs to. The value of this
   * attribute must be equal to the id attribute of a <form> element in the same
   * document. Please refer to this [guide](https://www.w3schools.com/tags/att_button_form.asp) for details.
   *
   * @since 5.22.0
   */
  form: _propTypes["default"].string,

  /**
   * If a URL is provided here, the component will behave like a link.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * An accessible label for the component. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   *
   */
  label: _propTypes["default"].string,

  /**
   * Sets the minimum width on the button. The button may grow wider than this
   * value depending on the length of its label, but it will not grow narrow
   * than this value.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Determines whether or not the click event will continue to bubble up
   * through the DOM. Read the [Event.stopPropagation() docs](https://developer.mozilla.org/en-US/docs/Web/API/Event/stopPropagation)
   * for details.
   */
  propagateClickEvent: _propTypes["default"].bool,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * If set to true the button will automatically trigger the submit action of
   * any `<form />` that it's placed in.
   */
  submit: _propTypes["default"].bool,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * This determines the visual style of the button.
   */
  type: _propTypes["default"].oneOf(["primary", "secondary", "tertiary", "link", "icon"]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=react-web)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves over the component. The [mouseenter event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseenter_event)
   * is passed as the first argument to the function.
   */
  onMouseEnter: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves off of the component. The [mouseleave event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseleave_event)
   * is passed as the first argument to the function.
   */
  onMouseLeave: _propTypes["default"].func
} : {};
Button.defaultProps = {
  propagateClickEvent: true,
  size: "medium",
  type: "primary"
};
var _default = Button;
exports["default"] = _default;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Thanks StackOverflow!
var getBrightness = function getBrightness(hex) {
  var decimal = parseInt(hex.substring(1), 16); // convert hex (rrggbb) to decimal

  var r = decimal >> 16 & 0xff; // extract red

  var g = decimal >> 8 & 0xff; // extract green

  var b = decimal >> 0 & 0xff; // extract blue

  return 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
};

var isColorDark = function isColorDark(hex) {
  return getBrightness(hex) < 128;
};

var _default = isColorDark;
exports["default"] = _default;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(48));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _uniqueId = _interopRequireDefault(__webpack_require__(51));

var _alert = _interopRequireDefault(__webpack_require__(493));

var _alertErrorXlarge = _interopRequireDefault(__webpack_require__(494));

var _alertErrorLarge = _interopRequireDefault(__webpack_require__(495));

var _alertErrorSmall = _interopRequireDefault(__webpack_require__(496));

var _alertInformationalLarge = _interopRequireDefault(__webpack_require__(497));

var _alertInformationalSmall = _interopRequireDefault(__webpack_require__(498));

var _alertSuccessXlarge = _interopRequireDefault(__webpack_require__(499));

var _alertSuccessLarge = _interopRequireDefault(__webpack_require__(500));

var _alertSuccessSmall = _interopRequireDefault(__webpack_require__(501));

var _alertWarningXlarge = _interopRequireDefault(__webpack_require__(502));

var _alertWarningLarge = _interopRequireDefault(__webpack_require__(503));

var _alertWarningSmall = _interopRequireDefault(__webpack_require__(504));

var _close = _interopRequireDefault(__webpack_require__(154));

var _theme = __webpack_require__(14);

var _button = _interopRequireDefault(__webpack_require__(50));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

var _token = __webpack_require__(12);

var _focus = __webpack_require__(157);

var _getIconCss = _interopRequireDefault(__webpack_require__(83));

var _text = _interopRequireDefault(__webpack_require__(27));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var iconTokens = {
  small: {
    error: _alertErrorSmall["default"],
    informational: _alertInformationalSmall["default"],
    success: _alertSuccessSmall["default"],
    warning: _alertWarningSmall["default"]
  },
  medium: {
    error: _alertErrorSmall["default"],
    informational: _alertInformationalSmall["default"],
    success: _alertSuccessSmall["default"],
    warning: _alertWarningSmall["default"]
  },
  large: {
    error: _alertErrorLarge["default"],
    informational: _alertInformationalLarge["default"],
    success: _alertSuccessLarge["default"],
    warning: _alertWarningLarge["default"]
  },
  xlarge: {
    error: _alertErrorXlarge["default"],
    informational: _alertInformationalLarge["default"],
    success: _alertSuccessXlarge["default"],
    warning: _alertWarningXlarge["default"]
  }
};
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _css2;

  var size = _ref.size,
      type = _ref.type,
      toast = _ref.toast,
      width = _ref.width;
  var borderWidth = t("borderWidth", size);
  var icon = (0, _token.getIconFromTokens)(iconTokens[size][type]);
  return (0, _emotion.css)((_css2 = {
    /**
     * Container styles
     */
    boxSizing: "border-box",
    display: "flex",
    flexDirection: size === "xlarge" ? "column" : "row",
    alignItems: size === "xlarge" ? "center" : "flex-start",
    backgroundColor: t("backgroundColor", [size, type]),
    borderWidth: borderWidth,
    borderColor: t("borderColor", type),
    borderStyle: borderWidth ? "solid" : undefined,
    borderRadius: t("borderRadius"),
    padding: t("spacingInset", size),
    width: width,
    boxShadow: toast && (size === "medium" || size === "large") ? t.boxShadowCss("shadow") : undefined,
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // "& > * + *": {
    //   marginInlineStart: t("spacingHorizontal", size),
    // },
    "& > * + *": {
      marginLeft: t("spacingHorizontal", size),
      marginRight: "0"
    }
  }, (0, _defineProperty2["default"])(_css2, "[dir=\"rtl\"] & > * + *", {
    marginRight: t("spacingHorizontal", size),
    marginLeft: "0"
  }), (0, _defineProperty2["default"])(_css2, "& > [role=img]", {
    flexShrink: 0,
    alignSelf: size === "xlarge" ? "center" : "stretch",
    backgroundImage: (0, _getIconCss["default"])(icon.data, t("foregroundColor", [size, type])),
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: icon.width,
    // This ensures that the icon is vertically centered on the first line of
    // text for single-line alerts and on the first two lines of text for
    // multi-line alerts.
    minHeight: icon.height,
    maxHeight: icon.height * 2
  }), (0, _defineProperty2["default"])(_css2, "& [mdn-text]", (0, _emotion.css)((0, _text["default"])(t, {
    fontSize: ["message", size],
    fontWeight: "body",
    // TODO: This token should be renamed to "message"
    lineHeight: ["message", size]
  }), {
    textAlign: size === "xlarge" ? "center" : "initial",
    color: t("foregroundColor", [size, type]),
    flex: "auto",
    display: "flex",
    flexDirection: size === "xlarge" ? "column" : "row",
    // Allow the message to wrap below the title if it's too long to fit.
    flexWrap: "wrap"
  })), (0, _defineProperty2["default"])(_css2, "& [mdn-alert-title]", (0, _emotion.css)((0, _text["default"])(t, {
    fontSize: ["title", size],
    fontWeight: "title",
    lineHeight: ["title", size]
  }), (0, _defineProperty2["default"])({
    color: t("foregroundColor", [size, type]),
    flexShrink: 0,
    fontWeight: t("fontWeightTitle"),
    // Fallback to "0" for margin-top to cancel out default browser stylings
    // on heading elements
    marginTop: t("spacingVertical", size) || 0,
    marginBottom: 0,
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // marginInlineEnd: t("titleSpacingRight", size),
    marginRight: t("titleSpacingRight", size),
    marginLeft: 0
  }, "[dir=\"rtl\"] &", {
    marginLeft: t("titleSpacingRight", size),
    marginRight: 0
  }))), (0, _defineProperty2["default"])(_css2, "& [mdn-alert-message]", {
    margin: 0,
    marginTop: t("spacingVertical", size),
    // Make the message fill the whole width of the alert, but keep it on
    // the same line as the title until it has to wrap.
    flex: "auto",
    flexShrink: 0,
    maxWidth: "100%"
  }), (0, _defineProperty2["default"])(_css2, "& [mdn-link]", {
    color: "".concat(t("linkColor", [size]), " !important"),
    textDecoration: size === "medium" || size === "large" ? "underline !important" : undefined
  }), _css2));
}, ["size", "type", "toast", "width"]);

var closeButtonStyles = function closeButtonStyles(t, _ref2) {
  var size = _ref2.size;
  return (0, _emotion.css)(size === "xlarge" ? (0, _defineProperty2["default"])({
    position: "absolute",
    top: t("closeButtonSpacing", size),
    right: t("closeButtonSpacing", size)
  }, "[dir=\"rtl\"] &", {
    right: "auto",
    left: t("closeButtonSpacing", size)
  }) : (0, _defineProperty2["default"])({
    flexShrink: 0,
    margin: t("closeButtonSpacing", size) - t("spacingInset", size),
    // HACK: Since we specify marginLeft/Right for the & > * + * style above
    // to accommodate IE11 we have to overwrite them with !important here.
    // If/when we drop IE11 we can simplify these styles to be:
    // marginInlineStart: t("spacingHorizontal", size),
    marginLeft: "".concat(t("spacingHorizontal", size), "px !important"),
    marginRight: "".concat(t("closeButtonSpacing", size) - t("spacingInset", size), "px !important")
  }, "[dir=\"rtl\"] &", {
    marginRight: "".concat(t("spacingHorizontal", size), "px !important"),
    marginLeft: "".concat(t("closeButtonSpacing", size) - t("spacingInset", size), "px !important")
  }));
};

var AlertTitle = function AlertTitle(_ref5) {
  var level = _ref5.level,
      children = _ref5.children,
      id = _ref5.id;
  var Tag = level ? "h".concat(level) : "div";
  return /*#__PURE__*/_react["default"].createElement(Tag, {
    "mdn-alert-title": "",
    id: id
  }, children);
};
/**
 * Render a banner that communicates status, feedback, and severity to the
 * customer.
 */


function Alert(props) {
  var t = (0, _theme.useTheme)(_alert["default"], "alert");
  var idPrefix = (0, _react.useMemo)(function () {
    return props.id || (0, _uniqueId["default"])("alert-");
  }, [props.id]);
  var node = (0, _react.useRef)();
  var big = props.size === "large" || props.size === "xlarge";
  var title = big ? props.title : undefined;
  var titleId = title ? "".concat(idPrefix, "-title") : undefined;
  var childrenId = "".concat(idPrefix, "-children");
  var showCloseButton = props.onClose && props.size !== "small";
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]); // If autoFocus is true then focus on the first interactive element in the
  // alert. This'll either be the first action rendered by the user or the
  // alert's close button if there are no actions.

  var autoFocus = props.autoFocus,
      inaccessibleAutoFocus = props.inaccessibleAutoFocus;
  (0, _react.useEffect)(function () {
    if (autoFocus || inaccessibleAutoFocus) {
      var _getKeyboardFocusNode = (0, _focus.getKeyboardFocusNodes)(node.current),
          _getKeyboardFocusNode2 = (0, _slicedToArray2["default"])(_getKeyboardFocusNode, 1),
          firstFocusNode = _getKeyboardFocusNode2[0];

      if (firstFocusNode) {
        firstFocusNode.focus();
      }
    }
  }, [autoFocus, inaccessibleAutoFocus]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, passThroughProps, {
    className: styles(t, props),
    ref: autoFocus || inaccessibleAutoFocus ? node : undefined,
    role: showCloseButton ? "alertdialog" : "alert",
    "aria-labelledby": titleId,
    "aria-describedby": childrenId,
    id: idPrefix
  }), /*#__PURE__*/_react["default"].createElement("div", {
    role: "img",
    "aria-hidden": "true"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-text": ""
  }, title ? /*#__PURE__*/_react["default"].createElement(AlertTitle, {
    id: titleId,
    level: props.titleLevel
  }, title) : null, /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-alert-message": "",
    id: childrenId
  }, props.children)), showCloseButton ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    size: big ? "medium" : "small",
    onClick: props.onClose,
    backdropColor: t("backgroundColor", [props.size, props.type]),
    className: closeButtonStyles(t, props),
    label: props.closeLabel
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _close["default"]
  })) : null);
}

Alert.propTypes =  false ? {
  /**
   * The main message to be shown in the alert. Any elements are allowed, but
   * plain text and links are recommended. Meridian [links](https://meridian.a2z.com/components/link/?platform=react-web)
   * will be underlined and use the primary font color.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Alert component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following properties,
   * they'll be ignored:
   *
   * aria-labelledby | aria-describedby
   *
   * @since 5.22.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * An accessible label for the alert's dismiss button. This is not shown in
   * the UI, but will be read by screen-readers.
   */
  closeLabel: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.22.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.21.0
   */
  id: _propTypes["default"].string,

  /**
   * Automatically focus on the alert when it's presented. The first interactive
   * element rendered in the alert will be focused, otherwise the alert's close
   * button will be focused. This will have no effect if the alert does not
   * contain any interactive elements.
   *
   * Use this when presenting an urgent alert that should grab the user's focus.
   * This will disrupt the user's current task, so use this with caution.
   *
   * @since  5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * Sets the size of the component using a preset. Note that this also
   * affects the layout of the alert and the availability of other props (namely
   * `title` and `onClose`).
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * A text-only title to display before the main message. This is only
   * available for alerts with `size` set to `"large"` or `"xlarge"`.
   */
  title: _propTypes["default"].string,

  /**
   * The title heading level. This corresponds directly to the [6 HTML headings](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Heading_Elements)
   * and, if set, will render the Alert title in a heading component. For example,
   * setting `titleLevel={2}` will render the Alert title in an `<h2>` element.
   *
   * You should chose a level based on the Alerts markup position and the documents
   * current heading structure ([lean more](https://www.w3.org/TR/2016/REC-html51-20161101/sections.html#headings-and-sections)). This will make it easier for
   * screen reader users to quickly make sense of the page's structure.
   *
   * For example, if the Alert is intended for the entire page, a `titleLevel={1}`
   * could be warranted. If the Alert is only relevant to a particular section
   * that was titled with a `<Heading level={3}/>`, a `titleLevel={3}` would be
   * a better choice.
   *
   * Because we cannot safely presume the heading structure of your page we do not
   * set a default value. If `titleLevel` is left unset, the title will render
   * in a `<div>` element.
   *
   * @since 5.21.0
   */
  titleLevel: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]),

  /**
   * Use this to indicate that the Alert is being used to display a toast
   * message. A drop shadow will be rendered behind the alert's body. This is
   * only applicable to "medium" and "large" alerts.
   *
   * This prop is intended to be used in tandem with the [Toaster](https://meridian.a2z.com/components/toaster/?platform=react-web) component.
   */
  toast: _propTypes["default"].bool,

  /**
   * The type of message that is being communicated with the alert. See the
   * design guidelines for recommendations regarding which type to use.
   */
  type: _propTypes["default"].oneOf(["error", "warning", "success", "informational"]),

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * If a function is supplied here then a dismiss button will be rendered in
   * the alert. The function will be called when the dismiss button is clicked.
   * The function will not receive any arguments.
   *
   * This only applies to alerts that are not size small. For alert with `size`
   * set to `"xlarge"` the dismiss button will be placed in the top right of
   * the closest parent element of the alert with non-static positioning.
   */
  onClose: _propTypes["default"].func
} : {};
Alert.defaultProps = {
  size: "large",
  type: "informational",
  closeLabel: "Dismiss"
};
AlertTitle.propTypes =  false ? {
  children: Alert.propTypes.title,
  id: _propTypes["default"].string,
  level: Alert.propTypes.titleLevel
} : {};
var _default = Alert;
exports["default"] = _default;

/***/ }),
/* 493 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    alertMobileFontSizeTitleSmall: 14,
    alertMobileFontSizeTitleMedium: 14,
    alertMobileFontSizeTitleLarge: 16,
    alertMobileFontSizeTitleXlarge: 24,
    alertMobileFontSizeMessageSmall: 14,
    alertMobileFontSizeMessageMedium: 14,
    alertMobileFontSizeMessageLarge: 16,
    alertMobileFontSizeMessageXlarge: 16,
    alertMobileLineHeightTitleSmall: "16px",
    alertMobileLineHeightTitleMedium: "16px",
    alertMobileLineHeightTitleLarge: "24px",
    alertMobileLineHeightTitleXlarge: "32px",
    alertMobileLineHeightMessageSmall: "16px",
    alertMobileLineHeightMessageMedium: "16px",
    alertMobileLineHeightMessageLarge: "24px",
    alertMobileLineHeightMessageXlarge: "24px",
    alertMobileMessageSpacingInsetHorizontalLarge: 15,
    alertMobileMessageSpacingInsetVerticalLarge: 8,
    alertMobileCloseButtonSpacingLarge: 3,
    alertBackgroundColorMediumError: "#F9D5E2",
    alertBackgroundColorMediumWarning: "#FEF2B8",
    alertBackgroundColorMediumSuccess: "#DCF3A0",
    alertBackgroundColorMediumInformational: "#F0F1F2",
    alertBackgroundColorLargeError: "#F9D5E2",
    alertBackgroundColorLargeWarning: "#FEF2B8",
    alertBackgroundColorLargeSuccess: "#DCF3A0",
    alertBackgroundColorLargeInformational: "#F0F1F2",
    alertForegroundColorSmallDefault: tokens.themeForegroundPrimaryDefault,
    alertForegroundColorSmallError: tokens.themeForegroundPrimaryError,
    alertForegroundColorMediumDefault: "#232F3E",
    alertForegroundColorLargeDefault: "#232F3E",
    alertForegroundColorXlargeDefault: tokens.themeForegroundPrimaryDefault,
    alertLinkColorMedium: "#232F3E",
    alertLinkColorLarge: "#232F3E",
    alertFontSizeTitleSmall: 14,
    alertFontSizeTitleMedium: 14,
    alertFontSizeTitleLarge: 16,
    alertFontSizeTitleXlarge: 24,
    alertFontSizeMessageSmall: 14,
    alertFontSizeMessageMedium: 14,
    alertFontSizeMessageLarge: 16,
    alertFontSizeMessageXlarge: 16,
    alertFontWeightTitle: 600,
    alertFontWeightBody: 400,
    alertLineHeightTitleSmall: "16px",
    alertLineHeightTitleMedium: "16px",
    alertLineHeightTitleLarge: "24px",
    alertLineHeightTitleXlarge: "32px",
    alertLineHeightMessageSmall: "16px",
    alertLineHeightMessageMedium: "16px",
    alertLineHeightMessageLarge: "24px",
    alertLineHeightMessageXlarge: "24px",
    alertBorderWidthMedium: 1,
    alertBorderWidthLarge: 1,
    alertBorderRadius: 4,
    alertBorderColorError: "#CC0C39",
    alertBorderColorWarning: "#DCB700",
    alertBorderColorSuccess: "#98C91E",
    alertBorderColorInformational: "#BBC0C1",
    alertSpacingInsetMedium: 8,
    alertSpacingInsetLarge: 15,
    alertSpacingInsetXlarge: 15,
    alertSpacingHorizontalSmall: 8,
    alertSpacingHorizontalMedium: 8,
    alertSpacingHorizontalLarge: 16,
    alertSpacingHorizontalXlarge: 0,
    alertCloseButtonSpacingMedium: 0,
    alertCloseButtonSpacingLarge: 7,
    alertCloseButtonSpacingXlarge: 7,
    alertTitleSpacingRightDefault: 8,
    alertTitleSpacingRightXlarge: 0,
    alertSpacingVerticalXlarge: 24,
    alertMotionDuration: "200ms",
    alertMotionFunction: "ease",
    alertShadowColor: "rgba(11, 12, 12, 0.1)",
    alertShadowOffsetX: 0,
    alertShadowOffsetY: 8,
    alertShadowBlur: 16,
    alertShadowSpread: 0
  }
};

/***/ }),
/* 494 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertErrorXlargeData: "data:image/svg+xml,%3csvg width='88' height='88' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle stroke='%23CC0C39' stroke-width='8' fill='%23FF7494' cx='44' cy='44' r='40'/%3e%3cpath d='M44 58.667a5 5 0 100 10 5 5 0 000-10z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M44 23.333v18.334' stroke='%23232F3E' stroke-width='8' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertErrorXlargeWidth: 88,
  iconAlertErrorXlargeHeight: 88
};

/***/ }),
/* 495 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertErrorLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle stroke='%23CC0C39' stroke-width='2' fill='%23FF7494' cx='12' cy='12' r='11'/%3e%3cpath d='M12 16.273A1.364 1.364 0 1012 19a1.364 1.364 0 000-2.727z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M12 7v5' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertErrorLargeWidth: 24,
  iconAlertErrorLargeHeight: 24
};

/***/ }),
/* 496 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertErrorSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23FF7494' fill-rule='nonzero' cx='8' cy='8' r='8'/%3e%3cpath d='M8 16A8 8 0 108 0a8 8 0 000 16zm0-1A7 7 0 118 1a7 7 0 010 14z' fill='%23CC0C39' fill-rule='nonzero'/%3e%3cpath d='M8 4v4' stroke='%23232F3E' stroke-width='2' stroke-linecap='round'/%3e%3ccircle fill='%23232F3E' fill-rule='nonzero' cx='8' cy='12' r='1'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertErrorSmallWidth: 16,
  iconAlertErrorSmallHeight: 16
};

/***/ }),
/* 497 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertInformationalLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23E7E9E9' cx='12' cy='12' r='11'/%3e%3cpath d='M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z' fill='%23BBC0C1' fill-rule='nonzero'/%3e%3cpath d='M12 11v6M13 17h-2M12 11h-1' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3ccircle fill='%23232F3E' fill-rule='nonzero' cx='12' cy='8' r='1'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertInformationalLargeWidth: 24,
  iconAlertInformationalLargeHeight: 24
};

/***/ }),
/* 498 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertInformationalSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23E7E9E9' fill-rule='nonzero' cx='8' cy='8' r='7.5'/%3e%3cpath d='M8 7.063v3.75M8 7.063h-.938M8.938 10.813H7.062' stroke='%23232F3E' stroke-width='2' stroke-linecap='round'/%3e%3ccircle fill='%23232F3E' fill-rule='nonzero' cx='8' cy='4.25' r='1'/%3e%3cpath d='M8 16A8 8 0 108 0a8 8 0 000 16zm0-1A7 7 0 118 1a7 7 0 010 14z' fill='%23BBC0C1' fill-rule='nonzero'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertInformationalSmallWidth: 16,
  iconAlertInformationalSmallHeight: 16
};

/***/ }),
/* 499 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertSuccessXlargeData: "data:image/svg+xml,%3csvg width='88' height='88' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23C3EB5E' cx='44' cy='44' r='40.333'/%3e%3cpath d='M44 88c24.3 0 44-19.7 44-44S68.3 0 44 0 0 19.7 0 44s19.7 44 44 44zm0-7.333C23.75 80.667 7.333 64.25 7.333 44S23.75 7.333 44 7.333 80.667 23.75 80.667 44 64.25 80.667 44 80.667z' fill='%2398C91E' fill-rule='nonzero'/%3e%3cpath stroke='%23232F3E' stroke-width='8' stroke-linecap='round' stroke-linejoin='round' d='M22 44.061l14.65 14.66L62.358 33'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertSuccessXlargeWidth: 88,
  iconAlertSuccessXlargeHeight: 88
};

/***/ }),
/* 500 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertSuccessLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23C3EB5E' cx='12' cy='12' r='11'/%3e%3cpath d='M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z' fill='%2398C91E' fill-rule='nonzero'/%3e%3cpath stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' d='M6 12.017l3.996 3.998L17.006 9'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertSuccessLargeWidth: 24,
  iconAlertSuccessLargeHeight: 24
};

/***/ }),
/* 501 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertSuccessSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23C3EB5E' fill-rule='nonzero' cx='7.97' cy='7.97' r='7.47'/%3e%3cpath d='M11.705 6.103l-4.669 4.669M7.036 10.772l-2.8-2.802' stroke='%23232F3E' stroke-width='2' stroke-linecap='round'/%3e%3cpath d='M7.97 15.94A7.97 7.97 0 107.97 0a7.97 7.97 0 000 15.94zm0-1A6.97 6.97 0 117.97 1a6.97 6.97 0 010 13.94z' fill='%2398C91E' fill-rule='nonzero'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertSuccessSmallWidth: 16,
  iconAlertSuccessSmallHeight: 16
};

/***/ }),
/* 502 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertWarningXlargeData: "data:image/svg+xml,%3csvg width='88' height='88' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M82.293 72.449L49.898 7.583A6.656 6.656 0 0043.996 4a6.656 6.656 0 00-5.902 3.583L5.699 72.449C1.756 80.29 7.605 84 11.273 84h65.67c3.494 0 9.29-3.814 5.35-11.551z' stroke='%23DCB700' stroke-width='8' fill='%23FCDE4D' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M43.57 62.333a4.583 4.583 0 100 9.167 4.583 4.583 0 000-9.167z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M43.57 36.667v14.666' stroke='%23232F3E' stroke-width='7.333' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertWarningXlargeWidth: 88,
  iconAlertWarningXlargeHeight: 88
};

/***/ }),
/* 503 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertWarningLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M22.532 19.823L13.623 1.985a1.83 1.83 0 00-3.246 0L1.468 19.823C.384 21.98 1.993 23 3.001 23h18.06c.96 0 2.554-1.049 1.47-3.177z' fill='%23FCDE4D'/%3e%3cpath d='M14.518 1.538A2.837 2.837 0 0012 0a2.83 2.83 0 00-2.51 1.523L.574 19.377C-.698 21.905.87 24 3 24h18.06c2.083 0 3.631-2.133 2.364-4.627L14.518 1.538zm7.123 18.74c.552 1.084.09 1.722-.58 1.722H3c-.732 0-1.196-.62-.64-1.727l8.91-17.841a.83.83 0 011.465.015l8.901 17.823.004.007z' fill='%23DCB700' fill-rule='nonzero'/%3e%3cpath d='M12 17a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M12 10v4' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertWarningLargeWidth: 24,
  iconAlertWarningLargeHeight: 24
};

/***/ }),
/* 504 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertWarningSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M15.205 13.08L9.11.994A1.254 1.254 0 008 .326c-.467 0-.895.257-1.111.668L.794 13.08c-.742 1.462.358 2.153 1.048 2.153h12.356c.658 0 1.748-.71 1.007-2.153z' fill='%23FCDE4D'/%3e%3cpath d='M9.557.942a1.757 1.757 0 00-3.11-.007L.302 13.12C-.506 14.71.468 16 1.797 16h12.448c1.296 0 2.258-1.312 1.452-2.882L9.557.942zm4.688 14.077H1.797c-.644 0-1.072-.566-.62-1.456L7.32 1.384A.77.77 0 018 .981c.29 0 .553.159.685.41l6.138 12.17c.45.879.027 1.458-.577 1.458z' fill='%23DCB700' fill-rule='nonzero'/%3e%3cpath d='M8 11.667a1 1 0 100 2 1 1 0 000-2z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M8 6v3' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertWarningSmallWidth: 16,
  iconAlertWarningSmallHeight: 16
};

/***/ }),
/* 505 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(507), src$en$$ = __webpack_require__(512);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(240), src$es5$$ = __webpack_require__(508), src$compiler$$ = __webpack_require__(509), intl$messageformat$parser$$ = __webpack_require__(510);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(240);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(511)['default'];
exports['default'] = exports;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 513 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(515)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(520);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(516), src$en$$ = __webpack_require__(519);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var intl$messageformat$$ = __webpack_require__(239), src$diff$$ = __webpack_require__(517), src$es5$$ = __webpack_require__(518);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45, 'second-short': 45,  // seconds to minute
        minute: 45, 'minute-short': 45, // minutes to hour
        hour  : 22, 'hour-short': 22, // hours to day
        day   : 26, 'day-short': 26, // days to month
        month : 11, 'month-short': 11 // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function(field) {
        return field.indexOf('-short') < 1;
    });

    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond    : millisecond,
        second         : second,
        'second-short' : second,
        minute         : minute,
        'minute-short' : minute,
        hour           : hour,
        'hour-short'   : hour,
        day            : day,
        'day-short'    : day,
        week           : week,
        'week-short'   : week,
        month          : month,
        'month-short'  : month,
        year           : year,
        'year-short'   : year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License



var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"year-short":{"displayName":"yr.","relative":{"0":"this yr.","1":"next yr.","-1":"last yr."},"relativeTime":{"future":{"one":"in {0} yr.","other":"in {0} yr."},"past":{"one":"{0} yr. ago","other":"{0} yr. ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"month-short":{"displayName":"mo.","relative":{"0":"this mo.","1":"next mo.","-1":"last mo."},"relativeTime":{"future":{"one":"in {0} mo.","other":"in {0} mo."},"past":{"one":"{0} mo. ago","other":"{0} mo. ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"day-short":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"hour-short":{"displayName":"hr.","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hr.","other":"in {0} hr."},"past":{"one":"{0} hr. ago","other":"{0} hr. ago"}}},"minute":{"displayName":"minute","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"minute-short":{"displayName":"min.","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} min.","other":"in {0} min."},"past":{"one":"{0} min. ago","other":"{0} min. ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}},"second-short":{"displayName":"sec.","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} sec.","other":"in {0} sec."},"past":{"one":"{0} sec. ago","other":"{0} sec. ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 520 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(522);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(526)['default'];
exports['default'] = exports;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jshint esnext: true */


var src$es5$$ = __webpack_require__(527);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill



var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(57));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _uniqueId = _interopRequireDefault(__webpack_require__(51));

var _keycode = _interopRequireDefault(__webpack_require__(47));

var _popover = _interopRequireDefault(__webpack_require__(158));

var _elevation = __webpack_require__(59);

var _theme = __webpack_require__(14);

var _popoverBody = _interopRequireDefault(__webpack_require__(529));

var _popoverController = _interopRequireDefault(__webpack_require__(242));

var _utils = __webpack_require__(159);

var _token = __webpack_require__(12);

var _functional = __webpack_require__(26);

var _rtl = __webpack_require__(52);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = (0, _functional.memoize)(function (maxWidth) {
  return (0, _emotion.css)({
    overflowWrap: "break-word",
    pointerEvents: "none",
    maxWidth: maxWidth
  });
});
/**
 * Add a tooltip to an element. A note on accessibility: tooltips should only be
 * added to elements that are focusable. This allows keyboard users to open the
 * tooltip by tabbing to the tooltip's anchor node. Otherwise keyboard users
 * would not be able to open the tooltip. This means that *tooltips should not
 * be anchored to disabled elements directly*, since disabled elements generally
 * can't be focused. If you need to add context to a disabled element, consider
 * anchoring the tooltip to a help icon near the element:
 *
 * ```
 * <Row>
 *   <Button disabled={true}>Submit</Button>
 *   <Tooltip title="You can't perform this action, move along." position="right" id="submit-tooltip">
 *     <Icon tokens={helpIconTokens} tabIndex={0}>Help tooltip</Icon>
 *   </Tooltip>
 * </Row>
 * ```
 */

var Tooltip = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Tooltip, _React$Component);

  var _super = _createSuper(Tooltip);

  function Tooltip() {
    var _this;

    (0, _classCallCheck2["default"])(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      hover: false,
      focus: false,
      id: _this.props.id ? _this.props.id : (0, _uniqueId["default"])("tooltip-")
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isOpen", function () {
      return _this.props.open === undefined ? _this.state.hover || _this.state.focus : _this.props.open;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateAnchorNode", function (node) {
      if (node && node !== _this.anchorNode) {
        /* eslint-disable-next-line react/no-find-dom-node */
        _this.anchorNode = _reactDom["default"].findDOMNode(node); // If the Tooltip is managing state internally then bind the event
        // listeners that trigger internal state changes

        if (_this.props.open === undefined) {
          _this.addEventListeners();
        } // If the Tooltip is supposed to be open then force an update so it
        // re-renders with the anchor node


        if (_this.isOpen()) {
          _this.forceUpdate();
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addEventListeners", function () {
      // Remove any existing event listeners to ensure we don't accidentally stack
      // multiple listeners
      _this.removeEventListeners();

      if (_this.anchorNode) {
        _this.anchorNode.addEventListener("mouseenter", _this.onMouseEnterAnchor); // NOTE: This *must* be bound using a native event listener because of a bug
        // in React: https://github.com/facebook/react/issues/4251


        _this.anchorNode.addEventListener("mouseleave", _this.onMouseLeaveAnchor);

        _this.anchorNode.addEventListener("focus", _this.onFocusAnchor, true);

        _this.anchorNode.addEventListener("blur", _this.onBlurAnchor, true);

        _this.anchorNode.addEventListener("keydown", _this.onKeyDownAnchor);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "removeEventListeners", function () {
      if (_this.anchorNode) {
        _this.anchorNode.removeEventListener("mouseenter", _this.onMouseEnterAnchor);

        _this.anchorNode.removeEventListener("mouseleave", _this.onMouseLeaveAnchor);

        _this.anchorNode.removeEventListener("focus", _this.onFocusAnchor, true);

        _this.anchorNode.removeEventListener("blur", _this.onBlurAnchor, true);

        _this.anchorNode.removeEventListener("keydown", _this.onKeyDownAnchor);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseEnterAnchor", function () {
      return _this.setState({
        hover: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseLeaveAnchor", function () {
      return _this.setState({
        hover: false,
        focus: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocusAnchor", function () {
      var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this),
          anchorNode = _assertThisInitialize.anchorNode; // If a user has not set an id for accessibility
      // use our own auto-generated one


      try {
        if (!anchorNode.hasAttribute("aria-controls")) {
          anchorNode.setAttribute("aria-controls", _this.state.id);
        }

        if (!anchorNode.hasAttribute("aria-describedby")) {
          anchorNode.setAttribute("aria-describedby", _this.state.id);
        }
      } catch (_) {// Silent error
      }

      _this.setState({
        focus: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlurAnchor", function () {
      return _this.setState({
        focus: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownAnchor", function (event) {
      if (_this.isOpen && (event.key === "Esc" || (0, _keycode["default"])(event) === "esc")) {
        _this.setState({
          focus: false
        });
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(Tooltip, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // If we're moving from state being managed via the `open` prop to state
      // being managed internally, bind the event listeners that trigger internal
      // state changes
      if (prevProps.open === undefined && this.props.open !== undefined) {
        this.addEventListeners();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEventListeners();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          maxWidth = _this$props.maxWidth,
          children = _this$props.children;
      var position = (0, _rtl.getHorizontalDirection)(this.props.position);
      var anchorNode = this.anchorNode;
      var oppositePosition = (0, _utils.flipAlignment)(position);
      var vertical = position === "top" || position === "bottom";
      var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, ["data-", "aria-"]);

      var popover = /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _popover["default"],
        map: (0, _token.getTokenHelper)("popover"),
        key: "popover"
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(_popoverController["default"], {
          open: _this2.isOpen(),
          anchorNode: anchorNode,
          anchorOrigin: vertical ? "".concat(position, " center") : "center ".concat(position),
          popoverOrigin: vertical ? "".concat(oppositePosition, " center") : "center ".concat(oppositePosition),
          offsetVertical: vertical ? t("offsetWithArrow") : 0,
          offsetHorizontal: vertical ? 0 : t("offsetWithArrow")
        }, function (_ref) {
          var popoverStyle = _ref.popoverStyle,
              popoverOrigin = _ref.popoverOrigin,
              anchorOrigin = _ref.anchorOrigin,
              anchorRect = _ref.anchorRect;
          return /*#__PURE__*/_react["default"].createElement(_popoverBody["default"], (0, _extends2["default"])({}, passThroughProps, {
            type: "fill",
            spacingInset: "small",
            zIndex: _elevation.elevationTooltip,
            className: "".concat(styles(maxWidth), " ").concat(popoverStyle),
            id: _this2.props.id ? _this2.props.id : (0, _uniqueId["default"])("tooltip-")
          }, _popoverBody["default"].generateArrowProps({
            popoverOrigin: popoverOrigin,
            anchorOrigin: anchorOrigin,
            anchorRect: anchorRect
          })), title);
        });
      });

      var child = _react["default"].Children.only(children);

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].cloneElement(child, {
        ref: this.updateAnchorNode
      }), popover);
    }
  }]);
  return Tooltip;
}(_react["default"].Component);

Tooltip.propTypes =  false ? {
  /**
   * The element that the tooltip should reference.
   *
   * The tooltip will point at this element, and will be triggered when the
   * user hovers over this element or focuses on it.
   *
   * This element must accept a [ref](https://reactjs.org/docs/refs-and-the-dom.html),
   * and should be focuseable to ensure that the tooltip is accessible to keyboard
   * users.
   */
  children: _propTypes["default"].element.isRequired,

  /**
   * The position of the tooltip relative to the anchor element (provided via
   * `children`).
   *
   * Note that the tooltip may reposition itself to the opposite side of the
   * element if there is not enough screen space to display itself in the
   * position identified here.
   */
  position: _propTypes["default"].oneOf(["top", "right", "end", "bottom", "left", "start"]).isRequired,

  /**
   * The content shown in the tooltip.
   */
  title: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Tooltip component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-expanded | aria-labelledby
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.x
   */
  id: _propTypes["default"].string,

  /**
   * Set the maximum width of the tooltip using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * If defined this will determine whether the tooltip is open or closed. If
   * omitted the tooltip will manage it's own state.
   *
   * Use this sparingly, in most cases the tooltip's internal state management
   * will correctly determine when it should open and close.
   */
  open: _propTypes["default"].bool
} : {};
Tooltip.defaultProps = {
  maxWidth: 300
};
var _default = Tooltip;
exports["default"] = _default;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _popoverBody = _interopRequireDefault(__webpack_require__(530));

var _default = _popoverBody["default"];
exports["default"] = _default;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _typeof2 = _interopRequireDefault(__webpack_require__(17));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _capitalize = _interopRequireDefault(__webpack_require__(531));

var _emotion = __webpack_require__(4);

var _popover = _interopRequireDefault(__webpack_require__(158));

var _elevation = __webpack_require__(59);

var _theme = __webpack_require__(14);

var _utils = __webpack_require__(159);

var _token = __webpack_require__(12);

var _cxMemoized = _interopRequireDefault(__webpack_require__(76));

var _text = _interopRequireDefault(__webpack_require__(27));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

var _getUnthemedTokens = (0, _token.getUnthemedTokens)(_popover["default"]),
    popoverArrowWidth = _getUnthemedTokens.popoverArrowWidth; // Takes an edge (e.g. "top") and turns it into a CSS border property (e.g.
// "borderTop").


var edgeToBorder = function edgeToBorder(edge) {
  return "border".concat((0, _capitalize["default"])(edge));
}; // Takes an edge (e.g. "top") and a CSS length (e.g. "5px") and creates a
// CSS translation function (e.g. "translateY(5px)") that can be added to an
// element  via the CSS "transform" property.


var edgeToTransform = function edgeToTransform(edge, amount) {
  return "translate".concat(edge === "left" || edge === "right" ? "X" : "Y", "(").concat(amount, ")");
}; // These styles are used to create the little arrow that points away from the
// popover. The method used to create the triangles involves psuedo elements
// with different transparent borders applied to certain sides. A good demo of
// this method can be found here: https://codepen.io/chriscoyier/pen/lotjh. The
// benefit of this method is that it doesn't require any images, but the
// downside is that you can't apply a border to the triangle. To get around
// this a border is faked by placing a slightly offset background-colored
// triangle (the :after pseudo element) on top of a border-colored triangle (the
// :before pseudo element).


var arrowStyles = function arrowStyles(t, _ref) {
  var _afterBefore, _before, _after;

  var type = _ref.type,
      arrowPosition = _ref.arrowPosition,
      arrowAlignment = _ref.arrowAlignment,
      arrowOffset = _ref.arrowOffset;
  var backgroundColor = t("backgroundColor", type);
  var borderColor = t("borderColor", type);
  var borderWidth = t("borderWidth");
  var arrowHeight = t("arrowHeight");
  var arrowWidthHalf = t("arrowWidth") / 2; // This is the edge of the popover (either "top" or "left") that is parallel
  // to the direction the arrow is pointing.

  var arrowParallelEdge = arrowPosition === "top" || arrowPosition === "bottom" ? "left" : "top"; // This is the edge of the popover that is opposite the edge that the arrow
  // is positioned on.

  var arrowOppositeEdge = (0, _utils.flipAlignment)(arrowPosition); // This uses maths to determine how far we have to scoot the fill triangle
  // along its axis to reveal exactly `borderWidth` pixels of the border
  // triangle along a line that is perpendicular to the edges of both triangles.

  var fillTriangleOffset = borderWidth / Math.sin(Math.atan(arrowWidthHalf / arrowHeight)); // This translates the arrow in the direction orthogonal to the direction that
  // the arrow is pointing (i.e. left/right for an arrow pointing up/down or
  // up/down for an arrow pointing left/right).

  var orthogonalTransform = function orthogonalTransform(alignment) {
    return {
      top: ["".concat(arrowOffset, "px")],
      left: ["".concat(arrowOffset, "px")],
      right: ["-".concat(arrowOffset, "px"), "-100%"],
      bottom: ["-".concat(arrowOffset, "px"), "-100%"],
      center: ["".concat(arrowOffset, "px"), "-50%"]
    }[alignment].map(function (amount) {
      return edgeToTransform(arrowParallelEdge, amount);
    }).join(" ");
  };

  return (0, _emotion.css)({
    "&:after, &:before": (_afterBefore = {
      content: "''",
      position: "absolute",
      height: 0,
      width: 0
    }, (0, _defineProperty2["default"])(_afterBefore, arrowOppositeEdge, "100%"), (0, _defineProperty2["default"])(_afterBefore, arrowParallelEdge, {
      top: 0,
      left: 0,
      right: "100%",
      bottom: "100%",
      center: "50%"
    }[arrowAlignment]), (0, _defineProperty2["default"])(_afterBefore, edgeToBorder(arrowParallelEdge), "".concat(arrowWidthHalf, "px solid transparent")), (0, _defineProperty2["default"])(_afterBefore, edgeToBorder((0, _utils.flipAlignment)(arrowParallelEdge)), "".concat(arrowWidthHalf, "px solid transparent")), _afterBefore),
    // This creates a triangle with a background color that is the same color as
    // the popover's border.
    "&:before": (_before = {}, (0, _defineProperty2["default"])(_before, edgeToBorder(arrowOppositeEdge), "".concat(arrowHeight, "px solid ").concat(borderColor)), (0, _defineProperty2["default"])(_before, "transform", orthogonalTransform(arrowAlignment)), _before),
    // If the popover has a border then this creates a triangle that is the same
    // color as the popover's background color. This triangle is displayed on
    // top of the border colored triangle but is scooted back just a bit to
    // reveal enough of the border triangle to create a faux border around
    // itself.
    "&:after": (_after = {}, (0, _defineProperty2["default"])(_after, edgeToBorder(arrowOppositeEdge), "".concat(arrowHeight, "px solid ").concat(backgroundColor)), (0, _defineProperty2["default"])(_after, "transform", "".concat(orthogonalTransform(arrowAlignment), " ").concat(edgeToTransform(arrowOppositeEdge, "".concat(arrowOppositeEdge === "top" || arrowOppositeEdge === "left" ? "-" : "").concat(fillTriangleOffset, "px")))), _after)
  });
};

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var type = _ref2.type,
      spacingInset = _ref2.spacingInset,
      zIndex = _ref2.zIndex,
      minWidth = _ref2.minWidth,
      maxWidth = _ref2.maxWidth,
      arrowPosition = _ref2.arrowPosition,
      arrowAlignment = _ref2.arrowAlignment,
      arrowOffset = _ref2.arrowOffset,
      allowOverflow = _ref2.allowOverflow;
  var borderColor = t("borderColor", type);
  return (0, _emotion.css)((0, _text["default"])(t, {
    color: type
  }), {
    display: "inline-block",
    position: "relative",
    outline: "none",
    zIndex: zIndex,
    minWidth: minWidth,
    maxWidth: maxWidth,
    // Children wrapper styles
    "& > div": {
      // If this is used with the PopoverController component then a max
      // width and height will be set on the outer element of this
      // component. Setting the max width and height to "inherit" here will
      // constrain this inner element to the same width/height as its parent
      // (oddly enough max width/height "100%" won't work because CSS). This
      // ensures that scrollbars will be shown for content that overflows.
      // Without these styles this element just extends outside of its
      // parent.
      maxHeight: allowOverflow ? "inherit" : undefined,
      maxWidth: allowOverflow ? "inherit" : undefined,
      overflow: allowOverflow ? "auto" : "hidden",
      padding: spacingInset !== "none" ? "".concat(t("spacingInsetVertical", spacingInset), "px ").concat(t("spacingInsetHorizontal", spacingInset), "px") : undefined,
      backgroundColor: t("backgroundColor", type),
      borderColor: borderColor,
      borderWidth: borderColor ? t("borderWidth") : undefined,
      borderStyle: borderColor ? "solid" : undefined,
      borderRadius: t("borderRadius"),
      boxShadow: t.boxShadowCss("dropShadow")
    }
  }, arrowPosition ? arrowStyles(t, {
    type: type,
    arrowPosition: arrowPosition,
    arrowAlignment: arrowAlignment,
    arrowOffset: arrowOffset
  }) : undefined);
}, ["type", "spacingInset", "zIndex", "maxWidth", "minWidth", "arrowPosition", "arrowAlignment", "arrowOffset", "allowOverflow"]);

var PopoverBody = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_popover["default"], "popover");
  var style = (0, _typeof2["default"])(props.style) === "object" ? props.style : undefined;
  var className = "".concat((0, _cxMemoized["default"])(styles(t, props), props.className));
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);

  if (typeof props.style === "string") {
    className = className.concat(" ".concat(props.style));
  }

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, passThroughProps, {
    onKeyDown: props.onKeyDown,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    tabIndex: props.tabIndex,
    className: className,
    style: style,
    role: props.tabIndex ? "dialog" : "tooltip",
    "aria-labelledby": props.labelledById,
    "aria-expanded": props.open,
    id: props.id,
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("div", null, props.children));
}); // This helper generates the arrow props that are necessary to point a popover
// arrow at a particular anchor


PopoverBody.generateArrowProps = function (_ref3) {
  var popoverOrigin = _ref3.popoverOrigin,
      anchorOrigin = _ref3.anchorOrigin,
      anchorRect = _ref3.anchorRect,
      dir = _ref3.dir;
  var vertical = popoverOrigin.y !== anchorOrigin.y && popoverOrigin.y === (0, _utils.flipAlignment)(anchorOrigin.y);
  var arrowAlignment = vertical ? popoverOrigin.x : popoverOrigin.y; // Truncate the top and left values so that browsers can better handle
  // the positioning of the arrow relative to the anchor.
  // Without truncation we may get values like:
  // {
  //     "top": 39.09090805053711,
  //     "left": 387.2585144042969,
  //     "width": 137,
  //     "height": 40
  // }

  anchorRect.left = Math.trunc(anchorRect.left);
  anchorRect.top = Math.trunc(anchorRect.top);
  return {
    arrowAlignment: arrowAlignment,
    arrowPosition: vertical ? popoverOrigin.y : popoverOrigin.x === "end" && dir === "ltr" ? "left" : popoverOrigin.x === "end" ? "right" : popoverOrigin.x === "start" && dir === "ltr" ? "right" : popoverOrigin.x === "start" ? "left" : popoverOrigin.x,
    arrowOffset: arrowAlignment !== "center" ? anchorRect[vertical ? "width" : "height"] / 2 - popoverArrowWidth / 2 : 0
  };
};

PopoverBody.displayName = "PopoverBody";
PopoverBody.propTypes =  false ? {
  children: _propTypes["default"].node.isRequired,

  /**
   * Set this to true to allow content to overflow with scrollbars.
   *
   * NOTE: This was added in conjunction with the `shrinkToFit` prop on the
   * Popover component. Like that prop, this prop should probably be removed in
   * the next major version and the shrink/overflow behavior made to be the
   * default behavior.
   */
  allowOverflow: _propTypes["default"].bool,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the PopoverBody component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-expanded | aria-labelledby
   *
   * If you are looking to set an accessible `aria-label` for the screen reader, please see the `children` prop details.
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,
  arrowAlignment: _propTypes["default"].oneOf(["top", "right", "bottom", "left", "center"]),
  arrowOffset: _propTypes["default"].number,

  /**
   * If this property is set then an arrow will be drawn pointing away from the
   * specified side of the popover body.
   */
  arrowPosition: _propTypes["default"].oneOf(["top", "right", "bottom", "left", "start", "end"]),

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * The id of an element that labels the popover body. See:
   * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
   */
  labelledById: _propTypes["default"].string,

  /**
   * Define a maximum width for the component. Any CSS width value is
   * acceptable.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /**
   * Define a minimum width for the component. Any CSS width value is
   * acceptable.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  open: _propTypes["default"].bool,
  spacingInset: _propTypes["default"].oneOf(["none", "small", "medium"]),

  /**
   * Can either be an object (applied directly to the element's `style` attribute)
   * or a class name string (appended to the element's `class` attribute). A style
   * object is generally faster but class name allows RTL magic ✨
   */
  style: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(["outline", "fill"]),
  zIndex: _propTypes["default"].number,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func
} : {};
PopoverBody.defaultProps = {
  open: true,
  type: "outline",
  arrowAlignment: "center",
  arrowOffset: 0,
  spacingInset: "small",
  zIndex: _elevation.elevationPopover
};
var _default = PopoverBody;
exports["default"] = _default;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(88),
    upperFirst = __webpack_require__(532);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(533);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(534),
    hasUnicode = __webpack_require__(241),
    stringToArray = __webpack_require__(536),
    toString = __webpack_require__(88);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(535);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 535 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(537),
    hasUnicode = __webpack_require__(241),
    unicodeToArray = __webpack_require__(538);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 537 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 538 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(108));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(57));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _noop = _interopRequireDefault(__webpack_require__(37));

var _popover = _interopRequireDefault(__webpack_require__(158));

var _utils = __webpack_require__(159);

var _rtl = __webpack_require__(52);

var _portal = _interopRequireDefault(__webpack_require__(160));

var _transitionController = _interopRequireDefault(__webpack_require__(243));

var _propTypes2 = _interopRequireDefault(__webpack_require__(77));

var _parsers = __webpack_require__(66);

var _addDebouncedEventListener = _interopRequireDefault(__webpack_require__(141));

var _waitAnimationFrame = _interopRequireDefault(__webpack_require__(109));

var _nodeBounds = __webpack_require__(216);

var _token = __webpack_require__(12);

var _excluded = ["children"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// The closest a popover can be shown to the edge of the viewport
var viewportPadding = 16; // Grab the popover motion duration and function from our tokens.

var _getUnthemedTokens = (0, _token.getUnthemedTokens)(_popover["default"]),
    popoverMotionDuration = _getUnthemedTokens.popoverMotionDuration,
    popoverMotionFunction = _getUnthemedTokens.popoverMotionFunction,
    popoverClosedScale = _getUnthemedTokens.popoverClosedScale;
/**
 * Styles
 */
// NOTE: This component does not use emotion because its styles are *highly*
// dynamic (updated on scroll). The emotion docs say that emotion is performant
// enough for highly dynamic styles, but using inline styles still seems to
// perform marginally better in this situation. Plus, using inline styles here
// isn't any worse from a dev perspective since we don't need any of the fancy
// css features enabled by emotion.


var styles = function styles(_ref) {
  var shrinkToFit = _ref.shrinkToFit,
      offsetHorizontal = _ref.offsetHorizontal,
      offsetVertical = _ref.offsetVertical,
      maxHeight = _ref.maxHeight,
      maxWidth = _ref.maxWidth,
      anchorRect = _ref.anchorRect,
      viewportRect = _ref.viewportRect,
      state = _ref.state,
      anchorOrigin = _ref.anchorOrigin,
      popoverOrigin = _ref.popoverOrigin,
      availableSpace = _ref.availableSpace;

  // The distance to offset the popover from the anchor's left edge (changes
  // based on the anchor origin).
  var offsetFromAnchorLeft = function offsetFromAnchorLeft(_ref2) {
    var x = _ref2.x;
    return {
      left: -offsetHorizontal,
      center: anchorRect.width / 2 + offsetHorizontal,
      right: anchorRect.width + offsetHorizontal
    }[x];
  }; // The distance to offset the popover from the anchor's top edge (changes
  // based on the anchor origin).


  var offsetFromAnchorTop = {
    top: -offsetVertical,
    center: anchorRect.height / 2 + offsetVertical,
    bottom: anchorRect.height + offsetVertical
  }[anchorOrigin.y];
  return (0, _emotion.css)((0, _defineProperty2["default"])({
    position: "fixed !important",
    boxSizing: "border-box",
    // Anchor the popover's position from its bottom edge if it's anchored at
    // the bottom. This ensures long content forces the popover to expand
    // downwards.
    top: state !== "exited" && popoverOrigin.y !== "bottom" ? anchorRect.top + offsetFromAnchorTop - viewportPadding : undefined,
    // Anchor the popover's position from its bottom edge if it's anchored at
    // the bottom. This ensures long content forces the popover to expand
    // upwards.
    bottom: state !== "exited" && popoverOrigin.y === "bottom" ? viewportRect.height - anchorRect.top - offsetFromAnchorTop - viewportPadding : undefined,
    // Anchor the popover's position from its left edge if it's anchored at the
    // the left or center. This ensures long content forces the popover to
    // expand to the right.
    left: state !== "exited" && popoverOrigin.x === "left" || state !== "exited" && popoverOrigin.x === "end" || state !== "exited" && popoverOrigin.x === "center" ? anchorRect.left + offsetFromAnchorLeft({
      x: anchorOrigin.x === "end" ? "right" : anchorOrigin.x
    }) - viewportPadding : undefined,
    // Anchor the popover's position from its right edge if it's anchored at the
    // right. This ensures long content forces the popover to expand to the left.
    right: state !== "exited" && popoverOrigin.x === "right" || state !== "exited" && popoverOrigin.x === "start" ? viewportRect.width - anchorRect.left - offsetFromAnchorLeft({
      x: anchorOrigin.x === "start" ? "left" : anchorOrigin.x
    }) - viewportPadding : undefined,
    transformOrigin: "".concat(popoverOrigin.y, " ").concat(popoverOrigin.x),
    opacity: state === "exited" || state === "exiting" ? 0 : 1,
    // For popovers that are anchored at their center, apply a transform to
    // ensure that the popover is positioned correctly and that long content
    // forces it to expand from the center.
    transform: "translateY(".concat(popoverOrigin.y === "center" ? "-50%" : "0%", ") translateX(").concat(popoverOrigin.x === "center" ? "-50%" : "0%", ") scale(").concat(state === "exited" || state === "exiting" ? popoverClosedScale / 100 : 1, ")"),
    transition: state === "entering" || state === "entered" || state === "exiting" ? "transform ".concat(popoverMotionDuration, " ").concat(popoverMotionFunction, ", opacity ").concat(popoverMotionDuration, " ").concat(popoverMotionFunction) : undefined,
    visibility: state === "exited" ? "hidden" : "visible",
    // Add margin on every side to make sure that the viewport padding is
    // maintained
    margin: viewportPadding,
    // If the user has specified a maxHeight then use that. If the popover is
    // open and the `shrinkToFit` prop is set then also constrain by the
    // available vertical space.
    maxHeight: state !== "exited" && shrinkToFit ? Math.min(maxHeight || availableSpace.y, availableSpace.y) : maxHeight,
    // If the user has specified a maxWidth then use that. If the popover is
    // open and the `shrinkToFit` prop is set then also constrain by the
    // available horizontal space.
    maxWidth: state !== "exited" && shrinkToFit ? Math.min(maxWidth || availableSpace.x, availableSpace.x) : maxWidth
  }, "[dir=\"rtl\"] &", {
    left: state !== "exited" && popoverOrigin.x === "start" ? anchorRect.left + offsetFromAnchorLeft({
      x: "right"
    }) - viewportPadding : popoverOrigin.x === "end" ? "inherit" : undefined,
    right: state !== "exited" && popoverOrigin.x === "end" ? viewportRect.width - anchorRect.left - offsetFromAnchorLeft({
      x: "left"
    }) - viewportPadding : popoverOrigin.x === "start" ? "inherit" : undefined
  }));
};
/**
 * This component handles the positioning of popover content in relation to
 * another element (the "anchor" element). It allows you to "stick" the popover
 * to the anchor element.
 *
 * This component has two real benefits over a simple absolute-positing strategy
 * for popover content. First, it renders popover content at the root of the DOM
 * using portals. This allows popovers to break out of the anchor element's
 * parent containers regardless of any overflow/scroll styles on those
 * containers. Second, this component will automatically re-position and re-size
 * the popover content based on the available space in the viewport. This
 * ensures that the content in the popover will be as accessible to the user as
 * possible.
 *
 * This component does not actually render anything to the DOM. It simply
 * generates the styles necessary to correctly position the popover. The styles
 * are passed via render props to the component's children so that the user can
 * render the popover exactly how they want to. This requires that the user set
 * the style prop on their popover element to the `popoverStyle` render prop
 * returned by this component.
 */


var PopoverController = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(PopoverController, _React$Component);

  var _super = _createSuper(PopoverController);

  function PopoverController() {
    var _this;

    (0, _classCallCheck2["default"])(this, PopoverController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      // Should we render the popover's children? We don't when the popover is
      // closed to avoid unnecessary work.
      render: false,
      // The bounding rectangle for the anchor node.
      anchorRect: _nodeBounds.emptyNodeBounds,
      // The bounding rectangle for the popover node.
      popoverRect: _nodeBounds.emptyNodeBounds,
      // The bounding rectangle for the viewport.
      viewportRect: _nodeBounds.emptyNodeBounds
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "eventListeners", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateAnchorRect", function () {
      var _this$props = _this.props,
          open = _this$props.open,
          anchorNode = _this$props.anchorNode;

      if (open) {
        /* eslint-disable-next-line react/no-find-dom-node */
        var anchorDomNode = _reactDom["default"].findDOMNode(anchorNode);

        var anchorRect = (0, _nodeBounds.getNodeBounds)(anchorDomNode);

        if (!(0, _nodeBounds.compareNodeBounds)(anchorRect, _this.state.anchorRect)) {
          _this.setState({
            anchorRect: anchorRect
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateViewportRect", function () {
      var viewportRect = (0, _nodeBounds.getNodeBounds)(window);

      if (!(0, _nodeBounds.compareNodeBounds)(viewportRect, _this.state.viewportRect)) {
        _this.setState({
          viewportRect: viewportRect
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updatePopoverRect", function () {
      var popoverRect = (0, _nodeBounds.getNodeBounds)(_this.popoverNode);

      if (!(0, _nodeBounds.compareNodeBounds)(popoverRect, _this.state.popoverRect)) {
        _this.setState({
          popoverRect: popoverRect
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onResizeWindow", function () {
      _this.updateViewportRect();

      _this.updateAnchorRect();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onScroll", function (event) {
      var open = _this.props.open;

      var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this),
          popoverNode = _assertThisInitialize.popoverNode; // If the popover is open and the scroll event came from *outside* the
      // popover then assume the anchor element moved (and an update is needed for
      // the anchor rect).


      if (open && (!popoverNode || !popoverNode.contains(event.target))) {
        _this.updateAnchorRect();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeOpen", function (done) {
      _this.props.onBeforeOpen();

      _this.setState({
        render: true
      }, function () {
        // Give the children a chance to settle before poking through the DOM
        _this.cancelAnimationFrame = (0, _waitAnimationFrame["default"])(function () {
          /* eslint-disable-next-line react/no-find-dom-node */
          _this.popoverNode = _reactDom["default"].findDOMNode((0, _assertThisInitialized2["default"])(_this));

          _this.updateViewportRect();

          _this.updateAnchorRect();

          _this.updatePopoverRect();

          _this.addEventListeners();

          done();
        });
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOpen", function (done) {
      _this.props.onOpen(_this.popoverNode);

      done();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterClose", function () {
      _this.props.onClose(_this.popoverNode);

      _this.removeEventListeners();

      _this.setState({
        render: false
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(PopoverController, [{
    key: "addEventListeners",
    value: function addEventListeners() {
      // Remove any existing event listeners just to be safe
      this.removeEventListeners(); // Listen for *any* scroll event in the document

      this.eventListeners.push((0, _addDebouncedEventListener["default"])(document, "scroll", this.onScroll, true)); // Listen for resize events from the window

      this.eventListeners.push((0, _addDebouncedEventListener["default"])(window, "resize", this.onResizeWindow));
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      this.eventListeners.forEach(function (removeListener) {
        return removeListener();
      });
      this.eventListeners = [];
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.open && Boolean(this.props.anchorNode)) {
        /* eslint-disable-next-line react/no-find-dom-node */
        this.onBeforeOpen(function () {
          return _this2.onOpen(_noop["default"]);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEventListeners();

      if (this.cancelAnimationFrame) {
        this.cancelAnimationFrame();
      }

      clearTimeout(this.blurTimeout);
      clearTimeout(this.animationTimeout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var anchorNode = this.props.anchorNode;

      if (anchorNode !== prevProps.anchorNode) {
        this.updateAnchorRect();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded); // HACK: 'dir' is used for RTL support to swap Popover to the opposite side.
      // Until we have a fully CSS-based solution for supporting RTL in the
      // Popover we have to take advantage of canUseDom. This dir prop
      // allows us to dynamically update start/end values to left/right
      // or right/left depending on the direction of the layout.

      var dir = (0, _rtl.getDOMDirection)(props.anchorNode); // HACK: For RTL, swap the anchorOrigin x direction.
      // EG: "center right" will become "center left".
      // Since we need to utilize canUseDom, the easiest way to swap
      // Popover in an RTL context (without doing a complete rewrite
      // to make the Popover entirely CSS-based using Emotion) is to
      // check whether the dom direction is RTL and if it is to
      // essentially swap all "left" to "right" and "right" to "left".

      var oppositeAnchorOriginXDirection = (0, _rtl.getHorizontalDirection)((0, _rtl.getRtl)(this.props.anchorOrigin.split(" ")[1]));
      var newAnchorOrigin = dir === "rtl" ? "".concat(this.props.anchorOrigin.split(" ")[0], " ").concat(oppositeAnchorOriginXDirection) : this.props.anchorOrigin; // HACK: For RTL, swap the popoverOrigin x direction.
      // EG: "center right" will become "center left"

      var oppositePopoverOriginXDirection = (0, _rtl.getHorizontalDirection)((0, _rtl.getRtl)(this.props.popoverOrigin.split(" ")[1]));
      var newPopoverOrigin = dir === "rtl" ? "".concat(this.props.popoverOrigin.split(" ")[0], " ").concat(oppositePopoverOriginXDirection) : this.props.popoverOrigin;
      var _this$state = this.state,
          anchorRect = _this$state.anchorRect,
          popoverRect = _this$state.popoverRect,
          viewportRect = _this$state.viewportRect,
          render = _this$state.render;

      var _getBestOrigin = (0, _utils.getBestOrigin)({
        anchorOrigin: (0, _parsers.parseAlignment)(newAnchorOrigin),
        popoverOrigin: (0, _parsers.parseAlignment)(newPopoverOrigin),
        extraSpace: {
          x: props.offsetHorizontal + viewportPadding,
          y: props.offsetVertical + viewportPadding
        },
        anchorRect: anchorRect,
        popoverRect: popoverRect,
        viewportRect: viewportRect
      }),
          anchorOrigin = _getBestOrigin.anchorOrigin,
          popoverOrigin = _getBestOrigin.popoverOrigin,
          availableSpace = _getBestOrigin.availableSpace;

      return /*#__PURE__*/_react["default"].createElement(_transitionController["default"], {
        "in": props.open && Boolean(props.anchorNode),
        duration: parseInt(popoverMotionDuration),
        onBeforeEnter: this.onBeforeOpen,
        onEnter: this.onOpen,
        onAfterExit: this.onAfterClose
      }, function (state) {
        return render ? /*#__PURE__*/_react["default"].createElement(_portal["default"], null, children({
          popoverState: state,
          popoverStyle: styles({
            shrinkToFit: props.shrinkToFit,
            offsetHorizontal: props.offsetHorizontal,
            offsetVertical: props.offsetVertical,
            maxHeight: props.maxHeight,
            maxWidth: props.maxWidth,
            state: state,
            anchorOrigin: anchorOrigin,
            popoverOrigin: popoverOrigin,
            anchorRect: anchorRect,
            popoverRect: popoverRect,
            viewportRect: viewportRect,
            availableSpace: availableSpace
          }),
          popoverOrigin: popoverOrigin,
          anchorOrigin: anchorOrigin,
          anchorRect: anchorRect
        })) : null;
      });
    }
  }]);
  return PopoverController;
}(_react["default"].Component);

(0, _defineProperty2["default"])(PopoverController, "defaultProps", {
  offsetHorizontal: 0,
  offsetVertical: 0,
  onBeforeOpen: _noop["default"],
  onOpen: _noop["default"],
  onClose: _noop["default"]
});
PopoverController.propTypes =  false ? {
  anchorOrigin: _propTypes2["default"].alignment.isRequired,
  children: _propTypes["default"].func.isRequired,
  popoverOrigin: _propTypes2["default"].alignment.isRequired,

  /**
   * Any dom node or React element is valid here, but it's recommended that
   * you add a ref to the React element you want to anchor the popover to and
   * then pass the result in here.
   *
   * This anchor node is required in order to open the popover, but is not
   * required to render a closed popover. This allows you to render an
   * instance of `<PopoverController />` while you're still waiting for a ref
   * to your anchor element.
   *
   * NOTE: When you add a callback ref to an element avoid using inline
   * functions, as they can result in the ref flipping to `null` which can
   * break popover positioning:
   * https://reactjs.org/docs/refs-and-the-dom.html#caveats-with-callback-refs
   */
  anchorNode: _propTypes["default"].object,
  maxHeight: _propTypes["default"].number,
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  offsetHorizontal: _propTypes["default"].number,
  offsetVertical: _propTypes["default"].number,
  open: _propTypes["default"].bool,

  /**
   * If set to true the controller will attempt to resize the popover if there
   * is not enough space to display it at its natural size.
   */
  shrinkToFit: _propTypes["default"].bool,
  onBeforeOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onOpen: _propTypes["default"].func
} : {};
var _default = PopoverController;
exports["default"] = _default;

/***/ }),
/* 540 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(57));

var _canUseDom = _interopRequireDefault(__webpack_require__(136));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Portal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Portal, _React$Component);

  var _super = _createSuper(Portal);

  function Portal() {
    (0, _classCallCheck2["default"])(this, Portal);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Portal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }

      this.defaultNode = null;
    }
  }, {
    key: "render",
    value: function render() {
      if (!_canUseDom["default"]) {
        return null;
      }

      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement("div");
        document.body.appendChild(this.defaultNode);
      }

      return /*#__PURE__*/_reactDom["default"].createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);
  return Portal;
}(_react["default"].Component);

Portal.propTypes =  false ? {
  children: _propTypes["default"].node.isRequired,
  node: _propTypes["default"].any
} : {};
var _default = Portal;
exports["default"] = _default;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _noop = _interopRequireDefault(__webpack_require__(37));

var _waitAnimationFrame = _interopRequireDefault(__webpack_require__(109));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var noopWithCallback = function noopWithCallback(callback) {
  return callback();
};
/**
 * This component makes it easy to apply complex transitions to elements. You
 * tell it whether the children should be transitioned in or out and what the
 * duration of the transition should be. It will provide you with the state of
 * the transition via a render prop. The state may be one of four values:
 * "entering", "entered", "exiting", or "exited". Six lifecycle hooks are
 * available: onBeforeEnter, onEnter, onAfterEnter, onBeforeExit, onExit, and
 * onAfterExit.
 */


var TransitionController = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TransitionController, _React$Component);

  var _super = _createSuper(TransitionController);

  function TransitionController() {
    var _this;

    (0, _classCallCheck2["default"])(this, TransitionController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      state: _this.props["in"] ? "entered" : "exited"
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancelWait", _noop["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "callback", _noop["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "waitAnimationFrame", function (callback, skip) {
      if (skip) {
        callback();
      } else {
        _this.cancelWait();

        _this.cancelWait = (0, _waitAnimationFrame["default"])(callback);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "waitDuration", function (callback) {
      var timeout;

      _this.cancelWait();

      _this.cancelWait = function () {
        return clearTimeout(timeout);
      };

      timeout = setTimeout(callback, _this.props.duration);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "withCallback", function (func) {
      return function (callback) {
        _this.callback = callback;
        func(function () {
          if (_this.callback === callback) {
            callback();
          }
        });
      };
    });
    return _this;
  }

  (0, _createClass2["default"])(TransitionController, [{
    key: "transition",
    value:
    /**
     * This orchestrates a transition. The basic flow is:
     * 1) cancel any existing timeouts
     * 2) call onBefore
     * 3) wait for a single animation frame *if* onBefore is defined (so that the
     *    DOM has a chance to settle)
     * 4) update the state to transitioning
     * 5) wait for a single animation frame *if* onTransition is defined (so that
     *    the DOM has a chance to settle)
     * 6) call onTransition
     * 7) wait for the duration of the animation
     * 8) update the state to transitioned
     * 9) wait for a single animation frame
     * 10) call onAfter
     */
    function transition(_ref) {
      var _this2 = this;

      var onBefore = _ref.onBefore,
          onTransition = _ref.onTransition,
          onAfter = _ref.onAfter,
          stateDuring = _ref.stateDuring,
          stateAfter = _ref.stateAfter;
      var onBeforeWithCallback = this.withCallback(onBefore);
      var onTransitionWithCallback = this.withCallback(onTransition);
      this.cancelWait();
      onBeforeWithCallback(function () {
        return _this2.waitAnimationFrame(function () {
          return _this2.setState({
            state: stateDuring
          }, function () {
            return _this2.waitAnimationFrame(function () {
              return onTransitionWithCallback(function () {
                return _this2.waitDuration(function () {
                  return _this2.setState({
                    state: stateAfter
                  }, _this2.waitAnimationFrame(onAfter, onAfter === _noop["default"]));
                });
              });
            }, // Don't wait an extra animation frame if no onTransition hook is
            // provided
            onTransition === noopWithCallback);
          });
        }, // Don't wait an extra animation frame if no onBefore hook is provided
        onBefore === noopWithCallback);
      });
    }
  }, {
    key: "transitionIn",
    value: function transitionIn() {
      this.transition({
        onBefore: this.props.onBeforeEnter,
        onTransition: this.props.onEnter,
        onAfter: this.props.onAfterEnter,
        stateDuring: "entering",
        stateAfter: "entered"
      });
    }
  }, {
    key: "transitionOut",
    value: function transitionOut() {
      this.transition({
        onBefore: this.props.onBeforeExit,
        onTransition: this.props.onExit,
        onAfter: this.props.onAfterExit,
        stateDuring: "exiting",
        stateAfter: "exited"
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props["in"] && !prevProps["in"]) {
        this.transitionIn();
      } else if (!this.props["in"] && prevProps["in"]) {
        this.transitionOut();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelWait();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.state.state);
    }
  }]);
  return TransitionController;
}(_react["default"].Component);

(0, _defineProperty2["default"])(TransitionController, "defaultProps", {
  onBeforeEnter: noopWithCallback,
  onEnter: noopWithCallback,
  onAfterEnter: _noop["default"],
  onBeforeExit: noopWithCallback,
  onExit: noopWithCallback,
  onAfterExit: _noop["default"]
});
TransitionController.propTypes =  false ? {
  children: _propTypes["default"].func.isRequired,
  duration: _propTypes["default"].number.isRequired,
  "in": _propTypes["default"].bool.isRequired,

  /**
   * Called right after the state has changed to "entered".
   */
  onAfterEnter: _propTypes["default"].func,

  /**
   * Called right after the state has changed to "exited".
   */
  onAfterExit: _propTypes["default"].func,

  /**
   * Called right before the state will change from "exited" to "entering".
   * This can be syncronous or asyncronous, but either way it must accept a
   * callback as its first argument and execute that callback when it's
   * finished doing its thing.
   */
  onBeforeEnter: _propTypes["default"].func,

  /**
   * Called right before the state will change from "entered" to "exiting".
   * This can be syncronous or asyncronous, but either way it must accept a
   * callback as its first argument and execute that callback when it's
   * finished doing its thing.
   */
  onBeforeExit: _propTypes["default"].func,

  /**
   * Called right after the state has changed to "entering". This can be
   * syncronous or asyncronous, but either way it must accept a callback as
   * its first argument and execute that callback when it's finished doing its
   * thing.
   */
  onEnter: _propTypes["default"].func,

  /**
   * Called right after the state has changed to "exited". This can be
   * syncronous or asyncronous, but either way it must accept a callback as
   * its first argument and execute that callback when it's finished doing its
   * thing.
   */
  onExit: _propTypes["default"].func
} : {};
var _default = TransitionController;
exports["default"] = _default;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(544);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 544 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports = {"common.stow_buffered":"Stow buffered","common.jackpot_buffered_mfr":"Jackpot buffered (MFR)","aisleOptions.aisle":"Aisle","associateStatusOptions.yes":"Yes","associateStatusOption.no":"No","associateStatusOption.active":"Active","clusterOptions.cluster":"Cluster","cycleOptions.cycle":"Cycle","zoneOptions.zone":"Zone","floorOptions.cartLocation":"Cart Location","CPT.":"CPT","CPT.cpt":"CPT","CPT.induct_by":"Induct By","CPT.stow_by":"Stow By","aisle.packages":"Packages","aisle.bags":"Bags","aisle.performance":"Performance","aisle.stowers":"Stowers","aisle.aisle":"Aisle","aisle.containerPlanned":"C. Planned","aisle.received":"Received","aisle.arrived":"Arrived","aisle.inducted":"Inducted","aisle.stowed":"Stowed","aisle.planned":"Planned","aisle.used":"Used","aisle.missing":"Missing","aisle.unused":"Unused","aisle.stow_rate":"Stow rate","aisle.scan_complaince":"Scan comp.","aisle.fsaf":"FSAF","aisle.active":"Active","associate.associates":"Associates","associate.heading":"Stow associates","associate.description":"This table shows stow associates’ performance data and current working location","associate.associate":"Associate","associate.pph":"PPH","associate.hours":"Hours","associate.total_pkgs":"Total Pkgs","associate.fsaf":"FSAF","associate.fsaf_dpmo":"FSAF DPMO","associate.active":"Active","associate.lastLocation":"Last Location","associate.inactive_periods":"Inactive periods","overview.aisles_at_risk":"Aisles at Risk","tooltip.overview.aisles_at_risk":"Aisles that have breached the upper Minutes of Work (MoW) thresholds","overview.container_planned":"C. Planned","tooltip.overview.container_planned":"Total number of packages container planned to a cluster","overview.arrived":"Arrived","tooltip.overview.arrived":"Arrived: Total volume that is virtually attached to a trailer and has entered the station's geofence","overview.inducted":"Inducted","tooltip.overview.inducted":"Shipments within a cluster that were inducted but have yet to be stowed","overview.stow_rate":"Stow Rate","tooltip.overview.stow_rate":"Last 15 minute Stow FPH/Amount of Active Stowers within Cluster","overview.stowers":"Stowers","tooltip.overview.stowers":"# of Associates stowing packages from stow buffer to destination sort zone or oversize location","overview.minutes_of_work":"MoW","tooltip.overview.minutes_of_work":"(Total packages Inducted / Stow FPH) * 60","overview.adjacency_score":"Stow Adherence","tooltip.overview.adjacency_score":"# of racks units moved/# of packages stowed","cluster.packages":"Packages","cluster.open_bags":"Open bags","cluster.performance":"Performance","cluster.stowers":"Stowers","tooltip.cluster.stowers":"# of Associates stowing packages from stow buffer to destination sort zone or oversize location","cluster.cluster":"Cluster","cluster.container_planned":"C. Planned","tooltip.cluster.container_planned":"Packages that are container planned for each particular cluster","cluster.received":"Received","cluster.arrived":"Arrived","tooltip.cluster.arrived":"Arrived: Total volume within a respective cluster that is virtually attached to a trailer and has entered the station's geofence","cluster.inducted":"Inducted","tooltip.cluster.inducted":"Shipments within a cluster that were inducted but have yet to be stowed.","cluster.stowed":"Stowed","cluster.stow_plan":"Stow / Plan","tooltip.cluster.stow_plan":"(Stowed Volume / Total Container Planned Volume) * 100%","cluster.ps":"PS","tooltip.cluster.ps":"Problem Solve packages container planned to the respective cluster","cluster.missing":"Unopened Bags","cluster.cartsMissing":"Unopened Carts","cluster.minutes_of_work":"Min of Work","tooltip.cluster.minutes_of_work":"(Inducted Volume / Cluster Stow FPH) * 60 min","cluster.stow_rate":"Stow rate","tooltip.cluster.stow_rate":"Cluster Stow FPH / Active Stowers","cluster.scan_compliance":"Scan comp.","tooltip.cluster.scan_compliance":"Scan Compliance per cluster calculated as (Inducted / Stowed Volume) * 100","cluster.active":"Active","tooltip.cluster.active":"Real time active stowers within the cluster","cluster.inactive":"Inactive","floorLocation.carts":"Carts","floorLocation.packages":"Packages","floorLocation.performance":"Performance","floorLocation.stowers":"Stowers","floorLocation.floor_location":"Floor Location","floorLocation.re_induct_day":"Re-induct Day","floorLocation.ofd":"OFD","floorLocation.inducted":"Inducted","floorLocation.stowed":"Stowed","floorLocation.no_of_carts":"# of Carts","floorLocation.stow_rate":"Stow rate","floorLocation.scan_compliance":"Scan comp.","floorLocation.active":"Active","floorLocation.inactive":"Inactive","cart.floor_location":"Floor Location","cart.reInductDay":"Re-induct Day","cart.ofd":"OFD","cart.cart_id":"Cart ID","cart.no_of_packages":"# of Packages","packageList.stow":"Stow","packageList.packageList":"Package List","packageList.packageSummary":"Package Summary","packageList.trackingId":"Tracking Id","packageList.lastScan":"Last scan","packageList.minute_in_state":"Minutes in state","packageList.state":"State","packageList.reason":"Reason","packageList.location":"Location","packageList.associate_id":"Associate ID","packageList.cycle":"Cycle","packageList.sortZone":"Sort Zone","packageList.cluster":"Cluster","packageList.ead":"EAD","packageList.size":"Size","packageList.routeCode":"Route Code","packageList.station_pair":"Station","sortZone.bags":"Bags","sortZone.ov_capacity":"OV Capacity","sortZone.packages":"Packages","sortZone.zone":"Zone","sortZone.planned":"Planned","sortZone.closed":"Closed","sortZone.open":"Open","sortZone.used":"Used","sortZone.container_planned":"C. Planned","sortZone.received":"Received","sortZone.arrived":"Arrived","sortZone.inducted":"Inducted","sortZone.stowed":"Stowed","stationPair.station_pair":"Station","stow.download_sort_location_plan":"Download-sort-location-plan","stow.error":"Some Error Occured","stow.close":"Close","options.options":"Options","options.clear_all":"Clear all","heatMapViewOptions.routeView":"Route","heatMapViewOptions.clusterView":"Cluster","heatMapViewOptions.stationPairView":"Station","heatMap.heading":"Stow","heatMap.description":"This table shows the clusters and statuses of containers and packages in the stow process","common.data_last_updated":"Data last updated","reverse.banner":"Welcome to the new SCC Reverse tab which provides the details about reverse containers. To learn more and watch a brief training, ","reverse.clickhere":"click here.","reverse.heading":"Reverse","reverse.description":"An overview of packages and containers being processed to depart from the station in reverse","reverse.reversePackages":"Reverse Packages","reverse.pendingStow":"Pending Stow","reverse.stowCompliance":"Stow Compliance","reverse.reverseContainers":"Reverse Containers","reverse.pendingClose":"Pending Close","reverse.pendingStage":"Pending Stage","reverse.pendingDepart":"Pending Depart","reverse.closeFailed":"Close Failed","reverse.containerScanCompliance":"Container Scan Compliance","reverse.closeSuccess":"Close Success","reverse.stageCompliance":"Stage Compliance","reverse.loadingCompliance":"Loading Compliance","reverse.departCompliance":"Depart Compliance","reverse.atRisk":"At risk","reverse.containerCount":"Container Count","reverse.visualView":"Visual view","reverse.tableView":"Table view","reverse.ShipmentType":"Shipment Type","reverse.exportCSV":"Export To CSV","pendingStowList.reverse":"Reverse","pendingStowList.pendingStowList":"Pending Stow List","pendingStowList.trackingId":"Tracking Id","pendingStowList.routeCode":"Route Code","pendingStowList.state":"State","pendingStowList.reason":"Reason","pendingStowList.location":"Sort Zone","reverse.CPT":"CPT","reverse.Containers":"Containers","reverse.pendingLoading":"Pending Loading","reverse.departed":"Departed","reverse.isAtRisk":"At Risk","reverse.toggleFullscreen":"Toggle fullscreen","reverse.OpenedAt":"Opened At","reverse.ContainerID":"Container ID","reverse.ResourceLabel":"Resource Label","reverse.Opened":"Opened","reverse.Closed":"Closed","reverse.Staged":"Staged","reverse.Loaded":"Loaded","reverse.Departed":"Departed","reverse.Volume":"Volume","reverse.Destination":"Destination","reverse.StackingFilter":"StackingFilter"}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports = {"common.stow_buffered":"Stow buffered","common.jackpot_buffered_mfr":"Jackpot buffered (MFR)","aisleOptions.aisle":"Pasillo","associateStatusOptions.yes":"Sí","associateStatusOption.no":"No","associateStatusOption.active":"Activo","clusterOptions.cluster":"Clúster","cycleOptions.cycle":"Ciclo","CPT.":"CPT","CPT.cpt":"CPT","CPT.induct_by":"Inducir por","CPT.stow_by":"Guardar por","aisle.packages":"Paquetes","aisle.bags":"Bolsas","aisle.performance":"Rendimiento","aisle.stowers":"Stowers","aisle.aisle":"Pasillo","aisle.containerPlanned":"C. planificado","aisle.received":"Recibido","aisle.arrived":"Llegado","aisle.inducted":"Iniciado","aisle.stowed":"En stow","aisle.planned":"Planificado","aisle.used":"Usado","aisle.missing":"Falta","aisle.unused":"Sin usar","aisle.stow_rate":"Tasa de stow","aisle.scan_complaince":"Cump. de escaneo","aisle.fsaf":"FSAF","aisle.active":"Activo","associate.associate":"Asociado","associate.heading":"Asociados de estiba","associate.description":"En esta tabla se muestran los datos de rendimiento de los asociados de stow y la ubicación de trabajo actual","associate.pph":"PPH","associate.hours":"Horas","associate.total_pkgs":"Total de pqtes.","associate.fsaf":"FSAF","associate.fsaf_dpmo":"DPMO de FSAF","associate.active":"Activo","associate.lastLocation":"Último Ubicación","associate.inactive_periods":"Periodos inactivos","overview.aisles_at_risk":"Aisles at Risk","tooltip.overview.aisles_at_risk":"Pasillos que han superado el umbral máximo de minutos de trabajo ","overview.container_planned":"C. planificado","tooltip.overview.container_planned":"Número total de paquetes planeado para un cluster","overview.arrived":"Llegado","tooltip.overview.arrived":"Llegado: volumen total que virtualmente está vinculado al camion y ha entrado en Geofence de la estación","overview.inducted":"Iniciado","tooltip.overview.inducted":"Envíos inducidos en cada clustes pendiente de stow","overview.stow_rate":"Tasa de stow","tooltip.overview.stow_rate":"Los últimos 15 minutos de Stow FPH/stowers activos en cada cluster","overview.stowers":"Stowers","tooltip.overview.stowers":"Número de asociados haciendo stow de paquetes desde las estanterias de stow a las bolsas o a la ubicacion de paquete grande","overview.minutes_of_work":"MoW","tooltip.overview.minutes_of_work":"(Total de paquetes inducidos/Stow FPH)*60","cluster.packages":"Paquetes","cluster.open_bags":"Bolsas abiertas","cluster.performance":"Rendimiento","cluster.stowers":"Stowers","tooltip.cluster.stowers":"Número de asociados haciendo stow de paquetes desde las estanterias de stow a las bolsas o a la ubicacion de paquete grande","cluster.cluster":"Clúster","cluster.container_planned":"C. planificado","tooltip.cluster.container_planned":"Paquetes planeados para cada uno de los clusters","cluster.received":"Recibido","cluster.arrived":"Llegado","tooltip.cluster.arrived":"Llegado: volumen total que virtualmente está vinculado al camion y ha entrado en Geofence de la estación","cluster.inducted":"Iniciado","tooltip.cluster.inducted":"Envíos inducidos en cada clustes pendiente de stow","cluster.stowed":"En stow","cluster.stow_plan":"Stow / Plan","tooltip.cluster.stow_plan":"(volumen de stow / el volumen total planeado) * 100%","cluster.ps":"PS","tooltip.cluster.ps":"Paquetes planeados de Problem Solve para cada respectivo clustes","cluster.missing":"Falta","cluster.minutes_of_work":"Min of Work","tooltip.cluster.minutes_of_work":"(Volumen inducido / Stow por cluster flujo por hora(FPH)) * 60 min","cluster.stow_rate":"Tasa de stow","tooltip.cluster.stow_rate":"Cluster stow FPH / Stowers activos","cluster.scan_complaince":"Cump. de escaneo","tooltip.cluster.scan_compliance":"Scan compliance por cluste claculado como (inducido / volumen stowed) * 100","cluster.active":"Activo","tooltip.cluster.active":"Stowers activos en tiempo real en cada cluster","cluster.inactive":"Inactivo","floorLocation.carts":"Carros","floorLocation.packages":"Paquetes","floorLocation.performance":"Rendimiento","floorLocation.stowers":"Stowers","floorLocation.floor_location":"Área designada","floorLocation.re_induct_day":"Día de Reinducción","floorLocation.inducted":"Iniciado","floorLocation.stowed":"En stow","floorLocation.no_of_carts":"Número de Carros","floorLocation.stow_rate":"Tasa de stow","floorLocation.scan_compliance":"Cump. de escaneo","floorLocation.active":"Activo","floorLocation.inactive":"Inactivo","cart.floor_location":"Área designada","cart.reInductDay":"Día de Reinducción","cart.cart_id":"ID de carrito","cart.no_of_packages":"Número de paquetes","packageList.stow":"Hacer stow","packageList.packageList":"Lista de paquetes","packageList.packageSummary":"Resumen de paquete","packageList.trackingId":"Id. de seguimiento","packageList.lastScan":"Último escaneo","packageList.minute_in_state":"Minutos en el estado","packageList.state":"Estado","packageList.reason":"Motivo","packageList.location":"Ubicación","packageList.associate_id":"Id. de asociado","packageList.cycle":"Ciclo","packageList.sortZone":"Zona de ordenación","packageList.cluster":"Clúster","packageList.ead":"EAD","packageList.size":"Tamaño","packageList.routeCode":"Código de ruta","sortZone.bags":"Bolsas","sortZone.ov_capacity":"Capacidad de OV","sortZone.packages":"Paquetes","sortZone.zone":"Zona","sortZone.planned":"Planificado","sortZone.closed":"Cerrado","sortZone.open":"Abierto","sortZone.used":"Usado","sortZone.container_planned":"C. planificado","sortZone.received":"Recibido","sortZone.arrived":"Llegado","sortZone.inducted":"Iniciado","sortZone.stowed":"En stow","stow.error":"Algún error ocurrido","stow.close":"Cerrar","stow.download_sort_location_plan":"Descargar-ordenar-ubicación-plan","options.clear_all":"Borrar todo","heatMap.heading":"Stow","heatMap.description":"En esta tabla se muestran los clústeres y estados de los contenedores y paquetes en el proceso de estiba","common.data_last_updated":"Datos actualizados por última vez","reverse.banner":"Bienvenido a la nueva pestaña SCC Reverse, que proporciona detalles sobre los contenedores inversos. Para obtener más información y ver un breve curso de formación, ","reverse.clickhere":"haga clic aquí.","reverse.heading":"Reverso","reverse.description":"Un resumen de los paquetes y contenedores que se están procesando para salir de la estación en sentido inverso","reverse.reversePackages":"Paquetes inversos","reverse.pendingStow":"Almacenamiento pendiente","reverse.stowCompliance":"Cumplimiento de Stow","reverse.reverseContainers":"Contenedores inversos","reverse.pendingClose":"Cierre pendiente","reverse.pendingStage":"Etapa pendiente","reverse.pendingDepart":"Salida pendiente","reverse.closeFailed":"Falló el cierre","reverse.containerScanCompliance":"Conformidad con el escaneo de contenedores","reverse.closeSuccess":"Éxito cercano","reverse.stageCompliance":"Cumplimiento de etapas","reverse.loadingCompliance":"Cumplimiento de carga","reverse.departCompliance":"Cumplimiento de normas","reverse.atRisk":"En riesgo","reverse.containerCount":"Recuento de contenedores","reverse.visualView":"Vista visual","reverse.tableView":"Vista de tabla","reverse.ShipmentType":"Tipo de envío","reverse.exportCSV":"Exportar a CSV","pendingStowList.reverse":"Reverso","pendingStowList.pendingStowList":"Lista de almacenamiento pendiente","pendingStowList.trackingId":"ID de seguimiento","pendingStowList.routeCode":"Código de ruta","pendingStowList.state":"Estado","pendingStowList.reason":"Motivo","pendingStowList.location":"Ordenar zona","reverse.CPT":"CPT","reverse.Containers":"Contenedores","reverse.pendingLoading":"Carga pendiente","reverse.departed":"Departed","reverse.isAtRisk":"En riesgo","reverse.toggleFullscreen":"Alternar pantalla completa","reverse.OpenedAt":"Abierto en","reverse.ContainerID":"ID de contenedor","reverse.ResourceLabel":"Etiqueta de recurso","reverse.Opened":"Abierto","reverse.Closed":"Cerrado","reverse.Staged":"Escenificado","reverse.Loaded":"Cargado","reverse.Departed":"Departed","reverse.Volume":"Volumen","reverse.Destination":"Destino","reverse.StackingFilter":"Filtro de apilamiento","cluster.cartsMissing":"Carros sin abrir"}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports = {"common.stow_buffered":"Stow buffered","common.jackpot_buffered_mfr":"Jackpot buffered (MFR)","aisleOptions.aisle":"Allée","associateStatusOptions.yes":"Oui","associateStatusOption.no":"Non","associateStatusOption.active":"Actif","clusterOptions.cluster":"Cluster","cycleOptions.cycle":"Cycle","CPT.":"CPT","CPT.cpt":"CPT","CPT.induct_by":"Introniser par","CPT.stow_by":"Rangement par","aisle.packages":"Colis","aisle.bags":"Sacs","aisle.performance":"Performance","aisle.stowers":"Stockeurs","aisle.aisle":"Allée","aisle.containerPlanned":"C. Planifié","aisle.received":"Reçu","aisle.arrived":"Arrivée","aisle.inducted":"Démarré","aisle.stowed":"Stocké","aisle.planned":"Planifié","aisle.used":"Utilisé","aisle.missing":"Manquant","aisle.unused":"Inutilisé","aisle.stow_rate":"Débit de stockage","aisle.scan_complaince":"Conf. du scan","aisle.fsaf":"FSAF","aisle.active":"Actif","associate.associate":"Associé","associate.heading":"Associés Stow","associate.description":"Ce tableau présente les données de performance des associés Stow et l'emplacement de travail actuel","associate.pph":"PPH","associate.hours":"Heures","associate.total_pkgs":"Colis au total","associate.fsaf":"FSAF","associate.fsaf_dpmo":"DPMO FSAF","associate.active":"Actif","associate.lastLocation":"Dernier Lieu","associate.inactive_periods":"Périodes d’inactivité","overview.aisles_at_risk":"Aisles at Risk","tooltip.overview.aisles_at_risk":"Allées ayant dépassé la limites supérieure de temps de travail","overview.container_planned":"C. Planifié","tooltip.overview.container_planned":"Nombre total de colis prévu pour un cluster","overview.arrived":"Arrivée","tooltip.overview.arrived":"Arrivé: Volume total porté virtuellement par un camion qui est entré dans le geofence de la station","overview.inducted":"Démarré","tooltip.overview.inducted":"Nombre total de colis inductés mais non rangé pour un cluster","overview.stow_rate":"Débit de stockage","tooltip.overview.stow_rate":"Dernier quart d heure stow FPH/ nombre total de stower actifs sur le cluster","overview.stowers":"Stockeurs","tooltip.overview.stowers":"# of Associates stowing packages from stow buffer to destination sort zone or oversize location","overview.minutes_of_work":"MoW","tooltip.overview.minutes_of_work":"(Total packages Inducted/ Stow FPH)*60","cluster.packages":"Colis","cluster.open_bags":"Sacs ouverts","cluster.performance":"Performance","cluster.stowers":"Stockeurs","tooltip.cluster.stowers":"# of Associates stowing packages from stow buffer to destination sort zone or oversize location","cluster.cluster":"Cluster","cluster.container_planned":"C. Planifié","tooltip.cluster.container_planned":"les paquets qui sont prévus dans le conteneurs pour chaque cluster particuliers","cluster.received":"Reçu","cluster.arrived":"Arrivée","tooltip.cluster.arrived":"Arrivé: Volume total porté virtuellement par un camion qui est entré dans le geofence de la station","cluster.inducted":"Démarré","tooltip.cluster.inducted":"Nombre total de colis inductés mais non rangé pour un cluster","cluster.stowed":"Stocké","cluster.stow_plan":"Stocker/planifier","tooltip.cluster.stow_plan":"(Stowed Volume / Total Container Planned Volume) * 100%","cluster.ps":"PS","tooltip.cluster.ps":"Problem Solve packages container planned to the respective cluster","cluster.missing":"Manquant","cluster.minutes_of_work":"Min of Work","tooltip.cluster.minutes_of_work":"(Inducted Volume / Cluster Stow FPH) * 60 min","cluster.stow_rate":"Débit de stockage","tooltip.cluster.stow_rate":"Cluster Stow FPH / Active Stowers","cluster.scan_complaince":"Conf. du scan","tooltip.cluster.scan_compliance":"Scan compliance par cluster égal (volume inducté / volume stow) * 100","cluster.active":"Actif","tooltip.cluster.active":"Temps réel des stowers actifs au sein du cluster","cluster.inactive":"Inactif","floorLocation.carts":"Chariot","floorLocation.packages":"Colis","floorLocation.performance":"Performance","floorLocation.stowers":"Stockeurs","floorLocation.floor_location":"Localisation sur le floor","floorLocation.re_induct_day":"Jour de re-induction","floorLocation.inducted":"Démarré","floorLocation.stowed":"Stocké","floorLocation.no_of_carts":"Numéro de chariot","floorLocation.stow_rate":"Débit de stockage","floorLocation.scan_compliance":"Conf. du scan","floorLocation.active":"Actif","floorLocation.inactive":"Inactif","cart.floor_location":"Localisation sur le floor","cart.reInductDay":"Jour de re-induction","cart.cart_id":"ID du chariot","cart.no_of_packages":"Numéro de colis","packageList.stow":"Stocker","packageList.packageList":"Liste des colis","packageList.packageSummary":"Synthèse du colis","packageList.trackingId":"ID de suivi","packageList.lastScan":"Dernier scan","packageList.minute_in_state":"Minutes dans l’état","packageList.state":"État","packageList.reason":"Raison","packageList.location":"Lieu","packageList.associate_id":"ID de l’associé","packageList.cycle":"Cycle","packageList.sortZone":"Zone de tri","packageList.cluster":"Cluster","packageList.ead":"EAD","packageList.size":"Taille","packageList.routeCode":"Code de route","sortZone.bags":"Sacs","sortZone.ov_capacity":"Capacité OV","sortZone.packages":"Colis","sortZone.zone":"Zone","sortZone.planned":"Planifié","sortZone.closed":"Fermé","sortZone.open":"Ouvert","sortZone.used":"Utilisé","sortZone.container_planned":"C. Planifié","sortZone.received":"Reçu","sortZone.arrived":"Arrivée","sortZone.inducted":"Démarré","sortZone.stowed":"Stocké","stow.error":"Une erreur s'est produite","stow.close":"Fermer","stow.download_sort_location_plan":"Télécharger-trier-localiser-plan","options.clear_all":"Tout effacer","heatMap.heading":"Stow","heatMap.description":"Ce tableau présente les clusters et statuts des conteneurs et colis pour le processus de Stow","common.data_last_updated":"Dernière mise à jour des données","reverse.banner":"Bienvenue dans le nouvel onglet SCC Reverse qui fournit des informations sur les conteneurs inversés. Pour en savoir plus et assister à une brève formation, ","reverse.clickhere":"cliquez ici.","reverse.heading":"Inverser","reverse.description":"Vue d'ensemble des colis et des conteneurs en cours de traitement pour quitter la gare en sens inverse","reverse.reversePackages":"Packages inversés","reverse.pendingStow":"En attente d'arrimage","reverse.stowCompliance":"Conformité à Stow","reverse.reverseContainers":"Conteneurs inversés","reverse.pendingClose":"Waiting for closure","reverse.pendingStage":"Étape en attente","reverse.pendingDepart":"Départ en attente","reverse.closeFailed":"Échec de la fermeture","reverse.containerScanCompliance":"Conformité au scan des conteneurs","reverse.closeSuccess":"Succès serré","reverse.stageCompliance":"Conformité aux étapes","reverse.loadingCompliance":"Conformité au chargement","reverse.departCompliance":"Conformité aux départs","reverse.atRisk":"À risque","reverse.containerCount":"Nombre de conteneurs","reverse.visualView":"Vue visuelle","reverse.tableView":"Vue du tableau","reverse.ShipmentType":"Type d'expédition","reverse.exportCSV":"Exporter au format CSV","pendingStowList.reverse":"Inverser","pendingStowList.pendingStowList":"Pending Stow List","pendingStowList.trackingId":"ID de suivi","pendingStowList.routeCode":"Code d'itinéraire","pendingStowList.state":"État","pendingStowList.reason":"Motif","pendingStowList.location":"Zone de tri","reverse.CPT":"CPT","reverse.Containers":"Conteneurs","reverse.pendingLoading":"En attente de chargement","reverse.departed":"Departed","reverse.isAtRisk":"À risque","reverse.toggleFullscreen":"Basculer en mode plein écran","reverse.OpenedAt":"Ouvert à","reverse.ContainerID":"Identifiant du conteneur","reverse.ResourceLabel":"Label de ressource","reverse.Opened":"Ouvert","reverse.Closed":"Fermé","reverse.Staged":"Mise en scène","reverse.Loaded":"Chargé","reverse.Departed":"Departed","reverse.Volume":"Volume","reverse.Destination":"Destination","reverse.StackingFilter":"Filtre d'empilage","cluster.cartsMissing":"Chariots non ouverts"}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports = {"common.stow_buffered":"Stow buffered","common.jackpot_buffered_mfr":"Jackpot buffered (MFR)","aisleOptions.aisle":"Corsia","associateStatusOptions.yes":"Sì","associateStatusOption.no":"No","associateStatusOption.active":"Attivo","clusterOptions.cluster":"Cluster","cycleOptions.cycle":"Ciclo","CPT.":"CPT","CPT.cpt":"CPT","CPT.induct_by":"Indotto da","CPT.stow_by":"Fermati vicino","aisle.packages":"Pacchi","aisle.bags":"Borse","aisle.performance":"Performance","aisle.stowers":"Stower","aisle.aisle":"Corsia","aisle.containerPlanned":"C. Pianificato","aisle.received":"Ricevuto","aisle.arrived":"Arrivato","aisle.inducted":"Indotto","aisle.stowed":"Stoccato","aisle.planned":"Pianificato","aisle.used":"Usato","aisle.missing":"Mancante","aisle.unused":"Inutilizzato","aisle.stow_rate":"Velocità di stoccaggio","aisle.scan_complaince":"Corr. scansione","aisle.fsaf":"FSAF","aisle.active":"Attivo","associate.associate":"Associate","associate.heading":"Associati Stow","associate.description":"Questa tabella mostra i dati sulle prestazioni degli associati stow e la posizione di lavoro corrente","associate.pph":"PPH","associate.hours":"Ore","associate.total_pkgs":"Totale pacchi","associate.fsaf":"FSAF","associate.fsaf_dpmo":"FSAF DPMO","associate.active":"Attivo","associate.location":"Ultima Posizione","associate.inactive_periods":"Periodi inattivi","overview.aisles_at_risk":"Aisles at Risk","tooltip.overview.aisles_at_risk":"Aisle che hanno superato la soglia massima di Minutes of Work (MoW)","overview.container_planned":"C. pianificato","tooltip.overview.container_planned":"Totale dei pacchi pianificati per ciascun cluster (finger)","overview.arrived":"Arrivato","tooltip.overview.arrived":"Arrived: Volume totale virtualmente legato a un trailer che è entrato nella geofence","overview.inducted":"Indotto","tooltip.overview.inducted":"Numero di pacchi di un determinato cluster che sono stati ricevuti ma non ancora sortati","overview.stow_rate":"Velocità di stoccagggio","tooltip.overview.stow_rate":"Stow FPH degli ultimi 15 minuti / Totale di stower attivi in un certo cluster","overview.stowers":"Stowers","tooltip.overview.stowers":"# of Associates stowing packages from stow buffer to destination sort zone or oversize location","overview.minutes_of_work":"MoW","tooltip.overview.minutes_of_work":"(Total packages Inducted / Stow FPH) * 60","cluster.packages":"Pacchi","cluster.open_bags":"Borse aperte","cluster.performance":"Performance","cluster.stowers":"Stower","tooltip.cluster.stowers":"# of Associates stowing packages from stow buffer to destination sort zone or oversize location","cluster.cluster":"Cluster","cluster.container_planned":"C. pianificato","tooltip.cluster.container_planned":"Pacchi pianificati per uno specifico cluster (finger)","cluster.received":"Ricevuto","cluster.arrived":"Arrivato","tooltip.cluster.arrived":"Arrived: Volume totale all'interno di un certo cluster che è virtualmente legato ad un trailer ed è entrato dela geofence della DS","cluster.inducted":"Indotto","tooltip.cluster.inducted":"Numero di pacchi di un determinato cluster che sono stati ricevuti ma non ancora sortati","cluster.stowed":"Stoccato","cluster.stow_plan":"Stoccaggio/Piano","tooltip.cluster.stow_plan":"(Stowed Volume / Total Container Planned Volume) * 100%","cluster.ps":"PS","tooltip.cluster.ps":"Problem Solve packages container planned to the respective cluster","cluster.missing":"Mancante","cluster.minutes_of_work":"Min of Work","tooltip.cluster.minutes_of_work":"(Inducted Volume / Cluster Stow FPH) * 60 min","cluster.stow_rate":"Velocità di stoccagggio","tooltip.cluster.stow_rate":"Cluster Stow FPH / Active Stowers","cluster.scan_complaince":"Corr. scansione","tooltip.cluster.scan_compliance":"Scan Compliance per cluster calcolata come (Inducted / Stowed Volume) * 100","cluster.active":"Attivo","tooltip.cluster.active":"Stower attivi in tempo reale all'interno del cluster (finger)","cluster.inactive":"Inattivo","floorLocation.carts":"Carrelli","floorLocation.packages":"Pacchi","floorLocation.performance":"Performance","floorLocation.stowers":"Stower","floorLocation.floor_location":"Area designata","floorLocation.re_induct_day":"Giorno di Ricezione","floorLocation.inducted":"Indotto","floorLocation.stowed":"Stoccato","floorLocation.no_of_carts":"Numero di Carrelli","floorLocation.stow_rate":"Velocità di stoccagggio","floorLocation.scan_compliance":"Corr. scansione","floorLocation.active":"Attivo","floorLocation.inactive":"Inattivo","cart.floor_location":"Area designata","cart.reInductDay":"Giorno di Ricezione","cart.cart_id":"ID carrello","cart.no_of_packages":"Numero di Pacchi","packageList.stow":"Stoccaggio","packageList.packageList":"Elenco pacchi","packageList.packageSummary":"Riepilogo pacchi","packageList.trackingId":"ID tracciabilità","packageList.lastScan":"Ultima scansione","packageList.minute_in_state":"Minuti in stato","packageList.state":"Stato","packageList.reason":"Motivo","packageList.location":"Posizione","packageList.associate_id":"ID Associate","packageList.cycle":"Ciclo","packageList.sortZone":"Zona sort","packageList.cluster":"Cluster","packageList.ead":"EAD","packageList.size":"Dimensione","packageList.routeCode":"Codice percorso","sortZone.bags":"Borse","sortZone.ov_capacity":"Capacità OV","sortZone.packages":"Pacchi","sortZone.zone":"Zona","sortZone.planned":"Pianificato","sortZone.closed":"Chiuso","sortZone.open":"Aperto","sortZone.used":"Utilizzato","sortZone.container_planned":"C. pianificato","sortZone.received":"Ricevuto","sortZone.arrived":"Arrivato","sortZone.inducted":"Indotto","sortZone.stowed":"Stoccato","stow.error":"Si è verificato un errore","stow.close":"Vicino","stow.download_sort_location_plan":"Scarica-ordina-posizione-piano","options.clear_all":"Cancella tutto","heatMap.heading":"Stow","heatMap.description":"Questa tabella mostra i cluster e gli stati dei contenitori e dei pacchetti nel processo di stow","common.data_last_updated":"Ultimo aggiornamento dei dati","reverse.banner":"Benvenuto nella nuova scheda SCC Reverse che fornisce i dettagli sui contenitori inversi. Per saperne di più e guardare un breve corso di formazione, ","reverse.clickhere":"clicca qui.","reverse.heading":"Reverse","reverse.description":"Una panoramica delle confezioni e dei contenitori in fase di lavorazione per partire dalla stazione in senso inverso","reverse.reversePackages":"Pacchetti inversi","reverse.pendingStow":"In attesa di stivaggio","reverse.stowCompliance":"Conformità Stow","reverse.reverseContainers":"Contenitori inversi","reverse.pendingClose":"In attesa di chiusura","reverse.pendingStage":"Fase in sospeso","reverse.pendingDepart":"In attesa di partenza","reverse.closeFailed":"Chiusura non riuscita","reverse.containerScanCompliance":"Conformità alla scansione dei contenitori","reverse.closeSuccess":"Successo ravvicinato","reverse.stageCompliance":"Conformità alla fase","reverse.loadingCompliance":"Conformità di caricamento","reverse.departCompliance":"Partenza dalla conformità","reverse.atRisk":"A rischio","reverse.containerCount":"Numero di contenitori","reverse.visualView":"Vista visiva","reverse.tableView":"Visualizzazione della tabella","reverse.ShipmentType":"Tipo di spedizione","reverse.exportCSV":"Esporta in formato CSV","pendingStowList.reverse":"Reverse","pendingStowList.pendingStowList":"Elenco di stivaggio in sospeso","pendingStowList.trackingId":"ID di tracciamento","pendingStowList.routeCode":"Codice del percorso","pendingStowList.state":"Stato","pendingStowList.reason":"Motivo","pendingStowList.location":"Zona di ordinamento","reverse.CPT":"CPT","reverse.Containers":"Contenitori","reverse.pendingLoading":"Caricamento in sospeso","reverse.departed":"Partita","reverse.isAtRisk":"A rischio","reverse.toggleFullscreen":"Passa a schermo intero","reverse.OpenedAt":"Aperto a","reverse.ContainerID":"ID contenitore","reverse.ResourceLabel":"Etichetta della risorsa","reverse.Opened":"Aperta","reverse.Closed":"Chiuso","reverse.Staged":"Messa in scena","reverse.Loaded":"Caricato","reverse.Departed":"Partita","reverse.Volume":"Volume","reverse.Destination":"Destinazione","reverse.StackingFilter":"Filtro impilabile","cluster.cartsMissing":"Carrelli non aperti"}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports = {"common.stow_buffered":"Stow buffered","common.jackpot_buffered_mfr":"Jackpot buffered (MFR)","aisleOptions.aisle":"通路","associateStatusOptions.yes":"はい","associateStatusOption.no":"いいえ","associateStatusOption.active":"アクティブ","clusterOptions.cluster":"クラスター","cycleOptions.cycle":"サイクル","CPT.":"CPT","CPT.cpt":"CPT","CPT.induct_by":"によって誘導する","CPT.stow_by":"収納","aisle.packages":"パッケージ","aisle.bags":"バッグ","aisle.performance":"パフォーマンス","aisle.stowers":"ストー担当者","aisle.aisle":"通路","aisle.containerPlanned":"予定","aisle.received":"受領済み","aisle.arrived":"敷地内到着","aisle.inducted":"インダクション済み","aisle.stowed":"ストー済み","aisle.planned":"予定","aisle.used":"使用中","aisle.missing":"不足","aisle.unused":"未使用","aisle.stow_rate":"ストーレート","aisle.scan_complaince":"スキャンコンプライアンス","aisle.fsaf":"FSAF","aisle.active":"アクティブ","associate.associate":"アソシエイト","associate.heading":"ストーアソシエイツ","associate.description":"この表は、ストー・アソシエイトのパフォーマンスデータと現在の作業場所を示しています","associate.pph":"PPH","associate.hours":"時","associate.total_pkgs":"パッケージ合計","associate.fsaf":"FSAF","associate.fsaf_dpmo":"FSAF DPMO","associate.active":"アクティブ","associate.lastLocation":"最終場所","associate.inactive_periods":"非アクティブ期間","overview.aisles_at_risk":"Aisles at Risk","tooltip.overview.aisles_at_risk":"Minutes of Work（MoW）が高く、完了リスクのあるアイル","overview.container_planned":"予定","tooltip.overview.container_planned":"ソートプランされたパッケージ数","overview.arrived":"敷地内到着","tooltip.overview.arrived":"到着済み：DSに敷地内到着 + DSから一定の距離内にいる幹線のパッケージ数","overview.inducted":"インダクション済み","tooltip.overview.inducted":"インダクトスキャン後、ストーされていないパッケージ数","overview.stow_rate":"ストーレート","tooltip.overview.stow_rate":"過去15分のストFPH / アクティブなストーアソシエイトの数","overview.stowers":"ストー担当者","tooltip.overview.stowers":"アクティブなストーアソシエイトの数","overview.minutes_of_work":"MoW","tooltip.overview.minutes_of_work":"（インダクトされたパッケージ / ストー FPH）* 60","cluster.packages":"パッケージ","cluster.open_bags":"開封済みバッグ","cluster.performance":"パフォーマンス","cluster.stowers":"ストー担当者","tooltip.cluster.stowers":"# of # of Associates stowing packages from stow buffer to destination sort zone or oversize location","cluster.cluster":"クラスター","cluster.container_planned":"予定","tooltip.cluster.container_planned":"各クラスターごとにソートプランされたパッケージ数","cluster.received":"受領済み","cluster.arrived":"敷地内到着","tooltip.cluster.arrived":"各クラスターごとにDSに敷地内到着 + DSから一定の距離内にいる幹線のパッケージ数","cluster.inducted":"インダクション済み","tooltip.cluster.inducted":"インダクトスキャン後、ストーされていないパッケージ数","cluster.stowed":"ストー済み","cluster.stow_plan":"ストー/予定","tooltip.cluster.stow_plan":"（ストーされた数 / ソートプランされた数） * 100%","cluster.ps":"PS","tooltip.cluster.ps":"各クラスターでソートプランされたパッケージのうち、問題解決が必要のパッケージ","cluster.missing":"不足","cluster.minutes_of_work":"MoW","tooltip.cluster.minutes_of_work":"（インダクトされた数 / クラスターのストーFPH）* 60分","cluster.stow_rate":"ストーレート","tooltip.cluster.stow_rate":"クラスターのストーFPH / アクティブなストーアソシエイト","cluster.scan_compliance":"スキャンコンプライアンス","tooltip.cluster.scan_compliance":"(インダクト済み / ストー済み) * 100で計算されたスキャンコンプライアンス","cluster.active":"アクティブ","tooltip.cluster.active":"クラスターでアクティブなストーアソシエイトの数","cluster.inactive":"非アクティブ","floorLocation.carts":"カート","floorLocation.packages":"パッケージ","floorLocation.performance":"パフォーマンス","floorLocation.stowers":"ストー担当者","floorLocation.floor_location":"場所","floorLocation.re_induct_day":"再インダクト日","floorLocation.inducted":"インダクション済み","floorLocation.stowed":"ストー済み","floorLocation.no_of_carts":"＃カート","floorLocation.stow_rate":"ストーレート","floorLocation.scan_compliance":"スキャンコンプライアンス","floorLocation.active":"アクティブ","floorLocation.inactive":"非アクティブ","cart.floor_location":"場所","cart.reInductDay":"再インダクト日","cart.cart_id":"カート ID","cart.no_of_packages":"パッケージ数","packageList.stow":"ストー","packageList.packageList":"パッケージリスト","packageList.packageSummary":"パッケージサマリー","packageList.trackingId":"追跡ID","packageList.lastScan":"最終スキャン","packageList.minute_in_state":"状態経過時間(分)","packageList.state":"状態","packageList.reason":"理由","packageList.location":"場所","packageList.associate_id":"アソシエイトID","packageList.cycle":"サイクル","packageList.sortZone":"ソートゾーン","packageList.cluster":"クラスター","packageList.ead":"EAD","packageList.size":"サイズ","packageList.routeCode":"ルートコード","sortZone.bags":"バッグ","sortZone.ov_capacity":"OVキャパシティ","sortZone.packages":"パッケージ","sortZone.zone":"ゾーン","sortZone.planned":"予定","sortZone.closed":"クローズ済み","sortZone.open":"オープン","sortZone.used":"使用中","sortZone.container_planned":"予定","sortZone.received":"受領済み","sortZone.arrived":"敷地内到着","sortZone.inducted":"インダクション済み","sortZone.stowed":"ストー済み","stow.error":"エラーが発生しました","stow.close":"閉じる","stow.download_sort_location_plan":"ダウンロード-並べ替え-場所-プラン","options.clear_all":"すべてクリア","heatMap.heading":"ストー","heatMap.description":"この表は、ストープロセスにおけるコンテナとパッケージのクラスターとステータスを示しています","common.data_last_updated":"データが最終更新されました","reverse.banner":"リバースコンテナに関する詳細を提供する新しい SCC リバースタブへようこそ。詳細を確認したり、簡単なトレーニングを視聴したりするには、","reverse.clickhere":"ここをクリック。","reverse.heading":"リバース","reverse.description":"ステーションから逆に出荷するように処理されているパッケージやコンテナの概要","reverse.reversePackages":"リバースパッケージ","reverse.pendingStow":"保留中のストウ","reverse.stowCompliance":"ストウ・コンプライアンス","reverse.reverseContainers":"リバースコンテナ","reverse.pendingClose":"クローズ保留中","reverse.pendingStage":"保留中のステージ","reverse.pendingDepart":"出発待ち","reverse.closeFailed":"閉じることができませんでした","reverse.containerScanCompliance":"コンテナスキャンコンプライアンス","reverse.closeSuccess":"クローズ・サクセス","reverse.stageCompliance":"ステージコンプライアンス","reverse.loadingCompliance":"ロードコンプライアンス","reverse.departCompliance":"デパート・コンプライアンス","reverse.atRisk":"危険にさらされている","reverse.containerCount":"コンテナ数","reverse.visualView":"ビジュアルビュー","reverse.tableView":"テーブルビュー","reverse.ShipmentType":"配送タイプ","reverse.exportCSV":"CSV にエクスポート","pendingStowList.reverse":"リバース","pendingStowList.pendingStowList":"保留中の積み込みリスト","pendingStowList.trackingId":"トラッキング ID","pendingStowList.routeCode":"ルートコード","pendingStowList.state":"状態","pendingStowList.reason":"理由","pendingStowList.location":"ソートゾーン","reverse.CPT":"CPT","reverse.Containers":"コンテナ","reverse.pendingLoading":"読み込み待ち","reverse.departed":"出発しました","reverse.isAtRisk":"危険にさらされている","reverse.toggleFullscreen":"全画面切り替え","reverse.OpenedAt":"オープン日時","reverse.ContainerID":"コンテナ ID","reverse.ResourceLabel":"リソースラベル","reverse.Opened":"開きました","reverse.Closed":"閉まっている","reverse.Staged":"上演","reverse.Loaded":"ロード済み","reverse.Departed":"出発しました","reverse.Volume":"ボリューム","reverse.Destination":"目的地","reverse.StackingFilter":"スタッキングフィルター","cluster.cartsMissing":"未開封のカート"}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports = {"common.stow_buffered":"Stow buffered","common.jackpot_buffered_mfr":"Jackpot buffered (MFR)","aisleOptions.aisle":"Gang","associateStatusOptions.yes":"Ja","associateStatusOption.no":"Nein","associateStatusOption.active":"Aktiv","clusterOptions.cluster":"Cluster","cycleOptions.cycle":"Zyklus","CPT.":"CPT","CPT.cpt":"CPT","CPT.induct_by":"Einleiten von","CPT.stow_by":"Verstauen","aisle.packages":"Pakete","aisle.bags":"Säcke","aisle.performance":"Leistung","aisle.stowers":"Stower","aisle.aisle":"Gang","aisle.containerPlanned":"C. geplant","aisle.received":"Empfangen","aisle.arrived":"Eingetroffen","aisle.inducted":"Eingeführt","aisle.stowed":"Abgelegt","aisle.planned":"Geplant","aisle.used":"Verwendet","aisle.missing":"Fehlt","aisle.unused":"Unbenutzt","aisle.stow_rate":"Ablagerate","aisle.scan_complaince":"Scan-Comp.","aisle.fsaf":"FSAF","aisle.active":"Aktiv","associate.associate":"Mitarbeiter","associate.heading":"Mitarbeiter verstauen","associate.description":"Diese Tabelle zeigt die Leistungsdaten von Stow Associates und den aktuellen Arbeitsort","associate.pph":"PPH","associate.hours":"Stunden","associate.total_pkgs":"Pakete ges.","associate.fsaf":"FSAF","associate.fsaf_dpmo":"FSAF DPMO","associate.active":"Aktiv","associate.lastLocation":"Letzter Ort","associate.inactive_periods":"Inaktive Perioden","overview.aisles_at_risk":"Aisles at Risk","tooltip.overview.aisles_at_risk":"Gänge, die den oberen Schwellenwert für Arbeitsminuten (MoW) überschritten haben","overview.container_planned":"C. geplant","tooltip.overview.container_planned":"Gesamtzahl der zu einem Cluster geplanten Containerpakete","overview.arrived":"Eingetroffen","tooltip.overview.arrived":"Angekommen: Gesamtvolumen, das virtuell an einen Anhänger angehängt ist und in den Geofence der Station gelangt ist","overview.inducted":"Eingeführt","tooltip.overview.inducted":"Pakete innerhalb eines Clusters, die eingeführt wurden, aber noch nicht verstaut sind.","overview.stow_rate":"Ablagerate","tooltip.overview.stow_rate":"Stow FPH der letzten 15 Minuten / Anzahl der aktiven Stower innerhalb eines Clusters","overview.stowers":"Stowers","tooltip.overview.stowers":"# Anzahl der Associates, die Pakete aus dem Staupuffer in die Zielsortierzone oder an den Ort der Übergröße stauen","overview.minutes_of_work":"MoW","tooltip.overview.minutes_of_work":"(Gesamtzahl der eingeführten Pakete / Stow FPH) * 60","cluster.packages":"Pakete","cluster.open_bags":"Geöffnete Säcke","cluster.performance":"Leistung","cluster.stowers":"Stower","tooltip.cluster.stowers":"# Anzahl der Associates, die Pakete aus dem Staupuffer in die Zielsortierzone oder an den Ort der Übergröße stauen","cluster.cluster":"Cluster","cluster.container_planned":"C. geplant","tooltip.cluster.container_planned":"Pakete, die als Container für den jeweiligen Cluster geplant sind","cluster.received":"Empfangen","cluster.arrived":"Eingetroffen","tooltip.cluster.arrived":"Angekommen: Gesamtvolumen innerhalb des jeweiligen Clusters, das virtuell an einen Trailer angehängt ist und den Geofence der Station erreicht hat","cluster.inducted":"Eingeführt","tooltip.cluster.inducted":"Pakete innerhalb eines Clusters, die eingeführt wurden, aber noch nicht verstaut sind.","cluster.stowed":"Abgelegt","cluster.stow_plan":"Ablage / Plan","tooltip.cluster.stow_plan":"(Verstautes Volumen / Geplantes Gesamtvolumen der Container) * 100%","cluster.ps":"PS","tooltip.cluster.ps":"Problemlösungspakete Container geplant zum jeweiligen Cluster","cluster.missing":"Fehlt","cluster.minutes_of_work":"Min of Work","tooltip.cluster.minutes_of_work":"(Eingeführtes Volumen / Cluster Stow FPH) * 60 min","cluster.stow_rate":"Ablagerate","tooltip.cluster.stow_rate":"Cluster Stow FPH / Aktive Stowers","cluster.scan_complaince":"Scan-Comp.","tooltip.cluster.scan_compliance":"Scan Compliance pro Cluster berechnet als (Eingeführtes / Verstautes Volumen) * 100","cluster.active":"Aktiv","tooltip.cluster.active":"Aktive Stowers innerhalb des Clusters in Echtzeit","cluster.inactive":"Inaktiv","floorLocation.carts":"Karts","floorLocation.packages":"Pakete","floorLocation.performance":"Leistung","floorLocation.stowers":"Stower","floorLocation.floor_location":"Abstellort","floorLocation.re_induct_day":"Induct Wiederholung","floorLocation.inducted":"Eingeführt","floorLocation.stowed":"Abgelegt","floorLocation.no_of_carts":"Anzahl von Karts","floorLocation.stow_rate":"Ablagerate","floorLocation.scan_compliance":"Scan-Comp.","floorLocation.active":"Aktiv","floorLocation.inactive":"Inaktiv","cart.floor_location":"Abstellort","cart.reInductDay":"Induct Wiederholung","cart.cart_id":"Warenkorb-ID","cart.no_of_packages":"Anzahl der Pakete","packageList.stow":"Ablegen","packageList.packageList":"Paketliste","packageList.packageSummary":"Paketübersicht","packageList.trackingId":"Verfolgungsnummer","packageList.lastScan":"Letzter Scan","packageList.minute_in_state":"Minuten in Zustand","packageList.state":"Zustand","packageList.reason":"Grund","packageList.location":"Ort","packageList.associate_id":"Mitarbeiternummer","packageList.cycle":"Zyklus","packageList.sortZone":"Sortierbereich","packageList.cluster":"Cluster","packageList.ead":"EAD","packageList.size":"Größe","packageList.routeCode":"Streckencode","sortZone.bags":"Säcke","sortZone.ov_capacity":"OV-Kapazität","sortZone.packages":"Pakete","sortZone.zone":"Bereich","sortZone.planned":"Geplant","sortZone.closed":"Geschlossen","sortZone.open":"Offen","sortZone.used":"Verwendet","sortZone.container_planned":"C. geplant","sortZone.received":"Empfangen","sortZone.arrived":"Eingetroffen","sortZone.inducted":"Eingeführt","sortZone.stowed":"Abgelegt","stow.error":"Es ist ein Fehler aufgetreten","stow.close":"Schließen","stow.download_sort_location_plan":"Download-Sort-Lageplan","options.clear_all":"Alles löschen","heatMap.heading":"Verstauen","heatMap.description":"Diese Tabelle zeigt die Cluster und den Status von Containern und Paketen im Stow-Prozess","common.data_last_updated":"Daten wurden zuletzt aktualisiert","reverse.banner":"Willkommen auf der neuen Registerkarte SCC Reverse, die Details zu Reverse-Containern enthält. Um mehr zu erfahren und sich ein kurzes Training anzusehen, ","reverse.clickhere":"hier klicken.","reverse.heading":"Umkehren","reverse.description":"Eine Übersicht über Pakete und Behälter, die verarbeitet werden, um die Station in umgekehrter Reihenfolge zu verlassen","reverse.reversePackages":"Pakete umkehren","reverse.pendingStow":"Ausstehendes Verstauen","reverse.stowCompliance":"Einhaltung von Vorschriften verstauen","reverse.reverseContainers":"Inverted containers","reverse.pendingClose":"Ausstehender Abschluss","reverse.pendingStage":"Ausstehende Phase","reverse.pendingDepart":"Ausstehende Abreise","reverse.closeFailed":"Schließen ist fehlgeschlagen","reverse.containerScanCompliance":"Konformität mit Containerscans","reverse.closeSuccess":"Knapper Erfolg","reverse.stageCompliance":"Einhaltung der Etappen","reverse.loadingCompliance":"Konformität wird geladen","reverse.departCompliance":"Verlassen Sie die Compliance-Abteilung","reverse.atRisk":"In Gefahr","reverse.containerCount":"Anzahl der Behälter","reverse.visualView":"Visuelle Ansicht","reverse.tableView":"Ansicht der Tabelle","reverse.ShipmentType":"Art der Lieferung","reverse.exportCSV":"Nach CSV exportieren","pendingStowList.reverse":"Umkehren","pendingStowList.pendingStowList":"Ausstehende Stow-Liste","pendingStowList.trackingId":"Tracking Id","pendingStowList.routeCode":"Routencode","pendingStowList.state":"State","pendingStowList.reason":"Grund","pendingStowList.location":"Zone sortieren","reverse.CPT":"CPT","reverse.Containers":"Behältnisse","reverse.pendingLoading":"Ausstehender Ladevorgang","reverse.departed":"Abgereist","reverse.isAtRisk":"In Gefahr","reverse.toggleFullscreen":"Vollbild umschalten","reverse.OpenedAt":"Geöffnet am","reverse.ContainerID":"Container-ID","reverse.ResourceLabel":"Bezeichnung der Ressource","reverse.Opened":"Eröffnet","reverse.Closed":"Geschlossen","reverse.Staged":"Inszeniert","reverse.Loaded":"Geladen","reverse.Departed":"Abgereist","reverse.Volume":"Volumen","reverse.Destination":"Reiseziel","reverse.StackingFilter":"Stapelfilter","cluster.cartsMissing":"Ungeöffnete Warenkörbe"}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports = {"common.stow_buffered":"Stow buffered","common.jackpot_buffered_mfr":"Jackpot buffered (MFR)","aisleOptions.aisle":"الممر","associateStatusOptions.yes":"نعم","associateStatusOption.no":"لا","associateStatusOption.active":"فعّال","clusterOptions.cluster":"مجموعة الشحنات","CPT.":"CPT","CPT.cpt":"CPT","CPT.induct_by":"استقراء بواسطة","CPT.stow_by":"ستو باي","cycleOptions.cycle":"الدورة","aisle.packages":"الشحنات","aisle.bags":"الحقائب","aisle.performance":"الأداء","aisle.stowers":"موظفو الترتيب","aisle.aisle":"الممر","aisle.containerPlanned":"الشحنات المخطط لها في الحاوية","aisle.received":"المستلمة","aisle.arrived":"التي وصلت","aisle.inducted":"الممسوحة ضوئياً","aisle.stowed":"المرتبة على الرف","aisle.planned":"المخطط لها","aisle.used":"المستعملة","aisle.missing":"المفقودة","aisle.unused":"غير مستعمل","aisle.stow_rate":"FPHللشحنات التي يتم ترتيبها على الرف ","aisle.scan_complaince":"النسبة المئوية للشحنات الممسوحة ضوئياً","aisle.fsaf":"FSAF","aisle.active":"فعّال","associate.associates":"الموظفون","associate.heading":"شركاء ستو","associate.description":"يعرض هذا الجدول بيانات أداء المقترعين وموقع العمل الحالي","associate.associate":"الموظف","associate.pph":"PPH","associate.hours":"الساعات","associate.total_pkgs":"مجموع الشحنات","associate.fsaf":"FSAF","associate.fsaf_dpmo":"FSAF DPMO","associate.active":"فعّال","associate.lastLocation":"آخر موقع","associate.inactive_periods":"الفترات غير الفعالة","cluster.packages":"الشحنات","cluster.open_bags":"عربات التحميل المفتوحة","cluster.performance":"الأداء","cluster.stowers":"موظفو الترتيب","cluster.cluster":"مجموعة الشحنات","cluster.container_planned":"المخطط لها في الحاوية","cluster.received":"المستلمة","cluster.arrived":"التي وصلت","cluster.inducted":"الممسوحة ضوئياً","cluster.stowed":"المرتبة على الرف","cluster.stow_plan":"ترتيب / تخطيط","cluster.ps":"حل المشكلة","cluster.missing":"المفقودة","cluster.stow_rate":"FPHللشحنات التي يتم ترتيبها على الرف ","cluster.scan_complaince":"النسبة المئوية للشحنات الممسوحة ضوئياً","cluster.active":"فعّال","cluster.inactive":"غير فعّال","floorLocation.carts":"عربات","floorLocation.packages":"الشحنات","floorLocation.performance":"الأداء","floorLocation.stowers":"موظفو الترتيب","floorLocation.floor_location":"موقع الطابق","floorLocation.re_induct_day":"يوم إعادة الإدخال","floorLocation.inducted":"الممسوحة ضوئياً","floorLocation.stowed":"المرتبة على الرف","floorLocation.no_of_carts":"عدد العربات","floorLocation.stow_rate":"FPHللشحنات التي يتم ترتيبها على الرف ","floorLocation.scan_compliance":"النسبة المئوية للشحنات الممسوحة ضوئياً","floorLocation.active":"فعّال","floorLocation.inactive":"غير فعّال","cart.floor_location":"موقع الطابق","cart.reInductDay":"يوم إعادة الإدخال","cart.cart_id":"معرف عربة التسوق","cart.no_of_packages":"عدد الباقات","packageList.stow":"ترتيب الشحنات على الرف","packageList.packageList":"قائمة الشحنة","packageList.packageSummary":"ملخص الشحنة","packageList.trackingId":"رقم التتبع","packageList.lastScan":"آخر مسح ضوئي","packageList.minute_in_state":"مدة نفس الحالة","packageList.state":"الحالة","packageList.reason":"السبب","packageList.location":"الموقع","packageList.associate_id":"رقم الموظف","packageList.cycle":"الدورة","packageList.sortZone":"منطقة الفرز","packageList.cluster":"مجموعة الشحنات","packageList.ead":"تاريخ الوصول المتوقع","packageList.size":"الحجم","packageList.routeCode":"رمز المسار","sortZone.bags":"الحقائب","sortZone.ov_capacity":"سعة OV","sortZone.packages":"الشحنات","sortZone.zone":"المنطقة","sortZone.planned":"المخطط لها","sortZone.open":"المفتوحة","sortZone.used":"المستعملة","sortZone.container_planned":"المخطط لها في الحاوية","sortZone.received":"المستلمة","sortZone.arrived":"التي وصلت","sortZone.inducted":"الممسوحة ضوئياً","sortZone.stowed":"المرتبة على الرف","stow.error":"حدثت بعض الأخطاء","stow.close":"يغلق","stow.download_sort_location_plan":"تنزيل مخطط ترتيب الموقع","options.options":"الخيارات","heatMapViewOptions.routeView":"المسار","heatMapViewOptions.clusterView":"مجموعة مناطق الاستلام","heatMap.heading":"ستو","heatMap.description":"يوضح هذا الجدول مجموعات وحالات الحاويات والحزم في عملية التخزين","options.clear_all":"مسح الكل","common.data_last_updated":"آخر تحديث للبيانات","reverse.banner":"مرحبًا بك في علامة تبويب SCC Reverse الجديدة التي توفر تفاصيل حول الحاويات العكسية. لمعرفة المزيد ومشاهدة تدريب قصير، ","reverse.clickhere":"انقر هنا.","reverse.heading":"عكس","reverse.description":"نظرة عامة على الطرود والحاويات التي تتم معالجتها للمغادرة من المحطة في الاتجاه المعاكس","reverse.reversePackages":"الحزم العكسية","reverse.pendingStow":"التخزين المعلق","reverse.stowCompliance":"التوافق مع التخزين","reverse.reverseContainers":"حاويات عكسية","reverse.pendingClose":"في انتظار الإغلاق","reverse.pendingStage":"مرحلة الانتظار","reverse.pendingDepart":"في انتظار المغادرة","reverse.closeFailed":"فشل الإغلاق","reverse.containerScanCompliance":"الامتثال لفحص الحاويات","reverse.closeSuccess":"إغلاق النجاح","reverse.stageCompliance":"الامتثال للمرحلة","reverse.loadingCompliance":"الامتثال جاري التحميل","reverse.departCompliance":"الامتثال تغادر","reverse.atRisk":"في خطر","reverse.containerCount":"عدد الحاويات","reverse.visualView":"عرض مرئي","reverse.tableView":"عرض الجدول","reverse.ShipmentType":"نوع الشحنة","reverse.exportCSV":"تصدير إلى CSV","pendingStowList.reverse":"عكس","pendingStowList.pendingStowList":"قائمة التخزين المعلقة","pendingStowList.trackingId":"معرف التتبع","pendingStowList.routeCode":"رمز المسار","pendingStowList.state":"حالة","pendingStowList.reason":"السبب","pendingStowList.location":"منطقة الفرز","reverse.CPT":"CPT","reverse.Containers":"حاويات","reverse.pendingLoading":"في انتظار التحميل","reverse.departed":"غادروا","reverse.isAtRisk":"في خطر","reverse.toggleFullscreen":"تبديل ملء الشاشة","reverse.OpenedAt":"تم افتتاحه في","reverse.ContainerID":"معرف الحاوية","reverse.ResourceLabel":"تسمية الموارد","reverse.Opened":"تم افتتاحه","reverse.Closed":"مغلق","reverse.Staged":"نظم","reverse.Loaded":"تم تحميله","reverse.Departed":"غادروا","reverse.Volume":"مستوى الصوت","reverse.Destination":"الوجهة","reverse.StackingFilter":"مرشح التكديس","cluster.cartsMissing":"عربات غير مفتوحة"}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports = {"common.stow_buffered":"Tampon bölgeye alınmış istif","common.jackpot_buffered_mfr":"Birikim alanı tamponlu (MFR)","aisleOptions.aisle":"Koridor","associateStatusOptions.yes":"Evet","associateStatusOption.no":"Hayır","associateStatusOption.active":"Aktif","clusterOptions.cluster":"Küme","cycleOptions.cycle":"Döngü","zoneOptions.zone":"Bölge","floorOptions.cartLocation":"Sepet Konumu","CPT.":"CPT","CPT.cpt":"CPT","CPT.induct_by":"İşlem yapan","CPT.stow_by":"İstifleme kriteri","aisle.packages":"Paketler","aisle.bags":"Çantalar","aisle.performance":"Performans","aisle.stowers":"İstifleyiciler","aisle.aisle":"Koridor","aisle.containerPlanned":"C. Planlanan","aisle.received":"Alındı","aisle.arrived":"Ulaştı","aisle.inducted":"Başlatıldı","aisle.stowed":"İstiflendi","aisle.planned":"Planlanan","aisle.used":"Kullanılmış","aisle.missing":"Eksik","aisle.unused":"Kullanılmayan","aisle.stow_rate":"İstifleme oranı","aisle.scan_complaince":"Uyumluluğu tarayın.","aisle.fsaf":"FSAF","aisle.active":"Aktif","associate.associates":"Çalışanlar","associate.heading":"İstifleme çalışanları","associate.description":"Bu tablo, istifleme ortaklarının performans verilerini ve mevcut çalışma konumunu gösterir","associate.associate":"Çalışan","associate.pph":"PPH","associate.hours":"Saat","associate.total_pkgs":"Toplam Paket","associate.fsaf":"FSAF","associate.fsaf_dpmo":"FSAF DPMO","associate.active":"Aktif","associate.lastLocation":"Son Konum","associate.inactive_periods":"Etkin olmayan dönemler","overview.aisles_at_risk":"Risk Altındaki Koridorlar","tooltip.overview.aisles_at_risk":"Üst Çalışma Tutanakları (MoW) eşiklerini ihlal eden koridorlar","overview.container_planned":"C. Planlanan","tooltip.overview.container_planned":"Bir kümeye planlanan toplam paket konteyner sayısı","overview.arrived":"Ulaştı","tooltip.overview.arrived":"Geldi: Bir römorka sanal olarak bağlanan ve istasyonun coğrafi çitine giren toplam hacim","overview.inducted":"İndüklenen","tooltip.overview.inducted":"Başvurulan ancak henüz istiflenmemiş bir küme içindeki nakliyeler","overview.stow_rate":"İstifleme Oranı","tooltip.overview.stow_rate":"Son 15 dakika İstifleme FPH/Küme İçindeki Aktif İstifleyicilerin Miktarı","overview.stowers":"İstifleyiciler","tooltip.overview.stowers":"Paketleri istifleme tampon alanından hedef sıralama bölgesine veya büyük boyutlu konuma istifleyen çalışanların sayısı","overview.minutes_of_work":"Çalışma Süresi","tooltip.overview.minutes_of_work":"(İşlenen toplam paket sayısı/FPH İstifleme) * 60","overview.adjacency_score":"İstiflemeye Uyma","tooltip.overview.adjacency_score":"Taşınan raf birimlerinin sayısı/istiflenen paket sayısı","cluster.packages":"Paketler","cluster.open_bags":"Açık torbalar","cluster.performance":"Performans","cluster.stowers":"İstifleyiciler","tooltip.cluster.stowers":"Paketleri istifleme tampon alanından hedef sıralama bölgesine veya büyük boyutlu konuma istifleyen çalışanların sayısı","cluster.cluster":"Küme","cluster.container_planned":"C. Planlanan","tooltip.cluster.container_planned":"Her bir küme için planlanan konteyner paketleri","cluster.received":"Alındı","cluster.arrived":"Ulaştı","tooltip.cluster.arrived":"Geldi: Bir römorka sanal olarak bağlanan ve istasyonun coğrafi çitine giren ilgili bir küme içindeki toplam hacim","cluster.inducted":"İndüklenen","tooltip.cluster.inducted":"Başvurulan ancak henüz istiflenmemiş bir küme içindeki nakliyeler.","cluster.stowed":"İstiflendi","cluster.stow_plan":"İstifleme / Planlama","tooltip.cluster.stow_plan":"(İstiflenmiş Hacim/Toplam Konteyner Planlanan Hacim) * %100","cluster.ps":"NOT","tooltip.cluster.ps":"İlgili kümeye planlanan Sorun Çözme paketleri konteyneri","cluster.missing":"Açılmamış Çantalar","cluster.cartsMissing":"Açılmamış Sepetler","cluster.minutes_of_work":"Çalışma Süresi","tooltip.cluster.minutes_of_work":"(İşlenen Hacim/Küme İstifleme FPH) * 60 dk","cluster.stow_rate":"İstifleme oranı","tooltip.cluster.stow_rate":"Küme İstifleme FPH / Aktif İstifleyiciler","cluster.scan_compliance":"Uyumluluğu tarayın.","tooltip.cluster.scan_compliance":"Küme başına Tarama Uyumluluğu (İşlenmiş/İstiflenmiş Hacim) * 100 olarak hesaplanır","cluster.active":"Aktif","tooltip.cluster.active":"Küme içindeki gerçek zamanlı aktif istifleyiciler","cluster.inactive":"Pasif","floorLocation.carts":"Arabalar","floorLocation.packages":"Paketler","floorLocation.performance":"Performans","floorLocation.stowers":"İstifleyiciler","floorLocation.floor_location":"Kat Konumu","floorLocation.re_induct_day":"Günü Yeniden İşle","floorLocation.ofd":"OFD","floorLocation.inducted":"Başlatılan","floorLocation.stowed":"İstiflendi","floorLocation.no_of_carts":"Sepetlerin Sayısı","floorLocation.stow_rate":"İstifleme oranı","floorLocation.scan_compliance":"Uyumluluğu tarayın.","floorLocation.active":"Aktif","floorLocation.inactive":"Pasif","cart.floor_location":"Kat Konumu","cart.reInductDay":"Günü Yeniden İşle","cart.ofd":"OFD","cart.cart_id":"Sepet ID’si","cart.no_of_packages":"Paket Sayısı","packageList.stow":"İstifle","packageList.packageList":"Paket Listesi","packageList.packageSummary":"Paket özeti","packageList.trackingId":"Takip numarası","packageList.lastScan":"Son tarama","packageList.minute_in_state":"Durumdaki dakika miktarı","packageList.state":"Durum","packageList.reason":"Neden","packageList.location":"Konum","packageList.associate_id":"Çalışan ID’si","packageList.cycle":"Döngü","packageList.sortZone":"Sıralama bölgesi","packageList.cluster":"Küme","packageList.ead":"Tahmini Varış Tarihi","packageList.size":"Boyut","packageList.routeCode":"Rota Kodu","packageList.station_pair":"İstasyon","sortZone.bags":"Çantalar","sortZone.ov_capacity":"OV Kapasitesi","sortZone.packages":"Paketler","sortZone.zone":"Bölge","sortZone.planned":"Planlanan","sortZone.closed":"Kapalı","sortZone.open":"Aç","sortZone.used":"Kullanılmış","sortZone.container_planned":"C. Planlanan","sortZone.received":"Alındı","sortZone.arrived":"Ulaştı","sortZone.inducted":"Başlatıldı","sortZone.stowed":"İstiflendi","stationPair.station_pair":"İstasyon","stow.error":"Bir hata oluştu","stow.close":"Kapat","stow.download_sort_location_plan":"İndir-sırala-konum-planı","options.options":"Seçenekler","options.clear_all":"Tümünü temizle","heatMapViewOptions.routeView":"Rota","heatMapViewOptions.clusterView":"Küme","heatMapViewOptions.stationPairView":"İstasyon","heatMap.heading":"İstifle","heatMap.description":"Bu tablo, istifleme işlemindeki konteynerlerin ve paketlerin kümelerini ve durumlarını göstermektedir","common.data_last_updated":"Veriler son güncellendi","reverse.banner":"Ters konteynerlerle ilgili ayrıntıları sağlayan yeni SCC Reverse sekmesine hoş geldiniz. Daha fazla bilgi edinmek ve kısa bir eğitim izlemek için, ","reverse.clickhere":"Buraya Tıklayın.","reverse.heading":"Ters","reverse.description":"İstasyondan tersine çıkış için işlenen paketlere ve konteynerlere genel bakış","reverse.reversePackages":"Ters Paketler","reverse.pendingStow":"İstifleme beklemede","reverse.stowCompliance":"İstifleme Uyumluluğu","reverse.reverseContainers":"Ters Konteynerler","reverse.pendingClose":"Kapanmayı Bekliyor","reverse.pendingStage":"Hazırlama Bekleniyor","reverse.pendingDepart":"Çıkışı Bekleyen","reverse.closeFailed":"Kapatma Başarısız","reverse.containerScanCompliance":"Konteyner Tarama Uyumluluğu","reverse.closeSuccess":"Kapatma Başarılı","reverse.stageCompliance":"Aşama Uyumluluğu","reverse.loadingCompliance":"Yükleme Uyumluluğu","reverse.departCompliance":"Çıkış Uyumluluğu","reverse.atRisk":"Risk altında","reverse.containerCount":"Konteyner Sayımı","reverse.visualView":"Görsel görünüm","reverse.tableView":"Tablo görünümü","reverse.ShipmentType":"Kargo Türü","reverse.exportCSV":"CSV’ye dışa aktar","pendingStowList.reverse":"Ters","pendingStowList.pendingStowList":"Bekleyen İstifleme Listesi","pendingStowList.trackingId":"Takip numarası","pendingStowList.routeCode":"Rota Kodu","pendingStowList.state":"Durum","pendingStowList.reason":"Neden","pendingStowList.location":"Sıralama bölgesi","reverse.CPT":"CPT","reverse.Containers":"Konteynerler","reverse.pendingLoading":"Yükleme Beklemede","reverse.departed":"Ayrıldı","reverse.isAtRisk":"Riskli","reverse.toggleFullscreen":"Tam ekranı aç/kapat","reverse.OpenedAt":"Açıldı","reverse.ContainerID":"Konteyner kimliği","reverse.ResourceLabel":"Kaynak Etiketi","reverse.Opened":"Açıldı","reverse.Closed":"Kapalı","reverse.Staged":"Hazırlanmış","reverse.Loaded":"Yüklendi","reverse.Departed":"Ayrıldı","reverse.Volume":"Hacim","reverse.Destination":"Hedef","reverse.StackingFilter":"StackingFilter"}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconHelpKnockoutData: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3e%3cpath d='M8 0a8 8 0 108 8 8 8 0 00-8-8zm0 14a1 1 0 111-1 1 1 0 01-1 1zm0-3.78a1 1 0 110-2A2.11 2.11 0 106 5.4a1 1 0 01-1.89-.67A4.11 4.11 0 118 10.22z' fill='currentColor'/%3e%3c/svg%3e",
  iconHelpKnockoutWidth: 16,
  iconHelpKnockoutHeight: 16
};

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _text = _interopRequireDefault(__webpack_require__(45));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

var Heading = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement(_text["default"], (0, _extends2["default"])({
    type: props.type ? props.type : "h".concat(7 - props.level, "00"),
    tag: "h".concat(props.level),
    id: props.id,
    color: props.color,
    alignment: props.alignment,
    transform: props.transform,
    truncate: props.truncate,
    fontFamily: props.fontFamily,
    className: props.className,
    tabIndex: props.tabIndex,
    ref: ref
  }, passThroughProps), props.children);
});

Heading.displayName = "Heading";
Heading.propTypes =  false ? {
  /**
   * The heading text.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The heading level. This corresponds directly to the [6 HTML headings](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Heading_Elements).
   */
  level: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]).isRequired,

  /**
   * The text alignment of the heading.
   */
  alignment: _propTypes["default"].oneOf(["left", "start", "center", "right", "end", "justify"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * The color of the heading's text. See the [Color Fundamentals page](https://meridian.a2z.com/fundamentals/color/?platform=react-web)
   * for information on the correct usage of these colors.
   */
  color: _propTypes["default"].oneOf(["primary", "secondary"]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.18.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * The font family of the heading's text. This is an advanced feature, and
   * generally should not be changed.
   *
   * Note that you must manually load the necessary web fonts before using this
   * prop.
   */
  fontFamily: _propTypes["default"].oneOf(["amazonEmber", "amazonEmberDisplay", "amazonEmberMonospace", "bookerly", "bookerlyDisplay"]),

  /**
   * Sets an `id` attribute on the component's DOM element.
   *
   * Use this for testing, for accessibility, or to target custom elements
   * inside the component. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * Setting tabIndex to "-1" allows the Heading to be programmatically focused
   * without adding it to the tab order. Programmatically focusing is useful
   * when, for instance, a user presses an anchor link and expects to scroll
   * and focus on particular content.
   *
   * @since 5.23.0
   */
  tabIndex: _propTypes["default"].oneOf(["-1"]),

  /**
   * Use this to apply a [CSS text transform](https://developer.mozilla.org/en-US/docs/Web/CSS/text-transform)
   * to the heading.
   */
  transform: _propTypes["default"].oneOf(["none", "capitalize", "uppercase", "lowercase"]),

  /**
   * Set this to true to truncate the text to a single line using ellipsis. If
   * the text already fits on a single line no truncation will be applied. This
   * relies on the CSS text-overflow property, refer to [the text-overflow documentation](https://developer.mozilla.org/en-US/docs/Web/CSS/text-overflow)
   * for details.
   */
  truncate: _propTypes["default"].bool,

  /**
   * This determines which entry from [Meridian's type scale](https://meridian.a2z.com/fundamentals/typography/?platform=reactjs&detailsTab=type-scale)
   * is used to render the heading text.
   */
  type: _propTypes["default"].oneOf(["d300", "d200", "d100", "d50", "h600", "h500", "h400", "h300", "h200", "h100", "b500", "b400", "b300", "b200", "b100"])
} : {};
var _default = Heading;
exports["default"] = _default;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _text = _interopRequireDefault(__webpack_require__(134));

var _getTextStyles = _interopRequireDefault(__webpack_require__(245));

var _theme = __webpack_require__(14);

var _cxMemoized = _interopRequireDefault(__webpack_require__(76));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * This component can be used to apply Meridian text styles to the UI. Text
 * styles will cascade to descendant Text, Heading, and Link components as well
 * as native HTML elements, but not to other Meridian components that define
 * their own text styles.
 */
var Text = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var children = props.children;
  var t = (0, _theme.useTheme)(_text["default"], "text");
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement(props.tag, _objectSpread(_objectSpread({}, passThroughProps), {}, {
    id: props.id,
    className: (0, _cxMemoized["default"])((0, _getTextStyles["default"])(t, props), props.className),
    tabIndex: props.tabIndex,
    title: props.title === undefined && props.truncate && typeof children === "string" ? children : props.title,
    "mdn-text": "",
    ref: ref,
    role: props.role,
    htmlFor: props.htmlFor
  }), children);
});

Text.displayName = "Text";
Text.propTypes =  false ? {
  /**
   * The text.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The alignment of the text.
   */
  alignment: _propTypes["default"].oneOf(["left", "start", "center", "right", "end", "justify"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set this to true to allow the browser to break text at any arbitrary
   * location - even in the middle of a word. This can be helpful when rendering
   * very long strings without natural breakpoints like spaces or hyphens. This
   * can also cause awkward breaks in text, so use sparingly. See the
   * "break-word" value of the [CSS overflow-wrap property](https://developer.mozilla.org/en-US/docs/Web/CSS/overflow-wrap)
   * for details.
   *
   * @since 5.x
   */
  breakWord: _propTypes["default"].bool,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * The color of the text. See the [Color Fundamentals page](https://meridian.a2z.com/fundamentals/color/?platform=react-web)
   * for information on the correct usage of these colors.
   */
  color: _propTypes["default"].oneOf(["primary", "secondary", "error", "inverted"]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * The font family of the heading's text. This is an advanced feature, and
   * generally should not be changed.
   *
   * Note that you must manually load the necessary web fonts before using this
   * prop.
   */
  fontFamily: _propTypes["default"].oneOf(["amazonEmber", "amazonEmberArabic", "amazonEmberDisplay", "amazonEmberMonospace", "bookerly", "bookerlyDisplay"]),

  /**
   * Sets the `for` attribute on the component's element. This is useful when
   * associating a label with an input.
   *
   * See docs to learn more about the [for attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/label#attr-for).
   * We use `htmlFor` to match [React's standard](https://reactjs.org/docs/dom-elements.html#htmlfor).
   *
   * ```
   * <Column>
   *   <Text tag="label" htmlFor="my-input">
   *     Phone number
   *   </Text>
   *   <Input id="my-input" value={value} onChange={setValue} />
   * </Column>
   * ```
   *
   * @since 5.x
   */
  htmlFor: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component's element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * Sets the list-style for digits in an ordered list.
   *
   * Use this to set digits for a locale.
   * See [list style types](https://www.w3.org/International/tests/html-css/list-style-type/results-list-style-type) for more information.
   */
  listStyle: _propTypes["default"].string,

  /**
   * An accessible ARIA role for the component.
   *
   * See docs for the [role attribute](https://www.w3.org/TR/wai-aria-1.0/roles)
   * for details on appropriate usage.
   *
   * @since 5.x
   */
  role: _propTypes["default"].string,

  /**
   * Setting tabIndex to "-1" allows the Text to be programmatically focused
   * without adding it to the tab order. Programmatically focusing is useful
   * when, for instance, a user presses an anchor link and expects to scroll
   * and focus on particular content.
   *
   * @since 5.23.0
   */
  tabIndex: _propTypes["default"].oneOf(["-1"]),

  /**
   * The HTML tag to use when rendering the component to the DOM.
   */
  tag: _propTypes["default"].string,

  /**
   * Add advisory information related to the element. See the [HTML title attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/title)
   * for details.
   *
   * If the `truncate` property is set to true, this prop will default to the
   * contents of the `Text` component *if* the contents are a plain string.
   * Otherwise this prop should be manually set to the non-truncated text to
   * ensure that the full text is accessible to readers.
   */
  title: _propTypes["default"].string,

  /**
   * Use this to apply a [CSS text transform](https://developer.mozilla.org/en-US/docs/Web/CSS/text-transform)
   * to the heading.
   */
  transform: _propTypes["default"].oneOf(["none", "capitalize", "uppercase", "lowercase"]),

  /**
   * Set this to true to truncate the text to a single line using ellipsis. If
   * the text already fits on a single line no truncation will be applied. This
   * relies on the CSS text-overflow property, refer to [the text-overflow documentation](https://developer.mozilla.org/en-US/docs/Web/CSS/text-overflow)
   * for details.
   */
  truncate: _propTypes["default"].bool,

  /**
   * This determines which entry from [Meridian's type scale](https://meridian.a2z.com/fundamentals/typography/?platform=reactjs&detailsTab=type-scale)
   * is used to render the heading text.
   */
  type: _propTypes["default"].oneOf(["d300", "d200", "d100", "d50", "h600", "h500", "h400", "h300", "h200", "h100", "b500", "b400", "b300", "b200", "b100"])
} : {};
Text.defaultProps = {
  tag: "p"
};
var _default = Text;
exports["default"] = _default;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _reduce = _interopRequireDefault(__webpack_require__(557));

var _box = _interopRequireDefault(__webpack_require__(49));

var _propTypes2 = _interopRequireDefault(__webpack_require__(77));

var _parsers = __webpack_require__(66);

var _functional = __webpack_require__(26);

var _cxMemoized = _interopRequireDefault(__webpack_require__(76));

var _rtl = __webpack_require__(52);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = function styles(heights) {
  return (0, _functional.memoizeByKeys)(function (_ref) {
    var spacing = _ref.spacing,
        alignmentVertical = _ref.alignmentVertical,
        alignmentHorizontal = _ref.alignmentHorizontal;
    return (0, _emotion.css)({
      display: "flex",
      flexDirection: "column",
      justifyContent: {
        top: "flex-start",
        bottom: "flex-end",
        center: "center",
        justify: "space-between"
      }[alignmentVertical],
      alignItems: {
        left: "flex-start",
        right: "flex-end",
        center: "center",
        stretch: "stretch"
      }[(0, _rtl.getHorizontalDirection)(alignmentHorizontal)],
      // Set margins and heights on the children of the column. Use !important to
      // override any existing styles.
      "& > *": {
        // Make sure that any borders or padding applied to the child don't throw
        // of the heights that we apply
        boxSizing: "border-box !important",
        // Ensure that the correct bottom margin is set (and clear other margins)
        margin: "0 0 ".concat((0, _parsers.parseSpacing)(spacing)[0], "px 0 !important"),
        // Don't let the last child add extra space to the end of the column.
        ":last-child": {
          margin: "0 !important"
        }
      }
    }, // If we've got an array of heights, apply each height to the child
    // whose index in the dom matches the height's index in the array. If
    // we've got a single height, apply that to all children.
    Array.isArray(heights) ? (0, _reduce["default"])(heights, function (result, height, index) {
      return _objectSpread(_objectSpread({}, result), {}, (0, _defineProperty2["default"])({}, "& > *:nth-child(".concat(parseInt(index) + 1, ")"), childStyles(height)));
    }, {}) : {
      "& > *": childStyles(heights)
    });
  }, ["spacing", "alignmentVertical", "alignmentHorizontal"]);
};

var stylesWithUniqueHeights = (0, _functional.memoizeArray)(styles);
var stylesWithUniformHeights = (0, _functional.memoize)(styles);

var childStyles = function childStyles(height) {
  return {
    flex: height === "fill" ? "1 !important" : undefined,
    flexShrink: height && height !== "fill" && height !== "auto" ? "0 !important" : undefined,
    height: height !== "fill" && height !== "fit" && height !== undefined && height !== null && height !== "" ? "".concat(height).concat(typeof height === "number" ? "px" : "", " !important") : undefined
  };
};
/**
 * The Column component stacks children up vertically in a column with even
 * spacing in-between them.
 */


var Column = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  // We need to memoize differently based on whether we got an array or scalar
  // for the "heights" property
  var stylesFunc = Array.isArray(props.heights) ? stylesWithUniqueHeights : stylesWithUniformHeights;
  var styles = stylesFunc(props.heights)(props);
  return /*#__PURE__*/_react["default"].createElement(_box["default"], _objectSpread(_objectSpread({}, props), {}, {
    className: (0, _cxMemoized["default"])(styles, props.className),
    ref: ref
  }));
});

Column.displayName = "Column";
Column.propTypes =  false ? {
  /**
   * Specify the horizontal alignment of the elements inside the column.
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["left", "start", "center", "right", "end", "stretch"]),

  /**
   * Specify the vertical alignment of the elements inside the column.
   */
  alignmentVertical: _propTypes["default"].oneOf(["top", "center", "bottom", "justify"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.18.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set the column's background color using a preset, or using a string
   * containing any valid CSS color.
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary"]), _propTypes["default"].string]),

  /**
   * The elements to line up in a column. Any elements can be supplied here, although if
   * only one child is supplied the column will not add much value (it's meant
   * for aligning multiple elements). If you only have one child, consider using
   * the `Box` component instead.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Set the height of the column using a number (which will be treated as
   * pixels) or a string containing any valid CSS dimension.
   */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the height of each element in the column.
   *
   * If a single height is provided then it will be applied to every element in
   * the column. If an array of heights is provided then each height will be
   * applied to the element in the column that exists at the same index as the
   * height in the array (e.g. `[<element 0 height>, <element 1 height>, null, <element 3 height>]`).
   *
   * The possible values for each height are:
   *   - `number` - A fixed pixel height.
   *   - `string` - Any valid CSS height.
   *   - `"fit"` - The element's height will shrink to fit its contents.
   *   - `"fill"` - The element's height will fill all remaining space in the column.
   *     If this value is set on multiple elements, they will share the remaining
   *     space in the column equally.
   */
  heights: _propTypes["default"].oneOfType([_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]), _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),

  /**
   * Set the maximum height of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum width of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum height of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum width of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Controls the horizontal overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowX` can cause the `overflow-y` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   *
   * @since 5.21.0
   */
  overflowX: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * Controls the vertical overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowY` can cause the `overflow-x` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   */
  overflowY: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * Set the vertical spacing between elements in the column using a preset.
   */
  spacing: _propTypes2["default"].spacing(1),

  /**
   * Apply padding to the component.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"small medium"` for small padding on the top/bottom and
   * medium padding on the left/right, or `"100 none none none"` for 2px
   * padding on the top and 0px padding on the right, left, and bottom).
   *
   * For more information on available spacing tokens please visit the
   * [Spacing fundamentals page](https://meridian.a2z.com/fundamentals/spacing/).
   */
  spacingInset: _propTypes2["default"].spacing(4),

  /**
   * The HTML tag to use when rendering the component to the DOM.
   */
  tag: _propTypes["default"].string,

  /**
   * Set the style of the column using one of Meridian's Box component styles.
   * If omitted the column will not have any decorative visual style applied to
   * it.
   */
  type: _propTypes["default"].oneOf(["outline", "fill"]),

  /**
   * Set the width of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
Column.defaultProps = {
  spacing: "medium",
  alignmentVertical: "top",
  alignmentHorizontal: "stretch"
};
var _default = Column;
exports["default"] = _default;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(558),
    baseEach = __webpack_require__(559),
    baseIteratee = __webpack_require__(102),
    baseReduce = __webpack_require__(564),
    isArray = __webpack_require__(42);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 558 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(560),
    createBaseEach = __webpack_require__(563);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(561),
    keys = __webpack_require__(86);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(562);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 562 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(73);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 564 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ErrorPage__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_TableCellUtil__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RefreshTimer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_link__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClusterV2=function(_Component){_inherits(ClusterV2,_Component);function ClusterV2(props){_classCallCheck(this,ClusterV2);var _this=_possibleConstructorReturn(this,(ClusterV2.__proto__||Object.getPrototypeOf(ClusterV2)).call(this,props));_this.getCombinedMetricsMap=function(cluster){var _this$props=_this.props,stowPackageMetricsMap=_this$props.stowPackageMetricsMap,minOfWorkMetricsMap=_this$props.minOfWorkMetricsMap,inductPackageMetricsMap=_this$props.inductPackageMetricsMap,stowAssociateMetricsMap=_this$props.stowAssociateMetricsMap,stowBinMetricsMap=_this$props.stowBinMetricsMap,stowCartMetricsMap=_this$props.stowCartMetricsMap;var defaultMetricValue="-";return{cluster:cluster,unopenedCarts:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(stowCartMetricsMap,cluster,"missingCarts"),binsMissingBag:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(stowBinMetricsMap,cluster,"binsMissingBag"),plannedPackages:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].plannedPackages;},defaultMetricValue),receivedPackages:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return inductPackageMetricsMap[cluster].receivedPackages;},defaultMetricValue),currentInductedPackages:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].currentInductedPackages;},defaultMetricValue),stowedPackages:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].stowedPackages;},defaultMetricValue),stowVsPlan:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].stowVsPlan;},defaultMetricValue),problemSolvePackages:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].problemSolvePackages;},defaultMetricValue),minutesOfWork:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return isNaN(parseFloat(minOfWorkMetricsMap[cluster].minutesOfWork).toFixed(1))?defaultMetricValue:parseFloat(minOfWorkMetricsMap[cluster].minutesOfWork).toFixed(1);},defaultMetricValue),stowRate:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].stowRate;},defaultMetricValue),lastFifteenMinuteStowRate:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return minOfWorkMetricsMap[cluster].lastFifteenMinuteStowRate;},defaultMetricValue),scanCompliance:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].scanCompliance;},defaultMetricValue),currentStowBufferedPackages:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].currentStowBufferedPackages;},defaultMetricValue),currentMFRJackpotBufferedPackages:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].currentMFRJackpotBufferedPackages;},defaultMetricValue),activeStowers:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowAssociateMetricsMap[cluster].activeStowers;},defaultMetricValue)};};_this.clusterRowClicked=function(clickedCluster){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["u" /* navigationAdded */])({key:'Cluster',value:clickedCluster}));};_this.renderTotalPackageCount=function(value,state){var params={PACKAGE_STATUS:state};return value!==0&&value!=='-'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_link___default.a,{href:_this.getPackageListURL(params),type:"secondary"}," ",value," "):value;};_this.getADTATableCell=function(value,aisle,state){return _this.isADTAVisibilityEnabled()&&Object(__WEBPACK_IMPORTED_MODULE_14__utils_TableCellUtil__["a" /* getTableCellCount */])(_this.renderPackageCount(value,aisle,state));};_this.renderPackageCount=function(value,cluster,state){var params={PACKAGE_STATUS:state,CLUSTER:cluster};return value!==0&&value!=='-'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_link___default.a,{href:_this.getPackageListURL(params),type:"secondary"}," ",value," "):value;};_this.getPackageListURL=function(params){var options=_this.props.options;if(options.cycle){params["CYCLE"]=options.cycle;}return"#packageList/?"+Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["e" /* formQueryParams */])(params);};_this.isADTAVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_16__constants__["j" /* FEATURES */].ADTA_VISIBILITY];};_this.isDRSStowVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_16__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY];};_this.isCartVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_16__constants__["j" /* FEATURES */].CART_VISIBILITY];};_this.state={sortColumn:"cluster",sortDirection:"ascending"};return _this;}_createClass(ClusterV2,[{key:"render",value:function render(){var _this2=this;var _props=this.props,loading=_props.loading,error=_props.error,stowPackageMetricsMap=_props.stowPackageMetricsMap,minOfWorkMetricsMap=_props.minOfWorkMetricsMap,inductPackageMetricsMap=_props.inductPackageMetricsMap,stowAssociateMetricsMap=_props.stowAssociateMetricsMap,stowBinMetricsMap=_props.stowBinMetricsMap,stowCartMetricsMap=_props.stowCartMetricsMap;this.aggregateStowRate=0;this.aggregateLFM=0;if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__utils_ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});}var allClusters=[].concat(_toConsumableArray(Object.keys(stowPackageMetricsMap)),_toConsumableArray(Object.keys(minOfWorkMetricsMap)),_toConsumableArray(Object.keys(inductPackageMetricsMap)),_toConsumableArray(Object.keys(stowAssociateMetricsMap)),_toConsumableArray(Object.keys(stowBinMetricsMap)),_toConsumableArray(Object.keys(stowCartMetricsMap)));var distinctClusters=[].concat(_toConsumableArray(new Set(allClusters)));if(loading&&!distinctClusters.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default.a,{height:"400px",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader___default.a,null));}var filteredClusters=Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["k" /* getFilteredLocations */])(distinctClusters,stowPackageMetricsMap,this.isDRSStowVisibilityEnabled());var onSort=function onSort(sortDetails){_this2.setState({sortColumn:sortDetails.sortColumn,sortDirection:sortDetails.sortDirection});};var sortColumn=this.state.sortColumn;var direction=this.state.sortDirection;filteredClusters.sort(function(c1,c2){var c1CombinedMetricsMap=_this2.getCombinedMetricsMap(c1);var c2CombinedMetricsMap=_this2.getCombinedMetricsMap(c2);if(c1CombinedMetricsMap[sortColumn]<c2CombinedMetricsMap[sortColumn]){return direction==="ascending"?-1:1;}if(c1CombinedMetricsMap[sortColumn]>c2CombinedMetricsMap[sortColumn]){return direction==="ascending"?1:-1;}return 0;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__RefreshTimer__["a" /* default */],{deps:[stowPackageMetricsMap]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{overflowX:"auto",maxWidth:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table___default.a,{headerRows:2,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true,sortColumn:this.state.sortColumn,sortDirection:this.state.sortDirection,onSort:onSort,"data-cy":"clusterTable"},this.renderHeadings(),this.renderSubHeadings(),filteredClusters.map(function(cluster){return _this2.renderClusterRow(cluster);}),filteredClusters.length?this.renderTotalClusterRow():null)));}},{key:"renderHeadings",value:function renderHeadings(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.packages",defaultMessage:"Packages"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),this.isADTAVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),this.isADTAVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.performance",defaultMessage:"Performance"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.stowers",defaultMessage:"Stowers"})));}},{key:"renderSubHeadings",value:function renderSubHeadings(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"cluster"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.cluster",defaultMessage:"Cluster"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"plannedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.cluster.container_planned"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.container_planned",defaultMessage:"C. Planned"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"receivedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.cluster.arrived"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.arrived",defaultMessage:"Arrived"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"currentInductedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.inducted",defaultMessage:"Inducted"})),this.isADTAVisibilityEnabled()&&Object(__WEBPACK_IMPORTED_MODULE_14__utils_TableCellUtil__["b" /* getTableCellHeader */])("currentStowBufferedPackages"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.stowed",defaultMessage:"Stowed"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowVsPlan",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.cluster.stow_plan"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.stow_plan",defaultMessage:"Stow/Plan"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"problemSolvePackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.cluster.ps"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.ps",defaultMessage:"PS"}))),this.isADTAVisibilityEnabled()&&Object(__WEBPACK_IMPORTED_MODULE_14__utils_TableCellUtil__["b" /* getTableCellHeader */])("currentMFRJackpotBufferedPackages"),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"cartsMissing",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.cartsMissing",defaultMessage:"Unopened Carts"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"binsMissingBag",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.missing",defaultMessage:"Unopened Bags"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"minutesOfWork",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.cluster.minutes_of_work"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.minutes_of_work",defaultMessage:"Min of Work"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowRate",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.cluster.stow_rate"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.stow_rate",defaultMessage:"Stow rate"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"scanCompliance",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.cluster.scan_compliance"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.scan_compliance",defaultMessage:"Scan comp."}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"activeStowers",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.cluster.active"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.active",defaultMessage:"Active"}))));}},{key:"renderClusterRow",value:function renderClusterRow(cluster){var _this3=this;var combinedMetricsMap=this.getCombinedMetricsMap(cluster);this.aggregateStowRate+=combinedMetricsMap.stowRate==="-"?0:combinedMetricsMap.stowRate;this.aggregateLFM+=combinedMetricsMap.lastFifteenMinuteStowRate==="-"?0:combinedMetricsMap.lastFifteenMinuteStowRate;var stowBufferedCell=this.getADTATableCell(combinedMetricsMap.currentStowBufferedPackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_STOW_BUFFERED);var mfrJackpotBufferedCell=this.getADTATableCell(combinedMetricsMap.currentMFRJackpotBufferedPackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_MFR_JACKPOT_BUFFERED);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,key:cluster,onClick:function onClick(){return _this3.clusterRowClicked(cluster);},"data-cy":"clusterDataRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null,cluster),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.plannedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.receivedPackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_RECEIVED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.currentInductedPackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_INDUCTED)),stowBufferedCell,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.stowedPackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].STOWED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.stowVsPlan,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.problemSolvePackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].PROBLEM_SOLVE)),mfrJackpotBufferedCell,this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.unopenedCarts),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.binsMissingBag),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.minutesOfWork),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},isFinite(parseFloat(combinedMetricsMap.stowRate/combinedMetricsMap.activeStowers).toFixed(2))?parseFloat(combinedMetricsMap.stowRate/combinedMetricsMap.activeStowers).toFixed(2):"-"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.scanCompliance,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.activeStowers));}},{key:"renderTotalClusterRow",value:function renderTotalClusterRow(){var _props2=this.props,totalStowPackageMetrics=_props2.totalStowPackageMetrics,totalInductPackageMetrics=_props2.totalInductPackageMetrics,totalStowAssociateMetrics=_props2.totalStowAssociateMetrics,totalStowBinMetrics=_props2.totalStowBinMetrics,totalStowCartMetricsMap=_props2.totalStowCartMetricsMap;if(!this.aggregateStowRate||!totalStowAssociateMetrics["Total"]||!totalStowAssociateMetrics["Total"].activeStowers||totalStowAssociateMetrics["Total"].activeStowers==="-"){totalStowPackageMetrics["Total"]=Object.assign({},totalStowPackageMetrics["Total"],{stowRate:"-"});}else{totalStowPackageMetrics["Total"]=Object.assign({},totalStowPackageMetrics["Total"],{stowRate:parseFloat(this.aggregateStowRate/totalStowAssociateMetrics["Total"].activeStowers).toFixed(2)});}if(!this.aggregateLFM||!totalStowPackageMetrics["Total"]||!totalStowPackageMetrics["Total"].currentInductedPackages||totalStowPackageMetrics["Total"].currentInductedPackages==="-"){totalStowPackageMetrics["Total"]=Object.assign({},totalStowPackageMetrics["Total"],{minutesOfWork:"-"});}else{totalStowPackageMetrics["Total"]=Object.assign({},totalStowPackageMetrics["Total"],{minutesOfWork:parseFloat(totalStowPackageMetrics["Total"].currentInductedPackages/this.aggregateLFM*60).toFixed(1)});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row___default.a,{"data-cy":"clusterTotalRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null,"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","plannedPackages")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderTotalPackageCount(Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalInductPackageMetrics,"Total","receivedPackages"),__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_RECEIVED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderTotalPackageCount(Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","currentInductedPackages"),__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_INDUCTED)),this.renderStowBufferedTotalCount(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","stowedPackages")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","stowVsPlan"),"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderTotalPackageCount(Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","problemSolvePackages"),__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].PROBLEM_SOLVE)),this.renderMFRJackpotBufferedTotalCount(),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowCartMetricsMap,"Total","cartsMissing")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowBinMetrics,"Total","binsMissingBag")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","minutesOfWork")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","stowRate")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","scanCompliance"),"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowAssociateMetrics,"Total","activeStowers")));}},{key:"renderStowBufferedTotalCount",value:function renderStowBufferedTotalCount(){if(this.isADTAVisibilityEnabled()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderTotalPackageCount(Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(this.props.totalStowPackageMetrics,"Total","currentStowBufferedPackages")));}}},{key:"renderMFRJackpotBufferedTotalCount",value:function renderMFRJackpotBufferedTotalCount(){if(this.isADTAVisibilityEnabled()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderTotalPackageCount(Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(this.props.totalStowPackageMetrics,"Total","currentMFRJackpotBufferedPackages")));}}}]);return ClusterV2;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{loading:state.clusterReducerV2.loading,error:state.clusterReducerV2.error,options:state.optionsReducer.options,minOfWorkMetricsMap:state.clusterReducerV2.minOfWorkMetricsMap,stowPackageMetricsMap:state.clusterReducerV2.stowPackageMetricsMap,stowBinMetricsMap:state.clusterReducerV2.stowBinMetricsMap,stowCartMetricsMap:state.clusterReducerV2.stowCartMetricsMap,inductPackageMetricsMap:state.clusterReducerV2.inductPackageMetricsMap,stowAssociateMetricsMap:state.clusterReducerV2.stowAssociateMetricsMap,totalStowPackageMetrics:state.clusterReducerV2.totalStowPackageMetrics,totalStowBinMetrics:state.clusterReducerV2.totalStowBinMetrics,totalInductPackageMetrics:state.clusterReducerV2.totalInductPackageMetrics,totalStowAssociateMetrics:state.clusterReducerV2.totalStowAssociateMetrics,featureStatus:state.configReducer.featureStatus};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_intl__["d" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ClusterV2))));

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return responsiveProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BreakPoints_js__ = __webpack_require__(567);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
    Responsive props to hold all the props relevant for device info and layout
    Immediate extension with spacing for Desktop and mobile
*/var responsiveProps={isMobile:_defineProperty({default:false},__WEBPACK_IMPORTED_MODULE_0__BreakPoints_js__["a" /* SMALL */],true),spacingInset_shorthand2:_defineProperty({default:"medium large"},__WEBPACK_IMPORTED_MODULE_0__BreakPoints_js__["a" /* SMALL */],"medium large medium none"),spacingInset_shorthand3:_defineProperty({default:"small"},__WEBPACK_IMPORTED_MODULE_0__BreakPoints_js__["a" /* SMALL */],"none"),spacingInset_shorthand4:_defineProperty({default:"small large"},__WEBPACK_IMPORTED_MODULE_0__BreakPoints_js__["a" /* SMALL */],"none"),spacingInset_shorthand5:_defineProperty({default:"small large"},__WEBPACK_IMPORTED_MODULE_0__BreakPoints_js__["a" /* SMALL */],"small medium"),spacingInset_shorthand6:_defineProperty({default:"none medium none large"},__WEBPACK_IMPORTED_MODULE_0__BreakPoints_js__["a" /* SMALL */],"small small none small")};

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EXTRA_SMALL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SMALL; });
/* unused harmony export LARGE */
var EXTRA_SMALL="480px";var SMALL="840px";var LARGE="1260px";

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _matchMedia = _interopRequireDefault(__webpack_require__(569));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This looks through an object of nested objects and returns a flat array
 * containing all the unique keys found in the nested objects.
 */
var getUniqueNestedObjectKeys = function getUniqueNestedObjectKeys(props) {
  return Object.keys(props) // Get the keys of each nested object
  .map(function (prop) {
    return Object.keys(props[prop]);
  }) // Flatten the keys into one array
  .reduce(function (result, keys) {
    return result.concat(keys);
  }, []) // Filter out duplicate keys
  .filter(function (value, index, keys) {
    return keys.indexOf(value) === index;
  });
};
/**
 * Sort an array according to it's numeric values
 */


var sortNumeric = function sortNumeric(arr, direction) {
  arr.sort(function (a, b) {
    return (parseFloat(a) - parseFloat(b)) * (direction === "descending" ? -1 : 1);
  });
  return arr;
};
/* eslint-disable react/prop-types */

/**
 * This component allows you to respond to the state of media features such as
 * viewport width, viewport aspect ratio, and device orientation. This is
 * similar to "media queries for JavaScript" (and it's even powered by media
 * queries behind the scenes), but it's a lot more powerful. Instead of only
 * allowing you to toggle something on or off based on a matching media query,
 * it allows you to set set any JavaScript variable based on the various states
 * of a media feature. You can use this functionality to do things that are not
 * possible with plain CSS media queries like:
 *   - render entirely different component trees based on viewport size
 *   - pass different props to a component based on viewport width
 *   - change the location of elements in the DOM based on device orientation
 *
 * NOTE: The props passed to this component cannot be changed after the
 * component is first instantiated.
 *
 * ```
 * // Renders "red" below the 1000px breakpoint, "blue" at or above the 1000px
 * // breakpoint but below the 1500px breakpoint, and "green" at or above the
 * // 1500px breakpoint. Renders 12px font below the 1500px breakpoint and 24px
 * // at or above the 1500px breakpoint.
 * <Responsive
 *   query="min-width"
 *   props={{
 *     color: { default: "red", "1000px": "blue", "1500px": "green" },
 *     fontSize: { default: 12, "1500px": 24 },
 *   }}
 * >
 *   {({ color, fontSize }) => (
 *     <div style={{ fontSize }}>My fav color is {color}</div>
 *.  )}
 * </Responsive>
 * ```
 */


var ResponsiveClass = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ResponsiveClass, _React$Component);

  var _super = _createSuper(ResponsiveClass);

  function ResponsiveClass(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ResponsiveClass);
    _this = _super.call(this, props); // Extract the media condition from the "query" prop

    var condition = /^min-/.test(props.query) ? "min" : /^max-/.test(props.query) ? "max" : null; // Extract the media feature from the "query" prop

    var feature = condition ? props.query.replace(new RegExp("^".concat(condition, "-")), "") : props.query; // Extract a list of unique breakpoints from the keys of the "props" prop.
    // Don't include the "default" since that's not something we can actually
    // query for (we'll fallback to that manually if no breakpoint matches)

    var breakpoints = getUniqueNestedObjectKeys(props.props).filter(function (key) {
      return key !== "default";
    }); // Sort the breakpoints according to the media query condition so that later
    // on we can just take the last matching breakpoint and know that that's the
    // min/max matching breakpoint

    var sortedBreakpoints = condition ? sortNumeric(breakpoints, condition === "min" ? "ascending" : "descending") : breakpoints; // This is an object of `MediaQueryList` instances (or mock instances - see
    // `matchMedia`) keyed by the breakpoints that they're matching against (e.g.
    // `{ "0px": mediaQueryA, "1000px": mediaQueryB }`).

    _this.mediaQueries = sortedBreakpoints.map(function (breakpoint) {
      var mediaQuery = (0, _matchMedia["default"])({
        feature: feature,
        condition: condition,
        fallback: props.fallback,
        breakpoint: breakpoint
      });

      var listener = function listener() {
        return _this.setState((0, _defineProperty2["default"])({}, breakpoint, mediaQuery.matches));
      };

      return {
        breakpoint: breakpoint,
        mediaQuery: mediaQuery,
        startListening: function startListening() {
          return mediaQuery.addListener(listener);
        },
        stopListening: function stopListening() {
          return mediaQuery.removeListener(listener);
        }
      };
    }); // Save off the list of prop names for each access later

    _this.propNames = Object.keys(props.props); // State is an object keyed by breakpoint that includes the match state of
    // the media query for that breakpoint (e.g. if the query is "min-width",
    // we're listening at the breakpoints "0px" and "1000px", adn the viewport
    // width is "500px" then the state object would be:
    // { "0px": true, "1000px": false }

    _this.state = _this.mediaQueries.reduce(function (result, _ref) {
      var breakpoint = _ref.breakpoint,
          mediaQuery = _ref.mediaQuery;
      // If a fallback prop is present, match against that for the intial
      // state. This ensures that that the same value is used during server
      // rendering and during the initial rehydrating render on the client.
      result[breakpoint] = _this.props.fallback ? mediaQuery.matchesFallback : mediaQuery.matches;
      return result;
    }, {});
    return _this;
  }

  (0, _createClass2["default"])(ResponsiveClass, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.mediaQueries.forEach(function (_ref2) {
        var mediaQuery = _ref2.mediaQuery,
            breakpoint = _ref2.breakpoint,
            startListening = _ref2.startListening;
        // Start listening for future state changes
        startListening(); // If we matched against the fallback prop on the initial render, but the
        // actual match is different, then update the state now and trigger a
        // re-render

        if (_this2.props.fallback && mediaQuery.matches !== mediaQuery.matchesFallback) {
          // Note: React batches state updates in lifecycle methods so we'll only
          // get one re-render no matter how many breakpoints we have to update.
          _this2.setState((0, _defineProperty2["default"])({}, breakpoint, mediaQuery.matches));
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mediaQueries.forEach(function (_ref3) {
        var stopListening = _ref3.stopListening;
        return stopListening();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      // Choose the best value from "props" based on the state of our media
      // queries. If no match is found then return the "default" value (or
      // undefined if there is no default).
      var props = this.propNames.reduce(function (result, propName) {
        var prop = _this3.props.props[propName];

        var value = _this3.mediaQueries.reduce(function (result, _ref4) {
          var breakpoint = _ref4.breakpoint;
          return _this3.state[breakpoint] && prop[breakpoint] !== undefined ? prop[breakpoint] : result;
        }, prop["default"]);

        result[propName] = value;
        return result;
      }, {});
      return this.props.children(props);
    }
  }]);
  return ResponsiveClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */
// Keep refs from being passed. We're doing this for 4.x - the
// most recent breaking change - so that we can change the
// _actual_ component to functional later without waiting
// for the next breaking change


var Responsive = function Responsive(props) {
  return /*#__PURE__*/_react["default"].createElement(ResponsiveClass, props);
};

Responsive.displayName = "Responsive";
Responsive.propTypes =  false ? {
  /**
   * A function that returns React elements. This will receive an object of
   * props based on the current state of the queried media feature and the
   * values passed to "props".
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * This is a nested object that allows you to define the prop values that
   * should be passed to the children function given any particular state of
   * the queried media feature. The special state "default" can be used to
   * indicate a value that should be returned if none of the other states are
   * matched. See the top-level documentation for this component for an
   * example.
   */
  props: _propTypes["default"].objectOf(_propTypes["default"].object).isRequired,

  /**
   * The media feature (e.g. width) and conditional (e.g. min) to watch for
   * changes and respond to.
   */
  query: _propTypes["default"].oneOf(["min-width", "max-width", "min-height", "max-height", "min-aspect-ratio", "max-aspect-ratio", "orientation"]).isRequired,

  /**
   * This is used as the fallback state of the queried media feature if the
   * component is rendered in an environment that doesn't support media
   * queries (e.g. NodeJS).
   *
   * Note that this does not have to match the states
   * found in the "props" object exactly to trigger a match. For example, if
   * "query" is set to "min-width", "fallback" is set to "1024px", and "props"
   * is set to `{ myValue: { default: "small", "800px": "medium", "1280px": "large" }}`,
   * then "myValue" would resolve to "medium" because "min-width: 800px"
   * passes when the width falls back to "1024px".
   *
   * IMPORTANT: This is required if you're server-rendering or pre-rendering this
   * component! Otherwise you may end up with a mismatch between your server
   * rendered markup and the markup that React tries to rehydrate with, and it
   * will literally shred the DOM.
   */
  fallback: _propTypes["default"].string
} : {};
var _default = Responsive;
exports["default"] = _default;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _noop = _interopRequireDefault(__webpack_require__(37));

var _functional = __webpack_require__(26);

/**
 * Attempt to convert a media query breakpoint to a number. If we received a
 * breakpoint like "5/10" (e.g. an aspect ratio) then run the math (e.g. "5/10"
 * => 0.5), otherwise just parse as a float (e.g. "5rem" => 5).
 */
var breakpointToNumber = function breakpointToNumber(str) {
  return /^\s?[0-9.]+\s?\/\s?[0-9.]+\s?$/.test(str) ? parseFloat(str.split("/")[0]) / parseFloat(str.split("/")[1]) : parseFloat(str);
};

var matchesFallback = function matchesFallback(_ref) {
  var condition = _ref.condition,
      breakpoint = _ref.breakpoint,
      fallback = _ref.fallback;
  return fallback === undefined ? false : condition === "min" ? breakpointToNumber(breakpoint) <= breakpointToNumber(fallback) : condition === "max" ? breakpointToNumber(breakpoint) >= breakpointToNumber(fallback) : breakpoint === fallback;
};
/**
 * A wrapper around `window.matchMedia`. If `window.matchMedia` is available
 * then a media query will be constructed and passed to `window.matchMedia` to
 * create a `MediaQueryList` instance. If we're in an env where
 * `window.matchMedia` is not available (e.g. NodeJS) then this will return a
 * mock MediaQueryList that matches against the provided fallback.
 */


var matchMedia = typeof window !== "undefined" && window.matchMedia ? (0, _functional.memoizeByKeys)(function (_ref2) {
  var condition = _ref2.condition,
      breakpoint = _ref2.breakpoint,
      feature = _ref2.feature,
      fallback = _ref2.fallback;
  // Build up a standard media query (e.g. `(min-width: 1000px)`) if
  // we have access to window.matchMedia
  var matchMedia = window.matchMedia("(".concat(condition ? "".concat(condition, "-") : "").concat(feature, ": ").concat(breakpoint, ")")); // Tack on the a property indicating whether the fallback matches.
  // This is helpful for situations where you're on the client, but want
  // to know what the match state would have been on the server (i.e.
  // when re-hydrating server-rendered markup on the client with React).

  matchMedia.matchesFallback = matchesFallback({
    condition: condition,
    breakpoint: breakpoint,
    fallback: fallback
  });
  return matchMedia;
}, ["feature", "condition", "breakpoint", "fallback"]) : function (args) {
  var matches = matchesFallback(args);
  return {
    // If we don't have access to `window.matchMedia` then "matches" will be
    // set statically based on the provided "fallback".
    matches: matches,
    // Mock out these functions for parity with the `MediaQueryList`
    // instance returned if `window.matchMedia` is available
    matchesFallback: matches,
    addListener: _noop["default"],
    removeListener: _noop["default"]
  };
};
var _default = matchMedia;
exports["default"] = _default;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _link = _interopRequireDefault(__webpack_require__(571));

var _text = _interopRequireDefault(__webpack_require__(134));

var _focusRing = _interopRequireDefault(__webpack_require__(219));

var _getTextStyles = _interopRequireDefault(__webpack_require__(245));

var _theme = __webpack_require__(14);

var _clickable = _interopRequireDefault(__webpack_require__(64));

var _useFocus2 = _interopRequireDefault(__webpack_require__(40));

var _token = __webpack_require__(12);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var type = _ref.type,
      focus = _ref.focus,
      disabled = _ref.disabled;

  var _focusRingTokens = (0, _focusRing["default"])(t.tokens),
      focusRingWidth = _focusRingTokens.focusRingWidth,
      focusRingColorFocus = _focusRingTokens.focusRingColorFocus;

  return (0, _emotion.css)({
    display: "inline",
    // HACK: Use !important to override the color set by the text styles
    color: "".concat(t("foregroundColor", disabled ? "disabled" : "default"), " !important"),
    textDecoration: type === "primary" ? "underline" : "none",
    transition: t.transitionCss("motion", "color"),
    // Use custom focus rings styles that will work even if the link wraps
    // across multiple lines.
    // NOTE: IE11 doesn't support outline-offset so the focus ring will
    // be tighter in that browser. The alternative would be to use our
    // previous multiple-box-shadow approach, but that has other issues
    // because it has to make an assumption about the background color
    // behind the link.
    outline: focus ? "".concat(focusRingWidth, "px solid ").concat(focusRingColorFocus) : undefined,
    outlineOffset: 2,
    ":hover": !disabled && {
      color: "".concat(t("foregroundColorHover"), " !important"),
      textDecoration: type === "secondary" ? "underline" : undefined
    },
    ":active": !disabled && {
      color: "".concat(t("foregroundColorPressed"), " !important")
    }
  }, (0, _getTextStyles["default"])((0, _token.getTokenHelper)("text")((0, _text["default"])(t.tokens)), {}));
}, ["type", "focus", "disabled"]);

var Link = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_link["default"], "link");

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]);
  return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, focusProps, passThroughProps, {
    className: styles(t, {
      type: props.type,
      disabled: props.disabled,
      focus: focus && focusTrigger === "keyboard"
    }),
    target: props.target,
    rel: props.rel,
    disabled: props.disabled,
    href: props.href,
    onClick: props.onClick,
    tabIndex: props.tabIndex,
    download: props.download,
    propagateClickEvent: props.propagateClickEvent,
    tag: "a",
    ref: ref,
    "mdn-link": ""
  }), props.children);
});

Link.displayName = "Link";
Link.propTypes =  false ? {
  /**
   * The contents of the link. Plain text recommended.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.21.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * See the [MDN docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-download) for details.
   * This string should be the file name which should be downloaded. If set to an empty string the browser
   * will default to file name (e.g. a file downloaded from `site.com/picture.jpg` will be named `picture.jpg`).
   */
  download: _propTypes["default"].string,

  /**
   * The URL that the link points to.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * Determines whether or not the click event will continue to bubble up
   * through the DOM. Read the [Event.stopPropagation() docs](https://developer.mozilla.org/en-US/docs/Web/API/Event/stopPropagation)
   * for details.
   */
  propagateClickEvent: _propTypes["default"].bool,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * This determines the visual style of the link.
   */
  type: _propTypes["default"].oneOf(["primary", "secondary"]),

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func
} : {};
Link.defaultProps = {
  type: "primary"
};
var _default = Link;
exports["default"] = _default;

/***/ }),
/* 571 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    linkForegroundColorDefault: tokens.themeForegroundAccentDefault,
    linkForegroundColorHover: tokens.themeForegroundAccentHover,
    linkForegroundColorPressed: tokens.themeForegroundAccentPressed,
    linkForegroundColorDisabled: tokens.themeBorderAccentDisabled,
    linkMotionDuration: "100ms",
    linkMotionFunction: "ease"
  }
};

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(573);

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(574);
var utils = __webpack_require__(54);
var dispatchRequest = __webpack_require__(575);
var InterceptorManager = __webpack_require__(581);
var isAbsoluteURL = __webpack_require__(582);
var combineURLs = __webpack_require__(583);
var bind = __webpack_require__(584);
var transformData = __webpack_require__(251);

function Axios(defaultConfig) {
  this.defaults = utils.merge({}, defaultConfig);
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Don't allow overriding defaults.withCredentials
  config.withCredentials = config.withCredentials || this.defaults.withCredentials;

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

var defaultInstance = new Axios(defaults);
var axios = module.exports = bind(Axios.prototype.request, defaultInstance);

axios.create = function create(defaultConfig) {
  return new Axios(defaultConfig);
};

// Expose defaults
axios.defaults = defaultInstance.defaults;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(585);

// Expose interceptors
axios.interceptors = defaultInstance.interceptors;

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
  axios[method] = bind(Axios.prototype[method], defaultInstance);
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
  axios[method] = bind(Axios.prototype[method], defaultInstance);
});


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);

var PROTECTION_PREFIX = /^\)\]\}',?\n/;
var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

module.exports = {
  transformRequest: [function transformResponseJSON(data, headers) {
    if (utils.isFormData(data)) {
      return data;
    }
    if (utils.isArrayBuffer(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isObject(data) && !utils.isFile(data) && !utils.isBlob(data)) {
      // Set application/json if no Content-Type has been specified
      if (!utils.isUndefined(headers)) {
        utils.forEach(headers, function processContentTypeHeader(val, key) {
          if (key.toLowerCase() === 'content-type') {
            headers['Content-Type'] = val;
          }
        });

        if (utils.isUndefined(headers['Content-Type'])) {
          headers['Content-Type'] = 'application/json;charset=utf-8';
        }
      }
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponseJSON(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      data = data.replace(PROTECTION_PREFIX, '');
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    },
    patch: utils.merge(DEFAULT_CONTENT_TYPE),
    post: utils.merge(DEFAULT_CONTENT_TYPE),
    put: utils.merge(DEFAULT_CONTENT_TYPE)
  },

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN'
};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

/**
 * Dispatch a request to the server using whichever adapter
 * is supported by the current environment.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  return new Promise(function executor(resolve, reject) {
    try {
      var adapter;

      if (typeof config.adapter === 'function') {
        // For custom adapter support
        adapter = config.adapter;
      } else if (typeof XMLHttpRequest !== 'undefined') {
        // For browsers use XHR adapter
        adapter = __webpack_require__(250);
      } else if (typeof process !== 'undefined') {
        // For node use HTTP adapter
        adapter = __webpack_require__(250);
      }

      if (typeof adapter === 'function') {
        adapter(resolve, reject, config);
      }
    } catch (e) {
      reject(e);
    }
  });
};


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(249)))

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};



/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}
InvalidCharacterError.prototype = new Error;
InvalidCharacterError.prototype.code = 5;
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new InvalidCharacterError('INVALID_CHARACTER_ERR: DOM Exception 5');
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
};


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _statusTag = _interopRequireDefault(__webpack_require__(587));

var _dismissibleTag = _interopRequireDefault(__webpack_require__(589));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

var Tag = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return props.onClose && (props.type === "theme" || props.type === "neutral") && props.children ? /*#__PURE__*/_react["default"].createElement(_dismissibleTag["default"], (0, _extends2["default"])({
    onClose: props.onClose,
    closeLabel: props.closeLabel,
    type: props.type,
    ref: ref,
    tabIndex: props.tabIndex
  }, passThroughProps), props.children) : /*#__PURE__*/_react["default"].createElement(_statusTag["default"], (0, _extends2["default"])({
    type: props.type,
    ref: ref,
    tabIndex: props.tabIndex
  }, passThroughProps), props.children);
});

Tag.displayName = "Tag";
Tag.propTypes =  false ? {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * The tag's label. Omit this to render a compact tag.
   */
  children: _propTypes["default"].string,

  /**
   * An accessible label for the tag's dismiss button. This is not shown in
   * the UI, but will be read by screen-readers.
   */
  closeLabel: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * If this is not specified the component will not be focuseable.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   *
   * @since 5.14.0
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The visual style of the tag.
   */
  type: _propTypes["default"].oneOf(["theme", "neutral", "success", "warning", "error"]),

  /**
   * If `type` is set to `"theme"` or `"neutral"`, a function can be provided
   * here to render a dismissable tag.
   *
   * This prop will be ignored for compact tags (if `children` is not set) or
   * for tags that are not of type `"theme"` or `"neutral"`.
   */
  onClose: _propTypes["default"].func
} : {};
Tag.defaultProps = {
  type: "theme"
};
var _default = Tag;
exports["default"] = _default;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _tag = _interopRequireDefault(__webpack_require__(164));

var _theme = __webpack_require__(14);

var _buttonReset = _interopRequireDefault(__webpack_require__(221));

var _token = __webpack_require__(12);

var _useFocus2 = _interopRequireDefault(__webpack_require__(40));

var _text = _interopRequireDefault(__webpack_require__(27));

var _focusRing = _interopRequireDefault(__webpack_require__(43));

var _indicator = _interopRequireDefault(__webpack_require__(588));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

/**
 * Styles
 */
var wrapperStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var focus = _ref.focus;
  return (0, _emotion.css)({
    // HACK: This is necessary to keep IE11 from allowing the tag's text to overflow
    // the boundaries of the tag. When we drop IE11 support this wrapper can be
    // removed and the "display" property of the styles below can be changed from
    // "inline-block" to "inline-flex" and other styles can move to `styles`.
    display: "inline-block"
  }, {
    outline: "none",
    "& > div > div": (0, _focusRing["default"])(t.tokens, {
      focus: focus,
      offset: t("focusOutlineOffset"),
      borderRadius: t("borderRadius"),
      borderWidth: t("borderWidth"),
      dropShadow: t.boxShadowCss("dropShadowHover")
    })
  });
}, ["focus"]);
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var type = _ref2.type,
      children = _ref2.children;
  return (0, _emotion.css)(_buttonReset["default"], (0, _text["default"])(t), {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: t("height"),
    boxSizing: "border-box",
    whiteSpace: "nowrap"
  }, children === undefined ? {
    width: t("height"),
    "& > div": {
      borderRadius: t("borderCompactRadius"),
      borderWidth: t("borderCompactWidth"),
      borderStyle: "solid",
      borderColor: t("borderColorCompact"),
      boxSizing: "border-box"
    }
  } : (0, _defineProperty2["default"])({
    borderRadius: t("borderRadius"),
    borderWidth: t("borderWidth"),
    borderStyle: "solid",
    borderColor: t("borderColorStatus", type),
    // HACK: IE11 does not support padding-inline-* so we have to use
    // directional padding-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   paddingInlineStart: t("spacingInsetStatusLeft"),
    //   paddingInlineEnd: t("spacingInsetStatusRight"),
    // },
    paddingRight: t("spacingInsetStatusRight"),
    paddingLeft: t("spacingInsetStatusLeft")
  }, "[dir=\"rtl\"] &", {
    paddingLeft: t("spacingInsetStatusRight"),
    paddingRight: t("spacingInsetStatusLeft")
  }));
}, ["type", "children"]);
/**
 * Component
 */

var StatusTag = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_tag["default"], "tag");

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var compact = typeof props.children === "undefined" ? true : false;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: wrapperStyles(t, {
      focus: focus && focusTrigger === "keyboard"
    }),
    ref: ref,
    "aria-label": props["aria-label"],
    tabIndex: props.tabIndex
  }, passThroughProps, focusProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, props)
  }, /*#__PURE__*/_react["default"].createElement(_indicator["default"], {
    type: props.type,
    compact: compact
  }), /*#__PURE__*/_react["default"].createElement("span", null, props.children)));
});

StatusTag.displayName = "StatusTag";
StatusTag.propTypes =  false ? {
  "aria-label": _propTypes["default"].string,
  children: _propTypes["default"].string,
  tabIndex: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(["success", "warning", "error", "theme", "neutral"])
} : {};
StatusTag.defaultProps = {
  type: "theme"
};
var _default = StatusTag;
exports["default"] = _default;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(4);

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _tag = _interopRequireDefault(__webpack_require__(164));

var _theme = __webpack_require__(14);

/**
 * Styles
 */
var styles = function styles(t, _ref) {
  var _css;

  var type = _ref.type,
      compact = _ref.compact;
  return (0, _emotion.css)((_css = {
    display: "inline-block",
    width: t("indicatorDiameter"),
    height: t("indicatorDiameter"),
    backgroundColor: t("borderColorStatus", type),
    borderRadius: t("indicatorDiameter") / 2,
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   marginInlineStart: compact ? 0 : t("spacingHorizontal"),
    // },
    marginRight: compact ? 0 : t("spacingHorizontal")
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    marginRight: 0,
    marginLeft: compact ? 0 : t("spacingHorizontal")
  }), (0, _defineProperty2["default"])(_css, "flexShrink", 0), _css));
};
/**
 * Component
 */


function Indicator(props) {
  var t = (0, _theme.useTheme)(_tag["default"], "tag");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, props)
  });
}

Indicator.propTypes =  false ? {
  compact: _propTypes["default"].bool,
  type: _propTypes["default"].oneOf(["success", "warning", "error", "theme", "neutral"])
} : {};
Indicator.defaultProps = {
  type: "theme"
};
var _default = Indicator;
exports["default"] = _default;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(4);

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _tag = _interopRequireDefault(__webpack_require__(164));

var _closeKnockout = _interopRequireDefault(__webpack_require__(590));

var _theme = __webpack_require__(14);

var _useFocus2 = _interopRequireDefault(__webpack_require__(40));

var _clickable = _interopRequireDefault(__webpack_require__(64));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _token = __webpack_require__(12);

var _focusRing = _interopRequireDefault(__webpack_require__(43));

var _text = _interopRequireDefault(__webpack_require__(27));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

/**
 * Styles
 */
var clickTargetSize = 20;
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _button, _css;

  var type = _ref.type;
  // This is the horizontal distance between the end of the icon and the end of the clickable,
  // on both the left and right side.
  var iconClickableXDelta = (clickTargetSize - t("closeIconSize")) / 2;
  return (0, _emotion.css)((0, _text["default"])(t), (_css = {
    backgroundColor: t("backgroundColorDismissible", type),
    borderRadius: t("borderRadius"),
    // HACK: IE11 does not support padding-inline-* so we have to use
    // directional padding-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   paddingInlineStart: t("spacingInsetDismissibleLeft"),
    //   paddingInlineEnd: `calc(${iconClickableXDelta}px - ${t(
    //           "spacingInsetDismissibleRight"
    //         )}px) `,
    // },
    paddingRight: "calc(".concat(iconClickableXDelta, "px - ").concat(t("spacingInsetDismissibleRight"), "px) "),
    paddingLeft: t("spacingInsetDismissibleLeft")
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    paddingRight: t("spacingInsetDismissibleLeft"),
    paddingLeft: "calc(".concat(iconClickableXDelta, "px - ").concat(t("spacingInsetDismissibleRight"), "px)")
  }), (0, _defineProperty2["default"])(_css, "display", "inline-flex"), (0, _defineProperty2["default"])(_css, "alignItems", "center"), (0, _defineProperty2["default"])(_css, "justifyContent", "center"), (0, _defineProperty2["default"])(_css, "height", t("height")), (0, _defineProperty2["default"])(_css, "lineHeight", "".concat(t("height"), "px")), (0, _defineProperty2["default"])(_css, "whiteSpace", "nowrap"), (0, _defineProperty2["default"])(_css, "& > button", (_button = {
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   marginInlineStart: `calc(${t("spacingHorizontal")}px - ${iconClickableXDelta}px)`,
    // },
    marginLeft: "calc(".concat(t("spacingHorizontal"), "px - ").concat(iconClickableXDelta, "px)")
  }, (0, _defineProperty2["default"])(_button, "[dir=\"rtl\"] &", {
    marginRight: "calc(".concat(t("spacingHorizontal"), "px - ").concat(iconClickableXDelta, "px)"),
    marginLeft: 0
  }), (0, _defineProperty2["default"])(_button, "lineHeight", 0), _button)), _css));
}, ["type"]);
var buttonStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var focus = _ref2.focus;
  var iconClickableXDelta = (clickTargetSize - t("closeIconSize")) / 2;
  return (0, _emotion.css)((0, _focusRing["default"])(t.tokens, {
    focus: focus,
    borderRadius: 999,
    offset: 4 - iconClickableXDelta
  }), {
    width: clickTargetSize,
    height: clickTargetSize,
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center"
  });
}, ["focus"]);
var closeIconStyles = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var type = _ref3.type;
  return (0, _emotion.css)({
    width: t("closeIconSize"),
    height: t("closeIconSize"),
    color: t("closeIconColorDismissible", [type, "default"]),
    "button:hover &": {
      color: t("closeIconColorDismissible", [type, "hover"])
    },
    "button:active &": {
      color: t("closeIconColorDismissible", [type, "pressed"])
    },
    transition: t.transitionCss("closeIconMotion", "color")
  });
}, ["type"]);
/**
 * Component
 */

var DissmissibleTag = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_tag["default"], "tag");

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: styles(t, {
      type: props.type
    }),
    ref: ref,
    "aria-label": props["aria-label"]
  }, passThroughProps), /*#__PURE__*/_react["default"].createElement("span", null, props.children), /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({
    onClick: props.onClose,
    className: buttonStyles(t, {
      focus: focus && focusTrigger === "keyboard"
    })
  }, focusProps, {
    tabIndex: props.tabIndex,
    "aria-label": props.closeLabel
  }), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: closeIconStyles(t, props),
    tokens: _closeKnockout["default"]
  })));
});

DissmissibleTag.displayName = "DissmissibleTag";
DissmissibleTag.propTypes =  false ? {
  children: _propTypes["default"].string.isRequired,
  onClose: _propTypes["default"].func.isRequired,
  "aria-label": _propTypes["default"].string,
  closeLabel: _propTypes["default"].string,
  tabIndex: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(["theme", "neutral"])
} : {};
DissmissibleTag.defaultProps = {
  type: "theme"
};
var _default = DissmissibleTag;
exports["default"] = _default;

/***/ }),
/* 590 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCloseKnockoutData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M9.411 8.003l2.126-2.126a1 1 0 10-1.414-1.414L7.998 6.588l-2.12-2.124a1 1 0 10-1.416 1.412l2.122 2.126-2.121 2.12a1 1 0 001.414 1.415l2.12-2.12 2.115 2.12a1 1 0 101.416-1.413L9.41 8.004zM8 16A8 8 0 118 0a8 8 0 010 16z' fill='currentColor' fill-rule='nonzero'/%3e%3c/svg%3e",
  iconCloseKnockoutWidth: 16,
  iconCloseKnockoutHeight: 16
};

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * This class is currently used by floor view to show the bin details
 */var BinTableCell=function(_Component){_inherits(BinTableCell,_Component);function BinTableCell(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BinTableCell);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BinTableCell.__proto__||Object.getPrototypeOf(BinTableCell)).call.apply(_ref,[this].concat(args))),_this),_this.getBag=function(bin){// For AR Next Gen, we only show the details for the bag that is currently attached to the bin
if(bin.bags&&bin.bags.length===1){return bin.bags[0];}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BinTableCell,[{key:"render",value:function render(){var bin=this.props.bin;var bag=this.getBag(bin);return bag?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table_table_cell___default.a,{columnSpan:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"bin.bin",defaultMessage:"Bin"})," ",bin.binLabel,"\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"bin.bag",defaultMessage:"Bag"})," ",bag.bagLabel,": (",bag.childCount,") packages"):null;}}]);return BinTableCell;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BinTableCell);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * This class is currently used by floor view to show the details for packages in a hybrid cart
 */var OVBinTableCell=function(_Component){_inherits(OVBinTableCell,_Component);function OVBinTableCell(){_classCallCheck(this,OVBinTableCell);return _possibleConstructorReturn(this,(OVBinTableCell.__proto__||Object.getPrototypeOf(OVBinTableCell)).apply(this,arguments));}_createClass(OVBinTableCell,[{key:"render",value:function render(){var cart=this.props.cart;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table_table_cell___default.a,{columnSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"ov.bin",defaultMessage:"OV Bin"})," ",cart.label,".OV: (",cart.packageCount,") packages");}}]);return OVBinTableCell;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (OVBinTableCell);

/***/ }),
/* 593 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    breadcrumbForegroundColorDefault: tokens.themeForegroundAccentDefault,
    breadcrumbForegroundColorHover: tokens.themeForegroundAccentHover,
    breadcrumbForegroundColorPressed: tokens.themeForegroundAccentPressed,
    breadcrumbForegroundColorSelected: tokens.themeForegroundPrimaryDefault,
    breadcrumbSeparatorColor: tokens.themeBorderSecondaryDefault,
    breadcrumbSpacingHorizontal: 24,
    breadcrumbFontSize: 14,
    breadcrumbLineHeight: "20px",
    breadcrumbMotionDuration: "100ms",
    breadcrumbMotionFunction: "ease"
  }
};

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var listReset = {
  listStyle: "none",
  padding: 0,
  margin: 0
};
var _default = listReset;
exports["default"] = _default;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _chevronRightSmall = _interopRequireDefault(__webpack_require__(137));

var _context = _interopRequireDefault(__webpack_require__(255));

var _useFocus2 = _interopRequireDefault(__webpack_require__(40));

var _clickable = _interopRequireDefault(__webpack_require__(64));

var _tooltip = _interopRequireDefault(__webpack_require__(67));

var _text = _interopRequireDefault(__webpack_require__(27));

var _noTextWrap = _interopRequireDefault(__webpack_require__(110));

var _focusRing = _interopRequireDefault(__webpack_require__(43));

var _getIconCss = _interopRequireDefault(__webpack_require__(83));

var _token = __webpack_require__(12);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var chevronIcon = (0, _token.getIconFromTokens)(_chevronRightSmall["default"]);

var chevronStyles = function chevronStyles(t, backgroundImage) {
  return {
    content: "''",
    display: "block",
    width: t("spacingHorizontal"),
    height: chevronIcon.height,
    backgroundImage: (0, _getIconCss["default"])(backgroundImage, t("separatorColor")),
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    // Center the icon just to the left of the breadcrumb
    position: "absolute",
    right: "100%",
    top: "50%",
    marginTop: -(chevronIcon.height / 2)
  };
};

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _css;

  var focus = _ref.focus,
      selected = _ref.selected;
  return (0, _emotion.css)((0, _text["default"])(t), (_css = {
    // This helps with the absolutely-positioned chevron icon.
    position: "relative",
    // Set a min width of 0 to allow truncation of text inside a flex child.
    // This does not work in IE11.
    // See: https://stackoverflow.com/a/36247448/2747759
    minWidth: 0,
    // Add spacing between breadcrumbs
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // "li + &": {
    //   marginInlineStart: t("spacingHorizontal"),
    // },
    "li + &": (0, _defineProperty2["default"])({
      marginLeft: t("spacingHorizontal"),
      marginRight: 0
    }, "[dir=\"rtl\"] &", {
      marginLeft: 0,
      marginRight: t("spacingHorizontal")
    }),
    // Add an chevron icon to the left of the breadcrumb (unless it's the
    // first one).
    "&:not(:first-of-type):before": chevronStyles(t, chevronIcon.data)
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &:not(:last-of-type):before", chevronStyles(t, chevronIcon.dataRtl)), (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &:last-of-type:before", {
    display: "none"
  }), (0, _defineProperty2["default"])(_css, "& > a, & > button", (0, _emotion.css)(_noTextWrap["default"], {
    display: "block",
    color: t("foregroundColor", selected ? "selected" : "default"),
    cursor: selected ? "default" : "pointer",
    transition: t.transitionCss("motion", "color"),
    ":hover": !selected ? {
      color: t("foregroundColorHover")
    } : undefined,
    ":active": !selected ? {
      color: t("foregroundColorPressed")
    } : undefined
  })), _css), (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: 4
  }));
}, ["focus", "selected"]);
/**
 * Used to render a single breadcrumb in a group of breadcrumbs. Place this as
 * a child of the BreadcrumbGroup component.
 */

var Breadcrumb = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var truncate = props.truncate,
      children = props.children;

  var _useContext = (0, _react.useContext)(_context["default"]),
      t = _useContext.t,
      selected = _useContext.selected;

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]); // Wrap the breadcrumb in a tooltip if the `truncate` prop is set to true.

  var MaybeTooltip = (0, _react.useCallback)(function (props) {
    return truncate ? /*#__PURE__*/_react["default"].createElement(_tooltip["default"], (0, _extends2["default"])({
      title: children,
      position: "bottom"
    }, props)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, props);
  }, [truncate, children]);
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: styles(t, {
      focus: focus && focusTrigger === "keyboard",
      selected: selected
    })
  }, /*#__PURE__*/_react["default"].createElement(MaybeTooltip, null, /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, focusProps, {
    "aria-current": selected ? "page" : undefined,
    disabled: selected,
    href: props.href,
    onClick: props.onClick,
    ref: ref
  }), props.truncate ? "…" : props.children)));
});

Breadcrumb.displayName = "Breadcrumb";
Breadcrumb.propTypes =  false ? {
  /**
   * The text to show in the breadcrumb. This is generally the title of the page
   * that the breadcrumb links to.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * The URL of the page that the breadcrumb links to.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * Set this to `true` to display the breadcrumb in a truncated format. Only
   * ellipsis will be shown in the UI. The full title will appear in a tooltip
   * on hover or focus.
   *
   * If this is `false` the breadcrumb may still be partially truncated by the
   * browser if there is not enough room in the layout for all breadcrumbs to be
   * shown.
   *
   * NOTE: Automatic truncation is not supported in IE11. If you support IE11
   * and your breadcrumbs do not fit in the layout please use this `truncate`
   * prop.
   *
   * @since 5.x
   */
  truncate: _propTypes["default"].bool,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func
} : {};
var _default = Breadcrumb;
exports["default"] = _default;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _input = _interopRequireDefault(__webpack_require__(597));

var _default = _input["default"];
exports["default"] = _default;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(48));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _uniqueId = _interopRequireDefault(__webpack_require__(51));

var _noop = _interopRequireDefault(__webpack_require__(37));

var _emotion = __webpack_require__(4);

var _input = _interopRequireDefault(__webpack_require__(256));

var _theme = __webpack_require__(14);

var _inputBox = _interopRequireDefault(__webpack_require__(257));

var _supportTextWrapper = _interopRequireDefault(__webpack_require__(258));

var _inputReset = _interopRequireDefault(__webpack_require__(259));

var _token = __webpack_require__(12);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

var _getSupportTextAriaDescribedby = _interopRequireDefault(__webpack_require__(260));

var _functional = __webpack_require__(26);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var widthStyles = (0, _functional.memoizeByKeys)(function (_ref) {
  var width = _ref.width;
  return (0, _emotion.css)({
    width: width,
    // If an explicit width is set then don't allow the input to flex
    flex: width ? "none !important" : undefined
  });
}, ["width"]);
var inputStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var size = _ref2.size,
      disabled = _ref2.disabled,
      empty = _ref2.empty;
  return (0, _emotion.css)((0, _inputReset["default"])({
    empty: empty,
    textColor: t("foregroundColor", disabled ? "disabled" : "default"),
    placeholderColor: t("placeholderColor", disabled ? "disabled" : "default")
  }), {
    height: t("lineHeight", size),
    lineHeight: t("lineHeight", size),
    textOverflow: "ellipsis"
  });
}, ["size", "disabled", "empty"]);
var inputModes = {
  email: "email",
  // TODO: Add number -> decimal in 6.x. We can't add inside 5.x because some mobile
  // browsers do not show the minus sign for inputmode="decimal" which could break
  // end-user interaction.
  // number: "decimal",
  search: "search",
  tel: "tel",
  text: "text",
  url: "url"
};

var Input = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_input["default"], "input");

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      focusState = _useState2[0],
      setFocusState = _useState2[1];

  var inputRef = (0, _react.useRef)();
  var idProp = props.id;
  var id = (0, _react.useMemo)(function () {
    return idProp || (0, _uniqueId["default"])("input-");
  }, [idProp]);
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]); // Make sure we never allow a value of `undefined` or `null`, which would put
  // the underlying input element in an uncontrolled state and allow the DOM and
  // the component to get out of sync.

  var value = props.value === undefined || props.value === null ? "" : props.value;
  var focus = props.focus !== undefined ? props.focus : focusState;
  var mask = props.type === "password" ? undefined : props.mask;
  var empty = value === "" && (!mask || !focus);
  var onChangeProp = props.onChange,
      onFocusProp = props.onFocus,
      onBlurProp = props.onBlur;
  var onChange = (0, _react.useCallback)(function (event) {
    var value = event.target.value;
    var pattern = mask ? undefined : props.pattern ? props.pattern : props.type === "number" ? /^(-?)([0-9]*)(\.?)([0-9]*)$/ : undefined;

    if (!props.disabled && (!pattern || value === "" || value.match(pattern))) {
      onChangeProp(value);
    }
  }, [props.pattern, props.type, props.disabled, mask, onChangeProp]);
  /**
   * Focus on the input anytime the user mouses down on the container. This
   * mimicks the default browser behavior when a user mouses down on an input.
   */

  var onMouseDownContainer = (0, _react.useCallback)(function (event) {
    if (inputRef.current && event.target !== inputRef.current) {
      event.preventDefault();
      inputRef.current.focus();
    }
  }, [inputRef]);
  var onFocus = (0, _react.useCallback)(function (event) {
    setFocusState(true);
    onFocusProp(event);
  }, [setFocusState, onFocusProp]);
  var onBlur = (0, _react.useCallback)(function (event) {
    setFocusState(false);
    onBlurProp(event);
  }, [setFocusState, onBlurProp]);
  var prefixId = props.prefix ? "".concat(id, "-prefix") : undefined;
  var suffixId = props.suffix ? "".concat(id, "-suffix") : undefined; // If there is not helperText, constraintText, errorMessage, prefix,
  // or suffix then the aria-describedby is empty.

  var ariaDescribedbyProp = {
    "aria-describedby": passThroughProps["aria-describedby"] ? passThroughProps["aria-describedby"] : props.helperText || props.constraintText || props.errorMessage || prefixId || suffixId ? [prefixId, suffixId, (0, _getSupportTextAriaDescribedby["default"])({
      id: id,
      hasHelperText: !!props.helperText,
      hasConstraintText: !!props.constraintText,
      hasErrorMessage: !!props.errorMessage,
      errorMessageFirst: props.size === "xlarge"
    })].filter(Boolean).join(" ") : undefined
  };

  var inputProps = _objectSpread(_objectSpread({
    "aria-label": props.label
  }, passThroughProps), {}, {
    onFocus: onFocus,
    onBlur: onBlur,
    className: (0, _emotion.cx)(inputStyles(t, _objectSpread(_objectSpread({}, props), {}, {
      empty: empty
    })), props.className),
    id: id,
    // HACK: https://sim.amazon.com/issues/P17584529
    type: props.type === "number" ? "text" : props.type,
    placeholder: props.placeholder,
    value: value,
    onChange: onChange,
    disabled: props.disabled,
    name: props.name,
    autoFocus: props.autoFocus || props.inaccessibleAutoFocus,
    autoComplete: props.autoFill ? undefined : "off",
    onKeyDown: props.onKeyDown,
    spellCheck: props.spellcheck,
    inputMode: props.inputMode || inputModes[props.type],
    role: props.role
  }, ariaDescribedbyProp); // react-input-mask only supports callback refs, so we have to wrap our object
  // ref in a callback to make it happy.


  var maskInputRef = (0, _react.useCallback)(function (node) {
    return inputRef.current = node;
  }, [inputRef]); // Pass our internal inputRef on up to the forwarded ref. This allows us to
  // use the input ref internally (e.g. see onMouseDownContainer) and still give
  // the parent access to it.

  (0, _react.useImperativeHandle)(ref, function () {
    return inputRef.current;
  }, [inputRef]);
  return /*#__PURE__*/_react["default"].createElement(_supportTextWrapper["default"], {
    id: id,
    helperText: props.helperText,
    constraintText: props.constraintText,
    errorMessage: props.errorMessage,
    helperBelowFormField: props.size === "xlarge",
    className: widthStyles({
      width: props.width
    })
  }, /*#__PURE__*/_react["default"].createElement(_inputBox["default"], {
    size: props.label ? "xlarge" : props.size,
    label: props.label,
    prefix: props.prefix,
    suffix: props.suffix,
    error: props.error,
    disabled: props.disabled,
    focus: focus,
    empty: empty,
    width: props.width,
    onMouseDown: onMouseDownContainer,
    htmlFor: id,
    cursor: "text",
    prefixIconTokens: props.prefixIconTokens,
    suffixIconTokens: props.suffixIconTokens,
    prefixId: prefixId,
    suffixId: suffixId
  }, mask ? mask.getElement(_objectSpread(_objectSpread({}, inputProps), {}, {
    inputRef: maskInputRef
  }), // If we're forcing focus on an input with a mask that only
  // shows on focus (!alwaysShow), then force the mask too.
  props.focus !== undefined && !mask.alwaysShow ? {
    alwaysShow: props.focus
  } : {}) : /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, inputProps, {
    ref: inputRef
  })), props.children));
});

Input.displayName = "Input";
Input.propTypes =  false ? {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * If adding a label with `aria-label`, first consider using the `label` prop
   * which will add a visible label and set the size to `xlarge`.
   *
   * @since 5.x
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Allow the browser to suggest auto-fill values for this input.
   *
   * Note that not all browsers respect this property. Some browsers (e.g.
   * Chrome 78) may choose to *always* allow auto-fill regardless of the value
   * of this property.
   */
  autoFill: _propTypes["default"].bool,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * Specify custom children that will be rendered as adjacent siblings to the
   * text input element.
   *
   * This is an advanced feature designed to allow custom overlays on an input.
   * You should not need this prop unless you are building an advanced component
   * on top of the input.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * Add constraint text to provide critical information regarding input content.
   *
   * @since 5.21.0
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with an `errorMessage`.
   */
  error: _propTypes["default"].bool,

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the Input.
   *
   * @since 5.21.0
   */
  errorMessage: _propTypes["default"].string,

  /**
   * This can be used to force the visible focus state of the input on or off.
   * This only affects the display of the focus ring, it does not change the
   * focus state of the input as far as the browser is concerned.
   *
   * Note that this should only be used when the input is still functionally
   * focused, despite not having the user's actual focus (e.g. typing would still
   * update the value of the input). This situation is only likely if you're
   * composing the Input with other components to build a more complex input
   * control.
   */
  focus: _propTypes["default"].bool,

  /**
   * Add helper text to provide additional instruction.
   *
   * @since 5.21.0
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * An id for the input that is unique among other inputs.
   *
   * This is only necessary if you need to use an input `size` other than xlarge
   * and want to add your own custom label for the specific input id,
   * eg: <Text tag="label" htmlFor="my-custom-id"/>
   *
   * It is recommended to use the `label` prop for almost all other cases,
   * which will set the `size` of the input to xlarge.
   *
   * @since 5.x
   */
  id: _propTypes["default"].string,

  /**
   * If set to true then the input will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since  5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * Useful for setting the keyboard for mobile browsers. For example, to display
   * a numeric keyboard:
   *
   * ```
   * // With decimal key
   * <Input type="number" inputMode="decimal" />
   *
   * // Without decimal
   * <Input type="number" inputMode="numeric" />
   * ```
   *
   * See docs for the [inputmode](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/inputmode)
   * for list of valid options, descriptions, and browser compatibility.
   *
   * Note: While `inputmode` is not "compatible" with all browsers no [supported
   * browsers](https://meridian.a2z.com/for-developers/react-web/getting-started/?platform=react-web#h4-browser-support)
   * will break or throw errors when the `inputmode` attribute is present.
   *
   * @since 5.14.0
   */
  inputMode: _propTypes["default"].string,

  /**
   * A label for the input.
   *
   * If this prop is provided the `size` prop will be ignored and set to `xlarge`.
   */
  label: _propTypes["default"].string,

  /**
   * Mask the input's value in order to force it to conform to a particular
   * format or template.
   *
   * This is helpful for things like formatting phone numbers:
   *
   * ```
   * import Input from "@amzn/meridian/input"
   * import InputMask from "@amzn/meridian/input/mask"
   *
   * const phoneMask = new InputMask("(###)###-####")
   * <Input type="tel" mask={phoneMask} />
   * ```
   *
   * The string passed to the mask accepts three special placeholder characters
   * by default:
   * - `"#"` - A placeholder for any digit [0-9]
   * - `"x"` - A placeholder for any latin character [A-Za-z]
   * - `"*"` - A placeholder for any latin character or digit [A-Za-z0-9]
   *
   * Custom placeholder characters can be set by passing an object of options as
   * the second argument to `InputMask`:
   *
   * ```
   * new InputMask("(^^^)^^^-^^^", { formatChars: { "^": "[1-8]" } })
   * ```
   *
   * Note that if the input type is "password" then this prop will be ignored.
   * Note that input masks should not be blank and should always include template
   * characters to indicate to the user that the input is masked.
   * Note that if custom placeholder characters are set, defaults are overridden.
   */
  mask: _propTypes["default"].object,

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * This can be used to ensure that input matches a specific pattern defined
   * by a regular expression. If the user tries to enter a value that does not
   * match the pattern then `onChange` will simply not be triggered.
   *
   * Note that if the input type is `"password"` or an input mask is provided via the
   * `mask` prop then this prop will be ignored.
   */
  pattern: _propTypes["default"].instanceOf(RegExp),

  /**
   * Text that is shown in place of the input's value when the input is empty.
   *
   * This text is not visible when a value is entered in the input, so it should
   * not contain essential information that should be persisted. For that,
   * consider using the `label` prop.
   */
  placeholder: _propTypes["default"].string,

  /**
   * Static text to show in an end-cap prepended to the component.
   *
   * To add a selectable prefix, see the `InputGroup` component.
   */
  prefix: _propTypes["default"].string,

  /**
   * Pass an object of icon tokens here (imported from `@amzn/meridian-tokens/base/icon/<icon-name>`)
   * in order to show an icon prepended to the input's text-entry area.
   */
  prefixIconTokens: _propTypes["default"].object,

  /**
   * An accessible ARIA role for the component.
   *
   * See docs for [permitted input roles](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#technical_summary)
   * for details on appropriate usage.
   *
   * @since 5.24.0
   */
  role: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   *
   * If the `label` prop is provided this prop will be ignored (the label
   * requires a particular amount of space which is not configurable).
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * Enable or disable spellchecking on the Input. See [the MDN documentation for `spellcheck`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck).
   *
   * @since 5.18.0
   */
  spellcheck: _propTypes["default"].bool,

  /**
   * Static text to show in an end-cap appended to the component.
   *
   * To add a selectable suffix, see the `InputGroup` component.
   */
  suffix: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Pass an object of icon tokens here (imported from `@amzn/meridian-tokens/base/icon/<icon-name>`)
   * in order to show an icon appended to the input's text-entry area.
   */
  suffixIconTokens: _propTypes["default"].object,

  /**
   * The data type of the input's value.
   */
  type: _propTypes["default"].oneOf(["date", "email", "number", "password", "search", "tel", "text", "url", "time"]),

  /**
   * The value of the input.
   *
   * Update this when `onChange` is called to ensure the component is interactive
   * (see the documentation for the `onChange` prop).
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by typing in the input). The new value will be
   * passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   *
   * Note: For Inputs with `type="number"`, the new value passed to `onChange`
   * will be a `string` _not_ a `number`. The `string` type is necessary for
   * allowing users to enter floats like `1.5`. To arrive at `1.5`, a user needs
   * to enter the partial value `1.`. At this point, parsing the partial value
   * with `parseFloat` or `parseInt` will remove the decimal point, effectively
   * blocking the user from completing their entry.
   */
  onChange: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func
} : {};
Input.defaultProps = {
  size: "medium",
  type: "text",
  onFocus: _noop["default"],
  onBlur: _noop["default"],
  children: null,
  value: "",
  autoFill: true
};
var _default = Input;
exports["default"] = _default;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _input = _interopRequireDefault(__webpack_require__(256));

var _context = _interopRequireDefault(__webpack_require__(599));

var _theme = __webpack_require__(14);

var _useColorScheme = _interopRequireDefault(__webpack_require__(206));

var _getIconCss = _interopRequireDefault(__webpack_require__(83));

var _token = __webpack_require__(12);

var _focusRing = _interopRequireDefault(__webpack_require__(43));

var _text = _interopRequireDefault(__webpack_require__(27));

var _noTextWrap = _interopRequireDefault(__webpack_require__(110));

var _rtl = __webpack_require__(52);

var _borderRadius = _interopRequireDefault(__webpack_require__(100));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Styles
 */

/* Styles for the root element */
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _css;

  var cursor = _ref.cursor,
      size = _ref.size,
      fontSize = _ref.fontSize,
      focus = _ref.focus,
      error = _ref.error,
      disabled = _ref.disabled,
      width = _ref.width,
      borderWidthLtr = _ref.borderWidthLtr,
      borderWidthRtl = _ref.borderWidthRtl,
      _ref$borderSides = _ref.borderSides,
      borderSides = _ref$borderSides === void 0 ? [] : _ref$borderSides,
      inputBorderRadius = _ref.inputBorderRadius,
      colorScheme = _ref.colorScheme;
  var state = disabled ? "disabled" : focus ? "focus" : error ? "error" : "default";
  return (0, _emotion.css)((0, _text["default"])(t, {
    fontSize: fontSize || size,
    lineHeight: "default",
    color: disabled ? "disabled" : "default"
  }), (_css = {
    display: "flex",
    boxSizing: "border-box",
    flexDirection: "row",
    justifyContent: "stretch",
    cursor: disabled ? "not-allowed" : cursor,
    backgroundColor: t("backgroundColor", state),
    colorScheme: colorScheme,
    height: t("height", size),
    maxWidth: t("widthMax"),
    width: width,
    outline: "none",
    // If an explicit width is set then don't allow the input to flex
    flex: width ? "none !important" : undefined,
    borderWidth: borderWidthLtr ? borderWidthLtr : t("borderWidth"),
    borderRadius: borderSides.length > 0 ? (0, _borderRadius["default"])(inputBorderRadius, borderSides) : t("borderRadius")
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    borderRadius: borderSides.length > 0 ? (0, _borderRadius["default"])(inputBorderRadius, borderSides.map(function (borderSide) {
      return (0, _rtl.getRtl)(borderSide);
    })) : t("borderRadius"),
    borderWidth: borderWidthRtl ? borderWidthRtl : t("borderWidth")
  }), (0, _defineProperty2["default"])(_css, "borderColor", t("borderColor", state)), (0, _defineProperty2["default"])(_css, "borderStyle", "solid"), _css), !disabled ? (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    error: error,
    offset: 1,
    dropShadow: true,
    borderWidth: t("focusRingBorderWidth"),
    borderRadius: inputBorderRadius ? inputBorderRadius + 1 : t("borderRadius"),
    borderSides: borderSides
  }) : undefined);
}, ["cursor", "size", "fontSize", "focus", "error", "disabled", "width", "borderWidthLtr", "borderWidthRtl", "borderSides", "inputBorderRadius", "colorScheme"]);
/* Styles for each segment of the input (e.g. an endcap, an icon, the input
container) */

var columnStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var size = _ref2.size,
      label = _ref2.label;
  var horizontalPadding = t("spacingInsetHorizontal");
  var verticalPadding = t("spacingInsetVertical", size); // If we have a label then reduce the top padding until the label is the same
  // number of pixels from the top as the original top padding when it's floated
  // down over the input

  var topPadding = label && verticalPadding > 0 ? verticalPadding - t("labelFloatDistance", size) : verticalPadding;
  return (0, _emotion.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "".concat(topPadding, "px ").concat(horizontalPadding, "px ").concat(verticalPadding, "px ").concat(horizontalPadding, "px")
  });
}, ["size", "label"]);

var endcapBorderShadow = function endcapBorderShadow(t, _ref3) {
  var state = _ref3.state,
      side = _ref3.side;
  return side === "left" ? " 1px 0 0 0 ".concat(t("borderColor", state)) : "-1px 0 0 0 ".concat(t("borderColor", state));
};
/* Styles for the prefix/suffix caps on either end of the input */


var endcapStyles = (0, _token.memoizeTokenStyles)(function (t, _ref4) {
  var disabled = _ref4.disabled,
      side = _ref4.side,
      size = _ref4.size,
      label = _ref4.label;
  var state = disabled ? "disabled" : "default";
  return (0, _emotion.css)(columnStyles(t, {
    size: size,
    label: label
  }), (0, _defineProperty2["default"])({
    flexShrink: 0,
    backgroundColor: t("endcapBackgroundColor"),
    borderRadius: (0, _borderRadius["default"])(t("endcapBorderRadius"), side === "left" ? ["topLeft", "bottomLeft"] : ["topRight", "bottomRight"]),
    boxShadow: endcapBorderShadow(t, {
      state: state,
      side: side
    })
  }, "[dir=\"rtl\"] &", {
    borderRadius: (0, _borderRadius["default"])(t("endcapBorderRadius"), side === "left" ? ["topRight", "bottomRight"] : ["topLeft", "bottomLeft"]),
    boxShadow: endcapBorderShadow(t, {
      state: state,
      side: (0, _rtl.getRtl)(side)
    })
  }), _noTextWrap["default"]);
}, ["disabled", "side", "size", "label"]);
/* Styles for everything in-between the endcaps */
// since the aislestyle and columnstyle shares the same attributes
// we can memoize them together

var aisleStyles = (0, _token.memoizeTokenStyles)(function (t, _ref5) {
  var size = _ref5.size,
      label = _ref5.label;
  return (0, _emotion.css)(columnStyles(t, {
    size: size,
    label: label
  }), {
    flex: "auto",
    overflow: "hidden"
  });
}, ["size", "label"]);
var labelStyles = (0, _token.memoizeTokenStyles)(function (t, _ref6) {
  var _css3;

  var animated = _ref6.animated,
      focus = _ref6.focus,
      disabled = _ref6.disabled,
      floated = _ref6.floated,
      size = _ref6.size;
  var colorState = disabled ? "disabled" : focus ? "focus" : "default";
  return (0, _emotion.css)((_css3 = {
    display: "block",
    cursor: "inherit",
    color: t("labelColor", colorState),
    fontSize: t("labelFontSizeDefault"),
    marginBottom: t("spacingVertical"),
    transformOrigin: "top left"
  }, (0, _defineProperty2["default"])(_css3, "[dir=\"rtl\"] &", {
    transformOrigin: "top right"
  }), (0, _defineProperty2["default"])(_css3, "transform", floated ? "translateY(0px) scale(".concat(t("labelFontSizeFloated") / t("labelFontSizeDefault"), ")") : "translateY(".concat(t("labelFloatDistance", size), "px) scale(1)")), (0, _defineProperty2["default"])(_css3, "transition", animated ? t.transitionCss("labelMotion", ["color", "transform"]) : undefined), _css3), _noTextWrap["default"]);
}, ["animated", "focus", "disabled", "floated", "size"]);
var iconStyles = (0, _token.memoizeTokenStyles)(function (t, _ref7) {
  var _css4;

  var tokens = _ref7.tokens,
      disabled = _ref7.disabled,
      position = _ref7.position;
  var state = disabled ? "disabled" : "default";

  var _getIconFromTokens = (0, _token.getIconFromTokens)(tokens),
      width = _getIconFromTokens.width,
      data = _getIconFromTokens.data;

  return (0, _emotion.css)((_css4 = {
    flexShrink: 0,
    width: width,
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   marginInlineStart:
    //    position === "prefix"
    //      ? t("spacingInsetHorizontal")
    //      : 0,
    //   marginInlineEnd:
    //    position == "prefix"
    //      ? 0
    //      : t("spacingInsetHorizontal"),
    // },
    margin: position === "prefix" ? "0 0 0 ".concat(t("spacingInsetHorizontal"), "px") : "0 ".concat(t("spacingInsetHorizontal"), "px 0 0")
  }, (0, _defineProperty2["default"])(_css4, "[dir=\"rtl\"] &", {
    margin: position === "prefix" ? "0 ".concat(t("spacingInsetHorizontal"), "px 0 0") : "0 0 0 ".concat(t("spacingInsetHorizontal"), "px")
  }), (0, _defineProperty2["default"])(_css4, "backgroundImage", (0, _getIconCss["default"])(data, t("foregroundColor", state))), (0, _defineProperty2["default"])(_css4, "backgroundPosition", "center"), (0, _defineProperty2["default"])(_css4, "backgroundRepeat", "no-repeat"), _css4));
}, ["tokens", "disabled", "position"]);
var childrenStyles = (0, _token.memoizeTokenStyles)(function (t, _ref8) {
  var size = _ref8.size,
      disabled = _ref8.disabled,
      empty = _ref8.empty,
      label = _ref8.label,
      floated = _ref8.floated;
  var state = disabled ? "disabled" : "default";
  return (0, _emotion.css)({
    position: "relative",
    color: empty ? t("placeholderColor", state) : undefined,
    minHeight: t("lineHeight", size),
    lineHeight: t("lineHeight", size),
    opacity: label && !floated ? 0 : 1,
    pointerEvents: disabled ? "none" : undefined
  });
}, ["size", "disabled", "empty", "label", "floated"]);
/**
 * Component
 */

var InputBox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_input["default"], "input");
  var colorScheme = (0, _useColorScheme["default"])();

  var _useContext = (0, _react.useContext)(_context["default"]),
      onFocus = _useContext.onFocus,
      onBlur = _useContext.onBlur,
      borderWidthLtr = _useContext.borderWidthLtr,
      borderWidthRtl = _useContext.borderWidthRtl,
      borderSides = _useContext.borderSides,
      inputBorderRadius = _useContext.inputBorderRadius;

  var styleProps = _objectSpread(_objectSpread({}, props), {}, {
    // If we have a label then the size must be at least "xlarge"
    size: props.label && props.size !== "xlarge" && props.size !== "auto" ? "xlarge" : props.size,
    floated: !props.label || (props.labelFloated !== undefined ? props.labelFloated : !props.empty || props.focus),
    borderWidthLtr: borderWidthLtr,
    borderWidthRtl: borderWidthRtl,
    borderSides: borderSides,
    inputBorderRadius: inputBorderRadius,
    colorScheme: colorScheme
  });

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: styles(t, styleProps),
    onMouseDown: props.onMouseDown,
    onFocus: onFocus,
    onBlur: onBlur,
    "mdn-input-box": "",
    tabIndex: props.tabIndex
  }, passThroughProps, {
    role: props.role,
    ref: ref,
    id: props.id
  }), props.prefix ? /*#__PURE__*/_react["default"].createElement("div", {
    id: props.prefixId,
    className: endcapStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
      side: "left"
    }))
  }, props.prefix) : null, props.prefixIconTokens ? /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-input-box-prefix": "",
    "aria-hidden": "true",
    className: iconStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
      tokens: props.prefixIconTokens,
      position: "prefix"
    }))
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: aisleStyles(t, styleProps)
  }, props.label ? /*#__PURE__*/_react["default"].createElement("label", {
    className: labelStyles(t, styleProps),
    htmlFor: props.htmlFor,
    id: props.labelId,
    "aria-hidden": "true"
  }, props.label) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: childrenStyles(t, styleProps)
  }, props.children)), props.suffixIconTokens ? /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-input-box-suffix": "",
    "aria-hidden": "true",
    className: iconStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
      tokens: props.suffixIconTokens,
      position: "suffix"
    }))
  }) : null, props.suffix ? typeof props.suffix === "string" ? /*#__PURE__*/_react["default"].createElement("div", {
    id: props.suffixId,
    className: endcapStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
      side: "right"
    }))
  }, props.suffix) : props.suffix : null);
});

InputBox.displayName = "InputBox";
InputBox.propTypes =  false ? {
  animated: _propTypes["default"].bool,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * NOTE: This was added to improve the a11y of the Select component.
   *
   * @since 5.27.0
   */
  "aria-*": _propTypes["default"].string,
  children: _propTypes["default"].node,
  cursor: _propTypes["default"].oneOf(["default", "text", "pointer"]),

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,
  empty: _propTypes["default"].bool,

  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with a small error `Alert` component below
   * or to the right of the component explaining what the error is.
   */
  error: _propTypes["default"].bool,
  focus: _propTypes["default"].bool,
  fontSize: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),
  htmlFor: _propTypes["default"].string,
  id: _propTypes["default"].string,
  label: _propTypes["default"].string,

  /**
   * If this is set it will force the float state of the label. True = the
   * label is floated up above the input, false = the label is resting over
   * the input.
   */
  labelFloated: _propTypes["default"].bool,
  labelId: _propTypes["default"].string,

  /**
   * Static text to show in an end-cap prepended to the input.
   *
   * To add a selectable prefix to an input, see the `InputGroup` component.
   */
  prefix: _propTypes["default"].string,

  /**
   * Pass an object of icon tokens here (imported from `@amzn/meridian-tokens/base/icon/<icon-name>`)
   * in order to show an icon prepended to the input's text-entry area.
   */
  prefixIconTokens: _propTypes["default"].object,
  prefixId: _propTypes["default"].string,

  /**
   * An accessible ARIA role for the component.
   *
   * See docs for [permitted input roles](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#technical_summary)
   * for details on appropriate usage.
   *
   * NOTE: This was added to improve the a11y of Select by allowing a "combobox" role to be passed
   * to the InputBox.
   *
   * @since 5.27.0
   */
  role: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset. This will set the font-size
   * unless `fontSize` is also set.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge", "auto"]),

  /**
   * Static text to show in an end-cap appended to the input.
   *
   * To add a selectable suffix to an input, see the `InputGroup` component.
   */
  suffix: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Pass an object of icon tokens here (imported from `@amzn/meridian-tokens/base/icon/<icon-name>`)
   * in order to show an icon appended to the input's text-entry area.
   */
  suffixIconTokens: _propTypes["default"].object,
  suffixId: _propTypes["default"].string,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   *
   * Note: This was added to improve the a11y of Select.
   *
   * @since 5.27.0
   */
  tabIndex: _propTypes["default"].string,

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  onMouseDown: _propTypes["default"].func
} : {};
InputBox.defaultProps = {
  size: "medium",
  cursor: "default",
  animated: true
};
var _default = InputBox;
exports["default"] = _default;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _default = /*#__PURE__*/_react["default"].createContext({});

exports["default"] = _default;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _text = _interopRequireDefault(__webpack_require__(45));

var _alert = _interopRequireDefault(__webpack_require__(156));

var _column = _interopRequireDefault(__webpack_require__(15));

var SupportTextWrapper = function SupportTextWrapper(props) {
  return /*#__PURE__*/_react["default"].createElement(_column["default"], {
    className: props.className,
    spacing: "200"
  }, props.helperText && !props.helperBelowFormField && /*#__PURE__*/_react["default"].createElement(_text["default"], {
    id: "".concat(props.id, "-helper-text"),
    type: "b200",
    color: "secondary"
  }, props.helperText), props.children, props.errorMessage && /*#__PURE__*/_react["default"].createElement(_column["default"], {
    spacingInset: "100 none none none"
  }, /*#__PURE__*/_react["default"].createElement(_alert["default"], {
    id: "".concat(props.id, "-error-message"),
    type: "error",
    size: "small"
  }, props.errorMessage)), props.helperText && props.helperBelowFormField && /*#__PURE__*/_react["default"].createElement(_text["default"], {
    id: "".concat(props.id, "-helper-text"),
    type: "b200",
    color: "secondary"
  }, props.helperText), props.constraintText && /*#__PURE__*/_react["default"].createElement(_text["default"], {
    id: "".concat(props.id, "-constraint-text"),
    type: "b200",
    color: "secondary"
  }, props.constraintText));
};

SupportTextWrapper.displayName = "SupportTextWrapper";
SupportTextWrapper.propTypes =  false ? {
  children: _propTypes["default"].node.isRequired,

  /**
   * The id used for the child form field component.
   * This will be used to generate the id's for the support text.
   * EG: "my-input" as an id will become "my-input-helper-text"
   * for the helper text's id.
   */
  id: _propTypes["default"].string.isRequired,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * Add constraint text to provide critical information regarding form field content.
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the form field.
   */
  errorMessage: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * When some form fields are xlarge we want the helper text to be below the
   * form field instead of above it, like Input or Select.
   * For form fields without a size prop (like InputGroup) we want the
   * helper text below regardless - so we use this boolean to dictate
   * whether or not the helper text is above or below the component
   * that the SupportTextWrapper wraps.
   */
  helperBelowFormField: _propTypes["default"].bool,

  /**
   * Add helper text to provide additional instruction.
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node])
} : {};
var _default = SupportTextWrapper;
exports["default"] = _default;

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_context_DeviceLayoutContext__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_GridAllocationActions__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_GridAllocationUtil__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__gridAllocation_AisleInfo__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_loader__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_modal__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_button__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__gridAllocation_SortLocationInfo__ = __webpack_require__(618);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Component to render the grid allocation view
 */var GridAllocation=function(_Component){_inherits(GridAllocation,_Component);function GridAllocation(props){_classCallCheck(this,GridAllocation);var _this=_possibleConstructorReturn(this,(GridAllocation.__proto__||Object.getPrototypeOf(GridAllocation)).call(this,props));_this.onClickCloseButton=function(){_this.setState({isModalOpen:false});};_this.onClickAisleInfo=function(aisleInfo){_this.setState({isModalOpen:true,modalAisleInfo:aisleInfo});};_this.state={isModalOpen:false,modalAisleInfo:{}};return _this;}_createClass(GridAllocation,[{key:"componentDidMount",value:function componentDidMount(){// load the grid allocation data
this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_GridAllocationActions__["d" /* getGridAllocationDataForNode */])(Object(__WEBPACK_IMPORTED_MODULE_4__Utility__["m" /* getNodeId */])()));}},{key:"renderAisleAllocationData",value:function renderAisleAllocationData(){var _this2=this;var gridAllocationData=this.props.gridAllocationData;var clusterInfoMap=Object(__WEBPACK_IMPORTED_MODULE_8__utils_GridAllocationUtil__["c" /* unFlattenSortLocationsModel */])(gridAllocationData.sortLocations);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row___default.a,{width:"100%",widths:"fill"},Object.keys(clusterInfoMap).sort().map(function(clusterLabel,i){var aisleInfoMap=clusterInfoMap[clusterLabel].aisleInfoMap;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{key:"1",style:Object(__WEBPACK_IMPORTED_MODULE_8__utils_GridAllocationUtil__["b" /* getTableStyle */])("none")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",{key:"1"},Object.values(aisleInfoMap).sort(__WEBPACK_IMPORTED_MODULE_8__utils_GridAllocationUtil__["a" /* compareAisleInfoForSorting */]).map(function(aisleInfo,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__gridAllocation_AisleInfo__["a" /* default */],{key:i,aisleInfo:aisleInfo,onClickAisleInfo:_this2.onClickAisleInfo});}))));}));}},{key:"renderLoader",value:function renderLoader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{height:"400px",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_loader___default.a,null));}},{key:"renderErrorToast",value:function renderErrorToast(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert___default.a,{toast:true,size:"medium",type:"error"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"stow.error",defaultMessage:"Some Error Occured"}));}},{key:"renderModalForViewSortLocations",value:function renderModalForViewSortLocations(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_modal___default.a,{open:this.state.isModalOpen,scrollContainer:"modal",describedById:"sort-locations-modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.aisle",defaultMessage:"Aisle"})," ",this.state.modalAisleInfo?this.state.modalAisleInfo.label:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row___default.a,null,this.state.modalAisleInfo.sortLocations?Object.keys(this.state.modalAisleInfo.sortLocations).sort().map(function(columnLabel,i){var sortLocations=_this3.state.modalAisleInfo.sortLocations[columnLabel];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{key:"1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{key:"1",style:Object(__WEBPACK_IMPORTED_MODULE_8__utils_GridAllocationUtil__["b" /* getTableStyle */])("none")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",{key:"1"},sortLocations.sort().map(function(sortLocation,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__gridAllocation_SortLocationInfo__["a" /* default */],{key:i,sortLocationInfo:sortLocation});}))));}):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_button___default.a,{type:"primary",size:"small",onClick:this.onClickCloseButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"stow.close",defaultMessage:"Close"})))));}},{key:"render",value:function render(){var _props=this.props,loading=_props.loading,isError=_props.isError;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,isError?this.renderErrorToast():null,loading?this.renderLoader():this.renderAisleAllocationData(),this.renderModalForViewSortLocations());}}]);return GridAllocation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// Adapter to convert class component to functional component.
function classToFunctionAdapter(CustomComponent){return function WrappedComponent(props){var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_1__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),spacingInset_shorthand4=_useDeviceLayout.spacingInset_shorthand4;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomComponent,Object.assign({},props,{spacingInset_shorthand4:spacingInset_shorthand4}));};}var mapStateToProps=function mapStateToProps(state){return{loading:state.gridAllocationReducer.loading,gridAllocationData:state.gridAllocationReducer.gridAllocationData,isError:state.gridAllocationReducer.isError};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(classToFunctionAdapter(GridAllocation))));

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSortGridAllocationForNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MetricUtility__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(5);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="SCC_STOW";var metricName="getGridAllocationData";var getSortLocationForNodeEndPoint='/sls/get-sort-location-node';var spgProcessName="sortPathGenerator";/**
 * Get Sort grid reservation details for a given node
 *
 * @param nodeId identifier of the node
 * @returns {Promise<*>}
 */var getSortGridAllocationForNode=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(nodeId){var startTime,requestBody,request,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:startTime=Date.now();requestBody={stationCode:nodeId};request=getSortPathGeneratorAPIGatewayRequest(getSortLocationForNodeEndPoint,requestBody);_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(request);case 5:response=_context.sent;if(!(response.status===200)){_context.next=9;break;}Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context.abrupt("return",response.data);case 9:Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 10:case"end":return _context.stop();}}},_callee,this);}));return function getSortGridAllocationForNode(_x){return _ref.apply(this,arguments);};}();function getSortPathGeneratorAPIGatewayRequest(endpoint,request){var httpMethod=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"POST";return{resourcePath:endpoint,httpMethod:httpMethod,processName:spgProcessName,requestBody:request};}

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_GridAllocationUtil__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Renders the aisle info section in the grid allocation view
 */var AisleInfo=function(_Component){_inherits(AisleInfo,_Component);function AisleInfo(){_classCallCheck(this,AisleInfo);return _possibleConstructorReturn(this,(AisleInfo.__proto__||Object.getPrototypeOf(AisleInfo)).apply(this,arguments));}_createClass(AisleInfo,[{key:"render",value:function render(){var _props=this.props,aisleInfo=_props.aisleInfo,onClickAisleInfo=_props.onClickAisleInfo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:Object(__WEBPACK_IMPORTED_MODULE_3__utils_GridAllocationUtil__["b" /* getTableStyle */])("none"),onClick:function onClick(){return onClickAisleInfo(aisleInfo);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{key:"1",style:Object(__WEBPACK_IMPORTED_MODULE_3__utils_GridAllocationUtil__["b" /* getTableStyle */])("none")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,null,aisleInfo.label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{key:"2",style:Object(__WEBPACK_IMPORTED_MODULE_3__utils_GridAllocationUtil__["b" /* getTableStyle */])(aisleInfo.color)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,null,aisleInfo.reservedFor)));}}]);return AisleInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(AisleInfo)));

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ModalFooter", {
  enumerable: true,
  get: function get() {
    return _modalFooter["default"];
  }
});
exports["default"] = void 0;

var _modal = _interopRequireDefault(__webpack_require__(605));

var _modalFooter = _interopRequireDefault(__webpack_require__(264));

var _default = _modal["default"];
exports["default"] = _default;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _modal = _interopRequireDefault(__webpack_require__(263));

var _modalBox = _interopRequireWildcard(__webpack_require__(606));

var _theme = __webpack_require__(14);

var _scrim = _interopRequireDefault(__webpack_require__(268));

var _portal = _interopRequireDefault(__webpack_require__(160));

var _responsive = _interopRequireDefault(__webpack_require__(111));

var _animateMount = _interopRequireWildcard(__webpack_require__(269));

var _propTypes2 = _interopRequireDefault(__webpack_require__(77));

var _onDirectClick = _interopRequireDefault(__webpack_require__(270));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AnimateFadeScaleWithMount = (0, _animateMount["default"])(_animateMount.AnimateFadeScale);
/**
 * The scrim is the vertical scroll container, and uses flexbox to center the
 * modal in the viewport.
 */

var scrimStyles = (0, _emotion.css)({
  display: "flex",
  alignItems: "center",
  overflow: "auto"
});
/**
 * This wrapper uses margin "auto" to center the modal, but sets a max width and
 * height which force the modal to overflow to the bottom/right of the viewport
 * instead of oveflowing all sides (which looks funky and makes the top/left
 * content inaccessible). For details see:
 * https://stackoverflow.com/questions/33454533/cant-scroll-to-top-of-flex-item-that-is-overflowing-container
 */

var outerWrapperStyles = (0, _emotion.css)({
  maxWidth: "100%",
  maxHeight: "100%",
  margin: "auto"
});
/**
 * The inner wrapper applies a margin around the modal to ensure a certain
 * amount of scrim is always shown. Applying the margin here as opposed to on
 * the outer wrapper ensures that the margin below the modal is preserved even
 * if the modal overflows the viewport and requires scrolling (otherwise the
 * padding would disappear due to this problem:
 * https://www.brunildo.org/test/overscrollback.html).
 */

var innerWrapperStyles = (0, _emotion.css)({
  padding: "".concat(_modalBox.scrimSpacingVertical, "vh ").concat(_modalBox.scrimSpacingHorizontal, "vw"),
  // HACK: IE11 will only respect the max-height property of the modal if the
  // modal's parent is a flex column. See:
  // https://stackoverflow.com/questions/44635857/flexbox-max-height-issue-with-ie11
  display: "flex",
  flexDirection: "column"
});
/**
 * Don't bother updating the modal if it's persisting in a closed state.
 */

var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
  return !prevProps.open && !nextProps.open;
};
/**
 * Render a modal in the viewport. On desktop the modal will be shown with a
 * scrim behind it. On mobile the modal will be shown fullscreen. Only one modal
 * should be rendered at a time.
 *
 * NOTE: Do not mount a Modal inside an interactive element. The Modal's DOM
 * element will be rendered at the application root using a [React Portal](https://reactjs.org/docs/portals.html),
 * but events from the Modal will bubble up through the element where it was
 * mounted. If the element is interactive then this may result in unexpected
 * behavior (e.g. a click on the Modal being counted as a click on the element
 * where the Modal was mounted). The React team [recommends solving this](https://github.com/facebook/react/issues/11387#issuecomment-366142349)
 * by rendering the portal-based component *outside* of any interactive elements.
 */


var Modal = /*#__PURE__*/_react["default"].memo(function (props) {
  var t = (0, _theme.useTheme)(_modal["default"], "modal");
  var scrimRef = (0, _react.useRef)();
  var anchorRef = (0, _react.useRef)(); // We want an onClose callback, but only if props.onClose is defined

  var onCloseProp = props.onClose;
  var onCloseCallback = (0, _react.useCallback)(function () {
    if (anchorRef.current && anchorRef.current.focus) {
      anchorRef.current.focus();
    }

    onCloseProp();
  }, [onCloseProp, anchorRef]);
  var onCloseMaybe = onCloseProp ? onCloseCallback : undefined;
  (0, _react.useEffect)(function () {
    if (props.open) {
      // Remember the node that the modal was opened from. We'll try to focus on
      // this when the modal is closed. We put this logic in a side effect rather
      // then the `modalRef` callback b/c by the time that callback is called
      // it's too late and the `activeElement` might already be an auto-focused
      // element inside of the modal - negating the benefit of remembering which
      // node caused the modal to open.
      anchorRef.current = document.activeElement;
    }
  }, [props.open]);
  var modalRef = (0, _react.useCallback)(function (modalNode) {
    if (modalNode) {
      // Get the active element and check if it's inside of the modal
      var activeElementInsideModal = modalNode.contains(document.activeElement);

      if (!activeElementInsideModal) {
        // Focus the first node in the Modal
        modalNode.focus(); // Reset the scroll position of the scrim to counteract the browser
        // auto-scrolling to the focused node. Note that we have to wait one
        // event loop for this to work (otherwise we'd be resetting the scroll
        // *before* the browser auto-scrolls).
        // Prevent the browser from scrolling to the focused node to avoid a
        // jitter when the modal opens.
        // TODO: Update this to use the "preventScroll" focus option when Safari
        // implements that and we drop support for IE11.

        if (scrimRef.current) {
          setTimeout(function () {
            scrimRef.current.scrollTop = 0;
            scrimRef.current.scrollLeft = 0;
          }, 0);
        }
      }
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(AnimateFadeScaleWithMount, {
    open: props.open,
    duration: t("motionDuration"),
    easing: t("motionFunction"),
    onOpen: props.onOpen
  }, function (_ref) {
    var className = _ref.className,
        onTransitionEnd = _ref.onTransitionEnd,
        open = _ref.open;
    return /*#__PURE__*/_react["default"].createElement(_responsive["default"], {
      query: "min-width",
      props: {
        fullscreen: (0, _defineProperty2["default"])({
          "default": true
        }, "".concat(t("floatingBreakpoint"), "px"), false)
      }
    }, function (_ref2) {
      var fullscreen = _ref2.fullscreen;

      var modal = /*#__PURE__*/_react["default"].createElement(_modalBox["default"], (0, _extends2["default"])({}, props, {
        onClose: onCloseMaybe,
        t: t,
        scrollContainer: props.scrollContainer,
        fullscreen: fullscreen,
        className: className,
        onTransitionEnd: onTransitionEnd,
        ref: modalRef
      }));

      return /*#__PURE__*/_react["default"].createElement(_portal["default"], null, /*#__PURE__*/_react["default"].createElement(_scrim["default"], {
        open: props.open || open,
        className: scrimStyles,
        onClick: onCloseMaybe,
        ref: scrimRef
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: outerWrapperStyles
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: innerWrapperStyles,
        onMouseDown: // The inner wrapper has a little padding
        // applied to keep the modal away from the
        // edges of the viewport. This padding appears
        // as scrim space to the user, but it blocks
        // clicks to the scrim so we have to add the
        // click-to-close behavior here as well
        (0, _onDirectClick["default"])(onCloseMaybe)
      }, modal))));
    });
  });
}, shouldNotUpdate);

Modal.displayName = "Modal";
Modal.propTypes =  false ? {
  /**
   * The contents of the modal.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Is the modal open? If false the modal will not be mounted in the DOM. If
   * changed from false to true the modal will be mounted and will animate
   * open.
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.11.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Sets the padding on the body of the modal
   */
  bodySpacingInset: _propTypes2["default"].spacing(4),

  /**
   * Determines whether or not the click event for the close button will continue to bubble up
   * through the DOM. Read the [Event.stopPropagation() docs](https://developer.mozilla.org/en-US/docs/Web/API/Event/stopPropagation)
   * for details.
   *
   * @since 5.x
   */
  closeButtonPropagateClickEvent: _propTypes["default"].bool,

  /**
   * An accessibility label for the close button. This will be read by screen
   * readers, but will not be present in the UI.
   */
  closeLabel: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * NOTE: This is deprecated, use `aria-describedby` instead.
   *
   * @deprecated 5.x
   */
  describedById: _propTypes["default"].string,

  /**
   * If the modal is a form (see `onSubmitForm`), this [action](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) will be passed
   * to the form element.
   */
  formAction: _propTypes["default"].string,

  /**
   * If the modal is a form (see `onSubmitForm`), this [method](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) will be passed
   * to the form element.
   */
  formMethod: _propTypes["default"].oneOf(["get", "post", "dialog"]),

  /**
   * This determines where the vertical scrollbar is placed for modals with
   * content that overflows vertically. If set to "modal", the scrollbar will
   * be placed inside the modal. The content will overflow inside the modal,
   * but the the modal itself will fit inside the viewport. If set to
   * "viewport", the scrollbar will be placed inside the viewport. The modal
   * will overflow the viewport, and the user will scroll the entire modal to
   * view the content.
   *
   * NOTE: This does not currently affect the horizontal scrollbar for content
   * which is too wide for the modal and cannot wrap. The horizontal scrollbar
   * will always be shown inside the modal.
   *
   * NOTE: This only applies to modals on desktop. On mobile modals are shown
   * fullscreen so there is no meaningful distinction between the modal
   * and the viewport.
   */
  scrollContainer: _propTypes["default"].oneOf(["modal", "viewport"]),

  /**
   * The title of the modal. This will be shown in the modal header. If no
   * title is provided, no header will be shown.
   */
  title: _propTypes["default"].string,

  /**
   * Set the width of the modal using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   *
   * This width only applies to desktop, as modals are displayed
   * full-screen on mobile.
   *
   * A max width is applied to the modal in
   * addition to this width to ensure that the modal is never too wide for the
   * viewport.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * If a callback is provided here, a close button will be rendered in the
   * modal. The user will be able to close the modal by clicking on the button
   * or the scrim behind the modal. The callback will be fired whent he user
   * performs either of these actions.
   *
   * If a callback is not provided here, no close button will be rendered and
   * nothing will happen when the user clicks the scrim. This can be helpful
   * for dialog modals that require an action from the user. Note that if
   * you do not provide a close handler here you *must* provide another way
   * for the user to close the modal (e.g. by confirming or denying a dialog
   * action). Otherwise the user will be stuck in the modal.
   */
  onClose: _propTypes["default"].func,

  /**
   * This callback will be fired after the Modal opens.
   */
  onOpen: _propTypes["default"].func,

  /**
   * If a callback is provided here the Modal will behave like a [form](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
   *
   * To set the [action and method](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) of the form, see `formAction` and `formMethod`.
   *
   * If using a Meridian [Button](https://meridian.a2z.com/components/button/?platform=react-web&detailsTab=api) in the footer for submission,
   * be sure to use set the button's `submit` prop to `true`.
   *
   * @since 4.x
   */
  onSubmitForm: _propTypes["default"].func
} : {};
Modal.defaultProps = {
  closeButtonPropagateClickEvent: true,
  closeLabel: "Close",
  bodySpacingInset: "medium",
  scrollContainer: "viewport"
};
var _default = Modal;
exports["default"] = _default;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrimSpacingVertical = exports.scrimSpacingHorizontal = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _keycode = _interopRequireDefault(__webpack_require__(47));

var _close = _interopRequireDefault(__webpack_require__(154));

var _elevation = __webpack_require__(59);

var _uniqueId = _interopRequireDefault(__webpack_require__(51));

var _modalFooter = _interopRequireDefault(__webpack_require__(264));

var _button = _interopRequireDefault(__webpack_require__(50));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _focusTrap = _interopRequireDefault(__webpack_require__(265));

var _propTypes2 = _interopRequireDefault(__webpack_require__(77));

var _parsers = __webpack_require__(66);

var _isElementOf = _interopRequireDefault(__webpack_require__(72));

var _text = _interopRequireDefault(__webpack_require__(27));

var _useFocus2 = _interopRequireDefault(__webpack_require__(40));

var _focusRing = _interopRequireDefault(__webpack_require__(43));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var closeButtonWidth = 32; // px

var scrimSpacingVertical = 10; // vh

exports.scrimSpacingVertical = scrimSpacingVertical;
var scrimSpacingHorizontal = 10; //vw

exports.scrimSpacingHorizontal = scrimSpacingHorizontal;
var isFooter = (0, _isElementOf["default"])(_modalFooter["default"]);

var isNotFooter = function isNotFooter(child) {
  return !isFooter(child);
};

var styles = function styles(t, _ref) {
  var _css, _divNotMdnMod;

  var focus = _ref.focus,
      scrollContainer = _ref.scrollContainer,
      fullscreen = _ref.fullscreen,
      width = _ref.width,
      bodySpacingInset = _ref.bodySpacingInset,
      showTitle = _ref.showTitle,
      showCloseButton = _ref.showCloseButton;
  var padding = (0, _parsers.parseSpacing)(bodySpacingInset);
  return (0, _emotion.css)(
  /**
   * Focus ring styles - important that these are first so subsequent styles
   * (like `position: fixed` for fullscreen modals) can overwrite the ring styles.
   */
  focus ? (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    borderRadius: t("borderRadius")
  }) : {},
  /**
   * Fullscreen vs non-fullscreen styles
   */
  fullscreen ? {
    // Fullscreen modals aren't shown in a scrim so we've got to handle
    // layout here
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: _elevation.elevationModal,
    // Use momentum scrolling on iOS. See:
    // https://css-tricks.com/snippets/css/momentum-scrolling-on-ios-overflow-elements/
    overflowY: "scroll",
    WebkitOverflowScrolling: "touch"
  } : {
    // Apply the user-provided width if we're not showing a fullscreen
    // modal
    width: width,
    // This allows the absolutely-positioned close button to anchor itself
    // to the modal
    position: "relative",
    boxShadow: t.boxShadowCss("dropShadow"),
    maxHeight: scrollContainer === "modal" ? "".concat(100 - scrimSpacingVertical * 2, "vh") : undefined,
    maxWidth: "".concat(100 - scrimSpacingHorizontal * 2, "vw"),
    borderRadius: t("borderRadius")
  }, {
    /**
     * Common styles
     */
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    backgroundColor: t("bodyBackgroundColor"),
    outline: "none",

    /**
     * Header styles
     */
    "& > header": (0, _emotion.css)((0, _text["default"])(t), (_css = {
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      minHeight: t("headerMinHeight"),
      paddingTop: t("headerSpacingInsetTop"),
      paddingBottom: t("headerSpacingInsetBottom"),
      // HACK: IE11 does not support padding-inline-* so we have
      // to use directional padding-left/right. If/when we drop IE11
      // and we update the token names, we can simplify these styles to be:
      // {
      //   paddingInlineStart: t("headerSpacingInsetStart")
      //   paddingInlineEnd: t("headerSpacingInsetEnd")
      // }
      paddingRight: t("headerSpacingInsetRight"),
      paddingLeft: t("headerSpacingInsetLeft")
    }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
      paddingLeft: t("headerSpacingInsetRight"),
      paddingRight: t("headerSpacingInsetLeft")
    }), (0, _defineProperty2["default"])(_css, "backgroundColor", t("headerBackgroundColor")), (0, _defineProperty2["default"])(_css, "color", t("headerForegroundColor")), (0, _defineProperty2["default"])(_css, "fontWeight", t("headerFontWeight")), _css)),

    /**
     * Body styles
     */
    "& > div:not([mdn-modal-footer])": (_divNotMdnMod = {
      padding: (0, _parsers.parseSpacing)(bodySpacingInset).map(function (value) {
        return "".concat(value, "px");
      }).join(" "),
      // HACK: IE11 does not support padding-inline-* so we have
      // to use directional padding-left/right. If/when we drop IE11 we can simplify
      // these styles to be:
      // {
      //   paddingInlineEnd: showCloseButton && !showTitle
      //             ? `calc(${padding[1] || padding[0]}px + ${closeButtonWidth}px)`
      //             : undefined,
      // }
      // Add extra right-padding on modals with no title and a close button
      paddingRight: showCloseButton && !showTitle ? "calc(".concat(padding[1] || padding[0], "px + ").concat(closeButtonWidth, "px)") : undefined
    }, (0, _defineProperty2["default"])(_divNotMdnMod, "[dir=\"rtl\"] &", {
      paddingLeft: showCloseButton && !showTitle ? "calc(".concat(padding[1] || padding[0], "px + ").concat(closeButtonWidth, "px)") : undefined,
      // HACK: Need to remove the additional right padding until we
      // update to use paddingInlineStart
      paddingRight: "".concat(t("headerSpacingInsetLeft"), "px !important")
    }), (0, _defineProperty2["default"])(_divNotMdnMod, "overflowY", scrollContainer === "modal" ? "auto" : undefined), (0, _defineProperty2["default"])(_divNotMdnMod, "overflowX", "auto"), (0, _defineProperty2["default"])(_divNotMdnMod, "flex", fullscreen ? "auto" : undefined), _divNotMdnMod),

    /**
     * Footer styles
     */
    "& > footer": {
      borderTop: t.borderCss("footerBorder"),
      padding: t("footerSpacingInset")
    }
  });
};

var closeButtonStyles = function closeButtonStyles(t) {
  var _css2;

  return (0, _emotion.css)((_css2 = {
    position: "absolute",
    top: t("closeButtonSpacingTop"),
    right: t("closeButtonSpacingRight")
  }, (0, _defineProperty2["default"])(_css2, "[dir=\"rtl\"] &", {
    left: t("closeButtonSpacingRight"),
    right: "auto"
  }), (0, _defineProperty2["default"])(_css2, "zIndex", _elevation.elevationForeground), _css2));
};
/* eslint-disable react/prop-types, react/display-name */
// The element we use at the root of the modal depends on
// the presence of an `onSubmit` prop. If the method
// is present, the modal uses a <form> element, else
// a <div>


var ModalBoxRoot = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(props.onSubmit ? "form" : "div", _objectSpread(_objectSpread({}, props), {}, {
    tabIndex: 0,
    ref: ref,
    role: "dialog"
  }));
});
/* eslint-enable react/prop-types, react/display-name */

/**
 * This component can be used to render a modal for your application
 */


var ModalBox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onClose = props.onClose,
      onSubmitForm = props.onSubmitForm,
      formAction = props.formAction,
      formMethod = props.formMethod;
  var id = (0, _react.useMemo)(function () {
    return (0, _uniqueId["default"])("modal-");
  }, []);
  var headerId = props.title ? "".concat(id, "-header") : undefined;

  var footer = _react["default"].Children.toArray(props.children).filter(isFooter)[0];

  var _useFocus = (0, _useFocus2["default"])(props),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps,
      focusDescendent = _useFocus.focusDescendent; // Call the onClose handler if the esc key is pressed


  var onKeyDownDocument = (0, _react.useCallback)(function (event) {
    if ((0, _keycode["default"])(event) === "esc") {
      onClose();
    }
  }, [onClose]); // Bind the onKeyDownDocument handler to the window

  (0, _react.useEffect)(function () {
    if (onClose) {
      window.addEventListener("keydown", onKeyDownDocument);
    }

    return function () {
      return window.removeEventListener("keydown", onKeyDownDocument);
    };
  }, [onClose, onKeyDownDocument]);
  var onSubmit = (0, _react.useCallback)(function (event) {
    if (!formAction && !formMethod) event.preventDefault();
    onSubmitForm();
  }, [formAction, formMethod, onSubmitForm]);
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement(_focusTrap["default"], null, /*#__PURE__*/_react["default"].createElement(ModalBoxRoot, (0, _extends2["default"])({}, focusProps, {
    className: (0, _emotion.cx)(props.className, styles(props.t, {
      focus: focus && focusTrigger === "keyboard" && !focusDescendent,
      scrollContainer: props.scrollContainer,
      width: props.width,
      fullscreen: props.fullscreen,
      bodySpacingInset: props.bodySpacingInset,
      showTitle: Boolean(props.title),
      showCloseButton: Boolean(onClose)
    })),
    onTransitionEnd: props.onTransitionEnd,
    onSubmit: onSubmitForm ? onSubmit : undefined,
    action: props.formAction,
    method: props.formMethod,
    "aria-labelledby": headerId,
    "aria-describedby": props.describedById,
    "aria-modal": true,
    ref: ref
  }, passThroughProps), props.title ? /*#__PURE__*/_react["default"].createElement("header", {
    id: headerId
  }, props.title) : null, onClose ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    onClick: onClose,
    size: "small",
    type: "icon",
    backdropColor: props.title ? props.t("headerBackgroundColor") : props.t("bodyBackgroundColor"),
    className: closeButtonStyles(props.t),
    propagateClickEvent: props.closeButtonPropagateClickEvent
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _close["default"]
  }, props.closeLabel)) : null, /*#__PURE__*/_react["default"].createElement("div", null, _react["default"].Children.toArray(props.children).filter(isNotFooter)), footer ? footer : null));
});

ModalBox.displayName = "ModalBox";
ModalBox.propTypes =  false ? {
  closeLabel: _propTypes["default"].string.isRequired,
  bodySpacingInset: _propTypes2["default"].spacing(4),
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,
  closeButtonPropagateClickEvent: _propTypes["default"].bool,

  /**
   * NOTE: This is deprecated, use `aria-describedby` instead.
   *
   * @deprecated 5.x
   */
  describedById: _propTypes["default"].string,
  formAction: _propTypes["default"].string,
  formMethod: _propTypes["default"].oneOf(["get", "post", "dialog"]),
  fullscreen: _propTypes["default"].bool,
  scrollContainer: _propTypes["default"].oneOf(["modal", "viewport"]),
  t: _propTypes["default"].func,
  title: _propTypes["default"].string,

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  onClose: _propTypes["default"].func,
  onSubmitForm: _propTypes["default"].func,
  onTransitionEnd: _propTypes["default"].func
} : {};
var _default = ModalBox;
exports["default"] = _default;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(57));

var _keycode = _interopRequireDefault(__webpack_require__(47));

var _includes = _interopRequireDefault(__webpack_require__(266));

var _find = _interopRequireDefault(__webpack_require__(101));

var _findLast = _interopRequireDefault(__webpack_require__(612));

var _noop = _interopRequireDefault(__webpack_require__(37));

var _focus = __webpack_require__(157);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This component allows you to trap the keyboard focus within a particular
 * section of the DOM (the component's children). An optional onBeforeBlur event
 * handler can be defined that allows you to execute custom behavior when the
 * user attempts to move the focus outside of the trap by pressing the tab key.
 *
 * NOTE: This component only handles keyboard focus. If the mouse is used to
 * move focus outside of the trap then the trap will not prevent the focus
 * change and onBeforeBlur will not be called.
 *
 * NOTE: This component must be wrapped around a single element to work
 * properly.
 *
 * NOTE: This component only manages focus for elements that are
 * descendents in the real DOM. This means that it will ignore any portals
 * nested inside of it in the virtual DOM.
 */
var FocusTrap = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(FocusTrap, _React$Component);

  var _super = _createSuper(FocusTrap);

  function FocusTrap() {
    var _this;

    (0, _classCallCheck2["default"])(this, FocusTrap);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "rootNode", undefined);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDown", function (event) {
      if ((0, _keycode["default"])(event) === "tab") {
        var _getBoundingFocusNode = (0, _focus.getBoundingFocusNodes)(_this.rootNode),
            startNodes = _getBoundingFocusNode.startNodes,
            endNodes = _getBoundingFocusNode.endNodes;

        var willBlur = _this.willBlur(event, startNodes, endNodes);

        var allowBlur = willBlur && _this.props.onBeforeBlur(willBlur);

        var firstFocusNode = (0, _find["default"])(startNodes, _focus.canKeyboardFocusNode);
        var lastFocusNode = (0, _findLast["default"])(endNodes, _focus.canKeyboardFocusNode); // If onBeforeBlur returned nothing then loop the focus ourselves

        if (willBlur === -1 && allowBlur === undefined && lastFocusNode) {
          lastFocusNode.focus();
        }

        if (willBlur === 1 && allowBlur === undefined && firstFocusNode) {
          firstFocusNode.focus();
        } // If allowBlur was not explicitly set to true then cancel the default event
        // behavior


        if (willBlur && allowBlur !== true) {
          event.preventDefault();
        }
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(FocusTrap, [{
    key: "focus",
    value: function focus() {
      var node = (0, _focus.getKeyboardFocusNodes)(this.rootNode)[0];

      if (node) {
        node.focus();
      }
    }
  }, {
    key: "focusEnd",
    value: function focusEnd() {
      var nodes = (0, _focus.getKeyboardFocusNodes)(this.rootNode);
      var node = nodes[nodes.length - 1];

      if (node) {
        node.focus();
      }
    }
    /**
     * Takes in a keydown event, returns 0 if focus is not leaving, 1 if it's
     * leaving to the next node in the tab order, and -1 if it's leaving to the
     * previous node in the tab order.
     */

  }, {
    key: "willBlur",
    value: function willBlur(event, startNodes, endNodes) {
      var key = (0, _keycode["default"])(event);
      var target = event.target,
          shiftKey = event.shiftKey;
      return (0, _includes["default"])(endNodes, target) && key === "tab" && !shiftKey ? 1 : (0, _includes["default"])(startNodes, target) && key === "tab" && shiftKey ? -1 : 0;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      /* eslint-disable-next-line react/no-find-dom-node */
      this.rootNode = _reactDom["default"].findDOMNode(this);
      this.rootNode.addEventListener("keydown", this.onKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.rootNode.removeEventListener("keydown", this.onKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return FocusTrap;
}(_react["default"].Component);

(0, _defineProperty2["default"])(FocusTrap, "defaultProps", {
  onBeforeBlur: _noop["default"]
});
FocusTrap.propTypes =  false ? {
  children: _propTypes["default"].element.isRequired,

  /**
   * This is called when the focus trap is about to lose focus because of
   * keyboard input.
   *
   * If the function is not provided or does not return a value then the blur
   * will be blocked and focus will be looped within the trap. If the function
   * is provided and returns false then the blur will be blocked but the focus
   * will not automatically be looped. If the function is provided and returns
   * true then focus will be allowed to leave the trap.
   *
   * The function is called with a single argument that indicates the
   * direction of the tab change: -1 if the user is moving backwards in the
   * tab order, or 1 if the user is moving fowards in the tab order.
   *
   * IMPORTANT: As mentioned above, this will only be called when the trap is
   * about to lose focus due to keyboard input. This will not be called if
   * focus is moved outside the trap via mouse input.
   */
  onBeforeBlur: _propTypes["default"].func
} : {};
var _default = FocusTrap;
exports["default"] = _default;

/***/ }),
/* 608 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 609 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(611),
    keys = __webpack_require__(86);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(149);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(222),
    findLastIndex = __webpack_require__(238);

/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */
var findLast = createFind(findLastIndex);

module.exports = findLast;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _scrim = _interopRequireDefault(__webpack_require__(173));

var _theme = __webpack_require__(14);

var _animateMount = _interopRequireWildcard(__webpack_require__(269));

var _onDirectClick = _interopRequireDefault(__webpack_require__(270));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AnimateFadeWithMount = (0, _animateMount["default"])(_animateMount.AnimateFade);

var styles = function styles(t) {
  return (0, _emotion.css)({
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: t("elevation"),
    backgroundColor: t("backgroundColor")
  });
};
/**
 * Don't bother updating the scrim if it's persisting in a closed state.
 */


var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
  return !prevProps.open && !nextProps.open;
};

var Scrim = /*#__PURE__*/_react["default"].memo( /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_scrim["default"], "scrim");
  return /*#__PURE__*/_react["default"].createElement(AnimateFadeWithMount, {
    open: props.open,
    onOpen: props.onOpen,
    duration: props.duration || t("motionTiming"),
    easing: props.easing || t("motionFunction"),
    type: "fade"
  }, function (_ref) {
    var className = _ref.className,
        onTransitionEnd = _ref.onTransitionEnd;
    return (
      /*#__PURE__*/
      // Regarding role=none, see:
      // https://www.scottohara.me/blog/2018/05/05/hidden-vs-none.html#what-does-rolenone-and-rolepresentation-do
      _react["default"].createElement("div", {
        role: "none",
        className: (0, _emotion.cx)(className, styles(t), props.className),
        onTransitionEnd: onTransitionEnd,
        onMouseDown: (0, _onDirectClick["default"])(props.onClick),
        ref: ref
      }, props.children)
    );
  });
}), shouldNotUpdate);

Scrim.displayName = "Scrim";
Scrim.propTypes =  false ? {
  open: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,
  duration: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  easing: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  onOpen: _propTypes["default"].func
} : {};
Scrim.defaultProps = {
  open: false,
  className: null
};
var _default = Scrim;
exports["default"] = _default;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Provides the WrappedComponent's displayName
// for easy debugging
var getsDisplayName = function getsDisplayName(WrappedComponent) {
  return WrappedComponent.getsDisplayName || WrappedComponent.name || "Component";
};

var withAnimateMount = function withAnimateMount(WrappedComponent) {
  var _class;

  /**
   * This is a higher order component that provides a consistent API to easily
   * create animations to be used for elements that need to be added and
   * removed to the DOM dynamically. Receives an animation component and returns a
   * wrapped, composed component.
   */
  return _class = /*#__PURE__*/function (_React$Component) {
    (0, _inherits2["default"])(WithAnimateMount, _React$Component);

    var _super = _createSuper(WithAnimateMount);

    function WithAnimateMount() {
      var _this;

      (0, _classCallCheck2["default"])(this, WithAnimateMount);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
        show: false
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function () {
        if (typeof _this.props.onOpen !== "undefined" && _this.state.show) {
          _this.props.onOpen();
        } // Remount the node when the open prop is true


        _this.setState({
          show: true
        });
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function () {
        if (!_this.props.open) {
          _this.setState({
            show: false
          });
        }
      });
      return _this;
    }

    (0, _createClass2["default"])(WithAnimateMount, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.open) {
          this.updateStateOnOpen();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (!prevProps.open && this.props.open) {
          this.updateStateOnOpen();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            duration = _this$props.duration,
            easing = _this$props.easing,
            open = _this$props.open,
            animateToHeight = _this$props.animateToHeight;
        var animateToHeightProps = typeof animateToHeight !== "undefined" ? {
          animateToHeight: animateToHeight
        } : null;
        return this.state.show && /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({
          duration: duration,
          easing: easing,
          open: open,
          updateStateOnOpen: this.updateStateOnOpen,
          transitionEnd: this.transitionEnd
        }, animateToHeightProps), children);
      }
    }]);
    return WithAnimateMount;
  }(_react["default"].Component), (0, _defineProperty2["default"])(_class, "propTypes", {
    /**
     * A function that returns the elements to animate.
     */
    children: _propTypes["default"].func.isRequired,

    /**
     * If true the children will be mounted, otherwise they will be unmounted.
     */
    open: _propTypes["default"].bool.isRequired,

    /**
     * Only applies to height based transitions. Allows for cases when the
     * desired effect is animating height to a value that's different than
     * the element's scrollHeight.
     */
    animateToHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

    /**
     * The duration of the animation. This should be a valid CSS animation
     * duration (e.g. `"100ms"` or `"1s"`).
     */
    duration: _propTypes["default"].string,

    /**
     * The easing function of the animation. This should be a valid CSS easing
     * function (e.g. `"linear"` or `"ease"`).
     */
    easing: _propTypes["default"].string,

    /**
     * The function provided here will be called if the component transitions
     * from a closed state to an open state, or if it is mounted in an open
     * state. Note that this is called as soon as the state changes, which
     * occurs *before* the elements being mounted are actually available in
     * the DOM.
     */
    onOpen: _propTypes["default"].func
  }), (0, _defineProperty2["default"])(_class, "defaultProps", {
    duration: "150ms",
    easing: "ease",
    open: false
  }), (0, _defineProperty2["default"])(_class, "displayName", "WithAnimateMount(".concat(getsDisplayName(WrappedComponent), ")")), _class;
};

var _default = withAnimateMount;
exports["default"] = _default;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var mountStyled = function mountStyled(opacity, duration, easing) {
  return (0, _emotion.css)({
    opacity: opacity,
    transition: "opacity ".concat(duration, " ").concat(easing)
  });
};

var AnimateFade = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AnimateFade, _React$Component);

  var _super = _createSuper(AnimateFade);

  function AnimateFade() {
    var _this;

    (0, _classCallCheck2["default"])(this, AnimateFade);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      opacity: 0
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "timer", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function () {
      // Tell the wrapper component to remount the node when the open prop is true
      _this.props.updateStateOnOpen(); // Set state to trigger intro animation


      _this.timer = setTimeout(_this.updateStateOnMount, 0);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function () {
      // Update state for unmount animation
      _this.setState({
        opacity: 0
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function () {
      // Update state for mount animation
      _this.setState({
        opacity: 1
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function () {
      if (!_this.props.open) {
        // Tell the wrapper component to remove the node on transition end when
        // the open prop is false
        _this.props.transitionEnd();
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(AnimateFade, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        this.updateStateOnOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open && !this.props.open) {
        this.updateStateOnUnmount();
      } else if (!prevProps.open && this.props.open) {
        this.updateStateOnMount();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Clear our timer to prevent leaks
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var opacity = this.state.opacity;
      var _this$props = this.props,
          children = _this$props.children,
          duration = _this$props.duration,
          easing = _this$props.easing,
          className = _this$props.className;
      var styles = mountStyled(opacity, duration, easing);
      return children({
        className: (0, _emotion.cx)(className, styles),
        onTransitionEnd: this.transitionEnd
      });
    }
  }]);
  return AnimateFade;
}(_react["default"].Component);

(0, _defineProperty2["default"])(AnimateFade, "defaultProps", {
  duration: "150ms",
  easing: "ease"
});
AnimateFade.propTypes =  false ? {
  /**
   * A function that returns the elements to animate.
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * If true the children will be mounted, otherwise they will be unmounted.
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about unmounting the
   * component so we can focus on animation
   */
  transitionEnd: _propTypes["default"].func.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about mounting the
   * component so we can focus on animation
   */
  updateStateOnOpen: _propTypes["default"].func.isRequired,

  /**
   * Accepts the shared css class provided by the AnimateMount parent
   */
  className: _propTypes["default"].string,

  /**
   * The duration of the animation. This should be a valid CSS animation
   * duration (e.g. `"100ms"` or `"1s"`).
   */
  duration: _propTypes["default"].string,

  /**
   * The easing function of the animation. This should be a valid CSS easing
   * function (e.g. `"linear"` or `"ease"`).
   */
  easing: _propTypes["default"].string
} : {};
var _default = AnimateFade;
exports["default"] = _default;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _waitAnimationFrame = _interopRequireDefault(__webpack_require__(109));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var mountStyled = function mountStyled(_ref) {
  var open = _ref.open,
      height = _ref.height,
      duration = _ref.duration,
      easing = _ref.easing;
  return (0, _emotion.css)({
    transform: "translateY(".concat(open ? "0" : "100%", ")"),
    height: height,
    overflow: "auto",
    transition: "transform ".concat(duration, " ").concat(easing)
  });
};

var AnimateSlideIn = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AnimateSlideIn, _React$Component);

  var _super = _createSuper(AnimateSlideIn);

  function AnimateSlideIn() {
    var _this;

    (0, _classCallCheck2["default"])(this, AnimateSlideIn);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      open: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isMounted", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function () {
      // Tell the wrapper component to remount the node when the open prop is true
      _this.props.updateStateOnOpen(); // Wait one animation frame so that the DOM can settle after mounting the
      // element, then set the state to trigger the mount animation


      (0, _waitAnimationFrame["default"])(_this.updateStateOnMount);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function () {
      return _this.setState({
        open: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function () {
      if (_this.isMounted) _this.setState({
        open: true
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(AnimateSlideIn, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isMounted = true;

      if (this.props.open) {
        this.updateStateOnOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        this.updateStateOnOpen();
      } else if (prevProps.open && !this.props.open) {
        this.updateStateOnUnmount();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var state = this.state;
      var props = this.props;
      var styles = mountStyled({
        open: state.open,
        duration: props.duration,
        easing: props.easing,
        height: props.animateToHeight
      });
      return props.children({
        open: state.open,
        className: (0, _emotion.cx)(props.className, styles),
        onTransitionEnd: this.props.transitionEnd
      });
    }
  }]);
  return AnimateSlideIn;
}(_react["default"].Component);

(0, _defineProperty2["default"])(AnimateSlideIn, "defaultProps", {
  duration: "150ms",
  easing: "ease"
});
AnimateSlideIn.propTypes =  false ? {
  /**
   * A function that returns the elements to animate.
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * If true the children will be mounted, otherwise they will be unmounted.
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about unmounting the
   * component so we can focus on animation
   */
  transitionEnd: _propTypes["default"].func.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about mounting the
   * component so we can focus on animation
   */
  updateStateOnOpen: _propTypes["default"].func.isRequired,

  /**
   * Allows for cases when the desired effect is animating height to
   * a value that's different than the element's scrollHeight
   */
  animateToHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Accepts the shared css class provided by the AnimateMount parent
   */
  className: _propTypes["default"].string,

  /**
   * The duration of the animation. This should be a valid CSS animation
   * duration (e.g. `"100ms"` or `"1s"`).
   */
  duration: _propTypes["default"].string,

  /**
   * The easing function of the animation. This should be a valid CSS easing
   * function (e.g. `"linear"` or `"ease"`).
   */
  easing: _propTypes["default"].string
} : {};
var _default = AnimateSlideIn;
exports["default"] = _default;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var mountStyled = function mountStyled(opacity, scale, duration, easing) {
  return (0, _emotion.css)({
    opacity: opacity,
    transform: scale ? "scale(".concat(scale, ")") : undefined,
    transition: "opacity ".concat(duration, " ").concat(easing, ", transform ").concat(duration, " ").concat(easing)
  });
};

var AnimateFadeScale = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AnimateFadeScale, _React$Component);

  var _super = _createSuper(AnimateFadeScale);

  function AnimateFadeScale() {
    var _this;

    (0, _classCallCheck2["default"])(this, AnimateFadeScale);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      opacity: 0,
      scale: 0.75,
      applyScale: true
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "timer", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function () {
      // Tell the wrapper component to remount the node when the open prop is true
      _this.props.updateStateOnOpen(); // Set state to trigger intro animation


      _this.timer = setTimeout(_this.updateStateOnMount, 0);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function () {
      // Update state for unmount animation
      _this.setState({
        opacity: 0,
        scale: 0.75,
        applyScale: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function () {
      // Update state for mount animation
      _this.setState({
        opacity: 1,
        scale: 1
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function () {
      if (!_this.props.open) {
        // Tell the wrapper component to remove the node on transition end when
        // the open prop is false
        _this.props.transitionEnd();
      } // Clear opening timer if it exists


      clearTimeout(_this.timer); // HACK: turn off `transform: scale(X)` to workaround this Chromium issue https://bugs.chromium.org/p/chromium/issues/detail?id=20574
      // which can cause a `position: fixed` child to render improperly.

      _this.setState({
        applyScale: false
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(AnimateFadeScale, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        this.updateStateOnOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open && !this.props.open) {
        this.updateStateOnUnmount();
      } else if (!prevProps.open && this.props.open) {
        // Set state to trigger intro animation
        this.timer = setTimeout(this.updateStateOnMount, 0);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Clear our timer to prevent leaks
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          opacity = _this$state.opacity,
          scale = _this$state.scale,
          applyScale = _this$state.applyScale;
      var _this$props = this.props,
          children = _this$props.children,
          duration = _this$props.duration,
          easing = _this$props.easing,
          className = _this$props.className;
      var styles = mountStyled(opacity, applyScale ? scale : undefined, duration, easing);
      return children({
        open: opacity !== 0,
        className: (0, _emotion.cx)(className, styles),
        onTransitionEnd: this.transitionEnd
      });
    }
  }]);
  return AnimateFadeScale;
}(_react["default"].Component);

(0, _defineProperty2["default"])(AnimateFadeScale, "defaultProps", {
  duration: "150ms",
  easing: "ease"
});
AnimateFadeScale.propTypes =  false ? {
  /**
   * A function that returns the elements to animate.
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * If true the children will be mounted, otherwise they will be unmounted.
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about unmounting the
   * component so we can focus on animation
   */
  transitionEnd: _propTypes["default"].func.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about mounting the
   * component so we can focus on animation
   */
  updateStateOnOpen: _propTypes["default"].func.isRequired,

  /**
   * Accepts the shared css class provided by the AnimateMount parent
   */
  className: _propTypes["default"].string,

  /**
   * The duration of the animation. This should be a valid CSS animation
   * duration (e.g. `"100ms"` or `"1s"`).
   */
  duration: _propTypes["default"].string,

  /**
   * The easing function of the animation. This should be a valid CSS easing
   * function (e.g. `"linear"` or `"ease"`).
   */
  easing: _propTypes["default"].string
} : {};
var _default = AnimateFadeScale;
exports["default"] = _default;

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_GridAllocationUtil__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Renders the aisle info section in the grid allocation view
 */var SortLocationInfo=function(_Component){_inherits(SortLocationInfo,_Component);function SortLocationInfo(){_classCallCheck(this,SortLocationInfo);return _possibleConstructorReturn(this,(SortLocationInfo.__proto__||Object.getPrototypeOf(SortLocationInfo)).apply(this,arguments));}_createClass(SortLocationInfo,[{key:"render",value:function render(){var sortLocationInfo=this.props.sortLocationInfo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{style:Object(__WEBPACK_IMPORTED_MODULE_3__utils_GridAllocationUtil__["b" /* getTableStyle */])("none")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{key:"1",style:Object(__WEBPACK_IMPORTED_MODULE_3__utils_GridAllocationUtil__["b" /* getTableStyle */])("none")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,null,sortLocationInfo.label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{key:"2",style:Object(__WEBPACK_IMPORTED_MODULE_3__utils_GridAllocationUtil__["b" /* getTableStyle */])(sortLocationInfo.color)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,null,sortLocationInfo.reservedFor)));}}]);return SortLocationInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(SortLocationInfo)));

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ClusterV3__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AisleV3__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__floor_Floor__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SortZoneV3__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_breadcrumb__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_breadcrumb_breadcrumb_group__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_breadcrumb_breadcrumb_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_breadcrumb_breadcrumb_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_ClusterActionsV2__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_AisleActions__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_SortZoneActions__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__station_pair_StationPair__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_StationPairActions__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions_FloorActions__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Route__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions_RouteActions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions_ZoneActions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Zone__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__CartLocation__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__actions_CartLocationActions__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__actions_ConfigActions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__sideline_FloorLocation__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__actions_FloorLocationActions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__sideline_Cart__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__actions_CartActions__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__common_context_DeviceLayoutContext__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__actions_ClusterActions__ = __webpack_require__(94);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StowBreakdownV3=function(_Component){_inherits(StowBreakdownV3,_Component);function StowBreakdownV3(props){_classCallCheck(this,StowBreakdownV3);var _this=_possibleConstructorReturn(this,(StowBreakdownV3.__proto__||Object.getPrototypeOf(StowBreakdownV3)).call(this,props));_this.getViewSubjects=function(key){return _this.props.navigationOptions.filter(function(navigationOption){return navigationOption.key===key;}).map(function(navigationOption){return navigationOption.value;});};_this.isCPTFilterEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].IS_CPT_FILTER_ENABLED];};_this.findViewByOptionValues=function(navigationOptions,selectedView){switch(_this.props.capability){case __WEBPACK_IMPORTED_MODULE_20__enums__["e" /* Capability */].SSD:return _this.findViewForSSD(navigationOptions,selectedView);case __WEBPACK_IMPORTED_MODULE_20__enums__["e" /* Capability */].AMZL:default:return _this.findViewForAmzlCore(navigationOptions,selectedView);case __WEBPACK_IMPORTED_MODULE_20__enums__["e" /* Capability */].AR_NEXT_GEN:return _this.findViewForArNextGen(navigationOptions,selectedView);}};_this.findViewForAmzlCore=function(navigationOptions,selectedView){if(__WEBPACK_IMPORTED_MODULE_20__enums__["q" /* ViewType */].SIDELINE_VIEW===selectedView){if(navigationOptions.length===1)return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].CART_VIEW;return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].FLOOR_LOCATION_VIEW;}if(Object(__WEBPACK_IMPORTED_MODULE_15__Utility__["u" /* isOnlyRouteViewApplicable */])(_this.state.nodeId,_this.props.capability)||__WEBPACK_IMPORTED_MODULE_20__enums__["q" /* ViewType */].ROUTE_VIEW===selectedView){return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].ROUTE_VIEW;}else if(navigationOptions.length===2)return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].SORT_ZONE_VIEW;else if(navigationOptions.length===1)return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].AISLE_VIEW;else return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].CLUSTER;};_this.findViewForSSD=function(navigationOptions,selectedView){if(__WEBPACK_IMPORTED_MODULE_20__enums__["q" /* ViewType */].ROUTE_VIEW===selectedView){return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].ROUTE_VIEW;}if(navigationOptions.length===1)return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].CART_LOCATION_VIEW;return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].ZONE_VIEW;};_this.findViewForArNextGen=function(navigationOptions,selectedView){if(__WEBPACK_IMPORTED_MODULE_20__enums__["q" /* ViewType */].ROUTE_VIEW===selectedView){return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].ROUTE_VIEW;}if(navigationOptions.length===1)return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].FLOOR_VIEW;else return __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].STATION_PAIR_VIEW;};_this.state={nodeId:Object(__WEBPACK_IMPORTED_MODULE_15__Utility__["m" /* getNodeId */])(),routeCodePrefixes:Object(__WEBPACK_IMPORTED_MODULE_15__Utility__["d" /* extractRouteCodePrefixesFromParam */])(props)};return _this;}_createClass(StowBreakdownV3,[{key:"render",value:function render(){var _this2=this;var _props=this.props,navigationOptions=_props.navigationOptions,selectedCycle=_props.selectedCycle,selectedCycleId=_props.selectedCycleId,selectedView=_props.selectedView,isInitialView=_props.isInitialView,selectedCPT=_props.selectedCPT,filterIdentifier=_props.filterIdentifier,spacingInset_shorthand4=_props.spacingInset_shorthand4;//For initial view open route view when route code prefix list exists in params
if(this.state.routeCodePrefixes&&this.state.routeCodePrefixes!==""&&isInitialView){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["x" /* viewChanged */])(__WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].ROUTE_VIEW));}var view=this.findViewByOptionValues(navigationOptions,selectedView);var renderSubComponent=function renderSubComponent(){clearInterval(_this2.timer);switch(view){case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].AISLE_VIEW:return _this2.renderAisleView(selectedCycle,selectedCycleId);case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].SORT_ZONE_VIEW:return _this2.renderSortZoneView(selectedCycle,selectedCycleId);case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].STATION_PAIR_VIEW:return _this2.renderStationPairView();case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].FLOOR_VIEW:return _this2.renderFloorView();case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].ROUTE_VIEW:return _this2.renderRouteView(_this2.state.routeCodePrefixes);case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].ZONE_VIEW:return _this2.renderZoneView(selectedCycle,selectedCycleId);case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].CART_LOCATION_VIEW:return _this2.renderCartLocationView();case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].FLOOR_LOCATION_VIEW:return _this2.renderFloorLocationView();case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].CART_VIEW:return _this2.renderCartView();case __WEBPACK_IMPORTED_MODULE_20__enums__["l" /* HeatMapView */].CLUSTER_VIEW:default:return _this2.renderClusterView(selectedCycle,selectedCycleId,selectedCPT,filterIdentifier,_this2.isCPTFilterEnabled());}};var navigationChanged=function navigationChanged(navigationIndex){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["v" /* navigationRemoved */])(navigationIndex));};function renderBreadCrumb(navigationOptions){if(navigationOptions.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box___default.a,{spacingInset:"small none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_breadcrumb_breadcrumb_group___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_breadcrumb___default.a,{onClick:function onClick(){return navigationChanged(0);}},"Stow"),navigationOptions.map(function(navigationOption,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_breadcrumb___default.a,{onClick:function onClick(){return navigationChanged(index+1);},key:navigationOption.key},navigationOption.key," ",getNavigationOptionValue(navigationOption));})));}}var getNavigationOptionValue=function getNavigationOptionValue(navigationOption){switch(_this2.props.capability){case __WEBPACK_IMPORTED_MODULE_20__enums__["e" /* Capability */].SSD:case __WEBPACK_IMPORTED_MODULE_20__enums__["e" /* Capability */].AR_NEXT_GEN:return navigationOption.displayValue;case __WEBPACK_IMPORTED_MODULE_20__enums__["e" /* Capability */].AMZL:return navigationOption.displayValue?navigationOption.displayValue:navigationOption.value;default:return navigationOption.value;}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default.a,{spacingInset:spacingInset_shorthand4},renderBreadCrumb(navigationOptions),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box___default.a,null,renderSubComponent()));}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps){return JSON.stringify(nextProps.navigationOptions)!==JSON.stringify(this.props.navigationOptions)||nextProps.selectedCycle!==this.props.selectedCycle||nextProps.selectedView!==this.props.selectedView;}},{key:"renderAisleView",value:function renderAisleView(selectedCycle,selectedCycleId){var _this3=this;this.fetchAisleData(this.state.nodeId,selectedCycle,this.getViewSubjects('Cluster'),selectedCycleId);this.timer=setInterval(function(){if(!document.hidden){_this3.fetchAisleData(_this3.state.nodeId,selectedCycle,_this3.getViewSubjects('Cluster'),selectedCycleId);}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AisleV3__["a" /* default */],null);}},{key:"renderSortZoneView",value:function renderSortZoneView(selectedCycle,selectedCycleId){var _this4=this;this.fetchSortZoneData(this.state.nodeId,selectedCycle,this.getViewSubjects('Aisle'),selectedCycleId);this.timer=setInterval(function(){if(!document.hidden){_this4.fetchSortZoneData(_this4.state.nodeId,selectedCycle,_this4.getViewSubjects('Aisle'),selectedCycleId);}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SortZoneV3__["a" /* default */],null);}},{key:"renderClusterView",value:function renderClusterView(selectedCycle,selectedCycleId,selectedCPT,filterIdentifier,isCPTFilterEnabled){var _this5=this;this.fetchClusterData(this.state.nodeId,selectedCycle,selectedCycleId,selectedCPT,filterIdentifier,isCPTFilterEnabled);this.timer=setInterval(function(){if(!document.hidden){_this5.fetchClusterData(_this5.state.nodeId,selectedCycle,selectedCycleId,selectedCPT,filterIdentifier,isCPTFilterEnabled);}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ClusterV3__["a" /* default */],null);}},{key:"renderFloorLocationView",value:function renderFloorLocationView(){var _this6=this;this.fetchFloorLocationData(this.state.nodeId);this.timer=setInterval(function(){if(!document.hidden){_this6.fetchFloorLocationData(_this6.state.nodeId);}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__sideline_FloorLocation__["a" /* default */],null);}},{key:"renderCartView",value:function renderCartView(){var _this7=this;this.fetchCartData.apply(this,[this.state.nodeId].concat(_toConsumableArray(this.getViewSubjects('Floor Location, Re-Induct Day'))));this.timer=setInterval(function(){if(!document.hidden){_this7.fetchCartData.apply(_this7,[_this7.state.nodeId].concat(_toConsumableArray(_this7.getViewSubjects('Floor Location, Re-Induct Day'))));}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__sideline_Cart__["a" /* default */],null);}},{key:"renderZoneView",value:function renderZoneView(selectedCycle,selectedCycleId){var _this8=this;this.fetchZoneData(this.state.nodeId,selectedCycle,selectedCycleId);this.timer=setInterval(function(){if(!document.hidden){_this8.fetchZoneData(_this8.state.nodeId,selectedCycle,selectedCycleId);}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__Zone__["a" /* default */],null);}},{key:"renderRouteView",value:function renderRouteView(routeCodePrefixes){var _this9=this;this.fetchRouteData(this.state.nodeId,this.props.capability);this.timer=setInterval(function(){if(!document.hidden){_this9.fetchRouteData(_this9.state.nodeId,_this9.props.capability);}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Route__["a" /* default */],{routeCodePrefixesFromUrl:routeCodePrefixes});}},{key:"renderFloorView",value:function renderFloorView(){var _this10=this;this.fetchFloorData();this.timer=setInterval(function(){if(!document.hidden){_this10.fetchFloorData();}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__floor_Floor__["a" /* default */],{nodeId:this.state.nodeId});}},{key:"renderCartLocationView",value:function renderCartLocationView(){var _this11=this;this.fetchCartLocationData();this.timer=setInterval(function(){if(!document.hidden){_this11.fetchCartLocationData();}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__CartLocation__["a" /* default */],{nodeId:this.state.nodeId});}},{key:"renderStationPairView",value:function renderStationPairView(){var _this12=this;this.fetchStationPairData();this.timer=setInterval(function(){if(!document.hidden){_this12.fetchStationPairData();}},__WEBPACK_IMPORTED_MODULE_19__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__station_pair_StationPair__["a" /* default */],null);}},{key:"fetchClusterData",value:function fetchClusterData(nodeId,cycle,cycleId,selectedCPT,filterIdentifier,isCPTFilterEnabled){if(cycle&&cycleId&&this.props.featureStatus||selectedCPT&&this.props.featureStatus){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_ClusterActionsV2__["o" /* getMinOfWorkMetricsForCluster */])(nodeId,this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY],[cycle],[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_ClusterActionsV2__["t" /* getStowPackageMetricsForCluster */])(this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].ADTA_VISIBILITY],this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY],nodeId,[cycle],[cycleId],[selectedCPT],filterIdentifier,isCPTFilterEnabled));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_ClusterActionsV2__["s" /* getStowBinMetricsForClusterforStowV2 */])(nodeId,[cycle],[cycleId],[selectedCPT],filterIdentifier,isCPTFilterEnabled,this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].STOW_BREAKDOWN_V2]));this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].CART_VISIBILITY]&&this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_34__actions_ClusterActions__["p" /* getStowCartMetricsForCluster */])(nodeId,[cycle],[cycleId],this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].STOW_BREAKDOWN_V2]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_ClusterActionsV2__["n" /* getInductPackageMetricsForCluster */])(nodeId,[cycle],[selectedCPT],filterIdentifier,isCPTFilterEnabled));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_ClusterActionsV2__["q" /* getStowAssociateMetricsForCluster */])(nodeId,[cycle],[selectedCPT],filterIdentifier,isCPTFilterEnabled));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_ClusterActionsV2__["p" /* getNodeResourceDataForCluster */])(nodeId,"CLUSTER"));}}},{key:"fetchFloorLocationData",value:function fetchFloorLocationData(nodeId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_30__actions_FloorLocationActions__["h" /* getStowPackageMetricsForFloorLocation */])(nodeId,this.props.featureStatus));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_30__actions_FloorLocationActions__["g" /* getStowFloorMetricsForFloorLocation */])(nodeId,this.props.featureStatus));}},{key:"fetchCartData",value:function fetchCartData(nodeId,floorLocationAndReInductDay){this.props.dispatch(__WEBPACK_IMPORTED_MODULE_32__actions_CartActions__["d" /* getStowPackageMetricsForCart */].apply(undefined,[nodeId,this.props.featureStatus].concat(_toConsumableArray(floorLocationAndReInductDay))));}},{key:"fetchRouteData",value:function fetchRouteData(nodeId,capability){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_RouteActions__["g" /* getMetricsForRoute */])(nodeId,capability));}},{key:"fetchAisleData",value:function fetchAisleData(nodeId,cycle,clusters,cycleId){if(cycle&&cycleId&&this.props.featureStatus){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_AisleActions__["r" /* getStowPackageMetricsForAisle */])(this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].ADTA_VISIBILITY],this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY],nodeId,[cycle],clusters,[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_AisleActions__["p" /* getStowBinMetricsForAisleForStowV2 */])(nodeId,[cycle],clusters,[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_AisleActions__["n" /* getStowBagMetricsForAisle */])(nodeId,[cycle],clusters,[cycleId],this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].STOW_BREAKDOWN_V2]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_AisleActions__["k" /* getInductPackageMetricsForAisle */])(nodeId,[cycle],clusters));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_AisleActions__["m" /* getStowAssociateMetricsForAisle */])(nodeId,[cycle],clusters));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_AisleActions__["l" /* getNodeResourceDataForAisle */])(nodeId,"AISLE",clusters));this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].CART_VISIBILITY]&&this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_AisleActions__["q" /* getStowCartMetricsForAisle */])(nodeId,[cycle],clusters,[cycleId],this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].STOW_BREAKDOWN_V2]));}}},{key:"fetchSortZoneData",value:function fetchSortZoneData(nodeId,cycle,aisles,cycleId){if(cycle&&cycleId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_SortZoneActions__["o" /* getStowPackageMetricsForSortZone */])(this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY],nodeId,[cycle],aisles,[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_SortZoneActions__["n" /* getStowBagMetricsForSortZone */])(nodeId,[cycle],aisles,[cycleId],this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].STOW_BREAKDOWN_V2]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_SortZoneActions__["l" /* getInductPackageMetricsForSortZone */])(nodeId,[cycle],aisles));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_SortZoneActions__["k" /* fetchOvUsageForSortZone */])(nodeId,[cycle],aisles));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_SortZoneActions__["m" /* getNodeResourceDataForSortZone */])(nodeId,"BIN",aisles));}}},{key:"fetchStationPairData",value:function fetchStationPairData(){var nodeId=this.state.nodeId;this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_StationPairActions__["m" /* getInductPackageMetricsForStationPair */])(nodeId));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_StationPairActions__["n" /* getPickPackageMetricsForStationPair */])(nodeId));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_StationPairActions__["o" /* getStowAssociateMetricsForStationPair */])(nodeId));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_StationPairActions__["p" /* getStowFloorMetricsForStationPair */])(nodeId));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_StationPairActions__["q" /* getStowPackageMetricsForStationPair */])(nodeId));}},{key:"fetchFloorData",value:function fetchFloorData(){var nodeId=this.state.nodeId;var stationPairs=this.getViewSubjects('Station');this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_FloorActions__["h" /* getInductPackageMetricsForFloor */])(nodeId,stationPairs));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_FloorActions__["i" /* getPickPackageMetricsForFloor */])(nodeId,stationPairs));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_FloorActions__["l" /* getStowPackageMetricsForFloor */])(nodeId,stationPairs));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_FloorActions__["k" /* getStowFloorDataForFloor */])(nodeId,stationPairs));}},{key:"fetchCartLocationData",value:function fetchCartLocationData(){var nodeId=this.state.nodeId;var zone=this.getViewSubjects('Zone');this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__actions_CartLocationActions__["h" /* getStowPackageMetricsForCartLocation */])(nodeId,zone));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__actions_CartLocationActions__["g" /* getStowFloorDataForCartLocation */])(nodeId,zone));}},{key:"fetchZoneData",value:function fetchZoneData(nodeId,cycle,cycleId){if(cycle&&cycleId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_ZoneActions__["h" /* getStowPackageMetricsForZone */])(nodeId,[cycle],[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_ZoneActions__["g" /* getStowAssociateMetricsForZone */])(nodeId,[cycle]));}}},{key:"componentDidMount",value:function componentDidMount(){var _this13=this;Object(__WEBPACK_IMPORTED_MODULE_23__handler_ParentDataHandler__["e" /* getFeaturesFromParent */])([__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].ADTA_VISIBILITY,__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY,__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].CART_VISIBILITY]).then(function(featureStatusResponse){_this13.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__actions_ConfigActions__["b" /* fetchFeatureStatusCallSuccess */])(featureStatusResponse.data));});Object(__WEBPACK_IMPORTED_MODULE_23__handler_ParentDataHandler__["g" /* getNodeCapabilityFromParent */])().then(function(capabilityResponse){var capability=JSON.parse(capabilityResponse.capability);Object(__WEBPACK_IMPORTED_MODULE_23__handler_ParentDataHandler__["e" /* getFeaturesFromParent */])([__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].IS_CPT_FILTER_ENABLED]).then(function(featureStatusResponse){_this13.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__actions_ConfigActions__["b" /* fetchFeatureStatusCallSuccess */])(featureStatusResponse.data));});if(_this13.props.featureStatus&&_this13.props.featureStatus[__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* FEATURES */].IS_CPT_FILTER_ENABLED]&&__WEBPACK_IMPORTED_MODULE_20__enums__["e" /* Capability */].AR_NEXT_GEN!==capability){_this13.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["r" /* fetchCPTList */])());}else if(__WEBPACK_IMPORTED_MODULE_20__enums__["e" /* Capability */].AR_NEXT_GEN!==capability){_this13.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["t" /* fetchCycles */])());}_this13.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["s" /* fetchCapabilityCallSuccess */])(capabilityResponse));});}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.timer);this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["v" /* navigationRemoved */])(0));}}]);return StowBreakdownV3;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// Adapter to convert class component to functional component.
function classToFunctionAdapter(CustomComponent){return function WrappedComponent(props){var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_33__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),spacingInset_shorthand4=_useDeviceLayout.spacingInset_shorthand4;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomComponent,Object.assign({},props,{spacingInset_shorthand4:spacingInset_shorthand4}));};}var mapStateToProps=function mapStateToProps(state){return{capability:state.optionsReducerV2.capability,navigationOptions:state.optionsReducerV2.navigationOptions,selectedCycle:state.optionsReducerV2.options.cycle,selectedCPT:state.optionsReducerV2.options.CPTId,filterIdentifier:state.optionsReducerV2.filterIdentifier,selectedView:state.optionsReducerV2.heatMapView,selectedCycleId:state.optionsReducerV2.options.cycleId,featureStatus:state.configReducer.featureStatus,isInitialView:state.optionsReducerV2.isInitialView};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(classToFunctionAdapter(StowBreakdownV3))));

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ErrorPage__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_TableCellUtil__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RefreshTimer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_link__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClusterV3=function(_Component){_inherits(ClusterV3,_Component);function ClusterV3(props){_classCallCheck(this,ClusterV3);var _this=_possibleConstructorReturn(this,(ClusterV3.__proto__||Object.getPrototypeOf(ClusterV3)).call(this,props));_this.getCombinedMetricsMap=function(cluster){var _this$props=_this.props,stowPackageMetricsMap=_this$props.stowPackageMetricsMap,minOfWorkMetricsMap=_this$props.minOfWorkMetricsMap,inductPackageMetricsMap=_this$props.inductPackageMetricsMap,stowAssociateMetricsMap=_this$props.stowAssociateMetricsMap,stowBinMetricsMapForStowV2=_this$props.stowBinMetricsMapForStowV2,nodeResourceDataMap=_this$props.nodeResourceDataMap,stowCartMetricsMap=_this$props.stowCartMetricsMap;var defaultMetricValue="-";return{cluster:cluster,unopenedCarts:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(stowCartMetricsMap,cluster,"missingCarts"),binsMissingBag:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["w" /* missingBagforStowV2 */])(nodeResourceDataMap,stowBinMetricsMapForStowV2,cluster),plannedPackages:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].plannedPackages;},defaultMetricValue),receivedPackages:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return inductPackageMetricsMap[cluster].receivedPackages;},defaultMetricValue),currentInductedPackages:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].currentInductedPackages;},defaultMetricValue),stowedPackages:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].stowedPackages;},defaultMetricValue),stowVsPlan:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].stowVsPlan;},defaultMetricValue),problemSolvePackages:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].problemSolvePackages;},defaultMetricValue),minutesOfWork:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return isNaN(parseFloat(minOfWorkMetricsMap[cluster].minutesOfWork).toFixed(1))?defaultMetricValue:parseFloat(minOfWorkMetricsMap[cluster].minutesOfWork).toFixed(1);},defaultMetricValue),stowRate:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].stowRate;},defaultMetricValue),lastFifteenMinuteStowRate:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return minOfWorkMetricsMap[cluster].lastFifteenMinuteStowRate;},defaultMetricValue),scanCompliance:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].scanCompliance;},defaultMetricValue),currentStowBufferedPackages:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].currentStowBufferedPackages;},defaultMetricValue),currentMFRJackpotBufferedPackages:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].currentMFRJackpotBufferedPackages;},defaultMetricValue),activeStowers:Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["a" /* chainWalk */])(function(){return stowAssociateMetricsMap[cluster].activeStowers;},defaultMetricValue)};};_this.clusterRowClicked=function(clickedCluster){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["u" /* navigationAdded */])({key:'Cluster',value:clickedCluster}));};_this.renderTotalPackageCount=function(value,state){var params={PACKAGE_STATUS:state};return value!==0&&value!=='-'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_link___default.a,{href:_this.getPackageListURL(params),type:"secondary"}," ",value," "):value;};_this.getADTATableCell=function(value,aisle,state){return _this.isADTAVisibilityEnabled()&&Object(__WEBPACK_IMPORTED_MODULE_14__utils_TableCellUtil__["a" /* getTableCellCount */])(_this.renderPackageCount(value,aisle,state));};_this.renderPackageCount=function(value,cluster,state){var params={PACKAGE_STATUS:state,CLUSTER:cluster};return value!==0&&value!=='-'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_link___default.a,{href:_this.getPackageListURL(params),type:"secondary"}," ",value," "):value;};_this.getPackageListURL=function(params){var options=_this.props.options;if(options.cycle){params["CYCLE"]=options.cycle;}return"#packageList/?"+Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["e" /* formQueryParams */])(params);};_this.isADTAVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_16__constants__["j" /* FEATURES */].ADTA_VISIBILITY];};_this.isDRSStowVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_16__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY];};_this.isCartVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_16__constants__["j" /* FEATURES */].CART_VISIBILITY];};_this.state={sortColumn:"cluster",sortDirection:"ascending"};return _this;}_createClass(ClusterV3,[{key:"render",value:function render(){var _this2=this;var _props=this.props,loading=_props.loading,error=_props.error,stowPackageMetricsMap=_props.stowPackageMetricsMap,minOfWorkMetricsMap=_props.minOfWorkMetricsMap,inductPackageMetricsMap=_props.inductPackageMetricsMap,stowAssociateMetricsMap=_props.stowAssociateMetricsMap,nodeResourceData=_props.nodeResourceData,stowBinMetricsMapForStowV2=_props.stowBinMetricsMapForStowV2;this.aggregateStowRate=0;this.aggregateLFM=0;if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__utils_ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});}var allClusters=[].concat(_toConsumableArray(Object.keys(stowPackageMetricsMap)),_toConsumableArray(Object.keys(minOfWorkMetricsMap)),_toConsumableArray(Object.keys(inductPackageMetricsMap)),_toConsumableArray(Object.keys(stowAssociateMetricsMap)),_toConsumableArray(Object.keys(stowBinMetricsMapForStowV2)));var distinctClusters=[].concat(_toConsumableArray(new Set(allClusters)));if(loading&&!distinctClusters.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default.a,{height:"400px",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader___default.a,null));}var filteredClusters=Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["k" /* getFilteredLocations */])(distinctClusters,stowPackageMetricsMap,this.isDRSStowVisibilityEnabled());filteredClusters=filteredClusters.filter(function(cluster){return cluster!=="totalMinOfWork";});filteredClusters=[].concat(_toConsumableArray(filteredClusters),_toConsumableArray(Object.keys(nodeResourceData)));filteredClusters=[].concat(_toConsumableArray(new Set(filteredClusters)));var onSort=function onSort(sortDetails){_this2.setState({sortColumn:sortDetails.sortColumn,sortDirection:sortDetails.sortDirection});};var sortColumn=this.state.sortColumn;var direction=this.state.sortDirection;filteredClusters.sort(function(c1,c2){var c1CombinedMetricsMap=_this2.getCombinedMetricsMap(c1);var c2CombinedMetricsMap=_this2.getCombinedMetricsMap(c2);if(c1CombinedMetricsMap[sortColumn]<c2CombinedMetricsMap[sortColumn]){return direction==="ascending"?-1:1;}if(c1CombinedMetricsMap[sortColumn]>c2CombinedMetricsMap[sortColumn]){return direction==="ascending"?1:-1;}return 0;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__RefreshTimer__["a" /* default */],{deps:[stowPackageMetricsMap]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{overflowX:"auto",maxWidth:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table___default.a,{headerRows:2,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true,sortColumn:this.state.sortColumn,sortDirection:this.state.sortDirection,onSort:onSort,"data-cy":"clusterTable"},this.renderHeadings(),this.renderSubHeadings(),filteredClusters.map(function(cluster){return _this2.renderClusterRow(cluster);}),filteredClusters.length?this.renderTotalClusterRow():null)));}},{key:"renderHeadings",value:function renderHeadings(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.packages",defaultMessage:"Packages"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),this.isADTAVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),this.isADTAVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.performance",defaultMessage:"Performance"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.stowers",defaultMessage:"Stowers"})));}},{key:"renderSubHeadings",value:function renderSubHeadings(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"cluster"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.cluster",defaultMessage:"Cluster"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"plannedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.cluster.container_planned"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.container_planned",defaultMessage:"C. Planned"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"receivedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.cluster.arrived"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.arrived",defaultMessage:"Arrived"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"currentInductedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.inducted",defaultMessage:"Inducted"})),this.isADTAVisibilityEnabled()&&Object(__WEBPACK_IMPORTED_MODULE_14__utils_TableCellUtil__["b" /* getTableCellHeader */])("currentStowBufferedPackages"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.stowed",defaultMessage:"Stowed"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowVsPlan",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.cluster.stow_plan"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.stow_plan",defaultMessage:"Stow/Plan"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"problemSolvePackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.cluster.ps"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.ps",defaultMessage:"PS"}))),this.isADTAVisibilityEnabled()&&Object(__WEBPACK_IMPORTED_MODULE_14__utils_TableCellUtil__["b" /* getTableCellHeader */])("currentMFRJackpotBufferedPackages"),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"carts",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.cartsMissing",defaultMessage:"Unopened Carts"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"binsMissingBag",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.missing",defaultMessage:"Unopened Bags"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"minutesOfWork",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.cluster.minutes_of_work"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.minutes_of_work",defaultMessage:"Min of Work"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowRate",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.cluster.stow_rate"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.stow_rate",defaultMessage:"Stow rate"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"scanCompliance",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.cluster.scan_compliance"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.scan_compliance",defaultMessage:"Scan comp."}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"activeStowers",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:this.props.intl.formatMessage({id:"tooltip.cluster.active"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.active",defaultMessage:"Active"}))));}},{key:"renderClusterRow",value:function renderClusterRow(cluster){var _this3=this;var combinedMetricsMap=this.getCombinedMetricsMap(cluster);this.aggregateStowRate+=combinedMetricsMap.stowRate==="-"?0:combinedMetricsMap.stowRate;this.aggregateLFM+=combinedMetricsMap.lastFifteenMinuteStowRate==="-"?0:combinedMetricsMap.lastFifteenMinuteStowRate;var stowBufferedCell=this.getADTATableCell(combinedMetricsMap.currentStowBufferedPackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_STOW_BUFFERED);var mfrJackpotBufferedCell=this.getADTATableCell(combinedMetricsMap.currentMFRJackpotBufferedPackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_MFR_JACKPOT_BUFFERED);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,key:cluster,onClick:function onClick(){return _this3.clusterRowClicked(cluster);},"data-cy":"clusterDataRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null,cluster),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.plannedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.receivedPackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_RECEIVED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.currentInductedPackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_INDUCTED)),stowBufferedCell,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.stowedPackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].STOWED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.stowVsPlan,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.problemSolvePackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].PROBLEM_SOLVE)),mfrJackpotBufferedCell,this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.unopenedCarts),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.binsMissingBag),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.minutesOfWork),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},isFinite(parseFloat(combinedMetricsMap.stowRate/combinedMetricsMap.activeStowers).toFixed(2))?parseFloat(combinedMetricsMap.stowRate/combinedMetricsMap.activeStowers).toFixed(2):"-"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.scanCompliance,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.activeStowers));}},{key:"renderTotalClusterRow",value:function renderTotalClusterRow(){var _props2=this.props,totalStowPackageMetrics=_props2.totalStowPackageMetrics,totalInductPackageMetrics=_props2.totalInductPackageMetrics,totalStowAssociateMetrics=_props2.totalStowAssociateMetrics,stowBinMetricsMapForStowV2=_props2.stowBinMetricsMapForStowV2,nodeResourceDataMap=_props2.nodeResourceDataMap,totalStowCartMetricsMap=_props2.totalStowCartMetricsMap;if(!this.aggregateStowRate||!totalStowAssociateMetrics["Total"]||!totalStowAssociateMetrics["Total"].activeStowers||totalStowAssociateMetrics["Total"].activeStowers==="-"){totalStowPackageMetrics["Total"]=Object.assign({},totalStowPackageMetrics["Total"],{stowRate:"-"});}else{totalStowPackageMetrics["Total"]=Object.assign({},totalStowPackageMetrics["Total"],{stowRate:parseFloat(this.aggregateStowRate/totalStowAssociateMetrics["Total"].activeStowers).toFixed(2)});}if(!this.aggregateLFM||!totalStowPackageMetrics["Total"]||!totalStowPackageMetrics["Total"].currentInductedPackages||totalStowPackageMetrics["Total"].currentInductedPackages==="-"){totalStowPackageMetrics["Total"]=Object.assign({},totalStowPackageMetrics["Total"],{minutesOfWork:"-"});}else{totalStowPackageMetrics["Total"]=Object.assign({},totalStowPackageMetrics["Total"],{minutesOfWork:parseFloat(totalStowPackageMetrics["Total"].currentInductedPackages/this.aggregateLFM*60).toFixed(1)});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row___default.a,{"data-cy":"clusterTotalRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null,"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","plannedPackages")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderTotalPackageCount(Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalInductPackageMetrics,"Total","receivedPackages"),__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_RECEIVED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderTotalPackageCount(Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","currentInductedPackages"),__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_INDUCTED)),this.renderStowBufferedTotalCount(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","stowedPackages")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","stowVsPlan"),"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderTotalPackageCount(Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","problemSolvePackages"),__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].PROBLEM_SOLVE)),this.renderMFRJackpotBufferedTotalCount(),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowCartMetricsMap,"Total","cartsMissing")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["r" /* getTotalUnopenedBags */])(nodeResourceDataMap,stowBinMetricsMapForStowV2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","minutesOfWork")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","stowRate")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","scanCompliance"),"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(totalStowAssociateMetrics,"Total","activeStowers")));}},{key:"renderStowBufferedTotalCount",value:function renderStowBufferedTotalCount(){if(this.isADTAVisibilityEnabled()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderTotalPackageCount(Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(this.props.totalStowPackageMetrics,"Total","currentStowBufferedPackages")));}}},{key:"renderMFRJackpotBufferedTotalCount",value:function renderMFRJackpotBufferedTotalCount(){if(this.isADTAVisibilityEnabled()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderTotalPackageCount(Object(__WEBPACK_IMPORTED_MODULE_11__Utility__["o" /* getOrDefaultValueForCell */])(this.props.totalStowPackageMetrics,"Total","currentMFRJackpotBufferedPackages")));}}}]);return ClusterV3;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{loading:state.clusterReducerV2.loading,error:state.clusterReducerV2.error,options:state.optionsReducer.options,minOfWorkMetricsMap:state.clusterReducerV2.minOfWorkMetricsMap,stowPackageMetricsMap:state.clusterReducerV2.stowPackageMetricsMap,stowBinMetricsMapForStowV2:state.clusterReducerV2.stowBinMetricsMapForStowV2,inductPackageMetricsMap:state.clusterReducerV2.inductPackageMetricsMap,stowAssociateMetricsMap:state.clusterReducerV2.stowAssociateMetricsMap,totalStowPackageMetrics:state.clusterReducerV2.totalStowPackageMetrics,totalStowBinMetrics:state.clusterReducerV2.totalStowBinMetrics,totalInductPackageMetrics:state.clusterReducerV2.totalInductPackageMetrics,totalStowAssociateMetrics:state.clusterReducerV2.totalStowAssociateMetrics,nodeResourceData:state.clusterReducerV2.nodeResourceData,nodeResourceDataMap:state.clusterReducerV2.nodeResourceDataMap,featureStatus:state.configReducer.featureStatus};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_intl__["d" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ClusterV3))));

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ErrorPage__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__handler_LocaleHandler__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_TableCellUtil__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__RefreshTimer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AisleV3=function(_Component){_inherits(AisleV3,_Component);function AisleV3(props){_classCallCheck(this,AisleV3);var _this=_possibleConstructorReturn(this,(AisleV3.__proto__||Object.getPrototypeOf(AisleV3)).call(this,props));_this.getCombinedMetricsMap=function(aisle){var _this$props=_this.props,stowPackageMetricsMap=_this$props.stowPackageMetricsMap,inductPackageMetricsMap=_this$props.inductPackageMetricsMap,stowAssociateMetricsMap=_this$props.stowAssociateMetricsMap,stowBinMetricsMapForStowV2=_this$props.stowBinMetricsMapForStowV2,stowBagMetricsMap=_this$props.stowBagMetricsMap,nodeResourceDataMap=_this$props.nodeResourceDataMap,stowCartMetricsMap=_this$props.stowCartMetricsMap;var defaultMetricValue="-";return{aisle:aisle,plannedCarts:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(stowCartMetricsMap,aisle,"plannedCarts"),usedCarts:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(stowCartMetricsMap,aisle,"usedCarts"),missingCarts:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(stowCartMetricsMap,aisle,"missingCarts"),plannedBags:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(stowBagMetricsMap,aisle,"plannedBags"),usedBags:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(stowBagMetricsMap,aisle,"usedBags"),binsMissingBag:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["w" /* missingBagforStowV2 */])(nodeResourceDataMap,stowBinMetricsMapForStowV2,aisle),plannedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[aisle].plannedPackages;},defaultMetricValue),receivedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return inductPackageMetricsMap[aisle].receivedPackages;},defaultMetricValue),currentInductedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[aisle].currentInductedPackages;},defaultMetricValue),stowedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[aisle].stowedPackages;},defaultMetricValue),stowRate:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[aisle].stowRate;},defaultMetricValue),scanCompliance:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[aisle].scanCompliance;},defaultMetricValue),currentStowBufferedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[aisle].currentStowBufferedPackages;},defaultMetricValue),fsaf:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[aisle].fsaf;},defaultMetricValue),activeStowers:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowAssociateMetricsMap[aisle].activeStowers;},defaultMetricValue)};};_this.aisleRowClicked=function(aisle){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_OptionsActions__["q" /* navigationAdded */])({key:'Aisle',value:aisle}));};_this.getADTATableCell=function(value,aisle,state){return _this.isADTAVisibilityEnabled()&&Object(__WEBPACK_IMPORTED_MODULE_15__utils_TableCellUtil__["a" /* getTableCellCount */])(_this.renderPackageCount(value,aisle,state));};_this.renderPackageCount=function(value,aisle,state){return value!==0&&value!=='-'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_link___default.a,{href:_this.getPackageListURL(state,aisle),type:"secondary"}," ",value," "):value;};_this.getPackageListURL=function(state,aisle){var _this$props2=_this.props,navigationOptions=_this$props2.navigationOptions,options=_this$props2.options;var params={PACKAGE_STATUS:state,CLUSTER:navigationOptions[0].value,AISLE:aisle};if(options.cycle){params["CYCLE"]=options.cycle;}return"#packageList/?"+Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["e" /* formQueryParams */])(params);};_this.isADTAVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_17__constants__["j" /* FEATURES */].ADTA_VISIBILITY];};_this.isDRSStowVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_17__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY];};_this.isCartVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_17__constants__["j" /* FEATURES */].CART_VISIBILITY];};_this.state={sortColumn:"aisle",sortDirection:"ascending"};return _this;}_createClass(AisleV3,[{key:"render",value:function render(){var _this2=this;var _props=this.props,loading=_props.loading,error=_props.error,stowPackageMetricsMap=_props.stowPackageMetricsMap,inductPackageMetricsMap=_props.inductPackageMetricsMap,stowAssociateMetricsMap=_props.stowAssociateMetricsMap,stowBagMetricsMap=_props.stowBagMetricsMap,nodeResourceData=_props.nodeResourceData,stowBinMetricsMapForStowV2=_props.stowBinMetricsMapForStowV2,stowCartMetricsMap=_props.stowCartMetricsMap;if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__utils_ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});}var allAisles=[].concat(_toConsumableArray(Object.keys(stowPackageMetricsMap)),_toConsumableArray(Object.keys(inductPackageMetricsMap)),_toConsumableArray(Object.keys(stowAssociateMetricsMap)),_toConsumableArray(Object.keys(stowBinMetricsMapForStowV2)),_toConsumableArray(Object.keys(stowBagMetricsMap)),_toConsumableArray(Object.keys(stowCartMetricsMap)));var distinctAisles=[].concat(_toConsumableArray(new Set(allAisles)));if(loading&&!distinctAisles.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,{height:"400px",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader___default.a,null));}var filteredAisles=Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["k" /* getFilteredLocations */])(distinctAisles,stowPackageMetricsMap,this.isDRSStowVisibilityEnabled());if(nodeResourceData!=null){filteredAisles=[].concat(_toConsumableArray(filteredAisles),_toConsumableArray(Object.keys(nodeResourceData)));}filteredAisles=[].concat(_toConsumableArray(new Set(filteredAisles)));try{filteredAisles=filteredAisles.filter(function(aisles){return aisles.startsWith(_this2.props.navigationOptions[0].value);});}catch(error){console.error(error);}var onSort=function onSort(sortDetails){_this2.setState({sortColumn:sortDetails.sortColumn,sortDirection:sortDetails.sortDirection});};function customCompare(a,b){return Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["b" /* convertToString */])(a).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["b" /* convertToString */])(b),Object(__WEBPACK_IMPORTED_MODULE_14__handler_LocaleHandler__["b" /* getLocale */])(),{numeric:true});}var sortColumn=this.state.sortColumn;var direction=this.state.sortDirection;filteredAisles.sort(function(a1,a2){var a1CombinedMetricsMap=_this2.getCombinedMetricsMap(a1);var a2CombinedMetricsMap=_this2.getCombinedMetricsMap(a2);if(direction==="ascending"){return customCompare(a1CombinedMetricsMap[sortColumn],a2CombinedMetricsMap[sortColumn]);}else{return customCompare(a2CombinedMetricsMap[sortColumn],a1CombinedMetricsMap[sortColumn]);}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__RefreshTimer__["a" /* default */],{deps:[stowBinMetricsMapForStowV2]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table___default.a,{headerRows:2,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true,sortColumn:this.state.sortColumn,sortDirection:this.state.sortDirection,onSort:onSort,"data-cy":"aisleTable"},this.renderHeadings(),this.renderSubHeadings(),filteredAisles.map(function(aisle){return _this2.renderAisleRow(aisle);})));}},{key:"renderHeadings",value:function renderHeadings(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.packages",defaultMessage:"Packages"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),this.isADTAVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.carts",defaultMessage:"Carts"})),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.bags",defaultMessage:"Bags"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.performance",defaultMessage:"Performance"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.stowers",defaultMessage:"Stowers"})));}},{key:"renderSubHeadings",value:function renderSubHeadings(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"aisle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.aisle",defaultMessage:"Aisle"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"plannedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.containerPlanned",defaultMessage:"C. Planned"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"receivedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.arrived",defaultMessage:"Arrived"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"currentInductedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.inducted",defaultMessage:"Inducted"})),this.isADTAVisibilityEnabled()&&Object(__WEBPACK_IMPORTED_MODULE_15__utils_TableCellUtil__["b" /* getTableCellHeader */])("currentStowBufferedPackages"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.stowed",defaultMessage:"Stowed"})),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"plannedCarts",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.planned_carts",defaultMessage:"Planned"})),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"usedCarts",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.used_carts",defaultMessage:"Used"})),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"missingCarts",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.missing_carts",defaultMessage:"Missing"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"plannedBags",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.planned",defaultMessage:"Planned"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"usedBags",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.used",defaultMessage:"Used"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"binsMissingBag",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.missing",defaultMessage:"Missing"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowRate",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.stow_rate",defaultMessage:"Stow rate"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"scanCompliance",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.scan_complaince",defaultMessage:"Scan comp."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"fsaf",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.fsaf",defaultMessage:"FSAF"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"activeStowers",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"aisle.active",defaultMessage:"Active"})));}},{key:"renderAisleRow",value:function renderAisleRow(aisle){var _this3=this;var combinedMetricsMap=this.getCombinedMetricsMap(aisle);var stowBufferedCell=this.getADTATableCell(combinedMetricsMap.currentStowBufferedPackages,aisle,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_STOW_BUFFERED);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,key:aisle,onClick:function onClick(){return _this3.aisleRowClicked(aisle);},"data-cy":"aisleDataRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,aisle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.plannedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.receivedPackages,aisle,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_RECEIVED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.currentInductedPackages,aisle,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_INDUCTED)),stowBufferedCell,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.stowedPackages,aisle,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].STOWED)),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.plannedCarts),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.usedCarts),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.missingCarts),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.plannedBags),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.usedBags),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.binsMissingBag),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.stowRate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.scanCompliance,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.fsaf),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.activeStowers));}}]);return AisleV3;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{loading:state.aisleReducer.loading,error:state.aisleReducer.error,navigationOptions:state.optionsReducer.navigationOptions,options:state.optionsReducer.options,stowPackageMetricsMap:state.aisleReducer.stowPackageMetricsMap,stowBinMetricsMap:state.aisleReducer.stowBinMetricsMap,stowBinMetricsMapForStowV2:state.aisleReducer.stowBinMetricsMapForStowV2,stowBagMetricsMap:state.aisleReducer.stowBagMetricsMap,stowCartMetricsMap:state.aisleReducer.stowCartMetricsMap,inductPackageMetricsMap:state.aisleReducer.inductPackageMetricsMap,stowAssociateMetricsMap:state.aisleReducer.stowAssociateMetricsMap,nodeResourceData:state.aisleReducer.nodeResourceData,nodeResourceDataMap:state.aisleReducer.nodeResourceDataMap,featureStatus:state.configReducer.featureStatus};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(AisleV3)));

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ErrorPage__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_SortZoneActions__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__handler_LocaleHandler__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RefreshTimer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SortZoneV3=function(_Component){_inherits(SortZoneV3,_Component);function SortZoneV3(props){_classCallCheck(this,SortZoneV3);var _this=_possibleConstructorReturn(this,(SortZoneV3.__proto__||Object.getPrototypeOf(SortZoneV3)).call(this,props));_this.getCombinedMetricsMap=function(sortZone){var _this$props=_this.props,stowPackageMetricsMap=_this$props.stowPackageMetricsMap,inductPackageMetricsMap=_this$props.inductPackageMetricsMap,ovUsageMap=_this$props.ovUsageMap,stowBagMetricsMap=_this$props.stowBagMetricsMap;var defaultMetricValue="-";return{sortZone:sortZone,plannedBags:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["o" /* getOrDefaultValueForCell */])(stowBagMetricsMap,sortZone,"plannedBags"),closedBags:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["o" /* getOrDefaultValueForCell */])(stowBagMetricsMap,sortZone,"closedBags"),openBags:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["o" /* getOrDefaultValueForCell */])(stowBagMetricsMap,sortZone,"openBags"),plannedPackages:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[sortZone].plannedPackages;},defaultMetricValue),receivedPackages:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return inductPackageMetricsMap[sortZone].receivedPackages;},defaultMetricValue),inductedPackages:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[sortZone].currentInductedPackages;},defaultMetricValue),stowedPackages:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[sortZone].stowedPackages;},defaultMetricValue),ovUsage:Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["a" /* chainWalk */])(function(){return ovUsageMap[sortZone].ovUsage+'%';},defaultMetricValue)};};_this.clickSortZoneRow=function(sortZone){_this.setState(function(oldState){if(oldState.expandedSortZones.indexOf(sortZone)!==-1){return{expandedSortZones:oldState.expandedSortZones.filter(function(expandedSortZone){return expandedSortZone!==sortZone;})};}else{_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_SortZoneActions__["j" /* fetchBagsDataForSortZone */])(Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["m" /* getNodeId */])(),[_this.props.options.cycle],sortZone));return{expandedSortZones:oldState.expandedSortZones.concat(sortZone)};}});};_this.isSortZoneExpanded=function(sortZone){return _this.state.expandedSortZones.indexOf(sortZone)!==-1;};_this.renderPackageCount=function(value,sortZone,state){return value!==0&&value!=='-'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_link___default.a,{href:_this.getPackageListURL(state,sortZone),type:"secondary"}," ",value," "):value;};_this.getPackageListURL=function(state,sortZone){var _this$props2=_this.props,navigationOptions=_this$props2.navigationOptions,options=_this$props2.options;var params={PACKAGE_STATUS:state,BIN:sortZone,AISLE:navigationOptions[1].value};if(options.cycle){params["CYCLE"]=options.cycle;}return"#packageList/?"+Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["e" /* formQueryParams */])(params);};_this.isDRSStowVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_16__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY];};_this.state={expandedSortZones:[],sortColumn:"sortZone",sortDirection:"ascending"};return _this;}_createClass(SortZoneV3,[{key:"render",value:function render(){var _this2=this;var _props=this.props,loading=_props.loading,error=_props.error,stowPackageMetricsMap=_props.stowPackageMetricsMap,inductPackageMetricsMap=_props.inductPackageMetricsMap,stowBagMetricsMap=_props.stowBagMetricsMap,ovUsageMap=_props.ovUsageMap,nodeResourceData=_props.nodeResourceData;if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utils_ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});}var sortZones=[].concat(_toConsumableArray(Object.keys(stowPackageMetricsMap)),_toConsumableArray(Object.keys(stowBagMetricsMap)),_toConsumableArray(Object.keys(inductPackageMetricsMap)),_toConsumableArray(Object.keys(ovUsageMap)));var distinctSortZones=[].concat(_toConsumableArray(new Set(sortZones)));if(loading&&!distinctSortZones.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default.a,{height:"400px",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_loader___default.a,null));}var filteredZones=Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["k" /* getFilteredLocations */])(distinctSortZones,stowPackageMetricsMap,this.isDRSStowVisibilityEnabled());if(nodeResourceData!=null){filteredZones=[].concat(_toConsumableArray(filteredZones),_toConsumableArray(Object.keys(nodeResourceData)));}filteredZones=[].concat(_toConsumableArray(new Set(filteredZones)));var onSort=function onSort(sortDetails){_this2.setState({sortColumn:sortDetails.sortColumn,sortDirection:sortDetails.sortDirection});};function customCompare(a,b){return Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["b" /* convertToString */])(a).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_9__Utility__["b" /* convertToString */])(b),Object(__WEBPACK_IMPORTED_MODULE_14__handler_LocaleHandler__["b" /* getLocale */])(),{numeric:true});}var sortColumn=this.state.sortColumn;var direction=this.state.sortDirection;filteredZones.sort(function(s1,s2){var s1CombinedMetricsMap=_this2.getCombinedMetricsMap(s1);var s2CombinedMetricsMap=_this2.getCombinedMetricsMap(s2);if(direction==="ascending"){return customCompare(s1CombinedMetricsMap[sortColumn],s2CombinedMetricsMap[sortColumn]);}else{return customCompare(s2CombinedMetricsMap[sortColumn],s1CombinedMetricsMap[sortColumn]);}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__RefreshTimer__["a" /* default */],{deps:[stowPackageMetricsMap]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table___default.a,{headerRows:2,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true,sortColumn:this.state.sortColumn,sortDirection:this.state.sortDirection,onSort:onSort,"data-cy":"zoneTable"},this.renderHeadings(),this.renderSubHeadings(),filteredZones.map(function(sortZone){return _this2.renderSortZoneRow(sortZone);})));}},{key:"renderHeadings",value:function renderHeadings(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.bags",defaultMessage:"Bags"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.ov_capacity",defaultMessage:"OV Capacity"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.packages",defaultMessage:"Packages"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null));}},{key:"renderSubHeadings",value:function renderSubHeadings(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"sortZone"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.zone",defaultMessage:"Zone"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"plannedBags",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.planned",defaultMessage:"Planned"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"closedBags",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.closed",defaultMessage:"Closed"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"openBags",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.open",defaultMessage:"Open"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"ovUsage",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.used",defaultMessage:"Used"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"plannedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.container_planned",defaultMessage:"C. Planned"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"receivedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.arrived",defaultMessage:"Arrived"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"inductedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.inducted",defaultMessage:"Inducted"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.stowed",defaultMessage:"Stowed"})));}},{key:"renderSortZoneRow",value:function renderSortZoneRow(sortZone){var _this3=this;var bagsData=this.props.bagsData;var combinedMetricsMap=this.getCombinedMetricsMap(sortZone);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,{key:sortZone,open:this.isSortZoneExpanded(sortZone),onClick:function onClick(){return _this3.clickSortZoneRow(sortZone);},"data-cy":"zoneDataRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,null,sortZone),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.plannedBags),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.closedBags),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.openBags),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.ovUsage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.plannedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.receivedPackages,sortZone,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_RECEIVED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.inductedPackages,sortZone,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_INDUCTED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.stowedPackages,sortZone,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].STOWED)),bagsData&&bagsData[sortZone]&&bagsData[sortZone].length?bagsData[sortZone].map(function(bag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_cell___default.a,{columnSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"sortZone.bag",defaultMessage:"Bag"})," ",bag.bagLabel," (",bag.state,"): ",bag.childCount," packages"));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table_table_row___default.a,null));}}]);return SortZoneV3;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{loading:state.sortZoneReducer.loading,error:state.sortZoneReducer.error,navigationOptions:state.optionsReducer.navigationOptions,options:state.optionsReducer.options,stowPackageMetricsMap:state.sortZoneReducer.stowPackageMetricsMap,stowBagMetricsMap:state.sortZoneReducer.stowBagMetricsMap,inductPackageMetricsMap:state.sortZoneReducer.inductPackageMetricsMap,bagsData:state.sortZoneReducer.bagsData,ovUsageMap:state.sortZoneReducer.stowOvUsageMap,nodeResourceData:state.sortZoneReducer.nodeResourceData,totalSortZoneMap:state.sortZoneReducer.totalSortZoneMap,featureStatus:state.configReducer.featureStatus};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(SortZoneV3)));

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OptionsV2__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_OptionsActionsV2__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_RouteConstants__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_Navigation__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__options_HeatMapViewOptionsV2__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_ConfigActions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_PageHeader__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__options_FilterOptionsV2__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_context_DeviceLayoutContext__ = __webpack_require__(41);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeatMapV2=function(_Component){_inherits(HeatMapV2,_Component);function HeatMapV2(props){_classCallCheck(this,HeatMapV2);var _this=_possibleConstructorReturn(this,(HeatMapV2.__proto__||Object.getPrototypeOf(HeatMapV2)).call(this,props));_this.state={nodeId:Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["m" /* getNodeId */])(),routeCodePrefixes:Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["d" /* extractRouteCodePrefixesFromParam */])(props)};return _this;}_createClass(HeatMapV2,[{key:'render',value:function render(){var _props=this.props,selectedView=_props.selectedView,spacingInset_shorthand5=_props.spacingInset_shorthand5;var routes=this.getRoutesToShow();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacingInset:spacingInset_shorthand5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__utils_PageHeader__["a" /* PageHeader */],__WEBPACK_IMPORTED_MODULE_9__constants__["n" /* HEADERS */].HEATMAP),this.renderOptions(selectedView),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__utils_Navigation__["b" /* default */],{routes:routes,location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__utils_Navigation__["a" /* NavigationRoutes */],{routes:routes}));}},{key:'renderOptions',value:function renderOptions(selectedView){return!Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["u" /* isOnlyRouteViewApplicable */])(this.state.nodeId,this.props.capability)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__OptionsV2__["a" /* default */],{options:this.getApplicableOptions(selectedView),optionsTagsRequired:this.getApplicableOptionTags(selectedView)});}},{key:'getRoutesToShow',value:function getRoutesToShow(){var routes=__WEBPACK_IMPORTED_MODULE_6__utils_RouteConstants__["d" /* STOW_ROUTES */];if(this.props.featureStatus&&this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_9__constants__["j" /* FEATURES */].STOW_BREAKDOWN_V2]){routes=routes.concat([__WEBPACK_IMPORTED_MODULE_6__utils_RouteConstants__["c" /* STOW_BREAKDOWN_V2_ROUTE */]]);}if(this.props.featureStatus&&this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_9__constants__["j" /* FEATURES */].GRID_ALLOCATION_VIEW_ENABLED]){routes=routes.concat([__WEBPACK_IMPORTED_MODULE_6__utils_RouteConstants__["b" /* GRID_ALLOCATION_ROUTE */]]);}return routes;}},{key:'getApplicableOptions',value:function getApplicableOptions(selectedView){if(__WEBPACK_IMPORTED_MODULE_10__enums__["q" /* ViewType */].ROUTE_VIEW===selectedView||__WEBPACK_IMPORTED_MODULE_10__enums__["q" /* ViewType */].SIDELINE_VIEW===selectedView||__WEBPACK_IMPORTED_MODULE_10__enums__["e" /* Capability */].AR_NEXT_GEN===this.props.capability)return[{component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__options_HeatMapViewOptionsV2__["a" /* default */],null),name:"HeatMapViewOptions"}];else return[{component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__options_HeatMapViewOptionsV2__["a" /* default */],null),name:"HeatMapViewOptions"},{component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__options_FilterOptionsV2__["a" /* default */],null),name:"FilterOptionsV2"}];}},{key:'getApplicableOptionTags',value:function getApplicableOptionTags(selectedView){if(__WEBPACK_IMPORTED_MODULE_10__enums__["q" /* ViewType */].ROUTE_VIEW===selectedView||__WEBPACK_IMPORTED_MODULE_10__enums__["q" /* ViewType */].SIDELINE_VIEW===selectedView||__WEBPACK_IMPORTED_MODULE_10__enums__["e" /* Capability */].AR_NEXT_GEN===this.props.capability)return[];return __WEBPACK_IMPORTED_MODULE_9__constants__["r" /* OPTIONS_TAG_REQUIRED */];}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_12__handler_ParentDataHandler__["e" /* getFeaturesFromParent */])([__WEBPACK_IMPORTED_MODULE_9__constants__["j" /* FEATURES */].CART_VISIBILITY,__WEBPACK_IMPORTED_MODULE_9__constants__["j" /* FEATURES */].ADTA_VISIBILITY,__WEBPACK_IMPORTED_MODULE_9__constants__["j" /* FEATURES */].SIDELINE_STOW_VISIBILITY,__WEBPACK_IMPORTED_MODULE_9__constants__["j" /* FEATURES */].SIDELINE_STOW_V2,__WEBPACK_IMPORTED_MODULE_9__constants__["j" /* FEATURES */].REINDUCT_DATE_PLUS_ONE_FIX,__WEBPACK_IMPORTED_MODULE_9__constants__["j" /* FEATURES */].GRID_ALLOCATION_VIEW_ENABLED,__WEBPACK_IMPORTED_MODULE_9__constants__["j" /* FEATURES */].STOW_BREAKDOWN_V2,__WEBPACK_IMPORTED_MODULE_9__constants__["j" /* FEATURES */].DOWNLOAD_SORT_PLAN_BUTTON_VISIBILITY]).then(function(featureStatusResponse){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_ConfigActions__["b" /* fetchFeatureStatusCallSuccess */])(featureStatusResponse.data));});Object(__WEBPACK_IMPORTED_MODULE_12__handler_ParentDataHandler__["g" /* getNodeCapabilityFromParent */])().then(function(capabilityResponse){var capability=JSON.parse(capabilityResponse.capability);Object(__WEBPACK_IMPORTED_MODULE_12__handler_ParentDataHandler__["e" /* getFeaturesFromParent */])([__WEBPACK_IMPORTED_MODULE_9__constants__["j" /* FEATURES */].IS_CPT_FILTER_ENABLED]).then(function(featureStatusResponse){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_ConfigActions__["b" /* fetchFeatureStatusCallSuccess */])(featureStatusResponse.data));});if(_this2.props.featureStatus&&_this2.props.featureStatus[__WEBPACK_IMPORTED_MODULE_9__constants__["j" /* FEATURES */].IS_CPT_FILTER_ENABLED]&&__WEBPACK_IMPORTED_MODULE_10__enums__["e" /* Capability */].AR_NEXT_GEN!==capability){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_OptionsActionsV2__["r" /* fetchCPTList */])());}else if(__WEBPACK_IMPORTED_MODULE_10__enums__["e" /* Capability */].AR_NEXT_GEN!==capability){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_OptionsActionsV2__["t" /* fetchCycles */])());}_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_OptionsActionsV2__["s" /* fetchCapabilityCallSuccess */])(capabilityResponse));});}}]);return HeatMapV2;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// Adapter to convert class component to functional component.
function classToFunctionAdapter(CustomComponent){return function WrappedComponent(props){var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_16__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),spacingInset_shorthand5=_useDeviceLayout.spacingInset_shorthand5;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomComponent,Object.assign({},props,{spacingInset_shorthand5:spacingInset_shorthand5}));};}var mapStateToProps=function mapStateToProps(state){return{capability:state.optionsReducerV2.capability,navigationOptions:state.optionsReducerV2.navigationOptions,selectedCycle:state.optionsReducerV2.options.cycle,selectedView:state.optionsReducerV2.heatMapView,selectedCycleId:state.optionsReducerV2.options.cycleId,featureStatus:state.configReducer.featureStatus,isInitialView:state.optionsReducerV2.isInitialView};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(classToFunctionAdapter(HeatMapV2))));

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_box__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_loader__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_context_DeviceLayoutContext__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_FilterExpander__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DownloadSortPlanButton__ = __webpack_require__(626);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OptionsV2=function(_Component){_inherits(OptionsV2,_Component);function OptionsV2(){_classCallCheck(this,OptionsV2);return _possibleConstructorReturn(this,(OptionsV2.__proto__||Object.getPrototypeOf(OptionsV2)).apply(this,arguments));}_createClass(OptionsV2,[{key:"render",value:function render(){var _props=this.props,loading=_props.loading,options=_props.options,isMobile=_props.isMobile,spacingInset_shorthand2=_props.spacingInset_shorthand2;function renderFilterOptions(){return options.map(function(option){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,{heights:"fill",alignmentHorizontal:"center",spacingInset:"none medium none",key:option.name},option.component);});}function showOptions(){if(loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,{height:"100px",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_loader___default.a,null));}if(isMobile){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_box___default.a,{backgroundColor:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_FilterExpander__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,{alignmentHorizontal:"left",alignmentVertical:"top",spacingInset:"medium small"},renderFilterOptions())));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{alignmentHorizontal:"left",alignmentVertical:"top",spacingInset:spacingInset_shorthand2,backgroundColor:"secondary"},renderFilterOptions(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"download-sort-plan-button"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__DownloadSortPlanButton__["a" /* default */],null)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,{width:"100%",className:"Options",spacingInset:"none"},showOptions());}}]);return OptionsV2;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// Adapter to convert class component to functional component.
function classToFunctionAdapter(CustomComponent){return function WrappedComponent(props){var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_7__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),isMobile=_useDeviceLayout.isMobile,spacingInset_shorthand2=_useDeviceLayout.spacingInset_shorthand2;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomComponent,Object.assign({},props,{isMobile:isMobile,spacingInset_shorthand2:spacingInset_shorthand2}));};}var mapStateToProps=function mapStateToProps(state){return{loading:state.optionsReducerV2.loading,selectedOptions:state.optionsReducerV2.options,showingOptionsMenu:state.optionsReducerV2.showingOptionsMenu};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(classToFunctionAdapter(OptionsV2))));

/***/ }),
/* 625 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconFilterData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round' stroke='currentColor' stroke-width='2'%3e%3cpath d='M3 5h12M3 19h12M21 5h-2M21 19h-2M9 12h12M3 12h2'/%3e%3ccircle fill-rule='nonzero' cx='17' cy='5' r='2'/%3e%3ccircle fill-rule='nonzero' cx='17' cy='19' r='2'/%3e%3ccircle fill-rule='nonzero' cx='7' cy='12' r='2'/%3e%3c/g%3e%3c/svg%3e",
  iconFilterWidth: 24,
  iconFilterHeight: 24
};

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resources_GetSortPlanResource__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_loader__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_loader__);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/**
 * Button component for downloading sort plan data in CSV format.
 * Gets the nodeId from query parameters and cycleId from Redux state.
 */var DownloadSortPlanButton=function DownloadSortPlanButton(_ref){var selectedCycle=_ref.selectedCycle,featureStatus=_ref.featureStatus;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isLoading=_useState2[0],setIsLoading=_useState2[1];var handleClick=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var nodeId,cycleId,fileType,response,today,dateStr,filename;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;setIsLoading(true);nodeId=Object(__WEBPACK_IMPORTED_MODULE_5__Utility__["m" /* getNodeId */])();cycleId=selectedCycle;fileType=__WEBPACK_IMPORTED_MODULE_7__enums__["i" /* FileType */].CSV;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_4__resources_GetSortPlanResource__["a" /* GetSortPlanResource */])(nodeId,cycleId,fileType);case 7:response=_context.sent;today=new Date();dateStr=today.toISOString().split('T')[0];filename='SortPlan-'+nodeId+'-'+cycleId+'-'+dateStr+'.csv';_context.next=13;return Object(__WEBPACK_IMPORTED_MODULE_5__Utility__["c" /* downloadCsvFromUrl */])(response.data.sortPlanMetadataPresignedS3Url,filename);case 13:_context.prev=13;setIsLoading(false);return _context.finish(13);case 16:case'end':return _context.stop();}}},_callee,_this,[[0,,13,16]]);}));return function handleClick(){return _ref2.apply(this,arguments);};}();if(!featureStatus||!featureStatus[__WEBPACK_IMPORTED_MODULE_8__constants__["j" /* FEATURES */].DOWNLOAD_SORT_PLAN_BUTTON_VISIBILITY]){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'download-sort-plan-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:isLoading?null:handleClick,className:'download-sort-plan-link '+(isLoading?'disabled':''),'data-cy':'downloadSortPlanBtn'},isLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_loader___default.a,{size:'small'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'stow.download_sort_location_plan',defaultMessage:'Download-sort-location-plan'})));};var mapStateToProps=function mapStateToProps(state){return{selectedCycle:state.optionsReducer.options.cycle,cycleId:state.optionsReducer.options.cycleId,featureStatus:state.configReducer.featureStatus};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(DownloadSortPlanButton)));

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetSortPlanResource; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__ = __webpack_require__(24);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getSortLocationPlanEndPoint='/sls/get-sort-plan';var spgProcessName="sortPathGenerator";/**
 * Gets a presigned S3 URL containing package-level OV planned sortZone info in CSV format
 * @param {string} nodeId - The station code
 * @param {string} cycleId - The cycle ID
 * @param {string} fileType - The file type (e.g., 'csv')
 * @returns {Promise<string>} - Presigned URL for downloading the sort plan CSV
 */var GetSortPlanResource=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(nodeId,cycleId,fileType){var requestBody,request,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:requestBody={stationCode:nodeId,cycleName:cycleId,fileType:fileType};request=getAPIGatewayPostRequest(getSortLocationPlanEndPoint,requestBody);_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(request);case 4:response=_context.sent;return _context.abrupt("return",response);case 6:case"end":return _context.stop();}}},_callee,this);}));return function GetSortPlanResource(_x,_x2,_x3){return _ref.apply(this,arguments);};}();function getAPIGatewayPostRequest(endpoint,request){var httpMethod=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"POST";return{resourcePath:endpoint,httpMethod:httpMethod,processName:spgProcessName,requestBody:request};}

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavigationRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_tab__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Custom hook that checks which route matches the current location
 * and returns its name in the object
 * @param routes
 * @param location
 * @returns Object
 */var useCurrentRoute=function useCurrentRoute(routes,location){var currentPath=location.pathname;var _ref=routes.find(function(route){return!!Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* matchPath */])(currentPath,{path:route.path});})||{},name=_ref.name;return{name:name};};/**
 * Returns Route components from a list of routes
 * @param routes
 * @returns JSX.Element
 */var NavigationRoutes=function NavigationRoutes(_ref2){var routes=_ref2.routes;return routes.map(function(_ref3){var path=_ref3.path,component=_ref3.component;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */],{key:path,path:path,component:component});});};/**
 * Component that handles the tab UI and changes
 * @param routes
 * @returns JSX.Element
 */var Navigation=function(_Component){_inherits(Navigation,_Component);function Navigation(){var _ref4;var _temp,_this,_ret;_classCallCheck(this,Navigation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref4=Navigation.__proto__||Object.getPrototypeOf(Navigation)).call.apply(_ref4,[this].concat(args))),_this),_this.state=useCurrentRoute(_this.props.routes,_this.props.location),_this.onTabChange=function(selectedTab){_this.props.routes.forEach(function(_ref5){var name=_ref5.name,path=_ref5.path;if(name===selectedTab){_this.setState({name:name});_this.props.history.push(path);}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Navigation,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_tab__["TabGroup"],{value:this.state.name,onChange:this.onTabChange,fill:"line"},this.props.routes.map(function(_ref6){var name=_ref6.name,id=_ref6.id;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_tab___default.a,{key:name,value:name},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:id}));}));}}]);return Navigation;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);/* harmony default export */ __webpack_exports__["b"] = (Navigation);

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TabGroup", {
  enumerable: true,
  get: function get() {
    return _tabGroup["default"];
  }
});
exports["default"] = void 0;

var _tab = _interopRequireDefault(__webpack_require__(630));

var _tabGroup = _interopRequireDefault(__webpack_require__(631));

var _default = _tab["default"];
exports["default"] = _default;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _keycode = _interopRequireDefault(__webpack_require__(47));

var _emotion = __webpack_require__(4);

var _context = __webpack_require__(272);

var _focus = _interopRequireDefault(__webpack_require__(135));

var _token = __webpack_require__(12);

var _focusRing = _interopRequireDefault(__webpack_require__(43));

var _text = _interopRequireDefault(__webpack_require__(27));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

var _borderRadius = _interopRequireDefault(__webpack_require__(100));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Styles
 */
var transparent = "rgba(0,0,0,0)"; // Root styles for the entire component

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var selected = _ref.selected,
      disabled = _ref.disabled,
      fill = _ref.fill,
      type = _ref.type;
  return (0, _emotion.css)((0, _text["default"])(t), {
    flexGrow: fill === "tabs" ? 1 : "initial",
    position: "relative",
    ":not(:last-child)": (0, _defineProperty2["default"])({
      // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
      // to use directional margin-left/right. If/when we drop IE11 we can simplify
      // these styles to be:
      // {
      //   marginInlineEnd: t("spacingHorizontal"),
      // }
      marginRight: t("spacingHorizontal")
    }, "[dir=\"rtl\"] &", {
      marginLeft: t("spacingHorizontal"),
      marginRight: 0
    }),
    cursor: disabled ? "not-allowed" : "pointer",
    transition: t.transitionCss("motion", "color"),
    color: t("foregroundColor", disabled ? "disabled" : selected ? "selected" : "default"),
    ":hover": !disabled && !selected && {
      color: t("foregroundColorHover")
    },
    ":active": !disabled && {
      color: t("foregroundColorPressed")
    }
  }, type === "classic" ? classicStyles(t, {
    selected: selected,
    disabled: disabled
  }) : {});
}, ["selected", "disabled", "fill", "type"]);

var classicStyles = function classicStyles(t, _ref2) {
  var disabled = _ref2.disabled;
  return {
    boxSizing: "border-box",
    border: "".concat(t("borderWidth"), "px solid ").concat(t("borderColor")),
    borderColor: "".concat(transparent, " ").concat(transparent, " ").concat(t("borderColor")),
    "&[mdn-tab-selected-previous]": (0, _defineProperty2["default"])({
      borderRadius: (0, _borderRadius["default"])(t("borderRadius"), ["bottomRight"])
    }, "[dir=\"rtl\"] &", {
      borderRadius: (0, _borderRadius["default"])(t("borderRadius"), ["bottomLeft"])
    }),
    "&[mdn-tab-selected-next]": (0, _defineProperty2["default"])({
      borderRadius: (0, _borderRadius["default"])(t("borderRadius"), ["bottomLeft"])
    }, "[dir=\"rtl\"] &", {
      borderRadius: (0, _borderRadius["default"])(t("borderRadius"), ["bottomRight"])
    }),
    "&[mdn-tab-selected]": {
      borderColor: transparent
    },
    "&[mdn-tab-selected]:after": {
      content: "\"\"",
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      border: "".concat(t("borderWidth"), "px solid ").concat(t("borderColor")),
      borderBottomColor: transparent,
      borderRadius: (0, _borderRadius["default"])(t("borderRadius"), ["topLeft", "topRight"])
    },
    ":not(:last-child)": (0, _defineProperty2["default"])({
      // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
      // to use directional margin-left/right. If/when we drop IE11 we can simplify
      // these styles to be:
      // {
      //   marginInlineEnd: -3,
      // }
      marginRight: -3
    }, "[dir=\"rtl\"] &", {
      marginLeft: -3
    }),
    "&:not([mdn-tab-selected]) > div": {
      opacity: 0
    },
    "&:not([mdn-tab-selected]):hover > div": {
      opacity: !disabled ? 1 : undefined
    },
    padding: "".concat(t("spacingInsetClassicVertical"), "px ").concat(t("spacingInsetClassicHorizontal"), "px"),
    paddingBottom: 0
  };
}; // Styles for the tab (a psuedo-element) that's actually displayed to users


var visibleTabStyles = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var disabled = _ref3.disabled,
      focus = _ref3.focus,
      type = _ref3.type;
  return (0, _emotion.css)({
    width: "100%",
    textAlign: "center",
    position: "relative",
    boxSizing: "border-box",
    padding: "".concat(t("spacingInsetVertical"), "px ").concat(t("spacingInsetHorizontal"), "px")
  }, !disabled ? (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    borderRadius: type === "classic" ? // We decrease border radius by one here because the focus ring will appear inside
    // another rounded box. Visually, two concentric rounded boxes look better if the
    // border radius gets smaller from the outside in
    "".concat(parseInt(t("borderRadius") - 1), " ").concat(parseInt(t("borderRadius") - 1), " 0 0") : undefined,
    offset: 0
  }) : undefined);
}, ["disabled", "focus", "type"]);
var tabBaseLineStyles = (0, _token.memoizeTokenStyles)(function (t, _ref4) {
  var selected = _ref4.selected,
      disabled = _ref4.disabled,
      type = _ref4.type;
  return (0, _emotion.css)({
    // This magic number for classic is used to make the appearance of internal padding
    // between the edge of the activated tab and the indicator bar. It's derived by
    // (target padding - existing padding) * 2 (sides)
    width: type === "classic" ? "calc(100% - ".concat((parseInt(t("spacingInsetClassicBaseLine")) - parseInt(t("spacingInsetClassicHorizontal"))) * 2, "px)") : "100%",
    height: t("indicatorHeight"),
    borderRadius: t("indicatorRadius"),
    margin: "auto",
    marginTop: t("spacingVertical", type),
    transition: t.transitionCss("motion", "background-color", "opacity"),
    backgroundColor: t("indicatorColor", disabled ? "disabled" : selected ? "selected" : "default"),
    "*:hover > &": (0, _emotion.css)(!disabled && {
      backgroundColor: t("indicatorColorHover")
    }),
    "*:active > &": (0, _emotion.css)(!disabled && {
      backgroundColor: t("indicatorColorPressed")
    })
  });
}, ["selected", "disabled", "type"]); // Styles for the actual HTML tab element that is hidden from the user

var hiddenTabStyles = (0, _emotion.css)({
  clip: "rect(0 0 0 0)",
  overflow: "hidden",
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  opacity: 0
});
/**
 * Used to render a single tab in a group of tabs. Place this as a child of the
 * `TabGroup` component.
 */

var Tab = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Tab, _React$Component);

  var _super = _createSuper(Tab);

  function Tab() {
    var _this;

    (0, _classCallCheck2["default"])(this, Tab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "rootRef", undefined);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateRootRef", function (ref, _ref5) {
      var selected = _ref5.selected,
          setSelectedRef = _ref5.setSelectedRef;
      _this.rootRef = ref;

      if (selected && _this.rootRef) {
        setSelectedRef(_this.rootRef);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getScrollDelta", function (tab, tabGroup) {
      var _tab$getBoundingClien = tab.getBoundingClientRect(),
          tabWidth = _tab$getBoundingClien.width;

      var _tabGroup$getBounding = tabGroup.getBoundingClientRect(),
          tabGroupWidth = _tabGroup$getBounding.width;

      var tabLeftEdge = tab.offsetLeft;
      var tabRightEdge = tab.offsetLeft + tabWidth;
      var viewportLeftEdge = tabGroup.scrollLeft + Tab.viewportBuffer;
      var viewportRightEdge = tabGroup.scrollLeft + tabGroupWidth - Tab.viewportBuffer;
      var leftEdgeOverlap = tabLeftEdge - viewportLeftEdge;
      var rightEdgeOverlap = viewportRightEdge - tabRightEdge;
      return leftEdgeOverlap < 0 ? leftEdgeOverlap : rightEdgeOverlap < 0 ? Math.abs(rightEdgeOverlap) : 0;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (updateTabGroup) {
      var tabGroup = _this.rootRef.offsetParent;

      var scrollDelta = _this.getScrollDelta(_this.rootRef, tabGroup);

      if (scrollDelta !== 0) {
        tabGroup.scrollLeft = tabGroup.scrollLeft + scrollDelta;
      }

      updateTabGroup(_this.props.value);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleKeyDown", function (e) {
      if ((0, _keycode["default"])(e) === "up" || (0, _keycode["default"])(e) === "down") {
        e.preventDefault();
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(Tab, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          disabled = _this$props.disabled,
          value = _this$props.value;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, ["data-", "aria-"]);
      return /*#__PURE__*/_react["default"].createElement(_context.Consumer, null, function (_ref6) {
        var selectedValue = _ref6.value,
            updateTabGroup = _ref6.updateTabGroup,
            t = _ref6.t,
            name = _ref6.name,
            fill = _ref6.fill,
            type = _ref6.type,
            nextValue = _ref6.nextValue,
            previousValue = _ref6.previousValue,
            setSelectedRef = _ref6.setSelectedRef;
        var selected = selectedValue === value;
        var previous = value === previousValue;
        var next = value === nextValue; // Only allow tabbing to the selected tab. This is the normal behavior
        // for most browsers, but some (ahem IE11) need a little extra help.

        var tabIndex = selected ? 0 : -1;
        return /*#__PURE__*/_react["default"].createElement("label", {
          className: styles(t, {
            selected: selected,
            disabled: disabled,
            fill: fill,
            type: type
          }),
          onMouseEnter: _this2.onMouseEnter,
          ref: function ref(_ref8) {
            return _this2.updateRootRef(_ref8, {
              selected: selected,
              setSelectedRef: setSelectedRef
            });
          },
          "mdn-tab-selected": selected ? "" : undefined,
          "mdn-tab-selected-previous": previous ? "" : undefined,
          "mdn-tab-selected-next": next ? "" : undefined
        }, /*#__PURE__*/_react["default"].createElement(_focus["default"], null, function (_ref7) {
          var focus = _ref7.focus,
              focusTrigger = _ref7.focusTrigger,
              focusProps = _ref7.focusProps;
          return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("div", {
            className: visibleTabStyles(t, {
              disabled: disabled,
              focus: focus && focusTrigger === "keyboard",
              type: type
            })
          }, children), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, passThroughProps, focusProps, {
            className: hiddenTabStyles,
            type: "radio",
            role: "tab",
            name: name,
            value: value,
            checked: selected,
            tabIndex: tabIndex,
            disabled: disabled,
            onChange: disabled ? undefined : function () {
              return _this2.onChange(updateTabGroup);
            },
            onKeyDown: _this2.handleKeyDown
          })));
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: tabBaseLineStyles(t, {
            selected: selected,
            disabled: disabled,
            type: type
          })
        }));
      });
    }
  }]);
  return Tab;
}(_react["default"].Component);

(0, _defineProperty2["default"])(Tab, "viewportBuffer", 60);
Tab.propTypes =  false ? {
  /**
   * The tab's label. Plain text (and optionally badges) recommended.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The value of the tab. This is used by the parent `TabGroup` component to
   * track the selection of the tab.
   */
  value: _propTypes["default"].any.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool
} : {};
var _default = Tab;
exports["default"] = _default;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(108));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _uniqueId = _interopRequireDefault(__webpack_require__(51));

var _tab = _interopRequireDefault(__webpack_require__(632));

var _context = __webpack_require__(272);

var _theme = __webpack_require__(14);

var _token = __webpack_require__(12);

var _excluded = ["children", "fill", "onChange", "type"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = (0, _emotion.css)({
  position: "relative",
  whiteSpace: "nowrap",
  display: "flex",
  width: "100%",
  overflowX: "auto",
  overflowY: "hidden"
});

var fillLineStyle = function fillLineStyle(t, _ref) {
  var type = _ref.type;
  return (0, _emotion.css)({
    width: "100%"
  }, type === "classic" ? {
    borderBottom: t.borderCss("border")
  } : {
    height: t("indicatorHeight"),
    marginTop: t("spacingVertical"),
    backgroundColor: t("indicatorColorDefault"),
    borderRadius: t("indicatorRadius"),
    alignSelf: "flex-end"
  });
};
/**
 * Used to group a set of tabs.
 */


var TabGroup = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TabGroup, _React$Component);

  var _super = _createSuper(TabGroup);

  function TabGroup() {
    var _this;

    (0, _classCallCheck2["default"])(this, TabGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      nextValue: undefined,
      previousValue: undefined
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setSelectedRef", function (ref) {
      var previousSibling = ref.previousSibling,
          nextSibling = ref.nextSibling;

      var previousValue = _this.getLabelValue(previousSibling);

      var nextValue = _this.getLabelValue(nextSibling);

      if (previousValue !== _this.state.previousValue || nextValue !== _this.state.nextValue) {
        _this.setState({
          nextValue: nextValue,
          previousValue: previousValue
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", (0, _uniqueId["default"])("tabs-"));
    return _this;
  }

  (0, _createClass2["default"])(TabGroup, [{
    key: "getLabelValue",
    value: function getLabelValue(labelRef) {
      return labelRef && labelRef.getElementsByTagName("input")[0] ? labelRef.getElementsByTagName("input")[0].value : undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          nextValue = _this$state.nextValue,
          previousValue = _this$state.previousValue;
      var _this$props = this.props,
          children = _this$props.children,
          fill = _this$props.fill,
          onChange = _this$props.onChange,
          type = _this$props.type,
          props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _tab["default"],
        map: (0, _token.getTokenHelper)("tab")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(_context.Provider, {
          value: _objectSpread({
            updateTabGroup: onChange,
            name: _this2.id,
            t: t,
            fill: fill,
            type: type,
            nextValue: nextValue,
            previousValue: previousValue,
            setSelectedRef: _this2.setSelectedRef
          }, props)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: styles,
          role: "tablist"
        }, children, fill === "line" && /*#__PURE__*/_react["default"].createElement("div", {
          className: fillLineStyle(t, {
            type: type
          })
        })));
      });
    }
  }]);
  return TabGroup;
}(_react["default"].Component);

(0, _defineProperty2["default"])(TabGroup, "defaultProps", {
  fill: "none",
  type: "default"
});
TabGroup.propTypes =  false ? {
  /**
   * The Tab children for the TabGroup.
   * EG: `<TabGroup><Tab value="tab-1">My tab 1</Tab></TabGroup>`
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The value of the selected Tab.
   */
  value: _propTypes["default"].any.isRequired,

  /**
   * A function that will be called when the user attempts to change the
   * selected tab. The new value will be passed as the first argument to this
   * function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * Determines how the unused space in the Tab group is handled.
   *
   * `"none"` will not fill the space; the width of each Tab depends on the length of its label.
   * `"tabs"` uses an equal amount of padding for each Tab to span the total available width.
   * `"line"` does not add additional padding to each Tab and fills the available width with a line.
   */
  fill: _propTypes["default"].oneOf(["none", "tabs", "line"]),

  /**
   * The visual style of the Tab group.
   */
  type: _propTypes["default"].oneOf(["default", "classic"])
} : {};
var _default = TabGroup;
exports["default"] = _default;

/***/ }),
/* 632 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    tabMotionDuration: "150ms",
    tabMotionFunction: "ease",
    tabForegroundColorDefault: tokens.themeForegroundSecondaryDefault,
    tabForegroundColorSelected: tokens.themeForegroundPrimaryDefault,
    tabForegroundColorHover: tokens.themeForegroundPrimaryDefault,
    tabForegroundColorPressed: tokens.themeForegroundPrimaryDefault,
    tabForegroundColorDisabled: tokens.themeForegroundSecondaryDisabled,
    tabIndicatorHeight: 4,
    tabIndicatorRadius: 999,
    tabIndicatorColorDefault: tokens.themeBackgroundTertiaryDefault,
    tabIndicatorColorSelected: tokens.themeBorderAccentHover,
    tabIndicatorColorHover: tokens.themeBorderAccentPressed,
    tabIndicatorColorPressed: tokens.themeForegroundAccentPressed,
    tabIndicatorColorDisabled: tokens.themeBackgroundTertiaryDefault,
    tabBorderWidth: 1,
    tabBorderRadius: 4,
    tabBorderColor: tokens.themeBorderPrimaryDefault,
    tabSpacingHorizontal: 4,
    tabSpacingVerticalDefault: 2,
    tabSpacingVerticalClassic: 0,
    tabSpacingInsetHorizontal: 24,
    tabSpacingInsetVertical: 6,
    tabSpacingInsetClassicHorizontal: 3,
    tabSpacingInsetClassicVertical: 3,
    tabSpacingInsetClassicBaseLine: 16
  }
};

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeatMapViewOptionsV2=function(_Component){_inherits(HeatMapViewOptionsV2,_Component);function HeatMapViewOptionsV2(){_classCallCheck(this,HeatMapViewOptionsV2);return _possibleConstructorReturn(this,(HeatMapViewOptionsV2.__proto__||Object.getPrototypeOf(HeatMapViewOptionsV2)).apply(this,arguments));}_createClass(HeatMapViewOptionsV2,[{key:"render",value:function render(){var _this2=this;var selectedView=this.props.selectedView;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"heatMapViewOptions.view",defaultMessage:"View"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select___default.a,{onChange:function onChange(updatedView){return _this2.handleViewChange(updatedView);},value:selectedView},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select__["SelectOption"],{value:__WEBPACK_IMPORTED_MODULE_5__enums__["q" /* ViewType */].DEFAULT_VIEW,"data-cy":"heatMapFieldsetOption",label:this.renderDefaultOption()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select__["SelectOption"],{value:__WEBPACK_IMPORTED_MODULE_5__enums__["q" /* ViewType */].ROUTE_VIEW,"data-cy":"heatMapFieldsetOption",label:"Route"}),this.isSidelineVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select__["SelectOption"],{value:__WEBPACK_IMPORTED_MODULE_5__enums__["q" /* ViewType */].SIDELINE_VIEW,"data-cy":"heatMapFieldsetOption",label:"Sideline"})));}},{key:"handleViewChange",value:function handleViewChange(updatedView){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActionsV2__["x" /* viewChanged */])(updatedView));}},{key:"renderDefaultOption",value:function renderDefaultOption(){var capability=this.props.capability;switch(capability){case __WEBPACK_IMPORTED_MODULE_5__enums__["e" /* Capability */].AR_NEXT_GEN:return"Station";case __WEBPACK_IMPORTED_MODULE_5__enums__["e" /* Capability */].SSD:return"Zone";default:return"Cluster";}}},{key:"isSidelineVisibilityEnabled",value:function isSidelineVisibilityEnabled(){return this.props.capability===__WEBPACK_IMPORTED_MODULE_5__enums__["e" /* Capability */].AMZL&&this.props.featureStatus&&this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_8__constants__["j" /* FEATURES */].SIDELINE_STOW_VISIBILITY];}}]);return HeatMapViewOptionsV2;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{capability:state.optionsReducerV2.capability,selectedView:state.optionsReducerV2.heatMapView,featureStatus:state.configReducer.featureStatus};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(HeatMapViewOptionsV2)));

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(63));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(48));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _keycode = _interopRequireDefault(__webpack_require__(47));

var _uniqueId = _interopRequireDefault(__webpack_require__(51));

var _find = _interopRequireDefault(__webpack_require__(101));

var _noop = _interopRequireDefault(__webpack_require__(37));

var _escapeRegExp = _interopRequireDefault(__webpack_require__(273));

var _chevronSelect = _interopRequireDefault(__webpack_require__(635));

var _select = _interopRequireDefault(__webpack_require__(636));

var _selectOptionList = _interopRequireDefault(__webpack_require__(637));

var _selectOptionListContainer = _interopRequireDefault(__webpack_require__(643));

var _utils = __webpack_require__(274);

var _inputBox = _interopRequireDefault(__webpack_require__(257));

var _useFocus2 = _interopRequireDefault(__webpack_require__(40));

var _theme = __webpack_require__(14);

var _responsive = _interopRequireDefault(__webpack_require__(111));

var _context = _interopRequireDefault(__webpack_require__(650));

var _token = __webpack_require__(12);

var _text = _interopRequireDefault(__webpack_require__(27));

var _inputReset = _interopRequireDefault(__webpack_require__(259));

var _noTextWrap = _interopRequireDefault(__webpack_require__(110));

var _visuallyHidden = _interopRequireDefault(__webpack_require__(58));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

var _supportTextWrapper = _interopRequireDefault(__webpack_require__(258));

var _getSupportTextAriaDescribedby = _interopRequireDefault(__webpack_require__(260));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var width = _ref.width,
      minWidth = _ref.minWidth;
  return (0, _emotion.css)((0, _text["default"])(t), {
    outline: "none",
    position: "relative",
    width: width,
    // If an explicit width is set then don't allow the select to flex
    flex: width ? "none !important" : undefined,
    minWidth: minWidth
  });
}, ["width", "minWidth"]);
var customSearchInputStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var disabled = _ref2.disabled,
      open = _ref2.open,
      empty = _ref2.empty;
  return (0, _emotion.css)((0, _inputReset["default"])({
    empty: empty,
    textColor: t("searchInputForegroundColorDefault"),
    placeholderColor: t("searchInputPlaceholderColor", disabled ? "disabled" : "default")
  }), // If the select is open then hide the value label and show the input,
  // otherwise hide the input and show the label. Note that the input is
  // visually hidden but is still focuseable (so the user can tab to it).
  open ? {
    "& + div": {
      display: "none"
    }
  } : // Preserve the input's width so the Select doesn't change width on
  // focus/input reveal.
  _objectSpread(_objectSpread({}, _visuallyHidden["default"]), {}, {
    width: "auto",
    position: "initial"
  }));
}, ["disabled", "open", "empty"]);
var valueLabelStyles = (0, _emotion.css)(_noTextWrap["default"]);

var Select = /*#__PURE__*/_react["default"].forwardRef(function (props, forwardedRef) {
  // Are the select options open?
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1]; // This enables us to preselect an option in the option list. This is the
  // "default" because the internal state of the option list may change if the
  // user uses up/down arrow keys to manage the preselected index.


  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      defaultPreselectedIndex = _useState4[0],
      setDefaultPreselectedIndex = _useState4[1];

  var _useState5 = (0, _react.useState)(defaultPreselectedIndex),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      preselectedIndex = _useState6[0],
      setPreselectedIndex = _useState6[1]; // For this component, there are two types of searching:
  //   1) Custom searching is what happens when `onSearch` and `searchQuery`
  //      are passed in as props. This renders a search input inside the
  //      Select and allows the developer to filter options down according to
  //      any custom search algorithm.
  //   2) Native searching is what happens when no custom search props are
  //      passed. This search mimicks the behavior of native html selects -
  //      the search query is stored internally and the first option that
  //      matches the query (prefix matching only) is selected if the select
  //      is closed or "preselected" if the select is open.


  var _useState7 = (0, _react.useState)(""),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      nativeSearchQuery = _useState8[0],
      setNativeSearchQuery = _useState8[1]; // We don't actually use the focus prop but we DO set it down the line


  var _useState9 = (0, _react.useState)(),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      setFocusState = _useState10[1];

  var rootRef = (0, _react.useRef)(null);
  var optionListRef = (0, _react.useRef)(null);

  var updateOptionListRef = function updateOptionListRef(ref) {
    return optionListRef.current = ref;
  };

  var customSearchInputRef = (0, _react.useRef)(null);
  var onSearch = props.onSearch;
  var nativeSearchTimeoutDuration = 1000; // Generate a unique id that can be used to reference this element in the DOM

  var id = props.id || (0, _uniqueId["default"])("select-");
  var popupId = (0, _uniqueId["default"])("options-list-");
  var isMultiSelectable = Array.isArray(props.value);
  var isNativeSearching = /[\S]/.test(nativeSearchQuery);
  var isCustomSearchable = Boolean(props.onSearch);
  var nativeSearchTimeout = (0, _react.useRef)(); // Assign the local and prop ref (if it exists) to the target ref (select)

  var assignRefs = (0, _react.useCallback)(function (targetRef) {
    rootRef.current = targetRef;

    if (forwardedRef) {
      // Assign the ref with a function (Class components) or assigning .current
      // (modern functional components using the `useRef` hook)
      if (typeof forwardedRef === "function") {
        forwardedRef(targetRef);
      } else {
        forwardedRef.current = targetRef;
      }
    }
  }, [forwardedRef]);
  var options = (0, _utils.getOptionsFromChildren)(props.children);
  var selectedOptions = options.filter(function (option) {
    return (0, _utils.isOptionValueSelected)(props.value, option.value);
  });
  var valueLabel = props.valueLabel(selectedOptions) || "";
  var t = (0, _theme.useTheme)(_select["default"], "select");
  /**
   * Close the select, optionally retaining focus on the handle.
   */

  var close = (0, _react.useCallback)(function (_ref3) {
    var retainFocus = _ref3.retainFocus;
    setOpen(false);
    setFocusState(retainFocus);
    setDefaultPreselectedIndex(undefined);

    if (isCustomSearchable) {
      onSearch("");
    } else {
      clearTimeout(nativeSearchTimeout.current);
      setNativeSearchQuery("");
      setDefaultPreselectedIndex(undefined);
    } // Move focus back to the main node before closing the option list


    if (retainFocus) {
      if (isCustomSearchable) {
        customSearchInputRef.current.focus();
      } else {
        rootRef.current.focus();
      }
    }
  }, [isCustomSearchable, onSearch]);
  /**
   * Take the current search query and attempt to find and focus the matching
   * option
   */

  var nativeSearch = (0, _react.useCallback)(function (searchQuery) {
    var value = props.value,
        onChange = props.onChange,
        children = props.children;
    var options = (0, _utils.getOptionsFromChildren)(children).filter(function (_ref4) {
      var disabled = _ref4.disabled;
      return !disabled;
    });
    var selectedOption = (0, _find["default"])(options, function (option) {
      return (0, _utils.isOptionValueSelected)(value, option.value);
    }); // Look for the first option that starts with the full search query

    var searchQueryRegExp = new RegExp("^".concat((0, _escapeRegExp["default"])(searchQuery)), "i");
    var fullMatch = (0, _find["default"])(options, function (option) {
      return searchQueryRegExp.test(option.label);
    }); // Look for an option that starts with the last character typed. Sort the
    // options so that if the same character is typed repeatedly the focus
    // cycles through all matching options.

    var lastChar = searchQuery[searchQuery.length - 1];
    var lastCharRegExp = new RegExp("^".concat((0, _escapeRegExp["default"])(lastChar)), "i");
    var currentIndex = open ? defaultPreselectedIndex : selectedOption ? selectedOption.index : 0;
    var lastCharMatch = (0, _find["default"])([].concat((0, _toConsumableArray2["default"])(options.slice(currentIndex + 1)), (0, _toConsumableArray2["default"])(options.slice(0, currentIndex + 1))), function (option) {
      return lastCharRegExp.test(option.label);
    }); // Prefer a full match to a last character match

    var match = fullMatch || lastCharMatch; // If the select is expanded and we have a match then focus it

    if (match && open) {
      setDefaultPreselectedIndex(match.index);
    } // If the select is closed and we have a match then select it
    else if (match) {
      onChange(isMultiSelectable ? [match.value] : match.value);
    }
  }, [defaultPreselectedIndex, isMultiSelectable, open, props]);
  /**
   * Event handlers
   */

  var onClickOption = function onClickOption(value) {
    if (isMultiSelectable) {
      // If the value is selected then deselect it, otherwise select it
      if ((0, _utils.isOptionValueSelected)(props.value, value)) {
        props.onChange(props.value.filter(function (v) {
          return v !== value;
        }));
      } else {
        props.onChange([].concat((0, _toConsumableArray2["default"])(props.value), [value]));
      } // If the searchable, multi-Select contains groups, refocus
      // on the Select after an option has been clicked.


      if (isCustomSearchable && _react["default"].Children.toArray(props.children).some(function (child) {
        return (0, _utils.isGroup)(child);
      })) {
        customSearchInputRef.current.focus();
      }
    } else {
      close({
        retainFocus: true
      });
      props.onChange(value);
    }
  };

  var onKeyDown = function onKeyDown(event) {
    var disabled = props.disabled;
    var key = (0, _keycode["default"])(event); // HACK: Assume the key is "printable" (can be added to a search query) if
    // it's either of length 1 or a space.

    var printableKey = key && key.length === 1 ? key : key === "space" ? " " : undefined;
    var isNativeSearch = isNativeSearching;
    var keyUsed = false; // If any character is typed that doesn't trigger behavior in the option
    // list (as indicated by event.defaultPrevented set to true) then make sure
    // the custom search input is focused

    if (isCustomSearchable && !event.defaultPrevented && customSearchInputRef.current !== document.activeElement) {
      customSearchInputRef.current.focus();
    } // If no custom search behavior is defined and a printable key was typed,
    // trigger the "native" search functionality that mimics the browser


    if (!isCustomSearchable && printableKey) {
      var nativeSearchQueryPrintableKey = nativeSearchQuery + printableKey;
      setNativeSearchQuery(nativeSearchQueryPrintableKey);
      nativeSearch(nativeSearchQueryPrintableKey); // Reset the timeout that will the search query

      clearTimeout(nativeSearchTimeout.current);
      nativeSearchTimeout.current = window.setTimeout(function () {
        setNativeSearchQuery("");
        setDefaultPreselectedIndex(undefined);
      }, nativeSearchTimeoutDuration);
      keyUsed = true;
    } // If no custom search behavior is defined and backspace or delete was
    // pressed, clear the "native" search query


    if (!isCustomSearchable && (key === "backspace" || key === "delete")) {
      // Reset the timeout that will clear search query and instead clear the
      // query immediately
      clearTimeout(nativeSearchTimeout.current);
      setNativeSearchQuery("");
      setDefaultPreselectedIndex(undefined);
      keyUsed = true;
    } // If the user hits escape on an open select then close it


    if (open && key === "esc") {
      // Stop propagating the event upwards. This ensures that a parent element
      // (e.g. a modal) won't also handle the escape key.
      event.stopPropagation();
      close({
        retainFocus: true
      });
      keyUsed = true;
    } // If the user hits up, down, or backspace/delete/space (and they're not in
    // the middle of a search) on a collapsed select then open it


    if (!open && !disabled && (key === "up" || key === "down" || (key === "backspace" || key === "delete" || key === "space") && !isNativeSearch)) {
      setOpen(true);
      keyUsed = true;
    } // Disabled tabbing while the select is open


    if (open && key === "tab") {
      keyUsed = true;
    } // Don't perform the normal action associated with the key (e.g. scroll for
    // arrows/space) if the key was used for a select-related action


    if (keyUsed) {
      event.preventDefault();
    }
  };

  var onKeyDownOptionList = function onKeyDownOptionList(event) {
    // Prevent "space" from selecting an option when the user is searching
    if ((0, _keycode["default"])(event) === "space" && isNativeSearching) {
      event.preventDefault();
    }
  };

  var onKeyDownCustomSearchInput = function onKeyDownCustomSearchInput(event) {
    var key = (0, _keycode["default"])(event); // If the user presses an up/down arrow key when focused on an open
    // searchable select's search input, then transfer the focus to the option
    // list and immediately move the preselected index from the current option
    // to the next/previous option. This mimicks what would happen if the option
    // list was focused when the arrow key was pressed.

    if (open && (key === "down" || key === "up") && optionListRef.current) {
      setDefaultPreselectedIndex(optionListRef.current.getNextPreselectedIndex(key === "down" ? 1 : -1));
      optionListRef.current.focus();
      event.preventDefault();
    } // If the user presses enter when focused on an open searchable select's
    // search input, then select the  first item in the option list (which will
    // be the preselected option). This mimicks what would happen if the option
    // list was focused when the enter key was pressed.
    else if (open && key === "enter") {
      var firstOption = (0, _utils.getOptionsFromChildren)(props.children)[0]; // Only select the first option if there's a search query

      if (firstOption && props.searchQuery && !firstOption.disabled) {
        onClickOption(firstOption.value);
      } // Don't submit a form if the user presses enter on an open searchable
      // select


      event.preventDefault();
    }
  };

  var onChangeCustomSearchInput = function onChangeCustomSearchInput(event) {
    var value = event.target.value; // Make sure the select is open if the user is typing in a search query

    if (!open) {
      setOpen(true);
    } // If we have a query, presleect the first option if it isn't already


    if (value && defaultPreselectedIndex !== 0) {
      setDefaultPreselectedIndex(0);
    } // If we don't have a query, clear the preselected option


    if (!value && defaultPreselectedIndex !== -1) {
      setDefaultPreselectedIndex(-1);
    }

    props.onSearch(value);
  };

  var onMouseDownInputBox = function onMouseDownInputBox(event) {
    if (isCustomSearchable) {
      if (!open) {
        // If the user mouses down on a closed searchable select, open it
        setOpen(true);
      }

      if (event.target !== customSearchInputRef.current) {
        // If the user mouses down on the input box of a custom searchable
        // select, focus on the custom search input
        customSearchInputRef.current.focus();
        event.preventDefault();
      }
    } else {
      // If the user mouses down on a non-searchable select, toggle it
      setOpen(!open);
    }
  };
  /**
   * Re-trigger the option list's "componentDidMount" when the option list is
   * actually visible. This is necessary because the things the option list does
   * on mount (like setting the scroll and transferring focus) only work when
   * it's visible, but the PopoverController mounts it in an invisible state (in
   * order to fade it in). This is only done for the popover because the
   * BottomSheet's onOpen even fires before its children are mounted, so this
   * won't work.
   */


  var onOpenPopover = function onOpenPopover() {
    if (optionListRef.current) {
      optionListRef.current.componentDidMount();
    }
  };
  /**
   * Close and retain focus if the user attempts to close the bottom sheet (e.g.
   * by tapping outside of it). This isn't necessary for the popover which
   * doesn't initiate its own close events.
   */


  var onCloseBottomSheet = function onCloseBottomSheet() {
    return close({
      retainFocus: true
    });
  };
  /**
   * Close the select when it loses focus.
   */


  var onBlur = function onBlur(event) {
    close({
      retainFocus: false
    });

    if (props.onBlur) {
      props.onBlur(event);
    }
  };
  /**
   * Clear out the default preselected index when the option list changes its
   * internal state. This allows us to update the default later on and stomp the
   * option list's internal state when we need too. If we didn't reset the
   * default here and just left it at 0 (for example), then setting it to 0
   * again later on would have no effect.
   */


  var onChangePreselectedIndex = function onChangePreselectedIndex(index) {
    if (defaultPreselectedIndex !== undefined) {
      setDefaultPreselectedIndex(undefined);
    }

    setPreselectedIndex(index);
  };

  (0, _react.useEffect)(function () {
    if (props.autoFocus || props.inaccessibleAutoFocus) {
      // NOTE: React guarantees that callback refs will be resolved before
      // componentDidMount is called, so this is safe.
      if (isCustomSearchable) {
        customSearchInputRef.current.focus();
      } else {
        rootRef.current.focus();
      }
    } // NOTE: Only run this once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []); // Cleanup - formerly sat in componentWillUnmount

  (0, _react.useEffect)(function () {
    return function () {
      return clearInterval(clearTimeout(nativeSearchTimeout.current));
    };
  }, []);
  (0, _react.useEffect)(function () {
    var disabled = props.disabled; // Collapse the select if it was disabled while open

    if (disabled && open) {
      close({
        retainFocus: false
      });
    }
  }, [close, open, props.disabled]);

  var _useFocus = (0, _useFocus2["default"])({
    multipleNodes: true,
    onFocus: props.onFocus,
    onBlur: onBlur
  }),
      focusProps = _useFocus.focusProps,
      focus = _useFocus.focus;
  /**
   * When support text has been provided to Select, add an aria-describedby
   * prop to Select for better screen reader experiences
   */


  var ariaDescribedbySupportText = (0, _react.useMemo)(function () {
    return (0, _getSupportTextAriaDescribedby["default"])({
      id: id,
      hasHelperText: !!props.helperText,
      hasConstraintText: !!props.constraintText,
      hasErrorMessage: !!props.errorMessage,
      errorMessageFirst: props.size === "xlarge"
    });
  }, [id, props.helperText, props.constraintText, props.errorMessage, props.size]);

  var ariaProps = _objectSpread(_objectSpread({
    "aria-describedby": ariaDescribedbySupportText,
    "aria-label": props.label
  }, (0, _filterPropsByPrefix["default"])(props, ["aria-"])), {}, {
    role: "combobox",
    "aria-controls": popupId,
    "aria-haspopup": true,
    "aria-expanded": open,
    "aria-disabled": props.disabled,
    "aria-activedescendant": open && optionListRef.current ? "".concat(optionListRef.current.props.id, "-").concat(preselectedIndex) : undefined
  });

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
  return /*#__PURE__*/_react["default"].createElement(_supportTextWrapper["default"], {
    id: id,
    helperText: props.helperText,
    constraintText: props.constraintText,
    errorMessage: props.errorMessage,
    helperBelowFormField: props.size === "xlarge",
    className: styles(t, {
      width: props.width,
      minWidth: props.minWidth
    })
  }, /*#__PURE__*/_react["default"].createElement(_responsive["default"], {
    query: "min-width",
    fallback: "".concat(t("optionListPopoverBreakpoint"), "px"),
    props: {
      optionListContainerType: isCustomSearchable ? {
        "default": "popover"
      } : (0, _defineProperty2["default"])({
        "default": "bottom-sheet"
      }, "".concat(t("optionListPopoverBreakpoint"), "px"), "popover")
    }
  }, function (_ref6) {
    var optionListContainerType = _ref6.optionListContainerType;
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, focusProps, {
      onKeyDown: props.disabled ? undefined : onKeyDown
    }), /*#__PURE__*/_react["default"].createElement(_context["default"].Consumer, null, function (_ref7) {
      var _ref7$suffixIconToken = _ref7.suffixIconTokens,
          suffixIconTokens = _ref7$suffixIconToken === void 0 ? _chevronSelect["default"] : _ref7$suffixIconToken;
      return /*#__PURE__*/_react["default"].createElement(_inputBox["default"], (0, _extends2["default"])({
        label: props.label,
        labelId: "".concat(id, "-label"),
        htmlFor: id,
        empty: !valueLabel,
        focus: focus,
        suffixIconTokens: suffixIconTokens,
        animated: optionListContainerType === "popover",
        labelFloated: isCustomSearchable && open || Boolean(props.placeholder || valueLabel),
        disabled: props.disabled,
        size: props.size,
        prefix: props.prefix,
        suffix: props.suffix,
        error: props.error && !focus,
        cursor: isCustomSearchable && open ? "text" : "pointer",
        onMouseDown: props.disabled ? undefined : onMouseDownInputBox,
        tabIndex: props.disabled || isCustomSearchable ? undefined : "0"
      }, !isCustomSearchable ? ariaProps : {}, {
        ref: assignRefs,
        id: id
      }, passThroughProps, {
        onKeyDown: props.disabled ? undefined : onKeyDown
      }), isCustomSearchable ? /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, isCustomSearchable ? ariaProps : {}, {
        // HACK: Prepend the value id if it exists to aria-labelledby
        // so it's read by screen-readers. This is necessary because
        // the <input> value attribute resets to an empty string
        // after a user has selected a value so they can begin
        // typing a new query with a fresh start.
        "aria-labelledby": "".concat(id, "-value ").concat(ariaProps["aria-labelledby"] || "".concat(id, "-label")),
        "aria-autocomplete": "list",
        "aria-controls": popupId,
        type: "text",
        onKeyDown: onKeyDownCustomSearchInput,
        className: customSearchInputStyles(t, {
          empty: props.searchQuery === undefined || props.searchQuery === "",
          open: open,
          disabled: props.disabled
        }),
        placeholder: props.placeholder,
        value: props.searchQuery || "",
        ref: customSearchInputRef,
        onChange: onChangeCustomSearchInput,
        disabled: props.disabled,
        autoComplete: "off"
      })) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: valueLabelStyles,
        id: "".concat(id, "-value"),
        "mdn-select-value": ""
      }, valueLabel ? valueLabel : props.placeholder));
    }), /*#__PURE__*/_react["default"].createElement(_selectOptionListContainer["default"], {
      type: optionListContainerType,
      open: open,
      popoverAnchorNode: rootRef.current,
      popoverMaxHeight: props.popoverMaxHeight,
      onOpenPopover: onOpenPopover,
      onCloseBottomSheet: onCloseBottomSheet,
      t: t,
      closeLabel: props.closeLabel
    }, /*#__PURE__*/_react["default"].createElement(_selectOptionList["default"], (0, _extends2["default"])({
      open: open,
      autoFocus: !isCustomSearchable,
      value: props.value,
      searchQuery: props.searchQuery,
      defaultPreselectedIndex: defaultPreselectedIndex,
      onChangePreselectedIndex: onChangePreselectedIndex,
      onClickOption: onClickOption,
      onKeyDown: onKeyDownOptionList,
      ref: updateOptionListRef,
      id: popupId // Only recalculate focus if we're native searchable
      ,
      recalculateFocusOnUpdate: !isCustomSearchable
    }, focusProps), props.children)), props.name ? isMultiSelectable ? props.value.map(function (value) {
      return /*#__PURE__*/_react["default"].createElement("input", {
        type: "hidden",
        key: value,
        name: "".concat(props.name, "[]"),
        value: value
      });
    }) : /*#__PURE__*/_react["default"].createElement("input", {
      type: "hidden",
      name: props.name,
      value: props.value || ""
    }) : null);
  }));
});

Select.displayName = "Select";
Select.propTypes =  false ? {
  /**
   * A list of `SelectOption` elements that represent the choices to present to
   * the user.
   *
   * If no `SelectOption` elements are provided then any other elements passed here
   * will be rendered in place of them. This allows you to render things like a
   * loading indicator while waiting for asyncronously loaded options or a
   * message to the user when no options are available. Note that these elements
   * cannot contain anything interactive like links or buttons for accessibility
   * reasons.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Select component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following properties,
   * they'll be ignored:
   *
   * aria-controls | aria-haspopup | aria-expanded | aria-disabled | aria-autocomplete | aria-activedescendant
   *
   * If `constraintText`, `helperText`, and/or an `errorMessage` are provided to
   * the Select these will be used to generate the `aria-describedby` prop.
   * This can be overridden by explicitly setting `aria-describedby` on the Select.
   *
   * @since 5.21.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * An accessible label for the close icon Button that appears in the mobile
   * view of the SelectOptionListContainer.
   *
   * NOTE: The default value for this prop is in English. If you support
   * multiple locales you will need to provide this prop for each locale.
   *
   * @since 5.27.0
   *
   */
  closeLabel: _propTypes["default"].string,

  /**
   * Add constraint text to provide critical information regarding content.
   *
   * @since 5.22.0
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   *
   * @since 5.18.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with an `errorMessage`.
   */
  error: _propTypes["default"].bool,

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the Select.
   *
   * @since 5.22.0
   */
  errorMessage: _propTypes["default"].string,

  /**
   * Add helper text to provide additional instruction.
   *
   * @since 5.22.0
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * If set to true then the select will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since 5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * A label for the input.
   *
   * If this prop is provided the `size` prop will be ignored.
   */
  label: _propTypes["default"].string,

  /**
   * Set the minimum width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   *
   * @since 5.x
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * Text that is shown in place of the select's value when nothing is selected.
   *
   * This text is not visible when an option is selected, so it should
   * not contain essential information that should be persisted. For that,
   * consider using the `label` prop.
   */
  placeholder: _propTypes["default"].string,

  /**
   * Sets the maximum height of the popover containing the select's options.
   * This is helpful if you have a very long list of options but don't want
   * to show a very tall popover. The option list is scrollable, so any
   * options that overflow the popover will still be accessible.
   */
  popoverMaxHeight: _propTypes["default"].number,

  /**
   * Static text to show in an end-cap prepended to the select.
   */
  prefix: _propTypes["default"].string,

  /**
   * Pass the query obtained via the `onSearch` handler back to this prop to
   * update the query rendered by the Select.
   */
  searchQuery: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   *
   * If the `label` prop is provided this prop will be ignored (the label
   * requires a particular amount of space which is not configurable).
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * Static text to show in an end-cap appended to the input.
   */
  suffix: _propTypes["default"].string,

  /**
   * This is the value of the currently selected option. Provide a number or
   * string value for a single-selectable Select, __or an array__ of numbers or
   * strings __for a multi-selectable Select__. The matching option will
   * automatically be highlighted in the select.
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),

  /**
   * This function generates the label that is shown in the Select's form
   * field to summarize the current value of the Select. This function
   * receives an array containing all of the selected options that are
   * provided as children to the Select component.
   *
   * The default function will return the selected option's label
   * if one selected option is found. If more than one selected option is
   * found it will return "X selected".
   *
   * If you are filtering the options in the Select (e.g. for a searchable
   * Select), you will have to provide your own function here that does not
   * rely on the array of options passed to this function. As stated above
   * that array will only include selected options *that are currently
   * rendered as children*, so it won't include any selected options that have
   * been filtered out of the current view.
   */
  valueLabel: _propTypes["default"].func,

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by selecting an option). The new value will be
   * passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This function makes the select "searchable". A searchable select allows
   * the user to type a query into a text input to search through options.
   *
   * This function will be called with the user's latest query, which should
   * be passed back to the `searchQuery` prop. Note that this will not
   * automatically filter the options in the select. That responsibility is
   * still up to the developer.
   */
  onSearch: _propTypes["default"].func
} : {};
Select.defaultProps = {
  closeLabel: "Close",
  onChange: _noop["default"],
  size: "medium",
  valueLabel: function valueLabel(options) {
    return options.length === 1 ? options[0].label : options.length > 0 ? "".concat(options.length, " selected") : "";
  }
};
var _default = Select;
exports["default"] = _default;

/***/ }),
/* 635 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronSelectData: "data:image/svg+xml,%3csvg width='10' height='18' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill-rule='nonzero' stroke='currentColor' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1 13l4 4 4-4M9 5L5 1 1 5'/%3e%3c/g%3e%3c/svg%3e",
  iconChevronSelectWidth: 10,
  iconChevronSelectHeight: 18
};

/***/ }),
/* 636 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    selectIosToolbarHeight: 44,
    selectIosToolbarBackgroundColor: tokens.themeBackgroundAlternateTertiaryFocus,
    selectIosToolbarForegroundColor: tokens.themeForegroundAccentDefault,
    selectIosToolbarBorderWidth: 1,
    selectIosToolbarBorderRadius: 0,
    selectIosToolbarBorderColor: tokens.themeBorderSecondaryDefault,
    selectIosToolbarSpacingHorizontal: 16,
    selectIosPickerMotionDuration: "200ms",
    selectIosPickerMotionFunction: "ease",
    selectOptionListElevation: 70,
    selectOptionListBorderWidth: 1,
    selectOptionListBorderRadius: 4,
    selectOptionListBorderColor: tokens.themeBorderPrimaryDefault,
    selectOptionListShadowOffsetX: 0,
    selectOptionListShadowOffsetY: 2,
    selectOptionListShadowBlur: 4,
    selectOptionListShadowSpread: 0,
    selectOptionListShadowColor: "rgba(11, 12, 12, 0.16)",
    selectOptionListPopoverOffsetVertical: 4,
    selectOptionListPopoverBreakpoint: 721,
    selectOptionListBackgroundColor: tokens.themeBackgroundPrimaryDefault,
    selectOptionListForegroundColor: tokens.themeForegroundPrimaryDefault,
    selectSearchInputForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    selectSearchInputPlaceholderColorDefault: tokens.themeForegroundSecondaryDefault,
    selectSearchInputPlaceholderColorDisabled: tokens.themeForegroundPrimaryDisabled
  }
};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _utils = __webpack_require__(274);

var _optionList = _interopRequireDefault(__webpack_require__(276));

var _highlightSubstring = _interopRequireDefault(__webpack_require__(278));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SelectOptionList = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SelectOptionList, _React$Component);

  var _super = _createSuper(SelectOptionList);

  function SelectOptionList() {
    var _this;

    (0, _classCallCheck2["default"])(this, SelectOptionList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseDownNonOptionChildren", function (event) {
      event.preventDefault();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderCustomSearchHighlightSubstring", function (option) {
      return function () {
        return /*#__PURE__*/_react["default"].createElement(_highlightSubstring["default"], {
          match: _this.props.searchQuery
        }, option.label);
      };
    });
    return _this;
  }

  (0, _createClass2["default"])(SelectOptionList, [{
    key: "shouldComponentUpdate",
    value:
    /**
     * Only update if the option list will continue to be open. This prevents the
     * list contents from changing while the Select is in the process of closing,
     * which can be jarring to the user.
     */
    function shouldComponentUpdate(nextProps) {
      return nextProps.open;
    }
    /**
     * Disable mouse interaction with any non-option children becase a) it would
     * blur the select and cause it to close and b) we really don't want anyone
     * including interactive elements here because they'll be innaccessible to
     * keyboard users.
     *
     * NOTE: a `pointerEvents: none` style on the non-option children container is
     * not enough to prevent a blur event on the option list, we have to actually
     * prevent the event's default behavior.
     */

  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var optionsAndGroups = (0, _utils.createOptionItemsAndGroups)(props);
      var nonOptionChildren = optionsAndGroups.length > 0 ? [] : (0, _utils.getNonOptionsFromChildren)(props.children);
      return optionsAndGroups.length ? /*#__PURE__*/_react["default"].createElement(_optionList["default"], {
        autoFocus: props.autoFocus || props.inaccessibleAutoFocus,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        onKeyDown: props.onKeyDown,
        defaultPreselectedIndex: props.defaultPreselectedIndex,
        onChangePreselectedIndex: props.onChangePreselectedIndex,
        multiSelectable: Array.isArray(props.value),
        recalculateFocusOnUpdate: props.recalculateFocusOnUpdate,
        id: props.id,
        ref: props.forwardedRef
      }, optionsAndGroups) : nonOptionChildren.length ? /*#__PURE__*/_react["default"].createElement("div", {
        onMouseDown: this.onMouseDownNonOptionChildren
      }, nonOptionChildren) : null;
    }
  }]);
  return SelectOptionList;
}(_react["default"].Component);

SelectOptionList.propTypes =  false ? {
  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  defaultPreselectedIndex: _propTypes["default"].number,
  forwardedRef: _propTypes["default"].func,
  id: _propTypes["default"].string,

  /**
   * If set to true then the input will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since  5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,
  open: _propTypes["default"].bool,

  /**
   * Set to true to have the option list continuously recalculate which list item
   * to focus. Helpful when the list might have options move disappear or move.
   */
  recalculateFocusOnUpdate: _propTypes["default"].bool,
  searchQuery: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,
  onChangePreselectedIndex: _propTypes["default"].func,
  onClickOption: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func
} : {};

function forwardRef(props, ref) {
  return /*#__PURE__*/_react["default"].createElement(SelectOptionList, (0, _extends2["default"])({}, props, {
    forwardedRef: ref
  }));
}

forwardRef.displayName = "SelectOptionList";

var _default = /*#__PURE__*/_react["default"].forwardRef(forwardRef);

exports["default"] = _default;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(63));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(57));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _keycode = _interopRequireDefault(__webpack_require__(47));

var _emotion = __webpack_require__(4);

var _uniqueId = _interopRequireDefault(__webpack_require__(51));

var _findIndex = _interopRequireDefault(__webpack_require__(151));

var _noop = _interopRequireDefault(__webpack_require__(37));

var _optionList = _interopRequireDefault(__webpack_require__(639));

var _optionListGroup = _interopRequireDefault(__webpack_require__(277));

var _theme = __webpack_require__(14);

var _token = __webpack_require__(12);

var _functional = __webpack_require__(26);

var _text = _interopRequireDefault(__webpack_require__(27));

var _isElementOf = _interopRequireDefault(__webpack_require__(72));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var isGroup = (0, _isElementOf["default"])(_optionListGroup["default"]);
var styles = (0, _functional.memoize)(function (t) {
  var _lastChild;

  return (0, _emotion.css)((0, _text["default"])(t), {
    outline: "none",
    // Shared option and group header styles
    "& [mdn-option-list-item], & [role=presentation]": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      boxSizing: "border-box"
    },
    // Option styles
    "& [mdn-option-list-item]": {
      padding: "".concat(t("optionSpacingInsetVertical"), "px ").concat(t("optionSpacingInsetHorizontal"), "px"),
      transition: t.transitionCss("optionMotion", ["color", "background-color"]),
      // Foreground and background color
      backgroundColor: t("optionBackgroundColorDefault"),
      color: t("optionForegroundColorDefault"),
      // Set color of child <Text/> components
      "& p": {
        color: t("optionForegroundColorDefault")
      },
      "&[aria-selected=true]": {
        backgroundColor: t("optionBackgroundColorSelected"),
        color: t("optionForegroundColorSelected"),
        // Set color of child <Text/> components
        "& p": {
          color: t("optionForegroundColorSelected")
        }
      },
      "&[aria-current=true]": {
        backgroundColor: t("optionBackgroundColorPreselected"),
        color: t("optionForegroundColorPreselected"),
        // Set color of child <Text/> components
        "& p": {
          color: t("optionForegroundColorPreselected")
        }
      },
      "&:active": {
        backgroundColor: t("optionBackgroundColorPressed"),
        color: t("optionForegroundColorPressed"),
        // Set color of child <Text/> components
        "& p": {
          color: t("optionForegroundColorPressed")
        }
      },
      "&[disabled], &[aria-disabled]": {
        backgroundColor: t("optionBackgroundColorDisabled"),
        color: t("optionForegroundColorDisabled"),
        // Set color of child <Text/> components
        "& p": {
          color: t("optionForegroundColorDisabled")
        }
      }
    },
    // Group header styles
    "& [role=presentation]": {
      padding: "".concat(t("groupHeaderSpacingInsetVertical"), "px ").concat(t("groupHeaderSpacingInsetHorizontal"), "px"),
      // Foreground and background color
      backgroundColor: t("groupHeaderBackgroundColorDefault"),
      color: t("groupHeaderForegroundColorDefault"),
      fontWeight: t("groupHeaderFontWeight"),
      "&[disabled], &[aria-disabled]": {
        backgroundColor: t("groupHeaderBackgroundColorDisabled"),
        color: t("groupHeaderForegroundColorDisabled")
      }
    },
    // Group styles
    "& [role=group]": {
      borderBottom: t.borderCss("groupBorder")
    },
    // Children styles
    "& [mdn-option-list-item] > *:first-child": {
      flex: "auto"
    },
    // Selected indicator styles
    "&[aria-multiselectable=true] [mdn-option-list-item]": {
      "& > *:last-child": (_lastChild = {
        flexShrink: 0,
        // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
        // to use directional margin-left/right. If/when we drop IE11 we can simplify
        // these styles to be:
        // {
        //   marginInlineStart: t("optionSpacingHorizontal"),
        // },
        marginLeft: t("optionSpacingInsetHorizontal")
      }, (0, _defineProperty2["default"])(_lastChild, "[dir=\"rtl\"] &", {
        marginRight: t("optionSpacingInsetHorizontal"),
        marginLeft: 0
      }), (0, _defineProperty2["default"])(_lastChild, "color", t("optionIndicatorColorDefault")), (0, _defineProperty2["default"])(_lastChild, "transition", t.transitionCss("motion", "color")), _lastChild),
      "&[aria-current=true] > *:last-child": {
        color: t("optionIndicatorColorPreselected")
      },
      "&[aria-selected=true] > *:last-child": {
        color: t("optionIndicatorColorSelected")
      },
      "&:active > *:last-child": {
        color: t("optionIndicatorColorPressed")
      },
      "&[disabled] > *:last-child, &[aria-disabled] > *:last-child": {
        color: "transparent"
      },
      "&[disabled][aria-selected=true] > *:last-child, &[aria-disabled][aria-selected=true] > *:last-child": {
        color: t("optionIndicatorColorDisabled")
      }
    }
  });
});
/**
 * This component helps render a keyboard-friendly list of selectable options.
 */

var OptionList = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(OptionList, _React$Component);

  var _super = _createSuper(OptionList);

  function OptionList() {
    var _this;

    (0, _classCallCheck2["default"])(this, OptionList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      preselectedIndex: _this.props.preselectedIndex !== undefined ? _this.props.preselectedIndex : _this.props.defaultPreselectedIndex !== undefined ? _this.props.defaultPreselectedIndex : -1
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", (0, _uniqueId["default"])(_this.props.role === "listbox" ? "option-list-" : "".concat(_this.props.role, "-")));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionDomNodes", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "listDomNode", undefined);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "allOptions", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateListDomNode", function (node) {
      return _this.listDomNode = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSelectedIndex", function (options) {
      return (0, _findIndex["default"])(options, function (option) {
        return option && option.props.selected;
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPreselectedIndex", function () {
      return _this.props.preselectedIndex !== undefined ? _this.props.preselectedIndex : _this.state.preselectedIndex;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getNextPreselectedIndex", function (offset) {
      var options = _this.allOptions;

      var preselectedIndex = _this.getPreselectedIndex();

      var selectedIndex = _this.getSelectedIndex(options);

      var enabledIndices = options.reduce(function (result, option, index) {
        if (option && !option.props.disabled) {
          result.push(index);
        }

        return result;
      }, []);
      var firstIndex = enabledIndices[0];
      var lastIndex = enabledIndices[enabledIndices.length - 1]; // If we've got a preselected or a selected option then move to the prev or
      // next option in the list (depending on the value of offset).

      var currentIndex = preselectedIndex !== -1 ? preselectedIndex : selectedIndex;

      if (currentIndex !== -1) {
        var nextIndex = enabledIndices[enabledIndices.indexOf(currentIndex) + offset];
        return nextIndex !== undefined ? nextIndex : offset < 0 ? firstIndex : lastIndex; // If we don't have a preselected or selected option and we were trying to
        // move up, preselect the option at the bottom of the list.
      } else if (offset < 0) {
        return lastIndex; // If we don't have a preselected or selected option and we were trying to
        // move down, preselect the option at the top of the list.
      } else {
        return firstIndex;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusOptionByIndex", function (index) {
      var optionDomNode = _this.optionDomNodes[index];

      if (optionDomNode) {
        optionDomNode.focus();
        return true;
      } else {
        return false;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangePreselectedIndex", function (preselectedIndex) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        focus: true
      },
          focus = _ref.focus;

      if (_this.props.preselectedIndex === undefined) {
        _this.setState({
          preselectedIndex: preselectedIndex
        });

        if (focus) {
          _this.focusOptionByIndex(preselectedIndex);
        }
      }

      _this.props.onChangePreselectedIndex(preselectedIndex);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownContainer", function (event) {
      // Call the user's key down handler first. If they prevent the default event
      // behavior, don't run any of our code.
      _this.props.onKeyDown(event);

      if (!event.defaultPrevented) {
        var key = (0, _keycode["default"])(event);
        var keyUsed = false; // Move the preselection up or down in the list when the up arrow is pressed

        if (key === "up" || key === "down") {
          var preselectedIndex = _this.getNextPreselectedIndex(key === "up" ? -1 : 1);

          _this.onChangePreselectedIndex(preselectedIndex);

          _this.scrollOptionIntoView(preselectedIndex);

          keyUsed = true;
        } // Simulate a click on the current preselected option when enter or space is
        // pressed


        if (key === "enter" || key === "space") {
          var _preselectedIndex = _this.getPreselectedIndex();

          var option = _this.allOptions[_preselectedIndex];

          if (option && !option.props.disabled) {
            _this.allOptions[_preselectedIndex].props.onClick();
          }

          keyUsed = true;
        } // Don't perform the normal action associated with the key (i.e. scroll for
        // arrows) if the key was used for an option list action


        if (keyUsed) {
          event.preventDefault();
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionRef", function (index) {
      return function (domNode) {
        return (
          /* eslint-disable-next-line react/no-find-dom-node */
          _this.optionDomNodes[index] = _reactDom["default"].findDOMNode(domNode)
        );
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollOptionIntoView", function (index) {
      var optionDomNode = _this.optionDomNodes[index];

      if (optionDomNode) {
        optionDomNode.scrollIntoView(optionDomNode);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(OptionList, [{
    key: "focus",
    value: function focus() {
      return this.listDomNode.focus();
    }
  }, {
    key: "processChildren",
    value: function processChildren() {
      var _this2 = this;

      var preselectedIndex = this.state.preselectedIndex;
      var id = this.props.id || this.id;
      var processedChildren = []; // Rest option counter to 0

      var optionCounter = 0; // Reset allOptions which tracks option components (no group components)

      this.allOptions = [];

      _react["default"].Children.toArray(this.props.children).forEach(function (child) {
        if (!child) {
          return;
        } else if (isGroup(child)) {
          var _this2$allOptions;

          var updatedGroup = /*#__PURE__*/_react["default"].cloneElement(child, child.props, _react["default"].Children.map(child.props.children, function (option, i) {
            var index = optionCounter + i;
            return /*#__PURE__*/_react["default"].cloneElement(option, {
              ref: _this2.optionRef(index),
              id: "".concat(id, "-").concat(child.props.role, "-").concat(index),
              // If "child" (the group) is disabled then disable all of its options
              disabled: child.props.disabled || option.props.disabled,
              preselected: index === preselectedIndex,
              showIndicator: _this2.props.multiSelectable,
              onChangePreselected: function onChangePreselected(preselected) {
                return (// Don't shift focus on mouse over
                  _this2.onChangePreselectedIndex(preselected ? index : -1, {
                    focus: false
                  })
                );
              }
            });
          })); // Update allOptions tracker


          _this2.allOptions = (_this2$allOptions = _this2.allOptions).concat.apply(_this2$allOptions, (0, _toConsumableArray2["default"])(updatedGroup.props.children)); // Push onto array

          processedChildren.push(updatedGroup); // Update option counter

          optionCounter += updatedGroup.props.children.length;
        } else {
          var index = optionCounter;

          var updatedOption = /*#__PURE__*/_react["default"].cloneElement(child, {
            ref: _this2.optionRef(index),
            id: "".concat(id, "-").concat(child.props.role, "-").concat(index),
            preselected: index === preselectedIndex,
            showIndicator: _this2.props.multiSelectable,
            onChangePreselected: function onChangePreselected(preselected) {
              return (// Don't shift focus on mouse over
                _this2.onChangePreselectedIndex(preselected ? index : -1, {
                  focus: false
                })
              );
            }
          }); // Update allOptions tracker


          _this2.allOptions = _this2.allOptions.concat(updatedOption); // Push onto array

          processedChildren.push(updatedOption); // Update option counter

          optionCounter += 1;
        }
      });

      return processedChildren;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Scroll the preselected or selected option into view on mount
      var preselectedIndex = this.getPreselectedIndex();

      if (preselectedIndex !== -1) {
        this.scrollOptionIntoView(preselectedIndex);
      } else {
        this.scrollOptionIntoView(this.getSelectedIndex(this.allOptions));
      } // Focus on mount


      if (this.props.autoFocus || this.props.inaccessibleAutoFocus) {
        // NOTE: React guarantees that callback refs will be resolved before
        // componentDidMount is called, so this is safe.
        this.focus();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          preselectedIndex = _this$props.preselectedIndex,
          defaultPreselectedIndex = _this$props.defaultPreselectedIndex; // If the preselected index was changed via props, update the internal state

      if (preselectedIndex !== undefined && preselectedIndex !== prevProps.preselectedIndex) {
        this.setState({
          preselectedIndex: preselectedIndex
        });
        this.focusOptionByIndex(preselectedIndex);
      } else if (preselectedIndex === undefined && defaultPreselectedIndex !== undefined && defaultPreselectedIndex !== prevProps.defaultPreselectedIndex) {
        this.setState({
          preselectedIndex: defaultPreselectedIndex
        }); // If the default was changed then scroll it into view. We don't do this
        // if the `preselectedIndex` prop is changed because that means the parent
        // component is fully managing state and will need to be responsible for
        // managing scroll position as well.

        this.scrollOptionIntoView(defaultPreselectedIndex);

        if (this.props.recalculateFocusOnUpdate) {
          this.focusOptionByIndex(defaultPreselectedIndex);
        }
      } // Always refocus on update in case the options move around and between groups
      // which could break React's connection with the underlying elements
      else if (this.props.recalculateFocusOnUpdate) {
        var _preselectedIndex2 = this.state.preselectedIndex;

        if (_preselectedIndex2 >= 0) {
          var successfulFocus = this.focusOptionByIndex(_preselectedIndex2); // If focusing on the preselected index was not successful, see if it was
          // because the option list shrunk

          if (!successfulFocus) {
            var filteredDomNodeList = this.optionDomNodes.filter(function (option) {
              return option;
            }); // If the list shrank and the preselected index now exceeds the number
            // of valid options, focus on the last valid option

            if (_preselectedIndex2 > filteredDomNodeList.length - 1) {
              this.setState({
                preselectedIndex: filteredDomNodeList.length - 1
              });
            }
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var props = this.props;
      var id = props.id || this.id;
      var children = this.processChildren();
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _optionList["default"],
        map: (0, _token.getTokenHelper)("optionList")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: _this3.updateListDomNode,
          onKeyDown: _this3.onKeyDownContainer,
          tabIndex: "0",
          role: props.role,
          "aria-multiselectable": props.multiSelectable,
          onFocus: props.onFocus,
          onBlur: props.onBlur,
          className: styles(t),
          id: id
        }, children);
      });
    }
  }]);
  return OptionList;
}(_react["default"].Component);

(0, _defineProperty2["default"])(OptionList, "defaultProps", {
  role: "listbox",
  onKeyDown: _noop["default"],
  onChangePreselectedIndex: _noop["default"]
});
OptionList.propTypes =  false ? {
  /**
   * A set of OptionListItem nodes.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * The index of the default "preselected" option. The "preselected" option
   * is the option that is highlighted and will be selected if the user
   * presses enter or space on their keyboard.
   *
   * NOTE: This is an uncontrolled component by default. It tracks the
   * preselected index using internal state. If the value of this prop changes
   * the internal state will be updated to reflect the new value, but
   * subsequent user interaction with the component may change the internal
   * state. To use make this component behave like a controlled component, use
   * the "preselectedIndex" and "onChangePreselectedIndex" props below.
   *
   */
  defaultPreselectedIndex: _propTypes["default"].number,

  /**
   * Sets an `id` attribute on the listbox element.
   */
  id: _propTypes["default"].string,

  /**
   * If set to true then the option list will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since  5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * If set to true if more than one option may be selected at once.
   */
  multiSelectable: _propTypes["default"].bool,

  /**
   * Use this to fix the index of the "preselected" option. This will disable
   * the internal state used to track the preselected index.
   */
  preselectedIndex: _propTypes["default"].number,

  /**
   * Set to true to have the option list continuously recalculate which list item
   * to focus. Helpful when the list might have options move disappear or move.
   */
  recalculateFocusOnUpdate: _propTypes["default"].bool,
  role: _propTypes["default"].string,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called any time the OptionList wants to update the preselected
   * index
   */
  onChangePreselectedIndex: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   *
   * If `event.preventDefault()` is called from this handler then the option
   * list's default keyboard behavior will be prevented.
   */
  onKeyDown: _propTypes["default"].func
} : {};
var _default = OptionList;
exports["default"] = _default;

/***/ }),
/* 639 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    optionListOptionMobileSpacingInsetVertical: 16,
    optionListOptionMobileSpacingInsetHorizontal: 16,
    optionListOptionSpacingInsetVertical: 8,
    optionListOptionSpacingInsetHorizontal: 12,
    optionListOptionForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    optionListOptionForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    optionListOptionForegroundColorPreselected: tokens.themeForegroundInvertedDefault,
    optionListOptionForegroundColorPressed: tokens.themeForegroundInvertedDefault,
    optionListOptionForegroundColorSelected: tokens.themeForegroundInvertedDefault,
    optionListOptionBackgroundColorDefault: tokens.themeBackgroundPrimaryDefault,
    optionListOptionBackgroundColorDisabled: tokens.themeBackgroundPrimaryDefault,
    optionListOptionBackgroundColorPreselected: tokens.themeForegroundAccentHover,
    optionListOptionBackgroundColorPressed: tokens.themeForegroundAccentPressed,
    optionListOptionBackgroundColorSelected: tokens.themeForegroundAccentDefault,
    optionListOptionIndicatorColorDefault: "rgba(0, 0, 0, 0)",
    optionListOptionIndicatorColorDisabled: tokens.themeForegroundPrimaryDisabled,
    optionListOptionIndicatorColorPreselected: tokens.themeForegroundAccentDefault,
    optionListOptionIndicatorColorPressed: tokens.themeForegroundInvertedDefault,
    optionListOptionIndicatorColorSelected: tokens.themeForegroundInvertedDefault,
    optionListOptionMotionDuration: "100ms",
    optionListOptionMotionFunction: "ease",
    optionListOptionLineHeight: "24px",
    optionListGroupHeaderSpacingInsetVertical: 8,
    optionListGroupHeaderSpacingInsetHorizontal: 12,
    optionListGroupHeaderForegroundColorDefault: tokens.themeForegroundSecondaryDefault,
    optionListGroupHeaderForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    optionListGroupHeaderBackgroundColorDefault: tokens.themeBackgroundPrimaryDefault,
    optionListGroupHeaderBackgroundColorDisabled: tokens.themeBackgroundPrimaryDefault,
    optionListGroupHeaderFontWeight: 600,
    optionListGroupBorderColor: tokens.themeBorderSecondaryDefault,
    optionListGroupBorderWidth: 1
  }
};

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _checkLarge = _interopRequireDefault(__webpack_require__(217));

var _clickable = _interopRequireDefault(__webpack_require__(64));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var OptionListItem = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(OptionListItem, _React$Component);

  var _super = _createSuper(OptionListItem);

  function OptionListItem() {
    var _this;

    (0, _classCallCheck2["default"])(this, OptionListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      preselected: _this.props.preselected,
      selected: _this.props.selected
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "mouseX", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "mouseY", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseMove", function (event) {
      if (!_this.props.preselected) {
        _this.props.onChangePreselected(true);
      } // Track the mouse position so we can detect whether `onMouseLeaveOption`
      // was triggered by a mouse move or by something else (e.g. scrolling).


      _this.mouseX = event.clientX;
      _this.mouseY = event.clientY;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseEnter", function (event) {
      // Track the mouse position so we can detect whether `onMouseLeaveOption`
      // was triggered by a mouse move or by something else (e.g. scrolling).
      _this.mouseX = event.clientX;
      _this.mouseY = event.clientY;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseLeave", function (event) {
      // If the user has moused out of an option by moving their mouse (and not by
      // scrolling the option out from under their mouse) then blur it. Don't blur
      // if they haven't moved their mouse. This allows the user to use keyboard
      // navigation while their mouse cursor is resting over the list (otherwise
      // the mouse and keyboard end up fighting over control).
      if (_this.props.preselected && (event.clientX !== _this.mouseX || event.clientY !== _this.mouseY)) {
        _this.props.onChangePreselected(false);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(OptionListItem, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.label !== this.props.label || nextProps.children !== this.props.children || nextProps.disabled !== this.props.disabled || nextProps.href !== this.props.href || nextProps.id !== this.props.id || nextState.selected !== this.state.selected || nextState.preselected !== this.state.preselected;
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var _this$state = this.state,
          selected = _this$state.selected,
          preselected = _this$state.preselected;
      var children = props.children ? props.children({
        selected: selected,
        preselected: preselected
      }) : props.label;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
      return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, {
        disabled: props.disabled,
        id: props.id,
        href: props.href,
        rel: props.rel,
        target: props.target,
        onClick: props.onClick,
        onMouseMove: props.disabled ? undefined : this.onMouseMove,
        onMouseEnter: props.disabled ? undefined : this.onMouseEnter,
        onMouseLeave: props.disabled ? undefined : this.onMouseLeave,
        role: props.role,
        "aria-selected": selected ? "true" : "false",
        "aria-current": preselected ? "true" : undefined,
        "aria-label": props.label,
        tabIndex: "-1",
        "mdn-option-list-item": ""
      }), /*#__PURE__*/_react["default"].createElement("div", null, children), props.showIndicator ? /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        tokens: _checkLarge["default"]
      }) : null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var preselected = state.preselected,
          selected = state.selected;

      if (props.selected !== selected) {
        // If the option was just selected or deselected then don't show the
        // preselected state
        return {
          selected: props.selected,
          preselected: false
        };
      } else if (props.preselected !== preselected) {
        // If the preselected prop was changed from on high then update the
        // internal preselected state to stay in sync
        return {
          preselected: props.preselected
        };
      } else {
        return null;
      }
    }
  }]);
  return OptionListItem;
}(_react["default"].Component);

(0, _defineProperty2["default"])(OptionListItem, "defaultProps", {
  selected: false,
  preselected: false,
  role: "option"
});
OptionListItem.propTypes =  false ? {
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the OptionListItem component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-selected | aria-current | aria-label
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,
  children: _propTypes["default"].func,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * If a URL is provided here, the component will behave like a link.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * IMPORTANT: This is provided by OptionList, do not set manually.
   */
  id: _propTypes["default"].string,

  /**
   * IMPORTANT: This is provided by OptionList, do not set manually.
   */
  preselected: _propTypes["default"].bool,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,
  role: _propTypes["default"].string,
  selected: _propTypes["default"].bool,

  /**
   * IMPORTANT: This is provided by OptionList, do not set manually.
   */
  showIndicator: _propTypes["default"].bool,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * IMPORTANT: This is provided by OptionList, do not set manually.
   */
  onChangePreselected: _propTypes["default"].func,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func
} : {};
var _default = OptionListItem;
exports["default"] = _default;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _escapeRegExp = _interopRequireDefault(__webpack_require__(273));

var _emotion = __webpack_require__(4);

var _typography = __webpack_require__(642);

var maxMatchLength = 100;
var defaultMatchedStyles = (0, _emotion.css)({
  fontWeight: _typography.typographyFontWeightH300
});

var makeSubstringWithMatch = function makeSubstringWithMatch(text, match) {
  return {
    text: text,
    match: match
  };
};
/**
 * Parses string into an ordered array of objects with substrings
 * and if was a match or not.
 * getSubstringWithMatchBool(/abc/g, "abc def abc")
 * [ {text: "abc", match: true},
 *   {text: "def", match: false},
 *   {text: "abc", match: true} ]
 */


var getSubstringsWithMatchBool = function getSubstringsWithMatchBool(regexp, stringInput) {
  var substringsWithMatchBool = [];
  var startBeforeIndex = 0;
  var match;
  var string = typeof stringInput !== "string" ? stringInput.toString() : stringInput;

  do {
    match = regexp.exec(string);

    if (match) {
      var length = match[0].length;
      var matchText = string.substr(match.index, length);
      var beforeText = string.substr(startBeforeIndex, match.index - startBeforeIndex);

      if (beforeText) {
        substringsWithMatchBool.push(makeSubstringWithMatch(beforeText, false));
      }

      substringsWithMatchBool.push(makeSubstringWithMatch(matchText, true));
      startBeforeIndex = match.index + length;
    } // Keep looking for matches if we previously found a match
    // and our regular expression is global (i.e. get all matches)

  } while (match && regexp.global); // If there's still some text leftover at the end, gobble it up


  if (startBeforeIndex < string.length) {
    var restText = string.substr(startBeforeIndex);
    substringsWithMatchBool.push(makeSubstringWithMatch(restText, false));
  }

  return substringsWithMatchBool;
};

var HighlightSubstring = function HighlightSubstring(_ref) {
  var children = _ref.children,
      match = _ref.match,
      className = _ref.className;
  var string = Array.isArray(children) ? children.join("") : children;
  var regexp = match instanceof RegExp ? match : new RegExp((0, _escapeRegExp["default"])(match.substr(0, maxMatchLength)), "i");
  var substrings = getSubstringsWithMatchBool(regexp, string);
  return /*#__PURE__*/_react["default"].createElement("span", null, substrings.map(function (_ref2, index) {
    var text = _ref2.text,
        match = _ref2.match;
    return !match ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: index
    }, text) : /*#__PURE__*/_react["default"].createElement("span", {
      key: index,
      className: className
    }, text);
  }));
};

HighlightSubstring.propTypes =  false ? {
  /**
   * The string(s) to highlight.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]).isRequired,

  /**
   * A string or regular expression used to identify which substring(s) should
   * be highlighted.
   *
   * If a string is provided, the first substring that matches the string
   * exactly will be highlighted.
   *
   * If a regular expression is provided, any substring matching the regular
   * expression will be highlighted (use a greedy regular expression to
   * highlight all matches).
   */
  match: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(RegExp)]).isRequired,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string
} : {};
HighlightSubstring.defaultProps = {
  className: defaultMatchedStyles
};
var _default = HighlightSubstring;
exports["default"] = _default;

/***/ }),
/* 642 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports = {
  typographyFontSizeD300: 76,
  typographyFontSizeD200: 54,
  typographyFontSizeD100: 48,
  typographyFontSizeD50: 36,
  typographyFontSizeH600: 36,
  typographyFontSizeH500: 28,
  typographyFontSizeH400: 24,
  typographyFontSizeH300: 20,
  typographyFontSizeH200: 18,
  typographyFontSizeH100: 16,
  typographyFontSizeB500: 20,
  typographyFontSizeB400: 18,
  typographyFontSizeB300: 16,
  typographyFontSizeB200: 14,
  typographyFontSizeB100: 12,
  typographyFontWeightD300: 200,
  typographyFontWeightD200: 200,
  typographyFontWeightD100: 200,
  typographyFontWeightD50: 200,
  typographyFontWeightH600: 600,
  typographyFontWeightH500: 600,
  typographyFontWeightH400: 600,
  typographyFontWeightH300: 600,
  typographyFontWeightH200: 600,
  typographyFontWeightH100: 600,
  typographyFontWeightB500: 400,
  typographyFontWeightB400: 400,
  typographyFontWeightB300: 400,
  typographyFontWeightB200: 400,
  typographyFontWeightB100: 400,
  typographyLineHeightD300: "96px",
  typographyLineHeightD200: "64px",
  typographyLineHeightD100: "60px",
  typographyLineHeightD50: "48px",
  typographyLineHeightH600: "48px",
  typographyLineHeightH500: "36px",
  typographyLineHeightH400: "32px",
  typographyLineHeightH300: "24px",
  typographyLineHeightH200: "24px",
  typographyLineHeightH100: "20px",
  typographyLineHeightB500: "28px",
  typographyLineHeightB400: "28px",
  typographyLineHeightB300: "24px",
  typographyLineHeightB200: "20px",
  typographyLineHeightB100: "16px"
};

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _scrim = _interopRequireDefault(__webpack_require__(173));

var _closeMedium = _interopRequireDefault(__webpack_require__(644));

var _popoverController = _interopRequireDefault(__webpack_require__(242));

var _token = __webpack_require__(12);

var _text = _interopRequireDefault(__webpack_require__(27));

var _sheet = _interopRequireDefault(__webpack_require__(645));

var _button = _interopRequireDefault(__webpack_require__(50));

var _icon = _interopRequireDefault(__webpack_require__(38));

var _context = _interopRequireDefault(__webpack_require__(279));

var _theme = __webpack_require__(14);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SheetContextProvider = _context["default"].Provider;
var popoverStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var anchorWidth = _ref.anchorWidth;
  return (0, _emotion.css)((0, _text["default"])(t), {
    boxSizing: "border-box",
    minWidth: anchorWidth,
    overflowY: "auto",
    outline: "none",
    backgroundColor: t("optionListBackgroundColor"),
    borderRadius: t("optionListBorderRadius"),
    border: t.borderCss("optionListBorder"),
    boxShadow: t.boxShadowCss("optionListShadow"),
    zIndex: t("optionListElevation")
  });
}, ["anchorWidth"]); // NOTE: We reverse the column of the select options and the close icon Button
// for the mobile sheet. This allows the list options to be read before
// the close button is read, while keeping the position of the close icon Button
// top aligned with using an explicit position.

var sheetStyles = (0, _emotion.css)({
  display: "flex",
  flexDirection: "column-reverse",
  // Close icon button styles
  "& > *:nth-child(2)": {
    display: "flex",
    justifyContent: "end"
  }
});

var SelectOptionListContainer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SelectOptionListContainer, _React$Component);

  var _super = _createSuper(SelectOptionListContainer);

  function SelectOptionListContainer() {
    var _this;

    (0, _classCallCheck2["default"])(this, SelectOptionListContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderPopover", function () {
      return /*#__PURE__*/_react["default"].createElement(_popoverController["default"], {
        open: _this.props.open,
        anchorNode: _this.props.popoverAnchorNode,
        anchorOrigin: "bottom left",
        popoverOrigin: "top left",
        offsetVertical: _this.props.t("optionListPopoverOffsetVertical"),
        maxHeight: _this.props.popoverMaxHeight,
        shrinkToFit: true,
        onOpen: _this.props.onOpenPopover
      }, function (_ref2) {
        var popoverStyle = _ref2.popoverStyle,
            anchorRect = _ref2.anchorRect;
        return /*#__PURE__*/_react["default"].createElement("div", {
          id: _this.props.id,
          className: "\n            ".concat(popoverStyles(_this.props.t, {
            anchorWidth: anchorRect.width
          }), "\n            ").concat(popoverStyle)
        }, _this.props.children);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderBottomSheet", function () {
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _scrim["default"],
        map: (0, _token.getTokenHelper)("scrim")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(SheetContextProvider, {
          value: {
            zIndex: t("elevation") + 2,
            // Turn off Sheet's onAfterClose which attempts to refocus to the
            // last active element before it was open which, in some cases, might
            // be other inputs.
            onAfterClose: function onAfterClose() {}
          }
        }, /*#__PURE__*/_react["default"].createElement(_sheet["default"], {
          id: _this.props.id,
          onClose: _this.props.onCloseBottomSheet,
          open: _this.props.open,
          type: "overlay",
          side: "bottom"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: sheetStyles
        }, _this.props.children, _this.props.closeLabel && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_button["default"], {
          label: _this.props.closeLabel,
          type: "icon",
          onClick: _this.props.onCloseBottomSheet
        }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
          tokens: _closeMedium["default"]
        }))))));
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(SelectOptionListContainer, [{
    key: "render",
    value: function render() {
      return this.props.type === "popover" ? this.renderPopover() : this.renderBottomSheet();
    }
  }]);
  return SelectOptionListContainer;
}(_react["default"].Component);

SelectOptionListContainer.propTypes =  false ? {
  children: _propTypes["default"].node,
  closeLabel: _propTypes["default"].string,
  id: _propTypes["default"].string,
  open: _propTypes["default"].bool,
  popoverAnchorNode: _propTypes["default"].object,
  popoverMaxHeight: _propTypes["default"].number,
  t: _propTypes["default"].func,
  type: _propTypes["default"].oneOf(["popover", "bottom-sheet"]),

  /**
   * NOTE: This is only available for the bottom sheet because the popover
   * does not trigger any close events on its own.
   */
  onCloseBottomSheet: _propTypes["default"].func,

  /**
   * NOTE: This is only available for the popover because the bottom sheet's
   * onOpen prop is executed before the bottom sheet is actually rendered to
   * the DOM.
   */
  onOpenPopover: _propTypes["default"].func
} : {};
var _default = SelectOptionListContainer;
exports["default"] = _default;

/***/ }),
/* 644 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCloseMediumData: "data:image/svg+xml,%3csvg width='14' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.613.21l.094.083L7 5.585 12.293.293l.094-.083a1 1 0 011.32 1.497L8.415 7l5.292 5.293a1 1 0 01-1.32 1.497l-.094-.083L7 8.415l-5.293 5.292-.094.083a1 1 0 01-1.32-1.497L5.585 7 .293 1.707A1 1 0 011.613.21z' fill='currentColor' fill-rule='nonzero'/%3e%3c/svg%3e",
  iconCloseMediumWidth: 14,
  iconCloseMediumHeight: 14
};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _sheet = _interopRequireDefault(__webpack_require__(646));

var _default = _sheet["default"];
exports["default"] = _default;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _keycode = _interopRequireDefault(__webpack_require__(47));

var _emotion = __webpack_require__(4);

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _sheet = _interopRequireDefault(__webpack_require__(647));

var _modal = _interopRequireDefault(__webpack_require__(263));

var _scrim = _interopRequireDefault(__webpack_require__(173));

var _context = _interopRequireDefault(__webpack_require__(279));

var _theme = __webpack_require__(14);

var _expanderController = _interopRequireDefault(__webpack_require__(648));

var _scrim2 = _interopRequireDefault(__webpack_require__(268));

var _portal = _interopRequireDefault(__webpack_require__(160));

var _focusTrap = _interopRequireDefault(__webpack_require__(265));

var _useFocus2 = _interopRequireDefault(__webpack_require__(40));

var _focus = __webpack_require__(157);

var _token = __webpack_require__(12);

var _parsers = __webpack_require__(66);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

var _rtl = __webpack_require__(52);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var borderSides = {
  left: "borderRight",
  right: "borderLeft",
  bottom: "borderTop"
};
var containerStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _css;

  var side = _ref.side,
      spacingInset = _ref.spacingInset,
      backgroundColor = _ref.backgroundColor;
  return (0, _emotion.css)((_css = {}, (0, _defineProperty2["default"])(_css, borderSides[side], t.borderCss("border")), (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", (0, _defineProperty2["default"])({}, (0, _rtl.getRtl)(borderSides[side]), t.borderCss("border"))), (0, _defineProperty2["default"])(_css, "& > div", {
    backgroundColor: backgroundColor,
    padding: "".concat((0, _parsers.parseSpacing)(spacingInset), "px"),
    outline: "none",
    overflowY: "auto",
    boxSizing: "border-box",
    maxHeight: side === "bottom" ? [// Take up 100% of the viewport height minus the minimum page reveal.
    // This has wide browser support but introduces an issue on mobile
    // browsers that can be solved by the following value.
    "calc(100vh - ".concat(t("minimumPageReveal"), "px)"), // If the browser supports it, use dynamic viewport height to
    // take care of that pesky problem where the browser UI changes
    // the perceived height of the webpage.
    //
    // https://www.bram.us/2021/07/08/the-large-small-and-dynamic-viewports/
    "calc(100dvh - ".concat(t("minimumPageReveal"), "px)")] : undefined
  }), _css));
}, ["side", "spacingInset", "backgroundColor"]);

var mediaQuery = function mediaQuery(floatingBreakpoint) {
  return "@media (max-width: ".concat(floatingBreakpoint, "px)");
};

var modalStyles = function modalStyles(tScrim, tModal, t, _ref2) {
  var _css2, _dirRtl2, _ref3;

  var side = _ref2.side,
      zIndex = _ref2.zIndex;
  return (0, _emotion.css)((_css2 = {
    zIndex: zIndex || tScrim("elevation")
  }, (0, _defineProperty2["default"])(_css2, mediaQuery(tModal.tokens.modalFloatingBreakpoint), {
    zIndex: zIndex || tScrim("elevation") - 1
  }), (0, _defineProperty2["default"])(_css2, "position", "fixed"), (0, _defineProperty2["default"])(_css2, "boxShadow", "".concat(t("shadowOffset", [side, "x"]), "px ").concat(t("shadowOffset", [side, "y"]), "px ").concat(t("shadow", "blur"), "px ").concat(t("shadow", "spread"), "px ").concat(t("shadow", "color"), "}")), _css2), side === "bottom" ? {
    bottom: 0,
    left: 0,
    right: 0
  } : (_ref3 = {
    top: 0,
    bottom: 0
  }, (0, _defineProperty2["default"])(_ref3, side, 0), (0, _defineProperty2["default"])(_ref3, "[dir=\"rtl\"] &", (_dirRtl2 = {}, (0, _defineProperty2["default"])(_dirRtl2, side, "auto"), (0, _defineProperty2["default"])(_dirRtl2, (0, _rtl.getRtl)(side), 0), _dirRtl2)), _ref3));
};

var overlayScrimStyles = function overlayScrimStyles(_ref4) {
  var tScrim = _ref4.tScrim,
      tModal = _ref4.tModal,
      zIndex = _ref4.zIndex;
  return (0, _emotion.css)((0, _defineProperty2["default"])({
    zIndex: zIndex ? zIndex - 1 : tScrim("elevation") - 1
  }, mediaQuery(tModal.tokens.modalFloatingBreakpoint), {
    zIndex: zIndex ? zIndex - 1 : tScrim("elevation") - 2
  }));
}; // Overlay expanders are put into a portal


var OverlayExpanderController = function OverlayExpanderController(props) {
  return /*#__PURE__*/_react["default"].createElement(_portal["default"], null, /*#__PURE__*/_react["default"].createElement(_expanderController["default"], props));
};
/**
 * This component renders a sheet that enters/exits on a particular side of
 * the screen. The sheet can appear as a overlay above other components or
 * displace surrounding components.
 *
 * @since 5.x
 */


var Sheet = function Sheet(props) {
  var open = props.open,
      side = props.side,
      onClose = props.onClose,
      spacingInset = props.spacingInset,
      onOpen = props.onOpen; // Always render children if closed size is set greater than 0 or
  // we're explicitly told via props

  var alwaysRenderChildren = props.closedSize !== undefined && props.closedSize > 0 || props.alwaysRenderChildren; // If we're always visible, force type to be push

  var type = alwaysRenderChildren ? "push" : props.type;
  var t = (0, _theme.useTheme)(_sheet["default"], "sheet"); // HACK: using modal floatingBreakpoint tokens - but we should really add this to the Sheet tokens and update this.

  var tModal = (0, _theme.useTheme)(_modal["default"], "modal");
  var tScrim = (0, _theme.useTheme)(_scrim["default"], "scrim");
  var hasMounted = (0, _react.useRef)(false);
  var contentRef = (0, _react.useRef)(); // DOM node wrapping sheet content

  var anchorRef = (0, _react.useRef)(); // DOM element that originally opened sheet

  var _useContext = (0, _react.useContext)(_context["default"]),
      zIndex = _useContext.zIndex,
      contextOnAfterClose = _useContext.onAfterClose; // An override z-index and custom onAfterClose method


  var initializeContentRef = (0, _react.useCallback)(function (contentProps) {
    return function (element) {
      contentRef.current = element;
      contentProps.ref(element);
    };
  }, []);
  var backgroundColor = (0, _react.useMemo)(function () {
    return (0, _token.getToken)(t.tokens, "themeBackground", [props.backgroundColor, "default"]) || props.backgroundColor;
  }, [t, props.backgroundColor]); // Put "overlay" sheets, which are essentially modals, in an expander that has built
  // in portal and focus trap.

  var Expander = (0, _react.useCallback)(function (props) {
    return /*#__PURE__*/_react["default"].createElement(type === "overlay" ? OverlayExpanderController : _expanderController["default"], props);
  }, [type]); // Put "overlay" sheets, which are essentially modals, in a focus trap

  var SheetWrapper = (0, _react.useCallback)(function (props) {
    return /*#__PURE__*/_react["default"].createElement(type === "overlay" ? _focusTrap["default"] : _react["default"].Fragment, props);
  }, [type]); // Overlay sheets are essentially modals. Here we add an keyboard listener
  // that closes the sheet when the user presses the "esc" key.
  // https://www.w3.org/TR/wai-aria-practices-1.1/#dialog_modal

  (0, _react.useEffect)(function () {
    if (type === "overlay" && onClose) {
      var onKeyDown = function onKeyDown(e) {
        if ((0, _keycode["default"])(e) === "esc") onClose();
      };

      window.addEventListener("keydown", onKeyDown);
      return function () {
        return window.removeEventListener("keydown", onKeyDown);
      };
    }
  }, [type, onClose]); // On open, move focus to the first focusable element. On close, move focus
  // back to the original element that opened the sheet.

  var onAfterOpen = (0, _react.useCallback)(function () {
    // Run this effect only after the component has mounted. Else, sheet
    // that load as `open` will immediately take over the active element.
    if (hasMounted.current && contentRef.current) {
      var firstFocusableNode = (0, _focus.getKeyboardFocusNodes)(contentRef.current)[0];
      if (firstFocusableNode) firstFocusableNode.focus();else contentRef.current.focus();
    }
  }, []); // On close, return focus to where it was before the bottom sheet was opened.

  var onAfterClose = function onAfterClose() {
    if (contextOnAfterClose) contextOnAfterClose();else if (anchorRef.current) anchorRef.current.focus();
  }; // When opening, record which element opened the sheet


  (0, _react.useEffect)(function () {
    if (open) anchorRef.current = document.activeElement;
    hasMounted.current = true;
  }, [open]);
  (0, _react.useEffect)(function () {
    if (open && onOpen) onOpen();
  }, [open, onOpen]);

  var _useFocus = (0, _useFocus2["default"])({
    multipleNodes: true,
    onFocus: props.onFocus,
    onBlur: props.onBlur
  }),
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement(Expander, {
    open: open,
    direction: side === "bottom" ? "down" : side,
    motionDuration: props.motionDuration || parseInt(t("motionTiming")),
    motionFunction: props.motionFunction || t("motionFunction"),
    onAfterOpen: onAfterOpen,
    onAfterClose: onAfterClose,
    alwaysRenderChildren: alwaysRenderChildren,
    closedSize: props.closedSize
  }, function (_ref5) {
    var state = _ref5.state,
        containerProps = _ref5.containerProps,
        contentProps = _ref5.contentProps;
    // The children of a sheet might be interested in the state of the expander
    // to dynamically hide/show components for various stages. For example, skinny
    // SideMenu shows different links based on the expander state.
    var children = typeof props.children === "function" ? props.children({
      expanderState: state
    }) : props.children;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(SheetWrapper, null, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, containerProps, {
      className: (0, _emotion.cx)(props.className, containerStyles(t, {
        side: side,
        spacingInset: spacingInset,
        backgroundColor: backgroundColor
      }), type === "overlay" ? modalStyles(tScrim, tModal, t, {
        side: side,
        zIndex: zIndex
      }) : undefined, containerProps.className)
    }), /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
      // TODO: Remove these props in 6.x
      "aria-labelledby": props.labelledById,
      "aria-describedby": props.describedById
    }, passThroughProps, focusProps, {
      className: contentProps.className,
      id: props.id,
      ref: initializeContentRef(contentProps),
      role: type === "overlay" ? "dialog" : undefined,
      "aria-modal": type === "overlay" ? true : undefined,
      tabIndex: "-1",
      onKeyDown: props.onKeyDown
    }), children))), type === "overlay" ? /*#__PURE__*/_react["default"].createElement(_scrim2["default"], {
      className: overlayScrimStyles({
        tScrim: tScrim,
        tModal: tModal,
        zIndex: zIndex
      }),
      onClick: props.onClose,
      open: state === "entering" || state === "entered",
      duration: t("motionTiming")
    }) : null);
  });
};

Sheet.displayName = "Sheet";
Sheet.propTypes =  false ? {
  /**
   * Set this to true if children should be rendered even when the sheet
   * is closed. This can be helpful when, for example, you want the sheet
   * to retain vertical or horizontal layout space (for a horizontal or
   * vertical sheet, respectively) even after it's collapsed.
   */
  alwaysRenderChildren: _propTypes["default"].bool,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * The sheet's background color. Any CSS color value is acceptable.
   *
   * Note that accessibility should be carefully considered when selecting a
   * background color. A [minimum contrast ratio of 4.5:1](https://www.w3.org/WAI/WCAG21/Understanding/contrast-minimum.html) between text and
   * background must be maintained. For large text a contrast ratio of 3:1 is acceptable.
   * You can use [a contrast checker](https://webaim.org/resources/contrastchecker/) to verify that your chosen background color
   * maintains an appropriate level of contrast. You can [read more here](https://meridian.a2z.com/guides/accessibility/?platform=react-web) about accessibility in Meridian.
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary", "alternatePrimary", "alternateSecondary"]), _propTypes["default"].string]),

  /**
   * The contents of the sheet. When a sheet is opened (and alwaysRenderChildren and closedSize
   * are _not_ set), the first focusable element will gain focus. Ideally this element should be
   * a close button so users can quickly toggle the sheet off.
   *
   * Children can also be a function that receives as its only argument an object with a key
   * `expanderState`. Expander state describes the phase of sheet's animation: "entering"/"entered"
   * when `open` is set to `true`, and "exiting"/"exited" when `open` is set to `false`. This
   * can be useful to conditionally show different components in the sheet based on the sheet's
   * animation phase.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * Causes the sheet to close to a fixed pixel height/width value.
   *
   * Forces `alwaysRenderChildren` to be `true` and type to be `push`.
   */
  closedSize: _propTypes["default"].number,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `aria-describedby` instead.
   *
   * @deprecated 5.30.0
   */
  describedById: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component's outer DOM element.
   *
   * Use this for testing, for accessibility, or to target custom elements
   * inside the component. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `aria-labelledby` instead.
   *
   * @deprecated 5.30.0
   */
  labelledById: _propTypes["default"].string,

  /**
   * The duration it should take to animate in milliseconds.
   */
  motionDuration: _propTypes["default"].number,

  /**
   * The animation function to use when animating. Learn more about [animation functions](https://developer.mozilla.org/en-US/docs/Web/CSS/animation-timing-function).
   */
  motionFunction: _propTypes["default"].string,

  /**
   * The state of the sheet. If true the sheet will be open, otherwise it will be closed.
   */
  open: _propTypes["default"].bool,

  /**
   * The side of the screen the sheet will appear. For type `overlay`, the sheet
   * is automatically fixed to the chosen side. For type `push`, however, setting
   * side _only_ affects how the sheet animates. Composing a `push` Sheet inside
   * the app's layout is the responsibility of the developer.
   */
  side: _propTypes["default"].oneOf(["left", "right", "bottom"]),

  /**
   * Apply padding around the contents of the sheet using a preset.
   */
  spacingInset: _propTypes["default"].oneOf(["none", "small", "medium", "300", "400"]),

  /**
   * sheets come in two flavors, push and overlay. Push displaces other elements on the
   * screen when it enters/exits. Overlay, on the other hand, enters/exits on top of the
   * application accompanied by a scrim (semi-transparent  overlay that covers the application
   * behind the sheet)
   */
  type: _propTypes["default"].oneOf(["push", "overlay"]),

  /**
   * This is called when the sheet loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * Required for type overlay. Called when a user presses the scrim (semi-transparent
   * overlay that covers the application behind the sheet) or hits the "escape" key.
   */
  onClose: _propTypes["default"].func,

  /**
   * This is called when the sheet gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func,

  /**
   * Called when the sheet is opened or when it is mounted open.
   */
  onOpen: _propTypes["default"].func
} : {};
Sheet.defaultProps = {
  type: "push",
  open: false,
  side: "right",
  spacingInset: "medium",
  backgroundColor: "alternatePrimary"
};
var _default = Sheet;
exports["default"] = _default;

/***/ }),
/* 647 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    sheetMinimumPageReveal: 40,
    sheetMotionTiming: "200ms",
    sheetMotionFunction: "ease",
    sheetBorderWidth: 1,
    sheetBorderRadius: 0,
    sheetBorderColor: tokens.themeBorderSecondaryDefault,
    sheetShadowColor: "rgba(11, 12, 12, 0.1)",
    sheetShadowBlur: 16,
    sheetShadowSpread: 0,
    sheetShadowOffsetBottomX: 0,
    sheetShadowOffsetBottomY: -8,
    sheetShadowOffsetLeftX: 8,
    sheetShadowOffsetLeftY: 0,
    sheetShadowOffsetRightX: -8,
    sheetShadowOffsetRightY: 0
  }
};

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _expanderController = _interopRequireDefault(__webpack_require__(649));

var _default = _expanderController["default"];
exports["default"] = _default;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(108));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _transitionController = _interopRequireDefault(__webpack_require__(243));

var _waitAnimationFrame = _interopRequireDefault(__webpack_require__(109));

var _functional = __webpack_require__(26);

var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getSizeProperty = function getSizeProperty(direction) {
  return {
    left: "width",
    right: "width",
    up: "height",
    down: "height"
  }[direction];
}; // The container element sets the width or height of the expander and handles
// the expanding and collapsing motion.


var containerStyles = (0, _functional.memoizeByKeys)(function (_ref) {
  var _css;

  var state = _ref.state,
      direction = _ref.direction,
      size = _ref.size,
      motionDuration = _ref.motionDuration,
      motionFunction = _ref.motionFunction,
      closedSize = _ref.closedSize;
  return (0, _emotion.css)({
    left: {
      // Horizontal expanders are inline-flex to ensure they shrink to fit
      // their children's width (vertical expanders shrink to fit by default
      // 'cause that's how CSS layout works).
      display: "inline-flex",
      // The up/left expanders use row/column-reverse so that content is fixed
      // to the bottom/right edges instead of top/left (the default).
      // NOTE: justifyContent: "flex-end" would work here instead *except* for
      // a bug in IE11: https://stackoverflow.com/questions/32885534/how-to-make-flex-end-work-in-ie11
      flexDirection: "row-reverse"
    },
    right: {
      display: "inline-flex",
      flexDirection: "row"
    },
    up: {
      display: "flex",
      flexDirection: "column-reverse"
    },
    down: {
      display: "flex",
      flexDirection: "column"
    }
  }[direction], (_css = {
    // Don't let a flex parent squish the expander
    flexShrink: 0
  }, (0, _defineProperty2["default"])(_css, getSizeProperty(direction), state === "entering" || state === "entered" ? size : closedSize), (0, _defineProperty2["default"])(_css, "overflow", "hidden"), (0, _defineProperty2["default"])(_css, "transition", motionDuration && motionFunction ? "".concat(getSizeProperty(direction), " ").concat(motionDuration, "ms ").concat(motionFunction) : undefined), (0, _defineProperty2["default"])(_css, "visibility", state === "exited" && closedSize === 0 ? "hidden" : undefined), (0, _defineProperty2["default"])(_css, "maxWidth", state === "exited" && (direction === "left" || direction === "right") ? closedSize : undefined), _css));
}, ["state", "direction", "size", "motionDuration", "motionFunction", "closedSize"]); // The content element automatically holds its dimensions, even when the
// container is collapsed, so that the container knows what size to animate to.

var contentStyles = (0, _functional.memoize)(function (direction) {
  var _css2;

  return (0, _emotion.css)((_css2 = {}, (0, _defineProperty2["default"])(_css2, getSizeProperty(direction), "max-content"), (0, _defineProperty2["default"])(_css2, "flexShrink", 0), (0, _defineProperty2["default"])(_css2, "transform", "translateZ(0)"), _css2));
});
/* eslint-disable react/prop-types */

/**
 * This component makes it easy to animate the size of a content block from 0 to
 * "auto" and back. It handles some nice things like expanding in various
 * directions, keeping children out of the tab order when collapsed, setting an
 * aria-hidden attribute when collapsed, and correctly handling situations when
 * the dimensions of the expander contents change on the fly.
 *
 * This component doesn't render anything to the DOM itself, but it needs at
 * least two nested elements to work. To make this happen it requires that you
 * pass in children as a function. It will call that function, passing it an
 * object containing two more objects keyed under "containerProps" and
 * "contentProps". These objects should be passed through as props to two nested
 * elements by your children function (with the container element as the root of
 * the expander and the content element as the only child of the container).
 * This allows you to take advantage of the expander functionality while
 * maintaining maximum control over the DOM. Example:
 *
 * ```
 * <ExpanderController>
 *   {({ containerProps, contentProps }) => (
 *     <div {...containerProps}>
 *       <div {...contentProps}>
 *         My expandable content here...
 *       <div>
 *     </div>
 *   )}
 * </ExpanderController>
 * ```
 *
 * NOTE: Horizontal ExpanderControllers are inline elements, so extra attention
 * may be needed to avoid unwanted whitespace around them. A couple tricks for
 * removing whitespace include setting `font-size: 0` or `display: flex` on an
 * inline element's parent.
 */

var ExpanderControllerClass = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ExpanderControllerClass, _React$Component);

  var _super = _createSuper(ExpanderControllerClass);

  function ExpanderControllerClass() {
    var _this;

    (0, _classCallCheck2["default"])(this, ExpanderControllerClass);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      size: undefined,
      render: _this.props.open || _this.props.alwaysRenderChildren
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateContentRef", function (node) {
      return _this.contentRef = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancelFixSize", function () {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "fixSize", function (done) {
      return _this.setState({
        size: _this.contentRef && _this.contentRef.getBoundingClientRect()[getSizeProperty(_this.props.direction)]
      }, done);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeOpen", function (done) {
      if (!_this.state.render) {
        // If the children aren't rendered yet, do so and then give them a chance
        // to settle before poking through the DOM
        _this.setState({
          render: true
        }, function () {
          _this.cancelFixSize = (0, _waitAnimationFrame["default"])(function () {
            return _this.fixSize(done);
          });
        });
      } else {
        _this.fixSize(done);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterOpen", function () {
      _this.setState({
        size: undefined
      });

      if (_this.props.onAfterOpen) _this.props.onAfterOpen();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeClose", function (done) {
      _this.cancelFixSize();

      _this.fixSize(done);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterClose", function () {
      if (!_this.props.alwaysRenderChildren) {
        _this.setState({
          render: false
        });
      }

      if (_this.props.onAfterClose) _this.props.onAfterClose();
    });
    return _this;
  }

  (0, _createClass2["default"])(ExpanderControllerClass, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelFixSize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var _this$state = this.state,
          size = _this$state.size,
          render = _this$state.render;
      return /*#__PURE__*/_react["default"].createElement(_transitionController["default"], {
        "in": props.open,
        duration: props.motionDuration && props.motionFunction ? props.motionDuration : 0,
        onBeforeEnter: this.onBeforeOpen,
        onAfterEnter: this.onAfterOpen,
        onBeforeExit: this.onBeforeClose,
        onAfterExit: this.onAfterClose
      }, function (state) {
        return render ? children({
          state: state,
          containerProps: {
            className: containerStyles(_objectSpread(_objectSpread({}, props), {}, {
              state: state,
              size: size
            })),
            "aria-hidden": !props.closedSize && !props.open
          },
          contentProps: {
            className: contentStyles(props.direction),
            ref: _this2.updateContentRef
          }
        }) : null;
      });
    }
  }]);
  return ExpanderControllerClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */
// Keep refs from being passed. We're doing this for 4.x - the
// most recent breaking change - so that we can change the
// _actual_ component to functional later without waiting
// for the next breaking change


var ExpanderController = function ExpanderController(props) {
  return /*#__PURE__*/_react["default"].createElement(ExpanderControllerClass, props);
};

ExpanderController.propTypes =  false ? {
  children: _propTypes["default"].func.isRequired,
  direction: _propTypes["default"].oneOf(["up", "down", "left", "right"]).isRequired,
  open: _propTypes["default"].bool.isRequired,

  /**
   * Set this to true if children should be rendered even when the expander
   * is closed. This can be helpful when, for example, you want the expander
   * to retain vertical or horizontal layout space (for a horizontal or
   * vertical expander, respectively) even after it's collapsed.
   */
  alwaysRenderChildren: _propTypes["default"].bool,

  /**
   * The value the expander should close to. Setting the value to > 0 will
   * keep the expander visible even when closed.
   */
  closedSize: _propTypes["default"].number,
  motionDuration: _propTypes["default"].number,
  motionFunction: _propTypes["default"].string,
  onAfterClose: _propTypes["default"].func,
  onAfterOpen: _propTypes["default"].func
} : {};
ExpanderController.defaultProps = {
  closedSize: 0
};
var _default = ExpanderController;
exports["default"] = _default;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = __webpack_require__(0);

var _default = /*#__PURE__*/(0, _react.createContext)({});

exports["default"] = _default;

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MobileDisplay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__context_DeviceLayoutContext__ = __webpack_require__(41);
/*
    This acts as a wrapper component and based on visibility parameter
     it will decide to show that component in mobile or not
     eg: If visibility is true wrapped component will be shown on mobile and not on desktop
         If visibility is false wrapped component will be shown on desktop and not on mobile
*/var MobileDisplay=function MobileDisplay(_ref){var children=_ref.children,visibility=_ref.visibility;var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_0__context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),isMobile=_useDeviceLayout.isMobile;return isMobile?visibility?children:null:visibility?null:children;};

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Options__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Cluster__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Aisle__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__floor_Floor__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SortZone__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_breadcrumb__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_breadcrumb_breadcrumb_group__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_breadcrumb_breadcrumb_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_breadcrumb_breadcrumb_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__options_CycleOptions__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_ClusterActions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_AisleActions__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_SortZoneActions__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__station_pair_StationPair__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_StationPairActions__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__actions_FloorActions__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Route__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__options_HeatMapViewOptions__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__actions_RouteActions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__actions_ZoneActions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Zone__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__CartLocation__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__actions_CartLocationActions__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__actions_ConfigActions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__utils_PageHeader__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__sideline_FloorLocation__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__actions_FloorLocationActions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__sideline_Cart__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__actions_CartActions__ = __webpack_require__(117);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeatMap=function(_Component){_inherits(HeatMap,_Component);function HeatMap(props){_classCallCheck(this,HeatMap);var _this=_possibleConstructorReturn(this,(HeatMap.__proto__||Object.getPrototypeOf(HeatMap)).call(this,props));_this.getViewSubjects=function(key){return _this.props.navigationOptions.filter(function(navigationOption){return navigationOption.key===key;}).map(function(navigationOption){return navigationOption.value;});};_this.findViewByOptionValues=function(navigationOptions,selectedView){switch(_this.props.capability){case __WEBPACK_IMPORTED_MODULE_23__enums__["e" /* Capability */].SSD:return _this.findViewForSSD(navigationOptions,selectedView);case __WEBPACK_IMPORTED_MODULE_23__enums__["e" /* Capability */].AMZL:default:return _this.findViewForAmzlCore(navigationOptions,selectedView);case __WEBPACK_IMPORTED_MODULE_23__enums__["e" /* Capability */].AR_NEXT_GEN:return _this.findViewForArNextGen(navigationOptions,selectedView);}};_this.findViewForAmzlCore=function(navigationOptions,selectedView){if(__WEBPACK_IMPORTED_MODULE_23__enums__["q" /* ViewType */].SIDELINE_VIEW===selectedView){if(navigationOptions.length===1)return __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].CART_VIEW;return __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].FLOOR_LOCATION_VIEW;}if(Object(__WEBPACK_IMPORTED_MODULE_18__Utility__["u" /* isOnlyRouteViewApplicable */])(_this.state.nodeId,_this.props.capability)||__WEBPACK_IMPORTED_MODULE_23__enums__["q" /* ViewType */].ROUTE_VIEW===selectedView){return __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].ROUTE_VIEW;}else if(navigationOptions.length===2)return __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].SORT_ZONE_VIEW;else if(navigationOptions.length===1)return __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].AISLE_VIEW;else return __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].CLUSTER;};_this.findViewForSSD=function(navigationOptions,selectedView){if(__WEBPACK_IMPORTED_MODULE_23__enums__["q" /* ViewType */].ROUTE_VIEW===selectedView){return __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].ROUTE_VIEW;}if(navigationOptions.length===1)return __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].CART_LOCATION_VIEW;return __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].ZONE_VIEW;};_this.findViewForArNextGen=function(navigationOptions,selectedView){if(__WEBPACK_IMPORTED_MODULE_23__enums__["q" /* ViewType */].ROUTE_VIEW===selectedView){return __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].ROUTE_VIEW;}if(navigationOptions.length===1)return __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].FLOOR_VIEW;else return __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].STATION_PAIR_VIEW;};_this.state={nodeId:Object(__WEBPACK_IMPORTED_MODULE_18__Utility__["m" /* getNodeId */])(),routeCodePrefixes:Object(__WEBPACK_IMPORTED_MODULE_18__Utility__["d" /* extractRouteCodePrefixesFromParam */])(props)};return _this;}_createClass(HeatMap,[{key:'render',value:function render(){var _this2=this;var _props=this.props,navigationOptions=_props.navigationOptions,selectedCycle=_props.selectedCycle,selectedCycleId=_props.selectedCycleId,selectedView=_props.selectedView,isInitialView=_props.isInitialView;//For initial view open route view when route code prefix list exists in params
if(this.state.routeCodePrefixes&&this.state.routeCodePrefixes!==""&&isInitialView){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_OptionsActions__["v" /* viewChanged */])(__WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].ROUTE_VIEW));}var view=this.findViewByOptionValues(navigationOptions,selectedView);var renderSubComponent=function renderSubComponent(){clearInterval(_this2.timer);switch(view){case __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].AISLE_VIEW:return _this2.renderAisleView(selectedCycle,selectedCycleId);case __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].SORT_ZONE_VIEW:return _this2.renderSortZoneView(selectedCycle,selectedCycleId);case __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].STATION_PAIR_VIEW:return _this2.renderStationPairView();case __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].FLOOR_VIEW:return _this2.renderFloorView();case __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].ROUTE_VIEW:return _this2.renderRouteView(_this2.state.routeCodePrefixes);case __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].ZONE_VIEW:return _this2.renderZoneView(selectedCycle,selectedCycleId);case __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].CART_LOCATION_VIEW:return _this2.renderCartLocationView();case __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].FLOOR_LOCATION_VIEW:return _this2.renderFloorLocationView();case __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].CART_VIEW:return _this2.renderCartView();case __WEBPACK_IMPORTED_MODULE_23__enums__["l" /* HeatMapView */].CLUSTER_VIEW:default:return _this2.renderClusterView(selectedCycle,selectedCycleId);}};var navigationChanged=function navigationChanged(navigationIndex){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_OptionsActions__["r" /* navigationRemoved */])(navigationIndex));};function renderBreadCrumb(navigationOptions){if(navigationOptions.length){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box___default.a,{spacingInset:'small none'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_breadcrumb_breadcrumb_group___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_breadcrumb___default.a,{onClick:function onClick(){return navigationChanged(0);}},'Stow'),navigationOptions.map(function(navigationOption,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_breadcrumb___default.a,{onClick:function onClick(){return navigationChanged(index+1);},key:navigationOption.key},navigationOption.key,' ',getNavigationOptionValue(navigationOption));})));}}var getNavigationOptionValue=function getNavigationOptionValue(navigationOption){switch(_this2.props.capability){case __WEBPACK_IMPORTED_MODULE_23__enums__["e" /* Capability */].SSD:case __WEBPACK_IMPORTED_MODULE_23__enums__["e" /* Capability */].AR_NEXT_GEN:return navigationOption.displayValue;case __WEBPACK_IMPORTED_MODULE_23__enums__["e" /* Capability */].AMZL:return navigationOption.displayValue?navigationOption.displayValue:navigationOption.value;default:return navigationOption.value;}};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default.a,{spacingInset:'small large'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__utils_PageHeader__["a" /* PageHeader */],__WEBPACK_IMPORTED_MODULE_22__constants__["n" /* HEADERS */].HEATMAP),this.renderOptions(selectedView),renderBreadCrumb(navigationOptions),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box___default.a,null,renderSubComponent()));}},{key:'renderOptions',value:function renderOptions(selectedView){return!Object(__WEBPACK_IMPORTED_MODULE_18__Utility__["u" /* isOnlyRouteViewApplicable */])(this.state.nodeId,this.props.capability)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Options__["a" /* default */],{options:this.getApplicableOptions(selectedView),optionsTagsRequired:this.getApplicableOptionTags(selectedView)});}},{key:'getApplicableOptions',value:function getApplicableOptions(selectedView){if(__WEBPACK_IMPORTED_MODULE_23__enums__["q" /* ViewType */].ROUTE_VIEW===selectedView||__WEBPACK_IMPORTED_MODULE_23__enums__["q" /* ViewType */].SIDELINE_VIEW===selectedView||__WEBPACK_IMPORTED_MODULE_23__enums__["e" /* Capability */].AR_NEXT_GEN===this.props.capability)return[{component:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__options_HeatMapViewOptions__["a" /* default */],null),name:"HeatMapViewOptions"}];else return[{component:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__options_HeatMapViewOptions__["a" /* default */],null),name:"HeatMapViewOptions"},{component:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__options_CycleOptions__["a" /* default */],null),name:"CycleOptions"}];}},{key:'getApplicableOptionTags',value:function getApplicableOptionTags(selectedView){if(__WEBPACK_IMPORTED_MODULE_23__enums__["q" /* ViewType */].ROUTE_VIEW===selectedView||__WEBPACK_IMPORTED_MODULE_23__enums__["q" /* ViewType */].SIDELINE_VIEW===selectedView||__WEBPACK_IMPORTED_MODULE_23__enums__["e" /* Capability */].AR_NEXT_GEN===this.props.capability)return[];return __WEBPACK_IMPORTED_MODULE_22__constants__["r" /* OPTIONS_TAG_REQUIRED */];}},{key:'renderAisleView',value:function renderAisleView(selectedCycle,selectedCycleId){var _this3=this;this.fetchAisleData(this.state.nodeId,selectedCycle,this.getViewSubjects('Cluster'),selectedCycleId);this.timer=setInterval(function(){if(!document.hidden){_this3.fetchAisleData(_this3.state.nodeId,selectedCycle,_this3.getViewSubjects('Cluster'),selectedCycleId);}},__WEBPACK_IMPORTED_MODULE_22__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Aisle__["a" /* default */],null);}},{key:'renderSortZoneView',value:function renderSortZoneView(selectedCycle,selectedCycleId){var _this4=this;this.fetchSortZoneData(this.state.nodeId,selectedCycle,this.getViewSubjects('Aisle'),selectedCycleId);this.timer=setInterval(function(){if(!document.hidden){_this4.fetchSortZoneData(_this4.state.nodeId,selectedCycle,_this4.getViewSubjects('Aisle'),selectedCycleId);}},__WEBPACK_IMPORTED_MODULE_22__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SortZone__["a" /* default */],null);}},{key:'renderClusterView',value:function renderClusterView(selectedCycle,selectedCycleId){var _this5=this;this.fetchClusterData(this.state.nodeId,selectedCycle,selectedCycleId);this.timer=setInterval(function(){if(!document.hidden){_this5.fetchClusterData(_this5.state.nodeId,selectedCycle,selectedCycleId);}},__WEBPACK_IMPORTED_MODULE_22__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Cluster__["a" /* default */],null);}},{key:'renderFloorLocationView',value:function renderFloorLocationView(){var _this6=this;this.fetchFloorLocationData(this.state.nodeId);this.timer=setInterval(function(){if(!document.hidden){_this6.fetchFloorLocationData(_this6.state.nodeId);}},__WEBPACK_IMPORTED_MODULE_22__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__sideline_FloorLocation__["a" /* default */],null);}},{key:'renderCartView',value:function renderCartView(){var _this7=this;this.fetchCartData.apply(this,[this.state.nodeId].concat(_toConsumableArray(this.getViewSubjects('Floor Location, Re-Induct Day'))));this.timer=setInterval(function(){if(!document.hidden){_this7.fetchCartData.apply(_this7,[_this7.state.nodeId].concat(_toConsumableArray(_this7.getViewSubjects('Floor Location, Re-Induct Day'))));}},__WEBPACK_IMPORTED_MODULE_22__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__sideline_Cart__["a" /* default */],null);}},{key:'renderZoneView',value:function renderZoneView(selectedCycle,selectedCycleId){var _this8=this;this.fetchZoneData(this.state.nodeId,selectedCycle,selectedCycleId);this.timer=setInterval(function(){if(!document.hidden){_this8.fetchZoneData(_this8.state.nodeId,selectedCycle,selectedCycleId);}},__WEBPACK_IMPORTED_MODULE_22__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__Zone__["a" /* default */],null);}},{key:'renderRouteView',value:function renderRouteView(routeCodePrefixes){var _this9=this;this.fetchRouteData(this.state.nodeId,this.props.capability);this.timer=setInterval(function(){if(!document.hidden){_this9.fetchRouteData(_this9.state.nodeId,_this9.props.capability);}},__WEBPACK_IMPORTED_MODULE_22__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Route__["a" /* default */],{routeCodePrefixesFromUrl:routeCodePrefixes});}},{key:'renderFloorView',value:function renderFloorView(){var _this10=this;this.fetchFloorData();this.timer=setInterval(function(){if(!document.hidden){_this10.fetchFloorData();}},__WEBPACK_IMPORTED_MODULE_22__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__floor_Floor__["a" /* default */],{nodeId:this.state.nodeId});}},{key:'renderCartLocationView',value:function renderCartLocationView(){var _this11=this;this.fetchCartLocationData();this.timer=setInterval(function(){if(!document.hidden){_this11.fetchCartLocationData();}},__WEBPACK_IMPORTED_MODULE_22__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__CartLocation__["a" /* default */],{nodeId:this.state.nodeId,featureStatus:this.props.featureStatus});}},{key:'renderStationPairView',value:function renderStationPairView(){var _this12=this;this.fetchStationPairData();this.timer=setInterval(function(){if(!document.hidden){_this12.fetchStationPairData();}},__WEBPACK_IMPORTED_MODULE_22__constants__["z" /* refreshInterval */]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__station_pair_StationPair__["a" /* default */],null);}},{key:'fetchClusterData',value:function fetchClusterData(nodeId,cycle,cycleId){if(cycle&&cycleId&&this.props.featureStatus){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_ClusterActions__["q" /* getStowPackageMetricsForCluster */])(this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_22__constants__["j" /* FEATURES */].ADTA_VISIBILITY],this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_22__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY],nodeId,[cycle],[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_ClusterActions__["o" /* getStowBinMetricsForCluster */])(nodeId,[cycle],[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_ClusterActions__["m" /* getInductPackageMetricsForCluster */])(nodeId,[cycle]));this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_22__constants__["j" /* FEATURES */].CART_VISIBILITY]&&this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_ClusterActions__["p" /* getStowCartMetricsForCluster */])(nodeId,[cycle],[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_ClusterActions__["n" /* getStowAssociateMetricsForCluster */])(nodeId,[cycle]));}}},{key:'fetchFloorLocationData',value:function fetchFloorLocationData(nodeId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_35__actions_FloorLocationActions__["h" /* getStowPackageMetricsForFloorLocation */])(nodeId,this.props.featureStatus));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_35__actions_FloorLocationActions__["g" /* getStowFloorMetricsForFloorLocation */])(nodeId,this.props.featureStatus));}},{key:'fetchCartData',value:function fetchCartData(nodeId,floorLocationAndReInductDay){this.props.dispatch(__WEBPACK_IMPORTED_MODULE_37__actions_CartActions__["d" /* getStowPackageMetricsForCart */].apply(undefined,[nodeId,this.props.featureStatus].concat(_toConsumableArray(floorLocationAndReInductDay))));}},{key:'fetchRouteData',value:function fetchRouteData(nodeId,capability){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__actions_RouteActions__["g" /* getMetricsForRoute */])(nodeId,capability));}},{key:'fetchAisleData',value:function fetchAisleData(nodeId,cycle,clusters,cycleId){if(cycle&&cycleId&&this.props.featureStatus){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_AisleActions__["r" /* getStowPackageMetricsForAisle */])(this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_22__constants__["j" /* FEATURES */].ADTA_VISIBILITY],this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_22__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY],nodeId,[cycle],clusters,[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_AisleActions__["o" /* getStowBinMetricsForAisle */])(nodeId,[cycle],clusters,[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_AisleActions__["n" /* getStowBagMetricsForAisle */])(nodeId,[cycle],clusters,[cycleId]));this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_22__constants__["j" /* FEATURES */].CART_VISIBILITY]&&this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_AisleActions__["q" /* getStowCartMetricsForAisle */])(nodeId,[cycle],clusters,[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_AisleActions__["k" /* getInductPackageMetricsForAisle */])(nodeId,[cycle],clusters));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_AisleActions__["m" /* getStowAssociateMetricsForAisle */])(nodeId,[cycle],clusters));}}},{key:'fetchSortZoneData',value:function fetchSortZoneData(nodeId,cycle,aisles,cycleId){if(cycle&&cycleId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_SortZoneActions__["o" /* getStowPackageMetricsForSortZone */])(this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_22__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY],nodeId,[cycle],aisles,[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_SortZoneActions__["n" /* getStowBagMetricsForSortZone */])(nodeId,[cycle],aisles,[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_SortZoneActions__["l" /* getInductPackageMetricsForSortZone */])(nodeId,[cycle],aisles));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_SortZoneActions__["k" /* fetchOvUsageForSortZone */])(nodeId,[cycle],aisles));}}},{key:'fetchStationPairData',value:function fetchStationPairData(){var nodeId=this.state.nodeId;this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_StationPairActions__["m" /* getInductPackageMetricsForStationPair */])(nodeId));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_StationPairActions__["n" /* getPickPackageMetricsForStationPair */])(nodeId));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_StationPairActions__["o" /* getStowAssociateMetricsForStationPair */])(nodeId));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_StationPairActions__["p" /* getStowFloorMetricsForStationPair */])(nodeId));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_StationPairActions__["q" /* getStowPackageMetricsForStationPair */])(nodeId));}},{key:'fetchFloorData',value:function fetchFloorData(){var nodeId=this.state.nodeId;var stationPairs=this.getViewSubjects('Station');this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_FloorActions__["h" /* getInductPackageMetricsForFloor */])(nodeId,stationPairs));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_FloorActions__["i" /* getPickPackageMetricsForFloor */])(nodeId,stationPairs));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_FloorActions__["l" /* getStowPackageMetricsForFloor */])(nodeId,stationPairs));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_FloorActions__["k" /* getStowFloorDataForFloor */])(nodeId,stationPairs));}},{key:'fetchCartLocationData',value:function fetchCartLocationData(){var nodeId=this.state.nodeId;var zone=this.getViewSubjects('Zone');this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_31__actions_CartLocationActions__["h" /* getStowPackageMetricsForCartLocation */])(nodeId,zone));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_31__actions_CartLocationActions__["g" /* getStowFloorDataForCartLocation */])(nodeId,zone,this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_22__constants__["j" /* FEATURES */].ROUTE_CODE_VISIBILITY]));}},{key:'fetchZoneData',value:function fetchZoneData(nodeId,cycle,cycleId){if(cycle&&cycleId){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__actions_ZoneActions__["h" /* getStowPackageMetricsForZone */])(nodeId,[cycle],[cycleId]));this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__actions_ZoneActions__["g" /* getStowAssociateMetricsForZone */])(nodeId,[cycle]));}}},{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this13=this;var featureResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_27__handler_ParentDataHandler__["e" /* getFeaturesFromParent */])([__WEBPACK_IMPORTED_MODULE_22__constants__["j" /* FEATURES */].CART_VISIBILITY,__WEBPACK_IMPORTED_MODULE_22__constants__["j" /* FEATURES */].ADTA_VISIBILITY,__WEBPACK_IMPORTED_MODULE_22__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY,__WEBPACK_IMPORTED_MODULE_22__constants__["j" /* FEATURES */].SIDELINE_STOW_VISIBILITY,__WEBPACK_IMPORTED_MODULE_22__constants__["j" /* FEATURES */].SIDELINE_STOW_V2,__WEBPACK_IMPORTED_MODULE_22__constants__["j" /* FEATURES */].REINDUCT_DATE_PLUS_ONE_FIX,__WEBPACK_IMPORTED_MODULE_22__constants__["j" /* FEATURES */].ROUTE_CODE_VISIBILITY,__WEBPACK_IMPORTED_MODULE_22__constants__["j" /* FEATURES */].DOWNLOAD_SORT_PLAN_BUTTON_VISIBILITY]);case 3:featureResponse=_context.sent;this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_32__actions_ConfigActions__["b" /* fetchFeatureStatusCallSuccess */])(featureResponse.data));_context.next=10;break;case 7:_context.prev=7;_context.t0=_context['catch'](0);console.error('Error loading features:',_context.t0);case 10:Object(__WEBPACK_IMPORTED_MODULE_27__handler_ParentDataHandler__["g" /* getNodeCapabilityFromParent */])().then(function(capabilityResponse){var capability=JSON.parse(capabilityResponse.capability);if(__WEBPACK_IMPORTED_MODULE_23__enums__["e" /* Capability */].AR_NEXT_GEN!==capability){_this13.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_OptionsActions__["o" /* fetchCycles */])());}_this13.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_OptionsActions__["n" /* fetchCapabilityCallSuccess */])(capabilityResponse));});case 11:case'end':return _context.stop();}}},_callee,this,[[0,7]]);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.timer);}}]);return HeatMap;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{capability:state.optionsReducer.capability,navigationOptions:state.optionsReducer.navigationOptions,selectedCycle:state.optionsReducer.options.cycle,selectedView:state.optionsReducer.heatMapView,selectedCycleId:state.optionsReducer.options.cycleId,featureStatus:state.configReducer.featureStatus,isInitialView:state.optionsReducer.isInitialView};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(HeatMap)));

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ErrorPage__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_TableCellUtil__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RefreshTimer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cluster=function(_Component){_inherits(Cluster,_Component);function Cluster(props){_classCallCheck(this,Cluster);var _this=_possibleConstructorReturn(this,(Cluster.__proto__||Object.getPrototypeOf(Cluster)).call(this,props));_this.getCombinedMetricsMap=function(cluster){var _this$props=_this.props,stowPackageMetricsMap=_this$props.stowPackageMetricsMap,inductPackageMetricsMap=_this$props.inductPackageMetricsMap,stowAssociateMetricsMap=_this$props.stowAssociateMetricsMap,stowBinMetricsMap=_this$props.stowBinMetricsMap,stowCartMetricsMap=_this$props.stowCartMetricsMap;var defaultMetricValue="-";return{cluster:cluster,binsMissingBag:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(stowBinMetricsMap,cluster,"binsMissingBag"),unopenedCarts:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(stowCartMetricsMap,cluster,"missingCarts"),plannedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].plannedPackages;},defaultMetricValue),receivedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return inductPackageMetricsMap[cluster].receivedPackages;},defaultMetricValue),currentInductedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].currentInductedPackages;},defaultMetricValue),stowedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].stowedPackages;},defaultMetricValue),stowVsPlan:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].stowVsPlan;},defaultMetricValue),problemSolvePackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].problemSolvePackages;},defaultMetricValue),stowRate:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].stowRate;},defaultMetricValue),scanCompliance:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].scanCompliance;},defaultMetricValue),currentStowBufferedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].currentStowBufferedPackages;},defaultMetricValue),currentMFRJackpotBufferedPackages:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowPackageMetricsMap[cluster].currentMFRJackpotBufferedPackages;},defaultMetricValue),activeStowers:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowAssociateMetricsMap[cluster].activeStowers;},defaultMetricValue),inactiveStowers:Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return stowAssociateMetricsMap[cluster].inactiveStowers;},defaultMetricValue)};};_this.clusterRowClicked=function(clickedCluster){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActions__["q" /* navigationAdded */])({key:'Cluster',value:clickedCluster}));};_this.renderTotalPackageCount=function(value,state){var params={PACKAGE_STATUS:state};return value!==0&&value!=='-'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_link___default.a,{href:_this.getPackageListURL(params),type:"secondary"}," ",value," "):value;};_this.getADTATableCell=function(value,aisle,state){return _this.isADTAVisibilityEnabled()&&Object(__WEBPACK_IMPORTED_MODULE_14__utils_TableCellUtil__["a" /* getTableCellCount */])(_this.renderPackageCount(value,aisle,state));};_this.renderPackageCount=function(value,cluster,state){var params={PACKAGE_STATUS:state,CLUSTER:cluster};return value!==0&&value!=='-'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_link___default.a,{href:_this.getPackageListURL(params),type:"secondary"}," ",value," "):value;};_this.getPackageListURL=function(params){var options=_this.props.options;if(options.cycle){params["CYCLE"]=options.cycle;}return"#packageList/?"+Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["e" /* formQueryParams */])(params);};_this.isADTAVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_16__constants__["j" /* FEATURES */].ADTA_VISIBILITY];};_this.isDRSStowVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_16__constants__["j" /* FEATURES */].DRS_STOW_VISIBILITY];};_this.isCartVisibilityEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_16__constants__["j" /* FEATURES */].CART_VISIBILITY];};_this.state={sortColumn:"cluster",sortDirection:"ascending"};return _this;}_createClass(Cluster,[{key:"render",value:function render(){var _this2=this;var _props=this.props,loading=_props.loading,error=_props.error,stowPackageMetricsMap=_props.stowPackageMetricsMap,inductPackageMetricsMap=_props.inductPackageMetricsMap,stowAssociateMetricsMap=_props.stowAssociateMetricsMap,stowBinMetricsMap=_props.stowBinMetricsMap,stowCartMetricsMap=_props.stowCartMetricsMap;if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__utils_ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});}var allClusters=[].concat(_toConsumableArray(Object.keys(stowPackageMetricsMap)),_toConsumableArray(Object.keys(inductPackageMetricsMap)),_toConsumableArray(Object.keys(stowAssociateMetricsMap)),_toConsumableArray(Object.keys(stowBinMetricsMap)),_toConsumableArray(Object.keys(stowCartMetricsMap)));var distinctClusters=[].concat(_toConsumableArray(new Set(allClusters)));if(loading&&!distinctClusters.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,{height:"400px",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_loader___default.a,null));}var filteredClusters=Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["k" /* getFilteredLocations */])(distinctClusters,stowPackageMetricsMap,this.isDRSStowVisibilityEnabled());var onSort=function onSort(sortDetails){_this2.setState({sortColumn:sortDetails.sortColumn,sortDirection:sortDetails.sortDirection});};var sortColumn=this.state.sortColumn;var direction=this.state.sortDirection;filteredClusters.sort(function(c1,c2){var c1CombinedMetricsMap=_this2.getCombinedMetricsMap(c1);var c2CombinedMetricsMap=_this2.getCombinedMetricsMap(c2);if(c1CombinedMetricsMap[sortColumn]<c2CombinedMetricsMap[sortColumn]){return direction==="ascending"?-1:1;}if(c1CombinedMetricsMap[sortColumn]>c2CombinedMetricsMap[sortColumn]){return direction==="ascending"?1:-1;}return 0;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__RefreshTimer__["a" /* default */],{deps:[stowPackageMetricsMap]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table___default.a,{headerRows:2,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true,sortColumn:this.state.sortColumn,sortDirection:this.state.sortDirection,onSort:onSort,"data-cy":"clusterTable"},this.renderHeadings(),this.renderSubHeadings(),filteredClusters.map(function(cluster){return _this2.renderClusterRow(cluster);}),filteredClusters.length?this.renderTotalClusterRow():null));}},{key:"renderHeadings",value:function renderHeadings(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.packages",defaultMessage:"Packages"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),this.isADTAVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),this.isADTAVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.performance",defaultMessage:"Performance"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.stowers",defaultMessage:"Stowers"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null));}},{key:"renderSubHeadings",value:function renderSubHeadings(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"cluster"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.cluster",defaultMessage:"Cluster"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"plannedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.container_planned",defaultMessage:"C. Planned"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"receivedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.arrived",defaultMessage:"Arrived"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"currentInductedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.inducted",defaultMessage:"Inducted"})),this.isADTAVisibilityEnabled()&&Object(__WEBPACK_IMPORTED_MODULE_14__utils_TableCellUtil__["b" /* getTableCellHeader */])("currentStowBufferedPackages"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.stowed",defaultMessage:"Stowed"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowVsPlan",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.stow_plan",defaultMessage:"Stow/Plan"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"problemSolvePackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.ps",defaultMessage:"PS"})),this.isADTAVisibilityEnabled()&&Object(__WEBPACK_IMPORTED_MODULE_14__utils_TableCellUtil__["b" /* getTableCellHeader */])("currentMFRJackpotBufferedPackages"),this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"missingCarts",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.cartsMissing",defaultMessage:"Unopened Carts"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"binsMissingBag",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.missing",defaultMessage:"Missing"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowRate",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.stow_rate",defaultMessage:"Stow rate"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"scanCompliance",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.scan_complaince",defaultMessage:"Scan comp."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"activeStowers",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.active",defaultMessage:"Active"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{sortColumn:"inactiveStowers",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cluster.inactive",defaultMessage:"Inactive"})));}},{key:"renderClusterRow",value:function renderClusterRow(cluster){var _this3=this;var combinedMetricsMap=this.getCombinedMetricsMap(cluster);var stowBufferedCell=this.getADTATableCell(combinedMetricsMap.currentStowBufferedPackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_STOW_BUFFERED);var mfrJackpotBufferedCell=this.getADTATableCell(combinedMetricsMap.currentMFRJackpotBufferedPackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_MFR_JACKPOT_BUFFERED);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row___default.a,{highlightOnHover:true,key:cluster,onClick:function onClick(){return _this3.clusterRowClicked(cluster);},"data-cy":"clusterDataRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null,cluster),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.plannedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.receivedPackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_RECEIVED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.currentInductedPackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_INDUCTED)),stowBufferedCell,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.stowedPackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].STOWED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.stowVsPlan,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderPackageCount(combinedMetricsMap.problemSolvePackages,cluster,__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].PROBLEM_SOLVE)),mfrJackpotBufferedCell,this.isCartVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.unopenedCarts),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.binsMissingBag),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.stowRate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.scanCompliance,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.activeStowers),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},combinedMetricsMap.inactiveStowers));}},{key:"renderTotalClusterRow",value:function renderTotalClusterRow(){var _props2=this.props,totalStowPackageMetrics=_props2.totalStowPackageMetrics,totalInductPackageMetrics=_props2.totalInductPackageMetrics,totalStowAssociateMetrics=_props2.totalStowAssociateMetrics,totalStowBinMetrics=_props2.totalStowBinMetrics,totalStowCartMetricsMap=_props2.totalStowCartMetricsMap;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table_table_row___default.a,{"data-cy":"clusterTotalRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,null,"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","plannedPackages")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderTotalPackageCount(Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(totalInductPackageMetrics,"Total","receivedPackages"),__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_RECEIVED)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderTotalPackageCount(Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","currentInductedPackages"),__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_INDUCTED)),this.renderStowBufferedTotalCount(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","stowedPackages")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","stowVsPlan"),"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderTotalPackageCount(Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","problemSolvePackages"),__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].PROBLEM_SOLVE)),this.renderMFRJackpotBufferedTotalCount(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(totalStowCartMetricsMap,"Total","missingCarts")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(totalStowBinMetrics,"Total","binsMissingBag")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","stowRate")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(totalStowPackageMetrics,"Total","scanCompliance"),"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(totalStowAssociateMetrics,"Total","activeStowers")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(totalStowAssociateMetrics,"Total","inactiveStowers")));}},{key:"renderStowBufferedTotalCount",value:function renderStowBufferedTotalCount(){if(this.isADTAVisibilityEnabled()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderTotalPackageCount(Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(this.props.totalStowPackageMetrics,"Total","currentStowBufferedPackages"),__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_STOW_BUFFERED));}}},{key:"renderMFRJackpotBufferedTotalCount",value:function renderMFRJackpotBufferedTotalCount(){if(this.isADTAVisibilityEnabled()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},this.renderTotalPackageCount(Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["o" /* getOrDefaultValueForCell */])(this.props.totalStowPackageMetrics,"Total","currentMFRJackpotBufferedPackages"),__WEBPACK_IMPORTED_MODULE_13__enums__["n" /* PackageStatus */].CURRENT_MFR_JACKPOT_BUFFERED));}}}]);return Cluster;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{loading:state.clusterReducer.loading,error:state.clusterReducer.error,options:state.optionsReducer.options,stowPackageMetricsMap:state.clusterReducer.stowPackageMetricsMap,stowBinMetricsMap:state.clusterReducer.stowBinMetricsMap,stowCartMetricsMap:state.clusterReducer.stowCartMetricsMap,inductPackageMetricsMap:state.clusterReducer.inductPackageMetricsMap,stowAssociateMetricsMap:state.clusterReducer.stowAssociateMetricsMap,totalStowPackageMetrics:state.clusterReducer.totalStowPackageMetrics,totalStowBinMetrics:state.clusterReducer.totalStowBinMetrics,totalStowCartMetricsMap:state.clusterReducer.totalStowCartMetricsMap,totalInductPackageMetrics:state.clusterReducer.totalInductPackageMetrics,totalStowAssociateMetrics:state.clusterReducer.totalStowAssociateMetrics,featureStatus:state.configReducer.featureStatus};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Cluster)));

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(63));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _uniqueId = _interopRequireDefault(__webpack_require__(51));

var _uniq = _interopRequireDefault(__webpack_require__(655));

var _includes = _interopRequireDefault(__webpack_require__(266));

var _controlGroup = _interopRequireDefault(__webpack_require__(657));

var _theme = __webpack_require__(14);

var _token = __webpack_require__(12);

var _fieldsetReset = _interopRequireDefault(__webpack_require__(285));

var _text = _interopRequireDefault(__webpack_require__(27));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = function styles(t) {
  return (0, _emotion.css)(_fieldsetReset["default"], {
    display: "flex",
    flexDirection: "column",
    // Don't stretch children - otherwise you may end up with a lot of
    // clickable whitespace in the label if the control group is wider than the
    // label.
    alignItems: "flex-start",
    "& > * + *": {
      marginTop: t("spacingVertical")
    }
  });
};

var labelStyles = function labelStyles(t, _ref) {
  var disabled = _ref.disabled,
      clickable = _ref.clickable;
  return (0, _emotion.css)((0, _text["default"])(t, {
    color: disabled ? "disabled" : "default"
  }), {
    cursor: clickable ? disabled ? "not-allowed" : "pointer" : "default"
  });
};

var ControlGroup = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ControlGroup, _React$Component);

  var _super = _createSuper(ControlGroup);

  function ControlGroup() {
    var _this;

    (0, _classCallCheck2["default"])(this, ControlGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", (0, _uniqueId["default"])("control-group-"));
    return _this;
  }

  (0, _createClass2["default"])(ControlGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          label = _this$props.label,
          value = _this$props.value,
          name = _this$props.name,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, ["data-", "aria-"]);
      var valueIsArray = Array.isArray(value) ? true : false;

      var renderChildren = _react["default"].Children.map(children, function (child) {
        return child ? /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread({
          checked: valueIsArray ? (0, _includes["default"])(value, child.props.value) : child.props.value === value,
          onChange: valueIsArray ? function (checked) {
            return onChange(checked ? (0, _uniq["default"])([].concat((0, _toConsumableArray2["default"])(value), [child.props.value])) : value.filter(function (v) {
              return v !== child.props.value;
            }));
          } : onChange,
          disabled: disabled,
          name: name
        }, child.props)) : null;
      });

      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _controlGroup["default"],
        map: (0, _token.getTokenHelper)("controlGroup")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("fieldset", (0, _extends2["default"])({}, passThroughProps, {
          className: styles(t)
        }), label ? /*#__PURE__*/_react["default"].createElement("legend", {
          className: labelStyles(t, {
            disabled: disabled
          })
        }, label) : null, renderChildren);
      });
    }
  }]);
  return ControlGroup;
}(_react["default"].Component);

ControlGroup.propTypes =  false ? {
  /**
   * All children must be elements of the same type (e.g. all Checkbox
   * elements or all RadioButton elements). Any element that supports `value`,
   * `onChange`, `checked`, `disabled`, and `name` props may be used.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with all the components in the control group
   * and applies special visual styles to indicate that they are not
   * interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * The label for the control group.
   */
  label: _propTypes["default"].string,

  /**
   * The name of the form control for each component contained in the group.
   * If the group is placed in a form, this will be the name associated with
   * the group's controls when the form is submitted.
   *
   * Any names set explicitly on individual components in the group will
   * override this property.
   */
  name: _propTypes["default"].string,

  /**
   * The current value of the group.
   *
   * Match this with the value(s) of controls options within the group to mark
   * those controls as checked.
   *
   * If this is an array then the group will allow multiple controls to be
   * checked (e.g. a group of checkboxes). If this is a single value then the
   * group will only allow one control to be checked (e.g. a group of radio
   * buttons).
   *
   * Note that this prop is not required, but if you do not use it you must
   * use the `checked` props on the individual controls within the group.
   */
  value: _propTypes["default"].any,

  /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by clicking on a control in the group). The new
   * value will be passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   *
   * Note that this prop is not required, but if you do not use it you must
   * use the `onChange` props on the individual controls within the group.
   */
  onChange: _propTypes["default"].func
} : {};
var _default = ControlGroup;
exports["default"] = _default;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(282);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(231),
    noop = __webpack_require__(37),
    setToArray = __webpack_require__(146);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 657 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    controlGroupForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    controlGroupForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    controlGroupFontSize: 16,
    controlGroupFontWeight: 600,
    controlGroupLineHeight: "20px",
    controlGroupSpacingVertical: 8
  }
};

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(48));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _keycode = _interopRequireDefault(__webpack_require__(47));

var _radioButton = _interopRequireDefault(__webpack_require__(659));

var _theme = __webpack_require__(14);

var _useFocus2 = _interopRequireDefault(__webpack_require__(40));

var _token = __webpack_require__(12);

var _focusRing = _interopRequireDefault(__webpack_require__(43));

var _text = _interopRequireDefault(__webpack_require__(27));

var _visuallyHidden = _interopRequireDefault(__webpack_require__(58));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

var _cardContext = _interopRequireDefault(__webpack_require__(220));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Root styles for the entire component. This makes it a block-level component
// without stretching the clickable-area beyond the visible label
var containerStyles = (0, _emotion.css)({
  // NOTE: Use "flex" instead of "block" to acheive block-level display while
  // fixing the min-height issue in IE11:
  // https://stackoverflow.com/questions/44700068/flexbox-min-height-and-ie11
  display: "flex",
  fontSize: 0
});
var labelStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var disabled = _ref.disabled;
  var textStyleObject = (0, _text["default"])(t);
  return (0, _emotion.css)(textStyleObject, {
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "center",
    position: "relative",
    color: t("foregroundColor", disabled ? "disabled" : "default"),
    cursor: disabled ? "not-allowed" : "pointer",
    userSelect: "none",
    minHeight: textStyleObject.lineHeight
  });
}, ["disabled"]); // Styles for the radio button (a psuedo-element) that's actually displayed to
// users

var visibleRadioButtonStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var _css;

  var checked = _ref2.checked,
      disabled = _ref2.disabled,
      focus = _ref2.focus,
      size = _ref2.size,
      hover = _ref2.hover,
      hoverDisabled = _ref2.hoverDisabled;
  var modifier = checked ? "selected" : "unselected";
  var state = disabled ? "disabled" : "default";
  var borderRadius = t("borderRadius");
  var borderWidth = t("borderWidth");
  return (0, _emotion.css)(hover && !hoverDisabled && !disabled ? {
    "* > &": !disabled && !hoverDisabled ? {
      backgroundColor: t("backgroundColor", [modifier, "hover"]),
      borderColor: t("borderColor", [modifier, "hover"]),
      "::before": {
        backgroundColor: t("indicatorColor", [modifier, "hover"])
      }
    } : undefined
  } : undefined, (_css = {
    position: "relative",
    boxSizing: "border-box",
    flexShrink: 0,
    transition: t.transitionCss("motion", "background-color"),
    borderRadius: borderRadius,
    borderWidth: borderWidth,
    borderStyle: "solid",
    borderColor: t("borderColor", [modifier, state]),
    backgroundColor: t("backgroundColor", [modifier, state]),
    width: t("diameter", size),
    height: t("diameter", size),
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   marginInlineStart: t("spacingHorizontal"),
    // },
    marginRight: t("spacingHorizontal")
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    marginLeft: t("spacingHorizontal"),
    marginRight: 0
  }), (0, _defineProperty2["default"])(_css, "::before", {
    content: "''",
    display: "block",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translateY(-50%) translateX(-50%)",
    borderRadius: borderRadius,
    width: t("indicatorDiameter", size),
    height: t("indicatorDiameter", size),
    transition: t.transitionCss("motion", "background-color"),
    backgroundColor: t("indicatorColor", [modifier, state])
  }), (0, _defineProperty2["default"])(_css, "*:hover > &", !disabled && !hoverDisabled ? {
    backgroundColor: t("backgroundColor", [modifier, "hover"]),
    borderColor: t("borderColor", [modifier, "hover"]),
    "::before": {
      backgroundColor: t("indicatorColor", [modifier, "hover"])
    }
  } : undefined), (0, _defineProperty2["default"])(_css, "*:active > &", !disabled && {
    backgroundColor: t("backgroundColor", [modifier, "pressed"]),
    borderColor: t("borderColor", [modifier, "pressed"]),
    "::before": {
      backgroundColor: t("indicatorColor", [modifier, "pressed"])
    }
  }), _css), !disabled ? (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    borderRadius: borderRadius,
    borderWidth: borderWidth,
    dropShadow: true,
    offset: 4,
    hoverSelector: "*:hover > &"
  }) : undefined);
}, ["checked", "disabled", "focus", "size", "hoverDisabled", "hover"]); // Styles for the actual HTML radio input element that is hidden from the user

var hiddenRadioButtonStyles = (0, _emotion.css)(_visuallyHidden["default"]);

var RadioButton = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var checked = props.checked,
      value = props.value,
      onChange = props.onChange;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      hoverDisabled = _useState2[0],
      setHoverDisabled = _useState2[1];

  var t = (0, _theme.useTheme)(_radioButton["default"], "radioButton");
  var context = (0, _react.useContext)(_cardContext["default"]);
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  var onChangeInput = (0, _react.useCallback)(function () {
    if (onChange) onChange(value);
    setHoverDisabled(true);
  }, [onChange, setHoverDisabled, value]);
  var onKeyDown = (0, _react.useCallback)(function (event) {
    // HACK: If the radio button is already checked and the user hits the
    // spacebar, cancel the event. This prevents a bug in Chrome & Safari where
    // pressing spacebar on a checked radio button will cause the active state
    // of the radio button to stick, even after the radio has been unchecked.
    if (checked && (0, _keycode["default"])(event) === "space") {
      event.preventDefault();
    }
  }, [checked]);
  var onMouseEnter = (0, _react.useCallback)(function () {
    return setHoverDisabled(false);
  }, []);

  var _useFocus = (0, _useFocus2["default"])({
    onFocus: function onFocus(event) {
      if (props.onFocus) props.onFocus(event);
    },
    onBlur: function onBlur(event) {
      if (props.onBlur) props.onBlur(event);
    }
  }),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: containerStyles
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: labelStyles(t, props),
    onMouseEnter: onMouseEnter,
    onKeyDown: onKeyDown
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, passThroughProps, focusProps, {
    id: props.id,
    className: hiddenRadioButtonStyles,
    type: "radio",
    name: props.name,
    value: value,
    "aria-checked": Boolean(checked),
    checked: // Cast `checked` to a boolean so that a value of `undefined`
    // doesn't flip the input into React's "uncontrolled" mode.
    Boolean(checked),
    disabled: props.disabled,
    tabIndex: props.tabIndex,
    onChange: onChangeInput,
    ref: ref
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: visibleRadioButtonStyles(t, {
      checked: checked,
      disabled: props.disabled,
      hover: context.hover,
      focus: focus && focusTrigger === "keyboard",
      size: props.size,
      hoverDisabled: hoverDisabled
    })
  }), /*#__PURE__*/_react["default"].createElement("div", null, props.children)));
});

RadioButton.displayName = "RadioButton";
RadioButton.propTypes =  false ? {
  /**
   * All props prefixed with `aria-` except `aria-checked` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * The checked state of the component. Use this in conjunction with the
   * `onChange` prop to make the component interactive.
   */
  checked: _propTypes["default"].bool,

  /**
   * The component's label. Plain text is recommended. This will be displayed
   * next to the form control, and will trigger a state change when clicked. If
   * you're using a Radio button without a visible label, be sure to assign a
   * label using `aria-label`.
   */
  children: _propTypes["default"].node,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["medium", "large"]),

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The value of the underlying input element. This is used to populate the
   * form data when submitting a form. To change the on/off status of the
   * component use the `checked` prop.
   */
  value: _propTypes["default"].any,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * A function that will be called when the user attempts to change the
   * component (e.g. by clicking on it). The `value` prop will be passed as the
   * only argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the checked state provided to this function somewhere in
   * your state and pass it back via the `checked` prop in order to make this
   * component interactive.
   *
   * Note that this is *not* called when the user selects another radio button
   * in the same group. In that case it's up to you to set the `checked` prop of
   * this component to `false`.
   */
  onChange: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func
} : {};
RadioButton.defaultProps = {
  size: "medium"
};
var _default = RadioButton;
exports["default"] = _default;

/***/ }),
/* 659 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    radioButtonMotionDuration: "100ms",
    radioButtonMotionFunction: "ease",
    radioButtonForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    radioButtonForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    radioButtonBackgroundColorSelectedDefault: tokens.themeForegroundAccentDefault,
    radioButtonBackgroundColorSelectedHover: tokens.themeForegroundAccentHover,
    radioButtonBackgroundColorSelectedPressed: tokens.themeForegroundAccentPressed,
    radioButtonBackgroundColorSelectedDisabled: tokens.themeForegroundAccentDisabled,
    radioButtonBackgroundColorUnselectedDefault: tokens.themeBackgroundPrimaryDefault,
    radioButtonBackgroundColorUnselectedHover: tokens.themeForegroundAccentHover,
    radioButtonBackgroundColorUnselectedPressed: tokens.themeForegroundAccentPressed,
    radioButtonBackgroundColorUnselectedDisabled: tokens.themeBackgroundPrimaryDisabled,
    radioButtonBorderWidth: 1,
    radioButtonBorderRadius: 999,
    radioButtonBorderColorSelectedDefault: "rgba(0, 0, 0, 0)",
    radioButtonBorderColorSelectedDisabled: tokens.themeBorderPrimaryDisabled,
    radioButtonBorderColorUnselectedDefault: tokens.themeBorderPrimaryDefault,
    radioButtonBorderColorUnselectedHover: "rgba(0, 0, 0, 0)",
    radioButtonBorderColorUnselectedPressed: "rgba(0, 0, 0, 0)",
    radioButtonBorderColorUnselectedDisabled: tokens.themeBorderPrimaryDisabled,
    radioButtonIndicatorDiameterMedium: 8,
    radioButtonIndicatorDiameterLarge: 10,
    radioButtonIndicatorColorSelectedDefault: tokens.themeBackgroundPrimaryDefault,
    radioButtonIndicatorColorUnselectedDefault: tokens.themeBackgroundPrimaryDefault,
    radioButtonIndicatorColorUnselectedHover: tokens.themeForegroundAccentDefault,
    radioButtonIndicatorColorUnselectedPressed: tokens.themeBackgroundPrimaryDefault,
    radioButtonIndicatorColorUnselectedDisabled: tokens.themeBackgroundPrimaryDisabled,
    radioButtonDiameterMedium: 20,
    radioButtonDiameterLarge: 24,
    radioButtonSpacingHorizontal: 12
  }
};

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_control_group__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_control_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_control_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_radio_button__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_radio_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_radio_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeatMapViewOptions=function(_Component){_inherits(HeatMapViewOptions,_Component);function HeatMapViewOptions(){_classCallCheck(this,HeatMapViewOptions);return _possibleConstructorReturn(this,(HeatMapViewOptions.__proto__||Object.getPrototypeOf(HeatMapViewOptions)).apply(this,arguments));}_createClass(HeatMapViewOptions,[{key:"render",value:function render(){var _this2=this;var selectedView=this.props.selectedView;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_control_group___default.a,{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"heatMapViewOptions.view",defaultMessage:"View"}),onChange:function onChange(updatedView){return _this2.handleViewChange(updatedView);},value:selectedView},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_radio_button___default.a,{value:__WEBPACK_IMPORTED_MODULE_7__enums__["q" /* ViewType */].DEFAULT_VIEW,"data-cy":"heatMapFieldsetOption"},this.renderDefaultOption()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_radio_button___default.a,{value:__WEBPACK_IMPORTED_MODULE_7__enums__["q" /* ViewType */].ROUTE_VIEW,"data-cy":"heatMapFieldsetOption"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"heatMapViewOptions.routeView",defaultMessage:"Route"})),this.isSidelineVisibilityEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_radio_button___default.a,{value:__WEBPACK_IMPORTED_MODULE_7__enums__["q" /* ViewType */].SIDELINE_VIEW,"data-cy":"heatMapFieldsetOption"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"heatMapViewOptions.sidelineView",defaultMessage:"Sideline"})));}},{key:"handleViewChange",value:function handleViewChange(updatedView){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_OptionsActions__["v" /* viewChanged */])(updatedView));}},{key:"renderDefaultOption",value:function renderDefaultOption(){var capability=this.props.capability;switch(capability){case __WEBPACK_IMPORTED_MODULE_7__enums__["e" /* Capability */].AR_NEXT_GEN:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"heatMapViewOptions.stationPairView",defaultMessage:"Station"});case __WEBPACK_IMPORTED_MODULE_7__enums__["e" /* Capability */].SSD:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"heatMapViewOptions.zone",defaultMessage:"Zone"});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"heatMapViewOptions.clusterView",defaultMessage:"Cluster"});}}},{key:"isSidelineVisibilityEnabled",value:function isSidelineVisibilityEnabled(){return this.props.capability===__WEBPACK_IMPORTED_MODULE_7__enums__["e" /* Capability */].AMZL&&this.props.featureStatus&&this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_8__constants__["j" /* FEATURES */].SIDELINE_STOW_VISIBILITY];}}]);return HeatMapViewOptions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{capability:state.optionsReducer.capability,selectedView:state.optionsReducer.heatMapView,featureStatus:state.configReducer.featureStatus};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(HeatMapViewOptions)));

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_AssociateActions__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Options__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__options_AssociateStatusOptions__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__options_ClusterOptions__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_OptionsActionsV2__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__options_AisleOptions__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AssociateTable__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_PageHeader__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_ConfigActions__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__options_FilterOptionsV2__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_context_DeviceLayoutContext__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__AssociateScanChartView__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__associate_context_AssociateScanContext__ = __webpack_require__(185);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Associate=function(_Component){_inherits(Associate,_Component);function Associate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Associate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Associate.__proto__||Object.getPrototypeOf(Associate)).call.apply(_ref,[this].concat(args))),_this),_this.getStowAssociates=function(nodeId,selectedCycle,CPTId,filterIdentifier,isCPTFilterEnabled,isEmptyCycleAllowedEnabled){var capability=_this.props.capability;if(capability&&__WEBPACK_IMPORTED_MODULE_15__enums__["e" /* Capability */].AR_NEXT_GEN===capability){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_AssociateActions__["d" /* getStowAssociatesForAssociateView */])(nodeId,[],[],filterIdentifier,isCPTFilterEnabled));}else if(isEmptyCycleAllowedEnabled){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_AssociateActions__["d" /* getStowAssociatesForAssociateView */])(nodeId,[selectedCycle],[CPTId],filterIdentifier,isCPTFilterEnabled));}else if(selectedCycle||CPTId){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_AssociateActions__["d" /* getStowAssociatesForAssociateView */])(nodeId,[selectedCycle],[CPTId],filterIdentifier,isCPTFilterEnabled));}},_this.isCPTFilterEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_14__constants__["j" /* FEATURES */].IS_CPT_FILTER_ENABLED];},_this.isEmptyCycleAllowedEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_14__constants__["j" /* FEATURES */].IS_EMPTY_CYCLE_ALLOWED_ENABLED];},_this.isAssociateScanMetricsEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_14__constants__["j" /* FEATURES */].IS_ASSOCIATE_SCAN_METRIC_ENABLED];},_this.getApplicableOptions=function(){switch(_this.props.capability){case __WEBPACK_IMPORTED_MODULE_15__enums__["e" /* Capability */].SSD:case __WEBPACK_IMPORTED_MODULE_15__enums__["e" /* Capability */].AMZL:return _this.getApplicableOptionsForAmzl();case __WEBPACK_IMPORTED_MODULE_15__enums__["e" /* Capability */].AR_NEXT_GEN:return _this.getApplicableOptionsForArNextGen();default:return[];}},_this.getApplicableOptionsForAmzl=function(){return[{component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__options_FilterOptionsV2__["a" /* default */],null),name:"FilterOptionsV2"},{component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__options_AssociateStatusOptions__["a" /* default */],null),name:"AssociateStatusOptions"},{component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__options_ClusterOptions__["a" /* default */],null),name:"ClusterOptions"},{component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__options_AisleOptions__["a" /* default */],null),name:"AisleOptions"}];},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Associate,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var nodeId=Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["m" /* getNodeId */])();this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_OptionsActions__["m" /* fetchCapability */])());this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_OptionsActions__["p" /* fetchFilters */])(nodeId));Object(__WEBPACK_IMPORTED_MODULE_16__handler_ParentDataHandler__["e" /* getFeaturesFromParent */])([__WEBPACK_IMPORTED_MODULE_14__constants__["j" /* FEATURES */].IS_CPT_FILTER_ENABLED,__WEBPACK_IMPORTED_MODULE_14__constants__["j" /* FEATURES */].IS_EMPTY_CYCLE_ALLOWED_ENABLED,__WEBPACK_IMPORTED_MODULE_14__constants__["j" /* FEATURES */].IS_ASSOCIATE_SCAN_METRIC_ENABLED]).then(function(featureStatusResponse){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_ConfigActions__["b" /* fetchFeatureStatusCallSuccess */])(featureStatusResponse.data));});if(this.props.featureStatus&&this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_14__constants__["j" /* FEATURES */].IS_CPT_FILTER_ENABLED]){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_OptionsActionsV2__["r" /* fetchCPTList */])());}else this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_OptionsActions__["o" /* fetchCycles */])());}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.timer);}},{key:"render",value:function render(){var _props=this.props,selectedCycle=_props.selectedCycle,CPTId=_props.CPTId,filterIdentifier=_props.filterIdentifier,spacingInset_shorthand6=_props.spacingInset_shorthand6;this.fetchAssociates(selectedCycle,CPTId,filterIdentifier,this.isCPTFilterEnabled(),this.isEmptyCycleAllowedEnabled());var options=this.getApplicableOptions();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,{spacingInset:spacingInset_shorthand6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__utils_PageHeader__["a" /* PageHeader */],__WEBPACK_IMPORTED_MODULE_14__constants__["n" /* HEADERS */].ASSOCIATE),this.isAssociateScanMetricsEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__associate_context_AssociateScanContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__AssociateScanChartView__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Options__["a" /* default */],{options:options,optionsTagsRequired:__WEBPACK_IMPORTED_MODULE_14__constants__["r" /* OPTIONS_TAG_REQUIRED */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__AssociateTable__["a" /* default */],null));}},{key:"fetchAssociates",value:function fetchAssociates(selectedCycle,CPTId,filterIdentifier,isCPTFilterEnabled,isEmptyCycleAllowedEnabled){var _this3=this;clearInterval(this.timer);var nodeId=Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["m" /* getNodeId */])();this.getStowAssociates(nodeId,selectedCycle,CPTId,filterIdentifier,isCPTFilterEnabled,isEmptyCycleAllowedEnabled);this.timer=setInterval(function(){if(!document.hidden){_this3.getStowAssociates(nodeId,selectedCycle,CPTId,filterIdentifier,isCPTFilterEnabled,isEmptyCycleAllowedEnabled);}},__WEBPACK_IMPORTED_MODULE_14__constants__["z" /* refreshInterval */]);}},{key:"getApplicableOptionsForArNextGen",value:function getApplicableOptionsForArNextGen(){return[{component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__options_AssociateStatusOptions__["a" /* default */],null),name:"AssociateStatusOptions"}];}}]);return Associate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// Adapter to convert class component to functional component.
function classToFunctionAdapter(CustomComponent){return function WrappedComponent(props){var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_19__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),spacingInset_shorthand6=_useDeviceLayout.spacingInset_shorthand6;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomComponent,Object.assign({},props,{spacingInset_shorthand6:spacingInset_shorthand6}));};}var mapStateToProps=function mapStateToProps(state){return{capability:state.optionsReducerV2.capability,selectedCycle:state.optionsReducerV2.options.cycle,filterIdentifier:state.optionsReducerV2.filterIdentifier,CPTId:state.optionsReducerV2.options.CPTId,featureStatus:state.configReducer.featureStatus};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(classToFunctionAdapter(Associate))));

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_control_group__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_control_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_control_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AssociateStatusOptions=function(_Component){_inherits(AssociateStatusOptions,_Component);function AssociateStatusOptions(){_classCallCheck(this,AssociateStatusOptions);return _possibleConstructorReturn(this,(AssociateStatusOptions.__proto__||Object.getPrototypeOf(AssociateStatusOptions)).apply(this,arguments));}_createClass(AssociateStatusOptions,[{key:"render",value:function render(){var _this2=this;var selectedStatuses=this.props.selectedStatuses;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_control_group___default.a,{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"associateStatusOption.active",defaultMessage:"Active"}),onChange:function onChange(updatedStatuses){return _this2.handleStatusesChange(updatedStatuses);},value:selectedStatuses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox___default.a,{"data-cy":"associateStatusFieldsetOption",key:"Yes",value:"Yes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"associateStatusOptions.yes",defaultMessage:"Yes"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox___default.a,{"data-cy":"associateStatusFieldsetOption",key:"No",value:"No"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"associateStatusOption.no",defaultMessage:"No"})));}},{key:"handleStatusesChange",value:function handleStatusesChange(updatedStatuses){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_OptionsActions__["u" /* optionsAddedOrChanged */])({'associateStatuses':updatedStatuses}));}}]);return AssociateStatusOptions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{selectedStatuses:state.optionsReducer.options.associateStatuses};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(AssociateStatusOptions)));

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_control_group__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_control_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_control_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClusterOptions=function(_Component){_inherits(ClusterOptions,_Component);function ClusterOptions(){_classCallCheck(this,ClusterOptions);return _possibleConstructorReturn(this,(ClusterOptions.__proto__||Object.getPrototypeOf(ClusterOptions)).apply(this,arguments));}_createClass(ClusterOptions,[{key:"render",value:function render(){var _this2=this;var _props=this.props,allClusters=_props.allClusters,selectedClusters=_props.selectedClusters;var _getTextDetails=this.getTextDetails(),textId=_getTextDetails.textId,defaultMessage=_getTextDetails.defaultMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_control_group___default.a,{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:textId,defaultMessage:defaultMessage}),onChange:function onChange(updatedClusters){return _this2.handleClustersChange(updatedClusters);},value:selectedClusters},allClusters.sort().map(function(cluster){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox___default.a,{key:cluster,value:cluster,"data-cy":"clusterFieldsetOption"},cluster);}));}},{key:"getTextDetails",value:function getTextDetails(){if(__WEBPACK_IMPORTED_MODULE_7__enums__["e" /* Capability */].SSD===this.props.capability){return{textId:"zoneOptions.zone",defaultMessage:"Zone"};}return{textId:"clusterOptions.cluster",defaultMessage:"Cluster"};}},{key:"handleClustersChange",value:function handleClustersChange(updatedClusters){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_OptionsActions__["u" /* optionsAddedOrChanged */])({'clusters':updatedClusters}));}}]);return ClusterOptions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{selectedClusters:state.optionsReducer.options.clusters,allClusters:state.optionsReducer.allClusters,capability:state.optionsReducer.capability};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ClusterOptions)));

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select_select_option__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select_select_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select_select_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__handler_LocaleHandler__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__enums__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AisleOptions=function(_Component){_inherits(AisleOptions,_Component);function AisleOptions(){_classCallCheck(this,AisleOptions);return _possibleConstructorReturn(this,(AisleOptions.__proto__||Object.getPrototypeOf(AisleOptions)).apply(this,arguments));}_createClass(AisleOptions,[{key:"render",value:function render(){var _this2=this;var _props=this.props,clusterAislesMap=_props.clusterAislesMap,selectedClusters=_props.selectedClusters,allAisles=_props.allAisles,selectedAisle=_props.selectedAisle;var _getTextDetails=this.getTextDetails(),textId=_getTextDetails.textId,defaultMessage=_getTextDetails.defaultMessage;function getAislesToDisplay(){if(selectedClusters&&selectedClusters.length){var _displayAisles=[];selectedClusters.forEach(function(selectedCluster){return _displayAisles.push.apply(_displayAisles,_toConsumableArray(clusterAislesMap[selectedCluster]));});return _displayAisles.sort(function(a1,a2){return a1.localeCompare(a2,Object(__WEBPACK_IMPORTED_MODULE_9__handler_LocaleHandler__["b" /* getLocale */])(),{numeric:true});});}else{return allAisles.sort(function(a1,a2){return a1.localeCompare(a2,Object(__WEBPACK_IMPORTED_MODULE_9__handler_LocaleHandler__["b" /* getLocale */])(),{numeric:true});});}}var displayAisles=getAislesToDisplay();var getSelectedAisle=function getSelectedAisle(){if(displayAisles.includes(selectedAisle)){return selectedAisle;}else{_this2.handleAisleChange("");return"";}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,{type:"h100",alignment:"left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:textId,defaultMessage:defaultMessage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select___default.a,{onChange:function onChange(clickedAisle){return _this2.handleAisleChange(selectedAisle,clickedAisle);},value:getSelectedAisle(),size:"small",placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:textId,defaultMessage:defaultMessage}),width:150},displayAisles&&displayAisles.map(function(aisle){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select_select_option___default.a,{label:aisle,value:aisle,"data-cy":"aisleFieldsetOption"});})));}},{key:"getTextDetails",value:function getTextDetails(){if(__WEBPACK_IMPORTED_MODULE_10__enums__["e" /* Capability */].SSD===this.props.capability){return{textId:"floorOptions.cartLocation",defaultMessage:"Cart Location"};}return{textId:"aisleOptions.aisle",defaultMessage:"Aisle"};}},{key:"handleAisleChange",value:function handleAisleChange(selectedAisle,clickedAisle){var updatedAisle=selectedAisle===clickedAisle?"":clickedAisle;this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_OptionsActions__["u" /* optionsAddedOrChanged */])({'aisle':updatedAisle}));}}]);return AisleOptions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{selectedAisle:state.optionsReducer.options.aisle,selectedClusters:state.optionsReducer.options.clusters,allAisles:state.optionsReducer.allAisles,clusterAislesMap:state.optionsReducer.clusterAislesMap,capability:state.optionsReducer.capability};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(AisleOptions)));

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__handler_LocaleHandler__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RefreshTimer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AssociateTable=function(_Component){_inherits(AssociateTable,_Component);function AssociateTable(props){_classCallCheck(this,AssociateTable);var _this=_possibleConstructorReturn(this,(AssociateTable.__proto__||Object.getPrototypeOf(AssociateTable)).call(this,props));_this.isAssociateScanMetricsEnabled=function(){return _this.props.featureStatus&&_this.props.featureStatus[__WEBPACK_IMPORTED_MODULE_13__constants__["j" /* FEATURES */].IS_ASSOCIATE_SCAN_METRIC_ENABLED];};_this.state={sortColumn:"name",sortDirection:"ascending",baseURL:""};return _this;}_createClass(AssociateTable,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_9__handler_ParentDataHandler__["d" /* getDocumentURL */])().then(function(value){_this2.setState({baseURL:value});});}},{key:"render",value:function render(){var _this3=this;var _props=this.props,associatesList=_props.associatesList,selectedStatuses=_props.selectedStatuses,selectedAisle=_props.selectedAisle,selectedClusters=_props.selectedClusters;var onSort=function onSort(sortDetails){_this3.setState({sortColumn:sortDetails.sortColumn,sortDirection:sortDetails.sortDirection});};var filteredAssociatesList=associatesList?associatesList.filter(function(associate){var doesStatusMatch=!selectedStatuses.length||selectedStatuses.includes(associate.active);var doesClusterMatch=!selectedClusters.length||selectedClusters.includes(associate.cluster);var doesAisleMatch=!selectedAisle||selectedAisle===associate.location;return doesAisleMatch&&doesClusterMatch&&doesStatusMatch;}):[];filteredAssociatesList&&filteredAssociatesList.sort(function(a,b){var fieldA=a[_this3.state.sortColumn];var fieldB=b[_this3.state.sortColumn];if(_this3.state.sortDirection==="ascending"){return Object(__WEBPACK_IMPORTED_MODULE_7__Utility__["b" /* convertToString */])(fieldA).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_7__Utility__["b" /* convertToString */])(fieldB),Object(__WEBPACK_IMPORTED_MODULE_10__handler_LocaleHandler__["b" /* getLocale */])(),{numeric:true});}else{return Object(__WEBPACK_IMPORTED_MODULE_7__Utility__["b" /* convertToString */])(fieldB).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_7__Utility__["b" /* convertToString */])(fieldA),Object(__WEBPACK_IMPORTED_MODULE_10__handler_LocaleHandler__["b" /* getLocale */])(),{numeric:true});}});var getAssociateLink=function getAssociateLink(loginId){var searchURL=new URL(_this3.state.baseURL.replace('associatesort','search'));var startDate=new Date();startDate.setHours(0,0,0,0);var endDate=new Date();endDate.setDate(startDate.getDate()+1);endDate.setHours(0,0,0,0);var optionsObj={"type":"ASSOCIATE","startDate":startDate.getTime(),"endDate":endDate.getTime()};var shareableLink="/detailPage/"+loginId+'/'+JSON.stringify(optionsObj);searchURL.searchParams.set("shareableLink",shareableLink);return searchURL.href;};var renderAlias=function renderAlias(loginId){var alias=Object(__WEBPACK_IMPORTED_MODULE_7__Utility__["f" /* getAliasFromLoginId */])(loginId);try{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_link___default.a,{href:getAssociateLink(loginId),type:"secondary",target:"_blank"},alias);}catch(e){return alias;}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RefreshTimer__["a" /* default */],{deps:[associatesList]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{overflowX:"auto",width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table___default.a,{headerRows:1,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true,headerColumns:1,stickyHeaderColumn:true,sortColumn:this.state.sortColumn,sortDirection:this.state.sortDirection,onSort:onSort,"data-cy":"associateTable"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{sortColumn:"name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"associate.associate",defaultMessage:"Associate"})),!this.isAssociateScanMetricsEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{sortColumn:"pph",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"associate.pph",defaultMessage:"PPH"})),!this.isAssociateScanMetricsEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{sortColumn:"minutesWorked",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"associate.hours",defaultMessage:"Hours"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"associate.total_pkgs",defaultMessage:"Total Pkgs"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{sortColumn:"fsaf",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"associate.fsaf",defaultMessage:"FSAF"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{sortColumn:"fsafDpmo",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"associate.fsaf_dpmo",defaultMessage:"FSAF DPMO"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{sortColumn:"active"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"associate.active",defaultMessage:"Active"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{sortColumn:"location"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"associate.lastLocation",defaultMessage:"Last Location"}))),filteredAssociatesList&&filteredAssociatesList.map(function(associate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table_table_row___default.a,{key:associate.alias,"data-cy":"associateDataRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null,renderAlias(associate.alias)),!_this3.isAssociateScanMetricsEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},associate.pph),!_this3.isAssociateScanMetricsEnabled()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},getFormattedHoursFromMinutes(associate.minutesWorked)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},associate.stowedPackages+associate.stowedBufferedPackages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},associate.fsaf),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},associate.fsafDpmo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null,associate.active),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_cell___default.a,null,associate.location));}))));function getFormattedHoursFromMinutes(minutesWorked){var hoursWorked=Object(__WEBPACK_IMPORTED_MODULE_7__Utility__["v" /* makeNumberTwoDigit */])(Math.floor(minutesWorked/60));var remainingMinutes=Object(__WEBPACK_IMPORTED_MODULE_7__Utility__["v" /* makeNumberTwoDigit */])(minutesWorked%60);return hoursWorked+':'+remainingMinutes;}}}]);return AssociateTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{associatesList:state.associateReducer.associatesList,selectedStatuses:state.optionsReducer.options.associateStatuses,selectedClusters:state.optionsReducer.options.clusters,selectedAisle:state.optionsReducer.options.aisle,featureStatus:state.configReducer.featureStatus};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(AssociateTable)));

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_control_group__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_control_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_control_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_radio_button__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_radio_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_radio_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AssociateScanChart__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context_AssociateScanContext__ = __webpack_require__(185);
var AssociateScanChartView=function AssociateScanChartView(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__context_AssociateScanContext__["a" /* AssociateScanContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var handleAssociateChange=function handleAssociateChange(selectedAssociates){dispatch({type:"SET_SELECTED_ASSOCIATES",data:{selectedAssociates:selectedAssociates}});};var handleGranularityChange=function handleGranularityChange(granularity){dispatch({type:"SET_GRANULARITY",data:{granularity:granularity}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{widths:["grid-3","grid-9"],spacingInset:"medium large"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacingInset:"none none medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Associates"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{overflow:"auto",maxHeight:viewModel.associateList.length>4?"125px":"auto"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_control_group___default.a,{name:"associates",onChange:handleAssociateChange,value:viewModel.chartData.selectedAssociates},viewModel.associateList.map(function(associate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox___default.a,{key:associate.key,value:associate.key},associate.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacingInset:"medium none none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Time Granularity"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_control_group___default.a,{name:"granularity",onChange:handleGranularityChange,value:viewModel.chartData.granularity},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_radio_button___default.a,{value:"15m"},"15 Minutes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_radio_button___default.a,{value:"30m"},"30 Minutes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_radio_button___default.a,{value:"1h"},"1 Hour"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_radio_button___default.a,{value:"cumulative"},"Cumulative")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"354px",position:"relative"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AssociateScanChart__["a" /* default */],null))));};/* harmony default export */ __webpack_exports__["a"] = (AssociateScanChartView);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_chartjs_2__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_chartjs_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_chartjs_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AssociateScanContext__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(5);
var AssociateScanChart=function AssociateScanChart(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_AssociateScanContext__["a" /* AssociateScanContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var getData=function getData(){dispatch({type:'LOAD_DATA',data:{dispatcher:dispatch}});};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},__WEBPACK_IMPORTED_MODULE_3__constants__["z" /* refreshInterval */]);return function(){return clearInterval(interval);};},[]);var getChartData=function getChartData(){var scanMetrics=viewModel.scanMetrics,chartData=viewModel.chartData;var selectedAssociates=chartData.selectedAssociates,granularity=chartData.granularity;if(!scanMetrics||!scanMetrics[granularity]||Object.keys(scanMetrics[granularity]).length===0){return{labels:[],datasets:[]};}var granularityData=scanMetrics[granularity];// Always get time labels from any available associate's data
var availableAssociates=Object.keys(granularityData);var labels=availableAssociates.length>0&&granularityData[availableAssociates[0]]&&Array.isArray(granularityData[availableAssociates[0]])?granularityData[availableAssociates[0]].map(function(item){return new Date(item.timeStampVal).toTimeString().split(" ")[0].split(":")[0]+":"+new Date(item.timeStampVal).toTimeString().split(" ")[0].split(":")[1];}):[];// Create datasets only for selected associates
var datasets=selectedAssociates.map(function(email,index){var associateData=granularityData[email];if(!associateData||!Array.isArray(associateData))return null;return{label:email.replace('@amazon.com',''),data:associateData.map(function(item){return item.metricValue||0;}),borderColor:generateColor(index),fill:false};}).filter(Boolean);return{labels:labels,datasets:datasets};};// Generate unlimited colors using HSL color space
var generateColor=function generateColor(index){var hue=index*137.508%360;// Golden angle approximation for good color distribution
var saturation=70+index%3*10;// Vary saturation slightly
var lightness=45+index%4*5;// Vary lightness slightly
return"hsl("+hue+", "+saturation+"%, "+lightness+"%)";};var chartOptions={maintainAspectRatio:false,legend:{display:true,position:'bottom'},scales:{xAxes:[{gridLines:{drawOnChartArea:false}}],yAxes:[{gridLines:{drawOnChartArea:false},ticks:{autoSkip:true,maxTicksLimit:5}}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_chartjs_2__["Line"],{data:getChartData(),options:chartOptions});};/* harmony default export */ __webpack_exports__["a"] = (AssociateScanChart);

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Chart", {
  enumerable: true,
  get: function get() {
    return _chart["default"];
  }
});
exports.defaults = exports.Scatter = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(78));

var _chart = _interopRequireDefault(__webpack_require__(669));

var _isEqual = _interopRequireDefault(__webpack_require__(671));

var _keyBy = _interopRequireDefault(__webpack_require__(733));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NODE_ENV = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":""}) && "production";

var ChartComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(ChartComponent, _React$Component);

  var _super = _createSuper(ChartComponent);

  function ChartComponent() {
    var _this;

    _classCallCheck(this, ChartComponent);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
      var instance = _this.chartInstance;
      var _this$props = _this.props,
          getDatasetAtEvent = _this$props.getDatasetAtEvent,
          getElementAtEvent = _this$props.getElementAtEvent,
          getElementsAtEvent = _this$props.getElementsAtEvent,
          onElementsClick = _this$props.onElementsClick;
      getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
      getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
      getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
      onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (element) {
      _this.element = element;
    });

    _this.chartInstance = undefined;
    return _this;
  }

  _createClass(ChartComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderChart();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.redraw) {
        this.destroyChart();
        this.renderChart();
        return;
      }

      this.updateChart();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props2 = this.props,
          redraw = _this$props2.redraw,
          type = _this$props2.type,
          options = _this$props2.options,
          plugins = _this$props2.plugins,
          legend = _this$props2.legend,
          height = _this$props2.height,
          width = _this$props2.width;

      if (nextProps.redraw === true) {
        return true;
      }

      if (height !== nextProps.height || width !== nextProps.width) {
        return true;
      }

      if (type !== nextProps.type) {
        return true;
      }

      if (!(0, _isEqual["default"])(legend, nextProps.legend)) {
        return true;
      }

      if (!(0, _isEqual["default"])(options, nextProps.options)) {
        return true;
      }

      var nextData = this.transformDataProp(nextProps);

      if (!(0, _isEqual["default"])(this.shadowDataProp, nextData)) {
        return true;
      }

      return !(0, _isEqual["default"])(plugins, nextProps.plugins);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyChart();
    }
  }, {
    key: "transformDataProp",
    value: function transformDataProp(props) {
      var data = props.data;

      if (typeof data == 'function') {
        var node = this.element;
        return data(node);
      } else {
        return data;
      }
    } // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
    // this makes impossible to compare the current and next data changes
    // therefore we memoize the data prop while sending a fake to Chart.js for mutation.
    // see https://github.com/chartjs/Chart.js/blob/master/src/core/core.controller.js#L615-L617

  }, {
    key: "memoizeDataProps",
    value: function memoizeDataProps() {
      if (!this.props.data) {
        return;
      }

      var data = this.transformDataProp(this.props);
      this.shadowDataProp = _objectSpread(_objectSpread({}, data), {}, {
        datasets: data.datasets && data.datasets.map(function (set) {
          return _objectSpread({}, set);
        })
      });
      this.saveCurrentDatasets(); // to remove the dataset metadata from this chart when the chart is destroyed

      return data;
    }
  }, {
    key: "checkDatasets",
    value: function checkDatasets(datasets) {
      var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
      var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
      var multipleDatasets = datasets.length > 1;

      if (isDev && multipleDatasets && !usingCustomKeyProvider) {
        var shouldWarn = false;
        datasets.forEach(function (dataset) {
          if (!dataset.label) {
            shouldWarn = true;
          }
        });

        if (shouldWarn) {
          console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
        }
      }
    }
  }, {
    key: "getCurrentDatasets",
    value: function getCurrentDatasets() {
      return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
    }
  }, {
    key: "saveCurrentDatasets",
    value: function saveCurrentDatasets() {
      var _this2 = this;

      this.datasets = this.datasets || {};
      var currentDatasets = this.getCurrentDatasets();
      currentDatasets.forEach(function (d) {
        _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
      });
    }
  }, {
    key: "updateChart",
    value: function updateChart() {
      var _this3 = this;

      var options = this.props.options;
      var data = this.memoizeDataProps(this.props);
      if (!this.chartInstance) return;

      if (options) {
        this.chartInstance.options = _chart["default"].helpers.configMerge(this.chartInstance.options, options);
      } // Pipe datasets to chart instance datasets enabling
      // seamless transitions


      var currentDatasets = this.getCurrentDatasets();
      var nextDatasets = data.datasets || [];
      this.checkDatasets(currentDatasets);
      var currentDatasetsIndexed = (0, _keyBy["default"])(currentDatasets, this.props.datasetKeyProvider); // We can safely replace the dataset array, as long as we retain the _meta property
      // on each dataset.

      this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
        var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];

        if (current && current.type === next.type && next.data) {
          // Be robust to no data. Relevant for other update mechanisms as in chartjs-plugin-streaming.
          // The data array must be edited in place. As chart.js adds listeners to it.
          current.data.splice(next.data.length);
          next.data.forEach(function (point, pid) {
            current.data[pid] = next.data[pid];
          });

          var _data = next.data,
              otherProps = _objectWithoutProperties(next, ["data"]); // Merge properties. Notice a weakness here. If a property is removed
          // from next, it will be retained by current and never disappears.
          // Workaround is to set value to null or undefined in next.


          return _objectSpread(_objectSpread({}, current), otherProps);
        } else {
          return next;
        }
      });

      var datasets = data.datasets,
          rest = _objectWithoutProperties(data, ["datasets"]);

      this.chartInstance.config.data = _objectSpread(_objectSpread({}, this.chartInstance.config.data), rest);
      this.chartInstance.update();
    }
  }, {
    key: "renderChart",
    value: function renderChart() {
      var _this$props3 = this.props,
          options = _this$props3.options,
          legend = _this$props3.legend,
          type = _this$props3.type,
          plugins = _this$props3.plugins;
      var node = this.element;
      var data = this.memoizeDataProps();

      if (typeof legend !== 'undefined' && !(0, _isEqual["default"])(ChartComponent.defaultProps.legend, legend)) {
        options.legend = legend;
      }

      this.chartInstance = new _chart["default"](node, {
        type: type,
        data: data,
        options: options,
        plugins: plugins
      });
    }
  }, {
    key: "destroyChart",
    value: function destroyChart() {
      if (!this.chartInstance) {
        return;
      } // Put all of the datasets that have existed in the chart back on the chart
      // so that the metadata associated with this chart get destroyed.
      // This allows the datasets to be used in another chart. This can happen,
      // for example, in a tabbed UI where the chart gets created each time the
      // tab gets switched to the chart and uses the same data).


      this.saveCurrentDatasets();
      var datasets = Object.values(this.datasets);
      this.chartInstance.config.data.datasets = datasets;
      this.chartInstance.destroy();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          height = _this$props4.height,
          width = _this$props4.width,
          id = _this$props4.id;
      return /*#__PURE__*/_react["default"].createElement("canvas", {
        ref: this.ref,
        height: height,
        width: width,
        id: id,
        onClick: this.handleOnClick
      });
    }
  }]);

  return ChartComponent;
}(_react["default"].Component);

_defineProperty(ChartComponent, "getLabelAsKey", function (d) {
  return d.label;
});

_defineProperty(ChartComponent, "propTypes", {
  data: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired,
  getDatasetAtEvent: _propTypes["default"].func,
  getElementAtEvent: _propTypes["default"].func,
  getElementsAtEvent: _propTypes["default"].func,
  height: _propTypes["default"].number,
  legend: _propTypes["default"].object,
  onElementsClick: _propTypes["default"].func,
  options: _propTypes["default"].object,
  plugins: _propTypes["default"].arrayOf(_propTypes["default"].object),
  redraw: _propTypes["default"].bool,
  type: function type(props, propName, componentName) {
    if (!_chart["default"].controllers[props[propName]]) {
      return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
    }
  },
  width: _propTypes["default"].number,
  datasetKeyProvider: _propTypes["default"].func
});

_defineProperty(ChartComponent, "defaultProps", {
  legend: {
    display: true,
    position: 'bottom'
  },
  type: 'doughnut',
  height: 150,
  width: 300,
  redraw: false,
  options: {},
  datasetKeyProvider: ChartComponent.getLabelAsKey
});

var _default = ChartComponent;
exports["default"] = _default;

var Doughnut = /*#__PURE__*/function (_React$Component2) {
  _inherits(Doughnut, _React$Component2);

  var _super2 = _createSuper(Doughnut);

  function Doughnut() {
    _classCallCheck(this, Doughnut);

    return _super2.apply(this, arguments);
  }

  _createClass(Doughnut, [{
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref) {
          return _this4.chartInstance = _ref && _ref.chartInstance;
        },
        type: "doughnut"
      }));
    }
  }]);

  return Doughnut;
}(_react["default"].Component);

exports.Doughnut = Doughnut;

var Pie = /*#__PURE__*/function (_React$Component3) {
  _inherits(Pie, _React$Component3);

  var _super3 = _createSuper(Pie);

  function Pie() {
    _classCallCheck(this, Pie);

    return _super3.apply(this, arguments);
  }

  _createClass(Pie, [{
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref2) {
          return _this5.chartInstance = _ref2 && _ref2.chartInstance;
        },
        type: "pie"
      }));
    }
  }]);

  return Pie;
}(_react["default"].Component);

exports.Pie = Pie;

var Line = /*#__PURE__*/function (_React$Component4) {
  _inherits(Line, _React$Component4);

  var _super4 = _createSuper(Line);

  function Line() {
    _classCallCheck(this, Line);

    return _super4.apply(this, arguments);
  }

  _createClass(Line, [{
    key: "render",
    value: function render() {
      var _this6 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref3) {
          return _this6.chartInstance = _ref3 && _ref3.chartInstance;
        },
        type: "line"
      }));
    }
  }]);

  return Line;
}(_react["default"].Component);

exports.Line = Line;

var Bar = /*#__PURE__*/function (_React$Component5) {
  _inherits(Bar, _React$Component5);

  var _super5 = _createSuper(Bar);

  function Bar() {
    _classCallCheck(this, Bar);

    return _super5.apply(this, arguments);
  }

  _createClass(Bar, [{
    key: "render",
    value: function render() {
      var _this7 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref4) {
          return _this7.chartInstance = _ref4 && _ref4.chartInstance;
        },
        type: "bar"
      }));
    }
  }]);

  return Bar;
}(_react["default"].Component);

exports.Bar = Bar;

var HorizontalBar = /*#__PURE__*/function (_React$Component6) {
  _inherits(HorizontalBar, _React$Component6);

  var _super6 = _createSuper(HorizontalBar);

  function HorizontalBar() {
    _classCallCheck(this, HorizontalBar);

    return _super6.apply(this, arguments);
  }

  _createClass(HorizontalBar, [{
    key: "render",
    value: function render() {
      var _this8 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref5) {
          return _this8.chartInstance = _ref5 && _ref5.chartInstance;
        },
        type: "horizontalBar"
      }));
    }
  }]);

  return HorizontalBar;
}(_react["default"].Component);

exports.HorizontalBar = HorizontalBar;

var Radar = /*#__PURE__*/function (_React$Component7) {
  _inherits(Radar, _React$Component7);

  var _super7 = _createSuper(Radar);

  function Radar() {
    _classCallCheck(this, Radar);

    return _super7.apply(this, arguments);
  }

  _createClass(Radar, [{
    key: "render",
    value: function render() {
      var _this9 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref6) {
          return _this9.chartInstance = _ref6 && _ref6.chartInstance;
        },
        type: "radar"
      }));
    }
  }]);

  return Radar;
}(_react["default"].Component);

exports.Radar = Radar;

var Polar = /*#__PURE__*/function (_React$Component8) {
  _inherits(Polar, _React$Component8);

  var _super8 = _createSuper(Polar);

  function Polar() {
    _classCallCheck(this, Polar);

    return _super8.apply(this, arguments);
  }

  _createClass(Polar, [{
    key: "render",
    value: function render() {
      var _this10 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref7) {
          return _this10.chartInstance = _ref7 && _ref7.chartInstance;
        },
        type: "polarArea"
      }));
    }
  }]);

  return Polar;
}(_react["default"].Component);

exports.Polar = Polar;

var Bubble = /*#__PURE__*/function (_React$Component9) {
  _inherits(Bubble, _React$Component9);

  var _super9 = _createSuper(Bubble);

  function Bubble() {
    _classCallCheck(this, Bubble);

    return _super9.apply(this, arguments);
  }

  _createClass(Bubble, [{
    key: "render",
    value: function render() {
      var _this11 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref8) {
          return _this11.chartInstance = _ref8 && _ref8.chartInstance;
        },
        type: "bubble"
      }));
    }
  }]);

  return Bubble;
}(_react["default"].Component);

exports.Bubble = Bubble;

var Scatter = /*#__PURE__*/function (_React$Component10) {
  _inherits(Scatter, _React$Component10);

  var _super10 = _createSuper(Scatter);

  function Scatter() {
    _classCallCheck(this, Scatter);

    return _super10.apply(this, arguments);
  }

  _createClass(Scatter, [{
    key: "render",
    value: function render() {
      var _this12 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref9) {
          return _this12.chartInstance = _ref9 && _ref9.chartInstance;
        },
        type: "scatter"
      }));
    }
  }]);

  return Scatter;
}(_react["default"].Component);

exports.Scatter = Scatter;
var defaults = _chart["default"].defaults;
exports.defaults = defaults;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(249)))

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */
(function (global, factory) {
 true ? module.exports = factory(function() { try { return __webpack_require__(670); } catch(e) { } }()) :
typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
(global = global || self, global.Chart = factory(global.moment));
}(this, (function (moment) { 'use strict';

moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

var conversions = createCommonjsModule(function (module) {
/* MIT license */


// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in colorName) {
	if (colorName.hasOwnProperty(key)) {
		reverseKeywords[colorName[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in colorName) {
		if (colorName.hasOwnProperty(keyword)) {
			var value = colorName[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return colorName[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};
});
var conversions_1 = conversions.rgb;
var conversions_2 = conversions.hsl;
var conversions_3 = conversions.hsv;
var conversions_4 = conversions.hwb;
var conversions_5 = conversions.cmyk;
var conversions_6 = conversions.xyz;
var conversions_7 = conversions.lab;
var conversions_8 = conversions.lch;
var conversions_9 = conversions.hex;
var conversions_10 = conversions.keyword;
var conversions_11 = conversions.ansi16;
var conversions_12 = conversions.ansi256;
var conversions_13 = conversions.hcg;
var conversions_14 = conversions.apple;
var conversions_15 = conversions.gray;

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

var route = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

var colorConvert = convert;

var colorName$1 = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/* MIT license */


var colorString = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
};

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr),
       hexAlpha = "";
   if (match) {
      match = match[1];
      hexAlpha = match[3];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(hex)) {
      hexAlpha = match[2];
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorName$1[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgba, a) {
   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
   return "#" + hexDouble(rgba[0]) 
              + hexDouble(rgba[1])
              + hexDouble(rgba[2])
              + (
                 (a >= 0 && a < 1)
                 ? hexDouble(Math.round(a * 255))
                 : ""
              );
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorName$1) {
   reverseNames[colorName$1[name]] = name;
}

/* MIT license */



var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = colorString.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = colorString.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = colorString.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return colorString.hexString(this.values.rgb);
	},
	rgbString: function () {
		return colorString.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return colorString.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return colorString.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return colorString.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return colorString.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return colorString.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return colorString.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = colorConvert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

var chartjsColor = Color;

function isValidKey(key) {
	return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
}

/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */
	isArray: function(value) {
		if (Array.isArray && Array.isArray(value)) {
			return true;
		}
		var type = Object.prototype.toString.call(value);
		if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
			return true;
		}
		return false;
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */
	isFinite: function(value) {
		return (typeof value === 'number' || value instanceof Number) && isFinite(value);
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = Object.create(source);
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		if (!isValidKey(key)) {
			// We want to ensure we do not copy prototypes over
			// as this can pollute global namespaces
			return;
		}

		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		if (!isValidKey(key)) {
			// We want to ensure we do not copy prototypes over
			// as this can pollute global namespaces
			return;
		}

		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */
	extend: Object.assign || function(target) {
		return helpers.merge(target, [].slice.call(arguments, 1), {
			merger: function(key, dst, src) {
				dst[key] = src[key];
			}
		});
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	},

	_deprecated: function(scope, value, previous, current) {
		if (value !== undefined) {
			console.warn(scope + ': "' + previous +
				'" is deprecated. Please use "' + current + '" instead');
		}
	}
};

var helpers_core = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

var helpers_easing = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.easingEffects = effects;

var PI = Math.PI;
var RAD_PER_DEG = PI / 180;
var DOUBLE_PI = PI * 2;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;

/**
 * @namespace Chart.helpers.canvas
 */
var exports$1 = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var r = Math.min(radius, height / 2, width / 2);
			var left = x + r;
			var top = y + r;
			var right = x + width - r;
			var bottom = y + height - r;

			ctx.moveTo(x, top);
			if (left < right && top < bottom) {
				ctx.arc(left, top, r, -PI, -HALF_PI);
				ctx.arc(right, top, r, -HALF_PI, 0);
				ctx.arc(right, bottom, r, 0, HALF_PI);
				ctx.arc(left, bottom, r, HALF_PI, PI);
			} else if (left < right) {
				ctx.moveTo(left, y);
				ctx.arc(right, top, r, -HALF_PI, HALF_PI);
				ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
			} else if (top < bottom) {
				ctx.arc(left, top, r, -PI, 0);
				ctx.arc(left, bottom, r, 0, PI);
			} else {
				ctx.arc(left, top, r, -PI, PI);
			}
			ctx.closePath();
			ctx.moveTo(x, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y, rotation) {
		var type, xOffset, yOffset, size, cornerRadius;
		var rad = (rotation || 0) * RAD_PER_DEG;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.save();
				ctx.translate(x, y);
				ctx.rotate(rad);
				ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
				ctx.restore();
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		ctx.beginPath();

		switch (style) {
		// Default includes circle
		default:
			ctx.arc(x, y, radius, 0, DOUBLE_PI);
			ctx.closePath();
			break;
		case 'triangle':
			ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			ctx.closePath();
			break;
		case 'rectRounded':
			// NOTE: the rounded rect implementation changed to use `arc` instead of
			// `quadraticCurveTo` since it generates better results when rect is
			// almost a circle. 0.516 (instead of 0.5) produces results with visually
			// closer proportion to the previous impl and it is inscribed in the
			// circle with `radius`. For more details, see the following PRs:
			// https://github.com/chartjs/Chart.js/issues/5597
			// https://github.com/chartjs/Chart.js/issues/5858
			cornerRadius = radius * 0.516;
			size = radius - cornerRadius;
			xOffset = Math.cos(rad + QUARTER_PI) * size;
			yOffset = Math.sin(rad + QUARTER_PI) * size;
			ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
			ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
			ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
			ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
			ctx.closePath();
			break;
		case 'rect':
			if (!rotation) {
				size = Math.SQRT1_2 * radius;
				ctx.rect(x - size, y - size, 2 * size, 2 * size);
				break;
			}
			rad += QUARTER_PI;
			/* falls through */
		case 'rectRot':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + yOffset, y - xOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			ctx.closePath();
			break;
		case 'crossRot':
			rad += QUARTER_PI;
			/* falls through */
		case 'cross':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'star':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			rad += QUARTER_PI;
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'line':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			break;
		case 'dash':
			ctx.moveTo(x, y);
			ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
			break;
		}

		ctx.fill();
		ctx.stroke();
	},

	/**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */
	_isPointInArea: function(point, area) {
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.

		return point.x > area.left - epsilon && point.x < area.right + epsilon &&
			point.y > area.top - epsilon && point.y < area.bottom + epsilon;
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		var stepped = target.steppedLine;
		if (stepped) {
			if (stepped === 'middle') {
				var midpoint = (previous.x + target.x) / 2.0;
				ctx.lineTo(midpoint, flip ? target.y : previous.y);
				ctx.lineTo(midpoint, flip ? previous.y : target.y);
			} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

var helpers_canvas = exports$1;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.clear = exports$1.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports$1.roundedRect.apply(exports$1, arguments);
};

var defaults = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers_core.merge(this[scope] || (this[scope] = {}), values);
	}
};

// TODO(v3): remove 'global' from namespace.  all default are global and
// there's inconsistency around which options are under 'global'
defaults._set('global', {
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	defaultLineHeight: 1.2,
	showLines: true
});

var core_defaults = defaults;

var valueOrDefault = helpers_core.valueOrDefault;

/**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */
function toFontString(font) {
	if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
		return null;
	}

	return (font.style ? font.style + ' ' : '')
		+ (font.weight ? font.weight + ' ' : '')
		+ font.size + 'px '
		+ font.family;
}

/**
 * @alias Chart.helpers.options
 * @namespace
 */
var helpers_options = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers_core.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */
	_parseFont: function(options) {
		var globalDefaults = core_defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var font = {
			family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
			lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
			size: size,
			style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
			weight: null,
			string: ''
		};

		font.string = toFontString(font);
		return font;
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index, info) {
		var cacheable = true;
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
				cacheable = false;
			}
			if (index !== undefined && helpers_core.isArray(value)) {
				value = value[index];
				cacheable = false;
			}
			if (value !== undefined) {
				if (info && !cacheable) {
					info.cacheable = false;
				}
				return value;
			}
		}
	}
};

/**
 * @alias Chart.helpers.math
 * @namespace
 */
var exports$2 = {
	/**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */
	_factorize: function(value) {
		var result = [];
		var sqrt = Math.sqrt(value);
		var i;

		for (i = 1; i < sqrt; i++) {
			if (value % i === 0) {
				result.push(i);
				result.push(value / i);
			}
		}
		if (sqrt === (sqrt | 0)) { // if value is a square number
			result.push(sqrt);
		}

		result.sort(function(a, b) {
			return a - b;
		}).pop();
		return result;
	},

	log10: Math.log10 || function(x) {
		var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
		// Check for whole powers of 10,
		// which due to floating point rounding error should be corrected.
		var powerOf10 = Math.round(exponent);
		var isPowerOf10 = x === Math.pow(10, powerOf10);

		return isPowerOf10 ? powerOf10 : exponent;
	}
};

var helpers_math = exports$2;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */
helpers_core.log10 = exports$2.log10;

var getRtlAdapter = function(rectX, width) {
	return {
		x: function(x) {
			return rectX + rectX + width - x;
		},
		setWidth: function(w) {
			width = w;
		},
		textAlign: function(align) {
			if (align === 'center') {
				return align;
			}
			return align === 'right' ? 'left' : 'right';
		},
		xPlus: function(x, value) {
			return x - value;
		},
		leftForLtr: function(x, itemWidth) {
			return x - itemWidth;
		},
	};
};

var getLtrAdapter = function() {
	return {
		x: function(x) {
			return x;
		},
		setWidth: function(w) { // eslint-disable-line no-unused-vars
		},
		textAlign: function(align) {
			return align;
		},
		xPlus: function(x, value) {
			return x + value;
		},
		leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
			return x;
		},
	};
};

var getAdapter = function(rtl, rectX, width) {
	return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
};

var overrideTextDirection = function(ctx, direction) {
	var style, original;
	if (direction === 'ltr' || direction === 'rtl') {
		style = ctx.canvas.style;
		original = [
			style.getPropertyValue('direction'),
			style.getPropertyPriority('direction'),
		];

		style.setProperty('direction', direction, 'important');
		ctx.prevTextDirection = original;
	}
};

var restoreTextDirection = function(ctx) {
	var original = ctx.prevTextDirection;
	if (original !== undefined) {
		delete ctx.prevTextDirection;
		ctx.canvas.style.setProperty('direction', original[0], original[1]);
	}
};

var helpers_rtl = {
	getRtlAdapter: getAdapter,
	overrideTextDirection: overrideTextDirection,
	restoreTextDirection: restoreTextDirection,
};

var helpers$1 = helpers_core;
var easing = helpers_easing;
var canvas = helpers_canvas;
var options = helpers_options;
var math = helpers_math;
var rtl = helpers_rtl;
helpers$1.easing = easing;
helpers$1.canvas = canvas;
helpers$1.options = options;
helpers$1.math = math;
helpers$1.rtl = rtl;

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = chartjsColor(origin);
				if (c0.valid) {
					c1 = chartjsColor(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers$1.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers$1.extend(Element.prototype, {
	_type: undefined,

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers$1.extend({}, me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = helpers$1.extend({}, model);
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
	}
});

Element.extend = helpers$1.inherits;

var core_element = Element;

var exports$3 = core_element.extend({
	chart: null, // the animation associated chart instance
	currentStep: 0, // the current animation step
	numSteps: 60, // default number of steps
	easing: '', // the easing to use for this animation
	render: null, // render function used by the animation service

	onAnimationProgress: null, // user specified callback to fire on each step of the animation
	onAnimationComplete: null, // user specified callback to fire when the animation finishes
});

var core_animation = exports$3;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'animationObject', {
	get: function() {
		return this;
	}
});

/**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'chartInstance', {
	get: function() {
		return this.chart;
	},
	set: function(value) {
		this.chart = value;
	}
});

core_defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers$1.noop,
		onComplete: helpers$1.noop
	}
});

var core_animations = {
	animations: [],
	request: null,

	/**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */
	addAnimation: function(chart, animation, duration, lazy) {
		var animations = this.animations;
		var i, ilen;

		animation.chart = chart;
		animation.startTime = Date.now();
		animation.duration = duration;

		if (!lazy) {
			chart.animating = true;
		}

		for (i = 0, ilen = animations.length; i < ilen; ++i) {
			if (animations[i].chart === chart) {
				animations[i] = animation;
				return;
			}
		}

		animations.push(animation);

		// If there are no animations queued, manually kickstart a digest, for lack of a better word
		if (animations.length === 1) {
			this.requestAnimationFrame();
		}
	},

	cancelAnimation: function(chart) {
		var index = helpers$1.findIndex(this.animations, function(animation) {
			return animation.chart === chart;
		});

		if (index !== -1) {
			this.animations.splice(index, 1);
			chart.animating = false;
		}
	},

	requestAnimationFrame: function() {
		var me = this;
		if (me.request === null) {
			// Skip animation frame requests until the active one is executed.
			// This can happen when processing mouse events, e.g. 'mousemove'
			// and 'mouseout' events will trigger multiple renders.
			me.request = helpers$1.requestAnimFrame.call(window, function() {
				me.request = null;
				me.startDigest();
			});
		}
	},

	/**
	 * @private
	 */
	startDigest: function() {
		var me = this;

		me.advance();

		// Do we have more stuff to animate?
		if (me.animations.length > 0) {
			me.requestAnimationFrame();
		}
	},

	/**
	 * @private
	 */
	advance: function() {
		var animations = this.animations;
		var animation, chart, numSteps, nextStep;
		var i = 0;

		// 1 animation per chart, so we are looping charts here
		while (i < animations.length) {
			animation = animations[i];
			chart = animation.chart;
			numSteps = animation.numSteps;

			// Make sure that currentStep starts at 1
			// https://github.com/chartjs/Chart.js/issues/6104
			nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
			animation.currentStep = Math.min(nextStep, numSteps);

			helpers$1.callback(animation.render, [chart, animation], chart);
			helpers$1.callback(animation.onAnimationProgress, [animation], chart);

			if (animation.currentStep >= numSteps) {
				helpers$1.callback(animation.onAnimationComplete, [animation], chart);
				chart.animating = false;
				animations.splice(i, 1);
			} else {
				++i;
			}
		}
	}
};

var resolve = helpers$1.options.resolve;

var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

/**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */
function listenArrayEvents(array, listener) {
	if (array._chartjs) {
		array._chartjs.listeners.push(listener);
		return;
	}

	Object.defineProperty(array, '_chartjs', {
		configurable: true,
		enumerable: false,
		value: {
			listeners: [listener]
		}
	});

	arrayEvents.forEach(function(key) {
		var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
		var base = array[key];

		Object.defineProperty(array, key, {
			configurable: true,
			enumerable: false,
			value: function() {
				var args = Array.prototype.slice.call(arguments);
				var res = base.apply(this, args);

				helpers$1.each(array._chartjs.listeners, function(object) {
					if (typeof object[method] === 'function') {
						object[method].apply(object, args);
					}
				});

				return res;
			}
		});
	});
}

/**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */
function unlistenArrayEvents(array, listener) {
	var stub = array._chartjs;
	if (!stub) {
		return;
	}

	var listeners = stub.listeners;
	var index = listeners.indexOf(listener);
	if (index !== -1) {
		listeners.splice(index, 1);
	}

	if (listeners.length > 0) {
		return;
	}

	arrayEvents.forEach(function(key) {
		delete array[key];
	});

	delete array._chartjs;
}

// Base class for all dataset controllers (line, bar, etc)
var DatasetController = function(chart, datasetIndex) {
	this.initialize(chart, datasetIndex);
};

helpers$1.extend(DatasetController.prototype, {

	/**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */
	datasetElementType: null,

	/**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */
	dataElementType: null,

	/**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth'
	],

	/**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'pointStyle'
	],

	initialize: function(chart, datasetIndex) {
		var me = this;
		me.chart = chart;
		me.index = datasetIndex;
		me.linkScales();
		me.addElements();
		me._type = me.getMeta().type;
	},

	updateIndex: function(datasetIndex) {
		this.index = datasetIndex;
	},

	linkScales: function() {
		var me = this;
		var meta = me.getMeta();
		var chart = me.chart;
		var scales = chart.scales;
		var dataset = me.getDataset();
		var scalesOpts = chart.options.scales;

		if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
			meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
		}
		if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
			meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
		}
	},

	getDataset: function() {
		return this.chart.data.datasets[this.index];
	},

	getMeta: function() {
		return this.chart.getDatasetMeta(this.index);
	},

	getScaleForId: function(scaleID) {
		return this.chart.scales[scaleID];
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().yAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getValueScale: function() {
		return this.getScaleForId(this._getValueScaleId());
	},

	/**
	 * @private
	 */
	_getIndexScale: function() {
		return this.getScaleForId(this._getIndexScaleId());
	},

	reset: function() {
		this._update(true);
	},

	/**
	 * @private
	 */
	destroy: function() {
		if (this._data) {
			unlistenArrayEvents(this._data, this);
		}
	},

	createMetaDataset: function() {
		var me = this;
		var type = me.datasetElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index
		});
	},

	createMetaData: function(index) {
		var me = this;
		var type = me.dataElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index,
			_index: index
		});
	},

	addElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data || [];
		var metaData = meta.data;
		var i, ilen;

		for (i = 0, ilen = data.length; i < ilen; ++i) {
			metaData[i] = metaData[i] || me.createMetaData(i);
		}

		meta.dataset = meta.dataset || me.createMetaDataset();
	},

	addElementAndReset: function(index) {
		var element = this.createMetaData(index);
		this.getMeta().data.splice(index, 0, element);
		this.updateElement(element, index, true);
	},

	buildOrUpdateElements: function() {
		var me = this;
		var dataset = me.getDataset();
		var data = dataset.data || (dataset.data = []);

		// In order to correctly handle data addition/deletion animation (an thus simulate
		// real-time charts), we need to monitor these data modifications and synchronize
		// the internal meta data accordingly.
		if (me._data !== data) {
			if (me._data) {
				// This case happens when the user replaced the data array instance.
				unlistenArrayEvents(me._data, me);
			}

			if (data && Object.isExtensible(data)) {
				listenArrayEvents(data, me);
			}
			me._data = data;
		}

		// Re-sync meta data in case the user replaced the data array or if we missed
		// any updates and so make sure that we handle number of datapoints changing.
		me.resyncElements();
	},

	/**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */
	_configure: function() {
		var me = this;
		me._config = helpers$1.merge(Object.create(null), [
			me.chart.options.datasets[me._type],
			me.getDataset(),
		], {
			merger: function(key, target, source) {
				if (key !== '_meta' && key !== 'data') {
					helpers$1._merger(key, target, source);
				}
			}
		});
	},

	_update: function(reset) {
		var me = this;
		me._configure();
		me._cachedDataOpts = null;
		me.update(reset);
	},

	update: helpers$1.noop,

	transition: function(easingValue) {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		for (; i < ilen; ++i) {
			elements[i].transition(easingValue);
		}

		if (meta.dataset) {
			meta.dataset.transition(easingValue);
		}
	},

	draw: function() {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		if (meta.dataset) {
			meta.dataset.draw();
		}

		for (; i < ilen; ++i) {
			elements[i].draw();
		}
	},

	/**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */
	getStyle: function(index) {
		var me = this;
		var meta = me.getMeta();
		var dataset = meta.dataset;
		var style;

		me._configure();
		if (dataset && index === undefined) {
			style = me._resolveDatasetElementOptions(dataset || {});
		} else {
			index = index || 0;
			style = me._resolveDataElementOptions(meta.data[index] || {}, index);
		}

		if (style.fill === false || style.fill === null) {
			style.backgroundColor = style.borderColor;
		}

		return style;
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element, hover) {
		var me = this;
		var chart = me.chart;
		var datasetOpts = me._config;
		var custom = element.custom || {};
		var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
		var elementOptions = me._datasetElementOptions;
		var values = {};
		var i, ilen, key, readKey;

		// Scriptable options
		var context = {
			chart: chart,
			dataset: me.getDataset(),
			datasetIndex: me.index,
			hover: hover
		};

		for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
			key = elementOptions[i];
			readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
			values[key] = resolve([
				custom[readKey],
				datasetOpts[readKey],
				options[readKey]
			], context);
		}

		return values;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(element, index) {
		var me = this;
		var custom = element && element.custom;
		var cached = me._cachedDataOpts;
		if (cached && !custom) {
			return cached;
		}
		var chart = me.chart;
		var datasetOpts = me._config;
		var options = chart.options.elements[me.dataElementType.prototype._type] || {};
		var elementOptions = me._dataElementOptions;
		var values = {};

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: me.getDataset(),
			datasetIndex: me.index
		};

		// `resolve` sets cacheable to `false` if any option is indexed or scripted
		var info = {cacheable: !custom};

		var keys, i, ilen, key;

		custom = custom || {};

		if (helpers$1.isArray(elementOptions)) {
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		} else {
			keys = Object.keys(elementOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[elementOptions[key]],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		}

		if (info.cacheable) {
			me._cachedDataOpts = Object.freeze(values);
		}

		return values;
	},

	removeHoverStyle: function(element) {
		helpers$1.merge(element._model, element.$previousStyle || {});
		delete element.$previousStyle;
	},

	setHoverStyle: function(element) {
		var dataset = this.chart.data.datasets[element._datasetIndex];
		var index = element._index;
		var custom = element.custom || {};
		var model = element._model;
		var getHoverColor = helpers$1.getHoverColor;

		element.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth
		};

		model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
		model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
		model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
	},

	/**
	 * @private
	 */
	_removeDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;

		if (element) {
			this.removeHoverStyle(element);
		}
	},

	/**
	 * @private
	 */
	_setDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;
		var prev = {};
		var i, ilen, key, keys, hoverOptions, model;

		if (!element) {
			return;
		}

		model = element._model;
		hoverOptions = this._resolveDatasetElementOptions(element, true);

		keys = Object.keys(hoverOptions);
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			prev[key] = model[key];
			model[key] = hoverOptions[key];
		}

		element.$previousStyle = prev;
	},

	/**
	 * @private
	 */
	resyncElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data;
		var numMeta = meta.data.length;
		var numData = data.length;

		if (numData < numMeta) {
			meta.data.splice(numData, numMeta - numData);
		} else if (numData > numMeta) {
			me.insertElements(numMeta, numData - numMeta);
		}
	},

	/**
	 * @private
	 */
	insertElements: function(start, count) {
		for (var i = 0; i < count; ++i) {
			this.addElementAndReset(start + i);
		}
	},

	/**
	 * @private
	 */
	onDataPush: function() {
		var count = arguments.length;
		this.insertElements(this.getDataset().data.length - count, count);
	},

	/**
	 * @private
	 */
	onDataPop: function() {
		this.getMeta().data.pop();
	},

	/**
	 * @private
	 */
	onDataShift: function() {
		this.getMeta().data.shift();
	},

	/**
	 * @private
	 */
	onDataSplice: function(start, count) {
		this.getMeta().data.splice(start, count);
		this.insertElements(start, arguments.length - 2);
	},

	/**
	 * @private
	 */
	onDataUnshift: function() {
		this.insertElements(0, arguments.length);
	}
});

DatasetController.extend = helpers$1.inherits;

var core_datasetController = DatasetController;

var TAU = Math.PI * 2;

core_defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: core_defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2,
			borderAlign: 'center'
		}
	}
});

function clipArc(ctx, arc) {
	var startAngle = arc.startAngle;
	var endAngle = arc.endAngle;
	var pixelMargin = arc.pixelMargin;
	var angleMargin = pixelMargin / arc.outerRadius;
	var x = arc.x;
	var y = arc.y;

	// Draw an inner border by cliping the arc and drawing a double-width border
	// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
	ctx.beginPath();
	ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
	if (arc.innerRadius > pixelMargin) {
		angleMargin = pixelMargin / arc.innerRadius;
		ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
	} else {
		ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
	}
	ctx.closePath();
	ctx.clip();
}

function drawFullCircleBorders(ctx, vm, arc, inner) {
	var endAngle = arc.endAngle;
	var i;

	if (inner) {
		arc.endAngle = arc.startAngle + TAU;
		clipArc(ctx, arc);
		arc.endAngle = endAngle;
		if (arc.endAngle === arc.startAngle && arc.fullCircles) {
			arc.endAngle += TAU;
			arc.fullCircles--;
		}
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}
}

function drawBorder(ctx, vm, arc) {
	var inner = vm.borderAlign === 'inner';

	if (inner) {
		ctx.lineWidth = vm.borderWidth * 2;
		ctx.lineJoin = 'round';
	} else {
		ctx.lineWidth = vm.borderWidth;
		ctx.lineJoin = 'bevel';
	}

	if (arc.fullCircles) {
		drawFullCircleBorders(ctx, vm, arc, inner);
	}

	if (inner) {
		clipArc(ctx, arc);
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
	ctx.closePath();
	ctx.stroke();
}

var element_arc = core_element.extend({
	_type: 'arc',

	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += TAU;
			}
			while (angle > endAngle) {
				angle -= TAU;
			}
			while (angle < startAngle) {
				angle += TAU;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
		var arc = {
			x: vm.x,
			y: vm.y,
			innerRadius: vm.innerRadius,
			outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
			pixelMargin: pixelMargin,
			startAngle: vm.startAngle,
			endAngle: vm.endAngle,
			fullCircles: Math.floor(vm.circumference / TAU)
		};
		var i;

		ctx.save();

		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;

		if (arc.fullCircles) {
			arc.endAngle = arc.startAngle + TAU;
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			for (i = 0; i < arc.fullCircles; ++i) {
				ctx.fill();
			}
			arc.endAngle = arc.startAngle + vm.circumference % TAU;
		}

		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.fill();

		if (vm.borderWidth) {
			drawBorder(ctx, vm, arc);
		}

		ctx.restore();
	}
});

var valueOrDefault$1 = helpers$1.valueOrDefault;

var defaultColor = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: defaultColor,
			borderWidth: 3,
			borderColor: defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

var element_line = core_element.extend({
	_type: 'line',

	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalDefaults = core_defaults.global;
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var closePath = me._loop;
		var index, previous, currentVM;

		if (!points.length) {
			return;
		}

		if (me._loop) {
			for (index = 0; index < points.length; ++index) {
				previous = helpers$1.previousItem(points, index);
				// If the line has an open path, shift the point array
				if (!points[index]._view.skip && previous._view.skip) {
					points = points.slice(index).concat(points.slice(0, index));
					closePath = spanGaps;
					break;
				}
			}
			// If the line has a close path, add the first point again
			if (closePath) {
				points.push(points[0]);
			}
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();

		// First point moves to it's starting position no matter what
		currentVM = points[0]._view;
		if (!currentVM.skip) {
			ctx.moveTo(currentVM.x, currentVM.y);
			lastDrawnIndex = 0;
		}

		for (index = 1; index < points.length; ++index) {
			currentVM = points[index]._view;
			previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];

			if (!currentVM.skip) {
				if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
					// There was a gap and this is the first point after the gap
					ctx.moveTo(currentVM.x, currentVM.y);
				} else {
					// Line to next point
					helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
				}
				lastDrawnIndex = index;
			}
		}

		if (closePath) {
			ctx.closePath();
		}

		ctx.stroke();
		ctx.restore();
	}
});

var valueOrDefault$2 = helpers$1.valueOrDefault;

var defaultColor$1 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor$1,
			borderColor: defaultColor$1,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

var element_point = core_element.extend({
	_type: 'point',

	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var rotation = vm.rotation;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow

		if (vm.skip) {
			return;
		}

		// Clipping for Points.
		if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
			helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
		}
	}
});

var defaultColor$2 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaultColor$2,
			borderColor: defaultColor$2,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(vm) {
	return vm && vm.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(vm) {
	var x1, x2, y1, y2, half;

	if (isVertical(vm)) {
		half = vm.width / 2;
		x1 = vm.x - half;
		x2 = vm.x + half;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		half = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - half;
		y2 = vm.y + half;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

function swap(orig, v1, v2) {
	return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}

function parseBorderSkipped(vm) {
	var edge = vm.borderSkipped;
	var res = {};

	if (!edge) {
		return res;
	}

	if (vm.horizontal) {
		if (vm.base > vm.x) {
			edge = swap(edge, 'left', 'right');
		}
	} else if (vm.base < vm.y) {
		edge = swap(edge, 'bottom', 'top');
	}

	res[edge] = true;
	return res;
}

function parseBorderWidth(vm, maxW, maxH) {
	var value = vm.borderWidth;
	var skip = parseBorderSkipped(vm);
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = +value.top || 0;
		r = +value.right || 0;
		b = +value.bottom || 0;
		l = +value.left || 0;
	} else {
		t = r = b = l = +value || 0;
	}

	return {
		t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
		r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
		b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
		l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
	};
}

function boundingRects(vm) {
	var bounds = getBarBounds(vm);
	var width = bounds.right - bounds.left;
	var height = bounds.bottom - bounds.top;
	var border = parseBorderWidth(vm, width / 2, height / 2);

	return {
		outer: {
			x: bounds.left,
			y: bounds.top,
			w: width,
			h: height
		},
		inner: {
			x: bounds.left + border.l,
			y: bounds.top + border.t,
			w: width - border.l - border.r,
			h: height - border.t - border.b
		}
	};
}

function inRange(vm, x, y) {
	var skipX = x === null;
	var skipY = y === null;
	var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);

	return bounds
		&& (skipX || x >= bounds.left && x <= bounds.right)
		&& (skipY || y >= bounds.top && y <= bounds.bottom);
}

var element_rectangle = core_element.extend({
	_type: 'rectangle',

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var rects = boundingRects(vm);
		var outer = rects.outer;
		var inner = rects.inner;

		ctx.fillStyle = vm.backgroundColor;
		ctx.fillRect(outer.x, outer.y, outer.w, outer.h);

		if (outer.w === inner.w && outer.h === inner.h) {
			return;
		}

		ctx.save();
		ctx.beginPath();
		ctx.rect(outer.x, outer.y, outer.w, outer.h);
		ctx.clip();
		ctx.fillStyle = vm.borderColor;
		ctx.rect(inner.x, inner.y, inner.w, inner.h);
		ctx.fill('evenodd');
		ctx.restore();
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		return inRange(this._view, mouseX, mouseY);
	},

	inLabelRange: function(mouseX, mouseY) {
		var vm = this._view;
		return isVertical(vm)
			? inRange(vm, mouseX, null)
			: inRange(vm, null, mouseY);
	},

	inXRange: function(mouseX) {
		return inRange(this._view, mouseX, null);
	},

	inYRange: function(mouseY) {
		return inRange(this._view, null, mouseY);
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(vm)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;

		return isVertical(vm)
			? vm.width * Math.abs(vm.y - vm.base)
			: vm.height * Math.abs(vm.x - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});

var elements = {};
var Arc = element_arc;
var Line = element_line;
var Point = element_point;
var Rectangle = element_rectangle;
elements.Arc = Arc;
elements.Line = Line;
elements.Point = Point;
elements.Rectangle = Rectangle;

var deprecated = helpers$1._deprecated;
var valueOrDefault$3 = helpers$1.valueOrDefault;

core_defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

core_defaults._set('global', {
	datasets: {
		bar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

/**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */
function computeMinSampleSize(scale, pixels) {
	var min = scale._length;
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
	}

	for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
		prev = curr;
	}

	return min;
}

/**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */
function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var min = helpers$1.isNullOrUndef(thickness)
		? computeMinSampleSize(ruler.scale, ruler.pixels)
		: -1;
	var size, ratio;

	if (helpers$1.isNullOrUndef(thickness)) {
		size = min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}

/**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */
function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale size.
		prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - (curr - Math.min(prev, next)) / 2 * percent;
	size = Math.abs(next - prev) / 2 * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

var controller_bar = core_datasetController.extend({

	dataElementType: elements.Rectangle,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderSkipped',
		'borderWidth',
		'barPercentage',
		'barThickness',
		'categoryPercentage',
		'maxBarThickness',
		'minBarLength'
	],

	initialize: function() {
		var me = this;
		var meta, scaleOpts;

		core_datasetController.prototype.initialize.apply(me, arguments);

		meta = me.getMeta();
		meta.stack = me.getDataset().stack;
		meta.bar = true;

		scaleOpts = me._getIndexScale().options;
		deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
		deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
		deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
		deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
		deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
	},

	update: function(reset) {
		var me = this;
		var rects = me.getMeta().data;
		var i, ilen;

		me._ruler = me.getRuler();

		for (i = 0, ilen = rects.length; i < ilen; ++i) {
			me.updateElement(rects[i], i, reset);
		}
	},

	updateElement: function(rectangle, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var dataset = me.getDataset();
		var options = me._resolveDataElementOptions(rectangle, index);

		rectangle._xScale = me.getScaleForId(meta.xAxisID);
		rectangle._yScale = me.getScaleForId(meta.yAxisID);
		rectangle._datasetIndex = me.index;
		rectangle._index = index;
		rectangle._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderSkipped: options.borderSkipped,
			borderWidth: options.borderWidth,
			datasetLabel: dataset.label,
			label: me.chart.data.labels[index]
		};

		if (helpers$1.isArray(dataset.data[index])) {
			rectangle._model.borderSkipped = null;
		}

		me._updateElementGeometry(rectangle, index, reset, options);

		rectangle.pivot();
	},

	/**
	 * @private
	 */
	_updateElementGeometry: function(rectangle, index, reset, options) {
		var me = this;
		var model = rectangle._model;
		var vscale = me._getValueScale();
		var base = vscale.getBasePixel();
		var horizontal = vscale.isHorizontal();
		var ruler = me._ruler || me.getRuler();
		var vpixels = me.calculateBarValuePixels(me.index, index, options);
		var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);

		model.horizontal = horizontal;
		model.base = reset ? base : vpixels.base;
		model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
		model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
		model.height = horizontal ? ipixels.size : undefined;
		model.width = horizontal ? undefined : ipixels.size;
	},

	/**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */
	_getStacks: function(last) {
		var me = this;
		var scale = me._getIndexScale();
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var stacked = scale.options.stacked;
		var ilen = metasets.length;
		var stacks = [];
		var i, meta;

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			// stacked   | meta.stack
			//           | found | not found | undefined
			// false     |   x   |     x     |     x
			// true      |       |     x     |
			// undefined |       |     x     |     x
			if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
				(stacked === undefined && meta.stack === undefined)) {
				stacks.push(meta.stack);
			}
			if (meta.index === last) {
				break;
			}
		}

		return stacks;
	},

	/**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */
	getStackCount: function() {
		return this._getStacks().length;
	},

	/**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */
	getStackIndex: function(datasetIndex, name) {
		var stacks = this._getStacks(datasetIndex);
		var index = (name !== undefined)
			? stacks.indexOf(name)
			: -1; // indexOf returns -1 if element is not present

		return (index === -1)
			? stacks.length - 1
			: index;
	},

	/**
	 * @private
	 */
	getRuler: function() {
		var me = this;
		var scale = me._getIndexScale();
		var pixels = [];
		var i, ilen;

		for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
			pixels.push(scale.getPixelForValue(null, i, me.index));
		}

		return {
			pixels: pixels,
			start: scale._startPixel,
			end: scale._endPixel,
			stackCount: me.getStackCount(),
			scale: scale
		};
	},

	/**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */
	calculateBarValuePixels: function(datasetIndex, index, options) {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var isHorizontal = scale.isHorizontal();
		var datasets = chart.data.datasets;
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var value = scale._parseValue(datasets[datasetIndex].data[index]);
		var minBarLength = options.minBarLength;
		var stacked = scale.options.stacked;
		var stack = me.getMeta().stack;
		var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
		var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
		var ilen = metasets.length;
		var i, imeta, ivalue, base, head, size, stackLength;

		if (stacked || (stacked === undefined && stack !== undefined)) {
			for (i = 0; i < ilen; ++i) {
				imeta = metasets[i];

				if (imeta.index === datasetIndex) {
					break;
				}

				if (imeta.stack === stack) {
					stackLength = scale._parseValue(datasets[imeta.index].data[index]);
					ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;

					if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
						start += ivalue;
					}
				}
			}
		}

		base = scale.getPixelForValue(start);
		head = scale.getPixelForValue(start + length);
		size = head - base;

		if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
			size = minBarLength;
			if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
				head = base - minBarLength;
			} else {
				head = base + minBarLength;
			}
		}

		return {
			size: size,
			base: base,
			head: head,
			center: head + size / 2
		};
	},

	/**
	 * @private
	 */
	calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
		var me = this;
		var range = options.barThickness === 'flex'
			? computeFlexCategoryTraits(index, ruler, options)
			: computeFitCategoryTraits(index, ruler, options);

		var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
		var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
		var size = Math.min(
			valueOrDefault$3(options.maxBarThickness, Infinity),
			range.chunk * range.ratio);

		return {
			base: center - size / 2,
			head: center + size / 2,
			center: center,
			size: size
		};
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var rects = me.getMeta().data;
		var dataset = me.getDataset();
		var ilen = rects.length;
		var i = 0;

		helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);

		for (; i < ilen; ++i) {
			var val = scale._parseValue(dataset.data[i]);
			if (!isNaN(val.min) && !isNaN(val.max)) {
				rects[i].draw();
			}
		}

		helpers$1.canvas.unclipArea(chart.ctx);
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function() {
		var me = this;
		var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
		var indexOpts = me._getIndexScale().options;
		var valueOpts = me._getValueScale().options;

		values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
		values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
		values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
		values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
		values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);

		return values;
	}

});

var valueOrDefault$4 = helpers$1.valueOrDefault;
var resolve$1 = helpers$1.options.resolve;

core_defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});

var controller_bubble = core_datasetController.extend({
	/**
	 * @protected
	 */
	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
		'hoverRadius',
		'hitRadius',
		'pointStyle',
		'rotation'
	],

	/**
	 * @protected
	 */
	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var points = meta.data;

		// Update Points
		helpers$1.each(points, function(point, index) {
			me.updateElement(point, index, reset);
		});
	},

	/**
	 * @protected
	 */
	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var xScale = me.getScaleForId(meta.xAxisID);
		var yScale = me.getScaleForId(meta.yAxisID);
		var options = me._resolveDataElementOptions(point, index);
		var data = me.getDataset().data[index];
		var dsIndex = me.index;

		var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
		var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = dsIndex;
		point._index = index;
		point._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			hitRadius: options.hitRadius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			radius: reset ? 0 : options.radius,
			skip: custom.skip || isNaN(x) || isNaN(y),
			x: x,
			y: y,
		};

		point.pivot();
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
		model.radius = options.radius + options.hoverRadius;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(point, index) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var custom = point.custom || {};
		var data = dataset.data[index] || {};
		var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		// In case values were cached (and thus frozen), we need to clone the values
		if (me._cachedDataOpts === values) {
			values = helpers$1.extend({}, values);
		}

		// Custom radius resolution
		values.radius = resolve$1([
			custom.radius,
			data.r,
			me._config.radius,
			chart.options.elements.point.radius
		], context, index);

		return values;
	}
});

var valueOrDefault$5 = helpers$1.valueOrDefault;

var PI$1 = Math.PI;
var DOUBLE_PI$1 = PI$1 * 2;
var HALF_PI$1 = PI$1 / 2;

core_defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: -HALF_PI$1,

	// The total circumference of the chart.
	circumference: DOUBLE_PI$1,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers$1.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

var controller_doughnut = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
	getRingIndex: function(datasetIndex) {
		var ringIndex = 0;

		for (var j = 0; j < datasetIndex; ++j) {
			if (this.chart.isDatasetVisible(j)) {
				++ringIndex;
			}
		}

		return ringIndex;
	},

	update: function(reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var ratioX = 1;
		var ratioY = 1;
		var offsetX = 0;
		var offsetY = 0;
		var meta = me.getMeta();
		var arcs = meta.data;
		var cutout = opts.cutoutPercentage / 100 || 0;
		var circumference = opts.circumference;
		var chartWeight = me._getRingWeight(me.index);
		var maxWidth, maxHeight, i, ilen;

		// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
		if (circumference < DOUBLE_PI$1) {
			var startAngle = opts.rotation % DOUBLE_PI$1;
			startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
			var endAngle = startAngle + circumference;
			var startX = Math.cos(startAngle);
			var startY = Math.sin(startAngle);
			var endX = Math.cos(endAngle);
			var endY = Math.sin(endAngle);
			var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
			var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
			var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
			var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
			var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
			var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
			var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
			var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
			ratioX = (maxX - minX) / 2;
			ratioY = (maxY - minY) / 2;
			offsetX = -(maxX + minX) / 2;
			offsetY = -(maxY + minY) / 2;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
		}

		chart.borderWidth = me.getMaxBorderWidth();
		maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
		maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
		chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
		chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
		chart.offsetX = offsetX * chart.outerRadius;
		chart.offsetY = offsetY * chart.outerRadius;

		meta.total = me.calculateTotal();

		me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
		me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			me.updateElement(arcs[i], i, reset);
		}
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var animationOpts = opts.animation;
		var centerX = (chartArea.left + chartArea.right) / 2;
		var centerY = (chartArea.top + chartArea.bottom) / 2;
		var startAngle = opts.rotation; // non reset case handled later
		var endAngle = opts.rotation; // non reset case handled later
		var dataset = me.getDataset();
		var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
		var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
		var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX + chart.offsetX,
				y: centerY + chart.offsetY,
				startAngle: startAngle,
				endAngle: endAngle,
				circumference: circumference,
				outerRadius: outerRadius,
				innerRadius: innerRadius,
				label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
			}
		});

		var model = arc._model;

		// Set correct angles if not resetting
		if (!reset || !animationOpts.animateRotate) {
			if (index === 0) {
				model.startAngle = opts.rotation;
			} else {
				model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
			}

			model.endAngle = model.startAngle + model.circumference;
		}

		arc.pivot();
	},

	calculateTotal: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var total = 0;
		var value;

		helpers$1.each(meta.data, function(element, index) {
			value = dataset.data[index];
			if (!isNaN(value) && !element.hidden) {
				total += Math.abs(value);
			}
		});

		/* if (total === 0) {
			total = NaN;
		}*/

		return total;
	},

	calculateCircumference: function(value) {
		var total = this.getMeta().total;
		if (total > 0 && !isNaN(value)) {
			return DOUBLE_PI$1 * (Math.abs(value) / total);
		}
		return 0;
	},

	// gets the max border or hover width to properly scale pie charts
	getMaxBorderWidth: function(arcs) {
		var me = this;
		var max = 0;
		var chart = me.chart;
		var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;

		if (!arcs) {
			// Find the outmost visible dataset
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					arcs = meta.data;
					if (i !== me.index) {
						controller = meta.controller;
					}
					break;
				}
			}
		}

		if (!arcs) {
			return 0;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arc = arcs[i];
			if (controller) {
				controller._configure();
				options = controller._resolveDataElementOptions(arc, i);
			} else {
				options = arc._options;
			}
			if (options.borderAlign !== 'inner') {
				borderWidth = options.borderWidth;
				hoverWidth = options.hoverBorderWidth;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
		}
		return max;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */
	_getRingWeightOffset: function(datasetIndex) {
		var ringWeightOffset = 0;

		for (var i = 0; i < datasetIndex; ++i) {
			if (this.chart.isDatasetVisible(i)) {
				ringWeightOffset += this._getRingWeight(i);
			}
		}

		return ringWeightOffset;
	},

	/**
	 * @private
	 */
	_getRingWeight: function(dataSetIndex) {
		return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
	},

	/**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */
	_getVisibleDatasetWeightTotal: function() {
		return this._getRingWeightOffset(this.chart.data.datasets.length);
	}
});

core_defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			type: 'category',
			position: 'left',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		mode: 'index',
		axis: 'y'
	}
});

core_defaults._set('global', {
	datasets: {
		horizontalBar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

var controller_horizontalBar = controller_bar.extend({
	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().yAxisID;
	}
});

var valueOrDefault$6 = helpers$1.valueOrDefault;
var resolve$2 = helpers$1.options.resolve;
var isPointInArea = helpers$1.canvas._isPointInArea;

core_defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

function scaleClip(scale, halfBorderWidth) {
	var tickOpts = scale && scale.options.ticks || {};
	var reverse = tickOpts.reverse;
	var min = tickOpts.min === undefined ? halfBorderWidth : 0;
	var max = tickOpts.max === undefined ? halfBorderWidth : 0;
	return {
		start: reverse ? max : min,
		end: reverse ? min : max
	};
}

function defaultClip(xScale, yScale, borderWidth) {
	var halfBorderWidth = borderWidth / 2;
	var x = scaleClip(xScale, halfBorderWidth);
	var y = scaleClip(yScale, halfBorderWidth);

	return {
		top: y.end,
		right: x.end,
		bottom: y.start,
		left: x.start
	};
}

function toClip(value) {
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = value.top;
		r = value.right;
		b = value.bottom;
		l = value.left;
	} else {
		t = r = b = l = value;
	}

	return {
		top: t,
		right: r,
		bottom: b,
		left: l
	};
}


var controller_line = core_datasetController.extend({

	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth',
		'cubicInterpolationMode',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var options = me.chart.options;
		var config = me._config;
		var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
		var i, ilen;

		me._xScale = me.getScaleForId(meta.xAxisID);
		me._yScale = me.getScaleForId(meta.yAxisID);

		// Update Line
		if (showLine) {
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}

			// Utility
			line._scale = me._yScale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			// Model
			line._model = me._resolveDatasetElementOptions(line);

			line.pivot();
		}

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		if (showLine && line._model.tension !== 0) {
			me.updateBezierControlPoints();
		}

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var datasetIndex = me.index;
		var value = dataset.data[index];
		var xScale = me._xScale;
		var yScale = me._yScale;
		var lineModel = meta.dataset._model;
		var x, y;

		var options = me._resolveDataElementOptions(point, index);

		x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
		y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

		// Utility
		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = datasetIndex;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x,
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
			steppedLine: lineModel ? lineModel.steppedLine : false,
			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element) {
		var me = this;
		var config = me._config;
		var custom = element.custom || {};
		var options = me.chart.options;
		var lineOptions = options.elements.line;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		// The default behavior of lines is to break at null values, according
		// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
		// This option gives lines the ability to span gaps
		values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
		values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
		values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));

		return values;
	},

	calculatePointY: function(value, index, datasetIndex) {
		var me = this;
		var chart = me.chart;
		var yScale = me._yScale;
		var sumPos = 0;
		var sumNeg = 0;
		var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;

		if (yScale.options.stacked) {
			rightValue = +yScale.getRightValue(value);
			metasets = chart._getSortedVisibleDatasetMetas();
			ilen = metasets.length;

			for (i = 0; i < ilen; ++i) {
				dsMeta = metasets[i];
				if (dsMeta.index === datasetIndex) {
					break;
				}

				ds = chart.data.datasets[dsMeta.index];
				if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
					stackedRightValue = +yScale.getRightValue(ds.data[index]);
					if (stackedRightValue < 0) {
						sumNeg += stackedRightValue || 0;
					} else {
						sumPos += stackedRightValue || 0;
					}
				}
			}

			if (rightValue < 0) {
				return yScale.getPixelForValue(sumNeg + rightValue);
			}
			return yScale.getPixelForValue(sumPos + rightValue);
		}
		return yScale.getPixelForValue(value);
	},

	updateBezierControlPoints: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var lineModel = meta.dataset._model;
		var area = chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (lineModel.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		if (lineModel.cubicInterpolationMode === 'monotone') {
			helpers$1.splineCurveMonotone(points);
		} else {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i)._model,
					model,
					helpers$1.nextItem(points, i)._model,
					lineModel.tension
				);
				model.controlPointPreviousX = controlPoints.previous.x;
				model.controlPointPreviousY = controlPoints.previous.y;
				model.controlPointNextX = controlPoints.next.x;
				model.controlPointNextY = controlPoints.next.y;
			}
		}

		if (chart.options.elements.line.capBezierPoints) {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				if (isPointInArea(model, area)) {
					if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					}
					if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			}
		}
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var points = meta.data || [];
		var area = chart.chartArea;
		var canvas = chart.canvas;
		var i = 0;
		var ilen = points.length;
		var clip;

		if (me._showLine) {
			clip = meta.dataset._model.clip;

			helpers$1.canvas.clipArea(chart.ctx, {
				left: clip.left === false ? 0 : area.left - clip.left,
				right: clip.right === false ? canvas.width : area.right + clip.right,
				top: clip.top === false ? 0 : area.top - clip.top,
				bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
			});

			meta.dataset.draw();

			helpers$1.canvas.unclipArea(chart.ctx);
		}

		// Draw the points
		for (; i < ilen; ++i) {
			points[i].draw(area);
		}
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
	},
});

var resolve$3 = helpers$1.options.resolve;

core_defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

var controller_polarArea = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var dataset = me.getDataset();
		var meta = me.getMeta();
		var start = me.chart.options.startAngle || 0;
		var starts = me._starts = [];
		var angles = me._angles = [];
		var arcs = meta.data;
		var i, ilen, angle;

		me._updateRadius();

		meta.count = me.countVisibleElements();

		for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
			starts[i] = start;
			angle = me._computeAngle(i);
			angles[i] = angle;
			start += angle;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			me.updateElement(arcs[i], i, reset);
		}
	},

	/**
	 * @private
	 */
	_updateRadius: function() {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

		chart.outerRadius = Math.max(minSize / 2, 0);
		chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

		me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
		me.innerRadius = me.outerRadius - chart.radiusLength;
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var opts = chart.options;
		var animationOpts = opts.animation;
		var scale = chart.scale;
		var labels = chart.data.labels;

		var centerX = scale.xCenter;
		var centerY = scale.yCenter;

		// var negHalfPI = -0.5 * Math.PI;
		var datasetStartAngle = opts.startAngle;
		var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var startAngle = me._starts[index];
		var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

		var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,
			_scale: scale,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX,
				y: centerY,
				innerRadius: 0,
				outerRadius: reset ? resetRadius : distance,
				startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
				endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
				label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
			}
		});

		arc.pivot();
	},

	countVisibleElements: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var count = 0;

		helpers$1.each(meta.data, function(element, index) {
			if (!isNaN(dataset.data[index]) && !element.hidden) {
				count++;
			}
		});

		return count;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;
		var valueOrDefault = helpers$1.valueOrDefault;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * @private
	 */
	_computeAngle: function(index) {
		var me = this;
		var count = this.getMeta().count;
		var dataset = me.getDataset();
		var meta = me.getMeta();

		if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
			return 0;
		}

		// Scriptable options
		var context = {
			chart: me.chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		return resolve$3([
			me.chart.options.elements.arc.angle,
			(2 * Math.PI) / count
		], context, index);
	}
});

core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
core_defaults._set('pie', {
	cutoutPercentage: 0
});

// Pie charts are Doughnut chart with different defaults
var controller_pie = controller_doughnut;

var valueOrDefault$7 = helpers$1.valueOrDefault;

core_defaults._set('radar', {
	spanGaps: false,
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			fill: 'start',
			tension: 0 // no bezier in radar
		}
	}
});

var controller_radar = core_datasetController.extend({
	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderWidth',
		'borderColor',
		'borderCapStyle',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var scale = me.chart.scale;
		var config = me._config;
		var i, ilen;

		// Compatibility: If the properties are defined with only the old name, use those values
		if (config.tension !== undefined && config.lineTension === undefined) {
			config.lineTension = config.tension;
		}

		// Utility
		line._scale = scale;
		line._datasetIndex = me.index;
		// Data
		line._children = points;
		line._loop = true;
		// Model
		line._model = me._resolveDatasetElementOptions(line);

		line.pivot();

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		// Update bezier control points
		me.updateBezierControlPoints();

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var scale = me.chart.scale;
		var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
		var options = me._resolveDataElementOptions(point, index);
		var lineModel = me.getMeta().dataset._model;
		var x = reset ? scale.xCenter : pointPosition.x;
		var y = reset ? scale.yCenter : pointPosition.y;

		// Utility
		point._scale = scale;
		point._options = options;
		point._datasetIndex = me.index;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x, // value not used in dataset scale, but we want a consistent API between scales
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),

			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function() {
		var me = this;
		var config = me._config;
		var options = me.chart.options;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);

		return values;
	},

	updateBezierControlPoints: function() {
		var me = this;
		var meta = me.getMeta();
		var area = me.chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (meta.dataset._model.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		for (i = 0, ilen = points.length; i < ilen; ++i) {
			model = points[i]._model;
			controlPoints = helpers$1.splineCurve(
				helpers$1.previousItem(points, i, true)._model,
				model,
				helpers$1.nextItem(points, i, true)._model,
				model.tension
			);

			// Prevent the bezier going outside of the bounds of the graph
			model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
			model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
			model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
			model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
		}
	},

	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
	}
});

core_defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

core_defaults._set('global', {
	datasets: {
		scatter: {
			showLine: false
		}
	}
});

// Scatter charts use line controllers
var controller_scatter = controller_line;

// NOTE export a map in which the key represents the controller type, not
// the class, and so must be CamelCase in order to be correctly retrieved
// by the controller in core.controller.js (`controllers[meta.type]`).

var controllers = {
	bar: controller_bar,
	bubble: controller_bubble,
	doughnut: controller_doughnut,
	horizontalBar: controller_horizontalBar,
	line: controller_line,
	polarArea: controller_polarArea,
	pie: controller_pie,
	radar: controller_radar,
	scatter: controller_scatter
};

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers$1.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var metasets = chart._getSortedVisibleDatasetMetas();
	var metadata, i, j, ilen, jlen, element;

	for (i = 0, ilen = metasets.length; i < ilen; ++i) {
		metadata = metasets[i].data;
		for (j = 0, jlen = metadata.length; j < jlen; ++j) {
			element = metadata[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);
		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
		var element = meta.data[items[0]._index];

		// don't count items that are skipped (null data)
		if (element && !element._view.skip) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
var core_interaction = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			return getNearestItems(chart, position, options.intersect, distanceMetric);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};

var extend = helpers$1.extend;

function filterByPosition(array, position) {
	return helpers$1.where(array, function(v) {
		return v.pos === position;
	});
}

function sortByWeight(array, reverse) {
	return array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0.index - v1.index :
			v0.weight - v1.weight;
	});
}

function wrapBoxes(boxes) {
	var layoutBoxes = [];
	var i, ilen, box;

	for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
		box = boxes[i];
		layoutBoxes.push({
			index: i,
			box: box,
			pos: box.position,
			horizontal: box.isHorizontal(),
			weight: box.weight
		});
	}
	return layoutBoxes;
}

function setLayoutDims(layouts, params) {
	var i, ilen, layout;
	for (i = 0, ilen = layouts.length; i < ilen; ++i) {
		layout = layouts[i];
		// store width used instead of chartArea.w in fitBoxes
		layout.width = layout.horizontal
			? layout.box.fullWidth && params.availableWidth
			: params.vBoxMaxWidth;
		// store height used instead of chartArea.h in fitBoxes
		layout.height = layout.horizontal && params.hBoxMaxHeight;
	}
}

function buildLayoutBoxes(boxes) {
	var layoutBoxes = wrapBoxes(boxes);
	var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
	var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
	var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
	var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));

	return {
		leftAndTop: left.concat(top),
		rightAndBottom: right.concat(bottom),
		chartArea: filterByPosition(layoutBoxes, 'chartArea'),
		vertical: left.concat(right),
		horizontal: top.concat(bottom)
	};
}

function getCombinedMax(maxPadding, chartArea, a, b) {
	return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}

function updateDims(chartArea, params, layout) {
	var box = layout.box;
	var maxPadding = chartArea.maxPadding;
	var newWidth, newHeight;

	if (layout.size) {
		// this layout was already counted for, lets first reduce old size
		chartArea[layout.pos] -= layout.size;
	}
	layout.size = layout.horizontal ? box.height : box.width;
	chartArea[layout.pos] += layout.size;

	if (box.getPadding) {
		var boxPadding = box.getPadding();
		maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
		maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
		maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
		maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
	}

	newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
	newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');

	if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
		chartArea.w = newWidth;
		chartArea.h = newHeight;

		// return true if chart area changed in layout's direction
		var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
		return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
	}
}

function handleMaxPadding(chartArea) {
	var maxPadding = chartArea.maxPadding;

	function updatePos(pos) {
		var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
		chartArea[pos] += change;
		return change;
	}
	chartArea.y += updatePos('top');
	chartArea.x += updatePos('left');
	updatePos('right');
	updatePos('bottom');
}

function getMargins(horizontal, chartArea) {
	var maxPadding = chartArea.maxPadding;

	function marginForPositions(positions) {
		var margin = {left: 0, top: 0, right: 0, bottom: 0};
		positions.forEach(function(pos) {
			margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
		});
		return margin;
	}

	return horizontal
		? marginForPositions(['left', 'right'])
		: marginForPositions(['top', 'bottom']);
}

function fitBoxes(boxes, chartArea, params) {
	var refitBoxes = [];
	var i, ilen, layout, box, refit, changed;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;

		box.update(
			layout.width || chartArea.w,
			layout.height || chartArea.h,
			getMargins(layout.horizontal, chartArea)
		);
		if (updateDims(chartArea, params, layout)) {
			changed = true;
			if (refitBoxes.length) {
				// Dimensions changed and there were non full width boxes before this
				// -> we have to refit those
				refit = true;
			}
		}
		if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
			refitBoxes.push(layout);
		}
	}

	return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
}

function placeBoxes(boxes, chartArea, params) {
	var userPadding = params.padding;
	var x = chartArea.x;
	var y = chartArea.y;
	var i, ilen, layout, box;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;
		if (layout.horizontal) {
			box.left = box.fullWidth ? userPadding.left : chartArea.left;
			box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
			box.top = y;
			box.bottom = y + box.height;
			box.width = box.right - box.left;
			y = box.bottom;
		} else {
			box.left = x;
			box.right = x + box.width;
			box.top = chartArea.top;
			box.bottom = chartArea.top + chartArea.h;
			box.height = box.bottom - box.top;
			x = box.right;
		}
	}

	chartArea.x = x;
	chartArea.y = y;
}

core_defaults._set('global', {
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

/**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */

// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
var core_layouts = {
	defaults: {},

	/**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;
		item._layers = item._layers || function() {
			return [{
				z: 0,
				draw: function() {
					item.draw.apply(item, arguments);
				}
			}];
		};

		chart.boxes.push(item);
	},

	/**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	/**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	/**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers$1.options.toPadding(layoutOptions.padding);

		var availableWidth = width - padding.width;
		var availableHeight = height - padding.height;
		var boxes = buildLayoutBoxes(chart.boxes);
		var verticalBoxes = boxes.vertical;
		var horizontalBoxes = boxes.horizontal;

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//

		var params = Object.freeze({
			outerWidth: width,
			outerHeight: height,
			padding: padding,
			availableWidth: availableWidth,
			vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
			hBoxMaxHeight: availableHeight / 2
		});
		var chartArea = extend({
			maxPadding: extend({}, padding),
			w: availableWidth,
			h: availableHeight,
			x: padding.left,
			y: padding.top
		}, padding);

		setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);

		// First fit vertical boxes
		fitBoxes(verticalBoxes, chartArea, params);

		// Then fit horizontal boxes
		if (fitBoxes(horizontalBoxes, chartArea, params)) {
			// if the area changed, re-fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
		}

		handleMaxPadding(chartArea);

		// Finally place the boxes to correct coordinates
		placeBoxes(boxes.leftAndTop, chartArea, params);

		// Move to opposite side of chart
		chartArea.x += chartArea.w;
		chartArea.y += chartArea.h;

		placeBoxes(boxes.rightAndBottom, chartArea, params);

		chart.chartArea = {
			left: chartArea.left,
			top: chartArea.top,
			right: chartArea.left + chartArea.w,
			bottom: chartArea.top + chartArea.h
		};

		// Finally update boxes in chartArea (radial scale for example)
		helpers$1.each(boxes.chartArea, function(layout) {
			var box = layout.box;
			extend(box, chart.chartArea);
			box.update(chartArea.w, chartArea.h);
		});
	}
};

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

var platform_basic = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};

var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";

var platform_dom$1 = /*#__PURE__*/Object.freeze({
__proto__: null,
'default': platform_dom
});

var stylesheet = getCjsExportFromNamespace(platform_dom$1);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers$1.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			// eslint-disable-next-line getter-return
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers$1.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers$1.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

function createDiv(cls) {
	var el = document.createElement('div');
	el.className = cls || '';
	return el;
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var maxSize = 1000000;

	// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
	// https://github.com/chartjs/Chart.js/issues/5902
	var resizer = createDiv(CSS_SIZE_MONITOR);
	var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
	var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');

	expand.appendChild(createDiv());
	shrink.appendChild(createDiv());

	resizer.appendChild(expand);
	resizer.appendChild(shrink);
	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};

	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers$1.each(ANIMATION_START_EVENTS, function(type) {
		addListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			removeListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			var container = chart.options.maintainAspectRatio && node.parentNode;
			var w = container ? container.clientWidth : 0;
			listener(createEvent('resize', chart));
			if (container && container.clientWidth < w && chart.canvas) {
				// If the container size shrank during chart resize, let's assume
				// scrollbar appeared. So we resize again with the scrollbar visible -
				// effectively making chart smaller and the scrollbar hidden again.
				// Because we are inside `throttled`, and currently `ticking`, scroll
				// events are ignored during this whole 2 resize process.
				// If we assumed wrong and something else happened, we are resizing
				// twice in a frame (potential performance issue)
				listener(createEvent('resize', chart));
			}
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

/**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */
function injectCSS(rootNode, css) {
	// https://stackoverflow.com/q/3922139
	var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
	if (!expando.containsStyles) {
		expando.containsStyles = true;
		css = '/* Chart.js */\n' + css;
		var style = document.createElement('style');
		style.setAttribute('type', 'text/css');
		style.appendChild(document.createTextNode(css));
		rootNode.appendChild(style);
	}
}

var platform_dom$2 = {
	/**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */
	disableCSSInjection: false,

	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	/**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */
	_ensureLoaded: function(canvas) {
		if (!this.disableCSSInjection) {
			// If the canvas is in a shadow DOM, then the styles must also be inserted
			// into the same shadow DOM.
			// https://github.com/chartjs/Chart.js/issues/5763
			var root = canvas.getRootNode ? canvas.getRootNode() : document;
			var targetNode = root.host ? root : document.head;
			injectCSS(targetNode, stylesheet);
		}
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			// Load platform resources on first chart creation, to make it possible to
			// import the library before setting platform options.
			this._ensureLoaded(item);
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers$1.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers$1.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		// eslint-disable-next-line no-self-assign
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.addEvent = addListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.removeEvent = removeListener;

// @TODO Make possible to select another platform at build time.
var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
var platform = helpers$1.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

core_defaults._set('global', {
	plugins: {}
});

/**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */
var core_plugins = {
	/**
	 * Globally registered plugins.
	 * @private
	 */
	_plugins: [],

	/**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */
	_cacheId: 0,

	/**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	/**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	/**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	/**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */
	count: function() {
		return this._plugins.length;
	},

	/**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */
	getAll: function() {
		return this._plugins;
	},

	/**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers$1.clone(core_defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	/**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

var core_scaleService = {
	// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
	// use the new chart options to grab the correct scale
	constructors: {},
	// Use a registration function so that we can move to an ES6 map when we no longer need to support
	// old browsers

	// Scale config defaults
	defaults: {},
	registerScaleType: function(type, scaleConstructor, scaleDefaults) {
		this.constructors[type] = scaleConstructor;
		this.defaults[type] = helpers$1.clone(scaleDefaults);
	},
	getScaleConstructor: function(type) {
		return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
	},
	getScaleDefaults: function(type) {
		// Return the scale defaults merged with the global settings so that we always use the latest ones
		return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
	},
	updateScaleDefaults: function(type, additions) {
		var me = this;
		if (me.defaults.hasOwnProperty(type)) {
			me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
		}
	},
	addScalesToLayout: function(chart) {
		// Adds each scale to the chart.boxes array to be sized accordingly
		helpers$1.each(chart.scales, function(scale) {
			// Set ILayoutItem parameters for backwards compatibility
			scale.fullWidth = scale.options.fullWidth;
			scale.position = scale.options.position;
			scale.weight = scale.options.weight;
			core_layouts.addBox(chart, scale);
		});
	}
};

var valueOrDefault$8 = helpers$1.valueOrDefault;
var getRtlHelper = helpers$1.rtl.getRtlAdapter;

core_defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers$1.noop,
			title: function(tooltipItems, data) {
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];
					if (item.label) {
						title = item.label;
					} else if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers$1.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers$1.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
					label += tooltipItem.value;
				} else {
					label += tooltipItem.yLabel;
				}
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers$1.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers$1.noop,
			footer: helpers$1.noop,
			afterFooter: helpers$1.noop
		}
	}
});

var positioners = {
	/**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */
	average: function(elements) {
		if (!elements.length) {
			return false;
		}

		var i, len;
		var x = 0;
		var y = 0;
		var count = 0;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var pos = el.tooltipPosition();
				x += pos.x;
				y += pos.y;
				++count;
			}
		}

		return {
			x: x / count,
			y: y / count
		};
	},

	/**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */
	nearest: function(elements, eventPosition) {
		var x = eventPosition.x;
		var y = eventPosition.y;
		var minDistance = Number.POSITIVE_INFINITY;
		var i, len, nearestElement;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var center = el.getCenterPoint();
				var d = helpers$1.distanceBetweenPoints(eventPosition, center);

				if (d < minDistance) {
					minDistance = d;
					nearestElement = el;
				}
			}
		}

		if (nearestElement) {
			var tp = nearestElement.tooltipPosition();
			x = tp.x;
			y = tp.y;
		}

		return {
			x: x,
			y: y
		};
	}
};

// Helper to push or concat based on if the 2nd parameter is an array or not
function pushOrConcat(base, toPush) {
	if (toPush) {
		if (helpers$1.isArray(toPush)) {
			// base = base.concat(toPush);
			Array.prototype.push.apply(base, toPush);
		} else {
			base.push(toPush);
		}
	}

	return base;
}

/**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */
function splitNewlines(str) {
	if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
		return str.split('\n');
	}
	return str;
}


/**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */
function createTooltipItem(element) {
	var xScale = element._xScale;
	var yScale = element._yScale || element._scale; // handle radar || polarArea charts
	var index = element._index;
	var datasetIndex = element._datasetIndex;
	var controller = element._chart.getDatasetMeta(datasetIndex).controller;
	var indexScale = controller._getIndexScale();
	var valueScale = controller._getValueScale();

	return {
		xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
		yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
		label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
		value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
		index: index,
		datasetIndex: datasetIndex,
		x: element._model.x,
		y: element._model.y
	};
}

/**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */
function getBaseModel(tooltipOpts) {
	var globalDefaults = core_defaults.global;

	return {
		// Positioning
		xPadding: tooltipOpts.xPadding,
		yPadding: tooltipOpts.yPadding,
		xAlign: tooltipOpts.xAlign,
		yAlign: tooltipOpts.yAlign,

		// Drawing direction and text direction
		rtl: tooltipOpts.rtl,
		textDirection: tooltipOpts.textDirection,

		// Body
		bodyFontColor: tooltipOpts.bodyFontColor,
		_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
		_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
		_bodyAlign: tooltipOpts.bodyAlign,
		bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
		bodySpacing: tooltipOpts.bodySpacing,

		// Title
		titleFontColor: tooltipOpts.titleFontColor,
		_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
		_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
		titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
		_titleAlign: tooltipOpts.titleAlign,
		titleSpacing: tooltipOpts.titleSpacing,
		titleMarginBottom: tooltipOpts.titleMarginBottom,

		// Footer
		footerFontColor: tooltipOpts.footerFontColor,
		_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
		_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
		footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
		_footerAlign: tooltipOpts.footerAlign,
		footerSpacing: tooltipOpts.footerSpacing,
		footerMarginTop: tooltipOpts.footerMarginTop,

		// Appearance
		caretSize: tooltipOpts.caretSize,
		cornerRadius: tooltipOpts.cornerRadius,
		backgroundColor: tooltipOpts.backgroundColor,
		opacity: 0,
		legendColorBackground: tooltipOpts.multiKeyBackground,
		displayColors: tooltipOpts.displayColors,
		borderColor: tooltipOpts.borderColor,
		borderWidth: tooltipOpts.borderWidth
	};
}

/**
 * Get the size of the tooltip
 */
function getTooltipSize(tooltip, model) {
	var ctx = tooltip._chart.ctx;

	var height = model.yPadding * 2; // Tooltip Padding
	var width = 0;

	// Count of all lines in the body
	var body = model.body;
	var combinedBodyLength = body.reduce(function(count, bodyItem) {
		return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
	}, 0);
	combinedBodyLength += model.beforeBody.length + model.afterBody.length;

	var titleLineCount = model.title.length;
	var footerLineCount = model.footer.length;
	var titleFontSize = model.titleFontSize;
	var bodyFontSize = model.bodyFontSize;
	var footerFontSize = model.footerFontSize;

	height += titleLineCount * titleFontSize; // Title Lines
	height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
	height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
	height += combinedBodyLength * bodyFontSize; // Body Lines
	height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
	height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
	height += footerLineCount * (footerFontSize); // Footer Lines
	height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

	// Title width
	var widthPadding = 0;
	var maxLineWidth = function(line) {
		width = Math.max(width, ctx.measureText(line).width + widthPadding);
	};

	ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
	helpers$1.each(model.title, maxLineWidth);

	// Body width
	ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
	helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

	// Body lines may include some extra width due to the color box
	widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
	helpers$1.each(body, function(bodyItem) {
		helpers$1.each(bodyItem.before, maxLineWidth);
		helpers$1.each(bodyItem.lines, maxLineWidth);
		helpers$1.each(bodyItem.after, maxLineWidth);
	});

	// Reset back to 0
	widthPadding = 0;

	// Footer width
	ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
	helpers$1.each(model.footer, maxLineWidth);

	// Add padding
	width += 2 * model.xPadding;

	return {
		width: width,
		height: height
	};
}

/**
 * Helper to get the alignment of a tooltip given the size
 */
function determineAlignment(tooltip, size) {
	var model = tooltip._model;
	var chart = tooltip._chart;
	var chartArea = tooltip._chart.chartArea;
	var xAlign = 'center';
	var yAlign = 'center';

	if (model.y < size.height) {
		yAlign = 'top';
	} else if (model.y > (chart.height - size.height)) {
		yAlign = 'bottom';
	}

	var lf, rf; // functions to determine left, right alignment
	var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
	var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
	var midX = (chartArea.left + chartArea.right) / 2;
	var midY = (chartArea.top + chartArea.bottom) / 2;

	if (yAlign === 'center') {
		lf = function(x) {
			return x <= midX;
		};
		rf = function(x) {
			return x > midX;
		};
	} else {
		lf = function(x) {
			return x <= (size.width / 2);
		};
		rf = function(x) {
			return x >= (chart.width - (size.width / 2));
		};
	}

	olf = function(x) {
		return x + size.width + model.caretSize + model.caretPadding > chart.width;
	};
	orf = function(x) {
		return x - size.width - model.caretSize - model.caretPadding < 0;
	};
	yf = function(y) {
		return y <= midY ? 'top' : 'bottom';
	};

	if (lf(model.x)) {
		xAlign = 'left';

		// Is tooltip too wide and goes over the right side of the chart.?
		if (olf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	} else if (rf(model.x)) {
		xAlign = 'right';

		// Is tooltip too wide and goes outside left edge of canvas?
		if (orf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	}

	var opts = tooltip._options;
	return {
		xAlign: opts.xAlign ? opts.xAlign : xAlign,
		yAlign: opts.yAlign ? opts.yAlign : yAlign
	};
}

/**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */
function getBackgroundPoint(vm, size, alignment, chart) {
	// Background Position
	var x = vm.x;
	var y = vm.y;

	var caretSize = vm.caretSize;
	var caretPadding = vm.caretPadding;
	var cornerRadius = vm.cornerRadius;
	var xAlign = alignment.xAlign;
	var yAlign = alignment.yAlign;
	var paddingAndSize = caretSize + caretPadding;
	var radiusAndPadding = cornerRadius + caretPadding;

	if (xAlign === 'right') {
		x -= size.width;
	} else if (xAlign === 'center') {
		x -= (size.width / 2);
		if (x + size.width > chart.width) {
			x = chart.width - size.width;
		}
		if (x < 0) {
			x = 0;
		}
	}

	if (yAlign === 'top') {
		y += paddingAndSize;
	} else if (yAlign === 'bottom') {
		y -= size.height + paddingAndSize;
	} else {
		y -= (size.height / 2);
	}

	if (yAlign === 'center') {
		if (xAlign === 'left') {
			x += paddingAndSize;
		} else if (xAlign === 'right') {
			x -= paddingAndSize;
		}
	} else if (xAlign === 'left') {
		x -= radiusAndPadding;
	} else if (xAlign === 'right') {
		x += radiusAndPadding;
	}

	return {
		x: x,
		y: y
	};
}

function getAlignedX(vm, align) {
	return align === 'center'
		? vm.x + vm.width / 2
		: align === 'right'
			? vm.x + vm.width - vm.xPadding
			: vm.x + vm.xPadding;
}

/**
 * Helper to build before and after body lines
 */
function getBeforeAfterBodyLines(callback) {
	return pushOrConcat([], splitNewlines(callback));
}

var exports$4 = core_element.extend({
	initialize: function() {
		this._model = getBaseModel(this._options);
		this._lastActive = [];
	},

	// Get the title
	// Args are: (tooltipItem, data)
	getTitle: function() {
		var me = this;
		var opts = me._options;
		var callbacks = opts.callbacks;

		var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
		var title = callbacks.title.apply(me, arguments);
		var afterTitle = callbacks.afterTitle.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeTitle));
		lines = pushOrConcat(lines, splitNewlines(title));
		lines = pushOrConcat(lines, splitNewlines(afterTitle));

		return lines;
	},

	// Args are: (tooltipItem, data)
	getBeforeBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
	},

	// Args are: (tooltipItem, data)
	getBody: function(tooltipItems, data) {
		var me = this;
		var callbacks = me._options.callbacks;
		var bodyItems = [];

		helpers$1.each(tooltipItems, function(tooltipItem) {
			var bodyItem = {
				before: [],
				lines: [],
				after: []
			};
			pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
			pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
			pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

			bodyItems.push(bodyItem);
		});

		return bodyItems;
	},

	// Args are: (tooltipItem, data)
	getAfterBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
	},

	// Get the footer and beforeFooter and afterFooter lines
	// Args are: (tooltipItem, data)
	getFooter: function() {
		var me = this;
		var callbacks = me._options.callbacks;

		var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
		var footer = callbacks.footer.apply(me, arguments);
		var afterFooter = callbacks.afterFooter.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeFooter));
		lines = pushOrConcat(lines, splitNewlines(footer));
		lines = pushOrConcat(lines, splitNewlines(afterFooter));

		return lines;
	},

	update: function(changed) {
		var me = this;
		var opts = me._options;

		// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
		// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
		// which breaks any animations.
		var existingModel = me._model;
		var model = me._model = getBaseModel(opts);
		var active = me._active;

		var data = me._data;

		// In the case where active.length === 0 we need to keep these at existing values for good animations
		var alignment = {
			xAlign: existingModel.xAlign,
			yAlign: existingModel.yAlign
		};
		var backgroundPoint = {
			x: existingModel.x,
			y: existingModel.y
		};
		var tooltipSize = {
			width: existingModel.width,
			height: existingModel.height
		};
		var tooltipPosition = {
			x: existingModel.caretX,
			y: existingModel.caretY
		};

		var i, len;

		if (active.length) {
			model.opacity = 1;

			var labelColors = [];
			var labelTextColors = [];
			tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

			var tooltipItems = [];
			for (i = 0, len = active.length; i < len; ++i) {
				tooltipItems.push(createTooltipItem(active[i]));
			}

			// If the user provided a filter function, use it to modify the tooltip items
			if (opts.filter) {
				tooltipItems = tooltipItems.filter(function(a) {
					return opts.filter(a, data);
				});
			}

			// If the user provided a sorting function, use it to modify the tooltip items
			if (opts.itemSort) {
				tooltipItems = tooltipItems.sort(function(a, b) {
					return opts.itemSort(a, b, data);
				});
			}

			// Determine colors for boxes
			helpers$1.each(tooltipItems, function(tooltipItem) {
				labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
				labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
			});


			// Build the Text Lines
			model.title = me.getTitle(tooltipItems, data);
			model.beforeBody = me.getBeforeBody(tooltipItems, data);
			model.body = me.getBody(tooltipItems, data);
			model.afterBody = me.getAfterBody(tooltipItems, data);
			model.footer = me.getFooter(tooltipItems, data);

			// Initial positioning and colors
			model.x = tooltipPosition.x;
			model.y = tooltipPosition.y;
			model.caretPadding = opts.caretPadding;
			model.labelColors = labelColors;
			model.labelTextColors = labelTextColors;

			// data points
			model.dataPoints = tooltipItems;

			// We need to determine alignment of the tooltip
			tooltipSize = getTooltipSize(this, model);
			alignment = determineAlignment(this, tooltipSize);
			// Final Size and Position
			backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
		} else {
			model.opacity = 0;
		}

		model.xAlign = alignment.xAlign;
		model.yAlign = alignment.yAlign;
		model.x = backgroundPoint.x;
		model.y = backgroundPoint.y;
		model.width = tooltipSize.width;
		model.height = tooltipSize.height;

		// Point where the caret on the tooltip points to
		model.caretX = tooltipPosition.x;
		model.caretY = tooltipPosition.y;

		me._model = model;

		if (changed && opts.custom) {
			opts.custom.call(me, model);
		}

		return me;
	},

	drawCaret: function(tooltipPoint, size) {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

		ctx.lineTo(caretPosition.x1, caretPosition.y1);
		ctx.lineTo(caretPosition.x2, caretPosition.y2);
		ctx.lineTo(caretPosition.x3, caretPosition.y3);
	},
	getCaretPosition: function(tooltipPoint, size, vm) {
		var x1, x2, x3, y1, y2, y3;
		var caretSize = vm.caretSize;
		var cornerRadius = vm.cornerRadius;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var ptX = tooltipPoint.x;
		var ptY = tooltipPoint.y;
		var width = size.width;
		var height = size.height;

		if (yAlign === 'center') {
			y2 = ptY + (height / 2);

			if (xAlign === 'left') {
				x1 = ptX;
				x2 = x1 - caretSize;
				x3 = x1;

				y1 = y2 + caretSize;
				y3 = y2 - caretSize;
			} else {
				x1 = ptX + width;
				x2 = x1 + caretSize;
				x3 = x1;

				y1 = y2 - caretSize;
				y3 = y2 + caretSize;
			}
		} else {
			if (xAlign === 'left') {
				x2 = ptX + cornerRadius + (caretSize);
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else if (xAlign === 'right') {
				x2 = ptX + width - cornerRadius - caretSize;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else {
				x2 = vm.caretX;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			}
			if (yAlign === 'top') {
				y1 = ptY;
				y2 = y1 - caretSize;
				y3 = y1;
			} else {
				y1 = ptY + height;
				y2 = y1 + caretSize;
				y3 = y1;
				// invert drawing order
				var tmp = x3;
				x3 = x1;
				x1 = tmp;
			}
		}
		return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
	},

	drawTitle: function(pt, vm, ctx) {
		var title = vm.title;
		var length = title.length;
		var titleFontSize, titleSpacing, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._titleAlign);

			ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
			ctx.textBaseline = 'middle';

			titleFontSize = vm.titleFontSize;
			titleSpacing = vm.titleSpacing;

			ctx.fillStyle = vm.titleFontColor;
			ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
				pt.y += titleFontSize + titleSpacing; // Line Height and spacing

				if (i + 1 === length) {
					pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
				}
			}
		}
	},

	drawBody: function(pt, vm, ctx) {
		var bodyFontSize = vm.bodyFontSize;
		var bodySpacing = vm.bodySpacing;
		var bodyAlign = vm._bodyAlign;
		var body = vm.body;
		var drawColorBoxes = vm.displayColors;
		var xLinePadding = 0;
		var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;

		var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

		var fillLineOfText = function(line) {
			ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
			pt.y += bodyFontSize + bodySpacing;
		};

		var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
		var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);

		ctx.textAlign = bodyAlign;
		ctx.textBaseline = 'middle';
		ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

		pt.x = getAlignedX(vm, bodyAlignForCalculation);

		// Before body lines
		ctx.fillStyle = vm.bodyFontColor;
		helpers$1.each(vm.beforeBody, fillLineOfText);

		xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
			? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
			: 0;

		// Draw body lines now
		for (i = 0, ilen = body.length; i < ilen; ++i) {
			bodyItem = body[i];
			textColor = vm.labelTextColors[i];
			labelColors = vm.labelColors[i];

			ctx.fillStyle = textColor;
			helpers$1.each(bodyItem.before, fillLineOfText);

			lines = bodyItem.lines;
			for (j = 0, jlen = lines.length; j < jlen; ++j) {
				// Draw Legend-like boxes if needed
				if (drawColorBoxes) {
					var rtlColorX = rtlHelper.x(colorX);

					// Fill a white rect so that colours merge nicely if the opacity is < 1
					ctx.fillStyle = vm.legendColorBackground;
					ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Border
					ctx.lineWidth = 1;
					ctx.strokeStyle = labelColors.borderColor;
					ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Inner square
					ctx.fillStyle = labelColors.backgroundColor;
					ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
					ctx.fillStyle = textColor;
				}

				fillLineOfText(lines[j]);
			}

			helpers$1.each(bodyItem.after, fillLineOfText);
		}

		// Reset back to 0 for after body
		xLinePadding = 0;

		// After body lines
		helpers$1.each(vm.afterBody, fillLineOfText);
		pt.y -= bodySpacing; // Remove last body spacing
	},

	drawFooter: function(pt, vm, ctx) {
		var footer = vm.footer;
		var length = footer.length;
		var footerFontSize, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._footerAlign);
			pt.y += vm.footerMarginTop;

			ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
			ctx.textBaseline = 'middle';

			footerFontSize = vm.footerFontSize;

			ctx.fillStyle = vm.footerFontColor;
			ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
				pt.y += footerFontSize + vm.footerSpacing;
			}
		}
	},

	drawBackground: function(pt, vm, ctx, tooltipSize) {
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var x = pt.x;
		var y = pt.y;
		var width = tooltipSize.width;
		var height = tooltipSize.height;
		var radius = vm.cornerRadius;

		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		if (yAlign === 'top') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width - radius, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
		if (yAlign === 'center' && xAlign === 'right') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width, y + height - radius);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
		if (yAlign === 'bottom') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + radius, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		if (yAlign === 'center' && xAlign === 'left') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x, y + radius);
		ctx.quadraticCurveTo(x, y, x + radius, y);
		ctx.closePath();

		ctx.fill();

		if (vm.borderWidth > 0) {
			ctx.stroke();
		}
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;

		if (vm.opacity === 0) {
			return;
		}

		var tooltipSize = {
			width: vm.width,
			height: vm.height
		};
		var pt = {
			x: vm.x,
			y: vm.y
		};

		// IE11/Edge does not like very small opacities, so snap to 0
		var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

		// Truthy/falsey value for empty tooltip
		var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

		if (this._options.enabled && hasTooltipContent) {
			ctx.save();
			ctx.globalAlpha = opacity;

			// Draw Background
			this.drawBackground(pt, vm, ctx, tooltipSize);

			// Draw Title, Body, and Footer
			pt.y += vm.yPadding;

			helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);

			// Titles
			this.drawTitle(pt, vm, ctx);

			// Body
			this.drawBody(pt, vm, ctx);

			// Footer
			this.drawFooter(pt, vm, ctx);

			helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);

			ctx.restore();
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me._options;
		var changed = false;

		me._lastActive = me._lastActive || [];

		// Find Active Elements for tooltips
		if (e.type === 'mouseout') {
			me._active = [];
		} else {
			me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			if (options.reverse) {
				me._active.reverse();
			}
		}

		// Remember Last Actives
		changed = !helpers$1.arrayEquals(me._active, me._lastActive);

		// Only handle target event on tooltip change
		if (changed) {
			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				me.update(true);
				me.pivot();
			}
		}

		return changed;
	}
});

/**
 * @namespace Chart.Tooltip.positioners
 */
var positioners_1 = positioners;

var core_tooltip = exports$4;
core_tooltip.positioners = positioners_1;

var valueOrDefault$9 = helpers$1.valueOrDefault;

core_defaults._set('global', {
	elements: {},
	events: [
		'mousemove',
		'mouseout',
		'click',
		'touchstart',
		'touchmove'
	],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	maintainAspectRatio: true,
	responsive: true,
	responsiveAnimationDuration: 0
});

/**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */
function mergeScaleConfig(/* config objects ... */) {
	return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			if (key === 'xAxes' || key === 'yAxes') {
				var slen = source[key].length;
				var i, type, scale;

				if (!target[key]) {
					target[key] = [];
				}

				for (i = 0; i < slen; ++i) {
					scale = source[key][i];
					type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');

					if (i >= target[key].length) {
						target[key].push({});
					}

					if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
						// new/untyped scale or type changed: let's apply the new defaults
						// then merge source scale to correctly overwrite the defaults.
						helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
					} else {
						// scales type are the same
						helpers$1.merge(target[key][i], scale);
					}
				}
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

/**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */
function mergeConfig(/* config objects ... */) {
	return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			var tval = target[key] || Object.create(null);
			var sval = source[key];

			if (key === 'scales') {
				// scale config merging is complex. Add our own function here for that
				target[key] = mergeScaleConfig(tval, sval);
			} else if (key === 'scale') {
				// used in polar area & radar charts since there is only one scale
				target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

function initConfig(config) {
	config = config || Object.create(null);

	// Do NOT use mergeConfig for the data object because this method merges arrays
	// and so would change references to labels and datasets, preventing data updates.
	var data = config.data = config.data || {};
	data.datasets = data.datasets || [];
	data.labels = data.labels || [];

	config.options = mergeConfig(
		core_defaults.global,
		core_defaults[config.type],
		config.options || {});

	return config;
}

function updateConfig(chart) {
	var newOptions = chart.options;

	helpers$1.each(chart.scales, function(scale) {
		core_layouts.removeBox(chart, scale);
	});

	newOptions = mergeConfig(
		core_defaults.global,
		core_defaults[chart.config.type],
		newOptions);

	chart.options = chart.config.options = newOptions;
	chart.ensureScalesHaveIDs();
	chart.buildOrUpdateScales();

	// Tooltip
	chart.tooltip._options = newOptions.tooltips;
	chart.tooltip.initialize();
}

function nextAvailableScaleId(axesOpts, prefix, index) {
	var id;
	var hasId = function(obj) {
		return obj.id === id;
	};

	do {
		id = prefix + index++;
	} while (helpers$1.findIndex(axesOpts, hasId) >= 0);

	return id;
}

function positionIsHorizontal(position) {
	return position === 'top' || position === 'bottom';
}

function compare2Level(l1, l2) {
	return function(a, b) {
		return a[l1] === b[l1]
			? a[l2] - b[l2]
			: a[l1] - b[l1];
	};
}

var Chart = function(item, config) {
	this.construct(item, config);
	return this;
};

helpers$1.extend(Chart.prototype, /** @lends Chart */ {
	/**
	 * @private
	 */
	construct: function(item, config) {
		var me = this;

		config = initConfig(config);

		var context = platform.acquireContext(item, config);
		var canvas = context && context.canvas;
		var height = canvas && canvas.height;
		var width = canvas && canvas.width;

		me.id = helpers$1.uid();
		me.ctx = context;
		me.canvas = canvas;
		me.config = config;
		me.width = width;
		me.height = height;
		me.aspectRatio = height ? width / height : null;
		me.options = config.options;
		me._bufferedRender = false;
		me._layers = [];

		/**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		me.chart = me;
		me.controller = me; // chart.chart.controller #inception

		// Add the chart instance to the global namespace
		Chart.instances[me.id] = me;

		// Define alias to the config data: `chart.data === chart.config.data`
		Object.defineProperty(me, 'data', {
			get: function() {
				return me.config.data;
			},
			set: function(value) {
				me.config.data = value;
			}
		});

		if (!context || !canvas) {
			// The given item is not a compatible context2d element, let's return before finalizing
			// the chart initialization but after setting basic chart / controller properties that
			// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
			// https://github.com/chartjs/Chart.js/issues/2807
			console.error("Failed to create chart: can't acquire context from the given item");
			return;
		}

		me.initialize();
		me.update();
	},

	/**
	 * @private
	 */
	initialize: function() {
		var me = this;

		// Before init plugin notification
		core_plugins.notify(me, 'beforeInit');

		helpers$1.retinaScale(me, me.options.devicePixelRatio);

		me.bindEvents();

		if (me.options.responsive) {
			// Initial resize before chart draws (must be silent to preserve initial animations).
			me.resize(true);
		}

		me.initToolTip();

		// After init plugin notification
		core_plugins.notify(me, 'afterInit');

		return me;
	},

	clear: function() {
		helpers$1.canvas.clear(this);
		return this;
	},

	stop: function() {
		// Stops any current animation loop occurring
		core_animations.cancelAnimation(this);
		return this;
	},

	resize: function(silent) {
		var me = this;
		var options = me.options;
		var canvas = me.canvas;
		var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

		// the canvas render width and height will be casted to integers so make sure that
		// the canvas display style uses the same integer values to avoid blurring effect.

		// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
		var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
		var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));

		if (me.width === newWidth && me.height === newHeight) {
			return;
		}

		canvas.width = me.width = newWidth;
		canvas.height = me.height = newHeight;
		canvas.style.width = newWidth + 'px';
		canvas.style.height = newHeight + 'px';

		helpers$1.retinaScale(me, options.devicePixelRatio);

		if (!silent) {
			// Notify any plugins about the resize
			var newSize = {width: newWidth, height: newHeight};
			core_plugins.notify(me, 'resize', [newSize]);

			// Notify of resize
			if (options.onResize) {
				options.onResize(me, newSize);
			}

			me.stop();
			me.update({
				duration: options.responsiveAnimationDuration
			});
		}
	},

	ensureScalesHaveIDs: function() {
		var options = this.options;
		var scalesOptions = options.scales || {};
		var scaleOptions = options.scale;

		helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
			if (!xAxisOptions.id) {
				xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
			}
		});

		helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
			if (!yAxisOptions.id) {
				yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
			}
		});

		if (scaleOptions) {
			scaleOptions.id = scaleOptions.id || 'scale';
		}
	},

	/**
	 * Builds a map of scale ID to scale object for future lookup.
	 */
	buildOrUpdateScales: function() {
		var me = this;
		var options = me.options;
		var scales = me.scales || {};
		var items = [];
		var updated = Object.keys(scales).reduce(function(obj, id) {
			obj[id] = false;
			return obj;
		}, {});

		if (options.scales) {
			items = items.concat(
				(options.scales.xAxes || []).map(function(xAxisOptions) {
					return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
				}),
				(options.scales.yAxes || []).map(function(yAxisOptions) {
					return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
				})
			);
		}

		if (options.scale) {
			items.push({
				options: options.scale,
				dtype: 'radialLinear',
				isDefault: true,
				dposition: 'chartArea'
			});
		}

		helpers$1.each(items, function(item) {
			var scaleOptions = item.options;
			var id = scaleOptions.id;
			var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);

			if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
				scaleOptions.position = item.dposition;
			}

			updated[id] = true;
			var scale = null;
			if (id in scales && scales[id].type === scaleType) {
				scale = scales[id];
				scale.options = scaleOptions;
				scale.ctx = me.ctx;
				scale.chart = me;
			} else {
				var scaleClass = core_scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}
				scale = new scaleClass({
					id: id,
					type: scaleType,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});
				scales[scale.id] = scale;
			}

			scale.mergeTicksOptions();

			// TODO(SB): I think we should be able to remove this custom case (options.scale)
			// and consider it as a regular scale part of the "scales"" map only! This would
			// make the logic easier and remove some useless? custom code.
			if (item.isDefault) {
				me.scale = scale;
			}
		});
		// clear up discarded scales
		helpers$1.each(updated, function(hasUpdated, id) {
			if (!hasUpdated) {
				delete scales[id];
			}
		});

		me.scales = scales;

		core_scaleService.addScalesToLayout(this);
	},

	buildOrUpdateControllers: function() {
		var me = this;
		var newControllers = [];
		var datasets = me.data.datasets;
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			var dataset = datasets[i];
			var meta = me.getDatasetMeta(i);
			var type = dataset.type || me.config.type;

			if (meta.type && meta.type !== type) {
				me.destroyDatasetMeta(i);
				meta = me.getDatasetMeta(i);
			}
			meta.type = type;
			meta.order = dataset.order || 0;
			meta.index = i;

			if (meta.controller) {
				meta.controller.updateIndex(i);
				meta.controller.linkScales();
			} else {
				var ControllerClass = controllers[meta.type];
				if (ControllerClass === undefined) {
					throw new Error('"' + meta.type + '" is not a chart type.');
				}

				meta.controller = new ControllerClass(me, i);
				newControllers.push(meta.controller);
			}
		}

		return newControllers;
	},

	/**
	 * Reset the elements of all datasets
	 * @private
	 */
	resetElements: function() {
		var me = this;
		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			me.getDatasetMeta(datasetIndex).controller.reset();
		}, me);
	},

	/**
	* Resets the chart back to it's state before the initial animation
	*/
	reset: function() {
		this.resetElements();
		this.tooltip.initialize();
	},

	update: function(config) {
		var me = this;
		var i, ilen;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		updateConfig(me);

		// plugins options references might have change, let's invalidate the cache
		// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		core_plugins._invalidate(me);

		if (core_plugins.notify(me, 'beforeUpdate') === false) {
			return;
		}

		// In case the entire data object changed
		me.tooltip._data = me.data;

		// Make sure dataset controllers are updated and new controllers are reset
		var newControllers = me.buildOrUpdateControllers();

		// Make sure all dataset controllers have correct meta data counts
		for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
			me.getDatasetMeta(i).controller.buildOrUpdateElements();
		}

		me.updateLayout();

		// Can only reset the new controllers after the scales have been updated
		if (me.options.animation && me.options.animation.duration) {
			helpers$1.each(newControllers, function(controller) {
				controller.reset();
			});
		}

		me.updateDatasets();

		// Need to reset tooltip in case it is displayed with elements that are removed
		// after update.
		me.tooltip.initialize();

		// Last active contains items that were previously in the tooltip.
		// When we reset the tooltip, we need to clear it
		me.lastActive = [];

		// Do this before render so that any plugins that need final scale updates can use it
		core_plugins.notify(me, 'afterUpdate');

		me._layers.sort(compare2Level('z', '_idx'));

		if (me._bufferedRender) {
			me._bufferedRequest = {
				duration: config.duration,
				easing: config.easing,
				lazy: config.lazy
			};
		} else {
			me.render(config);
		}
	},

	/**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */
	updateLayout: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeLayout') === false) {
			return;
		}

		core_layouts.update(this, this.width, this.height);

		me._layers = [];
		helpers$1.each(me.boxes, function(box) {
			// _configure is called twice, once in core.scale.update and once here.
			// Here the boxes are fully updated and at their final positions.
			if (box._configure) {
				box._configure();
			}
			me._layers.push.apply(me._layers, box._layers());
		}, me);

		me._layers.forEach(function(item, index) {
			item._idx = index;
		});

		/**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		core_plugins.notify(me, 'afterScaleUpdate');
		core_plugins.notify(me, 'afterLayout');
	},

	/**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */
	updateDatasets: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
			return;
		}

		for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.updateDataset(i);
		}

		core_plugins.notify(me, 'afterDatasetsUpdate');
	},

	/**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */
	updateDataset: function(index) {
		var me = this;
		var meta = me.getDatasetMeta(index);
		var args = {
			meta: meta,
			index: index
		};

		if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
			return;
		}

		meta.controller._update();

		core_plugins.notify(me, 'afterDatasetUpdate', [args]);
	},

	render: function(config) {
		var me = this;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		var animationOptions = me.options.animation;
		var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
		var lazy = config.lazy;

		if (core_plugins.notify(me, 'beforeRender') === false) {
			return;
		}

		var onComplete = function(animation) {
			core_plugins.notify(me, 'afterRender');
			helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
		};

		if (animationOptions && duration) {
			var animation = new core_animation({
				numSteps: duration / 16.66, // 60 fps
				easing: config.easing || animationOptions.easing,

				render: function(chart, animationObject) {
					var easingFunction = helpers$1.easing.effects[animationObject.easing];
					var currentStep = animationObject.currentStep;
					var stepDecimal = currentStep / animationObject.numSteps;

					chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
				},

				onAnimationProgress: animationOptions.onProgress,
				onAnimationComplete: onComplete
			});

			core_animations.addAnimation(me, animation, duration, lazy);
		} else {
			me.draw();

			// See https://github.com/chartjs/Chart.js/issues/3781
			onComplete(new core_animation({numSteps: 0, chart: me}));
		}

		return me;
	},

	draw: function(easingValue) {
		var me = this;
		var i, layers;

		me.clear();

		if (helpers$1.isNullOrUndef(easingValue)) {
			easingValue = 1;
		}

		me.transition(easingValue);

		if (me.width <= 0 || me.height <= 0) {
			return;
		}

		if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
			return;
		}

		// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
		// currently be part of layers. Instead, we draw
		// layers <= 0 before(default, backward compat), and the rest after
		layers = me._layers;
		for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
			layers[i].draw(me.chartArea);
		}

		me.drawDatasets(easingValue);

		// Rest of layers
		for (; i < layers.length; ++i) {
			layers[i].draw(me.chartArea);
		}

		me._drawTooltip(easingValue);

		core_plugins.notify(me, 'afterDraw', [easingValue]);
	},

	/**
	 * @private
	 */
	transition: function(easingValue) {
		var me = this;

		for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
			if (me.isDatasetVisible(i)) {
				me.getDatasetMeta(i).controller.transition(easingValue);
			}
		}

		me.tooltip.transition(easingValue);
	},

	/**
	 * @private
	 */
	_getSortedDatasetMetas: function(filterVisible) {
		var me = this;
		var datasets = me.data.datasets || [];
		var result = [];
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!filterVisible || me.isDatasetVisible(i)) {
				result.push(me.getDatasetMeta(i));
			}
		}

		result.sort(compare2Level('order', 'index'));

		return result;
	},

	/**
	 * @private
	 */
	_getSortedVisibleDatasetMetas: function() {
		return this._getSortedDatasetMetas(true);
	},

	/**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */
	drawDatasets: function(easingValue) {
		var me = this;
		var metasets, i;

		if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
			return;
		}

		metasets = me._getSortedVisibleDatasetMetas();
		for (i = metasets.length - 1; i >= 0; --i) {
			me.drawDataset(metasets[i], easingValue);
		}

		core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
	},

	/**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */
	drawDataset: function(meta, easingValue) {
		var me = this;
		var args = {
			meta: meta,
			index: meta.index,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
			return;
		}

		meta.controller.draw(easingValue);

		core_plugins.notify(me, 'afterDatasetDraw', [args]);
	},

	/**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */
	_drawTooltip: function(easingValue) {
		var me = this;
		var tooltip = me.tooltip;
		var args = {
			tooltip: tooltip,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
			return;
		}

		tooltip.draw();

		core_plugins.notify(me, 'afterTooltipDraw', [args]);
	},

	/**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */
	getElementAtEvent: function(e) {
		return core_interaction.modes.single(this, e);
	},

	getElementsAtEvent: function(e) {
		return core_interaction.modes.label(this, e, {intersect: true});
	},

	getElementsAtXAxis: function(e) {
		return core_interaction.modes['x-axis'](this, e, {intersect: true});
	},

	getElementsAtEventForMode: function(e, mode, options) {
		var method = core_interaction.modes[mode];
		if (typeof method === 'function') {
			return method(this, e, options);
		}

		return [];
	},

	getDatasetAtEvent: function(e) {
		return core_interaction.modes.dataset(this, e, {intersect: true});
	},

	getDatasetMeta: function(datasetIndex) {
		var me = this;
		var dataset = me.data.datasets[datasetIndex];
		if (!dataset._meta) {
			dataset._meta = {};
		}

		var meta = dataset._meta[me.id];
		if (!meta) {
			meta = dataset._meta[me.id] = {
				type: null,
				data: [],
				dataset: null,
				controller: null,
				hidden: null,			// See isDatasetVisible() comment
				xAxisID: null,
				yAxisID: null,
				order: dataset.order || 0,
				index: datasetIndex
			};
		}

		return meta;
	},

	getVisibleDatasetCount: function() {
		var count = 0;
		for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
			if (this.isDatasetVisible(i)) {
				count++;
			}
		}
		return count;
	},

	isDatasetVisible: function(datasetIndex) {
		var meta = this.getDatasetMeta(datasetIndex);

		// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
		// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
		return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
	},

	generateLegend: function() {
		return this.options.legendCallback(this);
	},

	/**
	 * @private
	 */
	destroyDatasetMeta: function(datasetIndex) {
		var id = this.id;
		var dataset = this.data.datasets[datasetIndex];
		var meta = dataset._meta && dataset._meta[id];

		if (meta) {
			meta.controller.destroy();
			delete dataset._meta[id];
		}
	},

	destroy: function() {
		var me = this;
		var canvas = me.canvas;
		var i, ilen;

		me.stop();

		// dataset controllers need to cleanup associated data
		for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.destroyDatasetMeta(i);
		}

		if (canvas) {
			me.unbindEvents();
			helpers$1.canvas.clear(me);
			platform.releaseContext(me.ctx);
			me.canvas = null;
			me.ctx = null;
		}

		core_plugins.notify(me, 'destroy');

		delete Chart.instances[me.id];
	},

	toBase64Image: function() {
		return this.canvas.toDataURL.apply(this.canvas, arguments);
	},

	initToolTip: function() {
		var me = this;
		me.tooltip = new core_tooltip({
			_chart: me,
			_chartInstance: me, // deprecated, backward compatibility
			_data: me.data,
			_options: me.options.tooltips
		}, me);
	},

	/**
	 * @private
	 */
	bindEvents: function() {
		var me = this;
		var listeners = me._listeners = {};
		var listener = function() {
			me.eventHandler.apply(me, arguments);
		};

		helpers$1.each(me.options.events, function(type) {
			platform.addEventListener(me, type, listener);
			listeners[type] = listener;
		});

		// Elements used to detect size change should not be injected for non responsive charts.
		// See https://github.com/chartjs/Chart.js/issues/2210
		if (me.options.responsive) {
			listener = function() {
				me.resize();
			};

			platform.addEventListener(me, 'resize', listener);
			listeners.resize = listener;
		}
	},

	/**
	 * @private
	 */
	unbindEvents: function() {
		var me = this;
		var listeners = me._listeners;
		if (!listeners) {
			return;
		}

		delete me._listeners;
		helpers$1.each(listeners, function(listener, type) {
			platform.removeEventListener(me, type, listener);
		});
	},

	updateHoverStyle: function(elements, mode, enabled) {
		var prefix = enabled ? 'set' : 'remove';
		var element, i, ilen;

		for (i = 0, ilen = elements.length; i < ilen; ++i) {
			element = elements[i];
			if (element) {
				this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
			}
		}

		if (mode === 'dataset') {
			this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
		}
	},

	/**
	 * @private
	 */
	eventHandler: function(e) {
		var me = this;
		var tooltip = me.tooltip;

		if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
			return;
		}

		// Buffer any update calls so that renders do not occur
		me._bufferedRender = true;
		me._bufferedRequest = null;

		var changed = me.handleEvent(e);
		// for smooth tooltip animations issue #4989
		// the tooltip should be the source of change
		// Animation check workaround:
		// tooltip._start will be null when tooltip isn't animating
		if (tooltip) {
			changed = tooltip._start
				? tooltip.handleEvent(e)
				: changed | tooltip.handleEvent(e);
		}

		core_plugins.notify(me, 'afterEvent', [e]);

		var bufferedRequest = me._bufferedRequest;
		if (bufferedRequest) {
			// If we have an update that was triggered, we need to do a normal render
			me.render(bufferedRequest);
		} else if (changed && !me.animating) {
			// If entering, leaving, or changing elements, animate the change via pivot
			me.stop();

			// We only need to render at this point. Updating will cause scales to be
			// recomputed generating flicker & using more memory than necessary.
			me.render({
				duration: me.options.hover.animationDuration,
				lazy: true
			});
		}

		me._bufferedRender = false;
		me._bufferedRequest = null;

		return me;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me.options || {};
		var hoverOptions = options.hover;
		var changed = false;

		me.lastActive = me.lastActive || [];

		// Find Active Elements for hover and tooltips
		if (e.type === 'mouseout') {
			me.active = [];
		} else {
			me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
		}

		// Invoke onHover hook
		// Need to call with native event here to not break backwards compatibility
		helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

		if (e.type === 'mouseup' || e.type === 'click') {
			if (options.onClick) {
				// Use e.native here for backwards compatibility
				options.onClick.call(me, e.native, me.active);
			}
		}

		// Remove styling for last active (even if it may still be active)
		if (me.lastActive.length) {
			me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
		}

		// Built in hover styling
		if (me.active.length && hoverOptions.mode) {
			me.updateHoverStyle(me.active, hoverOptions.mode, true);
		}

		changed = !helpers$1.arrayEquals(me.active, me.lastActive);

		// Remember Last Actives
		me.lastActive = me.active;

		return changed;
	}
});

/**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */
Chart.instances = {};

var core_controller = Chart;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */
Chart.Controller = Chart;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
Chart.types = {};

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.configMerge = mergeConfig;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.scaleMerge = mergeScaleConfig;

var core_helpers = function() {

	// -- Basic js utility methods

	helpers$1.where = function(collection, filterCallback) {
		if (helpers$1.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers$1.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers$1.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers$1.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers$1.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers$1.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
	};
	helpers$1.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers$1.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers$1.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers$1.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers$1.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};

	/**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */
	helpers$1._decimalPlaces = function(x) {
		if (!helpers$1.isFinite(x)) {
			return;
		}
		var e = 1;
		var p = 0;
		while (Math.round(x * e) / e !== x) {
			e *= 10;
			p++;
		}
		return p;
	};

	// Gets the angle from vertical upright to the point about a centre.
	helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers$1.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	helpers$1.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};

	/**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */
	helpers$1._alignPixel = function(chart, pixel, width) {
		var devicePixelRatio = chart.currentDevicePixelRatio;
		var halfWidth = width / 2;
		return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
	};

	helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers$1.EPSILON = Number.EPSILON || 1e-14;
	helpers$1.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers$1.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers$1.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers$1.niceNum = function(range, round) {
		var exponent = Math.floor(helpers$1.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers$1.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers$1.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.target || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	/**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = helpers$1._getParentNode(domNode);
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers$1.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers$1.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	/**
	 * @private
 	 */
	helpers$1._calculatePadding = function(container, padding, parentDimension) {
		padding = helpers$1.getStyle(container, padding);

		return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
	};
	/**
	 * @private
	 */
	helpers$1._getParentNode = function(domNode) {
		var parent = domNode.parentNode;
		if (parent && parent.toString() === '[object ShadowRoot]') {
			parent = parent.host;
		}
		return parent;
	};
	helpers$1.getMaximumWidth = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientWidth;
		}

		var clientWidth = container.clientWidth;
		var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
		var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);

		var w = clientWidth - paddingLeft - paddingRight;
		var cw = helpers$1.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers$1.getMaximumHeight = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientHeight;
		}

		var clientHeight = container.clientHeight;
		var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
		var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);

		var h = clientHeight - paddingTop - paddingBottom;
		var ch = helpers$1.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers$1.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers$1.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		var ilen = arrayOfThings.length;
		var i, j, jlen, thing, nestedThing;
		for (i = 0; i < ilen; i++) {
			thing = arrayOfThings[i];

			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
				longest = helpers$1.measureText(ctx, data, gc, longest, thing);
			} else if (helpers$1.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				for (j = 0, jlen = thing.length; j < jlen; j++) {
					nestedThing = thing[j];
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
						longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
					}
				}
			}
		}

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers$1.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};

	/**
	 * @deprecated
	 */
	helpers$1.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers$1.each(arrayOfThings, function(thing) {
			if (helpers$1.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers$1.color = !chartjsColor ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = core_defaults.global.defaultColor;
			}

			return chartjsColor(value);
		};

	helpers$1.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
			colorValue :
			helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};

function abstract() {
	throw new Error(
		'This method is not implemented: either no adapter can ' +
		'be found or an incomplete integration was provided.'
	);
}

/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */

/**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */

/**
 * @class
 */
function DateAdapter(options) {
	this.options = options || {};
}

helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
	/**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */
	formats: abstract,

	/**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */
	parse: abstract,

	/**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */
	format: abstract,

	/**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	add: abstract,

	/**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	diff: abstract,

	/**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */
	startOf: abstract,

	/**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */
	endOf: abstract,

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(value) {
		return value;
	}
});

DateAdapter.override = function(members) {
	helpers$1.extend(DateAdapter.prototype, members);
};

var _date = DateAdapter;

var core_adapters = {
	_date: _date
};

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
var core_ticks = {
	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */
		values: function(value) {
			return helpers$1.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers$1.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
				if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
					var logTick = helpers$1.log10(Math.abs(tickValue));
					var numExponential = Math.floor(logTick) - Math.floor(logDelta);
					numExponential = Math.max(Math.min(numExponential, 20), 0);
					tickString = tickValue.toExponential(numExponential);
				} else {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				}
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};

var isArray = helpers$1.isArray;
var isNullOrUndef = helpers$1.isNullOrUndef;
var valueOrDefault$a = helpers$1.valueOrDefault;
var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;

core_defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: core_ticks.formatters.values,
		minor: {},
		major: {}
	}
});

/** Returns a new array containing numItems from arr */
function sample(arr, numItems) {
	var result = [];
	var increment = arr.length / numItems;
	var i = 0;
	var len = arr.length;

	for (; i < len; i += increment) {
		result.push(arr[Math.floor(i)]);
	}
	return result;
}

function getPixelForGridLine(scale, index, offsetGridLines) {
	var length = scale.getTicks().length;
	var validIndex = Math.min(index, length - 1);
	var lineValue = scale.getPixelForTick(validIndex);
	var start = scale._startPixel;
	var end = scale._endPixel;
	var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	var offset;

	if (offsetGridLines) {
		if (length === 1) {
			offset = Math.max(lineValue - start, end - lineValue);
		} else if (index === 0) {
			offset = (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
		}
		lineValue += validIndex < index ? offset : -offset;

		// Return undefined if the pixel is out of the range
		if (lineValue < start - epsilon || lineValue > end + epsilon) {
			return;
		}
	}
	return lineValue;
}

function garbageCollect(caches, length) {
	helpers$1.each(caches, function(cache) {
		var gc = cache.gc;
		var gcLen = gc.length / 2;
		var i;
		if (gcLen > length) {
			for (i = 0; i < gcLen; ++i) {
				delete cache.data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
	});
}

/**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */
function computeLabelSizes(ctx, tickFonts, ticks, caches) {
	var length = ticks.length;
	var widths = [];
	var heights = [];
	var offsets = [];
	var widestLabelSize = 0;
	var highestLabelSize = 0;
	var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;

	for (i = 0; i < length; ++i) {
		label = ticks[i].label;
		tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
		ctx.font = fontString = tickFont.string;
		cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
		lineHeight = tickFont.lineHeight;
		width = height = 0;
		// Undefined labels and arrays should not be measured
		if (!isNullOrUndef(label) && !isArray(label)) {
			width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
			height = lineHeight;
		} else if (isArray(label)) {
			// if it is an array let's measure each element
			for (j = 0, jlen = label.length; j < jlen; ++j) {
				nestedLabel = label[j];
				// Undefined labels and arrays should not be measured
				if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
					width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
					height += lineHeight;
				}
			}
		}
		widths.push(width);
		heights.push(height);
		offsets.push(lineHeight / 2);
		widestLabelSize = Math.max(width, widestLabelSize);
		highestLabelSize = Math.max(height, highestLabelSize);
	}
	garbageCollect(caches, length);

	widest = widths.indexOf(widestLabelSize);
	highest = heights.indexOf(highestLabelSize);

	function valueAt(idx) {
		return {
			width: widths[idx] || 0,
			height: heights[idx] || 0,
			offset: offsets[idx] || 0
		};
	}

	return {
		first: valueAt(0),
		last: valueAt(length - 1),
		widest: valueAt(widest),
		highest: valueAt(highest)
	};
}

function getTickMarkLength(options) {
	return options.drawTicks ? options.tickMarkLength : 0;
}

function getScaleLabelHeight(options) {
	var font, padding;

	if (!options.display) {
		return 0;
	}

	font = helpers$1.options._parseFont(options);
	padding = helpers$1.options.toPadding(options.padding);

	return font.lineHeight + padding.height;
}

function parseFontOptions(options, nestedOpts) {
	return helpers$1.extend(helpers$1.options._parseFont({
		fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
		fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
		fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
		lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
	}), {
		color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
	});
}

function parseTickFontOptions(options) {
	var minor = parseFontOptions(options, options.minor);
	var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;

	return {minor: minor, major: major};
}

function nonSkipped(ticksToFilter) {
	var filtered = [];
	var item, index, len;
	for (index = 0, len = ticksToFilter.length; index < len; ++index) {
		item = ticksToFilter[index];
		if (typeof item._index !== 'undefined') {
			filtered.push(item);
		}
	}
	return filtered;
}

function getEvenSpacing(arr) {
	var len = arr.length;
	var i, diff;

	if (len < 2) {
		return false;
	}

	for (diff = arr[0], i = 1; i < len; ++i) {
		if (arr[i] - arr[i - 1] !== diff) {
			return false;
		}
	}
	return diff;
}

function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
	var evenMajorSpacing = getEvenSpacing(majorIndices);
	var spacing = (ticks.length - 1) / ticksLimit;
	var factors, factor, i, ilen;

	// If the major ticks are evenly spaced apart, place the minor ticks
	// so that they divide the major ticks into even chunks
	if (!evenMajorSpacing) {
		return Math.max(spacing, 1);
	}

	factors = helpers$1.math._factorize(evenMajorSpacing);
	for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
		factor = factors[i];
		if (factor > spacing) {
			return factor;
		}
	}
	return Math.max(spacing, 1);
}

function getMajorIndices(ticks) {
	var result = [];
	var i, ilen;
	for (i = 0, ilen = ticks.length; i < ilen; i++) {
		if (ticks[i].major) {
			result.push(i);
		}
	}
	return result;
}

function skipMajors(ticks, majorIndices, spacing) {
	var count = 0;
	var next = majorIndices[0];
	var i, tick;

	spacing = Math.ceil(spacing);
	for (i = 0; i < ticks.length; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = majorIndices[count * spacing];
		} else {
			delete tick.label;
		}
	}
}

function skip(ticks, spacing, majorStart, majorEnd) {
	var start = valueOrDefault$a(majorStart, 0);
	var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
	var count = 0;
	var length, i, tick, next;

	spacing = Math.ceil(spacing);
	if (majorEnd) {
		length = majorEnd - majorStart;
		spacing = length / Math.floor(length / spacing);
	}

	next = start;

	while (next < 0) {
		count++;
		next = Math.round(start + count * spacing);
	}

	for (i = Math.max(start, 0); i < end; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = Math.round(start + count * spacing);
		} else {
			delete tick.label;
		}
	}
}

var Scale = core_element.extend({

	zeroLineIndex: 0,

	/**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */
	getPadding: function() {
		var me = this;
		return {
			left: me.paddingLeft || 0,
			top: me.paddingTop || 0,
			right: me.paddingRight || 0,
			bottom: me.paddingBottom || 0
		};
	},

	/**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */
	getTicks: function() {
		return this._ticks;
	},

	/**
	* @private
	*/
	_getLabels: function() {
		var data = this.chart.data;
		return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
	},

	// These methods are ordered by lifecyle. Utilities then follow.
	// Any function defined here is inherited by all scale types.
	// Any function can be extended by the scale type

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	mergeTicksOptions: function() {
		// noop
	},

	beforeUpdate: function() {
		helpers$1.callback(this.options.beforeUpdate, [this]);
	},

	/**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */
	update: function(maxWidth, maxHeight, margins) {
		var me = this;
		var tickOpts = me.options.ticks;
		var sampleSize = tickOpts.sampleSize;
		var i, ilen, labels, ticks, samplingEnabled;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = helpers$1.extend({
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}, margins);

		me._ticks = null;
		me.ticks = null;
		me._labelSizes = null;
		me._maxLabelLines = 0;
		me.longestLabelWidth = 0;
		me.longestTextCache = me.longestTextCache || {};
		me._gridLineItems = null;
		me._labelItems = null;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();

		// Data min/max
		me.beforeDataLimits();
		me.determineDataLimits();
		me.afterDataLimits();

		// Ticks - `this.ticks` is now DEPRECATED!
		// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
		// and must not be accessed directly from outside this class. `this.ticks` being
		// around for long time and not marked as private, we can't change its structure
		// without unexpected breaking changes. If you need to access the scale ticks,
		// use scale.getTicks() instead.

		me.beforeBuildTicks();

		// New implementations should return an array of objects but for BACKWARD COMPAT,
		// we still support no return (`this.ticks` internally set by calling this method).
		ticks = me.buildTicks() || [];

		// Allow modification of ticks in callback.
		ticks = me.afterBuildTicks(ticks) || ticks;

		// Ensure ticks contains ticks in new tick format
		if ((!ticks || !ticks.length) && me.ticks) {
			ticks = [];
			for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
				ticks.push({
					value: me.ticks[i],
					major: false
				});
			}
		}

		me._ticks = ticks;

		// Compute tick rotation and fit using a sampled subset of labels
		// We generally don't need to compute the size of every single label for determining scale size
		samplingEnabled = sampleSize < ticks.length;
		labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);

		// _configure is called twice, once here, once from core.controller.updateLayout.
		// Here we haven't been positioned yet, but dimensions are correct.
		// Variables set in _configure are needed for calculateTickRotation, and
		// it's ok that coordinates are not correct there, only dimensions matter.
		me._configure();

		// Tick Rotation
		me.beforeCalculateTickRotation();
		me.calculateTickRotation();
		me.afterCalculateTickRotation();

		me.beforeFit();
		me.fit();
		me.afterFit();

		// Auto-skip
		me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;

		if (samplingEnabled) {
			// Generate labels using all non-skipped ticks
			labels = me._convertTicksToLabels(me._ticksToDraw);
		}

		me.ticks = labels;   // BACKWARD COMPATIBILITY

		// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!

		me.afterUpdate();

		// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
		// make maxWidth and maxHeight private
		return me.minSize;
	},

	/**
	 * @private
	 */
	_configure: function() {
		var me = this;
		var reversePixels = me.options.ticks.reverse;
		var startPixel, endPixel;

		if (me.isHorizontal()) {
			startPixel = me.left;
			endPixel = me.right;
		} else {
			startPixel = me.top;
			endPixel = me.bottom;
			// by default vertical scales are from bottom to top, so pixels are reversed
			reversePixels = !reversePixels;
		}
		me._startPixel = startPixel;
		me._endPixel = endPixel;
		me._reversePixels = reversePixels;
		me._length = endPixel - startPixel;
	},

	afterUpdate: function() {
		helpers$1.callback(this.options.afterUpdate, [this]);
	},

	//

	beforeSetDimensions: function() {
		helpers$1.callback(this.options.beforeSetDimensions, [this]);
	},
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;
	},
	afterSetDimensions: function() {
		helpers$1.callback(this.options.afterSetDimensions, [this]);
	},

	// Data limits
	beforeDataLimits: function() {
		helpers$1.callback(this.options.beforeDataLimits, [this]);
	},
	determineDataLimits: helpers$1.noop,
	afterDataLimits: function() {
		helpers$1.callback(this.options.afterDataLimits, [this]);
	},

	//
	beforeBuildTicks: function() {
		helpers$1.callback(this.options.beforeBuildTicks, [this]);
	},
	buildTicks: helpers$1.noop,
	afterBuildTicks: function(ticks) {
		var me = this;
		// ticks is empty for old axis implementations here
		if (isArray(ticks) && ticks.length) {
			return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
		}
		// Support old implementations (that modified `this.ticks` directly in buildTicks)
		me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
		return ticks;
	},

	beforeTickToLabelConversion: function() {
		helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
	},
	convertTicksToLabels: function() {
		var me = this;
		// Convert ticks to strings
		var tickOpts = me.options.ticks;
		me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
	},
	afterTickToLabelConversion: function() {
		helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
	},

	//

	beforeCalculateTickRotation: function() {
		helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
	},
	calculateTickRotation: function() {
		var me = this;
		var options = me.options;
		var tickOpts = options.ticks;
		var numTicks = me.getTicks().length;
		var minRotation = tickOpts.minRotation || 0;
		var maxRotation = tickOpts.maxRotation;
		var labelRotation = minRotation;
		var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;

		if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
			me.labelRotation = minRotation;
			return;
		}

		labelSizes = me._getLabelSizes();
		maxLabelWidth = labelSizes.widest.width;
		maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;

		// Estimate the width of each grid based on the canvas width, the maximum
		// label width and the number of tick intervals
		maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
		tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);

		// Allow 3 pixels x2 padding either side for label readability
		if (maxLabelWidth + 6 > tickWidth) {
			tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
			maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
				- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
			maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
			labelRotation = helpers$1.toDegrees(Math.min(
				Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
				Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
			));
			labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
		}

		me.labelRotation = labelRotation;
	},
	afterCalculateTickRotation: function() {
		helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
	},

	//

	beforeFit: function() {
		helpers$1.callback(this.options.beforeFit, [this]);
	},
	fit: function() {
		var me = this;
		// Reset
		var minSize = me.minSize = {
			width: 0,
			height: 0
		};

		var chart = me.chart;
		var opts = me.options;
		var tickOpts = opts.ticks;
		var scaleLabelOpts = opts.scaleLabel;
		var gridLineOpts = opts.gridLines;
		var display = me._isVisible();
		var isBottom = opts.position === 'bottom';
		var isHorizontal = me.isHorizontal();

		// Width
		if (isHorizontal) {
			minSize.width = me.maxWidth;
		} else if (display) {
			minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// height
		if (!isHorizontal) {
			minSize.height = me.maxHeight; // fill all the height
		} else if (display) {
			minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// Don't bother fitting the ticks if we are not showing the labels
		if (tickOpts.display && display) {
			var tickFonts = parseTickFontOptions(tickOpts);
			var labelSizes = me._getLabelSizes();
			var firstLabelSize = labelSizes.first;
			var lastLabelSize = labelSizes.last;
			var widestLabelSize = labelSizes.widest;
			var highestLabelSize = labelSizes.highest;
			var lineSpace = tickFonts.minor.lineHeight * 0.4;
			var tickPadding = tickOpts.padding;

			if (isHorizontal) {
				// A horizontal axis is more constrained by the height.
				var isRotated = me.labelRotation !== 0;
				var angleRadians = helpers$1.toRadians(me.labelRotation);
				var cosRotation = Math.cos(angleRadians);
				var sinRotation = Math.sin(angleRadians);

				var labelHeight = sinRotation * widestLabelSize.width
					+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
					+ (isRotated ? 0 : lineSpace); // padding

				minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

				var offsetLeft = me.getPixelForTick(0) - me.left;
				var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
				var paddingLeft, paddingRight;

				// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
				// which means that the right padding is dominated by the font height
				if (isRotated) {
					paddingLeft = isBottom ?
						cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
						sinRotation * (firstLabelSize.height - firstLabelSize.offset);
					paddingRight = isBottom ?
						sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
						cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
				} else {
					paddingLeft = firstLabelSize.width / 2;
					paddingRight = lastLabelSize.width / 2;
				}

				// Adjust padding taking into account changes in offsets
				// and add 3 px to move away from canvas edges
				me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
				me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
			} else {
				// A vertical axis is more constrained by the width. Labels are the
				// dominant factor here, so get that length first and account for padding
				var labelWidth = tickOpts.mirror ? 0 :
					// use lineSpace for consistency with horizontal axis
					// tickPadding is not implemented for horizontal
					widestLabelSize.width + tickPadding + lineSpace;

				minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);

				me.paddingTop = firstLabelSize.height / 2;
				me.paddingBottom = lastLabelSize.height / 2;
			}
		}

		me.handleMargins();

		if (isHorizontal) {
			me.width = me._length = chart.width - me.margins.left - me.margins.right;
			me.height = minSize.height;
		} else {
			me.width = minSize.width;
			me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
		}
	},

	/**
	 * Handle margins and padding interactions
	 * @private
	 */
	handleMargins: function() {
		var me = this;
		if (me.margins) {
			me.margins.left = Math.max(me.paddingLeft, me.margins.left);
			me.margins.top = Math.max(me.paddingTop, me.margins.top);
			me.margins.right = Math.max(me.paddingRight, me.margins.right);
			me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
		}
	},

	afterFit: function() {
		helpers$1.callback(this.options.afterFit, [this]);
	},

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},
	isFullWidth: function() {
		return this.options.fullWidth;
	},

	// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
	getRightValue: function(rawValue) {
		// Null and undefined values first
		if (isNullOrUndef(rawValue)) {
			return NaN;
		}
		// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
		if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
			return NaN;
		}

		// If it is in fact an object, dive in one more level
		if (rawValue) {
			if (this.isHorizontal()) {
				if (rawValue.x !== undefined) {
					return this.getRightValue(rawValue.x);
				}
			} else if (rawValue.y !== undefined) {
				return this.getRightValue(rawValue.y);
			}
		}

		// Value is good, return it
		return rawValue;
	},

	_convertTicksToLabels: function(ticks) {
		var me = this;
		var labels, i, ilen;

		me.ticks = ticks.map(function(tick) {
			return tick.value;
		});

		me.beforeTickToLabelConversion();

		// New implementations should return the formatted tick labels but for BACKWARD
		// COMPAT, we still support no return (`this.ticks` internally changed by calling
		// this method and supposed to contain only string values).
		labels = me.convertTicksToLabels(ticks) || me.ticks;

		me.afterTickToLabelConversion();

		// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			ticks[i].label = labels[i];
		}

		return labels;
	},

	/**
	 * @private
	 */
	_getLabelSizes: function() {
		var me = this;
		var labelSizes = me._labelSizes;

		if (!labelSizes) {
			me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
			me.longestLabelWidth = labelSizes.widest.width;
		}

		return labelSizes;
	},

	/**
	 * @private
	 */
	_parseValue: function(value) {
		var start, end, min, max;

		if (isArray(value)) {
			start = +this.getRightValue(value[0]);
			end = +this.getRightValue(value[1]);
			min = Math.min(start, end);
			max = Math.max(start, end);
		} else {
			value = +this.getRightValue(value);
			start = undefined;
			end = value;
			min = value;
			max = value;
		}

		return {
			min: min,
			max: max,
			start: start,
			end: end
		};
	},

	/**
	* @private
	*/
	_getScaleLabel: function(rawValue) {
		var v = this._parseValue(rawValue);
		if (v.start !== undefined) {
			return '[' + v.start + ', ' + v.end + ']';
		}

		return +this.getRightValue(rawValue);
	},

	/**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */
	getLabelForIndex: helpers$1.noop,

	/**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */
	getPixelForValue: helpers$1.noop,

	/**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */
	getValueForPixel: helpers$1.noop,

	/**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForTick: function(index) {
		var me = this;
		var offset = me.options.offset;
		var numTicks = me._ticks.length;
		var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);

		return index < 0 || index > numTicks - 1
			? null
			: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
	},

	/**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForDecimal: function(decimal) {
		var me = this;

		if (me._reversePixels) {
			decimal = 1 - decimal;
		}

		return me._startPixel + decimal * me._length;
	},

	getDecimalForPixel: function(pixel) {
		var decimal = (pixel - this._startPixel) / this._length;
		return this._reversePixels ? 1 - decimal : decimal;
	},

	/**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getBasePixel: function() {
		return this.getPixelForValue(this.getBaseValue());
	},

	getBaseValue: function() {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0;
	},

	/**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */
	_autoSkip: function(ticks) {
		var me = this;
		var tickOpts = me.options.ticks;
		var axisLength = me._length;
		var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
		var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
		var numMajorIndices = majorIndices.length;
		var first = majorIndices[0];
		var last = majorIndices[numMajorIndices - 1];
		var i, ilen, spacing, avgMajorSpacing;

		// If there are too many major ticks to display them all
		if (numMajorIndices > ticksLimit) {
			skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
			return nonSkipped(ticks);
		}

		spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);

		if (numMajorIndices > 0) {
			for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
				skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
			}
			avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
			skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
			skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
			return nonSkipped(ticks);
		}
		skip(ticks, spacing);
		return nonSkipped(ticks);
	},

	/**
	 * @private
	 */
	_tickSize: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		// Calculate space needed by label in axis direction.
		var rot = helpers$1.toRadians(me.labelRotation);
		var cos = Math.abs(Math.cos(rot));
		var sin = Math.abs(Math.sin(rot));

		var labelSizes = me._getLabelSizes();
		var padding = optionTicks.autoSkipPadding || 0;
		var w = labelSizes ? labelSizes.widest.width + padding : 0;
		var h = labelSizes ? labelSizes.highest.height + padding : 0;

		// Calculate space needed for 1 tick in axis direction.
		return me.isHorizontal()
			? h * cos > w * sin ? w / cos : h / sin
			: h * sin < w * cos ? h / cos : w / sin;
	},

	/**
	 * @private
	 */
	_isVisible: function() {
		var me = this;
		var chart = me.chart;
		var display = me.options.display;
		var i, ilen, meta;

		if (display !== 'auto') {
			return !!display;
		}

		// When 'auto', the scale is visible if at least one associated dataset is visible.
		for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				meta = chart.getDatasetMeta(i);
				if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
					return true;
				}
			}
		}

		return false;
	},

	/**
	 * @private
	 */
	_computeGridLineItems: function(chartArea) {
		var me = this;
		var chart = me.chart;
		var options = me.options;
		var gridLines = options.gridLines;
		var position = options.position;
		var offsetGridLines = gridLines.offsetGridLines;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);

		var tl = getTickMarkLength(gridLines);
		var items = [];
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var axisHalfWidth = axisWidth / 2;
		var alignPixel = helpers$1._alignPixel;
		var alignBorderValue = function(pixel) {
			return alignPixel(chart, pixel, axisWidth);
		};
		var borderValue, i, tick, lineValue, alignedLineValue;
		var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;

		if (position === 'top') {
			borderValue = alignBorderValue(me.bottom);
			ty1 = me.bottom - tl;
			ty2 = borderValue - axisHalfWidth;
			y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
			y2 = chartArea.bottom;
		} else if (position === 'bottom') {
			borderValue = alignBorderValue(me.top);
			y1 = chartArea.top;
			y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
			ty1 = borderValue + axisHalfWidth;
			ty2 = me.top + tl;
		} else if (position === 'left') {
			borderValue = alignBorderValue(me.right);
			tx1 = me.right - tl;
			tx2 = borderValue - axisHalfWidth;
			x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
			x2 = chartArea.right;
		} else {
			borderValue = alignBorderValue(me.left);
			x1 = chartArea.left;
			x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
			tx1 = borderValue + axisHalfWidth;
			tx2 = me.left + tl;
		}

		for (i = 0; i < ticksLength; ++i) {
			tick = ticks[i] || {};

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(tick.label) && i < ticks.length) {
				continue;
			}

			if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
				// Draw the first index specially
				lineWidth = gridLines.zeroLineWidth;
				lineColor = gridLines.zeroLineColor;
				borderDash = gridLines.zeroLineBorderDash || [];
				borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
			} else {
				lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
				lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
				borderDash = gridLines.borderDash || [];
				borderDashOffset = gridLines.borderDashOffset || 0.0;
			}

			lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);

			// Skip if the pixel is out of the range
			if (lineValue === undefined) {
				continue;
			}

			alignedLineValue = alignPixel(chart, lineValue, lineWidth);

			if (isHorizontal) {
				tx1 = tx2 = x1 = x2 = alignedLineValue;
			} else {
				ty1 = ty2 = y1 = y2 = alignedLineValue;
			}

			items.push({
				tx1: tx1,
				ty1: ty1,
				tx2: tx2,
				ty2: ty2,
				x1: x1,
				y1: y1,
				x2: x2,
				y2: y2,
				width: lineWidth,
				color: lineColor,
				borderDash: borderDash,
				borderDashOffset: borderDashOffset,
			});
		}

		items.ticksLength = ticksLength;
		items.borderValue = borderValue;

		return items;
	},

	/**
	 * @private
	 */
	_computeLabelItems: function() {
		var me = this;
		var options = me.options;
		var optionTicks = options.ticks;
		var position = options.position;
		var isMirrored = optionTicks.mirror;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var fonts = parseTickFontOptions(optionTicks);
		var tickPadding = optionTicks.padding;
		var tl = getTickMarkLength(options.gridLines);
		var rotation = -helpers$1.toRadians(me.labelRotation);
		var items = [];
		var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;

		if (position === 'top') {
			y = me.bottom - tl - tickPadding;
			textAlign = !rotation ? 'center' : 'left';
		} else if (position === 'bottom') {
			y = me.top + tl + tickPadding;
			textAlign = !rotation ? 'center' : 'right';
		} else if (position === 'left') {
			x = me.right - (isMirrored ? 0 : tl) - tickPadding;
			textAlign = isMirrored ? 'left' : 'right';
		} else {
			x = me.left + (isMirrored ? 0 : tl) + tickPadding;
			textAlign = isMirrored ? 'right' : 'left';
		}

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			tick = ticks[i];
			label = tick.label;

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(label)) {
				continue;
			}

			pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
			font = tick.major ? fonts.major : fonts.minor;
			lineHeight = font.lineHeight;
			lineCount = isArray(label) ? label.length : 1;

			if (isHorizontal) {
				x = pixel;
				textOffset = position === 'top'
					? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
					: (!rotation ? 0.5 : 0) * lineHeight;
			} else {
				y = pixel;
				textOffset = (1 - lineCount) * lineHeight / 2;
			}

			items.push({
				x: x,
				y: y,
				rotation: rotation,
				label: label,
				font: font,
				textOffset: textOffset,
				textAlign: textAlign
			});
		}

		return items;
	},

	/**
	 * @private
	 */
	_drawGrid: function(chartArea) {
		var me = this;
		var gridLines = me.options.gridLines;

		if (!gridLines.display) {
			return;
		}

		var ctx = me.ctx;
		var chart = me.chart;
		var alignPixel = helpers$1._alignPixel;
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
		var width, color, i, ilen, item;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			width = item.width;
			color = item.color;

			if (width && color) {
				ctx.save();
				ctx.lineWidth = width;
				ctx.strokeStyle = color;
				if (ctx.setLineDash) {
					ctx.setLineDash(item.borderDash);
					ctx.lineDashOffset = item.borderDashOffset;
				}

				ctx.beginPath();

				if (gridLines.drawTicks) {
					ctx.moveTo(item.tx1, item.ty1);
					ctx.lineTo(item.tx2, item.ty2);
				}

				if (gridLines.drawOnChartArea) {
					ctx.moveTo(item.x1, item.y1);
					ctx.lineTo(item.x2, item.y2);
				}

				ctx.stroke();
				ctx.restore();
			}
		}

		if (axisWidth) {
			// Draw the line at the edge of the axis
			var firstLineWidth = axisWidth;
			var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
			var borderValue = items.borderValue;
			var x1, x2, y1, y2;

			if (me.isHorizontal()) {
				x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
				x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
				y1 = y2 = borderValue;
			} else {
				y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
				y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
				x1 = x2 = borderValue;
			}

			ctx.lineWidth = axisWidth;
			ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
			ctx.beginPath();
			ctx.moveTo(x1, y1);
			ctx.lineTo(x2, y2);
			ctx.stroke();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		if (!optionTicks.display) {
			return;
		}

		var ctx = me.ctx;
		var items = me._labelItems || (me._labelItems = me._computeLabelItems());
		var i, j, ilen, jlen, item, tickFont, label, y;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			tickFont = item.font;

			// Make sure we draw text in the correct color and font
			ctx.save();
			ctx.translate(item.x, item.y);
			ctx.rotate(item.rotation);
			ctx.font = tickFont.string;
			ctx.fillStyle = tickFont.color;
			ctx.textBaseline = 'middle';
			ctx.textAlign = item.textAlign;

			label = item.label;
			y = item.textOffset;
			if (isArray(label)) {
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					// We just make sure the multiline element is a string here..
					ctx.fillText('' + label[j], 0, y);
					y += tickFont.lineHeight;
				}
			} else {
				ctx.fillText(label, 0, y);
			}
			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawTitle: function() {
		var me = this;
		var ctx = me.ctx;
		var options = me.options;
		var scaleLabel = options.scaleLabel;

		if (!scaleLabel.display) {
			return;
		}

		var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
		var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
		var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
		var halfLineHeight = scaleLabelFont.lineHeight / 2;
		var position = options.position;
		var rotation = 0;
		var scaleLabelX, scaleLabelY;

		if (me.isHorizontal()) {
			scaleLabelX = me.left + me.width / 2; // midpoint of the width
			scaleLabelY = position === 'bottom'
				? me.bottom - halfLineHeight - scaleLabelPadding.bottom
				: me.top + halfLineHeight + scaleLabelPadding.top;
		} else {
			var isLeft = position === 'left';
			scaleLabelX = isLeft
				? me.left + halfLineHeight + scaleLabelPadding.top
				: me.right - halfLineHeight - scaleLabelPadding.top;
			scaleLabelY = me.top + me.height / 2;
			rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
		}

		ctx.save();
		ctx.translate(scaleLabelX, scaleLabelY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';
		ctx.fillStyle = scaleLabelFontColor; // render in correct colour
		ctx.font = scaleLabelFont.string;
		ctx.fillText(scaleLabel.labelString, 0, 0);
		ctx.restore();
	},

	draw: function(chartArea) {
		var me = this;

		if (!me._isVisible()) {
			return;
		}

		me._drawGrid(chartArea);
		me._drawTitle();
		me._drawLabels();
	},

	/**
	 * @private
	 */
	_layers: function() {
		var me = this;
		var opts = me.options;
		var tz = opts.ticks && opts.ticks.z || 0;
		var gz = opts.gridLines && opts.gridLines.z || 0;

		if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
			// backward compatibility: draw has been overridden by custom scale
			return [{
				z: tz,
				draw: function() {
					me.draw.apply(me, arguments);
				}
			}];
		}

		return [{
			z: gz,
			draw: function() {
				me._drawGrid.apply(me, arguments);
				me._drawTitle.apply(me, arguments);
			}
		}, {
			z: tz,
			draw: function() {
				me._drawLabels.apply(me, arguments);
			}
		}];
	},

	/**
	 * @private
	 */
	_getMatchingVisibleMetas: function(type) {
		var me = this;
		var isHorizontal = me.isHorizontal();
		return me.chart._getSortedVisibleDatasetMetas()
			.filter(function(meta) {
				return (!type || meta.type === type)
					&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
			});
	}
});

Scale.prototype._draw = Scale.prototype.draw;

var core_scale = Scale;

var isNullOrUndef$1 = helpers$1.isNullOrUndef;

var defaultConfig = {
	position: 'bottom'
};

var scale_category = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var labels = me._getLabels();
		var ticksOpts = me.options.ticks;
		var min = ticksOpts.min;
		var max = ticksOpts.max;
		var minIndex = 0;
		var maxIndex = labels.length - 1;
		var findIndex;

		if (min !== undefined) {
			// user specified min value
			findIndex = labels.indexOf(min);
			if (findIndex >= 0) {
				minIndex = findIndex;
			}
		}

		if (max !== undefined) {
			// user specified max value
			findIndex = labels.indexOf(max);
			if (findIndex >= 0) {
				maxIndex = findIndex;
			}
		}

		me.minIndex = minIndex;
		me.maxIndex = maxIndex;
		me.min = labels[minIndex];
		me.max = labels[maxIndex];
	},

	buildTicks: function() {
		var me = this;
		var labels = me._getLabels();
		var minIndex = me.minIndex;
		var maxIndex = me.maxIndex;

		// If we are viewing some subset of labels, slice the original array
		me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var chart = me.chart;

		if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
			return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
		}

		return me._getLabels()[index];
	},

	_configure: function() {
		var me = this;
		var offset = me.options.offset;
		var ticks = me.ticks;

		core_scale.prototype._configure.call(me);

		if (!me.isHorizontal()) {
			// For backward compatibility, vertical category scale reverse is inverted.
			me._reversePixels = !me._reversePixels;
		}

		if (!ticks) {
			return;
		}

		me._startValue = me.minIndex - (offset ? 0.5 : 0);
		me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
	},

	// Used to get data value locations.  Value can either be an index or a numerical value
	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var valueCategory, labels, idx;

		if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
			value = me.chart.data.datasets[datasetIndex].data[index];
		}

		// If value is a data object, then index is the index in the data array,
		// not the index of the scale. We need to change that.
		if (!isNullOrUndef$1(value)) {
			valueCategory = me.isHorizontal() ? value.x : value.y;
		}
		if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
			labels = me._getLabels();
			value = helpers$1.valueOrDefault(valueCategory, value);
			idx = labels.indexOf(value);
			index = idx !== -1 ? idx : index;
			if (isNaN(index)) {
				index = value;
			}
		}
		return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
	},

	getPixelForTick: function(index) {
		var ticks = this.ticks;
		return index < 0 || index > ticks.length - 1
			? null
			: this.getPixelForValue(ticks[index], index + this.minIndex);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
		return Math.min(Math.max(value, 0), me.ticks.length - 1);
	},

	getBasePixel: function() {
		return this.bottom;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults = defaultConfig;
scale_category._defaults = _defaults;

var noop = helpers$1.noop;
var isNullOrUndef$2 = helpers$1.isNullOrUndef;

/**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var MIN_SPACING = 1e-14;
	var stepSize = generationOptions.stepSize;
	var unit = stepSize || 1;
	var maxNumSpaces = generationOptions.maxTicks - 1;
	var min = generationOptions.min;
	var max = generationOptions.max;
	var precision = generationOptions.precision;
	var rmin = dataRange.min;
	var rmax = dataRange.max;
	var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
	var factor, niceMin, niceMax, numSpaces;

	// Beyond MIN_SPACING floating point numbers being to lose precision
	// such that we can't do the math necessary to generate ticks
	if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
		return [rmin, rmax];
	}

	numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
	if (numSpaces > maxNumSpaces) {
		// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
		spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
	}

	if (stepSize || isNullOrUndef$2(precision)) {
		// If a precision is not specified, calculate factor based on spacing
		factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
	} else {
		// If the user specified a precision, round to that number of decimal places
		factor = Math.pow(10, precision);
		spacing = Math.ceil(spacing * factor) / factor;
	}

	niceMin = Math.floor(rmin / spacing) * spacing;
	niceMax = Math.ceil(rmax / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (stepSize) {
		// If very close to our whole number, use it.
		if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
			niceMin = min;
		}
		if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
			niceMax = max;
		}
	}

	numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	niceMin = Math.round(niceMin * factor) / factor;
	niceMax = Math.round(niceMax * factor) / factor;
	ticks.push(isNullOrUndef$2(min) ? niceMin : min);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
	}
	ticks.push(isNullOrUndef$2(max) ? niceMax : max);

	return ticks;
}

var scale_linearbase = core_scale.extend({
	getRightValue: function(value) {
		if (typeof value === 'string') {
			return +value;
		}
		return core_scale.prototype.getRightValue.call(this, value);
	},

	handleTickRangeOptions: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
		// do nothing since that would make the chart weird. If the user really wants a weird chart
		// axis, they can manually override it
		if (tickOpts.beginAtZero) {
			var minSign = helpers$1.sign(me.min);
			var maxSign = helpers$1.sign(me.max);

			if (minSign < 0 && maxSign < 0) {
				// move the top up to 0
				me.max = 0;
			} else if (minSign > 0 && maxSign > 0) {
				// move the bottom down to 0
				me.min = 0;
			}
		}

		var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
		var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

		if (tickOpts.min !== undefined) {
			me.min = tickOpts.min;
		} else if (tickOpts.suggestedMin !== undefined) {
			if (me.min === null) {
				me.min = tickOpts.suggestedMin;
			} else {
				me.min = Math.min(me.min, tickOpts.suggestedMin);
			}
		}

		if (tickOpts.max !== undefined) {
			me.max = tickOpts.max;
		} else if (tickOpts.suggestedMax !== undefined) {
			if (me.max === null) {
				me.max = tickOpts.suggestedMax;
			} else {
				me.max = Math.max(me.max, tickOpts.suggestedMax);
			}
		}

		if (setMin !== setMax) {
			// We set the min or the max but not both.
			// So ensure that our range is good
			// Inverted or 0 length range can happen when
			// ticks.min is set, and no datasets are visible
			if (me.min >= me.max) {
				if (setMin) {
					me.max = me.min + 1;
				} else {
					me.min = me.max - 1;
				}
			}
		}

		if (me.min === me.max) {
			me.max++;

			if (!tickOpts.beginAtZero) {
				me.min--;
			}
		}
	},

	getTickLimit: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var stepSize = tickOpts.stepSize;
		var maxTicksLimit = tickOpts.maxTicksLimit;
		var maxTicks;

		if (stepSize) {
			maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
		} else {
			maxTicks = me._computeTickLimit();
			maxTicksLimit = maxTicksLimit || 11;
		}

		if (maxTicksLimit) {
			maxTicks = Math.min(maxTicksLimit, maxTicks);
		}

		return maxTicks;
	},

	_computeTickLimit: function() {
		return Number.POSITIVE_INFINITY;
	},

	handleDirectionalChanges: noop,

	buildTicks: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// Figure out what the max number of ticks we can support it is based on the size of
		// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
		// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
		// the graph. Make sure we always have at least 2 ticks
		var maxTicks = me.getTickLimit();
		maxTicks = Math.max(2, maxTicks);

		var numericGeneratorOptions = {
			maxTicks: maxTicks,
			min: tickOpts.min,
			max: tickOpts.max,
			precision: tickOpts.precision,
			stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
		};
		var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

		me.handleDirectionalChanges();

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			ticks.reverse();

			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
	},

	convertTicksToLabels: function() {
		var me = this;
		me.ticksAsNumbers = me.ticks.slice();
		me.zeroLineIndex = me.ticks.indexOf(0);

		core_scale.prototype.convertTicksToLabels.call(me);
	},

	_configure: function() {
		var me = this;
		var ticks = me.getTicks();
		var start = me.min;
		var end = me.max;
		var offset;

		core_scale.prototype._configure.call(me);

		if (me.options.offset && ticks.length) {
			offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
			start -= offset;
			end += offset;
		}
		me._startValue = start;
		me._endValue = end;
		me._valueRange = end - start;
	}
});

var defaultConfig$1 = {
	position: 'left',
	ticks: {
		callback: core_ticks.formatters.linear
	}
};

var DEFAULT_MIN = 0;
var DEFAULT_MAX = 1;

function getOrCreateStack(stacks, stacked, meta) {
	var key = [
		meta.type,
		// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
		stacked === undefined && meta.stack === undefined ? meta.index : '',
		meta.stack
	].join('.');

	if (stacks[key] === undefined) {
		stacks[key] = {
			pos: [],
			neg: []
		};
	}

	return stacks[key];
}

function stackData(scale, stacks, meta, data) {
	var opts = scale.options;
	var stacked = opts.stacked;
	var stack = getOrCreateStack(stacks, stacked, meta);
	var pos = stack.pos;
	var neg = stack.neg;
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		pos[i] = pos[i] || 0;
		neg[i] = neg[i] || 0;

		if (opts.relativePoints) {
			pos[i] = 100;
		} else if (value.min < 0 || value.max < 0) {
			neg[i] += value.min;
		} else {
			pos[i] += value.max;
		}
	}
}

function updateMinMax(scale, meta, data) {
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		scale.min = Math.min(scale.min, value.min);
		scale.max = Math.max(scale.max, value.max);
	}
}

var scale_linear = scale_linearbase.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var metasets = me._getMatchingVisibleMetas();
		var hasStacks = opts.stacked;
		var stacks = {};
		var ilen = metasets.length;
		var i, meta, data, values;

		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;

		if (hasStacks === undefined) {
			for (i = 0; !hasStacks && i < ilen; ++i) {
				meta = metasets[i];
				hasStacks = meta.stack !== undefined;
			}
		}

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			data = datasets[meta.index].data;
			if (hasStacks) {
				stackData(me, stacks, meta, data);
			} else {
				updateMinMax(me, meta, data);
			}
		}

		helpers$1.each(stacks, function(stackValues) {
			values = stackValues.pos.concat(stackValues.neg);
			me.min = Math.min(me.min, helpers$1.min(values));
			me.max = Math.max(me.max, helpers$1.max(values));
		});

		me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
		me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		var me = this;
		var tickFont;

		if (me.isHorizontal()) {
			return Math.ceil(me.width / 40);
		}
		tickFont = helpers$1.options._parseFont(me.options.ticks);
		return Math.ceil(me.height / tickFont.lineHeight);
	},

	// Called after the ticks are built. We need
	handleDirectionalChanges: function() {
		if (!this.isHorizontal()) {
			// We are in a vertical orientation. The top value is the highest. So reverse the array
			this.ticks.reverse();
		}
	},

	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	// Utils
	getPixelForValue: function(value) {
		var me = this;
		return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
	},

	getValueForPixel: function(pixel) {
		return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
	},

	getPixelForTick: function(index) {
		var ticks = this.ticksAsNumbers;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$1 = defaultConfig$1;
scale_linear._defaults = _defaults$1;

var valueOrDefault$b = helpers$1.valueOrDefault;
var log10 = helpers$1.math.log10;

/**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks$1(generationOptions, dataRange) {
	var ticks = [];

	var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));

	var endExp = Math.floor(log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}

var defaultConfig$2 = {
	position: 'left',

	// label settings
	ticks: {
		callback: core_ticks.formatters.logarithmic
	}
};

// TODO(v3): change this to positiveOrDefault
function nonNegativeOrDefault(value, defaultValue) {
	return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
}

var scale_logarithmic = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var isHorizontal = me.isHorizontal();
		function IDMatches(meta) {
			return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
		}
		var datasetIndex, meta, value, data, i, ilen;

		// Calculate Range
		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;
		me.minNotZero = Number.POSITIVE_INFINITY;

		var hasStacks = opts.stacked;
		if (hasStacks === undefined) {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
					meta.stack !== undefined) {
					hasStacks = true;
					break;
				}
			}
		}

		if (opts.stacked || hasStacks) {
			var valuesPerStack = {};

			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				var key = [
					meta.type,
					// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
					((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
					meta.stack
				].join('.');

				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = [];
					}

					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						var values = valuesPerStack[key];
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}
						values[i] = values[i] || 0;
						values[i] += value.max;
					}
				}
			}

			helpers$1.each(valuesPerStack, function(valuesForType) {
				if (valuesForType.length > 0) {
					var minVal = helpers$1.min(valuesForType);
					var maxVal = helpers$1.max(valuesForType);
					me.min = Math.min(me.min, minVal);
					me.max = Math.max(me.max, maxVal);
				}
			});

		} else {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}

						me.min = Math.min(value.min, me.min);
						me.max = Math.max(value.max, me.max);

						if (value.min !== 0) {
							me.minNotZero = Math.min(value.min, me.minNotZero);
						}
					}
				}
			}
		}

		me.min = helpers$1.isFinite(me.min) ? me.min : null;
		me.max = helpers$1.isFinite(me.max) ? me.max : null;
		me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;

		// Common base implementation to handle ticks.min, ticks.max
		this.handleTickRangeOptions();
	},

	handleTickRangeOptions: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var DEFAULT_MIN = 1;
		var DEFAULT_MAX = 10;

		me.min = nonNegativeOrDefault(tickOpts.min, me.min);
		me.max = nonNegativeOrDefault(tickOpts.max, me.max);

		if (me.min === me.max) {
			if (me.min !== 0 && me.min !== null) {
				me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
				me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
			} else {
				me.min = DEFAULT_MIN;
				me.max = DEFAULT_MAX;
			}
		}
		if (me.min === null) {
			me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
		}
		if (me.max === null) {
			me.max = me.min !== 0
				? Math.pow(10, Math.floor(log10(me.min)) + 1)
				: DEFAULT_MAX;
		}
		if (me.minNotZero === null) {
			if (me.min > 0) {
				me.minNotZero = me.min;
			} else if (me.max < 1) {
				me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
			} else {
				me.minNotZero = DEFAULT_MIN;
			}
		}
	},

	buildTicks: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = !me.isHorizontal();

		var generationOptions = {
			min: nonNegativeOrDefault(tickOpts.min),
			max: nonNegativeOrDefault(tickOpts.max)
		};
		var ticks = me.ticks = generateTicks$1(generationOptions, me);

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			reverse = !reverse;
			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
		if (reverse) {
			ticks.reverse();
		}
	},

	convertTicksToLabels: function() {
		this.tickValues = this.ticks.slice();

		core_scale.prototype.convertTicksToLabels.call(this);
	},

	// Get the correct tooltip label
	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	getPixelForTick: function(index) {
		var ticks = this.tickValues;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	},

	/**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */
	_getFirstTickValue: function(value) {
		var exp = Math.floor(log10(value));
		var significand = Math.floor(value / Math.pow(10, exp));

		return significand * Math.pow(10, exp);
	},

	_configure: function() {
		var me = this;
		var start = me.min;
		var offset = 0;

		core_scale.prototype._configure.call(me);

		if (start === 0) {
			start = me._getFirstTickValue(me.minNotZero);
			offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
		}

		me._startValue = log10(start);
		me._valueOffset = offset;
		me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
	},

	getPixelForValue: function(value) {
		var me = this;
		var decimal = 0;

		value = +me.getRightValue(value);

		if (value > me.min && value > 0) {
			decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
		}
		return me.getPixelForDecimal(decimal);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var decimal = me.getDecimalForPixel(pixel);
		return decimal === 0 && me.min === 0
			? 0
			: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$2 = defaultConfig$2;
scale_logarithmic._defaults = _defaults$2;

var valueOrDefault$c = helpers$1.valueOrDefault;
var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
var resolve$4 = helpers$1.options.resolve;

var defaultConfig$3 = {
	display: true,

	// Boolean - Whether to animate scaling the chart from the centre
	animate: true,
	position: 'chartArea',

	angleLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		borderDash: [],
		borderDashOffset: 0.0
	},

	gridLines: {
		circular: false
	},

	// label settings
	ticks: {
		// Boolean - Show a backdrop to the scale label
		showLabelBackdrop: true,

		// String - The colour of the label backdrop
		backdropColor: 'rgba(255,255,255,0.75)',

		// Number - The backdrop padding above & below the label in pixels
		backdropPaddingY: 2,

		// Number - The backdrop padding to the side of the label in pixels
		backdropPaddingX: 2,

		callback: core_ticks.formatters.linear
	},

	pointLabels: {
		// Boolean - if true, show point labels
		display: true,

		// Number - Point label font size in pixels
		fontSize: 10,

		// Function - Used to convert point labels
		callback: function(label) {
			return label;
		}
	}
};

function getTickBackdropHeight(opts) {
	var tickOpts = opts.ticks;

	if (tickOpts.display && opts.display) {
		return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
	}
	return 0;
}

function measureLabelSize(ctx, lineHeight, label) {
	if (helpers$1.isArray(label)) {
		return {
			w: helpers$1.longestText(ctx, ctx.font, label),
			h: label.length * lineHeight
		};
	}

	return {
		w: ctx.measureText(label).width,
		h: lineHeight
	};
}

function determineLimits(angle, pos, size, min, max) {
	if (angle === min || angle === max) {
		return {
			start: pos - (size / 2),
			end: pos + (size / 2)
		};
	} else if (angle < min || angle > max) {
		return {
			start: pos - size,
			end: pos
		};
	}

	return {
		start: pos,
		end: pos + size
	};
}

/**
 * Helper function to fit a radial linear scale with point labels
 */
function fitWithPointLabels(scale) {

	// Right, this is really confusing and there is a lot of maths going on here
	// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
	//
	// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
	//
	// Solution:
	//
	// We assume the radius of the polygon is half the size of the canvas at first
	// at each index we check if the text overlaps.
	//
	// Where it does, we store that angle and that index.
	//
	// After finding the largest index and angle we calculate how much we need to remove
	// from the shape radius to move the point inwards by that x.
	//
	// We average the left and right distances to get the maximum shape radius that can fit in the box
	// along with labels.
	//
	// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
	// on each side, removing that from the size, halving it and adding the left x protrusion width.
	//
	// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
	// and position it in the most space efficient manner
	//
	// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif

	var plFont = helpers$1.options._parseFont(scale.options.pointLabels);

	// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
	// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
	var furthestLimits = {
		l: 0,
		r: scale.width,
		t: 0,
		b: scale.height - scale.paddingTop
	};
	var furthestAngles = {};
	var i, textSize, pointPosition;

	scale.ctx.font = plFont.string;
	scale._pointLabelSizes = [];

	var valueCount = scale.chart.data.labels.length;
	for (i = 0; i < valueCount; i++) {
		pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
		textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
		scale._pointLabelSizes[i] = textSize;

		// Add quarter circle to make degree 0 mean top of circle
		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians) % 360;
		var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
		var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

		if (hLimits.start < furthestLimits.l) {
			furthestLimits.l = hLimits.start;
			furthestAngles.l = angleRadians;
		}

		if (hLimits.end > furthestLimits.r) {
			furthestLimits.r = hLimits.end;
			furthestAngles.r = angleRadians;
		}

		if (vLimits.start < furthestLimits.t) {
			furthestLimits.t = vLimits.start;
			furthestAngles.t = angleRadians;
		}

		if (vLimits.end > furthestLimits.b) {
			furthestLimits.b = vLimits.end;
			furthestAngles.b = angleRadians;
		}
	}

	scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
}

function getTextAlignForAngle(angle) {
	if (angle === 0 || angle === 180) {
		return 'center';
	} else if (angle < 180) {
		return 'left';
	}

	return 'right';
}

function fillText(ctx, text, position, lineHeight) {
	var y = position.y + lineHeight / 2;
	var i, ilen;

	if (helpers$1.isArray(text)) {
		for (i = 0, ilen = text.length; i < ilen; ++i) {
			ctx.fillText(text[i], position.x, y);
			y += lineHeight;
		}
	} else {
		ctx.fillText(text, position.x, y);
	}
}

function adjustPointPositionForLabelHeight(angle, textSize, position) {
	if (angle === 90 || angle === 270) {
		position.y -= (textSize.h / 2);
	} else if (angle > 270 || angle < 90) {
		position.y -= textSize.h;
	}
}

function drawPointLabels(scale) {
	var ctx = scale.ctx;
	var opts = scale.options;
	var pointLabelOpts = opts.pointLabels;
	var tickBackdropHeight = getTickBackdropHeight(opts);
	var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
	var plFont = helpers$1.options._parseFont(pointLabelOpts);

	ctx.save();

	ctx.font = plFont.string;
	ctx.textBaseline = 'middle';

	for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
		// Extra pixels out for some label spacing
		var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
		var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);

		// Keep this in loop since we may support array properties here
		var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
		ctx.fillStyle = pointLabelFontColor;

		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians);
		ctx.textAlign = getTextAlignForAngle(angle);
		adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
		fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
	}
	ctx.restore();
}

function drawRadiusLine(scale, gridLineOpts, radius, index) {
	var ctx = scale.ctx;
	var circular = gridLineOpts.circular;
	var valueCount = scale.chart.data.labels.length;
	var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
	var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
	var pointPosition;

	if ((!circular && !valueCount) || !lineColor || !lineWidth) {
		return;
	}

	ctx.save();
	ctx.strokeStyle = lineColor;
	ctx.lineWidth = lineWidth;
	if (ctx.setLineDash) {
		ctx.setLineDash(gridLineOpts.borderDash || []);
		ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
	}

	ctx.beginPath();
	if (circular) {
		// Draw circular arcs between the points
		ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
	} else {
		// Draw straight lines connecting each index
		pointPosition = scale.getPointPosition(0, radius);
		ctx.moveTo(pointPosition.x, pointPosition.y);

		for (var i = 1; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, radius);
			ctx.lineTo(pointPosition.x, pointPosition.y);
		}
	}
	ctx.closePath();
	ctx.stroke();
	ctx.restore();
}

function numberOrZero(param) {
	return helpers$1.isNumber(param) ? param : 0;
}

var scale_radialLinear = scale_linearbase.extend({
	setDimensions: function() {
		var me = this;

		// Set the unconstrained dimension before label rotation
		me.width = me.maxWidth;
		me.height = me.maxHeight;
		me.paddingTop = getTickBackdropHeight(me.options) / 2;
		me.xCenter = Math.floor(me.width / 2);
		me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
		me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var min = Number.POSITIVE_INFINITY;
		var max = Number.NEGATIVE_INFINITY;

		helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);

				helpers$1.each(dataset.data, function(rawValue, index) {
					var value = +me.getRightValue(rawValue);
					if (isNaN(value) || meta.data[index].hidden) {
						return;
					}

					min = Math.min(value, min);
					max = Math.max(value, max);
				});
			}
		});

		me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
		me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
	},

	convertTicksToLabels: function() {
		var me = this;

		scale_linearbase.prototype.convertTicksToLabels.call(me);

		// Point labels
		me.pointLabels = me.chart.data.labels.map(function() {
			var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
			return label || label === 0 ? label : '';
		});
	},

	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	fit: function() {
		var me = this;
		var opts = me.options;

		if (opts.display && opts.pointLabels.display) {
			fitWithPointLabels(me);
		} else {
			me.setCenterPoint(0, 0, 0, 0);
		}
	},

	/**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */
	setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
		var me = this;
		var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
		var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
		var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
		var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);

		radiusReductionLeft = numberOrZero(radiusReductionLeft);
		radiusReductionRight = numberOrZero(radiusReductionRight);
		radiusReductionTop = numberOrZero(radiusReductionTop);
		radiusReductionBottom = numberOrZero(radiusReductionBottom);

		me.drawingArea = Math.min(
			Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
			Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
		me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
	},

	setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
		var me = this;
		var maxRight = me.width - rightMovement - me.drawingArea;
		var maxLeft = leftMovement + me.drawingArea;
		var maxTop = topMovement + me.drawingArea;
		var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;

		me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
		me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
	},

	getIndexAngle: function(index) {
		var chart = this.chart;
		var angleMultiplier = 360 / chart.data.labels.length;
		var options = chart.options || {};
		var startAngle = options.startAngle || 0;

		// Start from the top instead of right, so remove a quarter of the circle
		var angle = (index * angleMultiplier + startAngle) % 360;

		return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
	},

	getDistanceFromCenterForValue: function(value) {
		var me = this;

		if (helpers$1.isNullOrUndef(value)) {
			return NaN;
		}

		// Take into account half font size + the yPadding of the top value
		var scalingFactor = me.drawingArea / (me.max - me.min);
		if (me.options.ticks.reverse) {
			return (me.max - value) * scalingFactor;
		}
		return (value - me.min) * scalingFactor;
	},

	getPointPosition: function(index, distanceFromCenter) {
		var me = this;
		var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
		return {
			x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
			y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
		};
	},

	getPointPositionForValue: function(index, value) {
		return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
	},

	getBasePosition: function(index) {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.getPointPositionForValue(index || 0,
			me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0);
	},

	/**
	 * @private
	 */
	_drawGrid: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var gridLineOpts = opts.gridLines;
		var angleLineOpts = opts.angleLines;
		var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
		var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
		var i, offset, position;

		if (opts.pointLabels.display) {
			drawPointLabels(me);
		}

		if (gridLineOpts.display) {
			helpers$1.each(me.ticks, function(label, index) {
				if (index !== 0) {
					offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
					drawRadiusLine(me, gridLineOpts, offset, index);
				}
			});
		}

		if (angleLineOpts.display && lineWidth && lineColor) {
			ctx.save();
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = lineColor;
			if (ctx.setLineDash) {
				ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
				ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
			}

			for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
				offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
				position = me.getPointPosition(i, offset);
				ctx.beginPath();
				ctx.moveTo(me.xCenter, me.yCenter);
				ctx.lineTo(position.x, position.y);
				ctx.stroke();
			}

			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var tickOpts = opts.ticks;

		if (!tickOpts.display) {
			return;
		}

		var startAngle = me.getIndexAngle(0);
		var tickFont = helpers$1.options._parseFont(tickOpts);
		var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
		var offset, width;

		ctx.save();
		ctx.font = tickFont.string;
		ctx.translate(me.xCenter, me.yCenter);
		ctx.rotate(startAngle);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		helpers$1.each(me.ticks, function(label, index) {
			if (index === 0 && !tickOpts.reverse) {
				return;
			}

			offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

			if (tickOpts.showLabelBackdrop) {
				width = ctx.measureText(label).width;
				ctx.fillStyle = tickOpts.backdropColor;

				ctx.fillRect(
					-width / 2 - tickOpts.backdropPaddingX,
					-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
					width + tickOpts.backdropPaddingX * 2,
					tickFont.size + tickOpts.backdropPaddingY * 2
				);
			}

			ctx.fillStyle = tickFontColor;
			ctx.fillText(label, 0, -offset);
		});

		ctx.restore();
	},

	/**
	 * @private
	 */
	_drawTitle: helpers$1.noop
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$3 = defaultConfig$3;
scale_radialLinear._defaults = _defaults$3;

var deprecated$1 = helpers$1._deprecated;
var resolve$5 = helpers$1.options.resolve;
var valueOrDefault$d = helpers$1.valueOrDefault;

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: 1000
	},
	second: {
		common: true,
		size: 1000,
		steps: 60
	},
	minute: {
		common: true,
		size: 60000,
		steps: 60
	},
	hour: {
		common: true,
		size: 3600000,
		steps: 24
	},
	day: {
		common: true,
		size: 86400000,
		steps: 30
	},
	week: {
		common: false,
		size: 604800000,
		steps: 4
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: 12
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: 4
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

function getMin(options) {
	return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
}

function getMax(options) {
	return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate$1(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

function toTimestamp(scale, input) {
	var adapter = scale._adapter;
	var options = scale.options.time;
	var parser = options.parser;
	var format = parser || options.format;
	var value = input;

	if (typeof parser === 'function') {
		value = parser(value);
	}

	// Only parse if its not a timestamp already
	if (!helpers$1.isFinite(value)) {
		value = typeof format === 'string'
			? adapter.parse(value, format)
			: adapter.parse(value);
	}

	if (value !== null) {
		return +value;
	}

	// Labels are in an incompatible format and no `parser` has been provided.
	// The user might still use the deprecated `format` option for parsing.
	if (!parser && typeof format === 'function') {
		value = format(input);

		// `format` could return something else than a timestamp, if so, parse it
		if (!helpers$1.isFinite(value)) {
			value = adapter.parse(value);
		}
	}

	return value;
}

function parse(scale, input) {
	if (helpers$1.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = toTimestamp(scale, scale.getRightValue(input));
	if (value === null) {
		return value;
	}

	if (options.round) {
		value = +scale._adapter.startOf(value, options.round);
	}

	return value;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
	var i, unit;

	for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(scale, min, max, capacity) {
	var adapter = scale._adapter;
	var options = scale.options;
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var first = min;
	var ticks = [];
	var time;

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = +adapter.startOf(first, 'isoWeek', weekday);
	}

	// Align first ticks on unit
	first = +adapter.startOf(first, weekday ? 'day' : minor);

	// Prevent browser from freezing in case user options request millions of milliseconds
	if (adapter.diff(max, min, minor) > 100000 * stepSize) {
		throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
	}

	for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
		ticks.push(time);
	}

	if (time === max || options.bounds === 'ticks') {
		ticks.push(time);
	}

	return ticks;
}

/**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var start = 0;
	var end = 0;
	var first, last;

	if (options.offset && ticks.length) {
		first = interpolate$1(table, 'time', ticks[0], 'pos');
		if (ticks.length === 1) {
			start = 1 - first;
		} else {
			start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
		}
		last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
		if (ticks.length === 1) {
			end = last;
		} else {
			end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
		}
	}

	return {start: start, end: end, factor: 1 / (start + 1 + end)};
}

function setMajorTicks(scale, ticks, map, majorUnit) {
	var adapter = scale._adapter;
	var first = +adapter.startOf(ticks[0].value, majorUnit);
	var last = ticks[ticks.length - 1].value;
	var major, index;

	for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
		index = map[major];
		if (index >= 0) {
			ticks[index].major = true;
		}
	}
	return ticks;
}

function ticksFromTimestamps(scale, values, majorUnit) {
	var ticks = [];
	var map = {};
	var ilen = values.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = values[i];
		map[value] = i;

		ticks.push({
			value: value,
			major: false
		});
	}

	// We set the major ticks separately from the above loop because calling startOf for every tick
	// is expensive when there is a large number of ticks
	return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}

var defaultConfig$4 = {
	position: 'bottom',

	/**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */
	distribution: 'linear',

	/**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */
	bounds: 'data',

	adapters: {},
	time: {
		parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
		unit: false, // false == automatic or override with week, month, year, etc.
		round: false, // none, or override with week, month, year, etc.
		displayFormat: false, // DEPRECATED
		isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
		minUnit: 'millisecond',
		displayFormats: {}
	},
	ticks: {
		autoSkip: false,

		/**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		source: 'auto',

		major: {
			enabled: false
		}
	}
};

var scale_time = core_scale.extend({
	initialize: function() {
		this.mergeTicksOptions();
		core_scale.prototype.initialize.call(this);
	},

	update: function() {
		var me = this;
		var options = me.options;
		var time = options.time || (options.time = {});
		var adapter = me._adapter = new core_adapters._date(options.adapters.date);

		// DEPRECATIONS: output a message only one time per update
		deprecated$1('time scale', time.format, 'time.format', 'time.parser');
		deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
		deprecated$1('time scale', time.max, 'time.max', 'ticks.max');

		// Backward compatibility: before introducing adapter, `displayFormats` was
		// supposed to contain *all* unit/string pairs but this can't be resolved
		// when loading the scale (adapters are loaded afterward), so let's populate
		// missing formats on update
		helpers$1.mergeIf(time.displayFormats, adapter.formats());

		return core_scale.prototype.update.apply(me, arguments);
	},

	/**
	 * Allows data to be referenced via 't' attribute
	 */
	getRightValue: function(rawValue) {
		if (rawValue && rawValue.t !== undefined) {
			rawValue = rawValue.t;
		}
		return core_scale.prototype.getRightValue.call(this, rawValue);
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var adapter = me._adapter;
		var options = me.options;
		var unit = options.time.unit || 'day';
		var min = MAX_INTEGER;
		var max = MIN_INTEGER;
		var timestamps = [];
		var datasets = [];
		var labels = [];
		var i, j, ilen, jlen, data, timestamp, labelsAdded;
		var dataLabels = me._getLabels();

		for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
			labels.push(parse(me, dataLabels[i]));
		}

		for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				data = chart.data.datasets[i].data;

				// Let's consider that all data have the same format.
				if (helpers$1.isObject(data[0])) {
					datasets[i] = [];

					for (j = 0, jlen = data.length; j < jlen; ++j) {
						timestamp = parse(me, data[j]);
						timestamps.push(timestamp);
						datasets[i][j] = timestamp;
					}
				} else {
					datasets[i] = labels.slice(0);
					if (!labelsAdded) {
						timestamps = timestamps.concat(labels);
						labelsAdded = true;
					}
				}
			} else {
				datasets[i] = [];
			}
		}

		if (labels.length) {
			min = Math.min(min, labels[0]);
			max = Math.max(max, labels[labels.length - 1]);
		}

		if (timestamps.length) {
			timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
			min = Math.min(min, timestamps[0]);
			max = Math.max(max, timestamps[timestamps.length - 1]);
		}

		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// In case there is no valid min/max, set limits based on unit time option
		min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
		max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;

		// Make sure that max is strictly higher than min (required by the lookup table)
		me.min = Math.min(min, max);
		me.max = Math.max(min + 1, max);

		// PRIVATE
		me._table = [];
		me._timestamps = {
			data: timestamps,
			datasets: datasets,
			labels: labels
		};
	},

	buildTicks: function() {
		var me = this;
		var min = me.min;
		var max = me.max;
		var options = me.options;
		var tickOpts = options.ticks;
		var timeOpts = options.time;
		var timestamps = me._timestamps;
		var ticks = [];
		var capacity = me.getLabelCapacity(min);
		var source = tickOpts.source;
		var distribution = options.distribution;
		var i, ilen, timestamp;

		if (source === 'data' || (source === 'auto' && distribution === 'series')) {
			timestamps = timestamps.data;
		} else if (source === 'labels') {
			timestamps = timestamps.labels;
		} else {
			timestamps = generate(me, min, max, capacity);
		}

		if (options.bounds === 'ticks' && timestamps.length) {
			min = timestamps[0];
			max = timestamps[timestamps.length - 1];
		}

		// Enforce limits with user min/max options
		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// Remove ticks outside the min/max range
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			timestamp = timestamps[i];
			if (timestamp >= min && timestamp <= max) {
				ticks.push(timestamp);
			}
		}

		me.min = min;
		me.max = max;

		// PRIVATE
		// determineUnitForFormatting relies on the number of ticks so we don't use it when
		// autoSkip is enabled because we don't yet know what the final number of ticks will be
		me._unit = timeOpts.unit || (tickOpts.autoSkip
			? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
			: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
		me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
			: determineMajorUnit(me._unit);
		me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
		me._offsets = computeOffsets(me._table, ticks, min, max, options);

		if (tickOpts.reverse) {
			ticks.reverse();
		}

		return ticksFromTimestamps(me, ticks, me._majorUnit);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var adapter = me._adapter;
		var data = me.chart.data;
		var timeOpts = me.options.time;
		var label = data.labels && index < data.labels.length ? data.labels[index] : '';
		var value = data.datasets[datasetIndex].data[index];

		if (helpers$1.isObject(value)) {
			label = me.getRightValue(value);
		}
		if (timeOpts.tooltipFormat) {
			return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
		}
		if (typeof label === 'string') {
			return label;
		}
		return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
	},

	/**
	 * Function to format an individual tick mark
	 * @private
	 */
	tickFormatFunction: function(time, index, ticks, format) {
		var me = this;
		var adapter = me._adapter;
		var options = me.options;
		var formats = options.time.displayFormats;
		var minorFormat = formats[me._unit];
		var majorUnit = me._majorUnit;
		var majorFormat = formats[majorUnit];
		var tick = ticks[index];
		var tickOpts = options.ticks;
		var major = majorUnit && majorFormat && tick && tick.major;
		var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
		var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
		var formatter = resolve$5([
			nestedTickOpts.callback,
			nestedTickOpts.userCallback,
			tickOpts.callback,
			tickOpts.userCallback
		]);

		return formatter ? formatter(label, index, ticks) : label;
	},

	convertTicksToLabels: function(ticks) {
		var labels = [];
		var i, ilen;

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
		}

		return labels;
	},

	/**
	 * @private
	 */
	getPixelForOffset: function(time) {
		var me = this;
		var offsets = me._offsets;
		var pos = interpolate$1(me._table, 'time', time, 'pos');
		return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
	},

	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var time = null;

		if (index !== undefined && datasetIndex !== undefined) {
			time = me._timestamps.datasets[datasetIndex][index];
		}

		if (time === null) {
			time = parse(me, value);
		}

		if (time !== null) {
			return me.getPixelForOffset(time);
		}
	},

	getPixelForTick: function(index) {
		var ticks = this.getTicks();
		return index >= 0 && index < ticks.length ?
			this.getPixelForOffset(ticks[index].value) :
			null;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var offsets = me._offsets;
		var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
		var time = interpolate$1(me._table, 'pos', pos, 'time');

		// DEPRECATION, we should return time directly
		return me._adapter._create(time);
	},

	/**
	 * @private
	 */
	_getLabelSize: function(label) {
		var me = this;
		var ticksOpts = me.options.ticks;
		var tickLabelWidth = me.ctx.measureText(label).width;
		var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
		var cosRotation = Math.cos(angle);
		var sinRotation = Math.sin(angle);
		var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);

		return {
			w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
			h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
		};
	},

	/**
	 * Crude approximation of what the label width might be
	 * @private
	 */
	getLabelWidth: function(label) {
		return this._getLabelSize(label).w;
	},

	/**
	 * @private
	 */
	getLabelCapacity: function(exampleTime) {
		var me = this;
		var timeOpts = me.options.time;
		var displayFormats = timeOpts.displayFormats;

		// pick the longest format (milliseconds) for guestimation
		var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
		var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
		var size = me._getLabelSize(exampleLabel);
		var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);

		if (me.options.offset) {
			capacity--;
		}

		return capacity > 0 ? capacity : 1;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$4 = defaultConfig$4;
scale_time._defaults = _defaults$4;

var scales = {
	category: scale_category,
	linear: scale_linear,
	logarithmic: scale_logarithmic,
	radialLinear: scale_radialLinear,
	time: scale_time
};

var FORMATS = {
	datetime: 'MMM D, YYYY, h:mm:ss a',
	millisecond: 'h:mm:ss.SSS a',
	second: 'h:mm:ss a',
	minute: 'h:mm a',
	hour: 'hA',
	day: 'MMM D',
	week: 'll',
	month: 'MMM YYYY',
	quarter: '[Q]Q - YYYY',
	year: 'YYYY'
};

core_adapters._date.override(typeof moment === 'function' ? {
	_id: 'moment', // DEBUG ONLY

	formats: function() {
		return FORMATS;
	},

	parse: function(value, format) {
		if (typeof value === 'string' && typeof format === 'string') {
			value = moment(value, format);
		} else if (!(value instanceof moment)) {
			value = moment(value);
		}
		return value.isValid() ? value.valueOf() : null;
	},

	format: function(time, format) {
		return moment(time).format(format);
	},

	add: function(time, amount, unit) {
		return moment(time).add(amount, unit).valueOf();
	},

	diff: function(max, min, unit) {
		return moment(max).diff(moment(min), unit);
	},

	startOf: function(time, unit, weekday) {
		time = moment(time);
		if (unit === 'isoWeek') {
			return time.isoWeekday(weekday).valueOf();
		}
		return time.startOf(unit).valueOf();
	},

	endOf: function(time, unit) {
		return moment(time).endOf(unit).valueOf();
	},

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(time) {
		return moment(time);
	},
} : {});

core_defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		if (helpers$1.isArray(boundary)) {
			return function(point, i) {
				return boundary[i];
			};
		}

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeLinearBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (helpers$1.isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function computeCircularBoundary(source) {
	var scale = source.el._scale;
	var options = scale.options;
	var length = scale.chart.data.labels.length;
	var fill = source.fill;
	var target = [];
	var start, end, center, i, point;

	if (!length) {
		return null;
	}

	start = options.ticks.reverse ? scale.max : scale.min;
	end = options.ticks.reverse ? scale.min : scale.max;
	center = scale.getPointPositionForValue(0, start);
	for (i = 0; i < length; ++i) {
		point = fill === 'start' || fill === 'end'
			? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
			: scale.getBasePosition(i);
		if (options.gridLines.circular) {
			point.cx = center.x;
			point.cy = center.y;
			point.angle = scale.getIndexAngle(i) - Math.PI / 2;
		}
		target.push(point);
	}
	return target;
}

function computeBoundary(source) {
	var scale = source.el._scale || {};

	if (scale.getPointPositionForValue) {
		return computeCircularBoundary(source);
	}
	return computeLinearBoundary(source);
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i, cx, cy, r;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	if (curve1[0].angle !== undefined) {
		cx = curve1[0].cx;
		cy = curve1[0].cy;
		r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
		for (i = len1 - 1; i > 0; --i) {
			ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
		}
		return;
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1, loopOffset;

	ctx.beginPath();

	for (i = 0, ilen = count; i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (loop && loopOffset === undefined && d0) {
			loopOffset = i + 1;
			ilen = count + loopOffset;
		}

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

var plugin_filler = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetsDraw: function(chart) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var ctx = chart.ctx;
		var meta, i, el, view, points, mapper, color;

		for (i = metasets.length - 1; i >= 0; --i) {
			meta = metasets[i].$filler;

			if (!meta || !meta.visible) {
				continue;
			}

			el = meta.el;
			view = el._view;
			points = el._children || [];
			mapper = meta.mapper;
			color = view.backgroundColor || core_defaults.global.defaultColor;

			if (mapper && color && points.length) {
				helpers$1.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers$1.canvas.unclipArea(ctx);
			}
		}
	}
};

var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
var noop$1 = helpers$1.noop;
var valueOrDefault$e = helpers$1.valueOrDefault;

core_defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		align: 'center',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,
		onLeave: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var datasets = chart.data.datasets;
				var options = chart.options.legend || {};
				var usePointStyle = options.labels && options.labels.usePointStyle;

				return chart._getSortedDatasetMetas().map(function(meta) {
					var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);

					return {
						text: datasets[meta.index].label,
						fillStyle: style.backgroundColor,
						hidden: !chart.isDatasetVisible(meta.index),
						lineCap: style.borderCapStyle,
						lineDash: style.borderDash,
						lineDashOffset: style.borderDashOffset,
						lineJoin: style.borderJoinStyle,
						lineWidth: style.borderWidth,
						strokeStyle: style.borderColor,
						pointStyle: style.pointStyle,
						rotation: style.rotation,

						// Below is extra data used for toggling the datasets
						datasetIndex: meta.index
					};
				}, this);
			}
		}
	},

	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var datasets = chart.data.datasets;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			listItem = list.appendChild(document.createElement('li'));
			listItemSpan = listItem.appendChild(document.createElement('span'));
			listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
			if (datasets[i].label) {
				listItem.appendChild(document.createTextNode(datasets[i].label));
			}
		}

		return list.outerHTML;
	}
});

/**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */
function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
		fontSize :
		labelOpts.boxWidth;
}

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Legend = core_element.extend({

	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];

		/**
 		 * @private
 		 */
		me._hoveredItem = null;

		// Are we in doughnut mode which has a different data type
		me.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop$1,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop$1,

	//

	beforeSetDimensions: noop$1,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$1,

	//

	beforeBuildLabels: noop$1,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop$1,

	//

	beforeFit: noop$1,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (!display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}
		ctx.font = labelFont.string;

		if (isHorizontal) {
			// Labels

			// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
			var lineWidths = me.lineWidths = [0];
			var totalHeight = 0;

			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
					totalHeight += fontSize + labelOpts.padding;
					lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
				}

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: width,
					height: fontSize
				};

				lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
			});

			minSize.height += totalHeight;

		} else {
			var vPadding = labelOpts.padding;
			var columnWidths = me.columnWidths = [];
			var columnHeights = me.columnHeights = [];
			var totalWidth = labelOpts.padding;
			var currentColWidth = 0;
			var currentColHeight = 0;

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				// If too tall, go to new column
				if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
					totalWidth += currentColWidth + labelOpts.padding;
					columnWidths.push(currentColWidth); // previous column width
					columnHeights.push(currentColHeight);
					currentColWidth = 0;
					currentColHeight = 0;
				}

				// Get max width
				currentColWidth = Math.max(currentColWidth, itemWidth);
				currentColHeight += fontSize + vPadding;

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: itemWidth,
					height: fontSize
				};
			});

			totalWidth += currentColWidth;
			columnWidths.push(currentColWidth);
			columnHeights.push(currentColHeight);
			minSize.width += totalWidth;
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop$1,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor;
		var lineDefault = globalDefaults.elements.line;
		var legendHeight = me.height;
		var columnHeights = me.columnHeights;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (!opts.display) {
			return;
		}

		var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
		var ctx = me.ctx;
		var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;
		var cursor;

		// Canvas setup
		ctx.textAlign = rtlHelper.textAlign('left');
		ctx.textBaseline = 'middle';
		ctx.lineWidth = 0.5;
		ctx.strokeStyle = fontColor; // for strikethrough effect
		ctx.fillStyle = fontColor; // render in correct colour
		ctx.font = labelFont.string;

		var boxWidth = getBoxWidth(labelOpts, fontSize);
		var hitboxes = me.legendHitBoxes;

		// current position
		var drawLegendBox = function(x, y, legendItem) {
			if (isNaN(boxWidth) || boxWidth <= 0) {
				return;
			}

			// Set the ctx for the box
			ctx.save();

			var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
			ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
			ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
			ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
			ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);

			if (ctx.setLineDash) {
				// IE 9 and 10 do not support line dash
				ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
			}

			if (labelOpts && labelOpts.usePointStyle) {
				// Recalculate x and y for drawPoint() because its expecting
				// x and y to be center of figure (instead of top left)
				var radius = boxWidth * Math.SQRT2 / 2;
				var centerX = rtlHelper.xPlus(x, boxWidth / 2);
				var centerY = y + fontSize / 2;

				// Draw pointStyle as legend symbol
				helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
			} else {
				// Draw box as legend symbol
				ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				if (lineWidth !== 0) {
					ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				}
			}

			ctx.restore();
		};

		var fillText = function(x, y, legendItem, textWidth) {
			var halfFontSize = fontSize / 2;
			var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
			var yMiddle = y + halfFontSize;

			ctx.fillText(legendItem.text, xLeft, yMiddle);

			if (legendItem.hidden) {
				// Strikethrough the text if hidden
				ctx.beginPath();
				ctx.lineWidth = 2;
				ctx.moveTo(xLeft, yMiddle);
				ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
				ctx.stroke();
			}
		};

		var alignmentOffset = function(dimension, blockSize) {
			switch (opts.align) {
			case 'start':
				return labelOpts.padding;
			case 'end':
				return dimension - blockSize;
			default: // center
				return (dimension - blockSize + labelOpts.padding) / 2;
			}
		};

		// Horizontal
		var isHorizontal = me.isHorizontal();
		if (isHorizontal) {
			cursor = {
				x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
				y: me.top + labelOpts.padding,
				line: 0
			};
		} else {
			cursor = {
				x: me.left + labelOpts.padding,
				y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
				line: 0
			};
		}

		helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);

		var itemHeight = fontSize + labelOpts.padding;
		helpers$1.each(me.legendItems, function(legendItem, i) {
			var textWidth = ctx.measureText(legendItem.text).width;
			var width = boxWidth + (fontSize / 2) + textWidth;
			var x = cursor.x;
			var y = cursor.y;

			rtlHelper.setWidth(me.minSize.width);

			// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
			// instead of me.right and me.bottom because me.width and me.height
			// may have been changed since me.minSize was calculated
			if (isHorizontal) {
				if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
					y = cursor.y += itemHeight;
					cursor.line++;
					x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
				}
			} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
				x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
				cursor.line++;
				y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
			}

			var realX = rtlHelper.x(x);

			drawLegendBox(realX, y, legendItem);

			hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
			hitboxes[i].top = y;

			// Fill the actual label
			fillText(realX, y, legendItem, textWidth);

			if (isHorizontal) {
				cursor.x += width + labelOpts.padding;
			} else {
				cursor.y += itemHeight;
			}
		});

		helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
	},

	/**
	 * @private
	 */
	_getLegendItemAt: function(x, y) {
		var me = this;
		var i, hitBox, lh;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			lh = me.legendHitBoxes;
			for (i = 0; i < lh.length; ++i) {
				hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					return me.legendItems[i];
				}
			}
		}

		return null;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var hoveredItem;

		if (type === 'mousemove') {
			if (!opts.onHover && !opts.onLeave) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		hoveredItem = me._getLegendItemAt(e.x, e.y);

		if (type === 'click') {
			if (hoveredItem && opts.onClick) {
				// use e.native for backwards compatibility
				opts.onClick.call(me, e.native, hoveredItem);
			}
		} else {
			if (opts.onLeave && hoveredItem !== me._hoveredItem) {
				if (me._hoveredItem) {
					opts.onLeave.call(me, e.native, me._hoveredItem);
				}
				me._hoveredItem = hoveredItem;
			}

			if (opts.onHover && hoveredItem) {
				// use e.native for backwards compatibility
				opts.onHover.call(me, e.native, hoveredItem);
			}
		}
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	core_layouts.configure(chart, legend, legendOpts);
	core_layouts.addBox(chart, legend);
	chart.legend = legend;
}

var plugin_legend = {
	id: 'legend',

	/**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers$1.mergeIf(legendOpts, core_defaults.global.legend);

			if (legend) {
				core_layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			core_layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};

var noop$2 = helpers$1.noop;

core_defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Title = core_element.extend({
	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop$2,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop$2,

	//

	beforeSetDimensions: noop$2,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$2,

	//

	beforeBuildLabels: noop$2,
	buildLabels: noop$2,
	afterBuildLabels: noop$2,

	//

	beforeFit: noop$2,
	fit: function() {
		var me = this;
		var opts = me.options;
		var minSize = me.minSize = {};
		var isHorizontal = me.isHorizontal();
		var lineCount, textSize;

		if (!opts.display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}

		lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
		textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;

		me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
		me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
	},
	afterFit: noop$2,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;

		if (!opts.display) {
			return;
		}

		var fontOpts = helpers$1.options._parseFont(opts);
		var lineHeight = fontOpts.lineHeight;
		var offset = lineHeight / 2 + opts.padding;
		var rotation = 0;
		var top = me.top;
		var left = me.left;
		var bottom = me.bottom;
		var right = me.right;
		var maxWidth, titleX, titleY;

		ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
		ctx.font = fontOpts.string;

		// Horizontal
		if (me.isHorizontal()) {
			titleX = left + ((right - left) / 2); // midpoint of the width
			titleY = top + offset;
			maxWidth = right - left;
		} else {
			titleX = opts.position === 'left' ? left + offset : right - offset;
			titleY = top + ((bottom - top) / 2);
			maxWidth = bottom - top;
			rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
		}

		ctx.save();
		ctx.translate(titleX, titleY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		var text = opts.text;
		if (helpers$1.isArray(text)) {
			var y = 0;
			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], 0, y, maxWidth);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, 0, 0, maxWidth);
		}

		ctx.restore();
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	core_layouts.configure(chart, title, titleOpts);
	core_layouts.addBox(chart, title);
	chart.titleBlock = title;
}

var plugin_title = {
	id: 'title',

	/**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers$1.mergeIf(titleOpts, core_defaults.global.title);

			if (titleBlock) {
				core_layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			core_layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};

var plugins = {};
var filler = plugin_filler;
var legend = plugin_legend;
var title = plugin_title;
plugins.filler = filler;
plugins.legend = legend;
plugins.title = title;

/**
 * @namespace Chart
 */


core_controller.helpers = helpers$1;

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
core_helpers();

core_controller._adapters = core_adapters;
core_controller.Animation = core_animation;
core_controller.animationService = core_animations;
core_controller.controllers = controllers;
core_controller.DatasetController = core_datasetController;
core_controller.defaults = core_defaults;
core_controller.Element = core_element;
core_controller.elements = elements;
core_controller.Interaction = core_interaction;
core_controller.layouts = core_layouts;
core_controller.platform = platform;
core_controller.plugins = core_plugins;
core_controller.Scale = core_scale;
core_controller.scaleService = core_scaleService;
core_controller.Ticks = core_ticks;
core_controller.Tooltip = core_tooltip;

// Register built-in scales

core_controller.helpers.each(scales, function(scale, type) {
	core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
});

// Load to register built-in adapters (as side effects)


// Loading built-in plugins

for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		core_controller.plugins.register(plugins[k]);
	}
}

core_controller.platform.initialize();

var src = core_controller;
if (typeof window !== 'undefined') {
	window.Chart = core_controller;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
core_controller.Chart = core_controller;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Legend = plugins.legend._element;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Title = plugins.title._element;

/**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.pluginService = core_controller.plugins;

/**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */
core_controller.PluginBase = core_controller.Element.extend({});

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
core_controller.canvasHelpers = core_controller.helpers.canvas;

/**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */
core_controller.layoutService = core_controller.layouts;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
core_controller.LinearScaleBase = scale_linearbase;

/**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */
core_controller.helpers.each(
	[
		'Bar',
		'Bubble',
		'Doughnut',
		'Line',
		'PolarArea',
		'Radar',
		'Scatter'
	],
	function(klass) {
		core_controller[klass] = function(ctx, cfg) {
			return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
				type: klass.charAt(0).toLowerCase() + klass.slice(1)
			}));
		};
	}
);

return src;

})));


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)(module)))

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(177);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(287),
    equalArrays = __webpack_require__(292),
    equalByTag = __webpack_require__(706),
    equalObjects = __webpack_require__(710),
    getTag = __webpack_require__(728),
    isArray = __webpack_require__(56),
    isBuffer = __webpack_require__(294),
    isTypedArray = __webpack_require__(296);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 673 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(121);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(121);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(121);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(121);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(120);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 679 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 680 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 681 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(120),
    Map = __webpack_require__(178),
    MapCache = __webpack_require__(180);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(289),
    isMasked = __webpack_require__(686),
    isObject = __webpack_require__(179),
    toSource = __webpack_require__(291);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(122);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 685 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(687);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(55);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 688 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(690),
    ListCache = __webpack_require__(120),
    Map = __webpack_require__(178);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(691),
    hashDelete = __webpack_require__(692),
    hashGet = __webpack_require__(693),
    hashHas = __webpack_require__(694),
    hashSet = __webpack_require__(695);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(123);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 692 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(123);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(123);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(123);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(124);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 697 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(124);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(124);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(124);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(180),
    setCacheAdd = __webpack_require__(702),
    setCacheHas = __webpack_require__(703);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 702 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 703 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 704 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 705 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(122),
    Uint8Array = __webpack_require__(707),
    eq = __webpack_require__(288),
    equalArrays = __webpack_require__(292),
    mapToArray = __webpack_require__(708),
    setToArray = __webpack_require__(709);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(55);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 708 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 709 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(711);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(712),
    getSymbols = __webpack_require__(714),
    keys = __webpack_require__(181);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(713),
    isArray = __webpack_require__(56);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 713 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(715),
    stubArray = __webpack_require__(716);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 715 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 716 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(718),
    isArguments = __webpack_require__(293),
    isArray = __webpack_require__(56),
    isBuffer = __webpack_require__(294),
    isIndex = __webpack_require__(295),
    isTypedArray = __webpack_require__(296);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 718 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(95),
    isObjectLike = __webpack_require__(96);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 720 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(95),
    isLength = __webpack_require__(182),
    isObjectLike = __webpack_require__(96);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 722 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(290);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)(module)))

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(725),
    nativeKeys = __webpack_require__(726);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 725 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(727);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 727 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(729),
    Map = __webpack_require__(178),
    Promise = __webpack_require__(730),
    Set = __webpack_require__(731),
    WeakMap = __webpack_require__(732),
    baseGetTag = __webpack_require__(95),
    toSource = __webpack_require__(291);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(70),
    root = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(70),
    root = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(70),
    root = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(70),
    root = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(734),
    createAggregator = __webpack_require__(736);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(735);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(70);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(737),
    baseAggregator = __webpack_require__(738),
    baseIteratee = __webpack_require__(744),
    isArray = __webpack_require__(56);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 737 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(739);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(740),
    createBaseEach = __webpack_require__(743);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(741),
    keys = __webpack_require__(181);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(742);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 742 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(297);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(745),
    baseMatchesProperty = __webpack_require__(748),
    identity = __webpack_require__(759),
    isArray = __webpack_require__(56),
    property = __webpack_require__(760);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(746),
    getMatchData = __webpack_require__(747),
    matchesStrictComparable = __webpack_require__(299);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(287),
    baseIsEqual = __webpack_require__(177);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(298),
    keys = __webpack_require__(181);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(177),
    get = __webpack_require__(749),
    hasIn = __webpack_require__(756),
    isKey = __webpack_require__(183),
    isStrictComparable = __webpack_require__(298),
    matchesStrictComparable = __webpack_require__(299),
    toKey = __webpack_require__(125);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(300);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(751);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(752);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(180);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(754);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(122),
    arrayMap = __webpack_require__(755),
    isArray = __webpack_require__(56),
    isSymbol = __webpack_require__(184);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 755 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(757),
    hasPath = __webpack_require__(758);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 757 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(301),
    isArguments = __webpack_require__(293),
    isArray = __webpack_require__(56),
    isIndex = __webpack_require__(295),
    isLength = __webpack_require__(182),
    toKey = __webpack_require__(125);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 759 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(761),
    basePropertyDeep = __webpack_require__(762),
    isKey = __webpack_require__(183),
    toKey = __webpack_require__(125);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 761 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(300);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssociateScanReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_AssociateNetworkAPI__ = __webpack_require__(764);
var AssociateScanReducer=function AssociateScanReducer(state,action){switch(action.type){case"LOAD_DATA":var dispatcher=action.data.dispatcher;Object(__WEBPACK_IMPORTED_MODULE_0__network_AssociateNetworkAPI__["a" /* fetchAssociateScanMetrics */])(dispatcher);return state;case"RECEIVE_DATA":var scanData=action.data.associateScanMetricResponseMap||{};if(scanData["15m"]&&Object.keys(scanData["15m"]).length>0){scanData["cumulative"]={};Object.keys(scanData["15m"]).forEach(function(email){var data15m=scanData["15m"][email];if(data15m&&Array.isArray(data15m)){var cumulativeSum=0;scanData["cumulative"][email]=data15m.map(function(item){cumulativeSum+=item.metricValue||0;return{timeStampVal:item.timeStampVal,metricValue:cumulativeSum};});}});}var firstGranularity=Object.keys(scanData)[0];var associateList=firstGranularity&&scanData[firstGranularity]?Object.keys(scanData[firstGranularity]).sort().map(function(email){return{key:email,name:email.replace('@amazon.com','')};}):[];var isFirstLoad=state.associateList.length===0;var newAssociateKeys=associateList.map(function(associate){return associate.key;});var existingSelection=state.chartData.selectedAssociates.filter(function(key){return newAssociateKeys.includes(key);});return Object.assign({},state,{scanMetrics:scanData,associateList:associateList,chartData:Object.assign({},state.chartData,{selectedAssociates:isFirstLoad?newAssociateKeys:existingSelection})});case"SET_SELECTED_ASSOCIATES":return Object.assign({},state,{chartData:Object.assign({},state.chartData,{selectedAssociates:action.data.selectedAssociates})});case"SET_GRANULARITY":return Object.assign({},state,{chartData:Object.assign({},state.chartData,{granularity:action.data.granularity})});default:return state;}};

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchAssociateScanMetrics;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_StowResource__ = __webpack_require__(31);
var getAssociateScanMetrics=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher,request){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_StowResource__["f" /* getStowAssociateScanMetrics */])(request);case 3:result=_context.sent;dispatcher({type:"RECEIVE_DATA",data:result});_context.next=10;break;case 7:_context.prev=7;_context.t0=_context["catch"](0);console.error("Error fetching associate scan metrics:",_context.t0);case 10:case"end":return _context.stop();}}},_callee,this,[[0,7]]);}));return function getAssociateScanMetrics(_x,_x2){return _ref.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function fetchAssociateScanMetrics(dispatcher){var request={filters:{NODE:[Object(__WEBPACK_IMPORTED_MODULE_1__Utility__["m" /* getNodeId */])()]},metrics:["SCAN_TIME"],groupBy:"ASSOCIATE"};getAssociateScanMetrics(dispatcher,request);}

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_breadcrumb_breadcrumb_group__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_breadcrumb_breadcrumb_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_breadcrumb_breadcrumb_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_breadcrumb__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_heading__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_PackageListActions__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_pagination__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_row__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__handler_LocaleHandler__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__enums__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__RefreshTimer__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PackageList=function(_Component){_inherits(PackageList,_Component);function PackageList(props){_classCallCheck(this,PackageList);var _this=_possibleConstructorReturn(this,(PackageList.__proto__||Object.getPrototypeOf(PackageList)).call(this,props));_this.renderConveyanceHeading=function(){return __WEBPACK_IMPORTED_MODULE_17__enums__["e" /* Capability */].AR_NEXT_GEN===_this.props.capability&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,{sortColumn:"station_pair"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.station_pair",defaultMessage:"Station"}));};_this.renderCycleHeading=function(){return __WEBPACK_IMPORTED_MODULE_17__enums__["e" /* Capability */].AMZL===_this.props.capability&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,{sortColumn:"cycle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.cycle",defaultMessage:"Cycle"}));};_this.renderSortZoneHeading=function(){return __WEBPACK_IMPORTED_MODULE_17__enums__["e" /* Capability */].AMZL===_this.props.capability&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,{sortColumn:"sortZone"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.sortZone",defaultMessage:"Sort Zone"}));};_this.renderClusterHeading=function(){return __WEBPACK_IMPORTED_MODULE_17__enums__["e" /* Capability */].AMZL===_this.props.capability&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,{sortColumn:"cluster"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.cluster",defaultMessage:"Cluster"}));};_this.renderCartAndBinHeading=function(){return _this.isArNextGenStowedStatus()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,{sortColumn:"cartAndBin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.cartAndBin",defaultMessage:"Cart/Bin"}));};_this.renderConveyanceValue=function(packageObject){return __WEBPACK_IMPORTED_MODULE_17__enums__["e" /* Capability */].AR_NEXT_GEN===_this.props.capability&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,null," ",Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.conveyance;},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */])," ");};_this.renderLocationValue=function(packageObject){if(_this.isArNextGenStowedStatus()){var conveyance=Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.conveyance;},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */]);var floorSuffix=Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.floor.split(".")[1];},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */]);var value=conveyance+", "+floorSuffix;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,null," ",value," ");}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,null," ",Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.location;},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */])," ");}};_this.renderCycleValue=function(packageObject){return __WEBPACK_IMPORTED_MODULE_17__enums__["e" /* Capability */].AMZL===_this.props.capability&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,null," ",Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.cycle;},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */])," ");};_this.renderSortZoneValue=function(packageObject){return __WEBPACK_IMPORTED_MODULE_17__enums__["e" /* Capability */].AMZL===_this.props.capability&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,null," ",Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.sortZone;},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */])," ");};_this.renderClusterValue=function(packageObject){return __WEBPACK_IMPORTED_MODULE_17__enums__["e" /* Capability */].AMZL===_this.props.capability&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,null," ",Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.cluster;},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */])," ");};_this.renderCartAndBinValue=function(packageObject){if(_this.isArNextGenStowedStatus()){var cart=Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.location.split(".")[0];},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */]);var binSuffix=Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.location.split(".")[1];},null);var value=binSuffix?cart+", "+binSuffix:cart;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,null," ",value," ");}};_this.isArNextGenStowedStatus=function(){return __WEBPACK_IMPORTED_MODULE_17__enums__["e" /* Capability */].AR_NEXT_GEN===_this.props.capability&&__WEBPACK_IMPORTED_MODULE_17__enums__["n" /* PackageStatus */].CURRENT_STOWED===_this.state.queryParams.get(__WEBPACK_IMPORTED_MODULE_18__constants__["t" /* PACKAGE_STATUS */]);};_this.state={currentPage:1,sortColumn:"trackingId",sortDirection:"ascending",queryParams:new URLSearchParams(_this.props.location.search)};return _this;}_createClass(PackageList,[{key:"render",value:function render(){var _this2=this;var packageList=this.props.packageList;var queryParams=new URLSearchParams(this.props.location.search);var currentPage=this.state.currentPage;var onSort=function onSort(sortDetails){_this2.setState({sortColumn:sortDetails.sortColumn,sortDirection:sortDetails.sortDirection});switch(sortDetails.sortDirection){case'ascending':packageList.sort(function(a,b){return customCompare(a,b);});break;case'descending':packageList.sort(function(a,b){return customCompare(b,a);});break;default:break;}function customCompare(a,b){var orderedSizes=["EXTRA_SMALL","SMALL","MEDIUM","LARGE","EXTRA_LARGE"];var fieldA=a[sortDetails.sortColumn];var fieldB=b[sortDetails.sortColumn];if(sortDetails.sortColumn==="size"){return orderedSizes.indexOf(fieldA)-orderedSizes.indexOf(fieldB);}return Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["b" /* convertToString */])(fieldA).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["b" /* convertToString */])(fieldB),Object(__WEBPACK_IMPORTED_MODULE_15__handler_LocaleHandler__["b" /* getLocale */])(),{numeric:true});}};function isRouteCodeApplicable(){if(queryParams["PACKAGE_STATUS"]&&(queryParams["PACKAGE_STATUS"]==="CURRENT_INDUCTED"||queryParams["PACKAGE_STATUS"]==="CURRENT_RECEIVED")){return false;}return true;}var changePage=function changePage(pageNumber){_this2.setState(function(){return{currentPage:pageNumber};});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacingInset:"large medium none large"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_breadcrumb_breadcrumb_group___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_breadcrumb___default.a,{href:"#heatMap"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.stow",defaultMessage:"Stow"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_breadcrumb___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.packageList",defaultMessage:"Package List"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_heading___default.a,{level:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.packageSummary",defaultMessage:"Package Summary"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__RefreshTimer__["a" /* default */],{deps:[packageList]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true,sortColumn:this.state.sortColumn,sortDirection:this.state.sortDirection,onSort:onSort},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,{sortColumn:"trackingId"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.trackingId",defaultMessage:"Tracking Id"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,{sortColumn:"lastScan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.lastScan",defaultMessage:"Last scan"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,{sortColumn:"minutesInState",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.minute_in_state",defaultMessage:"Minutes in state"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,{sortColumn:"state"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.state",defaultMessage:"State"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,{sortColumn:"reason"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.reason",defaultMessage:"Reason"})),this.renderConveyanceHeading(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,{sortColumn:"location"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.location",defaultMessage:"Location"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,{sortColumn:"associateId"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.associate_id",defaultMessage:"Associate ID"})),this.renderCycleHeading(),this.renderSortZoneHeading(),this.renderClusterHeading(),this.renderCartAndBinHeading(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,{sortColumn:"ead"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.ead",defaultMessage:"EAD"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,{sortColumn:"size"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.size",defaultMessage:"Size"})),isRouteCodeApplicable()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,{sortColumn:"routeCode"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_intl__["a" /* FormattedMessage */],{id:"packageList.routeCode",defaultMessage:"Route Code"})):null),packageList&&packageList.slice((currentPage-1)*25,currentPage*25).map(function(packageObject){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table_table_row___default.a,{key:packageObject.trackingId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.trackingId;},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.lastScan;},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.minutesInState;},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.state;},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.reason;},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */])),_this2.renderConveyanceValue(packageObject),_this2.renderLocationValue(packageObject),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.associateId;},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */])),_this2.renderCycleValue(packageObject),_this2.renderSortZoneValue(packageObject),_this2.renderClusterValue(packageObject),_this2.renderCartAndBinValue(packageObject),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.ead;},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.size;},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */])),isRouteCodeApplicable()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table_table_cell___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["a" /* chainWalk */])(function(){return packageObject.routeCode;},__WEBPACK_IMPORTED_MODULE_18__constants__["o" /* HYPHEN */])):null);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_row___default.a,{alignmentVertical:"top",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_pagination___default.a,{numberOfPages:Math.ceil(packageList.length/25),onChange:function onChange(pageNumber){return changePage(pageNumber);},currentPage:this.state.currentPage})));}},{key:"componentDidMount",value:function componentDidMount(){var _this3=this;this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_OptionsActions__["m" /* fetchCapability */])()).then(function(){var nodeId=Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["m" /* getNodeId */])();var queryParams=_this3.state.queryParams;if(__WEBPACK_IMPORTED_MODULE_17__enums__["n" /* PackageStatus */].PICKED===queryParams.get(__WEBPACK_IMPORTED_MODULE_18__constants__["t" /* PACKAGE_STATUS */])){Object(__WEBPACK_IMPORTED_MODULE_19__handler_ParentDataHandler__["d" /* getDocumentURL */])().then(function(value){var baseURL=Object(__WEBPACK_IMPORTED_MODULE_10__Utility__["g" /* getBaseUrl */])(value);_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_PackageListActions__["e" /* fetchPickedPackageList */])(baseURL,nodeId,queryParams));});}else{_this3.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_PackageListActions__["d" /* fetchPackageListForFilters */])(nodeId,queryParams,_this3.props.capability));}});}}]);return PackageList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{capability:state.optionsReducer.capability,packageList:state.packageListReducer.packageList};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(PackageList)));

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _inherits2 = _interopRequireDefault(__webpack_require__(20));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(108));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(63));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _range = _interopRequireDefault(__webpack_require__(212));

var _difference = _interopRequireDefault(__webpack_require__(767));

var _find = _interopRequireDefault(__webpack_require__(101));

var _union = _interopRequireDefault(__webpack_require__(777));

var _pagination = _interopRequireDefault(__webpack_require__(778));

var _token = __webpack_require__(12);

var _theme = __webpack_require__(14);

var _row = _interopRequireDefault(__webpack_require__(44));

var _arrowControls = _interopRequireDefault(__webpack_require__(779));

var _pageButton = _interopRequireDefault(__webpack_require__(783));

var _ellipse = _interopRequireDefault(__webpack_require__(784));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

var _excluded = ["pageNumbers", "currentPage", "t"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/** Constants */
var BREAK = "BREAK";
var MEDIUM_SET_SPACES = 5;
/** Helpers */

var isShortSet = function isShortSet(val) {
  return val <= 5;
};

var isMediumSet = function isMediumSet(val) {
  return val > 5 && val <= 8;
};

var isLongSet = function isLongSet(val) {
  return val > 8;
};

var insertIf = function insertIf(condition) {
  for (var _len = arguments.length, elements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    elements[_key - 1] = arguments[_key];
  }

  return condition ? elements : [];
}; // Lodash doesn't include the end value in the array which
// is confusing. This method simply adds +1 to the end value
// which makes the code easier to understand


var getRange = function getRange(start, end, step) {
  return (0, _range["default"])(start, end + 1, step);
}; // Get surrounding numbers around an anchor and return them as an array


var getSurroundingNumbers = function getSurroundingNumbers(_ref) {
  var anchor = _ref.anchor,
      setLength = _ref.setLength,
      ceiling = _ref.ceiling,
      _ref$floor = _ref.floor,
      floor = _ref$floor === void 0 ? 0 : _ref$floor;
  var surroundingNumbers = [anchor];
  var i = 1; // While we still have spaces to fill

  while (surroundingNumbers.length < setLength) {
    // If we can, put an even smaller number at the start of the array
    if (anchor - i > floor) surroundingNumbers.unshift(anchor - i); // If we can, put an even larger number at the end of the array

    if (anchor + i <= ceiling) surroundingNumbers.push(anchor + i);
    i += 1;
  }

  return surroundingNumbers;
};

var getNumberOfEdgePages = function getNumberOfEdgePages(_ref2) {
  var closeTrunc = _ref2.closeTrunc,
      farTrunc = _ref2.farTrunc,
      surroundingPages = _ref2.surroundingPages,
      farRange = _ref2.farRange;
  return farTrunc ? closeTrunc ? 1 // if truncating on both sides, display 1
  : 3 // else display 3
  : // if the further edge doesn't need truncation,
  // calculate how many slots remain. This is done
  // by calculating the difference in the total number
  // of slots (6) and how many numbers are being used
  // in the far set (eg. [1, 2, 3, 4, 5])
  6 - (0, _union["default"])(farRange, surroundingPages).length;
};
/** Sets */


var shortSet = {
  check: isShortSet,
  pageNumbers: function pageNumbers(_ref3) {
    var numberOfPages = _ref3.numberOfPages;
    return getRange(1, numberOfPages);
  }
};
var mediumSet = {
  check: isMediumSet,
  pageNumbers: function pageNumbers(_ref4) {
    var numberOfPages = _ref4.numberOfPages,
        currentPage = _ref4.currentPage;
    return getSurroundingNumbers({
      anchor: currentPage,
      setLength: MEDIUM_SET_SPACES,
      ceiling: numberOfPages
    });
  }
};
var longSet = {
  check: isLongSet,
  pageNumbers: function pageNumbers(_ref5) {
    var numberOfPages = _ref5.numberOfPages,
        currentPage = _ref5.currentPage;
    var surroundingPages = getSurroundingNumbers({
      anchor: currentPage,
      setLength: 3,
      ceiling: numberOfPages
    }); // If the outer surrounding numbers are more then 3 away from
    // their respective extreme, add a truncation/ellipse

    var needsBeginningTrunc = surroundingPages[0] - 3 >= 1;
    var needsEndingTrunc = surroundingPages[2] + 3 <= numberOfPages;
    var numberOfEndingPages = getNumberOfEdgePages({
      closeTrunc: needsEndingTrunc,
      farTrunc: needsBeginningTrunc,
      farRange: getRange(1, 3),
      surroundingPages: surroundingPages
    });
    var numberOfBegginningPages = getNumberOfEdgePages({
      closeTrunc: needsBeginningTrunc,
      farTrunc: needsEndingTrunc,
      farRange: getRange(numberOfPages - 2, numberOfPages),
      surroundingPages: surroundingPages
    });
    var beginningPages = getRange(1, numberOfBegginningPages); // We add + 1 to numberOfPages because we are starting
    // with the assumption if numberOfEndingPages = 1 the
    // range should only include that number.
    // e.g. numberOfPages = 10, numberOfEndingPages = 1
    // getRange(10 + 1 - 1, 10) = [10]
    // e.g. numberOfPages = 10, numberOfEndingPages = 2
    // getRange(10 + 1 - 2, 10) = [9, 10]

    var endPages = getRange(numberOfPages + 1 - numberOfEndingPages, numberOfPages);
    return [].concat((0, _toConsumableArray2["default"])((0, _difference["default"])(beginningPages, surroundingPages)), (0, _toConsumableArray2["default"])(insertIf(needsBeginningTrunc, BREAK)), (0, _toConsumableArray2["default"])(surroundingPages), (0, _toConsumableArray2["default"])(insertIf(needsEndingTrunc, BREAK)), (0, _toConsumableArray2["default"])((0, _difference["default"])(endPages, surroundingPages)));
  }
};

var buildPageNumbers = function buildPageNumbers(numberOfPages, currentPage) {
  return (0, _find["default"])([shortSet, mediumSet, longSet], function (_ref6) {
    var check = _ref6.check;
    return check(numberOfPages);
  }).pageNumbers({
    numberOfPages: numberOfPages,
    currentPage: currentPage
  });
};

var buildPageButtons = function buildPageButtons(_ref7) {
  var pageNumbers = _ref7.pageNumbers,
      currentPage = _ref7.currentPage,
      t = _ref7.t,
      props = (0, _objectWithoutProperties2["default"])(_ref7, _excluded);
  return pageNumbers.map(function (value, index) {
    return value !== BREAK ? /*#__PURE__*/_react["default"].createElement(_pageButton["default"], (0, _extends2["default"])({}, props, {
      t: t,
      selected: value === currentPage,
      key: value
    }), value) : /*#__PURE__*/_react["default"].createElement(_ellipse["default"], {
      key: "ellipse-".concat(index),
      t: t,
      disabled: props.disabled
    });
  });
};

var Pagination = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Pagination, _React$Component);

  var _super = _createSuper(Pagination);

  function Pagination() {
    (0, _classCallCheck2["default"])(this, Pagination);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Pagination, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          showSkipArrows = _this$props.showSkipArrows,
          label = _this$props.label,
          locale = _this$props.locale;
      var _this$props2 = this.props,
          numberOfPages = _this$props2.numberOfPages,
          currentPage = _this$props2.currentPage;
      if (!numberOfPages || numberOfPages <= 0) numberOfPages = 1;

      if (!currentPage || currentPage <= 0) {
        currentPage = 1;
      } else if (currentPage > numberOfPages) {
        currentPage = numberOfPages;
      }

      var pageNumbers = buildPageNumbers(numberOfPages, currentPage);
      var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, ["data-", "aria-"]);
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _pagination["default"],
        map: (0, _token.getTokenHelper)("pagination")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("nav", (0, _extends2["default"])({}, passThroughProps, {
          role: "navigation",
          "aria-label": label
        }), /*#__PURE__*/_react["default"].createElement(_row["default"], {
          spacing: "none"
        }, /*#__PURE__*/_react["default"].createElement(_arrowControls["default"], (0, _extends2["default"])({}, _this.props, {
          currentPage: currentPage,
          numberOfPages: numberOfPages,
          showSkipArrows: showSkipArrows && !isShortSet(numberOfPages),
          arrowColor: t("arrowColor"),
          direction: "left"
        })), buildPageButtons(_objectSpread(_objectSpread({}, _this.props), {}, {
          currentPage: currentPage,
          numberOfPages: numberOfPages,
          pageNumbers: pageNumbers,
          t: t,
          locale: locale
        })), /*#__PURE__*/_react["default"].createElement(_arrowControls["default"], (0, _extends2["default"])({}, _this.props, {
          currentPage: currentPage,
          numberOfPages: numberOfPages,
          showSkipArrows: showSkipArrows && !isShortSet(numberOfPages),
          arrowColor: t("arrowColor"),
          direction: "right"
        }))));
      });
    }
  }]);
  return Pagination;
}(_react["default"].Component);

(0, _defineProperty2["default"])(Pagination, "defaultProps", {
  showSkipArrows: false,
  label: "Pagination navigation",
  locale: "en-US",
  pageLabel: function pageLabel(pageNumber) {
    return "Go to page ".concat(pageNumber);
  },
  currentPageLabel: function currentPageLabel(nextPageNumber) {
    return "Current page, page ".concat(nextPageNumber);
  },
  previousPageLabel: function previousPageLabel(prevPageNumber) {
    return "Go to previous page, page ".concat(prevPageNumber);
  },
  nextPageLabel: function nextPageLabel(nextPageNumber) {
    return "Go to next page, page ".concat(nextPageNumber);
  },
  firstPageLabel: function firstPageLabel(firstPageNumber) {
    return "Go to first page, page ".concat(firstPageNumber);
  },
  lastPageLabel: function lastPageLabel(lastPageNumber) {
    return "Go to last page, page ".concat(lastPageNumber);
  }
});
Pagination.propTypes =  false ? {
  /**
   * The number of the currently selected page, where `1` is the first page
   * (*not* 0-indexed).
   */
  currentPage: _propTypes["default"].number.isRequired,

  /**
   * The total number of pages in the list being paginated.
   */
  numberOfPages: _propTypes["default"].number.isRequired,

  /**
   * A function that will be called when the user attempts to change the current
   * page (e.g. by clicking on the "Next page" button). The new page number
   * will be passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `currentPage` prop in order to make this
   * component interactive.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Icon component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-label
   *
   * If you are looking to set an accessible `aria-label` for the screen reader, please see the `label` prop details.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * A function that generates an accessible label for the current page.
   *
   * This receives the current page's number as its only argument, and should return a string.
   */
  currentPageLabel: _propTypes["default"].func,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * A function that generates an accessible label for the skip-to-first-page button.
   *
   * This receives the first page's number as its only argument, and should return a string.
   */
  firstPageLabel: _propTypes["default"].func,

  /**
   * An accessible label for the component. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   */
  label: _propTypes["default"].string,

  /**
   * A function that generates an accessible label for the skip-to-last-page button.
   *
   * This receives the last page's number as its only argument, and should return a string.
   */
  lastPageLabel: _propTypes["default"].func,

  /**
   * The locale used to display the numbers in the page buttons. Any local supported by
   * the [Number.toLocaleString API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString)
   * will work.
   */
  locale: _propTypes["default"].string,

  /**
   * A function that generates an accessible label for the go-to-next-page button.
   *
   * This receives the next page's number as its only argument, and should return a string.
   */
  nextPageLabel: _propTypes["default"].func,

  /**
   * A function that generates an accessible label for any page.
   *
   * This receives a page number as its only argument, and should return a string.
   */
  pageLabel: _propTypes["default"].func,

  /**
   * A function that generates an accessible label for the go-to-previous-page button.
   *
   * This receives the previous page's number as its only argument, and should return a string.
   */
  previousPageLabel: _propTypes["default"].func,

  /**
   * Use this to shop skip-to-first-page and skip-to-last-page buttons.
   */
  showSkipArrows: _propTypes["default"].bool
} : {};
var _default = Pagination;
exports["default"] = _default;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(768),
    baseFlatten = __webpack_require__(304),
    baseRest = __webpack_require__(305),
    isArrayLikeObject = __webpack_require__(306);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(144),
    arrayIncludes = __webpack_require__(283),
    arrayIncludesWith = __webpack_require__(284),
    arrayMap = __webpack_require__(149),
    baseUnary = __webpack_require__(230),
    cacheHas = __webpack_require__(145);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(84),
    isArguments = __webpack_require__(147),
    isArray = __webpack_require__(42);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(771);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 771 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(773),
    shortOut = __webpack_require__(776);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(774),
    defineProperty = __webpack_require__(775),
    identity = __webpack_require__(150);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 774 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 776 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(304),
    baseRest = __webpack_require__(305),
    baseUniq = __webpack_require__(282),
    isArrayLikeObject = __webpack_require__(306);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 778 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    paginationNumberWidth: 24,
    paginationNumberHeight: 24,
    paginationNumberColorDefault: tokens.themeForegroundAccentDefault,
    paginationNumberColorSelected: tokens.themeForegroundPrimaryDefault,
    paginationNumberColorDisabled: tokens.themeForegroundPrimaryDisabled,
    paginationNumberSpacingInsetVertical: 2,
    paginationNumberSpacingInsetHorizontal: 8,
    paginationIndicatorBorderWidth: 2,
    paginationIndicatorBorderRadius: 999,
    paginationIndicatorHeight: 4,
    paginationIndicatorColorDefault: tokens.themeForegroundAccentDefault,
    paginationIndicatorColorHover: tokens.themeBorderAccentHover,
    paginationIndicatorColorPressed: tokens.themeBorderAccentPressed,
    paginationArrowColor: tokens.themeForegroundAccentDefault,
    paginationEllipseWidth: 24,
    paginationEllipseHeight: 14,
    paginationEllipseColorDefault: tokens.themeForegroundAccentDefault,
    paginationEllipseColorDisabled: tokens.themeForegroundPrimaryDisabled,
    paginationMotionDuration: "100ms",
    paginationMotionFunction: "ease"
  }
};

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _chevronRightSmall = _interopRequireDefault(__webpack_require__(137));

var _chevronLeftSmall = _interopRequireDefault(__webpack_require__(780));

var _chevronDoubleRight = _interopRequireDefault(__webpack_require__(781));

var _chevronDoubleLeft = _interopRequireDefault(__webpack_require__(782));

var _theme = _interopRequireDefault(__webpack_require__(14));

var _row = _interopRequireDefault(__webpack_require__(44));

var _button = _interopRequireDefault(__webpack_require__(50));

var _icon = _interopRequireDefault(__webpack_require__(38));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/prop-types */
var ArrowControls = function ArrowControls(_ref) {
  var direction = _ref.direction,
      numberOfPages = _ref.numberOfPages,
      showSkipArrows = _ref.showSkipArrows,
      disabled = _ref.disabled,
      currentPage = _ref.currentPage,
      onChange = _ref.onChange,
      arrowColor = _ref.arrowColor,
      nextPageLabel = _ref.nextPageLabel,
      previousPageLabel = _ref.previousPageLabel,
      lastPageLabel = _ref.lastPageLabel,
      firstPageLabel = _ref.firstPageLabel;
  var overrideTokens = (0, _react.useMemo)(function () {
    return {
      buttonForegroundColorIconLightBackdropDefault: arrowColor,
      buttonForegroundColorIconDarkBackdropDefault: arrowColor
    };
  }, [arrowColor]);
  return direction === "right" ? /*#__PURE__*/_react["default"].createElement(_theme["default"], {
    tokens: overrideTokens
  }, /*#__PURE__*/_react["default"].createElement(_row["default"], {
    spacing: "none"
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: function onClick() {
      return onChange(currentPage + 1);
    },
    disabled: disabled || currentPage === numberOfPages
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronRightSmall["default"]
  }, nextPageLabel(currentPage + 1))), showSkipArrows && /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: function onClick() {
      return onChange(numberOfPages);
    },
    disabled: disabled || currentPage >= numberOfPages - 1
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronDoubleRight["default"]
  }, lastPageLabel(numberOfPages))))) : /*#__PURE__*/_react["default"].createElement(_theme["default"], {
    tokens: overrideTokens
  }, /*#__PURE__*/_react["default"].createElement(_row["default"], {
    spacing: "none"
  }, showSkipArrows && /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: function onClick() {
      return onChange(1);
    },
    disabled: disabled || currentPage <= 2
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronDoubleLeft["default"]
  }, firstPageLabel(1))), /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: function onClick() {
      return onChange(currentPage - 1);
    },
    disabled: disabled || currentPage === 1
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronLeftSmall["default"]
  }, previousPageLabel(currentPage - 1)))));
};

var _default = ArrowControls;
exports["default"] = _default;

/***/ }),
/* 780 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronLeftSmallData: "data:image/svg+xml,%3csvg width='6' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5 1L1 5l4 4' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconChevronLeftSmallRtlSvg: "data:image/svg+xml,%3csvg width='6' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 9l4-4-4-4' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconChevronLeftSmallWidth: 6,
  iconChevronLeftSmallHeight: 10
};

/***/ }),
/* 781 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronDoubleRightData: "data:image/svg+xml,%3csvg width='13' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1 9l4-4-4-4M8 9l4-4-4-4'/%3e%3c/g%3e%3c/svg%3e",
  iconChevronDoubleRightRtlSvg: "data:image/svg+xml,%3csvg width='13' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M5 1L1 5l4 4M12 1L8 5l4 4'/%3e%3c/g%3e%3c/svg%3e",
  iconChevronDoubleRightWidth: 13,
  iconChevronDoubleRightHeight: 10
};

/***/ }),
/* 782 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronDoubleLeftData: "data:image/svg+xml,%3csvg width='13' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M5 1L1 5l4 4M12 1L8 5l4 4'/%3e%3c/g%3e%3c/svg%3e",
  iconChevronDoubleLeftRtlSvg: "data:image/svg+xml,%3csvg width='13' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1 9l4-4-4-4M8 9l4-4-4-4'/%3e%3c/g%3e%3c/svg%3e",
  iconChevronDoubleLeftWidth: 13,
  iconChevronDoubleLeftHeight: 10
};

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(4);

var _clickable = _interopRequireDefault(__webpack_require__(64));

var _focus = _interopRequireDefault(__webpack_require__(135));

var _text = _interopRequireDefault(__webpack_require__(27));

var _focusRing = _interopRequireDefault(__webpack_require__(43));

var indicatorStyle = function indicatorStyle(t, _ref) {
  var selected = _ref.selected,
      disabled = _ref.disabled;
  return (0, _emotion.css)({
    position: "absolute !important",
    display: "inline-block",
    height: t("indicatorHeight"),
    left: t("numberSpacingInsetHorizontal"),
    right: t("numberSpacingInsetHorizontal"),
    borderRadius: t("indicatorBorderRadius"),
    backgroundColor: selected ? t("indicatorColor", "default") : "transparent",
    "button:hover &": !disabled && {
      backgroundColor: t("indicatorColorHover")
    },
    "button:active &": !disabled && {
      backgroundColor: t("indicatorColorPressed")
    },
    transition: t.transitionCss("motion", "background-color")
  });
};

var pageButtonStyle = function pageButtonStyle(t) {
  return (0, _emotion.css)({
    position: "relative",
    // HACK: This is necessary for the absolutely positioned indicator to show
    // up in IE11. See https://stackoverflow.com/questions/38235418/div-inside-button-not-working-as-expected-in-ie
    overflow: "visible",
    padding: "0 ".concat(t("numberSpacingInsetHorizontal"), "px"),
    textAlign: "center",
    "& > span": {
      display: "block"
    }
  });
};

var textStyle = function textStyle(t, _ref2) {
  var focus = _ref2.focus,
      selected = _ref2.selected,
      disabled = _ref2.disabled;
  return (0, _emotion.css)((0, _text["default"])(t), {
    // We check for selected first because selected numbers still appear
    // enabled even if the button itself is disabled
    color: t("numberColor", selected ? "selected" : disabled ? "disabled" : "default"),
    transition: t.transitionCss("motion", "color"),
    margin: "".concat(t("numberSpacingInsetVertical"), "px 0"),
    minWidth: t("numberWidth"),
    outline: "none",
    width: "100%"
  }, (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: 1
  }));
};
/* eslint-disable react/prop-types */


var PageButton = function PageButton(_ref3) {
  var value = _ref3.children,
      onChange = _ref3.onChange,
      selected = _ref3.selected,
      disabled = _ref3.disabled,
      pageLabel = _ref3.pageLabel,
      currentPageLabel = _ref3.currentPageLabel,
      locale = _ref3.locale,
      t = _ref3.t;
  return /*#__PURE__*/_react["default"].createElement(_focus["default"], null, function (_ref4) {
    var focus = _ref4.focus,
        focusTrigger = _ref4.focusTrigger,
        focusProps = _ref4.focusProps;
    return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, focusProps, {
      onClick: function onClick() {
        return !disabled && onChange(value);
      },
      className: pageButtonStyle(t),
      disabled: selected ? false : disabled,
      "aria-current": selected ? "page" : undefined,
      "aria-label": selected ? currentPageLabel(value) : pageLabel(value)
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: textStyle(t, {
        selected: selected,
        disabled: disabled,
        focus: focus && focusTrigger === "keyboard"
      })
    }, value.toLocaleString(locale)), /*#__PURE__*/_react["default"].createElement("div", {
      className: indicatorStyle(t, {
        selected: selected,
        disabled: disabled
      })
    }));
  });
};
/* eslint-enable react/prop-types */


var _default = PageButton;
exports["default"] = _default;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(4);

var _menuMeatball = _interopRequireDefault(__webpack_require__(785));

var _token = __webpack_require__(12);

var _getIconCss = _interopRequireDefault(__webpack_require__(83));

var menuMeatball = (0, _token.getIconFromTokens)(_menuMeatball["default"]);

var ellipseStyle = function ellipseStyle(t, _ref) {
  var disabled = _ref.disabled;
  var state = disabled ? "disabled" : "default";
  return (0, _emotion.css)({
    backgroundImage: (0, _getIconCss["default"])(menuMeatball.data, t("ellipseColor", state)),
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: t("ellipseWidth"),
    height: t("ellipseHeight")
  });
};
/* eslint-disable react/prop-types */


var Ellipse = function Ellipse(_ref2) {
  var t = _ref2.t,
      disabled = _ref2.disabled;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: ellipseStyle(t, {
      disabled: disabled
    })
  });
};
/* eslint-enable react/prop-types */


var _default = Ellipse;
exports["default"] = _default;

/***/ }),
/* 785 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconMenuMeatballData: "data:image/svg+xml,%3csvg width='20' height='4' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='currentColor' fill-rule='nonzero'%3e%3ccircle transform='rotate(90 18 2)' cx='18' cy='2' r='2'/%3e%3ccircle transform='rotate(90 10 2)' cx='10' cy='2' r='2'/%3e%3ccircle transform='rotate(90 2 2)' cx='2' cy='2' r='2'/%3e%3c/g%3e%3c/svg%3e",
  iconMenuMeatballWidth: 20,
  iconMenuMeatballHeight: 4
};

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Options__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__options_CycleOptions__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_PageHeader__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StowBufferTable__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__options_MachineStatusOptions__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_context_DeviceLayoutContext__ = __webpack_require__(41);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StowBuffer=function(_Component){_inherits(StowBuffer,_Component);function StowBuffer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StowBuffer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StowBuffer.__proto__||Object.getPrototypeOf(StowBuffer)).call.apply(_ref,[this].concat(args))),_this),_this.getApplicableOptions=function(){return[{component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__options_CycleOptions__["a" /* default */],null),name:"CycleOptions"},{component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__options_MachineStatusOptions__["a" /* default */],null),name:"MachineStatusOptions"}];},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StowBuffer,[{key:"componentDidMount",value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_OptionsActions__["o" /* fetchCycles */])());}},{key:"render",value:function render(){var spacingInset_shorthand6=this.props.spacingInset_shorthand6;var options=this.getApplicableOptions();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,{spacingInset:spacingInset_shorthand6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__utils_PageHeader__["a" /* PageHeader */],__WEBPACK_IMPORTED_MODULE_8__constants__["n" /* HEADERS */].STOW_BUFFER),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Options__["a" /* default */],{options:options,optionsTagsRequired:__WEBPACK_IMPORTED_MODULE_8__constants__["s" /* OPTIONS_TAG_REQUIRED_STOW_BUFFER */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__StowBufferTable__["a" /* default */],null));}}]);return StowBuffer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// Adapter to convert class component to functional component.
function classToFunctionAdapter(CustomComponent){return function WrappedComponent(props){var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_11__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),spacingInset_shorthand6=_useDeviceLayout.spacingInset_shorthand6;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomComponent,Object.assign({},props,{spacingInset_shorthand6:spacingInset_shorthand6}));};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null)(classToFunctionAdapter(StowBuffer))));

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__handler_LocaleHandler__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RefreshTimer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_StowBufferAction__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tooltip__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tooltip__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StowBufferTable=function(_Component){_inherits(StowBufferTable,_Component);function StowBufferTable(props){_classCallCheck(this,StowBufferTable);var _this=_possibleConstructorReturn(this,(StowBufferTable.__proto__||Object.getPrototypeOf(StowBufferTable)).call(this,props));_this.onMachineClick=function(machine){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_OptionsActions__["q" /* navigationAdded */])({value:machine}));_this.props.history.push("/bay/"+machine);};_this.onSort=function(sortDetails){_this.setState({sortColumn:sortDetails.sortColumn,sortDirection:sortDetails.sortDirection});};_this.state={sortColumn:"name",sortDirection:"ascending",baseURL:"",inductedCount:0};return _this;}_createClass(StowBufferTable,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_10__handler_ParentDataHandler__["d" /* getDocumentURL */])().then(function(value){_this2.setState({baseURL:value});});}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState,snapshot){if(this.props.selectedCycle!==""&&prevProps.selectedCycle!==this.props.selectedCycle){this.fetchDataForMachineTable(this.props.selectedCycle,Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["m" /* getNodeId */])());}}},{key:"fetchDataForMachineTable",value:function fetchDataForMachineTable(selectedCycle,nodeId){var _this3=this;clearInterval(this.timer);this.getDataForMachineTable(selectedCycle,nodeId);this.timer=setInterval(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!document.hidden){_this3.getDataForMachineTable(selectedCycle,nodeId);}case 1:case"end":return _context.stop();}}},_callee,_this3);})),__WEBPACK_IMPORTED_MODULE_16__constants__["z" /* refreshInterval */]);}},{key:"getDataForMachineTable",value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(selectedCycle,nodeId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_StowBufferAction__["s" /* getInductCount */])(selectedCycle,nodeId));_context2.next=3;return this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_StowBufferAction__["u" /* getMachineTableData */])(nodeId,selectedCycle,'ASSOCIATE'));case 3:this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_StowBufferAction__["t" /* getMachineStatus */])(nodeId,this.props.machineList));case 4:case"end":return _context2.stop();}}},_callee2,this);}));function getDataForMachineTable(_x,_x2){return _ref2.apply(this,arguments);}return getDataForMachineTable;}()},{key:"getPercentageOfStationVolume",value:function getPercentageOfStationVolume(machine){if(parseInt(this.props.inductCount,10)!==0){return(parseInt(machine.stowedBufferedPackages,10)*100/parseInt(this.props.inductCount,10)).toFixed(2).toString()+"%";}else{return"-";}}},{key:"getFlyByRate",value:function getFlyByRate(machine){if(parseInt(machine.stowedBufferedPackages,10)!==0){return(parseInt(machine.flyByRate,10)*100/parseInt(machine.stowedBufferedPackages,10)).toFixed(2).toString()+"%";}else{return"-";}}},{key:"getNoReadRate",value:function getNoReadRate(machine){if(parseInt(machine.noReadRate,10)+parseInt(machine.stowedBufferedPackages,10)!==0){return(parseInt(machine.noReadRate,10)*100/(parseInt(machine.noReadRate,10)+parseInt(machine.stowedBufferedPackages,10))).toFixed(2).toString()+"%";}else{return"-";}}},{key:"render",value:function render(){var _this4=this;var _props=this.props,selectedStatuses=_props.selectedStatuses,machineList=_props.machineList;var filteredMachineList=machineList?machineList.filter(function(machine){return!selectedStatuses.length||selectedStatuses.includes(machine.status);}):[];filteredMachineList&&filteredMachineList.sort(function(a,b){var fieldA=a[_this4.state.sortColumn];var fieldB=b[_this4.state.sortColumn];if(_this4.state.sortDirection==="ascending"){return Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["b" /* convertToString */])(fieldA).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["b" /* convertToString */])(fieldB),Object(__WEBPACK_IMPORTED_MODULE_11__handler_LocaleHandler__["b" /* getLocale */])(),{numeric:true});}else{return Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["b" /* convertToString */])(fieldB).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_8__Utility__["b" /* convertToString */])(fieldA),Object(__WEBPACK_IMPORTED_MODULE_11__handler_LocaleHandler__["b" /* getLocale */])(),{numeric:true});}});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__RefreshTimer__["a" /* default */],{deps:[machineList]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{overflowX:"auto",width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default.a,{headerRows:1,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true,headerColumns:1,stickyHeaderColumn:true,sortColumn:this.state.sortColumn,sortDirection:this.state.sortDirection,onSort:this.onSort,"data-cy":"machineList"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{sortColumn:"name"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tooltip___default.a,{position:"top",title:"Name of the ADTA machine",id:"tooltip.machine"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{tabIndex:"0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"stowBuffer.machine",defaultMessage:"Machine"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{sortColumn:"machineStatus"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tooltip___default.a,{position:"top",title:"PLC Machine is Active or Inactive",id:"tooltip.machineStatus"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{tabIndex:"0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"stowBuffer.machineStatus",defaultMessage:"Machine Status"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{sortColumn:"fullBay",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tooltip___default.a,{position:"top",title:"Opens the bay level drilldown",id:"tooltip.fullBay"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{tabIndex:"0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"stowBuffer.fullBay",defaultMessage:"Full Bay"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{sortColumn:"flyByRate",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tooltip___default.a,{position:"top",title:"Rate of packages going to the jackpot Bay wrt total packages processed by the finger in the cycle",id:"tooltip.flyByRate"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{tabIndex:"0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"stowBuffer.flyByRate",defaultMessage:"Jackpot rate"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{sortColumn:"noReadRate",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tooltip___default.a,{position:"top",title:"Rate of NOREADS by the machine wrt total packages processed by the finger in the cycle",id:"tooltip.noReadRate"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{tabIndex:"0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"stowBuffer.noReadRate",defaultMessage:"No read rate"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowedBufferedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tooltip___default.a,{position:"top",title:"Volume processed by ADTA finger in current shift cycle",id:"tooltip.machineCurrentVolume"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{tabIndex:"0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"stowBuffer.currentVolume",defaultMessage:"Current Volume"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowedBufferedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tooltip___default.a,{position:"top",title:"Percentage of total packages processed by a finger wrt total packages diverted in a station in the cycle",id:"tooltip.percentOfStationVolume"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{tabIndex:"0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"stowBuffer.percentOfStationVolume",defaultMessage:"% of Station Volume"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{sortColumn:"pph",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tooltip___default.a,{position:"top",title:"Total volume processed by a finger averaged over the number of hours passed in the shift",id:"tooltip.avgPPH"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{tabIndex:"0"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"stowBuffer.avgPPH",defaultMessage:"Avg PPH"}))))),filteredMachineList&&filteredMachineList.map(function(machine){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default.a,{key:machine.alias,"data-cy":"associateDataRow"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,machine.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:machine.status==="Inactive"?{color:'#CC0C39'}:{color:"#ADE422"}},machine.status)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link___default.a,{onClick:function onClick(){return _this4.onMachineClick(machine.alias);}},"Bay_Details")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this4.getFlyByRate(machine)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this4.getNoReadRate(machine)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},machine.stowedBufferedPackages),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this4.getPercentageOfStationVolume(machine)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},machine.pph));}))));}}]);return StowBufferTable;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{selectedStatuses:state.optionsReducer.options.machineStatuses,selectedCycle:state.optionsReducer.options.cycle,inductCount:state.stowBufferReducer.inductCount,machineList:state.stowBufferReducer.machineList};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps)(StowBufferTable)));

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAPIGatewayPostRequest;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStowBufferTableData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MetricUtility__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(5);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="SCC_STOW_BUFFER";function getAPIGatewayPostRequest(request,resourcePath){var processName=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"stow";return{resourcePath:resourcePath,httpMethod:"post",processName:processName,requestBody:request};}var getStowBufferTableData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(request){var metricName,args,startTime,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:metricName="getStowAssociates";args=getAPIGatewayPostRequest(request,"svs/associates/data");startTime=Date.now();_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context.sent;if(!(response.status===200)){_context.next=9;break;}Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["b" /* publishTime */])(metricProcessName,metricName,startTime);return _context.abrupt("return",transformMachineList(response.data.associates));case 9:Object(__WEBPACK_IMPORTED_MODULE_2__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName+__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* ERROR_METRIC_SUFFFIX */]);case 10:case"end":return _context.stop();}}},_callee,this);}));return function getStowBufferTableData(_x2){return _ref.apply(this,arguments);};}();function transformMachineList(machine){return machine.map(function(machine){return{alias:machine.alias,name:machine.name,macAddress:machine.macAddress,location:machine.location,pph:machine.performance.pph===-1?'-':machine.performance.pph,stowedBufferedPackages:machine.performance.stowBufferedCount,flyByRate:machine.performance.flyByRate,noReadRate:machine.performance.noReadCount,maxPph:machine.performance.maxPph,localMaxScanTime:machine.performance.localMaxScanTime};});}

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_control_group__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_control_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_control_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MachineStatusOptions=function(_Component){_inherits(MachineStatusOptions,_Component);function MachineStatusOptions(){_classCallCheck(this,MachineStatusOptions);return _possibleConstructorReturn(this,(MachineStatusOptions.__proto__||Object.getPrototypeOf(MachineStatusOptions)).apply(this,arguments));}_createClass(MachineStatusOptions,[{key:"render",value:function render(){var _this2=this;var selectedStatuses=this.props.selectedStatuses;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_control_group___default.a,{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"machineStatusOption.active",defaultMessage:"Active"}),onChange:function onChange(updatedStatuses){return _this2.handleStatusesChange(updatedStatuses);},value:selectedStatuses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox___default.a,{"data-cy":"machineStatusFieldsetOption",key:"Active",value:"Active"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"machineStatusOptions.yes",defaultMessage:"Yes"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox___default.a,{"data-cy":"machineStatusFieldsetOption",key:"Inactive",value:"Inactive"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"machineStatusOption.no",defaultMessage:"No"})));}},{key:"handleStatusesChange",value:function handleStatusesChange(updatedStatuses){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_OptionsActions__["u" /* optionsAddedOrChanged */])({'machineStatuses':updatedStatuses}));}}]);return MachineStatusOptions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{selectedStatuses:state.optionsReducer.options.machineStatuses};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(MachineStatusOptions)));

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_breadcrumb__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BayTable__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_heading__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_text__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_box__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_box__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Bay=function(_Component){_inherits(Bay,_Component);function Bay(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Bay);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Bay.__proto__||Object.getPrototypeOf(Bay)).call.apply(_ref,[this].concat(args))),_this),_this.navigationChanged=function(navigationIndex){_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_OptionsActions__["r" /* navigationRemoved */])(navigationIndex));_this.props.history.push("/stowBuffer");},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Bay,[{key:"componentDidMount",value:function componentDidMount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_OptionsActions__["o" /* fetchCycles */])());if(!this.props.machineList.length){this.props.history.push("/stowBuffer");}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_OptionsActions__["r" /* navigationRemoved */])(0));}},{key:"renderBreadCrumb",value:function renderBreadCrumb(navigationOptions){var _this2=this;if(navigationOptions.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_box___default.a,{spacingInset:"small none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_breadcrumb__["BreadcrumbGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_breadcrumb___default.a,{onClick:function onClick(){return _this2.navigationChanged(0);}},"Machine Table"),navigationOptions.map(function(navigationOption,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_breadcrumb___default.a,{onClick:function onClick(){return _this2.navigationChanged(index+1);},key:navigationOption.value},navigationOption.value);})));}}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,{spacingInset:"none medium none large"},this.renderBreadCrumb(this.props.navigationOptions),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_box___default.a,{spacingInset:"medium none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_heading___default.a,{level:2,type:"h400",alignment:"left",spacingInset:"large large large"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"bayTable.heading",defaultMessage:"Bay Table for "+this.props.match.params.machine})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_text___default.a,{color:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"bayTable.description",defaultMessage:"This table shows the bay level drill down"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BayTable__["a" /* default */],null));}}]);return Bay;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{navigationOptions:state.optionsReducer.navigationOptions,machineList:state.stowBufferReducer.machineList};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Bay)));

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__handler_LocaleHandler__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_column__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RefreshTimer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_StowBufferAction__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BayTable=function(_Component){_inherits(BayTable,_Component);function BayTable(props){_classCallCheck(this,BayTable);var _this=_possibleConstructorReturn(this,(BayTable.__proto__||Object.getPrototypeOf(BayTable)).call(this,props));_this.nodeId=Object(__WEBPACK_IMPORTED_MODULE_7__Utility__["m" /* getNodeId */])();_this.onSort=function(sortDetails){_this.setState({sortColumn:sortDetails.sortColumn,sortDirection:sortDetails.sortDirection});};_this.state={sortColumn:"machine",sortDirection:"ascending",baseURL:"",machineDetails:[]};return _this;}_createClass(BayTable,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_9__handler_ParentDataHandler__["d" /* getDocumentURL */])().then(function(value){_this2.setState({baseURL:value});});this.fetchBayTableData(this.props.selectedCycle,this.nodeId);}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.timer);this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_StowBufferAction__["q" /* bayTableDataClear */])());}},{key:"fetchBayTableData",value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(selectedCycle,nodeId){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:this.getDataForBayTable(selectedCycle,nodeId);this.timer=setInterval(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!document.hidden){_this3.getDataForBayTable(selectedCycle,nodeId);}case 1:case"end":return _context.stop();}}},_callee,_this3);})),__WEBPACK_IMPORTED_MODULE_14__constants__["z" /* refreshInterval */]);case 2:case"end":return _context2.stop();}}},_callee2,this);}));function fetchBayTableData(_x,_x2){return _ref.apply(this,arguments);}return fetchBayTableData;}()},{key:"getDataForBayTable",value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(selectedCycle,nodeId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_StowBufferAction__["v" /* getPlannedCount */])(nodeId,selectedCycle,this.props.selectedCycleId));case 2:this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_StowBufferAction__["r" /* getBayTableData */])(nodeId,selectedCycle,'BAY',this.props.match.params.machine,this.props.stowPackageMetrics));case 3:case"end":return _context3.stop();}}},_callee3,this);}));function getDataForBayTable(_x3,_x4){return _ref3.apply(this,arguments);}return getDataForBayTable;}()},{key:"getBayName",value:function getBayName(bayNames){if(bayNames&&bayNames.startsWith(__WEBPACK_IMPORTED_MODULE_14__constants__["f" /* DEFAULT_JACKPOT_BAY_NAME */])){return bayNames;}else if(bayNames!==""){var transformedBayNames=bayNames.split(" ").map(function(bay){return bay[0]+bay.slice(2);}).join("-");return"Bay "+transformedBayNames;}else{return __WEBPACK_IMPORTED_MODULE_14__constants__["f" /* DEFAULT_JACKPOT_BAY_NAME */];}}},{key:"getLastBagScanTime",value:function getLastBagScanTime(localMaxScanTime){if(localMaxScanTime)return Object(__WEBPACK_IMPORTED_MODULE_7__Utility__["p" /* getRelativeTimeFromEpoch */])(localMaxScanTime);else{return"-";}}},{key:"render",value:function render(){var _this4=this;var filteredBayList=this.props.bayList?this.props.bayList.slice():[];filteredBayList&&filteredBayList.sort(function(a,b){var fieldA=a[_this4.state.sortColumn];var fieldB=b[_this4.state.sortColumn];if(_this4.state.sortDirection==="ascending"){return Object(__WEBPACK_IMPORTED_MODULE_7__Utility__["b" /* convertToString */])(fieldA).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_7__Utility__["b" /* convertToString */])(fieldB),Object(__WEBPACK_IMPORTED_MODULE_10__handler_LocaleHandler__["b" /* getLocale */])(),{numeric:true});}else{return Object(__WEBPACK_IMPORTED_MODULE_7__Utility__["b" /* convertToString */])(fieldB).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_7__Utility__["b" /* convertToString */])(fieldA),Object(__WEBPACK_IMPORTED_MODULE_10__handler_LocaleHandler__["b" /* getLocale */])(),{numeric:true});}});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RefreshTimer__["a" /* default */],{deps:[this.props.bayList]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default.a,{headerRows:1,showDividers:false,showStripes:false,spacing:"small",fixHeaderRows:true,fixHeaderRowsFullWidth:true,sortColumn:this.state.sortColumn,sortDirection:this.state.sortDirection,onSort:this.onSort,"data-cy":"bayList"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{sortColumn:"name"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default.a,{position:"top",title:"Bays in the Finger",id:"tooltip.bayName"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"bay.bayName",defaultMessage:"Bay"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{sortColumn:"plannedVolumeSum",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default.a,{position:"top",title:"Volume planned for the chute in the Cycle",id:"tooltip.plannedVolume"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"bay.plannedVolume",defaultMessage:"Planned Volume"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{sortColumn:"stowedBufferedPackages",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default.a,{position:"top",title:"Volume actually passed to the chute",id:"tooltip.processedVolume"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"bay.processedVolume",defaultMessage:"Processed Volume"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{sortColumn:"localMaxScanTime",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default.a,{position:"top",title:"Time when last scan happened in the aisles for which chutes are collecting packages",id:"tooltip.lastBagScan"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"bay.lastBagScan",defaultMessage:"Last Bag Scan"})))),filteredBayList?filteredBayList.map(function(bay){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table_table_row___default.a,{key:bay.alias,"data-cy":"associateDataRow"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,null,_this4.getBayName(bay.name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},bay.plannedVolumeSum),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},bay.stowedBufferedPackages),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_table_table_cell___default.a,{alignmentHorizontal:"right"},_this4.getLastBagScanTime(bay.localMaxScanTime)));}):""));}}]);return BayTable;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{stowPackageMetrics:state.stowBufferReducer.stowPackageMetrics,selectedCycle:state.optionsReducer.options.cycle,selectedCycleId:state.optionsReducer.options.cycleId,bayList:state.stowBufferReducer.bayList};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps)(BayTable)));

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ButtonOption", {
  enumerable: true,
  get: function get() {
    return _buttonOption["default"];
  }
});
exports["default"] = void 0;

var _buttonGroup = _interopRequireDefault(__webpack_require__(793));

var _buttonOption = _interopRequireDefault(__webpack_require__(794));

var _default = _buttonGroup["default"];
exports["default"] = _default;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(48));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(63));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _noop = _interopRequireDefault(__webpack_require__(37));

var _button2 = _interopRequireDefault(__webpack_require__(155));

var _elevation = __webpack_require__(59);

var _buttonGroupContext = _interopRequireDefault(__webpack_require__(308));

var _theme = _interopRequireWildcard(__webpack_require__(14));

var _parsers = __webpack_require__(66);

var _fieldsetReset = _interopRequireDefault(__webpack_require__(285));

var _visuallyHidden = _interopRequireDefault(__webpack_require__(58));

var _functional = __webpack_require__(26);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var legendStyles = (0, _emotion.css)(_visuallyHidden["default"]);
var rowStyles = (0, _functional.memoizeByKeys)(function (_ref) {
  var _button;

  var horizontalSpacing = _ref.horizontalSpacing,
      minWidth = _ref.minWidth,
      buttonBorderRadius = _ref.buttonBorderRadius,
      singleButton = _ref.singleButton;
  var buttonBorderRadiusLeftSide = "".concat(buttonBorderRadius, "px 0 0 ").concat(buttonBorderRadius, "px");
  var buttonBorderRadiusRightSide = "0 ".concat(buttonBorderRadius, "px ").concat(buttonBorderRadius, "px 0");
  return (0, _emotion.css)(_fieldsetReset["default"], {
    display: "flex",
    zIndex: _elevation.elevationBackground,
    position: "relative",
    label: _visuallyHidden["default"],
    "& > *:not([mdn-button-group-label])": {
      display: "inline-block"
    },
    "& button": (_button = {
      zIndex: _elevation.elevationMidground,
      boxSizing: "border-box",
      margin: "0 ".concat(horizontalSpacing, "px 0 0")
    }, (0, _defineProperty2["default"])(_button, "[dir=\"rtl\"] &", {
      margin: "0 0 0 ".concat(horizontalSpacing, "px")
    }), (0, _defineProperty2["default"])(_button, "borderRadius", singleButton ? buttonBorderRadius : "0"), _button),
    "& div:first-of-type > button": (0, _defineProperty2["default"])({
      borderRadius: singleButton ? undefined : buttonBorderRadiusLeftSide
    }, "[dir=\"rtl\"] &", {
      borderRadius: singleButton ? undefined : buttonBorderRadiusRightSide
    }),
    "& div:last-of-type > button": (0, _defineProperty2["default"])({
      borderRadius: singleButton ? undefined : buttonBorderRadiusRightSide,
      marginRight: 0
    }, "[dir=\"rtl\"] &", {
      borderRadius: singleButton ? undefined : buttonBorderRadiusLeftSide,
      marginLeft: 0
    }),
    "& button:focus, & button:hover, & input:focus + button": {
      // HACK: When we hover or focus on a button, bring it to the front z-index wise
      // so that the focus ring / fill doesn't get clipped by neighboring buttons
      zIndex: _elevation.elevationForeground
    },
    "& button:disabled": {
      // HACK: When the button is disabled, drop its z-index to 0 so the other
      // buttons can appear in front
      zIndex: "".concat(_elevation.elevationBackground, " !important")
    }
  }, minWidth ? {
    display: "flex",
    minWidth: minWidth,
    flexDirection: "row",
    "& > *:not([mdn-button-group-label])": {
      flex: "auto",
      display: "flex",
      "& > button": {
        flex: 1
      }
    }
  } : undefined);
}, ["horizontalSpacing", "minWidth", "buttonBorderRadius", "singleButton"]);

var getButtonTokens = function getButtonTokens(_ref2) {
  var type = _ref2.type;
  return {
    // Apply a transparent border to primary and secondary buttons so that they
    // size exactly the same as tertiary buttons (which have a border). This
    // allows us to mix and match tertiary and non-tertiary buttons without any
    // change in the way the buttons size.
    buttonBorderColorPrimaryDefault: type === "outline" ? "transparent" : null,
    buttonBorderColorSecondaryDefault: type === "outline" ? "transparent" : null
  };
};
/**
 * Render two or more buttons joined together into a unified form element that
 * can allow the selection of one or more options.
 */


var ButtonGroup = function ButtonGroup(props) {
  var value = props.value,
      onChange = props.onChange,
      size = props.size,
      name = props.name,
      type = props.type,
      children = props.children,
      minWidth = props.minWidth,
      label = props.label;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  var t = (0, _theme.useTheme)(_button2["default"], "button");
  var buttonBorderRadius = t("borderRadius");
  var inputType = (0, _react.useMemo)(function () {
    return Array.isArray(value) ? "checkbox" : "radio";
  }, [value]);
  var handleChange = (0, _react.useCallback)(function (optionValue) {
    var nextValue;

    if (inputType === "checkbox") {
      nextValue = value.indexOf(optionValue) === -1 ? [].concat((0, _toConsumableArray2["default"])(value), [optionValue]) : value.filter(function (v) {
        return v !== optionValue;
      });
    } else {
      nextValue = optionValue;
    }

    onChange(nextValue);
  }, [inputType, value, onChange]);
  var context = (0, _react.useMemo)(function () {
    return {
      onChange: handleChange,
      value: value,
      size: size,
      name: name,
      groupType: type,
      inputType: inputType
    };
  }, [handleChange, inputType, value, name, size, type]);
  var overrideButtonTokens = (0, _react.useMemo)(function () {
    return getButtonTokens({
      type: type
    });
  }, [type]);

  var _useMemo = (0, _react.useMemo)(function () {
    return type === "outline" ? [-2] : (0, _parsers.parseSpacing)("xxsmall");
  }, [type]),
      _useMemo2 = (0, _slicedToArray2["default"])(_useMemo, 1),
      horizontalSpacing = _useMemo2[0];

  return /*#__PURE__*/_react["default"].createElement(_buttonGroupContext["default"].Provider, {
    value: context
  }, /*#__PURE__*/_react["default"].createElement(_theme["default"], {
    tokens: overrideButtonTokens
  }, /*#__PURE__*/_react["default"].createElement("fieldset", (0, _extends2["default"])({}, passThroughProps, {
    className: rowStyles({
      horizontalSpacing: horizontalSpacing,
      minWidth: minWidth,
      buttonBorderRadius: buttonBorderRadius,
      singleButton: children.length === 1
    })
  }), /*#__PURE__*/_react["default"].createElement("legend", {
    className: legendStyles
  }, label), children)));
};

ButtonGroup.propTypes =  false ? {
  /**
   * A list of ButtonOption components.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * An accessible label for the component. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   */
  label: _propTypes["default"].string,

  /**
   * Sets the minimum width of the group. The group may be wider if the button
   * options that it contains have labels that cannot fit within the minimum
   * width.
   */
  minWidth: _propTypes["default"].string,

  /**
   * The name of the form control for each button option contained in the group.
   * If the group is placed in a form, this will be the name associated with
   * the group's controls when the form is submitted.
   *
   * Any names set explicitly on individual components in the group will
   * override this property.
   */
  name: _propTypes["default"].string,

  /**
   * Sets the size of the button options in the group using a preset.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * Sets the style of the group.
   */
  type: _propTypes["default"].oneOf(["fill", "outline"]),

  /**
   * The current value of the group.
   *
   * Match this with the value(s) of button options within the group to show
   * those options as checked.
   *
   * If this is an array then the group will allow multiple button options to be
   * checked (like a group of checkboxes). If this is a single value then the
   * group will only allow one button option to be checked (like a group of
   * radio buttons).
   */
  value: _propTypes["default"].any,

  /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by clicking on a button option). The new value will
   * be passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func
} : {};
ButtonGroup.defaultProps = {
  size: "medium",
  type: "fill",
  onChange: _noop["default"]
};
var _default = ButtonGroup;
exports["default"] = _default;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(17);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(48));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _uniqueId = _interopRequireDefault(__webpack_require__(51));

var _button = _interopRequireDefault(__webpack_require__(155));

var _noop = _interopRequireDefault(__webpack_require__(37));

var _buttonGroupContext = _interopRequireDefault(__webpack_require__(308));

var _button2 = _interopRequireDefault(__webpack_require__(50));

var _theme = __webpack_require__(14);

var _buttonStyles = __webpack_require__(237);

var _token = __webpack_require__(12);

var _visuallyHidden = _interopRequireDefault(__webpack_require__(58));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(13));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var type = _ref.type,
      disableHover = _ref.disableHover,
      disabled = _ref.disabled,
      backdropColor = _ref.backdropColor,
      minWidth = _ref.minWidth;
  var state = disabled ? "disabled" : "default";
  var borderColor = t("borderColor", [type, state]);
  var borderWidth = borderColor ? t("borderWidth") : 0;
  var borderRadius = t("borderRadius");
  return (0, _emotion.css)({
    // flex: "none !important" is used to allow for individual Buttons within
    // a ButtonGroupRow to override the minWidth set on the ButtonGroup
    flex: minWidth ? "none !important" : undefined,
    // Hide the input visual, but allow it to be still interacted with via
    // keyboard
    "& > input": _visuallyHidden["default"],
    // Artificially apply active/focused states to the button when the input
    // is active/focused.
    "& > input:active + button": (0, _buttonStyles.activeStyles)(t, {
      type: type
    }),
    "& > input:focus + button": (0, _buttonStyles.focusStyles)(t, {
      focus: true,
      borderWidth: borderWidth,
      borderRadius: borderRadius,
      backdropColor: backdropColor || t.tokens.themeBackgroundPrimaryDefault,
      linkOrIcon: type === "icon"
    }),
    // Disable the hover styles on the button (but ensure that we keep the
    // active/pressed styles) if `disableHover` is true (this is used when
    // unchecking a button because the hover styles look very similar to the
    // checked styles).
    "& > button:hover": disableHover ? (0, _buttonStyles.defaultStyles)(t, {
      type: type
    }) : undefined,
    "& > button:hover:active": disableHover ? (0, _buttonStyles.activeStyles)(t, {
      type: type
    }) : undefined
  });
}, ["type", "disableHover", "disabled", "backdropColor", "minWidth"]);
/**
 * Render a single option in a button group. This should only be used as the
 * child of a `ButtonGroup` component.
 */

var ButtonOption = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_button["default"], "button");

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      disableHover = _useState2[0],
      setDisableHover = _useState2[1];

  var context = (0, _react.useContext)(_buttonGroupContext["default"]);
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]);
  var onChange = context.onChange,
      inputType = context.inputType;
  var idProp = props.id,
      value = props.value,
      onClick = props.onClick;
  var id = (0, _react.useMemo)(function () {
    return idProp || (0, _uniqueId["default"])("checkable-button-");
  }, [idProp]);
  var checked = props.value !== undefined ? inputType === "checkbox" ? context.value.indexOf(props.value) !== -1 : context.value === props.value : false;
  var type = checked ? "primary" : context.groupType === "fill" ? "secondary" : "tertiary"; // When the input is selected via keyboard, trigger the onChange handler with
  // the input's value and trigger the onClick hander.

  var onChangeInput = (0, _react.useCallback)(function () {
    onChange(value);
    onClick();
  }, [value, onClick, onChange]); // When the button is clicked, disable the hover state if we're dealing with a
  // checkbox input and trigger the input's change handler.

  var onClickButton = (0, _react.useCallback)(function () {
    if (inputType === "checkbox") {
      setDisableHover(true);
    }

    onChangeInput();
  }, [inputType, onChangeInput]); // When the user's mouse enters or leaves a checkbox button, ensure that the
  // hover state is re-enabled

  var onMouseEnterLeaveButton = (0, _react.useCallback)(function () {
    if (inputType === "checkbox" && disableHover) {
      setDisableHover(false);
    }
  }, [inputType, disableHover]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, {
      disableHover: disableHover,
      type: type,
      minWidth: props.minWidth,
      disabled: props.disabled,
      backdropColor: props.backdropColor
    }),
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id
  }, props.label || props.children), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, passThroughProps, {
    name: props.name || context.name,
    type: inputType,
    checked: checked,
    disabled: props.disabled,
    onChange: onChangeInput,
    id: id,
    onFocus: props.onFocus,
    onBlur: props.onBlur
  })), /*#__PURE__*/_react["default"].createElement(_button2["default"], {
    size: context.size,
    type: type,
    minWidth: props.minWidth,
    disabled: props.disabled,
    onClick: onClickButton,
    onMouseEnter: onMouseEnterLeaveButton,
    onMouseLeave: onMouseEnterLeaveButton,
    tabIndex: "-1",
    "aria-hidden": true
  }, props.children));
});

ButtonOption.propTypes =  false ? {
  /**
   * The content shown in the button option. Plain text and/or icons are
   * recommended.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.22.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * If the button is placed on a backdrop that is not the primary background
   * color, then provide the color of the backdrop here so the button colors
   * can be optimized for display against the backdrop.
   */
  backdropColor: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * An accessible label for the component. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   */
  label: _propTypes["default"].string,

  /**
   * Sets the minimum width on a button. The button label may still extend
   * the width of the button if necessary
   */
  minWidth: _propTypes["default"].string,

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   *
   * This will override any `name` prop set on the parent ButtonGroup component.
   */
  name: _propTypes["default"].string,

  /**
   * The value of the option's form control. Use this in conjunction with the
   * `value` prop of the ButtonGroup component to mark this option as either
   * checked or unchecked.
   */
  value: _propTypes["default"].any,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the user clicks the option. No arguments are passed to
   * this function.
   */
  onClick: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func
} : {};
ButtonOption.defaultProps = {
  onClick: _noop["default"]
};
ButtonOption.displayName = "ButtonOption";
var _default = ButtonOption;
exports["default"] = _default;

/***/ }),
/* 795 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconInfoKnockoutData: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3e%3cpath d='M8 0a8 8 0 108 8 8 8 0 00-8-8zm0 3a1 1 0 11-1 1 1 1 0 011-1zm1 9a1 1 0 01-2 0V8a1 1 0 012 0z' fill='currentColor'/%3e%3c/svg%3e",
  iconInfoKnockoutWidth: 16,
  iconInfoKnockoutHeight: 16
};

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(78);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fscreen = __webpack_require__(797);

var _fscreen2 = _interopRequireDefault(_fscreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullScreen = function (_Component) {
  _inherits(FullScreen, _Component);

  function FullScreen(props) {
    _classCallCheck(this, FullScreen);

    var _this = _possibleConstructorReturn(this, (FullScreen.__proto__ || Object.getPrototypeOf(FullScreen)).call(this, props));

    _this.fullScreenElement = null;
    _this.detectFullScreen = _this.detectFullScreen.bind(_this);
    return _this;
  }

  _createClass(FullScreen, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _fscreen2.default.addEventListener("fullscreenchange", this.detectFullScreen);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _fscreen2.default.removeEventListener("fullscreenchange", this.detectFullScreen);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.handleProps(this.props);
    }
  }, {
    key: "handleProps",
    value: function handleProps(props) {
      var enabled = _fscreen2.default.fullscreenElement === this.node;
      if (enabled && !props.enabled) {
        this.leaveFullScreen();
      } else if (!enabled && props.enabled) {
        this.enterFullScreen();
      }
    }
  }, {
    key: "detectFullScreen",
    value: function detectFullScreen() {
      if (_fscreen2.default.fullscreenElement === this.node) {
        this.fullScreenElement = _fscreen2.default.fullscreenElement;
        this.props.onChange(true);
      } else if (!_fscreen2.default.fullscreenElement && this.fullScreenElement) {
        this.fullScreenElement = null;
        this.props.onChange(false);
      }
    }
  }, {
    key: "enterFullScreen",
    value: function enterFullScreen() {
      if (_fscreen2.default.fullscreenEnabled) {
        _fscreen2.default.requestFullscreen(this.node);
      }
    }
  }, {
    key: "leaveFullScreen",
    value: function leaveFullScreen() {
      if (_fscreen2.default.fullscreenEnabled) {
        _fscreen2.default.exitFullscreen();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = ["fullscreen"];
      if (this.props.enabled) {
        className.push("fullscreen-enabled");
      }

      return _react2.default.createElement(
        "div",
        {
          className: className.join(" "),
          ref: function ref(node) {
            return _this2.node = node;
          },
          style: this.props.enabled ? { height: "100%", width: "100%" } : undefined
        },
        this.props.children
      );
    }
  }]);

  return FullScreen;
}(_react.Component);

FullScreen.propTypes = {
  children: _propTypes2.default.node.isRequired,
  enabled: _propTypes2.default.bool.isRequired,
  onChange: _propTypes2.default.func
};
FullScreen.defaultProps = {
  enabled: false,
  onChange: function onChange() {
    return void 0;
  }
};
exports.default = FullScreen;

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var key = {
    fullscreenEnabled: 0,
    fullscreenElement: 1,
    requestFullscreen: 2,
    exitFullscreen: 3,
    fullscreenchange: 4,
    fullscreenerror: 5,
    fullscreen: 6
};
var webkit = [
    'webkitFullscreenEnabled',
    'webkitFullscreenElement',
    'webkitRequestFullscreen',
    'webkitExitFullscreen',
    'webkitfullscreenchange',
    'webkitfullscreenerror',
    '-webkit-full-screen',
];
var moz = [
    'mozFullScreenEnabled',
    'mozFullScreenElement',
    'mozRequestFullScreen',
    'mozCancelFullScreen',
    'mozfullscreenchange',
    'mozfullscreenerror',
    '-moz-full-screen',
];
var ms = [
    'msFullscreenEnabled',
    'msFullscreenElement',
    'msRequestFullscreen',
    'msExitFullscreen',
    'MSFullscreenChange',
    'MSFullscreenError',
    '-ms-fullscreen',
];
// so it doesn't throw if no window or document
var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
var vendor = (('fullscreenEnabled' in document && Object.keys(key)) ||
    (webkit[0] in document && webkit) ||
    (moz[0] in document && moz) ||
    (ms[0] in document && ms) ||
    []);
var fscreen = {
    requestFullscreen: function (element) { return element[vendor[key.requestFullscreen]](); },
    requestFullscreenFunction: function (element) { return element[vendor[key.requestFullscreen]]; },
    get exitFullscreen() { return document[vendor[key.exitFullscreen]].bind(document); },
    get fullscreenPseudoClass() { return ":" + vendor[key.fullscreen]; },
    addEventListener: function (type, handler, options) { return document.addEventListener(vendor[key[type]], handler, options); },
    removeEventListener: function (type, handler, options) { return document.removeEventListener(vendor[key[type]], handler, options); },
    get fullscreenEnabled() { return Boolean(document[vendor[key.fullscreenEnabled]]); },
    set fullscreenEnabled(val) { },
    get fullscreenElement() { return document[vendor[key.fullscreenElement]]; },
    set fullscreenElement(val) { },
    get onfullscreenchange() { return document[("on" + vendor[key.fullscreenchange]).toLowerCase()]; },
    set onfullscreenchange(handler) { return document[("on" + vendor[key.fullscreenchange]).toLowerCase()] = handler; },
    get onfullscreenerror() { return document[("on" + vendor[key.fullscreenerror]).toLowerCase()]; },
    set onfullscreenerror(handler) { return document[("on" + vendor[key.fullscreenerror]).toLowerCase()] = handler; },
};

/* harmony default export */ __webpack_exports__["default"] = (fscreen);
//# sourceMappingURL=fscreen.esm.js.map


/***/ }),
/* 798 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCheckSmallData: "data:image/svg+xml,%3csvg width='10' height='8' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 3.458l2.988 3.084L9 1.458' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconCheckSmallWidth: 10,
  iconCheckSmallHeight: 8
};

/***/ }),
/* 799 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCloseSmallData: "data:image/svg+xml,%3csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.053 1.053a1 1 0 011.414 0L6 4.585l3.533-3.532a1 1 0 011.32-.083l.094.083a1 1 0 010 1.414L7.415 6l3.532 3.533a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.414 0L6 7.415l-3.533 3.532a1 1 0 01-1.32.083l-.094-.083a1 1 0 010-1.414L4.585 6 1.053 2.467a1 1 0 01-.083-1.32z' fill='currentColor' fill-rule='nonzero'/%3e%3c/svg%3e",
  iconCloseSmallWidth: 12,
  iconCloseSmallHeight: 12
};

/***/ }),
/* 800 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconClockData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3ccircle cx='12' cy='12' r='11'/%3e%3cpath d='M12 6v6l4 4'/%3e%3c/g%3e%3c/svg%3e",
  iconClockWidth: 24,
  iconClockHeight: 24
};

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(802);


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSVLink = exports.CSVDownload = undefined;

var _Download = __webpack_require__(803);

var _Download2 = _interopRequireDefault(_Download);

var _Link = __webpack_require__(804);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CSVDownload = exports.CSVDownload = _Download2.default;
var CSVLink = exports.CSVLink = _Link2.default;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(309);

var _metaProps = __webpack_require__(310);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultProps = {
  target: '_blank'
};

var CSVDownload = function (_React$Component) {
  _inherits(CSVDownload, _React$Component);

  function CSVDownload(props) {
    _classCallCheck(this, CSVDownload);

    var _this = _possibleConstructorReturn(this, (CSVDownload.__proto__ || Object.getPrototypeOf(CSVDownload)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(CSVDownload, [{
    key: 'buildURI',
    value: function buildURI() {
      return _core.buildURI.apply(undefined, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          data = _props.data,
          headers = _props.headers,
          separator = _props.separator,
          enclosingCharacter = _props.enclosingCharacter,
          uFEFF = _props.uFEFF,
          target = _props.target,
          specs = _props.specs,
          replace = _props.replace;

      this.state.page = window.open(this.buildURI(data, uFEFF, headers, separator, enclosingCharacter), target, specs, replace);
    }
  }, {
    key: 'getWindow',
    value: function getWindow() {
      return this.state.page;
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return CSVDownload;
}(_react2.default.Component);

CSVDownload.defaultProps = Object.assign(_metaProps.defaultProps, defaultProps);
CSVDownload.propTypes = _metaProps.propTypes;
exports.default = CSVDownload;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(309);

var _metaProps = __webpack_require__(310);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CSVLink = function (_React$Component) {
  _inherits(CSVLink, _React$Component);

  function CSVLink(props) {
    _classCallCheck(this, CSVLink);

    var _this = _possibleConstructorReturn(this, (CSVLink.__proto__ || Object.getPrototypeOf(CSVLink)).call(this, props));

    _this.buildURI = _this.buildURI.bind(_this);
    return _this;
  }

  _createClass(CSVLink, [{
    key: 'buildURI',
    value: function buildURI() {
      return _core.buildURI.apply(undefined, arguments);
    }
  }, {
    key: 'handleLegacy',
    value: function handleLegacy(event) {
      var isAsync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (window.navigator.msSaveOrOpenBlob) {
        event.preventDefault();

        var _props = this.props,
            data = _props.data,
            headers = _props.headers,
            separator = _props.separator,
            filename = _props.filename,
            enclosingCharacter = _props.enclosingCharacter,
            uFEFF = _props.uFEFF;


        var csvData = isAsync && typeof data === 'function' ? data() : data;

        var blob = new Blob([uFEFF ? '\uFEFF' : '', (0, _core.toCSV)(csvData, headers, separator, enclosingCharacter)]);
        window.navigator.msSaveBlob(blob, filename);

        return false;
      }
    }
  }, {
    key: 'handleAsyncClick',
    value: function handleAsyncClick(event) {
      var _this2 = this;

      var done = function done(proceed) {
        if (proceed === false) {
          event.preventDefault();
          return;
        }
        _this2.handleLegacy(event, true);
      };

      this.props.onClick(event, done);
    }
  }, {
    key: 'handleSyncClick',
    value: function handleSyncClick(event) {
      var stopEvent = this.props.onClick(event) === false;
      if (stopEvent) {
        event.preventDefault();
        return;
      }
      this.handleLegacy(event);
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var _this3 = this;

      return function (event) {
        if (typeof _this3.props.onClick === 'function') {
          return _this3.props.asyncOnClick ? _this3.handleAsyncClick(event) : _this3.handleSyncClick(event);
        }
        _this3.handleLegacy(event);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          data = _props2.data,
          headers = _props2.headers,
          separator = _props2.separator,
          filename = _props2.filename,
          uFEFF = _props2.uFEFF,
          children = _props2.children,
          onClick = _props2.onClick,
          asyncOnClick = _props2.asyncOnClick,
          enclosingCharacter = _props2.enclosingCharacter,
          rest = _objectWithoutProperties(_props2, ['data', 'headers', 'separator', 'filename', 'uFEFF', 'children', 'onClick', 'asyncOnClick', 'enclosingCharacter']);

      var isNodeEnvironment = typeof window === 'undefined';
      var href = isNodeEnvironment ? '' : this.buildURI(data, uFEFF, headers, separator, enclosingCharacter);

      return _react2.default.createElement(
        'a',
        _extends({
          download: filename
        }, rest, {
          ref: function ref(link) {
            return _this4.link = link;
          },
          target: '_self',
          href: href,
          onClick: this.handleClick()
        }),
        children
      );
    }
  }]);

  return CSVLink;
}(_react2.default.Component);

CSVLink.defaultProps = _metaProps.defaultProps;
CSVLink.propTypes = _metaProps.propTypes;
exports.default = CSVLink;

/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfigReducer__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OptionsReducer__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AssociateReducer__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ClusterReducer__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClusterReducerV2__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AisleReducer__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FloorReducer__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SortZoneReducer__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PackageListReducer__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__StationPairReducer__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RouteReducer__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ZoneReducer__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CartLocationReducer__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__OverviewReducer__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__OptionsReducerV2__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__StowBufferReducer__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FloorLocationReducer__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__CartReducer__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__GridAllocationReducer__ = __webpack_require__(826);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({configReducer:__WEBPACK_IMPORTED_MODULE_1__ConfigReducer__["a" /* default */],optionsReducer:__WEBPACK_IMPORTED_MODULE_2__OptionsReducer__["a" /* default */],associateReducer:__WEBPACK_IMPORTED_MODULE_3__AssociateReducer__["a" /* default */],aisleReducer:__WEBPACK_IMPORTED_MODULE_6__AisleReducer__["a" /* default */],clusterReducer:__WEBPACK_IMPORTED_MODULE_4__ClusterReducer__["a" /* default */],clusterReducerV2:__WEBPACK_IMPORTED_MODULE_5__ClusterReducerV2__["a" /* default */],floorLocationReducer:__WEBPACK_IMPORTED_MODULE_17__FloorLocationReducer__["a" /* default */],floorReducer:__WEBPACK_IMPORTED_MODULE_7__FloorReducer__["a" /* default */],sortZoneReducer:__WEBPACK_IMPORTED_MODULE_8__SortZoneReducer__["a" /* default */],packageListReducer:__WEBPACK_IMPORTED_MODULE_9__PackageListReducer__["a" /* default */],stationPairReducer:__WEBPACK_IMPORTED_MODULE_10__StationPairReducer__["a" /* default */],zoneReducer:__WEBPACK_IMPORTED_MODULE_12__ZoneReducer__["a" /* default */],cartReducer:__WEBPACK_IMPORTED_MODULE_18__CartReducer__["a" /* default */],cartLocationReducer:__WEBPACK_IMPORTED_MODULE_13__CartLocationReducer__["a" /* default */],routeReducer:__WEBPACK_IMPORTED_MODULE_11__RouteReducer__["a" /* default */],overviewReducer:__WEBPACK_IMPORTED_MODULE_14__OverviewReducer__["a" /* default */],optionsReducerV2:__WEBPACK_IMPORTED_MODULE_15__OptionsReducerV2__["a" /* default */],stowBufferReducer:__WEBPACK_IMPORTED_MODULE_16__StowBufferReducer__["a" /* default */],gridAllocationReducer:__WEBPACK_IMPORTED_MODULE_19__GridAllocationReducer__["a" /* default */]}));

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optionsReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ConfigActions__ = __webpack_require__(68);
function optionsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_ConfigActions__["a" /* FETCH_FEATURE_STATUS_CALL_SUCCESS */]:return Object.assign({},state,{featureStatus:Object.assign({},state.featureStatus,action.featureStatus),loading:false});default:// ALWAYS have a default case in a reducer
return state;}}

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optionsReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(7);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Initial state of the options menu
 */var initialState={showingOptionsMenu:false,options:{cycle:"",cycleId:"",associateStatuses:[],machineStatuses:[],clusters:[]},heatMapView:__WEBPACK_IMPORTED_MODULE_2__enums__["q" /* ViewType */].DEFAULT_VIEW,isInitialView:true,navigationOptions:[],loading:false,allCycles:[],allClusters:[],allAisles:[],capability:__WEBPACK_IMPORTED_MODULE_2__enums__["e" /* Capability */].AMZL,clusterAislesMap:{}};function optionsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var newState=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActions__["i" /* OPTIONS_BUTTON_CLICKED */]:return Object.assign({},state,{showingOptionsMenu:!state.showingOptionsMenu});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActions__["h" /* OPTIONS_ADDED_OR_CHANGED */]:newState=Object.assign({},state,{options:Object.assign({},state.options,action.options)});Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["k" /* setSelectedCycle */])([newState.options.cycle]);return newState;case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActions__["j" /* OPTION_REMOVED */]:if(Array.isArray(state.options[action.removedOption])){var newArray=state.options[action.removedOption].filter(function(optionValue){return optionValue!==action.removedOptionValue;});newState=Object.assign({},state,{options:Object.assign({},state.options,_defineProperty({},action.removedOption,newArray))});Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["k" /* setSelectedCycle */])([newState.options.cycle]);return newState;}// Using Destructuring assignment
var _state$options=state.options,value=_state$options[action.removedOption],newOptions=_objectWithoutProperties(_state$options,[action.removedOption]);return Object.assign({},state,{options:newOptions});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActions__["k" /* OPTION_REMOVE_ALL */]:return Object.assign({},state,{options:initialState.options});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActions__["f" /* NAVIGATION_ADDED */]:return Object.assign({},state,{navigationOptions:[].concat(_toConsumableArray(state.navigationOptions),[action.navigationOption])});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActions__["g" /* NAVIGATION_REMOVED */]:return Object.assign({},state,{navigationOptions:[].concat(_toConsumableArray(state.navigationOptions.slice(0,action.navigationIndex)))});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActions__["d" /* FETCH_OPTIONS_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActions__["a" /* FETCH_CAPABILITY_CALL_SUCCESS */]:var capability=JSON.parse(action.capabilityResponse.capability);return Object.assign({},state,{capability:capability,loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActions__["b" /* FETCH_CYCLES_CALL_SUCCESS */]:var allCycles=JSON.parse(action.cyclesResponse.cycleList).filter(function(cycle){return cycle.cycleId!=="AllCycles";}).map(function(cycle){return Object.assign({},cycle,{displayableName:cycle.cycleId.replace('CYCLE_','')});}).sort(function(cycle1,cycle2){return cycle1.cycleName>cycle2.cycleName?1:cycle2.cycleName>cycle1.cycleName?-1:0;});var selectedCycles=JSON.parse(action.cyclesResponse.selectedCycles).filter(function(cycle){return cycle!=="AllCycles";});var selectedCycleIds=allCycles.filter(function(cycle){return selectedCycles.includes(cycle.cycleId);}).map(function(cycle){return cycle.casCycleId;});return Object.assign({},state,{options:Object.assign({},state.options,{cycle:selectedCycles.length?selectedCycles[0]:"",cycleId:selectedCycleIds.length?selectedCycleIds[0]:""}),allCycles:allCycles,loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActions__["c" /* FETCH_FILTERS_CALL_SUCCESS */]:return Object.assign({},state,{allClusters:action.filters.allClusters,allAisles:action.filters.allAisles,clusterAislesMap:action.filters.clusterAislesMap,loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActions__["e" /* FETCH_OPTIONS_CALL_FAILURE */]:return Object.assign({},state,{loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActions__["l" /* VIEW_CHANGED */]:return Object.assign({},state,{heatMapView:action.view,isInitialView:false});default:// ALWAYS have a default case in a reducer
return state;}}

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = associateReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_AssociateActions__ = __webpack_require__(286);
var initialState={loading:true,associatesList:[]};/**
 * Reducer function for Associate View that changes state
 * based on the action triggered.
 */function associateReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_AssociateActions__["a" /* LOAD_STOW_ASSOCIATES_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_AssociateActions__["c" /* LOAD_STOW_ASSOCIATES_CALL_SUCCESS */]:return Object.assign({},state,{loading:false,associatesList:action.associatesList});case __WEBPACK_IMPORTED_MODULE_0__actions_AssociateActions__["b" /* LOAD_STOW_ASSOCIATES_CALL_FAILURE */]:return Object.assign({},state,{loading:false});default:return state;}}

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clusterReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActions__ = __webpack_require__(94);
/**
 * Initial state of the system.
 */var initialState={loading:false,stowPackageMetricsMap:{},stowBinMetricsMap:{},stowCartMetricsMap:{},inductPackageMetricsMap:{},stowAssociateMetricsMap:{},totalStowPackageMetrics:{},totalStowBinMetrics:{},totalInductPackageMetrics:{},totalStowAssociateMetrics:{}/**
 * Reducer function for Cluster View that changes state
 * based on the action triggered.
 */};function clusterReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActions__["c" /* LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActions__["k" /* LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER */]:return Object.assign({},state,{loading:false,stowPackageMetricsMap:action.stowPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActions__["g" /* LOAD_STOW_BIN_METRICS_FOR_CLUSTER */]:return Object.assign({},state,{loading:false,stowBinMetricsMap:action.stowBinMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActions__["i" /* LOAD_STOW_CART_METRICS_FOR_CLUSTER */]:return Object.assign({},state,{loading:false,stowCartMetricsMap:action.stowCartMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActions__["j" /* LOAD_STOW_CART_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,stowCartMetricsMap:{"Total":Object.assign({},state.stowCartMetricsMap["Total"],action.stowCartMetricsMap["Total"])}});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActions__["a" /* LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER */]:return Object.assign({},state,{loading:false,inductPackageMetricsMap:action.inductPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActions__["e" /* LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER */]:return Object.assign({},state,{loading:false,stowAssociateMetricsMap:action.stowAssociateMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActions__["l" /* LOAD_STOW_PACKAGE_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,totalStowPackageMetrics:{"Total":Object.assign({},state.totalStowPackageMetrics["Total"],action.totalStowPackageMetrics["Total"])}});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActions__["h" /* LOAD_STOW_BIN_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,totalStowBinMetrics:action.totalStowBinMetrics});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActions__["b" /* LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,totalInductPackageMetrics:action.totalInductPackageMetrics});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActions__["f" /* LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,totalStowAssociateMetrics:action.totalStowAssociateMetrics});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActions__["d" /* LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE */]:return Object.assign({},state,{loading:false});default:return state;}}

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clusterReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActionsV2__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utility__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_ClusterActions__ = __webpack_require__(94);
/**
 * Initial state of the system.
 */var initialState={loading:false,minOfWorkMetricsMap:{},stowPackageMetricsMap:{},stowBinMetricsMap:{},stowCartMetricsMap:{},stowBinMetricsMapForStowV2:{},inductPackageMetricsMap:{},stowAssociateMetricsMap:{},nodeResourceData:{},totalStowPackageMetrics:{},totalStowBinMetrics:{},totalInductPackageMetrics:{},totalStowAssociateMetrics:{},nodeResourceDataMap:new Map()/**
 * Reducer function for Cluster View that changes state
 * based on the action triggered.
 */};function clusterReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActionsV2__["c" /* LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_2__actions_ClusterActions__["i" /* LOAD_STOW_CART_METRICS_FOR_CLUSTER */]:return Object.assign({},state,{loading:false,stowCartMetricsMap:action.stowCartMetricsMap});case __WEBPACK_IMPORTED_MODULE_2__actions_ClusterActions__["j" /* LOAD_STOW_CART_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,stowCartMetricsMap:{"Total":Object.assign({},state.stowCartMetricsMap["Total"],action.stowCartMetricsMap["Total"])}});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActionsV2__["k" /* LOAD_STOW_MIN_OF_WORK_METRICS_FOR_CLUSTER */]:return Object.assign({},state,{loading:false,minOfWorkMetricsMap:action.minOfWorkMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActionsV2__["l" /* LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER */]:return Object.assign({},state,{loading:false,stowPackageMetricsMap:action.stowPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActionsV2__["h" /* LOAD_STOW_BIN_METRICS_FOR_CLUSTER */]:return Object.assign({},state,{loading:false,stowBinMetricsMap:action.stowBinMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActionsV2__["a" /* LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER */]:return Object.assign({},state,{loading:false,inductPackageMetricsMap:action.inductPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActionsV2__["f" /* LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER */]:return Object.assign({},state,{loading:false,stowAssociateMetricsMap:action.stowAssociateMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActionsV2__["m" /* LOAD_STOW_PACKAGE_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,totalStowPackageMetrics:{"Total":Object.assign({},state.totalStowPackageMetrics["Total"],action.totalStowPackageMetrics["Total"])}});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActionsV2__["j" /* LOAD_STOW_BIN_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,totalStowBinMetrics:action.totalStowBinMetrics});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActionsV2__["b" /* LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,totalInductPackageMetrics:action.totalInductPackageMetrics});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActionsV2__["g" /* LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,totalStowAssociateMetrics:action.totalStowAssociateMetrics});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActionsV2__["d" /* LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE */]:return Object.assign({},state,{loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActionsV2__["e" /* LOAD_NODE_RESOURCE_DATA_FOR_CLUSTER */]:return Object.assign({},state,{loading:false,nodeResourceData:action.nodeResourceData,nodeResourceDataMap:Object(__WEBPACK_IMPORTED_MODULE_1__Utility__["n" /* getNodeResourceDataMap */])(action.nodeResourceData)});case __WEBPACK_IMPORTED_MODULE_0__actions_ClusterActionsV2__["i" /* LOAD_STOW_BIN_METRICS_FOR_CLUSTER_FOR_STOW_V2 */]:return Object.assign({},state,{loading:false,stowBinMetricsMapForStowV2:action.stowBinMetricsMapForStowV2});default:return state;}}

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = aisleReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_AisleActions__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utility__ = __webpack_require__(10);
/**
 * Initial state of the system.
 */var initialState={loading:true,stowPackageMetricsMap:{},stowBinMetricsMap:{},stowBinMetricsMapForStowV2:{},stowCartMetricsMap:{},stowBagMetricsMap:{},inductPackageMetricsMap:{},stowAssociateMetricsMap:{},nodeResourceData:{},nodeResourceDataMap:new Map()/**
 * Reducer function for Aisle View that changes state
 * based on the action triggered.
 */};function aisleReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_AisleActions__["b" /* LOAD_METRICS_FOR_AISLE_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_AisleActions__["j" /* LOAD_STOW_PACKAGE_METRICS_FOR_AISLE */]:return Object.assign({},state,{loading:false,stowPackageMetricsMap:action.stowPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_AisleActions__["g" /* LOAD_STOW_BIN_METRICS_FOR_AISLE */]:return Object.assign({},state,{loading:false,stowBinMetricsMap:action.stowBinMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_AisleActions__["f" /* LOAD_STOW_BAG_METRICS_FOR_AISLE */]:return Object.assign({},state,{loading:false,stowBagMetricsMap:action.stowBagMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_AisleActions__["i" /* LOAD_STOW_CART_METRICS_FOR_AISLE */]:return Object.assign({},state,{loading:false,stowCartMetricsMap:action.stowCartMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_AisleActions__["a" /* LOAD_INDUCT_PACKAGE_METRICS_FOR_AISLE */]:return Object.assign({},state,{loading:false,inductPackageMetricsMap:action.inductPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_AisleActions__["e" /* LOAD_STOW_ASSOCIATE_METRICS_FOR_AISLE */]:return Object.assign({},state,{loading:false,stowAssociateMetricsMap:action.stowAssociateMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_AisleActions__["c" /* LOAD_METRICS_FOR_AISLE_CALL_FAILURE */]:return Object.assign({},state,{loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_AisleActions__["d" /* LOAD_NODE_RESOURCE_DATA_FOR_AISLE */]:return Object.assign({},state,{loading:false,nodeResourceData:action.nodeResourceData,nodeResourceDataMap:Object(__WEBPACK_IMPORTED_MODULE_1__Utility__["n" /* getNodeResourceDataMap */])(action.nodeResourceData)});case __WEBPACK_IMPORTED_MODULE_0__actions_AisleActions__["h" /* LOAD_STOW_BIN_METRICS_FOR_AISLE_FOR_STOW_V2 */]:return Object.assign({},state,{loading:false,stowBinMetricsMapForStowV2:action.stowBinMetricsMapForStowV2});default:return state;}}

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = floorReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_FloorActions__ = __webpack_require__(91);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Initial state of the system.
 */var initialState={loading:true,inductPackageMetricsMap:{},pickPackageMetricsMap:{},stowCartData:{},stowFloorsData:{},stowPackageMetricsMap:{}/**
 * Reducer function for Floor View that changes state
 * based on the action triggered.
 */};function floorReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_FloorActions__["b" /* LOAD_METRICS_FOR_FLOOR_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_FloorActions__["a" /* LOAD_INDUCT_PACKAGE_METRICS_FOR_FLOOR */]:return Object.assign({},state,{loading:false,inductPackageMetricsMap:action.inductPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_FloorActions__["d" /* LOAD_PICK_PACKAGE_METRICS_FOR_FLOOR */]:return Object.assign({},state,{loading:false,pickPackageMetricsMap:action.pickPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_FloorActions__["e" /* LOAD_STOW_CART_DATA_FOR_FLOOR */]:return Object.assign({},state,{loading:false,stowCartData:Object.assign({},state.stowCartData,_defineProperty({},action.stowCartData.floor,action.stowCartData.cartData))});case __WEBPACK_IMPORTED_MODULE_0__actions_FloorActions__["f" /* LOAD_STOW_FLOOR_DATA_FOR_FLOOR */]:return Object.assign({},state,{loading:false,stowFloorsData:action.stowFloorsData});case __WEBPACK_IMPORTED_MODULE_0__actions_FloorActions__["g" /* LOAD_STOW_PACKAGE_METRICS_FOR_FLOOR */]:return Object.assign({},state,{loading:false,stowPackageMetricsMap:action.stowPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_FloorActions__["c" /* LOAD_METRICS_FOR_FLOOR_CALL_FAILURE */]:return Object.assign({},state,{loading:false});default:return state;}}

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortZoneReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_SortZoneActions__ = __webpack_require__(79);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Initial state of the system.
 */var initialState={loading:true,stowPackageMetricsMap:{},stowBagMetricsMap:{},stowOvUsageMap:{},inductPackageMetricsMap:{},bagsData:{},totalSortZoneMap:{}/**
 * Reducer function for Sort Zone View that changes state
 * based on the action triggered.
 */};function sortZoneReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_SortZoneActions__["b" /* LOAD_METRICS_FOR_SORT_ZONE_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_SortZoneActions__["h" /* LOAD_STOW_PACKAGE_METRICS_FOR_SORT_ZONE */]:return Object.assign({},state,{loading:false,stowPackageMetricsMap:action.stowPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_SortZoneActions__["f" /* LOAD_STOW_BAG_METRICS_FOR_SORT_ZONE */]:return Object.assign({},state,{loading:false,stowBagMetricsMap:action.stowBagMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_SortZoneActions__["a" /* LOAD_INDUCT_PACKAGE_METRICS_FOR_SORT_ZONE */]:return Object.assign({},state,{loading:false,inductPackageMetricsMap:action.inductPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_SortZoneActions__["g" /* LOAD_STOW_OV_USAGE_FOR_SORT_ZONE */]:return Object.assign({},state,{loading:false,stowOvUsageMap:action.stowOvUsageMap});case __WEBPACK_IMPORTED_MODULE_0__actions_SortZoneActions__["e" /* LOAD_STOW_BAG_DATA_FOR_SORT_ZONE */]:return Object.assign({},state,{loading:false,bagsData:Object.assign({},state.bagsData,_defineProperty({},action.stowBagsData.sortZone,action.stowBagsData.bagsData))});case __WEBPACK_IMPORTED_MODULE_0__actions_SortZoneActions__["d" /* LOAD_NODE_RESOURCE_DATA_FOR_SORT_ZONE */]:return Object.assign({},state,{loading:false,nodeResourceData:action.nodeResourceData});case __WEBPACK_IMPORTED_MODULE_0__actions_SortZoneActions__["c" /* LOAD_METRICS_FOR_SORT_ZONE_CALL_FAILURE */]:return Object.assign({},state,{loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_SortZoneActions__["i" /* LOAD_TOTAL_SORT_ZONE */]:return Object.assign({},state,{loading:false,totalSortZoneMap:action.totalSortZoneMap});default:return state;}}

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = packageListReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_PackageListActions__ = __webpack_require__(302);
var initialState={loading:true,packageList:[]/**
 * Reducer function for PackageList View that changes state
 * based on the action triggered.
 */};function packageListReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_PackageListActions__["a" /* LOAD_PACKAGE_LIST_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_PackageListActions__["c" /* LOAD_PACKAGE_LIST_SUCCESS */]:return Object.assign({},state,{loading:false,packageList:action.packageList});case __WEBPACK_IMPORTED_MODULE_0__actions_PackageListActions__["b" /* LOAD_PACKAGE_LIST_FAILURE */]:return Object.assign({},state,{loading:false});default:return state;}}

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stationPairReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_StationPairActions__ = __webpack_require__(113);
/**
 * Initial state of the system.
 */var initialState={loading:true,inductPackageMetricsMap:{},pickPackageMetricsMap:{},stowAssociateMetricsMap:{},stowFloorMetricsGroupMap:{},stowPackageMetricsMap:{},totalInductPackageMetrics:{},totalPickPackageMetricsMap:{},totalStowAssociateMetrics:{},totalStowFloorMetricsMap:{},totalStowPackageMetrics:{}/**
 * Reducer function for Station Pair View that changes state
 * based on the action triggered.
 */};function stationPairReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_StationPairActions__["c" /* LOAD_METRICS_FOR_STATION_PAIR_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_StationPairActions__["a" /* LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,totalInductPackageMetrics:action.totalInductPackageMetrics});case __WEBPACK_IMPORTED_MODULE_0__actions_StationPairActions__["b" /* LOAD_INDUCT_PACKAGE_METRICS_FOR_STATION_PAIR */]:return Object.assign({},state,{loading:false,inductPackageMetricsMap:action.inductPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_StationPairActions__["e" /* LOAD_PICK_PACKAGE_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,totalPickPackageMetricsMap:action.totalPickPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_StationPairActions__["f" /* LOAD_PICK_PACKAGE_METRICS_FOR_STATION_PAIR */]:return Object.assign({},state,{loading:false,pickPackageMetricsMap:action.pickPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_StationPairActions__["g" /* LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,totalStowAssociateMetrics:action.totalStowAssociateMetrics});case __WEBPACK_IMPORTED_MODULE_0__actions_StationPairActions__["h" /* LOAD_STOW_ASSOCIATE_METRICS_FOR_STATION_PAIR */]:return Object.assign({},state,{loading:false,stowAssociateMetricsMap:action.stowAssociateMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_StationPairActions__["i" /* LOAD_STOW_FLOOR_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,totalStowFloorMetricsMap:action.totalStowFloorMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_StationPairActions__["j" /* LOAD_STOW_FLOOR_METRICS_FOR_STATION_PAIR */]:return Object.assign({},state,{loading:false,stowFloorMetricsGroupMap:action.stowFloorMetricsGroupMap});case __WEBPACK_IMPORTED_MODULE_0__actions_StationPairActions__["k" /* LOAD_STOW_PACKAGE_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,totalStowPackageMetrics:action.totalStowPackageMetrics});case __WEBPACK_IMPORTED_MODULE_0__actions_StationPairActions__["l" /* LOAD_STOW_PACKAGE_METRICS_FOR_STATION_PAIR */]:return Object.assign({},state,{loading:false,stowPackageMetricsMap:action.stowPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_StationPairActions__["d" /* LOAD_METRICS_FOR_STATION_PAIR_CALL_FAILURE */]:return Object.assign({},state,{loading:false});default:return state;}}

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = routeReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_RouteActions__ = __webpack_require__(114);
/**
 * Initial state of the system.
 */var initialState={loading:true,stowPackageMetricsMap:{},plannedPackageMetricsMap:{},inductPackageMetricsMap:{},stowAssociateMetricsMap:{}/**
 * Reducer function for Route View that changes state
 * based on the action triggered.
 */};function routeReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_RouteActions__["b" /* LOAD_METRICS_FOR_ROUTE_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_RouteActions__["f" /* LOAD_STOW_PACKAGE_METRICS_FOR_ROUTE */]:return Object.assign({},state,{loading:false,stowPackageMetricsMap:action.stowPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_RouteActions__["d" /* LOAD_PLANNED_PACKAGE_METRICS_FOR_ROUTE */]:return Object.assign({},state,{loading:false,plannedPackageMetricsMap:action.plannedPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_RouteActions__["a" /* LOAD_INDUCT_PACKAGE_METRICS_FOR_ROUTE */]:return Object.assign({},state,{loading:false,inductPackageMetricsMap:action.inductPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_RouteActions__["e" /* LOAD_STOW_ASSOCIATE_METRICS_FOR_ROUTE */]:return Object.assign({},state,{loading:false,stowAssociateMetricsMap:action.stowAssociateMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_RouteActions__["c" /* LOAD_METRICS_FOR_ROUTE_CALL_FAILURE */]:return Object.assign({},state,{loading:false});default:return state;}}

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = zoneReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ZoneActions__ = __webpack_require__(115);
/**
 * Initial state of the system.
 */var initialState={loading:true,inductPackageMetricsMap:{},stowAssociateMetricsMap:{},stowPackageMetricsMap:{},totalInductPackageMetrics:{},totalStowAssociateMetrics:{},totalStowPackageMetrics:{}/**
 * Reducer function for Zone View that changes state
 * based on the action triggered.
 */};function zoneReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_ZoneActions__["a" /* LOAD_METRICS_FOR_ZONE_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_ZoneActions__["c" /* LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,totalStowAssociateMetrics:action.totalStowAssociateMetrics});case __WEBPACK_IMPORTED_MODULE_0__actions_ZoneActions__["d" /* LOAD_STOW_ASSOCIATE_METRICS_FOR_ZONE */]:return Object.assign({},state,{loading:false,stowAssociateMetricsMap:action.stowAssociateMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_ZoneActions__["e" /* LOAD_STOW_PACKAGE_METRICS_FOR_NODE */]:return Object.assign({},state,{loading:false,totalStowPackageMetrics:action.totalStowPackageMetrics});case __WEBPACK_IMPORTED_MODULE_0__actions_ZoneActions__["f" /* LOAD_STOW_PACKAGE_METRICS_FOR_ZONE */]:return Object.assign({},state,{loading:false,stowPackageMetricsMap:action.stowPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_ZoneActions__["b" /* LOAD_METRICS_FOR_ZONE_CALL_FAILURE */]:return Object.assign({},state,{loading:false});default:return state;}}

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cartLocationReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_CartLocationActions__ = __webpack_require__(93);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Initial state of the system.
 */var initialState={loading:true,inductPackageMetricsMap:{},stowCartData:{},stowCartLocationsData:{},stowPackageMetricsMap:{}/**
 * Reducer function for Floor View that changes state
 * based on the action triggered.
 */};function cartLocationReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_CartLocationActions__["a" /* LOAD_METRICS_FOR_CART_LOCATION_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_CartLocationActions__["c" /* LOAD_STOW_CART_DATA_FOR_CART_LOCATION */]:return Object.assign({},state,{loading:false,stowCartData:Object.assign({},state.stowCartData,_defineProperty({},action.stowCartData.floor,action.stowCartData.cartData))});case __WEBPACK_IMPORTED_MODULE_0__actions_CartLocationActions__["d" /* LOAD_STOW_FLOOR_DATA_FOR_CART_LOCATION */]:return Object.assign({},state,{loading:false,stowCartLocationsData:action.stowFloorsData});case __WEBPACK_IMPORTED_MODULE_0__actions_CartLocationActions__["e" /* LOAD_STOW_PACKAGE_METRICS_FOR_CART_LOCATION */]:return Object.assign({},state,{loading:false,stowPackageMetricsMap:action.stowPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_CartLocationActions__["b" /* LOAD_METRICS_FOR_CART_LOCATION_CALL_FAILURE */]:return Object.assign({},state,{loading:false});default:return state;}}

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = overviewReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_OverviewActions__ = __webpack_require__(246);
/**
 * Initial state of the system.
 */var initialState={loading:true,isSmartStowEnabled:false,atRiskAislesMetricsMap:{},inductPackageMetricsMapAisle:{},inductPackageMetricsMapCluster:{},stowPackageMetricsMapAisle:{},minOfWorkMetricsMapCluster:{},stowPackageMetricsMapCluster:{},stowAssociateMetricsMapCluster:{}/**
 * Reducer function for Overview View that changes state
 * based on the action triggered.
 */};function overviewReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_OverviewActions__["e" /* LOAD_METRICS_FOR_OVERVIEW_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_OverviewActions__["b" /* LOAD_AT_RISK_AISLES_METRICS_FOR_OVERVIEW */]:return Object.assign({},state,{loading:false,atRiskAislesMetricsMap:action.atRiskAislesMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_OverviewActions__["i" /* LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_AISLE */]:return Object.assign({},state,{loading:false,stowPackageMetricsMapAisle:action.stowPackageMetricsMapAisle});case __WEBPACK_IMPORTED_MODULE_0__actions_OverviewActions__["d" /* LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER */]:return Object.assign({},state,{loading:false,inductPackageMetricsMapCluster:action.inductPackageMetricsMapCluster});case __WEBPACK_IMPORTED_MODULE_0__actions_OverviewActions__["h" /* LOAD_STOW_MIN_OF_WORK_METRICS_FOR_OVERVIEW_CLUSTER */]:return Object.assign({},state,{loading:false,minOfWorkMetricsMapCluster:action.minOfWorkMetricsMapCluster});case __WEBPACK_IMPORTED_MODULE_0__actions_OverviewActions__["j" /* LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER */]:return Object.assign({},state,{loading:false,stowPackageMetricsMapCluster:action.stowPackageMetricsMapCluster});case __WEBPACK_IMPORTED_MODULE_0__actions_OverviewActions__["g" /* LOAD_STOW_ASSOCIATE_METRICS_FOR_OVERVIEW_CLUSTER */]:return Object.assign({},state,{loading:false,stowAssociateMetricsMapCluster:action.stowAssociateMetricsMapCluster});case __WEBPACK_IMPORTED_MODULE_0__actions_OverviewActions__["c" /* LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_AISLE */]:return Object.assign({},state,{loading:false,inductPackageMetricsMapAisle:action.inductPackageMetricsMapAisle});case __WEBPACK_IMPORTED_MODULE_0__actions_OverviewActions__["f" /* LOAD_METRICS_FOR_OVERVIEW_CALL_FAILURE */]:return Object.assign({},state,{loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_OverviewActions__["a" /* FETCH_SMART_STOW_ENABLEMENT_CALL_SUCCESS */]:return Object.assign({},state,{loading:false,isSmartStowEnabled:action.isSmartStowEnabled});default:return state;}}

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optionsReducerV2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(7);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Initial state of the options menu
 */var initialState={showingOptionsMenu:false,options:{cycle:"",cycleId:"",CPT:"",CPTId:"",associateStatuses:[],clusters:[]},heatMapView:__WEBPACK_IMPORTED_MODULE_2__enums__["q" /* ViewType */].DEFAULT_VIEW,isInitialView:true,navigationOptions:[],loading:false,allCycles:[],allCPT:[],filterIdentifier:'CPT',CPTLabel:'',allClusters:[],allAisles:[],capability:__WEBPACK_IMPORTED_MODULE_2__enums__["e" /* Capability */].AMZL,clusterAislesMap:{}};function optionsReducerV2(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var newState=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__["n" /* OPTIONS_BUTTON_CLICKED */]:return Object.assign({},state,{showingOptionsMenu:!state.showingOptionsMenu});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__["m" /* OPTIONS_ADDED_OR_CHANGED */]:newState=Object.assign({},state,{options:Object.assign({},state.options,action.options)});Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["k" /* setSelectedCycle */])([newState.options.cycle]);return newState;case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__["d" /* CPT_ADDED_OR_CHANGED */]:newState=Object.assign({},state,{options:Object.assign({},state.options,action.options)});return newState;case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__["o" /* OPTION_REMOVED */]:if(Array.isArray(state.options[action.removedOption])){var newArray=state.options[action.removedOption].filter(function(optionValue){return optionValue!==action.removedOptionValue;});newState=Object.assign({},state,{options:Object.assign({},state.options,_defineProperty({},action.removedOption,newArray))});Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["k" /* setSelectedCycle */])([newState.options.cycle]);return newState;}// Using Destructuring assignment
var _state$options=state.options,value=_state$options[action.removedOption],newOptions=_objectWithoutProperties(_state$options,[action.removedOption]);return Object.assign({},state,{options:newOptions});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__["p" /* OPTION_REMOVE_ALL */]:return Object.assign({},state,{options:initialState.options});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__["k" /* NAVIGATION_ADDED */]:return Object.assign({},state,{navigationOptions:[].concat(_toConsumableArray(state.navigationOptions),[action.navigationOption])});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__["l" /* NAVIGATION_REMOVED */]:return Object.assign({},state,{navigationOptions:[].concat(_toConsumableArray(state.navigationOptions.slice(0,action.navigationIndex)))});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__["i" /* FETCH_OPTIONS_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__["e" /* FETCH_CAPABILITY_CALL_SUCCESS */]:var capability=JSON.parse(action.capabilityResponse.capability);return Object.assign({},state,{capability:capability,loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__["g" /* FETCH_CYCLES_CALL_SUCCESS */]:var allCycles=JSON.parse(action.cyclesResponse.cycleList).filter(function(cycle){return cycle.cycleId!=="AllCycles";}).map(function(cycle){return Object.assign({},cycle,{displayableName:cycle.cycleId.replaceAll("_"," ")});}).sort(function(cycle1,cycle2){return cycle1.cycleName>cycle2.cycleName?1:cycle2.cycleName>cycle1.cycleName?-1:0;});var selectedCycles=JSON.parse(action.cyclesResponse.selectedCycles).filter(function(cycle){return cycle!=="AllCycles";});var selectedCycleIds=allCycles.filter(function(cycle){return selectedCycles.includes(cycle.cycleId);}).map(function(cycle){return cycle.casCycleId;});return Object.assign({},state,{options:Object.assign({},state.options,{cycle:selectedCycles.length?selectedCycles[0]:"",cycleId:selectedCycleIds.length?selectedCycleIds[0]:""}),allCycles:allCycles,loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__["f" /* FETCH_CPT_CALL_SUCCESS */]:var allCPT=action.data.CPTList;return Object.assign({},state,{allCPT:allCPT,options:Object.assign({},state.options,{CPTId:allCPT.filter(function(CPT){return CPT.label==="ALL";}).map(function(CPT){return CPT.id;}),CPT:allCPT.filter(function(CPT){return CPT.label==="ALL";}).map(function(CPT){return CPT.label;})}),loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__["a" /* ASSIGN_CPT_LABEL */]:return Object.assign({},state,{CPTLabel:action.CPTLabel});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__["b" /* ASSIGN_FILTER_IDENTIFIER */]:return Object.assign({},state,{filterIdentifier:action.filterIdentifier});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__["h" /* FETCH_FILTERS_CALL_SUCCESS */]:return Object.assign({},state,{allClusters:action.filters.allClusters,allAisles:action.filters.allAisles,clusterAislesMap:action.filters.clusterAislesMap,loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__["j" /* FETCH_OPTIONS_CALL_FAILURE */]:return Object.assign({},state,{loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_OptionsActionsV2__["q" /* VIEW_CHANGED */]:return Object.assign({},state,{heatMapView:action.view,isInitialView:false});default:// ALWAYS have a default case in a reducer
return state;}}

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__ = __webpack_require__(186);
var initialState={inductCount:'',loading:false,machineList:[],stowPackageMetrics:{},bayList:[],machineStatusList:[]};var stowBufferReducer=function stowBufferReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__["e" /* INDUCT_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__["g" /* INDUCT_CALL_SUCCESS */]:return Object.assign({},state,{inductCount:action.inductCount,loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__["f" /* INDUCT_CALL_FAILURE */]:return Object.assign({},state,{loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__["h" /* MACHINE_STATUS_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__["j" /* MACHINE_STATUS_CALL_SUCCESS */]:return Object.assign({},state,{machineStatusList:action.machineStatusList,loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__["i" /* MACHINE_STATUS_CALL_FAILURE */]:return Object.assign({},state,{loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__["a" /* BAY_TABLE_DATA_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__["d" /* BAY_TABLE_DATA_CLEAR */]:return Object.assign({},state,{bayList:[]});case __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__["c" /* BAY_TABLE_DATA_CALL_SUCCESS */]:return Object.assign({},state,{bayList:action.bayList,loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__["b" /* BAY_TABLE_DATA_CALL_FAILURE */]:return Object.assign({},state,{loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__["k" /* MACHINE_TABLE_DATA_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__["m" /* MACHINE_TABLE_DATA_CALL_SUCCESS */]:return Object.assign({},state,{machineList:action.machineList,loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__["l" /* MACHINE_TABLE_DATA_CALL_FAILURE */]:return Object.assign({},state,{loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__["n" /* PLANNED_COUNT_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__["p" /* PLANNED_COUNT_CALL_SUCCESS */]:return Object.assign({},state,{stowPackageMetrics:action.stowPackageMetricsMap,loading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_StowBufferAction__["o" /* PLANNED_COUNT_CALL_FAILURE */]:return Object.assign({},state,{loading:false});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (stowBufferReducer);

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = floorLocationReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_FloorLocationActions__ = __webpack_require__(116);
/**
 * Initial state of the system.
 */var initialState={loading:false,stowPackageMetricsMap:{},stowAssociateMetricsMap:{},stowFloorMetricsMap:{},totalStowPackageMetricsMap:{}/**
 * Reducer function for Floor Location View that changes state
 * based on the action triggered.
 */};function floorLocationReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_FloorLocationActions__["a" /* LOAD_FLOOR_LOCATION_METRICS_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_FloorLocationActions__["e" /* LOAD_STOW_PACKAGE_METRICS */]:return Object.assign({},state,{loading:false,stowPackageMetricsMap:action.stowPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_FloorLocationActions__["d" /* LOAD_STOW_FLOOR_METRICS */]:return Object.assign({},state,{loading:false,stowFloorMetricsMap:action.stowFloorMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_FloorLocationActions__["c" /* LOAD_STOW_ASSOCIATE_METRICS */]:return Object.assign({},state,{loading:false,stowAssociateMetricsMap:action.stowAssociateMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_FloorLocationActions__["f" /* LOAD_TOTAL_STOW_PACKAGE_METRICS */]:return Object.assign({},state,{loading:false,totalStowPackageMetrics:action.totalStowPackageMetrics});case __WEBPACK_IMPORTED_MODULE_0__actions_FloorLocationActions__["b" /* LOAD_FLOOR_LOCATION_METRICS_CALL_FAILURE */]:return Object.assign({},state,{loading:false});default:return state;}}

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cartReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_CartActions__ = __webpack_require__(117);
/**
 * Initial state of the system.
 */var initialState={loading:true,stowPackageMetricsMap:{}/**
 * Reducer function for Cart View that changes state
 * based on the action triggered.
 */};function cartReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_CartActions__["a" /* LOAD_METRICS_FOR_CART_CALL_BEGIN */]:return Object.assign({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_CartActions__["c" /* LOAD_STOW_PACKAGE_METRICS_FOR_CART */]:return Object.assign({},state,{loading:false,stowPackageMetricsMap:action.stowPackageMetricsMap});case __WEBPACK_IMPORTED_MODULE_0__actions_CartActions__["b" /* LOAD_METRICS_FOR_CART_CALL_FAILURE */]:return Object.assign({},state,{loading:false});default:return state;}}

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = gridAllocationReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_GridAllocationActions__ = __webpack_require__(262);
/**
 * Initial state of the system.
 */var initialState={loading:true,isError:false,gridAllocationData:{}};function gridAllocationReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_GridAllocationActions__["b" /* FETCH_ALLOCATION_DATA_START */]:return Object.assign({},state,{loading:true,isError:false});case __WEBPACK_IMPORTED_MODULE_0__actions_GridAllocationActions__["a" /* FETCH_ALLOCATION_DATA_FAILURE */]:return Object.assign({},state,{loading:false,isError:true});case __WEBPACK_IMPORTED_MODULE_0__actions_GridAllocationActions__["c" /* RENDER_ALLOCATION_DATA */]:return Object.assign({},state,{loading:false,gridAllocationData:action.data,isError:false});default:// ALWAYS have a default case in a reducer
return state;}}

/***/ }),
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var t=String(e).split("."),o=!t[1],n=Number(t[0])==e,r=n&&t[0].slice(-1),i=n&&t[0].slice(-2);return a?1==r&&11!=i?"one":2==r&&12!=i?"two":3==r&&13!=i?"few":"other":1==e&&o?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yr."},past:{one:"{0} yr. ago",other:"{0} yr. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hr."},past:{one:"{0} hr. ago",other:"{0} hr. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} min."},past:{one:"{0} min. ago",other:"{0} min. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} sec."},past:{one:"{0} sec. ago",other:"{0} sec. ago"}}}}},{locale:"en-001",parentLocale:"en",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo",other:"in {0} mo"},past:{one:"{0} mo ago",other:"{0} mo ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yrs"},past:{one:"{0} yr ago",other:"{0} yrs ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"h",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hrs"},past:{one:"{0} hr ago",other:"{0} hrs ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins"},past:{one:"{0} min. ago",other:"{0} mins ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs"},past:{one:"{0} sec. ago",other:"{0} secs ago"}}}}},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yrs."},past:{one:"{0} yr. ago",other:"{0} yrs. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mos."},past:{one:"{0} mo. ago",other:"{0} mos. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hrs."},past:{one:"{0} hr. ago",other:"{0} hrs. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins."},past:{one:"{0} min. ago",other:"{0} mins. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs."},past:{one:"{0} sec. ago",other:"{0} secs. ago"}}}}},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr",1:"next yr","-1":"last yr"},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mth",relative:{0:"this mth",1:"next mth","-1":"last mth"},relativeTime:{future:{one:"in {0} mth",other:"in {0} mth"},past:{one:"{0} mth ago",other:"{0} mth ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ja=t())}(this,function(){"use strict";return[{locale:"ja",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"翌年","-1":"昨年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"翌年","-1":"昨年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"今月",1:"翌月","-1":"先月"},relativeTime:{future:{other:"{0} か月後"},past:{other:"{0} か月前"}}},"month-short":{displayName:"月",relative:{0:"今月",1:"翌月","-1":"先月"},relativeTime:{future:{other:"{0} か月後"},past:{other:"{0} か月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"明後日","-2":"一昨日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},"day-short":{displayName:"日",relative:{0:"今日",1:"明日",2:"明後日","-2":"一昨日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"時",relative:{0:"1 時間以内"},relativeTime:{future:{other:"{0} 時間後"},past:{other:"{0} 時間前"}}},"hour-short":{displayName:"時",relative:{0:"1 時間以内"},relativeTime:{future:{other:"{0} 時間後"},past:{other:"{0} 時間前"}}},minute:{displayName:"分",relative:{0:"1 分以内"},relativeTime:{future:{other:"{0} 分後"},past:{other:"{0} 分前"}}},"minute-short":{displayName:"分",relative:{0:"1 分以内"},relativeTime:{future:{other:"{0} 分後"},past:{other:"{0} 分前"}}},second:{displayName:"秒",relative:{0:"今"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"今"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}}]});


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.it=a())}(this,function(){"use strict";return[{locale:"it",pluralRuleFunction:function(e,a){var t=!String(e).split(".")[1];return a?11==e||8==e||80==e||800==e?"many":"other":1==e&&t?"one":"other"},fields:{year:{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},"year-short":{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},month:{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},"month-short":{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},day:{displayName:"giorno",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} giorno",other:"tra {0} giorni"},past:{one:"{0} giorno fa",other:"{0} giorni fa"}}},"day-short":{displayName:"g",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} g",other:"tra {0} gg"},past:{one:"{0} g fa",other:"{0} gg fa"}}},hour:{displayName:"ora",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} ora",other:"tra {0} ore"},past:{one:"{0} ora fa",other:"{0} ore fa"}}},"hour-short":{displayName:"h.",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} h",other:"tra {0} h"},past:{one:"{0} h fa",other:"{0} h fa"}}},minute:{displayName:"minuto",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} minuto",other:"tra {0} minuti"},past:{one:"{0} minuto fa",other:"{0} minuti fa"}}},"minute-short":{displayName:"min",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} min",other:"tra {0} min"},past:{one:"{0} min fa",other:"{0} min fa"}}},second:{displayName:"secondo",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} secondo",other:"tra {0} secondi"},past:{one:"{0} secondo fa",other:"{0} secondi fa"}}},"second-short":{displayName:"s",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} s",other:"tra {0} sec."},past:{one:"{0} s fa",other:"{0} sec. fa"}}}}},{locale:"it-CH",parentLocale:"it"},{locale:"it-SM",parentLocale:"it"},{locale:"it-VA",parentLocale:"it"}]});


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.fr=a())}(this,function(){"use strict";return[{locale:"fr",pluralRuleFunction:function(e,a){return a?1==e?"one":"other":e>=0&&e<2?"one":"other"},fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-BE",parentLocale:"fr"},{locale:"fr-BF",parentLocale:"fr"},{locale:"fr-BI",parentLocale:"fr"},{locale:"fr-BJ",parentLocale:"fr"},{locale:"fr-BL",parentLocale:"fr"},{locale:"fr-CA",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"Dans {0} an",other:"Dans {0} ans"},past:{one:"Il y a {0} an",other:"Il y a {0} ans"}}},"year-short":{displayName:"a",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-CD",parentLocale:"fr"},{locale:"fr-CF",parentLocale:"fr"},{locale:"fr-CG",parentLocale:"fr"},{locale:"fr-CH",parentLocale:"fr"},{locale:"fr-CI",parentLocale:"fr"},{locale:"fr-CM",parentLocale:"fr"},{locale:"fr-DJ",parentLocale:"fr"},{locale:"fr-DZ",parentLocale:"fr"},{locale:"fr-GA",parentLocale:"fr"},{locale:"fr-GF",parentLocale:"fr"},{locale:"fr-GN",parentLocale:"fr"},{locale:"fr-GP",parentLocale:"fr"},{locale:"fr-GQ",parentLocale:"fr"},{locale:"fr-HT",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"jr.",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"hr",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min.",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-KM",parentLocale:"fr"},{locale:"fr-LU",parentLocale:"fr"},{locale:"fr-MA",parentLocale:"fr"},{locale:"fr-MC",parentLocale:"fr"},{locale:"fr-MF",parentLocale:"fr"},{locale:"fr-MG",parentLocale:"fr"},{locale:"fr-ML",parentLocale:"fr"},{locale:"fr-MQ",parentLocale:"fr"},{locale:"fr-MR",parentLocale:"fr"},{locale:"fr-MU",parentLocale:"fr"},{locale:"fr-NC",parentLocale:"fr"},{locale:"fr-NE",parentLocale:"fr"},{locale:"fr-PF",parentLocale:"fr"},{locale:"fr-PM",parentLocale:"fr"},{locale:"fr-RE",parentLocale:"fr"},{locale:"fr-RW",parentLocale:"fr"},{locale:"fr-SC",parentLocale:"fr"},{locale:"fr-SN",parentLocale:"fr"},{locale:"fr-SY",parentLocale:"fr"},{locale:"fr-TD",parentLocale:"fr"},{locale:"fr-TG",parentLocale:"fr"},{locale:"fr-TN",parentLocale:"fr"},{locale:"fr-VU",parentLocale:"fr"},{locale:"fr-WF",parentLocale:"fr"},{locale:"fr-YT",parentLocale:"fr"}]});


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";return[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} días",other:"dentro de {0} días"},past:{one:"hace {0} días",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-BR",parentLocale:"es-419"},{locale:"es-BZ",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419"},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"Minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419"},{locale:"es-HN",parentLocale:"es-419"},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"en {0} a",other:"en {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} m",other:"en {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"en {0} día",other:"en {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"en {0} h",other:"en {0} n"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"en {0} min",other:"en {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"en {0} s",other:"en {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-NI",parentLocale:"es-419"},{locale:"es-PA",parentLocale:"es-419"},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-US",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}]});


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.de=t())}(this,function(){"use strict";return[{locale:"de",pluralRuleFunction:function(e,t){var n=!String(e).split(".")[1];return t?"other":1==e&&n?"one":"other"},fields:{year:{displayName:"Jahr",relative:{0:"dieses Jahr",1:"nächstes Jahr","-1":"letztes Jahr"},relativeTime:{future:{one:"in {0} Jahr",other:"in {0} Jahren"},past:{one:"vor {0} Jahr",other:"vor {0} Jahren"}}},"year-short":{displayName:"Jahr",relative:{0:"dieses Jahr",1:"nächstes Jahr","-1":"letztes Jahr"},relativeTime:{future:{one:"in {0} Jahr",other:"in {0} Jahren"},past:{one:"vor {0} Jahr",other:"vor {0} Jahren"}}},month:{displayName:"Monat",relative:{0:"diesen Monat",1:"nächsten Monat","-1":"letzten Monat"},relativeTime:{future:{one:"in {0} Monat",other:"in {0} Monaten"},past:{one:"vor {0} Monat",other:"vor {0} Monaten"}}},"month-short":{displayName:"Monat",relative:{0:"diesen Monat",1:"nächsten Monat","-1":"letzten Monat"},relativeTime:{future:{one:"in {0} Monat",other:"in {0} Monaten"},past:{one:"vor {0} Monat",other:"vor {0} Monaten"}}},day:{displayName:"Tag",relative:{0:"heute",1:"morgen",2:"übermorgen","-2":"vorgestern","-1":"gestern"},relativeTime:{future:{one:"in {0} Tag",other:"in {0} Tagen"},past:{one:"vor {0} Tag",other:"vor {0} Tagen"}}},"day-short":{displayName:"Tag",relative:{0:"heute",1:"morgen",2:"übermorgen","-2":"vorgestern","-1":"gestern"},relativeTime:{future:{one:"in {0} Tag",other:"in {0} Tagen"},past:{one:"vor {0} Tag",other:"vor {0} Tagen"}}},hour:{displayName:"Stunde",relative:{0:"in dieser Stunde"},relativeTime:{future:{one:"in {0} Stunde",other:"in {0} Stunden"},past:{one:"vor {0} Stunde",other:"vor {0} Stunden"}}},"hour-short":{displayName:"Std.",relative:{0:"in dieser Stunde"},relativeTime:{future:{one:"in {0} Std.",other:"in {0} Std."},past:{one:"vor {0} Std.",other:"vor {0} Std."}}},minute:{displayName:"Minute",relative:{0:"in dieser Minute"},relativeTime:{future:{one:"in {0} Minute",other:"in {0} Minuten"},past:{one:"vor {0} Minute",other:"vor {0} Minuten"}}},"minute-short":{displayName:"Min.",relative:{0:"in dieser Minute"},relativeTime:{future:{one:"in {0} Min.",other:"in {0} Min."},past:{one:"vor {0} Min.",other:"vor {0} Min."}}},second:{displayName:"Sekunde",relative:{0:"jetzt"},relativeTime:{future:{one:"in {0} Sekunde",other:"in {0} Sekunden"},past:{one:"vor {0} Sekunde",other:"vor {0} Sekunden"}}},"second-short":{displayName:"Sek.",relative:{0:"jetzt"},relativeTime:{future:{one:"in {0} Sek.",other:"in {0} Sek."},past:{one:"vor {0} Sek.",other:"vor {0} Sek."}}}}},{locale:"de-AT",parentLocale:"de"},{locale:"de-BE",parentLocale:"de"},{locale:"de-CH",parentLocale:"de"},{locale:"de-IT",parentLocale:"de"},{locale:"de-LI",parentLocale:"de"},{locale:"de-LU",parentLocale:"de"}]});


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ar=a())}(this,function(){"use strict";return[{locale:"ar",pluralRuleFunction:function(e,a){var o=String(e).split("."),r=Number(o[0])==e&&o[0].slice(-2);return a?"other":0==e?"zero":1==e?"one":2==e?"two":r>=3&&r<=10?"few":r>=11&&r<=99?"many":"other"},fields:{year:{displayName:"السنة",relative:{0:"السنة الحالية",1:"السنة القادمة","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},"year-short":{displayName:"السنة",relative:{0:"السنة الحالية",1:"السنة القادمة","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},"month-short":{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"خلال {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},"day-short":{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},"hour-short":{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},"minute-short":{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}},"second-short":{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانٍ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-AE",parentLocale:"ar",fields:{year:{displayName:"السنة",relative:{0:"هذه السنة",1:"السنة التالية","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},"year-short":{displayName:"السنة",relative:{0:"هذه السنة",1:"السنة التالية","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},"month-short":{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"خلال {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},"day-short":{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},"hour-short":{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},"minute-short":{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}},"second-short":{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانٍ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-BH",parentLocale:"ar"},{locale:"ar-DJ",parentLocale:"ar"},{locale:"ar-DZ",parentLocale:"ar"},{locale:"ar-EG",parentLocale:"ar"},{locale:"ar-EH",parentLocale:"ar"},{locale:"ar-ER",parentLocale:"ar"},{locale:"ar-IL",parentLocale:"ar"},{locale:"ar-IQ",parentLocale:"ar"},{locale:"ar-JO",parentLocale:"ar"},{locale:"ar-KM",parentLocale:"ar"},{locale:"ar-KW",parentLocale:"ar"},{locale:"ar-LB",parentLocale:"ar"},{locale:"ar-LY",parentLocale:"ar"},{locale:"ar-MA",parentLocale:"ar"},{locale:"ar-MR",parentLocale:"ar"},{locale:"ar-OM",parentLocale:"ar"},{locale:"ar-PS",parentLocale:"ar"},{locale:"ar-QA",parentLocale:"ar"},{locale:"ar-SA",parentLocale:"ar"},{locale:"ar-SD",parentLocale:"ar"},{locale:"ar-SO",parentLocale:"ar"},{locale:"ar-SS",parentLocale:"ar"},{locale:"ar-SY",parentLocale:"ar"},{locale:"ar-TD",parentLocale:"ar"},{locale:"ar-TN",parentLocale:"ar"},{locale:"ar-YE",parentLocale:"ar"}]});


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.tr=a())}(this,function(){"use strict";return[{locale:"tr",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"yıl",relative:{0:"bu yıl",1:"gelecek yıl","-1":"geçen yıl"},relativeTime:{future:{one:"{0} yıl sonra",other:"{0} yıl sonra"},past:{one:"{0} yıl önce",other:"{0} yıl önce"}}},"year-short":{displayName:"yıl",relative:{0:"bu yıl",1:"gelecek yıl","-1":"geçen yıl"},relativeTime:{future:{one:"{0} yıl sonra",other:"{0} yıl sonra"},past:{one:"{0} yıl önce",other:"{0} yıl önce"}}},month:{displayName:"ay",relative:{0:"bu ay",1:"gelecek ay","-1":"geçen ay"},relativeTime:{future:{one:"{0} ay sonra",other:"{0} ay sonra"},past:{one:"{0} ay önce",other:"{0} ay önce"}}},"month-short":{displayName:"ay",relative:{0:"bu ay",1:"gelecek ay","-1":"geçen ay"},relativeTime:{future:{one:"{0} ay sonra",other:"{0} ay sonra"},past:{one:"{0} ay önce",other:"{0} ay önce"}}},day:{displayName:"gün",relative:{0:"bugün",1:"yarın",2:"öbür gün","-2":"evvelsi gün","-1":"dün"},relativeTime:{future:{one:"{0} gün sonra",other:"{0} gün sonra"},past:{one:"{0} gün önce",other:"{0} gün önce"}}},"day-short":{displayName:"gün",relative:{0:"bugün",1:"yarın",2:"öbür gün","-2":"evvelsi gün","-1":"dün"},relativeTime:{future:{one:"{0} gün sonra",other:"{0} gün sonra"},past:{one:"{0} gün önce",other:"{0} gün önce"}}},hour:{displayName:"saat",relative:{0:"bu saat"},relativeTime:{future:{one:"{0} saat sonra",other:"{0} saat sonra"},past:{one:"{0} saat önce",other:"{0} saat önce"}}},"hour-short":{displayName:"sa.",relative:{0:"bu saat"},relativeTime:{future:{one:"{0} sa. sonra",other:"{0} sa. sonra"},past:{one:"{0} sa. önce",other:"{0} sa. önce"}}},minute:{displayName:"dakika",relative:{0:"bu dakika"},relativeTime:{future:{one:"{0} dakika sonra",other:"{0} dakika sonra"},past:{one:"{0} dakika önce",other:"{0} dakika önce"}}},"minute-short":{displayName:"dk.",relative:{0:"bu dakika"},relativeTime:{future:{one:"{0} dk. sonra",other:"{0} dk. sonra"},past:{one:"{0} dk. önce",other:"{0} dk. önce"}}},second:{displayName:"saniye",relative:{0:"şimdi"},relativeTime:{future:{one:"{0} saniye sonra",other:"{0} saniye sonra"},past:{one:"{0} saniye önce",other:"{0} saniye önce"}}},"second-short":{displayName:"sn.",relative:{0:"şimdi"},relativeTime:{future:{one:"{0} sn. sonra",other:"{0} sn. sonra"},past:{one:"{0} sn. önce",other:"{0} sn. önce"}}}}},{locale:"tr-CY",parentLocale:"tr"}]});


/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetricUtility__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ErrorPage__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ErrorBoundary=function(_Component){_inherits(ErrorBoundary,_Component);function ErrorBoundary(props){_classCallCheck(this,ErrorBoundary);var _this=_possibleConstructorReturn(this,(ErrorBoundary.__proto__||Object.getPrototypeOf(ErrorBoundary)).call(this,props));_this.state={hasError:false};return _this;}_createClass(ErrorBoundary,[{key:"componentDidCatch",value:function componentDidCatch(error,errorInfo){// You can also log the error to an error reporting service
var metricProcessName="SCC_STOW";var metricName="clientError";Object(__WEBPACK_IMPORTED_MODULE_1__MetricUtility__["a" /* publishCount */])(metricProcessName,metricName);}},{key:"render",value:function render(){if(this.state.hasError){// You can render any custom fallback UI
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ErrorPage__["a" /* default */],{errorId:"stow.error",errorMessage:"Some error occurred"});}return this.props.children;}}],[{key:"getDerivedStateFromError",value:function getDerivedStateFromError(error){// Update state so the next render will show the fallback UI.
return{hasError:true};}}]);return ErrorBoundary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ErrorBoundary);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.32ab9348.js